var ME = Object.defineProperty;
var EE = (e, t, r) => t in e ? ME(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var fe = (e, t, r) => (EE(e, typeof t != "symbol" ? t + "" : t, r), r);
import P, { createContext as f1, useState as Ee, useEffect as Ne, useContext as wt, useRef as Ce, useId as D7, useLayoutEffect as qm, useMemo as dr, useReducer as SE, Fragment as PE, isValidElement as kr, Children as K1, PureComponent as mr, forwardRef as jE, useImperativeHandle as IE, useCallback as BE, cloneElement as Pt, createElement as Xm, Component as Jm } from "react";
import O7, { unstable_batchedUpdates as NE } from "react-dom";
var ji = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Xe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function LE(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var N4 = { exports: {} }, ri = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wd;
function TE() {
  if (Wd)
    return ri;
  Wd = 1;
  var e = P, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, c, u) {
    var d, h = {}, A = null, p = null;
    u !== void 0 && (A = "" + u), c.key !== void 0 && (A = "" + c.key), c.ref !== void 0 && (p = c.ref);
    for (d in c)
      n.call(c, d) && !i.hasOwnProperty(d) && (h[d] = c[d]);
    if (s && s.defaultProps)
      for (d in c = s.defaultProps, c)
        h[d] === void 0 && (h[d] = c[d]);
    return { $$typeof: t, type: s, key: A, ref: p, props: h, _owner: a.current };
  }
  return ri.Fragment = r, ri.jsx = o, ri.jsxs = o, ri;
}
var ni = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qd;
function _E() {
  return Qd || (Qd = 1, process.env.NODE_ENV !== "production" && function() {
    var e = P, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), A = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), v = Symbol.iterator, g = "@@iterator";
    function m(G) {
      if (G === null || typeof G != "object")
        return null;
      var se = v && G[v] || G[g];
      return typeof se == "function" ? se : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(G) {
      {
        for (var se = arguments.length, de = new Array(se > 1 ? se - 1 : 0), we = 1; we < se; we++)
          de[we - 1] = arguments[we];
        x("error", G, de);
      }
    }
    function x(G, se, de) {
      {
        var we = b.ReactDebugCurrentFrame, _e = we.getStackAddendum();
        _e !== "" && (se += "%s", de = de.concat([_e]));
        var We = de.map(function(Be) {
          return String(Be);
        });
        We.unshift("Warning: " + se), Function.prototype.apply.call(console[G], console, We);
      }
    }
    var y = !1, C = !1, O = !1, M = !1, E = !1, N;
    N = Symbol.for("react.module.reference");
    function F(G) {
      return !!(typeof G == "string" || typeof G == "function" || G === n || G === i || E || G === a || G === u || G === d || M || G === p || y || C || O || typeof G == "object" && G !== null && (G.$$typeof === A || G.$$typeof === h || G.$$typeof === o || G.$$typeof === s || G.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      G.$$typeof === N || G.getModuleId !== void 0));
    }
    function k(G, se, de) {
      var we = G.displayName;
      if (we)
        return we;
      var _e = se.displayName || se.name || "";
      return _e !== "" ? de + "(" + _e + ")" : de;
    }
    function R(G) {
      return G.displayName || "Context";
    }
    function j(G) {
      if (G == null)
        return null;
      if (typeof G.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof G == "function")
        return G.displayName || G.name || null;
      if (typeof G == "string")
        return G;
      switch (G) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case u:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof G == "object")
        switch (G.$$typeof) {
          case s:
            var se = G;
            return R(se) + ".Consumer";
          case o:
            var de = G;
            return R(de._context) + ".Provider";
          case c:
            return k(G, G.render, "ForwardRef");
          case h:
            var we = G.displayName || null;
            return we !== null ? we : j(G.type) || "Memo";
          case A: {
            var _e = G, We = _e._payload, Be = _e._init;
            try {
              return j(Be(We));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, X, Z, te, B, I, _, L;
    function D() {
    }
    D.__reactDisabledLog = !0;
    function T() {
      {
        if (ee === 0) {
          X = console.log, Z = console.info, te = console.warn, B = console.error, I = console.group, _ = console.groupCollapsed, L = console.groupEnd;
          var G = {
            configurable: !0,
            enumerable: !0,
            value: D,
            writable: !0
          };
          Object.defineProperties(console, {
            info: G,
            log: G,
            warn: G,
            error: G,
            group: G,
            groupCollapsed: G,
            groupEnd: G
          });
        }
        ee++;
      }
    }
    function Q() {
      {
        if (ee--, ee === 0) {
          var G = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, G, {
              value: X
            }),
            info: U({}, G, {
              value: Z
            }),
            warn: U({}, G, {
              value: te
            }),
            error: U({}, G, {
              value: B
            }),
            group: U({}, G, {
              value: I
            }),
            groupCollapsed: U({}, G, {
              value: _
            }),
            groupEnd: U({}, G, {
              value: L
            })
          });
        }
        ee < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var z = b.ReactCurrentDispatcher, W;
    function H(G, se, de) {
      {
        if (W === void 0)
          try {
            throw Error();
          } catch (_e) {
            var we = _e.stack.trim().match(/\n( *(at )?)/);
            W = we && we[1] || "";
          }
        return `
` + W + G;
      }
    }
    var $ = !1, V;
    {
      var Y = typeof WeakMap == "function" ? WeakMap : Map;
      V = new Y();
    }
    function S(G, se) {
      if (!G || $)
        return "";
      {
        var de = V.get(G);
        if (de !== void 0)
          return de;
      }
      var we;
      $ = !0;
      var _e = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var We;
      We = z.current, z.current = null, T();
      try {
        if (se) {
          var Be = function() {
            throw Error();
          };
          if (Object.defineProperty(Be.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Be, []);
            } catch (sr) {
              we = sr;
            }
            Reflect.construct(G, [], Be);
          } else {
            try {
              Be.call();
            } catch (sr) {
              we = sr;
            }
            G.call(Be.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (sr) {
            we = sr;
          }
          G();
        }
      } catch (sr) {
        if (sr && we && typeof sr.stack == "string") {
          for (var Ie = sr.stack.split(`
`), Et = we.stack.split(`
`), dt = Ie.length - 1, vt = Et.length - 1; dt >= 1 && vt >= 0 && Ie[dt] !== Et[vt]; )
            vt--;
          for (; dt >= 1 && vt >= 0; dt--, vt--)
            if (Ie[dt] !== Et[vt]) {
              if (dt !== 1 || vt !== 1)
                do
                  if (dt--, vt--, vt < 0 || Ie[dt] !== Et[vt]) {
                    var kt = `
` + Ie[dt].replace(" at new ", " at ");
                    return G.displayName && kt.includes("<anonymous>") && (kt = kt.replace("<anonymous>", G.displayName)), typeof G == "function" && V.set(G, kt), kt;
                  }
                while (dt >= 1 && vt >= 0);
              break;
            }
        }
      } finally {
        $ = !1, z.current = We, Q(), Error.prepareStackTrace = _e;
      }
      var en = G ? G.displayName || G.name : "", wa = en ? H(en) : "";
      return typeof G == "function" && V.set(G, wa), wa;
    }
    function J(G, se, de) {
      return S(G, !1);
    }
    function q(G) {
      var se = G.prototype;
      return !!(se && se.isReactComponent);
    }
    function re(G, se, de) {
      if (G == null)
        return "";
      if (typeof G == "function")
        return S(G, q(G));
      if (typeof G == "string")
        return H(G);
      switch (G) {
        case u:
          return H("Suspense");
        case d:
          return H("SuspenseList");
      }
      if (typeof G == "object")
        switch (G.$$typeof) {
          case c:
            return J(G.render);
          case h:
            return re(G.type, se, de);
          case A: {
            var we = G, _e = we._payload, We = we._init;
            try {
              return re(We(_e), se, de);
            } catch {
            }
          }
        }
      return "";
    }
    var ae = Object.prototype.hasOwnProperty, oe = {}, ue = b.ReactDebugCurrentFrame;
    function Ae(G) {
      if (G) {
        var se = G._owner, de = re(G.type, G._source, se ? se.type : null);
        ue.setExtraStackFrame(de);
      } else
        ue.setExtraStackFrame(null);
    }
    function ge(G, se, de, we, _e) {
      {
        var We = Function.call.bind(ae);
        for (var Be in G)
          if (We(G, Be)) {
            var Ie = void 0;
            try {
              if (typeof G[Be] != "function") {
                var Et = Error((we || "React class") + ": " + de + " type `" + Be + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof G[Be] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Et.name = "Invariant Violation", Et;
              }
              Ie = G[Be](se, Be, we, de, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (dt) {
              Ie = dt;
            }
            Ie && !(Ie instanceof Error) && (Ae(_e), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", we || "React class", de, Be, typeof Ie), Ae(null)), Ie instanceof Error && !(Ie.message in oe) && (oe[Ie.message] = !0, Ae(_e), w("Failed %s type: %s", de, Ie.message), Ae(null));
          }
      }
    }
    var Se = Array.isArray;
    function Te(G) {
      return Se(G);
    }
    function Re(G) {
      {
        var se = typeof Symbol == "function" && Symbol.toStringTag, de = se && G[Symbol.toStringTag] || G.constructor.name || "Object";
        return de;
      }
    }
    function at(G) {
      try {
        return bt(G), !1;
      } catch {
        return !0;
      }
    }
    function bt(G) {
      return "" + G;
    }
    function Qt(G) {
      if (at(G))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Re(G)), bt(G);
    }
    var or = b.ReactCurrentOwner, y1 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Aa, pa, w1;
    w1 = {};
    function Y2(G) {
      if (ae.call(G, "ref")) {
        var se = Object.getOwnPropertyDescriptor(G, "ref").get;
        if (se && se.isReactWarning)
          return !1;
      }
      return G.ref !== void 0;
    }
    function k2(G) {
      if (ae.call(G, "key")) {
        var se = Object.getOwnPropertyDescriptor(G, "key").get;
        if (se && se.isReactWarning)
          return !1;
      }
      return G.key !== void 0;
    }
    function V2(G, se) {
      if (typeof G.ref == "string" && or.current && se && or.current.stateNode !== se) {
        var de = j(or.current.type);
        w1[de] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(or.current.type), G.ref), w1[de] = !0);
      }
    }
    function G2(G, se) {
      {
        var de = function() {
          Aa || (Aa = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", se));
        };
        de.isReactWarning = !0, Object.defineProperty(G, "key", {
          get: de,
          configurable: !0
        });
      }
    }
    function W2(G, se) {
      {
        var de = function() {
          pa || (pa = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", se));
        };
        de.isReactWarning = !0, Object.defineProperty(G, "ref", {
          get: de,
          configurable: !0
        });
      }
    }
    var Q2 = function(G, se, de, we, _e, We, Be) {
      var Ie = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: G,
        key: se,
        ref: de,
        props: Be,
        // Record the component responsible for creating this element.
        _owner: We
      };
      return Ie._store = {}, Object.defineProperty(Ie._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ie, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: we
      }), Object.defineProperty(Ie, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: _e
      }), Object.freeze && (Object.freeze(Ie.props), Object.freeze(Ie)), Ie;
    };
    function U2(G, se, de, we, _e) {
      {
        var We, Be = {}, Ie = null, Et = null;
        de !== void 0 && (Qt(de), Ie = "" + de), k2(se) && (Qt(se.key), Ie = "" + se.key), Y2(se) && (Et = se.ref, V2(se, _e));
        for (We in se)
          ae.call(se, We) && !y1.hasOwnProperty(We) && (Be[We] = se[We]);
        if (G && G.defaultProps) {
          var dt = G.defaultProps;
          for (We in dt)
            Be[We] === void 0 && (Be[We] = dt[We]);
        }
        if (Ie || Et) {
          var vt = typeof G == "function" ? G.displayName || G.name || "Unknown" : G;
          Ie && G2(Be, vt), Et && W2(Be, vt);
        }
        return Q2(G, Ie, Et, _e, we, or.current, Be);
      }
    }
    var x1 = b.ReactCurrentOwner, ga = b.ReactDebugCurrentFrame;
    function Jr(G) {
      if (G) {
        var se = G._owner, de = re(G.type, G._source, se ? se.type : null);
        ga.setExtraStackFrame(de);
      } else
        ga.setExtraStackFrame(null);
    }
    var D1;
    D1 = !1;
    function O1(G) {
      return typeof G == "object" && G !== null && G.$$typeof === t;
    }
    function va() {
      {
        if (x1.current) {
          var G = j(x1.current.type);
          if (G)
            return `

Check the render method of \`` + G + "`.";
        }
        return "";
      }
    }
    function Z2(G) {
      {
        if (G !== void 0) {
          var se = G.fileName.replace(/^.*[\\\/]/, ""), de = G.lineNumber;
          return `

Check your code at ` + se + ":" + de + ".";
        }
        return "";
      }
    }
    var ma = {};
    function K2(G) {
      {
        var se = va();
        if (!se) {
          var de = typeof G == "string" ? G : G.displayName || G.name;
          de && (se = `

Check the top-level render call using <` + de + ">.");
        }
        return se;
      }
    }
    function Ca(G, se) {
      {
        if (!G._store || G._store.validated || G.key != null)
          return;
        G._store.validated = !0;
        var de = K2(se);
        if (ma[de])
          return;
        ma[de] = !0;
        var we = "";
        G && G._owner && G._owner !== x1.current && (we = " It was passed a child from " + j(G._owner.type) + "."), Jr(G), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', de, we), Jr(null);
      }
    }
    function ba(G, se) {
      {
        if (typeof G != "object")
          return;
        if (Te(G))
          for (var de = 0; de < G.length; de++) {
            var we = G[de];
            O1(we) && Ca(we, se);
          }
        else if (O1(G))
          G._store && (G._store.validated = !0);
        else if (G) {
          var _e = m(G);
          if (typeof _e == "function" && _e !== G.entries)
            for (var We = _e.call(G), Be; !(Be = We.next()).done; )
              O1(Be.value) && Ca(Be.value, se);
        }
      }
    }
    function z2(G) {
      {
        var se = G.type;
        if (se == null || typeof se == "string")
          return;
        var de;
        if (typeof se == "function")
          de = se.propTypes;
        else if (typeof se == "object" && (se.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        se.$$typeof === h))
          de = se.propTypes;
        else
          return;
        if (de) {
          var we = j(se);
          ge(de, G.props, "prop", we, G);
        } else if (se.PropTypes !== void 0 && !D1) {
          D1 = !0;
          var _e = j(se);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _e || "Unknown");
        }
        typeof se.getDefaultProps == "function" && !se.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function q2(G) {
      {
        for (var se = Object.keys(G.props), de = 0; de < se.length; de++) {
          var we = se[de];
          if (we !== "children" && we !== "key") {
            Jr(G), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", we), Jr(null);
            break;
          }
        }
        G.ref !== null && (Jr(G), w("Invalid attribute `ref` supplied to `React.Fragment`."), Jr(null));
      }
    }
    function ya(G, se, de, we, _e, We) {
      {
        var Be = F(G);
        if (!Be) {
          var Ie = "";
          (G === void 0 || typeof G == "object" && G !== null && Object.keys(G).length === 0) && (Ie += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Et = Z2(_e);
          Et ? Ie += Et : Ie += va();
          var dt;
          G === null ? dt = "null" : Te(G) ? dt = "array" : G !== void 0 && G.$$typeof === t ? (dt = "<" + (j(G.type) || "Unknown") + " />", Ie = " Did you accidentally export a JSX literal instead of a component?") : dt = typeof G, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", dt, Ie);
        }
        var vt = U2(G, se, de, _e, We);
        if (vt == null)
          return vt;
        if (Be) {
          var kt = se.children;
          if (kt !== void 0)
            if (we)
              if (Te(kt)) {
                for (var en = 0; en < kt.length; en++)
                  ba(kt[en], G);
                Object.freeze && Object.freeze(kt);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ba(kt, G);
        }
        return G === n ? q2(vt) : z2(vt), vt;
      }
    }
    function X2(G, se, de) {
      return ya(G, se, de, !0);
    }
    function J2(G, se, de) {
      return ya(G, se, de, !1);
    }
    var ei = J2, ti = X2;
    ni.Fragment = n, ni.jsx = ei, ni.jsxs = ti;
  }()), ni;
}
process.env.NODE_ENV === "production" ? N4.exports = TE() : N4.exports = _E();
var f = N4.exports;
const Ga = P.forwardRef((e, t) => {
  const {
    image: r,
    size: n = "sm"
  } = e, a = {
    xs: "h-[24px] w-[24px] min-w-[24px]",
    sm: "h-[28px] w-[28px] min-w-[28px]",
    md: "h-[150px] w-[150px] min-w-[150px] m-10"
  };
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: `${a[n]} flex items-center justify-center aspect-square rounded-full bg-secondary-200 border border-white overflow-hidden `, children: r.length > 2 ? /* @__PURE__ */ f.jsx(
    "img",
    {
      src: r,
      className: "h-full w-full object-cover bg-secondary-200 text-secondary-100",
      alt: ""
    }
  ) : r.length === 2 ? /* @__PURE__ */ f.jsx("span", { className: "text-secondary-500 font-bold leading-none text-xs", children: r }) : null });
});
Ga.displayName = "Avatar";
const RE = {
  light: "300",
  normal: "normal",
  medium: "500",
  semibold: "600",
  bold: "700",
  black: "900"
}, eC = {
  DEFAULT: "0.25rem",
  0: "0",
  xs: "0.25rem",
  md: "0.5rem",
  lg: "1rem",
  xl: "2rem",
  full: "100%"
}, gt = {
  "Marca-900": "#205591",
  "Marca-800": "#2874b4",
  "Marca-700": "#2b85c8",
  "Marca-600": "#3098dc",
  "Marca-500": "#34a6eb",
  "Marca-400": "#42b3ee",
  "Marca-300": "#5cc0f1",
  "Marca-200": "#86d2f6",
  "Marca-100": "#b5e4fa",
  "Marca-50": "#e2f5fd",
  "Acento-900": "#b23b29",
  "Acento-800": "#c24333",
  "Acento-700": "#cf4939",
  "Acento-600": "#e2523f",
  "Acento-500": "#ef5a40",
  "Acento-400": "#ec6658",
  "Acento-300": "#e2807a",
  "Acento-200": "#eca29f",
  "Acento-100": "#fdd2d4",
  "Acento-50": "#feedef",
  "Neutros-900": "#141a22",
  "Neutros-800": "#343a43",
  "Neutros-700": "#525962",
  "Neutros-600": "#666c76",
  "Neutros-500": "#8d949f",
  "Neutros-400": "#adb4bf",
  "Neutros-300": "#d1d8e4",
  "Neutros-200": "#e1e9f4",
  "Neutros-100": "#ebf2fe",
  "Neutros-50": "#f2f9ff",
  "Activos-900": "#005d00",
  "Activos-800": "#217c17",
  "Activos-700": "#2e8c22",
  "Activos-600": "#3a9e2e",
  "Activos-500": "#44ad36",
  "Activos-400": "#61b956",
  "Activos-300": "#7dc674",
  "Activos-200": "#a3d59c",
  "Activos-100": "#c7e5c3",
  "Activos-50": "#e8f5e6",
  "Error-900": "#b00020",
  "Error-800": "#bf152c",
  "Error-700": "#cc1d33",
  "Error-600": "#de2839",
  "Error-500": "#ed323b",
  "Error-400": "#e84853",
  "Error-300": "#de6c74",
  "Error-200": "#ea959b",
  "Error-100": "#fbcad2",
  "Error-50": "#fdeaee",
  "Información-900": "#194185",
  "Información-800": "#245da4",
  "Información-700": "#2b6eb6",
  "Información-600": "#337fc8",
  "Información-500": "#398cd5",
  "Información-400": "#509cdb",
  "Información-300": "#6bade0",
  "Información-200": "#92c4ea",
  "Información-100": "#bbdaf2",
  "Información-50": "#e3f0f9",
  "Negros-900": "#000000",
  "Negros-800": "#262626",
  "Negros-700": "#434343",
  "Negros-600": "#555555",
  "Negros-500": "#7b7b7b",
  "Negros-400": "#9d9d9d",
  "Negros-300": "#C4C4C4",
  "Negros-200": "#D9D9D9",
  "Negros-100": "#e9e9e9",
  "Negros-50": "#f5f5f5",
  "yellow-900": "#FEED01",
  "opacity-30": "#2055914D",
  "approved-200": "#12B76A",
  "pending-200": "#FF0000",
  "status-100": "#FEED01",
  transparent: "rgba(255, 255, 255, 0.08)",
  DEFAULT: "#E6E6E6",
  white: "#FFFFFF",
  "neutral-100": "#FFFFFF",
  "neutral-200": "#F5F5F5",
  "neutral-300": "#E6E6E6",
  "neutral-400": "#A3A3A3",
  "neutral-500": "#525252",
  "neutral-600": "#292929",
  "primary-100": "#FEF2F0",
  "primary-200": "#FDE5E1",
  "primary-300": "#FCD8D1",
  "primary-400": "#FBCBC2",
  "primary-500": "#F3765F",
  "primary-600": "#F15C41",
  "primary-700": "#CE4D37",
  "primary-800": "#A53C2B",
  "primary-850": "#7B2A1F",
  "primary-900": "#521913",
  "primary-950": "#280706",
  "secondary-100": "#EEF4F9",
  "secondary-200": "#DDE9F3",
  "secondary-300": "#CBDEED",
  "secondary-400": "#BAD3E7",
  "secondary-500": "#4A8BC0",
  "secondary-600": "#2875B4",
  "secondary-700": "#22629B",
  "secondary-800": "#165892",
  "secondary-850": "#104D85;",
  "secondary-900": "#0A4379",
  "secondary-950": "#03386C",
  "accent-100": "#FDEEF3",
  "accent-200": "#FBDEE7",
  "accent-300": "#F9CDDB",
  "accent-400": "#F7BCD0",
  "accent-500": "#E94F83",
  "accent-600": "#E52E6B",
  "accent-700": "#C4275B",
  "accent-800": "#9D1E47",
  "accent-850": "#761534",
  "accent-900": "#4F0C21",
  "accent-950": "#27040E",
  "info-50": "#EEF5FD",
  "info-100": "#DEEBFB",
  "info-200": "#CDE1F9",
  "info-300": "#BCD7F7",
  "info-400": "#4F96E9",
  "info-500": "#2E82E5",
  "info-600": "#276EC4",
  "info-700": "#0F2D59",
  "info-800": "#0B2348",
  "info-900": "#071938",
  "info-950": "#040F27",
  "success-50": "#EEFBF1",
  "success-100": "#DDF7E2",
  "success-200": "#CCF3D4",
  "success-300": "#BAEFC6",
  "success-400": "#4BD469",
  "success-500": "#29CC4D",
  "success-600": "#22AF42",
  "success-700": "#0D5120",
  "success-800": "#0A421B",
  "success-900": "#073415",
  "success-950": "#032510",
  "warning-50": "#FDF7EE",
  "warning-100": "#FBEFDE",
  "warning-200": "#F9E7CD",
  "warning-300": "#F7DFBC",
  "warning-400": "#E9AC4F",
  "warning-500": "#E59C2E",
  "warning-600": "#C48427",
  "warning-700": "#59350F",
  "warning-800": "#48290B",
  "warning-900": "#381C07",
  "warning-950": "#271004",
  "error-50": "#FDEEEE",
  "error-100": "#FBDEDE",
  "error-200": "#F9CDCD",
  "error-300": "#F7BCBC",
  "error-400": "#E94F4F",
  "error-500": "#E52E2E",
  "error-600": "#C42727",
  "error-700": "#590F10",
  "error-800": "#480B0C",
  "error-900": "#380709",
  "error-950": "#270405"
}, FE = P.forwardRef((e, t) => {
  const {
    mb: r,
    mt: n,
    bg: a,
    color: i,
    rounded: o,
    isHidden: s,
    spacing: c,
    spacingX: u,
    spacingY: d,
    spacingTop: h,
    spacingBottom: A,
    textAlign: p,
    border: v,
    borderTop: g,
    borderBottom: m,
    borderColor: b,
    borderStart: w,
    // Nueva propiedad
    children: x,
    className: y,
    ...C
  } = e, O = {
    textAlign: p,
    marginBottom: r !== void 0 ? `${r / 4}rem` : void 0,
    marginTop: n !== void 0 ? `${n / 4}rem` : void 0,
    backgroundColor: a !== void 0 ? gt[a] : void 0,
    color: i !== void 0 ? gt[i] : void 0,
    borderRadius: o !== void 0 ? eC[o] : void 0,
    borderColor: b !== void 0 ? gt[b] : void 0,
    padding: c !== void 0 ? `${c / 4}rem` : void 0
  };
  return v !== void 0 ? O.borderWidth = v : (O.borderTopWidth = g, O.borderBottomWidth = m), u !== void 0 && (O.paddingLeft = `${u / 4}rem`, O.paddingRight = `${u / 4}rem`), d !== void 0 && (O.paddingTop = `${d / 4}rem`, O.paddingBottom = `${d / 4}rem`), h !== void 0 && (O.paddingTop = `${h / 4}rem`), A !== void 0 && (O.paddingBottom = `${A / 4}rem`), w !== void 0 && (O.borderLeftWidth = w, O.borderLeftColor = b !== void 0 ? gt[b] : void 0, O.borderLeftStyle = "solid"), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `${s === !0 ? "hidden" : "block"}`,
      style: O,
      ...C,
      children: x
    }
  );
});
FE.displayName = "Box";
const $E = P.forwardRef((e, t) => {
  const {
    text: r,
    variant: n,
    minHeight: a = "60vh",
    minHeigthDesktop: i = "40vh"
  } = e, o = {
    "--ck-min-h-box-status": typeof a == "number" ? `${a}px` : a,
    "--ck-min-h-box-status-desktop": typeof i == "number" ? `${i}px` : i
  }, c = r ?? {
    loading: "Cargando...",
    empty: ""
  }[n];
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      style: o,
      className: "bg-Marca-800 flex items-center justify-center p-5 rounded-md h-full w-full min-h-[var(--ck-min-h-box-status)] m:min-h-[var(--ck-min-h-box-status-desktop)]",
      children: [
        n === "loading" && /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col items-center justify-center w-full text-center animate-pulse", children: [
          /* @__PURE__ */ f.jsx("div", { className: "bg-white flex justify-center items-center w-[64px] h-[64px] rounded-md mb-4", children: /* @__PURE__ */ f.jsxs("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
            /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_57_290)", children: [
              /* @__PURE__ */ f.jsx("path", { d: "M22.5565 4.17673C20.8792 3.90792 19.1218 3.90792 17.4445 4.17673L16.816 0.25121C18.9077 -0.0840621 21.0933 -0.0840621 23.185 0.25121L22.5565 4.17673Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M9.87513 7.57442L7.36798 4.48855C8.19002 3.81996 9.07558 3.211 10.0002 2.6773C10.9239 2.1436 11.8945 1.68126 12.8847 1.30396L14.303 5.01834C13.5093 5.32135 12.7303 5.69279 11.9884 6.12092C11.2455 6.55003 10.5349 7.03877 9.87611 7.57442H9.87513Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M5.02016 14.3014L1.30587 12.883C1.68414 11.8929 2.14647 10.9222 2.67918 9.99853C3.21286 9.07483 3.82181 8.18924 4.49038 7.36719L7.57618 9.8744C7.04054 10.5342 6.55084 11.2448 6.12272 11.9867C5.69362 12.7286 5.32317 13.5076 5.02016 14.3014Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M0.252181 23.1846C0.0850377 22.1387 0 21.0674 0 20C0 18.9326 0.0850377 17.8613 0.252181 16.8154L4.1776 17.4439C4.04369 18.2826 3.97527 19.1428 3.97527 20C3.97527 20.8573 4.04369 21.7174 4.1776 22.5561L0.252181 23.1846Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M4.49038 32.6319C3.82279 31.8098 3.21286 30.9242 2.67918 30.0005C2.14549 29.0768 1.68316 28.1062 1.30587 27.116L5.02016 25.6977C5.32317 26.4914 5.6946 27.2704 6.12272 28.0123C6.55182 28.7552 7.04054 29.4658 7.57618 30.1247L4.49038 32.6319Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M12.8837 38.6941C11.8936 38.3158 10.9239 37.8535 9.99927 37.3208C9.07558 36.7871 8.19002 36.1781 7.36701 35.5095L9.87416 32.4236C10.5339 32.9593 11.2445 33.448 11.9864 33.8771C12.7293 34.3063 13.5073 34.6767 14.301 34.9797L12.8827 38.6941H12.8837Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M20.0005 40C18.9331 40 17.8618 39.9149 16.816 39.7478L17.4445 35.8223C19.1218 36.0911 20.8792 36.0911 22.5565 35.8223L23.185 39.7478C22.1391 39.9149 21.0679 40 20.0005 40Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M27.1163 38.6941L25.698 34.9797C26.4917 34.6767 27.2707 34.3053 28.0126 33.8771C28.7555 33.448 29.4661 32.9593 30.1249 32.4236L32.632 35.5095C31.81 36.1781 30.9244 36.7871 29.9998 37.3208C29.0761 37.8545 28.1055 38.3168 27.1153 38.6941H27.1163Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M35.5096 32.6319L32.4238 30.1247C32.9595 29.4649 33.4482 28.7542 33.8773 28.0123C34.3064 27.2704 34.6768 26.4914 34.9798 25.6977L38.6941 27.116C38.3159 28.1062 37.8535 29.0768 37.3208 30.0005C36.7871 30.9242 36.1782 31.8098 35.5096 32.6319Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M39.7478 23.1836L35.8224 22.5551C35.9563 21.7165 36.0247 20.8563 36.0247 19.999C36.0247 19.1418 35.9563 18.2816 35.8224 17.443L39.7478 16.8145C39.915 17.8603 40 18.9317 40 19.999C40 21.0664 39.915 22.1377 39.7478 23.1836Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M34.9808 14.3023C34.6778 13.5086 34.3064 12.7296 33.8783 11.9877C33.4492 11.2448 32.9604 10.5342 32.4248 9.87537L35.5106 7.36816C36.1792 8.19022 36.7881 9.0758 37.3218 10.0005C37.8555 10.9242 38.3178 11.8948 38.6951 12.885L34.9808 14.3033V14.3023Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M30.1249 7.57442C29.4651 7.03877 28.7545 6.55003 28.0126 6.12092C27.2707 5.69181 26.4917 5.32135 25.698 5.01834L27.1163 1.30396C28.1064 1.68224 29.077 2.14458 30.0007 2.6773C30.9244 3.211 31.81 3.81996 32.632 4.48855L30.1249 7.57442Z", fill: "#141A22" })
            ] }),
            /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_57_290", children: /* @__PURE__ */ f.jsx("rect", { width: "40", height: "40", fill: "white" }) }) })
          ] }) }),
          c !== "" && /* @__PURE__ */ f.jsx(r1, { variant: "description-3", children: c })
        ] }),
        n === "empty" && /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col items-center justify-center w-full max-w-[300px] gap-4 text-center", children: [
          /* @__PURE__ */ f.jsx("div", { className: "flex justify-center select-none", children: /* @__PURE__ */ f.jsxs("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
            /* @__PURE__ */ f.jsx("path", { d: "M29.6452 29.6428C26.8698 31.7582 23.4903 32.9299 20.0011 32.9867C8.63586 32.9867 2.14081 19.9987 2.14081 19.9987C4.16063 16.235 6.96202 12.9468 10.357 10.3546M16.5909 7.4004C17.7087 7.13878 18.8531 7.00802 20.0011 7.01078C31.3664 7.01078 37.8614 19.9987 37.8614 19.9987C36.876 21.8422 35.7007 23.5778 34.3549 25.1772M23.437 23.4389C22.9899 23.9126 22.4523 24.2918 21.856 24.554C21.2598 24.8162 20.617 24.9562 19.9656 24.9655C19.3143 24.9749 18.6678 24.8536 18.0642 24.6086C17.4606 24.3637 16.9123 24.0002 16.4517 23.5396C15.9911 23.079 15.6276 22.5307 15.3827 21.9271C15.1377 21.3235 15.0164 20.677 15.0258 20.0257C15.0351 19.3743 15.1751 18.7315 15.4373 18.1353C15.6995 17.539 16.0787 17.0014 16.5524 16.5543", stroke: "#141A22", strokeWidth: "3", strokeLinecap: "round", "stroke-linejoin": "round" }),
            /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.627013 0.627013C1.46303 -0.209004 2.81848 -0.209004 3.6545 0.627013L39.373 36.3455C40.209 37.1815 40.209 38.537 39.373 39.373C38.537 40.209 37.1815 40.209 36.3455 39.373L0.627013 3.6545C-0.209004 2.81848 -0.209004 1.46303 0.627013 0.627013Z", fill: "#141A22" })
          ] }) }),
          c !== "" && /* @__PURE__ */ f.jsx(r1, { variant: "description-3", children: c })
        ] })
      ]
    }
  );
});
$E.displayName = "BoxStatus";
function Ye(e) {
  return `${e.filter((t) => t !== void 0).join(" ").trim()}`;
}
const HE = P.forwardRef((e, t) => {
  const {
    items: r = [],
    className: n
  } = e;
  return /* @__PURE__ */ f.jsx(
    "ul",
    {
      ref: t,
      className: Ye(["hidden m:flex flex-wrap gap-2", n]),
      children: r.map((a, i) => /* @__PURE__ */ f.jsxs(
        "li",
        {
          className: "text-neutral-400 flex gap-2 items-center",
          children: [
            /* @__PURE__ */ f.jsx(
              "div",
              {
                className: `hover:text-secondary-600 ${i + 1 === r.length ? "pointer-events-none" : "cursor-pointer"}`,
                onClick: () => {
                  i + 1 !== r.length && a.onClick !== void 0 && a.onClick();
                },
                children: /* @__PURE__ */ f.jsx(Vr, { variant: "title-3", children: a.description })
              }
            ),
            i + 1 !== r.length && /* @__PURE__ */ f.jsx("span", { className: "w-[14px] min-w-[14px] -rotate-90", children: /* @__PURE__ */ f.jsx(De, { variant: "arrow-down", width: 14 }) })
          ]
        },
        a.description
      ))
    }
  );
});
HE.displayName = "Breadcrumb";
const YE = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M14.043.71a.999.999 0 00-1.42 0l-4.58 4.58a1 1 0 01-1.42 0L2.043.71a1 1 0 10-1.42 1.41l4.59 4.59a3 3 0 004.24 0l4.59-4.59a1 1 0 000-1.41z",
        fill: "currentColor"
      }
    )
  }
), kE = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M6.70937 3.29018C6.61564 3.38315 6.54125 3.49375 6.49048 3.61561C6.43971 3.73747 6.41357 3.86817 6.41357 4.00018C6.41357 4.1322 6.43971 4.2629 6.49048 4.38476C6.54125 4.50662 6.61564 4.61722 6.70937 4.71018L11.2894 9.29018C11.3831 9.38315 11.4575 9.49375 11.5083 9.61561C11.559 9.73747 11.5852 9.86817 11.5852 10.0002C11.5852 10.1322 11.559 10.2629 11.5083 10.3848C11.4575 10.5066 11.3831 10.6172 11.2894 10.7102L6.70937 15.2902C6.61564 15.3831 6.54125 15.4937 6.49048 15.6156C6.43971 15.7375 6.41357 15.8682 6.41357 16.0002C6.41357 16.1322 6.43971 16.2629 6.49048 16.3848C6.54125 16.5066 6.61564 16.6172 6.70937 16.7102C6.89673 16.8964 7.15019 17.001 7.41437 17.001C7.67856 17.001 7.93201 16.8964 8.11937 16.7102L12.7094 12.1202C13.2712 11.5577 13.5867 10.7952 13.5867 10.0002C13.5867 9.20518 13.2712 8.44269 12.7094 7.88018L8.11937 3.29018C7.93201 3.10393 7.67856 2.99939 7.41437 2.99939C7.15019 2.99939 6.89673 3.10393 6.70937 3.29018Z",
        fill: "currentColor"
      }
    )
  }
), VE = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M16 9.005H6l3.29-3.29a1 1 0 10-1.41-1.42l-4.29 4.3a2 2 0 00-.59 1.41 2 2 0 00.59 1.4l4.29 4.3a1 1 0 001.628-1.096 1 1 0 00-.218-.324L6 11.005h10a1 1 0 000-2z",
        fill: "currentColor"
      }
    )
  }
), GE = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M13.426.2L15.2 2l-7.32 7.21a2.503 2.503 0 01-1.777.734 2.528 2.528 0 01-1.79-.74L.8 5.799 2.56 3.982l3.53 3.42 7.339-7.2L13.426.2z",
        fill: "currentColor"
      }
    )
  }
), WE = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_36415)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M14.0817 6.90667L15.2517 8.09417L10.4242 12.85C10.1017 13.1725 9.6775 13.3333 9.25167 13.3333C8.82583 13.3333 8.3975 13.1708 8.07167 12.8458L5.75333 10.5992L6.91417 9.40167L9.24167 11.6575L14.0817 6.90667ZM20.5 10C20.5 15.5142 16.0142 20 10.5 20C4.98583 20 0.5 15.5142 0.5 10C0.5 4.48583 4.98583 0 10.5 0C16.0142 0 20.5 4.48583 20.5 10ZM18.8333 10C18.8333 5.405 15.095 1.66667 10.5 1.66667C5.905 1.66667 2.16667 5.405 2.16667 10C2.16667 14.595 5.905 18.3333 10.5 18.3333C15.095 18.3333 18.8333 14.595 18.8333 10Z",
        fill: "currentColor"
      }
    ) })
  }
), QE = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433286 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34871 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0ZM10 18.3333C8.35183 18.3333 6.74066 17.8446 5.37025 16.9289C3.99984 16.0132 2.93174 14.7117 2.30101 13.189C1.67028 11.6663 1.50525 9.99075 1.82679 8.37425C2.14834 6.75774 2.94201 5.27288 4.10745 4.10744C5.27288 2.94201 6.75774 2.14833 8.37425 1.82679C9.99076 1.50525 11.6663 1.67027 13.189 2.301C14.7117 2.93173 16.0132 3.99984 16.9289 5.37025C17.8446 6.74066 18.3333 8.35182 18.3333 10C18.3309 12.2094 17.4522 14.3276 15.8899 15.8899C14.3276 17.4522 12.2094 18.3309 10 18.3333ZM10.8333 9.16667H14.1667V10.8333H10.8333V14.1667H9.16667V10.8333H5.83334V9.16667H9.16667V5.83333H10.8333V9.16667Z",
        fill: "currentColor"
      }
    )
  }
), UE = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12.9998 0.999818C12.8123 0.812347 12.558 0.707031 12.2928 0.707031C12.0277 0.707031 11.7733 0.812347 11.5858 0.999818L6.99982 5.58582L2.41382 0.999818C2.22629 0.812347 1.97198 0.707031 1.70682 0.707031C1.44165 0.707031 1.18735 0.812347 0.999818 0.999818C0.812347 1.18735 0.707031 1.44165 0.707031 1.70682C0.707031 1.97198 0.812347 2.22629 0.999818 2.41382L5.58582 6.99982L0.999818 11.5858C0.812347 11.7733 0.707031 12.0277 0.707031 12.2928C0.707031 12.558 0.812347 12.8123 0.999818 12.9998C1.18735 13.1873 1.44165 13.2926 1.70682 13.2926C1.97198 13.2926 2.22629 13.1873 2.41382 12.9998L6.99982 8.41382L11.5858 12.9998C11.7733 13.1873 12.0277 13.2926 12.2928 13.2926C12.558 13.2926 12.8123 13.1873 12.9998 12.9998C13.1873 12.8123 13.2926 12.558 13.2926 12.2928C13.2926 12.0277 13.1873 11.7733 12.9998 11.5858L8.41382 6.99982L12.9998 2.41382C13.1873 2.22629 13.2926 1.97198 13.2926 1.70682C13.2926 1.44165 13.1873 1.18735 12.9998 0.999818Z",
        fill: "currentColor"
      }
    )
  }
), ZE = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_1902_296)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M0.83 6.16504H19.16C19.62 6.16504 19.99 6.53504 19.99 6.99504C19.99 7.45504 19.62 7.82504 19.16 7.82504H0.83C0.37 7.83504 0 7.46504 0 7.00504C0 6.54504 0.37 6.16504 0.83 6.16504Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.83977 0.334961H19.1698C19.6298 0.334961 19.9998 0.704961 19.9998 1.16496C19.9998 1.62496 19.6298 1.99496 19.1698 1.99496H9.83977C9.37977 1.99496 9.00977 1.62496 9.00977 1.16496C9.00977 0.704961 9.37977 0.334961 9.83977 0.334961Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.83977 12.0049H19.1698C19.6298 12.0049 19.9998 12.3749 19.9998 12.8349C19.9998 13.2949 19.6298 13.6649 19.1698 13.6649H9.83977C9.37977 13.6649 9.00977 13.2949 9.00977 12.8349C9.00977 12.3749 9.37977 12.0049 9.83977 12.0049Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M2.17982 7.6749C1.80982 7.3049 1.79982 6.7049 2.17982 6.3249L6.54982 1.9649C6.91982 1.5949 6.92982 0.994902 6.54982 0.614902C6.17982 0.244902 5.57982 0.244902 5.20982 0.614902L0.839824 4.9849C-0.270176 6.1049 -0.270176 7.9049 0.839824 9.0249L5.20982 13.3949C5.38982 13.5749 5.62982 13.6749 5.87982 13.6749C6.12982 13.6749 6.37982 13.5749 6.55982 13.3949C6.92982 13.0249 6.93982 12.4249 6.55982 12.0449L2.17982 7.6749Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), KE = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.8333 1.6665H4.16667C1.86917 1.6665 0 3.53567 0 5.83317V14.1665C0 16.464 1.86917 18.3332 4.16667 18.3332H15.8333C18.1308 18.3332 20 16.464 20 14.1665V5.83317C20 3.53567 18.1308 1.6665 15.8333 1.6665ZM4.16667 3.33317H15.8333C17.2117 3.33317 18.3333 4.45484 18.3333 5.83317H1.66667C1.66667 4.45484 2.78833 3.33317 4.16667 3.33317ZM1.66667 14.1665V7.49984H9.16667V16.6665H4.16667C2.78833 16.6665 1.66667 15.5448 1.66667 14.1665ZM15.8333 16.6665H10.8333V7.49984H18.3333V14.1665C18.3333 15.5448 17.2117 16.6665 15.8333 16.6665Z",
        fill: "currentColor"
      }
    )
  }
), zE = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99984 6.6665C9.34057 6.6665 8.6961 6.862 8.14794 7.22827C7.59977 7.59454 7.17253 8.11514 6.92024 8.72423C6.66795 9.33331 6.60194 10.0035 6.73055 10.6501C6.85917 11.2967 7.17664 11.8907 7.64282 12.3569C8.10899 12.823 8.70293 13.1405 9.34954 13.2691C9.99614 13.3977 10.6664 13.3317 11.2755 13.0794C11.8845 12.8271 12.4051 12.3999 12.7714 11.8517C13.1377 11.3036 13.3332 10.6591 13.3332 9.99984C13.3332 9.11578 12.982 8.26794 12.3569 7.64281C11.7317 7.01769 10.8839 6.6665 9.99984 6.6665ZM9.99984 11.6665C9.6702 11.6665 9.34797 11.5688 9.07389 11.3856C8.79981 11.2025 8.58619 10.9422 8.46004 10.6376C8.33389 10.3331 8.30089 9.99799 8.3652 9.67469C8.42951 9.35139 8.58824 9.05441 8.82133 8.82133C9.05442 8.58824 9.35139 8.4295 9.67469 8.36519C9.99799 8.30089 10.3331 8.33389 10.6376 8.46004C10.9422 8.58618 11.2025 8.79981 11.3856 9.07389C11.5688 9.34797 11.6665 9.6702 11.6665 9.99984C11.6665 10.4419 11.4909 10.8658 11.1783 11.1783C10.8658 11.4909 10.4419 11.6665 9.99984 11.6665Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M17.7452 11.5833L17.3752 11.37C17.5417 10.4637 17.5417 9.53463 17.3752 8.62833L17.7452 8.415C18.0297 8.25085 18.2791 8.03226 18.4792 7.77172C18.6792 7.51118 18.826 7.21378 18.9111 6.89651C18.9962 6.57925 19.018 6.24832 18.9753 5.92263C18.9325 5.59694 18.826 5.28286 18.6618 4.99833C18.4977 4.7138 18.2791 4.46439 18.0185 4.26434C17.758 4.06428 17.4606 3.91751 17.1433 3.83239C16.8261 3.74726 16.4951 3.72547 16.1695 3.76824C15.8438 3.81101 15.5297 3.91751 15.2452 4.08167L14.8743 4.29583C14.1739 3.69743 13.369 3.23354 12.5002 2.9275V2.5C12.5002 1.83696 12.2368 1.20107 11.7679 0.732233C11.2991 0.263392 10.6632 0 10.0002 0C9.33712 0 8.70123 0.263392 8.23239 0.732233C7.76355 1.20107 7.50016 1.83696 7.50016 2.5V2.9275C6.63131 3.23464 5.8267 3.69967 5.12682 4.29917L4.75432 4.08333C4.17969 3.75181 3.49689 3.66214 2.85614 3.83405C2.21539 4.00596 1.66918 4.42536 1.33766 5C1.00614 5.57464 0.916468 6.25743 1.08838 6.89818C1.26028 7.53893 1.67969 8.08515 2.25432 8.41667L2.62432 8.63C2.45775 9.5363 2.45775 10.4654 2.62432 11.3717L2.25432 11.585C1.67969 11.9165 1.26028 12.4627 1.08838 13.1035C0.916468 13.7442 1.00614 14.427 1.33766 15.0017C1.66918 15.5763 2.21539 15.9957 2.85614 16.1676C3.49689 16.3395 4.17969 16.2499 4.75432 15.9183L5.12516 15.7042C5.8258 16.3027 6.63097 16.7666 7.50016 17.0725V17.5C7.50016 18.163 7.76355 18.7989 8.23239 19.2678C8.70123 19.7366 9.33712 20 10.0002 20C10.6632 20 11.2991 19.7366 11.7679 19.2678C12.2368 18.7989 12.5002 18.163 12.5002 17.5V17.0725C13.369 16.7654 14.1736 16.3003 14.8735 15.7008L15.246 15.9158C15.8206 16.2474 16.5034 16.337 17.1442 16.1651C17.7849 15.9932 18.3311 15.5738 18.6627 14.9992C18.9942 14.4245 19.0838 13.7417 18.9119 13.101C18.74 12.4602 18.3206 11.914 17.746 11.5825L17.7452 11.5833ZM15.6218 8.43667C15.904 9.45922 15.904 10.5391 15.6218 11.5617C15.5725 11.7396 15.5838 11.9289 15.6538 12.0998C15.7238 12.2707 15.8485 12.4135 16.0085 12.5058L16.9118 13.0275C17.1033 13.138 17.2431 13.3201 17.3004 13.5336C17.3577 13.7472 17.3277 13.9747 17.2172 14.1663C17.1067 14.3578 16.9247 14.4975 16.7111 14.5548C16.4976 14.6121 16.27 14.5822 16.0785 14.4717L15.1735 13.9483C15.0134 13.8556 14.827 13.8188 14.6437 13.8437C14.4604 13.8686 14.2906 13.9538 14.161 14.0858C13.4193 14.843 12.4848 15.3833 11.4585 15.6483C11.2794 15.6944 11.1206 15.7987 11.0073 15.9449C10.894 16.0911 10.8326 16.2709 10.8327 16.4558V17.5C10.8327 17.721 10.7449 17.933 10.5886 18.0893C10.4323 18.2455 10.2203 18.3333 9.99932 18.3333C9.77831 18.3333 9.56635 18.2455 9.41007 18.0893C9.25379 17.933 9.16599 17.721 9.16599 17.5V16.4567C9.16608 16.2717 9.10464 16.092 8.99133 15.9458C8.87802 15.7996 8.7193 15.6952 8.54016 15.6492C7.51378 15.3831 6.5796 14.8416 5.83849 14.0833C5.70893 13.9513 5.53911 13.8661 5.35579 13.8412C5.17247 13.8163 4.98608 13.8531 4.82599 13.9458L3.92266 14.4683C3.82785 14.5239 3.72298 14.5602 3.6141 14.5751C3.50521 14.59 3.39445 14.5832 3.2882 14.5551C3.18195 14.527 3.08231 14.4782 2.99501 14.4114C2.90771 14.3446 2.83447 14.2613 2.77952 14.1661C2.72457 14.0709 2.68899 13.9658 2.67482 13.8568C2.66066 13.7479 2.66819 13.6372 2.69698 13.5311C2.72578 13.425 2.77527 13.3257 2.8426 13.2389C2.90994 13.152 2.99379 13.0793 3.08932 13.025L3.99266 12.5033C4.15262 12.411 4.27739 12.2682 4.34737 12.0973C4.41736 11.9264 4.4286 11.7371 4.37932 11.5592C4.09712 10.5366 4.09712 9.45672 4.37932 8.43417C4.42771 8.25657 4.41594 8.06795 4.34584 7.89774C4.27574 7.72754 4.15125 7.58534 3.99182 7.49333L3.08849 6.97167C2.89698 6.86116 2.75722 6.6791 2.69994 6.46555C2.64266 6.25199 2.67257 6.02442 2.78307 5.83292C2.89358 5.64141 3.07564 5.50164 3.2892 5.44437C3.50275 5.38709 3.73032 5.41699 3.92182 5.5275L4.82682 6.05083C4.98647 6.14376 5.17247 6.18101 5.3556 6.15672C5.53872 6.13244 5.70858 6.048 5.83849 5.91667C6.58023 5.15945 7.51468 4.61918 8.54099 4.35417C8.72068 4.30797 8.87982 4.20313 8.99319 4.05625C9.10655 3.90938 9.16766 3.72887 9.16682 3.54333V2.5C9.16682 2.27899 9.25462 2.06702 9.4109 1.91074C9.56718 1.75446 9.77914 1.66667 10.0002 1.66667C10.2212 1.66667 10.4331 1.75446 10.5894 1.91074C10.7457 2.06702 10.8335 2.27899 10.8335 2.5V3.54333C10.8334 3.7283 10.8948 3.90804 11.0082 4.05423C11.1215 4.20043 11.2802 4.30478 11.4593 4.35083C12.486 4.61679 13.4205 5.15824 14.1618 5.91667C14.2914 6.04872 14.4612 6.13391 14.6445 6.15881C14.8278 6.1837 15.0142 6.14689 15.1743 6.05417L16.0777 5.53167C16.1725 5.47609 16.2773 5.43981 16.3862 5.42492C16.4951 5.41003 16.6059 5.41683 16.7121 5.44492C16.8184 5.47301 16.918 5.52184 17.0053 5.58859C17.0926 5.65535 17.1658 5.73872 17.2208 5.83389C17.2757 5.92907 17.3113 6.03417 17.3255 6.14316C17.3397 6.25214 17.3321 6.36285 17.3033 6.46891C17.2745 6.57497 17.225 6.67429 17.1577 6.76114C17.0904 6.848 17.0065 6.92068 16.911 6.975L16.0077 7.49667C15.8485 7.58892 15.7244 7.73123 15.6546 7.90141C15.5848 8.07159 15.5733 8.26008 15.6218 8.4375V8.43667Z",
          fill: "currentColor"
        }
      )
    ]
  }
), qE = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_842_3882)", children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M5.83333 0H3.33333C2.44928 0 1.60143 0.35119 0.976311 0.976311C0.35119 1.60143 0 2.44928 0 3.33333L0 5.83333C0 6.71739 0.35119 7.56524 0.976311 8.19036C1.60143 8.81548 2.44928 9.16667 3.33333 9.16667H5.83333C6.71739 9.16667 7.56524 8.81548 8.19036 8.19036C8.81548 7.56524 9.16667 6.71739 9.16667 5.83333V3.33333C9.16667 2.44928 8.81548 1.60143 8.19036 0.976311C7.56524 0.35119 6.71739 0 5.83333 0ZM7.5 5.83333C7.5 6.27536 7.32441 6.69928 7.01185 7.01185C6.69928 7.32441 6.27536 7.5 5.83333 7.5H3.33333C2.89131 7.5 2.46738 7.32441 2.15482 7.01185C1.84226 6.69928 1.66667 6.27536 1.66667 5.83333V3.33333C1.66667 2.89131 1.84226 2.46738 2.15482 2.15482C2.46738 1.84226 2.89131 1.66667 3.33333 1.66667H5.83333C6.27536 1.66667 6.69928 1.84226 7.01185 2.15482C7.32441 2.46738 7.5 2.89131 7.5 3.33333V5.83333Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M16.6668 0H14.1668C13.2828 0 12.4349 0.35119 11.8098 0.976311C11.1847 1.60143 10.8335 2.44928 10.8335 3.33333V5.83333C10.8335 6.71739 11.1847 7.56524 11.8098 8.19036C12.4349 8.81548 13.2828 9.16667 14.1668 9.16667H16.6668C17.5509 9.16667 18.3987 8.81548 19.0239 8.19036C19.649 7.56524 20.0002 6.71739 20.0002 5.83333V3.33333C20.0002 2.44928 19.649 1.60143 19.0239 0.976311C18.3987 0.35119 17.5509 0 16.6668 0ZM18.3335 5.83333C18.3335 6.27536 18.1579 6.69928 17.8453 7.01185C17.5328 7.32441 17.1089 7.5 16.6668 7.5H14.1668C13.7248 7.5 13.3009 7.32441 12.9883 7.01185C12.6758 6.69928 12.5002 6.27536 12.5002 5.83333V3.33333C12.5002 2.89131 12.6758 2.46738 12.9883 2.15482C13.3009 1.84226 13.7248 1.66667 14.1668 1.66667H16.6668C17.1089 1.66667 17.5328 1.84226 17.8453 2.15482C18.1579 2.46738 18.3335 2.89131 18.3335 3.33333V5.83333Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M5.83333 10.8335H3.33333C2.44928 10.8335 1.60143 11.1847 0.976311 11.8098C0.35119 12.4349 0 13.2828 0 14.1668L0 16.6668C0 17.5509 0.35119 18.3987 0.976311 19.0239C1.60143 19.649 2.44928 20.0002 3.33333 20.0002H5.83333C6.71739 20.0002 7.56524 19.649 8.19036 19.0239C8.81548 18.3987 9.16667 17.5509 9.16667 16.6668V14.1668C9.16667 13.2828 8.81548 12.4349 8.19036 11.8098C7.56524 11.1847 6.71739 10.8335 5.83333 10.8335ZM7.5 16.6668C7.5 17.1089 7.32441 17.5328 7.01185 17.8453C6.69928 18.1579 6.27536 18.3335 5.83333 18.3335H3.33333C2.89131 18.3335 2.46738 18.1579 2.15482 17.8453C1.84226 17.5328 1.66667 17.1089 1.66667 16.6668V14.1668C1.66667 13.7248 1.84226 13.3009 2.15482 12.9883C2.46738 12.6758 2.89131 12.5002 3.33333 12.5002H5.83333C6.27536 12.5002 6.69928 12.6758 7.01185 12.9883C7.32441 13.3009 7.5 13.7248 7.5 14.1668V16.6668Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M16.6668 10.8335H14.1668C13.2828 10.8335 12.4349 11.1847 11.8098 11.8098C11.1847 12.4349 10.8335 13.2828 10.8335 14.1668V16.6668C10.8335 17.5509 11.1847 18.3987 11.8098 19.0239C12.4349 19.649 13.2828 20.0002 14.1668 20.0002H16.6668C17.5509 20.0002 18.3987 19.649 19.0239 19.0239C19.649 18.3987 20.0002 17.5509 20.0002 16.6668V14.1668C20.0002 13.2828 19.649 12.4349 19.0239 11.8098C18.3987 11.1847 17.5509 10.8335 16.6668 10.8335ZM18.3335 16.6668C18.3335 17.1089 18.1579 17.5328 17.8453 17.8453C17.5328 18.1579 17.1089 18.3335 16.6668 18.3335H14.1668C13.7248 18.3335 13.3009 18.1579 12.9883 17.8453C12.6758 17.5328 12.5002 17.1089 12.5002 16.6668V14.1668C12.5002 13.7248 12.6758 13.3009 12.9883 12.9883C13.3009 12.6758 13.7248 12.5002 14.1668 12.5002H16.6668C17.1089 12.5002 17.5328 12.6758 17.8453 12.9883C18.1579 13.3009 18.3335 13.7248 18.3335 14.1668V16.6668Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_842_3882", children: /* @__PURE__ */ f.jsx("rect", { width: 20, height: 20, fill: "white" }) }) })
    ]
  }
), XE = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_30852)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M10 14.1666V17.4999C10 17.9583 9.625 18.3333 9.16667 18.3333H5.83333C5.375 18.3333 5 17.9583 5 17.4999C5 17.0416 5.375 16.6666 5.83333 16.6666H8.33333V14.9999H4.16667C1.86667 14.9999 0 13.1333 0 10.8333V4.99992C0 2.69992 1.86667 0.833252 4.16667 0.833252H14.1667C16.4667 0.833252 18.3333 2.69992 18.3333 4.99992C18.3333 5.45825 17.9583 5.83325 17.5 5.83325C17.0417 5.83325 16.6667 5.45825 16.6667 4.99992C16.6667 3.62492 15.5417 2.49992 14.1667 2.49992H4.16667C2.79167 2.49992 1.66667 3.62492 1.66667 4.99992V10.8333C1.66667 12.2083 2.79167 13.3333 4.16667 13.3333H9.16667C9.625 13.3333 10 13.7083 10 14.1666ZM20 10.8333V16.6666C20 18.5083 18.5083 19.9999 16.6667 19.9999H15C13.1583 19.9999 11.6667 18.5083 11.6667 16.6666V10.8333C11.6667 8.99158 13.1583 7.49992 15 7.49992H16.6667C18.5083 7.49992 20 8.99158 20 10.8333ZM18.3333 10.8333C18.3333 9.91658 17.5833 9.16658 16.6667 9.16658H15C14.0833 9.16658 13.3333 9.91658 13.3333 10.8333V16.6666C13.3333 17.5833 14.0833 18.3333 15 18.3333H16.6667C17.5833 18.3333 18.3333 17.5833 18.3333 16.6666V10.8333Z",
        fill: "currentColor"
      }
    ) })
  }
), JE = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2656_4445)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M13.3333 19.1667C13.3333 19.6267 12.9608 20 12.4999 20H4.99992C2.70242 20 0.833252 18.1308 0.833252 15.8333V4.16667C0.833252 1.86917 2.70242 0 4.99992 0H8.76242C10.3199 0 11.7849 0.606667 12.8874 1.70833L15.7908 4.61333C16.0166 4.83917 16.2266 5.08667 16.4141 5.34917C16.6816 5.72333 16.5949 6.24417 16.2208 6.51167C15.8466 6.77833 15.3249 6.6925 15.0583 6.3175C14.9241 6.13 14.7741 5.9525 14.6133 5.7925L11.7091 2.8875C11.4441 2.6225 11.1499 2.39833 10.8333 2.21667V5.83333C10.8333 6.2925 11.2066 6.66667 11.6666 6.66667H14.1666C14.6274 6.66667 14.9999 7.04 14.9999 7.5C14.9999 7.96 14.6274 8.33333 14.1666 8.33333H11.6666C10.2883 8.33333 9.16659 7.21167 9.16659 5.83333V1.68583C9.03325 1.67333 8.89825 1.66667 8.76242 1.66667H4.99992C3.62159 1.66667 2.49992 2.78833 2.49992 4.16667V15.8333C2.49992 17.2117 3.62159 18.3333 4.99992 18.3333H12.4999C12.9608 18.3333 13.3333 18.7067 13.3333 19.1667ZM18.0708 13.5558L15.5366 13.1333C15.2258 13.0817 14.9999 12.815 14.9999 12.5C14.9999 12.0408 15.3733 11.6667 15.8333 11.6667H17.7233C18.0199 11.6667 18.2966 11.8267 18.4458 12.0833C18.6749 12.4817 19.1833 12.6175 19.5841 12.3875C19.9824 12.1567 20.1191 11.6475 19.8874 11.2492C19.4424 10.4783 18.6124 9.99917 17.7224 9.99917H17.4991V9.16583C17.4991 8.70583 17.1266 8.3325 16.6658 8.3325C16.2049 8.3325 15.8324 8.70583 15.8324 9.16583V9.99917C14.4541 9.99917 13.3324 11.1208 13.3324 12.4992C13.3324 13.6325 14.1441 14.5908 15.2616 14.7767L17.7958 15.1992C18.1066 15.2508 18.3324 15.5175 18.3324 15.8325C18.3324 16.2917 17.9591 16.6658 17.4991 16.6658H15.6091C15.3124 16.6658 15.0358 16.5058 14.8866 16.2492C14.6574 15.85 14.1483 15.7142 13.7483 15.945C13.3499 16.1758 13.2133 16.685 13.4449 17.0833C13.8899 17.8542 14.7199 18.3325 15.6099 18.3325H15.8333V19.1658C15.8333 19.6258 16.2058 19.9992 16.6666 19.9992C17.1274 19.9992 17.4999 19.6258 17.4999 19.1658V18.3325C18.8783 18.3325 19.9999 17.2108 19.9999 15.8325C19.9999 14.6992 19.1883 13.7417 18.0708 13.5558ZM6.24992 12.5H10.8333C11.2941 12.5 11.6666 12.1267 11.6666 11.6667C11.6666 11.2067 11.2941 10.8333 10.8333 10.8333H6.24992C5.10159 10.8333 4.16659 11.7683 4.16659 12.9167V14.5833C4.16659 15.7317 5.10159 16.6667 6.24992 16.6667H10.8333C11.2941 16.6667 11.6666 16.2933 11.6666 15.8333C11.6666 15.3733 11.2941 15 10.8333 15H6.24992C6.01992 15 5.83325 14.8133 5.83325 14.5833V12.9167C5.83325 12.6867 6.01992 12.5 6.24992 12.5ZM4.99992 9.16667H6.66659C7.12659 9.16667 7.49992 8.79333 7.49992 8.33333C7.49992 7.87333 7.12659 7.5 6.66659 7.5H4.99992C4.53992 7.5 4.16659 7.87333 4.16659 8.33333C4.16659 8.79333 4.53992 9.16667 4.99992 9.16667ZM4.99992 5.83333H6.66659C7.12659 5.83333 7.49992 5.46 7.49992 5C7.49992 4.54 7.12659 4.16667 6.66659 4.16667H4.99992C4.53992 4.16667 4.16659 4.54 4.16659 5C4.16659 5.46 4.53992 5.83333 4.99992 5.83333Z",
        fill: "currentColor"
      }
    ) })
  }
), eS = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M7.33366 3.33333C8.25413 3.33333 9.00033 2.58714 9.00033 1.66667C9.00033 0.746192 8.25413 0 7.33366 0C6.41318 0 5.66699 0.746192 5.66699 1.66667C5.66699 2.58714 6.41318 3.33333 7.33366 3.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M7.33366 11.6668C8.25413 11.6668 9.00033 10.9206 9.00033 10.0002C9.00033 9.07969 8.25413 8.3335 7.33366 8.3335C6.41318 8.3335 5.66699 9.07969 5.66699 10.0002C5.66699 10.9206 6.41318 11.6668 7.33366 11.6668Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M7.33366 19.9998C8.25413 19.9998 9.00033 19.2536 9.00033 18.3332C9.00033 17.4127 8.25413 16.6665 7.33366 16.6665C6.41318 16.6665 5.66699 17.4127 5.66699 18.3332C5.66699 19.2536 6.41318 19.9998 7.33366 19.9998Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12.6667 3.33333C13.5871 3.33333 14.3333 2.58714 14.3333 1.66667C14.3333 0.746192 13.5871 0 12.6667 0C11.7462 0 11 0.746192 11 1.66667C11 2.58714 11.7462 3.33333 12.6667 3.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12.6667 11.6668C13.5871 11.6668 14.3333 10.9206 14.3333 10.0002C14.3333 9.07969 13.5871 8.3335 12.6667 8.3335C11.7462 8.3335 11 9.07969 11 10.0002C11 10.9206 11.7462 11.6668 12.6667 11.6668Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12.6667 19.9998C13.5871 19.9998 14.3333 19.2536 14.3333 18.3332C14.3333 17.4127 13.5871 16.6665 12.6667 16.6665C11.7462 16.6665 11 17.4127 11 18.3332C11 19.2536 11.7462 19.9998 12.6667 19.9998Z",
          fill: "currentColor"
        }
      )
    ]
  }
), tS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_32960)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M10.8333 4.99954H4.16667C1.86667 4.99954 0 6.86621 0 9.16621V15.8329C0 18.1329 1.86667 19.9995 4.16667 19.9995H10.8333C13.1333 19.9995 15 18.1329 15 15.8329V9.16621C15 6.86621 13.1333 4.99954 10.8333 4.99954ZM4.16667 6.66621H10.8333C12.2083 6.66621 13.3333 7.79121 13.3333 9.16621H1.66667C1.66667 7.79121 2.79167 6.66621 4.16667 6.66621ZM10.8333 18.3329H4.16667C2.79167 18.3329 1.66667 17.2079 1.66667 15.8329V10.8329H13.3333V15.8329C13.3333 17.2079 12.2083 18.3329 10.8333 18.3329ZM20 4.16621V11.2829C20 12.7662 19.2 14.1495 17.9167 14.8912C17.7833 14.9662 17.6417 14.9995 17.5 14.9995C17.2083 14.9995 16.9333 14.8495 16.775 14.5829C16.5417 14.1829 16.6833 13.6745 17.075 13.4412C17.85 12.9912 18.325 12.1662 18.325 11.2745V4.16621C18.325 2.79121 17.2 1.66621 15.825 1.66621H8.71667C7.825 1.66621 7 2.14954 6.55 2.91621C6.31667 3.31621 5.80833 3.44954 5.40833 3.21621C5.00833 2.98288 4.875 2.47454 5.10833 2.07454C5.85 0.791211 7.23333 -0.00878906 8.71667 -0.00878906H15.8333C18.1333 -0.00878906 20 1.85788 20 4.15788V4.16621Z",
        fill: "currentColor"
      }
    ) })
  }
), rS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2341_562)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.5468 0.775223L5.38676 10.9352C4.99872 11.3212 4.69108 11.7803 4.48167 12.2859C4.27225 12.7916 4.16522 13.3338 4.16676 13.8811V15.0002C4.16676 15.2212 4.25456 15.4332 4.41084 15.5895C4.56712 15.7458 4.77908 15.8336 5.0001 15.8336H6.11926C6.66657 15.8351 7.20874 15.7281 7.71439 15.5187C8.22005 15.3092 8.67914 15.0016 9.0651 14.6136L19.2251 4.45356C19.7121 3.96536 19.9856 3.30395 19.9856 2.61439C19.9856 1.92483 19.7121 1.26341 19.2251 0.775223C18.7298 0.301801 18.0711 0.0375977 17.3859 0.0375977C16.7008 0.0375977 16.042 0.301801 15.5468 0.775223ZM18.0468 3.27522L7.88676 13.4352C7.41687 13.9022 6.78177 14.1652 6.11926 14.1669H5.83343V13.8811C5.83517 13.2186 6.09807 12.5835 6.5651 12.1136L16.7251 1.95356C16.9031 1.78352 17.1398 1.68863 17.3859 1.68863C17.6321 1.68863 17.8688 1.78352 18.0468 1.95356C18.2217 2.12899 18.32 2.36663 18.32 2.61439C18.32 2.86215 18.2217 3.09979 18.0468 3.27522Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.1667 7.4825C18.9457 7.4825 18.7337 7.5703 18.5774 7.72658C18.4211 7.88286 18.3333 8.09482 18.3333 8.31583V12.5H15C14.337 12.5 13.7011 12.7634 13.2322 13.2322C12.7634 13.7011 12.5 14.337 12.5 15V18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H11.7017C11.9227 1.66667 12.1346 1.57887 12.2909 1.42259C12.4472 1.26631 12.535 1.05435 12.535 0.833333C12.535 0.61232 12.4472 0.400358 12.2909 0.244078C12.1346 0.0877974 11.9227 0 11.7017 0L4.16667 0C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H13.6192C14.1666 20.0016 14.7089 19.8945 15.2147 19.6851C15.7205 19.4757 16.1797 19.1681 16.5658 18.78L18.7792 16.565C19.1673 16.1791 19.475 15.72 19.6846 15.2143C19.8941 14.7087 20.0013 14.1665 20 13.6192V8.31583C20 8.09482 19.9122 7.88286 19.7559 7.72658C19.5996 7.5703 19.3877 7.4825 19.1667 7.4825ZM15.3875 17.6017C15.0525 17.9358 14.6289 18.1672 14.1667 18.2683V15C14.1667 14.779 14.2545 14.567 14.4107 14.4107C14.567 14.2545 14.779 14.1667 15 14.1667H18.2708C18.1677 14.6279 17.9367 15.0508 17.6042 15.3867L15.3875 17.6017Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), nS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2462_9634)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.55 17.4167C15.2083 17.1083 14.675 17.1417 14.375 17.4917C13.9 18.0333 13.2167 18.3417 12.5 18.3417H4.16667C2.79167 18.3417 1.66667 17.2167 1.66667 15.8417V4.16667C1.66667 2.79167 2.79167 1.66667 4.16667 1.66667H7.925C8.05833 1.66667 8.2 1.66667 8.33333 1.68333V5.83333C8.33333 7.20833 9.45833 8.33333 10.8333 8.33333H15.675C15.9333 8.33333 16.175 8.21667 16.3333 8.00833C16.4917 7.8 16.5417 7.54167 16.4833 7.29167C16.225 6.275 15.7 5.35 14.9583 4.60833L12.0583 1.70833C10.9583 0.608333 9.49167 0 7.93333 0H4.16667C1.86667 0 0 1.86667 0 4.16667V15.8333C0 18.1333 1.86667 20 4.16667 20H12.5C13.6917 20 14.8333 19.4833 15.625 18.5917C15.9333 18.25 15.9 17.7167 15.55 17.4167ZM10 2.21667C10.3167 2.4 10.6083 2.625 10.875 2.89167L13.775 5.79167C14.0333 6.05 14.2583 6.35 14.4417 6.66667H10.825C10.3667 6.66667 9.99167 6.29167 9.99167 5.83333V2.21667H10ZM19.275 15.075L17.9333 16.4167C17.7667 16.5833 17.5583 16.6583 17.3417 16.6583C17.125 16.6583 16.9167 16.575 16.75 16.4167C16.425 16.0917 16.425 15.5667 16.75 15.2417L17.825 14.1667H11.6583C11.2 14.1667 10.825 13.7917 10.825 13.3333C10.825 12.875 11.2 12.5 11.6583 12.5H17.825L16.75 11.425C16.425 11.1 16.425 10.575 16.75 10.25C17.075 9.925 17.6 9.925 17.925 10.25L19.2667 11.5917C20.225 12.55 20.225 14.1167 19.2667 15.0833L19.275 15.075Z",
        fill: "currentColor"
      }
    ) })
  }
), aS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_842_5289)", fill: "currentColor", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M19.392 7.85C18.1 5.745 15.16 2.213 10 2.213c-5.16 0-8.1 3.532-9.393 5.637a4.09 4.09 0 000 4.301C1.9 14.256 4.84 17.788 10 17.788c5.16 0 8.1-3.532 9.392-5.637a4.09 4.09 0 000-4.301zm-1.42 3.429c-1.11 1.805-3.623 4.842-7.972 4.842-4.35 0-6.862-3.037-7.972-4.842a2.431 2.431 0 010-2.557C3.138 6.917 5.651 3.88 10 3.88s6.861 3.034 7.971 4.842a2.432 2.432 0 010 2.557z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M10 5.833a4.167 4.167 0 100 8.333 4.167 4.167 0 000-8.333zm0 6.667A2.5 2.5 0 1110 7.5a2.5 2.5 0 010 4.999z" })
    ] })
  }
), iS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_842_5318)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M19.392 7.849a13.22 13.22 0 00-2.809-3.258l2.334-2.333a.833.833 0 00-1.179-1.178l-2.537 2.54A10.045 10.045 0 0010 2.212c-5.16 0-8.1 3.532-9.393 5.637a4.09 4.09 0 000 4.301 13.222 13.222 0 002.81 3.258l-2.334 2.333a.833.833 0 101.178 1.179l2.544-2.544A10.044 10.044 0 0010 17.787c5.159 0 8.099-3.531 9.392-5.636a4.09 4.09 0 000-4.302zM2.027 11.278a2.432 2.432 0 010-2.557C3.14 6.916 5.651 3.88 10 3.88a8.417 8.417 0 013.972.97l-1.678 1.678a4.16 4.16 0 00-5.767 5.767l-1.925 1.925a11.435 11.435 0 01-2.575-2.941zM12.5 10a2.5 2.5 0 01-2.5 2.5 2.458 2.458 0 01-1.071-.25l3.32-3.321c.164.333.25.7.25 1.07zm-5 0A2.5 2.5 0 0110 7.5a2.46 2.46 0 011.07.25l-3.32 3.32A2.46 2.46 0 017.5 10zm10.472 1.278C16.861 13.083 14.348 16.12 10 16.12a8.417 8.417 0 01-3.972-.97l1.678-1.678a4.16 4.16 0 005.766-5.767l1.925-1.925c1.021.826 1.892 1.82 2.575 2.941a2.431 2.431 0 010 2.557z",
        fill: "currentColor"
      }
    ) })
  }
), oS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_51729)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M1.2474 4.58208H3.5274C3.70626 5.24019 4.09671 5.82116 4.6385 6.23536C5.1803 6.64956 5.84333 6.87397 6.52531 6.87397C7.2073 6.87397 7.87033 6.64956 8.41212 6.23536C8.95392 5.82116 9.34437 5.24019 9.52323 4.58208H19.5807C19.8017 4.58208 20.0137 4.49429 20.17 4.33801C20.3263 4.18173 20.4141 3.96976 20.4141 3.74875C20.4141 3.52774 20.3263 3.31578 20.17 3.1595C20.0137 3.00321 19.8017 2.91542 19.5807 2.91542H9.52323C9.34437 2.25731 8.95392 1.67634 8.41212 1.26214C7.87033 0.847944 7.2073 0.623535 6.52531 0.623535C5.84333 0.623535 5.1803 0.847944 4.6385 1.26214C4.09671 1.67634 3.70626 2.25731 3.5274 2.91542H1.2474C1.02638 2.91542 0.81442 3.00321 0.65814 3.1595C0.50186 3.31578 0.414063 3.52774 0.414062 3.74875C0.414063 3.96976 0.50186 4.18173 0.65814 4.33801C0.81442 4.49429 1.02638 4.58208 1.2474 4.58208ZM6.5249 2.29042C6.81333 2.29042 7.09528 2.37595 7.3351 2.53619C7.57492 2.69643 7.76184 2.9242 7.87222 3.19067C7.9826 3.45715 8.01148 3.75037 7.95521 4.03326C7.89894 4.31615 7.76004 4.576 7.55609 4.77995C7.35214 4.9839 7.09229 5.12279 6.8094 5.17906C6.52651 5.23533 6.23329 5.20645 5.96682 5.09608C5.70034 4.9857 5.47258 4.79878 5.31234 4.55896C5.15209 4.31914 5.06656 4.03718 5.06656 3.74875C5.067 3.36211 5.22079 2.99144 5.49419 2.71804C5.76758 2.44465 6.13826 2.29086 6.5249 2.29042Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.5807 10.1667H17.3007C17.1222 9.50846 16.7319 8.92728 16.1901 8.51291C15.6484 8.09854 14.9853 7.87402 14.3032 7.87402C13.6212 7.87402 12.9581 8.09854 12.4163 8.51291C11.8746 8.92728 11.4843 9.50846 11.3057 10.1667H1.2474C1.02638 10.1667 0.81442 10.2545 0.65814 10.4108C0.50186 10.5671 0.414063 10.779 0.414062 11.0001C0.414063 11.2211 0.50186 11.433 0.65814 11.5893C0.81442 11.7456 1.02638 11.8334 1.2474 11.8334H11.3057C11.4843 12.4916 11.8746 13.0728 12.4163 13.4872C12.9581 13.9016 13.6212 14.1261 14.3032 14.1261C14.9853 14.1261 15.6484 13.9016 16.1901 13.4872C16.7319 13.0728 17.1222 12.4916 17.3007 11.8334H19.5807C19.8017 11.8334 20.0137 11.7456 20.17 11.5893C20.3263 11.433 20.4141 11.2211 20.4141 11.0001C20.4141 10.779 20.3263 10.5671 20.17 10.4108C20.0137 10.2545 19.8017 10.1667 19.5807 10.1667ZM14.3032 12.4584C14.0148 12.4584 13.7328 12.3729 13.493 12.2126C13.2532 12.0524 13.0663 11.8246 12.9559 11.5581C12.8455 11.2917 12.8166 10.9984 12.8729 10.7155C12.9292 10.4327 13.0681 10.1728 13.272 9.96885C13.476 9.7649 13.7358 9.62601 14.0187 9.56974C14.3016 9.51347 14.5948 9.54235 14.8613 9.65273C15.1278 9.76311 15.3555 9.95002 15.5158 10.1898C15.676 10.4297 15.7616 10.7116 15.7616 11.0001C15.7611 11.3867 15.6073 11.7574 15.3339 12.0308C15.0605 12.3042 14.6899 12.4579 14.3032 12.4584Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.5807 17.4179H9.52323C9.34437 16.7597 8.95392 16.1788 8.41212 15.7646C7.87033 15.3504 7.2073 15.126 6.52531 15.126C5.84333 15.126 5.1803 15.3504 4.6385 15.7646C4.09671 16.1788 3.70626 16.7597 3.5274 17.4179H1.2474C1.02638 17.4179 0.81442 17.5057 0.65814 17.6619C0.50186 17.8182 0.414063 18.0302 0.414062 18.2512C0.414063 18.4722 0.50186 18.6842 0.65814 18.8404C0.81442 18.9967 1.02638 19.0845 1.2474 19.0845H3.5274C3.70626 19.7426 4.09671 20.3236 4.6385 20.7378C5.1803 21.152 5.84333 21.3764 6.52531 21.3764C7.2073 21.3764 7.87033 21.152 8.41212 20.7378C8.95392 20.3236 9.34437 19.7426 9.52323 19.0845H19.5807C19.8017 19.0845 20.0137 18.9967 20.17 18.8404C20.3263 18.6842 20.4141 18.4722 20.4141 18.2512C20.4141 18.0302 20.3263 17.8182 20.17 17.6619C20.0137 17.5057 19.8017 17.4179 19.5807 17.4179ZM6.5249 19.7095C6.23646 19.7095 5.95451 19.624 5.71469 19.4638C5.47487 19.3035 5.28795 19.0757 5.17757 18.8093C5.06719 18.5428 5.03831 18.2496 5.09458 17.9667C5.15085 17.6838 5.28975 17.4239 5.4937 17.22C5.69765 17.016 5.9575 16.8772 6.24039 16.8209C6.52328 16.7646 6.8165 16.7935 7.08298 16.9039C7.34945 17.0142 7.57721 17.2012 7.73746 17.441C7.8977 17.6808 7.98323 17.9628 7.98323 18.2512C7.98257 18.6378 7.82871 19.0083 7.55536 19.2817C7.28202 19.555 6.91147 19.7089 6.5249 19.7095Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), sS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2656_4413)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.8333 0H4.16667C1.86667 0 0 1.86667 0 4.16667V15.8333C0 18.1333 1.86667 20 4.16667 20H8.69167C9.15 20 9.525 19.625 9.525 19.1667C9.525 18.7083 9.15 18.3333 8.69167 18.3333H4.16667C2.78333 18.3333 1.66667 17.2167 1.66667 15.8333V4.16667C1.66667 2.78333 2.78333 1.66667 4.16667 1.66667H15.8333C17.2167 1.66667 18.3333 2.78333 18.3333 4.16667V7.78333C18.3333 8.24167 18.7083 8.61667 19.1667 8.61667C19.625 8.61667 20 8.24167 20 7.78333V4.16667C20 1.86667 18.1333 0 15.8333 0Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.67511 9.6333C9.67511 10.9416 8.60844 12.0083 7.30011 12.0083V12.8C7.30011 13.2416 6.94178 13.5916 6.50844 13.5916C6.07511 13.5916 5.71678 13.2333 5.71678 12.8V12.0083H5.50844C4.65844 12.0083 3.87511 11.55 3.45011 10.8166C3.23344 10.4333 3.35844 9.94997 3.74178 9.7333C4.12511 9.5083 4.60844 9.64163 4.82511 10.025C4.96678 10.2666 5.23344 10.425 5.50844 10.425H7.30844C7.75011 10.425 8.10011 10.0666 8.10011 9.6333C8.10011 9.3333 7.88344 9.0833 7.59178 9.0333L5.18344 8.6333C4.11678 8.4583 3.35011 7.54163 3.35011 6.46663C3.35011 5.1583 4.41678 4.09163 5.72511 4.09163V3.29997C5.72511 2.8583 6.08344 2.5083 6.51678 2.5083C6.95011 2.5083 7.30844 2.86663 7.30844 3.29997V4.09163H7.51678C8.36678 4.09163 9.15011 4.54997 9.57511 5.2833C9.79178 5.6583 9.66678 6.14997 9.28344 6.36663C8.90011 6.5833 8.41678 6.4583 8.20011 6.07497C8.05844 5.8333 7.79178 5.67497 7.51678 5.67497H5.71678C5.27511 5.67497 4.92511 6.0333 4.92511 6.46663C4.92511 6.76663 5.14178 7.01663 5.43344 7.06663L7.84178 7.46663C8.90844 7.64163 9.67511 8.5583 9.67511 9.6333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.8916 11.2499C19.6583 10.8499 19.15 10.7166 18.75 10.9416L17.9416 11.4083C17.35 10.7499 16.575 10.2583 15.675 10.0833V9.16659C15.675 8.70825 15.3 8.33325 14.8416 8.33325C14.3833 8.33325 14.0083 8.70825 14.0083 9.16659V10.0833C13.1083 10.2666 12.325 10.7499 11.7416 11.4083L10.9333 10.9416C10.5333 10.7083 10.025 10.8499 9.79164 11.2499C9.55831 11.6499 9.69997 12.1583 10.1 12.3916L10.9083 12.8583C10.7666 13.2749 10.675 13.7083 10.675 14.1666C10.675 14.6249 10.7666 15.0583 10.9083 15.4749L10.1 15.9416C9.69997 16.1749 9.56664 16.6833 9.79164 17.0833C9.94997 17.3499 10.225 17.4999 10.5166 17.4999C10.6583 17.4999 10.8 17.4666 10.9333 17.3916L11.7416 16.9249C12.3333 17.5833 13.1083 18.0749 14.0083 18.2499V19.1666C14.0083 19.6249 14.3833 19.9999 14.8416 19.9999C15.3 19.9999 15.675 19.6249 15.675 19.1666V18.2499C16.575 18.0666 17.3583 17.5833 17.9416 16.9249L18.75 17.3916C18.8833 17.4666 19.025 17.4999 19.1666 17.4999C19.4583 17.4999 19.7333 17.3499 19.8916 17.0833C20.125 16.6833 19.9833 16.1749 19.5833 15.9416L18.775 15.4749C18.9166 15.0583 19.0083 14.6249 19.0083 14.1666C19.0083 13.7083 18.9166 13.2666 18.775 12.8583L19.5833 12.3916C19.9833 12.1583 20.1166 11.6499 19.8916 11.2499ZM14.8416 16.6666C13.4666 16.6666 12.3416 15.5416 12.3416 14.1666C12.3416 12.7916 13.4666 11.6666 14.8416 11.6666C16.2166 11.6666 17.3416 12.7916 17.3416 14.1666C17.3416 15.5416 16.2166 16.6666 14.8416 16.6666Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), lS = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M50.072 28.858A14.429 14.429 0 1164.5 14.428c-.01 7.965-6.463 14.42-14.428 14.429v.002zm0-26.358A11.928 11.928 0 1062 14.43C61.992 7.844 56.657 2.507 50.072 2.5z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M50.071 18.817c-.69 0-1.25-.56-1.25-1.25v-.087a5.753 5.753 0 012.729-4.855 2.766 2.766 0 10-4.245-2.338 1.25 1.25 0 11-2.5 0 5.288 5.288 0 011.673-3.85 5.22 5.22 0 013.965-1.402 5.267 5.267 0 012.445 9.705 3.258 3.258 0 00-1.567 2.742v.087c0 .69-.56 1.25-1.25 1.25v-.002zM50.072 23.837a1.19 1.19 0 01-.477-.095 1.195 1.195 0 01-.218-.117 1.208 1.208 0 01-.46-.561 1.26 1.26 0 01-.072-.727 1.26 1.26 0 01.982-.982 1.206 1.206 0 01.723.072 1.326 1.326 0 01.405.27 1.218 1.218 0 01.27.407 1.26 1.26 0 01.072.726 1.05 1.05 0 01-.072.234c-.032.075-.07.148-.114.216a1.277 1.277 0 01-1.038.557h-.002zM53.625 64H6.36A5.866 5.866 0 01.5 58.14V31.658a5.879 5.879 0 012.392-4.723l5.033-3.698a1.251 1.251 0 011.482 2.015L4.375 28.95A3.378 3.378 0 003 31.66V58.14a3.363 3.363 0 003.36 3.36h47.265a3.363 3.363 0 003.36-3.36V31.658a3.374 3.374 0 00-1.375-2.708L54 27.765a1.25 1.25 0 011.476-2.015l1.612 1.185a5.885 5.885 0 012.392 4.724V58.14A5.866 5.866 0 0153.625 64z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M56.663 62.85c-.266 0-.526-.085-.74-.243L35.938 47.923a1.25 1.25 0 111.48-2.015l19.987 14.684a1.25 1.25 0 01-.74 2.258h-.002zM3.317 62.85a1.252 1.252 0 01-.742-2.258l19.987-14.684a1.25 1.25 0 111.48 2.015L4.055 62.607a1.24 1.24 0 01-.738.243z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M29.99 52.278a5.852 5.852 0 01-3.707-1.313L1.401 30.653a1.253 1.253 0 01-.205-1.78c.214-.261.524-.426.86-.454.337-.03.67.078.925.298l24.882 20.31a3.376 3.376 0 004.25 0L57 28.717a1.251 1.251 0 111.581 1.937l-24.875 20.31a5.852 5.852 0 01-3.716 1.314z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M51.313 36.22c-.69 0-1.25-.56-1.25-1.25V27.55a1.25 1.25 0 112.5 0v7.421c0 .69-.56 1.25-1.25 1.25zM8.665 36.22c-.69 0-1.25-.56-1.25-1.25V10.875a5.869 5.869 0 015.862-5.86H39.72a1.25 1.25 0 010 2.5H13.277a3.365 3.365 0 00-3.362 3.36V34.97c0 .69-.56 1.25-1.25 1.25z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M28.106 13.797H15.555a1.25 1.25 0 010-2.5h12.551a1.25 1.25 0 010 2.5zM37.885 20.698H15.557a1.25 1.25 0 010-2.5h22.328a1.25 1.25 0 010 2.5zM44.423 27.602H15.557a1.25 1.25 0 010-2.5h28.868a1.25 1.25 0 010 2.5h-.002zM44.423 34.5H15.557a1.25 1.25 0 010-2.5h28.868a1.25 1.25 0 010 2.5h-.002zM44.423 41.408H15.557a1.25 1.25 0 010-2.5h28.868a1.25 1.25 0 010 2.5h-.002z",
          fill: "currentColor"
        }
      )
    ]
  }
), cS = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx("path", { d: "M10 25.7719L22.3062 11.6425C23.0758 10.7589 24.4367 10.7232 25.2516 11.5653L39 25.7719", stroke: "black", strokeLinecap: "round" }),
      /* @__PURE__ */ f.jsx("path", { d: "M13.0527 22.2105V34.9649C13.0527 36.0695 13.9481 36.9649 15.0527 36.9649H33.4386C34.5432 36.9649 35.4386 36.0695 35.4386 34.9649V22.2105", stroke: "black", strokeLinecap: "round" }),
      /* @__PURE__ */ f.jsx("rect", { x: "21.286", y: "23.0836", width: "6.19064", height: "6.19064", rx: "1.5", stroke: "black" })
    ]
  }
), uS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.8333 21.0018H4.16667C1.86917 21.0018 0 19.1326 0 16.8351V9.10513C0 7.71763 0.686667 6.42596 1.83667 5.65096L7.66917 1.7143C9.085 0.759297 10.915 0.759297 12.3308 1.7143L18.1642 5.65096C19.3133 6.42596 20 7.7168 20 9.10513V16.8351C20 19.1326 18.1308 21.0018 15.8333 21.0018ZM10 2.66596C9.51333 2.66596 9.02667 2.8093 8.60167 3.0968L2.76833 7.03263C2.07833 7.49763 1.66667 8.2718 1.66667 9.1043V16.8343C1.66667 18.2126 2.78833 19.3343 4.16667 19.3343H15.8333C17.2117 19.3343 18.3333 18.2126 18.3333 16.8343V9.10513C18.3333 8.27263 17.9217 7.49763 17.2325 7.03346L11.3983 3.0968C10.9733 2.8093 10.4867 2.66596 10 2.66596Z",
        fill: "currentColor"
      }
    )
  }
), dS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_30847)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.8334 7.02V5.83333C15.8334 4.28624 15.2188 2.80251 14.1249 1.70854C13.0309 0.614582 11.5472 0 10.0001 0C8.45298 0 6.96925 0.614582 5.87529 1.70854C4.78133 2.80251 4.16675 4.28624 4.16675 5.83333V7.02C3.42455 7.34392 2.79283 7.8771 2.34883 8.55434C1.90484 9.23158 1.66781 10.0235 1.66675 10.8333V15.8333C1.66807 16.938 2.10748 17.997 2.8886 18.7782C3.66971 19.5593 4.72875 19.9987 5.83341 20H14.1667C15.2714 19.9987 16.3305 19.5593 17.1116 18.7782C17.8927 17.997 18.3321 16.938 18.3334 15.8333V10.8333C18.3323 10.0235 18.0953 9.23158 17.6513 8.55434C17.2073 7.8771 16.5756 7.34392 15.8334 7.02ZM5.83341 5.83333C5.83341 4.72826 6.2724 3.66846 7.0538 2.88705C7.8352 2.10565 8.89501 1.66667 10.0001 1.66667C11.1052 1.66667 12.165 2.10565 12.9464 2.88705C13.7278 3.66846 14.1667 4.72826 14.1667 5.83333V6.66667H5.83341V5.83333ZM16.6667 15.8333C16.6667 16.4964 16.4034 17.1323 15.9345 17.6011C15.4657 18.0699 14.8298 18.3333 14.1667 18.3333H5.83341C5.17037 18.3333 4.53449 18.0699 4.06565 17.6011C3.59681 17.1323 3.33341 16.4964 3.33341 15.8333V10.8333C3.33341 10.1703 3.59681 9.53441 4.06565 9.06557C4.53449 8.59672 5.17037 8.33333 5.83341 8.33333H14.1667C14.8298 8.33333 15.4657 8.59672 15.9345 9.06557C16.4034 9.53441 16.6667 10.1703 16.6667 10.8333V15.8333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10.0001 11.6667C9.77907 11.6667 9.56711 11.7545 9.41083 11.9108C9.25455 12.0671 9.16675 12.2791 9.16675 12.5001V14.1667C9.16675 14.3878 9.25455 14.5997 9.41083 14.756C9.56711 14.9123 9.77907 15.0001 10.0001 15.0001C10.2211 15.0001 10.4331 14.9123 10.5893 14.756C10.7456 14.5997 10.8334 14.3878 10.8334 14.1667V12.5001C10.8334 12.2791 10.7456 12.0671 10.5893 11.9108C10.4331 11.7545 10.2211 11.6667 10.0001 11.6667Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), fS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_30861)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.56333 12.5C9.34232 12.5 9.13036 12.5878 8.97408 12.7441C8.8178 12.9004 8.73 13.1123 8.73 13.3333V15.8333C8.73 16.4964 8.46661 17.1323 7.99777 17.6011C7.52893 18.0699 6.89304 18.3333 6.23 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H6.23C6.89304 1.66667 7.52893 1.93006 7.99777 2.3989C8.46661 2.86774 8.73 3.50363 8.73 4.16667V6.66667C8.73 6.88768 8.8178 7.09964 8.97408 7.25592C9.13036 7.4122 9.34232 7.5 9.56333 7.5C9.78435 7.5 9.99631 7.4122 10.1526 7.25592C10.3089 7.09964 10.3967 6.88768 10.3967 6.66667V4.16667C10.3953 3.062 9.95593 2.00296 9.17482 1.22185C8.3937 0.440735 7.33466 0.00132321 6.23 0H4.16667C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H6.23C7.33466 19.9987 8.3937 19.5593 9.17482 18.7782C9.95593 17.997 10.3953 16.938 10.3967 15.8333V13.3333C10.3967 13.1123 10.3089 12.9004 10.1526 12.7441C9.99631 12.5878 9.78435 12.5 9.56333 12.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.0557 8.23232L15.234 4.41066C15.1571 4.33107 15.0652 4.26758 14.9635 4.22391C14.8618 4.18023 14.7525 4.15724 14.6418 4.15628C14.5312 4.15532 14.4215 4.1764 14.319 4.21831C14.2166 4.26021 14.1236 4.32208 14.0453 4.40033C13.9671 4.47857 13.9052 4.57161 13.8633 4.67403C13.8214 4.77644 13.8003 4.88618 13.8013 4.99682C13.8023 5.10747 13.8252 5.21682 13.8689 5.31849C13.9126 5.42016 13.9761 5.51212 14.0557 5.58899L17.6073 9.14149L4.99984 9.16649C4.77882 9.16649 4.56686 9.25429 4.41058 9.41057C4.2543 9.56685 4.1665 9.77881 4.1665 9.99982C4.1665 10.2208 4.2543 10.4328 4.41058 10.5891C4.56686 10.7454 4.77882 10.8332 4.99984 10.8332L17.6565 10.8073L14.054 14.4107C13.9744 14.4875 13.9109 14.5795 13.8673 14.6812C13.8236 14.7828 13.8006 14.8922 13.7996 15.0028C13.7987 15.1135 13.8198 15.2232 13.8617 15.3256C13.9036 15.428 13.9654 15.5211 14.0437 15.5993C14.1219 15.6776 14.215 15.7394 14.3174 15.7813C14.4198 15.8232 14.5295 15.8443 14.6402 15.8434C14.7508 15.8424 14.8602 15.8194 14.9618 15.7757C15.0635 15.7321 15.1555 15.6686 15.2323 15.589L19.054 11.7673C19.5229 11.2987 19.7865 10.6631 19.7868 10.0002C19.7871 9.33726 19.5241 8.70136 19.0557 8.23232Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), hS = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.1667 6.16699H0.833333C0.373096 6.16699 0 6.54009 0 7.00033C0 7.46056 0.373096 7.83366 0.833333 7.83366H19.1667C19.6269 7.83366 20 7.46056 20 7.00033C20 6.54009 19.6269 6.16699 19.1667 6.16699Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.1667 0.333496H0.833333C0.373096 0.333496 0 0.706592 0 1.16683C0 1.62707 0.373096 2.00016 0.833333 2.00016H19.1667C19.6269 2.00016 20 1.62707 20 1.16683C20 0.706592 19.6269 0.333496 19.1667 0.333496Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.1667 12H0.833333C0.373096 12 0 12.3731 0 12.8333C0 13.2936 0.373096 13.6667 0.833333 13.6667H19.1667C19.6269 13.6667 20 13.2936 20 12.8333C20 12.3731 19.6269 12 19.1667 12Z",
          fill: "currentColor"
        }
      )
    ]
  }
), AS = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99992 3.33333C10.9204 3.33333 11.6666 2.58714 11.6666 1.66667C11.6666 0.746192 10.9204 0 9.99992 0C9.07944 0 8.33325 0.746192 8.33325 1.66667C8.33325 2.58714 9.07944 3.33333 9.99992 3.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99992 11.6668C10.9204 11.6668 11.6666 10.9206 11.6666 10.0002C11.6666 9.07969 10.9204 8.3335 9.99992 8.3335C9.07944 8.3335 8.33325 9.07969 8.33325 10.0002C8.33325 10.9206 9.07944 11.6668 9.99992 11.6668Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99992 19.9998C10.9204 19.9998 11.6666 19.2536 11.6666 18.3332C11.6666 17.4127 10.9204 16.6665 9.99992 16.6665C9.07944 16.6665 8.33325 17.4127 8.33325 18.3332C8.33325 19.2536 9.07944 19.9998 9.99992 19.9998Z",
          fill: "currentColor"
        }
      )
    ]
  }
), pS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M18.91 11.382l-1.583-5.696a7.767 7.767 0 00-15.065.395l-1.225 5.512a4.166 4.166 0 004.067 5.07h.928a4.166 4.166 0 008.166 0h.698a4.166 4.166 0 004.014-5.281zm-8.795 6.947a2.5 2.5 0 01-2.346-1.666h4.692a2.5 2.5 0 01-2.346 1.666zm6.77-4.32a2.48 2.48 0 01-1.99.987H5.104a2.5 2.5 0 01-2.44-3.042L3.89 6.442a6.1 6.1 0 0111.832-.31l1.583 5.696a2.48 2.48 0 01-.418 2.181z",
        fill: "currentColor"
      }
    )
  }
), gS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.4374 6.63908L7.48643 0.805027C6.86542 0.350291 6.13061 0.0764315 5.36347 0.0138145C4.59632 -0.0488024 3.82682 0.10227 3.1403 0.45028C2.45377 0.798291 1.87704 1.32964 1.47406 1.98541C1.07108 2.64118 0.857591 3.39575 0.857269 4.16544V15.8336C0.857407 16.6036 1.07091 17.3585 1.47407 18.0146C1.87724 18.6707 2.45431 19.2022 3.14124 19.5502C3.82816 19.8982 4.59807 20.049 5.36553 19.986C6.13299 19.923 6.86798 19.6485 7.48892 19.1931L15.4399 13.3591C15.9677 12.972 16.3969 12.4661 16.6927 11.8823C16.9886 11.2985 17.1427 10.6532 17.1427 9.99867C17.1427 9.34417 16.9886 8.69887 16.6927 8.11505C16.3969 7.53123 15.9677 7.0253 15.4399 6.63825L15.4374 6.63908ZM14.4506 12.0148L6.49964 17.8488C6.1271 18.121 5.68651 18.2849 5.22662 18.3222C4.76673 18.3595 4.30549 18.2688 3.89395 18.0602C3.48241 17.8516 3.13662 17.5331 2.89486 17.1402C2.6531 16.7472 2.52479 16.295 2.52414 15.8336V4.16544C2.51952 3.70318 2.6454 3.24898 2.88734 2.85505C3.12927 2.46112 3.47743 2.14343 3.89181 1.9385C4.24427 1.75922 4.63402 1.66557 5.02945 1.66513C5.55943 1.66716 6.07476 1.83923 6.49964 2.15603L14.4506 7.99008C14.7669 8.22236 15.0241 8.52582 15.2013 8.87592C15.3786 9.22602 15.471 9.61292 15.471 10.0053C15.471 10.3977 15.3786 10.7847 15.2013 11.1348C15.0241 11.4848 14.7669 11.7883 14.4506 12.0206V12.0148Z",
        fill: "currentColor"
      }
    )
  }
), vS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.8333 8.83333H11.1667V4.16667C11.1667 3.85725 11.0437 3.5605 10.825 3.34171C10.6062 3.12292 10.3094 3 10 3C9.69058 3 9.39383 3.12292 9.17504 3.34171C8.95625 3.5605 8.83333 3.85725 8.83333 4.16667V8.83333H4.16667C3.85725 8.83333 3.5605 8.95625 3.34171 9.17504C3.12292 9.39383 3 9.69058 3 10C3 10.3094 3.12292 10.6062 3.34171 10.825C3.5605 11.0437 3.85725 11.1667 4.16667 11.1667H8.83333V15.8333C8.83333 16.1428 8.95625 16.4395 9.17504 16.6583C9.39383 16.8771 9.69058 17 10 17C10.3094 17 10.6062 16.8771 10.825 16.6583C11.0437 16.4395 11.1667 16.1428 11.1667 15.8333V11.1667H15.8333C16.1428 11.1667 16.4395 11.0437 16.6583 10.825C16.8771 10.6062 17 10.3094 17 10C17 9.69058 16.8771 9.39383 16.6583 9.17504C16.4395 8.95625 16.1428 8.83333 15.8333 8.83333Z",
        fill: "currentColor"
      }
    )
  }
), mS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_842_3889)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.8333 3.33333H14.9167C14.7233 2.39284 14.2115 1.54779 13.4677 0.940598C12.7239 0.333408 11.7935 0.0012121 10.8333 0L9.16667 0C8.2065 0.0012121 7.2761 0.333408 6.53229 0.940598C5.78848 1.54779 5.27675 2.39284 5.08333 3.33333H4.16667C3.062 3.33466 2.00296 3.77407 1.22185 4.55518C0.440735 5.3363 0.00132321 6.39534 0 7.5L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H15.8333C16.938 19.9987 17.997 19.5593 18.7782 18.7782C19.5593 17.997 19.9987 16.938 20 15.8333V7.5C19.9987 6.39534 19.5593 5.3363 18.7782 4.55518C17.997 3.77407 16.938 3.33466 15.8333 3.33333ZM9.16667 1.66667H10.8333C11.3485 1.6688 11.8505 1.83007 12.2706 2.12841C12.6906 2.42674 13.0083 2.84758 13.18 3.33333H6.82C6.99174 2.84758 7.30936 2.42674 7.72942 2.12841C8.14948 1.83007 8.65145 1.6688 9.16667 1.66667ZM4.16667 5H15.8333C16.4964 5 17.1323 5.26339 17.6011 5.73223C18.0699 6.20107 18.3333 6.83696 18.3333 7.5V10H1.66667V7.5C1.66667 6.83696 1.93006 6.20107 2.3989 5.73223C2.86774 5.26339 3.50363 5 4.16667 5ZM15.8333 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V11.6667H9.16667V12.5C9.16667 12.721 9.25446 12.933 9.41074 13.0893C9.56702 13.2455 9.77899 13.3333 10 13.3333C10.221 13.3333 10.433 13.2455 10.5893 13.0893C10.7455 12.933 10.8333 12.721 10.8333 12.5V11.6667H18.3333V15.8333C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1323 18.0699 16.4964 18.3333 15.8333 18.3333Z",
        fill: "currentColor"
      }
    ) })
  }
), CS = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433286 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34871 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0ZM10 18.3333C8.35183 18.3333 6.74066 17.8446 5.37025 16.9289C3.99984 16.0132 2.93174 14.7117 2.30101 13.189C1.67028 11.6663 1.50525 9.99075 1.82679 8.37425C2.14834 6.75774 2.94201 5.27288 4.10745 4.10744C5.27288 2.94201 6.75774 2.14833 8.37425 1.82679C9.99076 1.50525 11.6663 1.67027 13.189 2.301C14.7117 2.93173 16.0132 3.99984 16.9289 5.37025C17.8446 6.74066 18.3333 8.35182 18.3333 10C18.3309 12.2094 17.4522 14.3276 15.8899 15.8899C14.3276 17.4522 12.2094 18.3309 10 18.3333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10.5978 4.21903C10.1173 4.13147 9.62333 4.1506 9.15099 4.27506C8.67864 4.39952 8.23942 4.62628 7.8644 4.93928C7.48939 5.25228 7.18775 5.64388 6.98083 6.08636C6.77392 6.52884 6.66677 7.01139 6.66699 7.49986C6.66699 7.72087 6.75479 7.93284 6.91107 8.08912C7.06735 8.2454 7.27931 8.33319 7.50033 8.33319C7.72134 8.33319 7.9333 8.2454 8.08958 8.08912C8.24586 7.93284 8.33366 7.72087 8.33366 7.49986C8.33345 7.25467 8.38734 7.01246 8.49149 6.79049C8.59563 6.56852 8.74747 6.37227 8.93617 6.21572C9.12488 6.05917 9.3458 5.94618 9.58318 5.88481C9.82056 5.82345 10.0686 5.81521 10.3095 5.86069C10.6387 5.9246 10.9414 6.08518 11.1789 6.32193C11.4164 6.55869 11.5779 6.86086 11.6428 7.18986C11.7084 7.5352 11.6631 7.89242 11.5135 8.21047C11.3638 8.52852 11.1174 8.79111 10.8095 8.96069C10.2996 9.25608 9.87831 9.68279 9.58943 10.1964C9.30055 10.7099 9.15467 11.2916 9.16699 11.8807V12.4999C9.16699 12.7209 9.25479 12.9328 9.41107 13.0891C9.56735 13.2454 9.77931 13.3332 10.0003 13.3332C10.2213 13.3332 10.4333 13.2454 10.5896 13.0891C10.7459 12.9328 10.8337 12.7209 10.8337 12.4999V11.8807C10.8232 11.5907 10.8893 11.3031 11.0254 11.0468C11.1614 10.7905 11.3626 10.5745 11.6087 10.4207C12.2124 10.0891 12.6986 9.57857 13.0004 8.95936C13.3022 8.34015 13.4047 7.64266 13.2939 6.9628C13.1831 6.28294 12.8644 5.6541 12.3816 5.16277C11.8988 4.67144 11.2756 4.34175 10.5978 4.21903Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10.8337 14.9998C10.8337 14.5396 10.4606 14.1665 10.0003 14.1665C9.54009 14.1665 9.16699 14.5396 9.16699 14.9998C9.16699 15.4601 9.54009 15.8332 10.0003 15.8332C10.4606 15.8332 10.8337 15.4601 10.8337 14.9998Z",
          fill: "currentColor"
        }
      )
    ]
  }
), bS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_1353_11649)", children: /* @__PURE__ */ f.jsx("path", { d: "M19.7561 18.5773L14.782 13.6032C16.1375 11.9453 16.804 9.8299 16.6435 7.69445C16.4831 5.55901 15.508 3.56693 13.92 2.13025C12.3319 0.693577 10.2525 -0.0777715 8.11167 -0.024245C5.97088 0.0292815 3.93256 0.903588 2.41832 2.41783C0.904076 3.93207 0.0297698 5.97039 -0.0237567 8.11119C-0.0772832 10.252 0.694065 12.3314 2.13074 13.9195C3.56742 15.5075 5.5595 16.4826 7.69494 16.643C9.83038 16.8035 11.9458 16.137 13.6036 14.7815L18.5778 19.7557C18.735 19.9075 18.9455 19.9914 19.164 19.9895C19.3825 19.9876 19.5915 19.9 19.746 19.7455C19.9005 19.591 19.9881 19.382 19.99 19.1635C19.9919 18.945 19.9079 18.7345 19.7561 18.5773ZM8.33364 14.9998C7.0151 14.9998 5.72617 14.6088 4.62984 13.8763C3.53351 13.1437 2.67903 12.1025 2.17444 10.8844C1.66986 9.6662 1.53784 8.32576 1.79507 7.03255C2.05231 5.73934 2.68724 4.55146 3.61959 3.61911C4.55194 2.68676 5.73983 2.05182 7.03304 1.79458C8.32624 1.53735 9.66669 1.66937 10.8849 2.17395C12.103 2.67854 13.1442 3.53302 13.8768 4.62935C14.6093 5.72568 15.0003 7.01461 15.0003 8.33315C14.9983 10.1007 14.2953 11.7952 13.0455 13.045C11.7957 14.2948 10.1011 14.9978 8.33364 14.9998Z", fill: "currentColor" }) })
  }
), yS = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M16.743 10L8.25505 10C8.1049 9.9994 7.95831 9.95665 7.83381 9.87715C7.70931 9.79765 7.6125 9.68497 7.55561 9.55336C7.49873 9.42176 7.48433 9.27713 7.51423 9.13777C7.54413 8.99841 7.61699 8.87057 7.7236 8.77043L11.96 4.75815C12.0306 4.69075 12.1145 4.63726 12.207 4.60075C12.2996 4.56425 12.3988 4.54545 12.499 4.54545C12.5992 4.54545 12.6985 4.56425 12.791 4.60075C12.8835 4.63726 12.9675 4.69075 13.0381 4.75815L17.2744 8.77043C17.3811 8.87057 17.4539 8.99841 17.4838 9.13777C17.5137 9.27713 17.4993 9.42176 17.4424 9.55337C17.3855 9.68497 17.2887 9.79765 17.1642 9.87715C17.0397 9.95665 16.8931 9.9994 16.743 10Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8.25505 14H16.743C16.8931 14.0006 17.0397 14.0433 17.1642 14.1228C17.2887 14.2023 17.3855 14.315 17.4424 14.4466C17.4993 14.5782 17.5137 14.7229 17.4838 14.8622C17.4539 15.0016 17.3811 15.1294 17.2744 15.2296L13.0381 19.2419C12.9675 19.3092 12.8835 19.3627 12.791 19.3992C12.6985 19.4358 12.5992 19.4545 12.499 19.4545C12.3988 19.4545 12.2996 19.4358 12.207 19.3992C12.1145 19.3627 12.0306 19.3092 11.96 19.2419L7.7236 15.2296C7.61699 15.1294 7.54413 15.0016 7.51423 14.8622C7.48433 14.7229 7.49873 14.5782 7.55561 14.4466C7.6125 14.315 7.70931 14.2023 7.83381 14.1228C7.95831 14.0433 8.1049 14.0006 8.25505 14Z",
          fill: "currentColor"
        }
      )
    ]
  }
), wS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 97 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_1300_12843)", fill: "currentColor", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M67.225 43.186c-.387 0-.778-.113-1.11-.34a29.453 29.453 0 00-7.388-3.625 1.96 1.96 0 01-1.356-1.861V20.11c0-4.326-3.537-7.845-7.885-7.845s-7.885 3.518-7.885 7.844v17.25a1.96 1.96 0 01-1.356 1.862 29.545 29.545 0 00-7.388 3.624 1.978 1.978 0 01-2.03.114 1.959 1.959 0 01-1.05-1.734V20.106C29.776 9.296 38.618.5 49.484.5 60.35.5 69.194 9.296 69.194 20.11v21.117a1.972 1.972 0 01-1.972 1.962l.003-.003zm-5.913-7.214c1.35.508 2.67 1.102 3.941 1.779V20.109c0-8.651-7.073-15.688-15.767-15.688-8.694 0-15.767 7.037-15.767 15.688v17.642a33.676 33.676 0 013.94-1.779V20.106c0-6.487 5.306-11.764 11.827-11.764s11.826 5.277 11.826 11.764v15.866z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M49.486 100.5c-18.476 0-33.51-14.952-33.51-33.332 0-18.38 15.032-33.332 33.51-33.332 18.478 0 33.507 14.953 33.507 33.332 0 18.38-15.031 33.332-33.507 33.332zm0-62.744c-16.303 0-29.565 13.194-29.565 29.412 0 16.218 13.262 29.412 29.565 29.412s29.565-13.194 29.565-29.412c0-16.218-13.262-29.412-29.565-29.412z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M53.427 88.736h-7.885a1.967 1.967 0 01-1.972-1.962v-2.966a17.763 17.763 0 01-1.732-.716l-2.109 2.098a1.979 1.979 0 01-2.789 0l-5.575-5.547a1.959 1.959 0 010-2.775l2.108-2.097c-.27-.564-.51-1.138-.72-1.726h-2.981a1.967 1.967 0 01-1.972-1.962V63.24c0-1.082.881-1.962 1.972-1.962h2.982c.209-.585.449-1.162.72-1.725l-2.11-2.098a1.964 1.964 0 01-.577-1.388c0-.521.21-1.018.578-1.387l5.575-5.546a1.979 1.979 0 012.79 0l2.108 2.097c.566-.269 1.144-.508 1.732-.716v-2.966c0-1.082.882-1.962 1.972-1.962h7.885c1.088 0 1.972.877 1.972 1.962v2.966c.589.208 1.169.447 1.735.716l2.109-2.097a1.977 1.977 0 012.786 0l5.575 5.546c.77.766.77 2.006 0 2.772l-2.108 2.098c.27.563.51 1.137.72 1.726h2.981c1.088 0 1.972.876 1.972 1.961v7.844a1.967 1.967 0 01-1.972 1.962h-2.981c-.21.586-.45 1.163-.72 1.723l2.109 2.098c.77.766.77 2.006 0 2.775l-5.576 5.543a1.977 1.977 0 01-2.786 0l-2.11-2.097c-.565.269-1.143.507-1.734.716v2.966a1.965 1.965 0 01-1.972 1.962v.008zm-5.913-3.92h3.944v-2.457c0-.896.608-1.675 1.478-1.897 1.244-.32 2.44-.813 3.556-1.468a1.978 1.978 0 012.396.302l1.746 1.737 2.79-2.775-1.75-1.736a1.953 1.953 0 01-.303-2.384c.658-1.11 1.154-2.3 1.475-3.538a1.97 1.97 0 011.908-1.47h2.468v-3.92h-2.468a1.968 1.968 0 01-1.908-1.471 13.609 13.609 0 00-1.475-3.538 1.953 1.953 0 01.304-2.384l1.749-1.737-2.79-2.771-1.746 1.736a1.979 1.979 0 01-2.396.303 13.76 13.76 0 00-3.556-1.468 1.961 1.961 0 01-1.478-1.898v-2.455h-3.944v2.455c0 .896-.608 1.676-1.481 1.898-1.244.32-2.44.813-3.556 1.468a1.975 1.975 0 01-2.396-.303l-1.746-1.736-2.787 2.771 1.746 1.737c.636.633.762 1.615.305 2.384a13.646 13.646 0 00-1.476 3.538 1.968 1.968 0 01-1.908 1.47h-2.468v3.92h2.468c.901 0 1.685.606 1.908 1.471.32 1.238.817 2.428 1.476 3.538.457.771.331 1.751-.305 2.384l-1.746 1.736 2.787 2.775 1.746-1.737a1.98 1.98 0 012.396-.302 13.796 13.796 0 003.556 1.468 1.96 1.96 0 011.481 1.897v2.456z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M49.483 77.287c-1.632 0-3.3-.374-4.892-1.143-1.584-.766-3.361-2.53-4.13-4.11-2.043-4.18-1.326-8.903 1.82-12.033 3.147-3.13 7.894-3.84 12.097-1.812 1.584.766 3.361 2.533 4.13 4.11 2.043 4.178 1.326 8.904-1.82 12.03-1.956 1.946-4.527 2.956-7.205 2.956v.002zm.011-16.334a6.296 6.296 0 00-4.426 1.82c-1.545 1.537-2.636 4.326-1.063 7.547.388.794 1.51 1.91 2.307 2.295 3.235 1.565 6.041.48 7.584-1.057 1.545-1.538 2.635-4.326 1.062-7.548-.387-.793-1.509-1.909-2.306-2.294-1.116-.538-2.179-.763-3.158-.763zM92.847 52.46a2.949 2.949 0 01-2.957 2.94 2.95 2.95 0 01-2.956-2.94 2.95 2.95 0 012.956-2.942 2.95 2.95 0 012.957 2.941zM6.122 25.01a2.949 2.949 0 01-2.956 2.94 2.949 2.949 0 01-2.957-2.94 2.949 2.949 0 012.957-2.942 2.949 2.949 0 012.956 2.941zM14.005 87.754a2.949 2.949 0 01-2.957 2.94 2.95 2.95 0 01-2.956-2.94 2.95 2.95 0 012.956-2.942 2.95 2.95 0 012.957 2.942zM21.89 8.345a1.967 1.967 0 01-1.972 1.961 1.965 1.965 0 01-1.972-1.961c0-1.085.881-1.962 1.972-1.962 1.09 0 1.972.877 1.972 1.962zM21.89 37.754a1.967 1.967 0 01-1.972 1.961 1.965 1.965 0 01-1.972-1.962c0-1.084.881-1.961 1.972-1.961 1.09 0 1.972.877 1.972 1.962zM92.847 86.774a1.967 1.967 0 01-1.972 1.962 1.965 1.965 0 01-1.972-1.962c0-1.085.881-1.962 1.972-1.962 1.09 0 1.972.877 1.972 1.962zM81.02 35.795c-8.696 0-15.77-7.037-15.77-15.689 0-8.651 7.074-15.685 15.77-15.685 8.697 0 15.768 7.037 15.768 15.686 0 8.648-7.074 15.688-15.768 15.688zm0-27.45c-6.52 0-11.826 5.277-11.826 11.764 0 6.487 5.305 11.765 11.826 11.765 6.522 0 11.827-5.277 11.827-11.765 0-6.487-5.305-11.764-11.827-11.764z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M79.288 25.992c-.504 0-1.01-.192-1.394-.575l-2.62-2.605a1.956 1.956 0 010-2.775 1.98 1.98 0 012.79 0l1.224 1.218 5.576-5.546a1.977 1.977 0 012.786 0c.77.765.77 2.006 0 2.774l-6.967 6.931c-.385.383-.89.575-1.395.575v.003z" })
    ] })
  }
), xS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2648_4382)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M4.16667 18.3333C2.78333 18.3333 1.66667 17.2167 1.66667 15.8333V5.83333H7.5C7.5 7.21667 8.61667 8.33333 10 8.33333C11.3833 8.33333 12.5 7.21667 12.5 5.83333H18.3333V7.96667C18.3333 8.425 18.7083 8.8 19.1667 8.8C19.625 8.8 20 8.425 20 7.96667V4.16667C20 1.86667 18.1333 0 15.8333 0H4.16667C1.86667 0 0 1.86667 0 4.16667V15.8333C0 18.1333 1.86667 20 4.16667 20H9.30833C9.76667 20 10.1417 19.625 10.1417 19.1667C10.1417 18.7083 9.76667 18.3333 9.30833 18.3333H4.16667ZM12.5 1.66667H15.8333C17.2167 1.66667 18.3333 2.78333 18.3333 4.16667H12.5V1.66667ZM9.16667 1.66667H10.8333V5.83333C10.8333 6.29167 10.4583 6.66667 10 6.66667C9.54167 6.66667 9.16667 6.29167 9.16667 5.83333V1.66667ZM4.16667 1.66667H7.5V4.16667H1.66667C1.66667 2.78333 2.78333 1.66667 4.16667 1.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.5833 15.9499L18.775 15.4832C18.9166 15.0666 19.0083 14.6332 19.0083 14.1749C19.0083 13.7166 18.9166 13.2749 18.775 12.8666L19.5833 12.3999C19.9833 12.1666 20.1166 11.6582 19.8916 11.2582C19.6583 10.8582 19.15 10.7249 18.75 10.9499L17.9416 11.4166C17.35 10.7582 16.575 10.2666 15.675 10.0916V9.17489C15.675 8.71655 15.3 8.34155 14.8416 8.34155C14.3833 8.34155 14.0083 8.71655 14.0083 9.17489V10.0916C13.1083 10.2749 12.325 10.7582 11.7416 11.4166L10.9333 10.9499C10.5333 10.7166 10.025 10.8582 9.79164 11.2582C9.55831 11.6582 9.69997 12.1666 10.1 12.3999L10.9083 12.8666C10.7666 13.2832 10.675 13.7166 10.675 14.1749C10.675 14.6332 10.7666 15.0666 10.9083 15.4832L10.1 15.9499C9.69997 16.1832 9.56664 16.6916 9.79164 17.0916C9.94997 17.3582 10.225 17.5082 10.5166 17.5082C10.6583 17.5082 10.8 17.4749 10.9333 17.3999L11.7416 16.9332C12.3333 17.5916 13.1083 18.0832 14.0083 18.2582V19.1749C14.0083 19.6332 14.3833 20.0082 14.8416 20.0082C15.3 20.0082 15.675 19.6332 15.675 19.1749V18.2582C16.575 18.0749 17.3583 17.5916 17.9416 16.9332L18.75 17.3999C18.8833 17.4749 19.025 17.5082 19.1666 17.5082C19.4583 17.5082 19.7333 17.3582 19.8916 17.0916C20.125 16.6916 19.9833 16.1832 19.5833 15.9499ZM14.8333 16.6749C13.4583 16.6749 12.3333 15.5499 12.3333 14.1749C12.3333 12.7999 13.4583 11.6749 14.8333 11.6749C16.2083 11.6749 17.3333 12.7999 17.3333 14.1749C17.3333 15.5499 16.2083 16.6749 14.8333 16.6749Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), DS = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.8333 3.33333H13.25C13.0566 2.39284 12.5448 1.54779 11.801 0.940598C11.0572 0.333408 10.1268 0.0012121 9.16667 0L7.5 0C6.53983 0.0012121 5.60943 0.333408 4.86562 0.940598C4.12182 1.54779 3.61008 2.39284 3.41667 3.33333H0.833333C0.61232 3.33333 0.400358 3.42113 0.244078 3.57741C0.0877973 3.73369 0 3.94565 0 4.16667C0 4.38768 0.0877973 4.59964 0.244078 4.75592C0.400358 4.9122 0.61232 5 0.833333 5H1.66667V15.8333C1.66799 16.938 2.1074 17.997 2.88852 18.7782C3.66963 19.5593 4.72867 19.9987 5.83333 20H10.8333C11.938 19.9987 12.997 19.5593 13.7782 18.7782C14.5593 17.997 14.9987 16.938 15 15.8333V5H15.8333C16.0543 5 16.2663 4.9122 16.4226 4.75592C16.5789 4.59964 16.6667 4.38768 16.6667 4.16667C16.6667 3.94565 16.5789 3.73369 16.4226 3.57741C16.2663 3.42113 16.0543 3.33333 15.8333 3.33333ZM7.5 1.66667H9.16667C9.68356 1.6673 10.1876 1.82781 10.6097 2.1262C11.0317 2.42459 11.3512 2.84624 11.5242 3.33333H5.1425C5.31549 2.84624 5.63492 2.42459 6.05699 2.1262C6.47906 1.82781 6.9831 1.6673 7.5 1.66667ZM13.3333 15.8333C13.3333 16.4964 13.0699 17.1323 12.6011 17.6011C12.1323 18.0699 11.4964 18.3333 10.8333 18.3333H5.83333C5.17029 18.3333 4.53441 18.0699 4.06557 17.6011C3.59673 17.1323 3.33333 16.4964 3.33333 15.8333V5H13.3333V15.8333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M6.66683 15.0002C6.88784 15.0002 7.0998 14.9124 7.25608 14.7561C7.41237 14.5998 7.50016 14.3878 7.50016 14.1668V9.16683C7.50016 8.94582 7.41237 8.73385 7.25608 8.57757C7.0998 8.42129 6.88784 8.3335 6.66683 8.3335C6.44582 8.3335 6.23385 8.42129 6.07757 8.57757C5.92129 8.73385 5.8335 8.94582 5.8335 9.16683V14.1668C5.8335 14.3878 5.92129 14.5998 6.07757 14.7561C6.23385 14.9124 6.44582 15.0002 6.66683 15.0002Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99984 15.0002C10.2209 15.0002 10.4328 14.9124 10.5891 14.7561C10.7454 14.5998 10.8332 14.3878 10.8332 14.1668V9.16683C10.8332 8.94582 10.7454 8.73385 10.5891 8.57757C10.4328 8.42129 10.2209 8.3335 9.99984 8.3335C9.77882 8.3335 9.56686 8.42129 9.41058 8.57757C9.2543 8.73385 9.1665 8.94582 9.1665 9.16683V14.1668C9.1665 14.3878 9.2543 14.5998 9.41058 14.7561C9.56686 14.9124 9.77882 15.0002 9.99984 15.0002Z",
          fill: "currentColor"
        }
      )
    ]
  }
), OS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_30842)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 10C10.9889 10 11.9556 9.70676 12.7779 9.15735C13.6001 8.60794 14.241 7.82705 14.6194 6.91342C14.9978 5.99979 15.0969 4.99446 14.9039 4.02455C14.711 3.05465 14.2348 2.16373 13.5355 1.46447C12.8363 0.765206 11.9454 0.289002 10.9755 0.0960758C10.0055 -0.0968503 9.00021 0.00216643 8.08658 0.380605C7.17295 0.759043 6.39206 1.39991 5.84265 2.22215C5.29324 3.0444 5 4.0111 5 5C5.00132 6.32568 5.52853 7.59668 6.46593 8.53407C7.40332 9.47147 8.67432 9.99868 10 10ZM10 1.66667C10.6593 1.66667 11.3037 1.86217 11.8519 2.22844C12.4001 2.59471 12.8273 3.1153 13.0796 3.72439C13.3319 4.33348 13.3979 5.0037 13.2693 5.6503C13.1407 6.29691 12.8232 6.89085 12.357 7.35703C11.8908 7.8232 11.2969 8.14067 10.6503 8.26929C10.0037 8.3979 9.33348 8.33189 8.72439 8.0796C8.1153 7.82731 7.59471 7.40007 7.22843 6.8519C6.86216 6.30374 6.66667 5.65927 6.66667 5C6.66667 4.11595 7.01786 3.2681 7.64298 2.64298C8.2681 2.01786 9.11594 1.66667 10 1.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 11.6667C8.01155 11.669 6.10518 12.4598 4.69914 13.8659C3.29309 15.2719 2.50221 17.1783 2.5 19.1667C2.5 19.3878 2.5878 19.5997 2.74408 19.756C2.90036 19.9123 3.11232 20.0001 3.33333 20.0001C3.55435 20.0001 3.76631 19.9123 3.92259 19.756C4.07887 19.5997 4.16667 19.3878 4.16667 19.1667C4.16667 17.6197 4.78125 16.1359 5.87521 15.042C6.96917 13.948 8.4529 13.3334 10 13.3334C11.5471 13.3334 13.0308 13.948 14.1248 15.042C15.2188 16.1359 15.8333 17.6197 15.8333 19.1667C15.8333 19.3878 15.9211 19.5997 16.0774 19.756C16.2337 19.9123 16.4457 20.0001 16.6667 20.0001C16.8877 20.0001 17.0996 19.9123 17.2559 19.756C17.4122 19.5997 17.5 19.3878 17.5 19.1667C17.4978 17.1783 16.7069 15.2719 15.3009 13.8659C13.8948 12.4598 11.9884 11.669 10 11.6667Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), MS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_30857)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M5.83333 11.6667C7.675 11.6667 9.16667 10.175 9.16667 8.33333C9.16667 6.49167 7.675 5 5.83333 5C3.99167 5 2.5 6.49167 2.5 8.33333C2.5 10.175 3.99167 11.6667 5.83333 11.6667ZM5.83333 6.66667C6.75 6.66667 7.5 7.41667 7.5 8.33333C7.5 9.25 6.75 10 5.83333 10C4.91667 10 4.16667 9.25 4.16667 8.33333C4.16667 7.41667 4.91667 6.66667 5.83333 6.66667ZM11.6667 19.1667C11.6667 19.625 11.2917 20 10.8333 20C10.375 20 10 19.625 10 19.1667C10 16.8667 8.13333 15 5.83333 15C3.53333 15 1.66667 16.8667 1.66667 19.1667C1.66667 19.625 1.29167 20 0.833333 20C0.375 20 0 19.625 0 19.1667C0 15.95 2.61667 13.3333 5.83333 13.3333C9.05 13.3333 11.6667 15.95 11.6667 19.1667ZM20 4.16667V10.8333C20 13.1333 18.1333 15 15.8333 15H12.5C12.0417 15 11.6667 14.625 11.6667 14.1667C11.6667 13.7083 12.0417 13.3333 12.5 13.3333H15.8333C17.2083 13.3333 18.3333 12.2083 18.3333 10.8333V4.16667C18.3333 2.79167 17.2083 1.66667 15.8333 1.66667H7.88333C6.99167 1.66667 6.16667 2.15 5.71667 2.91667C5.48333 3.31667 4.975 3.45 4.575 3.225C4.175 2.99167 4.04167 2.48333 4.275 2.08333C5.025 0.8 6.40833 0 7.88333 0H15.8333C18.1333 0 20 1.86667 20 4.16667ZM11.3917 9.1L13.825 6.66667H12.5C12.0417 6.66667 11.6667 6.29167 11.6667 5.83333C11.6667 5.375 12.0417 5 12.5 5H15C15.9167 5 16.6667 5.75 16.6667 6.66667V9.16667C16.6667 9.625 16.2917 10 15.8333 10C15.375 10 15 9.625 15 9.16667V7.84167L12.5667 10.275C12.1833 10.6583 11.6667 10.8667 11.1417 10.8667C10.9583 10.8667 10.775 10.8417 10.5917 10.7917C10.15 10.6667 9.89167 10.2083 10.0167 9.76667C10.1417 9.325 10.6 9.06667 11.05 9.19167C11.15 9.21667 11.2833 9.20833 11.3917 9.1Z",
        fill: "currentColor"
      }
    ) })
  }
), ES = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2656_4398)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12.4999 5C12.4999 2.2425 10.2574 0 7.49986 0C4.74236 0 2.49986 2.2425 2.49986 5C2.49986 7.7575 4.74236 10 7.49986 10C10.2574 10 12.4999 7.7575 12.4999 5ZM7.49986 8.33333C5.66152 8.33333 4.16652 6.83833 4.16652 5C4.16652 3.16167 5.66152 1.66667 7.49986 1.66667C9.33819 1.66667 10.8332 3.16167 10.8332 5C10.8332 6.83833 9.33819 8.33333 7.49986 8.33333ZM7.49319 12.4483C7.54986 12.905 7.22652 13.3208 6.76902 13.3783C3.85986 13.7417 1.66569 16.2292 1.66569 19.1667C1.66569 19.6267 1.29236 20 0.832357 20C0.372357 20 -0.000976562 19.6267 -0.000976562 19.1667C-0.000976562 15.3908 2.82069 12.1917 6.56236 11.725C7.01402 11.6675 7.43486 11.9917 7.49236 12.4492L7.49319 12.4483ZM18.9132 15.9442L18.1015 15.4758C18.2399 15.0617 18.3332 14.6267 18.3332 14.1658C18.3332 13.705 18.2407 13.27 18.1015 12.8558L18.9132 12.3875C19.3115 12.1575 19.4482 11.6475 19.2182 11.2492C18.9874 10.85 18.479 10.7125 18.0799 10.9442L17.269 11.4125C16.6815 10.7508 15.899 10.2667 14.9999 10.0842V9.16667C14.9999 8.70667 14.6265 8.33333 14.1665 8.33333C13.7065 8.33333 13.3332 8.70667 13.3332 9.16667V10.0842C12.434 10.2675 11.6515 10.7517 11.064 11.4125L10.2532 10.9442C9.85319 10.7133 9.34486 10.85 9.11486 11.2492C8.88486 11.6483 9.02152 12.1575 9.41986 12.3875L10.2315 12.8558C10.0932 13.27 9.99986 13.705 9.99986 14.1658C9.99986 14.6267 10.0924 15.0617 10.2315 15.4758L9.41986 15.9442C9.02152 16.1742 8.88486 16.6842 9.11486 17.0825C9.26986 17.35 9.54902 17.4992 9.83736 17.4992C9.97819 17.4992 10.1215 17.4633 10.2532 17.3875L11.064 16.9192C11.6515 17.5808 12.434 18.065 13.3332 18.2475V19.165C13.3332 19.625 13.7065 19.9983 14.1665 19.9983C14.6265 19.9983 14.9999 19.625 14.9999 19.165V18.2475C15.899 18.0642 16.6815 17.58 17.269 16.9192L18.0799 17.3875C18.2115 17.4633 18.3549 17.4992 18.4957 17.4992C18.784 17.4992 19.064 17.35 19.2182 17.0825C19.4482 16.6833 19.3115 16.1742 18.9132 15.9442ZM14.1665 16.6658C12.7882 16.6658 11.6665 15.5442 11.6665 14.1658C11.6665 12.7875 12.7882 11.6658 14.1665 11.6658C15.5449 11.6658 16.6665 12.7875 16.6665 14.1658C16.6665 15.5442 15.5449 16.6658 14.1665 16.6658Z",
        fill: "currentColor"
      }
    ) })
  }
), SS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_42419)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M9.13972 12.5022C9.25472 12.9481 8.98639 13.4022 8.54055 13.5164C5.96472 14.1797 4.16555 16.5022 4.16555 19.1664C4.16555 19.6264 3.79222 19.9997 3.33222 19.9997C2.87222 19.9997 2.49889 19.6264 2.49889 19.1664C2.49889 15.7422 4.81222 12.7556 8.12389 11.9031C8.57305 11.7889 9.02389 12.0564 9.13889 12.5022H9.13972ZM19.7556 19.7556C19.5931 19.9181 19.3797 19.9997 19.1664 19.9997C18.9531 19.9997 18.7397 19.9181 18.5772 19.7556L0.243887 1.42222C-0.0819466 1.09639 -0.0819466 0.56972 0.243887 0.243887C0.56972 -0.0819466 1.09639 -0.0819466 1.42222 0.243887L5.11555 3.93722C5.60472 1.68972 7.60722 -0.000279957 9.99972 -0.000279957C12.7572 -0.000279957 14.9997 2.24222 14.9997 4.99972C14.9997 7.39222 13.3097 9.39472 11.0622 9.88389L19.7556 18.5772C20.0814 18.9031 20.0814 19.4297 19.7556 19.7556ZM6.72055 5.54222L9.45722 8.27889C9.63639 8.30805 9.81722 8.33305 9.99972 8.33305C11.8381 8.33305 13.3331 6.83805 13.3331 4.99972C13.3331 3.16139 11.8381 1.66639 9.99972 1.66639C8.16139 1.66639 6.66639 3.16139 6.66639 4.99972C6.66639 5.18139 6.69139 5.36305 6.72055 5.54222Z",
        fill: "currentColor"
      }
    ) })
  }
), PS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2364_27217)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.8333 9.1665H18.1667V7.49984C18.1667 7.27882 18.0789 7.06686 17.9226 6.91058C17.7663 6.7543 17.5543 6.6665 17.3333 6.6665C17.1123 6.6665 16.9004 6.7543 16.7441 6.91058C16.5878 7.06686 16.5 7.27882 16.5 7.49984V9.1665H14.8333C14.6123 9.1665 14.4004 9.2543 14.2441 9.41058C14.0878 9.56686 14 9.77882 14 9.99984C14 10.2209 14.0878 10.4328 14.2441 10.5891C14.4004 10.7454 14.6123 10.8332 14.8333 10.8332H16.5V12.4998C16.5 12.7209 16.5878 12.9328 16.7441 13.0891C16.9004 13.2454 17.1123 13.3332 17.3333 13.3332C17.5543 13.3332 17.7663 13.2454 17.9226 13.0891C18.0789 12.9328 18.1667 12.7209 18.1667 12.4998V10.8332H19.8333C20.0543 10.8332 20.2663 10.7454 20.4226 10.5891C20.5789 10.4328 20.6667 10.2209 20.6667 9.99984C20.6667 9.77882 20.5789 9.56686 20.4226 9.41058C20.2663 9.2543 20.0543 9.1665 19.8333 9.1665Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8.16699 10C9.1559 10 10.1226 9.70676 10.9448 9.15735C11.7671 8.60794 12.408 7.82705 12.7864 6.91342C13.1648 5.99979 13.2638 4.99446 13.0709 4.02455C12.878 3.05465 12.4018 2.16373 11.7025 1.46447C11.0033 0.765206 10.1123 0.289002 9.14244 0.0960758C8.17254 -0.0968503 7.16721 0.00216643 6.25358 0.380605C5.33994 0.759043 4.55905 1.39991 4.00964 2.22215C3.46024 3.0444 3.16699 4.0111 3.16699 5C3.16832 6.32568 3.69553 7.59668 4.63292 8.53407C5.57032 9.47147 6.84132 9.99868 8.16699 10ZM8.16699 1.66667C8.82626 1.66667 9.47073 1.86217 10.0189 2.22844C10.5671 2.59471 10.9943 3.1153 11.2466 3.72439C11.4989 4.33348 11.5649 5.0037 11.4363 5.6503C11.3077 6.29691 10.9902 6.89085 10.524 7.35703C10.0578 7.8232 9.4639 8.14067 8.81729 8.26929C8.17069 8.3979 7.50047 8.33189 6.89138 8.0796C6.28229 7.82731 5.7617 7.40007 5.39543 6.8519C5.02916 6.30374 4.83366 5.65927 4.83366 5C4.83366 4.11595 5.18485 3.2681 5.80997 2.64298C6.43509 2.01786 7.28294 1.66667 8.16699 1.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8.16699 11.6665C6.17855 11.6687 4.27217 12.4596 2.86613 13.8656C1.46008 15.2717 0.669198 17.1781 0.666992 19.1665C0.666992 19.3875 0.75479 19.5995 0.91107 19.7558C1.06735 19.912 1.27931 19.9998 1.50033 19.9998C1.72134 19.9998 1.9333 19.912 2.08958 19.7558C2.24586 19.5995 2.33366 19.3875 2.33366 19.1665C2.33366 17.6194 2.94824 16.1357 4.0422 15.0417C5.13616 13.9478 6.6199 13.3332 8.16699 13.3332C9.71409 13.3332 11.1978 13.9478 12.2918 15.0417C13.3857 16.1357 14.0003 17.6194 14.0003 19.1665C14.0003 19.3875 14.0881 19.5995 14.2444 19.7558C14.4007 19.912 14.6126 19.9998 14.8337 19.9998C15.0547 19.9998 15.2666 19.912 15.4229 19.7558C15.5792 19.5995 15.667 19.3875 15.667 19.1665C15.6648 17.1781 14.8739 15.2717 13.4679 13.8656C12.0618 12.4596 10.1554 11.6687 8.16699 11.6665Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), jS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_842_3895)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M10 13.3333C9.34073 13.3333 8.69626 13.1378 8.1481 12.7716C7.59994 12.4053 7.17269 11.8847 6.9204 11.2756C6.66811 10.6665 6.6021 9.9963 6.73072 9.3497C6.85933 8.7031 7.1768 8.10915 7.64298 7.64298C8.10915 7.1768 8.7031 6.85933 9.3497 6.73072C9.9963 6.6021 10.6665 6.66811 11.2756 6.9204C11.8847 7.1727 12.4053 7.59994 12.7716 8.1481C13.1378 8.69627 13.3333 9.34073 13.3333 10C13.3333 10.8841 12.9821 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333ZM10 8.33333C9.67036 8.33333 9.34813 8.43108 9.07405 8.61422C8.79997 8.79735 8.58635 9.05765 8.4602 9.3622C8.33405 9.66674 8.30105 10.0019 8.36536 10.3252C8.42967 10.6485 8.5884 10.9454 8.82149 11.1785C9.05458 11.4116 9.35155 11.5703 9.67485 11.6346C9.99815 11.699 10.3333 11.6659 10.6378 11.5398C10.9423 11.4137 11.2026 11.2 11.3858 10.926C11.5689 10.6519 11.6667 10.3296 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.8659 8.50893 10.442 8.33333 10 8.33333ZM15 19.1667C15 17.8406 14.4732 16.5688 13.5355 15.6311C12.5979 14.6935 11.3261 14.1667 10 14.1667C8.67392 14.1667 7.40215 14.6935 6.46447 15.6311C5.52678 16.5688 5 17.8406 5 19.1667C5 19.3877 5.0878 19.5996 5.24408 19.7559C5.40036 19.9122 5.61232 20 5.83333 20C6.05435 20 6.26631 19.9122 6.42259 19.7559C6.57887 19.5996 6.66667 19.3877 6.66667 19.1667C6.66667 18.2826 7.01786 17.4348 7.64298 16.8096C8.2681 16.1845 9.11594 15.8333 10 15.8333C10.8841 15.8333 11.7319 16.1845 12.357 16.8096C12.9821 17.4348 13.3333 18.2826 13.3333 19.1667C13.3333 19.3877 13.4211 19.5996 13.5774 19.7559C13.7337 19.9122 13.9457 20 14.1667 20C14.3877 20 14.5996 19.9122 14.7559 19.7559C14.9122 19.5996 15 19.3877 15 19.1667ZM15 6.66667C14.3407 6.66667 13.6963 6.47117 13.1481 6.1049C12.5999 5.73863 12.1727 5.21803 11.9204 4.60895C11.6681 3.99986 11.6021 3.32964 11.7307 2.68303C11.8593 2.03643 12.1768 1.44249 12.643 0.976312C13.1092 0.510137 13.7031 0.192668 14.3497 0.0640506C14.9963 -0.0645668 15.6665 0.00144427 16.2756 0.253736C16.8847 0.506029 17.4053 0.93327 17.7716 1.48143C18.1378 2.0296 18.3333 2.67406 18.3333 3.33334C18.3333 4.21739 17.9821 5.06524 17.357 5.69036C16.7319 6.31548 15.8841 6.66667 15 6.66667ZM15 1.66667C14.6704 1.66667 14.3481 1.76442 14.074 1.94755C13.8 2.13069 13.5863 2.39099 13.4602 2.69553C13.3341 3.00007 13.301 3.33518 13.3654 3.65849C13.4297 3.98179 13.5884 4.27876 13.8215 4.51185C14.0546 4.74493 14.3515 4.90367 14.6748 4.96798C14.9982 5.03229 15.3333 4.99928 15.6378 4.87313C15.9423 4.74699 16.2026 4.53337 16.3858 4.25929C16.5689 3.9852 16.6667 3.66297 16.6667 3.33334C16.6667 2.89131 16.4911 2.46738 16.1785 2.15482C15.8659 1.84226 15.442 1.66667 15 1.66667ZM20 12.5C19.9987 11.1743 19.4715 9.90333 18.5341 8.96593C17.5967 8.02853 16.3257 7.50133 15 7.5C14.779 7.5 14.567 7.5878 14.4107 7.74408C14.2545 7.90036 14.1667 8.11232 14.1667 8.33333C14.1667 8.55435 14.2545 8.76631 14.4107 8.92259C14.567 9.07887 14.779 9.16667 15 9.16667C15.8841 9.16667 16.7319 9.51786 17.357 10.143C17.9821 10.7681 18.3333 11.6159 18.3333 12.5C18.3333 12.721 18.4211 12.933 18.5774 13.0893C18.7337 13.2455 18.9457 13.3333 19.1667 13.3333C19.3877 13.3333 19.5996 13.2455 19.7559 13.0893C19.9122 12.933 20 12.721 20 12.5ZM5 6.66667C4.34073 6.66667 3.69626 6.47117 3.1481 6.1049C2.59994 5.73863 2.17269 5.21803 1.9204 4.60895C1.66811 3.99986 1.6021 3.32964 1.73072 2.68303C1.85933 2.03643 2.1768 1.44249 2.64298 0.976312C3.10915 0.510137 3.7031 0.192668 4.3497 0.0640506C4.9963 -0.0645668 5.66652 0.00144427 6.27561 0.253736C6.8847 0.506029 7.40529 0.93327 7.77156 1.48143C8.13784 2.0296 8.33333 2.67406 8.33333 3.33334C8.33333 4.21739 7.98214 5.06524 7.35702 5.69036C6.7319 6.31548 5.88405 6.66667 5 6.66667ZM5 1.66667C4.67036 1.66667 4.34813 1.76442 4.07405 1.94755C3.79997 2.13069 3.58635 2.39099 3.4602 2.69553C3.33405 3.00007 3.30105 3.33518 3.36536 3.65849C3.42967 3.98179 3.5884 4.27876 3.82149 4.51185C4.05458 4.74493 4.35155 4.90367 4.67485 4.96798C4.99815 5.03229 5.33326 4.99928 5.63781 4.87313C5.94235 4.74699 6.20265 4.53337 6.38578 4.25929C6.56892 3.9852 6.66667 3.66297 6.66667 3.33334C6.66667 2.89131 6.49107 2.46738 6.17851 2.15482C5.86595 1.84226 5.44203 1.66667 5 1.66667ZM1.66667 12.5C1.66667 11.6159 2.01786 10.7681 2.64298 10.143C3.2681 9.51786 4.11594 9.16667 5 9.16667C5.22101 9.16667 5.43297 9.07887 5.58926 8.92259C5.74554 8.76631 5.83333 8.55435 5.83333 8.33333C5.83333 8.11232 5.74554 7.90036 5.58926 7.74408C5.43297 7.5878 5.22101 7.5 5 7.5C3.67432 7.50133 2.40332 8.02853 1.46593 8.96593C0.528533 9.90333 0.00132369 11.1743 0 12.5C0 12.721 0.0877974 12.933 0.244078 13.0893C0.400358 13.2455 0.61232 13.3333 0.833333 13.3333C1.05435 13.3333 1.26631 13.2455 1.42259 13.0893C1.57887 12.933 1.66667 12.721 1.66667 12.5Z",
        fill: "currentColor"
      }
    ) })
  }
), IS = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.3925 6.34919C18.1 4.24419 15.16 0.712524 10 0.712524C4.84 0.712524 1.9 4.24419 0.607497 6.34919C0.207937 6.99545 -0.00370789 7.74023 -0.00370789 8.50002C-0.00370789 9.25982 0.207937 10.0046 0.607497 10.6509C1.9 12.7559 4.84 16.2875 10 16.2875C15.16 16.2875 18.1 12.7559 19.3925 10.6509C19.7921 10.0046 20.0037 9.25982 20.0037 8.50002C20.0037 7.74023 19.7921 6.99545 19.3925 6.34919ZM17.9717 9.77836C16.8617 11.5834 14.3492 14.6209 10 14.6209C5.65083 14.6209 3.13833 11.5834 2.02833 9.77836C1.79094 9.39423 1.66521 8.95159 1.66521 8.50002C1.66521 8.04846 1.79094 7.60582 2.02833 7.22169C3.13833 5.41669 5.65083 2.37919 10 2.37919C14.3492 2.37919 16.8617 5.41336 17.9717 7.22169C18.2091 7.60582 18.3348 8.04846 18.3348 8.50002C18.3348 8.95159 18.2091 9.39423 17.9717 9.77836Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 4.33331C9.17591 4.33331 8.37033 4.57768 7.68512 5.03552C6.99992 5.49336 6.46586 6.14411 6.1505 6.90547C5.83513 7.66682 5.75262 8.5046 5.91339 9.31286C6.07416 10.1211 6.471 10.8635 7.05372 11.4463C7.63644 12.029 8.37887 12.4258 9.18712 12.5866C9.99537 12.7474 10.8332 12.6648 11.5945 12.3495C12.3559 12.0341 13.0066 11.5001 13.4645 10.8149C13.9223 10.1297 14.1667 9.32407 14.1667 8.49998C14.1653 7.39532 13.7259 6.33628 12.9448 5.55516C12.1637 4.77405 11.1047 4.33464 10 4.33331ZM10 11C9.50554 11 9.02219 10.8534 8.61107 10.5787C8.19995 10.304 7.87952 9.9135 7.6903 9.45669C7.50108 8.99987 7.45157 8.49721 7.54803 8.01225C7.6445 7.5273 7.8826 7.08184 8.23223 6.73221C8.58186 6.38258 9.02732 6.14448 9.51227 6.04802C9.99722 5.95155 10.4999 6.00106 10.9567 6.19028C11.4135 6.3795 11.804 6.69993 12.0787 7.11105C12.3534 7.52218 12.5 8.00553 12.5 8.49998C12.5 9.16302 12.2366 9.79891 11.7678 10.2677C11.2989 10.7366 10.663 11 10 11Z",
          fill: "currentColor"
        }
      )
    ]
  }
), BS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M19.275 10.741L14.7667 6.08268C14.45 5.74935 13.9167 5.74102 13.5917 6.06602C13.2583 6.38268 13.25 6.91602 13.575 7.24102L17.8583 11.6577H4.16667C2.79167 11.6577 1.66667 10.5327 1.66667 9.15768V2.49935C1.66667 2.04102 1.29167 1.66602 0.833333 1.66602C0.375 1.66602 0 2.04102 0 2.49935V9.16602C0 11.466 1.86667 13.3327 4.16667 13.3327H17.85L13.5667 17.7493C13.25 18.0827 13.2583 18.6077 13.5833 18.9243C13.7417 19.0827 13.95 19.1577 14.1667 19.1577C14.3833 19.1577 14.6 19.0744 14.7667 18.9077L19.2667 14.2577C20.2417 13.2827 20.2417 11.6993 19.275 10.7327V10.741Z",
        fill: "currentColor"
      }
    )
  }
), NS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M16.6667 38.3333C16.6667 39.255 15.9217 40 15 40H8.33333C3.73833 40 0 36.2617 0 31.6667V8.33333C0 3.73833 3.73833 0 8.33333 0H21.6667C26.2617 0 30 3.73833 30 8.33333V11.6667C30 12.5883 29.255 13.3333 28.3333 13.3333C27.4117 13.3333 26.6667 12.5883 26.6667 11.6667V8.33333C26.6667 5.57667 24.4233 3.33333 21.6667 3.33333H8.33333C5.57667 3.33333 3.33333 5.57667 3.33333 8.33333V31.6667C3.33333 34.4233 5.57667 36.6667 8.33333 36.6667H15C15.9217 36.6667 16.6667 37.4117 16.6667 38.3333ZM23.3333 10C23.3333 9.07833 22.5883 8.33333 21.6667 8.33333H8.33333C7.41167 8.33333 6.66667 9.07833 6.66667 10C6.66667 10.9217 7.41167 11.6667 8.33333 11.6667H21.6667C22.5883 11.6667 23.3333 10.9217 23.3333 10ZM16.6667 18.3333C16.6667 17.4117 15.9217 16.6667 15 16.6667H8.33333C7.41167 16.6667 6.66667 17.4117 6.66667 18.3333C6.66667 19.255 7.41167 20 8.33333 20H15C15.9217 20 16.6667 19.255 16.6667 18.3333ZM8.33333 25C7.41167 25 6.66667 25.745 6.66667 26.6667C6.66667 27.5883 7.41167 28.3333 8.33333 28.3333H11.6667C12.5883 28.3333 13.3333 27.5883 13.3333 26.6667C13.3333 25.745 12.5883 25 11.6667 25H8.33333ZM40 28.3333C40 34.765 34.765 40 28.3333 40C21.9017 40 16.6667 34.765 16.6667 28.3333C16.6667 21.9017 21.9017 16.6667 28.3333 16.6667C34.765 16.6667 40 21.9017 40 28.3333ZM36.6667 28.3333C36.6667 23.7383 32.9283 20 28.3333 20C23.7383 20 20 23.7383 20 28.3333C20 32.9283 23.7383 36.6667 28.3333 36.6667C32.9283 36.6667 36.6667 32.9283 36.6667 28.3333ZM31.3467 26.265L27.6417 29.8217C27.4017 30.0567 27.01 30.0617 26.7717 29.825L24.8867 27.9783C24.2267 27.3317 23.1733 27.3417 22.53 28.0017C21.885 28.66 21.895 29.7133 22.5533 30.3583L24.44 32.2067C25.2067 32.955 26.21 33.33 27.2117 33.33C28.2133 33.33 29.2133 32.955 29.9667 32.2117L33.655 28.6717C34.3183 28.0333 34.34 26.9783 33.7033 26.315C33.065 25.6483 32.0083 25.63 31.3467 26.2667V26.265Z",
        fill: "currentColor"
      }
    )
  }
), LS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M20 0C16.0444 0 12.1776 1.17298 8.8886 3.3706C5.59962 5.56824 3.03618 8.6918 1.52242 12.3463C0.00866604 16.0009 -0.387402 20.0222 0.384304 23.9018C1.15601 27.7814 3.06082 31.345 5.85788 34.1422C8.65492 36.9392 12.2186 38.844 16.0982 39.6158C19.9778 40.3874 23.9992 39.9914 27.6536 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C39.9942 14.6974 37.8852 9.61368 34.1358 5.8642C30.3864 2.11472 25.3026 0.00573514 20 0ZM20 3.33334C23.8442 3.33026 27.5698 4.66292 30.54 7.10334L7.10334 30.54C5.10428 28.0998 3.83944 25.1418 3.45604 22.0108C3.07264 18.8796 3.58644 15.7039 4.93766 12.8534C6.28886 10.0029 8.4219 7.5948 11.0885 5.9094C13.755 4.22402 16.8455 3.33066 20 3.33334ZM20 36.6666C16.1559 36.6698 12.4301 35.337 9.46 32.8966L32.8966 9.46C34.8958 11.9003 36.1606 14.8581 36.544 17.9893C36.9274 21.1204 36.4136 24.2962 35.0624 27.1466C33.7112 29.9972 31.5782 32.4052 28.9116 34.0906C26.245 35.776 23.1546 36.6694 20 36.6666Z",
        fill: "currentColor"
      }
    )
  }
), TS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_16_25)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56824 3.03617 8.69181 1.52242 12.3463C0.00866572 16.0009 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9992 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C39.9943 14.6974 37.8853 9.61368 34.1358 5.8642C30.3863 2.11471 25.3026 0.00573514 20 0ZM20 36.6667C16.7037 36.6667 13.4813 35.6892 10.7405 33.8578C7.99969 32.0265 5.86348 29.4235 4.60202 26.3781C3.34056 23.3326 3.0105 19.9815 3.65359 16.7485C4.29667 13.5155 5.88402 10.5458 8.2149 8.21489C10.5458 5.88401 13.5155 4.29667 16.7485 3.65358C19.9815 3.01049 23.3326 3.34055 26.3781 4.60201C29.4235 5.86347 32.0265 7.99968 33.8578 10.7405C35.6892 13.4813 36.6667 16.7036 36.6667 20C36.6618 24.4188 34.9043 28.6552 31.7798 31.7798C28.6552 34.9043 24.4188 36.6618 20 36.6667Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M20 8.33331C19.558 8.33331 19.134 8.50891 18.8215 8.82147C18.5089 9.13403 18.3333 9.55795 18.3333 9.99998V23.3333C18.3333 23.7753 18.5089 24.1993 18.8215 24.5118C19.134 24.8244 19.558 25 20 25C20.442 25 20.8659 24.8244 21.1785 24.5118C21.4911 24.1993 21.6666 23.7753 21.6666 23.3333V9.99998C21.6666 9.55795 21.4911 9.13403 21.1785 8.82147C20.8659 8.50891 20.442 8.33331 20 8.33331Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M21.6666 30C21.6666 29.0795 20.9205 28.3333 20 28.3333C19.0795 28.3333 18.3333 29.0795 18.3333 30C18.3333 30.9205 19.0795 31.6666 20 31.6666C20.9205 31.6666 21.6666 30.9205 21.6666 30Z", fill: "currentColor" })
    ] })
  }
), _S = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M18.3295 20.0111V10.0055C18.3295 9.08836 19.0799 8.33794 19.9971 8.33794C20.9142 8.33794 21.6647 9.08836 21.6647 10.0055V20.0111C21.6647 20.9282 20.9142 21.6787 19.9971 21.6787C19.0799 21.6787 18.3295 20.9282 18.3295 20.0111ZM19.9971 23.3462C18.613 23.3462 17.4957 24.4635 17.4957 25.8476C17.4957 27.2317 18.613 28.349 19.9971 28.349C21.3812 28.349 22.4984 27.2317 22.4984 25.8476C22.4984 24.4635 21.3812 23.3462 19.9971 23.3462ZM39.3077 31.4841C38.1404 33.7353 35.6891 35.0194 32.6207 35.0194H7.39009C4.30505 35.0194 1.87037 33.7353 0.703061 31.4841C-0.480927 29.2162 -0.147409 26.3145 1.53686 23.8799L14.9443 2.66814C16.1283 0.967201 17.996 0 19.9971 0C21.9982 0 23.8659 0.967201 24.9998 2.61811L38.4739 23.9132C40.1582 26.3479 40.4751 29.2328 39.2911 31.4841H39.3077ZM35.7224 25.7809C35.7224 25.7809 35.6891 25.7476 35.6891 25.7142L22.2316 4.45246C21.748 3.76875 20.9142 3.33518 19.9971 3.33518C19.0799 3.33518 18.2461 3.76875 17.7291 4.51917L4.30505 25.7142C3.27115 27.1817 3.03769 28.7826 3.63802 29.9332C4.22167 31.0672 5.55574 31.6842 7.37342 31.6842H32.5874C34.405 31.6842 35.7391 31.0672 36.3228 29.9332C36.9231 28.7826 36.6896 27.1817 35.7057 25.7809H35.7224Z", fill: "currentColor" })
  }
), RS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_16_33)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M20 16.6667C18.6814 16.6667 17.3925 17.0577 16.2962 17.7902C15.1999 18.5228 14.3454 19.564 13.8408 20.7821C13.3362 22.0003 13.2042 23.3407 13.4614 24.634C13.7186 25.9272 14.3536 27.115 15.2859 28.0474C16.2183 28.9797 17.4062 29.6147 18.6994 29.8719C19.9926 30.1292 21.333 29.9971 22.5512 29.4926C23.7694 28.988 24.8106 28.1335 25.5431 27.0372C26.2757 25.9408 26.6666 24.6519 26.6666 23.3334C26.6666 21.5652 25.9643 19.8696 24.714 18.6193C23.4638 17.3691 21.7681 16.6667 20 16.6667ZM20 26.6667C19.3407 26.6667 18.6962 26.4712 18.1481 26.1049C17.5999 25.7386 17.1727 25.2181 16.9204 24.609C16.6681 23.9999 16.6021 23.3297 16.7307 22.6831C16.8593 22.0364 17.1768 21.4425 17.643 20.9763C18.1091 20.5102 18.7031 20.1927 19.3497 20.0641C19.9963 19.9355 20.6665 20.0015 21.2756 20.2538C21.8847 20.506 22.4053 20.9333 22.7715 21.4815C23.1378 22.0296 23.3333 22.6741 23.3333 23.3334C23.3333 24.2174 22.9821 25.0653 22.357 25.6904C21.7319 26.3155 20.884 26.6667 20 26.6667Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M37.56 6.87003L33.13 2.44003C32.3581 1.66394 31.4399 1.04867 30.4286 0.629836C29.4173 0.211008 28.3329 -0.0030576 27.2383 3.29938e-05H8.33333C6.12401 0.00267942 4.00593 0.881503 2.4437 2.44373C0.88147 4.00596 0.00264643 6.12404 0 8.33337L0 31.6667C0.00264643 33.876 0.88147 35.9941 2.4437 37.5563C4.00593 39.1186 6.12401 39.9974 8.33333 40H31.6667C33.876 39.9974 35.9941 39.1186 37.5563 37.5563C39.1185 35.9941 39.9974 33.876 40 31.6667V12.7617C40.0031 11.6671 39.789 10.5828 39.3702 9.57144C38.9514 8.56013 38.3361 7.64194 37.56 6.87003ZM28.3333 3.4667V5.00003C28.3333 6.32612 27.8066 7.59789 26.8689 8.53557C25.9312 9.47325 24.6594 10 23.3333 10H16.6667C15.3406 10 14.0688 9.47325 13.1311 8.53557C12.1935 7.59789 11.6667 6.32612 11.6667 5.00003V3.33337H27.2383C27.6072 3.33664 27.9745 3.38136 28.3333 3.4667ZM36.6667 31.6667C36.6667 32.9928 36.1399 34.2646 35.2022 35.2022C34.2645 36.1399 32.9928 36.6667 31.6667 36.6667H8.33333C7.00725 36.6667 5.73548 36.1399 4.7978 35.2022C3.86012 34.2646 3.33333 32.9928 3.33333 31.6667V8.33337C3.33333 7.00728 3.86012 5.73551 4.7978 4.79783C5.73548 3.86015 7.00725 3.33337 8.33333 3.33337V5.00003C8.33598 7.20936 9.2148 9.32744 10.777 10.8897C12.3393 12.4519 14.4573 13.3307 16.6667 13.3334H23.3333C25.4292 13.3269 27.4453 12.5295 28.9785 11.1006C30.5118 9.67181 31.4492 7.71685 31.6033 5.6267L35.2033 9.2267C36.1374 10.1665 36.6632 11.4367 36.6667 12.7617V31.6667Z", fill: "currentColor" })
    ] })
  }
), FS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_16_33)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M31.6667 3.33333H30V1.66667C30 1.22464 29.8244 0.800716 29.5118 0.488155C29.1993 0.175595 28.7754 0 28.3333 0C27.8913 0 27.4674 0.175595 27.1548 0.488155C26.8423 0.800716 26.6667 1.22464 26.6667 1.66667V3.33333H13.3333V1.66667C13.3333 1.22464 13.1577 0.800716 12.8452 0.488155C12.5326 0.175595 12.1087 0 11.6667 0C11.2246 0 10.8007 0.175595 10.4882 0.488155C10.1756 0.800716 10 1.22464 10 1.66667V3.33333H8.33333C6.12401 3.33598 4.00593 4.2148 2.4437 5.77703C0.88147 7.33926 0.00264643 9.45734 0 11.6667V31.6667C0.00264643 33.876 0.88147 35.9941 2.4437 37.5563C4.00593 39.1185 6.12401 39.9974 8.33333 40H31.6667C33.876 39.9974 35.9941 39.1185 37.5563 37.5563C39.1185 35.9941 39.9974 33.876 40 31.6667V11.6667C39.9974 9.45734 39.1185 7.33926 37.5563 5.77703C35.9941 4.2148 33.876 3.33598 31.6667 3.33333ZM3.33333 11.6667C3.33333 10.3406 3.86012 9.06881 4.7978 8.13113C5.73548 7.19345 7.00725 6.66667 8.33333 6.66667H31.6667C32.9927 6.66667 34.2645 7.19345 35.2022 8.13113C36.1399 9.06881 36.6667 10.3406 36.6667 11.6667V13.3333H3.33333V11.6667ZM31.6667 36.6667H8.33333C7.00725 36.6667 5.73548 36.1399 4.7978 35.2022C3.86012 34.2645 3.33333 32.9927 3.33333 31.6667V16.6667H36.6667V31.6667C36.6667 32.9927 36.1399 34.2645 35.2022 35.2022C34.2645 36.1399 32.9927 36.6667 31.6667 36.6667Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M20 27.5C21.3807 27.5 22.5 26.3807 22.5 25C22.5 23.6193 21.3807 22.5 20 22.5C18.6193 22.5 17.5 23.6193 17.5 25C17.5 26.3807 18.6193 27.5 20 27.5Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M11.6667 27.5C13.0474 27.5 14.1667 26.3807 14.1667 25C14.1667 23.6193 13.0474 22.5 11.6667 22.5C10.286 22.5 9.16667 23.6193 9.16667 25C9.16667 26.3807 10.286 27.5 11.6667 27.5Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M28.3333 27.5C29.714 27.5 30.8333 26.3807 30.8333 25C30.8333 23.6193 29.714 22.5 28.3333 22.5C26.9526 22.5 25.8333 23.6193 25.8333 25C25.8333 26.3807 26.9526 27.5 28.3333 27.5Z", fill: "currentColor" })
    ] })
  }
), $S = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M36.201 13.7825L38.1094 8.62045C38.1094 8.62045 38.1125 8.61375 38.1135 8.60974C38.1156 8.60439 38.1177 8.59903 38.1187 8.59368L39.274 5.4673C39.8333 3.95095 39.2531 2.08128 37.9771 1.29968L36.4062 0.341422C35.7646 -0.0520521 35.026 -0.108263 34.3802 0.187512C33.7938 0.455182 33.3302 0.983829 33.074 1.67709L30.4063 8.89615C28.9156 8.22831 27.3573 7.88971 25.7646 7.88971H14.2333C10.4458 7.88971 6.875 9.79953 4.18021 13.2659C1.48438 16.7335 0 21.324 0 26.1943V26.9545C0 32.1995 1.75833 37.1781 4.83229 40.6685L4.52708 47.8822C4.50417 48.443 4.68958 48.7401 4.85 48.8913C4.95417 48.989 5.10833 49.0827 5.31875 49.0827C5.43854 49.0827 5.57708 49.0533 5.73438 48.977C5.75625 48.9663 5.77708 48.9543 5.79792 48.9409L11.2854 45.3139C11.3146 45.2952 11.3469 45.2738 11.3687 45.2591C11.3896 45.2591 11.4177 45.2591 11.4427 45.2591H17.5281C17.8521 45.2591 18.1135 44.9218 18.1135 44.5069C18.1135 44.092 17.851 43.7548 17.5281 43.7548H11.4469C11.1312 43.7508 11.0427 43.7815 10.75 43.9756L5.725 47.2974L6.01146 40.5133C6.06354 40.1158 5.9 39.8669 5.79479 39.7504C2.85625 36.5357 1.17083 31.8716 1.17083 26.9545V26.1943C1.17083 16.9316 7.03021 9.39535 14.2333 9.39535H25.7646C27.1823 9.39535 28.5708 9.68711 29.901 10.2653L27.924 15.6133C27.7854 15.9894 27.9094 16.4377 28.2021 16.6171C28.4948 16.7951 28.8438 16.6358 28.9833 16.2597L32.7219 6.14584L36.8062 8.6432L29.7073 27.8485L25.6229 25.3511L27.8385 19.358C27.9771 18.9819 27.8531 18.5336 27.5604 18.3543C27.2677 18.1763 26.9188 18.3355 26.7792 18.7116L24.3125 25.3846C24.2812 25.4703 24.2625 25.5639 24.2573 25.659L23.8406 33.9286H8.98542C8.66146 33.9286 8.4 34.2659 8.4 34.6808C8.4 35.0957 8.66146 35.4329 8.98542 35.4329H24C24.0771 35.5574 24.1729 35.6578 24.2885 35.7287C24.401 35.7969 24.5208 35.8317 24.6406 35.8317C24.8396 35.8317 25.0406 35.7394 25.2187 35.5614C25.2312 35.5494 25.2437 35.5346 25.2563 35.5212L30.3833 29.4037C30.4375 29.3394 30.4813 29.2605 30.5135 29.1748L35.6573 15.2587C37.7073 18.3154 38.8281 22.1578 38.8281 26.1943V26.9545C38.8281 36.2172 32.9688 43.7534 25.7656 43.7534H20.1292C19.8052 43.7534 19.5437 44.0907 19.5437 44.5056C19.5437 44.9205 19.8062 45.2577 20.1292 45.2577H25.7656C29.5521 45.2577 33.1219 43.3479 35.8188 39.8816C38.5156 36.4139 40 31.8234 40 26.9531V26.193C40 21.573 38.6542 17.1859 36.2031 13.7811L36.201 13.7825ZM33.2229 4.78474L34.1323 2.32352C34.2542 1.99428 34.4813 1.74 34.7719 1.60616C35.1271 1.44422 35.5385 1.47768 35.9021 1.69985L37.474 2.65944C38.1667 3.0837 38.499 4.054 38.2156 4.82087L37.3063 7.28076L33.2219 4.7834L33.2229 4.78474ZM25.0229 33.7412L25.1437 31.3523L26.3875 32.1125L25.0229 33.7412ZM27.3115 31.0097L25.225 29.7329L25.3698 26.8621L28.9521 29.053L27.3125 31.0097H27.3115Z", fill: "currentColor" })
  }
), HS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M5.57407 17.7786C5.57407 17.4105 5.81724 17.113 6.11806 17.113H22.4116C22.7114 17.113 22.9556 17.4118 22.9556 17.7786C22.9556 18.1454 22.7124 18.4442 22.4116 18.4442H6.11806C5.81724 18.4442 5.57407 18.1466 5.57407 17.7786ZM14.4708 22.725H6.11806C5.81724 22.725 5.57407 23.0225 5.57407 23.3906C5.57407 23.7586 5.81724 24.0562 6.11806 24.0562H14.4708C14.7716 24.0562 15.0148 23.7586 15.0148 23.3906C15.0148 23.0225 14.7716 22.725 14.4708 22.725ZM14.4708 28.337H6.11806C5.81724 28.337 5.57407 28.6345 5.57407 29.0026C5.57407 29.3706 5.81724 29.6682 6.11806 29.6682H14.4708C14.7716 29.6682 15.0148 29.3706 15.0148 29.0026C15.0148 28.6345 14.7716 28.337 14.4708 28.337ZM14.4708 33.949H6.11806C5.81724 33.949 5.57407 34.2465 5.57407 34.6146C5.57407 34.9826 5.81724 35.2802 6.11806 35.2802H14.4708C14.7716 35.2802 15.0148 34.9826 15.0148 34.6146C15.0148 34.2465 14.7716 33.949 14.4708 33.949ZM39.879 33.477C39.7333 33.8682 39.4723 34.1644 39.1443 34.3132L37.4494 35.0839C37.3006 35.1506 37.1475 35.1852 36.9935 35.1852C36.8069 35.1852 36.6214 35.1365 36.4463 35.0378C36.3227 34.9685 36.2147 34.8723 36.1172 34.7646C36.0753 35.234 35.9306 35.6841 35.678 36.0227C35.3311 36.4869 34.8636 36.669 34.3647 36.5498C34.3521 36.8563 34.2861 37.1654 34.1593 37.4539C33.7872 38.3042 33.0126 38.7235 32.2757 38.5491C32.2621 38.8543 32.1929 39.1531 32.0724 39.4289C32.0032 39.5892 31.9131 39.729 31.8156 39.8598V41.7604C31.8156 44.1021 30.2905 46.013 28.3913 46.0912C27.9689 47.9097 26.6031 49.246 24.9837 49.246H3.5459C1.59109 49.246 0 47.3005 0 44.9088V7.48565C0 5.1439 1.52611 3.23305 3.42536 3.15482C3.85405 1.3222 5.24181 0 6.8329 0H28.2718C30.2266 0 31.8166 1.94676 31.8166 4.33724V25.0475C31.89 25.0834 31.9602 25.1206 32.0305 25.1565C32.5713 25.4335 32.912 25.5848 33.1813 25.5707C33.1216 25.2347 33.1478 24.8859 33.2673 24.5666C33.414 24.1767 33.674 23.8792 34.002 23.7304L35.698 22.9597C36.026 22.8109 36.3824 22.8276 36.701 23.0058C37.0197 23.1841 37.2628 23.5047 37.3844 23.9048L39.9178 32.2497C40.0394 32.6511 40.0258 33.0872 39.879 33.477ZM31.6102 26.3825C30.5861 25.858 29.5264 25.3155 28.0538 26.5595C27.7414 26.8237 27.4207 27.1571 27.0989 27.5534C26.905 27.7919 26.7069 28.0318 26.513 28.2639C26.1189 28.7371 25.6525 29.2988 25.4009 29.681C26.144 30.6287 26.9186 30.3402 28.1397 29.7785C29.1344 29.3206 30.2591 28.8012 31.2548 29.7297C31.5284 29.9208 31.9319 30.1645 32.3585 30.4222C33.5723 31.1545 34.5942 31.8022 35.2525 32.4562L33.5492 26.8442C33.4203 26.8801 33.2903 26.9019 33.1625 26.9019C32.6269 26.9019 32.0986 26.6313 31.6102 26.3812V26.3825ZM4.57833 3.14713H24.9837C26.9385 3.14713 28.5286 5.09388 28.5286 7.48437V24.7564C29.3535 24.3832 30.0851 24.4178 30.7276 24.6012V4.33724C30.7276 2.67903 29.625 1.3299 28.2697 1.3299H6.8329C5.8403 1.3299 4.9609 2.07244 4.57833 3.14585V3.14713ZM17.2044 10.8033L20.1381 8.38336C20.3216 8.23204 20.5626 8.23204 20.7461 8.38336L23.3696 10.5469V4.47831H17.2044V10.8033ZM27.4417 44.9088V43.2801C27.3274 43.3147 27.2132 43.3339 27.0989 43.3339C26.8327 43.3339 26.5717 43.2467 26.339 43.0941C25.9575 42.844 25.6388 42.4106 25.469 41.9053C25.4586 41.9091 25.447 41.9143 25.4355 41.9181C24.9995 42.0797 24.5404 42.0245 24.14 41.7629C23.8434 41.5821 23.5991 41.282 23.4409 40.9063C23.3644 40.9499 23.2857 40.987 23.204 41.0178C22.768 41.1781 22.3078 41.1243 21.9085 40.8627C21.5269 40.6292 21.2345 40.2035 21.0962 39.6713C21.0228 39.3866 20.9987 39.0877 21.0238 38.7966C20.7765 38.7838 20.527 38.7056 20.2943 38.5517C19.9138 38.3196 19.6204 37.8938 19.482 37.3616C19.3405 36.8178 19.3824 36.2253 19.5962 35.7354L19.7922 35.2878C19.679 35.3263 19.5638 35.3507 19.4474 35.3507C19.3122 35.3507 19.1759 35.325 19.0449 35.2725L17.3239 34.594C16.6363 34.3222 16.2568 33.4155 16.478 32.5742L18.7127 24.101C18.8196 23.6945 19.0512 23.3624 19.3636 23.1674C19.6759 22.9712 20.0312 22.9366 20.3635 23.0674L22.0856 23.7471C22.5269 23.9215 22.8392 24.3588 22.9482 24.8705C23.3476 24.8872 23.7459 24.791 24.1892 24.6833C25.1179 24.4576 26.1545 24.2075 27.4438 24.9859V7.48565C27.4438 5.82745 26.3411 4.47831 24.9858 4.47831H24.4586V11.7972C24.4586 12.0435 24.3475 12.2692 24.1704 12.3846C23.9922 12.5 23.7784 12.4859 23.6107 12.3487L20.4442 9.73635L17.2033 12.409C17.1132 12.4834 17.0073 12.5231 16.8994 12.5231H16.6635C16.3627 12.5231 16.1195 12.2256 16.1195 11.8575V4.47703H3.54904C2.19378 4.47703 1.09113 5.82616 1.09113 7.48437V44.9075C1.09113 46.5657 2.19378 47.9136 3.54904 47.9136H24.9869C26.3421 47.9136 27.4448 46.5644 27.4448 44.9075L27.4417 44.9088ZM29.0516 39.8803C29.1344 40.3035 29.0652 40.7229 28.9615 41.0717L29.017 41.1063C29.3556 41.3192 29.5285 40.9986 29.5726 40.8947C29.6218 40.778 29.7371 40.3997 29.365 40.0855L29.0527 39.879L29.0516 39.8803ZM28.5129 42.2874L28.4709 42.2605C28.4668 42.2695 28.4615 42.2785 28.4573 42.2874H28.5129ZM26.7593 40.1842L26.4784 40.8267C26.2992 41.2371 26.5759 41.7398 26.8516 41.9207C26.9553 41.9899 27.2719 42.1951 27.5601 41.5359L27.7645 41.0691C27.7645 41.0691 27.7645 41.0691 27.7645 41.0678C28.1502 40.1855 28.0381 40.0573 27.6282 39.7892C27.4521 39.6738 27.2624 39.7277 27.166 39.77C26.991 39.8457 26.8421 39.997 26.7604 40.1855L26.7593 40.1842ZM25.8631 37.8181C25.5665 37.6232 25.1934 37.7604 25.033 38.1259C25.033 38.1259 25.033 38.1272 25.033 38.1285L24.401 39.5738C24.3245 39.7495 24.3119 39.9662 24.3643 40.1688C24.3926 40.2766 24.4649 40.4741 24.6389 40.5805C24.7961 40.6831 24.9617 40.7023 25.119 40.6434C25.2762 40.5856 25.4061 40.4561 25.4827 40.2817L25.5194 40.1971C25.5194 40.1971 25.5194 40.1958 25.5204 40.1945L25.7971 39.5597C25.7971 39.5597 25.7971 39.5571 25.7971 39.5558L26.1137 38.8325C26.273 38.467 26.1598 38.0118 25.861 37.8156L25.8631 37.8181ZM24.2752 36.5703C24.228 36.3766 24.1222 36.2189 23.9796 36.1253C23.6819 35.9304 23.3088 36.0689 23.1484 36.4331C23.1484 36.4331 23.1484 36.4331 23.1484 36.4344L22.595 37.7014L22.1695 38.6735C22.0929 38.8492 22.0804 39.0659 22.1328 39.2686C22.1611 39.3763 22.2344 39.5751 22.4084 39.6802C22.7208 39.8841 23.0929 39.7444 23.2522 39.3814L23.443 38.9454C23.443 38.9454 23.443 38.9454 23.444 38.9428L24.075 37.5001C24.075 37.5001 24.075 37.5001 24.075 37.4988L24.2312 37.141C24.3087 36.9653 24.3245 36.7627 24.2762 36.569L24.2752 36.5703ZM22.0772 34.394C21.941 34.3145 21.7848 34.3004 21.637 34.3555C21.4798 34.4132 21.3509 34.5427 21.2733 34.7184L21.0406 35.2507L20.5543 36.3638C20.4777 36.5395 20.4641 36.7563 20.5176 36.9589C20.5459 37.0666 20.6182 37.2641 20.7932 37.3705C21.1035 37.5745 21.4766 37.4372 21.6359 37.0717C21.6359 37.0717 21.637 37.0692 21.637 37.0679L22.1894 35.8034L22.355 35.4238C22.4168 35.2814 22.6044 34.8518 22.0762 34.3914L22.0772 34.394ZM21.8938 25.3579C21.9305 25.2168 21.8655 25.059 21.7491 25.0142L20.027 24.3345C20.0029 24.3255 19.9809 24.3216 19.96 24.3216C19.9149 24.3216 19.8771 24.3396 19.8562 24.3524C19.8258 24.3716 19.7692 24.4191 19.7451 24.5102L17.5104 32.9833C17.4737 33.1244 17.5398 33.2821 17.6551 33.327L19.3772 34.0067C19.4526 34.0362 19.5166 34.008 19.547 33.9887C19.5784 33.9695 19.634 33.922 19.6581 33.8297L20.0459 32.3562C20.0595 32.2972 20.0721 32.2369 20.0868 32.1779C20.0931 32.1574 20.1004 32.1394 20.1077 32.1202L21.8917 25.3553L21.8938 25.3579ZM30.7297 41.7617V40.542C30.7297 40.542 30.7224 40.5446 30.7182 40.5446C30.7276 40.8845 30.6626 41.2205 30.5358 41.5141C30.2633 42.1515 29.7623 42.5068 29.2298 42.5068C28.9971 42.5068 28.7592 42.4375 28.5307 42.2964V44.751C29.7654 44.592 30.7297 43.3121 30.7297 41.7604V41.7617ZM34.9192 33.9246C34.5471 33.2321 32.9413 32.2613 31.8774 31.6188C31.3984 31.3302 30.9844 31.0801 30.6794 30.8634C30.6574 30.848 30.6354 30.8288 30.6144 30.8095C30.1176 30.3286 29.496 30.5787 28.5234 31.0276C27.3075 31.588 25.642 32.3536 24.2941 30.1363C24.1809 29.949 24.1547 29.7028 24.228 29.4861C24.4094 28.9461 24.9251 28.31 25.751 27.3161C25.9407 27.0879 26.1357 26.8545 26.3254 26.6198C26.4805 26.4287 26.6356 26.2492 26.7908 26.0812C25.9103 25.6195 25.1986 25.7926 24.3978 25.9875C23.8947 26.1106 23.3769 26.2338 22.8141 26.1914L21.0878 32.7396C21.049 32.9063 21.0175 33.0756 20.9987 33.2449C21.0993 33.1782 21.2073 33.1231 21.3205 33.082C21.7565 32.9192 22.2166 32.9756 22.616 33.2372C22.6411 33.2526 22.6642 33.2718 22.6872 33.2924C23.1359 33.6784 23.4115 34.1811 23.4954 34.7197C23.8276 34.6736 24.1746 34.7441 24.4922 34.9518C24.8915 35.2135 25.185 35.6508 25.316 36.1843C25.3349 36.2612 25.3506 36.3382 25.3621 36.4164C25.6996 36.3625 26.0539 36.4344 26.3767 36.6447C26.7719 36.9037 27.0476 37.3282 27.1817 37.8117C27.3368 37.5373 27.6366 37.4424 27.884 37.604L29.6879 38.7889C29.7182 38.8005 29.7497 38.8159 29.779 38.8351C29.779 38.8351 29.7801 38.8351 29.7811 38.8351L30.2318 39.1301C30.3849 39.2301 30.561 39.2506 30.7287 39.1891C30.8964 39.1262 31.0337 38.9903 31.1144 38.803C31.1961 38.6158 31.214 38.4003 31.1626 38.1952C31.1123 37.9912 31.0001 37.8232 30.8482 37.7232H30.8471C30.8282 37.7104 30.8125 37.6937 30.7957 37.6796L28.712 36.3164C28.4468 36.1432 28.3473 35.7406 28.4888 35.4161C28.6303 35.0916 28.9604 34.9685 29.2246 35.1429L31.3628 36.5421C31.3817 36.5536 31.3963 36.569 31.4131 36.5831L32.2988 37.1628C32.6227 37.3731 33.0273 37.2243 33.2002 36.8281C33.3679 36.4459 33.2568 35.9727 32.957 35.7495L30.0201 33.7989C29.756 33.6232 29.6585 33.2193 29.8011 32.8961C29.9446 32.5729 30.2748 32.4536 30.5389 32.6281L33.413 34.5363C33.4214 34.5415 33.4308 34.544 33.4392 34.5504L34.3322 35.134C34.6907 35.3674 34.8238 35.1917 34.8731 35.125C35.0617 34.8711 35.1215 34.3029 34.916 33.922L34.9192 33.9246ZM38.899 32.7153L36.3656 24.3704C36.3373 24.278 36.2807 24.2344 36.2482 24.2178C36.2283 24.2062 36.1948 24.1921 36.1539 24.1921C36.1308 24.1921 36.1057 24.1972 36.0784 24.2088L34.3825 24.9795C34.3081 25.0129 34.2725 25.0834 34.2578 25.1232C34.2431 25.1616 34.2232 25.2411 34.2505 25.3309L36.7838 33.6771C36.8111 33.7681 36.8687 33.8117 36.9002 33.831C36.9316 33.8477 36.9966 33.872 37.071 33.84L38.7669 33.0692C38.8414 33.0359 38.877 32.9653 38.8917 32.9269C38.9063 32.8884 38.9263 32.8089 38.899 32.7178V32.7153Z", fill: "currentColor" })
  }
), YS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 33 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M5.44355 49.8668H23.4943C26.359 49.8642 28.6809 47.5423 28.6835 44.6762V34.1782H29.9731C31.5924 34.1756 32.904 32.864 32.9066 31.2447V18.0663C32.9066 17.8858 32.8352 17.7144 32.708 17.5858L28.6848 13.5718V5.18926C28.6822 2.32452 26.3603 0.00259723 23.4956 0H5.44485C2.5788 0.00259723 0.258182 2.32452 0.255585 5.18926V44.6762C0.258182 47.541 2.5801 49.8629 5.44485 49.8668H5.44355ZM29.9744 32.8251H26.3382V22.0648C26.3382 21.8842 26.2668 21.7128 26.1396 21.5856L20.4399 15.8963C20.4399 15.8963 20.4373 15.8937 20.436 15.8924C20.3088 15.7613 20.1348 15.686 19.9517 15.686C19.9335 15.686 19.9153 15.6873 19.8984 15.6886C19.8802 15.6873 19.8621 15.686 19.8452 15.686H16.9155V14.6198C16.9155 13.7484 17.6232 13.042 18.4946 13.0407H25.8435V15.8197C25.8461 17.4391 27.1577 18.7507 28.777 18.7533H31.5561V31.2434C31.5548 32.1147 30.8483 32.8212 29.977 32.8225L29.9744 32.8251ZM19.2712 17.0417V19.8207C19.2725 21.4401 20.5854 22.7517 22.2048 22.7543H24.9838V35.2444C24.9838 36.1158 24.276 36.8222 23.4047 36.8235H11.9223C11.051 36.8222 10.3445 36.1158 10.3432 35.2444V18.6208C10.3432 17.7482 11.051 17.0417 11.9223 17.0404H19.2712V17.0417ZM24.0371 21.3999H22.2061C21.3334 21.3986 20.6282 20.6921 20.6269 19.8207V17.9975L24.0384 21.4012L24.0371 21.3999ZM27.3317 14.1328V14.1964H27.3953L30.6068 17.4001H28.7757C27.9044 17.4001 27.1966 16.6924 27.1966 15.821V13.9978L27.333 14.1341L27.3317 14.1328ZM5.44355 1.35445H23.4943C25.6123 1.35705 27.3278 3.07252 27.3304 5.19056V6.76967H25.7513C25.3773 6.76967 25.0747 7.07355 25.0747 7.44625C25.0747 7.81895 25.3786 8.12283 25.7513 8.12283H27.3304V12.2213L27.007 11.8992C27.007 11.8992 27.0044 11.8966 27.0018 11.8953C26.8746 11.7641 26.6993 11.6888 26.5175 11.6888C26.4993 11.6888 26.4811 11.6888 26.4642 11.6914C26.446 11.6888 26.4291 11.6888 26.411 11.6888H18.492C16.8727 11.6914 15.5611 13.003 15.5585 14.6224V15.6886H11.9223C10.303 15.6899 8.99136 17.0028 8.98876 18.6221V35.2457C8.99006 36.8651 10.303 38.1767 11.9223 38.1793H23.4047C25.024 38.178 26.3356 36.8651 26.3382 35.2457V34.1795H27.3317V40.3908H1.60874V8.12283H19.9984C20.3724 8.12283 20.675 7.81895 20.675 7.44625C20.675 7.07355 20.3724 6.76967 19.9984 6.76967H1.60874V5.19056C1.61134 3.07252 3.3281 1.35705 5.44485 1.35445H5.44355ZM1.60744 41.7439H27.3304V44.6775C27.3278 46.7956 25.6123 48.511 23.4943 48.5136H5.44355C3.32551 48.511 1.61004 46.7956 1.60744 44.6775V41.7439Z", fill: "currentColor" })
  }
), kS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M20.0001 20C21.3186 20 22.6076 19.609 23.7039 18.8765C24.8002 18.1439 25.6547 17.1027 26.1593 15.8846C26.6639 14.6664 26.7959 13.3259 26.5387 12.0327C26.2814 10.7395 25.6465 9.55164 24.7141 8.61929C23.7818 7.68694 22.5939 7.052 21.3007 6.79476C20.0075 6.53753 18.667 6.66955 17.4489 7.17414C16.2307 7.67872 15.1895 8.5332 14.457 9.62953C13.7244 10.7259 13.3334 12.0148 13.3334 13.3333C13.3334 15.1014 14.0358 16.7971 15.286 18.0474C16.5363 19.2976 18.232 20 20.0001 20ZM20.0001 10C20.6594 10 21.3038 10.1955 21.852 10.5618C22.4002 10.928 22.8274 11.4486 23.0797 12.0577C23.332 12.6668 23.398 13.337 23.2694 13.9836C23.1408 14.6302 22.8233 15.2242 22.3571 15.6904C21.8909 16.1565 21.297 16.474 20.6504 16.6026C20.0038 16.7312 19.3336 16.6652 18.7245 16.4129C18.1154 16.1606 17.5948 15.7334 17.2285 15.1852C16.8623 14.6371 16.6668 13.9926 16.6668 13.3333C16.6668 12.4493 17.0179 11.6014 17.6431 10.9763C18.2682 10.3512 19.116 10 20.0001 10ZM34.4334 15.2617L33.2351 14.8633C33.4507 12.9965 33.2693 11.1052 32.7028 9.31347C32.1362 7.52171 31.1973 5.86994 29.9476 4.46649C28.6979 3.06303 27.1656 1.9396 25.4513 1.16986C23.737 0.400112 21.8793 0.0014458 20.0001 0C18.0964 0.000734949 16.2149 0.40949 14.4825 1.19872C12.75 1.98796 11.2069 3.13934 9.95696 4.57529C8.70706 6.01124 7.77944 7.69841 7.23661 9.52312C6.69378 11.3478 6.54834 13.2677 6.81009 15.1533C5.21515 15.4507 3.7403 16.2032 2.56343 17.32C1.74872 18.0946 1.10104 19.0276 0.660223 20.0617C0.219405 21.0958 -0.00524229 22.2092 9.28451e-05 23.3333V30.125C0.0035955 31.9272 0.589746 33.68 1.67108 35.1218C2.75241 36.5635 4.27095 37.617 6.00009 38.125L10.7834 39.625C11.5869 39.875 12.4236 40.0015 13.2651 40C14.0284 39.999 14.7881 39.8947 15.5234 39.69L25.1568 36.84C26.015 36.6058 26.9202 36.6058 27.7784 36.84L31.7568 38.1733C32.7373 38.412 33.7591 38.4249 34.7454 38.2112C35.7316 37.9975 36.6564 37.5627 37.4502 36.9395C38.2439 36.3164 38.8858 35.5212 39.3275 34.6139C39.7692 33.7065 39.9992 32.7108 40.0001 31.7017V23.12C39.9963 21.3957 39.4593 19.7147 38.4627 18.3076C37.4661 16.9004 36.0587 15.8376 34.4334 15.2617ZM12.9301 6.27C13.8572 5.33915 14.959 4.60054 16.1722 4.09655C17.3855 3.59257 18.6863 3.33313 20.0001 3.33313C21.3139 3.33313 22.6147 3.59257 23.828 4.09655C25.0412 4.60054 26.143 5.33915 27.0701 6.27C28.9404 8.1519 29.9916 10.6964 29.9951 13.3496C29.9985 16.0028 28.9538 18.5499 27.0884 20.4367L21.1668 26.195C20.8577 26.498 20.4421 26.6678 20.0093 26.6678C19.5764 26.6678 19.1608 26.498 18.8518 26.195L12.9301 20.4617C11.0559 18.5756 10.0039 16.0247 10.0039 13.3658C10.0039 10.7069 11.0559 8.15602 12.9301 6.27ZM36.6668 31.7017C36.6678 32.2065 36.5536 32.7048 36.333 33.1589C36.1123 33.6129 35.791 34.0106 35.3934 34.3217C35.0178 34.6237 34.5802 34.8392 34.1118 34.953C33.6435 35.0668 33.1558 35.076 32.6834 34.98L28.7751 33.6667C27.2968 33.242 25.73 33.2327 24.2468 33.64L14.6068 36.4867C13.6806 36.7422 12.7003 36.7254 11.7834 36.4383L6.96009 34.9383C5.91618 34.6365 4.99836 34.0041 4.34442 33.1362C3.69049 32.2683 3.33574 31.2117 3.33343 30.125V23.3333C3.32968 22.6596 3.46377 21.9923 3.72746 21.3723C3.99115 20.7524 4.37886 20.1929 4.86676 19.7283C5.63052 19.0004 6.60346 18.5306 7.64843 18.385C8.32027 20.0503 9.32073 21.5632 10.5901 22.8333L16.5351 28.5883C17.4643 29.4982 18.713 30.0077 20.0134 30.0077C21.3139 30.0077 22.5626 29.4982 23.4918 28.5883L29.4301 22.8167C30.7597 21.4817 31.7897 19.879 32.4518 18.115L33.3468 18.4117C34.3174 18.7595 35.1571 19.3983 35.7512 20.2409C36.3454 21.0835 36.6651 22.089 36.6668 23.12V31.7017Z", fill: "currentColor" })
  }
), VS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M21.6667 1.66664C21.6667 1.22462 21.8423 0.800692 22.1548 0.488131C22.4674 0.175571 22.8913 -2.39338e-05 23.3333 -2.39338e-05C27.7521 0.00482873 31.9885 1.76233 35.1131 4.88689C38.2376 8.01145 39.9951 12.2479 40 16.6666C40 17.1087 39.8244 17.5326 39.5118 17.8452C39.1993 18.1577 38.7754 18.3333 38.3333 18.3333C37.8913 18.3333 37.4674 18.1577 37.1548 17.8452C36.8423 17.5326 36.6667 17.1087 36.6667 16.6666C36.6627 13.1316 35.2567 9.74256 32.757 7.24294C30.2574 4.74331 26.8683 3.33728 23.3333 3.33331C22.8913 3.33331 22.4674 3.15771 22.1548 2.84515C21.8423 2.53259 21.6667 2.10867 21.6667 1.66664ZM23.3333 9.99998C25.1014 9.99998 26.7971 10.7024 28.0474 11.9526C29.2976 13.2028 30 14.8985 30 16.6666C30 17.1087 30.1756 17.5326 30.4881 17.8452C30.8007 18.1577 31.2246 18.3333 31.6667 18.3333C32.1087 18.3333 32.5326 18.1577 32.8452 17.8452C33.1577 17.5326 33.3333 17.1087 33.3333 16.6666C33.3307 14.0153 32.2763 11.4733 30.4015 9.5985C28.5267 7.72371 25.9847 6.66929 23.3333 6.66664C22.8913 6.66664 22.4674 6.84224 22.1548 7.1548C21.8423 7.46736 21.6667 7.89128 21.6667 8.33331C21.6667 8.77534 21.8423 9.19926 22.1548 9.51182C22.4674 9.82438 22.8913 9.99998 23.3333 9.99998ZM38.4883 27.8983C39.4542 28.8668 39.9966 30.1788 39.9966 31.5466C39.9966 32.9145 39.4542 34.2265 38.4883 35.195L36.9717 36.9433C23.3217 50.0116 -9.895 16.8033 2.97166 3.10998L4.88833 1.44331C5.85794 0.504438 7.15822 -0.0149421 8.50784 -0.00246586C9.85746 0.0100104 11.1479 0.55334 12.1 1.50998C12.1517 1.56164 15.24 5.57331 15.24 5.57331C16.1564 6.53602 16.6665 7.81486 16.6643 9.14398C16.6622 10.4731 16.1479 11.7503 15.2283 12.71L13.2983 15.1366C14.3664 17.7318 15.9368 20.0904 17.9192 22.0768C19.9016 24.0632 22.257 25.6383 24.85 26.7116L27.2917 24.77C28.2515 23.8512 29.5284 23.3375 30.8572 23.3356C32.1859 23.3337 33.4642 23.8439 34.4267 24.76C34.4267 24.76 38.4367 27.8466 38.4883 27.8983ZM36.195 30.3216C36.195 30.3216 32.2067 27.2533 32.155 27.2016C31.8116 26.8612 31.3477 26.6702 30.8642 26.6702C30.3806 26.6702 29.9167 26.8612 29.5733 27.2016C29.5283 27.2483 26.1667 29.9266 26.1667 29.9266C25.9401 30.107 25.6705 30.2252 25.3844 30.2696C25.0983 30.314 24.8055 30.2831 24.535 30.18C21.1758 28.9293 18.1246 26.9712 15.5881 24.4384C13.0516 21.9057 11.089 18.8574 9.83333 15.5C9.72199 15.2257 9.6857 14.9268 9.72817 14.6339C9.77064 14.341 9.89035 14.0646 10.075 13.8333C10.075 13.8333 12.7533 10.47 12.7983 10.4266C13.1388 10.0833 13.3298 9.61934 13.3298 9.13581C13.3298 8.65228 13.1388 8.18833 12.7983 7.84498C12.7467 7.79498 9.67833 3.80331 9.67833 3.80331C9.32983 3.49082 8.875 3.32347 8.40708 3.33555C7.93915 3.34764 7.49357 3.53825 7.16166 3.86831L5.245 5.53498C-4.15834 16.8416 24.6267 44.03 34.535 34.6666L36.0533 32.9166C36.4091 32.5871 36.6228 32.1321 36.6493 31.6478C36.6757 31.1635 36.5128 30.688 36.195 30.3216Z", fill: "currentColor" })
  }
), GS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M31.6667 0H8.33333C6.12401 0.00264643 4.00593 0.88147 2.4437 2.4437C0.88147 4.00593 0.00264643 6.12401 0 8.33333L0 28.3333C0.00264643 30.5427 0.88147 32.6607 2.4437 34.223C4.00593 35.7852 6.12401 36.664 8.33333 36.6667H31.6667C33.876 36.664 35.9941 35.7852 37.5563 34.223C39.1185 32.6607 39.9974 30.5427 40 28.3333V8.33333C39.9974 6.12401 39.1185 4.00593 37.5563 2.4437C35.9941 0.88147 33.876 0.00264643 31.6667 0ZM8.33333 3.33333H31.6667C32.6646 3.3353 33.6392 3.63586 34.4649 4.19634C35.2906 4.75682 35.9298 5.55158 36.3 6.47833L23.5367 19.2433C22.5974 20.1789 21.3257 20.7041 20 20.7041C18.6743 20.7041 17.4026 20.1789 16.4633 19.2433L3.7 6.47833C4.07025 5.55158 4.70936 4.75682 5.53508 4.19634C6.3608 3.63586 7.33536 3.3353 8.33333 3.33333ZM31.6667 33.3333H8.33333C7.00725 33.3333 5.73548 32.8066 4.7978 31.8689C3.86012 30.9312 3.33333 29.6594 3.33333 28.3333V10.8333L14.1067 21.6C15.671 23.1604 17.7904 24.0367 20 24.0367C22.2096 24.0367 24.329 23.1604 25.8933 21.6L36.6667 10.8333V28.3333C36.6667 29.6594 36.1399 30.9312 35.2022 31.8689C34.2645 32.8066 32.9927 33.3333 31.6667 33.3333Z", fill: "currentColor" })
  }
), WS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M34.1737 5.81333C30.4124 2.06667 25.4118 0.00166667 20.0846 0C9.10697 0 0.172493 8.89 0.167469 19.82C0.165794 23.3133 1.08353 26.7233 2.82688 29.73L0 40L10.5573 37.2433C13.4662 38.8233 16.7419 39.655 20.0745 39.6567H20.0829C31.0588 39.6567 39.995 30.765 40 19.835C40.0033 14.54 37.9334 9.55833 34.1737 5.81333ZM20.0846 36.3083H20.0779C17.107 36.3083 14.1947 35.5133 11.6525 34.0117L11.0479 33.655L4.78292 35.29L6.45593 29.21L6.06238 28.5867C4.40444 25.9633 3.53025 22.9317 3.53192 19.82C3.53527 10.7367 10.9625 3.34667 20.0929 3.34667C24.5141 3.34667 28.6707 5.06333 31.7957 8.17667C34.9207 11.2917 36.6406 15.43 36.6389 19.8317C36.6339 28.9183 29.2083 36.3083 20.0846 36.3083ZM29.1647 23.97C28.6674 23.7217 26.2206 22.5233 25.7634 22.3583C25.3079 22.1933 24.9763 22.11 24.6431 22.605C24.3098 23.1 23.3586 24.2167 23.0672 24.5483C22.7775 24.8783 22.4861 24.92 21.9887 24.6717C21.4913 24.4233 19.887 23.9017 17.9862 22.2133C16.5074 20.9 15.5076 19.2783 15.2179 18.7817C14.9282 18.285 15.1878 18.0183 15.4356 17.7717C15.66 17.55 15.933 17.1933 16.1825 16.9033C16.4337 16.6167 16.5158 16.41 16.6833 16.0783C16.8491 15.7483 16.767 15.4583 16.6414 15.21C16.5158 14.9633 15.521 12.525 15.1074 11.5333C14.7038 10.5667 14.2935 10.6983 13.987 10.6833C13.6973 10.6683 13.3657 10.6667 13.0324 10.6667C12.7009 10.6667 12.1616 10.79 11.7061 11.2867C11.2506 11.7833 9.96441 12.9817 9.96441 15.4183C9.96441 17.8567 11.748 20.2117 11.9958 20.5417C12.2437 20.8717 15.5043 25.875 20.4965 28.02C21.6839 28.53 22.6117 28.835 23.3335 29.0633C24.5259 29.44 25.6111 29.3867 26.4685 29.26C27.4247 29.1183 29.4126 28.0617 29.8279 26.905C30.2432 25.7483 30.2432 24.755 30.1176 24.55C29.9937 24.3417 29.6621 24.2183 29.1647 23.97Z", fill: "currentColor" })
  }
), QS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M31.6667 4H20.7867C20.53 4 20.27 3.94 20.0417 3.825L14.7867 1.19834C14.095 0.851669 13.3217 0.668336 12.5467 0.668336H8.33333C3.73833 0.666669 0 4.405 0 9V29C0 33.595 3.73833 37.3333 8.33333 37.3333H13.3333C14.2533 37.3333 15 36.5883 15 35.6667C15 34.745 14.2533 34 13.3333 34H8.33333C5.57667 34 3.33333 31.7567 3.33333 29V14H36.6667V29C36.6667 31.7567 34.4233 34 31.6667 34H26.6667C25.7467 34 25 34.745 25 35.6667C25 36.5883 25.7467 37.3333 26.6667 37.3333H31.6667C36.2617 37.3333 40 33.595 40 29V12.3333C40 7.73834 36.2617 4 31.6667 4ZM3.33333 9C3.33333 6.24333 5.57667 4 8.33333 4H12.5467C12.8033 4 13.06 4.06 13.2917 4.17667L18.5517 6.805C19.2433 7.15 20.015 7.33167 20.7867 7.33167H31.6667C33.8367 7.33167 35.67 8.73 36.36 10.665H3.33333V9ZM23.8217 25.4933L21.6667 23.3383V35.6667C21.6667 36.5883 20.92 37.3333 20 37.3333C19.08 37.3333 18.3333 36.5883 18.3333 35.6667V23.3383L16.1783 25.4933C15.8533 25.8183 15.4267 25.9817 15 25.9817C14.5733 25.9817 14.1467 25.8183 13.8217 25.4933C13.17 24.8417 13.17 23.7883 13.8217 23.1367L16.51 20.4483C18.3733 18.5833 21.625 18.5833 23.49 20.4483L26.1783 23.1367C26.83 23.7883 26.83 24.8417 26.1783 25.4933C25.5267 26.145 24.4733 26.145 23.8217 25.4933Z", fill: "currentColor" })
  }
), US = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M32.2017 5.43333L28.2333 1.465C27.29 0.52 26.0333 0 24.6983 0H17C12.9767 0 9.60834 2.86833 8.835 6.66667H8.66667C4.07167 6.66667 0.333336 10.405 0.333336 15V31.6667C0.333336 36.2617 4.07167 40 8.66667 40H18.6667C23.2617 40 27 36.2617 27 31.6667V31.4983C30.7983 30.7233 33.6667 27.3567 33.6667 23.3333V8.96833C33.6667 7.63333 33.1467 6.37667 32.2017 5.43333ZM18.6667 36.6667H8.66667C5.91 36.6667 3.66667 34.4233 3.66667 31.6667V15C3.66667 12.2433 5.91 10 8.66667 10V23.3333C8.66667 27.9283 12.405 31.6667 17 31.6667H23.6667C23.6667 34.4233 21.4233 36.6667 18.6667 36.6667ZM25.3333 28.3333H17C14.2433 28.3333 12 26.09 12 23.3333V8.33333C12 5.57667 14.2433 3.33333 17 3.33333H23.6667V6.66667C23.6667 8.50833 25.1583 10 27 10H30.3333V23.3333C30.3333 26.09 28.09 28.3333 25.3333 28.3333ZM27 18.3333C27 19.2533 26.2533 20 25.3333 20H22.8333V22.5C22.8333 23.42 22.0867 24.1667 21.1667 24.1667C20.2467 24.1667 19.5 23.42 19.5 22.5V20H17C16.08 20 15.3333 19.2533 15.3333 18.3333C15.3333 17.4133 16.08 16.6667 17 16.6667H19.5V14.1667C19.5 13.2467 20.2467 12.5 21.1667 12.5C22.0867 12.5 22.8333 13.2467 22.8333 14.1667V16.6667H25.3333C26.2533 16.6667 27 17.4133 27 18.3333Z", fill: "currentColor" })
  }
), ZS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M39.9999 21.8038C40.0013 21.6889 39.9929 21.6735 39.8598 21.6693C39.4801 21.6539 39.078 21.6581 38.7235 21.8879C38.5106 22.0252 38.2836 22.1386 38.0651 22.2479C37.9656 22.297 37.8675 22.3474 37.7695 22.3992C37.6518 22.4609 37.4542 22.566 37.2231 22.4693C36.8126 22.2956 36.3867 22.1975 35.9341 22.091C35.6539 22.0252 35.3625 21.9579 35.0795 21.8711C35.0641 21.8669 35.0473 21.8627 35.0305 21.8598C34.9366 21.8402 34.7405 21.7996 34.6872 21.5782C34.6326 21.3485 34.7993 21.221 34.8792 21.1593C34.8918 21.1495 34.903 21.1411 34.9142 21.1327C35.3037 20.8021 35.5979 20.4168 35.8151 19.9559C36.1723 19.1951 36.1569 18.391 36.1023 17.4929C36.0154 16.0597 34.9212 14.7497 33.5538 14.4443C33.4908 14.4303 33.4025 14.4303 33.3171 14.4303C33.0915 14.4317 32.7861 14.4317 32.66 14.1445C32.5479 13.8909 32.6978 13.6317 32.8183 13.4258C32.8603 13.3543 32.8996 13.2871 32.9248 13.2268C33.0116 13.0307 32.9892 12.962 32.8785 12.8542C32.1374 12.1285 31.3935 11.3803 30.6972 10.6756C30.5963 10.5719 30.5655 10.5775 30.473 10.642C30.2839 10.7737 30.0891 10.8984 29.9 11.0189C29.7501 11.1141 29.5946 11.2136 29.4461 11.3131C29.2093 11.4742 28.9655 11.4882 28.7218 11.3565C28.3575 11.159 27.9652 10.9964 27.5589 10.8731C27.2591 10.7835 27.0798 10.5845 27.0251 10.2791C26.9831 10.0494 26.9313 9.81679 26.8808 9.58982C26.85 9.44692 26.8192 9.30682 26.7884 9.16392C26.7631 9.03923 26.7309 9 26.5824 9H26.574C25.6003 9.00841 24.5664 9.00981 23.4119 9.0014C23.2718 9 23.2452 9.03503 23.2228 9.1443C23.2032 9.23817 23.1808 9.33344 23.1612 9.42731C23.1149 9.63045 23.0715 9.82239 23.0463 10.0185C22.979 10.5313 22.7226 10.8283 22.2393 10.953C21.9913 11.0175 21.7531 11.1323 21.501 11.2556C21.4337 11.2892 21.3637 11.3229 21.295 11.3551C21.0246 11.4826 20.778 11.4658 20.5427 11.3019C20.404 11.2066 20.2597 11.1155 20.1182 11.0259C19.9416 10.9138 19.7581 10.7975 19.583 10.67C19.4541 10.5761 19.4037 10.5719 19.2678 10.712C18.8783 11.1155 18.4734 11.5176 18.0825 11.9071C17.9102 12.078 17.7379 12.2503 17.5669 12.4213C17.2699 12.7183 17.1088 12.8794 17.0836 13.0139C17.0584 13.1456 17.1396 13.3459 17.3119 13.7522C17.3722 13.8951 17.4212 14.0576 17.3344 14.2005C17.2475 14.342 17.0822 14.3743 16.9155 14.3855C15.9894 14.4555 15.2118 14.8828 14.5352 15.6912C14.0308 16.295 13.7674 17.5966 13.9117 18.786C14.0378 19.8284 14.4399 20.648 15.0451 21.0935C15.0563 21.1019 15.0689 21.1103 15.0815 21.1187C15.1754 21.1832 15.3702 21.3191 15.3239 21.56C15.2763 21.8066 15.0619 21.8458 14.9583 21.8641C14.933 21.8683 14.9008 21.8739 14.8882 21.8809C14.1765 22.1989 13.5166 22.1064 12.924 21.6063C12.868 21.5586 12.7937 21.5208 12.7152 21.4788C12.6438 21.4423 12.5709 21.4031 12.4981 21.3527C11.7275 20.8119 11.0564 20.6073 10.3195 20.69C10.0099 20.725 9.99869 20.7559 10.0001 20.9954C10.0141 22.1316 10.0113 23.2861 10.0099 24.4027C10.0085 24.8202 10.0085 25.2391 10.0085 25.6566V26.5967C10.0085 27.8506 10.0085 29.1031 10.0071 30.3556V30.3822C10.0071 30.5895 10.0197 30.6077 10.1136 30.6386C10.6656 30.8193 11.2148 31.0028 11.7654 31.1864C12.7096 31.5002 13.6847 31.8252 14.6486 32.1306C15.0549 32.2595 15.3169 32.2525 15.471 32.111C15.7947 31.8126 16.03 31.9163 16.243 32.0494C16.484 32.1993 16.7333 32.3492 16.9827 32.4949C17.1424 32.5888 17.3133 32.7191 17.361 32.9824C17.4605 33.5386 17.7869 33.8903 18.3585 34.0584C18.5504 34.1145 18.7578 34.2139 18.8376 34.5264C18.9693 35.0475 19.3028 35.3852 19.831 35.5295C20.1588 35.6191 20.2611 35.8363 20.3171 36.0366C20.4502 36.5074 20.7374 36.8128 21.1703 36.9487C21.5948 37.0804 21.7461 37.3662 21.8386 37.6268C21.9605 37.9714 22.2043 38.2446 22.5251 38.3959C22.8319 38.5416 23.1766 38.5571 23.4946 38.4422C23.6291 38.3931 23.751 38.3693 23.8659 38.3693C24.0844 38.3693 24.275 38.459 24.4655 38.6439C24.8031 38.9718 25.3481 39.0852 25.8525 38.9339C26.3232 38.7924 26.6511 38.4492 26.7533 37.9897C26.8094 37.7291 26.9663 37.5693 27.2297 37.5007C27.7396 37.3676 28.0689 37.0566 28.2062 36.5774C28.2958 36.2622 28.4682 36.0913 28.7792 36.0058C29.2387 35.8783 29.5483 35.5645 29.6744 35.1008C29.7767 34.7211 30.0219 34.5992 30.2474 34.5292C30.7868 34.3624 31.1007 33.9996 31.1777 33.4504C31.2296 33.0875 31.3977 32.869 31.7269 32.7443C31.8138 32.7107 31.9006 32.6644 31.9917 32.6154C32.0393 32.5902 32.0856 32.5649 32.1332 32.5411L33.2008 32.0073C35.3877 30.9146 37.5733 29.8218 39.7617 28.729C39.9536 28.6337 39.9915 28.5931 39.9901 28.4796C39.9943 26.3627 39.9943 24.1799 39.9999 21.8038ZM33.1601 15.0622C34.3412 15.2401 35.3177 16.2866 35.3835 17.4439C35.4144 17.9791 35.4144 18.4512 35.3863 18.8883C35.3345 19.6785 34.9296 20.3243 34.1843 20.8105C34.0064 20.9254 33.9489 21.0277 33.9545 21.2126C33.9629 21.4872 33.9601 21.6973 33.9573 21.8669C33.9545 22.0644 33.9531 22.2507 33.9811 22.2886C34.0064 22.3222 34.1857 22.3628 34.358 22.402C34.5275 22.4399 34.7377 22.4889 35.0137 22.566C35.235 22.6276 35.4634 22.685 35.6834 22.7397C35.7884 22.7663 35.8921 22.7929 35.9972 22.8181L36.1065 22.8462L36.2143 23.2104L35.6259 23.5228C35.2883 23.7008 34.952 23.8801 34.6158 24.058L34.0918 24.334C33.2316 24.788 32.37 25.2419 31.5084 25.693C31.3234 25.7897 31.1735 25.8681 31.0446 25.8681C30.9914 25.8681 30.9423 25.8555 30.8947 25.8261C30.728 25.7224 30.7336 25.5039 30.7392 25.2027C30.7546 24.5106 30.7322 23.7848 30.2727 23.188C30.1788 23.0661 30.1494 22.9484 30.1886 22.8406C30.2474 22.6724 30.4338 22.629 30.5122 22.6094C30.6481 22.5772 30.7826 22.5421 30.9185 22.5071C31.1119 22.4581 31.3122 22.4062 31.5126 22.3628C31.6989 22.3222 31.7143 22.2647 31.7045 22.1429C31.6919 22.0084 31.6933 21.8767 31.7059 21.752C31.7535 21.2602 31.6863 20.8932 31.2043 20.5863C30.5963 20.1997 30.2531 19.5034 30.2643 18.6754C30.2657 18.5269 30.2615 18.3727 30.2573 18.2256C30.2432 17.7241 30.2278 17.2071 30.4324 16.6929C30.8737 15.5749 32.0197 14.8912 33.1601 15.0622ZM23.8813 22.0098C23.8687 21.9299 23.8687 21.843 23.8799 21.759C23.9555 21.1972 23.8084 20.8637 23.3587 20.5667C22.7521 20.1674 22.4242 19.4879 22.434 18.6529C22.4368 18.5016 22.4354 18.3503 22.4354 18.2004C22.434 17.9721 22.4326 17.7367 22.441 17.5041C22.4887 16.1704 23.6039 15.0678 24.9278 15.0467C24.9404 15.0467 24.953 15.0453 24.9657 15.0453C26.2812 15.0453 27.4636 16.1241 27.5603 17.4187C27.5729 17.598 27.5701 17.7773 27.5659 17.951C27.5645 18.0239 27.5631 18.0981 27.5631 18.171C27.7018 19.3492 27.2577 20.2641 26.2448 20.8904C26.1439 20.952 26.1439 20.9814 26.1439 20.9996L26.1425 21.0234C26.1397 21.4283 26.1355 21.8458 26.1439 22.2563C26.1453 22.297 26.1453 22.3054 26.2994 22.3404C26.3204 22.3446 26.34 22.3502 26.3597 22.3544C26.6244 22.4217 26.8892 22.4875 27.1526 22.5519C27.671 22.6808 28.2076 22.8139 28.733 22.954C29.5988 23.1866 30.0079 23.719 30.0205 24.6324C30.0247 25.0121 30.0247 25.4156 30.0205 25.899C30.0191 26.1231 29.9939 26.3487 29.8257 26.4776C29.7417 26.542 29.6408 26.5644 29.5357 26.5644C29.4293 26.5644 29.3186 26.5406 29.2149 26.514C28.9109 26.4355 28.6069 26.3459 28.3127 26.2604C28.0367 26.1792 27.7509 26.0965 27.4679 26.0222C25.9323 25.6159 24.4291 25.2125 22.9062 24.7641C22.158 24.5442 21.3567 24.6156 20.6015 24.7277C20.4026 24.7571 20.2022 24.7641 20.0803 24.6268C19.9585 24.4895 19.9907 24.2976 20.0425 24.1099C20.2022 23.5313 20.5917 23.1418 21.1689 22.9877C21.9353 22.7817 22.7549 22.5646 23.5871 22.3824C23.8757 22.3194 23.9107 22.2199 23.8813 22.0098ZM29.086 22.2465C28.7428 22.3082 28.4345 22.2087 28.1361 22.1106C28.0128 22.07 27.8952 22.0322 27.7803 22.007C27.2801 21.8963 27.0041 21.836 26.9355 21.6091C26.8682 21.3849 27.0475 21.1972 27.4048 20.8245C27.8685 20.3426 28.1473 19.7681 28.2328 19.1209C28.4724 17.3108 28.1235 16.0891 27.1036 15.1644C26.3078 14.4429 25.1856 14.1949 24.0998 14.5004C23.0168 14.8044 22.1889 15.6015 21.8862 16.6327C21.7433 17.1174 21.6887 17.6078 21.7223 18.0911L21.7237 18.1037V18.1164C21.6579 19.4109 22.0558 20.4014 22.9412 21.1467C23.0126 21.207 23.206 21.3695 23.1569 21.5796C23.1079 21.7912 22.8599 21.8514 22.7661 21.8739C22.5713 21.9215 22.3752 21.9733 22.1847 22.0252C21.8988 22.1008 21.6046 22.1807 21.3104 22.2451C21.232 22.2633 21.1549 22.2703 21.0793 22.2703C20.8481 22.2703 20.6337 22.2003 20.439 22.1358C20.3157 22.0952 20.198 22.0574 20.0817 22.0364C20.0243 22.0266 19.9599 22.0182 19.8954 22.0098C19.5844 21.9691 19.2327 21.9243 19.1066 21.6483C18.9441 21.2924 19.2537 21.0767 19.4387 20.9464C19.5129 20.8946 19.59 20.8413 19.6306 20.7923C20.114 20.2081 20.3816 19.5888 20.4474 18.9023C20.5189 18.1626 20.5441 17.2968 20.1994 16.4744C20.1028 16.2446 20.1224 16.0345 20.2583 15.8145C21.3749 14.01 22.9888 13.1021 25.0497 13.1106C27.0489 13.1204 28.6265 14.017 29.7403 15.7781C29.9042 16.0373 29.844 16.2572 29.7893 16.452C29.3354 18.0841 29.4489 19.3619 30.1494 20.4714C30.2909 20.6956 30.4884 20.9114 30.7728 21.1495C30.8443 21.2098 31.0362 21.3695 30.9886 21.5768C30.9424 21.7814 30.7084 21.843 30.6327 21.8627C30.4926 21.8991 30.3525 21.9383 30.211 21.9775C29.844 22.0728 29.4685 22.1779 29.086 22.2465ZM18.1343 12.8149C18.5126 12.4633 18.8783 12.0864 19.1851 11.7628C19.314 11.6283 19.4415 11.561 19.576 11.5582C19.7007 11.5554 19.8226 11.6101 19.936 11.7194C20.5749 12.333 21.1773 12.3708 21.8918 11.8454C22.2547 11.5779 22.696 11.477 23.1233 11.3803L23.2578 11.3495C23.4315 11.3089 23.5002 11.2374 23.5282 11.0637C23.5548 10.8984 23.5927 10.7344 23.6277 10.5761C23.6571 10.443 23.6865 10.3071 23.7103 10.174C23.786 9.74954 24.076 9.66688 24.31 9.67108C24.7191 9.67949 25.1688 9.67949 25.7222 9.67248H25.7348C26.0458 9.67248 26.242 9.8364 26.2994 10.1474C26.3274 10.2973 26.3611 10.4486 26.3933 10.5971C26.4311 10.7653 26.4689 10.939 26.4998 11.1127C26.5278 11.2654 26.5894 11.3075 26.6931 11.3313C27.4524 11.5064 28.2062 11.8202 28.9978 12.2924C29.0706 12.3358 29.1154 12.34 29.2205 12.2686C29.341 12.1887 29.4643 12.1116 29.5834 12.036C29.7585 11.9253 29.9392 11.8118 30.1073 11.6927C30.3651 11.5078 30.5935 11.526 30.8079 11.7474C31.0656 12.015 31.3332 12.2826 31.5924 12.5417C31.7017 12.6482 31.8096 12.7561 31.916 12.864L31.9413 12.8892C32.0183 12.9635 32.178 13.119 32.1024 13.3361C32.0758 13.4118 32.0505 13.4888 32.0267 13.5659C31.909 13.9329 31.7858 14.3112 31.4957 14.6096C31.3402 14.7693 31.1525 14.8828 30.9704 14.9935C30.8723 15.0524 30.7798 15.1084 30.6944 15.1686C30.5963 15.2401 30.508 15.2667 30.4296 15.2667C30.2334 15.2667 30.1059 15.0916 30.0485 15.0103L30.0401 14.9991C29.4026 14.1151 28.5774 13.4384 27.5883 12.9845C26.7071 12.5796 25.8301 12.4058 24.6644 12.4058H24.6322C22.8123 12.4815 21.1675 13.395 19.9977 14.9795C19.6895 15.397 19.4415 15.2555 19.2019 15.1168L19.1739 15.1014C18.5813 14.7623 18.1876 14.265 17.9718 13.5855C17.8934 13.3347 17.8583 13.0699 18.1343 12.8149ZM15.2104 22.5604C15.2623 22.5351 15.3015 22.5169 15.3323 22.5015C15.3884 22.4749 15.4248 22.4567 15.4696 22.4427C15.74 22.36 15.9348 22.2984 15.9894 22.2283C16.0412 22.1625 16.0482 21.9901 16.0608 21.7029L16.0637 21.6259C16.0861 21.1243 15.9684 20.8707 15.5971 20.6228C14.94 20.1842 14.5898 19.4711 14.6122 18.6151C14.6164 18.4358 14.615 18.2523 14.615 18.0743C14.6136 17.916 14.6122 17.7535 14.6164 17.591C14.6416 16.2012 15.7134 15.0832 17.0584 15.0481C17.0822 15.0467 17.1046 15.0467 17.1284 15.0467C18.4818 15.0467 19.6446 16.1157 19.7385 17.4607C19.7707 17.9272 19.7735 18.3882 19.7455 18.8281C19.6937 19.6659 19.2804 20.337 18.5182 20.8231C18.3543 20.9282 18.3011 21.0206 18.3095 21.1902C18.3263 21.5152 18.3207 21.8444 18.3123 22.1527C18.3095 22.2787 18.3361 22.311 18.4594 22.339C18.6457 22.381 18.8334 22.4315 19.0128 22.4791C19.1697 22.5211 19.3336 22.566 19.4933 22.6024C19.5648 22.6192 19.7567 22.6626 19.8198 22.8321C19.8814 23.0003 19.7665 23.1544 19.7301 23.2062C19.4373 23.6069 19.2888 24.065 19.2748 24.6072C19.2692 24.8734 19.1655 25.0359 18.9665 25.0864C18.6107 25.1788 18.2576 25.2573 17.9144 25.3231C17.8836 25.3287 17.8555 25.3315 17.8303 25.3315C17.7042 25.3315 17.6244 25.2727 17.5865 25.2321C17.4997 25.1424 17.4661 25.0023 17.4983 24.8552C17.6076 24.3592 17.368 24.1421 16.858 23.8941C16.4699 23.705 16.1057 23.478 15.7204 23.2384C15.5495 23.132 15.373 23.0213 15.1894 22.912L14.8644 22.7173L15.2104 22.5604ZM12.9198 30.7254C12.8609 30.7562 12.8007 30.7675 12.7419 30.7675C12.6522 30.7675 12.5667 30.7408 12.5009 30.7156C12.0722 30.5517 11.6239 30.413 11.205 30.2869C10.8421 30.1776 10.674 29.9437 10.6796 29.5486C10.6908 28.6267 10.688 27.6894 10.6866 26.783C10.6866 26.4439 10.6852 26.1049 10.6852 25.7673L10.6838 24.6885C10.6838 23.8115 10.6824 22.9358 10.6852 22.0602C10.6866 21.8318 10.7118 21.5824 10.9037 21.4732C11.0957 21.3625 11.3296 21.4662 11.5328 21.5839C11.9265 21.8108 12.3188 22.0406 12.7124 22.2703C13.2855 22.6052 13.8781 22.9512 14.4637 23.2833C14.8308 23.4906 14.8055 23.7862 14.7537 23.9908C14.3124 25.7378 13.7324 28.0411 13.1524 30.371C13.1215 30.4943 13.0669 30.6484 12.9198 30.7254ZM15.1194 30.9398C15.0787 31.0855 15.0213 31.2844 14.8406 31.3699C14.7887 31.3951 14.7341 31.4063 14.6739 31.4063C14.5968 31.4063 14.5141 31.3867 14.4217 31.3461C14.381 31.3279 14.3278 31.3139 14.2704 31.2998C14.0742 31.2494 13.6637 31.1429 13.8038 30.5909C14.2493 28.8229 14.7355 26.8769 15.3337 24.4643C15.3631 24.3438 15.422 24.1771 15.5831 24.1141C15.761 24.044 15.9362 24.1561 15.9936 24.1939C16.1043 24.2654 16.2192 24.3298 16.341 24.3985C16.4055 24.4349 16.4685 24.4699 16.5316 24.5078C16.76 24.6408 16.837 24.844 16.7754 25.1438L16.7712 25.1592L15.9418 28.0579C15.6714 29.0008 15.3912 29.9773 15.1194 30.9398ZM18.9553 33.3607C18.8783 33.4084 18.7984 33.4098 18.755 33.4112L18.7396 33.4126H18.7228C18.4552 33.4098 18.2254 33.2739 18.1077 33.0497C17.9928 32.8311 18.0111 32.572 18.1554 32.3576C18.4538 31.9163 18.8489 31.58 19.1599 31.3363C19.4121 31.1387 19.7133 31.1429 19.9823 31.3489C20.2387 31.5436 20.3157 31.8672 20.1714 32.1334C19.9136 32.6112 19.5143 33.0119 18.9553 33.3607ZM20.177 34.8766C19.9963 34.8766 19.8212 34.7996 19.6811 34.6468C19.4219 34.3624 19.4485 33.9772 19.7511 33.6661C19.9921 33.4196 20.2765 33.1296 20.5721 32.8564C20.7977 32.6476 21.0807 32.607 21.3468 32.7443C21.5976 32.8732 21.6957 33.0931 21.7041 33.2416V33.2472C21.7125 33.519 21.6481 33.711 21.494 33.8693C21.4351 33.9281 21.3791 33.987 21.3216 34.0472C21.1241 34.2518 20.9209 34.4633 20.7038 34.6581C20.5385 34.8024 20.3549 34.8766 20.177 34.8766ZM22.1622 36.1263C21.9997 36.2748 21.8204 36.3477 21.6439 36.3477C21.4659 36.3477 21.2922 36.2706 21.1465 36.1179C20.8719 35.8321 20.8929 35.4664 21.2025 35.1428C21.4547 34.878 21.7209 34.6132 22.0137 34.3316C22.2197 34.1369 22.4901 34.092 22.7773 34.2055C22.9398 34.27 23.1359 34.4255 23.1471 34.7982V34.8024C23.1499 35.0153 23.0799 35.2016 22.9468 35.3389L22.8207 35.4692C22.6106 35.6906 22.392 35.9162 22.1622 36.1263ZM23.475 37.6982C23.3629 37.7809 23.2382 37.8215 23.1135 37.8215C22.9524 37.8215 22.7899 37.7557 22.6456 37.6254C22.4074 37.4082 22.357 37.072 22.5251 36.8254C22.8375 36.3673 23.227 35.982 23.6823 35.6794C23.758 35.629 23.8406 35.6191 23.8911 35.6121L23.9317 35.6037L23.9527 35.6051C24.2161 35.6093 24.4529 35.7494 24.5692 35.968C24.6798 36.1753 24.6686 36.4191 24.5369 36.6223C24.2918 37.0005 23.9443 37.3536 23.475 37.6982ZM26.1187 37.701C26.0949 37.9182 25.9716 38.2867 25.3986 38.3105H25.3846L25.3705 38.3091C25.0427 38.2769 24.7877 38.0919 24.656 37.7893C24.6014 37.6632 24.6826 37.5469 24.7219 37.4909C24.7261 37.4839 25.1996 36.8632 25.4406 36.8786C25.6241 36.8899 25.8007 37.0664 25.8889 37.1715C25.966 37.2611 26.1397 37.4923 26.1187 37.701ZM30.3147 33.6928C30.0401 33.9856 29.6394 33.9926 29.2948 33.7138C28.9487 33.4336 28.6027 33.145 28.2678 32.8662C28.1333 32.7541 27.9988 32.6406 27.8629 32.5285C27.7719 32.4529 27.6794 32.3786 27.5883 32.303C27.3656 32.1222 27.1372 31.9345 26.9187 31.737C26.8388 31.6655 26.8052 31.6641 26.8038 31.6641C26.8038 31.6641 26.7772 31.6725 26.7267 31.7412C26.7169 31.7566 26.7043 31.7706 26.6917 31.7832C26.546 31.9471 26.3989 32.111 26.3919 32.1643C26.4073 32.2077 26.5754 32.3478 26.7379 32.4809L26.7463 32.4879C27.3936 33.0217 28.0339 33.5583 28.6881 34.1047C29.0804 34.4325 29.1547 34.7743 28.9095 35.119C28.8072 35.2619 28.6545 35.3544 28.478 35.3782C28.2552 35.4076 28.0198 35.3319 27.8125 35.1638C27.084 34.5726 26.3036 33.9337 25.5303 33.2697C25.407 33.1632 25.3551 33.1562 25.3383 33.1576C25.3257 33.159 25.2767 33.173 25.1814 33.2963L25.1394 33.3509C25.0441 33.4742 24.953 33.5933 24.9278 33.6465C24.9572 33.6816 25.0371 33.7502 25.0973 33.8006C25.8203 34.4115 26.532 35.0083 27.2143 35.5743C27.6934 35.9708 27.6094 36.3267 27.4566 36.5536C27.3558 36.7049 27.2143 36.8002 27.0504 36.8324C27.0097 36.8394 26.9691 36.8436 26.9285 36.8436C26.7673 36.8436 26.5964 36.7862 26.4367 36.6783C25.9057 36.3168 25.4378 35.9806 25.0861 35.4973C24.9488 35.3095 24.7443 35.2086 24.5271 35.1008C24.3548 35.0153 24.1769 34.927 24.0284 34.7926C23.8701 34.6482 23.7902 34.4493 23.7132 34.2574C23.6249 34.0402 23.5506 33.8511 23.3839 33.7754C22.7296 33.4756 22.3262 33.0721 22.074 32.4627C21.9703 32.2119 21.6411 32.0844 21.3833 32.0228C21.0835 31.9499 20.9714 31.7524 20.9013 31.5688C20.6842 30.9958 20.3143 30.6246 19.8604 30.5223C19.398 30.4186 18.8965 30.6007 18.4426 31.0378C18.4019 31.0771 18.3613 31.1149 18.3207 31.1541C18.1694 31.297 18.0265 31.4315 17.9018 31.5814C17.6314 31.9023 17.326 31.9443 16.9939 31.7075C16.7361 31.524 16.4503 31.3643 16.2052 31.2326C15.8451 31.0393 15.8815 30.7506 15.9404 30.5503C16.2248 29.571 16.505 28.5735 16.7768 27.6082L17.0373 26.6807C17.0976 26.4692 17.2237 26.1778 17.6258 26.0923C18.0209 26.0096 18.4201 25.9186 18.8068 25.8303C19.5059 25.672 20.2288 25.5067 20.9504 25.3834C21.8232 25.2349 22.717 25.3512 23.8476 25.7589L24.2834 25.9158L23.8701 26.1245C23.6081 26.2576 23.3531 26.3837 23.1051 26.507C22.5615 26.7774 22.0488 27.0324 21.5444 27.3042C20.7906 27.7105 20.5273 28.6421 20.9448 29.4239C21.1297 29.7699 21.4309 30.0207 21.7938 30.1314C22.179 30.2477 22.6036 30.1986 22.9888 29.9927C23.3125 29.819 23.6333 29.6228 23.9457 29.4323L24.0676 29.358C25.4616 28.5062 25.6437 28.5244 26.8528 29.6326C27.5673 30.2883 28.3015 30.9468 29.0104 31.5828C29.3466 31.8841 29.6814 32.1839 30.0163 32.4865C30.0709 32.5355 30.1242 32.5874 30.1774 32.6378L30.2208 32.6812C30.5613 33.0049 30.5963 33.3929 30.3147 33.6928ZM38.8945 28.4082C36.3026 29.6957 33.7598 30.9664 31.3402 32.1853C31.224 32.2441 31.1189 32.2693 31.025 32.2693C30.8247 32.2693 30.6692 32.1601 30.5277 32.0326L30.3161 31.842C29.1407 30.7759 27.9246 29.6719 26.7141 28.6043C25.9478 27.929 25.2388 27.8674 24.3422 28.3983C24.1293 28.5258 23.9163 28.6519 23.7033 28.7808C23.4077 28.9588 23.1135 29.1353 22.8151 29.3104C22.5349 29.4743 22.2463 29.5248 21.9997 29.4533C21.7994 29.3959 21.6397 29.2614 21.5402 29.068C21.4281 28.8523 21.4071 28.6239 21.4757 28.4096C21.5542 28.17 21.7461 27.964 22.0165 27.8281C22.2771 27.6964 22.5405 27.5676 22.8039 27.4373C23.3335 27.1767 23.8813 26.9063 24.4109 26.6261C25.0441 26.2912 25.7306 26.2338 26.511 26.451C27.2927 26.6681 28.1235 26.9077 29.0552 27.1851C29.5483 27.3308 29.9574 27.2958 30.3833 27.0688C32.3307 26.032 34.316 24.9883 36.2354 23.9796C37.0073 23.5733 37.7807 23.1684 38.5526 22.7607C38.809 22.6262 38.9925 22.5295 39.1593 22.629C39.3246 22.7285 39.3246 22.94 39.326 23.209C39.3274 23.7246 39.3274 24.2416 39.3274 24.7571V25.4198C39.3274 25.6286 39.326 25.8387 39.326 26.0475C39.3246 26.5784 39.3218 27.1276 39.3316 27.6656C39.34 28.0257 39.2041 28.254 38.8945 28.4082Z", fill: "currentColor" })
  }
), KS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M28.7281 10.2004C28.711 9.48568 28.2491 9.0316 27.5225 9.01713C26.3972 8.99475 25.2232 8.99475 23.9307 9.01449C23.2463 9.02634 22.7159 9.53438 22.6685 10.2241C22.6185 10.9532 23.0094 11.4244 23.7662 11.5547C23.7938 11.5587 23.8201 11.5639 23.8504 11.5692L24.2124 11.6337L23.4727 12.3444C22.8396 12.9538 22.2407 13.5276 21.6392 14.116C21.4905 14.2607 21.3629 14.2371 21.2154 14.1581C20.8825 13.9778 20.5337 13.7948 20.1441 13.6C19.8269 13.4408 19.565 13.3592 19.3241 13.3592C18.9714 13.3592 18.6647 13.5342 18.2975 13.9028C16.0587 16.1574 13.8199 18.4106 11.5837 20.6666C11.4455 20.8061 11.3126 20.9456 11.2086 21.0969C10.8677 21.6023 10.9533 22.3131 11.4021 22.7171C11.5363 22.8382 11.6785 22.929 11.8272 22.9909C11.9746 23.0528 12.1286 23.0844 12.2826 23.0844C12.5511 23.0844 12.8183 22.9856 13.0539 22.7974C13.1921 22.6882 13.3184 22.5605 13.4421 22.4368L14.3253 21.5484C15.9679 19.8953 17.667 18.1869 19.3346 16.4956C19.5558 16.2705 19.7334 16.2455 19.9875 16.4022C20.2612 16.5693 20.5547 16.7141 20.8403 16.8549L20.9825 16.926C21.659 17.2616 22.1368 17.1905 22.683 16.672C23.0633 16.3113 23.445 15.9415 23.8162 15.5835C23.9912 15.4137 24.1676 15.2439 24.344 15.0741L26.1208 13.3658L26.1827 13.7119C26.209 13.858 26.2314 13.9791 26.259 14.1002C26.4235 14.7977 26.8829 15.1571 27.5515 15.111C28.2175 15.0636 28.7124 14.5569 28.7281 13.9067C28.7571 12.6669 28.7571 11.4205 28.7281 10.2004ZM27.483 14.3621C27.2817 14.3687 27.1566 14.2923 27.0869 14.2265C26.9776 14.1226 26.9171 13.962 26.9131 13.7646C26.9039 13.3737 26.9066 12.9762 26.9105 12.5905C26.9118 12.3694 26.896 12.1944 26.6815 12.1062C26.4735 12.0206 26.3393 12.1272 26.1721 12.2878C24.877 13.5342 23.5806 14.7793 22.2868 16.0271C21.8301 16.4667 21.7472 16.4785 21.1878 16.1942C20.8101 16.0007 20.4073 15.7954 20.0059 15.5861C19.5057 15.3255 19.4544 15.3334 19.0701 15.7204C17.0142 17.7907 14.961 19.8611 12.9051 21.9314C12.7103 22.1288 12.4748 22.3262 12.2365 22.3262C12.1286 22.3262 12.0207 22.2854 11.9154 22.1854C11.7996 22.0762 11.743 21.963 11.7403 21.8379C11.7377 21.6484 11.8601 21.4405 12.1378 21.1614C14.3582 18.9253 16.5786 16.6878 18.799 14.4516C19.0161 14.2331 19.1464 14.1015 19.3478 14.1015C19.4939 14.1015 19.6321 14.1739 19.8598 14.291C20.0177 14.3726 20.1757 14.4542 20.3336 14.5358C20.635 14.6898 20.9456 14.8491 21.2457 15.0123C21.4853 15.1413 21.6708 15.1149 21.8683 14.9241C22.6316 14.1844 23.399 13.4474 24.1413 12.734C24.5467 12.3431 24.9521 11.9535 25.3574 11.5626C25.4943 11.431 25.6101 11.2954 25.5299 11.0888C25.4377 10.8571 25.2403 10.8255 25.0587 10.8255L24.6783 10.8242C24.4532 10.8229 24.2282 10.8229 24.0044 10.8242C23.474 10.8163 23.4095 10.457 23.4069 10.3017C23.4042 10.1477 23.4529 10.0122 23.549 9.91475C23.653 9.80814 23.807 9.7476 23.9833 9.74628C24.9915 9.73707 26.0971 9.73707 27.462 9.74497C27.7963 9.7476 27.9871 9.94371 27.9845 10.2846C27.9819 10.6979 27.9819 11.1112 27.9832 11.5257L27.9845 12.1588L27.9832 12.5603C27.9819 12.9538 27.9819 13.3618 27.9858 13.7606C27.9964 14.1331 27.8095 14.3529 27.483 14.3621Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M17.5855 34.098C17.2723 33.7769 16.8419 33.5913 16.4049 33.5887H16.3931C15.4981 33.5887 14.7637 34.3218 14.7545 35.2286C14.7492 35.684 14.919 36.1078 15.2309 36.425C15.5389 36.737 15.9522 36.9094 16.397 36.912H16.4036C17.3012 36.912 18.0436 36.1776 18.0607 35.276C18.0699 34.839 17.9014 34.4205 17.5855 34.098ZM16.3997 36.1592H16.3891C15.8798 36.1552 15.4836 35.7551 15.4849 35.2484C15.4876 34.7416 15.8864 34.3429 16.3944 34.3389C16.6484 34.3389 16.8919 34.4416 17.0683 34.6219C17.2433 34.8009 17.3368 35.0312 17.3289 35.2734C17.3157 35.7617 16.8998 36.1592 16.3997 36.1592Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M37.7702 25.2245C37.3504 24.3847 36.6028 23.9846 35.6617 24.0978C35.3669 24.1333 35.1023 24.2597 34.8233 24.3939C34.772 24.419 34.7193 24.444 34.6654 24.469L34.3982 24.594V22.3539C34.3982 20.785 34.3982 19.2135 34.3969 17.6446V17.5762C34.3982 17.4709 34.3982 17.3643 34.3837 17.2642C34.3548 17.0616 34.2245 16.9457 34.027 16.9457C33.823 16.9457 33.6993 17.0589 33.6756 17.2629C33.6598 17.3998 33.6598 17.538 33.6598 17.6841C33.6585 20.0545 33.6585 22.4263 33.6611 24.7967C33.6611 24.981 33.6611 25.1915 33.4334 25.3626L33.3518 25.4232C32.6082 25.9799 31.8396 26.5538 31.0327 27.0487C31.0104 27.0618 30.988 27.0776 30.9656 27.0947C30.8735 27.1605 30.7485 27.25 30.6155 27.1829C30.476 27.1105 30.4957 26.9565 30.5102 26.8552C30.5142 26.821 30.5194 26.7907 30.5181 26.7657C30.5155 23.2726 30.5155 19.7795 30.5155 16.2877V14.8056C30.5155 13.9922 30.6089 13.5961 30.859 13.3473C31.1078 13.1025 31.5184 13.0091 32.3292 13.0183C33.1584 13.0262 33.6295 13.4842 33.6572 14.3068C33.6651 14.5411 33.6638 14.7793 33.6625 15.0096C33.6611 15.1426 33.6611 15.2729 33.6611 15.4019C33.6625 15.5703 33.6993 15.6914 33.773 15.7638C33.8336 15.8217 33.9152 15.8507 34.0376 15.8494C34.2758 15.8467 34.3969 15.7033 34.3942 15.4242C34.3929 15.2847 34.3956 15.1439 34.3969 15.0044C34.4008 14.6438 34.4048 14.27 34.3561 13.912C34.2534 13.146 33.7835 12.6129 32.9978 12.3681C32.7267 12.2839 32.4397 12.2865 32.162 12.2891C32.112 12.2891 32.062 12.2904 32.0133 12.2904C31.2631 12.2904 30.6998 12.476 30.3339 12.8432C29.968 13.2091 29.7824 13.7751 29.7824 14.5253V27.1487C29.7824 27.2948 29.7653 27.5041 29.6231 27.6317C29.5086 27.737 29.3323 27.7739 29.0677 27.7475C28.9637 27.737 28.8887 27.7015 28.8453 27.6423C28.7755 27.5449 28.8045 27.4198 28.8295 27.3079C28.84 27.2619 28.8505 27.2145 28.8505 27.1829C28.8374 24.4321 28.8387 21.6971 28.8426 18.662C28.844 17.7091 28.4912 17.0892 27.7344 16.7115C27.3356 16.5127 26.8868 16.5153 26.4525 16.518H26.3893C24.9942 16.5246 24.2242 17.2893 24.2202 18.6686L24.2189 19.2122C24.2163 20.3138 24.2137 21.4536 24.2268 22.5763C24.2308 22.879 24.1242 23.0515 23.8701 23.1528C23.778 23.1896 23.6859 23.237 23.5793 23.2923L23.5608 23.3015L23.2858 23.445L23.2884 22.8619C23.291 22.5539 23.2923 22.2617 23.2844 21.9735C23.2502 20.8284 22.5737 20.1598 21.4273 20.1361C21.2286 20.1322 21.0272 20.1335 20.8311 20.1348L20.6468 20.1361C19.3333 20.1401 18.666 20.8034 18.6634 22.1078C18.6607 22.9764 18.6621 23.8451 18.6621 24.7138L18.6634 25.5851C18.6647 25.7417 18.666 25.9194 18.4436 26.0365L18.3514 26.0852C17.6697 26.4419 17.0287 26.7775 16.2864 26.9657C15.1624 27.2514 14.0634 27.5817 13.1381 27.866C11.8575 28.2595 11.0059 29.5217 11.1994 30.7405C11.2862 31.2801 11.4323 31.8171 11.5745 32.3357L11.5797 32.3555C11.6179 32.4963 11.6574 32.6384 11.6943 32.7806C11.7377 32.9464 11.8048 33.057 11.8943 33.1083C11.9667 33.1491 12.0549 33.1557 12.1641 33.1254C12.405 33.0596 12.48 32.8898 12.3997 32.5897C12.3537 32.4173 12.3142 32.2396 12.2747 32.0685C12.2049 31.7619 12.1352 31.4526 12.0325 31.1577C11.843 30.6089 11.8838 30.0377 12.1483 29.5494C12.43 29.0269 12.9433 28.6504 13.5935 28.4886C14.6899 28.2148 15.7428 27.8976 16.6286 27.6225C16.9747 27.5146 17.134 27.5909 17.2564 27.9226C17.7302 29.2059 18.2159 30.5049 18.6871 31.7632L18.7042 31.8066C19.0845 32.8227 19.4781 33.873 19.8611 34.9075C20.0427 35.3958 19.9967 35.9618 19.7361 36.458C19.4649 36.9739 19.0003 37.3477 18.462 37.4833C17.5789 37.7057 16.6549 37.9137 15.7165 38.1005C14.6583 38.3125 13.7554 37.7412 13.4698 36.6791C13.379 36.3435 13.2908 36.0026 13.2065 35.6709L13.2 35.6419C13.1223 35.3379 13.042 35.0233 12.9591 34.7154C12.8907 34.4574 12.7946 34.285 12.5656 34.285C12.5392 34.285 12.5116 34.2876 12.4813 34.2915C12.3879 34.306 12.3168 34.3495 12.2707 34.4179C12.1997 34.5245 12.1891 34.693 12.2378 34.8944L12.3155 35.2155C12.4524 35.7722 12.5919 36.3435 12.7525 36.8949C13.1091 38.1111 14.1015 38.8981 15.2795 38.8981C15.4059 38.8981 15.5335 38.8889 15.6612 38.8705C16.6194 38.7323 17.6486 38.498 18.8082 38.1558C20.0664 37.7833 20.8008 36.7396 20.7232 35.434C20.7034 35.1102 20.8061 34.9733 21.1299 34.8957C22.3565 34.5995 23.6043 34.2942 24.8112 33.998L24.8441 33.9901C26.3235 33.6282 27.8516 33.2531 29.3573 32.8925C30.5023 32.6187 31.7027 32.2818 32.6885 31.4394C33.2794 30.9353 33.8915 30.4365 34.4837 29.9534C34.822 29.6784 35.1589 29.4046 35.4932 29.1282C35.6578 28.9913 35.8236 28.8571 35.9894 28.7228C36.4514 28.3464 36.9305 27.9581 37.3714 27.5449C38.0348 26.9157 38.1822 26.051 37.7702 25.2245ZM24.9613 19.9124V19.8308C24.9613 19.3701 24.9613 18.9108 24.9626 18.4514C24.9639 18.3514 24.9784 18.2408 25.0086 18.125C25.2298 17.284 26.0642 17.2103 26.8526 17.2485C27.1869 17.2656 27.4686 17.3682 27.6778 17.5433C27.8871 17.7183 28.024 17.9658 28.0714 18.2685C28.0964 18.4304 28.099 18.5923 28.099 18.7463C28.099 19.532 28.099 20.3191 28.0977 21.1048V21.1246C28.0964 23.1383 28.0964 25.2205 28.1095 27.2671C28.1108 27.4211 28.0964 27.5949 27.9898 27.6988C27.8989 27.787 27.7634 27.8068 27.6225 27.8068C27.6002 27.8068 27.5765 27.8055 27.5541 27.8055C27.2632 27.7949 26.9447 27.791 26.5525 27.791C26.3222 27.791 26.0905 27.7923 25.851 27.7936H25.8365C25.6694 27.7949 25.5009 27.7962 25.3285 27.7962L24.8981 27.7976L25.1903 27.4804C25.364 27.2935 25.539 27.1592 25.7088 27.0302C25.7773 26.9776 25.8457 26.9263 25.9102 26.8723C26.6446 26.2682 27.1224 25.4758 27.3317 24.519C27.4686 23.8846 27.3277 23.2923 26.9421 22.8922C26.5564 22.4934 25.9694 22.3289 25.3311 22.4447C25.2021 22.4671 25.1179 22.4592 25.0586 22.4197L25.0415 22.4092L25.0284 22.3947C24.977 22.342 24.956 22.2644 24.956 22.1249C24.9613 21.3773 24.9613 20.5981 24.9613 19.9124ZM19.4004 21.8235C19.4254 21.3049 19.8005 20.9245 20.3099 20.9008C20.7311 20.8798 21.1707 20.8798 21.605 20.8995C22.1486 20.9232 22.5092 21.297 22.525 21.8498C22.5369 22.2696 22.5342 22.6921 22.5329 23.1015L22.5316 23.1436C22.5316 23.2857 22.5303 23.4279 22.5303 23.57V23.5937C22.5303 23.703 22.5316 23.8517 22.371 23.9359C21.6735 24.3058 20.9759 24.6769 20.2533 25.0639L19.3939 25.5219V22.883C19.3939 22.783 19.3925 22.6829 19.3925 22.5816C19.3899 22.3328 19.3886 22.0775 19.4004 21.8235ZM36.7186 27.1421C35.1247 28.4662 33.444 29.8363 31.7237 31.2143C31.138 31.6829 30.4181 31.8579 29.7232 32.0291L28.2754 32.3831C25.8681 32.9714 23.3779 33.5782 20.9325 34.1889C20.8403 34.2126 20.76 34.2244 20.6903 34.2244C20.4692 34.2244 20.3481 34.1033 20.2428 33.8151C19.4768 31.704 18.6713 29.5836 17.9171 27.6054C17.8052 27.3132 17.8645 27.1645 18.1488 27.0158C19.8321 26.1313 21.5405 25.2218 23.1923 24.3439L23.3253 24.2729C23.8978 23.9675 24.4716 23.6622 25.0455 23.3581C25.2771 23.2357 25.5035 23.1252 25.7457 23.1252C25.897 23.1252 26.0379 23.1673 26.18 23.2541C26.5564 23.4858 26.7183 23.8648 26.6249 24.2965C26.434 25.1744 26.0129 25.8575 25.3377 26.3866C25.1797 26.5103 24.9718 26.6762 24.7651 26.8526C24.3808 27.1842 24.261 27.5541 24.4111 27.9516C24.5546 28.3319 24.8625 28.5294 25.3285 28.5359C25.7812 28.5425 26.2537 28.5412 26.6696 28.5399C26.8605 28.5386 27.0513 28.5386 27.2422 28.5386C27.3962 28.5373 27.5515 28.5373 27.7055 28.5373C28.507 28.5399 29.3336 28.5412 30.1206 28.278C30.6826 28.0898 31.2289 27.8055 31.7922 27.4093L32.4016 26.9789C33.29 26.3511 34.2087 25.7035 35.1155 25.0744C35.4551 24.8388 35.8394 24.7493 36.1974 24.8243C36.5422 24.8954 36.845 25.1139 37.049 25.4416C37.3977 26.0023 37.2661 26.6867 36.7186 27.1421Z", fill: "#141A22" })
] }), zS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M28.3468 14.9442C28.3031 15.1227 28.1894 15.2189 28.0072 15.2313C27.9734 15.2338 27.9385 15.2338 27.9048 15.2338H21.4462C19.9692 15.2338 18.4935 15.2338 17.0165 15.2351C17.0165 15.2351 17.0165 15.2351 17.0152 15.2351C16.9141 15.2351 16.8392 15.2226 16.7743 15.1964C16.6532 15.1477 16.5683 15.0166 16.5683 14.8793C16.567 14.7631 16.6569 14.6445 16.7805 14.5983C16.8654 14.5659 16.9591 14.5621 17.0477 14.5621H17.0489C18.7382 14.5634 20.4287 14.5634 22.1179 14.5634H24.1904C25.4327 14.5634 26.6737 14.5634 27.9148 14.5621C27.9148 14.5621 27.9148 14.5621 27.916 14.5621C28.0346 14.5621 28.1195 14.5796 28.1894 14.6208C28.3031 14.6882 28.3742 14.8331 28.3468 14.9442Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M28.3489 17.9668C28.3102 18.1504 28.1953 18.2515 28.0118 18.2665C27.9793 18.269 27.9431 18.269 27.9044 18.269H21.4745C19.9888 18.269 18.5043 18.269 17.0186 18.2702C17.0186 18.2702 17.0186 18.2702 17.0173 18.2702C16.9075 18.2702 16.8288 18.2565 16.7626 18.2265C16.679 18.1891 16.5804 18.1179 16.5691 17.9081C16.5629 17.8033 16.6465 17.6884 16.7639 17.641C16.8351 17.611 16.9187 17.5985 17.0348 17.5985C17.0361 17.5985 17.0361 17.5985 17.0361 17.5985C18.5131 17.5998 19.9901 17.5998 21.4671 17.5998H23.627C25.054 17.5998 26.4798 17.5998 27.9069 17.5985H27.9081C28.0317 17.5985 28.1141 17.616 28.1853 17.6547C28.3027 17.7196 28.3688 17.8732 28.3489 17.9668Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M28.3205 21.0969C28.2643 21.2192 28.1682 21.2792 28.0009 21.3004C27.9747 21.3029 27.9435 21.3029 27.911 21.3029C27.896 21.3016 27.881 21.3016 27.8661 21.3016H21.4674C19.9842 21.3016 18.501 21.3016 17.0165 21.3029C16.9166 21.3041 16.8404 21.2917 16.7743 21.2642C16.6519 21.2155 16.5683 21.0857 16.5683 20.9483C16.5695 20.8272 16.6569 20.7123 16.7793 20.6662C16.8467 20.6424 16.9141 20.6299 16.9865 20.6299C19.1477 20.6312 21.3101 20.6312 23.4725 20.6312H27.951C28.1495 20.6312 28.2306 20.7086 28.2743 20.7648C28.3605 20.8771 28.3742 20.9795 28.3205 21.0969Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M28.3206 24.132C28.2645 24.2543 28.1683 24.3143 28.001 24.3355C27.9748 24.338 27.9436 24.338 27.9111 24.338C27.8961 24.3367 27.8812 24.3367 27.8662 24.3367H21.4938C20.0018 24.3367 18.5086 24.3367 17.0153 24.338H17.0141C16.913 24.338 16.8381 24.3268 16.7731 24.2993C16.6508 24.2506 16.5671 24.1207 16.5671 23.9834C16.5684 23.8636 16.6558 23.7474 16.7781 23.7012C16.8455 23.6775 16.913 23.665 16.9854 23.665C19.179 23.6663 21.3714 23.6663 23.565 23.6663H27.9511C28.1496 23.6663 28.2307 23.7437 28.2744 23.7999C28.3606 23.9122 28.3743 24.0146 28.3206 24.132Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M21.084 27.3281C21.0154 27.3593 20.9392 27.3718 20.8506 27.3731C20.5122 27.3718 20.1739 27.3718 19.8343 27.3718H18.3548C17.8903 27.3731 17.4271 27.3731 16.9627 27.3706C16.7542 27.3693 16.6331 27.2857 16.5819 27.1034C16.5432 26.9623 16.6106 26.8137 16.7442 26.7513C16.8166 26.7176 16.884 26.7014 16.954 26.7014H17.8005C18.8317 26.7001 19.8618 26.7001 20.893 26.7026C21.0691 26.7026 21.1952 26.785 21.2501 26.9349C21.3063 27.0872 21.2339 27.2595 21.084 27.3281Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M37.3259 21.5238C37.075 21.0232 36.6854 20.761 36.1673 20.7448C35.6479 20.7285 35.2384 20.9545 34.9562 21.4152C34.8214 21.6337 34.6903 21.8597 34.563 22.0794C34.5093 22.1718 34.4556 22.2642 34.4019 22.3554C34.2633 22.5913 34.126 22.8273 33.9861 23.0658L33.6128 23.705L33.4605 23.4353C33.4068 23.3417 33.4118 23.2555 33.4156 23.2044C33.4168 23.1969 33.4168 23.1881 33.4168 23.1806C33.4156 19.927 33.4156 16.6721 33.4156 13.4197V10.9801C33.4156 10.643 33.2907 10.5169 32.9561 10.5169H32.453C31.4304 10.5169 30.4079 10.5157 29.3854 10.5194C29.3841 10.5194 29.3841 10.5194 29.3841 10.5194C29.2305 10.5194 29.1082 10.4683 29.0008 10.3584L28.841 10.1973C28.4727 9.82527 28.0932 9.43948 27.6961 9.08864C27.6275 9.02747 27.55 9 27.4489 9C24.7471 9.00125 22.0441 9.00125 19.3423 9.00125L12.9549 9.0025C12.6553 9.0025 12.5217 9.13609 12.5204 9.43698V9.71165C12.5192 10.07 12.5192 10.442 12.5229 10.8054C12.5254 10.9814 12.4355 11.095 12.2657 11.1312C12.1621 11.1537 12.0585 11.2086 11.9698 11.2598C11.0859 11.7667 10.755 12.8105 11.1982 13.6869C11.4342 14.1539 11.8013 14.471 12.2882 14.632C12.4468 14.6845 12.5254 14.7944 12.5229 14.9592C12.5167 15.2238 12.5167 15.516 12.5217 15.8781C12.5242 16.0978 12.3768 16.1615 12.2882 16.1802C12.1721 16.2052 12.0585 16.2651 11.9611 16.32C11.0884 16.8082 10.7588 17.8457 11.1933 18.7309C11.4217 19.1979 11.7888 19.5187 12.2857 19.6873L12.3007 19.6923C12.3556 19.7098 12.5267 19.7647 12.5229 19.9782C12.5179 20.2953 12.5192 20.6074 12.5217 20.9533C12.5229 21.0919 12.4493 21.1892 12.3157 21.2292C11.8537 21.3678 11.4966 21.6524 11.2544 22.0744C10.9436 22.6138 10.9173 23.1781 11.177 23.75C11.398 24.2369 11.7688 24.569 12.282 24.74C12.453 24.7975 12.5329 24.9148 12.5229 25.0921C12.5154 25.2057 12.5154 25.3293 12.5217 25.4841C12.5292 25.6439 12.443 25.7551 12.2857 25.7888C12.1671 25.815 12.0547 25.8737 11.9611 25.9286C11.0884 26.4343 10.7588 27.4718 11.1945 28.3407C11.433 28.8189 11.7913 29.1298 12.2882 29.2946C12.4468 29.347 12.5267 29.4582 12.5229 29.6217C12.5192 29.829 12.5192 30.04 12.5204 30.246C12.5217 30.3246 12.5217 30.4045 12.5217 30.4832V31.0637C12.5204 31.5519 12.5204 32.0388 12.5229 32.5258C12.5242 32.7904 12.6665 32.9315 12.9337 32.934C12.9599 32.934 12.9861 32.9353 13.0123 32.9353C13.0823 32.9365 13.1497 32.9378 13.2134 32.9328C13.2508 32.9303 13.3632 32.9203 13.4506 33.0014C13.5292 33.0739 13.538 33.1737 13.5355 33.2424C13.5317 33.6232 13.5317 34.0402 13.5342 34.5558C13.5355 34.7818 13.6378 34.9104 13.8463 34.9491C13.8888 34.9566 13.9387 34.9566 13.9924 34.9566H18.1662C20.9279 34.9566 23.6896 34.9579 26.4526 34.9579C26.4663 34.9579 26.4813 34.9554 26.4975 34.9541C26.52 34.9516 26.55 34.9479 26.5837 34.9479C26.6636 34.9479 26.7597 34.9679 26.8159 35.0677C26.9008 35.2188 26.8022 35.3549 26.7547 35.4186C26.746 35.4311 26.736 35.4435 26.7298 35.456C26.7073 35.4935 26.6848 35.5309 26.6624 35.5684C26.5787 35.7057 26.5 35.8343 26.4726 35.9767C26.4414 36.1377 26.4127 36.3 26.3839 36.4611L26.3802 36.4823C26.344 36.6771 26.3215 36.8806 26.2978 37.0778C26.2691 37.3176 26.2404 37.5648 26.1904 37.8095C26.1367 38.0742 26.0743 38.3726 26.0668 38.6622C26.0631 38.7908 26.1167 38.8794 26.2416 38.9531C26.3527 39.018 26.4526 39.0155 26.565 38.9456C26.6286 38.9057 26.6873 38.8657 26.7398 38.8233C27.2504 38.4275 27.7598 38.0305 28.2679 37.6322L28.3503 37.5685C28.6175 37.36 28.871 37.164 29.0258 36.8569C29.2243 36.4598 29.4565 36.0753 29.6813 35.7032C29.7899 35.5234 29.9022 35.3362 30.0084 35.1526C30.0858 35.019 30.1919 34.9566 30.3417 34.9566H30.3442C31.0721 34.9591 31.8 34.9591 32.5291 34.9591H32.9561C33.2845 34.9591 33.4131 34.8318 33.4131 34.5047V33.5333C33.4143 32.2423 33.4143 30.9077 33.4106 29.5955C33.4093 29.4282 33.4518 29.2746 33.5392 29.1273C33.9337 28.4544 34.3282 27.7814 34.7215 27.1085L35.402 25.9461C36.0162 24.8986 36.6305 23.8498 37.246 22.8023C37.5082 22.3591 37.5332 21.9409 37.3259 21.5238ZM12.3806 13.8829C12.3581 13.8917 12.3307 13.8992 12.3007 13.8992C12.247 13.8992 12.1833 13.8767 12.1197 13.8068L12.1134 13.8005C11.6502 13.4247 11.5903 12.8067 11.7726 12.3947C11.8462 12.2287 11.9611 12.0801 12.1346 11.9303C12.2095 11.8603 12.2882 11.8391 12.3681 11.8641C12.4056 11.8766 12.5292 11.929 12.5192 12.1026V13.0377C12.5192 13.2325 12.5192 13.4285 12.5179 13.6232L12.5192 13.6295C12.5354 13.798 12.4393 13.8605 12.3806 13.8829ZM12.3806 18.9407C12.3581 18.9494 12.3307 18.9569 12.3007 18.9569C12.247 18.9569 12.1833 18.9344 12.1197 18.8645L12.1134 18.8583C11.6502 18.4825 11.5903 17.8657 11.7726 17.4524C11.8462 17.2864 11.9611 17.1391 12.1346 16.988C12.2095 16.9181 12.287 16.8969 12.3681 16.9231C12.4056 16.9356 12.5292 16.9867 12.5192 17.1603V18.0954C12.5192 18.2902 12.5192 18.4862 12.5179 18.681L12.5192 18.6872C12.5354 18.8558 12.4393 18.9182 12.3806 18.9407ZM12.3981 23.9909C12.3744 24.0034 12.3394 24.0146 12.2994 24.0146C12.2445 24.0146 12.1796 23.9922 12.1147 23.9173L12.1109 23.9135C11.6515 23.5365 11.5928 22.9247 11.7726 22.5164C11.8475 22.3466 11.9611 22.198 12.1334 22.0495C12.2458 21.9446 12.3456 21.9671 12.3956 21.9908C12.4468 22.0145 12.5304 22.0757 12.5204 22.2243V23.1494C12.5204 23.3442 12.5204 23.5402 12.5192 23.735L12.5204 23.7412C12.5354 23.891 12.4617 23.9597 12.3981 23.9909ZM12.5204 27.729C12.5204 27.9237 12.5204 28.1198 12.5192 28.3145C12.5254 28.4806 12.4205 28.5368 12.3756 28.5542C12.3556 28.5617 12.3307 28.5667 12.3032 28.5667C12.2595 28.5667 12.2058 28.5517 12.1521 28.5043C11.7076 28.1622 11.5566 27.5604 11.7838 27.0423C11.8675 26.8488 12.0035 26.7152 12.1359 26.5978C12.2358 26.5054 12.3257 26.5154 12.3831 26.5379C12.4268 26.5554 12.5292 26.6128 12.5192 26.7726V27.729H12.5204ZM30.147 11.306C30.1707 11.2561 30.2344 11.1724 30.3829 11.1874H31.0596C31.5266 11.1874 31.9923 11.1874 32.4592 11.1849C32.4929 11.1849 32.5953 11.1849 32.6715 11.2611C32.7476 11.3385 32.7464 11.4408 32.7464 11.4746C32.7439 11.7043 32.7439 11.9378 32.7439 12.1625V14.491C32.7439 17.8832 32.7439 21.3928 32.7489 24.8436C32.7489 25.0809 32.6927 25.2869 32.5728 25.4891C32.3793 25.8112 32.1883 26.1434 32.0023 26.463C31.9248 26.5953 31.8487 26.7277 31.7713 26.86C31.7663 26.8687 31.7613 26.8762 31.7538 26.8875L31.569 27.1759L31.4317 26.885C31.3867 26.7876 31.3892 26.7089 31.393 26.6577C31.393 26.649 31.3942 26.6415 31.3942 26.634L31.393 25.3605C31.3917 21.3253 31.3917 17.154 31.3967 13.0514C31.3967 12.8279 31.3318 12.6719 31.1795 12.5271C30.9398 12.2986 30.7025 12.0601 30.4741 11.8291C30.3917 11.7467 30.3093 11.6643 30.2269 11.5819C30.0833 11.4721 30.1282 11.3422 30.147 11.306ZM27.8534 11.0213V10.3921L28.047 10.4096C28.1506 10.4183 28.2055 10.4795 28.2267 10.502C28.7748 11.0513 29.3204 11.5982 29.866 12.145C30.0021 12.2499 29.9709 12.3685 29.9509 12.4147C29.9335 12.4559 29.881 12.542 29.7449 12.542C29.7325 12.542 29.7175 12.5408 29.7025 12.5395L29.695 12.5383C29.3554 12.5395 29.0108 12.5395 28.665 12.5395L28.1319 12.5408C28.0832 12.5408 27.9933 12.542 27.9221 12.4709C27.8747 12.4234 27.8497 12.3585 27.8497 12.2811C27.8534 11.8616 27.8534 11.4421 27.8534 11.0213ZM13.5617 32.2648L13.5242 32.2636C13.5055 32.2623 13.4868 32.2623 13.468 32.2636C13.3632 32.2711 13.2995 32.2311 13.2645 32.1974C13.2283 32.1624 13.1871 32.1 13.1909 31.9951C13.1934 31.9365 13.1921 31.8778 13.1921 31.8203V31.2136C13.1934 30.683 13.1934 30.1523 13.1896 29.6217C13.1884 29.402 13.3257 29.3271 13.4293 29.2909C14.0773 29.0649 14.4719 28.6391 14.6379 27.9924C14.6754 27.8451 14.6179 27.7115 14.4806 27.6266C14.3807 27.5642 14.2222 27.5742 14.1335 27.6466C14.0661 27.7015 14.0186 27.7752 13.9949 27.8626C13.9288 28.0998 13.7989 28.2983 13.5966 28.4693L13.5929 28.4731C13.493 28.5805 13.3944 28.573 13.3307 28.5467C13.272 28.5243 13.1759 28.4606 13.1946 28.292L13.1959 28.2833C13.1946 27.6378 13.1946 26.9886 13.1946 26.3406V25.8212C13.1946 25.7488 13.1946 25.6764 13.1959 25.604C13.1971 25.428 13.1971 25.2457 13.1934 25.0671C13.1871 24.8249 13.3682 24.7612 13.4281 24.74C14.0798 24.5128 14.4781 24.0858 14.6417 23.4353C14.6779 23.2905 14.6179 23.1544 14.4806 23.072C14.3807 23.0121 14.2209 23.0221 14.1335 23.0957C14.0648 23.1532 14.0174 23.2293 13.9912 23.323C13.93 23.5489 13.7977 23.7462 13.5867 23.9272C13.4718 24.0434 13.3657 24.0146 13.3107 23.9872C13.262 23.9622 13.1821 23.8998 13.1934 23.7549V22.655C13.1934 21.7636 13.1934 20.8721 13.1921 19.9807C13.1909 19.8334 13.267 19.7347 13.4169 19.6885C13.945 19.5212 14.3195 19.1804 14.5617 18.646C14.6167 18.5249 14.6441 18.415 14.6466 18.3102C14.6491 18.1616 14.5568 18.0305 14.4219 17.9918C14.2671 17.9481 14.1435 17.9943 14.0549 18.1316C14.0186 18.1866 13.9912 18.254 13.9637 18.3451C13.8913 18.5936 13.714 18.7546 13.5717 18.8845C13.4631 18.9831 13.3632 18.9569 13.3257 18.9407C13.2883 18.9244 13.2009 18.872 13.1959 18.7272C13.1946 18.7047 13.1946 18.6835 13.1946 18.6623V17.8295C13.1946 16.8919 13.1959 15.923 13.1921 14.9704C13.1909 14.7394 13.327 14.662 13.4456 14.6196C14.0886 14.3911 14.4793 13.9653 14.6417 13.3211C14.6779 13.1763 14.6179 13.0402 14.4806 12.9578C14.3807 12.8966 14.2209 12.9079 14.1335 12.9815C14.0648 13.0389 14.0174 13.1151 13.9912 13.21C13.93 13.436 13.7977 13.6332 13.5867 13.813C13.473 13.9291 13.3657 13.9004 13.312 13.873C13.2633 13.848 13.1834 13.7856 13.1946 13.6407V12.5221C13.1946 11.6643 13.1946 10.8054 13.1934 9.94762C13.1934 9.85398 13.2221 9.78157 13.2783 9.73038C13.3332 9.68044 13.4069 9.66046 13.4968 9.67045C13.5018 9.67045 13.508 9.6692 13.5142 9.6692C13.523 9.6692 13.5317 9.66796 13.5392 9.66796H26.8421C27.1068 9.66796 27.1867 9.74786 27.1867 10.01V10.6056C27.1867 11.321 27.1867 12.0351 27.1855 12.7505C27.1855 12.8404 27.1942 12.9116 27.2154 12.974C27.2654 13.1238 27.394 13.2075 27.5775 13.2087C27.9209 13.21 28.2629 13.21 28.6063 13.21H30.4104C30.6464 13.21 30.7263 13.2899 30.7263 13.5271V22.3504C30.7263 24.3792 30.7263 26.408 30.7275 28.4369C30.7275 28.5717 30.6951 28.6928 30.6289 28.8064L30.3942 29.206C29.8598 30.1161 29.3067 31.0575 28.7711 31.9889C28.6587 32.1849 28.5114 32.2686 28.2804 32.2686H28.2792C24.038 32.2648 19.7269 32.2648 15.5556 32.2648H13.5617ZM14.5156 34.2874C14.4981 34.2874 14.4793 34.2874 14.4619 34.2887C14.3682 34.2924 14.3083 34.255 14.2758 34.2237C14.2421 34.1913 14.2022 34.1313 14.2022 34.034C14.2034 33.753 14.2034 33.4734 14.2022 33.1925C14.2009 33.0938 14.2421 33.0339 14.2758 33.0027C14.3095 32.9702 14.3707 32.934 14.4619 32.9378C14.4793 32.939 14.4968 32.939 14.5143 32.9378H27.7548C27.7698 32.939 27.7848 32.939 27.7997 32.9378C27.9308 32.9303 27.9933 32.989 28.022 33.0389C28.052 33.0888 28.0732 33.1725 28.0045 33.2861C27.9221 33.4222 27.841 33.5595 27.761 33.6956L27.6936 33.8092C27.6774 33.8367 27.6612 33.8629 27.6449 33.8904C27.6012 33.9628 27.5613 34.0302 27.5251 34.1001C27.4627 34.2237 27.359 34.2912 27.2292 34.2912C27.2167 34.2912 27.203 34.2899 27.1892 34.2887C27.183 34.2874 27.1755 34.2887 27.1693 34.2887L27.1443 34.2899L14.5156 34.2874ZM27.7061 37.2339C27.6612 37.2676 27.6162 37.3038 27.5713 37.3388C27.4577 37.4287 27.3403 37.5223 27.203 37.6097L26.8871 37.8095L26.947 37.2888C26.9645 37.144 26.9795 37.0092 26.9957 36.8743C27.0119 36.7432 27.0781 36.6858 27.1318 36.6608C27.1842 36.6371 27.2716 36.6221 27.3802 36.6946C27.4402 36.7358 27.5039 36.7732 27.57 36.8132C27.6037 36.8331 27.6374 36.8531 27.6699 36.8743C27.7036 36.8931 27.7898 36.9443 27.796 37.0529C27.7997 37.0928 27.791 37.1702 27.7061 37.2339ZM32.6665 34.2113C32.5978 34.2799 32.5091 34.2899 32.438 34.2899H32.4292C32.0822 34.2862 31.7276 34.2874 31.3855 34.2874C31.2494 34.2887 31.1133 34.2887 30.9785 34.2887C30.8798 34.2887 30.7675 34.2887 30.7063 34.1825C30.6451 34.0777 30.7025 33.979 30.7487 33.9016C31.0409 33.3997 31.3355 32.8978 31.6289 32.3972L32.2257 31.3759C32.2619 31.3135 32.2957 31.2523 32.3331 31.1874L32.5179 30.8577L32.6827 31.0712C32.7526 31.1624 32.7464 31.251 32.7439 31.2935L32.7426 31.3035C32.7439 31.5844 32.7439 31.864 32.7439 32.1437C32.7439 32.7542 32.7439 33.366 32.7464 33.9778C32.7464 34.0427 32.7389 34.1388 32.6665 34.2113ZM35.1048 25.1658C34.965 25.4005 34.8251 25.6377 34.6878 25.8737L34.0111 27.0285C33.4256 28.0274 32.84 29.0262 32.2557 30.025L28.7261 36.0503C28.6737 36.139 28.6213 36.2276 28.5663 36.315C28.5426 36.3537 28.4814 36.4561 28.3379 36.4561H28.3341L28.2967 36.4548L28.2555 36.4374C28.238 36.4299 28.2168 36.4199 28.1968 36.4086L27.9558 36.2676C27.806 36.1802 27.6574 36.0915 27.5076 36.0054C27.4789 35.9879 27.3902 35.938 27.364 35.8331C27.3365 35.7282 27.3877 35.6383 27.4052 35.6096C27.7835 34.9654 28.1606 34.3211 28.5364 33.6769L29.4041 32.1912C30.132 30.9464 30.8611 29.7004 31.5902 28.4544C32.1296 27.5342 32.669 26.614 33.2096 25.6926L33.8064 24.6739C33.8226 24.6464 33.8388 24.6202 33.855 24.5927C33.8813 24.549 33.9087 24.5053 33.9325 24.4616C33.9762 24.3805 34.0348 24.3293 34.1072 24.3105C34.2184 24.2818 34.3108 24.3392 34.342 24.358C34.5917 24.5128 34.7964 24.6339 34.9862 24.7363C35.0199 24.755 35.1198 24.8099 35.151 24.9223C35.1785 25.0234 35.1373 25.1096 35.1048 25.1658ZM35.8751 23.8398C35.824 23.9222 35.7753 24.0096 35.7266 24.0945C35.7103 24.122 35.6641 24.2057 35.563 24.2331C35.543 24.2381 35.5243 24.2406 35.5043 24.2406C35.4556 24.2406 35.4045 24.2256 35.3533 24.1944C35.1398 24.0658 34.9213 23.9385 34.709 23.8161L34.6404 23.7774C34.6141 23.7612 34.533 23.715 34.508 23.6189C34.4968 23.5764 34.493 23.509 34.5392 23.4328L34.6141 23.3042C34.6553 23.2356 34.6953 23.1669 34.7365 23.0982C34.8064 22.9796 34.9163 22.9759 34.9587 22.9796L35.0024 22.9834L35.0499 23.0146C35.0549 23.0171 35.0611 23.0221 35.0661 23.0258L35.2559 23.1407C35.4257 23.2431 35.6017 23.3504 35.7753 23.4503C35.804 23.4678 35.8926 23.519 35.9188 23.6239C35.9376 23.6925 35.9226 23.7649 35.8751 23.8398ZM36.7891 22.1394C36.7866 22.248 36.7304 22.3741 36.6842 22.4602C36.643 22.5351 36.5993 22.6088 36.5556 22.68C36.5331 22.7174 36.5106 22.7536 36.4882 22.7911C36.4719 22.8186 36.4257 22.8985 36.3271 22.9234C36.3084 22.9284 36.2896 22.9309 36.2709 22.9309C36.2235 22.9309 36.1748 22.9159 36.1261 22.8872C35.9201 22.7636 35.6991 22.635 35.4107 22.4715C35.2771 22.3966 35.2359 22.2605 35.3058 22.1244C35.3832 21.9758 35.4669 21.8185 35.578 21.6737C35.764 21.4327 36.0649 21.3478 36.3633 21.4527C36.6155 21.5426 36.7903 21.8235 36.7891 22.1356V22.1394Z", fill: "#141A22" })
] }), qS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M31.6917 3.11086C31.664 3.21547 31.5783 3.31253 31.4434 3.38942C30.4199 3.97553 29.3687 4.55408 28.3515 5.11499L28.0452 5.28389C28.0087 5.3028 27.9469 5.31792 27.894 5.33053C27.8851 5.33305 27.875 5.33431 27.8662 5.33683C27.604 5.29649 27.5536 5.19692 27.5246 5.09734C27.4553 4.86163 27.5637 4.75828 27.6645 4.69399C27.9872 4.49106 28.3313 4.29947 28.6628 4.11418L28.8469 4.01082C29.5527 3.6163 30.2913 3.20665 31.0426 2.79322C31.1422 2.73902 31.2606 2.69238 31.3703 2.69238C31.4749 2.69238 31.572 2.73398 31.6426 2.84868C31.6968 2.93943 31.7144 3.02767 31.6917 3.11086Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M25.5155 0.447463C25.3113 1.25416 25.092 2.03564 24.8449 2.90158C24.8172 2.9999 24.7567 3.10325 24.5197 3.13855C24.4151 3.13602 24.313 3.08813 24.2449 3.00746C24.2033 2.95956 24.1592 2.87889 24.1781 2.77805C24.3231 2.00539 24.5348 1.19618 24.8487 0.229404C24.9004 0.0705857 25.0315 0 25.1562 0C25.189 0 25.2205 0.00504168 25.252 0.0138649C25.4222 0.0655438 25.5684 0.243269 25.5155 0.447463Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M30.8624 9.70555C30.846 9.78622 30.7868 9.86815 30.7074 9.91857C30.667 9.94504 30.5864 9.98412 30.4943 9.96269C29.5654 9.74211 28.7272 9.51648 27.9306 9.27448C27.773 9.22658 27.7175 9.09045 27.768 8.86987C27.7894 8.77786 27.8171 8.65307 28.1335 8.61652L28.6024 8.73752C29.0788 8.86105 29.578 8.98961 30.0784 9.1207L30.1654 9.14339C30.3317 9.18624 30.4893 9.22658 30.6267 9.28834C30.8838 9.40682 30.8926 9.55808 30.8624 9.70555Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M6.18255 19.9657C6.1586 20.0552 6.08676 20.1359 5.9771 20.1976C5.8208 20.2859 5.66954 20.3829 5.52333 20.4762C5.06957 20.7661 4.64101 21.0396 4.15069 21.0106L4.14061 21.0094H4.12422C3.54315 21.0094 3.11711 20.7888 2.78309 20.3161C2.69864 20.1964 2.59024 19.9657 2.82216 19.7691C2.90788 19.696 3.03896 19.5863 3.32761 19.8535C3.93893 20.4207 4.14061 20.4422 4.86663 20.0199C4.93218 19.9821 4.99646 19.9443 5.062 19.9052C5.24981 19.7943 5.42754 19.6884 5.61282 19.5977C5.71996 19.5447 5.98592 19.4502 6.13844 19.7136C6.17373 19.7729 6.20902 19.8661 6.18255 19.9657Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M8.38073 18.6195C8.38199 18.6964 8.3467 18.7771 8.28242 18.8426C8.21183 18.9145 8.11982 18.9561 8.02906 18.9561C8.02906 18.9561 8.02906 18.9561 8.0278 18.9561C7.84756 18.9561 7.67487 18.7897 7.67361 18.6119C7.67235 18.5325 7.71143 18.4481 7.77949 18.3788C7.85008 18.3082 7.94083 18.2653 8.02528 18.2653H8.02654C8.11478 18.2653 8.20175 18.3094 8.26855 18.375C8.33409 18.4418 8.37947 18.53 8.38073 18.6195Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M25.7411 14.7462C25.5029 14.3365 25.2659 13.9269 25.029 13.5172C24.6697 12.8945 24.2992 12.2517 23.9273 11.6227C23.7332 11.2938 23.7408 11.0013 23.9487 10.7001C24.1139 10.4631 24.2765 10.2135 24.4328 9.97279C24.608 9.70557 24.7882 9.42827 24.976 9.16105C25.155 8.90644 25.1676 8.70855 25.0189 8.45393C24.6584 7.83757 24.2752 7.18213 23.9021 6.52039C23.7761 6.29729 23.6236 6.21284 23.374 6.22796C23.19 6.23931 23.0047 6.24813 22.8206 6.25695C22.4148 6.27586 21.995 6.29476 21.5917 6.34266C21.1266 6.39812 20.8178 6.24435 20.5934 5.84478C20.3615 5.43261 20.1157 5.01666 19.8787 4.61457C19.4703 3.92258 19.0468 3.20664 18.6737 2.47431C18.3674 1.87181 17.8506 1.49493 17.2582 1.44073C16.6595 1.38653 16.0671 1.68148 15.631 2.25121C13.8436 4.59188 11.9895 6.94264 10.1971 9.21525C9.38791 10.2413 8.55096 11.3026 7.73166 12.3488C7.54512 12.587 7.32958 12.7735 7.0737 12.921C5.94433 13.5689 4.79731 14.2319 3.68811 14.8722C3.20283 15.152 2.71755 15.4318 2.23228 15.7129C0.782746 16.5486 0.0126046 17.7763 0 18.559C0.00252092 20.3653 0.678128 21.9081 1.85666 22.7942C2.82973 23.5265 4.02591 23.7408 5.22209 23.3954C5.34687 23.3589 5.45653 23.3438 5.55359 23.3438C5.93929 23.3438 6.12206 23.5958 6.26449 23.8429C6.4712 24.2009 6.6754 24.5588 6.88085 24.9181C7.66234 26.2844 8.47155 27.6974 9.31354 29.0562C9.59589 29.5124 10.0585 29.8288 10.6143 29.9486C11.2168 30.0784 11.8508 29.9599 12.3525 29.6234C13.3747 28.9389 13.6432 27.7062 13.0206 26.5567C12.4899 25.5773 11.9252 24.6181 11.3933 23.7282C11.3126 23.5933 11.2118 23.3866 11.2761 23.161C11.3391 22.9391 11.5244 22.8207 11.6605 22.7501C11.987 22.5799 12.3134 22.3883 12.6298 22.203L12.6701 22.1791C13.1491 21.8967 13.1806 21.7833 12.9122 21.3081C12.8743 21.2413 12.8378 21.1758 12.8012 21.1077C12.6954 20.9161 12.5945 20.7346 12.4811 20.5619C12.4206 20.4686 12.258 20.2216 12.3676 19.9657C12.4786 19.7073 12.7722 19.6531 12.897 19.6304C13.6672 19.4867 14.4487 19.3304 15.2062 19.1805C15.6297 19.096 16.0545 19.0103 16.4793 18.9284C17.2191 18.7834 17.959 18.6385 18.6989 18.491C20.5921 18.1166 22.5509 17.7309 24.4832 17.3793C25.1537 17.257 25.6718 16.8978 25.9037 16.3948C26.1319 15.9033 26.0739 15.3159 25.7411 14.7462ZM21.7127 7.26784C21.8665 7.00945 22.2043 7.02583 22.3139 7.03087C22.3694 7.0334 22.4274 7.03339 22.5005 7.03213C22.5282 7.03213 22.5559 7.03214 22.5862 7.03087C22.8988 6.95651 23.4219 6.96533 23.7446 7.69766C23.7609 7.73421 23.7874 7.77707 23.8151 7.8237C23.8265 7.84261 23.8378 7.86152 23.8492 7.88042C24.3685 8.74888 24.3584 8.90392 23.7345 9.727L23.7282 9.73582C23.6689 9.81397 23.5152 10.0156 23.2744 10.0156C23.2643 10.0156 23.2542 10.0156 23.2442 10.0144C22.987 9.99674 22.8585 9.76607 22.803 9.66776C22.5143 9.15097 22.1702 8.54217 21.8047 7.93841C21.7316 7.81614 21.5564 7.52876 21.7127 7.26784ZM5.67333 22.4488C5.18049 22.7299 4.6511 22.7904 4.22506 22.8396L4.2049 22.8421H4.18473C2.64066 22.8295 1.23777 21.7896 0.850811 20.3703C0.414691 18.7733 1.03736 17.2582 2.47428 16.415C3.27216 15.9474 4.08767 15.4785 4.87546 15.0272C5.23973 14.818 5.60275 14.61 5.96576 14.4008C6.05651 14.3478 6.14853 14.2962 6.24054 14.2445C6.4586 14.121 6.68422 13.9924 6.89598 13.8588C7.03211 13.7731 7.24009 13.6659 7.47327 13.7239C7.73545 13.7895 7.8741 14.0315 7.91821 14.1096C8.70348 15.4898 9.54547 16.9457 10.6458 18.83C10.7164 18.9523 10.8059 19.1389 10.7492 19.3481C10.6937 19.5561 10.5274 19.672 10.4064 19.7401C9.5795 20.2115 8.74129 20.693 7.92956 21.1581C7.17958 21.5879 6.42709 22.0203 5.67333 22.4488ZM11.6895 25.6844L12.4344 26.9764C12.5756 27.2209 12.6437 27.4743 12.6311 27.7112C12.6273 28.4045 12.1937 29.0133 11.5761 29.1935C11.4147 29.2402 11.2547 29.2629 11.0996 29.2629C10.5564 29.2629 10.0686 28.9805 9.76731 28.4688C9.37152 27.797 8.97574 27.11 8.59382 26.4457C8.46525 26.2239 8.33921 26.0021 8.21064 25.7802C8.06821 25.5332 7.92704 25.2874 7.78712 25.0403C7.48966 24.5198 7.1821 23.9828 6.87077 23.4597C6.7775 23.3047 6.68044 23.0967 6.74472 22.8723C6.80901 22.6455 7.00312 22.5245 7.14303 22.4526C7.64343 22.1955 8.12241 21.9005 8.56609 21.6207C8.63541 21.5778 8.84339 21.4455 9.08036 21.5047C9.29338 21.5577 9.41186 21.7278 9.48244 21.8526C10.216 23.132 10.9647 24.4303 11.6895 25.6844ZM11.5521 21.9837C11.1147 22.2761 10.9685 22.285 10.9131 22.2875C10.9068 22.2887 10.8992 22.2887 10.8916 22.2887C10.7404 22.2887 10.6257 22.1942 10.5425 22.1098C10.4643 22.0316 9.9526 21.4342 9.97402 21.0938C9.98159 20.969 10.027 20.8317 10.4795 20.5216C10.9206 20.2191 11.0719 20.2165 11.1286 20.2153H11.1349C11.2912 20.2153 11.3971 20.3186 11.4374 20.3577C11.5546 20.4712 12.0538 21.1001 12.0576 21.3976C12.0613 21.5589 11.9832 21.6951 11.5521 21.9837ZM22.8988 16.7251C22.7942 16.957 22.5383 17.0074 22.4412 17.0263C19.8182 17.5393 17.1952 18.0536 14.5722 18.5679L12.1887 19.0355C12.166 19.0393 12.142 19.0431 12.1193 19.0468L12.0853 19.0519C12.05 19.0569 12.016 19.0594 11.9832 19.0594C11.5962 19.0594 11.4299 18.7494 11.3467 18.5931C11.3353 18.5704 11.324 18.549 11.3114 18.5275C10.729 17.5255 10.1417 16.5045 9.5732 15.5176L9.00221 14.5268C8.95809 14.4499 8.91272 14.3731 8.8686 14.2962C8.79297 14.1663 8.71861 14.0378 8.64424 13.9067C8.57491 13.7844 8.51315 13.6848 8.46399 13.6042C8.15392 13.0949 8.16652 12.945 8.55979 12.4597C8.61273 12.3941 8.67575 12.3172 8.7476 12.2252C10.3169 10.2135 11.9202 8.17285 13.4705 6.20023C13.952 5.58765 14.4335 4.9738 14.915 4.36122C15.1154 4.10787 15.2566 3.92384 15.5062 3.94149C15.7545 3.95913 15.873 4.16333 16.0368 4.44693C16.7919 5.75277 17.5456 7.05734 18.3006 8.36318C19.7754 10.9156 21.3005 13.555 22.8043 16.149C22.8711 16.26 23.0047 16.4906 22.8988 16.7251ZM25.3075 15.7986L25.3063 15.8075C25.2508 16.2146 24.9974 16.4957 24.5966 16.6003C24.5223 16.6192 24.4416 16.6331 24.3559 16.6331C24.1189 16.6331 23.8542 16.5322 23.6513 16.178C22.0883 13.4567 20.4926 10.6925 18.9498 8.02034L18.6157 7.44178C17.8658 6.14225 17.1284 4.87171 16.4251 3.66292C16.2801 3.41335 16.1238 3.08689 16.2095 2.77178C16.265 2.56632 16.4087 2.4012 16.6494 2.26633C17.1423 1.98903 17.6389 2.1718 17.9779 2.75539C19.2019 4.8654 20.4548 7.03213 21.7026 9.19382C22.3038 10.2375 22.9051 11.2811 23.5063 12.3248C24.037 13.2475 24.5676 14.1689 25.0996 15.0915L25.1109 15.1117C25.213 15.2881 25.339 15.5062 25.3075 15.7986Z", fill: "#141A22" })
] }), XS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M41.1987 27.8366C41.2028 27.7443 41.1675 27.6846 41.0806 27.633C41.0575 27.6194 41.0304 27.6085 40.9964 27.6085C40.9611 27.6085 40.9177 27.6207 40.862 27.656C40.7547 27.7226 40.6611 27.8135 40.5728 27.9018C40.3732 28.1014 40.1736 28.3009 39.9727 28.5005C39.5328 28.9404 39.0916 29.3803 38.653 29.8216C38.5743 29.9017 38.4942 29.9804 38.4127 30.0578C38.1941 30.271 37.9877 30.4719 37.8045 30.6986C37.7583 30.7557 37.7298 30.8113 37.7162 30.8697C37.704 30.9227 37.7203 30.9607 37.7651 30.9865C37.818 31.0177 37.8791 31.0313 37.9769 31.0313H37.9823C38.0434 31.034 38.1222 30.9892 38.2172 30.8942L39.0535 30.0565C39.6957 29.4143 40.3366 28.7734 40.9774 28.1312C41.0684 28.0389 41.1295 27.9656 41.1743 27.8909C41.196 27.8624 41.1987 27.8475 41.1987 27.8366Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M37.3414 28.2398C37.4107 28.3729 37.4921 28.3946 37.5301 28.4C37.5858 28.396 37.6306 28.3797 37.6808 28.3471C37.7772 28.2846 37.8709 28.2045 37.9877 28.0891C38.114 27.9629 38.2416 27.8366 38.3692 27.7117C38.7032 27.3831 39.0494 27.0423 39.3671 26.692C39.397 26.6595 39.4282 26.6282 39.4581 26.597C39.5409 26.5128 39.6115 26.4409 39.6495 26.3526C39.6848 26.2725 39.6644 26.1911 39.5966 26.13C39.5423 26.0824 39.4961 26.0675 39.4567 26.0675C39.4119 26.0675 39.3807 26.0865 39.3657 26.096C39.2816 26.1476 39.2069 26.2169 39.139 26.2847L38.5267 26.8971C38.1818 27.2419 37.8356 27.5881 37.4908 27.9343C37.4473 27.9791 37.4107 28.0185 37.3808 28.0579C37.302 28.1638 37.3278 28.2127 37.3414 28.2398Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M37.0062 25.8978H37.0198C37.0293 25.8978 37.0605 25.9005 37.1026 25.8611C37.1434 25.8218 37.1854 25.7824 37.2275 25.743C37.2954 25.6792 37.3647 25.6154 37.4312 25.5489C37.5113 25.4688 37.5914 25.3887 37.6729 25.3086C37.9403 25.0438 38.2173 24.7695 38.4671 24.4831C38.5486 24.3894 38.5391 24.3419 38.4834 24.2672C38.4481 24.2197 38.3952 24.1613 38.3368 24.1532C38.3313 24.1518 38.3273 24.1518 38.3218 24.1518C38.2675 24.1518 38.2064 24.1898 38.163 24.2224C38.1413 24.24 38.1195 24.2577 38.0978 24.2767C37.7937 24.551 37.5031 24.8524 37.2221 25.1429C37.0931 25.276 36.9641 25.409 36.8338 25.5407C36.7605 25.6154 36.7442 25.6819 36.7768 25.7715C36.8148 25.8761 36.9234 25.8978 37.0062 25.8978Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M41.0806 27.633C41.0575 27.6194 41.0304 27.6085 40.9964 27.6085C40.9611 27.6085 40.9177 27.6207 40.862 27.656C40.7547 27.7226 40.6611 27.8135 40.5728 27.9018C40.3732 28.1014 40.1736 28.3009 39.9727 28.5005C39.5328 28.9404 39.0916 29.3803 38.653 29.8216C38.5743 29.9017 38.4942 29.9804 38.4127 30.0578C38.1941 30.271 37.9877 30.4719 37.8045 30.6986C37.7583 30.7557 37.7298 30.8113 37.7162 30.8697C37.704 30.9227 37.7203 30.9607 37.7651 30.9865C37.818 31.0177 37.8791 31.0313 37.9769 31.0313H37.9823C38.0434 31.034 38.1222 30.9892 38.2172 30.8942L39.0535 30.0565C39.6957 29.4143 40.3366 28.7734 40.9774 28.1312C41.0684 28.0389 41.1295 27.9656 41.1743 27.8909C41.1919 27.8624 41.1946 27.8475 41.1946 27.8353C41.2028 27.7429 41.1675 27.6846 41.0806 27.633Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M37.681 28.3471C37.7774 28.2846 37.8711 28.2045 37.9878 28.0891C38.1141 27.9629 38.2417 27.8366 38.3693 27.7117C38.7033 27.3831 39.0496 27.0423 39.3673 26.692C39.3971 26.6595 39.4284 26.6282 39.4582 26.597C39.541 26.5128 39.6116 26.4409 39.6497 26.3526C39.685 26.2725 39.6646 26.1911 39.5967 26.13C39.5424 26.0824 39.4962 26.0675 39.4569 26.0675C39.4121 26.0675 39.3808 26.0865 39.3659 26.096C39.2817 26.1476 39.207 26.2169 39.1392 26.2847L38.5268 26.8971C38.182 27.2419 37.8358 27.5881 37.4909 27.9343C37.4475 27.9791 37.4108 28.0185 37.3809 28.0579C37.2995 28.1638 37.3253 28.2127 37.3402 28.2398C37.4095 28.3729 37.4909 28.3946 37.5289 28.4C37.5846 28.396 37.6308 28.3797 37.681 28.3471Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M37.0198 25.8992C37.0293 25.8992 37.0605 25.9019 37.1026 25.8625C37.1434 25.8232 37.1854 25.7838 37.2275 25.7444C37.2954 25.6806 37.3647 25.6168 37.4312 25.5503C37.5113 25.4702 37.5914 25.3901 37.6729 25.31C37.9403 25.0452 38.2173 24.7709 38.4671 24.4845C38.5486 24.3908 38.5391 24.3433 38.4834 24.2686C38.4481 24.2211 38.3952 24.1627 38.3368 24.1546C38.3313 24.1532 38.3273 24.1532 38.3218 24.1532C38.2675 24.1532 38.2064 24.1912 38.163 24.2238C38.1413 24.2414 38.1195 24.2591 38.0978 24.2781C37.7937 24.5524 37.5031 24.8538 37.2221 25.1443C37.0931 25.2774 36.9641 25.4104 36.8338 25.5421C36.7605 25.6168 36.7442 25.6833 36.7768 25.7729C36.8148 25.8748 36.922 25.8965 37.0062 25.8965L37.0198 25.8992Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M22.7965 9.60136V9.59457V9.58779C22.7965 9.57964 22.7965 9.55113 22.7761 9.51583C22.7422 9.4588 22.6933 9.42215 22.6363 9.41128C22.624 9.40857 22.6132 9.40857 22.601 9.40857C22.5548 9.40857 22.5073 9.42622 22.4652 9.4588C22.324 9.56878 22.1977 9.6964 22.0633 9.83217C22.028 9.86883 21.9927 9.90413 21.956 9.93943C21.7823 10.1119 21.6085 10.2843 21.4361 10.4567C20.7939 11.0948 20.1299 11.7533 19.4918 12.4172C19.4348 12.4756 19.3791 12.5408 19.3479 12.6141C19.3289 12.6603 19.314 12.7186 19.3954 12.8205C19.4348 12.8693 19.4782 12.8965 19.5706 12.8734C19.648 12.8544 19.7145 12.7987 19.8027 12.7105C20.2168 12.295 20.6309 11.8809 21.045 11.4668L21.7497 10.7622C22.0633 10.4486 22.3756 10.1363 22.6892 9.82267C22.7693 9.73985 22.7992 9.68011 22.7965 9.60136Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M24.0565 11.5347C24.0877 11.4994 24.1216 11.4655 24.1556 11.4315C24.2194 11.3677 24.2805 11.3066 24.3198 11.2401C24.3497 11.1899 24.3701 11.1261 24.2913 11.0229C24.2479 10.9658 24.1922 10.936 24.1338 10.936C24.1189 10.936 24.1053 10.9373 24.0904 10.9414C24.0307 10.9563 23.9791 10.9971 23.9098 11.0636C23.7971 11.1695 23.6844 11.2822 23.5758 11.3922C23.4876 11.4818 23.3993 11.5714 23.3084 11.6583C23.0599 11.8972 22.8128 12.1457 22.5725 12.386L22.5413 12.4172C22.377 12.5815 22.2154 12.7539 22.0579 12.9304C22.0172 12.9766 21.986 13.035 22.0376 13.1463C22.0715 13.2183 22.1136 13.2576 22.2371 13.259H22.2412C22.286 13.2549 22.3417 13.2495 22.358 13.2305C22.4381 13.1382 22.525 13.0608 22.6092 12.9861C22.6635 12.9372 22.7151 12.8911 22.7639 12.8435C22.8848 12.7227 23.0056 12.6032 23.1278 12.4838C23.4387 12.1783 23.7605 11.8619 24.0565 11.5347Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M24.6649 13.836C24.7341 13.8496 24.8183 13.8197 24.8957 13.7518C25.2093 13.4762 25.5026 13.1843 25.8447 12.8299C25.8691 12.8041 25.8949 12.7783 25.9207 12.7525C26.0293 12.6426 26.1325 12.5394 26.2045 12.4185C26.2683 12.3126 26.2452 12.242 26.2167 12.1918C26.1936 12.1497 26.1542 12.1063 26.0361 12.0832L26.0103 12.0873C25.9357 12.0995 25.8746 12.1497 25.7877 12.2366C25.4306 12.5923 25.0735 12.9494 24.7178 13.3078C24.6594 13.3662 24.6119 13.4165 24.5725 13.468C24.4775 13.5902 24.4924 13.6473 24.5169 13.6989C24.5413 13.7532 24.5875 13.8197 24.6649 13.836Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M26.9579 37.7057C26.9023 37.6174 26.7325 37.5305 26.5832 37.5916C26.5153 37.6188 26.4515 37.6582 26.3877 37.7084C26.3089 37.7709 26.2316 37.8347 26.1542 37.8985C25.9614 38.0573 25.7631 38.2216 25.5432 38.3628C25.2011 38.5828 24.844 38.7294 24.4788 38.7986C24.1298 38.8652 23.7687 38.8421 23.3763 38.7294L23.3044 38.709C23.1455 38.6642 22.9812 38.6181 22.8224 38.5352C22.5956 38.4171 22.5155 38.2325 22.5875 37.9881C22.654 37.7613 22.7205 37.5346 22.7884 37.3079L23.0396 36.4607C23.1509 36.0859 23.2609 35.7112 23.3736 35.3365C23.4781 34.9876 23.5813 34.6386 23.6859 34.2897C23.8053 33.8878 23.9262 33.4873 24.0457 33.0854C24.271 32.3306 24.5005 31.5567 24.7245 30.7936C24.7476 30.7149 24.772 30.6361 24.7965 30.5574C24.8548 30.3728 24.9092 30.1976 24.9458 30.017C24.9974 29.7604 24.9594 29.6667 24.7422 29.5201C24.6756 29.4753 24.6077 29.4305 24.5399 29.3884C24.3172 29.2513 24.0932 29.1155 23.8692 28.9798C23.5026 28.7584 23.1224 28.529 22.7545 28.2928C22.5793 28.1801 22.4762 28.0144 22.4531 27.8121C22.4273 27.5786 22.4368 27.3464 22.449 27.1469C22.4599 26.9785 22.4531 26.8115 22.4463 26.6336C22.4422 26.5345 22.4381 26.4354 22.4381 26.3363C22.4341 25.8842 22.4354 25.4267 22.4368 24.9827C22.4368 24.7804 22.4381 24.5781 22.4381 24.3758V24.3459C22.4381 24.24 22.4381 24.1301 22.4341 24.0255C22.4246 23.7879 22.3621 23.7214 22.1286 23.6956C21.9344 23.6752 21.7539 23.6657 21.5774 23.6671C21.4158 23.6684 21.2637 23.6603 21.1565 23.5544C21.0492 23.4471 21.0397 23.2924 21.0384 23.1294C21.037 22.8348 21.0356 22.5402 21.037 22.2456C21.037 22.1885 21.0316 22.1302 21.0221 22.0691C20.9976 21.9197 20.9284 21.8437 20.7831 21.8084C20.7084 21.7907 20.6256 21.7826 20.5482 21.7812C20.2169 21.7826 19.8857 21.7839 19.5544 21.7826C19.2896 21.7812 19.1213 21.636 19.0833 21.3739C19.0724 21.2993 19.0683 21.2341 19.071 21.1716C19.0778 20.9965 19.0751 20.8159 19.0738 20.6408C19.0724 20.5484 19.071 20.4561 19.071 20.3638C19.071 20.2891 19.0588 20.2104 19.0303 20.1004C19.0059 20.0054 18.9556 19.9538 18.8565 19.9212C18.7153 19.875 18.5578 19.871 18.4207 19.8696C18.0826 19.8669 17.7446 19.8669 17.4052 19.8682C17.1771 19.8682 16.949 19.8682 16.7209 19.8682C16.4412 19.8669 16.3 19.7298 16.2878 19.4473C16.2864 19.4229 16.2864 19.3998 16.2864 19.3754V19.355L16.285 17.9715C16.285 17.8249 16.2851 17.6796 16.2864 17.533C16.2878 17.2044 16.2878 16.865 16.2837 16.5324C16.2796 16.1671 16.1452 16.0925 15.9293 16.0884C15.3672 16.0775 14.7739 16.0775 14.0611 16.087C13.8453 16.0898 13.7489 16.1794 13.719 16.4061C13.6986 16.5622 13.6891 16.7007 13.6878 16.8297C13.6851 17.4271 13.6864 18.0258 13.6864 18.6232V19.3292C13.6864 19.3835 13.6878 19.4406 13.6837 19.5003C13.6701 19.708 13.5316 19.8492 13.3212 19.8669C13.2913 19.8696 13.2601 19.8696 13.2289 19.8696H13.199C12.9668 19.8723 12.7306 19.871 12.5025 19.8696C12.1156 19.8669 11.715 19.8642 11.324 19.8845C11.0742 19.8967 10.9995 19.9796 10.9602 20.1085C10.933 20.1968 10.9194 20.2891 10.9194 20.3814C10.9181 20.5131 10.9181 20.6448 10.9181 20.7765C10.9181 20.9422 10.9167 21.1078 10.9167 21.2721C10.9167 21.3305 10.9099 21.3916 10.8991 21.4527C10.8705 21.6142 10.7606 21.7283 10.5963 21.7636C10.5338 21.7772 10.4741 21.7812 10.4062 21.7826H9.98804C9.79932 21.7826 9.6106 21.7826 9.42188 21.7826C9.35128 21.7826 9.27254 21.7921 9.18836 21.8125C9.08382 21.8383 9.02544 21.8912 8.99285 21.989C8.9657 22.0745 8.95212 22.1532 8.95076 22.2333V22.3637C8.9494 22.6094 8.94805 22.8633 8.93583 23.1159C8.91818 23.4689 8.74846 23.644 8.39954 23.6657C8.36288 23.6684 8.32622 23.6684 8.29092 23.6684C8.26648 23.6684 8.23933 23.6684 8.21489 23.6698L8.19724 23.6712C8.04518 23.6793 7.90262 23.6861 7.76413 23.7146C7.66095 23.7363 7.60936 23.7811 7.58356 23.8707C7.56184 23.9468 7.55097 24.0337 7.55097 24.1409C7.5469 24.608 7.54962 25.0818 7.55097 25.5407C7.55369 26.2616 7.55641 27.0084 7.53875 27.7429C7.53332 27.9927 7.42471 28.1814 7.2197 28.3036L6.7703 28.5738C6.25709 28.882 5.72758 29.1997 5.22252 29.5364C5.05552 29.6477 5.00257 29.7781 5.04738 29.9695C5.07996 30.1094 5.12069 30.2506 5.16007 30.389L5.2361 30.6511C5.37866 31.1412 5.51986 31.63 5.66513 32.1188C5.76288 32.4487 5.862 32.7786 5.96247 33.1072C6.04936 33.3936 6.13625 33.6815 6.22179 33.9693C6.30461 34.2449 6.38471 34.5219 6.46617 34.7975C6.57207 35.1573 6.67797 35.5184 6.78659 35.8782C6.83547 36.0425 6.8857 36.2054 6.93594 36.3697C7.07714 36.834 7.22377 37.3147 7.35547 37.7912C7.37312 37.8523 7.38669 37.9202 7.40027 37.9976C7.41928 38.113 7.37312 38.1863 7.34325 38.2203C7.30659 38.261 7.2387 38.3085 7.1233 38.3031C7.01197 38.2963 6.91014 38.2746 6.83275 38.2542C6.58837 38.1931 6.33312 38.1632 6.05751 38.1632C5.96382 38.1632 5.86743 38.1673 5.76832 38.1741C5.29176 38.208 4.80707 38.3601 4.32372 38.6262C3.92456 38.8461 3.52947 39.1408 3.08007 39.5522C2.98232 39.6418 2.98639 39.8631 3.02712 39.9445C3.09501 40.0844 3.29866 40.1414 3.45344 40.0667C3.55527 40.0165 3.65981 39.9486 3.76978 39.8576C4.14994 39.5467 4.48258 39.3281 4.81521 39.1693C5.60675 38.7932 6.39557 38.7688 7.1586 39.1C7.27265 39.1489 7.38126 39.2059 7.4858 39.2602C7.57134 39.3051 7.6528 39.3471 7.73698 39.3865C8.06962 39.5386 8.45113 39.6404 8.90732 39.6974C9.26711 39.7422 9.58616 39.7368 9.8835 39.6811C10.3302 39.597 10.7456 39.4137 11.0566 39.2643C11.1231 39.2317 11.1882 39.2005 11.2548 39.1679C11.5603 39.0172 11.8752 38.8611 12.2201 38.766C12.7564 38.6181 13.2099 38.5977 13.6498 38.7036C13.9661 38.7796 14.2594 38.9127 14.5037 39.0322C14.5662 39.0634 14.6287 39.0933 14.6911 39.1245C14.9708 39.263 15.2586 39.4069 15.5533 39.5169C16.0067 39.6866 16.4317 39.7735 16.8539 39.783C17.3617 39.7938 17.8885 39.6676 18.4628 39.3987C18.6067 39.3308 18.7506 39.2548 18.8905 39.1815C19.0914 39.0756 19.2978 38.967 19.5137 38.876C20.069 38.6425 20.6365 38.5828 21.2013 38.6968C21.6059 38.7796 21.9765 38.9412 22.3227 39.1C23.0369 39.4286 23.6492 39.5617 24.248 39.5196C24.472 39.5046 24.6661 39.4734 24.8426 39.4245C25.5853 39.2222 26.2682 38.7932 26.9308 38.113C27.0204 38.0125 27.0353 37.8279 26.9579 37.7057ZM21.299 24.331C21.6276 24.331 21.8027 24.5034 21.8041 24.8306C21.8055 25.056 21.8041 25.28 21.8041 25.5054C21.8041 25.8435 21.8027 26.1938 21.8068 26.5373C21.8068 26.5929 21.8095 26.6499 21.8109 26.7056C21.8163 26.8604 21.8217 27.0192 21.8027 27.1835C21.7959 27.2405 21.7797 27.3912 21.652 27.4618C21.6099 27.4849 21.5665 27.4944 21.5258 27.4944C21.4457 27.4944 21.3764 27.4605 21.3425 27.4456C21.1796 27.3682 21.0288 27.2731 20.8836 27.1822C20.8306 27.1482 20.7777 27.1156 20.7234 27.083C19.7282 26.4829 18.9611 26.0173 18.2374 25.5746C18.1125 25.4986 17.9862 25.4226 17.86 25.3479C17.5776 25.1782 17.2843 25.0031 17.0033 24.817C16.9666 24.7926 16.9313 24.7668 16.8947 24.7397L16.6326 24.5523L16.8363 24.3934C16.9232 24.3256 17.0073 24.3296 17.0386 24.331C18.4601 24.331 19.8802 24.331 21.299 24.331ZM14.4141 17.0266C14.4589 16.827 14.6409 16.698 14.8472 16.7184C14.9178 16.7252 14.9912 16.7224 15.0699 16.7184L15.1093 16.717C15.2953 16.7089 15.4066 16.7768 15.4677 16.8351C15.5288 16.8935 15.6035 17.0035 15.6035 17.1895C15.6048 17.4556 15.6048 17.7204 15.6048 17.9865V18.1589V18.5431C15.6048 18.8228 15.6048 19.1025 15.6048 19.3822C15.6048 19.4338 15.6048 19.4908 15.5926 19.5519C15.5546 19.7501 15.4161 19.8642 15.2138 19.8669C15.1473 19.8682 15.0808 19.8682 15.0142 19.8682C14.9518 19.8682 14.8893 19.8682 14.8269 19.8669C14.5472 19.8642 14.4033 19.7216 14.4033 19.4433C14.4019 19.1989 14.4019 18.9559 14.4033 18.7115C14.4033 18.4644 14.4033 18.2159 14.4033 17.9688C14.4033 17.9036 14.4033 17.8371 14.4046 17.7719C14.406 17.5941 14.4074 17.4271 14.3951 17.2574C14.3843 17.1691 14.3992 17.0877 14.4141 17.0266ZM11.6051 20.9408C11.6173 20.7087 11.7653 20.5566 12.0015 20.5335C12.045 20.5294 12.087 20.5294 12.1223 20.5294H12.9207C14.4888 20.5294 16.0583 20.5294 17.6265 20.5308C17.6265 20.5308 17.6265 20.5308 17.6278 20.5308C17.6631 20.5308 17.6984 20.5281 17.7337 20.5254C17.8125 20.5199 17.9034 20.5131 17.9998 20.5294C18.2524 20.5715 18.3868 20.7209 18.399 20.9693C18.4058 21.0874 18.4058 21.2137 18.399 21.3536C18.3908 21.5599 18.2591 21.7106 18.0501 21.7582C17.9727 21.7758 17.898 21.7772 17.8355 21.7772H17.8342H12.1074C12.0667 21.7772 12.0219 21.7772 11.9716 21.769C11.7463 21.7324 11.6159 21.5898 11.6051 21.3658C11.5969 21.2259 11.5969 21.082 11.6051 20.9408ZM8.61134 24.331C10.0532 24.331 11.4937 24.331 12.9356 24.331C12.9763 24.3296 13.0469 24.3283 13.1284 24.3758L13.3524 24.5075L13.1623 24.684C13.0931 24.7492 13.0198 24.7899 12.956 24.8266C12.937 24.8374 12.9166 24.8483 12.8976 24.8605C12.4536 25.1334 12.0164 25.4022 11.5956 25.6561C11.0946 25.9589 10.5936 26.2616 10.0926 26.5644L9.22773 27.0871C9.04716 27.1971 8.86658 27.3071 8.68465 27.4143C8.6317 27.4456 8.54617 27.4958 8.45384 27.4958C8.41447 27.4958 8.37374 27.4863 8.33437 27.4646C8.1986 27.3872 8.1986 27.2229 8.1986 27.1333C8.1986 26.3363 8.1986 25.5393 8.1986 24.7424C8.19995 24.4654 8.33437 24.331 8.61134 24.331ZM14.539 38.0886C14.4236 38.1795 14.277 38.1429 14.2132 38.1279L14.1127 38.1035C13.8683 38.0437 13.6375 37.9854 13.3972 37.9569C12.9967 37.9093 12.5867 37.9378 12.1441 38.0451C11.6784 38.1592 11.2059 38.3547 10.6981 38.6425C10.3818 38.8231 10.0817 38.9385 9.78167 38.9982C9.61739 39.0308 9.44904 39.0471 9.27661 39.0471C9.12319 39.0471 8.96705 39.0335 8.80956 39.0077C8.55703 38.9656 8.37917 38.8095 8.29228 38.5556C8.16873 38.1917 8.06147 37.8184 7.95693 37.4586C7.92027 37.3323 7.88361 37.2074 7.84695 37.0811C7.76821 36.815 7.6881 36.5489 7.60935 36.2828C7.4668 35.8063 7.32017 35.3148 7.17896 34.8287C7.05406 34.3983 6.92236 33.9611 6.79474 33.5389C6.65625 33.08 6.51369 32.6062 6.37928 32.1378C6.23536 31.6341 6.09281 31.1426 5.93803 30.6592C5.91223 30.5791 5.89187 30.4977 5.87286 30.4203C5.86471 30.389 5.85792 30.3578 5.84978 30.3279C5.80769 30.1664 5.85249 30.013 5.97604 29.8962C6.05072 29.8242 6.13489 29.774 6.20957 29.7292L7.28758 29.0775C8.13886 28.5629 8.99014 28.0484 9.84141 27.5338C10.5759 27.0898 11.3091 26.6459 12.0436 26.2005L12.8867 25.69C13.2805 25.4511 13.6742 25.2135 14.0666 24.9745C14.0842 24.9637 14.1019 24.9515 14.1195 24.9392C14.1453 24.9202 14.1711 24.9026 14.1996 24.8863C14.3015 24.8252 14.4128 24.8198 14.5037 24.87C14.5947 24.9202 14.649 25.0166 14.6517 25.1347C14.6545 25.2352 14.6531 25.337 14.6531 25.4375C14.6531 25.485 14.6517 25.5326 14.6517 25.5814V31.296L14.6531 31.4901V37.7817C14.6545 37.8442 14.6545 37.9976 14.539 38.0886ZM14.2526 23.6657C13.0306 23.6657 11.8087 23.6657 10.5854 23.6657H10.5841C10.4307 23.6657 10.2664 23.6739 10.0804 23.6915C10.0614 23.6929 10.0424 23.6942 10.0247 23.6942C9.82376 23.6942 9.69207 23.5815 9.64862 23.3738C9.59703 23.1267 9.6011 22.9013 9.6622 22.6882C9.7165 22.4954 9.83327 22.4126 10.0261 22.4166C10.1048 22.418 10.1822 22.418 10.2609 22.418H10.3709C12.4523 22.418 14.5336 22.4166 16.615 22.4166H19.7377C19.8246 22.4166 19.902 22.4221 19.9739 22.4329C20.1898 22.4655 20.3337 22.6149 20.3486 22.8226C20.3595 22.9719 20.3677 23.1688 20.331 23.3697C20.2984 23.5449 20.1789 23.6521 20.0011 23.6644C19.9766 23.6657 19.9508 23.6657 19.925 23.6657H19.9128H14.2526ZM22.1612 37.0268C22.1367 37.111 22.1164 37.1979 22.0946 37.2889C22.0784 37.3622 22.0607 37.4341 22.0417 37.5075C21.9453 37.8632 21.7484 38.0098 21.3818 37.9989C21.3072 37.9962 21.2339 37.9881 21.1605 37.9745C20.7016 37.8863 20.2224 37.9229 19.6915 38.0858C19.3127 38.2026 18.9285 38.3655 18.5171 38.5855C18.1546 38.7783 17.8423 38.9249 17.4948 39.005C17.2979 39.0512 17.097 39.0742 16.8947 39.0742C16.6177 39.0742 16.3353 39.0308 16.0529 38.9439L16.0284 38.9371C15.8981 38.8977 15.7515 38.8529 15.6171 38.7606C15.4745 38.6629 15.3863 38.5271 15.3537 38.3587C15.3333 38.246 15.3116 38.0967 15.336 37.9365V25.6113C15.3374 25.462 15.3374 25.3208 15.3238 25.1809C15.3048 24.9827 15.4243 24.8958 15.4772 24.8686C15.5845 24.8116 15.7094 24.8211 15.8194 24.8958C16.1004 25.0886 16.4005 25.2678 16.691 25.4402C16.8186 25.5163 16.9462 25.5909 17.0725 25.6683C17.4825 25.9181 17.8926 26.168 18.3039 26.4164L19.4173 27.0912C20.0744 27.489 20.7315 27.8882 21.3886 28.286C21.9657 28.6349 22.544 28.9838 23.1224 29.3314L23.7999 29.7387C24.1095 29.9247 24.1909 30.1352 24.0945 30.4909C23.899 31.2077 23.6818 31.93 23.47 32.6279C23.3519 33.0189 23.2338 33.4099 23.1197 33.8009C22.9323 34.4404 22.7382 35.088 22.5508 35.7153C22.4218 36.1525 22.2902 36.5897 22.1612 37.0268Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M21.9453 30.5452C22.001 30.476 22.0132 30.404 21.986 30.3117C21.9494 30.1882 21.872 30.0918 21.7389 30.0103C20.942 29.5188 20.1463 29.0273 19.3494 28.5372C19.2923 28.5019 19.2353 28.4652 19.1783 28.4286C19.0385 28.339 18.9068 28.2548 18.7669 28.1869C18.7113 28.1598 18.6529 28.1462 18.5986 28.1462C18.5402 28.1462 18.4859 28.1611 18.437 28.1923C18.3406 28.2534 18.2849 28.3648 18.2849 28.4992V28.5073C18.2822 28.5711 18.2958 28.654 18.4261 28.7381C18.7099 28.9214 18.9665 29.0844 19.2109 29.2378C19.8653 29.6478 20.536 30.0551 21.1836 30.4502L21.4877 30.6348C21.5516 30.6729 21.7471 30.7923 21.9453 30.5452Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M17.3005 27.4795C17.2978 27.3804 17.2557 27.2827 17.1865 27.2188C17.1308 27.1673 17.0643 27.1428 16.9882 27.1455C16.8063 27.1523 16.6841 27.2799 16.6855 27.4619C16.6855 27.5623 16.7235 27.656 16.7887 27.7198C16.8253 27.7565 16.8878 27.7999 16.976 27.7986C17.0629 27.7972 17.1498 27.7579 17.215 27.6913C17.272 27.6289 17.3032 27.5542 17.3005 27.4795Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M11.8073 28.1638C11.772 28.1462 11.7272 28.1299 11.6715 28.1299C11.6104 28.1299 11.533 28.1489 11.4353 28.2046C11.1678 28.358 10.9519 28.487 10.7551 28.6092C10.5894 28.7137 10.4252 28.8196 10.2609 28.9255C10.0179 29.0816 9.76804 29.2432 9.5155 29.3966C9.24532 29.5609 8.9765 29.7401 8.71582 29.9125C8.63707 29.9641 8.55968 30.0171 8.48094 30.0687C8.27185 30.2058 8.28679 30.3497 8.29086 30.3972C8.30172 30.5126 8.36553 30.6077 8.466 30.6606C8.57055 30.7149 8.69138 30.7136 8.79864 30.6538C8.89504 30.6009 8.99007 30.5412 9.08104 30.4828L9.43947 30.2574C9.95811 29.9302 10.4781 29.603 10.9954 29.2731C11.0714 29.2242 11.1475 29.1767 11.2235 29.1305C11.4312 29.0015 11.6444 28.8685 11.8399 28.7218C11.9322 28.6526 11.9729 28.5671 11.9729 28.4449C11.9675 28.3064 11.9173 28.2195 11.8073 28.1638Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M13.6036 27.4307C13.6036 27.3587 13.5683 27.2827 13.5059 27.2216C13.438 27.1537 13.3484 27.117 13.2628 27.1143C13.0972 27.1157 12.9519 27.2569 12.9533 27.4184C12.9546 27.5977 13.0999 27.7429 13.2778 27.7429H13.2791C13.4448 27.7416 13.6036 27.5909 13.6036 27.4307Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M43.2842 7.82277C43.086 7.31227 42.6759 7.0258 42.1301 7.01358H42.122C42.1016 7.01358 42.0731 7.01222 42.0392 7.00679L42.0039 7L41.9577 7.00815C41.9007 7.01901 41.8464 7.02715 41.7921 7.03666C41.6848 7.05431 41.583 7.07196 41.4879 7.0964C41.0643 7.20637 40.6502 7.38287 40.2579 7.62183C39.4528 8.11196 38.6829 8.72292 37.9036 9.49002C37.6226 9.76699 37.351 10.0426 37.0971 10.3114C36.8908 10.53 36.6396 10.5952 36.3504 10.5042C36.0056 10.397 35.6512 10.2924 35.3091 10.192L34.9316 10.0806C34.8637 10.0603 34.7958 10.0412 34.728 10.0209C34.4931 9.95299 34.25 9.88239 34.0125 9.79414C33.7558 9.69775 33.6757 9.53211 33.7586 9.27279C33.8088 9.11665 33.8278 8.96866 33.8183 8.82067C33.7911 8.42423 33.5984 8.1554 33.2304 7.99927C32.8842 7.85263 32.5407 7.90694 32.2108 8.16083C32.0818 8.25994 31.965 8.37399 31.8361 8.50297C31.8089 8.53013 31.7831 8.55728 31.756 8.58308C31.6867 8.65368 31.6148 8.72564 31.5401 8.79488C31.3609 8.95916 31.0703 8.97545 30.8775 8.83018C30.6807 8.68219 30.735 8.51519 30.7676 8.44866C30.8382 8.30475 30.8531 8.13775 30.8164 7.90423C30.7662 7.58653 30.587 7.33671 30.3114 7.19958C30.029 7.05974 29.6923 7.06788 29.4099 7.2213C29.1763 7.34757 28.993 7.53765 28.7772 7.77253C28.6916 7.86621 28.431 8.15133 28.0114 8.00741C27.9843 7.99791 27.9517 7.98976 27.9164 7.98162C27.8838 7.97347 27.8499 7.96532 27.8173 7.95582L26.8139 7.65441C26.1989 7.46976 25.5839 7.28512 24.9688 7.10183C24.7462 7.0353 24.5832 7.07332 24.4393 7.22538C24.2954 7.37744 24.1447 7.52543 23.9994 7.66935C23.941 7.72773 23.8813 7.78611 23.8229 7.84449C23.7578 7.90966 23.698 7.98433 23.641 8.07258C23.5704 8.1812 23.5799 8.22057 23.6478 8.30068C23.7578 8.43237 23.899 8.53827 24.0497 8.6496L24.1135 8.69712C24.4095 8.91843 24.7136 9.13973 25.0082 9.35425C25.1508 9.45743 25.2933 9.56062 25.4345 9.66516L26.5465 10.4784C27.0271 10.8301 27.5077 11.1831 27.9897 11.5347C28.3074 11.7669 28.6265 11.999 28.9442 12.2312C29.4465 12.5978 29.9502 12.9644 30.4512 13.3323C30.5938 13.4369 30.7363 13.5428 30.8789 13.6473C31.2672 13.9338 31.6704 14.2311 32.0696 14.5149C32.094 14.5325 32.1185 14.5488 32.1429 14.5665C32.2488 14.6398 32.3574 14.7158 32.4579 14.8122C32.6113 14.9629 32.6222 15.1448 32.4864 15.3132C32.3194 15.5196 32.1415 15.7205 31.9691 15.9146C31.8877 16.007 31.8048 16.0993 31.7234 16.193C31.5428 16.4007 31.3609 16.6071 31.1803 16.8148C30.9916 17.0293 30.8042 17.2438 30.6168 17.4597C30.2489 17.8833 29.881 18.3096 29.5239 18.7264C29.2524 19.0428 28.9822 19.3605 28.7106 19.6782C28.5111 19.9117 28.3115 20.1466 28.1119 20.3801C28.0562 20.4453 28.0019 20.5091 27.9476 20.5743C27.8051 20.7453 27.6571 20.9205 27.4982 21.0861C27.3706 21.2192 27.2145 21.2762 27.0339 21.2599C26.8886 21.2463 26.7596 21.1961 26.6469 21.1527L26.2383 20.9952C25.7305 20.7997 25.2037 20.596 24.6891 20.3923C24.6131 20.3625 24.5452 20.3462 24.4814 20.3462C24.366 20.3462 24.2669 20.3964 24.1637 20.5023C24.1216 20.5458 24.0809 20.5892 24.0402 20.6327C23.9601 20.7182 23.8759 20.8078 23.7849 20.892L23.7754 20.9001C23.5717 21.0888 23.379 21.2667 23.2228 21.4785C23.1427 21.5871 23.14 21.6536 23.2133 21.765C23.2826 21.8695 23.3708 21.9741 23.4998 22.103C24.9294 23.5354 26.3618 24.9678 27.7928 26.3988L28.4065 27.0125C28.4812 27.0872 28.5694 27.1523 28.6862 27.2202C28.7568 27.2609 28.8111 27.2596 28.8817 27.2161C28.9482 27.1754 29.0107 27.1265 29.0664 27.0695C29.1492 26.9853 29.232 26.8998 29.3148 26.8156C29.4927 26.6323 29.6773 26.4422 29.8674 26.2617C30.0561 26.0811 30.0873 25.9141 29.9842 25.6453C29.7167 24.9529 29.4452 24.2455 29.179 23.5436C29.0894 23.3073 29.1397 23.0833 29.3216 22.9149C29.4153 22.8281 29.513 22.7439 29.6081 22.6638C29.6461 22.6312 29.6855 22.5986 29.7235 22.566C30.033 22.2999 30.3412 22.0338 30.6494 21.7677L31.3717 21.1445C31.6297 20.9218 31.8877 20.7005 32.1443 20.4779C32.5448 20.1317 32.9467 19.7841 33.3472 19.4365L33.8251 19.0224C34.06 18.8188 34.2949 18.6138 34.5297 18.4101L34.5732 18.3721C34.7497 18.22 34.9316 18.0612 35.1149 17.9105C35.2778 17.7761 35.4557 17.7883 35.605 17.9458C35.6661 18.0096 35.7137 18.0775 35.7598 18.1426C35.7761 18.1644 35.791 18.1874 35.8073 18.2092C35.8426 18.2567 35.8766 18.3056 35.9119 18.3544C36.0178 18.5024 36.1169 18.6436 36.2391 18.7617C36.3382 18.8581 36.4522 18.8011 36.497 18.7726C36.5907 18.7129 36.5839 18.6219 36.5622 18.5567C36.5296 18.4563 36.478 18.3558 36.4047 18.2513C36.2975 18.0965 36.1793 17.9431 36.0639 17.7951L35.9947 17.7068C35.8467 17.5154 35.8481 17.3362 35.9947 17.1407C36.0218 17.104 36.0531 17.0701 36.0857 17.0402C36.1658 16.9669 36.2472 16.8949 36.3273 16.8216C36.4156 16.7415 36.5038 16.6627 36.5921 16.5826L36.8147 16.379C37.1718 16.0545 37.5275 15.73 37.8833 15.4042C38.0652 15.2372 38.2458 15.0702 38.425 14.9018C38.5635 14.7728 38.7019 14.6438 38.8418 14.5162C38.9287 14.4361 39.0034 14.3723 39.0767 14.3153C39.1581 14.2528 39.2423 14.2297 39.3251 14.2474C39.4093 14.265 39.4772 14.3207 39.5261 14.4144C39.5736 14.5026 39.6007 14.595 39.6252 14.6764L39.7257 15.0159C39.7895 15.2304 39.8533 15.4449 39.9171 15.6594L40.285 16.8895C40.4167 17.3307 40.5498 17.772 40.6815 18.2132C40.8267 18.7006 40.972 19.1894 41.1173 19.6768L41.6821 21.5668C41.7948 21.9415 41.9061 22.3162 42.0174 22.6909C42.2347 23.42 42.4506 24.1505 42.6651 24.8795C42.7139 25.0452 42.7574 25.2108 42.794 25.3737C42.8511 25.6222 42.7438 25.8367 42.4736 26.0078C42.3474 26.0879 42.1641 26.1381 42.0025 25.9168C41.5246 25.2611 41.0467 24.6066 40.5688 23.9509L40.08 23.2815C39.3156 22.2347 38.5526 21.1893 37.7869 20.1439L37.7665 20.1167C37.6633 19.9755 37.5655 19.8411 37.4366 19.7529C37.3225 19.6741 37.2967 19.6795 37.1908 19.7488C37.1433 19.78 37.0944 19.8248 37.1324 19.9592C37.1582 20.0516 37.2221 20.1385 37.2832 20.224C37.9104 21.0861 38.539 21.9469 39.169 22.8077C39.9062 23.8151 40.6448 24.8225 41.3834 25.8286L41.7459 26.3228C41.8355 26.445 41.9265 26.5712 42.0215 26.6907C42.1627 26.8713 42.2713 26.8007 42.3121 26.7749C42.4288 26.7002 42.5429 26.6038 42.6515 26.4898L42.6841 26.4545C42.8036 26.3282 42.9285 26.1965 43.0642 26.077C43.3018 25.8679 43.3697 25.6711 43.2883 25.4145C43.1715 25.0479 43.0615 24.6745 42.9556 24.312C42.9149 24.1749 42.8755 24.0391 42.8348 23.902C42.7343 23.5626 42.6338 23.2231 42.5347 22.8837L42.3895 22.3909C42.2808 22.0229 42.4424 21.7962 42.5985 21.6699C42.7588 21.5396 42.8891 21.3794 43.0276 21.2083L43.0507 21.1798C43.2597 20.9232 43.3358 20.672 43.291 20.3896C43.2448 20.095 43.0669 19.8398 42.8049 19.6904C42.5429 19.5411 42.2333 19.5166 41.9563 19.6252C41.7581 19.7026 41.6115 19.6456 41.5192 19.4542C41.4893 19.3917 41.4771 19.332 41.4703 19.2858C41.435 19.0414 41.5966 18.8853 41.6577 18.8269C41.8667 18.6246 42.0609 18.402 42.2428 18.1902C42.403 18.0028 42.4831 17.7801 42.4804 17.5276C42.4777 17.2466 42.3664 17.009 42.1519 16.8202C41.9373 16.6315 41.6997 16.5541 41.4241 16.584C41.363 16.5908 41.2979 16.6098 41.23 16.6288C41.1675 16.6465 41.1037 16.6655 41.0331 16.6777C40.8512 16.7103 40.71 16.6369 40.634 16.4713C40.6027 16.4021 40.5742 16.3274 40.5525 16.2514C40.4792 16.0015 40.4059 15.7531 40.3325 15.5033C40.19 15.0145 40.042 14.5094 39.8926 14.0152C39.8139 13.7546 39.8723 13.5305 40.0637 13.35C40.19 13.2305 40.304 13.1232 40.4154 13.0132C40.7752 12.6589 41.0888 12.3303 41.3739 12.0113C41.9903 11.3216 42.4791 10.6522 42.8701 9.96386C43.0995 9.5579 43.3371 9.06778 43.3561 8.50161C43.3575 8.46224 43.3656 8.42694 43.3806 8.39436C43.3751 8.37263 43.3711 8.34684 43.3697 8.31833C43.367 8.11331 43.3371 7.95989 43.2842 7.82277ZM41.9238 20.2172C42.0107 20.0964 42.1627 20.023 42.3338 20.0217H42.3365C42.5076 20.0217 42.6651 20.1127 42.7587 20.2634C42.8511 20.4127 42.8619 20.5933 42.7873 20.744C42.7112 20.8974 42.6135 21.0332 42.4981 21.1459C42.4234 21.2192 42.3474 21.2355 42.2944 21.2355C42.2903 21.2355 42.2863 21.2355 42.2836 21.2355C42.2292 21.2328 42.1505 21.2124 42.0772 21.1269C42.0283 21.0698 41.9903 21.0047 41.9631 20.9341C41.9373 20.8648 41.9224 20.7997 41.9075 20.7358C41.898 20.6924 41.8885 20.6503 41.8762 20.6136C41.826 20.4684 41.8437 20.3285 41.9238 20.2172ZM41.4241 17.0728C41.6753 17.0212 41.9468 17.1841 42.0161 17.4285C42.046 17.5344 42.0337 17.6457 41.9794 17.7489C41.883 17.9335 41.7568 18.0978 41.6047 18.235C41.5477 18.2866 41.4812 18.3123 41.4146 18.3123C41.3454 18.3123 41.2761 18.2852 41.2178 18.2295C41.1132 18.1318 41.0494 18.0014 41.0209 17.8317C41.0114 17.772 41.006 17.7136 41.0005 17.6579C40.9978 17.6349 40.9965 17.6118 40.9937 17.5887V17.586C40.9571 17.1692 41.3087 17.0958 41.4241 17.0728ZM32.2094 8.75686C32.3384 8.63195 32.4823 8.53963 32.6181 8.45545C32.7756 8.35906 32.9684 8.35906 33.1218 8.4541C33.2752 8.54913 33.358 8.71477 33.3472 8.90078C33.3526 9.01075 33.3214 9.12208 33.2549 9.23206C33.1802 9.35561 33.0661 9.42485 32.9399 9.42485C32.9358 9.42485 32.9317 9.42485 32.9277 9.42485C32.7376 9.41806 32.4783 9.40856 32.2502 9.24835C32.2013 9.21305 32.0981 9.14109 32.0872 9.01347C32.0777 8.88584 32.1701 8.79488 32.2094 8.75686ZM29.342 7.8377C29.4397 7.74945 29.5483 7.67613 29.6651 7.61775C29.8375 7.53086 30.0235 7.55123 30.1756 7.6707C30.3195 7.78475 30.3888 7.95446 30.3711 8.14997C30.3684 8.18527 30.3589 8.21514 30.3521 8.23415L30.3494 8.24365C30.2869 8.45681 30.1634 8.54506 29.9285 8.54506C29.9231 8.54506 29.9176 8.54506 29.9122 8.54506H29.9041C29.8036 8.53963 29.6882 8.52334 29.5877 8.50161C29.5266 8.48804 29.4655 8.46496 29.4112 8.43509C29.361 8.40793 29.2076 8.3224 29.1885 8.15676C29.1723 7.99112 29.2999 7.87572 29.342 7.8377ZM31.9121 13.8482C31.8293 13.7871 31.7465 13.726 31.6636 13.6649C30.6236 12.9033 29.5836 12.1416 28.545 11.3799L27.1221 10.3372C26.3129 9.74391 25.5038 9.15059 24.6932 8.55728C24.6362 8.51519 24.5764 8.47718 24.5126 8.43509L24.4868 8.4188C24.3348 8.31968 24.29 8.15269 24.3742 7.99519C24.4122 7.92324 24.4597 7.83498 24.5371 7.76031C24.7041 7.60146 24.8833 7.5553 25.0869 7.6164C26.5315 8.0495 28.0006 8.48668 29.4207 8.90892L35.3036 10.6576C35.5127 10.7201 35.7218 10.7812 35.9295 10.845C35.9879 10.8627 36.144 10.9102 36.1861 11.0609C36.2269 11.2102 36.1196 11.3297 36.0789 11.3745C35.8861 11.5877 35.6906 11.8008 35.4964 12.0126L33.8672 13.7994C33.6852 13.9989 33.502 14.1972 33.3187 14.3954C33.2128 14.5108 33.096 14.5339 33.0173 14.5312C33.0132 14.5312 33.0078 14.5312 33.0037 14.5312C32.8788 14.5312 32.7878 14.4701 32.7254 14.428L32.7104 14.4185C32.4375 14.2365 32.1714 14.0383 31.9121 13.8482ZM25.4997 23.291C25.497 23.291 25.4956 23.291 25.4929 23.291C25.3639 23.291 25.2716 23.2001 25.1901 23.1186C24.7896 22.7208 24.3918 22.3216 23.994 21.9225C23.7998 21.727 23.7958 21.5491 23.9845 21.3454C24.0049 21.3237 24.0239 21.302 24.0429 21.2803C24.1135 21.2002 24.1936 21.1092 24.2981 21.0372C24.3728 20.9857 24.4841 20.9069 24.6484 20.9151L24.662 20.9164C24.8086 20.9341 24.9403 20.9857 25.0693 21.0359C25.0978 21.0468 25.1277 21.059 25.1575 21.0698C25.4685 21.1852 25.778 21.302 26.0889 21.4188L26.4541 21.5559C26.4732 21.5627 26.4922 21.5695 26.5112 21.579C26.5886 21.6129 26.6945 21.674 26.727 21.7989C26.7623 21.9388 26.6741 22.0555 26.6442 22.0949C26.374 22.4506 26.0916 22.7914 25.8025 23.1064C25.7223 23.1906 25.6327 23.2883 25.4997 23.291ZM29.399 25.3887C29.4058 25.4063 29.4139 25.4253 29.4207 25.443C29.4574 25.5339 29.5035 25.648 29.4995 25.7851C29.5076 25.91 29.4696 26.0227 29.3908 26.1042C29.3555 26.1408 29.3216 26.1802 29.2863 26.2182C29.1981 26.316 29.1071 26.4165 28.9985 26.5074C28.936 26.559 28.8668 26.5848 28.7975 26.5848C28.7269 26.5848 28.655 26.5577 28.5898 26.5033C28.4486 26.3852 28.321 26.2535 28.1974 26.1286C28.1418 26.0716 28.0861 26.0146 28.0304 25.9589C27.858 25.7892 27.6869 25.6181 27.5159 25.4471L27.2946 25.2257C27.2728 25.204 27.2511 25.1823 27.2307 25.1606C27.2009 25.1266 27.1113 25.0235 27.1208 24.8863C27.1316 24.7492 27.2362 24.6609 27.2701 24.6324C27.3326 24.5795 27.3977 24.5279 27.4616 24.4763C27.5227 24.4274 27.5838 24.3785 27.6435 24.327C27.7888 24.2061 27.9327 24.0839 28.0766 23.9617L28.2775 23.7907C28.2925 23.7784 28.3074 23.7649 28.3223 23.754C28.359 23.7255 28.469 23.64 28.6034 23.6753C28.6916 23.6983 28.7595 23.7635 28.8057 23.8721C28.8817 24.0473 28.9482 24.2197 29.0216 24.4125C29.1505 24.7343 29.2754 25.0615 29.399 25.3887ZM42.7262 9.31216C42.5198 9.75884 42.2469 10.2069 41.8654 10.7228C41.435 11.3039 41.0508 11.7574 40.6557 12.147L40.524 12.276C40.1099 12.686 39.6808 13.1083 39.2477 13.5142C39.0943 13.6582 38.9423 13.8034 38.7902 13.9487C38.6857 14.0492 38.5825 14.1483 38.4766 14.2488C37.9511 14.747 37.4176 15.2412 36.8908 15.7178L36.5663 16.0124C36.2622 16.288 35.9472 16.5745 35.6349 16.8528C35.0769 17.3484 34.5216 17.8372 34.0029 18.2906C33.5834 18.6586 33.149 19.036 32.6751 19.4447C32.3194 19.7515 31.9623 20.057 31.6053 20.3611L31.3717 20.5607C30.8952 20.968 30.4173 21.3753 29.9394 21.7826C29.733 21.9578 29.5266 22.1316 29.3202 22.3067C29.1614 22.4398 29.0039 22.5742 28.8451 22.7086C28.3074 23.1648 27.7698 23.6196 27.2321 24.0771C27.1601 24.1382 27.0882 24.202 27.0176 24.2659L26.9293 24.3446C26.8479 24.4166 26.7664 24.4532 26.6822 24.4532C26.6116 24.4532 26.5397 24.4274 26.4664 24.3758C26.3034 24.2618 26.1202 24.1138 25.9993 23.8884C25.9056 23.7133 25.9844 23.5843 26.0414 23.5232C26.2491 23.2951 26.4514 23.0534 26.6469 22.8186C26.7338 22.7154 26.8207 22.6108 26.9076 22.5076C27.1018 22.2782 27.2959 22.0487 27.4887 21.8179C27.6489 21.6278 27.8091 21.4364 27.9693 21.2463C28.4988 20.6204 29.0283 19.9959 29.5592 19.3727L29.5972 19.3279C30.0276 18.8228 30.4716 18.3001 30.9128 17.7896C31.3595 17.2737 31.8415 16.7198 32.4307 16.0504C32.8978 15.5182 33.4802 14.8556 34.0478 14.2297C34.4578 13.7776 34.8977 13.2984 35.3932 12.7607C35.5494 12.5924 35.7096 12.4254 35.8657 12.2638C36.0585 12.0642 36.2567 11.8578 36.4455 11.6501C36.7591 11.3025 37.0904 10.9672 37.4121 10.6413C37.5778 10.473 37.7434 10.306 37.9077 10.1363C38.463 9.56062 38.9871 9.08271 39.5084 8.67812C40.0447 8.2613 40.5796 7.93817 41.1417 7.69107C41.4459 7.55666 41.7296 7.48741 42.0093 7.47927H42.0107C42.1152 7.47655 42.2211 7.49013 42.3229 7.51864C42.7194 7.62997 42.9461 7.9436 42.9434 8.38214C42.942 8.68762 42.8687 9.00261 42.7262 9.31216Z", fill: "#141A22" })
] }), JS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M38.258 35.2232L38.106 35.0699C35.7244 32.6833 33.2605 30.2156 30.8257 27.8023C30.4533 27.4337 30.4089 27.0853 30.6775 26.6356C32.4649 23.6422 32.8387 20.4334 31.7885 17.1005C30.2607 12.26 25.6382 8.93597 20.5495 9.01198L20.5368 9.01324L20.5241 9.01198C19.5006 8.94864 18.3212 9.13739 17.1165 9.55796C13.1704 10.9362 10.6001 13.6155 9.47771 17.5223C8.49721 20.9325 9.02799 24.1894 11.0523 27.2044C14.4993 32.3349 21.359 33.8449 26.6694 30.6425C26.8607 30.5272 27.0329 30.4689 27.1976 30.4689C27.4193 30.4689 27.6233 30.5741 27.8361 30.7882C30.0365 33.0076 32.2851 35.2523 34.4589 37.4224L35.2012 38.1634C35.3773 38.3395 35.542 38.4827 35.7029 38.6018C36.5972 39.2618 37.8843 39.0831 38.5709 38.2014C39.2904 37.2792 39.1701 36.1378 38.258 35.2232ZM20.7243 31.6838H20.7129C17.6891 31.6293 14.8945 30.4626 12.8423 28.399C10.799 26.343 9.67786 23.5877 9.68419 20.6411C9.69179 17.654 10.8332 14.8772 12.9006 12.8225C14.9591 10.7754 17.7144 9.64917 20.6622 9.64917H20.7015C23.6949 9.65931 26.4743 10.8032 28.5278 12.8719C30.585 14.9456 31.7112 17.7288 31.6973 20.707C31.6846 23.6739 30.5331 26.4342 28.4568 28.4801C26.4084 30.4955 23.6633 31.6344 20.7243 31.6838ZM29.9377 31.7345C29.716 31.7345 29.5425 31.5964 29.436 31.4836C29.0611 31.0821 28.657 30.6906 28.301 30.3448C28.2453 30.2903 28.073 30.1231 28.0818 29.8862C28.0907 29.6481 28.2706 29.4973 28.3301 29.4479C28.7418 29.1033 29.1333 28.7119 29.4943 28.2837C29.5425 28.2254 29.6894 28.0532 29.9212 28.0443C30.1505 28.0367 30.3101 28.1963 30.3608 28.2482C30.637 28.5295 30.922 28.8145 31.1969 29.0881C31.3185 29.2097 31.4414 29.3314 31.563 29.4517C31.6441 29.5328 31.7885 29.6772 31.7923 29.9293L31.7948 30.0319L31.7378 30.1168C31.7264 30.1332 31.7163 30.151 31.7049 30.1687C31.6694 30.2244 31.6263 30.2941 31.5693 30.3613C31.1868 30.8034 30.7776 31.1923 30.4267 31.5128C30.2468 31.6749 30.0821 31.7345 29.9377 31.7345ZM38.3961 36.9309C38.3302 37.5199 38.0667 37.9392 37.6119 38.1761C37.3852 38.2952 37.1546 38.3535 36.9253 38.3535C36.6365 38.3535 36.3515 38.2597 36.0766 38.0748C35.9499 37.9886 35.8448 37.8835 35.7523 37.791L35.7333 37.772C35.281 37.321 34.8301 36.8688 34.3791 36.4165C33.2567 35.2929 32.0963 34.1312 30.9461 32.9975C30.7978 32.8505 30.6294 32.6504 30.6458 32.3894C30.6623 32.1322 30.8523 31.9612 30.9929 31.8535C31.3134 31.6116 31.6162 31.3076 31.9456 30.8984C32.0444 30.7742 32.204 30.6083 32.4409 30.5956C32.6803 30.5829 32.8564 30.7324 32.9679 30.8464C34.5045 32.397 36.0766 33.9653 37.5967 35.4816L37.8868 35.7705C38.1858 36.0694 38.353 36.4254 38.3973 36.8612L38.4011 36.8954L38.3961 36.9309Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M20.6939 11.3986H20.6914C15.5887 11.3986 11.4362 15.5474 11.4349 20.6488C11.4336 25.7527 15.5836 29.9065 20.685 29.9077H20.6876C25.7902 29.9077 29.9428 25.759 29.944 20.6576C29.944 15.5537 25.794 11.3999 20.6939 11.3986ZM26.7023 26.8687C25.115 28.4015 22.9564 29.2718 20.7572 29.2718C20.7066 29.2718 20.6546 29.2705 20.6039 29.2705C18.1578 29.2249 15.9345 28.2508 14.3447 26.5254C12.8575 24.914 12.029 22.7377 12.0683 20.5575C12.1126 18.1329 13.0893 15.9185 14.821 14.3224C16.5388 12.7389 18.8342 11.9142 21.1221 12.0561C23.3491 12.1511 25.4241 13.0949 26.9633 14.7164C28.5125 16.3467 29.3448 18.4813 29.3081 20.7273C29.2676 23.1051 28.3428 25.2865 26.7023 26.8687Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M26.9304 18.594C26.848 18.6282 26.6555 18.7105 26.4604 18.271C25.6813 16.5165 24.3753 15.3193 22.5751 14.7138C22.0963 14.5529 21.6073 14.4947 21.1361 14.4376C21.036 14.4262 20.9372 14.4136 20.8358 14.4009C20.6129 14.3718 20.3507 14.2907 20.3735 14.0639C20.3811 13.9816 20.4013 13.789 20.8662 13.7878H21.1006C23.5772 13.8397 26.1298 15.65 27.0393 17.9986C27.2243 18.4711 27.0026 18.5636 26.9304 18.594Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M27.5497 20.6475C27.5522 20.8147 27.4154 20.9655 27.2596 20.968C27.1899 20.9693 27.1177 20.9389 27.0607 20.8831C26.9987 20.8223 26.9619 20.7413 26.9606 20.6577C26.9581 20.4904 27.0949 20.3397 27.2507 20.3372H27.2558C27.3242 20.3372 27.3926 20.3663 27.4496 20.4208C27.513 20.4816 27.5484 20.5639 27.5497 20.6475Z", fill: "#141A22" })
] }), eP = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M25.0696 24.2991V19.5497C25.5154 19.5625 25.9797 19.6396 26.4628 19.7819C26.9906 19.9374 27.4714 20.1757 27.9055 20.4967L27.9972 20.5645L28.0524 20.4648L28.2902 20.0361L28.3326 19.9597L28.2624 19.9075C27.8397 19.5926 27.3273 19.3446 26.7272 19.162C26.184 18.984 25.6314 18.8877 25.0696 18.8734V17.1298V17.0298H24.9696H24.5576H24.4576V17.1298V18.8851C23.7762 18.9263 23.1971 19.0616 22.7233 19.2942C22.1499 19.5653 21.7214 19.9264 21.4451 20.3802C21.1717 20.8295 21.0343 21.3131 21.0343 21.8294C21.0343 22.425 21.1587 22.922 21.4152 23.3131L21.4152 23.3132L21.4171 23.3159C21.6805 23.6897 22.0259 23.9859 22.4516 24.2046L22.4516 24.2046L22.4543 24.2059C22.8827 24.4098 23.3478 24.5811 23.8494 24.72L23.8494 24.7201L23.8518 24.7207C24.0554 24.7717 24.2574 24.8218 24.4576 24.8711V29.6283C23.8239 29.5963 23.226 29.4637 22.6632 29.2312C22.0177 28.9495 21.5241 28.613 21.1772 28.2246L21.0958 28.1335L21.0226 28.2313L20.7373 28.6123L20.6893 28.6764L20.7414 28.7373C21.1348 29.1971 21.699 29.5756 22.4275 29.8761L22.4291 29.8767C23.0732 30.1293 23.7496 30.2719 24.4576 30.3049V32.054V32.154L26.9665 29.8154M25.0696 24.2991C25.3566 24.3716 25.6435 24.4476 25.9305 24.5271C26.433 24.6557 26.8939 24.8274 27.3129 25.0426C27.7487 25.261 28.0947 25.5572 28.348 25.9317C28.6168 26.3027 28.7465 26.7852 28.7465 27.3704C28.7465 27.8871 28.6035 28.3711 28.3194 28.8203C28.0424 29.2749 27.6025 29.6357 27.0083 29.9063M25.0696 24.2991V24.4023C25.0363 24.3938 25.003 24.3854 24.9696 24.3771M27.0083 29.9063C27.0082 29.9063 27.0081 29.9064 27.008 29.9064L26.9665 29.8154M27.0083 29.9063C27.0084 29.9062 27.0085 29.9062 27.0086 29.9061L26.9665 29.8154M27.0083 29.9063C26.485 30.1489 25.8376 30.2813 25.0696 30.3075V30.2074C25.8271 30.1813 26.4594 30.0506 26.9665 29.8154", fill: "#141A22", stroke: "black", strokeWidth: "0.2" }),
  /* @__PURE__ */ f.jsx("path", { d: "M24.1203 35.824C30.1895 35.824 35.1076 30.849 35.1076 24.7143C35.1076 18.5797 30.1895 13.6047 24.1203 13.6047C18.0511 13.6047 13.1329 18.5797 13.1329 24.7143C13.1329 30.849 18.0511 35.824 24.1203 35.824ZM34.57 24.7143C34.57 30.5521 29.8905 35.2826 24.1203 35.2826C18.3501 35.2826 13.6705 30.5521 13.6705 24.7143C13.6705 18.8766 18.3501 14.146 24.1203 14.146C29.8905 14.146 34.57 18.8766 34.57 24.7143Z", fill: "#141A22", stroke: "black", strokeWidth: "0.2" }),
  /* @__PURE__ */ f.jsxs("mask", { id: "path-3-outside-1_961_14670", maskUnits: "userSpaceOnUse", x: "-0.449754", y: "-0.0832603", width: "49.4975", height: "49.4975", fill: "black", children: [
    /* @__PURE__ */ f.jsx("rect", { fill: "white", x: "-0.449754", y: "-0.0832603", width: "49.4975", height: "49.4975" }),
    /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6082 12.5084C14.9227 10.2135 17.8619 8.65017 21.0597 8.01409C24.2805 7.37343 27.619 7.70224 30.653 8.95895C33.687 10.2157 36.2801 12.3438 38.1046 15.0743C39.9291 17.8048 40.9029 21.015 40.9029 24.299C40.9029 27.5829 39.9291 30.7931 38.1046 33.5236C36.2801 36.2541 33.687 38.3823 30.653 39.639C27.619 40.8957 24.2805 41.2245 21.0597 40.5839C17.8619 39.9478 14.9227 38.3844 12.6082 36.0895C12.5998 36.0812 12.5914 36.0729 12.5831 36.0645C12.583 36.0645 12.583 36.0645 12.583 36.0644C12.5692 36.0509 12.5471 36.0509 12.5334 36.0645C12.5197 36.0782 12.5197 36.1005 12.5334 36.1141C12.5335 36.1142 12.5335 36.1142 12.5335 36.1142C12.5419 36.1226 12.5504 36.131 12.5588 36.1393C14.8831 38.444 17.8347 40.0139 21.046 40.6527C24.2805 41.2961 27.6331 40.9659 30.6799 39.7038C33.7266 38.4418 36.3308 36.3046 38.163 33.5626C39.9951 30.8206 40.973 27.5968 40.973 24.299C40.973 21.0012 39.9951 17.7774 38.163 15.0353C36.3308 12.2933 33.7266 10.1561 30.6799 8.89412C27.6331 7.6321 24.2805 7.3019 21.046 7.94527C17.8347 8.58404 14.8831 10.154 12.5588 12.4586C12.5504 12.467 12.5419 12.4753 12.5335 12.4837C12.5335 12.4837 12.5335 12.4838 12.5334 12.4838C12.5197 12.4975 12.5197 12.5197 12.5334 12.5334C12.5471 12.5471 12.5692 12.5471 12.583 12.5335C12.583 12.5335 12.583 12.5335 12.5831 12.5334C12.5914 12.5251 12.5998 12.5168 12.6082 12.5084ZM12.5935 36.0539C12.5935 36.0539 12.5935 36.0539 12.5936 36.054C12.5935 36.0539 12.5935 36.0539 12.5935 36.0539ZM12.5936 12.544C12.5935 12.544 12.5935 12.5441 12.5935 12.5441L12.5936 12.544ZM12.4734 12.4235C14.8134 10.0933 17.79 8.5062 21.0294 7.86183C24.2804 7.21518 27.6501 7.54706 30.7124 8.81553C33.7747 10.084 36.3922 12.2321 38.2337 14.9881C40.0752 17.7441 41.0581 20.9843 41.0581 24.299C41.0581 27.6136 40.0752 30.8538 38.2337 33.6099C36.3922 36.3659 33.7747 38.514 30.7124 39.7824C27.6501 41.0509 24.2804 41.3828 21.0294 40.7361C17.79 40.0918 14.8134 38.5046 12.4734 36.1744C12.4263 36.1275 12.4263 36.0513 12.4732 36.0044C12.5202 35.9574 12.5962 35.9576 12.6431 36.0042C14.9495 38.301 17.8834 39.8653 21.0763 40.5004C24.2806 41.1378 27.602 40.8107 30.6204 39.5604C33.6389 38.3101 36.2188 36.1929 38.0339 33.4764C39.849 30.7598 40.8178 27.5661 40.8178 24.299C40.8178 21.0319 39.849 17.8381 38.0339 15.1216C36.2188 12.4051 33.6389 10.2878 30.6204 9.03755C27.602 7.78728 24.2806 7.46015 21.0763 8.09753C17.8834 8.73264 14.9495 10.297 12.6431 12.5937C12.5962 12.6404 12.5202 12.6406 12.4732 12.5936C12.4263 12.5466 12.4263 12.4704 12.4734 12.4235Z" })
  ] }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6082 12.5084C14.9227 10.2135 17.8619 8.65017 21.0597 8.01409C24.2805 7.37343 27.619 7.70224 30.653 8.95895C33.687 10.2157 36.2801 12.3438 38.1046 15.0743C39.9291 17.8048 40.9029 21.015 40.9029 24.299C40.9029 27.5829 39.9291 30.7931 38.1046 33.5236C36.2801 36.2541 33.687 38.3823 30.653 39.639C27.619 40.8957 24.2805 41.2245 21.0597 40.5839C17.8619 39.9478 14.9227 38.3844 12.6082 36.0895C12.5998 36.0812 12.5914 36.0729 12.5831 36.0645C12.583 36.0645 12.583 36.0645 12.583 36.0644C12.5692 36.0509 12.5471 36.0509 12.5334 36.0645C12.5197 36.0782 12.5197 36.1005 12.5334 36.1141C12.5335 36.1142 12.5335 36.1142 12.5335 36.1142C12.5419 36.1226 12.5504 36.131 12.5588 36.1393C14.8831 38.444 17.8347 40.0139 21.046 40.6527C24.2805 41.2961 27.6331 40.9659 30.6799 39.7038C33.7266 38.4418 36.3308 36.3046 38.163 33.5626C39.9951 30.8206 40.973 27.5968 40.973 24.299C40.973 21.0012 39.9951 17.7774 38.163 15.0353C36.3308 12.2933 33.7266 10.1561 30.6799 8.89412C27.6331 7.6321 24.2805 7.3019 21.046 7.94527C17.8347 8.58404 14.8831 10.154 12.5588 12.4586C12.5504 12.467 12.5419 12.4753 12.5335 12.4837C12.5335 12.4837 12.5335 12.4838 12.5334 12.4838C12.5197 12.4975 12.5197 12.5197 12.5334 12.5334C12.5471 12.5471 12.5692 12.5471 12.583 12.5335C12.583 12.5335 12.583 12.5335 12.5831 12.5334C12.5914 12.5251 12.5998 12.5168 12.6082 12.5084ZM12.5935 36.0539C12.5935 36.0539 12.5935 36.0539 12.5936 36.054C12.5935 36.0539 12.5935 36.0539 12.5935 36.0539ZM12.5936 12.544C12.5935 12.544 12.5935 12.5441 12.5935 12.5441L12.5936 12.544ZM12.4734 12.4235C14.8134 10.0933 17.79 8.5062 21.0294 7.86183C24.2804 7.21518 27.6501 7.54706 30.7124 8.81553C33.7747 10.084 36.3922 12.2321 38.2337 14.9881C40.0752 17.7441 41.0581 20.9843 41.0581 24.299C41.0581 27.6136 40.0752 30.8538 38.2337 33.6099C36.3922 36.3659 33.7747 38.514 30.7124 39.7824C27.6501 41.0509 24.2804 41.3828 21.0294 40.7361C17.79 40.0918 14.8134 38.5046 12.4734 36.1744C12.4263 36.1275 12.4263 36.0513 12.4732 36.0044C12.5202 35.9574 12.5962 35.9576 12.6431 36.0042C14.9495 38.301 17.8834 39.8653 21.0763 40.5004C24.2806 41.1378 27.602 40.8107 30.6204 39.5604C33.6389 38.3101 36.2188 36.1929 38.0339 33.4764C39.849 30.7598 40.8178 27.5661 40.8178 24.299C40.8178 21.0319 39.849 17.8381 38.0339 15.1216C36.2188 12.4051 33.6389 10.2878 30.6204 9.03755C27.602 7.78728 24.2806 7.46015 21.0763 8.09753C17.8834 8.73264 14.9495 10.297 12.6431 12.5937C12.5962 12.6404 12.5202 12.6406 12.4732 12.5936C12.4263 12.5466 12.4263 12.4704 12.4734 12.4235Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M12.6642 12.6148L12.6643 12.6147L12.5229 12.4733L12.5228 12.4734L12.6642 12.6148ZM21.0597 8.01409L21.0987 8.21025L21.0597 8.01409ZM12.6082 12.5084L12.4674 12.3664L12.4674 12.3664L12.6082 12.5084ZM30.653 8.95895L30.7295 8.77418L30.653 8.95895ZM38.1046 15.0743L37.9383 15.1854L38.1046 15.0743ZM40.9029 24.299L41.1029 24.299L40.9029 24.299ZM38.1046 33.5236L38.2709 33.6347L38.2709 33.6347L38.1046 33.5236ZM30.653 39.639L30.5765 39.4542L30.653 39.639ZM21.0597 40.5839L21.0987 40.3877L21.0597 40.5839ZM12.6082 36.0895L12.749 35.9475L12.6082 36.0895ZM12.5831 36.0645L12.7242 35.9228L12.7242 35.9228L12.5831 36.0645ZM12.583 36.0644L12.4424 36.2067L12.4424 36.2067L12.583 36.0644ZM12.5334 36.1141L12.3923 36.2559L12.3923 36.2559L12.5334 36.1141ZM12.5335 36.1142L12.6747 35.9725L12.6747 35.9725L12.5335 36.1142ZM12.5588 36.1393L12.418 36.2814L12.5588 36.1393ZM21.046 40.6527L21.085 40.4565L21.046 40.6527ZM30.6799 39.7038L30.6033 39.5191L30.6799 39.7038ZM38.163 33.5626L38.3293 33.6737L38.3293 33.6737L38.163 33.5626ZM40.973 24.299L40.773 24.299L40.973 24.299ZM30.6799 8.89412L30.6033 9.0789L30.6799 8.89412ZM21.046 7.94527L21.007 7.74911L21.046 7.94527ZM12.5588 12.4586L12.418 12.3166L12.418 12.3166L12.5588 12.4586ZM12.5335 12.4837L12.3924 12.342L12.3921 12.3423L12.5335 12.4837ZM12.5334 12.4838L12.6746 12.6255L12.6749 12.6252L12.5334 12.4838ZM12.583 12.5335L12.7235 12.6758L12.7244 12.675L12.583 12.5335ZM12.5831 12.5334L12.4419 12.3917L12.4416 12.392L12.5831 12.5334ZM12.5936 36.054L12.4524 36.1957L12.7351 35.9127L12.5936 36.054ZM21.0294 7.86183L21.0684 8.05799L21.0294 7.86183ZM12.4734 12.4235L12.6145 12.5653L12.4734 12.4235ZM30.7124 8.81553L30.7889 8.63075L30.7124 8.81553ZM38.2337 14.9881L38.4 14.877L38.2337 14.9881ZM41.0581 24.299L41.2581 24.299L41.0581 24.299ZM38.2337 33.6099L38.0674 33.4988L38.2337 33.6099ZM30.7124 39.7824L30.7889 39.9672L30.7124 39.7824ZM21.0294 40.7361L20.9904 40.9323L21.0294 40.7361ZM12.4734 36.1744L12.6145 36.0327L12.4734 36.1744ZM12.6431 36.0042L12.502 36.146L12.6431 36.0042ZM21.0763 40.5004L21.0373 40.6966L21.0763 40.5004ZM30.6204 39.5604L30.697 39.7452L30.6204 39.5604ZM38.0339 33.4764L38.2002 33.5875L38.0339 33.4764ZM40.8178 24.299L41.0178 24.299L40.8178 24.299ZM38.0339 15.1216L38.2002 15.0105L38.0339 15.1216ZM30.6204 9.03755L30.697 8.85277L30.697 8.85277L30.6204 9.03755ZM21.0763 8.09753L21.1153 8.29369L21.0763 8.09753ZM12.6431 12.5937L12.7842 12.7354L12.6431 12.5937ZM21.0207 7.81794C17.7844 8.46168 14.8098 10.0439 12.4674 12.3664L12.749 12.6505C15.0356 10.3832 17.9394 8.83867 21.0987 8.21025L21.0207 7.81794ZM30.7295 8.77418C27.659 7.50233 24.2803 7.16956 21.0207 7.81794L21.0987 8.21025C24.2808 7.5773 27.579 7.90216 30.5765 9.14373L30.7295 8.77418ZM38.2709 14.9632C36.4245 12.1998 33.8001 10.046 30.7295 8.77418L30.5765 9.14373C33.5739 10.3853 36.1358 12.4878 37.9383 15.1854L38.2709 14.9632ZM41.1029 24.299C41.1029 20.9755 40.1173 17.7266 38.2709 14.9632L37.9383 15.1854C39.7408 17.8831 40.7029 21.0546 40.7029 24.299L41.1029 24.299ZM38.2709 33.6347C40.1173 30.8713 41.1029 27.6225 41.1029 24.299L40.7029 24.299C40.7029 27.5434 39.7408 30.7149 37.9383 33.4125L38.2709 33.6347ZM30.7295 39.8238C33.8001 38.5519 36.4245 36.3981 38.2709 33.6347L37.9383 33.4125C36.1358 36.1101 33.5739 38.2127 30.5765 39.4542L30.7295 39.8238ZM21.0207 40.78C24.2803 41.4284 27.659 41.0956 30.7295 39.8238L30.5765 39.4542C27.579 40.6958 24.2808 41.0207 21.0987 40.3877L21.0207 40.78ZM12.4674 36.2315C14.8098 38.5541 17.7844 40.1363 21.0207 40.78L21.0987 40.3877C17.9394 39.7593 15.0356 38.2148 12.749 35.9475L12.4674 36.2315ZM12.4419 36.2062C12.4504 36.2147 12.4589 36.2231 12.4674 36.2315L12.749 35.9475C12.7407 35.9393 12.7325 35.931 12.7242 35.9228L12.4419 36.2062ZM12.4424 36.2067L12.4419 36.2063L12.7242 35.9228C12.724 35.9226 12.7237 35.9224 12.7235 35.9221L12.4424 36.2067ZM12.6748 36.206C12.6104 36.2704 12.5066 36.2701 12.4424 36.2067L12.7235 35.9221C12.6318 35.8316 12.4837 35.8313 12.392 35.9231L12.6748 36.206ZM12.6746 35.9724C12.7393 36.0369 12.7393 36.1415 12.6748 36.206L12.392 35.9231C12.3001 36.015 12.3001 36.1641 12.3923 36.2559L12.6746 35.9724ZM12.6747 35.9725C12.6746 35.9725 12.6746 35.9725 12.6746 35.9724L12.3923 36.2559C12.3923 36.2559 12.3924 36.2559 12.3924 36.256L12.6747 35.9725ZM12.6996 35.9973C12.6913 35.9891 12.683 35.9808 12.6747 35.9725L12.3924 36.256C12.4009 36.2644 12.4094 36.2729 12.418 36.2814L12.6996 35.9973ZM21.085 40.4565C17.9122 39.8254 14.996 38.2743 12.6996 35.9973L12.418 36.2814C14.7701 38.6136 17.7572 40.2024 21.007 40.8488L21.085 40.4565ZM30.6033 39.5191C27.5931 40.7659 24.2807 41.0922 21.085 40.4565L21.007 40.8488C24.2802 41.4999 27.6731 41.1658 30.7564 39.8886L30.6033 39.5191ZM37.9967 33.4515C36.1865 36.1606 33.6136 38.2722 30.6033 39.5191L30.7564 39.8886C33.8397 38.6114 36.4751 36.4487 38.3293 33.6737L37.9967 33.4515ZM40.773 24.299C40.773 27.5572 39.8069 30.7423 37.9967 33.4515L38.3293 33.6737C40.1834 30.8988 41.173 27.6364 41.173 24.299L40.773 24.299ZM37.9967 15.1465C39.8069 17.8556 40.773 21.0407 40.773 24.299L41.173 24.299C41.173 20.9616 40.1834 17.6992 38.3292 14.9242L37.9967 15.1465ZM30.6033 9.0789C33.6136 10.3258 36.1865 12.4373 37.9967 15.1465L38.3292 14.9242C36.4751 12.1493 33.8397 9.98651 30.7564 8.70935L30.6033 9.0789ZM21.085 8.14143C24.2807 7.50577 27.5931 7.83201 30.6033 9.0789L30.7564 8.70935C27.6731 7.43219 24.2802 7.09802 21.007 7.74911L21.085 8.14143ZM12.6996 12.6006C14.996 10.3237 17.9122 8.77253 21.085 8.14143L21.007 7.74911C17.7572 8.39554 14.7701 9.98434 12.418 12.3166L12.6996 12.6006ZM12.6747 12.6254C12.683 12.6172 12.6913 12.6089 12.6996 12.6006L12.418 12.3166C12.4094 12.3251 12.4009 12.3335 12.3924 12.342L12.6747 12.6254ZM12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6251 12.6749 12.6251 12.6749 12.6251C12.6749 12.6251 12.6749 12.6251 12.6749 12.6251L12.6749 12.6251C12.6749 12.6251 12.6749 12.6251 12.6749 12.6251C12.6749 12.6251 12.6749 12.6251 12.6749 12.6251C12.6749 12.6251 12.6749 12.6251 12.6749 12.6251C12.6749 12.6251 12.6749 12.6251 12.675 12.6251L12.675 12.6251C12.675 12.6251 12.675 12.6251 12.675 12.6251C12.675 12.6251 12.675 12.6251 12.675 12.6251C12.675 12.6251 12.675 12.6251 12.675 12.6251C12.675 12.6251 12.675 12.6251 12.675 12.6251L12.675 12.6251C12.675 12.6251 12.675 12.6251 12.675 12.6251L12.675 12.6251L12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3424C12.3921 12.3424 12.3921 12.3424 12.3921 12.3424C12.3921 12.3424 12.3921 12.3424 12.3921 12.3424L12.3921 12.3424C12.3921 12.3424 12.3921 12.3424 12.3921 12.3424C12.3921 12.3424 12.3921 12.3424 12.3921 12.3424C12.3921 12.3424 12.3921 12.3424 12.3921 12.3424C12.3921 12.3424 12.3921 12.3424 12.3921 12.3424L12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424L12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424L12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424L12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424L12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424L12.6749 12.6252ZM12.6748 12.392C12.7393 12.4565 12.7393 12.5611 12.6746 12.6255L12.3923 12.3421C12.3001 12.4339 12.3001 12.583 12.392 12.6748L12.6748 12.392ZM12.4424 12.3912C12.5066 12.3279 12.6104 12.3276 12.6748 12.392L12.392 12.6748C12.4837 12.7666 12.6318 12.7664 12.7235 12.6758L12.4424 12.3912ZM12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921L12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921L12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921L12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921L12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921L12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921L12.4415 12.3921L12.7244 12.675L12.7244 12.675C12.7244 12.675 12.7244 12.675 12.7244 12.675L12.7244 12.675C12.7244 12.675 12.7244 12.675 12.7244 12.675C12.7244 12.675 12.7244 12.675 12.7244 12.675L12.7244 12.675C12.7244 12.675 12.7244 12.675 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749L12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749L12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749L12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749L12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749L12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749L12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749L12.7245 12.6749L12.4416 12.392ZM12.4674 12.3664C12.4589 12.3749 12.4504 12.3833 12.4419 12.3917L12.7242 12.6752C12.7325 12.6669 12.7407 12.6587 12.749 12.6505L12.4674 12.3664ZM12.4523 36.1956L12.452 36.1953L12.7351 35.9127L12.7346 35.9122L12.4523 36.1956ZM12.7347 35.9123C12.7347 35.9122 12.7346 35.9122 12.7346 35.9122C12.7346 35.9122 12.7346 35.9122 12.7346 35.9122L12.4523 36.1956C12.4524 36.1956 12.4524 36.1956 12.4524 36.1956C12.4524 36.1957 12.4524 36.1957 12.4524 36.1957L12.7347 35.9123ZM12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4027L12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027L12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027L12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027L12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027L12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027L12.452 12.4027C12.452 12.4027 12.452 12.4027 12.452 12.4027C12.452 12.4027 12.452 12.4027 12.452 12.4027L12.452 12.4027L12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.735 12.6855L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854L12.4521 12.4026ZM20.9904 7.66568C17.7123 8.31773 14.7002 9.9238 12.3323 12.2818L12.6145 12.5653C14.9266 10.2629 17.8677 8.69466 21.0684 8.05799L20.9904 7.66568ZM30.7889 8.63075C27.6901 7.34715 24.2801 7.0113 20.9904 7.66568L21.0684 8.05799C24.2806 7.41905 27.6101 7.74698 30.6359 9.0003L30.7889 8.63075ZM38.4 14.877C36.5365 12.088 33.8878 9.91435 30.7889 8.63075L30.6359 9.0003C33.6617 10.2536 36.2479 12.3761 38.0674 15.0992L38.4 14.877ZM41.2581 24.299C41.2581 20.9448 40.2635 17.6659 38.4 14.877L38.0674 15.0992C39.8869 17.8223 40.8581 21.0239 40.8581 24.299L41.2581 24.299ZM38.4 33.721C40.2635 30.9321 41.2581 27.6532 41.2581 24.299L40.8581 24.299C40.8581 27.5741 39.8869 30.7756 38.0674 33.4988L38.4 33.721ZM30.7889 39.9672C33.8878 38.6836 36.5365 36.5099 38.4 33.721L38.0674 33.4988C36.2479 36.2219 33.6617 38.3443 30.6359 39.5977L30.7889 39.9672ZM20.9904 40.9323C24.2801 41.5867 27.6901 41.2508 30.7889 39.9672L30.6359 39.5977C27.6101 40.851 24.2806 41.1789 21.0684 40.54L20.9904 40.9323ZM12.3323 36.3161C14.7002 38.6742 17.7123 40.2802 20.9904 40.9323L21.0684 40.54C17.8677 39.9033 14.9266 38.3351 12.6145 36.0327L12.3323 36.3161ZM12.3318 35.863C12.2068 35.988 12.2067 36.1911 12.3323 36.3161L12.6145 36.0327C12.6459 36.064 12.6458 36.1146 12.6147 36.1458L12.3318 35.863ZM12.7842 35.8625C12.6596 35.7384 12.4572 35.7376 12.3318 35.863L12.6147 36.1458C12.5833 36.1772 12.5329 36.1768 12.502 36.146L12.7842 35.8625ZM21.1153 40.3043C17.961 39.6768 15.0627 38.1314 12.7842 35.8625L12.502 36.146C14.8363 38.4705 17.8057 40.0538 21.0373 40.6966L21.1153 40.3043ZM30.5439 39.3756C27.562 40.6108 24.2808 40.9339 21.1153 40.3043L21.0373 40.6966C24.2804 41.3417 27.642 41.0106 30.697 39.7452L30.5439 39.3756ZM37.8676 33.3652C36.0744 36.0489 33.5258 38.1405 30.5439 39.3756L30.697 39.7452C33.752 38.4798 36.3631 36.3369 38.2002 33.5875L37.8676 33.3652ZM40.6178 24.299C40.6178 27.5265 39.6607 30.6816 37.8676 33.3652L38.2002 33.5875C40.0373 30.8381 41.0178 27.6057 41.0178 24.299L40.6178 24.299ZM37.8676 15.2327C39.6607 17.9163 40.6178 21.0714 40.6178 24.299L41.0178 24.299C41.0178 20.9923 40.0373 17.7599 38.2002 15.0105L37.8676 15.2327ZM30.5439 9.22232C33.5258 10.4575 36.0744 12.5491 37.8676 15.2327L38.2002 15.0105C36.3631 12.2611 33.752 10.1182 30.697 8.85277L30.5439 9.22232ZM21.1153 8.29369C24.2808 7.66402 27.562 7.98719 30.5439 9.22232L30.697 8.85277C27.642 7.58736 24.2804 7.25627 21.0373 7.90138L21.1153 8.29369ZM12.7842 12.7354C15.0627 10.4665 17.961 8.92111 21.1153 8.29369L21.0373 7.90138C17.8057 8.54418 14.8363 10.1275 12.502 12.452L12.7842 12.7354ZM12.3318 12.735C12.4572 12.8604 12.6596 12.8595 12.7842 12.7354L12.502 12.452C12.5329 12.4212 12.5833 12.4208 12.6147 12.4522L12.3318 12.735ZM12.3323 12.2818C12.2067 12.4069 12.2068 12.6099 12.3318 12.735L12.6147 12.4522C12.6458 12.4833 12.6459 12.534 12.6145 12.5653L12.3323 12.2818Z", fill: "black", mask: "url(#path-3-outside-1_961_14670)" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5301 12.6042C15.5407 12.7216 15.4551 12.8197 15.3389 12.8232L12.0712 12.9215C11.9161 12.9262 11.785 12.7896 11.7953 12.634L12.01 9.37564C12.0177 9.25905 12.1183 9.1766 12.2347 9.19148C12.3511 9.20636 12.4393 9.31292 12.4316 9.42951L12.2299 12.4902L15.3006 12.3978C15.4168 12.3943 15.5195 12.4867 15.5301 12.6042ZM12.0331 12.4961C12.033 12.4961 12.033 12.4961 12.0329 12.4961L12.0482 12.6663L12.0329 12.4961L12.0331 12.4961Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6493 12.5934C15.6659 12.7777 15.5293 12.9372 15.3425 12.9428L12.0748 13.0412C11.8484 13.048 11.661 12.8516 11.6759 12.6261L11.8906 9.36774C11.9028 9.18175 12.0656 9.04916 12.2499 9.07271C12.4286 9.09555 12.5629 9.25718 12.551 9.43735L12.358 12.3666L15.297 12.2781C15.478 12.2727 15.6332 12.4143 15.6493 12.5934ZM15.3006 12.3978C15.4168 12.3943 15.5195 12.4867 15.5301 12.6041C15.5407 12.7216 15.4551 12.8197 15.3389 12.8232L12.0712 12.9215C11.9161 12.9262 11.785 12.7896 11.7953 12.6339L12.01 9.37561C12.0177 9.25903 12.1183 9.17658 12.2347 9.19146C12.3511 9.20633 12.4393 9.3129 12.4316 9.42948L12.2299 12.4902L15.3006 12.3978Z", fill: "#141A22" })
] }), tP = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M31.2782 13.0392H30.3233C26.4811 13.0392 22.6389 13.0392 18.7967 13.0392C18.766 13.0392 18.7339 13.0392 18.7032 13.0392C18.6725 13.0392 18.6418 13.0392 18.6124 13.0392C18.5389 13.0392 18.4668 13.0405 18.3974 13.0485C18.169 13.0739 18.0835 13.1821 18.1022 13.4238C18.1223 13.6655 18.2304 13.7323 18.6057 13.7323C18.607 13.7323 18.6084 13.7323 18.6097 13.7323C20.1976 13.731 21.7868 13.731 23.3747 13.731H26.8898C28.4069 13.731 29.924 13.731 31.4424 13.7283C31.8711 13.727 31.9112 13.5507 31.9139 13.3851C31.9179 13.2101 31.8858 13.0525 31.4558 13.0419C31.397 13.0392 31.3369 13.0392 31.2782 13.0392Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M31.4559 15.0611C31.3971 15.0598 31.337 15.0598 31.2782 15.0598H30.2539C26.4344 15.0598 22.6149 15.0598 18.7954 15.0598C18.7647 15.0585 18.7326 15.0598 18.7006 15.0598C18.6699 15.0598 18.6392 15.0598 18.6098 15.0598C18.5363 15.0598 18.4642 15.0611 18.3948 15.0691C18.1664 15.0945 18.0809 15.2027 18.101 15.4444C18.121 15.6861 18.2292 15.7516 18.6044 15.7516C18.6058 15.7516 18.6071 15.7516 18.6084 15.7516C20.1937 15.7502 21.7776 15.7502 23.3628 15.7502H26.8818C28.4016 15.7502 29.9227 15.7502 31.4425 15.7476C31.8699 15.7462 31.9099 15.57 31.9139 15.403C31.9179 15.2307 31.8859 15.0732 31.4559 15.0611Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M18.4296 17.7681C18.5043 17.7735 18.5805 17.7735 18.6619 17.7721H18.7127H19.1467C23.1959 17.7721 27.2451 17.7721 31.2943 17.7708H31.3317C31.4666 17.7708 31.5935 17.7708 31.7003 17.7401C31.8085 17.7094 31.93 17.6399 31.9153 17.3822C31.9047 17.2086 31.8299 17.1231 31.6669 17.0977C31.5668 17.0817 31.4586 17.0817 31.3451 17.083H31.2783C29.5729 17.0817 27.8688 17.0817 26.1634 17.083H23.7715C22.1222 17.083 20.4729 17.083 18.8235 17.083H18.7354C18.7073 17.083 18.6793 17.083 18.6512 17.083C18.5711 17.083 18.4937 17.0844 18.4175 17.0897C18.1972 17.1057 18.1064 17.2019 18.1037 17.4196C18.097 17.6506 18.1918 17.7521 18.4296 17.7681Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M31.4586 19.1036C31.3985 19.1023 31.3384 19.1023 31.2796 19.1023H31.2115C27.0742 19.1023 22.9368 19.1023 18.7981 19.1023C18.7674 19.1023 18.7354 19.1023 18.7047 19.1023C18.6739 19.1023 18.6432 19.1023 18.6139 19.1023C18.5391 19.1023 18.4683 19.1036 18.3975 19.1116C18.1678 19.1357 18.0823 19.2439 18.101 19.4856C18.1184 19.7046 18.1918 19.7954 18.6032 19.7954C18.6045 19.7954 18.6058 19.7954 18.6072 19.7954C20.1951 19.7941 21.7843 19.7941 23.3722 19.7941H26.8725C28.395 19.7941 29.9174 19.7941 31.4399 19.7914C31.8686 19.7901 31.91 19.6138 31.914 19.4495C31.9193 19.2746 31.8873 19.1157 31.4586 19.1036Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M36.4907 21.1336C36.1181 21.1042 35.9552 20.9253 35.9605 20.554C35.9672 20.16 35.9659 19.7594 35.9646 19.3721C35.9632 19.0796 35.9632 18.7858 35.9646 18.4933C35.9726 17.4076 35.4611 16.6423 34.4448 16.2163C34.0802 16.0641 33.9333 15.841 33.9373 15.4484C33.952 14.1263 33.9466 12.7881 33.9413 11.494C33.9399 11.0947 33.8745 11.0279 33.4779 11.0213L33.3363 11.0186C33.0692 11.0133 32.7928 11.0066 32.527 11.0239C32.316 11.0373 32.1624 10.9932 32.0569 10.8891C31.9153 10.7475 31.91 10.5445 31.9194 10.4043C31.934 10.1599 31.93 9.90613 31.9247 9.66174L31.922 9.49346C31.9153 9.0621 31.8566 9.002 31.4359 9.002C25.9911 8.99933 20.3099 8.99933 14.554 9.002C14.1119 9.002 14.0558 9.06076 14.0545 9.52017C14.0505 10.4724 14.0478 11.4874 14.0558 12.5063C14.0585 12.8362 13.929 13.0298 13.6231 13.154C12.5347 13.5948 12.0152 14.3506 12.0366 15.4644C12.0446 15.8824 11.863 16.0721 11.4476 16.0828C9.91581 16.1188 9.001 17.0497 9.001 18.5721C8.99967 24.479 8.99967 30.3859 9.001 36.2927V38.3174C9.001 38.9744 9.02638 38.9998 9.68878 38.9998C12.6829 38.9998 15.6758 38.9998 18.67 38.9998H21.8137C22.185 38.9998 22.5562 38.9998 22.9275 38.9998C23.8276 38.9998 24.7277 38.9998 25.6265 38.9998C28.383 38.9998 31.1394 39.0011 33.8959 38.9971C35.0831 38.9958 35.9926 38.2492 36.2143 37.0954C36.448 35.8734 36.6764 34.6274 36.8967 33.4241C37.0156 32.7737 37.1358 32.122 37.256 31.4716C37.4069 30.6623 37.5578 29.8517 37.71 29.0424C38.0265 27.3597 38.3537 25.6182 38.6582 23.9034C38.7784 23.225 38.6235 22.5652 38.2229 22.0457C37.8102 21.5129 37.1972 21.191 36.4907 21.1336ZM34.1656 16.9989C34.3767 16.9281 34.5289 17.0697 34.621 17.1552C34.6371 17.1699 34.6531 17.1859 34.6691 17.1992C35.0417 17.5077 35.2421 17.9578 35.2634 18.5361C35.2781 18.922 35.2754 19.3133 35.2728 19.6926C35.2714 19.9904 35.2688 20.2989 35.2754 20.6021C35.2794 20.7797 35.2367 20.9092 35.1472 21C35.0164 21.1323 34.8361 21.1296 34.6918 21.1269C34.6624 21.1269 34.6331 21.1256 34.6037 21.1269L34.5796 21.1283C34.5463 21.1296 34.5129 21.1296 34.4782 21.1296C34.3326 21.1296 34.183 21.1109 34.0682 20.9974C33.9733 20.9026 33.9319 20.7663 33.9386 20.5807C33.952 20.2121 33.9493 19.8342 33.9453 19.4696C33.944 19.3093 33.9426 19.1491 33.9426 18.9888L33.9413 18.6349C33.9399 18.2676 33.9386 17.8884 33.944 17.5131C33.944 17.4984 33.9413 17.473 33.9386 17.4503C33.9293 17.3488 33.9012 17.0871 34.1656 16.9989ZM32.543 11.701C32.7367 11.6997 32.9517 11.7184 33.0973 11.864C33.2442 12.0109 33.2615 12.2326 33.2602 12.4088C33.2428 15.0411 33.2428 17.7455 33.2602 20.4472C33.2615 20.6154 33.2442 20.8278 33.1026 20.9707C32.9624 21.1109 32.7554 21.1309 32.5684 21.1309C32.5671 21.1309 32.5644 21.1309 32.5631 21.1309C27.5002 21.1202 22.416 21.1202 17.4493 21.1309C17.4466 21.1309 17.4453 21.1309 17.444 21.1309C17.2597 21.1309 17.0527 21.1109 16.9124 20.9707C16.7709 20.8278 16.7535 20.6141 16.7535 20.4445C16.7695 17.8536 16.7695 15.1346 16.7549 12.3634C16.7535 12.2005 16.7709 11.9948 16.9098 11.8559C17.0487 11.7171 17.2517 11.6997 17.4306 11.701C19.3551 11.7117 21.3129 11.7104 23.2053 11.709C23.8196 11.709 24.4353 11.7077 25.0496 11.7077C25.0549 11.7077 25.0603 11.7077 25.0656 11.7077C25.6839 11.7077 26.3023 11.7077 26.9219 11.709C28.7636 11.7117 30.6693 11.713 32.543 11.701ZM14.8959 9.84203C15.0414 9.69646 15.2538 9.67643 15.4447 9.6791C17.3398 9.69245 19.2683 9.68978 21.1326 9.68845C21.7616 9.68845 22.3893 9.68711 23.0183 9.68711H24.9414C26.8111 9.68711 28.6808 9.68711 30.5505 9.68711C30.8162 9.68711 31.0513 9.81532 31.1808 10.0317C31.3157 10.2574 31.317 10.5418 31.1822 10.7929C31.1314 10.8891 31.0259 11.0039 30.8162 11.0119C30.6867 11.0159 30.5572 11.0159 30.4303 11.0159H16.7535C16.0711 11.0159 16.0711 11.0159 16.0711 11.689C16.0711 13.3223 16.0711 14.9556 16.0711 16.5889V20.3577C16.0711 20.5927 16.0444 20.8825 15.84 21.0455C15.7292 21.1336 15.593 21.163 15.4541 21.163C15.3299 21.163 15.2044 21.1403 15.0908 21.1136C14.7262 21.0294 14.7369 20.733 14.7409 20.5901C14.7423 20.57 14.7423 20.5513 14.7423 20.5326C14.7396 19.7941 14.7396 19.0542 14.7396 18.3157V17.6293C14.7396 17.0176 14.7396 16.4046 14.7409 15.7916C14.7423 14.0221 14.7436 12.1912 14.7316 10.3922C14.7303 10.2026 14.749 9.98893 14.8959 9.84203ZM9.68878 32.1901V31.3074C9.68878 27.1473 9.68744 22.9886 9.68878 18.8285C9.68878 17.4223 10.3458 16.7652 11.7561 16.7612C12.2262 16.7599 12.5374 16.7585 12.6269 16.6677C12.7177 16.5742 12.719 16.2537 12.7203 15.7663C12.7217 15.2387 12.7991 14.5737 13.3881 14.1116C13.4001 14.1022 13.4108 14.0929 13.4228 14.0822C13.4989 14.0168 13.6752 13.8645 13.8956 13.9941C14.0759 14.1009 14.0598 14.2905 14.0518 14.3827C14.0505 14.3987 14.0492 14.4147 14.0492 14.4308C14.0505 15.1519 14.0505 15.8744 14.0505 16.5956C14.0505 17.899 14.0505 19.2479 14.0545 20.574C14.0558 20.9052 13.9156 21.0882 13.6004 21.1683C12.5481 21.4368 11.9444 22.0871 11.7534 23.1569C11.3568 25.3751 10.9495 27.6294 10.5555 29.8089L10.2697 31.3915C10.2256 31.6332 10.1762 31.8763 10.1295 32.1113L10.1161 32.1781C10.1041 32.2382 10.0707 32.2796 10.052 32.3023L10.044 32.3103L9.79962 32.6776L9.68878 32.1901ZM37.9117 23.6203C37.8796 24.2159 37.7594 24.8022 37.6433 25.3684C37.5979 25.5915 37.5498 25.8225 37.5097 26.0495C37.1157 28.2371 36.7017 30.458 36.3024 32.6055C36.1315 33.5229 35.9605 34.4404 35.7909 35.3579C35.7549 35.5556 35.7202 35.7519 35.6868 35.9495C35.6334 36.2594 35.5786 36.5785 35.5145 36.8924C35.3329 37.7738 34.6251 38.3 33.6221 38.3013C32.499 38.3027 31.3758 38.3027 30.2527 38.3027C29.5796 38.3027 28.9065 38.3027 28.2321 38.3027H10.5889C10.2564 38.3027 10.0734 38.3027 9.95588 38.1624C9.83835 38.0222 9.87174 37.8339 9.9265 37.5227C10.2657 35.621 10.6063 33.7206 10.9481 31.8189C11.1845 30.5034 11.4196 29.1879 11.6546 27.8738C11.7855 27.1406 11.915 26.4074 12.0446 25.6729C12.1861 24.8743 12.3277 24.0743 12.4706 23.2757C12.6175 22.4531 13.2746 21.8801 14.1426 21.8174C14.2348 21.8107 14.3256 21.812 14.4124 21.812H14.4925H16.0457C22.6724 21.812 29.2991 21.812 35.9245 21.8134C36.1248 21.8134 36.3372 21.8174 36.5482 21.8601C37.4763 22.0551 37.9611 22.6788 37.9117 23.6203Z", fill: "#141A22" })
] }), rP = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M29 13L19.5706 23.8438C19.2434 24.2201 19.2434 24.7799 19.5706 25.1562L29 36", stroke: "black" }) }), nP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx("path", { fill: "#21a366", d: "M28 15h16v9H28z" }),
      /* @__PURE__ */ f.jsx("path", { fill: "#185c37", d: "M44 24H12v16a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V24z" }),
      /* @__PURE__ */ f.jsx("path", { fill: "#107c42", d: "M28 24h16v9H28z" }),
      /* @__PURE__ */ f.jsx("path", { fill: "#3fa071", d: "M12 15h16v9H12z" }),
      /* @__PURE__ */ f.jsx("path", { fill: "#33c481", d: "M42 6H28v9h16V8a2 2 0 0 0-2-2z" }),
      /* @__PURE__ */ f.jsx("path", { fill: "#21a366", d: "M14 6h14v9H12V8a2 2 0 0 1 2-2z" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M22.319 13H12v24h10.319A3.68 3.68 0 0 0 26 33.319V16.681A3.68 3.68 0 0 0 22.319 13z",
          opacity: 0.05
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M22.213 36H12V13.333h10.213a3.12 3.12 0 0 1 3.121 3.121v16.425A3.122 3.122 0 0 1 22.213 36z",
          opacity: 0.07
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M22.106 35H12V13.667h10.106a2.56 2.56 0 0 1 2.56 2.56V32.44a2.56 2.56 0 0 1-2.56 2.56z",
          opacity: 0.09
        }
      ),
      /* @__PURE__ */ f.jsxs(
        "linearGradient",
        {
          id: "a",
          x1: 4.725,
          x2: 23.055,
          y1: 14.725,
          y2: 33.055,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ f.jsx("stop", { offset: 0, stopColor: "#18884f" }),
            /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#0b6731" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "url(#a)",
          d: "M22 34H6a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "#fff",
          d: "M9.807 19h2.386l1.936 3.754L16.175 19h2.229l-3.071 5 3.141 5h-2.351l-2.11-3.93L11.912 29H9.526l3.193-5.018L9.807 19z"
        }
      )
    ]
  }
), aP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsxs(
        "linearGradient",
        {
          id: "a",
          x1: 28,
          x2: 28,
          y1: 14.966,
          y2: 6.45,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ f.jsx("stop", { offset: 0, stopColor: "#42a3f2" }),
            /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#42a4eb" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx("path", { fill: "url(#a)", d: "M42 6H14a2 2 0 0 0-2 2v7.003h32V8a2 2 0 0 0-2-2z" }),
      /* @__PURE__ */ f.jsxs(
        "linearGradient",
        {
          id: "b",
          x1: 28,
          x2: 28,
          y1: 42,
          y2: 33.054,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ f.jsx("stop", { offset: 0, stopColor: "#11408a" }),
            /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#103f8f" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "url(#b)",
          d: "M12 33.054V40a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2v-6.946H12z"
        }
      ),
      /* @__PURE__ */ f.jsxs(
        "linearGradient",
        {
          id: "c",
          x1: 28,
          x2: 28,
          y1: -15.46,
          y2: -15.521,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ f.jsx("stop", { offset: 0, stopColor: "#3079d6" }),
            /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#297cd2" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx("path", { fill: "url(#c)", d: "M12 15.003h32v9.002H12v-9.002z" }),
      /* @__PURE__ */ f.jsxs(
        "linearGradient",
        {
          id: "d",
          x1: 12,
          x2: 44,
          y1: 28.53,
          y2: 28.53,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ f.jsx("stop", { offset: 0, stopColor: "#1d59b3" }),
            /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#195bbc" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx("path", { fill: "url(#d)", d: "M12 24.005h32v9.05H12v-9.05z" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M22.319 13H12v24h10.319A3.68 3.68 0 0 0 26 33.319V16.681A3.68 3.68 0 0 0 22.319 13z",
          opacity: 0.05
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M22.213 36H12V13.333h10.213a3.12 3.12 0 0 1 3.121 3.121v16.425A3.122 3.122 0 0 1 22.213 36z",
          opacity: 0.07
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M22.106 35H12V13.667h10.106a2.56 2.56 0 0 1 2.56 2.56V32.44a2.56 2.56 0 0 1-2.56 2.56z",
          opacity: 0.09
        }
      ),
      /* @__PURE__ */ f.jsxs(
        "linearGradient",
        {
          id: "e",
          x1: 4.744,
          x2: 23.494,
          y1: 14.744,
          y2: 33.493,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ f.jsx("stop", { offset: 0, stopColor: "#256ac2" }),
            /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#1247ad" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "url(#e)",
          d: "M22 34H6a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "#fff",
          d: "m18.403 19-1.546 7.264L15.144 19h-2.187l-1.767 7.489L9.597 19H7.641l2.344 10h2.352l1.713-7.689L15.764 29h2.251l2.344-10h-1.956z"
        }
      ),
      " "
    ]
  }
), iP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 16 16",
    fill: "#9aa1ab",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          "fill-rule": "evenodd",
          d: "M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          "fill-rule": "evenodd",
          d: "M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708z"
        }
      )
    ]
  }
), oP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "4 4 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M17.4165 22C19.9478 22 21.9999 19.948 21.9999 17.4167C21.9999 14.8854 19.9478 12.8334 17.4165 12.8334C14.8852 12.8334 12.8332 14.8854 12.8332 17.4167C12.8332 19.948 14.8852 22 17.4165 22Z",
          stroke: "white",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M17.4167 15.6201V17.4166L18.6667 18.6666",
          stroke: "white",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M18.6667 7V8.66667",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10.3333 7V8.66667",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M11.1922 22C10.6879 22 9.93149 22 8.92291 22C8.25427 22 8.01181 21.9348 7.76737 21.8125C7.52292 21.6902 7.33108 21.5107 7.20035 21.282C7.06962 21.0532 7 20.8264 7 20.2007V10.4658C7 9.84022 7.06962 9.61335 7.20035 9.38463C7.33108 9.15591 7.52292 8.97641 7.76737 8.85409C8.01181 8.73177 8.25427 8.66663 8.92291 8.66663H20.0771C20.7457 8.66663 20.9882 8.73177 21.2326 8.85409C21.4771 8.97641 21.6689 9.15591 21.7997 9.38463C21.9304 9.61335 22 10.5389 22 11.1645",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
), sP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 32 32",
    width: 20,
    height: 20,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M.13 31.978c0-.016.866-1.73 1.926-3.807a308.631 308.631 0 0 0 1.926-3.81c0-.019-.178-.319-.396-.667a15.211 15.211 0 0 1-2.337-8.148A15.413 15.413 0 0 1 4.603 5.91c.487-.616 1.747-1.886 2.33-2.347 2.31-1.83 4.817-2.9 7.736-3.305.889-.124 3.09-.105 4.007.034 6.824 1.03 12.03 6.256 13.053 13.102.138.923.158 3.134.036 4.022-.4 2.916-1.476 5.452-3.294 7.763-.46.586-1.724 1.85-2.339 2.34-2.763 2.199-6.096 3.368-9.599 3.366a15.074 15.074 0 0 1-8.119-2.346c-.347-.219-.646-.397-.664-.397-.018 0-1.726.87-3.796 1.933A332.966 332.966 0 0 1 .16 32.009a.03.03 0 0 1-.03-.03zm18.38-3.023c2.807-.414 5.266-1.618 7.329-3.586 2.877-2.747 4.356-6.362 4.22-10.321-.081-2.397-.72-4.544-1.954-6.58-1.074-1.77-2.757-3.458-4.52-4.537a13.489 13.489 0 0 0-10.896-1.418C8.162 3.863 4.592 7.61 3.422 12.24c-.366 1.45-.479 3.525-.275 5.083.3 2.291 1.246 4.58 2.679 6.475l.274.363-.936 1.845c-.515 1.014-.926 1.855-.913 1.867.013.013.85-.4 1.861-.916l1.838-.94.361.277c.548.418 1.48 1.01 2.08 1.32 1.213.63 2.942 1.179 4.293 1.363.993.136 2.834.126 3.826-.021zM8.27 17.336a1.876 1.876 0 0 1-1.351-1.95c.079-.99.865-1.72 1.858-1.726.772-.004 1.408.425 1.737 1.171.18.406.147 1.117-.069 1.546-.39.773-1.346 1.195-2.175.96zm7.701 0c-1.675-.476-1.852-2.789-.268-3.517.91-.418 2.013-.01 2.459.91.432.89-.01 2.106-.91 2.505-.355.158-.923.203-1.28.101zm7.677-.007c-.396-.125-.615-.26-.856-.528-.292-.325-.392-.527-.47-.945-.235-1.28.886-2.407 2.163-2.17.435.08.72.23 1.008.53.436.453.624 1.12.483 1.714-.247 1.049-1.348 1.71-2.328 1.4z",
        strokeWidth: "1"
      }
    )
  }
), lP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 1.5,
    stroke: "currentColor",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
      }
    )
  }
), cP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 1.5,
    stroke: "currentColor",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z"
      }
    )
  }
), uP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    className: "w-full",
    viewBox: "0 0 56 56",
    fill: "none",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0 0 36.985 0z",
          style: {
            fill: "#e9e9e0"
          }
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M37.5.151V12h11.849z",
          style: {
            fill: "#d9d7ca"
          }
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.514 33.324c-.348 0-.682-.113-.967-.326-1.041-.781-1.181-1.65-1.115-2.242.182-1.628 2.195-3.332 5.985-5.068 1.504-3.296 2.935-7.357 3.788-10.75-.998-2.172-1.968-4.99-1.261-6.643.248-.579.557-1.023 1.134-1.215a4.91 4.91 0 0 1 1.016-.172c.504 0 .947.649 1.261 1.049.295.376.964 1.173-.373 6.802 1.348 2.784 3.258 5.62 5.088 7.562 1.311-.237 2.439-.358 3.358-.358 1.566 0 2.515.365 2.902 1.117.32.622.189 1.349-.39 2.16-.557.779-1.325 1.191-2.22 1.191-1.216 0-2.632-.768-4.211-2.285-2.837.593-6.15 1.651-8.828 2.822-.836 1.774-1.637 3.203-2.383 4.251-1.025 1.435-1.909 2.105-2.784 2.105zm2.662-5.126c-2.137 1.201-3.008 2.188-3.071 2.744-.01.092-.037.334.431.692.149-.047 1.019-.444 2.64-3.436zm13.637-4.442c.815.627 1.014.944 1.547.944.234 0 .901-.01 1.21-.441.149-.209.207-.343.23-.415-.123-.065-.286-.197-1.175-.197-.505.001-1.14.023-1.812.109zm-7.47-6.582a71.291 71.291 0 0 1-2.674 7.564 49.966 49.966 0 0 1 6.496-2.02c-1.35-1.568-2.699-3.526-3.822-5.544zm-.607-8.462c-.098.033-1.33 1.757.096 3.216.949-2.115-.053-3.23-.096-3.216zM48.037 56H7.963A1.463 1.463 0 0 1 6.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z",
          style: {
            fill: "#cc4b4c"
          }
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M17.385 53h-1.641V42.924h2.898c.428 0 .852.068 1.271.205.419.137.795.342 1.128.615.333.273.602.604.807.991s.308.822.308 1.306c0 .511-.087.973-.26 1.388a2.9 2.9 0 0 1-.725 1.046c-.31.282-.684.501-1.121.656s-.921.232-1.449.232h-1.217V53zm0-8.832v3.992h1.504c.2 0 .398-.034.595-.103.196-.068.376-.18.54-.335.164-.155.296-.371.396-.649.1-.278.15-.622.15-1.032 0-.164-.023-.354-.068-.567a1.637 1.637 0 0 0-.28-.615 1.657 1.657 0 0 0-.595-.492c-.255-.132-.593-.198-1.012-.198h-1.23zM32.219 47.682c0 .829-.089 1.538-.267 2.126s-.403 1.08-.677 1.477-.581.709-.923.937-.672.398-.991.513a4.094 4.094 0 0 1-.875.219c-.264.03-.46.046-.588.046h-3.814V42.924h3.035c.848 0 1.593.135 2.235.403s1.176.627 1.6 1.073.74.955.95 1.524c.21.57.315 1.156.315 1.758zm-4.867 4.115c1.112 0 1.914-.355 2.406-1.066s.738-1.741.738-3.09c0-.419-.05-.834-.15-1.244-.101-.41-.294-.781-.581-1.114s-.677-.602-1.169-.807-1.13-.308-1.914-.308h-.957v7.629h1.627zM36.266 44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924H40.9v1.244h-4.634z",
          style: {
            fill: "#fff"
          }
        }
      )
    ]
  }
), dP = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_1441_2226)", children: /* @__PURE__ */ f.jsx("path", { d: "M16.4808 2.685C14.75 0.954167 12.4475 0 10 0C7.5525 0 5.25 0.954167 3.51833 2.685C-0.055837 6.25917 -0.055837 12.0742 3.54166 15.6717L6.82666 18.7067C7.68 19.5408 8.8075 20.0008 10 20.0008C11.1925 20.0008 12.3192 19.5408 13.155 18.7233L16.4808 15.65C20.055 12.0758 20.055 6.26 16.4808 2.68583V2.685ZM15.3258 14.4475L12.0067 17.515C10.9275 18.5717 9.09 18.5875 7.975 17.4983L4.69583 14.47C1.77166 11.545 1.77166 6.7875 4.69583 3.8625C6.1125 2.44667 7.99666 1.66583 9.99916 1.66583C12.0017 1.66583 13.885 2.44667 15.3017 3.8625C18.2258 6.7875 18.2258 11.545 15.325 14.4467L15.3258 14.4475ZM9.16583 9.58333V5C9.16583 4.53917 9.53833 4.16667 9.99916 4.16667C10.46 4.16667 10.8325 4.53917 10.8325 5V9.58333C10.8325 10.0442 10.46 10.4167 9.99916 10.4167C9.53833 10.4167 9.16583 10.0442 9.16583 9.58333ZM11.2492 12.9167C11.2492 13.6067 10.6892 14.1667 9.99916 14.1667C9.30916 14.1667 8.74916 13.6067 8.74916 12.9167C8.74916 12.2267 9.30916 11.6667 9.99916 11.6667C10.6892 11.6667 11.2492 12.2267 11.2492 12.9167Z", fill: "currentColor" }) }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_1441_2226", children: /* @__PURE__ */ f.jsx("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
] }), fP = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M8.021 11.9 3.453 8.62a.72.72 0 0 1 0-1.238L8.021 4.1a.716.716 0 0 1 1.079.619V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M5.232 4.293a.5.5 0 0 1-.106.7L1.114 7.945l-.042.028a.147.147 0 0 0 0 .252l.042.028 4.012 2.954a.5.5 0 1 1-.593.805L.539 9.073a1.147 1.147 0 0 1 0-1.946l3.994-2.94a.5.5 0 0 1 .699.106",
      fill: "currentColor"
    }
  )
] }), hP = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M13.29063 3.29018C13.38436 3.38315 13.45875 3.49375 13.50952 3.61561C13.56029 3.73747 13.58643 3.86817 13.58643 4.00018C13.58643 4.1322 13.56029 4.2629 13.50952 4.38476C13.45875 4.50662 13.38436 4.61722 13.29063 4.71018L8.71063 9.29018C8.61689 9.38315 8.5425 9.49375 8.49173 9.61561C8.44096 9.73747 8.41482 9.86817 8.41482 10.0002C8.41482 10.1322 8.44096 10.2629 8.49173 10.3848C8.5425 10.5066 8.61689 10.6172 8.71063 10.7102L13.29063 15.2902C13.38436 15.3831 13.45875 15.4937 13.50952 15.6156C13.56029 15.7375 13.58643 15.8682 13.58643 16.0002C13.58643 16.1322 13.56029 16.2629 13.50952 16.3848C13.45875 16.5066 13.38436 16.6172 13.29063 16.7102C13.1033 16.8964 12.8498 17.001 12.5856 17.001C12.3214 17.001 12.0679 16.8964 11.8806 16.7102L7.29063 12.1202C6.72882 11.5577 6.41329 10.7952 6.41329 10.0002C6.41329 9.20518 6.72882 8.44269 7.29063 7.88018L11.8806 3.29018C12.0679 3.10393 12.3214 2.99939 12.5856 2.99939C12.8498 2.99939 13.1033 3.10393 13.29063 3.29018Z", fill: "currentColor" }) }), AP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "rect",
        {
          x: "2",
          y: "2",
          width: "20",
          height: "20",
          stroke: "currentColor",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12 16V8M12 8l-4 4M12 8l4 4",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), pP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-.5-13h-1v6h4v-1.5h-2.5z",
        fill: "currentColor"
      }
    )
  }
), gP = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "currentColor", className: "bi bi-window-stack", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M4.5 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M6 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" }),
  /* @__PURE__ */ f.jsx("path", { d: "M12 1a2 2 0 0 1 2 2 2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2 2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM2 12V5a2 2 0 0 1 2-2h9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1m1-4v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8zm12-1V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2z" })
] }), vP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-2.5-5l5-3-5-3v6z",
        fill: "currentColor"
      }
    )
  }
), mP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M11.0833 1.16669H5.83333C4.22333 1.16669 2.91667 2.47335 2.91667 4.08335V7.58335C2.91667 9.19335 4.22333 10.5 5.83333 10.5H11.0833C12.6933 10.5 14 9.19335 14 7.58335V4.08335C14 2.47335 12.6933 1.16669 11.0833 1.16669ZM5.83333 2.33335H11.0833C11.8417 2.33335 12.4833 2.82335 12.7283 3.50002H4.18833C4.4275 2.82335 5.06917 2.33335 5.83333 2.33335ZM11.0833 9.33335H5.83333C4.87083 9.33335 4.08333 8.54585 4.08333 7.58335V4.66669H12.8333V7.58335C12.8333 8.54585 12.0458 9.33335 11.0833 9.33335ZM9.91667 12.25C9.91667 12.5709 9.65417 12.8334 9.33333 12.8334H2.91667C1.30667 12.8334 0 11.5267 0 9.91669V5.62919C0 4.91752 0.256667 4.23502 0.729167 3.69835C0.945 3.45919 1.3125 3.43585 1.55167 3.64585C1.79667 3.86169 1.81417 4.22919 1.60417 4.46835C1.32417 4.78919 1.16667 5.19752 1.16667 5.62335V9.91085C1.16667 10.8734 1.95417 11.6609 2.91667 11.6609H9.33333C9.65417 11.6609 9.91667 11.9234 9.91667 12.2442V12.25Z",
        fill: "currentColor"
      }
    )
  }
), CP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { id: "Vector", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M23.71 20.3C23.52 20.11 23.27 20.01 23 20.01C22.73 20.01 22.48 20.12 22.29 20.3C22.1 20.48 22 20.74 22 21.01C22 21.28 21.63 21.69 21 21.89V23.28C21 23.52 20.95 23.75 20.86 23.96C22.62 23.72 24 22.47 24 21.01C24 20.74 23.89 20.49 23.71 20.3Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M15 23.28V21.99C14.92 21.99 14.83 22.01 14.75 22.01C13.66 22.01 13 21.32 13 21.01V11.39L14.99 12.04C15.83 11.4 16.87 11 18 11C18.71 11 19.39 11.15 20 11.42V9C20 7.94 19.58 6.92 18.83 6.17C18.08 5.42 17.06 5 16 5V4C16 2.94 15.58 1.92 14.83 1.17C14.08 0.42 13.06 0 12 0C10.94 0 9.92 0.42 9.17 1.17C8.42 1.92 8 2.94 8 4V5C6.94 5 5.92 5.42 5.17 6.17C4.42 6.92 4 7.94 4 9V11.57C3.32 11.8 2.75 12.27 2.39 12.89C2.03 13.51 1.9 14.24 2.03 14.94C2.47 17.27 3.58 19.42 5.22 21.12C5.27 21.18 5.31 21.24 5.35 21.31C5.15 21.54 4.91 21.72 4.63 21.83C4.35 21.95 4.05 22 3.75 21.99C2.66 21.99 2 21.3 2 20.99C2 20.72 1.89 20.47 1.71 20.28C1.52 20.09 1.27 19.99 1 19.99C0.73 19.99 0.48 20.1 0.29 20.28C0.1 20.47 0 20.72 0 20.99C0 22.62 1.72 23.99 3.75 23.99C4.76 23.99 5.74 23.64 6.51 22.99C7.28 23.63 8.25 23.99 9.25 23.99C10.25 23.99 11.22 23.65 12 23.01C12.78 23.65 13.75 23.99 14.75 23.99C14.88 23.99 15.01 23.97 15.15 23.95C15.06 23.74 15 23.5 15 23.26V23.28ZM10 4.01C10 3.48 10.21 2.97 10.59 2.6C10.97 2.22 11.47 2.01 12 2.01C12.53 2.01 13.04 2.22 13.41 2.6C13.79 2.98 14 3.48 14 4.01V5.01H10V4.01ZM11 21.01C11 21.35 10.32 22.01 9.25 22.01C8.92 22.03 8.58 21.96 8.28 21.81C7.98 21.66 7.72 21.44 7.54 21.16C7.33 20.66 7.05 20.2 6.69 19.79C5.31 18.36 4.38 16.57 4 14.62C3.95 14.38 4 14.13 4.12 13.92C4.24 13.71 4.44 13.55 4.67 13.47L11.01 11.4V21.02L11 21.01ZM11.06 9.27L6 10.92V9.01C6 8.48 6.21 7.97 6.59 7.6C6.97 7.22 7.47 7.01 8 7.01H16C16.53 7.01 17.04 7.22 17.41 7.6C17.79 7.98 18 8.48 18 9.01V10.93L12.95 9.27C12.34 9.07 11.67 9.07 11.06 9.27Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M18 12.01C15.79 12.01 14 13.8 14 16.01C14 17.49 14.81 18.78 16 19.47V23.28C16 23.92 16.78 24.24 17.23 23.79L18 23.02L18.77 23.79C19.22 24.24 20 23.92 20 23.28V19.47C21.19 18.78 22 17.48 22 16.01C22 13.8 20.21 12.01 18 12.01ZM18 18.01C16.9 18.01 16 17.11 16 16.01C16 14.91 16.9 14.01 18 14.01C19.1 14.01 20 14.91 20 16.01C20 17.11 19.1 18.01 18 18.01Z", fill: "currentColor" })
    ] })
  }
), bP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M19.5 0H12.5C10.019 0 8 2.019 8 4.5V15.5C8 17.43 9.57 19 11.5 19H19.5C21.981 19 24 16.981 24 14.5V4.5C24 2.019 21.981 0 19.5 0ZM12.5 2H19.5C20.878 2 22 3.121 22 4.5V12H11.5C10.964 12 10.455 12.122 10 12.338V4.5C10 3.121 11.122 2 12.5 2ZM19.5 17H11.5C10.673 17 10 16.327 10 15.5C10 14.673 10.673 14 11.5 14H22V14.5C22 15.879 20.878 17 19.5 17ZM14.663 21.3C15.05 21.695 15.044 22.327 14.649 22.714C13.803 23.543 12.685 24 11.5 24H3.5C1.57 24 0 22.43 0 20.5V9.5C0 7.019 2.019 5 4.5 5H5C5.552 5 6 5.447 6 6C6 6.553 5.552 7 5 7H4.5C3.122 7 2 8.121 2 9.5V17.338C2.455 17.121 2.964 17 3.5 17H5C5.552 17 6 17.447 6 18C6 18.553 5.552 19 5 19H3.5C2.673 19 2 19.673 2 20.5C2 21.327 2.673 22 3.5 22H11.5C12.158 22 12.78 21.746 13.249 21.286C13.644 20.898 14.276 20.906 14.663 21.3Z",
        fill: "currentColor"
      }
    )
  }
), yP = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M22.61 16.1623C21.46 15.7473 20.019 15.2563 18.385 14.7613L21.462 3.22227C21.664 2.46527 21.506 1.67527 21.029 1.05427C20.551 0.434271 19.83 0.0772705 19.047 0.0772705H18.749C17.34 0.0772705 15.994 0.75027 15.149 1.87827L9.298 9.67827C8.124 11.2433 6.342 12.0773 5.506 12.0773H1C0.447 12.0773 0 12.5243 0 13.0773C0 13.6303 0.447 14.0773 1 14.0773H3.008C9.909 14.0773 17.826 16.5613 21.932 18.0433C21.961 18.0543 22.001 18.0683 22 18.1393C22 18.2103 21.96 18.2243 21.931 18.2343C17.827 19.6703 9.91 22.0783 3.008 22.0783H1C0.447 22.0783 0 22.5253 0 23.0783C0 23.6313 0.447 24.0783 1 24.0783H3.008C10.204 24.0783 18.366 21.5993 22.591 20.1223C23.444 19.8243 23.996 19.0503 24 18.1493C24.004 17.2483 23.459 16.4683 22.61 16.1633V16.1623ZM10.899 10.8773L16.75 3.07727C17.22 2.45127 17.968 2.07727 18.75 2.07727H19.048C19.262 2.07727 19.388 2.19927 19.444 2.27227C19.5 2.34527 19.586 2.49927 19.531 2.70627L16.465 14.2043C14.219 13.5823 11.72 12.9983 9.173 12.6003C9.796 12.1313 10.392 11.5563 10.9 10.8783L10.899 10.8773ZM8 19.0773C7.447 19.0773 7 18.6303 7 18.0773C7 17.5243 7.447 17.0773 8 17.0773H13C13.553 17.0773 14 17.5243 14 18.0773C14 18.6303 13.553 19.0773 13 19.0773H8Z",
    fill: "currentColor"
  }
) }), wP = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M21 24.0773C19.346 24.0773 18 22.7313 18 21.0773V13.0773C18 12.5263 17.552 12.0773 17 12.0773H7C6.448 12.0773 6 12.5263 6 13.0773V21.0773C6 22.7313 4.654 24.0773 3 24.0773C1.346 24.0773 0 22.7313 0 21.0773V9.80125C0 8.13625 0.824 6.58725 2.203 5.65625L9.203 0.932254C10.902 -0.213746 13.098 -0.213746 14.797 0.932254L21.797 5.65625C23.176 6.58725 24 8.13625 24 9.80125V21.0773C24 22.7313 22.654 24.0773 21 24.0773ZM7 10.0773H17C18.654 10.0773 20 11.4233 20 13.0773V21.0773C20 21.6283 20.448 22.0773 21 22.0773C21.552 22.0773 22 21.6283 22 21.0773V9.80125C22 8.80225 21.506 7.87225 20.678 7.31425L13.678 2.59025C12.658 1.90225 11.342 1.90225 10.323 2.59025L3.322 7.31425C2.494 7.87225 2 8.80225 2 9.80125V21.0773C2 21.6283 2.448 22.0773 3 22.0773C3.552 22.0773 4 21.6283 4 21.0773V13.0773C4 11.4233 5.346 10.0773 7 10.0773ZM11 23.0773V21.0773C11 20.5253 10.553 20.0773 10 20.0773H9C8.447 20.0773 8 20.5253 8 21.0773V23.0773C8 23.6293 8.447 24.0773 9 24.0773H10C10.553 24.0773 11 23.6293 11 23.0773ZM11 17.0773V15.0773C11 14.5253 10.553 14.0773 10 14.0773H9C8.447 14.0773 8 14.5253 8 15.0773V17.0773C8 17.6293 8.447 18.0773 9 18.0773H10C10.553 18.0773 11 17.6293 11 17.0773ZM16 23.0773V21.0773C16 20.5253 15.553 20.0773 15 20.0773H14C13.447 20.0773 13 20.5253 13 21.0773V23.0773C13 23.6293 13.447 24.0773 14 24.0773H15C15.553 24.0773 16 23.6293 16 23.0773Z",
    fill: "currentColor"
  }
) }), xP = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 14 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M1 5.00513H11L7.71 1.71513C7.61627 1.62216 7.54188 1.51156 7.49111 1.3897C7.44034 1.26784 7.4142 1.13714 7.4142 1.00513C7.4142 0.873114 7.44034 0.742408 7.49111 0.620549C7.54188 0.49869 7.61627 0.388089 7.71 0.295126C7.89736 0.108875 8.15081 0.0043335 8.415 0.0043335C8.67919 0.0043335 8.93264 0.108875 9.12 0.295126L13.41 4.59513C13.7856 4.96848 13.9978 5.47555 14 6.00513C13.9951 6.53123 13.7832 7.03423 13.41 7.40513L9.12 11.7051C9.02676 11.7977 8.9162 11.871 8.79463 11.9209C8.67306 11.9707 8.54286 11.9961 8.41146 11.9957C8.28007 11.9952 8.15005 11.9689 8.02884 11.9182C7.90762 11.8675 7.79758 11.7934 7.705 11.7001C7.61242 11.6069 7.53911 11.4963 7.48925 11.3748C7.4394 11.2532 7.41398 11.123 7.41444 10.9916C7.41491 10.8602 7.44125 10.7302 7.49196 10.609C7.54267 10.4877 7.61676 10.3777 7.71 10.2851L11 7.00513H1C0.734783 7.00513 0.480429 6.89977 0.292892 6.71223C0.105356 6.5247 0 6.27034 0 6.00513C0 5.73991 0.105356 5.48556 0.292892 5.29802C0.480429 5.11048 0.734783 5.00513 1 5.00513Z",
    fill: "currentColor"
  }
) }), DP = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 20 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M17.949 5.536L14.465 2.05C13.142 0.728 11.384 0 9.515 0H5C2.243 0 0 2.243 0 5V19C0 21.757 2.243 24 5 24H15C17.757 24 20 21.757 20 19V10.485C20 8.614 19.271 6.858 17.949 5.536ZM16.535 6.951C16.853 7.268 17.122 7.621 17.34 8.001H12.999C12.447 8.001 11.999 7.552 11.999 7.001V2.659C12.379 2.877 12.732 3.146 13.05 3.464L16.535 6.951ZM18 19.001C18 20.655 16.654 22.001 15 22.001H5C3.346 22.001 2 20.655 2 19.001V5C2 3.346 3.346 2 5 2H9.515C9.678 2 9.84 2.008 10 2.023V7C10 8.654 11.346 10 13 10H17.977C17.992 10.16 18 10.322 18 10.485V19.001ZM13.707 16.106C14.098 16.496 14.098 17.129 13.707 17.52L12.094 19.134C11.517 19.711 10.758 20 10 20C9.242 20 8.483 19.711 7.906 19.134L6.293 17.52C5.902 17.129 5.902 16.496 6.293 16.106C6.684 15.715 7.316 15.715 7.707 16.106L9 17.399V13.001C9 12.449 9.447 12.001 10 12.001C10.553 12.001 11 12.449 11 13.001V17.399L12.293 16.106C12.684 15.715 13.316 15.715 13.707 16.106Z",
    fill: "currentColor"
  }
) }), OP = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 25 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M18.86 5.14152C18.528 5.07552 18.257 4.86852 18.118 4.57252C16.566 1.30152 12.975 -0.527481 9.38301 0.134519C6.11101 0.734519 3.54601 3.34652 2.99901 6.63552C2.83701 7.60652 2.84901 8.57852 3.03201 9.52552C3.09201 9.83452 2.95901 10.1785 2.68601 10.4265C1.54101 11.4675 0.88501 12.9505 0.88501 14.4965C0.88501 17.5285 3.35201 19.9965 6.38501 19.9965H17.385C21.521 19.9965 24.885 16.6325 24.885 12.4965C24.885 8.93152 22.351 5.83852 18.859 5.14252L18.86 5.14152ZM17.386 17.9955H6.38601C4.45601 17.9955 2.88601 16.4255 2.88601 14.4955C2.88601 13.5125 3.30401 12.5675 4.03201 11.9055C4.81801 11.1905 5.18701 10.1325 4.99501 9.14252C4.85701 8.43052 4.84901 7.69752 4.97101 6.96152C5.37401 4.53952 7.33601 2.54052 9.74201 2.09952C10.127 2.02952 10.51 1.99552 10.887 1.99552C13.199 1.99552 15.293 3.28452 16.309 5.42952C16.723 6.30152 17.509 6.91052 18.467 7.10252C21.026 7.61352 22.884 9.88052 22.884 12.4965C22.884 15.5285 20.417 17.9965 17.384 17.9965L17.386 17.9955ZM16.007 11.2885C16.398 11.6795 16.398 12.3115 16.007 12.7025L13.3 15.4095C12.913 15.7965 12.404 15.9915 11.895 15.9935L11.886 15.9955L11.877 15.9935C11.368 15.9915 10.859 15.7965 10.472 15.4095L7.76501 12.7025C7.37401 12.3115 7.37401 11.6795 7.76501 11.2885C8.15601 10.8975 8.78801 10.8975 9.17901 11.2885L10.886 12.9955V7.99552C10.886 7.44252 11.334 6.99552 11.886 6.99552C12.438 6.99552 12.886 7.44252 12.886 7.99552V12.9955L14.593 11.2885C14.984 10.8975 15.616 10.8975 16.007 11.2885Z",
    fill: "currentColor"
  }
) }), MP = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M16.885 8C16.6975 7.81253 16.4432 7.70721 16.178 7.70721C15.9128 7.70721 15.6585 7.81253 15.471 8L12.885 10.586L10.299 8C10.1104 7.81784 9.85781 7.71705 9.59561 7.71933C9.33341 7.7216 9.0826 7.82677 8.89719 8.01218C8.71178 8.19759 8.60661 8.4484 8.60434 8.7106C8.60206 8.9728 8.70285 9.2254 8.88501 9.414L11.471 12L8.88501 14.586C8.70285 14.7746 8.60206 15.0272 8.60434 15.2894C8.60661 15.5516 8.71178 15.8024 8.89719 15.9878C9.0826 16.1732 9.33341 16.2784 9.59561 16.2807C9.85781 16.283 10.1104 16.1822 10.299 16L12.885 13.414L15.471 16C15.6596 16.1822 15.9122 16.283 16.1744 16.2807C16.4366 16.2784 16.6874 16.1732 16.8728 15.9878C17.0582 15.8024 17.1634 15.5516 17.1657 15.2894C17.168 15.0272 17.0672 14.7746 16.885 14.586L14.299 12L16.885 9.414C17.0725 9.22647 17.1778 8.97216 17.1778 8.707C17.1778 8.44184 17.0725 8.18753 16.885 8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M12.885 0C10.5116 0 8.19156 0.703788 6.21817 2.02236C4.24478 3.34094 2.70671 5.21509 1.79846 7.4078C0.890209 9.60051 0.652569 12.0133 1.11559 14.3411C1.57861 16.6689 2.7215 18.8071 4.39973 20.4853C6.07796 22.1635 8.21616 23.3064 10.5439 23.7694C12.8717 24.2324 15.2845 23.9948 17.4772 23.0866C19.6699 22.1783 21.5441 20.6402 22.8626 18.6668C24.1812 16.6935 24.885 14.3734 24.885 12C24.8816 8.81846 23.6162 5.76821 21.3665 3.51852C19.1168 1.26883 16.0666 0.00344108 12.885 0ZM12.885 22C10.9072 22 8.9738 21.4135 7.32931 20.3147C5.68482 19.2159 4.4031 17.6541 3.64622 15.8268C2.88934 13.9996 2.69131 11.9889 3.07716 10.0491C3.46301 8.10929 4.41542 6.32746 5.81395 4.92893C7.21247 3.53041 8.9943 2.578 10.9341 2.19215C12.8739 1.8063 14.8846 2.00433 16.7119 2.7612C18.5391 3.51808 20.1009 4.79981 21.1997 6.4443C22.2985 8.08879 22.885 10.0222 22.885 12C22.8821 14.6513 21.8276 17.1931 19.9529 19.0679C18.0781 20.9426 15.5363 21.9971 12.885 22Z",
      fill: "currentColor"
    }
  )
] }), EP = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 25 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M4.88501 14V21C4.88501 21.552 4.43701 22 3.88501 22C3.33301 22 2.88501 21.552 2.88501 21V14C2.88501 13.448 3.33301 13 3.88501 13C4.43701 13 4.88501 13.448 4.88501 14ZM18.885 13C18.333 13 17.885 13.448 17.885 14V21C17.885 21.552 18.333 22 18.885 22C19.437 22 19.885 21.552 19.885 21V14C19.885 13.448 19.437 13 18.885 13ZM10.885 13C10.333 13 9.88501 13.448 9.88501 14V21C9.88501 21.552 10.333 22 10.885 22C11.437 22 11.885 21.552 11.885 21V14C11.885 13.448 11.437 13 10.885 13ZM7.38501 13C6.55601 13 5.88501 13.671 5.88501 14.5V20.5C5.88501 21.329 6.55601 22 7.38501 22C8.21401 22 8.88501 21.329 8.88501 20.5V14.5C8.88501 13.671 8.21401 13 7.38501 13ZM15.385 13C14.556 13 13.885 13.671 13.885 14.5V20.5C13.885 21.329 14.556 22 15.385 22C16.214 22 16.885 21.329 16.885 20.5V14.5C16.885 13.671 16.214 13 15.385 13ZM21.885 13C21.333 13 20.885 13.448 20.885 14V21C20.885 21.552 21.333 22 21.885 22C22.437 22 22.885 21.552 22.885 21V14C22.885 13.448 22.437 13 21.885 13ZM23.885 9H22.885V1C22.885 0.448 22.437 0 21.885 0C21.333 0 20.885 0.448 20.885 1V9H19.885V1C19.885 0.448 19.437 0 18.885 0C18.333 0 17.885 0.448 17.885 1V9H16.885V1.5C16.885 0.671 16.214 0 15.385 0C14.556 0 13.885 0.671 13.885 1.5V9H11.885V1C11.885 0.448 11.437 0 10.885 0C10.333 0 9.88501 0.448 9.88501 1V9H8.88501V1.5C8.88501 0.671 8.21401 0 7.38501 0C6.55601 0 5.88501 0.671 5.88501 1.5V9H4.88501V1C4.88501 0.448 4.43701 0 3.88501 0C3.33301 0 2.88501 0.448 2.88501 1V9H1.88501C1.33301 9 0.88501 9.448 0.88501 10C0.88501 10.552 1.33301 11 1.88501 11H23.885C24.437 11 24.885 10.552 24.885 10C24.885 9.448 24.437 9 23.885 9Z",
    fill: "currentColor"
  }
) }), SP = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M18.885 19C19.0828 19 19.2761 18.9413 19.4405 18.8314C19.6049 18.7215 19.733 18.5654 19.8087 18.3827C19.8844 18.2 19.9042 17.9989 19.8656 17.805C19.827 17.611 19.7318 17.4328 19.592 17.293L13.42 11.122C12.4824 10.1846 11.2108 9.65807 9.88501 9.65807C8.55919 9.65807 7.28765 10.1846 6.35001 11.122L4.17801 13.293C3.99585 13.4816 3.89506 13.7342 3.89734 13.9964C3.89961 14.2586 4.00478 14.5094 4.19019 14.6948C4.3756 14.8802 4.62641 14.9854 4.88861 14.9877C5.15081 14.99 5.40341 14.8892 5.59201 14.707L7.76401 12.536C8.33523 11.9901 9.09491 11.6855 9.88501 11.6855C10.6751 11.6855 11.4348 11.9901 12.006 12.536L18.178 18.707C18.3655 18.8946 18.6198 18.9999 18.885 19Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M16.885 10.5C17.5772 10.5 18.2539 10.2947 18.8295 9.91014C19.4051 9.52556 19.8537 8.97893 20.1186 8.33939C20.3835 7.69985 20.4528 6.99612 20.3178 6.31718C20.1827 5.63825 19.8494 5.01461 19.3599 4.52513C18.8704 4.03564 18.2468 3.7023 17.5678 3.56725C16.8889 3.4322 16.1852 3.50151 15.5456 3.76642C14.9061 4.03133 14.3595 4.47993 13.9749 5.0555C13.5903 5.63108 13.385 6.30777 13.385 7C13.385 7.92826 13.7538 8.8185 14.4101 9.47487C15.0665 10.1313 15.9568 10.5 16.885 10.5ZM16.885 5.5C17.1817 5.5 17.4717 5.58797 17.7184 5.7528C17.965 5.91762 18.1573 6.15189 18.2708 6.42597C18.3844 6.70006 18.4141 7.00166 18.3562 7.29264C18.2983 7.58361 18.1554 7.85088 17.9457 8.06066C17.7359 8.27044 17.4686 8.4133 17.1776 8.47118C16.8867 8.52906 16.5851 8.49935 16.311 8.38582C16.0369 8.27229 15.8026 8.08003 15.6378 7.83335C15.473 7.58668 15.385 7.29667 15.385 7C15.385 6.60218 15.543 6.22064 15.8243 5.93934C16.1057 5.65804 16.4872 5.5 16.885 5.5Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M23.885 16C23.6198 16 23.3654 16.1054 23.1779 16.2929C22.9904 16.4804 22.885 16.7348 22.885 17V19C22.885 19.7957 22.5689 20.5587 22.0063 21.1213C21.4437 21.6839 20.6807 22 19.885 22H17.885C17.6198 22 17.3654 22.1054 17.1779 22.2929C16.9904 22.4804 16.885 22.7348 16.885 23C16.885 23.2652 16.9904 23.5196 17.1779 23.7071C17.3654 23.8946 17.6198 24 17.885 24H19.885C21.2106 23.9984 22.4815 23.4711 23.4188 22.5338C24.3561 21.5964 24.8834 20.3256 24.885 19V17C24.885 16.7348 24.7797 16.4804 24.5921 16.2929C24.4046 16.1054 24.1502 16 23.885 16Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M1.88501 8C2.15023 8 2.40458 7.89464 2.59212 7.70711C2.77965 7.51957 2.88501 7.26522 2.88501 7V5C2.88501 4.20435 3.20108 3.44129 3.76369 2.87868C4.3263 2.31607 5.08936 2 5.88501 2H7.88501C8.15023 2 8.40458 1.89464 8.59212 1.70711C8.77965 1.51957 8.88501 1.26522 8.88501 1C8.88501 0.734784 8.77965 0.48043 8.59212 0.292893C8.40458 0.105357 8.15023 0 7.88501 0H5.88501C4.55941 0.00158786 3.28857 0.528882 2.35123 1.46622C1.41389 2.40356 0.886598 3.67441 0.88501 5V7C0.88501 7.26522 0.990367 7.51957 1.1779 7.70711C1.36544 7.89464 1.61979 8 1.88501 8Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M7.88501 22H5.88501C5.08936 22 4.3263 21.6839 3.76369 21.1213C3.20108 20.5587 2.88501 19.7957 2.88501 19V17C2.88501 16.7348 2.77965 16.4804 2.59212 16.2929C2.40458 16.1054 2.15023 16 1.88501 16C1.61979 16 1.36544 16.1054 1.1779 16.2929C0.990367 16.4804 0.88501 16.7348 0.88501 17V19C0.886598 20.3256 1.41389 21.5964 2.35123 22.5338C3.28857 23.4711 4.55941 23.9984 5.88501 24H7.88501C8.15023 24 8.40458 23.8946 8.59212 23.7071C8.77965 23.5196 8.88501 23.2652 8.88501 23C8.88501 22.7348 8.77965 22.4804 8.59212 22.2929C8.40458 22.1054 8.15023 22 7.88501 22Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M19.885 0H17.885C17.6198 0 17.3654 0.105357 17.1779 0.292893C16.9904 0.48043 16.885 0.734784 16.885 1C16.885 1.26522 16.9904 1.51957 17.1779 1.70711C17.3654 1.89464 17.6198 2 17.885 2H19.885C20.6807 2 21.4437 2.31607 22.0063 2.87868C22.5689 3.44129 22.885 4.20435 22.885 5V7C22.885 7.26522 22.9904 7.51957 23.1779 7.70711C23.3654 7.89464 23.6198 8 23.885 8C24.1502 8 24.4046 7.89464 24.5921 7.70711C24.7797 7.51957 24.885 7.26522 24.885 7V5C24.8834 3.67441 24.3561 2.40356 23.4188 1.46622C22.4815 0.528882 21.2106 0.00158786 19.885 0Z", fill: "currentColor" })
] }), PP = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M24.3294 22.7398L21.8994 15.5698C21.5834 14.6528 20.7924 14.0608 19.8814 14.0608C18.9704 14.0608 18.1794 14.6538 17.8634 15.5738L15.4344 22.7398C15.2574 23.2628 15.5374 23.8308 16.0604 24.0088C16.5844 24.1868 17.1504 23.9048 17.3284 23.3828L17.7974 21.9998H21.9654L22.4344 23.3828C22.5764 23.7988 22.9644 24.0618 23.3814 24.0618C23.4874 24.0618 23.5964 24.0448 23.7024 24.0088C24.2254 23.8308 24.5064 23.2638 24.3284 22.7398H24.3294ZM18.4754 19.9998L19.7564 16.2208C19.8314 15.9998 19.9334 16.0038 20.0064 16.2168L21.2884 19.9998H18.4754ZM16.5404 9.55077C16.0344 8.59677 15.0504 8.00377 13.9714 8.00377L10.1384 8.00077L11.3434 2.77377C11.6524 1.69577 11.2044 0.601772 10.2794 0.173772C9.3994 -0.233228 8.4144 0.087772 7.8064 0.999772L1.3874 11.4608C0.781404 12.3548 0.719404 13.5028 1.2244 14.4568C1.7294 15.4108 2.7144 16.0038 3.7944 16.0038H7.6244L6.4204 21.2298C6.1114 22.3088 6.5594 23.4018 7.4844 23.8298C7.7374 23.9468 7.9994 24.0038 8.2574 24.0038C8.8994 24.0038 9.5244 23.6538 9.9564 23.0038L16.3764 12.5468C16.9824 11.6528 17.0444 10.5048 16.5394 9.55177L16.5404 9.55077ZM14.6974 11.4608L8.3334 21.8258C8.3384 21.7968 9.8554 15.2278 9.8554 15.2278C9.9234 14.9308 9.8534 14.6198 9.6634 14.3798C9.4734 14.1418 9.1854 14.0028 8.8804 14.0028H3.7944C3.3004 14.0028 3.0684 13.6648 2.9914 13.5198C2.9144 13.3738 2.7644 12.9918 3.0664 12.5448L9.4304 2.17677C9.4254 2.20577 7.9084 8.77577 7.9084 8.77577C7.8404 9.07277 7.9104 9.38377 8.1004 9.62277C8.2904 9.86177 8.5784 10.0008 8.8824 10.0008L13.9704 10.0048C14.4644 10.0048 14.6964 10.3428 14.7734 10.4878C14.8504 10.6328 14.9994 11.0138 14.6974 11.4608Z",
    fill: "currentColor"
  }
) }), jP = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M12.3361 2.00028C13.6626 2.00463 14.9751 2.27201 16.1976 2.78696C17.4201 3.30191 18.5283 4.05419 19.4581 5.00028H16.3361C16.0709 5.00028 15.8166 5.10563 15.629 5.29317C15.4415 5.48071 15.3361 5.73506 15.3361 6.00028C15.3361 6.26549 15.4415 6.51985 15.629 6.70738C15.8166 6.89492 16.0709 7.00028 16.3361 7.00028H20.4791C20.9716 7.00001 21.4437 6.80428 21.7919 6.45608C22.1401 6.10788 22.3359 5.6357 22.3361 5.14328V1.00028C22.3361 0.735059 22.2308 0.480706 22.0432 0.293169C21.8557 0.105633 21.6014 0.000275954 21.3361 0.000275954C21.0709 0.000275954 20.8166 0.105633 20.629 0.293169C20.4415 0.480706 20.3361 0.735059 20.3361 1.00028V3.07828C18.6833 1.58973 16.6487 0.590686 14.4602 0.193025C12.2717 -0.204636 10.0158 0.0147879 7.94493 0.826723C5.87408 1.63866 4.07016 3.01105 2.73515 4.7902C1.40015 6.56935 0.586782 8.68502 0.38614 10.9003C0.373223 11.0395 0.389456 11.18 0.433803 11.3126C0.47815 11.4452 0.54964 11.5672 0.643716 11.6707C0.737793 11.7741 0.852394 11.8569 0.980218 11.9136C1.10804 11.9704 1.24629 11.9999 1.38614 12.0003C1.63073 12.0034 1.86767 11.9151 2.0506 11.7527C2.23352 11.5903 2.34925 11.3655 2.37514 11.1223C2.59775 8.63302 3.74311 6.31698 5.58622 4.62911C7.42933 2.94125 9.83696 2.00357 12.3361 2.00028Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M23.2869 12.0003C23.0423 11.9972 22.8054 12.0855 22.6225 12.2479C22.4396 12.4103 22.3238 12.6351 22.2979 12.8783C22.1326 14.7816 21.4249 16.5974 20.2586 18.1105C19.0923 19.6236 17.5165 20.7704 15.7181 21.4149C13.9197 22.0593 11.9741 22.1744 10.1123 21.7464C8.25044 21.3184 6.55043 20.3654 5.21394 19.0003H8.33594C8.60115 19.0003 8.85551 18.895 9.04305 18.7074C9.23058 18.5199 9.33594 18.2655 9.33594 18.0003C9.33594 17.7351 9.23058 17.4808 9.04305 17.2932C8.85551 17.1057 8.60115 17.0003 8.33594 17.0003H4.19294C3.94904 17.0002 3.7075 17.0481 3.48214 17.1414C3.25678 17.2347 3.05201 17.3715 2.87955 17.5439C2.70708 17.7164 2.5703 17.9212 2.47703 18.1465C2.38375 18.3719 2.33581 18.6134 2.33594 18.8573V23.0003C2.33594 23.2655 2.44129 23.5199 2.62883 23.7074C2.81637 23.895 3.07072 24.0003 3.33594 24.0003C3.60115 24.0003 3.85551 23.895 4.04304 23.7074C4.23058 23.5199 4.33594 23.2655 4.33594 23.0003V20.9223C5.98877 22.4109 8.02335 23.4099 10.2118 23.8076C12.4003 24.2052 14.6563 23.9858 16.7272 23.1739C18.798 22.3619 20.6019 20.9896 21.9369 19.2104C23.2719 17.4312 24.0853 15.3156 24.2859 13.1003C24.2989 12.9611 24.2826 12.8206 24.2383 12.688C24.1939 12.5554 24.1224 12.4334 24.0284 12.3299C23.9343 12.2265 23.8197 12.1437 23.6919 12.087C23.564 12.0302 23.4268 12.0007 23.2869 12.0003Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M12.3359 11.167C11.4151 11.167 10.6693 11.9128 10.6693 12.8336C10.6693 13.7545 11.4151 14.5003 12.3359 14.5003C13.2568 14.5003 14.0026 13.7545 14.0026 12.8336C14.0026 11.9128 13.2568 11.167 12.3359 11.167ZM14.8359 17.0003H9.83594C8.4576 17.0003 7.33594 15.8786 7.33594 14.5003V11.167C7.33594 9.80114 8.43677 8.68864 9.79677 8.6678L10.3768 7.76531C10.6834 7.28697 11.2076 7.00031 11.7784 7.00031H12.8934C13.4643 7.00031 13.9876 7.28697 14.2959 7.76614L14.8751 8.6678C16.2359 8.68864 17.3359 9.80114 17.3359 11.167V14.5003C17.3359 15.8786 16.2143 17.0003 14.8359 17.0003ZM15.6693 11.167C15.6693 10.707 15.2959 10.3336 14.8359 10.3336H9.83594C9.37594 10.3336 9.0026 10.707 9.0026 11.167V14.5003C9.0026 14.9603 9.37594 15.3336 9.83594 15.3336H14.8359C15.2959 15.3336 15.6693 14.9603 15.6693 14.5003V11.167Z", fill: "currentColor" })
] }), IP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M33.1018 6.06516C29.5133 2.47661 24.7418 0.5 19.667 0.5C14.5922 0.5 9.8207 2.47661 6.23215 6.06516C2.6436 9.65371 0.666992 14.4252 0.666992 19.5C0.666992 22.492 1.34323 25.3563 2.67527 28.0122C3.94602 30.5445 5.80619 32.801 8.0535 34.5386C8.16484 34.6244 8.29764 34.6663 8.42839 34.6663C8.61124 34.6663 8.79307 34.5846 8.91361 34.4283C9.12097 34.1606 9.07194 33.7755 8.80328 33.5682C4.57425 30.2983 2.0828 25.4206 1.90404 20.1129H17.4493C17.718 21.0854 18.6108 21.8015 19.668 21.8015C20.7253 21.8015 21.617 21.0854 21.8857 20.1129H37.43C37.2553 25.2664 34.8803 30.0501 30.8504 33.3159C30.5879 33.5294 30.547 33.9155 30.7605 34.178C30.974 34.4405 31.3591 34.4814 31.6227 34.2679C36.0999 30.6395 38.668 25.2562 38.668 19.5C38.668 14.4252 36.6914 9.65371 33.1029 6.06516H33.1018ZM37.4289 18.8871H30.9526C30.8658 17.2752 30.4408 15.7521 29.7462 14.3884L35.3532 11.1512C36.5933 13.4721 37.3339 16.0994 37.4289 18.8871ZM34.7383 10.0899L29.1302 13.3281C28.2722 12.0165 27.1495 10.8938 25.8379 10.0358L29.0761 4.42769C31.3653 5.86188 33.3051 7.80172 34.7393 10.0899H34.7383ZM14.5544 9.42081L11.3172 3.81376C13.6381 2.57366 16.2654 1.83306 19.0531 1.73806V8.21339C17.4411 8.30022 15.9181 8.72618 14.5544 9.42081ZM20.2799 1.73704C23.0676 1.83204 25.6949 2.57263 28.0158 3.81274L24.7776 9.42081C23.4139 8.72618 21.8908 8.30022 20.2789 8.21339V1.73704H20.2799ZM10.2569 4.42769L13.494 10.0358C12.1824 10.8938 11.0598 12.0165 10.2017 13.3281L4.59366 10.0899C6.02785 7.80172 7.96769 5.86188 10.2559 4.42769H10.2569ZM9.5878 14.3884C8.89318 15.7521 8.46721 17.2762 8.3814 18.8871H1.90404C1.99904 16.0994 2.73963 13.4721 3.97973 11.1512L9.58678 14.3884H9.5878ZM17.4493 18.8871H9.60925C9.92694 13.6151 14.3163 9.42285 19.668 9.42285C25.0197 9.42285 29.4081 13.6151 29.7258 18.8871H21.8857C21.8346 18.7022 21.7611 18.5275 21.6691 18.3651L24.1831 15.8512C24.4221 15.6122 24.4221 15.224 24.1831 14.9849C23.944 14.7459 23.5559 14.7459 23.3168 14.9849L20.8029 17.4989C20.4679 17.3078 20.0807 17.1985 19.669 17.1985C18.6118 17.1985 17.72 17.9146 17.4503 18.8871H17.4493ZM19.668 20.5756C19.0745 20.5756 18.5924 20.0925 18.5924 19.5C18.5924 18.9075 19.0745 18.4244 19.668 18.4244C20.2615 18.4244 20.7437 18.9065 20.7437 19.5C20.7437 20.0935 20.2615 20.5756 19.668 20.5756ZM18.4963 28.5475H15.7618C15.4237 28.5475 15.1489 28.8212 15.1489 29.1604V37.8871C15.1489 38.2252 15.4237 38.5 15.7618 38.5H18.4963C18.8345 38.5 19.1092 38.2252 19.1092 37.8871V29.1604C19.1092 28.8212 18.8345 28.5475 18.4963 28.5475ZM17.8834 37.2742H16.3747V29.7733H17.8834V37.2742ZM23.5732 29.6865H20.8397C20.5005 29.6865 20.2268 29.9612 20.2268 30.2994V37.8871C20.2268 38.2252 20.5005 38.5 20.8397 38.5H23.5732C23.9113 38.5 24.1861 38.2252 24.1861 37.8871V30.2994C24.1861 29.9612 23.9113 29.6865 23.5732 29.6865ZM22.9603 37.2742H21.4526V30.9123H22.9603V37.2742ZM28.6501 24.961H25.9155C25.5774 24.961 25.3026 25.2358 25.3026 25.5739V37.8871C25.3026 38.2252 25.5774 38.5 25.9155 38.5H28.6501C28.9893 38.5 29.263 38.2252 29.263 37.8871V25.5739C29.263 25.2358 28.9893 24.961 28.6501 24.961ZM28.0372 37.2742H26.5284V26.1868H28.0372V37.2742ZM13.4195 31.9327H10.6849C10.3468 31.9327 10.072 32.2075 10.072 32.5456V37.8871C10.072 38.2252 10.3468 38.5 10.6849 38.5H13.4195C13.7586 38.5 14.0324 38.2252 14.0324 37.8871V32.5456C14.0324 32.2075 13.7586 31.9327 13.4195 31.9327ZM12.8066 37.2742H11.2978V33.1585H12.8066V37.2742ZM22.0216 25.7608L25.652 22.0997C25.3261 22.111 25.0483 21.8689 25.0197 21.542C24.9901 21.2049 25.2393 20.9066 25.5764 20.878L27.2292 20.733C27.412 20.7166 27.5929 20.784 27.7216 20.9158C27.8493 21.0476 27.9126 21.2294 27.8922 21.4123L27.7083 23.061C27.6736 23.3746 27.408 23.6054 27.1005 23.6054C27.078 23.6054 27.0545 23.6044 27.031 23.6013C26.7205 23.5666 26.4906 23.3041 26.4866 22.9997L22.6273 26.8926C22.4649 27.0571 22.2228 27.1153 22.0032 27.0438L17.2501 25.5024L12.4296 29.2554C12.3173 29.3422 12.1855 29.3851 12.0537 29.3851C11.8709 29.3851 11.6901 29.3044 11.5695 29.1491C11.3622 28.8815 11.4091 28.4964 11.6768 28.289L16.7537 24.3358C16.914 24.2112 17.1255 24.1734 17.3196 24.2367L22.0226 25.7628L22.0216 25.7608Z",
        fill: "currentColor"
      }
    )
  }
), BP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_2383_69933)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M30.0156 7.9375C27.8143 7.9375 26.0312 9.72051 26.0312 11.9219V13.25H21.2294C22.8298 10.5134 23.6406 8.46078 23.6406 7.14062C23.6406 3.47898 20.6616 0.5 17 0.5C13.3384 0.5 10.3594 3.47898 10.3594 7.14062C10.3594 8.46078 11.1702 10.5134 12.7706 13.25H7.96875V11.9219C7.96875 9.72449 6.18176 7.9375 3.98438 7.9375C1.78699 7.9375 0 9.72051 0 11.9219V15.6406C0 16.0072 0.2975 16.3047 0.664062 16.3047C1.03062 16.3047 1.32812 16.0072 1.32812 15.6406V11.9219C1.32812 10.455 2.5168 9.26562 3.98438 9.26562C5.45195 9.26562 6.64062 10.4576 6.64062 11.9219V27.5486C5.93539 26.9164 5.00371 26.5312 3.98438 26.5312C2.96504 26.5312 2.03336 26.9171 1.32812 27.5493V20.9531C1.32812 20.5866 1.03062 20.2891 0.664062 20.2891C0.2975 20.2891 0 20.5866 0 20.9531V30.5156C0 32.794 1.96695 34.5 4.17363 34.5H30.0156C32.213 34.5 34 32.713 34 30.5156V11.9219C34 9.72449 32.213 7.9375 30.0156 7.9375ZM27.3594 11.9219C27.3594 10.455 28.548 9.26562 30.0156 9.26562C31.4832 9.26562 32.6719 10.4576 32.6719 11.9219V27.53C32.215 27.1236 31.6658 26.8208 31.0662 26.6667C29.7354 26.3227 28.3661 26.6468 27.3594 27.5453V11.9219ZM26.0312 21.2188H17.5312C15.306 19.0997 11.0553 15.0516 10.5586 14.5781H13.5754C15.0251 16.8944 16.4535 18.8075 16.4681 18.8275C16.5936 18.9948 16.7908 19.0938 17 19.0938C17.2092 19.0938 17.4064 18.9955 17.5319 18.8275C17.5465 18.8075 18.9749 16.8937 20.4246 14.5781H26.0312V21.2188ZM17 1.82812C19.9292 1.82812 22.3125 4.21145 22.3125 7.14062C22.3125 9.60629 18.4231 15.3079 17 17.3001C15.5543 15.2761 11.6875 9.58371 11.6875 7.14062C11.6875 4.21145 14.0708 1.82812 17 1.82812ZM1.32812 30.5156C1.32812 29.0514 2.51945 27.8594 3.98438 27.8594C5.4493 27.8594 6.64062 29.0514 6.64062 30.5156C6.64062 30.8822 6.93813 31.1797 7.30469 31.1797C7.67125 31.1797 7.96875 30.8822 7.96875 30.5156V19.4477L14.709 25.8672L7.03906 33.1719H4.17363C2.68414 33.1719 1.32812 32.0589 1.32812 30.5156ZM16.1294 26.348C16.2609 26.2225 16.3359 26.0485 16.3359 25.8672C16.3359 25.6859 16.2616 25.5113 16.1294 25.3864L7.96875 17.6142V14.5781H8.63281C8.67797 14.6213 16.4913 22.0628 16.8074 22.3636C16.9309 22.4811 17.095 22.5469 17.265 22.5469H26.0306V25.2031H20.9837C20.8077 25.2031 20.6384 25.2729 20.5142 25.3977L12.7394 33.1719H8.96418L16.1287 26.348H16.1294ZM30.0156 33.1719H14.6187L21.2593 26.5312H26.0312V30.5156C26.0312 30.8822 26.3288 31.1797 26.6953 31.1797C27.0619 31.1797 27.3594 30.8822 27.3594 30.5156C27.3594 28.7984 28.9677 27.4961 30.7341 27.9523C31.8126 28.2312 32.6719 29.2267 32.6719 30.5156C32.6719 31.9805 31.4799 33.1719 30.0156 33.1719Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M17 10.4609C18.8308 10.4609 20.3203 8.97145 20.3203 7.14062C20.3203 5.3098 18.8308 3.82031 17 3.82031C15.1692 3.82031 13.6797 5.3098 13.6797 7.14062C13.6797 8.97145 15.1692 10.4609 17 10.4609ZM17 5.14844C18.0984 5.14844 18.9922 6.04227 18.9922 7.14062C18.9922 8.23898 18.0984 9.13281 17 9.13281C15.9016 9.13281 15.0078 8.23898 15.0078 7.14062C15.0078 6.04227 15.9016 5.14844 17 5.14844Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M0.664062 18.9609C1.03062 18.9609 1.32812 18.6634 1.32812 18.2969C1.32812 17.9303 1.03062 17.6328 0.664062 17.6328C0.2975 17.6328 0 17.9303 0 18.2969C0 18.6634 0.2975 18.9609 0.664062 18.9609Z", fill: "currentColor" })
    ] })
  }
), NP = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 40 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_106_18)", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M13.75 24.3719C13.94 26.8166 15.825 28.7205 19.205 28.946V30.75H20.705V28.9332C24.205 28.6821 26.25 26.7653 26.25 23.9824C26.25 21.4533 24.685 20.1489 21.8875 19.4724L20.705 19.1854V14.2731C22.205 14.4474 23.16 15.2879 23.39 16.4513H26.02C25.83 14.0963 23.86 12.2539 20.705 12.054V10.25H19.205V12.0924C16.2175 12.3922 14.18 14.2347 14.18 16.8408C14.18 19.147 15.695 20.6128 18.2125 21.2149L19.205 21.4661V26.6782C17.6675 26.4399 16.65 25.5763 16.42 24.3719H13.75ZM19.1925 18.8216C17.7175 18.4705 16.9175 17.7556 16.9175 16.6793C16.9175 15.4749 17.78 14.5729 19.205 14.309V18.819L19.1925 18.8216ZM20.9225 21.8786C22.715 22.304 23.5425 22.9933 23.5425 24.2105C23.5425 25.5994 22.5125 26.5526 20.705 26.7269V21.8274L20.9225 21.8786Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M20 38.4375C15.3587 38.4375 10.9075 36.5477 7.62563 33.1837C4.34374 29.8198 2.5 25.2573 2.5 20.5C2.5 15.7427 4.34374 11.1802 7.62563 7.81627C10.9075 4.45234 15.3587 2.5625 20 2.5625C24.6413 2.5625 29.0925 4.45234 32.3744 7.81627C35.6563 11.1802 37.5 15.7427 37.5 20.5C37.5 25.2573 35.6563 29.8198 32.3744 33.1837C29.0925 36.5477 24.6413 38.4375 20 38.4375ZM20 41C25.3043 41 30.3914 38.8402 34.1421 34.9957C37.8929 31.1512 40 25.9369 40 20.5C40 15.0631 37.8929 9.84881 34.1421 6.00431C30.3914 2.15982 25.3043 0 20 0C14.6957 0 9.60859 2.15982 5.85786 6.00431C2.10714 9.84881 0 15.0631 0 20.5C0 25.9369 2.10714 31.1512 5.85786 34.9957C9.60859 38.8402 14.6957 41 20 41Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M20 34.5938C16.3533 34.5938 12.8559 33.1089 10.2773 30.4658C7.69866 27.8227 6.25 24.2379 6.25 20.5C6.25 16.7621 7.69866 13.1773 10.2773 10.5342C12.8559 7.89112 16.3533 6.40625 20 6.40625C23.6467 6.40625 27.1441 7.89112 29.7227 10.5342C32.3013 13.1773 33.75 16.7621 33.75 20.5C33.75 24.2379 32.3013 27.8227 29.7227 30.4658C27.1441 33.1089 23.6467 34.5938 20 34.5938ZM20 35.875C21.9698 35.875 23.9204 35.4773 25.7403 34.7046C27.5601 33.932 29.2137 32.7995 30.6066 31.3718C31.9995 29.9441 33.1044 28.2491 33.8582 26.3838C34.612 24.5184 35 22.5191 35 20.5C35 18.4809 34.612 16.4816 33.8582 14.6162C33.1044 12.7509 31.9995 11.0559 30.6066 9.62823C29.2137 8.20053 27.5601 7.06802 25.7403 6.29535C23.9204 5.52269 21.9698 5.125 20 5.125C16.0218 5.125 12.2064 6.74486 9.3934 9.62823C6.58035 12.5116 5 16.4223 5 20.5C5 24.5777 6.58035 28.4884 9.3934 31.3718C12.2064 34.2551 16.0218 35.875 20 35.875Z", fill: "currentColor" })
] }) }), LP = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M39.6339 0.366153C39.9874 0.719731 40.0963 1.25 39.9106 1.71427L32.9106 19.2143C32.6542 19.8553 31.9267 20.167 31.2857 19.9106C30.6448 19.6542 30.333 18.9268 30.5894 18.2858L35.3277 6.44013L16.5929 25.1749L20.0318 30.5789C20.4025 31.1614 20.2308 31.934 19.6484 32.3046C19.0659 32.6752 18.2933 32.5036 17.9227 31.9211L14.0945 25.9055L1.6077 17.9593C0.318659 17.139 0.499343 15.204 1.91798 14.6365L38.2857 0.0894406C38.75 -0.0962678 39.2803 0.0125747 39.6339 0.366153ZM14.8251 23.4071L33.5599 4.67237L3.97869 16.5048L14.8251 23.4071Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M31.25 40C36.0825 40 40 36.0825 40 31.25C40 26.4175 36.0825 22.5 31.25 22.5C26.4175 22.5 22.5 26.4175 22.5 31.25C22.5 36.0825 26.4175 40 31.25 40ZM32.1339 26.6161C31.893 26.3752 31.5642 26.2431 31.2236 26.2503C30.8829 26.2575 30.56 26.4034 30.3295 26.6543L27.4584 29.7793C26.9914 30.2877 27.0248 31.0784 27.5332 31.5455C28.0416 32.0126 28.8323 31.9791 29.2994 31.4707L30 30.7081V35C30 35.6904 30.5596 36.25 31.25 36.25C31.9404 36.25 32.5 35.6904 32.5 35V30.5178L33.4911 31.5089C33.9793 31.997 34.7707 31.997 35.2589 31.5089C35.747 31.0207 35.747 30.2293 35.2589 29.7411L32.1339 26.6161Z", fill: "currentColor" })
] }), TP = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M7.78684 24.0628C5.97659 24.0616 4.22784 23.4057 2.86329 22.2162C1.49874 21.0267 0.610474 19.3837 0.362401 17.5906C0.114327 15.7974 0.523189 13.975 1.51354 12.4597C2.50389 10.9443 4.00889 9.83835 5.75084 9.34576C7.01696 8.98319 8.35713 8.96661 9.63184 9.29776L17.5398 1.39176C17.9596 0.969046 18.4592 0.633898 19.0096 0.405759C19.5599 0.177621 20.1501 0.0610343 20.7458 0.0627631C21.6834 0.0635575 22.5823 0.436354 23.2453 1.09931C23.9082 1.76227 24.281 2.6612 24.2818 3.59876C24.2834 4.19455 24.1668 4.78474 23.9389 5.3352C23.7109 5.88567 23.3761 6.38549 22.9538 6.80576L22.2818 7.47776C21.9058 7.8512 21.3978 8.06139 20.8678 8.06276H19.2818V9.06276C19.2818 9.5932 19.0711 10.1019 18.6961 10.477C18.321 10.852 17.8123 11.0628 17.2818 11.0628H16.2818V12.6488C16.2825 12.9115 16.2311 13.1718 16.1305 13.4145C16.0299 13.6572 15.8822 13.8776 15.6958 14.0628L15.0458 14.7128C15.3788 15.9869 15.3626 17.3271 14.9988 18.5928C14.5896 20.0348 13.7591 21.3218 12.614 22.289C11.4688 23.2562 10.061 23.8595 8.57084 24.0218C8.31038 24.0488 8.0487 24.0625 7.78684 24.0628ZM7.78684 11.0628C6.76299 11.0618 5.75918 11.3466 4.88842 11.8851C4.01767 12.4237 3.31452 13.1946 2.85814 14.1111C2.40176 15.0277 2.21027 16.0534 2.30521 17.0728C2.40016 18.0922 2.77778 19.0649 3.39556 19.8814C4.01334 20.6979 4.84676 21.3257 5.80199 21.6942C6.75723 22.0627 7.79637 22.1572 8.80243 21.9672C9.80848 21.7771 10.7415 21.31 11.4965 20.6185C12.2515 19.9269 12.7985 19.0383 13.0758 18.0528C13.3878 16.9693 13.3529 15.8153 12.9758 14.7528C12.9143 14.5753 12.904 14.3841 12.9461 14.2011C12.9882 14.018 13.081 13.8505 13.2138 13.7178L14.2818 12.6488V11.0628C14.2818 10.5323 14.4926 10.0236 14.8676 9.64855C15.2427 9.27348 15.7514 9.06276 16.2818 9.06276H17.2818V8.06276C17.2818 7.53233 17.4926 7.02362 17.8676 6.64855C18.2427 6.27348 18.7514 6.06276 19.2818 6.06276H20.8678L21.5398 5.39076C21.7758 5.15592 21.9629 4.87663 22.0902 4.56904C22.2176 4.26145 22.2827 3.93167 22.2818 3.59876C22.2816 3.19164 22.1198 2.80126 21.832 2.51329C21.5442 2.22532 21.154 2.06329 20.7468 2.06276C20.4137 2.06194 20.0837 2.12719 19.7759 2.25472C19.4682 2.38226 19.1888 2.56955 18.9538 2.80576L10.6228 11.1358C10.4899 11.2686 10.3222 11.3614 10.1389 11.4033C9.95569 11.4452 9.76434 11.4346 9.58684 11.3728C9.00691 11.1686 8.39666 11.0638 7.78184 11.0628H7.78684ZM5.28184 18.0628C5.28184 18.2605 5.34049 18.4539 5.45037 18.6183C5.56025 18.7828 5.71643 18.911 5.89915 18.9866C6.08188 19.0623 6.28295 19.0821 6.47693 19.0435C6.67091 19.005 6.84909 18.9097 6.98894 18.7699C7.1288 18.63 7.22404 18.4518 7.26262 18.2579C7.30121 18.0639 7.2814 17.8628 7.20572 17.6801C7.13003 17.4974 7.00186 17.3412 6.83741 17.2313C6.67296 17.1214 6.47962 17.0628 6.28184 17.0628C6.01662 17.0628 5.76227 17.1681 5.57473 17.3557C5.3872 17.5432 5.28184 17.7975 5.28184 18.0628Z", fill: "currentColor" }) }), _P = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 25 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M16.1462 0.0727539H9.82088C4.94887 0.0727539 0.984497 4.02038 0.984497 8.87182C0.984497 13.7233 4.94887 17.6709 9.82088 17.6709H10.8279C11.4486 17.6709 11.9531 17.1686 11.9531 16.5505V8.94091C11.9531 8.32281 11.4486 7.82049 10.8279 7.82049H7.07545C6.45473 7.82049 5.95027 8.32281 5.95027 8.94091C5.95027 9.55901 6.45473 10.0613 7.07545 10.0613H9.70273V15.43C6.12467 15.3665 3.23485 12.4497 3.23485 8.87182C3.23485 5.29393 6.19031 2.3136 9.82088 2.3136H16.1462C19.7787 2.3136 22.7323 5.25658 22.7323 8.87182C22.7323 12.4871 19.8424 15.3647 16.2663 15.43V10.0613H18.8935C19.5143 10.0613 20.0187 9.55901 20.0187 8.94091C20.0187 8.32281 19.5143 7.82049 18.8935 7.82049H15.1411C14.5204 7.82049 14.0159 8.32281 14.0159 8.94091V16.5505C14.0159 17.1686 14.5204 17.6709 15.1411 17.6709H16.1444C21.0164 17.6709 24.9807 13.7233 24.9807 8.87182C24.9807 4.02038 21.0201 0.0727539 16.1462 0.0727539Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M10.8279 7.82236H7.07545C6.45473 7.82236 5.95027 8.32468 5.95027 8.94278C5.95027 9.56088 6.45473 10.0632 7.07545 10.0632H9.70273V12.6383C10.4266 12.8437 11.1786 12.9838 11.9531 13.0491V8.94091C11.9531 8.32281 11.4486 7.82049 10.8279 7.82049V7.82236Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M18.8954 7.82236H15.143C14.5222 7.82236 14.0178 8.32468 14.0178 8.94278V13.0529C14.7904 12.9875 15.5424 12.8512 16.2681 12.6476V10.0632H18.8954C19.5161 10.0632 20.0206 9.56088 20.0206 8.94278C20.0206 8.32468 19.5161 7.82236 18.8954 7.82236Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M16.1462 0.0727539H9.82088C6.21844 0.0727539 3.11295 2.23331 1.74024 5.32008C2.1228 6.33966 2.64226 7.29389 3.27611 8.15848C3.63429 4.87564 6.4341 2.3136 9.82275 2.3136H16.1481C19.5518 2.3136 22.3591 4.89618 22.7004 8.1977C23.338 7.3331 23.8612 6.37888 24.2475 5.35742C22.8804 2.25011 19.7656 0.0727539 16.1462 0.0727539Z", fill: "currentColor" })
] }), RP = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M12.9835 24.0728C11.3665 24.0728 9.84748 23.3648 8.80748 22.1528C7.22048 22.2768 5.64148 21.7018 4.49748 20.5578C3.35348 19.4128 2.78048 17.8388 2.90248 16.2478C1.69048 15.2088 0.982483 13.6898 0.982483 12.0728C0.982483 10.4558 1.69048 8.93675 2.90248 7.89775C2.78048 6.30675 3.35348 4.73175 4.49748 3.58775C5.64148 2.44475 7.22048 1.87575 8.80748 1.99275C9.84748 0.780754 11.3665 0.0727539 12.9835 0.0727539C14.6005 0.0727539 16.1195 0.780754 17.1595 1.99275C18.7465 1.87375 20.3265 2.44475 21.4695 3.58775C22.6135 4.73275 23.1865 6.30675 23.0645 7.89775C24.2765 8.93675 24.9845 10.4558 24.9845 12.0728C24.9845 13.6898 24.2765 15.2088 23.0645 16.2478C23.1865 17.8388 22.6135 19.4138 21.4695 20.5578C20.3265 21.7018 18.7475 22.2768 17.1595 22.1528C16.1195 23.3648 14.6005 24.0728 12.9835 24.0728ZM9.70948 19.9778L10.0795 20.5268C10.7325 21.4948 11.8185 22.0728 12.9835 22.0728C14.1485 22.0728 15.2345 21.4948 15.8875 20.5268L16.2575 19.9778L16.9065 20.1038C18.0545 20.3268 19.2295 19.9678 20.0535 19.1438C20.8775 18.3188 21.2365 17.1428 21.0135 15.9978L20.8865 15.3478L21.4365 14.9778C22.4045 14.3248 22.9825 13.2388 22.9825 12.0738C22.9825 10.9088 22.4045 9.82275 21.4365 9.16975L20.8865 8.79975L21.0135 8.14975C21.2365 7.00475 20.8775 5.82775 20.0535 5.00375C19.2295 4.17975 18.0535 3.82175 16.9065 4.04375L16.2575 4.16975L15.8875 3.62075C15.2345 2.65275 14.1485 2.07475 12.9835 2.07475C11.8185 2.07475 10.7325 2.65275 10.0795 3.62075L9.70948 4.16975L9.06048 4.04375C7.91348 3.82375 6.73748 4.17975 5.91348 5.00375C5.08948 5.82875 4.73048 7.00475 4.95348 8.14975L5.08048 8.79975L4.53048 9.16975C3.56248 9.82275 2.98448 10.9088 2.98448 12.0738C2.98448 13.2388 3.56248 14.3248 4.53048 14.9778L5.08048 15.3478L4.95348 15.9978C4.73048 17.1428 5.08948 18.3198 5.91348 19.1438C6.73748 19.9668 7.91148 20.3258 9.06048 20.1038L9.70948 19.9778ZM12.8935 15.4928L18.6865 9.78575L17.2825 8.36075L11.4735 14.0618L8.68048 11.3548L7.28748 12.7918L10.0695 15.4878C10.4605 15.8788 10.9725 16.0728 11.4855 16.0728C11.9985 16.0728 12.5075 15.8798 12.8935 15.4928Z", fill: "currentColor" }) }), FP = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("g", { "clip-path": "url(#clip0_135_74)", children: /* @__PURE__ */ f.jsx("path", { d: "M22.853 1.22522C22.1732 0.546421 21.2517 0.165161 20.291 0.165161C19.3303 0.165161 18.4089 0.546421 17.729 1.22522L1.46502 17.4892C0.999266 17.9524 0.629977 18.5032 0.378513 19.11C0.127049 19.7168 -0.00159798 20.3674 1.49812e-05 21.0242V23.0772C1.49812e-05 23.3424 0.105372 23.5968 0.292908 23.7843C0.480445 23.9719 0.734799 24.0772 1.00002 24.0772H3.05301C3.70978 24.0791 4.36038 23.9506 4.96717 23.6993C5.57396 23.448 6.12487 23.0789 6.58801 22.6132L22.853 6.34822C23.5315 5.66842 23.9126 4.74719 23.9126 3.78672C23.9126 2.82626 23.5315 1.90503 22.853 1.22522ZM5.17401 21.1992C4.61002 21.7595 3.84798 22.0749 3.05301 22.0772H2.00002V21.0242C1.999 20.6301 2.07617 20.2397 2.22705 19.8757C2.37793 19.5116 2.59953 19.1811 2.87901 18.9032L15.222 6.56022L17.522 8.86022L5.17401 21.1992ZM21.438 4.93422L18.932 7.44122L16.632 5.14622L19.139 2.63922C19.29 2.48853 19.4693 2.36906 19.6664 2.28763C19.8636 2.20621 20.0749 2.16441 20.2883 2.16465C20.5016 2.16488 20.7128 2.20713 20.9098 2.28899C21.1069 2.37084 21.2858 2.4907 21.4365 2.64172C21.5872 2.79274 21.7067 2.97197 21.7881 3.16916C21.8695 3.36635 21.9113 3.57765 21.9111 3.79099C21.9109 4.00433 21.8686 4.21554 21.7868 4.41256C21.7049 4.60957 21.585 4.78853 21.434 4.93922L21.438 4.93422Z", fill: "currentColor" }) }) }), $P = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 41 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M2.74817 40.0772H33.0565C38.8752 40.0772 42.676 34.2334 40.0703 29.2671L36.3479 22.1537C27.8843 31.5075 16.1097 38.0421 2.74817 40.0772Z", fill: "#204585" }),
  /* @__PURE__ */ f.jsx("path", { d: "M26.7877 3.95137L25.5338 1.56156C24.4955 -0.417493 21.5371 -0.417493 20.4988 1.56156L5.21725 30.706C15.209 24.3767 22.889 14.9855 26.7877 3.95137Z", fill: "#F15C41" }),
  /* @__PURE__ */ f.jsx("path", { d: "M35.6623 20.8473L27.6885 5.64966C23.2803 17.1506 14.8363 26.8032 4.0021 33.0577L0.906616 38.9762C14.7971 37.2772 27.0811 30.5932 35.6819 20.866L35.6623 20.8473Z", fill: "#2875B4" })
] }), HP = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 79 61", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsxs("g", { children: [
  /* @__PURE__ */ f.jsx("path", { d: "M58.1699 46.1411H39.6543V57.0898H58.1699V46.1411Z", fill: "#293939" }),
  /* @__PURE__ */ f.jsx("path", { d: "M25.459 61.0001H2.31445C1.03533 61.0001 0 59.9506 0 58.6539V7.03854C0 5.7419 1.03533 4.69238 2.31445 4.69238H25.459C26.7366 4.69238 27.7734 5.7419 27.7734 7.03854V58.6539C27.7734 59.9506 26.7366 61.0001 25.459 61.0001Z", fill: "#3E5959" }),
  /* @__PURE__ */ f.jsx("path", { d: "M27.7734 7.03854V58.6539C27.7734 59.949 26.7366 61.0001 25.459 61.0001H13.8867V4.69238H25.459C26.7366 4.69238 27.7734 5.74346 27.7734 7.03854Z", fill: "#293939" }),
  /* @__PURE__ */ f.jsx("path", { d: "M27.7734 16.4231H0V25.8077H27.7734V16.4231Z", fill: "#547983" }),
  /* @__PURE__ */ f.jsx("path", { d: "M27.7734 16.4231H13.8867V25.8077H27.7734V16.4231Z", fill: "#3E5959" }),
  /* @__PURE__ */ f.jsx("path", { d: "M16.2012 54.4309C16.2012 55.7275 15.1658 56.777 13.8867 56.777C12.6076 56.777 11.5723 55.7275 11.5723 54.4309C11.5723 53.1342 12.6076 52.0847 13.8867 52.0847C15.1658 52.0847 16.2012 53.1342 16.2012 54.4309Z", fill: "#81E885" }),
  /* @__PURE__ */ f.jsx("mask", { id: "mask0_168_181", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "79", height: "61", children: /* @__PURE__ */ f.jsx("path", { d: "M79 0H0V61H79V0Z", fill: "white" }) }),
  /* @__PURE__ */ f.jsxs("g", { mask: "url(#mask0_168_181)", children: [
    /* @__PURE__ */ f.jsx("path", { d: "M16.2012 54.4309C16.2012 55.7259 15.1643 56.777 13.8867 56.777V52.0847C15.1643 52.0847 16.2012 53.1358 16.2012 54.4309Z", fill: "#5DC983" }),
    /* @__PURE__ */ f.jsx("path", { d: "M74.3711 46.9231H23.4531C20.9011 46.9231 18.8242 44.8178 18.8242 42.2308V4.69231C18.8242 2.10528 20.9011 0 23.4531 0H74.3711C76.9232 0 79 2.10528 79 4.69231V42.2308C79 44.8178 76.9232 46.9231 74.3711 46.9231Z", fill: "#547983" })
  ] }),
  /* @__PURE__ */ f.jsx("path", { d: "M74.3711 4.69238H23.4531V42.2308H74.3711V4.69238Z", fill: "#F3765F" }),
  /* @__PURE__ */ f.jsx("path", { d: "M62.7988 60.9999H35.0254C33.7463 60.9999 32.7109 59.9504 32.7109 58.6538C32.7109 57.3571 33.7463 56.3076 35.0254 56.3076H62.7988C64.0779 56.3076 65.1133 57.3571 65.1133 58.6538C65.1133 59.9504 64.0779 60.9999 62.7988 60.9999Z", fill: "#547983" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.15", d: "M54.9991 42.2308H51.3747L31.5984 4.69238H35.2229L54.9991 42.2308Z", fill: "white" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.15", d: "M62.7989 42.2308H59.1744L39.3982 4.69238H43.0226L62.7989 42.2308Z", fill: "white" })
] }) }), YP = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 42 42", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0ZM5.3561 11.3562C6.20942 14.844 12.0011 18.0215 15.1108 19.7276C16.3725 20.4198 17.1927 20.8698 17.0625 21C16.8507 21.2119 16.6365 21.4157 16.4266 21.6155C15.3363 22.6534 14.3626 23.5803 14.4375 24.9375C14.5294 26.6027 16.0592 27.0996 17.6248 27.6081C19.1402 28.1004 20.6891 28.6035 21 30.1875C21.2151 31.2833 20.8043 32.7813 20.4218 34.1768C19.8586 36.2308 19.3564 38.0625 21 38.0625C24.9375 36.75 30.9708 29.7003 31.5 24.9375C31.8624 21.6756 26.25 19.6875 22.3125 18.375C21.0578 17.9568 20.3293 18.5878 19.713 19.1217C19.2611 19.5131 18.8695 19.8524 18.375 19.6875C17.2061 19.2979 11.8125 14.4375 14.4375 13.125C16.487 12.1003 16.9363 12.6757 17.6596 13.602C17.8626 13.8621 18.0873 14.1498 18.375 14.4375C19.9723 15.2362 20.1117 14.0909 20.2717 12.7761C20.3746 11.9301 20.4861 11.0139 21 10.5C22.1383 9.36176 24.3201 8.42297 26.3227 7.56133C28.1932 6.75649 29.9073 6.01896 30.4683 5.24905C35.8054 8.46421 39.375 14.3152 39.375 21C39.375 31.1482 31.1482 39.375 21 39.375C10.8518 39.375 2.625 31.1482 2.625 21C2.625 17.463 3.62435 14.1594 5.3561 11.3562Z", fill: "currentColor" }) }), kP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 54 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx("path", { d: "M46.5542 12.7677L44.7664 13.0693C43.8107 13.2328 42.8286 13.1168 41.9394 12.7338L41.8089 12.6774C40.0076 11.8991 37.9453 11.9857 36.2097 12.9139L29.9367 16.2493L17.5845 15.6324C17.4547 15.6257 17.3246 15.6543 17.2093 15.7156L14.0342 17.4039C13.777 17.5406 13.6281 17.8172 13.6552 18.1056C13.6823 18.3941 13.8819 18.6368 14.1593 18.7218L21.2433 20.8717L13.5902 24.941L4.81596 20.2326C4.60383 20.1196 4.34881 20.12 4.13607 20.2331L1.59598 21.5837C1.39171 21.6923 1.25227 21.8922 1.2201 22.1202C1.18743 22.3499 1.26833 22.5786 1.43546 22.7372L7.29022 28.2921L6.8637 28.5188C6.03499 28.9595 5.5939 29.8917 5.78195 30.8071C5.96951 31.7241 6.7398 32.4042 7.67434 32.4792L8.96799 32.5837L8.61643 36.0588C8.58938 36.3219 8.71 36.5769 8.92936 36.7239C9.14872 36.8709 9.43194 36.8853 9.6664 36.762L10.9364 36.0867C11.074 36.0135 11.1839 35.8983 11.2502 35.7576L14.3128 29.2618C14.445 28.982 14.3826 28.6501 14.1585 28.438C13.9344 28.2259 13.5996 28.1809 13.3265 28.3261L9.51636 30.3519C9.30468 30.4645 9.16175 30.6757 9.13787 30.9142L9.11299 31.1559L7.79455 31.0457C7.49819 31.0194 7.25361 30.802 7.19431 30.5117C7.13445 30.2204 7.27326 29.9249 7.53567 29.7826L36.8833 14.1782C37.6887 13.75 38.5954 13.5478 39.5057 13.5951L39.3437 13.6812C38.4664 14.1477 38.1322 15.2326 38.5969 16.1064C39.0615 16.9802 40.1477 17.3099 41.0251 16.8434L45.6459 14.3864C45.6544 14.3819 45.6606 14.3732 45.6675 14.3682L46.7882 14.1779C47.0934 14.1265 47.3974 14.2745 47.541 14.547L47.5808 14.6218C47.7254 14.8937 47.6796 15.229 47.4657 15.4523L46.3304 16.6414C45.5309 17.4816 44.5996 18.1863 43.5751 18.731L34.0074 23.8183L34.1105 23.6012C34.2427 23.3213 34.1803 22.9895 33.9562 22.7774C33.7321 22.5653 33.3973 22.5202 33.1242 22.6654L26.139 26.3795C25.9612 26.4741 25.83 26.6385 25.7804 26.8338L25.3689 28.4114L21.5419 30.4463C19.7151 31.4176 17.6501 31.8463 15.5909 31.6784L15.0488 31.6341C14.8587 31.6189 14.6705 31.6784 14.5244 31.802C14.3794 31.9251 14.2882 32.1007 14.2722 32.2903C14.2563 32.48 14.3154 32.6676 14.4388 32.8129C14.5622 32.9582 14.7373 33.0476 14.9274 33.0628L15.4695 33.1072C17.8041 33.2977 20.1458 32.8124 22.2154 31.7106L24.8783 30.2947L22.8319 38.1349C22.7596 38.41 22.8575 38.7013 23.0813 38.8771C23.3051 39.0528 23.6111 39.0794 23.8636 38.9465L27.6737 36.9206C27.8113 36.8475 27.9211 36.7323 27.9875 36.5916L32.9897 25.9818L44.2497 19.9948C45.4097 19.378 46.4641 18.578 47.3704 17.627L48.5051 16.4369C49.1468 15.7645 49.2867 14.7612 48.8524 13.9443L48.8126 13.8695C48.3777 13.0542 47.4683 12.6103 46.5558 12.7656L46.5542 12.7677ZM10.5286 31.4362L12.094 30.6039L10.2075 34.6084L10.5286 31.4362ZM8.6285 27.5791L3.14908 22.3803L4.46887 21.6786L12.065 25.7519L8.62956 27.5786L8.6285 27.5791ZM23.0393 19.9168L16.2403 17.8533L17.7072 17.0733L27.4697 17.5611L23.0393 19.9168ZM39.8669 15.4311C39.7739 15.2561 39.8406 15.0395 40.0163 14.9461L41.57 14.12C41.8879 14.243 42.2138 14.3401 42.5466 14.4119L40.3525 15.5785C40.1769 15.6719 39.9599 15.6061 39.8669 15.4311ZM26.7879 35.7705L24.632 36.9168L27.0904 27.4975L31.8912 24.9448L26.7869 35.7711L26.7879 35.7705Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M36.5617 18.406L36.2255 17.7735C36.0399 17.4246 35.6045 17.2925 35.2542 17.4788C34.9038 17.665 34.7699 18.0999 34.9554 18.4488L35.2917 19.0813C35.4772 19.4302 35.9126 19.5623 36.263 19.376C36.6133 19.1898 36.7472 18.7549 36.5617 18.406Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M33.722 20.7256C34.0723 20.5394 34.2062 20.1045 34.0207 19.7556L33.6844 19.1231C33.4989 18.7743 33.0635 18.6421 32.7131 18.8284C32.3628 19.0146 32.2289 19.4496 32.4144 19.7984L32.7507 20.4309C32.9362 20.7798 33.3716 20.9119 33.722 20.7256Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M31.4807 21.1071L31.1444 20.4747C30.9589 20.1258 30.5234 19.9937 30.1731 20.1799C29.8228 20.3662 29.6888 20.8011 29.8744 21.15L30.2106 21.7824C30.3961 22.1313 30.8316 22.2635 31.1819 22.0772C31.5322 21.8909 31.6662 21.456 31.4807 21.1071Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M28.9406 22.4567L28.6044 21.8243C28.4189 21.4754 27.9834 21.3433 27.6331 21.5295C27.2827 21.7158 27.1488 22.1507 27.3343 22.4996L27.6706 23.132C27.8561 23.4809 28.2916 23.6131 28.6419 23.4268C28.9922 23.2406 29.1261 22.8056 28.9406 22.4567Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M26.4006 23.8083L26.0643 23.1759C25.8788 22.827 25.4434 22.6948 25.093 22.8811C24.7427 23.0674 24.6088 23.5023 24.7943 23.8512L25.1305 24.4836C25.3161 24.8325 25.7515 24.9647 26.1018 24.7784C26.4522 24.5921 26.5861 24.1572 26.4006 23.8083Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M23.8606 25.1579L23.5243 24.5255C23.3388 24.1766 22.9033 24.0444 22.553 24.2307C22.2027 24.417 22.0687 24.8519 22.2542 25.2008L22.5905 25.8332C22.776 26.1821 23.2115 26.3143 23.5618 26.128C23.9121 25.9417 24.0461 25.5068 23.8606 25.1579Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M21.3205 26.5095L20.9842 25.8771C20.7987 25.5282 20.3633 25.396 20.013 25.5823C19.6626 25.7685 19.5287 26.2035 19.7142 26.5523L20.0505 27.1848C20.236 27.5337 20.6714 27.6658 21.0218 27.4796C21.3721 27.2933 21.506 26.8584 21.3205 26.5095Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M18.7805 27.8591L18.4442 27.2267C18.2587 26.8778 17.8232 26.7456 17.4729 26.9319C17.1226 27.1182 16.9887 27.5531 17.1742 27.902L17.5104 28.5344C17.6959 28.8833 18.1314 29.0154 18.4817 28.8292C18.832 28.6429 18.966 28.208 18.7805 27.8591Z", fill: "currentColor" })
    ]
  }
), VP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_2676_51189)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M23.3023 19.6547C23.3023 19.6547 27.8473 22.4595 27.8501 22.4609C28.1771 22.6627 28.6165 22.5587 28.8176 22.2317C29.0187 21.9047 28.9161 21.466 28.5891 21.2642C28.5891 21.2642 24.0469 18.4615 24.0413 18.458C23.7143 18.2562 23.2742 18.3624 23.0731 18.6872C22.8713 19.0121 22.9782 19.4551 23.3023 19.6547Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M20.9115 18.1735C21.0198 18.2424 21.1456 18.2832 21.2771 18.2832C21.5232 18.2832 21.7475 18.1588 21.8762 17.9492C22.1504 17.5027 21.8059 16.877 21.2785 16.877C20.8292 16.877 20.491 17.3045 20.5937 17.7411C20.6345 17.9155 20.754 18.0737 20.9115 18.1735Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M8.88406 22.5684C9.01625 22.572 9.14774 22.5417 9.25813 22.4721C9.25813 22.4721 13.7757 19.6231 13.7785 19.6209C14.1034 19.4156 14.2025 18.9769 13.9979 18.6513C13.7996 18.3356 13.3426 18.233 13.0283 18.432C13.0283 18.432 8.51563 21.2775 8.50789 21.2824C8.18305 21.4877 8.0832 21.9265 8.28852 22.252C8.41156 22.4475 8.64922 22.5621 8.88477 22.5684H8.88406Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M15.7823 18.2285C16.1079 18.2285 16.3961 17.9993 16.4679 17.6808C16.5663 17.2448 16.2267 16.8223 15.7809 16.8223C15.4547 16.8223 15.1685 17.0515 15.0961 17.37C14.9976 17.8031 15.3408 18.2285 15.7823 18.2285Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M36.162 32.5251C35.9075 32.2319 35.4631 32.2009 35.1699 32.4562C34.4204 33.108 33.7264 33.7837 32.7428 34.0558C31.6494 34.3581 30.6102 34.1198 29.6202 33.6248L33.2821 21.3046C33.3735 20.998 33.2462 20.669 32.9727 20.503L29.585 18.4499V12.4558C29.585 12.0677 29.27 11.7527 28.8819 11.7527H27.4756V9.64328C27.4756 9.25516 27.1606 8.94016 26.7725 8.94016H24.5577V6.83078C24.5577 6.44266 24.2427 6.12766 23.8545 6.12766H20.4444V1.20508C20.4444 0.816953 20.1294 0.501953 19.7413 0.501953H16.9288C16.5406 0.501953 16.2256 0.816953 16.2256 1.20508V6.12695H12.8155C12.4274 6.12695 12.1124 6.44195 12.1124 6.83008V8.93945H9.89752C9.50939 8.93945 9.19439 9.25445 9.19439 9.64258V11.752H7.78814C7.40002 11.752 7.08502 12.067 7.08502 12.4551V18.4492L3.69736 20.5016C3.42385 20.6676 3.29658 20.9966 3.38799 21.3032C3.38799 21.3032 7.04072 33.5931 7.04213 33.5988C6.97955 33.3892 5.85455 33.2507 5.65557 33.2247C3.60807 32.9596 2.05135 33.9855 0.576894 35.2673C0.283691 35.5218 0.252754 35.9662 0.507285 36.2594C0.750566 36.5392 1.20338 36.5863 1.49939 36.3283C3.01885 35.0078 4.73166 34.0009 6.74189 35.0057C8.56017 35.9148 10.4431 36.3051 12.3374 35.308C13.8646 34.5044 15.3383 33.8097 17.0434 34.6218L18.7963 35.4564C20.296 36.1708 22.0074 36.1539 23.4931 35.4114C24.4086 34.9537 25.3388 34.3448 26.3844 34.273C27.4095 34.2027 28.3995 34.5845 29.3003 35.0345C30.4899 35.6294 31.8828 35.7482 33.1597 35.384C34.336 35.0486 35.1924 34.2991 36.0938 33.5158C36.387 33.2612 36.418 32.8169 36.1635 32.5237L36.162 32.5251ZM28.3208 33.0609C28.3285 32.8436 26.3492 32.845 26.217 32.8591C24.9964 32.9884 23.941 33.6163 22.8638 34.1549C21.5912 34.7912 20.282 34.6084 19.0388 34.0157V13.7031L31.7802 21.4234L28.3215 33.0609H28.3208ZM28.1788 17.5977L20.8522 13.1589H28.1788V17.5977ZM17.6312 1.9082H19.0374V6.12695H17.6312V1.9082ZM13.5179 7.5332H23.1507V8.93945H13.5179V7.5332ZM10.5999 10.3457H26.0687V11.752H10.5999V10.3457ZM8.49057 13.1582H15.8171L8.49057 17.597V13.1582ZM17.6312 13.7031V33.3456C17.6312 33.2205 16.6285 32.9905 16.4978 32.9617C15.2743 32.6966 13.9602 32.8647 12.8506 33.449C12.0456 33.8723 11.2693 34.3666 10.3482 34.4854C10.3468 34.4854 10.3447 34.4854 10.3433 34.4854C9.80541 34.5508 9.25486 34.5114 8.73455 34.3595L4.88916 21.4227L17.6305 13.7024L17.6312 13.7031Z", fill: "currentColor" })
    ] })
  }
), GP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_2383_69953)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M26.8439 29.5664C25.492 29.5664 24.3926 30.6658 24.3926 32.0177C24.3926 33.3695 25.492 34.4689 26.8439 34.4689C28.1958 34.4689 29.2952 33.3695 29.2952 32.0177C29.2952 30.6658 28.1958 29.5664 26.8439 29.5664ZM26.8439 33.384C26.0904 33.384 25.4766 32.7711 25.4766 32.0167C25.4766 31.2622 26.0894 30.6494 26.8439 30.6494C27.5984 30.6494 28.2112 31.2622 28.2112 32.0167C28.2112 32.7711 27.5984 33.384 26.8439 33.384Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M20.7339 23.437C21.0336 23.437 21.2754 23.1942 21.2754 22.8955V5.2251C21.2754 4.92544 21.0326 4.68359 20.7339 4.68359C20.4352 4.68359 20.1924 4.92641 20.1924 5.2251V22.8945C20.1924 23.1942 20.4352 23.436 20.7339 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M23.3628 23.437C23.6615 23.437 23.9053 23.1942 23.9053 22.8955V5.2251C23.9053 4.92544 23.6625 4.68359 23.3628 4.68359C23.0631 4.68359 22.8213 4.92641 22.8213 5.2251V22.8945C22.8213 23.1942 23.0641 23.436 23.3628 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M25.9907 23.437C26.2904 23.437 26.5323 23.1942 26.5323 22.8955V5.2251C26.5323 4.92544 26.2894 4.68359 25.9907 4.68359C25.692 4.68359 25.4492 4.92641 25.4492 5.2251V22.8945C25.4492 23.1942 25.692 23.436 25.9907 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M28.6196 23.437C28.9193 23.437 29.1612 23.1942 29.1612 22.8955V5.2251C29.1612 4.92544 28.9184 4.68359 28.6196 4.68359C28.3209 4.68359 28.0781 4.92641 28.0781 5.2251V22.8945C28.0781 23.1942 28.3209 23.436 28.6196 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M31.2466 23.437C31.5463 23.437 31.7881 23.1942 31.7881 22.8955V5.2251C31.7881 4.92544 31.5453 4.68359 31.2466 4.68359C30.9479 4.68359 30.7051 4.92641 30.7051 5.2251V22.8945C30.7051 23.1942 30.9479 23.436 31.2466 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M33.8745 23.437C34.1742 23.437 34.4161 23.1942 34.4161 22.8955V5.2251C34.4161 4.92544 34.1732 4.68359 33.8745 4.68359C33.5758 4.68359 33.333 4.92641 33.333 5.2251V22.8945C33.333 23.1942 33.5758 23.436 33.8745 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M16.0483 18.9138C15.8884 18.6614 15.553 18.5862 15.3006 18.7462L11.8279 20.9459C11.5754 21.1059 11.5003 21.4412 11.6602 21.6936C11.8202 21.9461 12.1555 22.0222 12.4079 21.8613L15.8806 19.6615C16.1331 19.5016 16.2083 19.1663 16.0483 18.9138Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M15.3004 23.4497L13.9543 24.3024C13.7018 24.4624 13.6257 24.7977 13.7866 25.0501C13.9466 25.3036 14.2819 25.3778 14.5343 25.2178L15.8805 24.3651C16.1329 24.2051 16.209 23.8698 16.0481 23.6174C15.8882 23.3649 15.5528 23.2888 15.3004 23.4497Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M16.0484 21.2654C15.8885 21.0129 15.5531 20.9378 15.3007 21.0977L12.8908 22.624C12.6384 22.7839 12.5622 23.1192 12.7231 23.3717C12.8831 23.6241 13.2184 23.6993 13.4709 23.5393L15.8808 22.0131C16.1332 21.8531 16.2084 21.5178 16.0484 21.2654Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M2.17802 19.7725L7.35045 20.1387C8.10589 20.1917 8.60212 19.3678 8.20802 18.7261L7.60098 17.7366L12.943 14.4547C13.3882 14.1811 13.5279 13.5991 13.2542 13.154L12.2984 11.5988C12.0247 11.1546 11.4408 11.0149 10.9976 11.2885L5.65554 14.5704L5.04753 13.5808C4.6515 12.9372 3.69275 13.0104 3.39983 13.707L1.38886 18.4862C1.14219 19.072 1.54496 19.7282 2.17899 19.7735L2.17802 19.7725ZM4.28053 14.4056L4.8683 15.3624C5.1063 15.7488 5.61025 15.8682 5.99568 15.6312L11.4456 12.2829L12.2569 13.603L6.807 16.9513C6.42157 17.1873 6.30113 17.6932 6.5372 18.0786L7.12594 19.0354L2.47095 18.7068L4.28149 14.4056H4.28053Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M36.2076 0H28.5703C28.2707 0 28.0288 0.242812 28.0288 0.54151C28.0288 0.840208 28.2716 1.08302 28.5703 1.08302H36.0842V2.62469H17.8372V1.08398H26.041C26.3407 1.08398 26.5825 0.841172 26.5825 0.542474C26.5825 0.243776 26.3397 0.000963542 26.041 0.000963542H17.7138C17.1839 0.000963542 16.7532 0.431667 16.7532 0.961614V2.74995C16.7532 3.18547 17.0451 3.55354 17.4431 3.67109V24.4508C17.1752 24.5298 16.9565 24.7226 16.8418 24.9721L13.8827 26.8472L12.79 25.1224C12.6301 24.87 12.2947 24.7948 12.0423 24.9548C11.7898 25.1147 11.7147 25.45 11.8746 25.7025L12.9673 27.4272C11.9989 28.041 7.66287 30.789 6.95947 31.2342L3.52146 25.8056L5.15375 24.7717L6.49599 26.8915C6.73978 27.2769 7.25143 27.3916 7.63686 27.1478L8.98489 26.2941C9.37031 26.0503 9.48498 25.5387 9.24119 25.1533L7.89895 23.0335L9.53123 21.9996L10.5227 23.5653C10.6827 23.8178 11.018 23.8929 11.2705 23.733C11.5229 23.573 11.599 23.2377 11.4381 22.9853L10.4042 21.3521C10.1074 20.8828 9.4869 20.7441 9.01765 21.0409L2.87491 24.9316C2.40662 25.2284 2.26786 25.8499 2.56368 26.3182L6.04504 31.8142L0.609564 35.2589C-0.185378 35.7628 0.170178 37 1.11447 37H3.51279C3.77199 37 4.02348 36.9268 4.24317 36.788L17.922 28.12H18.1195V31.2929C18.1195 31.9915 18.688 32.559 19.3866 32.559H21.8957C22.1665 35.0527 24.2834 36.999 26.8475 36.999C29.4115 36.999 31.5285 35.0527 31.7993 32.559H35.9041C36.6026 32.559 37.1702 31.9915 37.1702 31.2929V0.960651C37.1702 0.430703 36.7395 0 36.2095 0H36.2076ZM6.9797 23.6135L8.18416 25.5155L7.27166 26.0937L6.06721 24.1916C6.62704 23.8371 6.41987 23.9681 6.9797 23.6135ZM3.65925 35.8727C3.61397 35.9016 3.56193 35.916 3.50894 35.916H1.59433C2.30159 35.468 16.1442 26.6949 16.7522 26.3105V27.1593C16.7522 27.2827 16.7792 27.4176 16.8264 27.5284L3.66022 35.8717L3.65925 35.8727ZM21.8909 31.477H19.3818C19.2816 31.477 19.1997 31.3951 19.1997 31.2949V28.1219H23.7438C22.681 28.9689 22.0297 30.1935 21.8899 31.4779L21.8909 31.477ZM26.8436 35.917C24.6949 35.917 22.946 34.1681 22.946 32.0195C22.946 29.8708 24.6949 28.1219 26.8436 28.1219C28.9924 28.1219 30.7413 29.8698 30.7413 32.0195C30.7413 34.1691 28.9934 35.917 26.8436 35.917ZM36.0833 31.2949C36.0833 31.3951 36.0014 31.477 35.9012 31.477H31.7973C31.6547 30.1646 30.9822 28.9477 29.9434 28.121H36.0833V31.2949ZM36.0833 27.037H17.8362V25.4953H36.0833V27.037ZM36.0833 24.4113H18.5261V3.70964H36.0833V24.4104V24.4113Z", fill: "currentColor" })
    ] })
  }
), WP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_2383_69969)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M2.15098 30.25H15.351C15.6552 30.25 15.901 30.0034 15.901 29.7C15.901 29.3966 15.6552 29.15 15.351 29.15H2.15098C1.84676 29.15 1.60098 28.9042 1.60098 28.6V8.8H7.65098C8.56277 8.8 9.30098 8.0618 9.30098 7.15V1.1H24.151C24.4543 1.1 24.701 1.34578 24.701 1.65V14.85C24.701 15.1542 24.9468 15.4 25.251 15.4C25.5552 15.4 25.801 15.1542 25.801 14.85V1.65C25.801 0.739063 25.0628 0 24.151 0H8.75098C8.60574 0 8.46566 0.0584375 8.36254 0.161563L0.662539 7.86156C0.559414 7.96469 0.500977 8.10477 0.500977 8.25V28.6C0.500977 29.5109 1.24004 30.25 2.15098 30.25ZM7.65098 7.7H2.37871L8.20098 1.87773V7.15C8.20098 7.45422 7.95434 7.7 7.65098 7.7Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M3.25117 24.1992C2.94695 24.1992 2.70117 24.445 2.70117 24.7492V27.4992C2.70117 27.8034 2.94695 28.0492 3.25117 28.0492H6.00117C6.30539 28.0492 6.55117 27.8034 6.55117 27.4992C6.55117 27.195 6.30539 26.9492 6.00117 26.9492H3.80117V24.7492C3.80117 24.445 3.55539 24.1992 3.25117 24.1992Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M23.601 5.49922V2.74922C23.601 2.445 23.3543 2.19922 23.051 2.19922H20.301C19.9976 2.19922 19.751 2.445 19.751 2.74922C19.751 3.05344 19.9976 3.29922 20.301 3.29922H22.501V5.49922C22.501 5.80344 22.7476 6.04922 23.051 6.04922C23.3543 6.04922 23.601 5.80344 23.601 5.49922Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M31.301 16.5H19.201C17.9858 16.5 17.001 17.4848 17.001 18.7V30.8C17.001 32.0152 17.9858 33 19.201 33H31.301C32.5161 33 33.501 32.0152 33.501 30.8V18.7C33.501 17.4848 32.5161 16.5 31.301 16.5ZM28.551 17.6V22.8937C28.551 22.9668 28.5149 23.0347 28.4547 23.0759C28.3946 23.1172 28.3181 23.1249 28.2502 23.0983L25.7417 22.0945C25.4271 21.9691 25.0757 21.9691 24.7611 22.0945L22.2535 23.1009C22.1856 23.1284 22.1082 23.1198 22.0472 23.0785C21.9871 23.0373 21.951 22.9677 21.9518 22.8946V17.6009H28.5518L28.551 17.6ZM32.401 30.8C32.401 31.4076 31.9086 31.9 31.301 31.9H19.201C18.5934 31.9 18.101 31.4076 18.101 30.8V18.7C18.101 18.0924 18.5934 17.6 19.201 17.6H20.851V22.8937C20.851 23.332 21.0684 23.7411 21.4311 23.9869C21.7937 24.2327 22.2552 24.2816 22.6617 24.1192L25.1693 23.1155C25.2226 23.094 25.2811 23.094 25.3343 23.1155L27.8429 24.1192C28.2493 24.2816 28.71 24.2309 29.0718 23.986C29.4336 23.7402 29.651 23.3312 29.651 22.8937V17.6H31.301C31.9086 17.6 32.401 18.0924 32.401 18.7V30.8Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M22.501 29.1504H20.301C19.9976 29.1504 19.751 29.397 19.751 29.7004C19.751 30.0037 19.9976 30.2504 20.301 30.2504H22.501C22.8043 30.2504 23.051 30.0037 23.051 29.7004C23.051 29.397 22.8052 29.1504 22.501 29.1504Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 10.4492H3.80098C3.49762 10.4492 3.25098 10.695 3.25098 10.9992C3.25098 11.3034 3.49762 11.5492 3.80098 11.5492H12.051C12.3552 11.5492 12.601 11.3034 12.601 10.9992C12.601 10.695 12.3543 10.4492 12.051 10.4492Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M22.5012 10.4492H14.2512C13.947 10.4492 13.7012 10.695 13.7012 10.9992C13.7012 11.3034 13.947 11.5492 14.2512 11.5492H22.5012C22.8045 11.5492 23.0512 11.3034 23.0512 10.9992C23.0512 10.695 22.8054 10.4492 22.5012 10.4492Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 12.6504H3.80098C3.49762 12.6504 3.25098 12.897 3.25098 13.2004C3.25098 13.5038 3.49762 13.7504 3.80098 13.7504H12.051C12.3552 13.7504 12.601 13.5038 12.601 13.2004C12.601 12.897 12.3543 12.6504 12.051 12.6504Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M22.5012 12.6504H14.2512C13.947 12.6504 13.7012 12.897 13.7012 13.2004C13.7012 13.5038 13.947 13.7504 14.2512 13.7504H22.5012C22.8045 13.7504 23.0512 13.5038 23.0512 13.2004C23.0512 12.897 22.8054 12.6504 22.5012 12.6504Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 14.8496H3.80098C3.49762 14.8496 3.25098 15.0954 3.25098 15.3996C3.25098 15.7038 3.49762 15.9496 3.80098 15.9496H12.051C12.3552 15.9496 12.601 15.703 12.601 15.3996C12.601 15.0962 12.3543 14.8496 12.051 14.8496Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 17.0508H3.80098C3.49762 17.0508 3.25098 17.2974 3.25098 17.6008C3.25098 17.9041 3.49762 18.1508 3.80098 18.1508H12.051C12.3552 18.1508 12.601 17.905 12.601 17.6008C12.601 17.2966 12.3543 17.0508 12.051 17.0508Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 19.25H3.80098C3.49762 19.25 3.25098 19.4966 3.25098 19.8C3.25098 20.1034 3.49762 20.35 3.80098 20.35H12.051C12.3552 20.35 12.601 20.1034 12.601 19.8C12.601 19.4966 12.3543 19.25 12.051 19.25Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.601 21.9992C12.601 21.695 12.3543 21.4492 12.051 21.4492H3.80098C3.49762 21.4492 3.25098 21.695 3.25098 21.9992C3.25098 22.3034 3.49762 22.5492 3.80098 22.5492H12.051C12.3552 22.5492 12.601 22.3034 12.601 21.9992Z", fill: "currentColor" })
    ] })
  }
), QP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M0.525597 18.8546C0.654764 19.4617 1.18435 19.875 1.79143 19.875C2.83768 19.875 4.87851 18.7383 6.00226 17.6663C7.46185 19.0225 9.11518 19.875 10.8331 19.875C16.1806 19.875 18.5831 15.3412 18.5831 12.125C18.5831 9.99375 16.8393 8.25 14.7081 8.25C12.5768 8.25 10.8331 9.99375 10.8331 12.125C10.8331 13.6233 11.621 15.4317 12.8739 16.9171C12.2927 17.1496 11.621 17.2917 10.8331 17.2917C9.79976 17.2917 8.70185 16.6717 7.66851 15.6771C9.73518 12.6546 10.8331 8.65042 10.8331 5.66667C10.8331 2.68292 8.52101 0.5 5.66643 0.5C2.81185 0.5 0.499764 2.81208 0.499764 5.66667C0.499764 8.52125 1.9981 12.7192 4.28435 15.7417C3.4706 16.5425 2.5406 17.0979 1.52018 17.3175C0.82268 17.4596 0.370597 18.1442 0.525597 18.8417V18.8546ZM14.7081 10.8333C15.4185 10.8333 15.9998 11.4146 15.9998 12.125C15.9998 12.9646 15.6898 14.2433 14.9018 15.3154C13.9331 14.1917 13.4164 12.9129 13.4164 12.125C13.4164 11.4146 13.9977 10.8333 14.7081 10.8333ZM3.0831 5.66667C3.0831 4.24583 4.2456 3.08333 5.66643 3.08333C7.08726 3.08333 8.24976 4.24583 8.24976 5.66667C8.24976 8.03042 7.41018 11.1692 5.93768 13.6104C4.28435 11.195 3.0831 8.05625 3.0831 5.66667ZM18.906 5.48583C19.3839 4.95625 20.1977 4.90458 20.7273 5.3825C21.4377 6.02833 22.0448 6.76458 22.5356 7.60417C22.8973 8.22417 22.6777 9.01208 22.0706 9.37375C21.8639 9.49 21.6443 9.54167 21.4248 9.54167C20.9727 9.54167 20.5464 9.30917 20.301 8.89583C19.9523 8.30167 19.526 7.77208 19.0093 7.30708C18.4798 6.82917 18.4281 6.01542 18.906 5.48583ZM28.9164 19.2808V17.2917C28.9164 14.4371 26.6043 12.125 23.7498 12.125C20.8952 12.125 18.5831 14.4371 18.5831 17.2917V19.2808C17.046 20.1721 15.9998 21.8512 15.9998 23.75V26.3333C15.9998 29.1879 18.3118 31.5 21.1664 31.5H26.3331C29.1877 31.5 31.4998 29.1879 31.4998 26.3333V23.75C31.4998 21.8383 30.4535 20.1721 28.9164 19.2808ZM21.1664 17.2917C21.1664 15.8708 22.3289 14.7083 23.7498 14.7083C25.1706 14.7083 26.3331 15.8708 26.3331 17.2917V18.5833H21.1664V17.2917ZM28.9164 26.3333C28.9164 27.7542 27.7539 28.9167 26.3331 28.9167H21.1664C19.7456 28.9167 18.5831 27.7542 18.5831 26.3333V23.75C18.5831 22.3292 19.7456 21.1667 21.1664 21.1667H26.3331C27.7539 21.1667 28.9164 22.3292 28.9164 23.75V26.3333ZM13.4164 23.75C13.4164 24.4604 12.8352 25.0417 12.1248 25.0417H1.79143C1.08101 25.0417 0.499764 24.4604 0.499764 23.75C0.499764 23.0396 1.08101 22.4583 1.79143 22.4583H12.1248C12.8352 22.4583 13.4164 23.0396 13.4164 23.75ZM25.6873 25.0417C25.6873 26.1137 24.8218 26.9792 23.7498 26.9792C22.6777 26.9792 21.8123 26.1137 21.8123 25.0417C21.8123 23.9696 22.6777 23.1042 23.7498 23.1042C24.8218 23.1042 25.6873 23.9696 25.6873 25.0417Z", fill: "currentColor" })
  }
), UP = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M11.9543 2.06241C13.2808 2.06676 14.5933 2.33415 15.8158 2.8491C17.0383 3.36404 18.1465 4.11633 19.0763 5.06241H15.9543C15.6891 5.06241 15.4347 5.16777 15.2472 5.3553C15.0597 5.54284 14.9543 5.79719 14.9543 6.06241C14.9543 6.32763 15.0597 6.58198 15.2472 6.76952C15.4347 6.95705 15.6891 7.06241 15.9543 7.06241H20.0973C20.5897 7.06214 21.0619 6.86641 21.4101 6.51821C21.7583 6.17002 21.954 5.69784 21.9543 5.20541V1.06241C21.9543 0.797193 21.8489 0.542839 21.6614 0.355303C21.4739 0.167767 21.2195 0.0624097 20.9543 0.0624097C20.6891 0.0624097 20.4347 0.167767 20.2472 0.355303C20.0597 0.542839 19.9543 0.797193 19.9543 1.06241V3.14041C18.3015 1.65186 16.2669 0.652819 14.0784 0.255159C11.8899 -0.142502 9.63393 0.0769217 7.56309 0.888857C5.49225 1.70079 3.68832 3.07318 2.35332 4.85233C1.01831 6.63149 0.204946 8.74715 0.00430406 10.9624C-0.00861256 11.1017 0.00761984 11.2421 0.051967 11.3747C0.0963141 11.5074 0.167804 11.6293 0.26188 11.7328C0.355957 11.8363 0.470558 11.919 0.598382 11.9758C0.726206 12.0325 0.864449 12.062 1.0043 12.0624C1.24889 12.0655 1.48584 11.9772 1.66876 11.8149C1.85169 11.6525 1.96742 11.4276 1.9933 11.1844C2.21592 8.69516 3.36128 6.37911 5.20438 4.69125C7.04749 3.00338 9.45512 2.0657 11.9543 2.06241Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M22.9051 12.0625C22.6605 12.0593 22.4236 12.1476 22.2406 12.31C22.0577 12.4724 21.942 12.6972 21.9161 12.9405C21.7508 14.8437 21.043 16.6596 19.8768 18.1727C18.7105 19.6858 17.1347 20.8326 15.3362 21.477C13.5378 22.1215 11.5923 22.2365 9.73045 21.8086C7.86861 21.3806 6.1686 20.4275 4.8321 19.0625H7.9541C8.21932 19.0625 8.47367 18.9571 8.66121 18.7696C8.84875 18.582 8.9541 18.3277 8.9541 18.0625C8.9541 17.7972 8.84875 17.5429 8.66121 17.3554C8.47367 17.1678 8.21932 17.0625 7.9541 17.0625H3.8111C3.5672 17.0623 3.32566 17.1103 3.1003 17.2035C2.87494 17.2968 2.67018 17.4336 2.49771 17.6061C2.32525 17.7785 2.18847 17.9833 2.09519 18.2087C2.00191 18.434 1.95397 18.6756 1.9541 18.9195V23.0625C1.9541 23.3277 2.05946 23.582 2.24699 23.7696C2.43453 23.9571 2.68889 24.0625 2.9541 24.0625C3.21932 24.0625 3.47367 23.9571 3.66121 23.7696C3.84875 23.582 3.9541 23.3277 3.9541 23.0625V20.9845C5.60693 22.473 7.64151 23.472 9.83 23.8697C12.0185 24.2674 14.2745 24.0479 16.3453 23.236C18.4162 22.4241 20.2201 21.0517 21.5551 19.2725C22.8901 17.4934 23.7035 15.3777 23.9041 13.1625C23.917 13.0232 23.9008 12.8828 23.8564 12.7501C23.8121 12.6175 23.7406 12.4956 23.6465 12.3921C23.5524 12.2886 23.4378 12.2058 23.31 12.1491C23.1822 12.0923 23.045 12.0628 22.9051 12.0625Z", fill: "currentColor" })
] }), ZP = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 41 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M20.5 41C31.8218 41 41 31.8218 41 20.5C41 9.17816 31.8218 0 20.5 0C9.17816 0 0 9.17816 0 20.5C0 31.8218 9.17816 41 20.5 41Z", fill: "#77B3D4" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.2", d: "M7.6875 16.0156V32.0312C7.6875 33.4406 8.84062 34.5938 10.25 34.5938H30.75C32.1594 34.5938 33.3125 33.4406 33.3125 32.0312V16.0156H7.6875Z", fill: "#007AFF" }),
  /* @__PURE__ */ f.jsx("path", { d: "M7.6875 14.7344V30.75C7.6875 32.1594 8.84062 33.3125 10.25 33.3125H30.75C32.1594 33.3125 33.3125 32.1594 33.3125 30.75V14.7344H7.6875Z", fill: "white" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.2", d: "M30.75 8.96875H10.25C8.84062 8.96875 7.6875 10.1219 7.6875 11.5312V16.0156H33.3125V11.5312C33.3125 10.1219 32.1594 8.96875 30.75 8.96875Z", fill: "#007AFF" }),
  /* @__PURE__ */ f.jsx("path", { d: "M30.75 7.6875H10.25C8.84062 7.6875 7.6875 8.84062 7.6875 10.25V14.7344H33.3125V10.25C33.3125 8.84062 32.1594 7.6875 30.75 7.6875Z", fill: "#C75C5C" }),
  /* @__PURE__ */ f.jsx("path", { d: "M20.5 30.75C19.7953 30.75 19.2188 30.1734 19.2188 29.4688C19.2188 25.9453 20.3719 23.3828 21.4609 21.7812H17.2969C16.5922 21.7812 16.0156 21.2047 16.0156 20.5C16.0156 19.7953 16.5922 19.2188 17.2969 19.2188H24.3438C24.9203 19.2188 25.3688 19.6031 25.5609 20.1156C25.7531 20.6281 25.5609 21.2047 25.1125 21.525C24.9844 21.6531 21.7812 24.0234 21.7812 29.4688C21.7812 30.1734 21.2047 30.75 20.5 30.75Z", fill: "white", "fill-opacity": "0.3" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.2", d: "M12.8125 13.4531C12.1078 13.4531 11.5312 12.8766 11.5312 12.1719V7.6875C11.5312 6.98281 12.1078 6.40625 12.8125 6.40625C13.5172 6.40625 14.0938 6.98281 14.0938 7.6875V12.1719C14.0938 12.8766 13.5172 13.4531 12.8125 13.4531Z", fill: "#007AFF" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.2", d: "M28.8281 13.4531C28.1234 13.4531 27.5469 12.8766 27.5469 12.1719V7.6875C27.5469 6.98281 28.1234 6.40625 28.8281 6.40625C29.5328 6.40625 30.1094 6.98281 30.1094 7.6875V12.1719C30.1094 12.8766 29.5328 13.4531 28.8281 13.4531Z", fill: "#007AFF" }),
  /* @__PURE__ */ f.jsx("path", { d: "M12.8125 12.1719C12.1078 12.1719 11.5312 11.5953 11.5312 10.8906V6.40625C11.5312 5.70156 12.1078 5.125 12.8125 5.125C13.5172 5.125 14.0938 5.70156 14.0938 6.40625V10.8906C14.0938 11.5953 13.5172 12.1719 12.8125 12.1719Z", fill: "#E0E0D1" }),
  /* @__PURE__ */ f.jsx("path", { d: "M28.8281 12.1719C28.1234 12.1719 27.5469 11.5953 27.5469 10.8906V6.40625C27.5469 5.70156 28.1234 5.125 28.8281 5.125C29.5328 5.125 30.1094 5.70156 30.1094 6.40625V10.8906C30.1094 11.5953 29.5328 12.1719 28.8281 12.1719Z", fill: "#E0E0D1" })
] }), KP = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("g", { "clip-path": "url(#clip0_280_423)", children: /* @__PURE__ */ f.jsx("path", { d: "M19 2H18V1C18 0.448 17.553 0 17 0C16.447 0 16 0.448 16 1V2H8V1C8 0.448 7.553 0 7 0C6.447 0 6 0.448 6 1V2H5C2.243 2 0 4.243 0 7V19C0 21.757 2.243 24 5 24H19C21.757 24 24 21.757 24 19V7C24 4.243 21.757 2 19 2ZM5 4H19C20.654 4 22 5.346 22 7V8H2V7C2 5.346 3.346 4 5 4ZM19 22H5C3.346 22 2 20.654 2 19V10H22V19C22 20.654 20.654 22 19 22ZM17.832 13.152C18.216 13.549 18.204 14.183 17.807 14.566L13.067 19.134C12.514 19.687 11.76 20 10.959 20C10.158 20 9.404 19.688 8.838 19.121L6.586 17.029C6.182 16.653 6.158 16.02 6.534 15.616C6.912 15.211 7.544 15.189 7.947 15.564L10.225 17.681C10.658 18.111 11.288 18.083 11.664 17.707L16.418 13.125C16.816 12.742 17.448 12.754 17.832 13.151V13.152Z", fill: "currentColor" }) }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_280_423", children: /* @__PURE__ */ f.jsx("rect", { width: "24", height: "24", fill: "currentColor" }) }) })
] }), zP = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("g", { "clip-path": "url(#clip0_280_421)", children: /* @__PURE__ */ f.jsx("path", { d: "M15.707 13.707L13.414 16L15.707 18.293C16.098 18.684 16.098 19.316 15.707 19.707C15.512 19.902 15.256 20 15 20C14.744 20 14.488 19.902 14.293 19.707L12 17.414L9.707 19.707C9.512 19.902 9.256 20 9 20C8.744 20 8.488 19.902 8.293 19.707C7.902 19.316 7.902 18.684 8.293 18.293L10.586 16L8.293 13.707C7.902 13.316 7.902 12.684 8.293 12.293C8.684 11.902 9.316 11.902 9.707 12.293L12 14.586L14.293 12.293C14.684 11.902 15.316 11.902 15.707 12.293C16.098 12.684 16.098 13.316 15.707 13.707ZM24 7V19C24 21.757 21.757 24 19 24H5C2.243 24 0 21.757 0 19V7C0 4.243 2.243 2 5 2H6V1C6 0.447 6.448 0 7 0C7.552 0 8 0.447 8 1V2H16V1C16 0.447 16.448 0 17 0C17.552 0 18 0.447 18 1V2H19C21.757 2 24 4.243 24 7ZM2 7V8H22V7C22 5.346 20.654 4 19 4H5C3.346 4 2 5.346 2 7ZM22 19V10H2V19C2 20.654 3.346 22 5 22H19C20.654 22 22 20.654 22 19Z", fill: "currentColor" }) }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_280_421", children: /* @__PURE__ */ f.jsx("rect", { width: "24", height: "24", fill: "currentColor" }) }) })
] }), qP = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("g", { "clip-path": "url(#clip0_280_419)", children: /* @__PURE__ */ f.jsx("path", { d: "M19 2H18V1C18 0.448 17.552 0 17 0C16.448 0 16 0.448 16 1V2H8V1C8 0.448 7.552 0 7 0C6.448 0 6 0.448 6 1V2H5C2.243 2 0 4.243 0 7V19C0 21.757 2.243 24 5 24H19C21.757 24 24 21.757 24 19V7C24 4.243 21.757 2 19 2ZM19 22H5C3.346 22 2 20.654 2 19V10H8C8.552 10 9 9.552 9 9C9 8.448 8.552 8 8 8H2V7C2 5.346 3.346 4 5 4H19C20.654 4 22 5.346 22 7V8H16C15.448 8 15 8.448 15 9C15 9.552 15.448 10 16 10H22V19C22 20.654 20.654 22 19 22ZM13 9V16C13 16.552 12.552 17 12 17C11.448 17 11 16.552 11 16V9C11 8.448 11.448 8 12 8C12.552 8 13 8.448 13 9ZM13 19C13 19.552 12.552 20 12 20C11.448 20 11 19.552 11 19C11 18.448 11.448 18 12 18C12.552 18 13 18.448 13 19Z", fill: "currentColor" }) }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_280_419", children: /* @__PURE__ */ f.jsx("rect", { width: "24", height: "24", fill: "currentColor" }) }) })
] }), XP = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsxs("g", { children: [
    /* @__PURE__ */ f.jsx("path", { d: "M19.1666 13.3334C18.9456 13.3334 18.7337 13.4212 18.5774 13.5775C18.4211 13.7337 18.3333 13.9457 18.3333 14.1667V15.8334C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1322 18.07 16.4964 18.3334 15.8333 18.3334H14.1666C13.9456 18.3334 13.7337 18.4212 13.5774 18.5775C13.4211 18.7337 13.3333 18.9457 13.3333 19.1667C13.3333 19.3877 13.4211 19.5997 13.5774 19.756C13.7337 19.9122 13.9456 20 14.1666 20H15.8333C16.938 19.9987 17.997 19.5593 18.7781 18.7782C19.5592 17.9971 19.9987 16.938 20 15.8334V14.1667C20 13.9457 19.9122 13.7337 19.7559 13.5775C19.5996 13.4212 19.3877 13.3334 19.1666 13.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M0.833333 6.66667C1.05435 6.66667 1.26631 6.57887 1.42259 6.42259C1.57887 6.26631 1.66667 6.05435 1.66667 5.83333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H5.83333C6.05435 1.66667 6.26631 1.57887 6.42259 1.42259C6.57887 1.26631 6.66667 1.05435 6.66667 0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0L4.16667 0C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 5.83333C0 6.05435 0.0877974 6.26631 0.244078 6.42259C0.400358 6.57887 0.61232 6.66667 0.833333 6.66667Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M5.83333 18.3334H4.16667C3.50363 18.3334 2.86774 18.07 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8334V14.1667C1.66667 13.9457 1.57887 13.7337 1.42259 13.5775C1.26631 13.4212 1.05435 13.3334 0.833333 13.3334C0.61232 13.3334 0.400358 13.4212 0.244078 13.5775C0.0877974 13.7337 0 13.9457 0 14.1667L0 15.8334C0.00132321 16.938 0.440735 17.9971 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H5.83333C6.05435 20 6.26631 19.9122 6.42259 19.756C6.57887 19.5997 6.66667 19.3877 6.66667 19.1667C6.66667 18.9457 6.57887 18.7337 6.42259 18.5775C6.26631 18.4212 6.05435 18.3334 5.83333 18.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M15.8333 0H14.1666C13.9456 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333C13.3333 1.05435 13.4211 1.26631 13.5774 1.42259C13.7337 1.57887 13.9456 1.66667 14.1666 1.66667H15.8333C16.4964 1.66667 17.1322 1.93006 17.6011 2.3989C18.0699 2.86774 18.3333 3.50363 18.3333 4.16667V5.83333C18.3333 6.05435 18.4211 6.26631 18.5774 6.42259C18.7337 6.57887 18.9456 6.66667 19.1666 6.66667C19.3877 6.66667 19.5996 6.57887 19.7559 6.42259C19.9122 6.26631 20 6.05435 20 5.83333V4.16667C19.9987 3.062 19.5592 2.00296 18.7781 1.22185C17.997 0.440735 16.938 0.00132321 15.8333 0Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M10 9.16667C10.6593 9.16667 11.3038 8.97117 11.8519 8.6049C12.4001 8.23863 12.8273 7.71803 13.0796 7.10895C13.3319 6.49986 13.3979 5.82964 13.2693 5.18303C13.1407 4.53643 12.8232 3.94249 12.357 3.47631C11.8909 3.01014 11.2969 2.69267 10.6503 2.56405C10.0037 2.43543 9.3335 2.50144 8.72441 2.75374C8.11532 3.00603 7.59473 3.43327 7.22846 3.98143C6.86218 4.5296 6.66669 5.17406 6.66669 5.83334C6.66669 6.71739 7.01788 7.56524 7.643 8.19036C8.26812 8.81548 9.11597 9.16667 10 9.16667ZM10 4.16667C10.3297 4.16667 10.6519 4.26442 10.926 4.44755C11.2001 4.63069 11.4137 4.89099 11.5398 5.19553C11.666 5.50007 11.699 5.83518 11.6347 6.15849C11.5704 6.48179 11.4116 6.77876 11.1785 7.01185C10.9454 7.24493 10.6485 7.40367 10.3252 7.46798C10.0019 7.53229 9.66676 7.49928 9.36222 7.37313C9.05767 7.24699 8.79737 7.03337 8.61424 6.75929C8.4311 6.4852 8.33335 6.16297 8.33335 5.83334C8.33335 5.39131 8.50895 4.96738 8.82151 4.65482C9.13407 4.34226 9.55799 4.16667 10 4.16667Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M15 16.6667C15.221 16.6667 15.433 16.5789 15.5893 16.4226C15.7456 16.2664 15.8334 16.0544 15.8334 15.8334C15.832 14.5077 15.3048 13.2367 14.3674 12.2993C13.43 11.3619 12.159 10.8347 10.8334 10.8334H9.16669C7.84101 10.8347 6.57001 11.3619 5.63262 12.2993C4.69522 13.2367 4.16801 14.5077 4.16669 15.8334C4.16669 16.0544 4.25448 16.2664 4.41076 16.4226C4.56705 16.5789 4.77901 16.6667 5.00002 16.6667C5.22103 16.6667 5.433 16.5789 5.58928 16.4226C5.74556 16.2664 5.83335 16.0544 5.83335 15.8334C5.83335 14.9493 6.18454 14.1015 6.80966 13.4764C7.43479 12.8512 8.28263 12.5 9.16669 12.5H10.8334C11.7174 12.5 12.5653 12.8512 13.1904 13.4764C13.8155 14.1015 14.1667 14.9493 14.1667 15.8334C14.1667 16.0544 14.2545 16.2664 14.4108 16.4226C14.567 16.5789 14.779 16.6667 15 16.6667Z", fill: "currentColor" })
  ] }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_213_175", children: /* @__PURE__ */ f.jsx("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
] }), JP = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0" }),
  /* @__PURE__ */ f.jsx("path", { d: "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" }),
  /* @__PURE__ */ f.jsx("path", { d: "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" })
] }), ej = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z", fill: "currentColor" })
] }), tj = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M5.5 10.3125C2.84213 10.3125 0.6875 8.15787 0.6875 5.5C0.6875 2.84213 2.84213 0.6875 5.5 0.6875C8.15787 0.6875 10.3125 2.84213 10.3125 5.5C10.3125 8.15787 8.15787 10.3125 5.5 10.3125ZM5.5 11C8.53757 11 11 8.53757 11 5.5C11 2.46243 8.53757 0 5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11Z",
    fill: "currentColor"
  }
) }), rj = () => /* @__PURE__ */ f.jsx("svg", { width: "21", height: "21", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M11.8773 0.570516C11.1167 -0.190171 9.88334 -0.190173 9.12265 0.570515L0.570516 9.12265C-0.190171 9.88334 -0.190173 11.1167 0.570515 11.8773L9.12265 20.4295C9.88334 21.1902 11.1167 21.1902 11.8773 20.4295L20.4295 11.8773C21.1902 11.1167 21.1902 9.88334 20.4295 9.12265L11.8773 0.570516ZM10.5 5.24996C11.2027 5.24996 11.7518 5.85671 11.6819 6.55595L11.2215 11.1595C11.1845 11.5302 10.8725 11.8125 10.5 11.8125C10.1275 11.8125 9.81552 11.5302 9.77845 11.1595L9.3181 6.55595C9.24817 5.85671 9.79727 5.24996 10.5 5.24996ZM10.502 13.125C11.2269 13.125 11.8145 13.7126 11.8145 14.4375C11.8145 15.1623 11.2269 15.75 10.502 15.75C9.77715 15.75 9.18952 15.1623 9.18952 14.4375C9.18952 13.7126 9.77715 13.125 10.502 13.125Z",
    fill: "#E52E2E"
  }
) }), nj = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    children: [
      /* @__PURE__ */ f.jsx("path", { d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4.5a.5.5 0 0 1-1 0V5.383l-7 4.2-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-1.99zm1 7.105 4.708-2.897L1 5.383zM1 4v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.354-5.354 1.25 1.25a.5.5 0 0 1-.708.708L13 12.207V14a.5.5 0 0 1-1 0v-1.717l-.28.305a.5.5 0 0 1-.737-.676l1.149-1.25a.5.5 0 0 1 .722-.016" })
    ]
  }
), aj = () => /* @__PURE__ */ f.jsx("svg", { fill: "none", viewBox: "0 0 25 25", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M10.5426 23.0627C10.5426 23.6157 10.0956 24.0627 9.54257 24.0627H5.54257C2.78557 24.0627 0.542572 21.8197 0.542572 19.0627V5.06274C0.542572 2.30574 2.78557 0.0627441 5.54257 0.0627441H13.5426C16.2996 0.0627441 18.5426 2.30574 18.5426 5.06274V7.06274C18.5426 7.61574 18.0956 8.06274 17.5426 8.06274C16.9896 8.06274 16.5426 7.61574 16.5426 7.06274V5.06274C16.5426 3.40874 15.1966 2.06274 13.5426 2.06274H5.54257C3.88857 2.06274 2.54257 3.40874 2.54257 5.06274V19.0627C2.54257 20.7167 3.88857 22.0627 5.54257 22.0627H9.54257C10.0956 22.0627 10.5426 22.5097 10.5426 23.0627ZM14.5426 6.06274C14.5426 5.50974 14.0956 5.06274 13.5426 5.06274H5.54257C4.98957 5.06274 4.54257 5.50974 4.54257 6.06274C4.54257 6.61574 4.98957 7.06274 5.54257 7.06274H13.5426C14.0956 7.06274 14.5426 6.61574 14.5426 6.06274ZM10.5426 11.0627C10.5426 10.5097 10.0956 10.0627 9.54257 10.0627H5.54257C4.98957 10.0627 4.54257 10.5097 4.54257 11.0627C4.54257 11.6157 4.98957 12.0627 5.54257 12.0627H9.54257C10.0956 12.0627 10.5426 11.6157 10.5426 11.0627ZM5.54257 15.0627C4.98957 15.0627 4.54257 15.5097 4.54257 16.0627C4.54257 16.6157 4.98957 17.0627 5.54257 17.0627H7.54257C8.09557 17.0627 8.54257 16.6157 8.54257 16.0627C8.54257 15.5097 8.09557 15.0627 7.54257 15.0627H5.54257ZM24.5426 17.0627C24.5426 20.9217 21.4016 24.0627 17.5426 24.0627C13.6836 24.0627 10.5426 20.9217 10.5426 17.0627C10.5426 13.2037 13.6836 10.0627 17.5426 10.0627C21.4016 10.0627 24.5426 13.2037 24.5426 17.0627ZM22.5426 17.0627C22.5426 14.3057 20.2996 12.0627 17.5426 12.0627C14.7856 12.0627 12.5426 14.3057 12.5426 17.0627C12.5426 19.8197 14.7856 22.0627 17.5426 22.0627C20.2996 22.0627 22.5426 19.8197 22.5426 17.0627ZM19.3506 15.8217L17.1276 17.9557C16.9836 18.0967 16.7486 18.0997 16.6056 17.9577L15.4746 16.8497C15.0786 16.4617 14.4466 16.4677 14.0606 16.8637C13.6736 17.2587 13.6796 17.8907 14.0746 18.2777L15.2066 19.3867C15.6666 19.8357 16.2686 20.0607 16.8696 20.0607C17.4706 20.0607 18.0706 19.8357 18.5226 19.3897L20.7356 17.2657C21.1336 16.8827 21.1466 16.2497 20.7646 15.8517C20.3816 15.4517 19.7476 15.4407 19.3506 15.8227V15.8217Z",
    fill: "currentColor"
  }
) }), ij = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z", fill: "currentColor" })
] }), oj = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1", fill: "currentColor" })
] }), sj = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z", fill: "currentColor" })
] }), lj = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsxs("g", { children: [
    /* @__PURE__ */ f.jsx("path", { d: "M19.1666 13.3334C18.9456 13.3334 18.7337 13.4212 18.5774 13.5775C18.4211 13.7337 18.3333 13.9457 18.3333 14.1667V15.8334C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1322 18.07 16.4964 18.3334 15.8333 18.3334H14.1666C13.9456 18.3334 13.7337 18.4212 13.5774 18.5775C13.4211 18.7337 13.3333 18.9457 13.3333 19.1667C13.3333 19.3877 13.4211 19.5997 13.5774 19.756C13.7337 19.9122 13.9456 20 14.1666 20H15.8333C16.938 19.9987 17.997 19.5593 18.7781 18.7782C19.5592 17.9971 19.9987 16.938 20 15.8334V14.1667C20 13.9457 19.9122 13.7337 19.7559 13.5775C19.5996 13.4212 19.3877 13.3334 19.1666 13.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M0.833333 6.66667C1.05435 6.66667 1.26631 6.57887 1.42259 6.42259C1.57887 6.26631 1.66667 6.05435 1.66667 5.83333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H5.83333C6.05435 1.66667 6.26631 1.57887 6.42259 1.42259C6.57887 1.26631 6.66667 1.05435 6.66667 0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0L4.16667 0C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 5.83333C0 6.05435 0.0877974 6.26631 0.244078 6.42259C0.400358 6.57887 0.61232 6.66667 0.833333 6.66667Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M5.83333 18.3334H4.16667C3.50363 18.3334 2.86774 18.07 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8334V14.1667C1.66667 13.9457 1.57887 13.7337 1.42259 13.5775C1.26631 13.4212 1.05435 13.3334 0.833333 13.3334C0.61232 13.3334 0.400358 13.4212 0.244078 13.5775C0.0877974 13.7337 0 13.9457 0 14.1667L0 15.8334C0.00132321 16.938 0.440735 17.9971 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H5.83333C6.05435 20 6.26631 19.9122 6.42259 19.756C6.57887 19.5997 6.66667 19.3877 6.66667 19.1667C6.66667 18.9457 6.57887 18.7337 6.42259 18.5775C6.26631 18.4212 6.05435 18.3334 5.83333 18.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M15.8333 0H14.1666C13.9456 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333C13.3333 1.05435 13.4211 1.26631 13.5774 1.42259C13.7337 1.57887 13.9456 1.66667 14.1666 1.66667H15.8333C16.4964 1.66667 17.1322 1.93006 17.6011 2.3989C18.0699 2.86774 18.3333 3.50363 18.3333 4.16667V5.83333C18.3333 6.05435 18.4211 6.26631 18.5774 6.42259C18.7337 6.57887 18.9456 6.66667 19.1666 6.66667C19.3877 6.66667 19.5996 6.57887 19.7559 6.42259C19.9122 6.26631 20 6.05435 20 5.83333V4.16667C19.9987 3.062 19.5592 2.00296 18.7781 1.22185C17.997 0.440735 16.938 0.00132321 15.8333 0Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M10 9.16667C10.6593 9.16667 11.3038 8.97117 11.8519 8.6049C12.4001 8.23863 12.8273 7.71803 13.0796 7.10895C13.3319 6.49986 13.3979 5.82964 13.2693 5.18303C13.1407 4.53643 12.8232 3.94249 12.357 3.47631C11.8909 3.01014 11.2969 2.69267 10.6503 2.56405C10.0037 2.43543 9.3335 2.50144 8.72441 2.75374C8.11532 3.00603 7.59473 3.43327 7.22846 3.98143C6.86218 4.5296 6.66669 5.17406 6.66669 5.83334C6.66669 6.71739 7.01788 7.56524 7.643 8.19036C8.26812 8.81548 9.11597 9.16667 10 9.16667ZM10 4.16667C10.3297 4.16667 10.6519 4.26442 10.926 4.44755C11.2001 4.63069 11.4137 4.89099 11.5398 5.19553C11.666 5.50007 11.699 5.83518 11.6347 6.15849C11.5704 6.48179 11.4116 6.77876 11.1785 7.01185C10.9454 7.24493 10.6485 7.40367 10.3252 7.46798C10.0019 7.53229 9.66676 7.49928 9.36222 7.37313C9.05767 7.24699 8.79737 7.03337 8.61424 6.75929C8.4311 6.4852 8.33335 6.16297 8.33335 5.83334C8.33335 5.39131 8.50895 4.96738 8.82151 4.65482C9.13407 4.34226 9.55799 4.16667 10 4.16667Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M15 16.6667C15.221 16.6667 15.433 16.5789 15.5893 16.4226C15.7456 16.2664 15.8334 16.0544 15.8334 15.8334C15.832 14.5077 15.3048 13.2367 14.3674 12.2993C13.43 11.3619 12.159 10.8347 10.8334 10.8334H9.16669C7.84101 10.8347 6.57001 11.3619 5.63262 12.2993C4.69522 13.2367 4.16801 14.5077 4.16669 15.8334C4.16669 16.0544 4.25448 16.2664 4.41076 16.4226C4.56705 16.5789 4.77901 16.6667 5.00002 16.6667C5.22103 16.6667 5.433 16.5789 5.58928 16.4226C5.74556 16.2664 5.83335 16.0544 5.83335 15.8334C5.83335 14.9493 6.18454 14.1015 6.80966 13.4764C7.43479 12.8512 8.28263 12.5 9.16669 12.5H10.8334C11.7174 12.5 12.5653 12.8512 13.1904 13.4764C13.8155 14.1015 14.1667 14.9493 14.1667 15.8334C14.1667 16.0544 14.2545 16.2664 14.4108 16.4226C14.567 16.5789 14.779 16.6667 15 16.6667Z", fill: "currentColor" })
  ] }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_213_175", children: /* @__PURE__ */ f.jsx("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
] }), cj = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 25 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M10 1.25C11.3807 1.25 12.5 2.36929 12.5 3.75V6.25H7.50002V3.75C7.50002 2.36929 8.6193 1.25 10 1.25ZM13.75 6.25V3.75C13.75 1.67893 12.0711 0 10 0C7.92895 0 6.25002 1.67893 6.25002 3.75V6.25H4.2015C3.27338 6.25 2.48492 6.92901 2.34724 7.84686L1.06256 16.4114C0.77915 18.3008 2.24246 20 4.15298 20H15.847C17.7576 20 19.2209 18.3008 18.9375 16.4114L17.6528 7.84686C17.5151 6.92901 16.7266 6.25 15.7985 6.25H13.75ZM12.5 7.5V9.375C12.5 9.72018 12.7798 10 13.125 10C13.4702 10 13.75 9.72018 13.75 9.375V7.5H15.7985C16.1079 7.5 16.3707 7.72634 16.4166 8.03229L17.7013 16.5969C17.8713 17.7305 16.9934 18.75 15.847 18.75H4.15298C3.00667 18.75 2.12868 17.7305 2.29873 16.5969L3.58342 8.03229C3.62931 7.72634 3.89213 7.5 4.2015 7.5H6.25002V9.375C6.25002 9.72018 6.52984 10 6.87502 10C7.22019 10 7.50002 9.72018 7.50002 9.375V7.5H12.5Z",
    fill: "currentColor"
  }
) }), uj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-.5-13h-1v6h4v-1.5h-2.5z",
        fill: "currentColor"
      }
    )
  }
), dj = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M27.5 32.5C34.4036 32.5 40 26.9036 40 20C40 13.0964 34.4036 7.5 27.5 7.5C21.0183 7.5 15.6889 12.4333 15.0617 18.75H10C10 16.6789 8.32107 15 6.25 15H3.75C1.67893 15 0 16.6789 0 18.75V21.25C0 23.3211 1.67893 25 3.75 25H6.25C8.32107 25 10 23.3211 10 21.25H15.0617C15.6889 27.5667 21.0183 32.5 27.5 32.5ZM28.75 13.75V18.75H33.75C34.4404 18.75 35 19.3096 35 20C35 20.6904 34.4404 21.25 33.75 21.25H28.75V26.25C28.75 26.9404 28.1904 27.5 27.5 27.5C26.8096 27.5 26.25 26.9404 26.25 26.25V21.25H21.25C20.5596 21.25 20 20.6904 20 20C20 19.3096 20.5596 18.75 21.25 18.75H26.25V13.75C26.25 13.0596 26.8096 12.5 27.5 12.5C28.1904 12.5 28.75 13.0596 28.75 13.75Z", fill: "currentColor" }) }), fj = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.6 26.6 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.93.93 0 0 1-.765.935c-.845.147-2.34.346-4.235.346s-3.39-.2-4.235-.346A.93.93 0 0 1 3 9.219zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a25 25 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25 25 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2zM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5",
      fill: "currentColor"
    }
  )
] }), hj = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 42 43", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M39.3165 20.6978H38.0635V20.3025C38.0635 19.4986 37.424 18.8445 36.6378 18.8445H35.7683C34.9823 18.8445 34.3428 19.4986 34.3428 20.3025V20.6978H31.0829V20.3025C31.0829 19.5536 30.5277 18.9353 29.8163 18.8542V1.15577C29.8163 0.793593 29.5296 0.5 29.1761 0.5H1.39019C1.03662 0.5 0.75 0.793593 0.75 1.15577V41.8442C0.75 42.2064 1.03662 42.5 1.39019 42.5H39.3165C40.6583 42.5 41.75 41.4526 41.75 40.1654V23.0301C41.7499 21.744 40.6583 20.6978 39.3165 20.6978ZM35.6231 20.3024C35.6231 20.223 35.6896 20.1559 35.7683 20.1559H36.6378C36.7165 20.1559 36.7831 20.223 36.7831 20.3024V22.8905C36.7831 22.9699 36.7165 23.037 36.6378 23.037H35.7683C35.6897 23.037 35.6231 22.9699 35.6231 22.8905V20.3024ZM34.3427 22.0093V22.8905C34.3427 23.6944 34.9821 24.3485 35.7682 24.3485H36.6377C37.4238 24.3485 38.0634 23.6944 38.0634 22.8905V22.0093H39.3164C39.9522 22.0093 40.4695 22.4672 40.4695 23.0301V25.4321H18.3318V23.0301C18.3318 22.4672 18.8491 22.0093 19.485 22.0093H20.3816V22.8905C20.3816 23.6944 21.0212 24.3485 21.8073 24.3485H22.6767C23.4628 24.3485 24.1023 23.6944 24.1023 22.8905V22.0093H27.3621V22.8905C27.3621 23.6944 28.0016 24.3485 28.7878 24.3485H29.6571C30.4432 24.3485 31.0829 23.6944 31.0829 22.8905V22.0093H34.3427ZM21.6621 22.8905V20.3024C21.6621 20.223 21.7285 20.1559 21.8073 20.1559H22.6767C22.7554 20.1559 22.8219 20.223 22.8219 20.3024V22.8905C22.8219 22.9699 22.7555 23.037 22.6767 23.037H21.8073C21.7285 23.037 21.6621 22.9699 21.6621 22.8905ZM29.6571 20.156C29.7359 20.156 29.8024 20.2231 29.8024 20.3025V22.8906C29.8024 22.97 29.7359 23.037 29.6571 23.037H28.7878C28.7091 23.037 28.6426 22.97 28.6426 22.8906V20.3025C28.6426 20.2231 28.7091 20.156 28.7878 20.156H29.6571ZM2.03038 1.81153H28.5358V18.8687C27.8697 18.991 27.3622 19.5866 27.3622 20.3025V20.6978H24.1024V20.3025C24.1024 19.4986 23.4629 18.8445 22.6768 18.8445H21.8073C21.0213 18.8445 20.3817 19.4986 20.3817 20.3025V20.6978H19.4851C18.1432 20.6978 17.0514 21.744 17.0514 23.0301V40.1654C17.0514 40.5322 17.1403 40.8794 17.2981 41.1886H2.03038V1.81153ZM39.3165 41.1885H19.485C18.8599 41.1885 18.3318 40.72 18.3318 40.1654V26.7437H40.4696V40.1654C40.4695 40.7295 39.9523 41.1885 39.3165 41.1885ZM24.9264 28.7549H21.6392C21.2857 28.7549 20.9991 29.0485 20.9991 29.4107V32.7755C20.9991 33.1377 21.2857 33.4313 21.6392 33.4313H24.9264C25.2799 33.4313 25.5665 33.1377 25.5665 32.7755V29.4107C25.5665 29.0486 25.2799 28.7549 24.9264 28.7549ZM24.2862 32.1197H22.2794V30.0665H24.2862V32.1197ZM30.9875 28.7549H27.7026C27.349 28.7549 27.0624 29.0485 27.0624 29.4107V32.7755C27.0624 33.1377 27.349 33.4313 27.7026 33.4313H30.9875C31.3411 33.4313 31.6277 33.1377 31.6277 32.7755V29.4107C31.6277 29.0486 31.3411 28.7549 30.9875 28.7549ZM30.3473 32.1197H28.3429V30.0665H30.3473V32.1197ZM24.9264 34.5008H21.6392C21.2857 34.5008 20.9991 34.7944 20.9991 35.1566V38.5214C20.9991 38.8835 21.2857 39.1771 21.6392 39.1771H24.9264C25.2799 39.1771 25.5665 38.8835 25.5665 38.5214V35.1566C25.5665 34.7944 25.2799 34.5008 24.9264 34.5008ZM24.2862 37.8656H22.2794V35.8124H24.2862V37.8656ZM30.9875 34.5008H27.7026C27.349 34.5008 27.0624 34.7944 27.0624 35.1566V38.5214C27.0624 38.8835 27.349 39.1771 27.7026 39.1771H30.9875C31.3411 39.1771 31.6277 38.8835 31.6277 38.5214V35.1566C31.6277 34.7944 31.3411 34.5008 30.9875 34.5008ZM30.3473 37.8656H28.3429V35.8124H30.3473V37.8656ZM37.1644 28.7549H33.8774C33.5238 28.7549 33.2372 29.0485 33.2372 29.4107V32.7755C33.2372 33.1377 33.5238 33.4313 33.8774 33.4313H37.1644C37.518 33.4313 37.8046 33.1377 37.8046 32.7755V29.4107C37.8046 29.0486 37.518 28.7549 37.1644 28.7549ZM36.5242 32.1197H34.5176V30.0665H36.5242V32.1197ZM37.1644 34.5008H33.8774C33.5238 34.5008 33.2372 34.7944 33.2372 35.1566V38.5214C33.2372 38.8835 33.5238 39.1771 33.8774 39.1771H37.1644C37.518 39.1771 37.8046 38.8835 37.8046 38.5214V35.1566C37.8046 34.7944 37.518 34.5008 37.1644 34.5008ZM36.5242 37.8656H34.5176V35.8124H36.5242V37.8656ZM4.67938 12.2289V5.18084C4.67938 4.81867 4.966 4.52507 5.31957 4.52507H12.7588C13.1123 4.52507 13.399 4.81867 13.399 5.18084C13.399 5.54301 13.1123 5.83661 12.7588 5.83661H5.95976V11.5732H12.1185V9.57752L10.9279 10.6845C10.8056 10.7982 10.6515 10.8548 10.4977 10.8548C10.3337 10.8548 10.1699 10.7905 10.0453 10.6631L8.58562 9.17015C8.33544 8.91429 8.33512 8.49904 8.58498 8.24277C8.8346 7.98651 9.24006 7.98618 9.49032 8.24204L10.5187 9.29377L13.6087 6.42076C13.8705 6.17737 14.2752 6.1973 14.513 6.46555C14.7506 6.73371 14.7311 7.14838 14.4693 7.39185L13.399 8.38699V12.2289C13.399 12.5911 13.1123 12.8846 12.7588 12.8846H5.31957C4.966 12.8846 4.67938 12.5911 4.67938 12.2289ZM4.67938 25.0229V17.9771C4.67938 17.615 4.966 17.3214 5.31957 17.3214H12.7588C13.1123 17.3214 13.399 17.615 13.399 17.9771C13.399 18.3393 13.1123 18.6329 12.7588 18.6329H5.95976V24.3671H12.1185V22.3737L10.9279 23.4808C10.8056 23.5945 10.6515 23.651 10.4977 23.651C10.3335 23.651 10.1696 23.5867 10.045 23.4588L8.5853 21.9636C8.33528 21.7075 8.33528 21.2924 8.5853 21.0363C8.83524 20.7802 9.2407 20.7802 9.49065 21.0363L10.519 22.0896L13.6087 19.217C13.8705 18.9735 14.2752 18.9935 14.513 19.2618C14.7506 19.5299 14.7311 19.9446 14.4693 20.1881L13.399 21.1832V25.0229C13.399 25.385 13.1123 25.6786 12.7588 25.6786H5.31957C4.966 25.6786 4.67938 25.385 4.67938 25.0229ZM14.5132 32.0583C14.7507 32.3265 14.731 32.7412 14.469 32.9845L13.399 33.9787V37.8191C13.399 38.1813 13.1123 38.4748 12.7588 38.4748H5.31957C4.966 38.4748 4.67938 38.1813 4.67938 37.8191V30.7733C4.67938 30.4112 4.966 30.1176 5.31957 30.1176H12.7588C13.1123 30.1176 13.399 30.4112 13.399 30.7733C13.399 31.1355 13.1123 31.4291 12.7588 31.4291H5.95976V37.1632H12.1185V35.1683L10.9277 36.2747C10.8055 36.3884 10.6515 36.4448 10.4977 36.4448C10.3337 36.4448 10.1699 36.3806 10.0453 36.253L8.58562 34.7601C8.33544 34.5042 8.33512 34.089 8.58498 33.8327C8.8346 33.5765 9.24006 33.5761 9.49032 33.8321L10.5188 34.884L13.6089 32.0129C13.8707 31.7697 14.2755 31.7899 14.5132 32.0583ZM17.0513 5.18084C17.0513 4.81867 17.338 4.52507 17.6915 4.52507H26.016C26.3695 4.52507 26.6562 4.81867 26.6562 5.18084C26.6562 5.54301 26.3695 5.83661 26.016 5.83661H17.6915C17.338 5.83661 17.0513 5.54301 17.0513 5.18084ZM17.0513 8.70371C17.0513 8.34154 17.338 8.04795 17.6915 8.04795H26.016C26.3695 8.04795 26.6562 8.34154 26.6562 8.70371C26.6562 9.06589 26.3695 9.35948 26.016 9.35948H17.6915C17.338 9.35948 17.0513 9.06589 17.0513 8.70371Z",
    fill: "currentColor"
  }
) }), Aj = () => /* @__PURE__ */ f.jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M11 23C11 23.55 10.55 24 10 24H6C3.24 24 1 21.76 1 19V5C1 2.24 3.24 0 6 0H14C16.76 0 19 2.24 19 5V8C19 8.55 18.55 9 18 9C17.45 9 17 8.55 17 8V5C17 3.35 15.65 2 14 2H6C4.35 2 3 3.35 3 5V19C3 20.65 4.35 22 6 22H10C10.55 22 11 22.45 11 23Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M15 6C15 5.45 14.55 5 14 5H6C5.45 5 5 5.45 5 6C5 6.55 5.45 7 6 7H14C14.55 7 15 6.55 15 6Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M10 11C10 10.45 9.55 10 9 10H6C5.45 10 5 10.45 5 11C5 11.55 5.45 12 6 12H9C9.55 12 10 11.55 10 11Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M6 15C5.45 15 5 15.45 5 16C5 16.55 5.45 17 6 17H8C8.55 17 9 16.55 9 16C9 15.45 8.55 15 8 15H6Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M18.74 24C17.84 24 16.96 23.63 16.32 22.99L15.64 22.31H14.32C13.95 22.31 13.59 22.22 13.26 22.06C12.76 21.81 12.37 21.42 12.13 20.94C11.96 20.59 11.87 20.22 11.87 19.86V18.53L11.19 17.85C10.66 17.32 10.32 16.63 10.22 15.89C10.1 14.98 10.33 14.08 10.88 13.36C11.43 12.63 12.24 12.16 13.14 12.04L20.83 10.42C21.63 10.23 22.51 10.48 23.1 11.08C23.71 11.68 23.95 12.57 23.75 13.4L22.12 21.14C21.95 22.36 21.07 23.41 19.83 23.82C19.48 23.94 19.11 24 18.74 24ZM15.86 20.31C16.26 20.31 16.63 20.46 16.91 20.74L17.74 21.57C18.12 21.95 18.69 22.09 19.2 21.92C19.72 21.75 20.08 21.32 20.15 20.79L21.8 12.95C21.85 12.76 21.8 12.6 21.69 12.49C21.58 12.37 21.43 12.33 21.28 12.36L13.49 14C13.04 14.06 12.71 14.26 12.48 14.56C12.25 14.86 12.15 15.24 12.2 15.61C12.24 15.92 12.39 16.2 12.6 16.42L13.43 17.25C13.71 17.53 13.87 17.9 13.87 18.3V19.84C13.87 19.9 13.89 19.97 13.91 20.02C13.96 20.12 14.03 20.19 14.12 20.23C14.19 20.27 14.26 20.28 14.32 20.28H15.85L15.86 20.31Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M21.6975 11.0789L12.5409 20.1086L13.9452 21.5327L23.1019 12.503L21.6975 11.0789Z", fill: "currentColor" })
] }), pj = () => /* @__PURE__ */ f.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("g", { children: /* @__PURE__ */ f.jsx("path", { d: "M23.61 10.836L21.892 7.24396C21.674 6.78896 21.15 6.56596 20.673 6.72696L11.996 9.62296L3.30701 6.72796C2.83001 6.56896 2.30601 6.78996 2.08801 7.24596L0.436012 10.719C-0.0409879 11.511 -0.130988 12.462 0.189012 13.328C0.499012 14.168 1.15301 14.819 1.99001 15.123L1.98401 17.438C1.98401 19.595 3.35701 21.503 5.40301 22.185L9.76801 23.641C10.482 23.878 11.232 23.997 11.982 23.997C12.732 23.997 13.482 23.878 14.196 23.64L18.565 22.184C20.609 21.502 21.983 19.598 21.984 17.446L21.99 15.124C22.836 14.828 23.498 14.179 23.809 13.336C24.125 12.478 24.036 11.536 23.61 10.836ZM2.19401 11.666L3.51201 8.90296L10.577 11.257L8.95701 14.513C8.71501 14.919 8.22801 15.097 7.78301 14.949L2.70201 13.254C2.40401 13.155 2.17201 12.93 2.06301 12.636C1.95501 12.343 1.98601 12.02 2.19401 11.666ZM6.03601 20.289C4.80801 19.879 3.98301 18.734 3.98401 17.441L3.98801 15.791L7.15201 16.846C8.49801 17.292 9.94501 16.756 10.711 15.474L10.988 14.919L10.984 21.898C10.787 21.858 10.593 21.807 10.402 21.744L6.03701 20.289H6.03601ZM17.932 20.287L13.563 21.743C13.373 21.806 13.179 21.858 12.983 21.898L12.987 14.903L13.306 15.543C13.863 16.471 14.838 17.003 15.868 17.003C16.186 17.003 16.511 16.952 16.828 16.846L19.988 15.793L19.984 17.444C19.984 18.736 19.159 19.878 17.932 20.287ZM21.932 12.642C21.827 12.927 21.601 13.146 21.313 13.243L16.195 14.948C15.757 15.095 15.26 14.912 15.059 14.583L13.405 11.261L20.469 8.90396L21.851 11.784C22.007 12.045 22.038 12.357 21.932 12.642ZM5.21401 5.89596C4.82301 5.50496 4.82301 4.87296 5.21401 4.48196L9.11101 0.585959C9.89001 -0.193041 11.16 -0.193041 11.939 0.585959L13.535 2.18196C14.288 1.79696 15.273 1.91196 15.888 2.52696L18.143 4.78196C18.534 5.17296 18.534 5.80496 18.143 6.19596C17.752 6.58696 17.12 6.58696 16.729 6.19596L14.474 3.94096L11.323 7.09196C11.128 7.28696 10.872 7.38496 10.616 7.38496C10.36 7.38496 10.104 7.28696 9.90901 7.09196C9.51801 6.70096 9.51801 6.06896 9.90901 5.67796L12.056 3.53096L10.526 2.00096L6.62901 5.89696C6.43401 6.09196 6.17801 6.18996 5.92201 6.18996C5.66601 6.18996 5.41001 6.09196 5.21501 5.89696L5.21401 5.89596Z", fill: "currentColor" }) }) }), gj = () => /* @__PURE__ */ f.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsxs("g", { children: [
  /* @__PURE__ */ f.jsx("path", { d: "M16 0H8C6.67441 0.00158786 5.40356 0.528882 4.46622 1.46622C3.52888 2.40356 3.00159 3.67441 3 5V23C3.00014 23.1819 3.04989 23.3603 3.14388 23.516C3.23788 23.6717 3.37256 23.7989 3.53344 23.8837C3.69431 23.9686 3.87529 24.008 4.05688 23.9976C4.23847 23.9873 4.4138 23.9276 4.564 23.825L6.67 22.386L8.776 23.825C8.94239 23.9389 9.13934 23.9999 9.341 23.9999C9.54266 23.9999 9.73961 23.9389 9.906 23.825L12.006 22.386L14.106 23.825C14.2725 23.9392 14.4696 24.0003 14.6715 24.0003C14.8734 24.0003 15.0705 23.9392 15.237 23.825L17.337 22.387L19.437 23.824C19.5871 23.9263 19.7623 23.9857 19.9436 23.996C20.125 24.0062 20.3057 23.9669 20.4664 23.8821C20.627 23.7974 20.7616 23.6706 20.8556 23.5151C20.9496 23.3597 20.9996 23.1816 21 23V5C20.9984 3.67441 20.4711 2.40356 19.5338 1.46622C18.5964 0.528882 17.3256 0.00158786 16 0ZM19 21.1L17.9 20.348C17.7334 20.2336 17.5361 20.1724 17.334 20.1724C17.1319 20.1724 16.9346 20.2336 16.768 20.348L14.668 21.787L12.568 20.348C12.4015 20.2338 12.2044 20.1727 12.0025 20.1727C11.8006 20.1727 11.6035 20.2338 11.437 20.348L9.337 21.787L7.237 20.348C7.07071 20.2343 6.87396 20.1734 6.6725 20.1734C6.47105 20.1734 6.27429 20.2343 6.108 20.348L5 21.1V5C5 4.20435 5.31607 3.44129 5.87868 2.87868C6.44129 2.31607 7.20435 2 8 2H16C16.7956 2 17.5587 2.31607 18.1213 2.87868C18.6839 3.44129 19 4.20435 19 5V21.1Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M16 8H8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10H16C16.5523 10 17 9.55228 17 9C17 8.44772 16.5523 8 16 8Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M14 12H8C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14H14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12Z", fill: "currentColor" })
] }) }), vj = () => /* @__PURE__ */ f.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("g", { children: /* @__PURE__ */ f.jsx("path", { d: "M19 2H5C2.24 2 0 4.24 0 7V17C0 19.76 2.24 22 5 22H12C12.55 22 13 21.55 13 21C13 20.45 12.55 20 12 20H5C3.35 20 2 18.65 2 17V9H22V14C22 14.55 22.45 15 23 15C23.55 15 24 14.55 24 14V7C24 4.24 21.76 2 19 2ZM2 7C2 5.35 3.35 4 5 4H19C20.65 4 22 5.35 22 7H2ZM16.41 12.17C15.65 11.41 14.65 11 13.58 11H11.99C11.44 11 10.99 11.45 10.99 12V13.59C10.99 14.66 11.41 15.66 12.16 16.42L18.87 23.13C19.44 23.7 20.19 24.01 20.99 24.01C21.79 24.01 22.54 23.7 23.11 23.13C23.68 22.56 23.99 21.81 23.99 21.01C23.99 20.21 23.68 19.46 23.11 18.89L16.4 12.18L16.41 12.17ZM21.7 21.71C21.32 22.09 20.66 22.09 20.29 21.71L13.58 15C13.2 14.62 12.99 14.12 12.99 13.59V13H13.58C14.11 13 14.62 13.21 14.99 13.59L21.7 20.3C21.89 20.49 21.99 20.74 21.99 21.01C21.99 21.28 21.89 21.53 21.7 21.72V21.71Z", fill: "currentColor" }) }) }), mj = () => /* @__PURE__ */ f.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("g", { children: /* @__PURE__ */ f.jsx("path", { d: "M21 15H10.26C9.46 15 8.71 14.69 8.14 14.12L6.72 12.71C6.53 12.52 6.43 12.27 6.43 12C6.43 11.73 6.54 11.48 6.72 11.29L8.14 9.88C8.71 9.31 9.46 9 10.26 9H21C22.65 9 24 10.35 24 12C24 13.65 22.65 15 21 15ZM8.85 12L9.56 12.71C9.75 12.9 10 13 10.27 13H21.01C21.56 13 22.01 12.55 22.01 12C22.01 11.45 21.56 11 21.01 11H10.26C10 11 9.74 11.11 9.55 11.29L8.84 12H8.85ZM18 6H10.26C9.46 6 8.71 5.69 8.14 5.12L6.72 3.71C6.53 3.52 6.43 3.27 6.43 3C6.43 2.73 6.54 2.48 6.72 2.29L8.14 0.88C8.71 0.31 9.46 0 10.26 0H18C19.65 0 21 1.35 21 3C21 4.65 19.65 6 18 6ZM8.85 3L9.56 3.71C9.75 3.9 10 4 10.27 4H18.01C18.56 4 19.01 3.55 19.01 3C19.01 2.45 18.56 2 18.01 2H10.27C10.01 2 9.75 2.11 9.56 2.29L8.85 3ZM16 24H10.26C9.46 24 8.71 23.69 8.14 23.12L6.72 21.71C6.53 21.52 6.43 21.27 6.43 21C6.43 20.73 6.54 20.48 6.72 20.29L8.14 18.88C8.71 18.31 9.46 18 10.26 18H16C17.65 18 19 19.35 19 21C19 22.65 17.65 24 16 24ZM8.85 21L9.56 21.71C9.75 21.9 10 22 10.27 22H16.01C16.56 22 17.01 21.55 17.01 21C17.01 20.45 16.56 20 16.01 20H10.27C10.01 20 9.75 20.11 9.56 20.29L8.85 21ZM2 19C0.9 19 0 19.9 0 21C0 22.1 0.9 23 2 23C3.1 23 4 22.1 4 21C4 19.9 3.1 19 2 19ZM2 10C0.9 10 0 10.9 0 12C0 13.1 0.9 14 2 14C3.1 14 4 13.1 4 12C4 10.9 3.1 10 2 10ZM2 1C0.9 1 0 1.9 0 3C0 4.1 0.9 5 2 5C3.1 5 4 4.1 4 3C4 1.9 3.1 1 2 1Z", fill: "currentColor" }) }) }), Cj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    children: /* @__PURE__ */ f.jsx("path", { d: "M8 0c-.787 0-1.292.592-1.572 1.151A4.35 4.35 0 0 0 6 3v3.691l-2 1V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.191l-1.17.585A1.5 1.5 0 0 0 0 10.618V12a.5.5 0 0 0 .582.493l1.631-.272.313.937a.5.5 0 0 0 .948 0l.405-1.214 2.21-.369.375 2.253-1.318 1.318A.5.5 0 0 0 5.5 16h5a.5.5 0 0 0 .354-.854l-1.318-1.318.375-2.253 2.21.369.405 1.214a.5.5 0 0 0 .948 0l.313-.937 1.63.272A.5.5 0 0 0 16 12v-1.382a1.5 1.5 0 0 0-.83-1.342L14 8.691V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.191l-2-1V3c0-.568-.14-1.271-.428-1.849C9.292.591 8.787 0 8 0M7 3c0-.432.11-.979.322-1.401C7.542 1.159 7.787 1 8 1s.458.158.678.599C8.889 2.02 9 2.569 9 3v4a.5.5 0 0 0 .276.447l5.448 2.724a.5.5 0 0 1 .276.447v.792l-5.418-.903a.5.5 0 0 0-.575.41l-.5 3a.5.5 0 0 0 .14.437l.646.646H6.707l.647-.646a.5.5 0 0 0 .14-.436l-.5-3a.5.5 0 0 0-.576-.411L1 11.41v-.792a.5.5 0 0 1 .276-.447l5.448-2.724A.5.5 0 0 0 7 7z" })
  }
), bj = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", d: "M6 8V1h1v6.117L8.743 6.07a.5.5 0 0 1 .514 0L11 7.117V1h1v7a.5.5 0 0 1-.757.429L9 7.083 6.757 8.43A.5.5 0 0 1 6 8" }),
  /* @__PURE__ */ f.jsx("path", { d: "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" }),
  /* @__PURE__ */ f.jsx("path", { d: "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" })
] }), yj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        "fill-rule": "evenodd",
        d: "M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5"
      }
    )
  }
), wj = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z" }),
  /* @__PURE__ */ f.jsx("path", { d: "M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0M7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0" })
] }), xj = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    "fill-rule": "evenodd",
    fill: "currentColor",
    d: "M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"
  }
) }), Dj = () => /* @__PURE__ */ f.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: /* @__PURE__ */ f.jsx("path", { d: "M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783" }) }), Oj = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5",
      fill: "currentColor"
    }
  )
] }), Mj = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      "fill-rule": "evenodd",
      fill: "currentColor",
      d: "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0M8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      "fill-rule": "evenodd",
      fill: "currentColor",
      d: "M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12 12 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7m6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.55 4.55 0 0 1 .23-2.002m-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.5 4.5 0 0 1-1.3-1.905"
    }
  )
] }), Ej = {
  "arrow-down": /* @__PURE__ */ f.jsx(YE, {}),
  "arrow-right": /* @__PURE__ */ f.jsx(kE, {}),
  "back-arrow": /* @__PURE__ */ f.jsx(VE, {}),
  "check-mark": /* @__PURE__ */ f.jsx(GE, {}),
  "circle-check": /* @__PURE__ */ f.jsx(WE, {}),
  "circle-plus": /* @__PURE__ */ f.jsx(QE, {}),
  close: /* @__PURE__ */ f.jsx(UE, {}),
  "collect-menu": /* @__PURE__ */ f.jsx(ZE, {}),
  "column-actions": /* @__PURE__ */ f.jsx(KE, {}),
  config: /* @__PURE__ */ f.jsx(zE, {}),
  dashboard: /* @__PURE__ */ f.jsx(qE, {}),
  "devices-linked": /* @__PURE__ */ f.jsx(XE, {}),
  "doc-config": /* @__PURE__ */ f.jsx(JE, {}),
  drag: /* @__PURE__ */ f.jsx(eS, {}),
  duplicate: /* @__PURE__ */ f.jsx(tS, {}),
  edit: /* @__PURE__ */ f.jsx(rS, {}),
  export: /* @__PURE__ */ f.jsx(nS, {}),
  eye: /* @__PURE__ */ f.jsx(aS, {}),
  "eye-hide": /* @__PURE__ */ f.jsx(iS, {}),
  filter: /* @__PURE__ */ f.jsx(oS, {}),
  "financing-config": /* @__PURE__ */ f.jsx(sS, {}),
  "help-card": /* @__PURE__ */ f.jsx(lS, {}),
  home: /* @__PURE__ */ f.jsx(cS, {}),
  "home-2": /* @__PURE__ */ f.jsx(uS, {}),
  lock: /* @__PURE__ */ f.jsx(dS, {}),
  logout: /* @__PURE__ */ f.jsx(fS, {}),
  menu: /* @__PURE__ */ f.jsx(hS, {}),
  "menu-context": /* @__PURE__ */ f.jsx(AS, {}),
  notification: /* @__PURE__ */ f.jsx(pS, {}),
  play: /* @__PURE__ */ f.jsx(gS, {}),
  plus: /* @__PURE__ */ f.jsx(vS, {}),
  projects: /* @__PURE__ */ f.jsx(mS, {}),
  question: /* @__PURE__ */ f.jsx(CS, {}),
  search: /* @__PURE__ */ f.jsx(bS, {}),
  sort: /* @__PURE__ */ f.jsx(yS, {}),
  "success-password": /* @__PURE__ */ f.jsx(wS, {}),
  "traffic-config": /* @__PURE__ */ f.jsx(xS, {}),
  trash: /* @__PURE__ */ f.jsx(DS, {}),
  user: /* @__PURE__ */ f.jsx(OS, {}),
  "user-change": /* @__PURE__ */ f.jsx(MS, {}),
  "user-config": /* @__PURE__ */ f.jsx(ES, {}),
  "user-inactive": /* @__PURE__ */ f.jsx(SS, {}),
  "user-plus": /* @__PURE__ */ f.jsx(PS, {}),
  "user-team": /* @__PURE__ */ f.jsx(jS, {}),
  view: /* @__PURE__ */ f.jsx(IS, {}),
  "arrow-turn-down-right": /* @__PURE__ */ f.jsx(BS, {}),
  "memo-circle-check": /* @__PURE__ */ f.jsx(NS, {}),
  "circle-forbidden": /* @__PURE__ */ f.jsx(LS, {}),
  "circle-exclamation": /* @__PURE__ */ f.jsx(TS, {}),
  "triangle-exclamation": /* @__PURE__ */ f.jsx(_S, {}),
  "floppy-disk": /* @__PURE__ */ f.jsx(RS, {}),
  calendar: /* @__PURE__ */ f.jsx(FS, {}),
  "comment-pen": /* @__PURE__ */ f.jsx($S, {}),
  "files-client": /* @__PURE__ */ f.jsx(HS, {}),
  "files-included": /* @__PURE__ */ f.jsx(YS, {}),
  "map-location": /* @__PURE__ */ f.jsx(kS, {}),
  "phone-volume": /* @__PURE__ */ f.jsx(VS, {}),
  envelope: /* @__PURE__ */ f.jsx(GS, {}),
  whatsapp: /* @__PURE__ */ f.jsx(WS, {}),
  "folder-arrow-up": /* @__PURE__ */ f.jsx(QS, {}),
  "files-plus": /* @__PURE__ */ f.jsx(US, {}),
  pricing: /* @__PURE__ */ f.jsx(ZS, {}),
  sale: /* @__PURE__ */ f.jsx(KS, {}),
  gan: /* @__PURE__ */ f.jsx(zS, {}),
  marketing: /* @__PURE__ */ f.jsx(qS, {}),
  operations: /* @__PURE__ */ f.jsx(XS, {}),
  audit: /* @__PURE__ */ f.jsx(JS, {}),
  "cash-flow": /* @__PURE__ */ f.jsx(eP, {}),
  administrative: /* @__PURE__ */ f.jsx(tP, {}),
  "right-arrow": /* @__PURE__ */ f.jsx(rP, {}),
  excel: /* @__PURE__ */ f.jsx(nP, {}),
  word: /* @__PURE__ */ f.jsx(aP, {}),
  uploadCLoud: /* @__PURE__ */ f.jsx(iP, {}),
  task: /* @__PURE__ */ f.jsx(oP, {}),
  dialog: /* @__PURE__ */ f.jsx(sP, {}),
  copy: /* @__PURE__ */ f.jsx(lP, {}),
  print: /* @__PURE__ */ f.jsx(cP, {}),
  pdf: /* @__PURE__ */ f.jsx(uP, {}),
  alert: /* @__PURE__ */ f.jsx(dP, {}),
  AccessAlarm: /* @__PURE__ */ f.jsx(uj, {}),
  "arrow-left": /* @__PURE__ */ f.jsx(hP, {}),
  "ArrowUpInBox ": /* @__PURE__ */ f.jsx(AP, {}),
  clock: /* @__PURE__ */ f.jsx(pP, {}),
  "column-order": /* @__PURE__ */ f.jsx(gP, {}),
  SiacoLogo: /* @__PURE__ */ f.jsx(lj, {}),
  "user-profile": /* @__PURE__ */ f.jsx(XP, {}),
  viewvalue: /* @__PURE__ */ f.jsx(mP, {}),
  boat: /* @__PURE__ */ f.jsx(CP, {}),
  clone: /* @__PURE__ */ f.jsx(bP, {}),
  plane: /* @__PURE__ */ f.jsx(yP, {}),
  deposit: /* @__PURE__ */ f.jsx(wP, {}),
  "in-arrow": /* @__PURE__ */ f.jsx(xP, {}),
  "file-donwload": /* @__PURE__ */ f.jsx(DP, {}),
  "cloud-donwload": /* @__PURE__ */ f.jsx(OP, {}),
  "circle-close": /* @__PURE__ */ f.jsx(MP, {}),
  "bar-code": /* @__PURE__ */ f.jsx(EP, {}),
  camera: /* @__PURE__ */ f.jsx(SP, {}),
  flash: /* @__PURE__ */ f.jsx(PP, {}),
  "camera-circle": /* @__PURE__ */ f.jsx(jP, {}),
  indicator: /* @__PURE__ */ f.jsx(IP, {}),
  airplane: /* @__PURE__ */ f.jsx(kP, {}),
  "boat-front": /* @__PURE__ */ f.jsx(VP, {}),
  "lower-limit": /* @__PURE__ */ f.jsx(GP, {}),
  "upper-limit": /* @__PURE__ */ f.jsx(WP, {}),
  signature: /* @__PURE__ */ f.jsx(QP, {}),
  map: /* @__PURE__ */ f.jsx(BP, {}),
  coin: /* @__PURE__ */ f.jsx(NP, {}),
  "send-arrow-up": /* @__PURE__ */ f.jsx(LP, {}),
  key: /* @__PURE__ */ f.jsx(TP, {}),
  genio: /* @__PURE__ */ f.jsx(_P, {}),
  "patch-check": /* @__PURE__ */ f.jsx(RP, {}),
  pencil: /* @__PURE__ */ f.jsx(FP, {}),
  cima: /* @__PURE__ */ f.jsx($P, {}),
  computer: /* @__PURE__ */ f.jsx(HP, {}),
  world: /* @__PURE__ */ f.jsx(YP, {}),
  "refresh-circle": /* @__PURE__ */ f.jsx(UP, {}),
  "calendar-icon": /* @__PURE__ */ f.jsx(ZP, {}),
  "calendar-check": /* @__PURE__ */ f.jsx(KP, {}),
  "calendar-close": /* @__PURE__ */ f.jsx(zP, {}),
  "calendar-exclamation": /* @__PURE__ */ f.jsx(qP, {}),
  "journal-check": /* @__PURE__ */ f.jsx(JP, {}),
  "clipboard-check": /* @__PURE__ */ f.jsx(ej, {}),
  circle: /* @__PURE__ */ f.jsx(tj, {}),
  "exclamation-diamond-fill": /* @__PURE__ */ f.jsx(rj, {}),
  "envelope-arrow-up": /* @__PURE__ */ f.jsx(nj, {}),
  "file-text-check": /* @__PURE__ */ f.jsx(aj, {}),
  "pencil-square": /* @__PURE__ */ f.jsx(ij, {}),
  printer: /* @__PURE__ */ f.jsx(oj, {}),
  "file-earmark-check": /* @__PURE__ */ f.jsx(sj, {}),
  "hand-bag": /* @__PURE__ */ f.jsx(cj, {}),
  "node-fill-plus": /* @__PURE__ */ f.jsx(dj, {}),
  "robot-icon": /* @__PURE__ */ f.jsx(fj, {}),
  "list-calendar": /* @__PURE__ */ f.jsx(hj, {}),
  "file-send": /* @__PURE__ */ f.jsx(Aj, {}),
  "box-open": /* @__PURE__ */ f.jsx(pj, {}),
  invoice: /* @__PURE__ */ f.jsx(gj, {}),
  register: /* @__PURE__ */ f.jsx(vj, {}),
  list: /* @__PURE__ */ f.jsx(mj, {}),
  "airplane-engines": /* @__PURE__ */ f.jsx(Cj, {}),
  "journal-bookmark": /* @__PURE__ */ f.jsx(bj, {}),
  "arrow-return-left": /* @__PURE__ */ f.jsx(yj, {}),
  "card-checklist": /* @__PURE__ */ f.jsx(wj, {}),
  ReturnArrowIcon: /* @__PURE__ */ f.jsx(fP, {}),
  ArrowLeftRight: /* @__PURE__ */ f.jsx(xj, {}),
  DatabaseFillAdd: /* @__PURE__ */ f.jsx(Mj, {}),
  ClockHistory: /* @__PURE__ */ f.jsx(Oj, {}),
  book: /* @__PURE__ */ f.jsx(Dj, {}),
  PlayCircleOutline: /* @__PURE__ */ f.jsx(vP, {})
}, tC = P.forwardRef((e, t) => {
  const {
    color: r,
    width: n = 20,
    widthFull: a = !1,
    isContain: i = !1,
    variant: o
  } = e, s = {
    width: a || i ? "100%" : n,
    height: i ? "100%" : void 0,
    color: r !== void 0 ? gt[r] : void 0
  };
  return /* @__PURE__ */ f.jsx("i", { ref: t, className: `block pointer-events-none ${i ? "codeicon-contain" : ""}`, style: s, children: Ej[o] });
});
tC.displayName = "CodeIcon";
const De = tC, Qr = P.forwardRef((e, t) => {
  const {
    variant: r,
    size: n,
    icon: a,
    children: i,
    isFull: o = !1,
    asSpan: s = !1,
    isLoading: c = !1,
    onlyIcon: u = !1,
    onlyIconMobile: d = !1,
    hideIconDesktop: h = !1,
    unroundedRight: A = !1,
    unroundedLeft: p = !1,
    minWidth: v,
    active: g = !1,
    inactive: m = !1,
    tooltip: b,
    tooltipDirection: w = "top",
    ...x
  } = e, y = "bg-neutral-200 hover:bg-neutral-300 text-neutral-600", C = {
    primary: "bg-primary-100 text-primary-600 hover:bg-primary-300",
    "primary-bold": g ? "bg-primary-500 text-white " : "bg-primary-600 text-white hover:bg-primary-500",
    secondary: g ? "bg-secondary-600 text-white" : "bg-secondary-100 text-secondary-600 hover:bg-secondary-200",
    "secondary-light": g ? "bg-secondary-600 text-white" : "bg-secondary-200 text-secondary-600 hover:bg-secondary-300",
    "secondary-light-bold": "bg-secondary-300 text-secondary-600 hover:bg-secondary-400",
    "secondary-bold": "bg-secondary-600 text-white hover:bg-secondary-500",
    terciary: "bg-secondary-800 text-white hover:bg-secondary-700",
    accent: "bg-accent-600 text-white hover:bg-accent-500",
    info: "bg-info-500 text-white hover:bg-info-400",
    warning: "bg-warning-500 text-white hover:bg-warning-400",
    success: "bg-success-500 text-white hover:bg-success-400",
    error: "bg-error-500 text-white hover:bg-error-400",
    "error-light": g ? "bg-error-100 text-error-500" : "bg-error-50 text-error-500 hover:bg-error-100",
    "error-light-bold": "bg-error-200 text-error-500 hover:bg-error-300",
    "white-secondary": "bg-white text-secondary-600 hover:bg-secondary-100"
  }, O = `h-[3rem] ${d ? "px-0 m:px-[1rem]" : `${u ? "px-0" : "px-[1rem]"}`}`, M = "fill-neutral-200", E = {
    primary: "fill-primary-100",
    "primary-bold": "fill-primary-600",
    secondary: "fill-secondary-100",
    "secondary-light": "fill-secondary-200",
    "secondary-light-bold": "fill-secondary-300",
    "secondary-bold": "fill-secondary-600",
    terciary: "fill-secondary-800",
    accent: "fill-accent-600",
    info: "fill-info-500",
    warning: "fill-warning-500",
    success: "fill-success-500",
    error: "fill-error-500",
    "error-light": "fill-error-50",
    "error-light-bold": "fill-error-200",
    "white-secondary": "fill-white"
  }, N = {
    s: `h-[32px] ${d ? "px-0 m:px-[1rem]" : `${u ? "px-0" : "px-[1rem]"}`}`,
    m: `h-10 ${d ? "px-0 m:px-[1rem]" : `${u ? "px-0" : "px-[1rem]"}`}`,
    l: `h-10 ${d ? "px-0 m:px-[1.25rem]" : `${u ? "px-0" : "px-[1.25rem]"}`}`,
    "2l": `h-10 ${d ? "px-0 m:px-[1.5rem]" : `${u ? "px-0" : "px-[1.5rem]"}`}`,
    xl: `h-[64px] ${d ? "px-0 m:px-[1.5rem]" : `${u ? "px-0" : "px-[1.5rem]"}`}`
  }, F = {
    top: "after:left-1/2 after:-translate-x-1/2 after:bottom-[calc(100%+15px)] before:left-1/2 before:-translate-x-1/2 before:bottom-[calc(100%+6px)] before:border-t-info-500 before:border-t-[9px] before:border-x-transparent before:border-x-[6px]",
    bottom: "after:left-1/2 after:-translate-x-1/2 after:top-[calc(100%+15px)] before:left-1/2 before:-translate-x-1/2 before:top-[calc(100%+6px)] before:border-b-info-500 before:border-b-[9px] before:border-x-transparent before:border-x-[6px]",
    left: "after:left-0 after:-translate-x-[calc(100%+15px)] after:top-1/2 after:-translate-y-1/2 before:left-0 before:-translate-x-[calc(100%+6px)] before:top-1/2 before:-translate-y-1/2 before:border-l-info-500 before:border-l-[9px] before:border-y-transparent before:border-y-[6px]",
    right: "after:right-0 after:translate-x-[calc(100%+15px)] after:top-1/2 after:-translate-y-1/2 before:right-0 before:translate-x-[calc(100%+6px)] before:top-1/2 before:-translate-y-1/2 before:border-r-info-500 before:border-r-[9px] before:border-y-transparent before:border-y-[6px]"
  }, k = Ye([
    "cursor-pointer border border-transparent flex items-center font-bold relative leading-[100%]",
    "disabled:opacity-50 disabled:pointer-events-none",
    p ? void 0 : "rounded-l-md",
    A ? void 0 : "rounded-r-md",
    r !== void 0 ? m ? "bg-neutral-300 text-neutral-400 pointer-events-none" : C[r] : y,
    a !== void 0 ? u ? "aspect-square justify-center" : d ? h ? "gap-[10px] justify-center aspect-square m:aspect-auto" : "gap-[10px] justify-center m:max-w-[fit-content] aspect-square m:aspect-auto" : "gap-[10px] justify-center max-w-[fit-content]" : "justify-center",
    n !== void 0 ? N[n] : O,
    c ? "pointer-events-none" : void 0,
    o ? "w-full max-w-full" : void 0,
    v !== void 0 ? d ? "m:w-[var(--ck-button-min-width)]" : "w-[var(--ck-button-min-width)]" : void 0,
    b !== void 0 && !g ? `${F[w]} relative after:content-[attr(data-title)] after:w-[max-content] after:absolute after:z-[10] after:bg-info-500 after:h-8 after:px-4 after:rounded-md after:text-s after:leading-[120%] after:text-white after:justify-center after:items-center after:hidden hover:after:flex before:absolute before:z-[10] before:hidden hover:before:block` : void 0
  ]), R = {};
  return v !== void 0 && (R["--ck-button-min-width"] = `${v}px`), s ? /* @__PURE__ */ f.jsxs(
    "span",
    {
      ref: t,
      className: k,
      style: R,
      "data-title": b,
      ...x,
      children: [
        a !== void 0 && /* @__PURE__ */ f.jsx("span", { className: `${a === "close" ? "w-[14px]" : "w-5"} aspect-square ${h ? "block m:hidden" : "block"}`, children: /* @__PURE__ */ f.jsx(De, { variant: a, isContain: !0 }) }),
        /* @__PURE__ */ f.jsx("p", { className: `${d ? "hidden m:block" : "block"}`, children: i })
      ]
    }
  ) : /* @__PURE__ */ f.jsxs(
    "button",
    {
      ref: t,
      className: k,
      style: R,
      "data-title": b,
      ...x,
      children: [
        a !== void 0 && /* @__PURE__ */ f.jsx("span", { className: `${a === "close" ? "w-[14px]" : "w-5"} aspect-square ${h ? "block m:hidden" : "block"}`, children: /* @__PURE__ */ f.jsx(De, { variant: a, isContain: !0 }) }),
        /* @__PURE__ */ f.jsx("p", { className: `${d ? "hidden m:block" : "block"}`, children: i }),
        c && /* @__PURE__ */ f.jsxs("div", { className: `absolute top-0 left-0 w-full h-full flex items-center justify-center ${r !== void 0 ? C[r] : y}`, children: [
          /* @__PURE__ */ f.jsxs(
            "svg",
            {
              "aria-hidden": "true",
              className: `h-[65%] aspect-square animate-spin ${r !== void 0 ? E[r] : M}`,
              viewBox: "0 0 100 101",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [
                /* @__PURE__ */ f.jsx("path", { d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z", fill: "currentColor" }),
                /* @__PURE__ */ f.jsx("path", { d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z", fill: "currentFill" })
              ]
            }
          ),
          /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "Loading..." })
        ] })
      ]
    }
  );
});
Qr.displayName = "Button";
const Ur = f1(null), Sj = ({ children: e }) => {
  const [t, r] = Ee(() => ({
    isCollapsedMenu: window.localStorage.getItem("castor-is-collapsed-menu") === "true",
    isOpenMenuUser: !1,
    isOpenNotifications: !1,
    isOpenMenu: !1
  })), n = () => {
    r((d) => ({
      ...d,
      isOpenMenu: !1,
      isOpenNotifications: !d.isOpenNotifications
    }));
  }, a = () => {
    r((d) => ({
      ...d,
      isOpenNotifications: !1
    }));
  }, i = () => {
    r((d) => ({
      ...d,
      isOpenNotifications: !1,
      isOpenMenu: !d.isOpenMenu
    }));
  }, o = () => {
    r((d) => ({
      ...d,
      isOpenMenu: !1
    }));
  }, s = () => {
    r((d) => {
      const h = !d.isCollapsedMenu;
      return window.localStorage.setItem("castor-is-collapsed-menu", h ? "true" : "false"), {
        ...d,
        isCollapsedMenu: h
      };
    });
  }, c = () => {
    r((d) => ({
      ...d,
      isOpenMenuUser: !d.isOpenMenuUser
    }));
  }, u = () => {
    r((d) => ({
      ...d,
      isOpenMenuUser: !1
    }));
  };
  return Ne(() => {
    t.isOpenMenu ? document.body.classList.add("overflow-y-hidden-dashboard") : document.body.classList.remove("overflow-y-hidden-dashboard");
  }, [t.isOpenMenu]), /* @__PURE__ */ f.jsx(
    Ur.Provider,
    {
      value: {
        isOpenMenu: t.isOpenMenu,
        isCollapsedMenu: t.isCollapsedMenu,
        isOpenNotifications: t.isOpenNotifications,
        isOpenMenuUser: t.isOpenMenuUser,
        toggleOpenMenu: i,
        closeMenu: o,
        toggleCollapsedMenu: s,
        toggleOpenNotifications: n,
        closeNotifications: a,
        toggleOpenMenuUser: c,
        closeMenuUser: u
      },
      children: e
    }
  );
};
Sj.displayName = "Dashboard";
const Pj = P.forwardRef((e, t) => {
  const {
    isPadding: r = !1,
    children: n,
    ...a
  } = e, i = wt(Ur), o = (i == null ? void 0 : i.isCollapsedMenu) ?? !1;
  return /* @__PURE__ */ f.jsx("main", { ref: t, className: `${r ? "px-4 py-4" : "px-0"} bg-Neutros-50 pb-[4.5rem] 2s:pb-4 2s:pt-[4.5rem] l:pt-[5rem] ${o ? "l:ml-[130px]" : "l:ml-72"}`, ...a, children: n });
});
Pj.displayName = "DashboardMain";
const iCe = () => {
  const e = new CustomEvent("codekit:closeDropdown");
  document.dispatchEvent(e);
}, jj = {
  actions: "bg-white w-full min-w-[148px] max-w-[240px] p-4 shadow-l",
  box: "bg-white w-[287px] p-8 shadow-l text-center",
  "box-danger": "bg-error-100 w-[287px] p-8 text-center"
}, rC = P.forwardRef((e, t) => {
  const {
    button: r,
    variant: n = "box",
    children: a
  } = e, [i, o] = Ee(!1), s = Ce(null), c = Ce(null), u = () => P.Children.map(r, (A) => P.cloneElement(A, {
    ref: s,
    active: i,
    onClick: () => {
      o((p) => !p);
    }
  })), d = () => P.Children.map(a, (A) => P.cloneElement(A, {
    closeDropdown: () => {
      o(!1);
    }
  })), h = (A) => {
    if (s.current !== null && !s.current.contains(A.target)) {
      if (c.current !== null) {
        if (c.current.contains(A.target))
          return;
        o(!1);
        return;
      }
      o(!1);
    }
  };
  return Ne(() => {
    const A = () => {
      o(!1);
    };
    return document.addEventListener("codekit:closeDropdown", A, !0), () => {
      document.removeEventListener("codekit:closeDropdown", A, !0);
    };
  }, []), Ne(() => (document.addEventListener("click", h, !0), () => {
    document.removeEventListener("click", h, !0);
  }), []), /* @__PURE__ */ f.jsxs("div", { ref: t, className: "relative max-w-[fit-content]", children: [
    u(),
    i && /* @__PURE__ */ f.jsx("div", { ref: c, className: "w-[max-content] absolute top-[calc(100%+5px)] z-[2] right-0 pb-[80px] pointer-events-none", children: /* @__PURE__ */ f.jsx(
      "div",
      {
        className: Ye([
          jj[n],
          "rounded-md pointer-events-auto"
        ]),
        children: d()
      }
    ) })
  ] });
});
rC.displayName = "Dropdown";
const L4 = P.forwardRef((e, t) => {
  const {
    icon: r,
    children: n,
    onClick: a,
    closeDropdown: i,
    ...o
  } = e, s = (c) => {
    i !== void 0 && i(), a !== void 0 && a(c);
  };
  return /* @__PURE__ */ f.jsxs(
    "button",
    {
      ref: t,
      onClick: s,
      className: "text-secondary-600 gap-2 px-2 py-[10px] flex items-center hover:bg-secondary-200 w-full outline-none shadow-transparent rounded-md",
      ...o,
      children: [
        /* @__PURE__ */ f.jsx("span", { className: `${r === "close" ? "w-[14px]" : "w-5"} aspect-square block`, children: /* @__PURE__ */ f.jsx(De, { variant: r, isContain: !0 }) }),
        /* @__PURE__ */ f.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] font-bold text-left", children: n }) })
      ]
    }
  );
});
L4.displayName = "DropdownAction";
const Ij = P.forwardRef((e, t) => {
  const {
    children: r
  } = e, n = "px-4 py-2 min-h-[40px] h-full leading-[120%] font-bold text-neutral-400 flex items-center";
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: "grid gap-2", children: [
    /* @__PURE__ */ f.jsxs("div", { className: "hidden m:grid grid-cols-export-table", children: [
      /* @__PURE__ */ f.jsx("div", { className: n, style: { gridArea: "name" }, children: "Nombre" }),
      /* @__PURE__ */ f.jsx("div", { className: n, style: { gridArea: "date" }, children: "Fecha de creación" }),
      /* @__PURE__ */ f.jsx("div", { className: n, style: { gridArea: "type" }, children: "Tipo de plantilla" }),
      /* @__PURE__ */ f.jsx("div", { className: n, style: { gridArea: "user" }, children: "Usuario" }),
      /* @__PURE__ */ f.jsx("div", { className: n, style: { gridArea: "actions" }, children: "Acciones" })
    ] }),
    r
  ] });
});
Ij.displayName = "ExportTable";
const Bj = P.forwardRef((e, t) => {
  const {
    name: r,
    date: n,
    type: a,
    user: i,
    children: o
  } = e, s = "m:border-r m:border-white m:h-full m:flex m:items-center m:px-4 m:py-2 m:min-h-[48px]";
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: "grid grid-cols-export-table items-center p-4 m:p-0 rounded-md bg-secondary-100 border border-neutral-100 leading-[120%]", children: [
    /* @__PURE__ */ f.jsx("div", { style: { gridArea: "name" }, className: `font-bold pr-3 ${s}`, children: r }),
    /* @__PURE__ */ f.jsx("div", { style: { gridArea: "date" }, className: `mt-2 m:mt-0 ${s}`, children: n }),
    /* @__PURE__ */ f.jsx("div", { style: { gridArea: "type" }, className: `mt-2 m:mt-0 ${s}`, children: a }),
    /* @__PURE__ */ f.jsx(
      "div",
      {
        style: { gridArea: "user" },
        className: `mt-3 pt-3 border-t border-secondary-200 m:mt-0 m:border-r-none ${s}`,
        children: /* @__PURE__ */ f.jsxs("div", { className: "flex gap-2 items-center", children: [
          /* @__PURE__ */ f.jsx("div", { className: "w-[14px] min-w-[24px]", children: /* @__PURE__ */ f.jsx(Ga, { size: "xs", image: i.image }) }),
          /* @__PURE__ */ f.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ f.jsx("p", { children: i.name }) })
        ] })
      }
    ),
    /* @__PURE__ */ f.jsx("div", { style: { gridArea: "actions" }, className: "s:flex s:px-4 s:h-full s:items-center s:justify-center", children: /* @__PURE__ */ f.jsx("div", { className: "flex gap-2 items-center", children: o }) })
  ] });
});
Bj.displayName = "ExportTableCol";
const Nj = {
  normal: "normal",
  start: "flex-start",
  end: "flex-end",
  center: "center",
  between: "space-between",
  around: "space-around",
  evenly: "space-evenly",
  stretch: "stretch"
}, Lj = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  baseline: "baseline",
  stretch: "stretch"
}, ts = P.forwardRef((e, t) => {
  const {
    direction: r = "row",
    gap: n,
    gapY: a,
    gapX: i,
    justifyContent: o,
    alignItems: s,
    wrap: c = !1,
    minHeight: u,
    children: d,
    ...h
  } = e, A = {
    justifyContent: o !== void 0 ? Nj[o] : void 0,
    alignItems: s !== void 0 ? Lj[s] : void 0,
    flexWrap: c ? "wrap" : void 0,
    flexDirection: r,
    minHeight: u
  };
  return n !== void 0 ? A.gap = n !== void 0 ? `${n / 4}rem` : void 0 : (A.columnGap = i !== void 0 ? `${i / 4}rem` : void 0, A.rowGap = a !== void 0 ? `${a / 4}rem` : void 0), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: "flex",
      style: A,
      ...h,
      children: d
    }
  );
});
ts.displayName = "Flexbox";
const Tj = P.forwardRef((e, t) => {
  const {
    grow: r = !1,
    minWidth: n,
    children: a,
    ...i
  } = e, o = {
    flexGrow: r ? 1 : void 0
  };
  return n !== void 0 && (o.minWidth = `${n}px`), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: "block",
      style: o,
      ...i,
      children: a
    }
  );
});
Tj.displayName = "FlexboxRow";
function nC(e, t = 500) {
  const [r, n] = Ee(e);
  return Ne(() => {
    const a = setTimeout(() => {
      n(e);
    }, t);
    return () => {
      clearTimeout(a);
    };
  }, [e, t]), r;
}
const T4 = P.forwardRef((e, t) => {
  const {
    icon: r,
    variant: n = "default",
    isInvalid: a = !1,
    isSuccess: i = !1,
    selected: o = null,
    placeholder: s = "Search...",
    textLoading: c = "Cargando...",
    textNoResults: u = "No hay resultados",
    minLengthToSearch: d = 5,
    searchResults: h = [],
    disabled: A,
    readOnly: p,
    onChangeSearch: v,
    onItemClick: g,
    onResetSelected: m
  } = e, [b, w] = Ee(""), [x, y] = Ee(!1), [C, O] = Ee(!1), M = Ce(!0), E = nC(b), N = () => {
    O(!1);
  };
  return Ne(() => {
    if (M.current) {
      M.current = !1;
      return;
    }
    if (!(A === !0 || p === !0)) {
      if (E.trim().length < d) {
        y(!1);
        return;
      }
      y(!0), v(E.trim(), N);
    }
  }, [E]), /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: Ye([
        "relative flex w-full text-neutral-600 h-10"
      ]),
      children: [
        /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          o === null ? /* @__PURE__ */ f.jsx(
            "input",
            {
              ref: t,
              type: "text",
              placeholder: s,
              value: b,
              onChange: (F) => {
                w(F.target.value), O(!0);
              },
              className: Ye([
                "w-full h-full flex items-center border rounded-md outline-none shadow-transparent placeholder:text-neutral-400",
                p === !0 || A === !0 ? "cursor-default pointer-events-none" : "hover:border-secondary-400 focus:border-secondary-600",
                A === !0 ? "bg-neutral-300" : n === "default" ? "bg-neutral-200" : "bg-white",
                A === !0 ? "border-neutral-300" : a ? "border-error-500" : i ? "border-success-500" : n === "default" ? "border-neutral-300" : "border-secondary-300",
                r !== void 0 ? "pl-4 pr-[2.75rem]" : "px-4"
              ])
            }
          ) : /* @__PURE__ */ f.jsx(
            "div",
            {
              className: Ye([
                "w-full h-full flex items-center border rounded-md",
                p === !0 || A === !0 ? "cursor-default pointer-events-none" : "hover:border-secondary-400",
                A === !0 ? "bg-neutral-300 border-neutral-300" : n === "default" ? "bg-neutral-200 border-neutral-300" : "bg-white border-secondary-300",
                r !== void 0 ? "pl-4 pr-[2.75rem]" : "px-4"
              ]),
              children: /* @__PURE__ */ f.jsxs(
                "div",
                {
                  className: Ye([
                    "h-8 flex gap-2 items-center pr-2 overflow-hidden rounded-[24px] border",
                    p === !0 || A === !0 ? "pl-2" : "pl-4",
                    A === !0 ? "border-neutral-400 text-neutral-400" : p === !0 ? "border-secondary-400 text-secondary-400" : "border-secondary-600 text-secondary-600"
                  ]),
                  children: [
                    /* @__PURE__ */ f.jsx("div", { className: "flex-grow cursor-default overflow-hidden", children: /* @__PURE__ */ f.jsx("p", { className: "font-bold leading-[120%] text-ellipsis overflow-hidden whitespace-nowrap", children: o }) }),
                    p !== !0 && A !== !0 && /* @__PURE__ */ f.jsx("div", { className: "w-[20px] min-w-[20px] h-[20px]", children: /* @__PURE__ */ f.jsx(
                      "button",
                      {
                        type: "button",
                        className: "w-full h-full rounded-full bg-secondary-600 flex items-center justify-center text-white",
                        onClick: () => {
                          w(""), O(!1), y(!1), m();
                        },
                        children: /* @__PURE__ */ f.jsx(De, { variant: "close", width: 10 })
                      }
                    ) })
                  ]
                }
              )
            }
          ),
          r !== void 0 && /* @__PURE__ */ f.jsx("span", { className: "absolute right-[1rem] top-1/2 -translate-y-1/2 z-[1]", children: /* @__PURE__ */ f.jsx(De, { variant: r, width: 18 }) })
        ] }),
        x && /* @__PURE__ */ f.jsx("div", { className: "absolute top-[calc(100%+4px)] left-0 w-full pointer-events-none min-w-[280px] z-[1] pb-[80px]", children: /* @__PURE__ */ f.jsx("div", { className: "bg-white rounded-lg p-4 shadow-l w-full pointer-events-auto", children: /* @__PURE__ */ f.jsx(f.Fragment, { children: C ? /* @__PURE__ */ f.jsxs("div", { className: "p-4 flex flex-col gap-4 items-center justify-center", children: [
          /* @__PURE__ */ f.jsxs(
            "svg",
            {
              "aria-hidden": "true",
              className: "w-[45px] aspect-square animate-spin fill-white text-secondary-600",
              viewBox: "0 0 100 101",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [
                /* @__PURE__ */ f.jsx("path", { d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z", fill: "currentColor" }),
                /* @__PURE__ */ f.jsx("path", { d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z", fill: "currentFill" })
              ]
            }
          ),
          /* @__PURE__ */ f.jsx("span", { children: c })
        ] }) : /* @__PURE__ */ f.jsx(f.Fragment, { children: h.length > 0 ? /* @__PURE__ */ f.jsx("ul", { children: h.map((F) => /* @__PURE__ */ f.jsxs(
          "li",
          {
            className: "flex gap-2 items-center cursor-pointer p-4 rounded-md hover:bg-secondary-100",
            onClick: () => {
              y(!1), g({ item: F });
            },
            children: [
              F.image !== void 0 && /* @__PURE__ */ f.jsx(Ga, { size: "md", image: F.image }),
              /* @__PURE__ */ f.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] font-bold", children: F.label }) })
            ]
          },
          F.id
        )) }) : /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col gap-4 items-center justify-center p-4", children: [
          /* @__PURE__ */ f.jsx(De, { variant: "search", width: 45, color: "secondary-600" }),
          /* @__PURE__ */ f.jsx("span", { className: "block mx-auto text-center w-[90%] max-w-[500px]", children: u })
        ] }) }) }) }) })
      ]
    }
  );
});
T4.displayName = "Autocomplete";
const f0 = P.forwardRef((e, t) => {
  const {
    disabled: r,
    readOnly: n,
    checked: a = !1,
    type: i = "default",
    variant: o = "default",
    isBold: s = !1,
    variantSize: c = "sm",
    children: u,
    onChange: d,
    ...h
  } = e, A = (p) => {
    n === !0 || r === !0 || d !== void 0 && d(p);
  };
  return /* @__PURE__ */ f.jsxs("label", { className: `flex items-center ${c === "sm" ? "gap-4" : "gap-2"} select-none`, children: [
    /* @__PURE__ */ f.jsx("input", { ref: t, type: "checkbox", className: "hidden", checked: a, onChange: A, ...h }),
    i === "default" && /* @__PURE__ */ f.jsx(
      "span",
      {
        className: Ye([
          "flex w-6 min-w-[24px] h-6 justify-center items-center border text-white overflow-hidden rounded-xs transition-colors",
          n === !0 || r === !0 ? "cursor-default pointer-events-none" : "cursor-pointer hover:border-secondary-400",
          r === !0 ? a ? "bg-neutral-400 border-neutral-400" : "bg-neutral-300 border-neutral-300" : a ? "bg-Activos-600 border-secondary-600 hover:border-secondary-600" : o === "default" ? "bg-neutral-200 border-neutral-300" : "bg-white border-secondary-300"
        ]),
        children: a && /* @__PURE__ */ f.jsx(De, { variant: "check-mark", width: 16 })
      }
    ),
    i === "switch" && /* @__PURE__ */ f.jsx(
      "div",
      {
        className: Ye([
          "relative border rounded-[200px]",
          c === "xs" ? "h-5 w-[37px] min-w-[37px]" : "h-6 w-[54px] min-w-[54px]",
          n === !0 || r === !0 ? "cursor-default pointer-events-none" : "cursor-pointer",
          r === !0 ? a ? "bg-neutral-400 border-neutral-400" : "bg-neutral-300 border-neutral-300" : a ? "bg-secondary-600 border-secondary-600" : o === "white" ? "bg-white border-secondary-300 hover:border-secondary-400" : "bg-neutral-200 border-neutral-300 hover:border-secondary-400"
        ]),
        children: /* @__PURE__ */ f.jsx(
          "span",
          {
            className: Ye([
              "block absolute transition-all rounded-full top-1/2 -translate-y-1/2",
              c === "sm" ? "w-5 h-5" : "w-4 h-4",
              a ? c === "sm" ? "left-[31px]" : "left-[17px]" : "left-[2px]",
              o === "default" || a || r === !0 ? "bg-white" : "bg-secondary-400"
            ])
          }
        )
      }
    ),
    /* @__PURE__ */ f.jsx("span", { className: "flex-grow", children: s ? /* @__PURE__ */ f.jsx(Vr, { variant: "title-2", children: u }) : /* @__PURE__ */ f.jsx(r1, { variant: "description-2", children: u }) })
  ] });
});
f0.displayName = "Checkbox";
const _j = P.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ f.jsx("span", { ref: t, ...n, className: "block text-s mt-1.5 leading-[120%] text-error-500", children: r });
});
_j.displayName = "FieldError";
const Un = P.forwardRef((e, t) => {
  const {
    variant: r = "default",
    type: n = "text",
    isInvalid: a = !1,
    isSuccess: i = !1,
    isOtp: o = !1,
    iconLeft: s,
    iconRight: c,
    ...u
  } = e, [d, h] = Ee(!1);
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: `relative w-full block text-neutral-600 ${o ? "h-[4.9rem]" : "h-10"}`,
      children: [
        /* @__PURE__ */ f.jsx(
          "input",
          {
            ref: t,
            type: n === "password" ? d ? "text" : "password" : n,
            className: Ye([
              ` flex items-center w-full h-full outline-none shadow-transparent
            border rounded-md text-neutral-600 leading-none
            hover:border-primary-600
            focus:border-primary-600
            placeholder:text-neutral-400
            disabled:text-neutral-400 disabled:bg-neutral-300 disabled:pointer-events-none
            read-only:hover:border-neutral-300 read-only:focus:border-neutral-300 read-only:text-neutral-400
          `,
              r === "white" ? "bg-white" : "bg-neutral-200",
              a ? "border-error-500" : i ? "border-success-500" : r === "white" ? "border-secondary-300" : "border-neutral-300",
              o ? "text-center" : void 0,
              n === "password" ? "pl-[1rem] pr-[2.75rem]" : o ? "px-4" : `${c !== void 0 ? "pr-[2.75rem]" : "pr-4"} ${s !== void 0 ? "pl-[2.75rem]" : "pl-4"}`
            ]),
            ...u
          }
        ),
        n === "password" ? /* @__PURE__ */ f.jsx(
          "button",
          {
            onClick: () => {
              h((A) => !A);
            },
            type: "button",
            className: "absolute right-[1rem] top-1/2 -translate-y-1/2 z-[1]",
            children: d ? /* @__PURE__ */ f.jsx(De, { variant: "eye-hide" }) : /* @__PURE__ */ f.jsx(De, { variant: "eye" })
          }
        ) : c !== void 0 ? /* @__PURE__ */ f.jsx("span", { className: "absolute right-[1rem] top-1/2 -translate-y-1/2 z-[1]", children: /* @__PURE__ */ f.jsx(De, { variant: c, width: 18 }) }) : s !== void 0 ? /* @__PURE__ */ f.jsx("span", { className: "absolute left-[1rem] top-1/2 -translate-y-1/2 z-[1]", children: /* @__PURE__ */ f.jsx(De, { variant: s, width: 18 }) }) : null
      ]
    }
  );
});
Un.displayName = "Input";
const Rj = P.forwardRef((e, t) => {
  const {
    alignment: r,
    children: n,
    weight: a = "bold",
    ...i
  } = e, o = {
    textAlign: r,
    fontWeight: a !== void 0 ? RE[a] : void 0
  };
  return /* @__PURE__ */ f.jsx("label", { ref: t, ...i, className: "block text-[1rem] mb-2 leading-[120%]", style: o, children: n });
});
Rj.displayName = "Label";
const Fj = P.forwardRef((e, t) => {
  const {
    value: r,
    readOnly: n,
    disabled: a,
    checked: i = !1,
    isBold: o = !1,
    variant: s = "default",
    children: c,
    onChange: u,
    ...d
  } = e, h = (A) => {
    n === !0 || a === !0 || u !== void 0 && u(A);
  };
  return /* @__PURE__ */ f.jsxs("label", { className: "flex items-center gap-3 select-none", children: [
    /* @__PURE__ */ f.jsx("input", { ref: t, type: "radio", className: "hidden", checked: i, onChange: h, ...d }),
    /* @__PURE__ */ f.jsx(
      "span",
      {
        className: Ye([
          "flex w-6 min-w-[24px] h-6 justify-center items-center overflow-hidden rounded-full border",
          n === !0 || a === !0 ? "cursor-default pointer-events-none" : "cursor-pointer",
          a === !0 ? `${i ? "bg-white" : "bg-neutral-300"} border-neutral-300` : s === "white" ? `bg-white ${i ? "border-secondary-600" : "border-secondary-300"}` : `bg-neutral-200 ${i ? "border-secondary-600" : "border-neutral-300"}`,
          i ? void 0 : "hover:border-secondary-400"
        ]),
        children: /* @__PURE__ */ f.jsx("span", { className: `block w-[18px] h-[18px] overflow-hidden ${a === !0 ? "bg-neutral-300" : "bg-secondary-600"} rounded-full transition-opacity ${i ? "opacity-100" : "opacity-0"}` })
      }
    ),
    /* @__PURE__ */ f.jsx("span", { className: "flex-grow", children: o ? /* @__PURE__ */ f.jsx(Vr, { variant: "title-2", children: c }) : /* @__PURE__ */ f.jsx(r1, { variant: "description-2", children: c }) })
  ] });
});
Fj.displayName = "Radio";
const $j = P.forwardRef((e, t) => {
  const {
    options: r = [],
    value: n = "",
    variant: a = "default",
    readOnly: i = !1,
    disabled: o = !1,
    isInvalid: s = !1,
    isSuccess: c = !1,
    placeholder: u = "Seleccione una opción",
    onChangeValue: d,
    onLoadOptions: h
    // Agregamos esta prop
  } = e, [A, p] = Ee(!1), [v, g] = Ee(!1), m = Ce(null), b = Ce(null), w = r.find((O) => O.value === n), x = (w == null ? void 0 : w.text) ?? u, y = (O) => {
    if (m.current !== null && !m.current.contains(O.target)) {
      if (b.current !== null) {
        if (b.current.contains(O.target))
          return;
        p(!1);
        return;
      }
      p(!1);
    }
  };
  Ne(() => (document.addEventListener("click", y, !0), () => {
    document.removeEventListener("click", y, !0);
  }), []);
  const C = () => {
    p((O) => !O), !v && h && (h(), g(!0));
  };
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: `w-full block text-neutral-600 ${a === "no-border" ? "h-[38px]" : "h-10"}`, children: /* @__PURE__ */ f.jsxs("div", { className: "relative w-full h-full", children: [
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        ref: m,
        onClick: C,
        className: Ye([
          "rounded-md flex items-center w-full gap-3 h-full px-4 leading-none",
          i ? "" : "cursor-pointer select-none",
          o ? "bg-neutral-300 text-neutral-400 pointer-events-none" : a === "white" ? "bg-white text-neutral-600" : "bg-neutral-200 text-neutral-600",
          A ? "border-secondary-600" : i ? "" : "hover:border-secondary-400",
          o ? "border border-neutral-300" : a !== "no-border" ? s ? A ? "border border-secondary-600" : "border border-error-500" : c ? A ? "border border-secondary-600" : "border border-success-500" : a === "white" ? "border border-secondary-300" : "border border-neutral-300" : void 0
        ]),
        children: [
          /* @__PURE__ */ f.jsx("div", { className: "flex-grow overflow-hidden", children: /* @__PURE__ */ f.jsx("div", { className: "w-full pointer-events-none text-clamp-1 leading-[32px] break-all", children: x }) }),
          r.length > 0 && /* @__PURE__ */ f.jsx("span", { className: `w-[14px] min-w-[14px] ${A ? "rotate-180" : ""}`, children: /* @__PURE__ */ f.jsx(De, { variant: "arrow-down", width: 14 }) })
        ]
      }
    ),
    A && r.length > 0 && !i && !o && /* @__PURE__ */ f.jsxs("div", { ref: b, className: "absolute top-[calc(100%+8px)] left-0 w-full min-w-[250px] z-[1500] pb-[80px] pointer-events-none", children: [
      " ",
      /* @__PURE__ */ f.jsx(
        "ul",
        {
          className: `bg-white shadow-l rounded-md p-4 pointer-events-auto ${r.length > 6 ? "max-h-[350px] overflow-y-auto" : ""}`,
          children: r.map((O) => /* @__PURE__ */ f.jsx(
            "li",
            {
              className: `font-bold leading-[120%] p-4 cursor-pointer rounded-md ${n === O.value ? "bg-secondary-600 text-white" : "bg-white hover:bg-secondary-100"}`,
              onClick: () => {
                p(!1), n !== O.value && d !== void 0 && d({ option: O });
              },
              children: O.text
            },
            O.value
          ))
        }
      )
    ] })
  ] }) });
});
$j.displayName = "Select";
const oCe = ({
  options: e = [],
  selectedOptions: t = [],
  variant: r = "default",
  readOnly: n = !1,
  disabled: a = !1,
  isInvalid: i = !1,
  isSuccess: o = !1,
  placeholder: s = "Seleccione una opción",
  onChangeSelectedOptions: c,
  // Cambiamos el nombre de la función de cambio
  onLoadOptions: u
}) => {
  const [d, h] = Ee(!1), [A, p] = Ee(!1), v = Ce(null), g = Ce(null), m = (x) => {
    if (v.current !== null && !v.current.contains(x.target)) {
      if (g.current !== null) {
        if (g.current.contains(x.target))
          return;
        h(!1);
        return;
      }
      h(!1);
    }
  };
  Ne(() => (document.addEventListener("click", m, !0), () => {
    document.removeEventListener("click", m, !0);
  }), []);
  const b = () => {
    h((x) => !x), !A && u && (u(), p(!0));
  }, w = (x) => {
    const y = t.some(
      (O) => O.value === x.value
    );
    let C = [];
    y ? C = t.filter(
      (O) => O.value !== x.value
    ) : C = [...t, x], c && c(C);
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: `w-full block text-neutral-600 ${r === "no-border" ? "h-[38px]" : "h-10"}`,
      children: /* @__PURE__ */ f.jsxs("div", { className: "relative w-full h-full", children: [
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            ref: v,
            onClick: b,
            className: Ye([
              "rounded-md flex items-center w-full gap-3 h-full px-4 leading-none",
              n ? "" : "cursor-pointer select-none",
              a ? "bg-neutral-300 text-neutral-400 pointer-events-none" : r === "white" ? "bg-white text-neutral-600" : "bg-neutral-200 text-neutral-600",
              d ? "border-secondary-600" : n ? "" : "hover:border-secondary-400",
              a ? "border border-neutral-300" : r !== "no-border" ? i ? d ? "border border-secondary-600" : "border border-error-500" : o ? d ? "border border-secondary-600" : "border border-success-500" : r === "white" ? "border border-secondary-300" : "border border-neutral-300" : void 0
            ]),
            children: [
              /* @__PURE__ */ f.jsx("div", { className: "flex-grow overflow-hidden", children: /* @__PURE__ */ f.jsx("div", { className: "w-full pointer-events-none text-clamp-1 leading-[32px] break-all", children: t.length === 0 ? s : t.map((x) => x.text).join(", ") }) }),
              e.length > 0 && /* @__PURE__ */ f.jsx(
                "span",
                {
                  className: `w-[14px] min-w-[14px] ${d ? "rotate-180" : ""}`,
                  children: /* @__PURE__ */ f.jsx(De, { variant: "arrow-down", width: 14 })
                }
              )
            ]
          }
        ),
        d && e.length > 0 && !n && !a && /* @__PURE__ */ f.jsx(
          "div",
          {
            ref: g,
            className: "absolute top-[calc(100%+8px)] left-0 w-full min-w-[250px] z-[1500] pb-[80px] pointer-events-none",
            children: /* @__PURE__ */ f.jsx("ul", { className: "bg-white shadow-l rounded-md p-4 pointer-events-auto", children: e.map((x) => {
              const y = t.some(
                (C) => C.value === x.value
              );
              return /* @__PURE__ */ f.jsx(
                "li",
                {
                  className: `font-bold leading-[120%] p-4 cursor-pointer rounded-md ${y ? "bg-secondary-600 text-white" : "bg-white hover:bg-secondary-100"}`,
                  onClick: () => w(x),
                  children: x.text
                },
                x.value
              );
            }) })
          }
        )
      ] })
    }
  );
};
var _4 = { exports: {} }, o6, Ud;
function Hj() {
  if (Ud)
    return o6;
  Ud = 1;
  function e(B) {
    return B && typeof B == "object" && "default" in B ? B.default : B;
  }
  var t = e(P), r = O7;
  function n(B, I) {
    for (var _ = Object.getOwnPropertyNames(I), L = 0; L < _.length; L++) {
      var D = _[L], T = Object.getOwnPropertyDescriptor(I, D);
      T && T.configurable && B[D] === void 0 && Object.defineProperty(B, D, T);
    }
    return B;
  }
  function a() {
    return (a = Object.assign || function(B) {
      for (var I = 1; I < arguments.length; I++) {
        var _ = arguments[I];
        for (var L in _)
          Object.prototype.hasOwnProperty.call(_, L) && (B[L] = _[L]);
      }
      return B;
    }).apply(this, arguments);
  }
  function i(B, I) {
    B.prototype = Object.create(I.prototype), n(B.prototype.constructor = B, I);
  }
  function o(B, I) {
    if (B == null)
      return {};
    var _, L, D = {}, T = Object.keys(B);
    for (L = 0; L < T.length; L++)
      _ = T[L], 0 <= I.indexOf(_) || (D[_] = B[_]);
    return D;
  }
  function s(B) {
    if (B === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return B;
  }
  var c = function(B, I, _, L, D, T, Q, z) {
    if (!B) {
      var W;
      if (I === void 0)
        W = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var H = [_, L, D, T, Q, z], $ = 0;
        (W = new Error(I.replace(/%s/g, function() {
          return H[$++];
        }))).name = "Invariant Violation";
      }
      throw W.framesToPop = 1, W;
    }
  }, u = c;
  function d(B, I, _) {
    if ("selectionStart" in B && "selectionEnd" in B)
      B.selectionStart = I, B.selectionEnd = _;
    else {
      var L = B.createTextRange();
      L.collapse(!0), L.moveStart("character", I), L.moveEnd("character", _ - I), L.select();
    }
  }
  function h(B) {
    var I = 0, _ = 0;
    if ("selectionStart" in B && "selectionEnd" in B)
      I = B.selectionStart, _ = B.selectionEnd;
    else {
      var L = document.selection.createRange();
      L.parentElement() === B && (I = -L.moveStart("character", -B.value.length), _ = -L.moveEnd("character", -B.value.length));
    }
    return { start: I, end: _, length: _ - I };
  }
  var A = { 9: "[0-9]", a: "[A-Za-z]", "*": "[A-Za-z0-9]" }, p = "_";
  function v(B, I, _) {
    var L = "", D = "", T = null, Q = [];
    if (I === void 0 && (I = p), _ == null && (_ = A), !B || typeof B != "string")
      return { maskChar: I, formatChars: _, mask: null, prefix: null, lastEditablePosition: null, permanents: [] };
    var z = !1;
    return B.split("").forEach(function(W) {
      z = !z && W === "\\" || (z || !_[W] ? (Q.push(L.length), L.length === Q.length - 1 && (D += W)) : T = L.length + 1, L += W, !1);
    }), { maskChar: I, formatChars: _, prefix: D, mask: L, lastEditablePosition: T, permanents: Q };
  }
  function g(B, I) {
    return B.permanents.indexOf(I) !== -1;
  }
  function m(B, I, _) {
    var L = B.mask, D = B.formatChars;
    if (!_)
      return !1;
    if (g(B, I))
      return L[I] === _;
    var T = D[L[I]];
    return new RegExp(T).test(_);
  }
  function b(B, I) {
    return I.split("").every(function(_, L) {
      return g(B, L) || !m(B, L, _);
    });
  }
  function w(B, I) {
    var _ = B.maskChar, L = B.prefix;
    if (!_) {
      for (; I.length > L.length && g(B, I.length - 1); )
        I = I.slice(0, I.length - 1);
      return I.length;
    }
    for (var D = L.length, T = I.length; T >= L.length; T--) {
      var Q = I[T];
      if (!g(B, T) && m(B, T, Q)) {
        D = T + 1;
        break;
      }
    }
    return D;
  }
  function x(B, I) {
    return w(B, I) === B.mask.length;
  }
  function y(B, I) {
    var _ = B.maskChar, L = B.mask, D = B.prefix;
    if (!_) {
      for ((I = O(B, "", I, 0)).length < D.length && (I = D); I.length < L.length && g(B, I.length); )
        I += L[I.length];
      return I;
    }
    if (I)
      return O(B, y(B, ""), I, 0);
    for (var T = 0; T < L.length; T++)
      g(B, T) ? I += L[T] : I += _;
    return I;
  }
  function C(B, I, _, L) {
    var D = _ + L, T = B.maskChar, Q = B.mask, z = B.prefix, W = I.split("");
    if (T)
      return W.map(function($, V) {
        return V < _ || D <= V ? $ : g(B, V) ? Q[V] : T;
      }).join("");
    for (var H = D; H < W.length; H++)
      g(B, H) && (W[H] = "");
    return _ = Math.max(z.length, _), W.splice(_, D - _), I = W.join(""), y(B, I);
  }
  function O(B, I, _, L) {
    var D = B.mask, T = B.maskChar, Q = B.prefix, z = _.split(""), W = x(B, I);
    return !T && L > I.length && (I += D.slice(I.length, L)), z.every(function(H) {
      for (; S = H, g(B, Y = L) && S !== D[Y]; ) {
        if (L >= I.length && (I += D[L]), $ = H, V = L, T && g(B, V) && $ === T)
          return !0;
        if (++L >= D.length)
          return !1;
      }
      var $, V, Y, S;
      return !m(B, L, H) && H !== T || (L < I.length ? I = T || W || L < Q.length ? I.slice(0, L) + H + I.slice(L + 1) : (I = I.slice(0, L) + H + I.slice(L), y(B, I)) : T || (I += H), ++L < D.length);
    }), I;
  }
  function M(B, I, _, L) {
    var D = B.mask, T = B.maskChar, Q = _.split(""), z = L;
    return Q.every(function(W) {
      for (; $ = W, g(B, H = L) && $ !== D[H]; )
        if (++L >= D.length)
          return !1;
      var H, $;
      return (m(B, L, W) || W === T) && L++, L < D.length;
    }), L - z;
  }
  function E(B, I) {
    for (var _ = I; 0 <= _; --_)
      if (!g(B, _))
        return _;
    return null;
  }
  function N(B, I) {
    for (var _ = B.mask, L = I; L < _.length; ++L)
      if (!g(B, L))
        return L;
    return null;
  }
  function F(B) {
    return B || B === 0 ? B + "" : "";
  }
  function k(B, I, _, L, D) {
    var T = B.mask, Q = B.prefix, z = B.lastEditablePosition, W = I, H = "", $ = 0, V = 0, Y = Math.min(D.start, _.start);
    return _.end > D.start ? V = ($ = M(B, L, H = W.slice(D.start, _.end), Y)) ? D.length : 0 : W.length < L.length && (V = L.length - W.length), W = L, V && (V === 1 && !D.length && (Y = D.start === _.start ? N(B, _.start) : E(B, _.start)), W = C(B, W, Y, V)), W = O(B, W, H, Y), (Y += $) >= T.length ? Y = T.length : Y < Q.length && !$ ? Y = Q.length : Y >= Q.length && Y < z && $ && (Y = N(B, Y)), H || (H = null), { value: W = y(B, W), enteredString: H, selection: { start: Y, end: Y } };
  }
  function R() {
    var B = new RegExp("windows", "i"), I = new RegExp("phone", "i"), _ = navigator.userAgent;
    return B.test(_) && I.test(_);
  }
  function j(B) {
    return typeof B == "function";
  }
  function U() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }
  function ee() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }
  function X(B) {
    return (ee() ? U() : function() {
      return setTimeout(B, 1e3 / 60);
    })(B);
  }
  function Z(B) {
    (ee() || clearTimeout)(B);
  }
  var te = function(B) {
    function I(L) {
      var D = B.call(this, L) || this;
      D.focused = !1, D.mounted = !1, D.previousSelection = null, D.selectionDeferId = null, D.saveSelectionLoopDeferId = null, D.saveSelectionLoop = function() {
        D.previousSelection = D.getSelection(), D.saveSelectionLoopDeferId = X(D.saveSelectionLoop);
      }, D.runSaveSelectionLoop = function() {
        D.saveSelectionLoopDeferId === null && D.saveSelectionLoop();
      }, D.stopSaveSelectionLoop = function() {
        D.saveSelectionLoopDeferId !== null && (Z(D.saveSelectionLoopDeferId), D.saveSelectionLoopDeferId = null, D.previousSelection = null);
      }, D.getInputDOMNode = function() {
        if (!D.mounted)
          return null;
        var J = r.findDOMNode(s(s(D))), q = typeof window < "u" && J instanceof window.Element;
        if (J && !q)
          return null;
        if (J.nodeName !== "INPUT" && (J = J.querySelector("input")), !J)
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        return J;
      }, D.getInputValue = function() {
        var J = D.getInputDOMNode();
        return J ? J.value : null;
      }, D.setInputValue = function(J) {
        var q = D.getInputDOMNode();
        q && (D.value = J, q.value = J);
      }, D.setCursorToEnd = function() {
        var J = w(D.maskOptions, D.value), q = N(D.maskOptions, J);
        q !== null && D.setCursorPosition(q);
      }, D.setSelection = function(J, q, re) {
        re === void 0 && (re = {});
        var ae = D.getInputDOMNode(), oe = D.isFocused();
        ae && oe && (re.deferred || d(ae, J, q), D.selectionDeferId !== null && Z(D.selectionDeferId), D.selectionDeferId = X(function() {
          D.selectionDeferId = null, d(ae, J, q);
        }), D.previousSelection = { start: J, end: q, length: Math.abs(q - J) });
      }, D.getSelection = function() {
        return h(D.getInputDOMNode());
      }, D.getCursorPosition = function() {
        return D.getSelection().start;
      }, D.setCursorPosition = function(J) {
        D.setSelection(J, J);
      }, D.isFocused = function() {
        return D.focused;
      }, D.getBeforeMaskedValueChangeConfig = function() {
        var J = D.maskOptions, q = J.mask, re = J.maskChar, ae = J.permanents, oe = J.formatChars;
        return { mask: q, maskChar: re, permanents: ae, alwaysShowMask: !!D.props.alwaysShowMask, formatChars: oe };
      }, D.isInputAutofilled = function(J, q, re, ae) {
        var oe = D.getInputDOMNode();
        try {
          if (oe.matches(":-webkit-autofill"))
            return !0;
        } catch {
        }
        return !D.focused || ae.end < re.length && q.end === J.length;
      }, D.onChange = function(J) {
        var q = s(s(D)).beforePasteState, re = s(s(D)).previousSelection, ae = D.props.beforeMaskedValueChange, oe = D.getInputValue(), ue = D.value, Ae = D.getSelection();
        D.isInputAutofilled(oe, Ae, ue, re) && (ue = y(D.maskOptions, ""), re = { start: 0, end: 0, length: 0 }), q && (re = q.selection, ue = q.value, Ae = { start: re.start + oe.length, end: re.start + oe.length, length: 0 }, oe = ue.slice(0, re.start) + oe + ue.slice(re.end), D.beforePasteState = null);
        var ge = k(D.maskOptions, oe, Ae, ue, re), Se = ge.enteredString, Te = ge.selection, Re = ge.value;
        if (j(ae)) {
          var at = ae({ value: Re, selection: Te }, { value: ue, selection: re }, Se, D.getBeforeMaskedValueChangeConfig());
          Re = at.value, Te = at.selection;
        }
        D.setInputValue(Re), j(D.props.onChange) && D.props.onChange(J), D.isWindowsPhoneBrowser ? D.setSelection(Te.start, Te.end, { deferred: !0 }) : D.setSelection(Te.start, Te.end);
      }, D.onFocus = function(J) {
        var q = D.props.beforeMaskedValueChange, re = D.maskOptions, ae = re.mask, oe = re.prefix;
        if (D.focused = !0, D.mounted = !0, ae) {
          if (D.value)
            w(D.maskOptions, D.value) < D.maskOptions.mask.length && D.setCursorToEnd();
          else {
            var ue = y(D.maskOptions, oe), Ae = y(D.maskOptions, ue), ge = w(D.maskOptions, Ae), Se = N(D.maskOptions, ge), Te = { start: Se, end: Se };
            if (j(q)) {
              var Re = q({ value: Ae, selection: Te }, { value: D.value, selection: null }, null, D.getBeforeMaskedValueChangeConfig());
              Ae = Re.value, Te = Re.selection;
            }
            var at = Ae !== D.getInputValue();
            at && D.setInputValue(Ae), at && j(D.props.onChange) && D.props.onChange(J), D.setSelection(Te.start, Te.end);
          }
          D.runSaveSelectionLoop();
        }
        j(D.props.onFocus) && D.props.onFocus(J);
      }, D.onBlur = function(J) {
        var q = D.props.beforeMaskedValueChange, re = D.maskOptions.mask;
        if (D.stopSaveSelectionLoop(), D.focused = !1, re && !D.props.alwaysShowMask && b(D.maskOptions, D.value)) {
          var ae = "";
          j(q) && (ae = q({ value: ae, selection: null }, { value: D.value, selection: D.previousSelection }, null, D.getBeforeMaskedValueChangeConfig()).value);
          var oe = ae !== D.getInputValue();
          oe && D.setInputValue(ae), oe && j(D.props.onChange) && D.props.onChange(J);
        }
        j(D.props.onBlur) && D.props.onBlur(J);
      }, D.onMouseDown = function(J) {
        if (!D.focused && document.addEventListener) {
          D.mouseDownX = J.clientX, D.mouseDownY = J.clientY, D.mouseDownTime = (/* @__PURE__ */ new Date()).getTime();
          var q = function re(ae) {
            if (document.removeEventListener("mouseup", re), D.focused) {
              var oe = Math.abs(ae.clientX - D.mouseDownX), ue = Math.abs(ae.clientY - D.mouseDownY), Ae = Math.max(oe, ue), ge = (/* @__PURE__ */ new Date()).getTime() - D.mouseDownTime;
              (Ae <= 10 && ge <= 200 || Ae <= 5 && ge <= 300) && D.setCursorToEnd();
            }
          };
          document.addEventListener("mouseup", q);
        }
        j(D.props.onMouseDown) && D.props.onMouseDown(J);
      }, D.onPaste = function(J) {
        j(D.props.onPaste) && D.props.onPaste(J), J.defaultPrevented || (D.beforePasteState = { value: D.getInputValue(), selection: D.getSelection() }, D.setInputValue(""));
      }, D.handleRef = function(J) {
        D.props.children == null && j(D.props.inputRef) && D.props.inputRef(J);
      };
      var T = L.mask, Q = L.maskChar, z = L.formatChars, W = L.alwaysShowMask, H = L.beforeMaskedValueChange, $ = L.defaultValue, V = L.value;
      D.maskOptions = v(T, Q, z), $ == null && ($ = ""), V == null && (V = $);
      var Y = F(V);
      if (D.maskOptions.mask && (W || Y) && (Y = y(D.maskOptions, Y), j(H))) {
        var S = L.value;
        L.value == null && (S = $), Y = H({ value: Y, selection: null }, { value: S = F(S), selection: null }, null, D.getBeforeMaskedValueChangeConfig()).value;
      }
      return D.value = Y, D;
    }
    i(I, B);
    var _ = I.prototype;
    return _.componentDidMount = function() {
      this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = R(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, _.componentDidUpdate = function() {
      var L = this.previousSelection, D = this.props, T = D.beforeMaskedValueChange, Q = D.alwaysShowMask, z = D.mask, W = D.maskChar, H = D.formatChars, $ = this.maskOptions, V = Q || this.isFocused(), Y = this.props.value != null, S = Y ? F(this.props.value) : this.value, J = L ? L.start : null;
      if (this.maskOptions = v(z, W, H), this.maskOptions.mask) {
        !$.mask && this.isFocused() && this.runSaveSelectionLoop();
        var q = this.maskOptions.mask && this.maskOptions.mask !== $.mask;
        if ($.mask || Y || (S = this.getInputValue()), (q || this.maskOptions.mask && (S || V)) && (S = y(this.maskOptions, S)), q) {
          var re = w(this.maskOptions, S);
          (J === null || re < J) && (J = x(this.maskOptions, S) ? re : N(this.maskOptions, re));
        }
        !this.maskOptions.mask || !b(this.maskOptions, S) || V || Y && this.props.value || (S = "");
        var ae = { start: J, end: J };
        if (j(T)) {
          var oe = T({ value: S, selection: ae }, { value: this.value, selection: this.previousSelection }, null, this.getBeforeMaskedValueChangeConfig());
          S = oe.value, ae = oe.selection;
        }
        this.value = S;
        var ue = this.getInputValue() !== this.value;
        ue ? (this.setInputValue(this.value), this.forceUpdate()) : q && this.forceUpdate();
        var Ae = !1;
        ae.start != null && ae.end != null && (Ae = !L || L.start !== ae.start || L.end !== ae.end), (Ae || ue) && this.setSelection(ae.start, ae.end);
      } else
        $.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
    }, _.componentWillUnmount = function() {
      this.mounted = !1, this.selectionDeferId !== null && Z(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, _.render = function() {
      var L, D = this.props, T = (D.mask, D.alwaysShowMask, D.maskChar, D.formatChars, D.inputRef, D.beforeMaskedValueChange, D.children), Q = o(D, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);
      if (T) {
        j(T) || u(!1);
        var z = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"], W = a({}, Q);
        z.forEach(function($) {
          return delete W[$];
        }), L = T(W), z.filter(function($) {
          return L.props[$] != null && L.props[$] !== Q[$];
        }).length && u(!1);
      } else
        L = t.createElement("input", a({ ref: this.handleRef }, Q));
      var H = { onFocus: this.onFocus, onBlur: this.onBlur };
      return this.maskOptions.mask && (Q.disabled || Q.readOnly || (H.onChange = this.onChange, H.onPaste = this.onPaste, H.onMouseDown = this.onMouseDown), Q.value != null && (H.value = this.value)), L = t.cloneElement(L, H);
    }, I;
  }(t.Component);
  return o6 = te, o6;
}
var s6, Zd;
function Yj() {
  if (Zd)
    return s6;
  Zd = 1;
  var e = function(t, r, n, a, i, o, s, c) {
    if (process.env.NODE_ENV !== "production" && r === void 0)
      throw new Error("invariant requires an error message argument");
    if (!t) {
      var u;
      if (r === void 0)
        u = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var d = [n, a, i, o, s, c], h = 0;
        u = new Error(
          r.replace(/%s/g, function() {
            return d[h++];
          })
        ), u.name = "Invariant Violation";
      }
      throw u.framesToPop = 1, u;
    }
  };
  return s6 = e, s6;
}
var l6, Kd;
function kj() {
  if (Kd)
    return l6;
  Kd = 1;
  var e = process.env.NODE_ENV !== "production", t = function() {
  };
  if (e) {
    var r = function(a, i) {
      var o = arguments.length;
      i = new Array(o > 1 ? o - 1 : 0);
      for (var s = 1; s < o; s++)
        i[s - 1] = arguments[s];
      var c = 0, u = "Warning: " + a.replace(/%s/g, function() {
        return i[c++];
      });
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
    t = function(n, a, i) {
      var o = arguments.length;
      i = new Array(o > 2 ? o - 2 : 0);
      for (var s = 2; s < o; s++)
        i[s - 2] = arguments[s];
      if (a === void 0)
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      n || r.apply(null, [a].concat(i));
    };
  }
  return l6 = t, l6;
}
var c6, zd;
function Vj() {
  if (zd)
    return c6;
  zd = 1;
  function e(B) {
    return B && typeof B == "object" && "default" in B ? B.default : B;
  }
  var t = e(P), r = O7, n = e(Yj()), a = e(kj());
  function i(B, I) {
    for (var _ = Object.getOwnPropertyNames(I), L = 0; L < _.length; L++) {
      var D = _[L], T = Object.getOwnPropertyDescriptor(I, D);
      T && T.configurable && B[D] === void 0 && Object.defineProperty(B, D, T);
    }
    return B;
  }
  function o() {
    return o = Object.assign || function(B) {
      for (var I = 1; I < arguments.length; I++) {
        var _ = arguments[I];
        for (var L in _)
          Object.prototype.hasOwnProperty.call(_, L) && (B[L] = _[L]);
      }
      return B;
    }, o.apply(this, arguments);
  }
  function s(B, I) {
    B.prototype = Object.create(I.prototype), B.prototype.constructor = B, i(B, I);
  }
  function c(B, I) {
    if (B == null)
      return {};
    var _ = {}, L = Object.keys(B), D, T;
    for (T = 0; T < L.length; T++)
      D = L[T], !(I.indexOf(D) >= 0) && (_[D] = B[D]);
    return _;
  }
  function u(B) {
    if (B === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return B;
  }
  function d(B, I, _) {
    if ("selectionStart" in B && "selectionEnd" in B)
      B.selectionStart = I, B.selectionEnd = _;
    else {
      var L = B.createTextRange();
      L.collapse(!0), L.moveStart("character", I), L.moveEnd("character", _ - I), L.select();
    }
  }
  function h(B) {
    var I = 0, _ = 0;
    if ("selectionStart" in B && "selectionEnd" in B)
      I = B.selectionStart, _ = B.selectionEnd;
    else {
      var L = document.selection.createRange();
      L.parentElement() === B && (I = -L.moveStart("character", -B.value.length), _ = -L.moveEnd("character", -B.value.length));
    }
    return {
      start: I,
      end: _,
      length: _ - I
    };
  }
  var A = {
    9: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]"
  }, p = "_";
  function v(B, I, _) {
    var L = "", D = "", T = null, Q = [];
    if (I === void 0 && (I = p), _ == null && (_ = A), !B || typeof B != "string")
      return {
        maskChar: I,
        formatChars: _,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
      };
    var z = !1;
    return B.split("").forEach(function(W) {
      !z && W === "\\" ? z = !0 : (z || !_[W] ? (Q.push(L.length), L.length === Q.length - 1 && (D += W)) : T = L.length + 1, L += W, z = !1);
    }), {
      maskChar: I,
      formatChars: _,
      prefix: D,
      mask: L,
      lastEditablePosition: T,
      permanents: Q
    };
  }
  function g(B, I) {
    return B.permanents.indexOf(I) !== -1;
  }
  function m(B, I, _) {
    var L = B.mask, D = B.formatChars;
    if (!_)
      return !1;
    if (g(B, I))
      return L[I] === _;
    var T = L[I], Q = D[T];
    return new RegExp(Q).test(_);
  }
  function b(B, I) {
    return I.split("").every(function(_, L) {
      return g(B, L) || !m(B, L, _);
    });
  }
  function w(B, I) {
    var _ = B.maskChar, L = B.prefix;
    if (!_) {
      for (; I.length > L.length && g(B, I.length - 1); )
        I = I.slice(0, I.length - 1);
      return I.length;
    }
    for (var D = L.length, T = I.length; T >= L.length; T--) {
      var Q = I[T], z = !g(B, T) && m(B, T, Q);
      if (z) {
        D = T + 1;
        break;
      }
    }
    return D;
  }
  function x(B, I) {
    return w(B, I) === B.mask.length;
  }
  function y(B, I) {
    var _ = B.maskChar, L = B.mask, D = B.prefix;
    if (!_) {
      for (I = O(B, "", I, 0), I.length < D.length && (I = D); I.length < L.length && g(B, I.length); )
        I += L[I.length];
      return I;
    }
    if (I) {
      var T = y(B, "");
      return O(B, T, I, 0);
    }
    for (var Q = 0; Q < L.length; Q++)
      g(B, Q) ? I += L[Q] : I += _;
    return I;
  }
  function C(B, I, _, L) {
    var D = _ + L, T = B.maskChar, Q = B.mask, z = B.prefix, W = I.split("");
    if (!T) {
      for (var H = D; H < W.length; H++)
        g(B, H) && (W[H] = "");
      return _ = Math.max(z.length, _), W.splice(_, D - _), I = W.join(""), y(B, I);
    }
    return W.map(function($, V) {
      return V < _ || V >= D ? $ : g(B, V) ? Q[V] : T;
    }).join("");
  }
  function O(B, I, _, L) {
    var D = B.mask, T = B.maskChar, Q = B.prefix, z = _.split(""), W = x(B, I), H = function(Y, S) {
      return !g(B, Y) || S === D[Y];
    }, $ = function(Y, S) {
      return !T || !g(B, S) || Y !== T;
    };
    return !T && L > I.length && (I += D.slice(I.length, L)), z.every(function(V) {
      for (; !H(L, V); ) {
        if (L >= I.length && (I += D[L]), !$(V, L))
          return !0;
        if (L++, L >= D.length)
          return !1;
      }
      var Y = m(B, L, V) || V === T;
      return Y ? (L < I.length ? T || W || L < Q.length ? I = I.slice(0, L) + V + I.slice(L + 1) : (I = I.slice(0, L) + V + I.slice(L), I = y(B, I)) : T || (I += V), L++, L < D.length) : !0;
    }), I;
  }
  function M(B, I, _, L) {
    var D = B.mask, T = B.maskChar, Q = _.split(""), z = L, W = function($, V) {
      return !g(B, $) || V === D[$];
    };
    return Q.every(function(H) {
      for (; !W(L, H); )
        if (L++, L >= D.length)
          return !1;
      var $ = m(B, L, H) || H === T;
      return $ && L++, L < D.length;
    }), L - z;
  }
  function E(B, I) {
    for (var _ = I; _ >= 0; --_)
      if (!g(B, _))
        return _;
    return null;
  }
  function N(B, I) {
    for (var _ = B.mask, L = I; L < _.length; ++L)
      if (!g(B, L))
        return L;
    return null;
  }
  function F(B) {
    return !B && B !== 0 ? "" : B + "";
  }
  function k(B, I, _, L, D) {
    var T = B.mask, Q = B.prefix, z = B.lastEditablePosition, W = I, H = "", $ = 0, V = 0, Y = Math.min(D.start, _.start);
    if (_.end > D.start ? (H = W.slice(D.start, _.end), $ = M(B, L, H, Y), $ ? V = D.length : V = 0) : W.length < L.length && (V = L.length - W.length), W = L, V) {
      if (V === 1 && !D.length) {
        var S = D.start === _.start;
        Y = S ? N(B, _.start) : E(B, _.start);
      }
      W = C(B, W, Y, V);
    }
    return W = O(B, W, H, Y), Y = Y + $, Y >= T.length ? Y = T.length : Y < Q.length && !$ ? Y = Q.length : Y >= Q.length && Y < z && $ && (Y = N(B, Y)), W = y(B, W), H || (H = null), {
      value: W,
      enteredString: H,
      selection: {
        start: Y,
        end: Y
      }
    };
  }
  function R() {
    var B = new RegExp("windows", "i"), I = new RegExp("phone", "i"), _ = navigator.userAgent;
    return B.test(_) && I.test(_);
  }
  function j(B) {
    return typeof B == "function";
  }
  function U() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }
  function ee() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }
  function X(B) {
    var I = !!ee(), _;
    return I ? _ = U() : _ = function() {
      return setTimeout(B, 1e3 / 60);
    }, _(B);
  }
  function Z(B) {
    var I = ee() || clearTimeout;
    I(B);
  }
  var te = /* @__PURE__ */ function(B) {
    s(I, B);
    function I(L) {
      var D;
      D = B.call(this, L) || this, D.focused = !1, D.mounted = !1, D.previousSelection = null, D.selectionDeferId = null, D.saveSelectionLoopDeferId = null, D.saveSelectionLoop = function() {
        D.previousSelection = D.getSelection(), D.saveSelectionLoopDeferId = X(D.saveSelectionLoop);
      }, D.runSaveSelectionLoop = function() {
        D.saveSelectionLoopDeferId === null && D.saveSelectionLoop();
      }, D.stopSaveSelectionLoop = function() {
        D.saveSelectionLoopDeferId !== null && (Z(D.saveSelectionLoopDeferId), D.saveSelectionLoopDeferId = null, D.previousSelection = null);
      }, D.getInputDOMNode = function() {
        if (!D.mounted)
          return null;
        var q = r.findDOMNode(u(u(D))), re = typeof window < "u" && q instanceof window.Element;
        if (q && !re)
          return null;
        if (q.nodeName !== "INPUT" && (q = q.querySelector("input")), !q)
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        return q;
      }, D.getInputValue = function() {
        var q = D.getInputDOMNode();
        return q ? q.value : null;
      }, D.setInputValue = function(q) {
        var re = D.getInputDOMNode();
        re && (D.value = q, re.value = q);
      }, D.setCursorToEnd = function() {
        var q = w(D.maskOptions, D.value), re = N(D.maskOptions, q);
        re !== null && D.setCursorPosition(re);
      }, D.setSelection = function(q, re, ae) {
        ae === void 0 && (ae = {});
        var oe = D.getInputDOMNode(), ue = D.isFocused();
        if (!(!oe || !ue)) {
          var Ae = ae, ge = Ae.deferred;
          ge || d(oe, q, re), D.selectionDeferId !== null && Z(D.selectionDeferId), D.selectionDeferId = X(function() {
            D.selectionDeferId = null, d(oe, q, re);
          }), D.previousSelection = {
            start: q,
            end: re,
            length: Math.abs(re - q)
          };
        }
      }, D.getSelection = function() {
        var q = D.getInputDOMNode();
        return h(q);
      }, D.getCursorPosition = function() {
        return D.getSelection().start;
      }, D.setCursorPosition = function(q) {
        D.setSelection(q, q);
      }, D.isFocused = function() {
        return D.focused;
      }, D.getBeforeMaskedValueChangeConfig = function() {
        var q = D.maskOptions, re = q.mask, ae = q.maskChar, oe = q.permanents, ue = q.formatChars, Ae = D.props.alwaysShowMask;
        return {
          mask: re,
          maskChar: ae,
          permanents: oe,
          alwaysShowMask: !!Ae,
          formatChars: ue
        };
      }, D.isInputAutofilled = function(q, re, ae, oe) {
        var ue = D.getInputDOMNode();
        try {
          if (ue.matches(":-webkit-autofill"))
            return !0;
        } catch {
        }
        return D.focused ? oe.end < ae.length && re.end === q.length : !0;
      }, D.onChange = function(q) {
        var re = u(u(D)), ae = re.beforePasteState, oe = u(u(D)), ue = oe.previousSelection, Ae = D.props.beforeMaskedValueChange, ge = D.getInputValue(), Se = D.value, Te = D.getSelection();
        D.isInputAutofilled(ge, Te, Se, ue) && (Se = y(D.maskOptions, ""), ue = {
          start: 0,
          end: 0,
          length: 0
        }), ae && (ue = ae.selection, Se = ae.value, Te = {
          start: ue.start + ge.length,
          end: ue.start + ge.length,
          length: 0
        }, ge = Se.slice(0, ue.start) + ge + Se.slice(ue.end), D.beforePasteState = null);
        var Re = k(D.maskOptions, ge, Te, Se, ue), at = Re.enteredString, bt = Re.selection, Qt = Re.value;
        if (j(Ae)) {
          var or = Ae({
            value: Qt,
            selection: bt
          }, {
            value: Se,
            selection: ue
          }, at, D.getBeforeMaskedValueChangeConfig());
          Qt = or.value, bt = or.selection;
        }
        D.setInputValue(Qt), j(D.props.onChange) && D.props.onChange(q), D.isWindowsPhoneBrowser ? D.setSelection(bt.start, bt.end, {
          deferred: !0
        }) : D.setSelection(bt.start, bt.end);
      }, D.onFocus = function(q) {
        var re = D.props.beforeMaskedValueChange, ae = D.maskOptions, oe = ae.mask, ue = ae.prefix;
        if (D.focused = !0, D.mounted = !0, oe) {
          if (D.value)
            w(D.maskOptions, D.value) < D.maskOptions.mask.length && D.setCursorToEnd();
          else {
            var Ae = y(D.maskOptions, ue), ge = y(D.maskOptions, Ae), Se = w(D.maskOptions, ge), Te = N(D.maskOptions, Se), Re = {
              start: Te,
              end: Te
            };
            if (j(re)) {
              var at = re({
                value: ge,
                selection: Re
              }, {
                value: D.value,
                selection: null
              }, null, D.getBeforeMaskedValueChangeConfig());
              ge = at.value, Re = at.selection;
            }
            var bt = ge !== D.getInputValue();
            bt && D.setInputValue(ge), bt && j(D.props.onChange) && D.props.onChange(q), D.setSelection(Re.start, Re.end);
          }
          D.runSaveSelectionLoop();
        }
        j(D.props.onFocus) && D.props.onFocus(q);
      }, D.onBlur = function(q) {
        var re = D.props.beforeMaskedValueChange, ae = D.maskOptions.mask;
        if (D.stopSaveSelectionLoop(), D.focused = !1, ae && !D.props.alwaysShowMask && b(D.maskOptions, D.value)) {
          var oe = "";
          if (j(re)) {
            var ue = re({
              value: oe,
              selection: null
            }, {
              value: D.value,
              selection: D.previousSelection
            }, null, D.getBeforeMaskedValueChangeConfig());
            oe = ue.value;
          }
          var Ae = oe !== D.getInputValue();
          Ae && D.setInputValue(oe), Ae && j(D.props.onChange) && D.props.onChange(q);
        }
        j(D.props.onBlur) && D.props.onBlur(q);
      }, D.onMouseDown = function(q) {
        if (!D.focused && document.addEventListener) {
          D.mouseDownX = q.clientX, D.mouseDownY = q.clientY, D.mouseDownTime = (/* @__PURE__ */ new Date()).getTime();
          var re = function ae(oe) {
            if (document.removeEventListener("mouseup", ae), !!D.focused) {
              var ue = Math.abs(oe.clientX - D.mouseDownX), Ae = Math.abs(oe.clientY - D.mouseDownY), ge = Math.max(ue, Ae), Se = (/* @__PURE__ */ new Date()).getTime() - D.mouseDownTime;
              (ge <= 10 && Se <= 200 || ge <= 5 && Se <= 300) && D.setCursorToEnd();
            }
          };
          document.addEventListener("mouseup", re);
        }
        j(D.props.onMouseDown) && D.props.onMouseDown(q);
      }, D.onPaste = function(q) {
        j(D.props.onPaste) && D.props.onPaste(q), q.defaultPrevented || (D.beforePasteState = {
          value: D.getInputValue(),
          selection: D.getSelection()
        }, D.setInputValue(""));
      }, D.handleRef = function(q) {
        D.props.children == null && j(D.props.inputRef) && D.props.inputRef(q);
      };
      var T = L.mask, Q = L.maskChar, z = L.formatChars, W = L.alwaysShowMask, H = L.beforeMaskedValueChange, $ = L.defaultValue, V = L.value;
      D.maskOptions = v(T, Q, z), $ == null && ($ = ""), V == null && (V = $);
      var Y = F(V);
      if (D.maskOptions.mask && (W || Y) && (Y = y(D.maskOptions, Y), j(H))) {
        var S = L.value;
        L.value == null && (S = $), S = F(S);
        var J = H({
          value: Y,
          selection: null
        }, {
          value: S,
          selection: null
        }, null, D.getBeforeMaskedValueChangeConfig());
        Y = J.value;
      }
      return D.value = Y, D;
    }
    var _ = I.prototype;
    return _.componentDidMount = function() {
      this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = R(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, _.componentDidUpdate = function() {
      var D = this.previousSelection, T = this.props, Q = T.beforeMaskedValueChange, z = T.alwaysShowMask, W = T.mask, H = T.maskChar, $ = T.formatChars, V = this.maskOptions, Y = z || this.isFocused(), S = this.props.value != null, J = S ? F(this.props.value) : this.value, q = D ? D.start : null;
      if (this.maskOptions = v(W, H, $), this.maskOptions.mask)
        !V.mask && this.isFocused() && this.runSaveSelectionLoop();
      else {
        V.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
        return;
      }
      var re = this.maskOptions.mask && this.maskOptions.mask !== V.mask;
      if (!V.mask && !S && (J = this.getInputValue()), (re || this.maskOptions.mask && (J || Y)) && (J = y(this.maskOptions, J)), re) {
        var ae = w(this.maskOptions, J);
        (q === null || ae < q) && (x(this.maskOptions, J) ? q = ae : q = N(this.maskOptions, ae));
      }
      this.maskOptions.mask && b(this.maskOptions, J) && !Y && (!S || !this.props.value) && (J = "");
      var oe = {
        start: q,
        end: q
      };
      if (j(Q)) {
        var ue = Q({
          value: J,
          selection: oe
        }, {
          value: this.value,
          selection: this.previousSelection
        }, null, this.getBeforeMaskedValueChangeConfig());
        J = ue.value, oe = ue.selection;
      }
      this.value = J;
      var Ae = this.getInputValue() !== this.value;
      Ae ? (this.setInputValue(this.value), this.forceUpdate()) : re && this.forceUpdate();
      var ge = !1;
      oe.start != null && oe.end != null && (ge = !D || D.start !== oe.start || D.end !== oe.end), (ge || Ae) && this.setSelection(oe.start, oe.end);
    }, _.componentWillUnmount = function() {
      this.mounted = !1, this.selectionDeferId !== null && Z(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, _.render = function() {
      var D = this.props, T = D.mask;
      D.alwaysShowMask;
      var Q = D.maskChar, z = D.formatChars, W = D.inputRef;
      D.beforeMaskedValueChange;
      var H = D.children, $ = c(D, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]), V;
      if (process.env.NODE_ENV !== "production" && a(
        // parse mask to test against actual mask prop as this.maskOptions
        // will be updated later in componentDidUpdate
        !$.maxLength || !v(T, Q, z).mask,
        "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length."
      ), H) {
        j(H) || (process.env.NODE_ENV !== "production" ? n(!1, "react-input-mask: children must be a function") : n(!1));
        var Y = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"], S = o({}, $);
        Y.forEach(function(re) {
          return delete S[re];
        }), V = H(S);
        var J = Y.filter(function(re) {
          return V.props[re] != null && V.props[re] !== $[re];
        });
        J.length && (process.env.NODE_ENV !== "production" ? n(!1, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + J.join(", ")) : n(!1)), process.env.NODE_ENV !== "production" && a(!W, "react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead");
      } else
        V = t.createElement("input", o({
          ref: this.handleRef
        }, $));
      var q = {
        onFocus: this.onFocus,
        onBlur: this.onBlur
      };
      return this.maskOptions.mask && (!$.disabled && !$.readOnly && (q.onChange = this.onChange, q.onPaste = this.onPaste, q.onMouseDown = this.onMouseDown), $.value != null && (q.value = this.value)), V = t.cloneElement(V, q), V;
    }, I;
  }(t.Component);
  return c6 = te, c6;
}
process.env.NODE_ENV === "production" ? _4.exports = Hj() : _4.exports = Vj();
var Gj = _4.exports;
const Wj = /* @__PURE__ */ Xe(Gj), Qj = P.forwardRef((e, t) => {
  const {
    variant: r = "default",
    mask: n = "",
    maskChar: a = "",
    isInvalid: i = !1,
    isSuccess: o = !1,
    ...s
  } = e, c = Ce(null);
  return /* @__PURE__ */ f.jsx("div", { className: "relative w-full block text-neutral-600 h-10", ref: t, children: /* @__PURE__ */ f.jsx(
    Wj,
    {
      mask: n,
      maskChar: a,
      ...s,
      children: (u) => /* @__PURE__ */ f.jsx(
        "input",
        {
          ...u,
          ref: c,
          className: Ye([
            `
            flex items-center w-full h-full outline-none shadow-transparent
            border rounded-md text-neutral-600 leading-none
            hover:border-secondary-400
            focus:border-secondary-600
            placeholder:text-neutral-400
            disabled:text-neutral-400 disabled:bg-neutral-300 disabled:pointer-events-none
            read-only:hover:border-neutral-300 read-only:focus:border-neutral-300 read-only:text-neutral-400 pl-4
          `,
            r === "white" ? "bg-white" : "bg-neutral-200",
            i ? "border-error-500" : o ? "border-success-500" : r === "white" ? "border-secondary-300" : "border-neutral-300"
          ])
        }
      )
    }
  ) });
});
Qj.displayName = "InputMask";
const Uj = P.forwardRef((e, t) => {
  const {
    variant: r = "default",
    isInvalid: n = !1,
    isSuccess: a = !1,
    ...i
  } = e;
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: "relative w-full block text-neutral-600",
      children: /* @__PURE__ */ f.jsx(
        "textarea",
        {
          ref: t,
          className: Ye([
            `
            flex items-center w-full h-full outline-none shadow-transparent
            border rounded-md text-neutral-600 leading-none
            hover:border-secondary-400
            focus:border-secondary-600
            placeholder:text-neutral-400
            disabled:text-neutral-400 disabled:bg-neutral-300 disabled:pointer-events-none
            read-only:hover:border-neutral-300 read-only:focus:border-neutral-300 read-only:text-neutral-400
            p-2 resize-none
          `,
            r === "white" ? "bg-white" : "bg-neutral-200",
            n ? "border-error-500" : a ? "border-success-500" : r === "white" ? "border-secondary-300" : "border-neutral-300"
          ]),
          ...i,
          style: { height: "100px" }
        }
      )
    }
  );
});
Uj.displayName = "Textarea";
const sCe = ({
  options: e,
  selectedOption: t = null,
  onChangeSelectedOption: r,
  disabled: n = !1,
  readOnly: a = !1,
  placeholder: i = "Seleccione.."
}) => {
  const [o, s] = Ee(!1), [c, u] = Ee(""), [d, h] = Ee(e), A = (g) => {
    const m = g.target.value;
    u(m), h(
      e.filter(
        (b) => b.label.toLowerCase().includes(m.toLowerCase())
      )
    );
  }, p = () => {
    !n && !a && (s(!o), u(""), h(e));
  }, v = (g) => {
    !a && !n && r && (r(g), s(!1));
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: `relative ${n ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`,
      children: [
        /* @__PURE__ */ f.jsx(
          "div",
          {
            className: "border rounded-md border-gray-300 rounded px-4 py-2 bg-white",
            onClick: p,
            children: t && t.label ? t.label : i
          }
        ),
        o && /* @__PURE__ */ f.jsxs("div", { className: "absolute mt-1 w-full max-h-60 border  border-gray-300 bg-white rounded shadow-l z-10", children: [
          /* @__PURE__ */ f.jsx(
            "input",
            {
              type: "text",
              value: c,
              onChange: A,
              placeholder: "Filtrar...",
              className: "w-full px-4 py-2 border-b border-gray-300 focus:outline-none"
            }
          ),
          /* @__PURE__ */ f.jsx("ul", { className: "overflow-y-auto max-h-48", children: d.length > 0 ? d.map((g) => /* @__PURE__ */ f.jsx(
            "li",
            {
              className: `px-4 py-2 hover:bg-gray-100 ${t && t.value === g.value ? "bg-secondary-600 text-white" : "bg-white hover:bg-secondary-100"}`,
              onClick: () => v(g),
              children: g.label
            },
            g.value
          )) : /* @__PURE__ */ f.jsx("li", { className: "px-4 py-2 text-gray-500", children: "No se encuentran resultados" }) })
        ] })
      ]
    }
  );
}, Zj = "data:image/png;base64,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", Kj = P.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ f.jsxs("div", { ref: t, ...n, className: "flex gap-16 flex-grow items-center", children: [
    /* @__PURE__ */ f.jsx(
      "img",
      {
        src: Zj,
        alt: "Castor Logo",
        style: { width: "16%" }
      }
    ),
    r
  ] });
});
Kj.displayName = "HedaerBoxLeft";
const zj = P.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e, a = wt(Ur), i = (a == null ? void 0 : a.isOpenMenu) ?? !1;
  return /* @__PURE__ */ f.jsxs("div", { ref: t, ...n, className: "flex gap-4 items-center", children: [
    r,
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        className: "l:hidden flex items-center justify-center rounded-[0.5rem] bg-secondary-800 hover:bg-primary-600 min-w-[40px] aspect-square text-white",
        children: /* @__PURE__ */ f.jsx(De, { variant: "search", width: 18 })
      }
    ),
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        onClick: a == null ? void 0 : a.toggleOpenMenu,
        className: `l:hidden flex items-center justify-center rounded-[0.5rem] ${i ? "bg-primary-600" : "bg-secondary-800"} hover:bg-primary-600 min-w-[40px] aspect-square text-white`,
        children: i ? /* @__PURE__ */ f.jsx(De, { variant: "close", width: 14 }) : /* @__PURE__ */ f.jsx(De, { variant: "menu" })
      }
    )
  ] });
});
zj.displayName = "HeaderBoxRight";
const qj = P.forwardRef((e, t) => {
  const {
    image: r,
    children: n,
    onClick: a,
    ...i
  } = e, o = wt(Ur), s = (c) => {
    a !== void 0 && a(c), o == null || o.closeNotifications();
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      className: "flex items-start gap-2 cursor-pointer select-none p-4 rounded-md hover:bg-secondary-100",
      onClick: s,
      ...i,
      children: [
        /* @__PURE__ */ f.jsx(Ga, { size: "sm", image: r }),
        /* @__PURE__ */ f.jsx("div", { children: n })
      ]
    }
  );
});
qj.displayName = "HeaderNotificationItem";
const Xj = P.forwardRef((e, t) => {
  const {
    children: r,
    quantity: n,
    ...a
  } = e, i = wt(Ur), o = (i == null ? void 0 : i.isOpenNotifications) ?? !1, s = Ce(null), c = Ce(null), u = (d) => {
    if (s.current !== null && !s.current.contains(d.target)) {
      if (c.current !== null) {
        if (c.current.contains(d.target))
          return;
        i == null || i.closeNotifications();
        return;
      }
      i == null || i.closeNotifications();
    }
  };
  return Ne(() => (document.addEventListener("click", u, !0), () => {
    document.removeEventListener("click", u, !0);
  }), []), /* @__PURE__ */ f.jsxs("div", { ref: t, className: "relative", ...a, children: [
    /* @__PURE__ */ f.jsx(
      "button",
      {
        ref: s,
        type: "button",
        className: "flex items-center justify-center rounded-[0.5rem] min-w-[40px] aspect-square text-white",
        onClick: i == null ? void 0 : i.toggleOpenNotifications,
        children: /* @__PURE__ */ f.jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ f.jsx("div", { className: "absolute top-0 right-0 bg-error-500 w-[19px] aspect-square rounded-full overflow-hidden inline-flex items-center justify-center text-xs translate-x-1/2 -translate-y-1/2", children: n }),
          /* @__PURE__ */ f.jsx(De, { variant: "notification", width: 18 })
        ] })
      }
    ),
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        ref: c,
        className: `fixed 2s:absolute w-[calc(100%-1.8rem)] max-w-[450px] 2s:w-[290px] z-[1] bottom-[5.5rem] 2s:bottom-auto 2s:top-[calc(100%+9px)]
         2s:left-1/2 right-[0.9rem] 2s:right-auto 2s:-translate-x-full bg-white shadow-l rounded-md overflow-hidden  ${o ? "block" : "hidden"}`,
        children: [
          /* @__PURE__ */ f.jsx("div", { className: "pt-6 px-4 pb-4 border-b border-neutral-200", children: /* @__PURE__ */ f.jsx(Ri, { variant: "heading-6", children: "Notificaciones" }) }),
          /* @__PURE__ */ f.jsx("div", { className: "px-4 pt-4 pb-6 mb-10 l:mb-0", children: r })
        ]
      }
    )
  ] });
});
Xj.displayName = "HeaderNotifications";
const Jj = P.forwardRef((e, t) => {
  const {
    ...r
  } = e;
  return /* @__PURE__ */ f.jsxs(
    "button",
    {
      type: "button",
      ref: t,
      className: "hidden l:flex h-10 items-center justify-between w-[240px] rounded-md bg-secondary-800 hover:bg-primary-600 text-white px-4",
      ...r,
      children: [
        /* @__PURE__ */ f.jsx("p", { className: "font-semibold", children: "Plataforma tradicional" }),
        /* @__PURE__ */ f.jsx("span", { className: "rotate-180", children: /* @__PURE__ */ f.jsx(De, { variant: "back-arrow" }) })
      ]
    }
  );
});
Jj.displayName = "HeaderOldButton";
const eI = P.forwardRef((e, t) => {
  const {
    ...r
  } = e, n = D7();
  return /* @__PURE__ */ f.jsx("form", { ref: t, ...r, className: "hidden w-full max-w-[416px] l:block", children: /* @__PURE__ */ f.jsxs("div", { className: "h-10 bg-Neutros-50 rounded-md relative", children: [
    /* @__PURE__ */ f.jsx(
      "input",
      {
        id: n,
        type: "text",
        className: "h-full pl-4 pr-12 w-full outline-none rounded-md border ",
        style: { textTransform: "none" }
      }
    ),
    /* @__PURE__ */ f.jsx("label", { htmlFor: n, className: "absolute top-1/2 right-4 cursor-pointer -translate-y-1/2", children: /* @__PURE__ */ f.jsx(De, { variant: "search", className: "bg-secondary-800" }) })
  ] }) });
});
eI.displayName = "HeaderSearch";
const tI = P.forwardRef((e, t) => {
  const {
    image: r,
    name: n,
    cargo: a,
    email: i,
    isInsideMenu: o = !1,
    children: s,
    ...c
  } = e, u = wt(Ur), d = (u == null ? void 0 : u.isOpenMenuUser) ?? !1, h = Ce(null), A = Ce(null), p = (v) => {
    if (!o && !(window.innerWidth < 1280) && h.current !== null && !h.current.contains(v.target)) {
      if (A.current !== null) {
        if (A.current.contains(v.target))
          return;
        u == null || u.closeMenuUser();
        return;
      }
      u == null || u.closeMenuUser();
    }
  };
  return Ne(() => (document.addEventListener("click", p, !0), () => {
    document.removeEventListener("click", p, !0);
  }), []), /* @__PURE__ */ f.jsxs("div", { ref: t, className: `w-full relative ${o ? "block l:hidden max-w-none px-4" : "hidden l:block w-[350px]"}`, ...c, children: [
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        ref: h,
        className: "h-10 w-full cursor-pointer flex gap-2 items-center rounded-md text-white px-2 select-none",
        onClick: u == null ? void 0 : u.toggleOpenMenuUser,
        children: [
          /* @__PURE__ */ f.jsx(Ga, { size: "sm", image: r }),
          /* @__PURE__ */ f.jsx("span", { className: `flex-shrink ${d ? "-rotate-180" : ""}`, children: /* @__PURE__ */ f.jsx(De, { variant: "arrow-down", width: 14 }) })
        ]
      }
    ),
    /* @__PURE__ */ f.jsx("div", { className: `fixed 2s:absolute w-[calc(100%-1.8rem)] max-w-[450px] 2s:w-[290px] z-[1] bottom-[5.5rem] 2s:bottom-auto 2s:top-[calc(100%+9px)]
       2s:left-1/2 right-[0.9rem] 2s:right-auto 2s:-translate-x-full bg-white shadow-l rounded-md overflow-hidden  ${d ? "block" : "hidden"}`, children: /* @__PURE__ */ f.jsxs("ul", { className: "bg-secondary-800 text-center l:bg-white px-10 py-3 rounded-md l:shadow-l", children: [
      /* @__PURE__ */ f.jsx(Ga, { size: "md", image: r }),
      /* @__PURE__ */ f.jsxs("p", { className: "text-s font-bold leading-none text-ellipsis whitespace-nowrap overflow-hidden w-full", children: [
        " ¡Hola, ",
        n,
        "!"
      ] }),
      /* @__PURE__ */ f.jsx("p", { className: "text-xs leading-none text-ellipsis whitespace-nowrap overflow-hidden w-full", children: a }),
      s,
      /* @__PURE__ */ f.jsx("p", { className: "text-s leading-none text-ellipsis whitespace-nowrap overflow-hidden w-full m-3", children: i })
    ] }) })
  ] });
});
tI.displayName = "HeaderUser";
const rI = P.forwardRef((e, t) => {
  const {
    icon: r,
    children: n,
    onClick: a,
    ...i
  } = e, o = wt(Ur), s = (c) => {
    o == null || o.closeMenu(), o == null || o.closeMenuUser(), a !== void 0 && a(c);
  };
  return /* @__PURE__ */ f.jsxs(
    "li",
    {
      ref: t,
      onClick: s,
      className: "flex justify-between gap-2 items-center my-3 bg-Neutros-50 text-black  l:text-black p-2 cursor-pointer rounded-md hover:bg-secondary-600 l:hover:bg-secondary-200",
      ...i,
      children: [
        /* @__PURE__ */ f.jsx("span", { className: "w-[20px] min-w-[20px]", children: /* @__PURE__ */ f.jsx(De, { variant: r, width: 20 }) }),
        /* @__PURE__ */ f.jsx("span", { className: "flex-grow font-bold", children: n })
      ]
    }
  );
});
rI.displayName = "HeaderUserItem";
const nI = P.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ f.jsx("header", { ref: t, ...n, className: "w-full bg-Marca-800 px-6 flex items-center justify-between gap-4 fixed bottom-0 2s:top-0 h-[4.5rem] l:h-[5rem] z-[1600]", children: r });
});
nI.displayName = "HeaderWrapper";
const aI = "data:image/png;base64,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", aC = ({ width: e = 210 }) => /* @__PURE__ */ f.jsx(
  "img",
  {
    src: aI,
    alt: "Castor Logo",
    style: { width: `${e}px` }
  }
), iI = "data:image/png;base64,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", oI = ({ width: e = 160 }) => /* @__PURE__ */ f.jsx(
  "img",
  {
    src: iI,
    alt: "Map Logo",
    style: { width: `${e}px` }
  }
);
function R4(e, t) {
  return R4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, R4(e, t);
}
function iC(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, R4(e, t);
}
function be() {
  return be = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, be.apply(null, arguments);
}
function Zi(e) {
  "@babel/helpers - typeof";
  return Zi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zi(e);
}
function sI(e, t) {
  if (Zi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Zi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function lI(e) {
  var t = sI(e, "string");
  return Zi(t) == "symbol" ? t : t + "";
}
function cI(e, t, r) {
  return (t = lI(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function qd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Xd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qd(Object(r), !0).forEach(function(n) {
      cI(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : qd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function nr(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var Jd = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), u6 = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, ef = {
  INIT: "@@redux/INIT" + u6(),
  REPLACE: "@@redux/REPLACE" + u6(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + u6();
  }
};
function uI(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function dI(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (AI(e))
    return "date";
  if (hI(e))
    return "error";
  var r = fI(e);
  switch (r) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return r;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function fI(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function hI(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function AI(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function T1(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = dI(e)), t;
}
function oC(e, t, r) {
  var n;
  if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? nr(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof r > "u" && (r = t, t = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(process.env.NODE_ENV === "production" ? nr(1) : "Expected the enhancer to be a function. Instead, received: '" + T1(r) + "'");
    return r(oC)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? nr(2) : "Expected the root reducer to be a function. Instead, received: '" + T1(e) + "'");
  var a = e, i = t, o = [], s = o, c = !1;
  function u() {
    s === o && (s = o.slice());
  }
  function d() {
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? nr(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return i;
  }
  function h(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? nr(4) : "Expected the listener to be a function. Instead, received: '" + T1(g) + "'");
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? nr(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var m = !0;
    return u(), s.push(g), function() {
      if (m) {
        if (c)
          throw new Error(process.env.NODE_ENV === "production" ? nr(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        m = !1, u();
        var w = s.indexOf(g);
        s.splice(w, 1), o = null;
      }
    };
  }
  function A(g) {
    if (!uI(g))
      throw new Error(process.env.NODE_ENV === "production" ? nr(7) : "Actions must be plain objects. Instead, the actual type was: '" + T1(g) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof g.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? nr(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? nr(9) : "Reducers may not dispatch actions.");
    try {
      c = !0, i = a(i, g);
    } finally {
      c = !1;
    }
    for (var m = o = s, b = 0; b < m.length; b++) {
      var w = m[b];
      w();
    }
    return g;
  }
  function p(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? nr(10) : "Expected the nextReducer to be a function. Instead, received: '" + T1(g));
    a = g, A({
      type: ef.REPLACE
    });
  }
  function v() {
    var g, m = h;
    return g = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(w) {
        if (typeof w != "object" || w === null)
          throw new Error(process.env.NODE_ENV === "production" ? nr(11) : "Expected the observer to be an object. Instead, received: '" + T1(w) + "'");
        function x() {
          w.next && w.next(d());
        }
        x();
        var y = m(x);
        return {
          unsubscribe: y
        };
      }
    }, g[Jd] = function() {
      return this;
    }, g;
  }
  return A({
    type: ef.INIT
  }), n = {
    dispatch: A,
    subscribe: h,
    getState: d,
    replaceReducer: p
  }, n[Jd] = v, n;
}
function tf(e, t) {
  return function() {
    return t(e.apply(this, arguments));
  };
}
function rf(e, t) {
  if (typeof e == "function")
    return tf(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(process.env.NODE_ENV === "production" ? nr(16) : "bindActionCreators expected an object or a function, but instead received: '" + T1(e) + `'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`);
  var r = {};
  for (var n in e) {
    var a = e[n];
    typeof a == "function" && (r[n] = tf(a, t));
  }
  return r;
}
function sC() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return t.length === 0 ? function(n) {
    return n;
  } : t.length === 1 ? t[0] : t.reduce(function(n, a) {
    return function() {
      return n(a.apply(void 0, arguments));
    };
  });
}
function pI() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(n) {
    return function() {
      var a = n.apply(void 0, arguments), i = function() {
        throw new Error(process.env.NODE_ENV === "production" ? nr(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, o = {
        getState: a.getState,
        dispatch: function() {
          return i.apply(void 0, arguments);
        }
      }, s = t.map(function(c) {
        return c(o);
      });
      return i = sC.apply(void 0, s)(a.dispatch), Xd(Xd({}, a), {}, {
        dispatch: i
      });
    };
  };
}
var F4 = { exports: {} }, b3 = { exports: {} }, Qe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nf;
function gI() {
  if (nf)
    return Qe;
  nf = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, A = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function x(C) {
    if (typeof C == "object" && C !== null) {
      var O = C.$$typeof;
      switch (O) {
        case t:
          switch (C = C.type, C) {
            case c:
            case u:
            case n:
            case i:
            case a:
            case h:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case s:
                case d:
                case v:
                case p:
                case o:
                  return C;
                default:
                  return O;
              }
          }
        case r:
          return O;
      }
    }
  }
  function y(C) {
    return x(C) === u;
  }
  return Qe.AsyncMode = c, Qe.ConcurrentMode = u, Qe.ContextConsumer = s, Qe.ContextProvider = o, Qe.Element = t, Qe.ForwardRef = d, Qe.Fragment = n, Qe.Lazy = v, Qe.Memo = p, Qe.Portal = r, Qe.Profiler = i, Qe.StrictMode = a, Qe.Suspense = h, Qe.isAsyncMode = function(C) {
    return y(C) || x(C) === c;
  }, Qe.isConcurrentMode = y, Qe.isContextConsumer = function(C) {
    return x(C) === s;
  }, Qe.isContextProvider = function(C) {
    return x(C) === o;
  }, Qe.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, Qe.isForwardRef = function(C) {
    return x(C) === d;
  }, Qe.isFragment = function(C) {
    return x(C) === n;
  }, Qe.isLazy = function(C) {
    return x(C) === v;
  }, Qe.isMemo = function(C) {
    return x(C) === p;
  }, Qe.isPortal = function(C) {
    return x(C) === r;
  }, Qe.isProfiler = function(C) {
    return x(C) === i;
  }, Qe.isStrictMode = function(C) {
    return x(C) === a;
  }, Qe.isSuspense = function(C) {
    return x(C) === h;
  }, Qe.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === n || C === u || C === i || C === a || C === h || C === A || typeof C == "object" && C !== null && (C.$$typeof === v || C.$$typeof === p || C.$$typeof === o || C.$$typeof === s || C.$$typeof === d || C.$$typeof === m || C.$$typeof === b || C.$$typeof === w || C.$$typeof === g);
  }, Qe.typeOf = x, Qe;
}
var Ue = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var af;
function vI() {
  return af || (af = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, A = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function x(S) {
      return typeof S == "string" || typeof S == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      S === n || S === u || S === i || S === a || S === h || S === A || typeof S == "object" && S !== null && (S.$$typeof === v || S.$$typeof === p || S.$$typeof === o || S.$$typeof === s || S.$$typeof === d || S.$$typeof === m || S.$$typeof === b || S.$$typeof === w || S.$$typeof === g);
    }
    function y(S) {
      if (typeof S == "object" && S !== null) {
        var J = S.$$typeof;
        switch (J) {
          case t:
            var q = S.type;
            switch (q) {
              case c:
              case u:
              case n:
              case i:
              case a:
              case h:
                return q;
              default:
                var re = q && q.$$typeof;
                switch (re) {
                  case s:
                  case d:
                  case v:
                  case p:
                  case o:
                    return re;
                  default:
                    return J;
                }
            }
          case r:
            return J;
        }
      }
    }
    var C = c, O = u, M = s, E = o, N = t, F = d, k = n, R = v, j = p, U = r, ee = i, X = a, Z = h, te = !1;
    function B(S) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), I(S) || y(S) === c;
    }
    function I(S) {
      return y(S) === u;
    }
    function _(S) {
      return y(S) === s;
    }
    function L(S) {
      return y(S) === o;
    }
    function D(S) {
      return typeof S == "object" && S !== null && S.$$typeof === t;
    }
    function T(S) {
      return y(S) === d;
    }
    function Q(S) {
      return y(S) === n;
    }
    function z(S) {
      return y(S) === v;
    }
    function W(S) {
      return y(S) === p;
    }
    function H(S) {
      return y(S) === r;
    }
    function $(S) {
      return y(S) === i;
    }
    function V(S) {
      return y(S) === a;
    }
    function Y(S) {
      return y(S) === h;
    }
    Ue.AsyncMode = C, Ue.ConcurrentMode = O, Ue.ContextConsumer = M, Ue.ContextProvider = E, Ue.Element = N, Ue.ForwardRef = F, Ue.Fragment = k, Ue.Lazy = R, Ue.Memo = j, Ue.Portal = U, Ue.Profiler = ee, Ue.StrictMode = X, Ue.Suspense = Z, Ue.isAsyncMode = B, Ue.isConcurrentMode = I, Ue.isContextConsumer = _, Ue.isContextProvider = L, Ue.isElement = D, Ue.isForwardRef = T, Ue.isFragment = Q, Ue.isLazy = z, Ue.isMemo = W, Ue.isPortal = H, Ue.isProfiler = $, Ue.isStrictMode = V, Ue.isSuspense = Y, Ue.isValidElementType = x, Ue.typeOf = y;
  }()), Ue;
}
var of;
function lC() {
  return of || (of = 1, process.env.NODE_ENV === "production" ? b3.exports = gI() : b3.exports = vI()), b3.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var d6, sf;
function mI() {
  if (sf)
    return d6;
  sf = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(o).map(function(d) {
        return o[d];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        u[d] = d;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return d6 = a() ? Object.assign : function(i, o) {
    for (var s, c = n(i), u, d = 1; d < arguments.length; d++) {
      s = Object(arguments[d]);
      for (var h in s)
        t.call(s, h) && (c[h] = s[h]);
      if (e) {
        u = e(s);
        for (var A = 0; A < u.length; A++)
          r.call(s, u[A]) && (c[u[A]] = s[u[A]]);
      }
    }
    return c;
  }, d6;
}
var f6, lf;
function M7() {
  if (lf)
    return f6;
  lf = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return f6 = e, f6;
}
var h6, cf;
function cC() {
  return cf || (cf = 1, h6 = Function.call.bind(Object.prototype.hasOwnProperty)), h6;
}
var A6, uf;
function CI() {
  if (uf)
    return A6;
  uf = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = M7(), r = {}, n = cC();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, s, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in i)
        if (n(i, d)) {
          var h;
          try {
            if (typeof i[d] != "function") {
              var A = Error(
                (c || "React class") + ": " + s + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw A.name = "Invariant Violation", A;
            }
            h = i[d](o, d, c, s, null, t);
          } catch (v) {
            h = v;
          }
          if (h && !(h instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in r)) {
            r[h.message] = !0;
            var p = u ? u() : "";
            e(
              "Failed " + s + " type: " + h.message + (p ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, A6 = a, A6;
}
var p6, df;
function bI() {
  if (df)
    return p6;
  df = 1;
  var e = lC(), t = mI(), r = M7(), n = cC(), a = CI(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return p6 = function(s, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function h(I) {
      var _ = I && (u && I[u] || I[d]);
      if (typeof _ == "function")
        return _;
    }
    var A = "<<anonymous>>", p = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: w(),
      arrayOf: x,
      element: y(),
      elementType: C(),
      instanceOf: O,
      node: F(),
      objectOf: E,
      oneOf: M,
      oneOfType: N,
      shape: R,
      exact: j
    };
    function v(I, _) {
      return I === _ ? I !== 0 || 1 / I === 1 / _ : I !== I && _ !== _;
    }
    function g(I, _) {
      this.message = I, this.data = _ && typeof _ == "object" ? _ : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function m(I) {
      if (process.env.NODE_ENV !== "production")
        var _ = {}, L = 0;
      function D(Q, z, W, H, $, V, Y) {
        if (H = H || A, V = V || W, Y !== r) {
          if (c) {
            var S = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw S.name = "Invariant Violation", S;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var J = H + ":" + W;
            !_[J] && // Avoid spamming the console because they are often not actionable except for lib authors
            L < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + V + "` prop on `" + H + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), _[J] = !0, L++);
          }
        }
        return z[W] == null ? Q ? z[W] === null ? new g("The " + $ + " `" + V + "` is marked as required " + ("in `" + H + "`, but its value is `null`.")) : new g("The " + $ + " `" + V + "` is marked as required in " + ("`" + H + "`, but its value is `undefined`.")) : null : I(z, W, H, $, V);
      }
      var T = D.bind(null, !1);
      return T.isRequired = D.bind(null, !0), T;
    }
    function b(I) {
      function _(L, D, T, Q, z, W) {
        var H = L[D], $ = X(H);
        if ($ !== I) {
          var V = Z(H);
          return new g(
            "Invalid " + Q + " `" + z + "` of type " + ("`" + V + "` supplied to `" + T + "`, expected ") + ("`" + I + "`."),
            { expectedType: I }
          );
        }
        return null;
      }
      return m(_);
    }
    function w() {
      return m(o);
    }
    function x(I) {
      function _(L, D, T, Q, z) {
        if (typeof I != "function")
          return new g("Property `" + z + "` of component `" + T + "` has invalid PropType notation inside arrayOf.");
        var W = L[D];
        if (!Array.isArray(W)) {
          var H = X(W);
          return new g("Invalid " + Q + " `" + z + "` of type " + ("`" + H + "` supplied to `" + T + "`, expected an array."));
        }
        for (var $ = 0; $ < W.length; $++) {
          var V = I(W, $, T, Q, z + "[" + $ + "]", r);
          if (V instanceof Error)
            return V;
        }
        return null;
      }
      return m(_);
    }
    function y() {
      function I(_, L, D, T, Q) {
        var z = _[L];
        if (!s(z)) {
          var W = X(z);
          return new g("Invalid " + T + " `" + Q + "` of type " + ("`" + W + "` supplied to `" + D + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(I);
    }
    function C() {
      function I(_, L, D, T, Q) {
        var z = _[L];
        if (!e.isValidElementType(z)) {
          var W = X(z);
          return new g("Invalid " + T + " `" + Q + "` of type " + ("`" + W + "` supplied to `" + D + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(I);
    }
    function O(I) {
      function _(L, D, T, Q, z) {
        if (!(L[D] instanceof I)) {
          var W = I.name || A, H = B(L[D]);
          return new g("Invalid " + Q + " `" + z + "` of type " + ("`" + H + "` supplied to `" + T + "`, expected ") + ("instance of `" + W + "`."));
        }
        return null;
      }
      return m(_);
    }
    function M(I) {
      if (!Array.isArray(I))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function _(L, D, T, Q, z) {
        for (var W = L[D], H = 0; H < I.length; H++)
          if (v(W, I[H]))
            return null;
        var $ = JSON.stringify(I, function(Y, S) {
          var J = Z(S);
          return J === "symbol" ? String(S) : S;
        });
        return new g("Invalid " + Q + " `" + z + "` of value `" + String(W) + "` " + ("supplied to `" + T + "`, expected one of " + $ + "."));
      }
      return m(_);
    }
    function E(I) {
      function _(L, D, T, Q, z) {
        if (typeof I != "function")
          return new g("Property `" + z + "` of component `" + T + "` has invalid PropType notation inside objectOf.");
        var W = L[D], H = X(W);
        if (H !== "object")
          return new g("Invalid " + Q + " `" + z + "` of type " + ("`" + H + "` supplied to `" + T + "`, expected an object."));
        for (var $ in W)
          if (n(W, $)) {
            var V = I(W, $, T, Q, z + "." + $, r);
            if (V instanceof Error)
              return V;
          }
        return null;
      }
      return m(_);
    }
    function N(I) {
      if (!Array.isArray(I))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var _ = 0; _ < I.length; _++) {
        var L = I[_];
        if (typeof L != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + te(L) + " at index " + _ + "."
          ), o;
      }
      function D(T, Q, z, W, H) {
        for (var $ = [], V = 0; V < I.length; V++) {
          var Y = I[V], S = Y(T, Q, z, W, H, r);
          if (S == null)
            return null;
          S.data && n(S.data, "expectedType") && $.push(S.data.expectedType);
        }
        var J = $.length > 0 ? ", expected one of type [" + $.join(", ") + "]" : "";
        return new g("Invalid " + W + " `" + H + "` supplied to " + ("`" + z + "`" + J + "."));
      }
      return m(D);
    }
    function F() {
      function I(_, L, D, T, Q) {
        return U(_[L]) ? null : new g("Invalid " + T + " `" + Q + "` supplied to " + ("`" + D + "`, expected a ReactNode."));
      }
      return m(I);
    }
    function k(I, _, L, D, T) {
      return new g(
        (I || "React class") + ": " + _ + " type `" + L + "." + D + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + T + "`."
      );
    }
    function R(I) {
      function _(L, D, T, Q, z) {
        var W = L[D], H = X(W);
        if (H !== "object")
          return new g("Invalid " + Q + " `" + z + "` of type `" + H + "` " + ("supplied to `" + T + "`, expected `object`."));
        for (var $ in I) {
          var V = I[$];
          if (typeof V != "function")
            return k(T, Q, z, $, Z(V));
          var Y = V(W, $, T, Q, z + "." + $, r);
          if (Y)
            return Y;
        }
        return null;
      }
      return m(_);
    }
    function j(I) {
      function _(L, D, T, Q, z) {
        var W = L[D], H = X(W);
        if (H !== "object")
          return new g("Invalid " + Q + " `" + z + "` of type `" + H + "` " + ("supplied to `" + T + "`, expected `object`."));
        var $ = t({}, L[D], I);
        for (var V in $) {
          var Y = I[V];
          if (n(I, V) && typeof Y != "function")
            return k(T, Q, z, V, Z(Y));
          if (!Y)
            return new g(
              "Invalid " + Q + " `" + z + "` key `" + V + "` supplied to `" + T + "`.\nBad object: " + JSON.stringify(L[D], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(I), null, "  ")
            );
          var S = Y(W, V, T, Q, z + "." + V, r);
          if (S)
            return S;
        }
        return null;
      }
      return m(_);
    }
    function U(I) {
      switch (typeof I) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !I;
        case "object":
          if (Array.isArray(I))
            return I.every(U);
          if (I === null || s(I))
            return !0;
          var _ = h(I);
          if (_) {
            var L = _.call(I), D;
            if (_ !== I.entries) {
              for (; !(D = L.next()).done; )
                if (!U(D.value))
                  return !1;
            } else
              for (; !(D = L.next()).done; ) {
                var T = D.value;
                if (T && !U(T[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ee(I, _) {
      return I === "symbol" ? !0 : _ ? _["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && _ instanceof Symbol : !1;
    }
    function X(I) {
      var _ = typeof I;
      return Array.isArray(I) ? "array" : I instanceof RegExp ? "object" : ee(_, I) ? "symbol" : _;
    }
    function Z(I) {
      if (typeof I > "u" || I === null)
        return "" + I;
      var _ = X(I);
      if (_ === "object") {
        if (I instanceof Date)
          return "date";
        if (I instanceof RegExp)
          return "regexp";
      }
      return _;
    }
    function te(I) {
      var _ = Z(I);
      switch (_) {
        case "array":
        case "object":
          return "an " + _;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + _;
        default:
          return _;
      }
    }
    function B(I) {
      return !I.constructor || !I.constructor.name ? A : I.constructor.name;
    }
    return p.checkPropTypes = a, p.resetWarningCache = a.resetWarningCache, p.PropTypes = p, p;
  }, p6;
}
var g6, ff;
function yI() {
  if (ff)
    return g6;
  ff = 1;
  var e = M7();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, g6 = function() {
    function n(o, s, c, u, d, h) {
      if (h !== e) {
        var A = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw A.name = "Invariant Violation", A;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, g6;
}
if (process.env.NODE_ENV !== "production") {
  var wI = lC(), xI = !0;
  F4.exports = bI()(wI.isElement, xI);
} else
  F4.exports = yI()();
var Zr = F4.exports;
const Me = /* @__PURE__ */ Xe(Zr);
var E7 = /* @__PURE__ */ P.createContext(null);
process.env.NODE_ENV !== "production" && (E7.displayName = "ReactRedux");
function DI(e) {
  e();
}
var uC = DI, OI = function(t) {
  return uC = t;
}, MI = function() {
  return uC;
};
function EI() {
  var e = MI(), t = null, r = null;
  return {
    clear: function() {
      t = null, r = null;
    },
    notify: function() {
      e(function() {
        for (var a = t; a; )
          a.callback(), a = a.next;
      });
    },
    get: function() {
      for (var a = [], i = t; i; )
        a.push(i), i = i.next;
      return a;
    },
    subscribe: function(a) {
      var i = !0, o = r = {
        callback: a,
        next: null,
        prev: r
      };
      return o.prev ? o.prev.next = o : t = o, function() {
        !i || t === null || (i = !1, o.next ? o.next.prev = o.prev : r = o.prev, o.prev ? o.prev.next = o.next : t = o.next);
      };
    }
  };
}
var hf = {
  notify: function() {
  },
  get: function() {
    return [];
  }
};
function dC(e, t) {
  var r, n = hf;
  function a(h) {
    return c(), n.subscribe(h);
  }
  function i() {
    n.notify();
  }
  function o() {
    d.onStateChange && d.onStateChange();
  }
  function s() {
    return !!r;
  }
  function c() {
    r || (r = t ? t.addNestedSub(o) : e.subscribe(o), n = EI());
  }
  function u() {
    r && (r(), r = void 0, n.clear(), n = hf);
  }
  var d = {
    addNestedSub: a,
    notifyNestedSubs: i,
    handleChangeWrapper: o,
    isSubscribed: s,
    trySubscribe: c,
    tryUnsubscribe: u,
    getListeners: function() {
      return n;
    }
  };
  return d;
}
var fC = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? qm : Ne;
function hC(e) {
  var t = e.store, r = e.context, n = e.children, a = dr(function() {
    var s = dC(t);
    return {
      store: t,
      subscription: s
    };
  }, [t]), i = dr(function() {
    return t.getState();
  }, [t]);
  fC(function() {
    var s = a.subscription;
    return s.onStateChange = s.notifyNestedSubs, s.trySubscribe(), i !== t.getState() && s.notifyNestedSubs(), function() {
      s.tryUnsubscribe(), s.onStateChange = null;
    };
  }, [a, i]);
  var o = r || E7;
  return /* @__PURE__ */ P.createElement(o.Provider, {
    value: a
  }, n);
}
process.env.NODE_ENV !== "production" && (hC.propTypes = {
  store: Me.shape({
    subscribe: Me.func.isRequired,
    dispatch: Me.func.isRequired,
    getState: Me.func.isRequired
  }),
  context: Me.object,
  children: Me.any
});
function rs(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if ({}.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var $4 = { exports: {} }, Ze = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Af;
function SI() {
  if (Af)
    return Ze;
  Af = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, A = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function x(C) {
    if (typeof C == "object" && C !== null) {
      var O = C.$$typeof;
      switch (O) {
        case t:
          switch (C = C.type, C) {
            case c:
            case u:
            case n:
            case i:
            case a:
            case h:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case s:
                case d:
                case v:
                case p:
                case o:
                  return C;
                default:
                  return O;
              }
          }
        case r:
          return O;
      }
    }
  }
  function y(C) {
    return x(C) === u;
  }
  return Ze.AsyncMode = c, Ze.ConcurrentMode = u, Ze.ContextConsumer = s, Ze.ContextProvider = o, Ze.Element = t, Ze.ForwardRef = d, Ze.Fragment = n, Ze.Lazy = v, Ze.Memo = p, Ze.Portal = r, Ze.Profiler = i, Ze.StrictMode = a, Ze.Suspense = h, Ze.isAsyncMode = function(C) {
    return y(C) || x(C) === c;
  }, Ze.isConcurrentMode = y, Ze.isContextConsumer = function(C) {
    return x(C) === s;
  }, Ze.isContextProvider = function(C) {
    return x(C) === o;
  }, Ze.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, Ze.isForwardRef = function(C) {
    return x(C) === d;
  }, Ze.isFragment = function(C) {
    return x(C) === n;
  }, Ze.isLazy = function(C) {
    return x(C) === v;
  }, Ze.isMemo = function(C) {
    return x(C) === p;
  }, Ze.isPortal = function(C) {
    return x(C) === r;
  }, Ze.isProfiler = function(C) {
    return x(C) === i;
  }, Ze.isStrictMode = function(C) {
    return x(C) === a;
  }, Ze.isSuspense = function(C) {
    return x(C) === h;
  }, Ze.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === n || C === u || C === i || C === a || C === h || C === A || typeof C == "object" && C !== null && (C.$$typeof === v || C.$$typeof === p || C.$$typeof === o || C.$$typeof === s || C.$$typeof === d || C.$$typeof === m || C.$$typeof === b || C.$$typeof === w || C.$$typeof === g);
  }, Ze.typeOf = x, Ze;
}
var Ke = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pf;
function PI() {
  return pf || (pf = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, A = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function x(S) {
      return typeof S == "string" || typeof S == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      S === n || S === u || S === i || S === a || S === h || S === A || typeof S == "object" && S !== null && (S.$$typeof === v || S.$$typeof === p || S.$$typeof === o || S.$$typeof === s || S.$$typeof === d || S.$$typeof === m || S.$$typeof === b || S.$$typeof === w || S.$$typeof === g);
    }
    function y(S) {
      if (typeof S == "object" && S !== null) {
        var J = S.$$typeof;
        switch (J) {
          case t:
            var q = S.type;
            switch (q) {
              case c:
              case u:
              case n:
              case i:
              case a:
              case h:
                return q;
              default:
                var re = q && q.$$typeof;
                switch (re) {
                  case s:
                  case d:
                  case v:
                  case p:
                  case o:
                    return re;
                  default:
                    return J;
                }
            }
          case r:
            return J;
        }
      }
    }
    var C = c, O = u, M = s, E = o, N = t, F = d, k = n, R = v, j = p, U = r, ee = i, X = a, Z = h, te = !1;
    function B(S) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), I(S) || y(S) === c;
    }
    function I(S) {
      return y(S) === u;
    }
    function _(S) {
      return y(S) === s;
    }
    function L(S) {
      return y(S) === o;
    }
    function D(S) {
      return typeof S == "object" && S !== null && S.$$typeof === t;
    }
    function T(S) {
      return y(S) === d;
    }
    function Q(S) {
      return y(S) === n;
    }
    function z(S) {
      return y(S) === v;
    }
    function W(S) {
      return y(S) === p;
    }
    function H(S) {
      return y(S) === r;
    }
    function $(S) {
      return y(S) === i;
    }
    function V(S) {
      return y(S) === a;
    }
    function Y(S) {
      return y(S) === h;
    }
    Ke.AsyncMode = C, Ke.ConcurrentMode = O, Ke.ContextConsumer = M, Ke.ContextProvider = E, Ke.Element = N, Ke.ForwardRef = F, Ke.Fragment = k, Ke.Lazy = R, Ke.Memo = j, Ke.Portal = U, Ke.Profiler = ee, Ke.StrictMode = X, Ke.Suspense = Z, Ke.isAsyncMode = B, Ke.isConcurrentMode = I, Ke.isContextConsumer = _, Ke.isContextProvider = L, Ke.isElement = D, Ke.isForwardRef = T, Ke.isFragment = Q, Ke.isLazy = z, Ke.isMemo = W, Ke.isPortal = H, Ke.isProfiler = $, Ke.isStrictMode = V, Ke.isSuspense = Y, Ke.isValidElementType = x, Ke.typeOf = y;
  }()), Ke;
}
process.env.NODE_ENV === "production" ? $4.exports = SI() : $4.exports = PI();
var jI = $4.exports, S7 = jI, II = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, BI = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, NI = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, AC = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, P7 = {};
P7[S7.ForwardRef] = NI;
P7[S7.Memo] = AC;
function gf(e) {
  return S7.isMemo(e) ? AC : P7[e.$$typeof] || II;
}
var LI = Object.defineProperty, TI = Object.getOwnPropertyNames, vf = Object.getOwnPropertySymbols, _I = Object.getOwnPropertyDescriptor, RI = Object.getPrototypeOf, mf = Object.prototype;
function pC(e, t, r) {
  if (typeof t != "string") {
    if (mf) {
      var n = RI(t);
      n && n !== mf && pC(e, n, r);
    }
    var a = TI(t);
    vf && (a = a.concat(vf(t)));
    for (var i = gf(e), o = gf(t), s = 0; s < a.length; ++s) {
      var c = a[s];
      if (!BI[c] && !(r && r[c]) && !(o && o[c]) && !(i && i[c])) {
        var u = _I(t, c);
        try {
          LI(e, c, u);
        } catch {
        }
      }
    }
  }
  return e;
}
var FI = pC;
const Cf = /* @__PURE__ */ Xe(FI);
var H4 = { exports: {} }, et = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bf;
function $I() {
  if (bf)
    return et;
  bf = 1;
  var e = 60103, t = 60106, r = 60107, n = 60108, a = 60114, i = 60109, o = 60110, s = 60112, c = 60113, u = 60120, d = 60115, h = 60116, A = 60121, p = 60122, v = 60117, g = 60129, m = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var b = Symbol.for;
    e = b("react.element"), t = b("react.portal"), r = b("react.fragment"), n = b("react.strict_mode"), a = b("react.profiler"), i = b("react.provider"), o = b("react.context"), s = b("react.forward_ref"), c = b("react.suspense"), u = b("react.suspense_list"), d = b("react.memo"), h = b("react.lazy"), A = b("react.block"), p = b("react.server.block"), v = b("react.fundamental"), g = b("react.debug_trace_mode"), m = b("react.legacy_hidden");
  }
  function w(j) {
    if (typeof j == "object" && j !== null) {
      var U = j.$$typeof;
      switch (U) {
        case e:
          switch (j = j.type, j) {
            case r:
            case a:
            case n:
            case c:
            case u:
              return j;
            default:
              switch (j = j && j.$$typeof, j) {
                case o:
                case s:
                case h:
                case d:
                case i:
                  return j;
                default:
                  return U;
              }
          }
        case t:
          return U;
      }
    }
  }
  var x = i, y = e, C = s, O = r, M = h, E = d, N = t, F = a, k = n, R = c;
  return et.ContextConsumer = o, et.ContextProvider = x, et.Element = y, et.ForwardRef = C, et.Fragment = O, et.Lazy = M, et.Memo = E, et.Portal = N, et.Profiler = F, et.StrictMode = k, et.Suspense = R, et.isAsyncMode = function() {
    return !1;
  }, et.isConcurrentMode = function() {
    return !1;
  }, et.isContextConsumer = function(j) {
    return w(j) === o;
  }, et.isContextProvider = function(j) {
    return w(j) === i;
  }, et.isElement = function(j) {
    return typeof j == "object" && j !== null && j.$$typeof === e;
  }, et.isForwardRef = function(j) {
    return w(j) === s;
  }, et.isFragment = function(j) {
    return w(j) === r;
  }, et.isLazy = function(j) {
    return w(j) === h;
  }, et.isMemo = function(j) {
    return w(j) === d;
  }, et.isPortal = function(j) {
    return w(j) === t;
  }, et.isProfiler = function(j) {
    return w(j) === a;
  }, et.isStrictMode = function(j) {
    return w(j) === n;
  }, et.isSuspense = function(j) {
    return w(j) === c;
  }, et.isValidElementType = function(j) {
    return typeof j == "string" || typeof j == "function" || j === r || j === a || j === g || j === n || j === c || j === u || j === m || typeof j == "object" && j !== null && (j.$$typeof === h || j.$$typeof === d || j.$$typeof === i || j.$$typeof === o || j.$$typeof === s || j.$$typeof === v || j.$$typeof === A || j[0] === p);
  }, et.typeOf = w, et;
}
var tt = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yf;
function HI() {
  return yf || (yf = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, r = 60107, n = 60108, a = 60114, i = 60109, o = 60110, s = 60112, c = 60113, u = 60120, d = 60115, h = 60116, A = 60121, p = 60122, v = 60117, g = 60129, m = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var b = Symbol.for;
      e = b("react.element"), t = b("react.portal"), r = b("react.fragment"), n = b("react.strict_mode"), a = b("react.profiler"), i = b("react.provider"), o = b("react.context"), s = b("react.forward_ref"), c = b("react.suspense"), u = b("react.suspense_list"), d = b("react.memo"), h = b("react.lazy"), A = b("react.block"), p = b("react.server.block"), v = b("react.fundamental"), b("react.scope"), b("react.opaque.id"), g = b("react.debug_trace_mode"), b("react.offscreen"), m = b("react.legacy_hidden");
    }
    var w = !1;
    function x(Y) {
      return !!(typeof Y == "string" || typeof Y == "function" || Y === r || Y === a || Y === g || Y === n || Y === c || Y === u || Y === m || w || typeof Y == "object" && Y !== null && (Y.$$typeof === h || Y.$$typeof === d || Y.$$typeof === i || Y.$$typeof === o || Y.$$typeof === s || Y.$$typeof === v || Y.$$typeof === A || Y[0] === p));
    }
    function y(Y) {
      if (typeof Y == "object" && Y !== null) {
        var S = Y.$$typeof;
        switch (S) {
          case e:
            var J = Y.type;
            switch (J) {
              case r:
              case a:
              case n:
              case c:
              case u:
                return J;
              default:
                var q = J && J.$$typeof;
                switch (q) {
                  case o:
                  case s:
                  case h:
                  case d:
                  case i:
                    return q;
                  default:
                    return S;
                }
            }
          case t:
            return S;
        }
      }
    }
    var C = o, O = i, M = e, E = s, N = r, F = h, k = d, R = t, j = a, U = n, ee = c, X = !1, Z = !1;
    function te(Y) {
      return X || (X = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function B(Y) {
      return Z || (Z = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function I(Y) {
      return y(Y) === o;
    }
    function _(Y) {
      return y(Y) === i;
    }
    function L(Y) {
      return typeof Y == "object" && Y !== null && Y.$$typeof === e;
    }
    function D(Y) {
      return y(Y) === s;
    }
    function T(Y) {
      return y(Y) === r;
    }
    function Q(Y) {
      return y(Y) === h;
    }
    function z(Y) {
      return y(Y) === d;
    }
    function W(Y) {
      return y(Y) === t;
    }
    function H(Y) {
      return y(Y) === a;
    }
    function $(Y) {
      return y(Y) === n;
    }
    function V(Y) {
      return y(Y) === c;
    }
    tt.ContextConsumer = C, tt.ContextProvider = O, tt.Element = M, tt.ForwardRef = E, tt.Fragment = N, tt.Lazy = F, tt.Memo = k, tt.Portal = R, tt.Profiler = j, tt.StrictMode = U, tt.Suspense = ee, tt.isAsyncMode = te, tt.isConcurrentMode = B, tt.isContextConsumer = I, tt.isContextProvider = _, tt.isElement = L, tt.isForwardRef = D, tt.isFragment = T, tt.isLazy = Q, tt.isMemo = z, tt.isPortal = W, tt.isProfiler = H, tt.isStrictMode = $, tt.isSuspense = V, tt.isValidElementType = x, tt.typeOf = y;
  }()), tt;
}
process.env.NODE_ENV === "production" ? H4.exports = $I() : H4.exports = HI();
var wf = H4.exports, YI = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"], kI = ["reactReduxForwardedRef"], VI = [], GI = [null, null], WI = function(t) {
  try {
    return JSON.stringify(t);
  } catch {
    return String(t);
  }
};
function QI(e, t) {
  var r = e[1];
  return [t.payload, r + 1];
}
function xf(e, t, r) {
  fC(function() {
    return e.apply(void 0, t);
  }, r);
}
function UI(e, t, r, n, a, i, o) {
  e.current = n, t.current = a, r.current = !1, i.current && (i.current = null, o());
}
function ZI(e, t, r, n, a, i, o, s, c, u) {
  if (e) {
    var d = !1, h = null, A = function() {
      if (!d) {
        var g = t.getState(), m, b;
        try {
          m = n(g, a.current);
        } catch (w) {
          b = w, h = w;
        }
        b || (h = null), m === i.current ? o.current || c() : (i.current = m, s.current = m, o.current = !0, u({
          type: "STORE_UPDATED",
          payload: {
            error: b
          }
        }));
      }
    };
    r.onStateChange = A, r.trySubscribe(), A();
    var p = function() {
      if (d = !0, r.tryUnsubscribe(), r.onStateChange = null, h)
        throw h;
    };
    return p;
  }
}
var KI = function() {
  return [null, 0];
};
function zI(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.getDisplayName, a = n === void 0 ? function(O) {
    return "ConnectAdvanced(" + O + ")";
  } : n, i = r.methodName, o = i === void 0 ? "connectAdvanced" : i, s = r.renderCountProp, c = s === void 0 ? void 0 : s, u = r.shouldHandleStateChanges, d = u === void 0 ? !0 : u, h = r.storeKey, A = h === void 0 ? "store" : h, p = r.withRef, v = p === void 0 ? !1 : p, g = r.forwardRef, m = g === void 0 ? !1 : g, b = r.context, w = b === void 0 ? E7 : b, x = rs(r, YI);
  if (process.env.NODE_ENV !== "production") {
    if (c !== void 0)
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    if (v)
      throw new Error("withRef is removed. To access the wrapped instance, use a ref on the connected component");
    var y = "To use a custom Redux store for specific components, create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    if (A !== "store")
      throw new Error("storeKey has been removed and does not do anything. " + y);
  }
  var C = w;
  return function(M) {
    if (process.env.NODE_ENV !== "production" && !wf.isValidElementType(M))
      throw new Error("You must pass a component to the function returned by " + (o + ". Instead received " + WI(M)));
    var E = M.displayName || M.name || "Component", N = a(E), F = be({}, x, {
      getDisplayName: a,
      methodName: o,
      renderCountProp: c,
      shouldHandleStateChanges: d,
      storeKey: A,
      displayName: N,
      wrappedComponentName: E,
      WrappedComponent: M
    }), k = x.pure;
    function R(Z) {
      return e(Z.dispatch, F);
    }
    var j = k ? dr : function(Z) {
      return Z();
    };
    function U(Z) {
      var te = dr(function() {
        var Re = Z.reactReduxForwardedRef, at = rs(Z, kI);
        return [Z.context, Re, at];
      }, [Z]), B = te[0], I = te[1], _ = te[2], L = dr(function() {
        return B && B.Consumer && wf.isContextConsumer(/* @__PURE__ */ P.createElement(B.Consumer, null)) ? B : C;
      }, [B, C]), D = wt(L), T = !!Z.store && !!Z.store.getState && !!Z.store.dispatch, Q = !!D && !!D.store;
      if (process.env.NODE_ENV !== "production" && !T && !Q)
        throw new Error('Could not find "store" in the context of ' + ('"' + N + '". Either wrap the root component in a <Provider>, ') + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + N + " in connect options."));
      var z = T ? Z.store : D.store, W = dr(function() {
        return R(z);
      }, [z]), H = dr(function() {
        if (!d)
          return GI;
        var Re = dC(z, T ? null : D.subscription), at = Re.notifyNestedSubs.bind(Re);
        return [Re, at];
      }, [z, T, D]), $ = H[0], V = H[1], Y = dr(function() {
        return T ? D : be({}, D, {
          subscription: $
        });
      }, [T, D, $]), S = SE(QI, VI, KI), J = S[0], q = J[0], re = S[1];
      if (q && q.error)
        throw q.error;
      var ae = Ce(), oe = Ce(_), ue = Ce(), Ae = Ce(!1), ge = j(function() {
        return ue.current && _ === oe.current ? ue.current : W(z.getState(), _);
      }, [z, q, _]);
      xf(UI, [oe, ae, Ae, _, ge, ue, V]), xf(ZI, [d, z, $, W, oe, ae, Ae, ue, V, re], [z, $, W]);
      var Se = dr(function() {
        return /* @__PURE__ */ P.createElement(M, be({}, ge, {
          ref: I
        }));
      }, [I, M, ge]), Te = dr(function() {
        return d ? /* @__PURE__ */ P.createElement(L.Provider, {
          value: Y
        }, Se) : Se;
      }, [L, Se, Y]);
      return Te;
    }
    var ee = k ? P.memo(U) : U;
    if (ee.WrappedComponent = M, ee.displayName = U.displayName = N, m) {
      var X = P.forwardRef(function(te, B) {
        return /* @__PURE__ */ P.createElement(ee, be({}, te, {
          reactReduxForwardedRef: B
        }));
      });
      return X.displayName = N, X.WrappedComponent = M, Cf(X, M);
    }
    return Cf(ee, M);
  };
}
function Df(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function v6(e, t) {
  if (Df(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var r = Object.keys(e), n = Object.keys(t);
  if (r.length !== n.length)
    return !1;
  for (var a = 0; a < r.length; a++)
    if (!Object.prototype.hasOwnProperty.call(t, r[a]) || !Df(e[r[a]], t[r[a]]))
      return !1;
  return !0;
}
function qI(e, t) {
  var r = {}, n = function(o) {
    var s = e[o];
    typeof s == "function" && (r[o] = function() {
      return t(s.apply(void 0, arguments));
    });
  };
  for (var a in e)
    n(a);
  return r;
}
function XI(e) {
  if (typeof e != "object" || e === null)
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var r = t; Object.getPrototypeOf(r) !== null; )
    r = Object.getPrototypeOf(r);
  return t === r;
}
function gC(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function vC(e, t, r) {
  XI(e) || gC(r + "() in " + t + " must return a plain object. Instead received " + e + ".");
}
function j7(e) {
  return function(r, n) {
    var a = e(r, n);
    function i() {
      return a;
    }
    return i.dependsOnOwnProps = !1, i;
  };
}
function Of(e) {
  return e.dependsOnOwnProps !== null && e.dependsOnOwnProps !== void 0 ? !!e.dependsOnOwnProps : e.length !== 1;
}
function mC(e, t) {
  return function(n, a) {
    var i = a.displayName, o = function(c, u) {
      return o.dependsOnOwnProps ? o.mapToProps(c, u) : o.mapToProps(c);
    };
    return o.dependsOnOwnProps = !0, o.mapToProps = function(c, u) {
      o.mapToProps = e, o.dependsOnOwnProps = Of(e);
      var d = o(c, u);
      return typeof d == "function" && (o.mapToProps = d, o.dependsOnOwnProps = Of(d), d = o(c, u)), process.env.NODE_ENV !== "production" && vC(d, i, t), d;
    }, o;
  };
}
function JI(e) {
  return typeof e == "function" ? mC(e, "mapDispatchToProps") : void 0;
}
function eB(e) {
  return e ? void 0 : j7(function(t) {
    return {
      dispatch: t
    };
  });
}
function tB(e) {
  return e && typeof e == "object" ? j7(function(t) {
    return qI(e, t);
  }) : void 0;
}
const rB = [JI, eB, tB];
function nB(e) {
  return typeof e == "function" ? mC(e, "mapStateToProps") : void 0;
}
function aB(e) {
  return e ? void 0 : j7(function() {
    return {};
  });
}
const iB = [nB, aB];
function oB(e, t, r) {
  return be({}, r, e, t);
}
function sB(e) {
  return function(r, n) {
    var a = n.displayName, i = n.pure, o = n.areMergedPropsEqual, s = !1, c;
    return function(d, h, A) {
      var p = e(d, h, A);
      return s ? (!i || !o(p, c)) && (c = p) : (s = !0, c = p, process.env.NODE_ENV !== "production" && vC(c, a, "mergeProps")), c;
    };
  };
}
function lB(e) {
  return typeof e == "function" ? sB(e) : void 0;
}
function cB(e) {
  return e ? void 0 : function() {
    return oB;
  };
}
const uB = [lB, cB];
function m6(e, t, r) {
  if (e)
    (t === "mapStateToProps" || t === "mapDispatchToProps") && (Object.prototype.hasOwnProperty.call(e, "dependsOnOwnProps") || gC("The selector for " + t + " of " + r + " did not specify a value for dependsOnOwnProps."));
  else
    throw new Error("Unexpected value for " + t + " in " + r + ".");
}
function dB(e, t, r, n) {
  m6(e, "mapStateToProps", n), m6(t, "mapDispatchToProps", n), m6(r, "mergeProps", n);
}
var fB = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function hB(e, t, r, n) {
  return function(i, o) {
    return r(e(i, o), t(n, o), o);
  };
}
function AB(e, t, r, n, a) {
  var i = a.areStatesEqual, o = a.areOwnPropsEqual, s = a.areStatePropsEqual, c = !1, u, d, h, A, p;
  function v(x, y) {
    return u = x, d = y, h = e(u, d), A = t(n, d), p = r(h, A, d), c = !0, p;
  }
  function g() {
    return h = e(u, d), t.dependsOnOwnProps && (A = t(n, d)), p = r(h, A, d), p;
  }
  function m() {
    return e.dependsOnOwnProps && (h = e(u, d)), t.dependsOnOwnProps && (A = t(n, d)), p = r(h, A, d), p;
  }
  function b() {
    var x = e(u, d), y = !s(x, h);
    return h = x, y && (p = r(h, A, d)), p;
  }
  function w(x, y) {
    var C = !o(y, d), O = !i(x, u, y, d);
    return u = x, d = y, C && O ? g() : C ? m() : O ? b() : p;
  }
  return function(y, C) {
    return c ? w(y, C) : v(y, C);
  };
}
function pB(e, t) {
  var r = t.initMapStateToProps, n = t.initMapDispatchToProps, a = t.initMergeProps, i = rs(t, fB), o = r(e, i), s = n(e, i), c = a(e, i);
  process.env.NODE_ENV !== "production" && dB(o, s, c, i.displayName);
  var u = i.pure ? AB : hB;
  return u(o, s, c, e, i);
}
var gB = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
function C6(e, t, r) {
  for (var n = t.length - 1; n >= 0; n--) {
    var a = t[n](e);
    if (a)
      return a;
  }
  return function(i, o) {
    throw new Error("Invalid value of type " + typeof e + " for " + r + " argument when connecting component " + o.wrappedComponentName + ".");
  };
}
function vB(e, t) {
  return e === t;
}
function mB(e) {
  var t = e === void 0 ? {} : e, r = t.connectHOC, n = r === void 0 ? zI : r, a = t.mapStateToPropsFactories, i = a === void 0 ? iB : a, o = t.mapDispatchToPropsFactories, s = o === void 0 ? rB : o, c = t.mergePropsFactories, u = c === void 0 ? uB : c, d = t.selectorFactory, h = d === void 0 ? pB : d;
  return function(p, v, g, m) {
    m === void 0 && (m = {});
    var b = m, w = b.pure, x = w === void 0 ? !0 : w, y = b.areStatesEqual, C = y === void 0 ? vB : y, O = b.areOwnPropsEqual, M = O === void 0 ? v6 : O, E = b.areStatePropsEqual, N = E === void 0 ? v6 : E, F = b.areMergedPropsEqual, k = F === void 0 ? v6 : F, R = rs(b, gB), j = C6(p, i, "mapStateToProps"), U = C6(v, s, "mapDispatchToProps"), ee = C6(g, u, "mergeProps");
    return n(h, be({
      // used in error messages
      methodName: "connect",
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function(Z) {
        return "Connect(" + Z + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: !!p,
      // passed through to selectorFactory
      initMapStateToProps: j,
      initMapDispatchToProps: U,
      initMergeProps: ee,
      pure: x,
      areStatesEqual: C,
      areOwnPropsEqual: M,
      areStatePropsEqual: N,
      areMergedPropsEqual: k
    }, R));
  };
}
const CC = /* @__PURE__ */ mB();
OI(NE);
function CB(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function bC(e, t) {
  var r = Ee(function() {
    return {
      inputs: t,
      result: e()
    };
  })[0], n = Ce(!0), a = Ce(r), i = n.current || !!(t && a.current.inputs && CB(t, a.current.inputs)), o = i ? a.current : {
    inputs: t,
    result: e()
  };
  return Ne(function() {
    n.current = !1, a.current = o;
  }, [o]), o.result;
}
function bB(e, t) {
  return bC(function() {
    return e;
  }, t);
}
var He = bC, ve = bB, yB = process.env.NODE_ENV === "production", b6 = "Invariant failed";
function Wt(e, t) {
  if (!e) {
    if (yB)
      throw new Error(b6);
    var r = typeof t == "function" ? t() : t, n = r ? "".concat(b6, ": ").concat(r) : b6;
    throw new Error(n);
  }
}
var Yr = function(t) {
  var r = t.top, n = t.right, a = t.bottom, i = t.left, o = n - i, s = a - r, c = {
    top: r,
    right: n,
    bottom: a,
    left: i,
    width: o,
    height: s,
    x: i,
    y: r,
    center: {
      x: (n + i) / 2,
      y: (a + r) / 2
    }
  };
  return c;
}, I7 = function(t, r) {
  return {
    top: t.top - r.top,
    left: t.left - r.left,
    bottom: t.bottom + r.bottom,
    right: t.right + r.right
  };
}, Mf = function(t, r) {
  return {
    top: t.top + r.top,
    left: t.left + r.left,
    bottom: t.bottom - r.bottom,
    right: t.right - r.right
  };
}, wB = function(t, r) {
  return {
    top: t.top + r.y,
    left: t.left + r.x,
    bottom: t.bottom + r.y,
    right: t.right + r.x
  };
}, y6 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, B7 = function(t) {
  var r = t.borderBox, n = t.margin, a = n === void 0 ? y6 : n, i = t.border, o = i === void 0 ? y6 : i, s = t.padding, c = s === void 0 ? y6 : s, u = Yr(I7(r, a)), d = Yr(Mf(r, o)), h = Yr(Mf(d, c));
  return {
    marginBox: u,
    borderBox: Yr(r),
    paddingBox: d,
    contentBox: h,
    margin: a,
    border: o,
    padding: c
  };
}, Cr = function(t) {
  var r = t.slice(0, -2), n = t.slice(-2);
  if (n !== "px")
    return 0;
  var a = Number(r);
  return isNaN(a) && (process.env.NODE_ENV !== "production" ? Wt(!1, "Could not parse value [raw: " + t + ", without suffix: " + r + "]") : Wt(!1)), a;
}, xB = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
}, ns = function(t, r) {
  var n = t.borderBox, a = t.border, i = t.margin, o = t.padding, s = wB(n, r);
  return B7({
    borderBox: s,
    border: a,
    margin: i,
    padding: o
  });
}, as = function(t, r) {
  return r === void 0 && (r = xB()), ns(t, r);
}, yC = function(t, r) {
  var n = {
    top: Cr(r.marginTop),
    right: Cr(r.marginRight),
    bottom: Cr(r.marginBottom),
    left: Cr(r.marginLeft)
  }, a = {
    top: Cr(r.paddingTop),
    right: Cr(r.paddingRight),
    bottom: Cr(r.paddingBottom),
    left: Cr(r.paddingLeft)
  }, i = {
    top: Cr(r.borderTopWidth),
    right: Cr(r.borderRightWidth),
    bottom: Cr(r.borderBottomWidth),
    left: Cr(r.borderLeftWidth)
  };
  return B7({
    borderBox: t,
    margin: n,
    padding: a,
    border: i
  });
}, wC = function(t) {
  var r = t.getBoundingClientRect(), n = window.getComputedStyle(t);
  return yC(r, n);
}, Ef = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function DB(e, t) {
  return !!(e === t || Ef(e) && Ef(t));
}
function OB(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!DB(e[r], t[r]))
      return !1;
  return !0;
}
function _t(e, t) {
  t === void 0 && (t = OB);
  var r, n = [], a, i = !1;
  function o() {
    for (var s = [], c = 0; c < arguments.length; c++)
      s[c] = arguments[c];
    return i && r === this && t(s, n) || (a = e.apply(this, s), i = !0, r = this, n = s), a;
  }
  return o;
}
var MB = function(t) {
  var r = [], n = null, a = function() {
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++)
      s[c] = arguments[c];
    r = s, !n && (n = requestAnimationFrame(function() {
      n = null, t.apply(void 0, r);
    }));
  };
  return a.cancel = function() {
    n && (cancelAnimationFrame(n), n = null);
  }, a;
};
const Ki = MB;
var EB = process.env.NODE_ENV === "production", SB = /[ \t]{2,}/g, PB = /^[ \t]*/gm, Sf = function(t) {
  return t.replace(SB, " ").replace(PB, "").trim();
}, jB = function(t) {
  return Sf(`
  %creact-beautiful-dnd

  %c` + Sf(t) + `

  %c👷‍ This is a development only message. It will be removed in production builds.
`);
}, IB = function(t) {
  return [jB(t), "color: #00C584; font-size: 1.2em; font-weight: bold;", "line-height: 1.5", "color: #723874;"];
}, BB = "__react-beautiful-dnd-disable-dev-warnings";
function xC(e, t) {
  var r;
  EB || typeof window < "u" && window[BB] || (r = console)[e].apply(r, IB(t));
}
var ut = xC.bind(null, "warn"), Y4 = xC.bind(null, "error");
function Jn() {
}
function NB(e, t) {
  return be({}, e, {}, t);
}
function Sr(e, t, r) {
  var n = t.map(function(a) {
    var i = NB(r, a.options);
    return e.addEventListener(a.eventName, a.fn, i), function() {
      e.removeEventListener(a.eventName, a.fn, i);
    };
  });
  return function() {
    n.forEach(function(i) {
      i();
    });
  };
}
var LB = process.env.NODE_ENV === "production", Pf = "Invariant failed";
function zi(e) {
  this.message = e;
}
zi.prototype.toString = function() {
  return this.message;
};
function K(e, t) {
  if (!e)
    throw LB ? new zi(Pf) : new zi(Pf + ": " + (t || ""));
}
var TB = function(e) {
  iC(t, e);
  function t() {
    for (var n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(i)) || this, n.callbacks = null, n.unbind = Jn, n.onWindowError = function(s) {
      var c = n.getCallbacks();
      c.isDragging() && (c.tryAbort(), process.env.NODE_ENV !== "production" && ut(`
        An error was caught by our window 'error' event listener while a drag was occurring.
        The active drag has been aborted.
      `));
      var u = s.error;
      u instanceof zi && (s.preventDefault(), process.env.NODE_ENV !== "production" && Y4(u.message));
    }, n.getCallbacks = function() {
      if (!n.callbacks)
        throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
      return n.callbacks;
    }, n.setCallbacks = function(s) {
      n.callbacks = s;
    }, n;
  }
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.unbind = Sr(window, [{
      eventName: "error",
      fn: this.onWindowError
    }]);
  }, r.componentDidCatch = function(a) {
    if (a instanceof zi) {
      process.env.NODE_ENV !== "production" && Y4(a.message), this.setState({});
      return;
    }
    throw a;
  }, r.componentWillUnmount = function() {
    this.unbind();
  }, r.render = function() {
    return this.props.children(this.setCallbacks);
  }, t;
}(P.Component), _B = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`, is = function(t) {
  return t + 1;
}, RB = function(t) {
  return `
  You have lifted an item in position ` + is(t.source.index) + `
`;
}, DC = function(t, r) {
  var n = t.droppableId === r.droppableId, a = is(t.index), i = is(r.index);
  return n ? `
      You have moved the item from position ` + a + `
      to position ` + i + `
    ` : `
    You have moved the item from position ` + a + `
    in list ` + t.droppableId + `
    to list ` + r.droppableId + `
    in position ` + i + `
  `;
}, OC = function(t, r, n) {
  var a = r.droppableId === n.droppableId;
  return a ? `
      The item ` + t + `
      has been combined with ` + n.draggableId : `
      The item ` + t + `
      in list ` + r.droppableId + `
      has been combined with ` + n.draggableId + `
      in list ` + n.droppableId + `
    `;
}, FB = function(t) {
  var r = t.destination;
  if (r)
    return DC(t.source, r);
  var n = t.combine;
  return n ? OC(t.draggableId, t.source, n) : "You are over an area that cannot be dropped on";
}, jf = function(t) {
  return `
  The item has returned to its starting position
  of ` + is(t.index) + `
`;
}, $B = function(t) {
  if (t.reason === "CANCEL")
    return `
      Movement cancelled.
      ` + jf(t.source) + `
    `;
  var r = t.destination, n = t.combine;
  return r ? `
      You have dropped the item.
      ` + DC(t.source, r) + `
    ` : n ? `
      You have dropped the item.
      ` + OC(t.draggableId, t.source, n) + `
    ` : `
    The item has been dropped while not over a drop area.
    ` + jf(t.source) + `
  `;
}, X3 = {
  dragHandleUsageInstructions: _B,
  onDragStart: RB,
  onDragUpdate: FB,
  onDragEnd: $B
}, Rt = {
  x: 0,
  y: 0
}, Ht = function(t, r) {
  return {
    x: t.x + r.x,
    y: t.y + r.y
  };
}, Ar = function(t, r) {
  return {
    x: t.x - r.x,
    y: t.y - r.y
  };
}, e1 = function(t, r) {
  return t.x === r.x && t.y === r.y;
}, m2 = function(t) {
  return {
    x: t.x !== 0 ? -t.x : 0,
    y: t.y !== 0 ? -t.y : 0
  };
}, X1 = function(t, r, n) {
  var a;
  return n === void 0 && (n = 0), a = {}, a[t] = r, a[t === "x" ? "y" : "x"] = n, a;
}, qi = function(t, r) {
  return Math.sqrt(Math.pow(r.x - t.x, 2) + Math.pow(r.y - t.y, 2));
}, If = function(t, r) {
  return Math.min.apply(Math, r.map(function(n) {
    return qi(t, n);
  }));
}, MC = function(t) {
  return function(r) {
    return {
      x: t(r.x),
      y: t(r.y)
    };
  };
}, HB = function(e, t) {
  var r = Yr({
    top: Math.max(t.top, e.top),
    right: Math.min(t.right, e.right),
    bottom: Math.min(t.bottom, e.bottom),
    left: Math.max(t.left, e.left)
  });
  return r.width <= 0 || r.height <= 0 ? null : r;
}, Yo = function(t, r) {
  return {
    top: t.top + r.y,
    left: t.left + r.x,
    bottom: t.bottom + r.y,
    right: t.right + r.x
  };
}, Bf = function(t) {
  return [{
    x: t.left,
    y: t.top
  }, {
    x: t.right,
    y: t.top
  }, {
    x: t.left,
    y: t.bottom
  }, {
    x: t.right,
    y: t.bottom
  }];
}, YB = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, kB = function(t, r) {
  return r ? Yo(t, r.scroll.diff.displacement) : t;
}, VB = function(t, r, n) {
  if (n && n.increasedBy) {
    var a;
    return be({}, t, (a = {}, a[r.end] = t[r.end] + n.increasedBy[r.line], a));
  }
  return t;
}, GB = function(t, r) {
  return r && r.shouldClipSubject ? HB(r.pageMarginBox, t) : Yr(t);
}, Wa = function(e) {
  var t = e.page, r = e.withPlaceholder, n = e.axis, a = e.frame, i = kB(t.marginBox, a), o = VB(i, n, r), s = GB(o, a);
  return {
    page: t,
    withPlaceholder: r,
    active: s
  };
}, N7 = function(e, t) {
  e.frame || (process.env.NODE_ENV, K(!1));
  var r = e.frame, n = Ar(t, r.scroll.initial), a = m2(n), i = be({}, r, {
    scroll: {
      initial: r.scroll.initial,
      current: t,
      diff: {
        value: n,
        displacement: a
      },
      max: r.scroll.max
    }
  }), o = Wa({
    page: e.subject.page,
    withPlaceholder: e.subject.withPlaceholder,
    axis: e.axis,
    frame: i
  }), s = be({}, e, {
    frame: i,
    subject: o
  });
  return s;
};
function WB(e) {
  return Number.isInteger ? Number.isInteger(e) : typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
function os(e) {
  return Object.values ? Object.values(e) : Object.keys(e).map(function(t) {
    return e[t];
  });
}
function L7(e, t) {
  if (e.findIndex)
    return e.findIndex(t);
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
  return -1;
}
function h1(e, t) {
  if (e.find)
    return e.find(t);
  var r = L7(e, t);
  if (r !== -1)
    return e[r];
}
function EC(e) {
  return Array.prototype.slice.call(e);
}
var SC = _t(function(e) {
  return e.reduce(function(t, r) {
    return t[r.descriptor.id] = r, t;
  }, {});
}), PC = _t(function(e) {
  return e.reduce(function(t, r) {
    return t[r.descriptor.id] = r, t;
  }, {});
}), h0 = _t(function(e) {
  return os(e);
}), QB = _t(function(e) {
  return os(e);
}), na = _t(function(e, t) {
  var r = QB(t).filter(function(n) {
    return e === n.descriptor.droppableId;
  }).sort(function(n, a) {
    return n.descriptor.index - a.descriptor.index;
  });
  return r;
});
function T7(e) {
  return e.at && e.at.type === "REORDER" ? e.at.destination : null;
}
function A0(e) {
  return e.at && e.at.type === "COMBINE" ? e.at.combine : null;
}
var p0 = _t(function(e, t) {
  return t.filter(function(r) {
    return r.descriptor.id !== e.descriptor.id;
  });
}), UB = function(e) {
  var t = e.isMovingForward, r = e.draggable, n = e.destination, a = e.insideDestination, i = e.previousImpact;
  if (!n.isCombineEnabled)
    return null;
  var o = T7(i);
  if (!o)
    return null;
  function s(g) {
    var m = {
      type: "COMBINE",
      combine: {
        draggableId: g,
        droppableId: n.descriptor.id
      }
    };
    return be({}, i, {
      at: m
    });
  }
  var c = i.displaced.all, u = c.length ? c[0] : null;
  if (t)
    return u ? s(u) : null;
  var d = p0(r, a);
  if (!u) {
    if (!d.length)
      return null;
    var h = d[d.length - 1];
    return s(h.descriptor.id);
  }
  var A = L7(d, function(g) {
    return g.descriptor.id === u;
  });
  A === -1 && (process.env.NODE_ENV !== "production" ? K(!1, "Could not find displaced item in set") : K(!1));
  var p = A - 1;
  if (p < 0)
    return null;
  var v = d[p];
  return s(v.descriptor.id);
}, C2 = function(e, t) {
  return e.descriptor.droppableId === t.descriptor.id;
}, jC = {
  point: Rt,
  value: 0
}, Xi = {
  invisible: {},
  visible: {},
  all: []
}, ZB = {
  displaced: Xi,
  displacedBy: jC,
  at: null
}, jr = function(e, t) {
  return function(r) {
    return e <= r && r <= t;
  };
}, IC = function(e) {
  var t = jr(e.top, e.bottom), r = jr(e.left, e.right);
  return function(n) {
    var a = t(n.top) && t(n.bottom) && r(n.left) && r(n.right);
    if (a)
      return !0;
    var i = t(n.top) || t(n.bottom), o = r(n.left) || r(n.right), s = i && o;
    if (s)
      return !0;
    var c = n.top < e.top && n.bottom > e.bottom, u = n.left < e.left && n.right > e.right, d = c && u;
    if (d)
      return !0;
    var h = c && o || u && i;
    return h;
  };
}, KB = function(e) {
  var t = jr(e.top, e.bottom), r = jr(e.left, e.right);
  return function(n) {
    var a = t(n.top) && t(n.bottom) && r(n.left) && r(n.right);
    return a;
  };
}, _7 = {
  direction: "vertical",
  line: "y",
  crossAxisLine: "x",
  start: "top",
  end: "bottom",
  size: "height",
  crossAxisStart: "left",
  crossAxisEnd: "right",
  crossAxisSize: "width"
}, BC = {
  direction: "horizontal",
  line: "x",
  crossAxisLine: "y",
  start: "left",
  end: "right",
  size: "width",
  crossAxisStart: "top",
  crossAxisEnd: "bottom",
  crossAxisSize: "height"
}, zB = function(e) {
  return function(t) {
    var r = jr(t.top, t.bottom), n = jr(t.left, t.right);
    return function(a) {
      return e === _7 ? r(a.top) && r(a.bottom) : n(a.left) && n(a.right);
    };
  };
}, qB = function(t, r) {
  var n = r.frame ? r.frame.scroll.diff.displacement : Rt;
  return Yo(t, n);
}, XB = function(t, r, n) {
  return r.subject.active ? n(r.subject.active)(t) : !1;
}, JB = function(t, r, n) {
  return n(r)(t);
}, R7 = function(t) {
  var r = t.target, n = t.destination, a = t.viewport, i = t.withDroppableDisplacement, o = t.isVisibleThroughFrameFn, s = i ? qB(r, n) : r;
  return XB(s, n, o) && JB(s, a, o);
}, eN = function(t) {
  return R7(be({}, t, {
    isVisibleThroughFrameFn: IC
  }));
}, NC = function(t) {
  return R7(be({}, t, {
    isVisibleThroughFrameFn: KB
  }));
}, tN = function(t) {
  return R7(be({}, t, {
    isVisibleThroughFrameFn: zB(t.destination.axis)
  }));
}, rN = function(t, r, n) {
  if (typeof n == "boolean")
    return n;
  if (!r)
    return !0;
  var a = r.invisible, i = r.visible;
  if (a[t])
    return !1;
  var o = i[t];
  return o ? o.shouldAnimate : !0;
};
function nN(e, t) {
  var r = e.page.marginBox, n = {
    top: t.point.y,
    right: 0,
    bottom: 0,
    left: t.point.x
  };
  return Yr(I7(r, n));
}
function Ji(e) {
  var t = e.afterDragging, r = e.destination, n = e.displacedBy, a = e.viewport, i = e.forceShouldAnimate, o = e.last;
  return t.reduce(function(c, u) {
    var d = nN(u, n), h = u.descriptor.id;
    c.all.push(h);
    var A = eN({
      target: d,
      destination: r,
      viewport: a,
      withDroppableDisplacement: !0
    });
    if (!A)
      return c.invisible[u.descriptor.id] = !0, c;
    var p = rN(h, o, i), v = {
      draggableId: h,
      shouldAnimate: p
    };
    return c.visible[h] = v, c;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}
function aN(e, t) {
  if (!e.length)
    return 0;
  var r = e[e.length - 1].descriptor.index;
  return t.inHomeList ? r : r + 1;
}
function Nf(e) {
  var t = e.insideDestination, r = e.inHomeList, n = e.displacedBy, a = e.destination, i = aN(t, {
    inHomeList: r
  });
  return {
    displaced: Xi,
    displacedBy: n,
    at: {
      type: "REORDER",
      destination: {
        droppableId: a.descriptor.id,
        index: i
      }
    }
  };
}
function ss(e) {
  var t = e.draggable, r = e.insideDestination, n = e.destination, a = e.viewport, i = e.displacedBy, o = e.last, s = e.index, c = e.forceShouldAnimate, u = C2(t, n);
  if (s == null)
    return Nf({
      insideDestination: r,
      inHomeList: u,
      displacedBy: i,
      destination: n
    });
  var d = h1(r, function(g) {
    return g.descriptor.index === s;
  });
  if (!d)
    return Nf({
      insideDestination: r,
      inHomeList: u,
      displacedBy: i,
      destination: n
    });
  var h = p0(t, r), A = r.indexOf(d), p = h.slice(A), v = Ji({
    afterDragging: p,
    destination: n,
    displacedBy: i,
    last: o,
    viewport: a.frame,
    forceShouldAnimate: c
  });
  return {
    displaced: v,
    displacedBy: i,
    at: {
      type: "REORDER",
      destination: {
        droppableId: n.descriptor.id,
        index: s
      }
    }
  };
}
function o1(e, t) {
  return !!t.effected[e];
}
var iN = function(e) {
  var t = e.isMovingForward, r = e.destination, n = e.draggables, a = e.combine, i = e.afterCritical;
  if (!r.isCombineEnabled)
    return null;
  var o = a.draggableId, s = n[o], c = s.descriptor.index, u = o1(o, i);
  return u ? t ? c : c - 1 : t ? c + 1 : c;
}, oN = function(e) {
  var t = e.isMovingForward, r = e.isInHomeList, n = e.insideDestination, a = e.location;
  if (!n.length)
    return null;
  var i = a.index, o = t ? i + 1 : i - 1, s = n[0].descriptor.index, c = n[n.length - 1].descriptor.index, u = r ? c : c + 1;
  return o < s || o > u ? null : o;
}, sN = function(e) {
  var t = e.isMovingForward, r = e.isInHomeList, n = e.draggable, a = e.draggables, i = e.destination, o = e.insideDestination, s = e.previousImpact, c = e.viewport, u = e.afterCritical, d = s.at;
  if (d || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot move in direction without previous impact location") : K(!1)), d.type === "REORDER") {
    var h = oN({
      isMovingForward: t,
      isInHomeList: r,
      location: d.destination,
      insideDestination: o
    });
    return h == null ? null : ss({
      draggable: n,
      insideDestination: o,
      destination: i,
      viewport: c,
      last: s.displaced,
      displacedBy: s.displacedBy,
      index: h
    });
  }
  var A = iN({
    isMovingForward: t,
    destination: i,
    displaced: s.displaced,
    draggables: a,
    combine: d.combine,
    afterCritical: u
  });
  return A == null ? null : ss({
    draggable: n,
    insideDestination: o,
    destination: i,
    viewport: c,
    last: s.displaced,
    displacedBy: s.displacedBy,
    index: A
  });
}, lN = function(e) {
  var t = e.displaced, r = e.afterCritical, n = e.combineWith, a = e.displacedBy, i = !!(t.visible[n] || t.invisible[n]);
  return o1(n, r) ? i ? Rt : m2(a.point) : i ? a.point : Rt;
}, cN = function(e) {
  var t = e.afterCritical, r = e.impact, n = e.draggables, a = A0(r);
  a || (process.env.NODE_ENV, K(!1));
  var i = a.draggableId, o = n[i].page.borderBox.center, s = lN({
    displaced: r.displaced,
    afterCritical: t,
    combineWith: i,
    displacedBy: r.displacedBy
  });
  return Ht(o, s);
}, LC = function(t, r) {
  return r.margin[t.start] + r.borderBox[t.size] / 2;
}, uN = function(t, r) {
  return r.margin[t.end] + r.borderBox[t.size] / 2;
}, F7 = function(t, r, n) {
  return r[t.crossAxisStart] + n.margin[t.crossAxisStart] + n.borderBox[t.crossAxisSize] / 2;
}, Lf = function(t) {
  var r = t.axis, n = t.moveRelativeTo, a = t.isMoving;
  return X1(r.line, n.marginBox[r.end] + LC(r, a), F7(r, n.marginBox, a));
}, Tf = function(t) {
  var r = t.axis, n = t.moveRelativeTo, a = t.isMoving;
  return X1(r.line, n.marginBox[r.start] - uN(r, a), F7(r, n.marginBox, a));
}, dN = function(t) {
  var r = t.axis, n = t.moveInto, a = t.isMoving;
  return X1(r.line, n.contentBox[r.start] + LC(r, a), F7(r, n.contentBox, a));
}, fN = function(e) {
  var t = e.impact, r = e.draggable, n = e.draggables, a = e.droppable, i = e.afterCritical, o = na(a.descriptor.id, n), s = r.page, c = a.axis;
  if (!o.length)
    return dN({
      axis: c,
      moveInto: a.page,
      isMoving: s
    });
  var u = t.displaced, d = t.displacedBy, h = u.all[0];
  if (h) {
    var A = n[h];
    if (o1(h, i))
      return Tf({
        axis: c,
        moveRelativeTo: A.page,
        isMoving: s
      });
    var p = ns(A.page, d.point);
    return Tf({
      axis: c,
      moveRelativeTo: p,
      isMoving: s
    });
  }
  var v = o[o.length - 1];
  if (v.descriptor.id === r.descriptor.id)
    return s.borderBox.center;
  if (o1(v.descriptor.id, i)) {
    var g = ns(v.page, m2(i.displacedBy.point));
    return Lf({
      axis: c,
      moveRelativeTo: g,
      isMoving: s
    });
  }
  return Lf({
    axis: c,
    moveRelativeTo: v.page,
    isMoving: s
  });
}, k4 = function(e, t) {
  var r = e.frame;
  return r ? Ht(t, r.scroll.diff.displacement) : t;
}, hN = function(t) {
  var r = t.impact, n = t.draggable, a = t.droppable, i = t.draggables, o = t.afterCritical, s = n.page.borderBox.center, c = r.at;
  return !a || !c ? s : c.type === "REORDER" ? fN({
    impact: r,
    draggable: n,
    draggables: i,
    droppable: a,
    afterCritical: o
  }) : cN({
    impact: r,
    draggables: i,
    afterCritical: o
  });
}, g0 = function(e) {
  var t = hN(e), r = e.droppable, n = r ? k4(r, t) : t;
  return n;
}, TC = function(e, t) {
  var r = Ar(t, e.scroll.initial), n = m2(r), a = Yr({
    top: t.y,
    bottom: t.y + e.frame.height,
    left: t.x,
    right: t.x + e.frame.width
  }), i = {
    frame: a,
    scroll: {
      initial: e.scroll.initial,
      max: e.scroll.max,
      current: t,
      diff: {
        value: r,
        displacement: n
      }
    }
  };
  return i;
};
function _f(e, t) {
  return e.map(function(r) {
    return t[r];
  });
}
function AN(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r].visible[e];
    if (n)
      return n;
  }
  return null;
}
var pN = function(e) {
  var t = e.impact, r = e.viewport, n = e.destination, a = e.draggables, i = e.maxScrollChange, o = TC(r, Ht(r.scroll.current, i)), s = n.frame ? N7(n, Ht(n.frame.scroll.current, i)) : n, c = t.displaced, u = Ji({
    afterDragging: _f(c.all, a),
    destination: n,
    displacedBy: t.displacedBy,
    viewport: o.frame,
    last: c,
    forceShouldAnimate: !1
  }), d = Ji({
    afterDragging: _f(c.all, a),
    destination: s,
    displacedBy: t.displacedBy,
    viewport: r.frame,
    last: c,
    forceShouldAnimate: !1
  }), h = {}, A = {}, p = [c, u, d];
  c.all.forEach(function(g) {
    var m = AN(g, p);
    if (m) {
      A[g] = m;
      return;
    }
    h[g] = !0;
  });
  var v = be({}, t, {
    displaced: {
      all: c.all,
      invisible: h,
      visible: A
    }
  });
  return v;
}, gN = function(e, t) {
  return Ht(e.scroll.diff.displacement, t);
}, $7 = function(e) {
  var t = e.pageBorderBoxCenter, r = e.draggable, n = e.viewport, a = gN(n, t), i = Ar(a, r.page.borderBox.center);
  return Ht(r.client.borderBox.center, i);
}, _C = function(e) {
  var t = e.draggable, r = e.destination, n = e.newPageBorderBoxCenter, a = e.viewport, i = e.withDroppableDisplacement, o = e.onlyOnMainAxis, s = o === void 0 ? !1 : o, c = Ar(n, t.page.borderBox.center), u = Yo(t.page.borderBox, c), d = {
    target: u,
    destination: r,
    withDroppableDisplacement: i,
    viewport: a
  };
  return s ? tN(d) : NC(d);
}, vN = function(e) {
  var t = e.isMovingForward, r = e.draggable, n = e.destination, a = e.draggables, i = e.previousImpact, o = e.viewport, s = e.previousPageBorderBoxCenter, c = e.previousClientSelection, u = e.afterCritical;
  if (!n.isEnabled)
    return null;
  var d = na(n.descriptor.id, a), h = C2(r, n), A = UB({
    isMovingForward: t,
    draggable: r,
    destination: n,
    insideDestination: d,
    previousImpact: i
  }) || sN({
    isMovingForward: t,
    isInHomeList: h,
    draggable: r,
    draggables: a,
    destination: n,
    insideDestination: d,
    previousImpact: i,
    viewport: o,
    afterCritical: u
  });
  if (!A)
    return null;
  var p = g0({
    impact: A,
    draggable: r,
    droppable: n,
    draggables: a,
    afterCritical: u
  }), v = _C({
    draggable: r,
    destination: n,
    newPageBorderBoxCenter: p,
    viewport: o.frame,
    withDroppableDisplacement: !1,
    onlyOnMainAxis: !0
  });
  if (v) {
    var g = $7({
      pageBorderBoxCenter: p,
      draggable: r,
      viewport: o
    });
    return {
      clientSelection: g,
      impact: A,
      scrollJumpRequest: null
    };
  }
  var m = Ar(p, s), b = pN({
    impact: A,
    viewport: o,
    destination: n,
    draggables: a,
    maxScrollChange: m
  });
  return {
    clientSelection: c,
    impact: b,
    scrollJumpRequest: m
  };
}, Ut = function(t) {
  var r = t.subject.active;
  return r || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot get clipped area from droppable") : K(!1)), r;
}, mN = function(e) {
  var t = e.isMovingForward, r = e.pageBorderBoxCenter, n = e.source, a = e.droppables, i = e.viewport, o = n.subject.active;
  if (!o)
    return null;
  var s = n.axis, c = jr(o[s.start], o[s.end]), u = h0(a).filter(function(h) {
    return h !== n;
  }).filter(function(h) {
    return h.isEnabled;
  }).filter(function(h) {
    return !!h.subject.active;
  }).filter(function(h) {
    return IC(i.frame)(Ut(h));
  }).filter(function(h) {
    var A = Ut(h);
    return t ? o[s.crossAxisEnd] < A[s.crossAxisEnd] : A[s.crossAxisStart] < o[s.crossAxisStart];
  }).filter(function(h) {
    var A = Ut(h), p = jr(A[s.start], A[s.end]);
    return c(A[s.start]) || c(A[s.end]) || p(o[s.start]) || p(o[s.end]);
  }).sort(function(h, A) {
    var p = Ut(h)[s.crossAxisStart], v = Ut(A)[s.crossAxisStart];
    return t ? p - v : v - p;
  }).filter(function(h, A, p) {
    return Ut(h)[s.crossAxisStart] === Ut(p[0])[s.crossAxisStart];
  });
  if (!u.length)
    return null;
  if (u.length === 1)
    return u[0];
  var d = u.filter(function(h) {
    var A = jr(Ut(h)[s.start], Ut(h)[s.end]);
    return A(r[s.line]);
  });
  return d.length === 1 ? d[0] : d.length > 1 ? d.sort(function(h, A) {
    return Ut(h)[s.start] - Ut(A)[s.start];
  })[0] : u.sort(function(h, A) {
    var p = If(r, Bf(Ut(h))), v = If(r, Bf(Ut(A)));
    return p !== v ? p - v : Ut(h)[s.start] - Ut(A)[s.start];
  })[0];
}, Rf = function(t, r) {
  var n = t.page.borderBox.center;
  return o1(t.descriptor.id, r) ? Ar(n, r.displacedBy.point) : n;
}, CN = function(t, r) {
  var n = t.page.borderBox;
  return o1(t.descriptor.id, r) ? Yo(n, m2(r.displacedBy.point)) : n;
}, bN = function(e) {
  var t = e.pageBorderBoxCenter, r = e.viewport, n = e.destination, a = e.insideDestination, i = e.afterCritical, o = a.filter(function(s) {
    return NC({
      target: CN(s, i),
      destination: n,
      viewport: r.frame,
      withDroppableDisplacement: !0
    });
  }).sort(function(s, c) {
    var u = qi(t, k4(n, Rf(s, i))), d = qi(t, k4(n, Rf(c, i)));
    return u < d ? -1 : d < u ? 1 : s.descriptor.index - c.descriptor.index;
  });
  return o[0] || null;
}, ko = _t(function(t, r) {
  var n = r[t.line];
  return {
    value: n,
    point: X1(t.line, n)
  };
}), yN = function(t, r, n) {
  var a = t.axis;
  if (t.descriptor.mode === "virtual")
    return X1(a.line, r[a.line]);
  var i = t.subject.page.contentBox[a.size], o = na(t.descriptor.id, n), s = o.reduce(function(d, h) {
    return d + h.client.marginBox[a.size];
  }, 0), c = s + r[a.line], u = c - i;
  return u <= 0 ? null : X1(a.line, u);
}, RC = function(t, r) {
  return be({}, t, {
    scroll: be({}, t.scroll, {
      max: r
    })
  });
}, FC = function(t, r, n) {
  var a = t.frame;
  C2(r, t) && (process.env.NODE_ENV !== "production" ? K(!1, "Should not add placeholder space to home list") : K(!1)), t.subject.withPlaceholder && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot add placeholder size to a subject when it already has one") : K(!1));
  var i = ko(t.axis, r.displaceBy).point, o = yN(t, i, n), s = {
    placeholderSize: i,
    increasedBy: o,
    oldFrameMaxScroll: t.frame ? t.frame.scroll.max : null
  };
  if (!a) {
    var c = Wa({
      page: t.subject.page,
      withPlaceholder: s,
      axis: t.axis,
      frame: t.frame
    });
    return be({}, t, {
      subject: c
    });
  }
  var u = o ? Ht(a.scroll.max, o) : a.scroll.max, d = RC(a, u), h = Wa({
    page: t.subject.page,
    withPlaceholder: s,
    axis: t.axis,
    frame: d
  });
  return be({}, t, {
    subject: h,
    frame: d
  });
}, wN = function(t) {
  var r = t.subject.withPlaceholder;
  r || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot remove placeholder form subject when there was none") : K(!1));
  var n = t.frame;
  if (!n) {
    var a = Wa({
      page: t.subject.page,
      axis: t.axis,
      frame: null,
      withPlaceholder: null
    });
    return be({}, t, {
      subject: a
    });
  }
  var i = r.oldFrameMaxScroll;
  i || (process.env.NODE_ENV !== "production" ? K(!1, "Expected droppable with frame to have old max frame scroll when removing placeholder") : K(!1));
  var o = RC(n, i), s = Wa({
    page: t.subject.page,
    axis: t.axis,
    frame: o,
    withPlaceholder: null
  });
  return be({}, t, {
    subject: s,
    frame: o
  });
}, xN = function(e) {
  var t = e.previousPageBorderBoxCenter, r = e.moveRelativeTo, n = e.insideDestination, a = e.draggable, i = e.draggables, o = e.destination, s = e.viewport, c = e.afterCritical;
  if (!r) {
    if (n.length)
      return null;
    var u = {
      displaced: Xi,
      displacedBy: jC,
      at: {
        type: "REORDER",
        destination: {
          droppableId: o.descriptor.id,
          index: 0
        }
      }
    }, d = g0({
      impact: u,
      draggable: a,
      droppable: o,
      draggables: i,
      afterCritical: c
    }), h = C2(a, o) ? o : FC(o, a, i), A = _C({
      draggable: a,
      destination: h,
      newPageBorderBoxCenter: d,
      viewport: s.frame,
      withDroppableDisplacement: !1,
      onlyOnMainAxis: !0
    });
    return A ? u : null;
  }
  var p = t[o.axis.line] <= r.page.borderBox.center[o.axis.line], v = function() {
    var m = r.descriptor.index;
    return r.descriptor.id === a.descriptor.id || p ? m : m + 1;
  }(), g = ko(o.axis, a.displaceBy);
  return ss({
    draggable: a,
    insideDestination: n,
    destination: o,
    viewport: s,
    displacedBy: g,
    last: Xi,
    index: v
  });
}, DN = function(e) {
  var t = e.isMovingForward, r = e.previousPageBorderBoxCenter, n = e.draggable, a = e.isOver, i = e.draggables, o = e.droppables, s = e.viewport, c = e.afterCritical, u = mN({
    isMovingForward: t,
    pageBorderBoxCenter: r,
    source: a,
    droppables: o,
    viewport: s
  });
  if (!u)
    return null;
  var d = na(u.descriptor.id, i), h = bN({
    pageBorderBoxCenter: r,
    viewport: s,
    destination: u,
    insideDestination: d,
    afterCritical: c
  }), A = xN({
    previousPageBorderBoxCenter: r,
    destination: u,
    draggable: n,
    draggables: i,
    moveRelativeTo: h,
    insideDestination: d,
    viewport: s,
    afterCritical: c
  });
  if (!A)
    return null;
  var p = g0({
    impact: A,
    draggable: n,
    droppable: u,
    draggables: i,
    afterCritical: c
  }), v = $7({
    pageBorderBoxCenter: p,
    draggable: n,
    viewport: s
  });
  return {
    clientSelection: v,
    impact: A,
    scrollJumpRequest: null
  };
}, pr = function(e) {
  var t = e.at;
  return t ? t.type === "REORDER" ? t.destination.droppableId : t.combine.droppableId : null;
}, ON = function(t, r) {
  var n = pr(t);
  return n ? r[n] : null;
}, MN = function(e) {
  var t = e.state, r = e.type, n = ON(t.impact, t.dimensions.droppables), a = !!n, i = t.dimensions.droppables[t.critical.droppable.id], o = n || i, s = o.axis.direction, c = s === "vertical" && (r === "MOVE_UP" || r === "MOVE_DOWN") || s === "horizontal" && (r === "MOVE_LEFT" || r === "MOVE_RIGHT");
  if (c && !a)
    return null;
  var u = r === "MOVE_DOWN" || r === "MOVE_RIGHT", d = t.dimensions.draggables[t.critical.draggable.id], h = t.current.page.borderBoxCenter, A = t.dimensions, p = A.draggables, v = A.droppables;
  return c ? vN({
    isMovingForward: u,
    previousPageBorderBoxCenter: h,
    draggable: d,
    destination: o,
    draggables: p,
    viewport: t.viewport,
    previousClientSelection: t.current.client.selection,
    previousImpact: t.impact,
    afterCritical: t.afterCritical
  }) : DN({
    isMovingForward: u,
    previousPageBorderBoxCenter: h,
    draggable: d,
    isOver: o,
    draggables: p,
    droppables: v,
    viewport: t.viewport,
    afterCritical: t.afterCritical
  });
};
function _1(e) {
  return e.phase === "DRAGGING" || e.phase === "COLLECTING";
}
function $C(e) {
  var t = jr(e.top, e.bottom), r = jr(e.left, e.right);
  return function(a) {
    return t(a.y) && r(a.x);
  };
}
function EN(e, t) {
  return e.left < t.right && e.right > t.left && e.top < t.bottom && e.bottom > t.top;
}
function SN(e) {
  var t = e.pageBorderBox, r = e.draggable, n = e.candidates, a = r.page.borderBox.center, i = n.map(function(o) {
    var s = o.axis, c = X1(o.axis.line, t.center[s.line], o.page.borderBox.center[s.crossAxisLine]);
    return {
      id: o.descriptor.id,
      distance: qi(a, c)
    };
  }).sort(function(o, s) {
    return s.distance - o.distance;
  });
  return i[0] ? i[0].id : null;
}
function PN(e) {
  var t = e.pageBorderBox, r = e.draggable, n = e.droppables, a = h0(n).filter(function(i) {
    if (!i.isEnabled)
      return !1;
    var o = i.subject.active;
    if (!o || !EN(t, o))
      return !1;
    if ($C(o)(t.center))
      return !0;
    var s = i.axis, c = o.center[s.crossAxisLine], u = t[s.crossAxisStart], d = t[s.crossAxisEnd], h = jr(o[s.crossAxisStart], o[s.crossAxisEnd]), A = h(u), p = h(d);
    return !A && !p ? !0 : A ? u < c : d > c;
  });
  return a.length ? a.length === 1 ? a[0].descriptor.id : SN({
    pageBorderBox: t,
    draggable: r,
    candidates: a
  }) : null;
}
var HC = function(t, r) {
  return Yr(Yo(t, r));
}, jN = function(e, t) {
  var r = e.frame;
  return r ? HC(t, r.scroll.diff.value) : t;
};
function YC(e) {
  var t = e.displaced, r = e.id;
  return !!(t.visible[r] || t.invisible[r]);
}
function IN(e) {
  var t = e.draggable, r = e.closest, n = e.inHomeList;
  return r ? n && r.descriptor.index > t.descriptor.index ? r.descriptor.index - 1 : r.descriptor.index : null;
}
var BN = function(e) {
  var t = e.pageBorderBoxWithDroppableScroll, r = e.draggable, n = e.destination, a = e.insideDestination, i = e.last, o = e.viewport, s = e.afterCritical, c = n.axis, u = ko(n.axis, r.displaceBy), d = u.value, h = t[c.start], A = t[c.end], p = p0(r, a), v = h1(p, function(m) {
    var b = m.descriptor.id, w = m.page.borderBox.center[c.line], x = o1(b, s), y = YC({
      displaced: i,
      id: b
    });
    return x ? y ? A <= w : h < w - d : y ? A <= w + d : h < w;
  }), g = IN({
    draggable: r,
    closest: v,
    inHomeList: C2(r, n)
  });
  return ss({
    draggable: r,
    insideDestination: a,
    destination: n,
    viewport: o,
    last: i,
    displacedBy: u,
    index: g
  });
}, NN = 4, LN = function(e) {
  var t = e.draggable, r = e.pageBorderBoxWithDroppableScroll, n = e.previousImpact, a = e.destination, i = e.insideDestination, o = e.afterCritical;
  if (!a.isCombineEnabled)
    return null;
  var s = a.axis, c = ko(a.axis, t.displaceBy), u = c.value, d = r[s.start], h = r[s.end], A = p0(t, i), p = h1(A, function(g) {
    var m = g.descriptor.id, b = g.page.borderBox, w = b[s.size], x = w / NN, y = o1(m, o), C = YC({
      displaced: n.displaced,
      id: m
    });
    return y ? C ? h > b[s.start] + x && h < b[s.end] - x : d > b[s.start] - u + x && d < b[s.end] - u - x : C ? h > b[s.start] + u + x && h < b[s.end] + u - x : d > b[s.start] + x && d < b[s.end] - x;
  });
  if (!p)
    return null;
  var v = {
    displacedBy: c,
    displaced: n.displaced,
    at: {
      type: "COMBINE",
      combine: {
        draggableId: p.descriptor.id,
        droppableId: a.descriptor.id
      }
    }
  };
  return v;
}, kC = function(e) {
  var t = e.pageOffset, r = e.draggable, n = e.draggables, a = e.droppables, i = e.previousImpact, o = e.viewport, s = e.afterCritical, c = HC(r.page.borderBox, t), u = PN({
    pageBorderBox: c,
    draggable: r,
    droppables: a
  });
  if (!u)
    return ZB;
  var d = a[u], h = na(d.descriptor.id, n), A = jN(d, c);
  return LN({
    pageBorderBoxWithDroppableScroll: A,
    draggable: r,
    previousImpact: i,
    destination: d,
    insideDestination: h,
    afterCritical: s
  }) || BN({
    pageBorderBoxWithDroppableScroll: A,
    draggable: r,
    destination: d,
    insideDestination: h,
    last: i.displaced,
    viewport: o,
    afterCritical: s
  });
}, H7 = function(e, t) {
  var r;
  return be({}, e, (r = {}, r[t.descriptor.id] = t, r));
}, TN = function(t) {
  var r = t.previousImpact, n = t.impact, a = t.droppables, i = pr(r), o = pr(n);
  if (!i || i === o)
    return a;
  var s = a[i];
  if (!s.subject.withPlaceholder)
    return a;
  var c = wN(s);
  return H7(a, c);
}, _N = function(e) {
  var t = e.draggable, r = e.draggables, n = e.droppables, a = e.previousImpact, i = e.impact, o = TN({
    previousImpact: a,
    impact: i,
    droppables: n
  }), s = pr(i);
  if (!s)
    return o;
  var c = n[s];
  if (C2(t, c) || c.subject.withPlaceholder)
    return o;
  var u = FC(c, t, r);
  return H7(o, u);
}, Ti = function(e) {
  var t = e.state, r = e.clientSelection, n = e.dimensions, a = e.viewport, i = e.impact, o = e.scrollJumpRequest, s = a || t.viewport, c = n || t.dimensions, u = r || t.current.client.selection, d = Ar(u, t.initial.client.selection), h = {
    offset: d,
    selection: u,
    borderBoxCenter: Ht(t.initial.client.borderBoxCenter, d)
  }, A = {
    selection: Ht(h.selection, s.scroll.current),
    borderBoxCenter: Ht(h.borderBoxCenter, s.scroll.current),
    offset: Ht(h.offset, s.scroll.diff.value)
  }, p = {
    client: h,
    page: A
  };
  if (t.phase === "COLLECTING")
    return be({
      phase: "COLLECTING"
    }, t, {
      dimensions: c,
      viewport: s,
      current: p
    });
  var v = c.draggables[t.critical.draggable.id], g = i || kC({
    pageOffset: A.offset,
    draggable: v,
    draggables: c.draggables,
    droppables: c.droppables,
    previousImpact: t.impact,
    viewport: s,
    afterCritical: t.afterCritical
  }), m = _N({
    draggable: v,
    impact: g,
    previousImpact: t.impact,
    draggables: c.draggables,
    droppables: c.droppables
  }), b = be({}, t, {
    current: p,
    dimensions: {
      draggables: c.draggables,
      droppables: m
    },
    impact: g,
    viewport: s,
    scrollJumpRequest: o || null,
    forceShouldAnimate: o ? !1 : null
  });
  return b;
};
function RN(e, t) {
  return e.map(function(r) {
    return t[r];
  });
}
var VC = function(e) {
  var t = e.impact, r = e.viewport, n = e.draggables, a = e.destination, i = e.forceShouldAnimate, o = t.displaced, s = RN(o.all, n), c = Ji({
    afterDragging: s,
    destination: a,
    displacedBy: t.displacedBy,
    viewport: r.frame,
    forceShouldAnimate: i,
    last: o
  });
  return be({}, t, {
    displaced: c
  });
}, GC = function(e) {
  var t = e.impact, r = e.draggable, n = e.droppable, a = e.draggables, i = e.viewport, o = e.afterCritical, s = g0({
    impact: t,
    draggable: r,
    draggables: a,
    droppable: n,
    afterCritical: o
  });
  return $7({
    pageBorderBoxCenter: s,
    draggable: r,
    viewport: i
  });
}, WC = function(e) {
  var t = e.state, r = e.dimensions, n = e.viewport;
  t.movementMode !== "SNAP" && (process.env.NODE_ENV, K(!1));
  var a = t.impact, i = n || t.viewport, o = r || t.dimensions, s = o.draggables, c = o.droppables, u = s[t.critical.draggable.id], d = pr(a);
  d || (process.env.NODE_ENV !== "production" ? K(!1, "Must be over a destination in SNAP movement mode") : K(!1));
  var h = c[d], A = VC({
    impact: a,
    viewport: i,
    destination: h,
    draggables: s
  }), p = GC({
    impact: A,
    draggable: u,
    droppable: h,
    draggables: s,
    viewport: i,
    afterCritical: t.afterCritical
  });
  return Ti({
    impact: A,
    clientSelection: p,
    state: t,
    dimensions: o,
    viewport: i
  });
}, FN = function(e) {
  return {
    index: e.index,
    droppableId: e.droppableId
  };
}, QC = function(e) {
  var t = e.draggable, r = e.home, n = e.draggables, a = e.viewport, i = ko(r.axis, t.displaceBy), o = na(r.descriptor.id, n), s = o.indexOf(t);
  s === -1 && (process.env.NODE_ENV !== "production" ? K(!1, "Expected draggable to be inside home list") : K(!1));
  var c = o.slice(s + 1), u = c.reduce(function(p, v) {
    return p[v.descriptor.id] = !0, p;
  }, {}), d = {
    inVirtualList: r.descriptor.mode === "virtual",
    displacedBy: i,
    effected: u
  }, h = Ji({
    afterDragging: c,
    destination: r,
    displacedBy: i,
    last: null,
    viewport: a.frame,
    forceShouldAnimate: !1
  }), A = {
    displaced: h,
    displacedBy: i,
    at: {
      type: "REORDER",
      destination: FN(t.descriptor)
    }
  };
  return {
    impact: A,
    afterCritical: d
  };
}, $N = function(e, t) {
  return {
    draggables: e.draggables,
    droppables: H7(e.droppables, t)
  };
}, Vo = function(t) {
  process.env.NODE_ENV;
}, Go = function(t) {
  process.env.NODE_ENV;
}, HN = function(e) {
  var t = e.draggable, r = e.offset, n = e.initialWindowScroll, a = ns(t.client, r), i = as(a, n), o = be({}, t, {
    placeholder: be({}, t.placeholder, {
      client: a
    }),
    client: a,
    page: i
  });
  return o;
}, YN = function(e) {
  var t = e.frame;
  return t || (process.env.NODE_ENV !== "production" ? K(!1, "Expected Droppable to have a frame") : K(!1)), t;
}, kN = function(e) {
  var t = e.additions, r = e.updatedDroppables, n = e.viewport, a = n.scroll.diff.value;
  return t.map(function(i) {
    var o = i.descriptor.droppableId, s = r[o], c = YN(s), u = c.scroll.diff.value, d = Ht(a, u), h = HN({
      draggable: i,
      offset: d,
      initialWindowScroll: n.scroll.initial
    });
    return h;
  });
}, VN = function(e) {
  var t = e.state, r = e.published;
  Vo();
  var n = r.modified.map(function(x) {
    var y = t.dimensions.droppables[x.droppableId], C = N7(y, x.scroll);
    return C;
  }), a = be({}, t.dimensions.droppables, {}, SC(n)), i = PC(kN({
    additions: r.additions,
    updatedDroppables: a,
    viewport: t.viewport
  })), o = be({}, t.dimensions.draggables, {}, i);
  r.removals.forEach(function(x) {
    delete o[x];
  });
  var s = {
    droppables: a,
    draggables: o
  }, c = pr(t.impact), u = c ? s.droppables[c] : null, d = s.draggables[t.critical.draggable.id], h = s.droppables[t.critical.droppable.id], A = QC({
    draggable: d,
    home: h,
    draggables: o,
    viewport: t.viewport
  }), p = A.impact, v = A.afterCritical, g = u && u.isCombineEnabled ? t.impact : p, m = kC({
    pageOffset: t.current.page.offset,
    draggable: s.draggables[t.critical.draggable.id],
    draggables: s.draggables,
    droppables: s.droppables,
    previousImpact: g,
    viewport: t.viewport,
    afterCritical: v
  });
  Go();
  var b = be({
    phase: "DRAGGING"
  }, t, {
    phase: "DRAGGING",
    impact: m,
    onLiftImpact: p,
    dimensions: s,
    afterCritical: v,
    forceShouldAnimate: !1
  });
  if (t.phase === "COLLECTING")
    return b;
  var w = be({
    phase: "DROP_PENDING"
  }, b, {
    phase: "DROP_PENDING",
    reason: t.reason,
    isWaiting: !1
  });
  return w;
}, V4 = function(t) {
  return t.movementMode === "SNAP";
}, w6 = function(t, r, n) {
  var a = $N(t.dimensions, r);
  return !V4(t) || n ? Ti({
    state: t,
    dimensions: a
  }) : WC({
    state: t,
    dimensions: a
  });
};
function x6(e) {
  return e.isDragging && e.movementMode === "SNAP" ? be({
    phase: "DRAGGING"
  }, e, {
    scrollJumpRequest: null
  }) : e;
}
var Ff = {
  phase: "IDLE",
  completed: null,
  shouldFlush: !1
}, GN = function(e, t) {
  if (e === void 0 && (e = Ff), t.type === "FLUSH")
    return be({}, Ff, {
      shouldFlush: !0
    });
  if (t.type === "INITIAL_PUBLISH") {
    e.phase !== "IDLE" && (process.env.NODE_ENV !== "production" ? K(!1, "INITIAL_PUBLISH must come after a IDLE phase") : K(!1));
    var r = t.payload, n = r.critical, a = r.clientSelection, i = r.viewport, o = r.dimensions, s = r.movementMode, c = o.draggables[n.draggable.id], u = o.droppables[n.droppable.id], d = {
      selection: a,
      borderBoxCenter: c.client.borderBox.center,
      offset: Rt
    }, h = {
      client: d,
      page: {
        selection: Ht(d.selection, i.scroll.initial),
        borderBoxCenter: Ht(d.selection, i.scroll.initial),
        offset: Ht(d.selection, i.scroll.diff.value)
      }
    }, A = h0(o.droppables).every(function(Y) {
      return !Y.isFixedOnPage;
    }), p = QC({
      draggable: c,
      home: u,
      draggables: o.draggables,
      viewport: i
    }), v = p.impact, g = p.afterCritical, m = {
      phase: "DRAGGING",
      isDragging: !0,
      critical: n,
      movementMode: s,
      dimensions: o,
      initial: h,
      current: h,
      isWindowScrollAllowed: A,
      impact: v,
      afterCritical: g,
      onLiftImpact: v,
      viewport: i,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return m;
  }
  if (t.type === "COLLECTION_STARTING") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? K(!1, "Collection cannot start from phase " + e.phase) : K(!1));
    var b = be({
      phase: "COLLECTING"
    }, e, {
      phase: "COLLECTING"
    });
    return b;
  }
  if (t.type === "PUBLISH_WHILE_DRAGGING")
    return e.phase === "COLLECTING" || e.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? K(!1, "Unexpected " + t.type + " received in phase " + e.phase) : K(!1)), VN({
      state: e,
      published: t.payload
    });
  if (t.type === "MOVE") {
    if (e.phase === "DROP_PENDING")
      return e;
    _1(e) || (process.env.NODE_ENV !== "production" ? K(!1, t.type + " not permitted in phase " + e.phase) : K(!1));
    var w = t.payload.client;
    return e1(w, e.current.client.selection) ? e : Ti({
      state: e,
      clientSelection: w,
      impact: V4(e) ? e.impact : null
    });
  }
  if (t.type === "UPDATE_DROPPABLE_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "COLLECTING")
      return x6(e);
    _1(e) || (process.env.NODE_ENV !== "production" ? K(!1, t.type + " not permitted in phase " + e.phase) : K(!1));
    var x = t.payload, y = x.id, C = x.newScroll, O = e.dimensions.droppables[y];
    if (!O)
      return e;
    var M = N7(O, C);
    return w6(e, M, !1);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    _1(e) || (process.env.NODE_ENV !== "production" ? K(!1, "Attempting to move in an unsupported phase " + e.phase) : K(!1));
    var E = t.payload, N = E.id, F = E.isEnabled, k = e.dimensions.droppables[N];
    k || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot find Droppable[id: " + N + "] to toggle its enabled state") : K(!1)), k.isEnabled === F && (process.env.NODE_ENV !== "production" ? K(!1, "Trying to set droppable isEnabled to " + String(F) + `
      but it is already ` + String(k.isEnabled)) : K(!1));
    var R = be({}, k, {
      isEnabled: F
    });
    return w6(e, R, !0);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    _1(e) || (process.env.NODE_ENV !== "production" ? K(!1, "Attempting to move in an unsupported phase " + e.phase) : K(!1));
    var j = t.payload, U = j.id, ee = j.isCombineEnabled, X = e.dimensions.droppables[U];
    X || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot find Droppable[id: " + U + "] to toggle its isCombineEnabled state") : K(!1)), X.isCombineEnabled === ee && (process.env.NODE_ENV !== "production" ? K(!1, "Trying to set droppable isCombineEnabled to " + String(ee) + `
      but it is already ` + String(X.isCombineEnabled)) : K(!1));
    var Z = be({}, X, {
      isCombineEnabled: ee
    });
    return w6(e, Z, !0);
  }
  if (t.type === "MOVE_BY_WINDOW_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "DROP_ANIMATING")
      return e;
    _1(e) || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot move by window in phase " + e.phase) : K(!1)), e.isWindowScrollAllowed || (process.env.NODE_ENV !== "production" ? K(!1, "Window scrolling is currently not supported for fixed lists") : K(!1));
    var te = t.payload.newScroll;
    if (e1(e.viewport.scroll.current, te))
      return x6(e);
    var B = TC(e.viewport, te);
    return V4(e) ? WC({
      state: e,
      viewport: B
    }) : Ti({
      state: e,
      viewport: B
    });
  }
  if (t.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
    if (!_1(e))
      return e;
    var I = t.payload.maxScroll;
    if (e1(I, e.viewport.scroll.max))
      return e;
    var _ = be({}, e.viewport, {
      scroll: be({}, e.viewport.scroll, {
        max: I
      })
    });
    return be({
      phase: "DRAGGING"
    }, e, {
      viewport: _
    });
  }
  if (t.type === "MOVE_UP" || t.type === "MOVE_DOWN" || t.type === "MOVE_LEFT" || t.type === "MOVE_RIGHT") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? K(!1, t.type + " received while not in DRAGGING phase") : K(!1));
    var L = MN({
      state: e,
      type: t.type
    });
    return L ? Ti({
      state: e,
      impact: L.impact,
      clientSelection: L.clientSelection,
      scrollJumpRequest: L.scrollJumpRequest
    }) : e;
  }
  if (t.type === "DROP_PENDING") {
    var D = t.payload.reason;
    e.phase !== "COLLECTING" && (process.env.NODE_ENV !== "production" ? K(!1, "Can only move into the DROP_PENDING phase from the COLLECTING phase") : K(!1));
    var T = be({
      phase: "DROP_PENDING"
    }, e, {
      phase: "DROP_PENDING",
      isWaiting: !0,
      reason: D
    });
    return T;
  }
  if (t.type === "DROP_ANIMATE") {
    var Q = t.payload, z = Q.completed, W = Q.dropDuration, H = Q.newHomeClientOffset;
    e.phase === "DRAGGING" || e.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot animate drop from phase " + e.phase) : K(!1));
    var $ = {
      phase: "DROP_ANIMATING",
      completed: z,
      dropDuration: W,
      newHomeClientOffset: H,
      dimensions: e.dimensions
    };
    return $;
  }
  if (t.type === "DROP_COMPLETE") {
    var V = t.payload.completed;
    return {
      phase: "IDLE",
      completed: V,
      shouldFlush: !1
    };
  }
  return e;
}, WN = function(t) {
  return {
    type: "BEFORE_INITIAL_CAPTURE",
    payload: t
  };
}, QN = function(t) {
  return {
    type: "LIFT",
    payload: t
  };
}, UN = function(t) {
  return {
    type: "INITIAL_PUBLISH",
    payload: t
  };
}, ZN = function(t) {
  return {
    type: "PUBLISH_WHILE_DRAGGING",
    payload: t
  };
}, KN = function() {
  return {
    type: "COLLECTION_STARTING",
    payload: null
  };
}, zN = function(t) {
  return {
    type: "UPDATE_DROPPABLE_SCROLL",
    payload: t
  };
}, qN = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_ENABLED",
    payload: t
  };
}, XN = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
    payload: t
  };
}, UC = function(t) {
  return {
    type: "MOVE",
    payload: t
  };
}, JN = function(t) {
  return {
    type: "MOVE_BY_WINDOW_SCROLL",
    payload: t
  };
}, eL = function(t) {
  return {
    type: "UPDATE_VIEWPORT_MAX_SCROLL",
    payload: t
  };
}, tL = function() {
  return {
    type: "MOVE_UP",
    payload: null
  };
}, rL = function() {
  return {
    type: "MOVE_DOWN",
    payload: null
  };
}, nL = function() {
  return {
    type: "MOVE_RIGHT",
    payload: null
  };
}, aL = function() {
  return {
    type: "MOVE_LEFT",
    payload: null
  };
}, Y7 = function() {
  return {
    type: "FLUSH",
    payload: null
  };
}, iL = function(t) {
  return {
    type: "DROP_ANIMATE",
    payload: t
  };
}, k7 = function(t) {
  return {
    type: "DROP_COMPLETE",
    payload: t
  };
}, ZC = function(t) {
  return {
    type: "DROP",
    payload: t
  };
}, oL = function(t) {
  return {
    type: "DROP_PENDING",
    payload: t
  };
}, KC = function() {
  return {
    type: "DROP_ANIMATION_FINISHED",
    payload: null
  };
};
function sL(e) {
  if (!(e.length <= 1)) {
    for (var t = e.map(function(s) {
      return s.descriptor.index;
    }), r = {}, n = 1; n < t.length; n++) {
      var a = t[n], i = t[n - 1];
      a !== i + 1 && (r[a] = !0);
    }
    if (Object.keys(r).length) {
      var o = t.map(function(s) {
        var c = !!r[s];
        return c ? "[🔥" + s + "]" : "" + s;
      }).join(", ");
      process.env.NODE_ENV !== "production" && ut(`
    Detected non-consecutive <Draggable /> indexes.

    (This can cause unexpected bugs)

    ` + o + `
  `);
    }
  }
}
function lL(e, t) {
  if (process.env.NODE_ENV !== "production") {
    var r = na(e.droppable.id, t.draggables);
    sL(r);
  }
}
var cL = function(e) {
  return function(t) {
    var r = t.getState, n = t.dispatch;
    return function(a) {
      return function(i) {
        if (i.type !== "LIFT") {
          a(i);
          return;
        }
        var o = i.payload, s = o.id, c = o.clientSelection, u = o.movementMode, d = r();
        d.phase === "DROP_ANIMATING" && n(k7({
          completed: d.completed
        })), r().phase !== "IDLE" && (process.env.NODE_ENV !== "production" ? K(!1, "Unexpected phase to start a drag") : K(!1)), n(Y7()), n(WN({
          draggableId: s,
          movementMode: u
        }));
        var h = {
          shouldPublishImmediately: u === "SNAP"
        }, A = {
          draggableId: s,
          scrollOptions: h
        }, p = e.startPublishing(A), v = p.critical, g = p.dimensions, m = p.viewport;
        lL(v, g), n(UN({
          critical: v,
          dimensions: g,
          clientSelection: c,
          movementMode: u,
          viewport: m
        }));
      };
    };
  };
}, uL = function(e) {
  return function() {
    return function(t) {
      return function(r) {
        r.type === "INITIAL_PUBLISH" && e.dragging(), r.type === "DROP_ANIMATE" && e.dropping(r.payload.completed.result.reason), (r.type === "FLUSH" || r.type === "DROP_COMPLETE") && e.resting(), t(r);
      };
    };
  };
}, V7 = {
  outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
  drop: "cubic-bezier(.2,1,.1,1)"
}, eo = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
}, G7 = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
}, M1 = G7.outOfTheWay + "s " + V7.outOfTheWay, _i = {
  fluid: "opacity " + M1,
  snap: "transform " + M1 + ", opacity " + M1,
  drop: function(t) {
    var r = t + "s " + V7.drop;
    return "transform " + r + ", opacity " + r;
  },
  outOfTheWay: "transform " + M1,
  placeholder: "height " + M1 + ", width " + M1 + ", margin " + M1
}, $f = function(t) {
  return e1(t, Rt) ? null : "translate(" + t.x + "px, " + t.y + "px)";
}, G4 = {
  moveTo: $f,
  drop: function(t, r) {
    var n = $f(t);
    return n ? r ? n + " scale(" + eo.scale.drop + ")" : n : null;
  }
}, W4 = G7.minDropTime, zC = G7.maxDropTime, dL = zC - W4, Hf = 1500, fL = 0.6, hL = function(e) {
  var t = e.current, r = e.destination, n = e.reason, a = qi(t, r);
  if (a <= 0)
    return W4;
  if (a >= Hf)
    return zC;
  var i = a / Hf, o = W4 + dL * i, s = n === "CANCEL" ? o * fL : o;
  return Number(s.toFixed(2));
}, AL = function(e) {
  var t = e.impact, r = e.draggable, n = e.dimensions, a = e.viewport, i = e.afterCritical, o = n.draggables, s = n.droppables, c = pr(t), u = c ? s[c] : null, d = s[r.descriptor.droppableId], h = GC({
    impact: t,
    draggable: r,
    draggables: o,
    afterCritical: i,
    droppable: u || d,
    viewport: a
  }), A = Ar(h, r.client.borderBox.center);
  return A;
}, pL = function(e) {
  var t = e.draggables, r = e.reason, n = e.lastImpact, a = e.home, i = e.viewport, o = e.onLiftImpact;
  if (!n.at || r !== "DROP") {
    var s = VC({
      draggables: t,
      impact: o,
      destination: a,
      viewport: i,
      forceShouldAnimate: !0
    });
    return {
      impact: s,
      didDropInsideDroppable: !1
    };
  }
  if (n.at.type === "REORDER")
    return {
      impact: n,
      didDropInsideDroppable: !0
    };
  var c = be({}, n, {
    displaced: Xi
  });
  return {
    impact: c,
    didDropInsideDroppable: !0
  };
}, gL = function(e) {
  var t = e.getState, r = e.dispatch;
  return function(n) {
    return function(a) {
      if (a.type !== "DROP") {
        n(a);
        return;
      }
      var i = t(), o = a.payload.reason;
      if (i.phase === "COLLECTING") {
        r(oL({
          reason: o
        }));
        return;
      }
      if (i.phase !== "IDLE") {
        var s = i.phase === "DROP_PENDING" && i.isWaiting;
        s && (process.env.NODE_ENV !== "production" ? K(!1, "A DROP action occurred while DROP_PENDING and still waiting") : K(!1)), i.phase === "DRAGGING" || i.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot drop in phase: " + i.phase) : K(!1));
        var c = i.critical, u = i.dimensions, d = u.draggables[i.critical.draggable.id], h = pL({
          reason: o,
          lastImpact: i.impact,
          afterCritical: i.afterCritical,
          onLiftImpact: i.onLiftImpact,
          home: i.dimensions.droppables[i.critical.droppable.id],
          viewport: i.viewport,
          draggables: i.dimensions.draggables
        }), A = h.impact, p = h.didDropInsideDroppable, v = p ? T7(A) : null, g = p ? A0(A) : null, m = {
          index: c.draggable.index,
          droppableId: c.droppable.id
        }, b = {
          draggableId: d.descriptor.id,
          type: d.descriptor.type,
          source: m,
          reason: o,
          mode: i.movementMode,
          destination: v,
          combine: g
        }, w = AL({
          impact: A,
          draggable: d,
          dimensions: u,
          viewport: i.viewport,
          afterCritical: i.afterCritical
        }), x = {
          critical: i.critical,
          afterCritical: i.afterCritical,
          result: b,
          impact: A
        }, y = !e1(i.current.client.offset, w) || !!b.combine;
        if (!y) {
          r(k7({
            completed: x
          }));
          return;
        }
        var C = hL({
          current: i.current.client.offset,
          destination: w,
          reason: o
        }), O = {
          newHomeClientOffset: w,
          dropDuration: C,
          completed: x
        };
        r(iL(O));
      }
    };
  };
}, qC = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};
function vL(e) {
  return {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function(r) {
      r.target !== window && r.target !== window.document || e();
    }
  };
}
function mL(e) {
  var t = e.onWindowScroll;
  function r() {
    t(qC());
  }
  var n = Ki(r), a = vL(n), i = Jn;
  function o() {
    return i !== Jn;
  }
  function s() {
    o() && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot start scroll listener when already active") : K(!1)), i = Sr(window, [a]);
  }
  function c() {
    o() || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot stop scroll listener when not active") : K(!1)), n.cancel(), i(), i = Jn;
  }
  return {
    start: s,
    stop: c,
    isActive: o
  };
}
var CL = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, bL = function(e) {
  var t = mL({
    onWindowScroll: function(n) {
      e.dispatch(JN({
        newScroll: n
      }));
    }
  });
  return function(r) {
    return function(n) {
      !t.isActive() && n.type === "INITIAL_PUBLISH" && t.start(), t.isActive() && CL(n) && t.stop(), r(n);
    };
  };
}, yL = function(e) {
  var t = !1, r = !1, n = setTimeout(function() {
    r = !0;
  }), a = function(o) {
    if (t) {
      process.env.NODE_ENV !== "production" && ut("Announcement already made. Not making a second announcement");
      return;
    }
    if (r) {
      process.env.NODE_ENV !== "production" && ut(`
        Announcements cannot be made asynchronously.
        Default message has already been announced.
      `);
      return;
    }
    t = !0, e(o), clearTimeout(n);
  };
  return a.wasCalled = function() {
    return t;
  }, a;
}, wL = function() {
  var e = [], t = function(i) {
    var o = L7(e, function(u) {
      return u.timerId === i;
    });
    o === -1 && (process.env.NODE_ENV !== "production" ? K(!1, "Could not find timer") : K(!1));
    var s = e.splice(o, 1), c = s[0];
    c.callback();
  }, r = function(i) {
    var o = setTimeout(function() {
      return t(o);
    }), s = {
      timerId: o,
      callback: i
    };
    e.push(s);
  }, n = function() {
    if (e.length) {
      var i = [].concat(e);
      e.length = 0, i.forEach(function(o) {
        clearTimeout(o.timerId), o.callback();
      });
    }
  };
  return {
    add: r,
    flush: n
  };
}, xL = function(t, r) {
  return t == null && r == null ? !0 : t == null || r == null ? !1 : t.droppableId === r.droppableId && t.index === r.index;
}, DL = function(t, r) {
  return t == null && r == null ? !0 : t == null || r == null ? !1 : t.draggableId === r.draggableId && t.droppableId === r.droppableId;
}, OL = function(t, r) {
  if (t === r)
    return !0;
  var n = t.draggable.id === r.draggable.id && t.draggable.droppableId === r.draggable.droppableId && t.draggable.type === r.draggable.type && t.draggable.index === r.draggable.index, a = t.droppable.id === r.droppable.id && t.droppable.type === r.droppable.type;
  return n && a;
}, ai = function(t, r) {
  Vo(), r(), Go();
}, y3 = function(t, r) {
  return {
    draggableId: t.draggable.id,
    type: t.droppable.type,
    source: {
      droppableId: t.droppable.id,
      index: t.draggable.index
    },
    mode: r
  };
}, D6 = function(t, r, n, a) {
  if (!t) {
    n(a(r));
    return;
  }
  var i = yL(n), o = {
    announce: i
  };
  t(r, o), i.wasCalled() || n(a(r));
}, ML = function(e, t) {
  var r = wL(), n = null, a = function(A, p) {
    n && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot fire onBeforeCapture as a drag start has already been published") : K(!1)), ai("onBeforeCapture", function() {
      var v = e().onBeforeCapture;
      if (v) {
        var g = {
          draggableId: A,
          mode: p
        };
        v(g);
      }
    });
  }, i = function(A, p) {
    n && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : K(!1)), ai("onBeforeDragStart", function() {
      var v = e().onBeforeDragStart;
      v && v(y3(A, p));
    });
  }, o = function(A, p) {
    n && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : K(!1));
    var v = y3(A, p);
    n = {
      mode: p,
      lastCritical: A,
      lastLocation: v.source,
      lastCombine: null
    }, r.add(function() {
      ai("onDragStart", function() {
        return D6(e().onDragStart, v, t, X3.onDragStart);
      });
    });
  }, s = function(A, p) {
    var v = T7(p), g = A0(p);
    n || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot fire onDragMove when onDragStart has not been called") : K(!1));
    var m = !OL(A, n.lastCritical);
    m && (n.lastCritical = A);
    var b = !xL(n.lastLocation, v);
    b && (n.lastLocation = v);
    var w = !DL(n.lastCombine, g);
    if (w && (n.lastCombine = g), !(!m && !b && !w)) {
      var x = be({}, y3(A, n.mode), {
        combine: g,
        destination: v
      });
      r.add(function() {
        ai("onDragUpdate", function() {
          return D6(e().onDragUpdate, x, t, X3.onDragUpdate);
        });
      });
    }
  }, c = function() {
    n || (process.env.NODE_ENV !== "production" ? K(!1, "Can only flush responders while dragging") : K(!1)), r.flush();
  }, u = function(A) {
    n || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot fire onDragEnd when there is no matching onDragStart") : K(!1)), n = null, ai("onDragEnd", function() {
      return D6(e().onDragEnd, A, t, X3.onDragEnd);
    });
  }, d = function() {
    if (n) {
      var A = be({}, y3(n.lastCritical, n.mode), {
        combine: null,
        destination: null,
        reason: "CANCEL"
      });
      u(A);
    }
  };
  return {
    beforeCapture: a,
    beforeStart: i,
    start: o,
    update: s,
    flush: c,
    drop: u,
    abort: d
  };
}, EL = function(e, t) {
  var r = ML(e, t);
  return function(n) {
    return function(a) {
      return function(i) {
        if (i.type === "BEFORE_INITIAL_CAPTURE") {
          r.beforeCapture(i.payload.draggableId, i.payload.movementMode);
          return;
        }
        if (i.type === "INITIAL_PUBLISH") {
          var o = i.payload.critical;
          r.beforeStart(o, i.payload.movementMode), a(i), r.start(o, i.payload.movementMode);
          return;
        }
        if (i.type === "DROP_COMPLETE") {
          var s = i.payload.completed.result;
          r.flush(), a(i), r.drop(s);
          return;
        }
        if (a(i), i.type === "FLUSH") {
          r.abort();
          return;
        }
        var c = n.getState();
        c.phase === "DRAGGING" && r.update(c.critical, c.impact);
      };
    };
  };
}, SL = function(e) {
  return function(t) {
    return function(r) {
      if (r.type !== "DROP_ANIMATION_FINISHED") {
        t(r);
        return;
      }
      var n = e.getState();
      n.phase !== "DROP_ANIMATING" && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot finish a drop animating when no drop is occurring") : K(!1)), e.dispatch(k7({
        completed: n.completed
      }));
    };
  };
}, PL = function(e) {
  var t = null, r = null;
  function n() {
    r && (cancelAnimationFrame(r), r = null), t && (t(), t = null);
  }
  return function(a) {
    return function(i) {
      if ((i.type === "FLUSH" || i.type === "DROP_COMPLETE" || i.type === "DROP_ANIMATION_FINISHED") && n(), a(i), i.type === "DROP_ANIMATE") {
        var o = {
          eventName: "scroll",
          options: {
            capture: !0,
            passive: !1,
            once: !0
          },
          fn: function() {
            var c = e.getState();
            c.phase === "DROP_ANIMATING" && e.dispatch(KC());
          }
        };
        r = requestAnimationFrame(function() {
          r = null, t = Sr(window, [o]);
        });
      }
    };
  };
}, jL = function(e) {
  return function() {
    return function(t) {
      return function(r) {
        (r.type === "DROP_COMPLETE" || r.type === "FLUSH" || r.type === "DROP_ANIMATE") && e.stopPublishing(), t(r);
      };
    };
  };
}, IL = function(e) {
  var t = !1;
  return function() {
    return function(r) {
      return function(n) {
        if (n.type === "INITIAL_PUBLISH") {
          t = !0, e.tryRecordFocus(n.payload.critical.draggable.id), r(n), e.tryRestoreFocusRecorded();
          return;
        }
        if (r(n), !!t) {
          if (n.type === "FLUSH") {
            t = !1, e.tryRestoreFocusRecorded();
            return;
          }
          if (n.type === "DROP_COMPLETE") {
            t = !1;
            var a = n.payload.completed.result;
            a.combine && e.tryShiftRecord(a.draggableId, a.combine.draggableId), e.tryRestoreFocusRecorded();
          }
        }
      };
    };
  };
}, BL = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, NL = function(e) {
  return function(t) {
    return function(r) {
      return function(n) {
        if (BL(n)) {
          e.stop(), r(n);
          return;
        }
        if (n.type === "INITIAL_PUBLISH") {
          r(n);
          var a = t.getState();
          a.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? K(!1, "Expected phase to be DRAGGING after INITIAL_PUBLISH") : K(!1)), e.start(a);
          return;
        }
        r(n), e.scroll(t.getState());
      };
    };
  };
}, LL = function(e) {
  return function(t) {
    return function(r) {
      if (t(r), r.type === "PUBLISH_WHILE_DRAGGING") {
        var n = e.getState();
        n.phase === "DROP_PENDING" && (n.isWaiting || e.dispatch(ZC({
          reason: n.reason
        })));
      }
    };
  };
}, TL = process.env.NODE_ENV !== "production" && typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: "react-beautiful-dnd"
}) : sC, _L = function(e) {
  var t = e.dimensionMarshal, r = e.focusMarshal, n = e.styleMarshal, a = e.getResponders, i = e.announce, o = e.autoScroller;
  return oC(GN, TL(pI(uL(n), jL(t), cL(t), gL, SL, PL, LL, NL(o), bL, IL(r), EL(a, i))));
}, O6 = function() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function RL(e) {
  var t = e.registry, r = e.callbacks, n = O6(), a = null, i = function() {
    a || (r.collectionStarting(), a = requestAnimationFrame(function() {
      a = null, Vo();
      var d = n, h = d.additions, A = d.removals, p = d.modified, v = Object.keys(h).map(function(b) {
        return t.draggable.getById(b).getDimension(Rt);
      }).sort(function(b, w) {
        return b.descriptor.index - w.descriptor.index;
      }), g = Object.keys(p).map(function(b) {
        var w = t.droppable.getById(b), x = w.callbacks.getScrollWhileDragging();
        return {
          droppableId: b,
          scroll: x
        };
      }), m = {
        additions: v,
        removals: Object.keys(A),
        modified: g
      };
      n = O6(), Go(), r.publish(m);
    }));
  }, o = function(d) {
    var h = d.descriptor.id;
    n.additions[h] = d, n.modified[d.descriptor.droppableId] = !0, n.removals[h] && delete n.removals[h], i();
  }, s = function(d) {
    var h = d.descriptor;
    n.removals[h.id] = !0, n.modified[h.droppableId] = !0, n.additions[h.id] && delete n.additions[h.id], i();
  }, c = function() {
    a && (cancelAnimationFrame(a), a = null, n = O6());
  };
  return {
    add: o,
    remove: s,
    stop: c
  };
}
var XC = function(e) {
  var t = e.scrollHeight, r = e.scrollWidth, n = e.height, a = e.width, i = Ar({
    x: r,
    y: t
  }, {
    x: a,
    y: n
  }), o = {
    x: Math.max(0, i.x),
    y: Math.max(0, i.y)
  };
  return o;
}, JC = function() {
  var e = document.documentElement;
  return e || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot find document.documentElement") : K(!1)), e;
}, eb = function() {
  var e = JC(), t = XC({
    scrollHeight: e.scrollHeight,
    scrollWidth: e.scrollWidth,
    width: e.clientWidth,
    height: e.clientHeight
  });
  return t;
}, FL = function() {
  var e = qC(), t = eb(), r = e.y, n = e.x, a = JC(), i = a.clientWidth, o = a.clientHeight, s = n + i, c = r + o, u = Yr({
    top: r,
    left: n,
    right: s,
    bottom: c
  }), d = {
    frame: u,
    scroll: {
      initial: e,
      current: e,
      max: t,
      diff: {
        value: Rt,
        displacement: Rt
      }
    }
  };
  return d;
}, $L = function(e) {
  var t = e.critical, r = e.scrollOptions, n = e.registry;
  Vo();
  var a = FL(), i = a.scroll.current, o = t.droppable, s = n.droppable.getAllByType(o.type).map(function(h) {
    return h.callbacks.getDimensionAndWatchScroll(i, r);
  }), c = n.draggable.getAllByType(t.draggable.type).map(function(h) {
    return h.getDimension(i);
  }), u = {
    draggables: PC(c),
    droppables: SC(s)
  };
  Go();
  var d = {
    dimensions: u,
    critical: t,
    viewport: a
  };
  return d;
};
function Yf(e, t, r) {
  if (r.descriptor.id === t.id || r.descriptor.type !== t.type)
    return !1;
  var n = e.droppable.getById(r.descriptor.droppableId);
  return n.descriptor.mode !== "virtual" ? (process.env.NODE_ENV !== "production" && ut(`
      You are attempting to add or remove a Draggable [id: ` + r.descriptor.id + `]
      while a drag is occurring. This is only supported for virtual lists.

      See https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/patterns/virtual-lists.md
    `), !1) : !0;
}
var HL = function(e, t) {
  var r = null, n = RL({
    callbacks: {
      publish: t.publishWhileDragging,
      collectionStarting: t.collectionStarting
    },
    registry: e
  }), a = function(p, v) {
    e.droppable.exists(p) || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot update is enabled flag of Droppable " + p + " as it is not registered") : K(!1)), r && t.updateDroppableIsEnabled({
      id: p,
      isEnabled: v
    });
  }, i = function(p, v) {
    r && (e.droppable.exists(p) || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot update isCombineEnabled flag of Droppable " + p + " as it is not registered") : K(!1)), t.updateDroppableIsCombineEnabled({
      id: p,
      isCombineEnabled: v
    }));
  }, o = function(p, v) {
    r && (e.droppable.exists(p) || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot update the scroll on Droppable " + p + " as it is not registered") : K(!1)), t.updateDroppableScroll({
      id: p,
      newScroll: v
    }));
  }, s = function(p, v) {
    r && e.droppable.getById(p).callbacks.scroll(v);
  }, c = function() {
    if (r) {
      n.stop();
      var p = r.critical.droppable;
      e.droppable.getAllByType(p.type).forEach(function(v) {
        return v.callbacks.dragStopped();
      }), r.unsubscribe(), r = null;
    }
  }, u = function(p) {
    r || (process.env.NODE_ENV !== "production" ? K(!1, "Should only be subscribed when a collection is occurring") : K(!1));
    var v = r.critical.draggable;
    p.type === "ADDITION" && Yf(e, v, p.value) && n.add(p.value), p.type === "REMOVAL" && Yf(e, v, p.value) && n.remove(p.value);
  }, d = function(p) {
    r && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot start capturing critical dimensions as there is already a collection") : K(!1));
    var v = e.draggable.getById(p.draggableId), g = e.droppable.getById(v.descriptor.droppableId), m = {
      draggable: v.descriptor,
      droppable: g.descriptor
    }, b = e.subscribe(u);
    return r = {
      critical: m,
      unsubscribe: b
    }, $L({
      critical: m,
      registry: e,
      scrollOptions: p.scrollOptions
    });
  }, h = {
    updateDroppableIsEnabled: a,
    updateDroppableIsCombineEnabled: i,
    scrollDroppable: s,
    updateDroppableScroll: o,
    startPublishing: d,
    stopPublishing: c
  };
  return h;
}, tb = function(e, t) {
  return e.phase === "IDLE" ? !0 : e.phase !== "DROP_ANIMATING" || e.completed.result.draggableId === t ? !1 : e.completed.result.reason === "DROP";
}, YL = function(e) {
  window.scrollBy(e.x, e.y);
}, kL = _t(function(e) {
  return h0(e).filter(function(t) {
    return !(!t.isEnabled || !t.frame);
  });
}), VL = function(t, r) {
  var n = h1(kL(r), function(a) {
    return a.frame || (process.env.NODE_ENV !== "production" ? K(!1, "Invalid result") : K(!1)), $C(a.frame.pageMarginBox)(t);
  });
  return n;
}, GL = function(e) {
  var t = e.center, r = e.destination, n = e.droppables;
  if (r) {
    var a = n[r];
    return a.frame ? a : null;
  }
  var i = VL(t, n);
  return i;
}, t1 = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function(t) {
    return Math.pow(t, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
}, WL = function(e, t) {
  var r = e[t.size] * t1.startFromPercentage, n = e[t.size] * t1.maxScrollAtPercentage, a = {
    startScrollingFrom: r,
    maxScrollValueAt: n
  };
  return a;
}, rb = function(e) {
  var t = e.startOfRange, r = e.endOfRange, n = e.current, a = r - t;
  if (a === 0)
    return process.env.NODE_ENV !== "production" && ut(`
      Detected distance range of 0 in the fluid auto scroller
      This is unexpected and would cause a divide by 0 issue.
      Not allowing an auto scroll
    `), 0;
  var i = n - t, o = i / a;
  return o;
}, W7 = 1, QL = function(e, t) {
  if (e > t.startScrollingFrom)
    return 0;
  if (e <= t.maxScrollValueAt)
    return t1.maxPixelScroll;
  if (e === t.startScrollingFrom)
    return W7;
  var r = rb({
    startOfRange: t.maxScrollValueAt,
    endOfRange: t.startScrollingFrom,
    current: e
  }), n = 1 - r, a = t1.maxPixelScroll * t1.ease(n);
  return Math.ceil(a);
}, kf = t1.durationDampening.accelerateAt, Vf = t1.durationDampening.stopDampeningAt, UL = function(e, t) {
  var r = t, n = Vf, a = Date.now(), i = a - r;
  if (i >= Vf)
    return e;
  if (i < kf)
    return W7;
  var o = rb({
    startOfRange: kf,
    endOfRange: n,
    current: i
  }), s = e * t1.ease(o);
  return Math.ceil(s);
}, Gf = function(e) {
  var t = e.distanceToEdge, r = e.thresholds, n = e.dragStartTime, a = e.shouldUseTimeDampening, i = QL(t, r);
  return i === 0 ? 0 : a ? Math.max(UL(i, n), W7) : i;
}, Wf = function(e) {
  var t = e.container, r = e.distanceToEdges, n = e.dragStartTime, a = e.axis, i = e.shouldUseTimeDampening, o = WL(t, a), s = r[a.end] < r[a.start];
  return s ? Gf({
    distanceToEdge: r[a.end],
    thresholds: o,
    dragStartTime: n,
    shouldUseTimeDampening: i
  }) : -1 * Gf({
    distanceToEdge: r[a.start],
    thresholds: o,
    dragStartTime: n,
    shouldUseTimeDampening: i
  });
}, ZL = function(e) {
  var t = e.container, r = e.subject, n = e.proposedScroll, a = r.height > t.height, i = r.width > t.width;
  return !i && !a ? n : i && a ? null : {
    x: i ? 0 : n.x,
    y: a ? 0 : n.y
  };
}, KL = MC(function(e) {
  return e === 0 ? 0 : e;
}), nb = function(e) {
  var t = e.dragStartTime, r = e.container, n = e.subject, a = e.center, i = e.shouldUseTimeDampening, o = {
    top: a.y - r.top,
    right: r.right - a.x,
    bottom: r.bottom - a.y,
    left: a.x - r.left
  }, s = Wf({
    container: r,
    distanceToEdges: o,
    dragStartTime: t,
    axis: _7,
    shouldUseTimeDampening: i
  }), c = Wf({
    container: r,
    distanceToEdges: o,
    dragStartTime: t,
    axis: BC,
    shouldUseTimeDampening: i
  }), u = KL({
    x: c,
    y: s
  });
  if (e1(u, Rt))
    return null;
  var d = ZL({
    container: r,
    subject: n,
    proposedScroll: u
  });
  return d ? e1(d, Rt) ? null : d : null;
}, zL = MC(function(e) {
  return e === 0 ? 0 : e > 0 ? 1 : -1;
}), Q7 = function() {
  var e = function(r, n) {
    return r < 0 ? r : r > n ? r - n : 0;
  };
  return function(t) {
    var r = t.current, n = t.max, a = t.change, i = Ht(r, a), o = {
      x: e(i.x, n.x),
      y: e(i.y, n.y)
    };
    return e1(o, Rt) ? null : o;
  };
}(), ab = function(t) {
  var r = t.max, n = t.current, a = t.change, i = {
    x: Math.max(n.x, r.x),
    y: Math.max(n.y, r.y)
  }, o = zL(a), s = Q7({
    max: i,
    current: n,
    change: o
  });
  return !s || o.x !== 0 && s.x === 0 || o.y !== 0 && s.y === 0;
}, U7 = function(t, r) {
  return ab({
    current: t.scroll.current,
    max: t.scroll.max,
    change: r
  });
}, qL = function(t, r) {
  if (!U7(t, r))
    return null;
  var n = t.scroll.max, a = t.scroll.current;
  return Q7({
    current: a,
    max: n,
    change: r
  });
}, Z7 = function(t, r) {
  var n = t.frame;
  return n ? ab({
    current: n.scroll.current,
    max: n.scroll.max,
    change: r
  }) : !1;
}, XL = function(t, r) {
  var n = t.frame;
  return !n || !Z7(t, r) ? null : Q7({
    current: n.scroll.current,
    max: n.scroll.max,
    change: r
  });
}, JL = function(e) {
  var t = e.viewport, r = e.subject, n = e.center, a = e.dragStartTime, i = e.shouldUseTimeDampening, o = nb({
    dragStartTime: a,
    container: t.frame,
    subject: r,
    center: n,
    shouldUseTimeDampening: i
  });
  return o && U7(t, o) ? o : null;
}, eT = function(e) {
  var t = e.droppable, r = e.subject, n = e.center, a = e.dragStartTime, i = e.shouldUseTimeDampening, o = t.frame;
  if (!o)
    return null;
  var s = nb({
    dragStartTime: a,
    container: o.pageMarginBox,
    subject: r,
    center: n,
    shouldUseTimeDampening: i
  });
  return s && Z7(t, s) ? s : null;
}, Qf = function(e) {
  var t = e.state, r = e.dragStartTime, n = e.shouldUseTimeDampening, a = e.scrollWindow, i = e.scrollDroppable, o = t.current.page.borderBoxCenter, s = t.dimensions.draggables[t.critical.draggable.id], c = s.page.marginBox;
  if (t.isWindowScrollAllowed) {
    var u = t.viewport, d = JL({
      dragStartTime: r,
      viewport: u,
      subject: c,
      center: o,
      shouldUseTimeDampening: n
    });
    if (d) {
      a(d);
      return;
    }
  }
  var h = GL({
    center: o,
    destination: pr(t.impact),
    droppables: t.dimensions.droppables
  });
  if (h) {
    var A = eT({
      dragStartTime: r,
      droppable: h,
      subject: c,
      center: o,
      shouldUseTimeDampening: n
    });
    A && i(h.descriptor.id, A);
  }
}, tT = function(e) {
  var t = e.scrollWindow, r = e.scrollDroppable, n = Ki(t), a = Ki(r), i = null, o = function(d) {
    i || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot fluid scroll if not dragging") : K(!1));
    var h = i, A = h.shouldUseTimeDampening, p = h.dragStartTime;
    Qf({
      state: d,
      scrollWindow: n,
      scrollDroppable: a,
      dragStartTime: p,
      shouldUseTimeDampening: A
    });
  }, s = function(d) {
    Vo(), i && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot start auto scrolling when already started") : K(!1));
    var h = Date.now(), A = !1, p = function() {
      A = !0;
    };
    Qf({
      state: d,
      dragStartTime: 0,
      shouldUseTimeDampening: !1,
      scrollWindow: p,
      scrollDroppable: p
    }), i = {
      dragStartTime: h,
      shouldUseTimeDampening: A
    }, Go(), A && o(d);
  }, c = function() {
    i && (n.cancel(), a.cancel(), i = null);
  };
  return {
    start: s,
    stop: c,
    scroll: o
  };
}, rT = function(e) {
  var t = e.move, r = e.scrollDroppable, n = e.scrollWindow, a = function(u, d) {
    var h = Ht(u.current.client.selection, d);
    t({
      client: h
    });
  }, i = function(u, d) {
    if (!Z7(u, d))
      return d;
    var h = XL(u, d);
    if (!h)
      return r(u.descriptor.id, d), null;
    var A = Ar(d, h);
    r(u.descriptor.id, A);
    var p = Ar(d, A);
    return p;
  }, o = function(u, d, h) {
    if (!u || !U7(d, h))
      return h;
    var A = qL(d, h);
    if (!A)
      return n(h), null;
    var p = Ar(h, A);
    n(p);
    var v = Ar(h, p);
    return v;
  }, s = function(u) {
    var d = u.scrollJumpRequest;
    if (d) {
      var h = pr(u.impact);
      h || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot perform a jump scroll when there is no destination") : K(!1));
      var A = i(u.dimensions.droppables[h], d);
      if (A) {
        var p = u.viewport, v = o(u.isWindowScrollAllowed, p, A);
        v && a(u, v);
      }
    }
  };
  return s;
}, nT = function(e) {
  var t = e.scrollDroppable, r = e.scrollWindow, n = e.move, a = tT({
    scrollWindow: r,
    scrollDroppable: t
  }), i = rT({
    move: n,
    scrollWindow: r,
    scrollDroppable: t
  }), o = function(u) {
    if (u.phase === "DRAGGING") {
      if (u.movementMode === "FLUID") {
        a.scroll(u);
        return;
      }
      u.scrollJumpRequest && i(u);
    }
  }, s = {
    scroll: o,
    start: a.start,
    stop: a.stop
  };
  return s;
}, Qa = "data-rbd", Ua = function() {
  var e = Qa + "-drag-handle";
  return {
    base: e,
    draggableId: e + "-draggable-id",
    contextId: e + "-context-id"
  };
}(), Q4 = function() {
  var e = Qa + "-draggable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), aT = function() {
  var e = Qa + "-droppable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), Uf = {
  contextId: Qa + "-scroll-container-context-id"
}, iT = function(t) {
  return function(r) {
    return "[" + r + '="' + t + '"]';
  };
}, ii = function(t, r) {
  return t.map(function(n) {
    var a = n.styles[r];
    return a ? n.selector + " { " + a + " }" : "";
  }).join(" ");
}, oT = "pointer-events: none;", sT = function(e) {
  var t = iT(e), r = function() {
    var s = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
    return {
      selector: t(Ua.contextId),
      styles: {
        always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
        resting: s,
        dragging: oT,
        dropAnimating: s
      }
    };
  }(), n = function() {
    var s = `
      transition: ` + _i.outOfTheWay + `;
    `;
    return {
      selector: t(Q4.contextId),
      styles: {
        dragging: s,
        dropAnimating: s,
        userCancel: s
      }
    };
  }(), a = {
    selector: t(aT.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  }, i = {
    selector: "body",
    styles: {
      dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
    }
  }, o = [n, r, a, i];
  return {
    always: ii(o, "always"),
    resting: ii(o, "resting"),
    dragging: ii(o, "dragging"),
    dropAnimating: ii(o, "dropAnimating"),
    userCancel: ii(o, "userCancel")
  };
}, gr = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? qm : Ne, M6 = function() {
  var t = document.querySelector("head");
  return t || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot find the head to append a style to") : K(!1)), t;
}, Zf = function(t) {
  var r = document.createElement("style");
  return t && r.setAttribute("nonce", t), r.type = "text/css", r;
};
function lT(e, t) {
  var r = He(function() {
    return sT(e);
  }, [e]), n = Ce(null), a = Ce(null), i = ve(_t(function(h) {
    var A = a.current;
    A || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot set dynamic style element if it is not set") : K(!1)), A.textContent = h;
  }), []), o = ve(function(h) {
    var A = n.current;
    A || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot set dynamic style element if it is not set") : K(!1)), A.textContent = h;
  }, []);
  gr(function() {
    !n.current && !a.current || (process.env.NODE_ENV !== "production" ? K(!1, "style elements already mounted") : K(!1));
    var h = Zf(t), A = Zf(t);
    return n.current = h, a.current = A, h.setAttribute(Qa + "-always", e), A.setAttribute(Qa + "-dynamic", e), M6().appendChild(h), M6().appendChild(A), o(r.always), i(r.resting), function() {
      var p = function(g) {
        var m = g.current;
        m || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot unmount ref as it is not set") : K(!1)), M6().removeChild(m), g.current = null;
      };
      p(n), p(a);
    };
  }, [t, o, i, r.always, r.resting, e]);
  var s = ve(function() {
    return i(r.dragging);
  }, [i, r.dragging]), c = ve(function(h) {
    if (h === "DROP") {
      i(r.dropAnimating);
      return;
    }
    i(r.userCancel);
  }, [i, r.dropAnimating, r.userCancel]), u = ve(function() {
    a.current && i(r.resting);
  }, [i, r.resting]), d = He(function() {
    return {
      dragging: s,
      dropping: c,
      resting: u
    };
  }, [s, c, u]);
  return d;
}
var ib = function(e) {
  return e && e.ownerDocument ? e.ownerDocument.defaultView : window;
};
function Wo(e) {
  return e instanceof ib(e).HTMLElement;
}
function ob(e, t) {
  var r = "[" + Ua.contextId + '="' + e + '"]', n = EC(document.querySelectorAll(r));
  if (!n.length)
    return process.env.NODE_ENV !== "production" && ut('Unable to find any drag handles in the context "' + e + '"'), null;
  var a = h1(n, function(i) {
    return i.getAttribute(Ua.draggableId) === t;
  });
  return a ? Wo(a) ? a : (process.env.NODE_ENV !== "production" && ut("drag handle needs to be a HTMLElement"), null) : (process.env.NODE_ENV !== "production" && ut('Unable to find drag handle with id "' + t + '" as no handle with a matching id was found'), null);
}
function cT(e) {
  var t = Ce({}), r = Ce(null), n = Ce(null), a = Ce(!1), i = ve(function(A, p) {
    var v = {
      id: A,
      focus: p
    };
    return t.current[A] = v, function() {
      var m = t.current, b = m[A];
      b !== v && delete m[A];
    };
  }, []), o = ve(function(A) {
    var p = ob(e, A);
    p && p !== document.activeElement && p.focus();
  }, [e]), s = ve(function(A, p) {
    r.current === A && (r.current = p);
  }, []), c = ve(function() {
    n.current || a.current && (n.current = requestAnimationFrame(function() {
      n.current = null;
      var A = r.current;
      A && o(A);
    }));
  }, [o]), u = ve(function(A) {
    r.current = null;
    var p = document.activeElement;
    p && p.getAttribute(Ua.draggableId) === A && (r.current = A);
  }, []);
  gr(function() {
    return a.current = !0, function() {
      a.current = !1;
      var A = n.current;
      A && cancelAnimationFrame(A);
    };
  }, []);
  var d = He(function() {
    return {
      register: i,
      tryRecordFocus: u,
      tryRestoreFocusRecorded: c,
      tryShiftRecord: s
    };
  }, [i, u, c, s]);
  return d;
}
function uT() {
  var e = {
    draggables: {},
    droppables: {}
  }, t = [];
  function r(h) {
    return t.push(h), function() {
      var p = t.indexOf(h);
      p !== -1 && t.splice(p, 1);
    };
  }
  function n(h) {
    t.length && t.forEach(function(A) {
      return A(h);
    });
  }
  function a(h) {
    return e.draggables[h] || null;
  }
  function i(h) {
    var A = a(h);
    return A || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot find draggable entry with id [" + h + "]") : K(!1)), A;
  }
  var o = {
    register: function(A) {
      e.draggables[A.descriptor.id] = A, n({
        type: "ADDITION",
        value: A
      });
    },
    update: function(A, p) {
      var v = e.draggables[p.descriptor.id];
      v && v.uniqueId === A.uniqueId && (delete e.draggables[p.descriptor.id], e.draggables[A.descriptor.id] = A);
    },
    unregister: function(A) {
      var p = A.descriptor.id, v = a(p);
      v && A.uniqueId === v.uniqueId && (delete e.draggables[p], n({
        type: "REMOVAL",
        value: A
      }));
    },
    getById: i,
    findById: a,
    exists: function(A) {
      return !!a(A);
    },
    getAllByType: function(A) {
      return os(e.draggables).filter(function(p) {
        return p.descriptor.type === A;
      });
    }
  };
  function s(h) {
    return e.droppables[h] || null;
  }
  function c(h) {
    var A = s(h);
    return A || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot find droppable entry with id [" + h + "]") : K(!1)), A;
  }
  var u = {
    register: function(A) {
      e.droppables[A.descriptor.id] = A;
    },
    unregister: function(A) {
      var p = s(A.descriptor.id);
      p && A.uniqueId === p.uniqueId && delete e.droppables[A.descriptor.id];
    },
    getById: c,
    findById: s,
    exists: function(A) {
      return !!s(A);
    },
    getAllByType: function(A) {
      return os(e.droppables).filter(function(p) {
        return p.descriptor.type === A;
      });
    }
  };
  function d() {
    e.draggables = {}, e.droppables = {}, t.length = 0;
  }
  return {
    draggable: o,
    droppable: u,
    subscribe: r,
    clean: d
  };
}
function dT() {
  var e = He(uT, []);
  return Ne(function() {
    return function() {
      requestAnimationFrame(e.clean);
    };
  }, [e]), e;
}
var K7 = P.createContext(null), to = function() {
  var e = document.body;
  return e || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot find document.body") : K(!1)), e;
}, fT = {
  position: "absolute",
  width: "1px",
  height: "1px",
  margin: "-1px",
  border: "0",
  padding: "0",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  "clip-path": "inset(100%)"
}, hT = function(t) {
  return "rbd-announcement-" + t;
};
function AT(e) {
  var t = He(function() {
    return hT(e);
  }, [e]), r = Ce(null);
  Ne(function() {
    var i = document.createElement("div");
    return r.current = i, i.id = t, i.setAttribute("aria-live", "assertive"), i.setAttribute("aria-atomic", "true"), be(i.style, fT), to().appendChild(i), function() {
      setTimeout(function() {
        var c = to();
        c.contains(i) && c.removeChild(i), i === r.current && (r.current = null);
      });
    };
  }, [t]);
  var n = ve(function(a) {
    var i = r.current;
    if (i) {
      i.textContent = a;
      return;
    }
    process.env.NODE_ENV !== "production" && ut(`
      A screen reader message was trying to be announced but it was unable to do so.
      This can occur if you unmount your <DragDropContext /> in your onDragEnd.
      Consider calling provided.announce() before the unmount so that the instruction will
      not be lost for users relying on a screen reader.

      Message not passed to screen reader:

      "` + a + `"
    `);
  }, []);
  return n;
}
var pT = 0, gT = {
  separator: "::"
};
function z7(e, t) {
  return t === void 0 && (t = gT), He(function() {
    return "" + e + t.separator + pT++;
  }, [t.separator, e]);
}
function vT(e) {
  var t = e.contextId, r = e.uniqueId;
  return "rbd-hidden-text-" + t + "-" + r;
}
function mT(e) {
  var t = e.contextId, r = e.text, n = z7("hidden-text", {
    separator: "-"
  }), a = He(function() {
    return vT({
      contextId: t,
      uniqueId: n
    });
  }, [n, t]);
  return Ne(function() {
    var o = document.createElement("div");
    return o.id = a, o.textContent = r, o.style.display = "none", to().appendChild(o), function() {
      var c = to();
      c.contains(o) && c.removeChild(o);
    };
  }, [a, r]), a;
}
var v0 = P.createContext(null), CT = {
  react: "^16.8.5 || ^17.0.0 || ^18.0.0",
  "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
}, bT = /(\d+)\.(\d+)\.(\d+)/, Kf = function(t) {
  var r = bT.exec(t);
  r == null && (process.env.NODE_ENV !== "production" ? K(!1, "Unable to parse React version " + t) : K(!1));
  var n = Number(r[1]), a = Number(r[2]), i = Number(r[3]);
  return {
    major: n,
    minor: a,
    patch: i,
    raw: t
  };
}, yT = function(t, r) {
  return r.major > t.major ? !0 : r.major < t.major ? !1 : r.minor > t.minor ? !0 : r.minor < t.minor ? !1 : r.patch >= t.patch;
}, wT = function(e, t) {
  var r = Kf(e), n = Kf(t);
  yT(r, n) || process.env.NODE_ENV !== "production" && ut(`
    React version: [` + n.raw + `]
    does not satisfy expected peer dependency version: [` + r.raw + `]

    This can result in run time bugs, and even fatal crashes
  `);
}, E6 = `
  We expect a html5 doctype: <!doctype html>
  This is to ensure consistent browser layout and measurement

  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md
`, xT = function(e) {
  var t = e.doctype;
  if (!t) {
    process.env.NODE_ENV !== "production" && ut(`
      No <!doctype html> found.

      ` + E6 + `
    `);
    return;
  }
  t.name.toLowerCase() !== "html" && process.env.NODE_ENV !== "production" && ut(`
      Unexpected <!doctype> found: (` + t.name + `)

      ` + E6 + `
    `), t.publicId !== "" && process.env.NODE_ENV !== "production" && ut(`
      Unexpected <!doctype> publicId found: (` + t.publicId + `)
      A html5 doctype does not have a publicId

      ` + E6 + `
    `);
};
function q7(e) {
  process.env.NODE_ENV !== "production" && e();
}
function Qo(e, t) {
  q7(function() {
    Ne(function() {
      try {
        e();
      } catch (r) {
        Y4(`
          A setup problem was encountered.

          > ` + r.message + `
        `);
      }
    }, t);
  });
}
function DT() {
  Qo(function() {
    wT(CT.react, P.version), xT(document);
  }, []);
}
function X7(e) {
  var t = Ce(e);
  return Ne(function() {
    t.current = e;
  }), t;
}
function OT() {
  var e = null;
  function t() {
    return !!e;
  }
  function r(o) {
    return o === e;
  }
  function n(o) {
    e && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot claim lock as it is already claimed") : K(!1));
    var s = {
      abandon: o
    };
    return e = s, s;
  }
  function a() {
    e || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot release lock when there is no lock") : K(!1)), e = null;
  }
  function i() {
    e && (e.abandon(), a());
  }
  return {
    isClaimed: t,
    isActive: r,
    claim: n,
    release: a,
    tryAbandon: i
  };
}
var MT = 9, ET = 13, J7 = 27, sb = 32, ST = 33, PT = 34, jT = 35, IT = 36, BT = 37, NT = 38, LT = 39, TT = 40, w3, _T = (w3 = {}, w3[ET] = !0, w3[MT] = !0, w3), lb = function(e) {
  _T[e.keyCode] && e.preventDefault();
}, m0 = function() {
  var e = "visibilitychange";
  if (typeof document > "u")
    return e;
  var t = [e, "ms" + e, "webkit" + e, "moz" + e, "o" + e], r = h1(t, function(n) {
    return "on" + n in document;
  });
  return r || e;
}(), cb = 0, zf = 5;
function RT(e, t) {
  return Math.abs(t.x - e.x) >= zf || Math.abs(t.y - e.y) >= zf;
}
var qf = {
  type: "IDLE"
};
function FT(e) {
  var t = e.cancel, r = e.completed, n = e.getPhase, a = e.setPhase;
  return [{
    eventName: "mousemove",
    fn: function(o) {
      var s = o.button, c = o.clientX, u = o.clientY;
      if (s === cb) {
        var d = {
          x: c,
          y: u
        }, h = n();
        if (h.type === "DRAGGING") {
          o.preventDefault(), h.actions.move(d);
          return;
        }
        h.type !== "PENDING" && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot be IDLE") : K(!1));
        var A = h.point;
        if (RT(A, d)) {
          o.preventDefault();
          var p = h.actions.fluidLift(d);
          a({
            type: "DRAGGING",
            actions: p
          });
        }
      }
    }
  }, {
    eventName: "mouseup",
    fn: function(o) {
      var s = n();
      if (s.type !== "DRAGGING") {
        t();
        return;
      }
      o.preventDefault(), s.actions.drop({
        shouldBlockNextClick: !0
      }), r();
    }
  }, {
    eventName: "mousedown",
    fn: function(o) {
      n().type === "DRAGGING" && o.preventDefault(), t();
    }
  }, {
    eventName: "keydown",
    fn: function(o) {
      var s = n();
      if (s.type === "PENDING") {
        t();
        return;
      }
      if (o.keyCode === J7) {
        o.preventDefault(), t();
        return;
      }
      lb(o);
    }
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function() {
      n().type === "PENDING" && t();
    }
  }, {
    eventName: "webkitmouseforcedown",
    fn: function(o) {
      var s = n();
      if (s.type === "IDLE" && (process.env.NODE_ENV !== "production" ? K(!1, "Unexpected phase") : K(!1)), s.actions.shouldRespectForcePress()) {
        t();
        return;
      }
      o.preventDefault();
    }
  }, {
    eventName: m0,
    fn: t
  }];
}
function $T(e) {
  var t = Ce(qf), r = Ce(Jn), n = He(function() {
    return {
      eventName: "mousedown",
      fn: function(h) {
        if (!h.defaultPrevented && h.button === cb && !(h.ctrlKey || h.metaKey || h.shiftKey || h.altKey)) {
          var A = e.findClosestDraggableId(h);
          if (A) {
            var p = e.tryGetLock(A, o, {
              sourceEvent: h
            });
            if (p) {
              h.preventDefault();
              var v = {
                x: h.clientX,
                y: h.clientY
              };
              r.current(), u(p, v);
            }
          }
        }
      }
    };
  }, [e]), a = He(function() {
    return {
      eventName: "webkitmouseforcewillbegin",
      fn: function(h) {
        if (!h.defaultPrevented) {
          var A = e.findClosestDraggableId(h);
          if (A) {
            var p = e.findOptionsForDraggable(A);
            p && (p.shouldRespectForcePress || e.canGetLock(A) && h.preventDefault());
          }
        }
      }
    };
  }, [e]), i = ve(function() {
    var h = {
      passive: !1,
      capture: !0
    };
    r.current = Sr(window, [a, n], h);
  }, [a, n]), o = ve(function() {
    var d = t.current;
    d.type !== "IDLE" && (t.current = qf, r.current(), i());
  }, [i]), s = ve(function() {
    var d = t.current;
    o(), d.type === "DRAGGING" && d.actions.cancel({
      shouldBlockNextClick: !0
    }), d.type === "PENDING" && d.actions.abort();
  }, [o]), c = ve(function() {
    var h = {
      capture: !0,
      passive: !1
    }, A = FT({
      cancel: s,
      completed: o,
      getPhase: function() {
        return t.current;
      },
      setPhase: function(v) {
        t.current = v;
      }
    });
    r.current = Sr(window, A, h);
  }, [s, o]), u = ve(function(h, A) {
    t.current.type !== "IDLE" && (process.env.NODE_ENV !== "production" ? K(!1, "Expected to move from IDLE to PENDING drag") : K(!1)), t.current = {
      type: "PENDING",
      point: A,
      actions: h
    }, c();
  }, [c]);
  gr(function() {
    return i(), function() {
      r.current();
    };
  }, [i]);
}
var xa;
function HT() {
}
var YT = (xa = {}, xa[PT] = !0, xa[ST] = !0, xa[IT] = !0, xa[jT] = !0, xa);
function kT(e, t) {
  function r() {
    t(), e.cancel();
  }
  function n() {
    t(), e.drop();
  }
  return [{
    eventName: "keydown",
    fn: function(i) {
      if (i.keyCode === J7) {
        i.preventDefault(), r();
        return;
      }
      if (i.keyCode === sb) {
        i.preventDefault(), n();
        return;
      }
      if (i.keyCode === TT) {
        i.preventDefault(), e.moveDown();
        return;
      }
      if (i.keyCode === NT) {
        i.preventDefault(), e.moveUp();
        return;
      }
      if (i.keyCode === LT) {
        i.preventDefault(), e.moveRight();
        return;
      }
      if (i.keyCode === BT) {
        i.preventDefault(), e.moveLeft();
        return;
      }
      if (YT[i.keyCode]) {
        i.preventDefault();
        return;
      }
      lb(i);
    }
  }, {
    eventName: "mousedown",
    fn: r
  }, {
    eventName: "mouseup",
    fn: r
  }, {
    eventName: "click",
    fn: r
  }, {
    eventName: "touchstart",
    fn: r
  }, {
    eventName: "resize",
    fn: r
  }, {
    eventName: "wheel",
    fn: r,
    options: {
      passive: !0
    }
  }, {
    eventName: m0,
    fn: r
  }];
}
function VT(e) {
  var t = Ce(HT), r = He(function() {
    return {
      eventName: "keydown",
      fn: function(i) {
        if (i.defaultPrevented || i.keyCode !== sb)
          return;
        var o = e.findClosestDraggableId(i);
        if (!o)
          return;
        var s = e.tryGetLock(o, d, {
          sourceEvent: i
        });
        if (!s)
          return;
        i.preventDefault();
        var c = !0, u = s.snapLift();
        t.current();
        function d() {
          c || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot stop capturing a keyboard drag when not capturing") : K(!1)), c = !1, t.current(), n();
        }
        t.current = Sr(window, kT(u, d), {
          capture: !0,
          passive: !1
        });
      }
    };
  }, [e]), n = ve(function() {
    var i = {
      passive: !1,
      capture: !0
    };
    t.current = Sr(window, [r], i);
  }, [r]);
  gr(function() {
    return n(), function() {
      t.current();
    };
  }, [n]);
}
var S6 = {
  type: "IDLE"
}, GT = 120, WT = 0.15;
function QT(e) {
  var t = e.cancel, r = e.getPhase;
  return [{
    eventName: "orientationchange",
    fn: t
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "contextmenu",
    fn: function(a) {
      a.preventDefault();
    }
  }, {
    eventName: "keydown",
    fn: function(a) {
      if (r().type !== "DRAGGING") {
        t();
        return;
      }
      a.keyCode === J7 && a.preventDefault(), t();
    }
  }, {
    eventName: m0,
    fn: t
  }];
}
function UT(e) {
  var t = e.cancel, r = e.completed, n = e.getPhase;
  return [{
    eventName: "touchmove",
    options: {
      capture: !1
    },
    fn: function(i) {
      var o = n();
      if (o.type !== "DRAGGING") {
        t();
        return;
      }
      o.hasMoved = !0;
      var s = i.touches[0], c = s.clientX, u = s.clientY, d = {
        x: c,
        y: u
      };
      i.preventDefault(), o.actions.move(d);
    }
  }, {
    eventName: "touchend",
    fn: function(i) {
      var o = n();
      if (o.type !== "DRAGGING") {
        t();
        return;
      }
      i.preventDefault(), o.actions.drop({
        shouldBlockNextClick: !0
      }), r();
    }
  }, {
    eventName: "touchcancel",
    fn: function(i) {
      if (n().type !== "DRAGGING") {
        t();
        return;
      }
      i.preventDefault(), t();
    }
  }, {
    eventName: "touchforcechange",
    fn: function(i) {
      var o = n();
      o.type === "IDLE" && (process.env.NODE_ENV, K(!1));
      var s = i.touches[0];
      if (s) {
        var c = s.force >= WT;
        if (c) {
          var u = o.actions.shouldRespectForcePress();
          if (o.type === "PENDING") {
            u && t();
            return;
          }
          if (u) {
            if (o.hasMoved) {
              i.preventDefault();
              return;
            }
            t();
            return;
          }
          i.preventDefault();
        }
      }
    }
  }, {
    eventName: m0,
    fn: t
  }];
}
function ZT(e) {
  var t = Ce(S6), r = Ce(Jn), n = ve(function() {
    return t.current;
  }, []), a = ve(function(p) {
    t.current = p;
  }, []), i = He(function() {
    return {
      eventName: "touchstart",
      fn: function(p) {
        if (!p.defaultPrevented) {
          var v = e.findClosestDraggableId(p);
          if (v) {
            var g = e.tryGetLock(v, s, {
              sourceEvent: p
            });
            if (g) {
              var m = p.touches[0], b = m.clientX, w = m.clientY, x = {
                x: b,
                y: w
              };
              r.current(), h(g, x);
            }
          }
        }
      }
    };
  }, [e]), o = ve(function() {
    var p = {
      capture: !0,
      passive: !1
    };
    r.current = Sr(window, [i], p);
  }, [i]), s = ve(function() {
    var A = t.current;
    A.type !== "IDLE" && (A.type === "PENDING" && clearTimeout(A.longPressTimerId), a(S6), r.current(), o());
  }, [o, a]), c = ve(function() {
    var A = t.current;
    s(), A.type === "DRAGGING" && A.actions.cancel({
      shouldBlockNextClick: !0
    }), A.type === "PENDING" && A.actions.abort();
  }, [s]), u = ve(function() {
    var p = {
      capture: !0,
      passive: !1
    }, v = {
      cancel: c,
      completed: s,
      getPhase: n
    }, g = Sr(window, UT(v), p), m = Sr(window, QT(v), p);
    r.current = function() {
      g(), m();
    };
  }, [c, n, s]), d = ve(function() {
    var p = n();
    p.type !== "PENDING" && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot start dragging from phase " + p.type) : K(!1));
    var v = p.actions.fluidLift(p.point);
    a({
      type: "DRAGGING",
      actions: v,
      hasMoved: !1
    });
  }, [n, a]), h = ve(function(p, v) {
    n().type !== "IDLE" && (process.env.NODE_ENV !== "production" ? K(!1, "Expected to move from IDLE to PENDING drag") : K(!1));
    var g = setTimeout(d, GT);
    a({
      type: "PENDING",
      point: v,
      actions: p,
      longPressTimerId: g
    }), u();
  }, [u, n, a, d]);
  gr(function() {
    return o(), function() {
      r.current();
      var v = n();
      v.type === "PENDING" && (clearTimeout(v.longPressTimerId), a(S6));
    };
  }, [n, o, a]), gr(function() {
    var p = Sr(window, [{
      eventName: "touchmove",
      fn: function() {
      },
      options: {
        capture: !1,
        passive: !1
      }
    }]);
    return p;
  }, []);
}
function KT(e) {
  q7(function() {
    var t = X7(e);
    Qo(function() {
      t.current.length !== e.length && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot change the amount of sensor hooks after mounting") : K(!1));
    });
  });
}
var zT = {
  input: !0,
  button: !0,
  textarea: !0,
  select: !0,
  option: !0,
  optgroup: !0,
  video: !0,
  audio: !0
};
function ub(e, t) {
  if (t == null)
    return !1;
  var r = !!zT[t.tagName.toLowerCase()];
  if (r)
    return !0;
  var n = t.getAttribute("contenteditable");
  return n === "true" || n === "" ? !0 : t === e ? !1 : ub(e, t.parentElement);
}
function qT(e, t) {
  var r = t.target;
  return Wo(r) ? ub(e, r) : !1;
}
var XT = function(e) {
  return Yr(e.getBoundingClientRect()).center;
};
function JT(e) {
  return e instanceof ib(e).Element;
}
var e_ = function() {
  var e = "matches";
  if (typeof document > "u")
    return e;
  var t = [e, "msMatchesSelector", "webkitMatchesSelector"], r = h1(t, function(n) {
    return n in Element.prototype;
  });
  return r || e;
}();
function db(e, t) {
  return e == null ? null : e[e_](t) ? e : db(e.parentElement, t);
}
function t_(e, t) {
  return e.closest ? e.closest(t) : db(e, t);
}
function r_(e) {
  return "[" + Ua.contextId + '="' + e + '"]';
}
function n_(e, t) {
  var r = t.target;
  if (!JT(r))
    return process.env.NODE_ENV !== "production" && ut("event.target must be a Element"), null;
  var n = r_(e), a = t_(r, n);
  return a ? Wo(a) ? a : (process.env.NODE_ENV !== "production" && ut("drag handle must be a HTMLElement"), null) : null;
}
function a_(e, t) {
  var r = n_(e, t);
  return r ? r.getAttribute(Ua.draggableId) : null;
}
function i_(e, t) {
  var r = "[" + Q4.contextId + '="' + e + '"]', n = EC(document.querySelectorAll(r)), a = h1(n, function(i) {
    return i.getAttribute(Q4.id) === t;
  });
  return a ? Wo(a) ? a : (process.env.NODE_ENV !== "production" && ut("Draggable element is not a HTMLElement"), null) : null;
}
function o_(e) {
  e.preventDefault();
}
function x3(e) {
  var t = e.expected, r = e.phase, n = e.isLockActive, a = e.shouldWarn;
  return n() ? t !== r ? (a && process.env.NODE_ENV !== "production" && ut(`
        Cannot perform action.
        The actions you used belong to an outdated phase

        Current phase: ` + t + `
        You called an action from outdated phase: ` + r + `

        Tips:

        - Do not use preDragActions actions after calling preDragActions.lift()
      `), !1) : !0 : (a && process.env.NODE_ENV !== "production" && ut(`
        Cannot perform action.
        The sensor no longer has an action lock.

        Tips:

        - Throw away your action handlers when forceStop() is called
        - Check actions.isActive() if you really need to
      `), !1);
}
function fb(e) {
  var t = e.lockAPI, r = e.store, n = e.registry, a = e.draggableId;
  if (t.isClaimed())
    return !1;
  var i = n.draggable.findById(a);
  return i ? !(!i.options.isEnabled || !tb(r.getState(), a)) : (process.env.NODE_ENV !== "production" && ut("Unable to find draggable with id: " + a), !1);
}
function s_(e) {
  var t = e.lockAPI, r = e.contextId, n = e.store, a = e.registry, i = e.draggableId, o = e.forceSensorStop, s = e.sourceEvent, c = fb({
    lockAPI: t,
    store: n,
    registry: a,
    draggableId: i
  });
  if (!c)
    return null;
  var u = a.draggable.getById(i), d = i_(r, u.descriptor.id);
  if (!d)
    return process.env.NODE_ENV !== "production" && ut("Unable to find draggable element with id: " + i), null;
  if (s && !u.options.canDragInteractiveElements && qT(d, s))
    return null;
  var h = t.claim(o || Jn), A = "PRE_DRAG";
  function p() {
    return u.options.shouldRespectForcePress;
  }
  function v() {
    return t.isActive(h);
  }
  function g(O, M) {
    x3({
      expected: O,
      phase: A,
      isLockActive: v,
      shouldWarn: !0
    }) && n.dispatch(M());
  }
  var m = g.bind(null, "DRAGGING");
  function b(O) {
    function M() {
      t.release(), A = "COMPLETED";
    }
    A !== "PRE_DRAG" && (M(), A !== "PRE_DRAG" && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot lift in phase " + A) : K(!1))), n.dispatch(QN(O.liftActionArgs)), A = "DRAGGING";
    function E(N, F) {
      if (F === void 0 && (F = {
        shouldBlockNextClick: !1
      }), O.cleanup(), F.shouldBlockNextClick) {
        var k = Sr(window, [{
          eventName: "click",
          fn: o_,
          options: {
            once: !0,
            passive: !1,
            capture: !0
          }
        }]);
        setTimeout(k);
      }
      M(), n.dispatch(ZC({
        reason: N
      }));
    }
    return be({
      isActive: function() {
        return x3({
          expected: "DRAGGING",
          phase: A,
          isLockActive: v,
          shouldWarn: !1
        });
      },
      shouldRespectForcePress: p,
      drop: function(F) {
        return E("DROP", F);
      },
      cancel: function(F) {
        return E("CANCEL", F);
      }
    }, O.actions);
  }
  function w(O) {
    var M = Ki(function(N) {
      m(function() {
        return UC({
          client: N
        });
      });
    }), E = b({
      liftActionArgs: {
        id: i,
        clientSelection: O,
        movementMode: "FLUID"
      },
      cleanup: function() {
        return M.cancel();
      },
      actions: {
        move: M
      }
    });
    return be({}, E, {
      move: M
    });
  }
  function x() {
    var O = {
      moveUp: function() {
        return m(tL);
      },
      moveRight: function() {
        return m(nL);
      },
      moveDown: function() {
        return m(rL);
      },
      moveLeft: function() {
        return m(aL);
      }
    };
    return b({
      liftActionArgs: {
        id: i,
        clientSelection: XT(d),
        movementMode: "SNAP"
      },
      cleanup: Jn,
      actions: O
    });
  }
  function y() {
    var O = x3({
      expected: "PRE_DRAG",
      phase: A,
      isLockActive: v,
      shouldWarn: !0
    });
    O && t.release();
  }
  var C = {
    isActive: function() {
      return x3({
        expected: "PRE_DRAG",
        phase: A,
        isLockActive: v,
        shouldWarn: !1
      });
    },
    shouldRespectForcePress: p,
    fluidLift: w,
    snapLift: x,
    abort: y
  };
  return C;
}
var l_ = [$T, VT, ZT];
function c_(e) {
  var t = e.contextId, r = e.store, n = e.registry, a = e.customSensors, i = e.enableDefaultSensors, o = [].concat(i ? l_ : [], a || []), s = Ee(function() {
    return OT();
  })[0], c = ve(function(w, x) {
    w.isDragging && !x.isDragging && s.tryAbandon();
  }, [s]);
  gr(function() {
    var w = r.getState(), x = r.subscribe(function() {
      var y = r.getState();
      c(w, y), w = y;
    });
    return x;
  }, [s, r, c]), gr(function() {
    return s.tryAbandon;
  }, [s.tryAbandon]);
  var u = ve(function(b) {
    return fb({
      lockAPI: s,
      registry: n,
      store: r,
      draggableId: b
    });
  }, [s, n, r]), d = ve(function(b, w, x) {
    return s_({
      lockAPI: s,
      registry: n,
      contextId: t,
      store: r,
      draggableId: b,
      forceSensorStop: w,
      sourceEvent: x && x.sourceEvent ? x.sourceEvent : null
    });
  }, [t, s, n, r]), h = ve(function(b) {
    return a_(t, b);
  }, [t]), A = ve(function(b) {
    var w = n.draggable.findById(b);
    return w ? w.options : null;
  }, [n.draggable]), p = ve(function() {
    s.isClaimed() && (s.tryAbandon(), r.getState().phase !== "IDLE" && r.dispatch(Y7()));
  }, [s, r]), v = ve(s.isClaimed, [s]), g = He(function() {
    return {
      canGetLock: u,
      tryGetLock: d,
      findClosestDraggableId: h,
      findOptionsForDraggable: A,
      tryReleaseLock: p,
      isLockClaimed: v
    };
  }, [u, d, h, A, p, v]);
  KT(o);
  for (var m = 0; m < o.length; m++)
    o[m](g);
}
var u_ = function(t) {
  return {
    onBeforeCapture: t.onBeforeCapture,
    onBeforeDragStart: t.onBeforeDragStart,
    onDragStart: t.onDragStart,
    onDragEnd: t.onDragEnd,
    onDragUpdate: t.onDragUpdate
  };
};
function oi(e) {
  return e.current || (process.env.NODE_ENV !== "production" ? K(!1, "Could not find store from lazy ref") : K(!1)), e.current;
}
function d_(e) {
  var t = e.contextId, r = e.setCallbacks, n = e.sensors, a = e.nonce, i = e.dragHandleUsageInstructions, o = Ce(null);
  DT();
  var s = X7(e), c = ve(function() {
    return u_(s.current);
  }, [s]), u = AT(t), d = mT({
    contextId: t,
    text: i
  }), h = lT(t, a), A = ve(function(N) {
    oi(o).dispatch(N);
  }, []), p = He(function() {
    return rf({
      publishWhileDragging: ZN,
      updateDroppableScroll: zN,
      updateDroppableIsEnabled: qN,
      updateDroppableIsCombineEnabled: XN,
      collectionStarting: KN
    }, A);
  }, [A]), v = dT(), g = He(function() {
    return HL(v, p);
  }, [v, p]), m = He(function() {
    return nT(be({
      scrollWindow: YL,
      scrollDroppable: g.scrollDroppable
    }, rf({
      move: UC
    }, A)));
  }, [g.scrollDroppable, A]), b = cT(t), w = He(function() {
    return _L({
      announce: u,
      autoScroller: m,
      dimensionMarshal: g,
      focusMarshal: b,
      getResponders: c,
      styleMarshal: h
    });
  }, [u, m, g, b, c, h]);
  process.env.NODE_ENV !== "production" && o.current && o.current !== w && process.env.NODE_ENV !== "production" && ut("unexpected store change"), o.current = w;
  var x = ve(function() {
    var N = oi(o), F = N.getState();
    F.phase !== "IDLE" && N.dispatch(Y7());
  }, []), y = ve(function() {
    var N = oi(o).getState();
    return N.isDragging || N.phase === "DROP_ANIMATING";
  }, []), C = He(function() {
    return {
      isDragging: y,
      tryAbort: x
    };
  }, [y, x]);
  r(C);
  var O = ve(function(N) {
    return tb(oi(o).getState(), N);
  }, []), M = ve(function() {
    return _1(oi(o).getState());
  }, []), E = He(function() {
    return {
      marshal: g,
      focus: b,
      contextId: t,
      canLift: O,
      isMovementAllowed: M,
      dragHandleUsageInstructionsId: d,
      registry: v
    };
  }, [t, g, d, b, O, M, v]);
  return c_({
    contextId: t,
    store: w,
    registry: v,
    customSensors: n,
    enableDefaultSensors: e.enableDefaultSensors !== !1
  }), Ne(function() {
    return x;
  }, [x]), P.createElement(v0.Provider, {
    value: E
  }, P.createElement(hC, {
    context: K7,
    store: w
  }, e.children));
}
var f_ = 0;
function h_() {
  return He(function() {
    return "" + f_++;
  }, []);
}
function A_(e) {
  var t = h_(), r = e.dragHandleUsageInstructions || X3.dragHandleUsageInstructions;
  return P.createElement(TB, null, function(n) {
    return P.createElement(d_, {
      nonce: e.nonce,
      contextId: t,
      setCallbacks: n,
      dragHandleUsageInstructions: r,
      enableDefaultSensors: e.enableDefaultSensors,
      sensors: e.sensors,
      onBeforeCapture: e.onBeforeCapture,
      onBeforeDragStart: e.onBeforeDragStart,
      onDragStart: e.onDragStart,
      onDragUpdate: e.onDragUpdate,
      onDragEnd: e.onDragEnd
    }, e.children);
  });
}
var e9 = function(t) {
  return function(r) {
    return t === r;
  };
}, p_ = e9("scroll"), g_ = e9("auto"), v_ = e9("visible"), Xf = function(t, r) {
  return r(t.overflowX) || r(t.overflowY);
}, m_ = function(t, r) {
  return r(t.overflowX) && r(t.overflowY);
}, hb = function(t) {
  var r = window.getComputedStyle(t), n = {
    overflowX: r.overflowX,
    overflowY: r.overflowY
  };
  return Xf(n, p_) || Xf(n, g_);
}, C_ = function() {
  if (process.env.NODE_ENV === "production")
    return !1;
  var t = to(), r = document.documentElement;
  if (r || (process.env.NODE_ENV, K(!1)), !hb(t))
    return !1;
  var n = window.getComputedStyle(r), a = {
    overflowX: n.overflowX,
    overflowY: n.overflowY
  };
  return m_(a, v_) || process.env.NODE_ENV !== "production" && ut(`
    We have detected that your <body> element might be a scroll container.
    We have found no reliable way of detecting whether the <body> element is a scroll container.
    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)

    Because we cannot determine if the <body> is a scroll container, and generally it is not one,
    we will be treating the <body> as *not* a scroll container

    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md
  `), !1;
}, Ab = function e(t) {
  return t == null ? null : t === document.body ? C_() ? t : null : t === document.documentElement ? null : hb(t) ? t : e(t.parentElement);
}, b_ = function(e) {
  if (e) {
    var t = Ab(e.parentElement);
    t && process.env.NODE_ENV !== "production" && ut(`
    Droppable: unsupported nested scroll container detected.
    A Droppable can only have one scroll parent (which can be itself)
    Nested scroll containers are currently not supported.

    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131
  `);
  }
}, U4 = function(e) {
  return {
    x: e.scrollLeft,
    y: e.scrollTop
  };
}, y_ = function e(t) {
  if (!t)
    return !1;
  var r = window.getComputedStyle(t);
  return r.position === "fixed" ? !0 : e(t.parentElement);
}, w_ = function(e) {
  var t = Ab(e), r = y_(e);
  return {
    closestScrollable: t,
    isFixedOnPage: r
  };
}, x_ = function(e) {
  var t = e.descriptor, r = e.isEnabled, n = e.isCombineEnabled, a = e.isFixedOnPage, i = e.direction, o = e.client, s = e.page, c = e.closest, u = function() {
    if (!c)
      return null;
    var p = c.scrollSize, v = c.client, g = XC({
      scrollHeight: p.scrollHeight,
      scrollWidth: p.scrollWidth,
      height: v.paddingBox.height,
      width: v.paddingBox.width
    });
    return {
      pageMarginBox: c.page.marginBox,
      frameClient: v,
      scrollSize: p,
      shouldClipSubject: c.shouldClipSubject,
      scroll: {
        initial: c.scroll,
        current: c.scroll,
        max: g,
        diff: {
          value: Rt,
          displacement: Rt
        }
      }
    };
  }(), d = i === "vertical" ? _7 : BC, h = Wa({
    page: s,
    withPlaceholder: null,
    axis: d,
    frame: u
  }), A = {
    descriptor: t,
    isCombineEnabled: n,
    isFixedOnPage: a,
    axis: d,
    isEnabled: r,
    client: o,
    page: s,
    frame: u,
    subject: h
  };
  return A;
}, D_ = function(t, r) {
  var n = wC(t);
  if (!r || t !== r)
    return n;
  var a = n.paddingBox.top - r.scrollTop, i = n.paddingBox.left - r.scrollLeft, o = a + r.scrollHeight, s = i + r.scrollWidth, c = {
    top: a,
    right: s,
    bottom: o,
    left: i
  }, u = I7(c, n.border), d = B7({
    borderBox: u,
    margin: n.margin,
    border: n.border,
    padding: n.padding
  });
  return d;
}, O_ = function(e) {
  var t = e.ref, r = e.descriptor, n = e.env, a = e.windowScroll, i = e.direction, o = e.isDropDisabled, s = e.isCombineEnabled, c = e.shouldClipSubject, u = n.closestScrollable, d = D_(t, u), h = as(d, a), A = function() {
    if (!u)
      return null;
    var v = wC(u), g = {
      scrollHeight: u.scrollHeight,
      scrollWidth: u.scrollWidth
    };
    return {
      client: v,
      page: as(v, a),
      scroll: U4(u),
      scrollSize: g,
      shouldClipSubject: c
    };
  }(), p = x_({
    descriptor: r,
    isEnabled: !o,
    isCombineEnabled: s,
    isFixedOnPage: n.isFixedOnPage,
    direction: i,
    client: d,
    page: h,
    closest: A
  });
  return p;
}, M_ = {
  passive: !1
}, E_ = {
  passive: !0
}, Jf = function(e) {
  return e.shouldPublishImmediately ? M_ : E_;
};
function ls(e) {
  var t = wt(e);
  return t || (process.env.NODE_ENV !== "production" ? K(!1, "Could not find required context") : K(!1)), t;
}
var D3 = function(t) {
  return t && t.env.closestScrollable || null;
};
function S_(e) {
  var t = Ce(null), r = ls(v0), n = z7("droppable"), a = r.registry, i = r.marshal, o = X7(e), s = He(function() {
    return {
      id: e.droppableId,
      type: e.type,
      mode: e.mode
    };
  }, [e.droppableId, e.mode, e.type]), c = Ce(s), u = He(function() {
    return _t(function(y, C) {
      t.current || (process.env.NODE_ENV !== "production" ? K(!1, "Can only update scroll when dragging") : K(!1));
      var O = {
        x: y,
        y: C
      };
      i.updateDroppableScroll(s.id, O);
    });
  }, [s.id, i]), d = ve(function() {
    var y = t.current;
    return !y || !y.env.closestScrollable ? Rt : U4(y.env.closestScrollable);
  }, []), h = ve(function() {
    var y = d();
    u(y.x, y.y);
  }, [d, u]), A = He(function() {
    return Ki(h);
  }, [h]), p = ve(function() {
    var y = t.current, C = D3(y);
    y && C || (process.env.NODE_ENV !== "production" ? K(!1, "Could not find scroll options while scrolling") : K(!1));
    var O = y.scrollOptions;
    if (O.shouldPublishImmediately) {
      h();
      return;
    }
    A();
  }, [A, h]), v = ve(function(y, C) {
    t.current && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot collect a droppable while a drag is occurring") : K(!1));
    var O = o.current, M = O.getDroppableRef();
    M || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot collect without a droppable ref") : K(!1));
    var E = w_(M), N = {
      ref: M,
      descriptor: s,
      env: E,
      scrollOptions: C
    };
    t.current = N;
    var F = O_({
      ref: M,
      descriptor: s,
      env: E,
      windowScroll: y,
      direction: O.direction,
      isDropDisabled: O.isDropDisabled,
      isCombineEnabled: O.isCombineEnabled,
      shouldClipSubject: !O.ignoreContainerClipping
    }), k = E.closestScrollable;
    return k && (k.setAttribute(Uf.contextId, r.contextId), k.addEventListener("scroll", p, Jf(N.scrollOptions)), process.env.NODE_ENV !== "production" && b_(k)), F;
  }, [r.contextId, s, p, o]), g = ve(function() {
    var y = t.current, C = D3(y);
    return y && C || (process.env.NODE_ENV !== "production" ? K(!1, "Can only recollect Droppable client for Droppables that have a scroll container") : K(!1)), U4(C);
  }, []), m = ve(function() {
    var y = t.current;
    y || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot stop drag when no active drag") : K(!1));
    var C = D3(y);
    t.current = null, C && (A.cancel(), C.removeAttribute(Uf.contextId), C.removeEventListener("scroll", p, Jf(y.scrollOptions)));
  }, [p, A]), b = ve(function(y) {
    var C = t.current;
    C || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot scroll when there is no drag") : K(!1));
    var O = D3(C);
    O || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot scroll a droppable with no closest scrollable") : K(!1)), O.scrollTop += y.y, O.scrollLeft += y.x;
  }, []), w = He(function() {
    return {
      getDimensionAndWatchScroll: v,
      getScrollWhileDragging: g,
      dragStopped: m,
      scroll: b
    };
  }, [m, v, g, b]), x = He(function() {
    return {
      uniqueId: n,
      descriptor: s,
      callbacks: w
    };
  }, [w, s, n]);
  gr(function() {
    return c.current = x.descriptor, a.droppable.register(x), function() {
      t.current && (process.env.NODE_ENV !== "production" && ut("Unsupported: changing the droppableId or type of a Droppable during a drag"), m()), a.droppable.unregister(x);
    };
  }, [w, s, m, x, i, a.droppable]), gr(function() {
    t.current && i.updateDroppableIsEnabled(c.current.id, !e.isDropDisabled);
  }, [e.isDropDisabled, i]), gr(function() {
    t.current && i.updateDroppableIsCombineEnabled(c.current.id, e.isCombineEnabled);
  }, [e.isCombineEnabled, i]);
}
function P6() {
}
var eh = {
  width: 0,
  height: 0,
  margin: YB
}, P_ = function(t) {
  var r = t.isAnimatingOpenOnMount, n = t.placeholder, a = t.animate;
  return r || a === "close" ? eh : {
    height: n.client.borderBox.height,
    width: n.client.borderBox.width,
    margin: n.client.margin
  };
}, j_ = function(t) {
  var r = t.isAnimatingOpenOnMount, n = t.placeholder, a = t.animate, i = P_({
    isAnimatingOpenOnMount: r,
    placeholder: n,
    animate: a
  });
  return {
    display: n.display,
    boxSizing: "border-box",
    width: i.width,
    height: i.height,
    marginTop: i.margin.top,
    marginRight: i.margin.right,
    marginBottom: i.margin.bottom,
    marginLeft: i.margin.left,
    flexShrink: "0",
    flexGrow: "0",
    pointerEvents: "none",
    transition: a !== "none" ? _i.placeholder : null
  };
};
function I_(e) {
  var t = Ce(null), r = ve(function() {
    t.current && (clearTimeout(t.current), t.current = null);
  }, []), n = e.animate, a = e.onTransitionEnd, i = e.onClose, o = e.contextId, s = Ee(e.animate === "open"), c = s[0], u = s[1];
  Ne(function() {
    return c ? n !== "open" ? (r(), u(!1), P6) : t.current ? P6 : (t.current = setTimeout(function() {
      t.current = null, u(!1);
    }), r) : P6;
  }, [n, c, r]);
  var d = ve(function(A) {
    A.propertyName === "height" && (a(), n === "close" && i());
  }, [n, i, a]), h = j_({
    isAnimatingOpenOnMount: c,
    animate: e.animate,
    placeholder: e.placeholder
  });
  return P.createElement(e.placeholder.tagName, {
    style: h,
    "data-rbd-placeholder-context-id": o,
    onTransitionEnd: d,
    ref: e.innerRef
  });
}
var B_ = P.memo(I_), t9 = P.createContext(null);
function pb(e) {
  e && Wo(e) || (process.env.NODE_ENV !== "production" ? K(!1, `
    provided.innerRef has not been provided with a HTMLElement.

    You can find a guide on using the innerRef callback functions at:
    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md
  `) : K(!1));
}
function j6(e) {
  return typeof e == "boolean";
}
function I6(e, t) {
  t.forEach(function(r) {
    return r(e);
  });
}
var N_ = [function(t) {
  var r = t.props;
  r.droppableId || (process.env.NODE_ENV !== "production" ? K(!1, "A Droppable requires a droppableId prop") : K(!1)), typeof r.droppableId != "string" && (process.env.NODE_ENV !== "production" ? K(!1, "A Droppable requires a [string] droppableId. Provided: [" + typeof r.droppableId + "]") : K(!1));
}, function(t) {
  var r = t.props;
  j6(r.isDropDisabled) || (process.env.NODE_ENV !== "production" ? K(!1, "isDropDisabled must be a boolean") : K(!1)), j6(r.isCombineEnabled) || (process.env.NODE_ENV !== "production" ? K(!1, "isCombineEnabled must be a boolean") : K(!1)), j6(r.ignoreContainerClipping) || (process.env.NODE_ENV !== "production" ? K(!1, "ignoreContainerClipping must be a boolean") : K(!1));
}, function(t) {
  var r = t.getDroppableRef;
  pb(r());
}], L_ = [function(t) {
  var r = t.props, n = t.getPlaceholderRef;
  if (r.placeholder) {
    var a = n();
    a || process.env.NODE_ENV !== "production" && ut(`
      Droppable setup issue [droppableId: "` + r.droppableId + `"]:
      DroppableProvided > placeholder could not be found.

      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.
      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md
    `);
  }
}], T_ = [function(t) {
  var r = t.props;
  r.renderClone || (process.env.NODE_ENV !== "production" ? K(!1, "Must provide a clone render function (renderClone) for virtual lists") : K(!1));
}, function(t) {
  var r = t.getPlaceholderRef;
  r() && (process.env.NODE_ENV !== "production" ? K(!1, "Expected virtual list to not have a placeholder") : K(!1));
}];
function __(e) {
  Qo(function() {
    I6(e, N_), e.props.mode === "standard" && I6(e, L_), e.props.mode === "virtual" && I6(e, T_);
  });
}
var R_ = function(e) {
  iC(t, e);
  function t() {
    for (var n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(i)) || this, n.state = {
      isVisible: !!n.props.on,
      data: n.props.on,
      animate: n.props.shouldAnimate && n.props.on ? "open" : "none"
    }, n.onClose = function() {
      n.state.animate === "close" && n.setState({
        isVisible: !1
      });
    }, n;
  }
  t.getDerivedStateFromProps = function(a, i) {
    return a.shouldAnimate ? a.on ? {
      isVisible: !0,
      data: a.on,
      animate: "open"
    } : i.isVisible ? {
      isVisible: !0,
      data: i.data,
      animate: "close"
    } : {
      isVisible: !1,
      animate: "close",
      data: null
    } : {
      isVisible: !!a.on,
      data: a.on,
      animate: "none"
    };
  };
  var r = t.prototype;
  return r.render = function() {
    if (!this.state.isVisible)
      return null;
    var a = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(a);
  }, t;
}(P.PureComponent), th = {
  dragging: 5e3,
  dropAnimating: 4500
}, F_ = function(t, r) {
  return r ? _i.drop(r.duration) : t ? _i.snap : _i.fluid;
}, $_ = function(t, r) {
  return t ? r ? eo.opacity.drop : eo.opacity.combining : null;
}, H_ = function(t) {
  return t.forceShouldAnimate != null ? t.forceShouldAnimate : t.mode === "SNAP";
};
function Y_(e) {
  var t = e.dimension, r = t.client, n = e.offset, a = e.combineWith, i = e.dropping, o = !!a, s = H_(e), c = !!i, u = c ? G4.drop(n, o) : G4.moveTo(n), d = {
    position: "fixed",
    top: r.marginBox.top,
    left: r.marginBox.left,
    boxSizing: "border-box",
    width: r.borderBox.width,
    height: r.borderBox.height,
    transition: F_(s, i),
    transform: u,
    opacity: $_(o, c),
    zIndex: c ? th.dropAnimating : th.dragging,
    pointerEvents: "none"
  };
  return d;
}
function k_(e) {
  return {
    transform: G4.moveTo(e.offset),
    transition: e.shouldAnimateDisplacement ? null : "none"
  };
}
function V_(e) {
  return e.type === "DRAGGING" ? Y_(e) : k_(e);
}
function G_(e, t, r) {
  r === void 0 && (r = Rt);
  var n = window.getComputedStyle(t), a = t.getBoundingClientRect(), i = yC(a, n), o = as(i, r), s = {
    client: i,
    tagName: t.tagName.toLowerCase(),
    display: n.display
  }, c = {
    x: i.marginBox.width,
    y: i.marginBox.height
  }, u = {
    descriptor: e,
    placeholder: s,
    displaceBy: c,
    client: i,
    page: o
  };
  return u;
}
function W_(e) {
  var t = z7("draggable"), r = e.descriptor, n = e.registry, a = e.getDraggableRef, i = e.canDragInteractiveElements, o = e.shouldRespectForcePress, s = e.isEnabled, c = He(function() {
    return {
      canDragInteractiveElements: i,
      shouldRespectForcePress: o,
      isEnabled: s
    };
  }, [i, s, o]), u = ve(function(p) {
    var v = a();
    return v || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot get dimension when no ref is set") : K(!1)), G_(r, v, p);
  }, [r, a]), d = He(function() {
    return {
      uniqueId: t,
      descriptor: r,
      options: c,
      getDimension: u
    };
  }, [r, u, c, t]), h = Ce(d), A = Ce(!0);
  gr(function() {
    return n.draggable.register(h.current), function() {
      return n.draggable.unregister(h.current);
    };
  }, [n.draggable]), gr(function() {
    if (A.current) {
      A.current = !1;
      return;
    }
    var p = h.current;
    h.current = d, n.draggable.update(d, p);
  }, [d, n.draggable]);
}
function Q_(e, t, r) {
  Qo(function() {
    function n(i) {
      return "Draggable[id: " + i + "]: ";
    }
    var a = e.draggableId;
    a || (process.env.NODE_ENV !== "production" ? K(!1, "Draggable requires a draggableId") : K(!1)), typeof a != "string" && (process.env.NODE_ENV !== "production" ? K(!1, `Draggable requires a [string] draggableId.
      Provided: [type: ` + typeof a + "] (value: " + a + ")") : K(!1)), WB(e.index) || (process.env.NODE_ENV !== "production" ? K(!1, n(a) + " requires an integer index prop") : K(!1)), e.mapped.type !== "DRAGGING" && (pb(r()), e.isEnabled && (ob(t, a) || (process.env.NODE_ENV !== "production" ? K(!1, n(a) + " Unable to find drag handle") : K(!1))));
  });
}
function U_(e) {
  q7(function() {
    var t = Ce(e);
    Qo(function() {
      e !== t.current && (process.env.NODE_ENV !== "production" ? K(!1, "Draggable isClone prop value changed during component life") : K(!1));
    }, [e]);
  });
}
function Z_(e) {
  e.preventDefault();
}
function K_(e) {
  var t = Ce(null), r = ve(function(N) {
    t.current = N;
  }, []), n = ve(function() {
    return t.current;
  }, []), a = ls(v0), i = a.contextId, o = a.dragHandleUsageInstructionsId, s = a.registry, c = ls(t9), u = c.type, d = c.droppableId, h = He(function() {
    return {
      id: e.draggableId,
      index: e.index,
      type: u,
      droppableId: d
    };
  }, [e.draggableId, e.index, u, d]), A = e.children, p = e.draggableId, v = e.isEnabled, g = e.shouldRespectForcePress, m = e.canDragInteractiveElements, b = e.isClone, w = e.mapped, x = e.dropAnimationFinished;
  if (Q_(e, i, n), U_(b), !b) {
    var y = He(function() {
      return {
        descriptor: h,
        registry: s,
        getDraggableRef: n,
        canDragInteractiveElements: m,
        shouldRespectForcePress: g,
        isEnabled: v
      };
    }, [h, s, n, m, g, v]);
    W_(y);
  }
  var C = He(function() {
    return v ? {
      tabIndex: 0,
      role: "button",
      "aria-describedby": o,
      "data-rbd-drag-handle-draggable-id": p,
      "data-rbd-drag-handle-context-id": i,
      draggable: !1,
      onDragStart: Z_
    } : null;
  }, [i, o, p, v]), O = ve(function(N) {
    w.type === "DRAGGING" && w.dropping && N.propertyName === "transform" && x();
  }, [x, w]), M = He(function() {
    var N = V_(w), F = w.type === "DRAGGING" && w.dropping ? O : null, k = {
      innerRef: r,
      draggableProps: {
        "data-rbd-draggable-context-id": i,
        "data-rbd-draggable-id": p,
        style: N,
        onTransitionEnd: F
      },
      dragHandleProps: C
    };
    return k;
  }, [i, C, p, w, O, r]), E = He(function() {
    return {
      draggableId: h.id,
      type: h.type,
      source: {
        index: h.index,
        droppableId: h.droppableId
      }
    };
  }, [h.droppableId, h.id, h.index, h.type]);
  return A(M, w.snapshot, E);
}
var gb = function(e, t) {
  return e === t;
}, vb = function(e) {
  var t = e.combine, r = e.destination;
  return r ? r.droppableId : t ? t.droppableId : null;
}, z_ = function(t) {
  return t.combine ? t.combine.draggableId : null;
}, q_ = function(t) {
  return t.at && t.at.type === "COMBINE" ? t.at.combine.draggableId : null;
};
function X_() {
  var e = _t(function(a, i) {
    return {
      x: a,
      y: i
    };
  }), t = _t(function(a, i, o, s, c) {
    return {
      isDragging: !0,
      isClone: i,
      isDropAnimating: !!c,
      dropAnimation: c,
      mode: a,
      draggingOver: o,
      combineWith: s,
      combineTargetFor: null
    };
  }), r = _t(function(a, i, o, s, c, u, d) {
    return {
      mapped: {
        type: "DRAGGING",
        dropping: null,
        draggingOver: c,
        combineWith: u,
        mode: i,
        offset: a,
        dimension: o,
        forceShouldAnimate: d,
        snapshot: t(i, s, c, u, null)
      }
    };
  }), n = function(i, o) {
    if (i.isDragging) {
      if (i.critical.draggable.id !== o.draggableId)
        return null;
      var s = i.current.client.offset, c = i.dimensions.draggables[o.draggableId], u = pr(i.impact), d = q_(i.impact), h = i.forceShouldAnimate;
      return r(e(s.x, s.y), i.movementMode, c, o.isClone, u, d, h);
    }
    if (i.phase === "DROP_ANIMATING") {
      var A = i.completed;
      if (A.result.draggableId !== o.draggableId)
        return null;
      var p = o.isClone, v = i.dimensions.draggables[o.draggableId], g = A.result, m = g.mode, b = vb(g), w = z_(g), x = i.dropDuration, y = {
        duration: x,
        curve: V7.drop,
        moveTo: i.newHomeClientOffset,
        opacity: w ? eo.opacity.drop : null,
        scale: w ? eo.scale.drop : null
      };
      return {
        mapped: {
          type: "DRAGGING",
          offset: i.newHomeClientOffset,
          dimension: v,
          dropping: y,
          draggingOver: b,
          combineWith: w,
          mode: m,
          forceShouldAnimate: null,
          snapshot: t(m, p, b, w, y)
        }
      };
    }
    return null;
  };
  return n;
}
function mb(e) {
  return {
    isDragging: !1,
    isDropAnimating: !1,
    isClone: !1,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: e,
    combineWith: null
  };
}
var J_ = {
  mapped: {
    type: "SECONDARY",
    offset: Rt,
    combineTargetFor: null,
    shouldAnimateDisplacement: !0,
    snapshot: mb(null)
  }
};
function eR() {
  var e = _t(function(o, s) {
    return {
      x: o,
      y: s
    };
  }), t = _t(mb), r = _t(function(o, s, c) {
    return s === void 0 && (s = null), {
      mapped: {
        type: "SECONDARY",
        offset: o,
        combineTargetFor: s,
        shouldAnimateDisplacement: c,
        snapshot: t(s)
      }
    };
  }), n = function(s) {
    return s ? r(Rt, s, !0) : null;
  }, a = function(s, c, u, d) {
    var h = u.displaced.visible[s], A = !!(d.inVirtualList && d.effected[s]), p = A0(u), v = p && p.draggableId === s ? c : null;
    if (!h) {
      if (!A)
        return n(v);
      if (u.displaced.invisible[s])
        return null;
      var g = m2(d.displacedBy.point), m = e(g.x, g.y);
      return r(m, v, !0);
    }
    if (A)
      return n(v);
    var b = u.displacedBy.point, w = e(b.x, b.y);
    return r(w, v, h.shouldAnimate);
  }, i = function(s, c) {
    if (s.isDragging)
      return s.critical.draggable.id === c.draggableId ? null : a(c.draggableId, s.critical.draggable.id, s.impact, s.afterCritical);
    if (s.phase === "DROP_ANIMATING") {
      var u = s.completed;
      return u.result.draggableId === c.draggableId ? null : a(c.draggableId, u.result.draggableId, u.impact, u.afterCritical);
    }
    return null;
  };
  return i;
}
var tR = function() {
  var t = X_(), r = eR(), n = function(i, o) {
    return t(i, o) || r(i, o) || J_;
  };
  return n;
}, rR = {
  dropAnimationFinished: KC
}, nR = CC(tR, rR, null, {
  context: K7,
  pure: !0,
  areStatePropsEqual: gb
})(K_);
function Cb(e) {
  var t = ls(t9), r = t.isUsingCloneFor;
  return r === e.draggableId && !e.isClone ? null : P.createElement(nR, e);
}
function aR(e) {
  var t = typeof e.isDragDisabled == "boolean" ? !e.isDragDisabled : !0, r = !!e.disableInteractiveElementBlocking, n = !!e.shouldRespectForcePress;
  return P.createElement(Cb, be({}, e, {
    isClone: !1,
    isEnabled: t,
    canDragInteractiveElements: r,
    shouldRespectForcePress: n
  }));
}
function iR(e) {
  var t = wt(v0);
  t || (process.env.NODE_ENV !== "production" ? K(!1, "Could not find app context") : K(!1));
  var r = t.contextId, n = t.isMovementAllowed, a = Ce(null), i = Ce(null), o = e.children, s = e.droppableId, c = e.type, u = e.mode, d = e.direction, h = e.ignoreContainerClipping, A = e.isDropDisabled, p = e.isCombineEnabled, v = e.snapshot, g = e.useClone, m = e.updateViewportMaxScroll, b = e.getContainerForClone, w = ve(function() {
    return a.current;
  }, []), x = ve(function(R) {
    a.current = R;
  }, []), y = ve(function() {
    return i.current;
  }, []), C = ve(function(R) {
    i.current = R;
  }, []);
  __({
    props: e,
    getDroppableRef: w,
    getPlaceholderRef: y
  });
  var O = ve(function() {
    n() && m({
      maxScroll: eb()
    });
  }, [n, m]);
  S_({
    droppableId: s,
    type: c,
    mode: u,
    direction: d,
    isDropDisabled: A,
    isCombineEnabled: p,
    ignoreContainerClipping: h,
    getDroppableRef: w
  });
  var M = P.createElement(R_, {
    on: e.placeholder,
    shouldAnimate: e.shouldAnimatePlaceholder
  }, function(R) {
    var j = R.onClose, U = R.data, ee = R.animate;
    return P.createElement(B_, {
      placeholder: U,
      onClose: j,
      innerRef: C,
      animate: ee,
      contextId: r,
      onTransitionEnd: O
    });
  }), E = He(function() {
    return {
      innerRef: x,
      placeholder: M,
      droppableProps: {
        "data-rbd-droppable-id": s,
        "data-rbd-droppable-context-id": r
      }
    };
  }, [r, s, M, x]), N = g ? g.dragging.draggableId : null, F = He(function() {
    return {
      droppableId: s,
      type: c,
      isUsingCloneFor: N
    };
  }, [s, N, c]);
  function k() {
    if (!g)
      return null;
    var R = g.dragging, j = g.render, U = P.createElement(Cb, {
      draggableId: R.draggableId,
      index: R.source.index,
      isClone: !0,
      isEnabled: !0,
      shouldRespectForcePress: !1,
      canDragInteractiveElements: !0
    }, function(ee, X) {
      return j(ee, X, R);
    });
    return O7.createPortal(U, b());
  }
  return P.createElement(t9.Provider, {
    value: F
  }, o(E, v), k());
}
var B6 = function(t, r) {
  return t === r.droppable.type;
}, rh = function(t, r) {
  return r.draggables[t.draggable.id];
}, oR = function() {
  var t = {
    placeholder: null,
    shouldAnimatePlaceholder: !0,
    snapshot: {
      isDraggingOver: !1,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: !1
    },
    useClone: null
  }, r = be({}, t, {
    shouldAnimatePlaceholder: !1
  }), n = _t(function(o) {
    return {
      draggableId: o.id,
      type: o.type,
      source: {
        index: o.index,
        droppableId: o.droppableId
      }
    };
  }), a = _t(function(o, s, c, u, d, h) {
    var A = d.descriptor.id, p = d.descriptor.droppableId === o;
    if (p) {
      var v = h ? {
        render: h,
        dragging: n(d.descriptor)
      } : null, g = {
        isDraggingOver: c,
        draggingOverWith: c ? A : null,
        draggingFromThisWith: A,
        isUsingPlaceholder: !0
      };
      return {
        placeholder: d.placeholder,
        shouldAnimatePlaceholder: !1,
        snapshot: g,
        useClone: v
      };
    }
    if (!s)
      return r;
    if (!u)
      return t;
    var m = {
      isDraggingOver: c,
      draggingOverWith: A,
      draggingFromThisWith: null,
      isUsingPlaceholder: !0
    };
    return {
      placeholder: d.placeholder,
      shouldAnimatePlaceholder: !0,
      snapshot: m,
      useClone: null
    };
  }), i = function(s, c) {
    var u = c.droppableId, d = c.type, h = !c.isDropDisabled, A = c.renderClone;
    if (s.isDragging) {
      var p = s.critical;
      if (!B6(d, p))
        return r;
      var v = rh(p, s.dimensions), g = pr(s.impact) === u;
      return a(u, h, g, g, v, A);
    }
    if (s.phase === "DROP_ANIMATING") {
      var m = s.completed;
      if (!B6(d, m.critical))
        return r;
      var b = rh(m.critical, s.dimensions);
      return a(u, h, vb(m.result) === u, pr(m.impact) === u, b, A);
    }
    if (s.phase === "IDLE" && s.completed && !s.shouldFlush) {
      var w = s.completed;
      if (!B6(d, w.critical))
        return r;
      var x = pr(w.impact) === u, y = !!(w.impact.at && w.impact.at.type === "COMBINE"), C = w.critical.droppable.id === u;
      return x ? y ? t : r : C ? t : r;
    }
    return r;
  };
  return i;
}, sR = {
  updateViewportMaxScroll: eL
};
function lR() {
  return document.body || (process.env.NODE_ENV !== "production" ? K(!1, "document.body is not ready") : K(!1)), document.body;
}
var cR = {
  mode: "standard",
  type: "DEFAULT",
  direction: "vertical",
  isDropDisabled: !1,
  isCombineEnabled: !1,
  ignoreContainerClipping: !1,
  renderClone: null,
  getContainerForClone: lR
}, bb = CC(oR, sR, null, {
  context: K7,
  pure: !0,
  areStatePropsEqual: gb
})(iR);
bb.defaultProps = cR;
const yb = P.forwardRef((e, t) => {
  const {
    item: r,
    currentItem: n,
    resetCurrentItem: a
  } = e, i = wt(Ur), o = (i == null ? void 0 : i.isCollapsedMenu) ?? !1, s = (r == null ? void 0 : r.items) ?? [];
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: n !== null && n.id === r.id && s.length > 0 && /* @__PURE__ */ f.jsx("div", { ref: t, className: `my-[-50px] drop-shadow-xl rounded-md fixed left-12 z-[30] w-full m:max-w-[288px] bg-white
           ${o ? "m:left-[300px] l:left-[130px]" : "m:left-[288px]"} `, children: /* @__PURE__ */ f.jsxs("div", { className: "flex h-full flex-col", children: [
    /* @__PURE__ */ f.jsxs("div", { className: "flex items-center gap-4 justify-between p-4 border-b border-secondary-300 m:px-8", children: [
      /* @__PURE__ */ f.jsx("div", { className: "w-10 min-w-[40px] h-10 m:hidden", children: /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          onClick: a,
          className: "bg-secondary-300 hover:bg-secondary-400 w-full h-full flex items-center justify-center rounded-md text-Negros-900",
          children: /* @__PURE__ */ f.jsx(De, { variant: "back-arrow", width: 18 })
        }
      ) }),
      /* @__PURE__ */ f.jsx("div", { className: "flex-grow font-bold text-Negros-900 leading-[120%]", children: n.description }),
      /* @__PURE__ */ f.jsx("div", { className: "w-10 min-w-[40px] h-10 m:hidden", children: /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          onClick: i == null ? void 0 : i.closeMenu,
          className: "bg-secondary-300 hover:bg-secondary-400 w-full h-full flex items-center justify-center rounded-md text-secondary-600",
          children: /* @__PURE__ */ f.jsx(De, { variant: "close", width: 14 })
        }
      ) })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "flex-grow overflow-hidden px-4", children: /* @__PURE__ */ f.jsx("div", { className: "h-full max-h-[calc(100%-32px)] w-full max-w-[568px] my-4 mx-auto overflow-y-auto menu-subitems-scrollbar", children: /* @__PURE__ */ f.jsx("ul", { children: s.map((c) => /* @__PURE__ */ f.jsxs(
      "li",
      {
        className: "flex items-center px-4 py-2 font-bold text-Negros-900 cursor-pointer rounded-md hover:bg-Acento-50",
        onClick: () => {
          c.onClick !== void 0 && (c == null || c.onClick()), i == null || i.closeMenu(), a();
        },
        children: [
          /* @__PURE__ */ f.jsx(De, { variant: "arrow-right", width: 10 }),
          "  ",
          /* @__PURE__ */ f.jsx("span", { className: "ml-3", children: c.description })
        ]
      },
      c.id
    )) }) }) })
  ] }) }) });
});
yb.displayName = "MenuSubitems";
const wb = (e) => {
  const {
    idx: t,
    item: r,
    currentItem: n,
    changeCurrentItem: a,
    resetCurrentItem: i
  } = e, {
    id: o,
    icon: s,
    items: c,
    isActive: u,
    description: d,
    onClick: h = () => {
    }
  } = r, A = n !== null && n.id === r.id, p = c !== void 0, v = c ?? [], g = wt(Ur), m = (g == null ? void 0 : g.isCollapsedMenu) ?? !1, b = () => {
    window.innerWidth >= 1024 && a(r);
  }, w = () => {
    window.innerWidth >= 1024 && i();
  };
  return /* @__PURE__ */ f.jsx(aR, { draggableId: `${o}`, index: t, children: (x, y) => /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: x.innerRef,
      ...x.draggableProps,
      ...x.dragHandleProps,
      style: {
        cursor: "default",
        ...x.draggableProps.style
      },
      className: "select-none px-4",
      onMouseEnter: b,
      onMouseLeave: w,
      children: [
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            title: d,
            className: Ye([
              "min-h-[40px] py-2  flex items-center justify-between font-bold gap-2 cursor-pointer rounded-md px-2",
              A ? "bg-Acento-50" : u ? (y.isDragging, "bg-Acento-50") : y.isDragging ? "bg-secondary-800" : "bg-white-900"
            ]),
            onClick: () => {
              h(), a(r), p || g == null || g.closeMenu();
            },
            children: [
              /* @__PURE__ */ f.jsx("div", { className: "flex gap-2 items-center", children: /* @__PURE__ */ f.jsxs("div", { className: "flex gap-2 px-7 items-center leading-none capitalize", children: [
                /* @__PURE__ */ f.jsx("span", { className: "w-[30px] min-w-[30px]", children: /* @__PURE__ */ f.jsx(De, { variant: s, width: 30 }) }),
                /* @__PURE__ */ f.jsx("span", { className: `${m ? "block l:hidden" : "block"}`, children: d })
              ] }) }),
              p && v.length > 0 && /* @__PURE__ */ f.jsx("span", { className: "-rotate-90", children: /* @__PURE__ */ f.jsx(De, { variant: "arrow-down", width: 14 }) })
            ]
          }
        ),
        /* @__PURE__ */ f.jsx(
          yb,
          {
            item: r,
            currentItem: n,
            resetCurrentItem: i
          }
        )
      ]
    }
  ) }, o);
};
wb.displayName = "MenuItem";
const uR = ({ children: e, ...t }) => {
  const [r, n] = Ee(!1);
  return Ne(() => {
    const a = requestAnimationFrame(() => n(!0));
    return () => {
      cancelAnimationFrame(a), n(!1);
    };
  }, []), r ? /* @__PURE__ */ f.jsx(bb, { ...t, children: e }) : null;
}, dR = (e, t, r) => {
  const n = Array.from(e), [a] = n.splice(t, 1);
  return n.splice(r, 0, a), n;
}, fR = P.forwardRef((e, t) => {
  const {
    className: r,
    items: n,
    activeHome: a,
    labelHome: i = "Inicio",
    onClickHome: o = () => {
    },
    onMenuDragged: s = () => {
    },
    ...c
  } = e, [u, d] = Ee(n), [h, A] = Ee(null), p = wt(Ur), v = (p == null ? void 0 : p.isOpenMenu) ?? !1, g = (p == null ? void 0 : p.isCollapsedMenu) ?? !1, m = (x) => {
    A(x);
  }, b = () => {
    A(null);
  }, w = ({ source: x, destination: y }) => {
    if (y == null)
      return;
    const C = dR(
      u,
      x.index,
      y.index
    );
    s({
      _newItems: C,
      item: {
        payload: C[y.index],
        indexes: {
          previous: x.index,
          new: y.index
        }
      }
    }), d(C);
  };
  return Ne(() => {
    v || A(null);
  }, [v]), Ne(() => {
    d(n);
  }, [n]), /* @__PURE__ */ f.jsxs(
    "ul",
    {
      ref: t,
      className: Ye(["flex flex-col text-black select-none", r]),
      ...c,
      children: [
        /* @__PURE__ */ f.jsx("li", { className: "h-10 px-4 ", children: /* @__PURE__ */ f.jsx(
          "div",
          {
            className: "h-full flex gap-2 items-center justify-between font-bold cursor-pointer rounded-md pl-2 l:pl-[36px] pr-2",
            title: i,
            onClick: () => {
              o(), p == null || p.closeMenu();
            },
            children: /* @__PURE__ */ f.jsxs("div", { className: "flex gap-2 items-center ", children: [
              /* @__PURE__ */ f.jsx(De, { variant: "home", width: 30 }),
              /* @__PURE__ */ f.jsx("span", { className: `${g ? "block l:hidden" : "block"}`, children: i })
            ] })
          }
        ) }),
        /* @__PURE__ */ f.jsx(A_, { onDragEnd: w, children: /* @__PURE__ */ f.jsx(uR, { droppableId: "droppable", children: (x) => /* @__PURE__ */ f.jsxs(
          "div",
          {
            ...x.droppableProps,
            ref: x.innerRef,
            children: [
              u.map((y, C) => /* @__PURE__ */ f.jsx(
                wb,
                {
                  idx: C,
                  item: y,
                  currentItem: h,
                  changeCurrentItem: m,
                  resetCurrentItem: b
                },
                y.id
              )),
              x.placeholder
            ]
          }
        ) }) })
      ]
    }
  );
});
fR.displayName = "MenuItems";
const hR = P.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e, a = wt(Ur), i = (a == null ? void 0 : a.isOpenMenu) ?? !1, o = (a == null ? void 0 : a.isCollapsedMenu) ?? !1;
  return /* @__PURE__ */ f.jsx("aside", { ref: t, ...n, className: `fixed z-[1000] w-full  top-0 bottom-[4.5rem] 2s:bottom-0 2s:top-[4.5rem] l:top-[5rem] ${i ? "left-0" : "-left-[100vw] m:-left-[288px] l:left-0"} ${o ? "m:max-w-[288px] l:max-w-[130px]" : "m:max-w-[288px]"}`, children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col h-full w-full", children: [
    /* @__PURE__ */ f.jsx("div", { className: "flex-grow max-h-[calc(100%-72px-56px-32px)] l:max-h-[calc(100%-56px-56px-32px)] w-full max-w-[600px] my-4 mx-auto", children: /* @__PURE__ */ f.jsx("div", { className: "h-4/5 overflow-y-auto menu-wrapper-scrollbar", children: /* @__PURE__ */ f.jsx("div", { className: "flex flex-col gap-4", children: r }) }) }),
    /* @__PURE__ */ f.jsxs("div", { className: "flex l:hidden items-center justify-between px-4 h-[72px] text-white border-b border-secondary-850", children: [
      /* @__PURE__ */ f.jsx(Ri, { variant: "heading-6", children: "Menú" }),
      /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          onClick: a == null ? void 0 : a.closeMenu,
          className: "w-10 aspect-square bg-secondary-850 hover:bg-secondary-600 rounded-md flex justify-center items-center",
          children: /* @__PURE__ */ f.jsx(De, { variant: "close", width: 14 })
        }
      )
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "hidden l:flex items-center  px-4 h-[56px] text-black font-bold  border-secondary-850", children: /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        onClick: a == null ? void 0 : a.toggleCollapsedMenu,
        className: "w-10 pl-12 aspect-square  rounded-md flex justify-center items-center ",
        children: /* @__PURE__ */ f.jsx("span", { className: `${o ? "-rotate-180" : ""}`, children: /* @__PURE__ */ f.jsx(De, { variant: "right-arrow", width: 40 }) })
      }
    ) })
  ] }) });
});
hR.displayName = "MenuWrapper";
const AR = P.forwardRef((e, t) => {
  const {
    size: r = "xl",
    isTop: n = !1,
    isOpen: a,
    children: i
  } = e, o = {
    sm: "px-4 max-w-[calc(474px+32px)]",
    xl: "px-0 2s:px-4 w-full 2s:max-w-[calc(944px+32px)]"
  };
  return Ne(() => {
    if (!n)
      return a ? document.body.classList.add("overflow-y-hidden-modal") : document.body.classList.remove("overflow-y-hidden-modal"), () => {
        document.body.classList.remove("overflow-y-hidden-modal");
      };
  }, [a]), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `
        fixed overflow-x-hidden overflow-y-auto modal-scrollbar
        ${n ? "z-[1710]" : "z-[1700]"}
        ${r === "xl" ? "bg-white 2s:bg-[rgba(3,56,108,0.6)] left-0 top-0 bottom-[4.5rem] 2s:bottom-0" : "bg-[rgba(3,56,108,0.6)] inset-0"}
        ${a ? "visible w-full" : "invisible w-0 h-0"}
      `,
      children: /* @__PURE__ */ f.jsx("div", { className: `flex ${r === "xl" ? "items-start 2s:items-center" : "items-center"} ${r === "xl" ? "my-0 2s:my-[28px]" : "my-[28px]"} mx-auto ${r === "xl" ? "min-h-full 2s:min-h-[calc(100%-56px)]" : "min-h-[calc(100%-56px)]"} w-full relative ${o[r]}`, children: /* @__PURE__ */ f.jsx("div", { className: `bg-white rounded-lg relative w-full ${a ? "scale-[1] transition-all" : "scale-[0.9]"}`, children: i }) })
    }
  );
});
AR.displayName = "Modal";
const pR = P.forwardRef((e, t) => {
  const {
    size: r = "sm",
    children: n
  } = e, a = {
    sm: "p-4 s:p-8",
    xl: "p-4 2s:p-12"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: a[r],
      children: n
    }
  );
});
pR.displayName = "ModalBody";
const gR = P.forwardRef((e, t) => {
  const {
    isOpen: r,
    children: n
  } = e;
  return Ne(() => (r ? document.body.classList.add("overflow-y-hidden-modal") : document.body.classList.remove("overflow-y-hidden-modal"), () => {
    document.body.classList.remove("overflow-y-hidden-modal");
  }), [r]), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `
        fixed z-[900] l:z-[1500] left-0 top-0 bottom-[4.5rem] 2s:bottom-0 2s:top-[4.5rem] l:top-[5rem] overflow-x-hidden overflow-y-auto modal-focus-scrollbar bg-white
        ${r ? "visible w-full" : "invisible w-0 h-0"}
      `,
      children: /* @__PURE__ */ f.jsx("div", { className: "flex mx-autom mb-[80px] min-h-[calc(100%-80px)] w-full relative", children: /* @__PURE__ */ f.jsx("div", { className: `relative w-full ${r ? "scale-[1] transition-all" : "scale-[0.9]"}`, children: n }) })
    }
  );
});
gR.displayName = "ModalFocus";
const vR = P.forwardRef((e, t) => {
  const {
    size: r = "xl",
    children: n
  } = e, a = {
    xl: "p-4 2s:p-8"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `${a[r]} border-b border-neutral-200`,
      children: n
    }
  );
});
vR.displayName = "ModalHeader";
const mR = P.forwardRef((e, t) => {
  const {
    size: r = "xl",
    children: n
  } = e, a = {
    xl: "p-4 2s:px-8 2s:pt-8 2s:pb-16"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `${a[r]} border-t border-neutral-200`,
      children: n
    }
  );
});
mR.displayName = "ModalFooter";
const CR = P.forwardRef((e, t) => {
  const {
    children: r
  } = e;
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: "w-full max-w-[1300px] mx-auto", children: r });
});
CR.displayName = "ModalFocusContainer";
const bR = P.forwardRef((e, t) => {
  const {
    variant: r,
    children: n,
    srcBgImage: a,
    className: i,
    ...o
  } = e, s = {
    login: "relative ",
    "password-recovery": "relative",
    "change-password": "relative"
  }, c = {
    login: "bg-image  m:min-h-[100vh]",
    "password-recovery": "bg-image  m:min-h-[100vh]",
    "change-password": "bg-image  m:min-h-[100vh]"
  }, u = {
    login: "m:grid m:grid-cols-2",
    "password-recovery": "m:grid m:grid-cols-2",
    "change-password": "m:grid m:grid-cols-2"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: Ye([s[r], i]),
      ...o,
      children: /* @__PURE__ */ f.jsxs("div", { className: u[r], children: [
        n,
        /* @__PURE__ */ f.jsx(
          "div",
          {
            className: c[r],
            style: { backgroundImage: `url(${a})` }
          }
        ),
        /* @__PURE__ */ f.jsx("footer", { ref: t, className: " m:absolute m:border-0", ...o, children: /* @__PURE__ */ f.jsx("div", { className: "brand p-4 flex justify-center", children: /* @__PURE__ */ f.jsx(oI, {}) }) })
      ] })
    }
  );
});
bR.displayName = "Spreen";
const yR = P.forwardRef((e, t) => {
  const {
    variant: r,
    children: n,
    className: a,
    isSuccessPasswordRecovery: i = !1,
    ...o
  } = e, s = {
    login: "my-[2rem]  m:px-[16rem] grid gap-[2rem]",
    "password-recovery": "my-[10rem] l:px-[12rem] m:px-[8rem] grid gap-[2rem] s:px-[10rem]",
    "change-password": "my-[6rem] xl:px-[16rem]  m:px-[4rem]  grid gap-[2rem]"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: Ye([s[r], a]),
      ...o,
      children: n
    }
  );
});
yR.displayName = "SpreenBody";
const wR = P.forwardRef((e, t) => {
  const {
    children: r,
    className: n,
    ...a
  } = e;
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: Ye([" py-[4rem] text-center", n]),
      ...a,
      children: r
    }
  );
});
wR.displayName = "SpreenFooter";
const xR = P.forwardRef((e, t) => {
  const {
    children: r,
    className: n,
    ...a
  } = e;
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      className: Ye(["bg-white m:rounded-l-lg", n]),
      ...a,
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "m:pt-[10rem] m:pb-[1rem] flex justify-center", id: "CastorLogo", children: /* @__PURE__ */ f.jsx(aC, {}) }),
        r
      ]
    }
  );
});
xR.displayName = "SpreenLeft";
const DR = P.forwardRef((e, t) => {
  const {
    children: r,
    className: n,
    ...a
  } = e;
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: Ye(["bg-secondary-800 text-white py-[2rem] px-[1rem] m:px-[2rem] m:rounded-r-lg", n]),
      ...a,
      children: r
    }
  );
});
DR.displayName = "SpreenRight";
const OR = P.forwardRef((e, t) => {
  const {
    variant: r,
    children: n,
    className: a,
    ...i
  } = e, o = {
    "password-recovery": "",
    "change-password": ""
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      className: Ye([o[r], a]),
      ...i,
      children: [
        n,
        /* @__PURE__ */ f.jsx("div", { className: "flex justify-center pb-10", children: /* @__PURE__ */ f.jsx(aC, { width: 200 }) })
      ]
    }
  );
});
OR.displayName = "SpreenHeader";
const r9 = P.forwardRef((e, t) => {
  const {
    gap: r,
    gapY: n,
    gapX: a,
    bg: i,
    rounded: o,
    columns: s,
    columnsVariant: c,
    spacing: u,
    alignItems: d,
    justifyItems: h,
    responsiveColumns: A,
    children: p,
    className: v,
    ...g
  } = e, m = {
    gridTemplateColumns: c === void 0 && s !== void 0 ? `repeat(${s}, 1fr)` : void 0,
    backgroundColor: i !== void 0 ? gt[i] : void 0,
    borderRadius: o !== void 0 ? eC[o] : void 0,
    padding: u !== void 0 ? `${u / 4}rem` : void 0,
    justifyItems: h,
    alignItems: d
  };
  r !== void 0 ? m.gap = r !== void 0 ? `${r / 4}rem` : void 0 : (m.columnGap = a !== void 0 ? `${a / 4}rem` : void 0, m.rowGap = n !== void 0 ? `${n / 4}rem` : void 0);
  const b = {
    "form-4": "grid-cols-1 2s:grid-cols-2 l:grid-cols-4 gap-x-4 gap-y-8 label-form-4",
    "form-2": "grid-cols-1 2s:grid-cols-2 gap-x-4 gap-y-8 label-form-2"
  };
  A !== void 0 && Object.entries(A).forEach(([x, y]) => {
    const C = `--ck-cols-${x}`;
    typeof y == "number" && (m[C] = `repeat(${y},1fr)`), typeof y == "string" && (m[C] = y);
  });
  const w = {
    initial: "grid-cols-[var(--ck-cols-initial)]",
    small: "s:grid-cols-[var(--ck-cols-small)]",
    extraSmall: "2s:grid-cols-[var(--ck-cols-extraSmall)]",
    medium: "m:grid-cols-[var(--ck-cols-medium)]",
    large: "l:grid-cols-[var(--ck-cols-large)]",
    extraLarge: "xl:grid-cols-[var(--ck-cols-extraLarge)]"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: Ye([
        "grid",
        c !== void 0 ? b[c] : void 0,
        A !== void 0 ? `${Object.keys(A).map((x) => w[x]).join(" ")}` : void 0
      ]),
      style: m,
      ...g,
      children: p
    }
  );
});
r9.displayName = "Stack";
const MR = P.forwardRef((e, t) => {
  const {
    responsiveColSpan: r,
    showDesktopOnly: n,
    forceWidth: a = !1,
    children: i,
    ...o
  } = e, s = {};
  r !== void 0 && Object.entries(r).forEach(([u, d]) => {
    if (typeof d == "number") {
      const h = `--ck-col-span-${u}`;
      s[h] = `span ${d} / span ${d}`;
    }
  });
  const c = {
    initial: "col-[var(--ck-col-span-initial)]",
    small: "s:col-[var(--ck-col-span-small)]",
    extraSmall: "2s:col-[var(--ck-col-span-extraSmall)]",
    medium: "m:col-[var(--ck-col-span-medium)]",
    large: "l:col-[var(--ck-col-span-large)]",
    extraLarge: "xl:col-[var(--ck-col-span-extraLarge)]"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      style: s,
      className: Ye([
        `${n === !0 ? "hidden m:block" : "block"} ${a ? "max-w-full overflow-x-hidden" : ""}`,
        r !== void 0 ? `${Object.keys(r).map((u) => c[u]).join(" ")}` : void 0
      ]),
      ...o,
      children: i
    }
  );
});
MR.displayName = "StackRow";
const ER = P.forwardRef((e, t) => {
  const {
    children: r,
    className: n
  } = e;
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: Ye(["bg-secondary-100 flex items-center justify-center p-5 rounded-md min-h-[70vh]", n]), children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col items-center justify-center w-full max-w-[300px] gap-4 text-center", children: [
    /* @__PURE__ */ f.jsx("div", { className: "flex justify-center select-none", children: /* @__PURE__ */ f.jsx(
      "svg",
      {
        width: 90,
        height: 101,
        viewBox: "0 0 90 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_49432)", children: [
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M89.9844 52.4766C89.8853 51.6849 89.314 51.0339 88.5418 50.8307L80.2566 48.6484L86.6766 41.5833C87.0783 41.1406 87.2531 40.5417 87.1566 39.9531C87.0601 39.3646 86.7001 38.8542 86.1783 38.5625L62.2618 25.276C61.3644 23.6068 60.2166 22.0573 58.834 20.6823C55.1401 16.9922 50.2253 14.9609 45.0001 14.9609C39.7748 14.9609 34.8601 16.9922 31.1661 20.6823C29.7731 22.0729 28.6357 23.6224 27.7514 25.2708L3.82441 38.5651C3.30267 38.8542 2.94267 39.3672 2.84614 39.9557C2.74962 40.5443 2.92701 41.1432 3.32875 41.5859L9.74615 48.651L1.45832 50.8333C0.686145 51.0365 0.11484 51.6875 0.0157101 52.4792C-0.0834204 53.2708 0.307884 54.0417 1.00701 54.4297L11.4027 60.2057V80.974C11.4027 81.6823 11.7888 82.3359 12.407 82.6797L44.0505 100.258C44.3479 100.422 44.674 100.505 45.0027 100.505C45.3314 100.505 45.6601 100.424 45.9548 100.258L77.5983 82.6797C78.2192 82.3359 78.6027 81.6823 78.6027 80.974V60.2057L88.9983 54.4297C89.6948 54.0417 90.0888 53.2708 89.987 52.4792L89.9844 52.4766ZM82.1192 40.7839L76.2366 47.2578L63.694 40.2917C64.2679 38.4401 64.5653 36.4896 64.5653 34.4974C64.5653 33.2578 64.4505 32.0365 64.2261 30.8438L82.1218 40.7839H82.1192ZM33.9314 23.4479C36.887 20.4974 40.8183 18.8724 45.0001 18.8724C49.1818 18.8724 53.1105 20.4974 56.0688 23.4479C59.027 26.3984 60.6522 30.3229 60.6522 34.4974C60.6522 38.6719 59.0244 42.5938 56.0688 45.5469C54.0235 47.5885 51.4644 49.0208 48.6653 49.6901C48.1435 49.8151 47.6948 50.1484 47.4261 50.612L45.0001 54.8099C44.1914 53.4089 43.3827 52.0104 42.574 50.612C42.3053 50.1484 41.8566 49.8151 41.3348 49.6875C38.5383 49.0182 35.9792 47.5859 33.934 45.5443C27.8322 39.4531 27.8322 29.5391 33.934 23.4479H33.9314ZM7.88093 40.7839L25.7896 30.8359C25.1948 33.9714 25.3696 37.2214 26.3192 40.2865L13.7661 47.2604L7.88354 40.7865L7.88093 40.7839ZM13.0957 51.8073L20.5331 55.9401C20.8357 56.1068 21.1618 56.1875 21.4827 56.1875C22.1714 56.1875 22.8366 55.8255 23.194 55.1823C23.7209 54.2396 23.3792 53.0495 22.4348 52.526L17.3818 49.7188L27.8531 43.9036C28.7218 45.4844 29.8279 46.9688 31.1661 48.3073C33.5192 50.6563 36.4148 52.3594 39.5922 53.2682C40.4348 54.7266 41.2774 56.1849 42.1227 57.6458C42.7253 58.6823 43.7975 59.2995 44.9975 59.2995H45.0235C46.2131 59.2917 47.3114 58.6484 47.8957 57.6172L50.4105 53.2682C53.5853 52.3568 56.4835 50.6536 58.8366 48.3073C60.1618 46.9818 61.2757 45.5026 62.1575 43.9063L72.6209 49.7188L45.0027 65.0599L37.8261 61.0729C36.8818 60.5495 35.6896 60.888 35.1653 61.8307C34.6383 62.7734 34.9801 63.9635 35.9244 64.487L39.8061 66.6432L33.8661 68.2057L7.15571 53.3672L13.0957 51.8047V51.8073ZM15.3157 62.375L32.6505 72.0052C33.0914 72.25 33.6105 72.3151 34.1009 72.1875L43.0461 69.8333V95.2266L15.3157 79.8229V62.3776V62.375ZM74.687 79.8203L46.9566 95.224V69.8307L55.9018 72.1849C56.0661 72.2266 56.2331 72.25 56.4001 72.25C56.7314 72.25 57.0574 72.1667 57.3496 72.0026L74.6844 62.3724V79.8177L74.687 79.8203ZM56.1392 68.2083L50.1992 66.6432L76.907 51.8073L82.847 53.3698L56.1392 68.2083Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M35.2173 36.7422C36.2973 36.7422 37.1738 35.8672 37.1738 34.7891C37.1738 33.7109 36.2973 32.8359 35.2173 32.8359C34.1373 32.8359 33.2607 33.7109 33.2607 34.7891C33.2607 35.8672 34.1373 36.7422 35.2173 36.7422Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M45 36.7422C46.08 36.7422 46.9565 35.8672 46.9565 34.7891C46.9565 33.7109 46.08 32.8359 45 32.8359C43.92 32.8359 43.0435 33.7109 43.0435 34.7891C43.0435 35.8672 43.92 36.7422 45 36.7422Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M54.7827 36.7422C55.8627 36.7422 56.7392 35.8672 56.7392 34.7891C56.7392 33.7109 55.8627 32.8359 54.7827 32.8359C53.7027 32.8359 52.8262 33.7109 52.8262 34.7891C52.8262 35.8672 53.7027 36.7422 54.7827 36.7422Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M45 8.89844C46.08 8.89844 46.9565 8.02344 46.9565 6.94531V2.45312C46.9565 1.375 46.08 0.5 45 0.5C43.92 0.5 43.0435 1.375 43.0435 2.45312V6.94531C43.0435 8.02344 43.92 8.89844 45 8.89844Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M33.0573 10.6639C33.4199 11.2915 34.0773 11.6405 34.7529 11.6405C35.0842 11.6405 35.4207 11.5571 35.7286 11.38C36.6651 10.841 36.9859 9.64566 36.4459 8.71077L34.1973 4.82014C33.6573 3.88525 32.4599 3.56494 31.5259 4.104C30.5894 4.64306 30.2686 5.83837 30.8086 6.77327L33.0573 10.6639Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M54.2685 11.3776C54.5764 11.5547 54.9129 11.638 55.2468 11.638C55.9225 11.638 56.5799 11.2891 56.9425 10.6615L59.1912 6.77083C59.7312 5.83593 59.4103 4.64062 58.4738 4.10156C57.5372 3.56249 56.3425 3.88281 55.8025 4.8177L53.5538 8.70833C53.0138 9.64322 53.3346 10.8359 54.2685 11.3776Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M29.1782 56.5547C28.0982 56.5547 27.2217 57.4297 27.2217 58.5078C27.2217 59.5859 28.0982 60.4609 29.1782 60.4609C30.2582 60.4609 31.1347 59.5885 31.1347 58.5078C31.1347 57.4271 30.2582 56.5547 29.1782 56.5547Z",
              fill: "#2875B4"
            }
          )
        ] })
      }
    ) }),
    r
  ] }) });
});
ER.displayName = "TableEmpty";
const SR = P.forwardRef((e, t) => {
  const {
    children: r,
    className: n
  } = e;
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: Ye(["pt-4 px-4 border-t border-neutral-300 m:border-none", n]), children: /* @__PURE__ */ f.jsx("div", { className: "flex flex-col-reverse m:flex-row m:justify-between flex-wrap gap-4", children: r }) });
});
SR.displayName = "TableFooter";
const PR = (e) => {
  const {
    idSearch: t,
    placeholder: r,
    minLengthToSearch: n = 5,
    onSearch: a,
    onClickRefresh: i
  } = e, [o, s] = Ee(""), c = Ce(!0), u = nC(o), d = (p) => {
    const v = p.target.value;
    v.startsWith(" ") || s(v);
  }, h = () => {
    s(""), a !== void 0 && a({
      value: "",
      canSearch: !1
    });
  };
  Ne(() => {
    if (c.current) {
      c.current = !1;
      return;
    }
    a !== void 0 && (u.trim().length >= n ? a({
      value: u.trim(),
      canSearch: !0
    }) : a({
      value: u.trim(),
      canSearch: !1
    }));
  }, [u]);
  const A = () => {
    i !== void 0 && (h(), i());
  };
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ f.jsx(
      "input",
      {
        type: "text",
        id: t,
        placeholder: r,
        value: o,
        onChange: d,
        className: "w-full h-full px-3 bg-transparent text-neutral-600 placeholder:text-neutral-400 outline-none shadow-transparent",
        style: { textTransform: "none" }
      }
    ) }),
    o.trim().length >= n ? /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        onClick: h,
        className: "w-[48px] min-w-[48px] flex items-center justify-center border-l border-neutral-300 cursor-pointer",
        children: /* @__PURE__ */ f.jsx(De, { variant: "close", width: 14 })
      }
    ) : /* @__PURE__ */ f.jsx("label", { htmlFor: t, className: "w-[48px] min-w-[48px] flex items-center justify-center border-l border-neutral-300 cursor-pointer", children: /* @__PURE__ */ f.jsx(De, { variant: "search", width: 20 }) }),
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        onClick: A,
        className: "w-[48px] min-w-[48px] flex items-center justify-center border-l border-neutral-300 cursor-pointer",
        children: /* @__PURE__ */ f.jsx(De, { variant: "refresh-circle", width: 18 })
      }
    )
  ] });
}, jR = P.forwardRef((e, t) => {
  const {
    search: r,
    consult: n,
    selectFilter: a,
    permissions: i,
    onClickExport: o,
    onClickReports: s,
    onClickRefresh: c
  } = e, {
    placeholder: u = "Search...",
    minLengthToSearch: d = 5,
    onSearch: h
  } = r, A = D7(), p = (n == null ? void 0 : n.filled) ?? 0, v = () => {
    (n == null ? void 0 : n.onClick) !== void 0 && n.onClick();
  }, g = () => {
    (n == null ? void 0 : n.onReset) !== void 0 && n.onReset();
  }, m = () => {
    s !== void 0 && s();
  }, b = () => {
    o !== void 0 && o();
  }, w = Object.values(i).reduce((x, y) => y ? x + 1 : x, 0);
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: "border-b border-neutral-300 m:border-none px-4 pt-4", children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col m:flex-row m:justify-between gap-4", children: [
    /* @__PURE__ */ f.jsx("div", { className: "flex flex-grow gap-2", children: /* @__PURE__ */ f.jsxs("div", { className: "flex m:flex-grow m:max-w-[800px] justify-between h-[40px] border border-neutral-300 rounded-md bg-neutral-200 w-[100%]", children: [
      /* @__PURE__ */ f.jsx("div", { className: "w-[110px] min-w-[110px] s:w-[140px] s:min-w-[140px] 2s:min-w-[30%] relative h-full border-r border-neutral-300", children: a }),
      /* @__PURE__ */ f.jsx(
        PR,
        {
          idSearch: A,
          placeholder: u,
          minLengthToSearch: d,
          onSearch: h,
          onClickRefresh: c
        }
      )
    ] }) }),
    w > 0 && /* @__PURE__ */ f.jsx("div", { className: "flex flex-col m:flex-row gap-4", children: /* @__PURE__ */ f.jsxs("div", { className: `grid ${w < 2 ? "grid-cols-1" : "grid-table-main-header"} m:flex gap-4`, children: [
      i.consult && /* @__PURE__ */ f.jsxs("div", { className: "relative", children: [
        /* @__PURE__ */ f.jsx(
          "button",
          {
            type: "button",
            onClick: v,
            className: `h-10 w-full bg-secondary-100 text-secondary-600 hover:bg-secondary-200 font-bold flex gap-4 items-center rounded-md border ${p > 0 ? "justify-center s:justify-between pl-4 pr-4 s:pr-[4.5rem] border-secondary-600" : "justify-center px-4 border-transparent"}`,
            children: /* @__PURE__ */ f.jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ f.jsx("span", { className: "w-[20px] min-w-[20px]", children: /* @__PURE__ */ f.jsx(De, { variant: "filter" }) }),
              /* @__PURE__ */ f.jsx("span", { children: "Consulta" })
            ] })
          }
        ),
        p > 0 && /* @__PURE__ */ f.jsxs("div", { className: "absolute top-1/2 -translate-y-1/2 right-4 hidden s:flex items-center gap-2 z-[1] pointer-events-none font-bold", children: [
          /* @__PURE__ */ f.jsx("span", { className: "flex w-5 h-5 rounded-full bg-secondary-600 text-white text-xs items-center justify-center", children: p }),
          /* @__PURE__ */ f.jsx(
            "span",
            {
              onClick: g,
              className: "w-[14px] min-w-[14px] hover:scale-110 active:scale-95 pointer-events-auto cursor-pointer text-secondary-600",
              children: /* @__PURE__ */ f.jsx(De, { variant: "close", width: 14 })
            }
          )
        ] })
      ] }),
      i.reports && /* @__PURE__ */ f.jsx("div", { className: "m:w-[215px]", children: /* @__PURE__ */ f.jsx(Qr, { variant: "secondary", size: "m", isFull: !0, onClick: m, children: /* @__PURE__ */ f.jsx("span", { className: `block ${w > 1 ? "w-[35vw] m:w-auto text-ellipsis overflow-hidden whitespace-nowrap h-[30px] leading-[30px]" : "whitespace-nowrap"}`, children: "Reportes programados" }) }) }),
      i.export && /* @__PURE__ */ f.jsx("div", { className: "m:min-w-[140px]", children: /* @__PURE__ */ f.jsx(Qr, { variant: "secondary-bold", size: "m", isFull: !0, onClick: b, children: "Exportar" }) })
    ] }) })
  ] }) });
});
jR.displayName = "TableHeaderDeclarant";
const IR = P.forwardRef((e, t) => {
  const {
    text: r = "Cargando...",
    className: n
  } = e;
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: Ye(["bg-secondary-100 flex items-center justify-center p-5 rounded-md min-h-[70vh] select-none", n]), children: /* @__PURE__ */ f.jsxs("div", { className: "text-center animate-pulse", children: [
    /* @__PURE__ */ f.jsx("div", { className: "bg-white flex justify-center items-center w-[64px] h-[64px] rounded-md mb-4", children: /* @__PURE__ */ f.jsx(
      "svg",
      {
        version: "1.0",
        xmlns: "http://www.w3.org/2000/svg",
        width: "352.000000pt",
        height: "374.000000pt",
        viewBox: "0 0 352.000000 374.000000",
        preserveAspectRatio: "xMidYMid meet",
        children: /* @__PURE__ */ f.jsxs(
          "g",
          {
            transform: "translate(0.000000,374.000000) scale(0.100000,-0.100000)",
            fill: "#000000",
            stroke: "none",
            children: [
              /* @__PURE__ */ f.jsx("path", { d: `M2115 3189 c-27 -6 -63 -16 -80 -23 -16 -8 -47 -19 -67 -25 -20 -7\r
          -42 -19 -48 -27 -7 -7 -18 -14 -25 -14 -31 0 -190 -169 -231 -245 -35 -64\r
          -142 -272 -177 -340 -22 -44 -44 -81 -49 -83 -4 -2 -8 -9 -8 -15 0 -7 -13 -40\r
          -30 -73 -16 -33 -34 -72 -40 -85 -5 -13 -14 -31 -20 -39 -5 -8 -21 -42 -36\r
          -75 -14 -33 -38 -87 -53 -120 -15 -33 -34 -76 -41 -95 -8 -19 -16 -37 -20 -40\r
          -3 -3 -14 -30 -24 -60 -11 -30 -22 -57 -26 -60 -3 -3 -14 -33 -25 -67 -10 -35\r
          -21 -63 -25 -63 -3 0 -12 -22 -19 -48 -6 -26 -19 -61 -27 -78 -9 -16 -23 -51\r
          -31 -79 -8 -27 -19 -54 -23 -60 -14 -18 -32 -126 -33 -206 -2 -83 -12 -97 -46\r
          -64 -35 34 -96 67 -149 80 -66 18 -181 19 -236 4 -42 -12 -92 -57 -107 -97\r
          -12 -32 -11 -159 2 -204 21 -77 127 -158 207 -158 13 0 41 -4 61 -9 20 -5 61\r
          -14 90 -21 79 -15 138 -48 164 -89 45 -74 106 -113 203 -130 32 -6 70 -14 84\r
          -18 14 -4 88 -7 165 -8 77 0 146 -4 154 -9 21 -14 672 -12 696 2 13 7 17 14\r
          10 20 -19 18 -110 62 -127 62 -10 0 -18 5 -18 11 0 7 25 10 73 9 97 -4 110 -2\r
          131 13 17 13 15 16 -26 39 -24 15 -72 32 -106 39 -34 7 -62 16 -62 21 0 4 38\r
          46 84 93 72 73 146 164 146 181 0 3 13 33 29 67 15 34 34 87 41 117 7 30 16\r
          60 20 65 10 12 40 199 40 244 0 17 4 39 9 49 5 9 13 91 18 182 9 163 9 165 41\r
          212 37 54 128 138 148 138 8 0 14 4 14 10 0 13 95 40 141 40 21 0 41 5 44 10\r
          3 6 15 10 27 10 26 0 78 56 78 84 0 22 -51 86 -69 86 -5 0 -17 8 -27 18 -15\r
          14 -37 17 -151 17 -132 0 -133 0 -133 22 0 16 -9 27 -27 35 -31 13 -63 38 -63\r
          48 0 15 96 47 191 64 35 6 59 35 59 71 0 8 19 27 43 42 23 15 50 36 59 47 19\r
          23 24 76 8 76 -5 0 -10 22 -10 49 0 28 5 53 10 56 26 16 -6 76 -47 89 -11 3\r
          -42 32 -69 62 -82 95 -179 162 -299 207 -121 45 -242 57 -360 36z m350 -77\r
          c117 -39 180 -73 248 -133 65 -58 74 -77 52 -119 -14 -27 -14 -33 1 -62 9 -17\r
          26 -39 38 -49 17 -14 21 -28 21 -80 l0 -64 -40 -21 c-22 -13 -53 -23 -70 -25\r
          -30 -2 -30 -2 5 -8 64 -11 47 -66 -24 -76 -11 -2 -47 -13 -78 -24 -32 -12 -66\r
          -21 -77 -21 -11 0 -23 -5 -27 -11 -4 -7 -24 -9 -54 -6 -29 4 -66 0 -95 -9 -27\r
          -8 -75 -14 -107 -14 -41 0 -78 -8 -120 -26 -34 -14 -72 -24 -86 -21 l-24 5 25\r
          -26 c30 -30 109 -41 172 -23 21 6 40 9 42 8 1 -2 5 -37 9 -78 4 -41 11 -80 17\r
          -87 11 -14 2 -23 -78 -74 -67 -42 -116 -73 -167 -105 -24 -14 -55 -34 -69 -44\r
          -78 -53 -134 -74 -196 -74 -46 0 -67 5 -82 19 -12 11 -21 15 -21 10 0 -5 9\r
          -15 21 -22 24 -15 21 -41 -10 -102 -10 -19 -24 -53 -31 -75 -7 -22 -16 -44\r
          -20 -50 -14 -19 -19 -60 -13 -98 5 -34 8 -38 29 -33 19 5 24 2 24 -12 0 -10 4\r
          -22 9 -28 4 -5 16 -44 26 -86 10 -43 21 -78 24 -78 4 0 13 -15 19 -34 11 -30\r
          51 -88 122 -176 l20 -25 0 51 c0 29 6 58 15 70 11 15 13 36 8 91 -6 76 1 88\r
          31 57 15 -14 16 -7 16 81 l0 97 25 -6 c22 -6 25 -2 30 31 11 71 41 96 51 44 8\r
          -40 20 -32 28 19 3 23 20 66 36 97 53 100 70 108 70 33 0 -27 5 -50 10 -50 6\r
          0 10 9 10 20 0 11 5 20 10 20 6 0 10 10 10 23 0 29 19 57 27 40 11 -28 21 -9\r
          38 69 10 46 21 89 26 98 4 8 15 39 24 68 9 28 21 52 26 52 5 0 9 6 9 13 0 6\r
          18 33 40 58 51 60 131 101 201 103 l54 1 3 -51 c3 -44 -1 -54 -23 -75 -109\r
          -101 -136 -136 -171 -215 -20 -46 -27 -87 -40 -242 -8 -103 -19 -196 -24 -207\r
          -4 -11 -13 -73 -19 -139 -10 -118 -23 -158 -45 -136 -8 8 -14 -3 -21 -41 -10\r
          -53 -30 -75 -38 -42 -2 13 -7 7 -13 -17 -13 -44 -34 -45 -48 -3 -18 52 -26 49\r
          -26 -10 0 -56 -16 -78 -27 -37 -3 11 -9 20 -13 20 -5 0 -10 8 -12 18 -3 9 -8\r
          -34 -12 -97 -7 -92 -11 -114 -25 -118 -9 -2 -29 -31 -45 -64 -82 -169 -164\r
          -209 -433 -209 l-153 0 0 -35 c0 -29 -4 -36 -26 -41 -37 -9 -287 2 -310 14\r
          -11 5 -37 15 -59 22 -63 20 -135 79 -155 127 -6 14 -21 23 -50 28 -22 4 -46\r
          13 -53 20 -7 7 -23 16 -35 19 -28 9 -122 121 -122 145 0 9 -5 22 -12 29 -9 9\r
          -6 12 15 12 21 0 27 5 27 21 0 16 5 20 20 16 15 -4 20 0 20 14 0 22 11 24 28\r
          7 9 -9 12 -6 12 15 0 31 0 30 34 17 18 -7 26 -6 26 2 0 16 -40 78 -51 78 -5 0\r
          -9 7 -9 15 0 35 74 4 124 -52 17 -19 40 -45 51 -58 11 -12 37 -32 57 -43 l36\r
          -21 -14 34 c-8 19 -14 37 -14 40 0 13 24 3 41 -17 l19 -23 -6 30 c-4 17 -10\r
          32 -14 35 -10 7 -30 152 -32 230 -1 83 20 179 44 193 14 10 18 25 18 78 0 48\r
          4 70 15 79 9 7 23 40 32 72 15 54 53 108 75 108 5 0 15 15 23 33 29 64 64 86\r
          65 39 1 -13 7 -10 24 12 15 17 30 27 39 23 11 -4 17 8 26 53 13 67 22 77 45\r
          54 15 -14 16 -14 16 5 0 11 5 23 10 26 6 3 10 16 10 28 0 34 16 55 32 39 19\r
          -19 25 -15 32 29 8 49 51 174 69 203 25 38 29 70 36 262 4 117 10 196 17 205\r
          6 8 15 25 19 38 11 37 64 116 78 116 7 0 14 -20 17 -50 8 -69 24 -95 59 -95\r
          48 0 110 57 111 101 0 29 -13 43 -50 54 -14 3 -40 13 -57 21 -31 14 -32 16\r
          -18 37 22 33 75 72 120 88 22 7 45 17 52 22 24 18 112 26 233 22 104 -3 140\r
          -9 215 -33z m34 -721 c7 -5 14 -20 14 -35 0 -23 4 -26 31 -26 32 0 56 -15 56\r
          -35 0 -20 -233 -155 -269 -155 -28 0 -26 186 2 202 9 4 23 15 31 23 31 31 105\r
          45 135 26z m400 -154 c59 -16 74 -41 41 -69 -14 -11 -24 -25 -22 -30 1 -5 -2\r
          -18 -8 -28 -14 -27 -84 -27 -128 0 -51 31 -89 109 -65 133 10 11 134 6 182 -6z` }),
              /* @__PURE__ */ f.jsx("path", { d: `M2327 2936 c8 -38 35 -57 71 -50 36 7 39 19 16 52 -11 16 -25 22 -53\r
          22 -35 0 -38 -2 -34 -24z` }),
              /* @__PURE__ */ f.jsx("path", { d: `M1710 1990 c-13 -9 -12 -12 5 -26 14 -11 35 -14 72 -11 57 4 72 12\r
          56 28 -15 15 -115 22 -133 9z` }),
              /* @__PURE__ */ f.jsx("path", { d: `M2311 1413 c-7 -15 -20 -44 -30 -63 -10 -19 -22 -54 -26 -78 l-7 -44\r
          30 16 c46 24 74 79 70 139 -3 58 -20 71 -37 30z` }),
              /* @__PURE__ */ f.jsx("path", { d: `M1560 1267 c0 -10 -8 -17 -19 -17 -43 0 3 -115 71 -178 33 -30 58\r
          -20 58 22 0 18 7 41 15 52 32 42 1 94 -60 99 -23 2 -45 11 -52 21 -12 16 -13\r
          17 -13 1z` })
            ]
          }
        )
      }
    ) }),
    /* @__PURE__ */ f.jsx(r1, { variant: "description-3", children: r })
  ] }) });
});
IR.displayName = "TableLoader";
const xb = (e) => {
  const {
    actions: t = [],
    row: r,
    canEdit: n,
    onEditClick: a,
    onActionClick: i,
    onRowClick: o,
    handleDisplayDetail: s,
    handleClickDetail: c,
    showDetail: u
  } = e, [d, h] = Ee(!1), A = Ce(null), p = Ce(null), v = () => {
    h(!1), a !== void 0 && a({ row: r });
  }, g = (y) => () => {
    i !== void 0 && i({ row: r, action: y }), h(!1);
  }, m = () => {
    o !== void 0 && o({ row: r });
  }, b = (y) => {
    if (A.current !== null && !A.current.contains(y.target)) {
      if (p.current !== null) {
        if (p.current.contains(y.target))
          return;
        h(!1);
        return;
      }
      h(!1);
    }
  };
  Ne(() => (document.addEventListener("click", b, !0), () => {
    document.removeEventListener("click", b, !0);
  }), []);
  const [w, x] = Ee(!0);
  return /* @__PURE__ */ f.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ f.jsx(
      Qr,
      {
        type: "button",
        variant: "secondary-light-bold",
        icon: "menu-context",
        tooltip: "Acciones",
        tooltipDirection: "left",
        disabled: t.length === 0,
        ref: A,
        size: "s",
        onlyIcon: !0,
        onClick: () => {
          h((y) => !y);
        }
      }
    ),
    d && /* @__PURE__ */ f.jsx("div", { ref: p, className: "absolute top-[calc(100%+8px)] right-0 z-[20] cursor-default pb-[20px] pointer-events-none", children: /* @__PURE__ */ f.jsx("div", { className: "bg-white min-w-[165px] max-w-[250px] p-4 rounded-md shadow-l pointer-events-auto", children: /* @__PURE__ */ f.jsxs("ul", { children: [
      n && /* @__PURE__ */ f.jsxs(
        "li",
        {
          onClick: v,
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200 2s:hidden",
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ f.jsx(De, { variant: "edit", isContain: !0 }) }),
            /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: "Editar" })
          ]
        }
      ),
      t.map((y) => /* @__PURE__ */ f.jsxs(
        "li",
        {
          onClick: g(y),
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200",
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ f.jsx(De, { variant: y.icon, isContain: !0 }) }),
            /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: y.title })
          ]
        },
        y.id
      )),
      u && /* @__PURE__ */ f.jsxs(
        "li",
        {
          onClick: () => {
            s !== void 0 && (s({ row: r, isShowDetail: w }), c !== void 0 && c({ row: r }), x((y) => !y));
          },
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200 2s:hidden",
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ f.jsx(De, { variant: "arrow-down", isContain: !0 }) }),
            /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: "Ver detalle" })
          ]
        }
      ),
      t.length === 0 && /* @__PURE__ */ f.jsxs(
        "li",
        {
          onClick: m,
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200",
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ f.jsx(De, { variant: "eye", isContain: !0 }) }),
            /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: "Ver" })
          ]
        }
      )
    ] }) }) })
  ] });
}, BR = (e) => {
  const {
    actions: t,
    row: r,
    index: n,
    detailData: a = [],
    detailColumns: i = [],
    handleDeleteDetatail: o,
    rowDetail: s,
    NOMCOLXX: c,
    onRowDetailClick: u
  } = e, d = t.filter((h) => h.id === 104);
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: a.map((h, A) => s !== r[c] ? null : /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: "relative p-4 rounded-md bg-secondary-400 hover:bg-secondary-300 hover:text-secondary-600 w-full cursor-pointer",
      onClick: () => {
        u !== void 0 && u({ row: h });
      },
      children: [
        Object.entries(h).map(([p, v]) => i.find((m) => m.id === p) === void 0 ? null : /* @__PURE__ */ f.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: v })),
        /* @__PURE__ */ f.jsx("div", { className: "absolute top-4 right-4", children: /* @__PURE__ */ f.jsx("div", { className: "bg-secondary-400", children: d && /* @__PURE__ */ f.jsx(
          Qr,
          {
            type: "button",
            variant: "secondary-light-bold",
            icon: "trash",
            tooltip: "Eliminar",
            tooltipDirection: "left",
            size: "s",
            onlyIcon: !0,
            onClick: () => {
              o !== void 0 && o({ item: h, row: r });
            }
          }
        ) }) })
      ]
    },
    `detail-${n}-${A}`
  )) });
}, NR = (e) => {
  const {
    actions: t = [],
    columns: r = [],
    data: n = [],
    canEdit: a,
    onEditClick: i,
    onActionClick: o,
    onRowClick: s,
    handleDisplayDetail: c,
    detailData: u,
    detailColumns: d = [],
    showDetail: h,
    handleDeleteDetatail: A
  } = e, p = d.length > 0 ? d[0].id : "", [v, g] = Ee(null), m = (b) => {
    const { row: w } = b;
    g(w[p]);
  };
  return /* @__PURE__ */ f.jsx("div", { className: "grid gap-2 2s:hidden", children: n.map((b, w) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        className: "relative p-4 rounded-md bg-secondary-100 hover:bg-secondary-200 hover:text-secondary-600 w-full cursor-pointer",
        children: [
          /* @__PURE__ */ f.jsx(
            "div",
            {
              className: "flex flex-wrap gap-y-1.5 gap-x-6",
              onClick: () => {
                s !== void 0 && s({ row: b });
              },
              children: Object.entries(b).filter(([x]) => r.some((y) => y.id === x && y.isMobileShow)).map(([x, y]) => {
                const C = r.find((E) => E.id === x);
                if (C === void 0)
                  return null;
                const {
                  isMobileShow: O = !1,
                  isTextBold: M = !1
                } = C;
                return O ? /* @__PURE__ */ f.jsx(
                  "p",
                  {
                    className: `leading-[120%] ${M ? "font-bold" : ""} w-full pr-12`,
                    children: y
                  },
                  x
                ) : null;
              })
            }
          ),
          /* @__PURE__ */ f.jsx("div", { className: "absolute top-4 right-4", children: /* @__PURE__ */ f.jsx(
            xb,
            {
              actions: t,
              row: b,
              canEdit: a,
              onEditClick: i,
              onActionClick: o,
              onRowClick: s,
              handleDisplayDetail: c,
              detailColumns: d,
              showDetail: h,
              handleClickDetail: m
            }
          ) })
        ]
      },
      b.id
    ),
    u.length > 0 && /* @__PURE__ */ f.jsx(
      BR,
      {
        actions: t,
        row: b,
        index: w,
        detailData: u,
        detailColumns: d,
        handleDeleteDetatail: A,
        rowDetail: v,
        NOMCOLXX: p,
        onRowDetailClick: s
      }
    )
  ] })) });
}, LR = (e) => {
  const {
    columns: t = [],
    onChangeShowColumn: r
  } = e, [n, a] = Ee(!1), [i, o] = Ee(!1), s = Ce(null), c = Ce(null), u = (d) => {
    if (s.current !== null && !s.current.contains(d.target)) {
      if (c.current !== null) {
        if (c.current.contains(d.target))
          return;
        a(!1);
        return;
      }
      a(!1);
    }
  };
  return Ne(() => (document.addEventListener("click", u, !0), () => {
    document.removeEventListener("click", u, !0);
  }), []), Ne(() => {
    t.filter((h) => h.canToggleShow).length > 0 ? o(!0) : o(!1);
  }, [t]), i ? /* @__PURE__ */ f.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ f.jsx(
      Qr,
      {
        type: "button",
        ref: s,
        variant: "secondary",
        icon: "column-actions",
        active: n,
        size: "s",
        onlyIcon: !0,
        tooltip: "Visualizar columnas",
        tooltipDirection: "left",
        onClick: () => {
          a((d) => !d);
        }
      }
    ),
    n && /* @__PURE__ */ f.jsx("div", { ref: c, className: "absolute top-[calc(100%+4px)] right-0 z-[30]", children: /* @__PURE__ */ f.jsxs("div", { className: "bg-white rounded-md shadow-xl w-[330px]", children: [
      /* @__PURE__ */ f.jsx("div", { className: "px-4 py-3.5 border-b border-b-neutral-300", children: /* @__PURE__ */ f.jsx(Vr, { variant: "title-3", children: "Ver / esconder columnas" }) }),
      /* @__PURE__ */ f.jsx("div", { className: "p-4 max-h-80 overflow-y-auto", children: /* @__PURE__ */ f.jsx(r9, { gap: 2, children: t.map((d) => d.canToggleShow ? /* @__PURE__ */ f.jsx(
        f0,
        {
          type: "switch",
          variantSize: "xs",
          isBold: !0,
          checked: d.isShow,
          onChange: () => {
            r !== void 0 && r({ column: d });
          },
          children: /* @__PURE__ */ f.jsx("p", { children: d.title })
        },
        d.id
      ) : null) }) })
    ] }) })
  ] }) : /* @__PURE__ */ f.jsx(f.Fragment, {});
}, TR = (e) => {
  const {
    columns: t = [],
    onColumnClick: r,
    onChangeShowColumn: n,
    isCheckedRow: a,
    handleCheckedAllRows: i,
    data: o,
    ischeckedAll: s,
    handleOrderChange: c
  } = e;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    a && /* @__PURE__ */ f.jsx(
      "div",
      {
        style: { gridArea: "col-reserved-check" },
        className: "min-w-[50px] flex gap-2 justify-between items-center px-4",
        children: /* @__PURE__ */ f.jsx(
          "input",
          {
            type: "checkbox",
            id: "checkAll",
            title: "Seleccionar todos",
            className: "w-full overflow-hidden whitespace-nowrap",
            onChange: (u) => {
              i !== void 0 && i(o, u.target.checked);
            },
            checked: s
          }
        )
      }
    ),
    t.filter((u) => u.isShow).map((u) => /* @__PURE__ */ f.jsxs(
      "div",
      {
        style: { gridArea: `col-${u.id}` },
        title: u.title,
        className: `min-w-[205px] flex gap-2 justify-between items-center px-4 font-bold leading-[120%] select-none ${u.sorted && u.orderBy !== null ? "text-secondary-600" : "hover:text-secondary-500"}`,
        children: [
          /* @__PURE__ */ f.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: u.title }),
          u.sortable && /* @__PURE__ */ f.jsx(
            "button",
            {
              type: "button",
              className: "w-6 h-6 flex items-center justify-center",
              onClick: () => {
                r !== void 0 && r({ column: u });
              },
              children: /* @__PURE__ */ f.jsxs(
                "svg",
                {
                  className: "w-5",
                  viewBox: "0 0 25 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [
                    /* @__PURE__ */ f.jsx(
                      "path",
                      {
                        d: "M16.743 10L8.25505 10C8.1049 9.9994 7.95831 9.95665 7.83381 9.87715C7.70931 9.79765 7.6125 9.68497 7.55561 9.55336C7.49873 9.42176 7.48433 9.27713 7.51423 9.13777C7.54413 8.99841 7.61699 8.87057 7.7236 8.77043L11.96 4.75815C12.0306 4.69075 12.1145 4.63726 12.207 4.60075C12.2996 4.56425 12.3988 4.54545 12.499 4.54545C12.5992 4.54545 12.6985 4.56425 12.791 4.60075C12.8835 4.63726 12.9675 4.69075 13.0381 4.75815L17.2744 8.77043C17.3811 8.87057 17.4539 8.99841 17.4838 9.13777C17.5137 9.27713 17.4993 9.42176 17.4424 9.55337C17.3855 9.68497 17.2887 9.79765 17.1642 9.87715C17.0397 9.95665 16.8931 9.9994 16.743 10Z",
                        fill: u.sorted && u.orderBy === "asc" ? "#2875B4" : "#E6E6E6"
                      }
                    ),
                    /* @__PURE__ */ f.jsx(
                      "path",
                      {
                        d: "M8.25505 14H16.743C16.8931 14.0006 17.0397 14.0433 17.1642 14.1228C17.2887 14.2023 17.3855 14.315 17.4424 14.4466C17.4993 14.5782 17.5137 14.7229 17.4838 14.8622C17.4539 15.0016 17.3811 15.1294 17.2744 15.2296L13.0381 19.2419C12.9675 19.3092 12.8835 19.3627 12.791 19.3992C12.6985 19.4358 12.5992 19.4545 12.499 19.4545C12.3988 19.4545 12.2996 19.4358 12.207 19.3992C12.1145 19.3627 12.0306 19.3092 11.96 19.2419L7.7236 15.2296C7.61699 15.1294 7.54413 15.0016 7.51423 14.8622C7.48433 14.7229 7.49873 14.5782 7.55561 14.4466C7.6125 14.315 7.70931 14.2023 7.83381 14.1228C7.95831 14.0433 8.1049 14.0006 8.25505 14Z",
                        fill: u.sorted && u.orderBy === "desc" ? "#2875B4" : "#E6E6E6"
                      }
                    )
                  ]
                }
              )
            }
          )
        ]
      },
      u.id
    )),
    /* @__PURE__ */ f.jsx("div", { className: "sticky right-0 bg-white z-[99999]", style: { gridArea: "col-reserved-actions" }, children: /* @__PURE__ */ f.jsxs("div", { className: "flex items-center justify-between pl-4 pr-2 h-10 select-none", children: [
      /* @__PURE__ */ f.jsx("p", { className: "font-bold", children: "Acciones" }),
      /* @__PURE__ */ f.jsx(
        Qr,
        {
          type: "button",
          variant: "secondary",
          icon: "column-order",
          size: "s",
          onlyIcon: !0,
          onClick: () => {
            c !== void 0 && c(!0);
          },
          tooltip: "Reordenar Columnas",
          tooltipDirection: "left"
        }
      ),
      /* @__PURE__ */ f.jsx(
        LR,
        {
          columns: t,
          onChangeShowColumn: n
        }
      )
    ] }) })
  ] });
}, _R = (e) => {
  const {
    actions: t,
    row: r,
    index: n,
    detailData: a = [],
    detailColumns: i = [],
    handleDeleteDetatail: o,
    rowDetail: s,
    NOMCOLXX: c,
    onRowDetailClick: u,
    colorColumn: d
  } = e, h = i.map((m) => `col-${m.id}`).concat("col-reserved-actions").join(" ").toString();
  let A = 0;
  const p = Array.from({ length: i.length }, () => {
    let m = "1fr";
    return A === 0 && (m = "0.2fr"), A++, m;
  }).join(" ").toString(), v = { gridTemplateAreas: `'${h}'`, gridTemplateColumns: p + " 150px" }, g = t.filter((m) => m.id === "toggle");
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: a.map((m, b) => s !== r[c] ? null : /* @__PURE__ */ f.jsxs(
    "div",
    {
      style: v,
      className: "bg-secondary-400 hover:bg-secondary-300 hover:text-secondary-600 cursor-pointer border-b border-white last:border-none h-[48px] grid w-full",
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "bg-white", children: /* @__PURE__ */ f.jsx("div", { className: "flex items-center gap-2 h-[48px]", children: /* @__PURE__ */ f.jsx(De, { variant: "arrow-turn-down-right" }) }) }),
        Object.entries(m).map(([w, x]) => {
          const y = i.find((E) => E.id === w);
          if (y === void 0)
            return null;
          let C = d ? d.filter((E) => E.title === w) : [], O = !1, M = "";
          if (C.length > 0) {
            O = !0;
            const E = C[0].params.filter((F) => F.value === x), N = E.length > 0 ? E[0].color : "transparent";
            M = gt[N];
          }
          return /* @__PURE__ */ f.jsx(
            "div",
            {
              style: { gridArea: `col-${y.id}` },
              title: x,
              className: "min-w-[205px] flex items-center px-4 border-l border-white first:border-none leading-[120%]",
              onClick: () => {
                if (u !== void 0) {
                  const E = { ...m };
                  Object.keys(E).forEach((N) => {
                    N.startsWith("TARIDCHX") && (E.TARIDXXX = E[N], delete E[N]);
                  }), u({ row: E });
                }
              },
              children: O ? /* @__PURE__ */ f.jsx("div", { className: "w-full h-8 px-4 justify-center items-center gap-2 flex", style: { borderRadius: "8px", backgroundColor: M }, children: /* @__PURE__ */ f.jsx("div", { className: "grow text-center text-white text-xs font-bold leading-[14.40px]", children: x }) }) : /* @__PURE__ */ f.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: x })
            },
            w
          );
        }),
        /* @__PURE__ */ f.jsx("div", { className: "bg-white sticky block right-0 border-l border-white cursor-default pr-1", children: /* @__PURE__ */ f.jsx("div", { className: "bg-secondary-400", children: /* @__PURE__ */ f.jsx("div", { className: "flex items-center gap-2 h-[48px] px-4", children: g.length > 0 && /* @__PURE__ */ f.jsx(
          Qr,
          {
            type: "button",
            variant: "secondary-light-bold",
            icon: "trash",
            tooltip: "Eliminar",
            tooltipDirection: "left",
            size: "s",
            onlyIcon: !0,
            onClick: () => {
              o !== void 0 && o({ item: m, row: r });
            }
          }
        ) }) }) })
      ]
    },
    `detail-${n}-${b}`
  )) });
}, RR = (e) => {
  const {
    actions: t = [],
    columns: r = [],
    data: n = [],
    canEdit: a,
    activeRowValidation: i,
    onEditClick: o,
    onActionClick: s,
    onRowClick: c,
    onColumnClick: u,
    onChangeShowColumn: d,
    handleDisplayDetail: h,
    detailData: A = [],
    detailColumns: p = [],
    showDetail: v,
    handleDeleteDetatail: g,
    isCheckedRow: m,
    handleCheckedRow: b,
    handleCheckedAllRows: w,
    selectedRows: x,
    colorColumn: y,
    intermediateContent: C,
    ischeckedAll: O,
    handleOrderChange: M
  } = e, E = (m ? "col-reserved-check " : "") + r.filter((Z) => Z.isShow).map((Z) => `col-${Z.id}`).concat("col-reserved-actions").join(" ").toString(), N = (m ? "50px " : "") + Array.from({ length: r.filter((Z) => Z.isShow).length }, () => "1fr").concat(a ? "150px" : "").join(" ").toString(), F = { gridTemplateAreas: `'${E}'`, gridTemplateColumns: N }, [k, R] = Ee(null), j = p.length > 0 ? p[0].id : "", [U, ee] = Ee(!0), X = (Z) => {
    const { row: te } = Z;
    R(te[j]);
  };
  return /* @__PURE__ */ f.jsx("div", { className: "grid gap-2 hidden 2s:block", children: /* @__PURE__ */ f.jsx("div", { className: `${C ? "" : "max-h-[calc(100vh-461px)] min-h-[calc(100vh-461px)]"}
                        ${C ? "" : "m:max-h-[calc(100vh-305px)] m:min-h-[calc(100vh-305px)]"}
                        ${C ? "" : "l:max-h-[calc(100vh-312px)] l:min-h-[calc(100vh-312px)]"}
                        ${C ? "table-max-height" : ""}
                        w-full overflow-x-auto overflow-y-auto table-main-scrollbar pb-1`, children: /* @__PURE__ */ f.jsxs("div", { className: "min-w-[min-content]", children: [
    /* @__PURE__ */ f.jsx("div", { className: "bg-white grid w-full h-10 sticky top-0", style: { ...F, zIndex: n.length + 10 }, children: /* @__PURE__ */ f.jsx(
      TR,
      {
        columns: r,
        onColumnClick: u,
        onChangeShowColumn: d,
        isCheckedRow: m,
        handleCheckedAllRows: w,
        data: n,
        ischeckedAll: O,
        handleOrderChange: M
      }
    ) }),
    /* @__PURE__ */ f.jsx("div", { className: "bg-secondary-100 w-full", children: /* @__PURE__ */ f.jsx("div", { children: n.map((Z, te) => {
      const B = te % 2 === 0, I = i === void 0 || Z[i.field] === void 0 ? !0 : Z[i.field] === i.value, _ = I ? B ? "bg-secondary-200" : "bg-secondary-100" : "bg-neutral-200 text-neutral-400", L = x && x.some((D) => JSON.stringify(D) === JSON.stringify(Z));
      return /* @__PURE__ */ f.jsxs(PE, { children: [
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            style: F,
            className: `${_} hover:bg-secondary-300 hover:text-secondary-600 cursor-pointer border-b border-white last:border-none h-[40px] grid w-full`,
            children: [
              m && /* @__PURE__ */ f.jsx("div", { className: "min-w-[50px] flex justify-between items-center pr-1", children: /* @__PURE__ */ f.jsx(
                "input",
                {
                  type: "checkbox",
                  title: "Seleccionar",
                  checked: L || O,
                  className: "checkbox w-full overflow-hidden whitespace-nowrap",
                  onChange: (D) => {
                    b !== void 0 && b(Z, D.target.checked);
                  }
                }
              ) }),
              Object.entries(Z).map(([D, T]) => {
                const Q = r.find((V) => V.id === D);
                if (Q === void 0 || !Q.isShow)
                  return null;
                const {
                  isTextBold: z = !1
                } = Q;
                let W = !1, H = "", $ = y ? y.filter((V) => V.title === D) : [];
                if ($.length > 0) {
                  W = !0;
                  const V = $[0].params.filter((S) => S.value === T), Y = V.length > 0 ? V[0].color : "transparent";
                  H = gt[Y];
                }
                return /* @__PURE__ */ f.jsx(
                  "div",
                  {
                    style: { gridArea: `col-${Q.id}` },
                    title: T,
                    className: `min-w-[205px] h-10 flex items-center px-4 border-l border-white first:border-none leading-[120%] ${z ? "font-bold" : ""}`,
                    onClick: () => {
                      c !== void 0 && !Q.onClickCell && c({ row: Z });
                    },
                    children: W ? /* @__PURE__ */ f.jsx("div", { className: "w-full h-8 px-4 justify-center items-center gap-2 flex", style: { borderRadius: "8px", backgroundColor: H }, children: /* @__PURE__ */ f.jsx("div", { className: "grow text-center text-white text-xs font-bold leading-[14.40px]", children: T }) }) : /* @__PURE__ */ f.jsx(
                      "p",
                      {
                        className: `w-full text-ellipsis overflow-hidden whitespace-nowrap ${Q.isHyperlink ? "underline text-secondary-600" : ""}`,
                        onClick: () => Q.onClickCell && Q.onClickCell(Z, Q),
                        children: T
                      }
                    )
                  },
                  D
                );
              }),
              /* @__PURE__ */ f.jsx("div", { className: "bg-white sticky block right-0 border-l border-white cursor-default pr-1", style: { zIndex: n.length - te + 1 }, children: /* @__PURE__ */ f.jsx("div", { className: _, children: /* @__PURE__ */ f.jsxs("div", { className: `flex items-center gap-2 h-[40px] ${a ? "px-4" : "pl-6 pr-4"} ${te + 1 === n.length ? "" : "border-b border-white"}`, children: [
                a && I ? /* @__PURE__ */ f.jsx(
                  Qr,
                  {
                    type: "button",
                    variant: "secondary-light-bold",
                    icon: "edit",
                    tooltip: "Editar",
                    tooltipDirection: "left",
                    disabled: !I,
                    size: "s",
                    onlyIcon: !0,
                    onClick: () => {
                      o !== void 0 && o({ row: Z });
                    }
                  }
                ) : "        ",
                /* @__PURE__ */ f.jsx(
                  xb,
                  {
                    actions: t,
                    row: Z,
                    canEdit: a,
                    onEditClick: o,
                    onActionClick: s,
                    onRowClick: c,
                    handleDisplayDetail: h,
                    detailColumns: p,
                    showDetail: v,
                    handleClickDetail: X
                  }
                ),
                v && /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(
                  Qr,
                  {
                    type: "button",
                    variant: "secondary-light-bold",
                    icon: "arrow-down",
                    tooltip: "Ver Detalle",
                    tooltipDirection: "left",
                    size: "s",
                    onlyIcon: !0,
                    onClick: () => {
                      h !== void 0 && (h({ row: Z, isShowDetail: U }), X({ row: Z }), ee((D) => !D));
                    }
                  }
                ) })
              ] }) }) })
            ]
          },
          Z.id
        ),
        A.length > 0 && /* @__PURE__ */ f.jsx(
          _R,
          {
            actions: t,
            row: Z,
            index: te,
            detailData: A,
            detailColumns: p,
            handleDeleteDetatail: g,
            rowDetail: k,
            NOMCOLXX: j,
            onRowDetailClick: c,
            colorColumn: y
          }
        )
      ] }, `fragment-${te}`);
    }) }) })
  ] }) }) });
}, FR = P.forwardRef((e, t) => {
  const {
    actions: r = [],
    columns: n = [],
    data: a = [],
    canEdit: i = !1,
    activeRowValidation: o,
    className: s,
    onEditClick: c,
    onActionClick: u,
    onRowClick: d,
    onColumnClick: h,
    onChangeShowColumn: A,
    handleDisplayDetail: p,
    detailData: v = [],
    detailColumns: g = [],
    showDetail: m = !1,
    handleDeleteDetatail: b,
    isCheckedRow: w = !1,
    handleCheckedRow: x,
    handleCheckedAllRows: y,
    selectedRows: C,
    colorColumn: O,
    intermediateContent: M,
    ischeckedAll: E = !1,
    handleOrderChange: N
  } = e;
  return n.length < 1 ? null : /* @__PURE__ */ f.jsxs("div", { ref: t, className: Ye(["block", s]), children: [
    /* @__PURE__ */ f.jsx(
      NR,
      {
        actions: r,
        columns: n,
        data: a,
        canEdit: i,
        onEditClick: c,
        onActionClick: u,
        onRowClick: d,
        handleDisplayDetail: p,
        detailData: v,
        detailColumns: g,
        showDetail: m,
        handleDeleteDetatail: b
      }
    ),
    /* @__PURE__ */ f.jsx(
      RR,
      {
        actions: r,
        columns: n,
        data: a,
        activeRowValidation: o,
        canEdit: i,
        onEditClick: c,
        onActionClick: u,
        onRowClick: d,
        onColumnClick: h,
        onChangeShowColumn: A,
        handleDisplayDetail: p,
        detailData: v,
        detailColumns: g,
        showDetail: m,
        handleDeleteDetatail: b,
        isCheckedRow: w,
        handleCheckedRow: x,
        handleCheckedAllRows: y,
        selectedRows: C,
        colorColumn: O,
        intermediateContent: M,
        ischeckedAll: E,
        handleOrderChange: N
      }
    )
  ] });
});
FR.displayName = "TableMain";
function J3() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
const $R = P.forwardRef((e, t) => {
  const {
    items: r = [],
    prevActive: n = !1,
    nextActive: a = !1,
    className: i,
    onItemClick: o,
    onPrevClick: s = () => {
    },
    onNextClick: c = () => {
    },
    trackingMeta: u
  } = e;
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: Ye(["flex flex-wrap justify-center gap-4", i]), children: [
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        className: "bg-secondary-600 rounded-md w-8 h-8 flex items-center justify-center text-white disabled:bg-neutral-300 disabled:pointer-events-none",
        disabled: !n,
        onClick: () => {
          n && (s(), J3());
        },
        children: /* @__PURE__ */ f.jsx("span", { className: "w-[20px] min-w-[20px]", children: /* @__PURE__ */ f.jsx(De, { variant: "back-arrow", width: 18 }) })
      }
    ),
    r.map((d) => {
      const h = (d == null ? void 0 : d.isActive) ?? !0, A = (d == null ? void 0 : d.isDisabled) ?? !1;
      return /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          className: `w-8 h-8 flex justify-center items-center rounded-md font-bold ${h ? "bg-secondary-600 text-white pointer-events-none" : "bg-secondary-100 text-secondary-600 hover:bg-secondary-600 hover:text-white"} disabled:pointer-events-none`,
          disabled: A,
          onClick: () => {
            A || h || o !== void 0 && (o({ item: d }), J3());
          },
          children: d.label
        },
        d.label
      );
    }),
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        className: "bg-secondary-600 rounded-md w-8 h-8 flex items-center justify-center text-white disabled:bg-neutral-300 disabled:pointer-events-none",
        disabled: !a,
        onClick: () => {
          a && (c(), J3());
        },
        children: /* @__PURE__ */ f.jsx("span", { className: "w-[20px] min-w-[20px] -rotate-180", children: /* @__PURE__ */ f.jsx(De, { variant: "back-arrow", width: 18 }) })
      }
    ),
    /* @__PURE__ */ f.jsxs("p", { className: "text-ellipsis text-secondary-600 font-bold", children: [
      "Mostrando ",
      u.from,
      " al ",
      u.to,
      " de un total de ",
      u.total
    ] })
  ] });
});
$R.displayName = "TablePagination";
const HR = P.forwardRef((e, t) => {
  const {
    pages: r = [],
    onChangePage: n,
    className: a,
    trackingMeta: i
  } = e, [o, s] = Ee(!1), c = r;
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: Ye(["flex items-center justify-center gap-4", a]), children: [
    /* @__PURE__ */ f.jsx(Vr, { variant: "title-2", children: "Items por página" }),
    /* @__PURE__ */ f.jsxs("div", { className: "flex-grow max-w-[100px] m:min-w-[100px] relative", children: [
      /* @__PURE__ */ f.jsxs(
        "button",
        {
          type: "button",
          className: `h-8 bg-neutral-200 border ${o ? "border-secondary-600" : "border-neutral-300 hover:border-secondary-400"} rounded-md w-full flex items-center justify-between gap-2 px-4`,
          onClick: () => {
            s((u) => !u);
          },
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "block flex-grow text-left", children: i.per_page }),
            c.length > 0 && /* @__PURE__ */ f.jsx("span", { className: `w-[15px] min-w-[15px] ${o ? "-rotate-180" : ""}`, children: /* @__PURE__ */ f.jsx(De, { variant: "arrow-down", width: 15 }) })
          ]
        }
      ),
      c.length > 0 && o && /* @__PURE__ */ f.jsx("ul", { className: "absolute left-0 w-full bg-neutral-200 border border-neutral-300 rounded-md bottom-[calc(100%+8px)] shadow-m z-[1000] p-2 overflow-hidden", children: c.map((u) => /* @__PURE__ */ f.jsx(
        "li",
        {
          className: `px-4 py-3 rounded-md cursor-pointer leading-[120%] ${u === i.per_page ? "text-white bg-secondary-600" : "hover:bg-secondary-200"}`,
          onClick: () => {
            s(!1), u !== i.per_page && (n !== void 0 && n(u), J3());
          },
          children: u
        },
        u
      )) })
    ] })
  ] });
});
HR.displayName = "TableShowPages";
const YR = "h-64 animation-toast-in flex items-center justify-center grid gap-2 text-black font-bold py-4 px-5 rounded-[16px] ", kR = {
  error: "bg-Negros-100",
  success: "bg-Negros-100",
  info: "bg-Negros-100",
  warning: "bg-Negros-100"
}, VR = {
  error: `
  <svg width="70" height="70"  fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M34.5 54C29.3283 54 24.3684 51.9455 20.7114 48.2886C17.0545 44.6316 15 39.6717 15 34.5C15 29.3283 17.0545 24.3684 20.7114 20.7114C24.3684 17.0545 29.3283 15 34.5 15L34.5 34.5L34.5 54Z" fill="#E2807A"/>
    <path d="M34.5 54C39.6717 54 44.6316 51.9455 48.2886 48.2886C51.9455 44.6316 54 39.6717 54 34.5C54 29.3283 51.9455 24.3684 48.2886 20.7114C44.6316 17.0545 39.6717 15 34.5 15L34.5 34.5L34.5 54Z" fill="#B23B29"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M43.627 25.5858C44.4081 26.3668 44.4081 27.6332 43.627 28.4142L29.4142 42.627C28.6332 43.4081 27.3668 43.4081 26.5858 42.627C25.8047 41.846 25.8047 40.5796 26.5858 39.7986L40.7986 25.5858C41.5796 24.8047 42.846 24.8047 43.627 25.5858Z" fill="white"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M26.5858 25.5858C27.3668 24.8047 28.6332 24.8047 29.4142 25.5858L43.627 39.7986C44.4081 40.5796 44.4081 41.846 43.627 42.627C42.846 43.4081 41.5796 43.4081 40.7986 42.627L26.5858 28.4142C25.8047 27.6332 25.8047 26.3668 26.5858 25.5858Z" fill="white"/>
  </svg>

  `,
  success: `
  <svg width="70" height="70"  fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_57_322)">
    <path d="M18 36C27.9411 36 36 27.9411 36 18C36 8.05888 27.9411 0 18 0C8.05888 0 0 8.05888 0 18C0 27.9411 8.05888 36 18 36Z" fill="#00AD34"/>
    <path d="M0 18C0 27.9413 8.05868 36 18 36V0C8.05868 0 0 8.05868 0 18Z" fill="#76E592"/>
    <path d="M10.4687 16.9326C11.1089 16.9564 11.6054 17.2583 12.0439 17.7065C12.9089 18.5897 13.7893 19.4582 14.6633 20.3323C14.7705 20.4394 14.7719 20.438 14.8784 20.3323C16.0249 19.1843 17.1714 18.0357 18.3187 16.8885C19.2348 15.9724 20.1537 15.0591 21.0698 14.1429C22.0854 13.1267 23.1002 12.1104 24.113 11.0913C24.5332 10.6683 25.0361 10.426 25.6307 10.419C26.6645 10.4071 27.5288 11.0984 27.7466 12.0726C27.9273 12.8801 27.6878 13.5623 27.1058 14.1401C26.4131 14.8279 25.7267 15.5227 25.0361 16.2133C24.293 16.9564 23.5478 17.6967 22.8054 18.4398C22.1568 19.0884 21.511 19.7384 20.8625 20.3869C20.1194 21.13 19.3749 21.871 18.6318 22.6134C17.855 23.3902 17.0783 24.1683 16.303 24.9464C15.8904 25.3604 15.3911 25.5852 14.8097 25.595C14.2375 25.6048 13.7234 25.4192 13.313 25.0137C12.2988 24.0121 11.2945 23.0001 10.2859 21.9922C9.81315 21.5201 9.34109 21.0467 8.86763 20.576C7.81704 19.5317 8.14553 17.7275 9.49518 17.1217C9.80615 16.9823 10.1297 16.9214 10.4687 16.9333V16.9326Z" fill="white"/>
    <path d="M26.9426 10.9064L12.8942 24.6663C13.0342 24.805 13.1729 24.945 13.313 25.083C13.7234 25.4885 14.2375 25.6741 14.8097 25.6643C15.3911 25.6545 15.8904 25.429 16.303 25.0158C17.079 24.2376 17.855 23.4595 18.6318 22.6828C19.3749 21.9397 20.1194 21.1987 20.8625 20.4562C21.5111 19.8077 22.1568 19.157 22.8054 18.5092C23.5485 17.766 24.2937 17.0257 25.0361 16.2826C25.7267 15.592 26.4124 14.898 27.1058 14.2095C27.6871 13.6323 27.9273 12.9495 27.7466 12.1419C27.6325 11.6327 27.3418 11.2006 26.9426 10.9064Z" fill="#DDEBF0"/>
    </g>
    <defs>
    <clipPath id="clip0_57_322">
    <rect width="36" height="36" fill="white"/>
    </clipPath>
    </defs>
  </svg>
  `,
  info: `
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_57_332)">
    <path d="M18 36C27.9411 36 36 27.9411 36 18C36 8.05888 27.9411 0 18 0C8.05888 0 0 8.05888 0 18C0 27.9411 8.05888 36 18 36Z" fill="#FF4A04"/>
    <path d="M0 18C0 27.9413 8.05868 36 18 36V0C8.05868 0 0 8.05868 0 18Z" fill="#FF7719"/>
    <path d="M21.2918 10.5409C21.2918 8.74218 19.8337 7.28406 18.035 7.28406C16.2363 7.28406 14.7782 8.74218 14.7782 10.5409V18.7354C14.7782 20.5341 16.2363 21.9922 18.035 21.9922C19.8337 21.9922 21.2918 20.5341 21.2918 18.7354V10.5409Z" fill="#DDEBF0"/>
    <path d="M18.07 28.716C19.772 28.716 21.1518 27.3362 21.1518 25.6343C21.1518 23.9323 19.772 22.5526 18.07 22.5526C16.3681 22.5526 14.9883 23.9323 14.9883 25.6343C14.9883 27.3362 16.3681 28.716 18.07 28.716Z" fill="#DDEBF0"/>
    <path d="M18.035 7.28406C16.2364 7.28406 14.7782 8.74227 14.7782 10.5409V18.7354C14.7782 20.534 16.2364 21.9922 18.035 21.9922C18.0469 21.9922 18.0581 21.9915 18.07 21.9915V7.28476C18.0581 7.28476 18.0469 7.28406 18.035 7.28406Z" fill="white"/>
    <path d="M14.9883 25.6343C14.9883 27.3362 16.3681 28.716 18.07 28.716V22.5526C16.3681 22.5526 14.9883 23.9323 14.9883 25.6343Z" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0_57_332">
    <rect width="36" height="36" fill="white"/>
    </clipPath>
    </defs>
  </svg>
  
  `,
  warning: `
  <svg width="40" height="36" viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M19.74 0C18.2513 -1.74141e-06 16.7625 0.734374 15.9118 2.20313L0.598825 28.6406C-1.10261 31.5781 1.02418 35.25 4.42706 35.25H19.74V0Z" fill="#E2807A"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M19.74 0C21.2288 4.88378e-06 22.7175 0.73438 23.5682 2.20313L38.8812 28.6406C40.5826 31.5781 38.4558 35.25 35.0529 35.25H19.74V0Z" fill="#B23B29"/>
    <path d="M23.5 11.8597C23.5 9.9821 22.027 8.46002 20.21 8.46002C18.393 8.46002 16.92 9.9821 16.92 11.8597V20.4137C16.92 22.2913 18.393 23.8134 20.21 23.8134C22.027 23.8134 23.5 22.2913 23.5 20.4137V11.8597Z" fill="#DDEBF0"/>
    <path d="M20.21 31.4899C22.027 31.4899 23.5 30.0169 23.5 28.1999C23.5 26.3828 22.027 24.9099 20.21 24.9099C18.393 24.9099 16.92 26.3828 16.92 28.1999C16.92 30.0169 18.393 31.4899 20.21 31.4899Z" fill="#DDEBF0"/>
    <path d="M20.175 8.46002C18.3774 8.46002 16.92 9.9822 16.92 11.8597V20.4137C16.92 22.2912 18.3774 23.8134 20.175 23.8134C20.1869 23.8134 20.1981 23.8126 20.21 23.8126V8.46075C20.1981 8.46075 20.1869 8.46002 20.175 8.46002Z" fill="white"/>
  </svg>
  
  `
}, GR = `
  <svg width="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.9998 0.999818C12.8123 0.812347 12.558 0.707031 12.2928 0.707031C12.0277 0.707031 11.7733 0.812347 11.5858 0.999818L6.99982 5.58582L2.41382 0.999818C2.22629 0.812347 1.97198 0.707031 1.70682 0.707031C1.44165 0.707031 1.18735 0.812347 0.999818 0.999818C0.812347 1.18735 0.707031 1.44165 0.707031 1.70682C0.707031 1.97198 0.812347 2.22629 0.999818 2.41382L5.58582 6.99982L0.999818 11.5858C0.812347 11.7733 0.707031 12.0277 0.707031 12.2928C0.707031 12.558 0.812347 12.8123 0.999818 12.9998C1.18735 13.1873 1.44165 13.2926 1.70682 13.2926C1.97198 13.2926 2.22629 13.1873 2.41382 12.9998L6.99982 8.41382L11.5858 12.9998C11.7733 13.1873 12.0277 13.2926 12.2928 13.2926C12.558 13.2926 12.8123 13.1873 12.9998 12.9998C13.1873 12.8123 13.2926 12.558 13.2926 12.2928C13.2926 12.0277 13.1873 11.7733 12.9998 11.5858L8.41382 6.99982L12.9998 2.41382C13.1873 2.22629 13.2926 1.97198 13.2926 1.70682C13.2926 1.44165 13.1873 1.18735 12.9998 0.999818Z" fill="red"/>
  </svg>
`, WR = P.forwardRef((e, t) => {
  const {
    className: r
  } = e, [n, a] = Ee(!1), i = Ce(null);
  return Ne(() => {
    const o = (s) => {
      var w;
      let c;
      const d = s.detail, h = d.duration ?? 6e3, A = (d == null ? void 0 : d.autoHide) ?? !0, p = document.createElement("div"), v = `${YR} ${kR[d.variant]}`.trim();
      p.setAttribute("class", v), A && (c = setTimeout(() => {
        p.classList.add("animation-toast-out"), d.onClose !== void 0 && d.onClose(), setTimeout(() => {
          p.style.display = "none";
        }, 250);
      }, h));
      const g = document.createElement("div");
      g.setAttribute("class", "w-8 min-w-[90px] absolute top-0 pt-12 left-1/2 transform -translate-x-1/2"), g.innerHTML = `${VR[d.variant]}`;
      const m = document.createElement("button");
      m.setAttribute("class", "w-10 min-w-[40px] h-10 rounded-md flex items-center justify-center bg-[rgba(255,255,255,0.18)] absolute top-0 right-0 my-6 mr-4"), m.innerHTML = GR, m.onclick = () => {
        p.classList.add("animation-toast-out"), d.onClose !== void 0 && d.onClose(), clearTimeout(c), setTimeout(() => {
          p.style.display = "none", a(!1);
        }, 250);
      };
      const b = document.createElement("p");
      b.setAttribute("class", "cursor-default flex-grow text-center pt-6"), b.innerText = d.text, p.append(g), p.append(m), p.append(b), (w = i.current) == null || w.append(p), A && (console.log("Ingreso ??"), a(!0), c = setTimeout(() => {
        p.classList.add("animation-toast-out"), d.onClose !== void 0 && d.onClose(), setTimeout(() => {
          p.style.display = "none", a(!1);
        }, 250);
      }, h));
    };
    return document.addEventListener("codekit:shootToast", o, !0), () => {
      document.removeEventListener("codekit:shootToast", o, !0);
    };
  }, []), /* @__PURE__ */ f.jsxs("div", { children: [
    n && /* @__PURE__ */ f.jsx(
      "div",
      {
        className: "fixed top-0 left-0 w-full h-full bg-Marca-800 opacity-80"
      }
    ),
    /* @__PURE__ */ f.jsx("div", { ref: t, className: Ye(["fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full pointer-events-none z-[2000] px-4", r]), children: /* @__PURE__ */ f.jsx("div", { ref: i, className: "grid gap-2 w-full max-w-[610px] mx-auto" }) })
  ] });
});
WR.displayName = "Toast";
const lCe = (e) => {
  const t = new CustomEvent("codekit:shootToast", {
    detail: e
  });
  document.dispatchEvent(t);
}, QR = P.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, u = `${{
    "body-1": "text-[20px]",
    "body-2": "text-[16px]",
    "body-3": "text-[14px]",
    "body-4": "text-[12px]"
  }[n]} not-italic font-normal leading-[160%]`, d = {
    textAlign: i,
    color: a !== void 0 ? gt[a] : void 0
  };
  return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: u, style: d, ...s, children: r }) : /* @__PURE__ */ f.jsx("p", { ref: t, className: u, style: d, ...s, children: r });
});
QR.displayName = "Body";
const Db = P.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, u = `${{
    "description-1": "text-[20px]",
    "description-2": "text-[16px]",
    "description-3": "text-[14px]",
    "description-4": "text-[12px]"
  }[n]} not-italic font-normal leading-[120%]`, d = {
    textAlign: i,
    color: a !== void 0 ? gt[a] : void 0
  };
  return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: u, style: d, ...s, children: r }) : /* @__PURE__ */ f.jsx("p", { ref: t, className: u, style: d, ...s, children: r });
});
Db.displayName = "Description";
const r1 = Db, Ob = P.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, c = "not-italic font-bold leading-[120%]", u = {
    textAlign: i,
    color: a !== void 0 ? gt[a] : void 0
  };
  if (n === "heading-1") {
    const d = `${c} text-[48px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: d, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("h1", { ref: t, className: d, style: u, ...s, children: r });
  }
  if (n === "heading-2") {
    const d = `${c} text-[40px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: d, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("h2", { ref: t, className: d, style: u, ...s, children: r });
  }
  if (n === "heading-3") {
    const d = `${c} text-[34px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: d, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("h3", { ref: t, className: d, style: u, ...s, children: r });
  }
  if (n === "heading-4") {
    const d = `${c} text-[28px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: d, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("h4", { ref: t, className: d, style: u, ...s, children: r });
  }
  if (n === "heading-5") {
    const d = `${c} text-[24px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: d, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("h5", { ref: t, className: d, style: u, ...s, children: r });
  }
  if (n === "heading-6") {
    const d = `${c} text-[20px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: d, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("h6", { ref: t, className: d, style: u, ...s, children: r });
  }
  return null;
});
Ob.displayName = "Heading";
const Ri = Ob, UR = P.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, u = `${{
    "overheading-1": "font-normal text-[14px] tracking-[0.44em]",
    "hyperlink-1": "font-bold text-[16px] underline"
  }[n]} not-italic leading-[100%]`, d = {
    textAlign: i,
    color: a !== void 0 ? gt[a] : void 0
  };
  return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: u, style: d, ...s, children: r }) : /* @__PURE__ */ f.jsx("p", { ref: t, className: u, style: d, ...s, children: r });
});
UR.displayName = "TextOther";
const Mb = P.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, u = `${{
    "title-1": "text-[20px]",
    "title-2": "text-[16px]",
    "title-3": "text-[14px]",
    "title-4": "text-[12px]"
  }[n]} not-italic font-bold leading-[120%]`, d = {
    textAlign: i,
    color: a !== void 0 ? gt[a] : void 0
  };
  return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: u, style: d, ...s, children: r }) : /* @__PURE__ */ f.jsx("p", { ref: t, className: u, style: d, ...s, children: r });
});
Mb.displayName = "Title";
const Vr = Mb, ZR = P.forwardRef((e) => {
  const { imageUrl: t } = e;
  return /* @__PURE__ */ f.jsx("div", { className: "max-w-md mx-auto bg-black rounded overflow-hidden shadow-lg border border-indigo-600 rounded-lg drop-shadow-md overflow-hidden shadow-lg transition-transform duration-300 ease-in-out transform hover:-translate-y-2", children: /* @__PURE__ */ f.jsx("img", { className: "w-full h-full object-cover", src: t }) });
});
ZR.displayName = "Cards";
function Eb(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var a = e.length;
      for (t = 0; t < a; t++)
        e[t] && (r = Eb(e[t])) && (n && (n += " "), n += r);
    } else
      for (r in e)
        e[r] && (n && (n += " "), n += r);
  return n;
}
function Pe() {
  for (var e, t, r = 0, n = "", a = arguments.length; r < a; r++)
    (e = arguments[r]) && (t = Eb(e)) && (n && (n += " "), n += t);
  return n;
}
var KR = Array.isArray, ir = KR, zR = typeof ji == "object" && ji && ji.Object === Object && ji, Sb = zR, qR = Sb, XR = typeof self == "object" && self && self.Object === Object && self, JR = qR || XR || Function("return this")(), fn = JR, eF = fn, tF = eF.Symbol, Uo = tF, nh = Uo, Pb = Object.prototype, rF = Pb.hasOwnProperty, nF = Pb.toString, si = nh ? nh.toStringTag : void 0;
function aF(e) {
  var t = rF.call(e, si), r = e[si];
  try {
    e[si] = void 0;
    var n = !0;
  } catch {
  }
  var a = nF.call(e);
  return n && (t ? e[si] = r : delete e[si]), a;
}
var iF = aF, oF = Object.prototype, sF = oF.toString;
function lF(e) {
  return sF.call(e);
}
var cF = lF, ah = Uo, uF = iF, dF = cF, fF = "[object Null]", hF = "[object Undefined]", ih = ah ? ah.toStringTag : void 0;
function AF(e) {
  return e == null ? e === void 0 ? hF : fF : ih && ih in Object(e) ? uF(e) : dF(e);
}
var Pn = AF;
function pF(e) {
  return e != null && typeof e == "object";
}
var jn = pF, gF = Pn, vF = jn, mF = "[object Symbol]";
function CF(e) {
  return typeof e == "symbol" || vF(e) && gF(e) == mF;
}
var b2 = CF, bF = ir, yF = b2, wF = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, xF = /^\w*$/;
function DF(e, t) {
  if (bF(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || yF(e) ? !0 : xF.test(e) || !wF.test(e) || t != null && e in Object(t);
}
var n9 = DF;
function OF(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var A1 = OF;
const y2 = /* @__PURE__ */ Xe(A1);
var MF = Pn, EF = A1, SF = "[object AsyncFunction]", PF = "[object Function]", jF = "[object GeneratorFunction]", IF = "[object Proxy]";
function BF(e) {
  if (!EF(e))
    return !1;
  var t = MF(e);
  return t == PF || t == jF || t == SF || t == IF;
}
var a9 = BF;
const xe = /* @__PURE__ */ Xe(a9);
var NF = fn, LF = NF["__core-js_shared__"], TF = LF, N6 = TF, oh = function() {
  var e = /[^.]+$/.exec(N6 && N6.keys && N6.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function _F(e) {
  return !!oh && oh in e;
}
var RF = _F, FF = Function.prototype, $F = FF.toString;
function HF(e) {
  if (e != null) {
    try {
      return $F.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var jb = HF, YF = a9, kF = RF, VF = A1, GF = jb, WF = /[\\^$.*+?()[\]{}|]/g, QF = /^\[object .+?Constructor\]$/, UF = Function.prototype, ZF = Object.prototype, KF = UF.toString, zF = ZF.hasOwnProperty, qF = RegExp(
  "^" + KF.call(zF).replace(WF, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function XF(e) {
  if (!VF(e) || kF(e))
    return !1;
  var t = YF(e) ? qF : QF;
  return t.test(GF(e));
}
var JF = XF;
function e$(e, t) {
  return e == null ? void 0 : e[t];
}
var t$ = e$, r$ = JF, n$ = t$;
function a$(e, t) {
  var r = n$(e, t);
  return r$(r) ? r : void 0;
}
var aa = a$, i$ = aa, o$ = i$(Object, "create"), C0 = o$, sh = C0;
function s$() {
  this.__data__ = sh ? sh(null) : {}, this.size = 0;
}
var l$ = s$;
function c$(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var u$ = c$, d$ = C0, f$ = "__lodash_hash_undefined__", h$ = Object.prototype, A$ = h$.hasOwnProperty;
function p$(e) {
  var t = this.__data__;
  if (d$) {
    var r = t[e];
    return r === f$ ? void 0 : r;
  }
  return A$.call(t, e) ? t[e] : void 0;
}
var g$ = p$, v$ = C0, m$ = Object.prototype, C$ = m$.hasOwnProperty;
function b$(e) {
  var t = this.__data__;
  return v$ ? t[e] !== void 0 : C$.call(t, e);
}
var y$ = b$, w$ = C0, x$ = "__lodash_hash_undefined__";
function D$(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = w$ && t === void 0 ? x$ : t, this;
}
var O$ = D$, M$ = l$, E$ = u$, S$ = g$, P$ = y$, j$ = O$;
function w2(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
w2.prototype.clear = M$;
w2.prototype.delete = E$;
w2.prototype.get = S$;
w2.prototype.has = P$;
w2.prototype.set = j$;
var I$ = w2;
function B$() {
  this.__data__ = [], this.size = 0;
}
var N$ = B$;
function L$(e, t) {
  return e === t || e !== e && t !== t;
}
var i9 = L$, T$ = i9;
function _$(e, t) {
  for (var r = e.length; r--; )
    if (T$(e[r][0], t))
      return r;
  return -1;
}
var b0 = _$, R$ = b0, F$ = Array.prototype, $$ = F$.splice;
function H$(e) {
  var t = this.__data__, r = R$(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : $$.call(t, r, 1), --this.size, !0;
}
var Y$ = H$, k$ = b0;
function V$(e) {
  var t = this.__data__, r = k$(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var G$ = V$, W$ = b0;
function Q$(e) {
  return W$(this.__data__, e) > -1;
}
var U$ = Q$, Z$ = b0;
function K$(e, t) {
  var r = this.__data__, n = Z$(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var z$ = K$, q$ = N$, X$ = Y$, J$ = G$, eH = U$, tH = z$;
function x2(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
x2.prototype.clear = q$;
x2.prototype.delete = X$;
x2.prototype.get = J$;
x2.prototype.has = eH;
x2.prototype.set = tH;
var y0 = x2, rH = aa, nH = fn, aH = rH(nH, "Map"), o9 = aH, lh = I$, iH = y0, oH = o9;
function sH() {
  this.size = 0, this.__data__ = {
    hash: new lh(),
    map: new (oH || iH)(),
    string: new lh()
  };
}
var lH = sH;
function cH(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var uH = cH, dH = uH;
function fH(e, t) {
  var r = e.__data__;
  return dH(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var w0 = fH, hH = w0;
function AH(e) {
  var t = hH(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var pH = AH, gH = w0;
function vH(e) {
  return gH(this, e).get(e);
}
var mH = vH, CH = w0;
function bH(e) {
  return CH(this, e).has(e);
}
var yH = bH, wH = w0;
function xH(e, t) {
  var r = wH(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var DH = xH, OH = lH, MH = pH, EH = mH, SH = yH, PH = DH;
function D2(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
D2.prototype.clear = OH;
D2.prototype.delete = MH;
D2.prototype.get = EH;
D2.prototype.has = SH;
D2.prototype.set = PH;
var s9 = D2, Ib = s9, jH = "Expected a function";
function l9(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(jH);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return r.cache = i.set(a, o) || i, o;
  };
  return r.cache = new (l9.Cache || Ib)(), r;
}
l9.Cache = Ib;
var Bb = l9;
const IH = /* @__PURE__ */ Xe(Bb);
var BH = Bb, NH = 500;
function LH(e) {
  var t = BH(e, function(n) {
    return r.size === NH && r.clear(), n;
  }), r = t.cache;
  return t;
}
var TH = LH, _H = TH, RH = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, FH = /\\(\\)?/g, $H = _H(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(RH, function(r, n, a, i) {
    t.push(a ? i.replace(FH, "$1") : n || r);
  }), t;
}), HH = $H;
function YH(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var c9 = YH, ch = Uo, kH = c9, VH = ir, GH = b2, WH = 1 / 0, uh = ch ? ch.prototype : void 0, dh = uh ? uh.toString : void 0;
function Nb(e) {
  if (typeof e == "string")
    return e;
  if (VH(e))
    return kH(e, Nb) + "";
  if (GH(e))
    return dh ? dh.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -WH ? "-0" : t;
}
var QH = Nb, UH = QH;
function ZH(e) {
  return e == null ? "" : UH(e);
}
var Lb = ZH, KH = ir, zH = n9, qH = HH, XH = Lb;
function JH(e, t) {
  return KH(e) ? e : zH(e, t) ? [e] : qH(XH(e));
}
var Tb = JH, eY = b2, tY = 1 / 0;
function rY(e) {
  if (typeof e == "string" || eY(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -tY ? "-0" : t;
}
var x0 = rY, nY = Tb, aY = x0;
function iY(e, t) {
  t = nY(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[aY(t[r++])];
  return r && r == n ? e : void 0;
}
var u9 = iY, oY = u9;
function sY(e, t, r) {
  var n = e == null ? void 0 : oY(e, t);
  return n === void 0 ? r : n;
}
var _b = sY;
const vr = /* @__PURE__ */ Xe(_b);
function lY(e) {
  return e == null;
}
var cY = lY;
const ye = /* @__PURE__ */ Xe(cY);
var uY = Pn, dY = ir, fY = jn, hY = "[object String]";
function AY(e) {
  return typeof e == "string" || !dY(e) && fY(e) && uY(e) == hY;
}
var pY = AY;
const Zo = /* @__PURE__ */ Xe(pY);
var Z4 = { exports: {} }, ze = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fh;
function gY() {
  if (fh)
    return ze;
  fh = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, A = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function x(C) {
    if (typeof C == "object" && C !== null) {
      var O = C.$$typeof;
      switch (O) {
        case t:
          switch (C = C.type, C) {
            case c:
            case u:
            case n:
            case i:
            case a:
            case h:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case s:
                case d:
                case v:
                case p:
                case o:
                  return C;
                default:
                  return O;
              }
          }
        case r:
          return O;
      }
    }
  }
  function y(C) {
    return x(C) === u;
  }
  return ze.AsyncMode = c, ze.ConcurrentMode = u, ze.ContextConsumer = s, ze.ContextProvider = o, ze.Element = t, ze.ForwardRef = d, ze.Fragment = n, ze.Lazy = v, ze.Memo = p, ze.Portal = r, ze.Profiler = i, ze.StrictMode = a, ze.Suspense = h, ze.isAsyncMode = function(C) {
    return y(C) || x(C) === c;
  }, ze.isConcurrentMode = y, ze.isContextConsumer = function(C) {
    return x(C) === s;
  }, ze.isContextProvider = function(C) {
    return x(C) === o;
  }, ze.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, ze.isForwardRef = function(C) {
    return x(C) === d;
  }, ze.isFragment = function(C) {
    return x(C) === n;
  }, ze.isLazy = function(C) {
    return x(C) === v;
  }, ze.isMemo = function(C) {
    return x(C) === p;
  }, ze.isPortal = function(C) {
    return x(C) === r;
  }, ze.isProfiler = function(C) {
    return x(C) === i;
  }, ze.isStrictMode = function(C) {
    return x(C) === a;
  }, ze.isSuspense = function(C) {
    return x(C) === h;
  }, ze.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === n || C === u || C === i || C === a || C === h || C === A || typeof C == "object" && C !== null && (C.$$typeof === v || C.$$typeof === p || C.$$typeof === o || C.$$typeof === s || C.$$typeof === d || C.$$typeof === m || C.$$typeof === b || C.$$typeof === w || C.$$typeof === g);
  }, ze.typeOf = x, ze;
}
var qe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hh;
function vY() {
  return hh || (hh = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, A = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function x(S) {
      return typeof S == "string" || typeof S == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      S === n || S === u || S === i || S === a || S === h || S === A || typeof S == "object" && S !== null && (S.$$typeof === v || S.$$typeof === p || S.$$typeof === o || S.$$typeof === s || S.$$typeof === d || S.$$typeof === m || S.$$typeof === b || S.$$typeof === w || S.$$typeof === g);
    }
    function y(S) {
      if (typeof S == "object" && S !== null) {
        var J = S.$$typeof;
        switch (J) {
          case t:
            var q = S.type;
            switch (q) {
              case c:
              case u:
              case n:
              case i:
              case a:
              case h:
                return q;
              default:
                var re = q && q.$$typeof;
                switch (re) {
                  case s:
                  case d:
                  case v:
                  case p:
                  case o:
                    return re;
                  default:
                    return J;
                }
            }
          case r:
            return J;
        }
      }
    }
    var C = c, O = u, M = s, E = o, N = t, F = d, k = n, R = v, j = p, U = r, ee = i, X = a, Z = h, te = !1;
    function B(S) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), I(S) || y(S) === c;
    }
    function I(S) {
      return y(S) === u;
    }
    function _(S) {
      return y(S) === s;
    }
    function L(S) {
      return y(S) === o;
    }
    function D(S) {
      return typeof S == "object" && S !== null && S.$$typeof === t;
    }
    function T(S) {
      return y(S) === d;
    }
    function Q(S) {
      return y(S) === n;
    }
    function z(S) {
      return y(S) === v;
    }
    function W(S) {
      return y(S) === p;
    }
    function H(S) {
      return y(S) === r;
    }
    function $(S) {
      return y(S) === i;
    }
    function V(S) {
      return y(S) === a;
    }
    function Y(S) {
      return y(S) === h;
    }
    qe.AsyncMode = C, qe.ConcurrentMode = O, qe.ContextConsumer = M, qe.ContextProvider = E, qe.Element = N, qe.ForwardRef = F, qe.Fragment = k, qe.Lazy = R, qe.Memo = j, qe.Portal = U, qe.Profiler = ee, qe.StrictMode = X, qe.Suspense = Z, qe.isAsyncMode = B, qe.isConcurrentMode = I, qe.isContextConsumer = _, qe.isContextProvider = L, qe.isElement = D, qe.isForwardRef = T, qe.isFragment = Q, qe.isLazy = z, qe.isMemo = W, qe.isPortal = H, qe.isProfiler = $, qe.isStrictMode = V, qe.isSuspense = Y, qe.isValidElementType = x, qe.typeOf = y;
  }()), qe;
}
process.env.NODE_ENV === "production" ? Z4.exports = gY() : Z4.exports = vY();
var K4 = Z4.exports, mY = Pn, CY = jn, bY = "[object Number]";
function yY(e) {
  return typeof e == "number" || CY(e) && mY(e) == bY;
}
var Rb = yY;
const wY = /* @__PURE__ */ Xe(Rb);
var xY = Rb;
function DY(e) {
  return xY(e) && e != +e;
}
var OY = DY;
const O2 = /* @__PURE__ */ Xe(OY);
var qt = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, G1 = function(t) {
  return Zo(t) && t.indexOf("%") === t.length - 1;
}, le = function(t) {
  return wY(t) && !O2(t);
}, jt = function(t) {
  return le(t) || Zo(t);
}, MY = 0, p1 = function(t) {
  var r = ++MY;
  return "".concat(t || "").concat(r);
}, Xt = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!le(t) && !Zo(t))
    return n;
  var i;
  if (G1(t)) {
    var o = t.indexOf("%");
    i = r * parseFloat(t.slice(0, o)) / 100;
  } else
    i = +t;
  return O2(i) && (i = n), a && i > r && (i = r), i;
}, Kn = function(t) {
  if (!t)
    return null;
  var r = Object.keys(t);
  return r && r.length ? t[r[0]] : null;
}, EY = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var r = t.length, n = {}, a = 0; a < r; a++)
    if (!n[t[a]])
      n[t[a]] = !0;
    else
      return !0;
  return !1;
}, yt = function(t, r) {
  return le(t) && le(r) ? function(n) {
    return t + n * (r - t);
  } : function() {
    return r;
  };
};
function cs(e, t, r) {
  return !e || !e.length ? null : e.find(function(n) {
    return n && (typeof t == "function" ? t(n) : vr(n, t)) === r;
  });
}
var SY = function(t) {
  if (!t || !t.length)
    return null;
  for (var r = t.length, n = 0, a = 0, i = 0, o = 0, s = 1 / 0, c = -1 / 0, u = 0, d = 0, h = 0; h < r; h++)
    u = t[h].cx || 0, d = t[h].cy || 0, n += u, a += d, i += u * d, o += u * u, s = Math.min(s, u), c = Math.max(c, u);
  var A = r * o !== n * n ? (r * i - n * a) / (r * o - n * n) : 0;
  return {
    xmin: s,
    xmax: c,
    a: A,
    b: (a - A * n) / r
  };
};
function Ha(e, t) {
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(t, r) || e[r] !== t[r]))
      return !1;
  for (var n in t)
    if ({}.hasOwnProperty.call(t, n) && !{}.hasOwnProperty.call(e, n))
      return !1;
  return !0;
}
function z4(e) {
  "@babel/helpers - typeof";
  return z4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, z4(e);
}
var PY = ["viewBox", "children"], jY = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], Ah = ["points", "pathLength"], L6 = {
  svg: PY,
  polygon: Ah,
  polyline: Ah
}, d9 = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], us = function(t, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var n = t;
  if (/* @__PURE__ */ kr(t) && (n = t.props), !y2(n))
    return null;
  var a = {};
  return Object.keys(n).forEach(function(i) {
    d9.includes(i) && (a[i] = r || function(o) {
      return n[i](n, o);
    });
  }), a;
}, IY = function(t, r, n) {
  return function(a) {
    return t(r, n, a), null;
  };
}, s1 = function(t, r, n) {
  if (!y2(t) || z4(t) !== "object")
    return null;
  var a = null;
  return Object.keys(t).forEach(function(i) {
    var o = t[i];
    d9.includes(i) && typeof o == "function" && (a || (a = {}), a[i] = IY(o, r, n));
  }), a;
}, BY = ["children"], NY = ["children"];
function ph(e, t) {
  if (e == null)
    return {};
  var r = LY(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function LY(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function q4(e) {
  "@babel/helpers - typeof";
  return q4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, q4(e);
}
var gh = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart"
}, xn = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, vh = null, T6 = null, f9 = function e(t) {
  if (t === vh && Array.isArray(T6))
    return T6;
  var r = [];
  return K1.forEach(t, function(n) {
    ye(n) || (K4.isFragment(n) ? r = r.concat(e(n.props.children)) : r.push(n));
  }), T6 = r, vh = t, r;
};
function er(e, t) {
  var r = [], n = [];
  return Array.isArray(t) ? n = t.map(function(a) {
    return xn(a);
  }) : n = [xn(t)], f9(e).forEach(function(a) {
    var i = vr(a, "type.displayName") || vr(a, "type.name");
    n.indexOf(i) !== -1 && r.push(a);
  }), r;
}
function fr(e, t) {
  var r = er(e, t);
  return r && r[0];
}
var mh = function(t) {
  if (!t || !t.props)
    return !1;
  var r = t.props, n = r.width, a = r.height;
  return !(!le(n) || n <= 0 || !le(a) || a <= 0);
}, TY = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], _Y = function(t) {
  return t && t.type && Zo(t.type) && TY.indexOf(t.type) >= 0;
}, Fb = function(t) {
  return t && q4(t) === "object" && "cx" in t && "cy" in t && "r" in t;
}, RY = function(t, r, n, a) {
  var i, o = (i = L6 == null ? void 0 : L6[a]) !== null && i !== void 0 ? i : [];
  return !xe(t) && (a && o.includes(r) || jY.includes(r)) || n && d9.includes(r);
}, pe = function(t, r, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var a = t;
  if (/* @__PURE__ */ kr(t) && (a = t.props), !y2(a))
    return null;
  var i = {};
  return Object.keys(a).forEach(function(o) {
    var s;
    RY((s = a) === null || s === void 0 ? void 0 : s[o], o, r, n) && (i[o] = a[o]);
  }), i;
}, X4 = function e(t, r) {
  if (t === r)
    return !0;
  var n = K1.count(t);
  if (n !== K1.count(r))
    return !1;
  if (n === 0)
    return !0;
  if (n === 1)
    return Ch(Array.isArray(t) ? t[0] : t, Array.isArray(r) ? r[0] : r);
  for (var a = 0; a < n; a++) {
    var i = t[a], o = r[a];
    if (Array.isArray(i) || Array.isArray(o)) {
      if (!e(i, o))
        return !1;
    } else if (!Ch(i, o))
      return !1;
  }
  return !0;
}, Ch = function(t, r) {
  if (ye(t) && ye(r))
    return !0;
  if (!ye(t) && !ye(r)) {
    var n = t.props || {}, a = n.children, i = ph(n, BY), o = r.props || {}, s = o.children, c = ph(o, NY);
    return a && s ? Ha(i, c) && X4(a, s) : !a && !s ? Ha(i, c) : !1;
  }
  return !1;
}, bh = function(t, r) {
  var n = [], a = {};
  return f9(t).forEach(function(i, o) {
    if (_Y(i))
      n.push(i);
    else if (i) {
      var s = xn(i.type), c = r[s] || {}, u = c.handler, d = c.once;
      if (u && (!d || !a[s])) {
        var h = u(i, s, o);
        n.push(h), a[s] = !0;
      }
    }
  }), n;
}, FY = function(t) {
  var r = t && t.type;
  return r && gh[r] ? gh[r] : null;
}, $Y = function(t, r) {
  return f9(r).indexOf(t);
}, HY = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function J4() {
  return J4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, J4.apply(this, arguments);
}
function YY(e, t) {
  if (e == null)
    return {};
  var r = kY(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function kY(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function e5(e) {
  var t = e.children, r = e.width, n = e.height, a = e.viewBox, i = e.className, o = e.style, s = e.title, c = e.desc, u = YY(e, HY), d = a || {
    width: r,
    height: n,
    x: 0,
    y: 0
  }, h = Pe("recharts-surface", i);
  return /* @__PURE__ */ P.createElement("svg", J4({}, pe(u, !0, "svg"), {
    className: h,
    width: r,
    height: n,
    style: o,
    viewBox: "".concat(d.x, " ").concat(d.y, " ").concat(d.width, " ").concat(d.height)
  }), /* @__PURE__ */ P.createElement("title", null, s), /* @__PURE__ */ P.createElement("desc", null, c), t);
}
var VY = ["children", "className"];
function t5() {
  return t5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, t5.apply(this, arguments);
}
function GY(e, t) {
  if (e == null)
    return {};
  var r = WY(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function WY(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var je = /* @__PURE__ */ P.forwardRef(function(e, t) {
  var r = e.children, n = e.className, a = GY(e, VY), i = Pe("recharts-layer", n);
  return /* @__PURE__ */ P.createElement("g", t5({
    className: i
  }, pe(a, !0), {
    ref: t
  }), r);
}), QY = process.env.NODE_ENV !== "production", Gr = function(t, r) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    a[i - 2] = arguments[i];
  if (QY && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(r.replace(/%s/g, function() {
        return a[o++];
      }));
    }
};
function UY(e, t, r) {
  var n = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), r = r > a ? a : r, r < 0 && (r += a), a = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var i = Array(a); ++n < a; )
    i[n] = e[n + t];
  return i;
}
var ZY = UY, KY = ZY;
function zY(e, t, r) {
  var n = e.length;
  return r = r === void 0 ? n : r, !t && r >= n ? e : KY(e, t, r);
}
var qY = zY, XY = "\\ud800-\\udfff", JY = "\\u0300-\\u036f", ek = "\\ufe20-\\ufe2f", tk = "\\u20d0-\\u20ff", rk = JY + ek + tk, nk = "\\ufe0e\\ufe0f", ak = "\\u200d", ik = RegExp("[" + ak + XY + rk + nk + "]");
function ok(e) {
  return ik.test(e);
}
var $b = ok;
function sk(e) {
  return e.split("");
}
var lk = sk, Hb = "\\ud800-\\udfff", ck = "\\u0300-\\u036f", uk = "\\ufe20-\\ufe2f", dk = "\\u20d0-\\u20ff", fk = ck + uk + dk, hk = "\\ufe0e\\ufe0f", Ak = "[" + Hb + "]", r5 = "[" + fk + "]", n5 = "\\ud83c[\\udffb-\\udfff]", pk = "(?:" + r5 + "|" + n5 + ")", Yb = "[^" + Hb + "]", kb = "(?:\\ud83c[\\udde6-\\uddff]){2}", Vb = "[\\ud800-\\udbff][\\udc00-\\udfff]", gk = "\\u200d", Gb = pk + "?", Wb = "[" + hk + "]?", vk = "(?:" + gk + "(?:" + [Yb, kb, Vb].join("|") + ")" + Wb + Gb + ")*", mk = Wb + Gb + vk, Ck = "(?:" + [Yb + r5 + "?", r5, kb, Vb, Ak].join("|") + ")", bk = RegExp(n5 + "(?=" + n5 + ")|" + Ck + mk, "g");
function yk(e) {
  return e.match(bk) || [];
}
var wk = yk, xk = lk, Dk = $b, Ok = wk;
function Mk(e) {
  return Dk(e) ? Ok(e) : xk(e);
}
var Ek = Mk, Sk = qY, Pk = $b, jk = Ek, Ik = Lb;
function Bk(e) {
  return function(t) {
    t = Ik(t);
    var r = Pk(t) ? jk(t) : void 0, n = r ? r[0] : t.charAt(0), a = r ? Sk(r, 1).join("") : t.slice(1);
    return n[e]() + a;
  };
}
var Nk = Bk, Lk = Nk, Tk = Lk("toUpperCase"), _k = Tk;
const D0 = /* @__PURE__ */ Xe(_k);
function lt(e) {
  return function() {
    return e;
  };
}
const Qb = Math.cos, ds = Math.sin, Kr = Math.sqrt, fs = Math.PI, O0 = 2 * fs, a5 = Math.PI, i5 = 2 * a5, R1 = 1e-6, Rk = i5 - R1;
function Ub(e) {
  this._ += e[0];
  for (let t = 1, r = e.length; t < r; ++t)
    this._ += arguments[t] + e[t];
}
function Fk(e) {
  let t = Math.floor(e);
  if (!(t >= 0))
    throw new Error(`invalid digits: ${e}`);
  if (t > 15)
    return Ub;
  const r = 10 ** t;
  return function(n) {
    this._ += n[0];
    for (let a = 1, i = n.length; a < i; ++a)
      this._ += Math.round(arguments[a] * r) / r + n[a];
  };
}
class $k {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? Ub : Fk(t);
  }
  moveTo(t, r) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, r) {
    this._append`L${this._x1 = +t},${this._y1 = +r}`;
  }
  quadraticCurveTo(t, r, n, a) {
    this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +a}`;
  }
  bezierCurveTo(t, r, n, a, i, o) {
    this._append`C${+t},${+r},${+n},${+a},${this._x1 = +i},${this._y1 = +o}`;
  }
  arcTo(t, r, n, a, i) {
    if (t = +t, r = +r, n = +n, a = +a, i = +i, i < 0)
      throw new Error(`negative radius: ${i}`);
    let o = this._x1, s = this._y1, c = n - t, u = a - r, d = o - t, h = s - r, A = d * d + h * h;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = r}`;
    else if (A > R1)
      if (!(Math.abs(h * c - u * d) > R1) || !i)
        this._append`L${this._x1 = t},${this._y1 = r}`;
      else {
        let p = n - o, v = a - s, g = c * c + u * u, m = p * p + v * v, b = Math.sqrt(g), w = Math.sqrt(A), x = i * Math.tan((a5 - Math.acos((g + A - m) / (2 * b * w))) / 2), y = x / w, C = x / b;
        Math.abs(y - 1) > R1 && this._append`L${t + y * d},${r + y * h}`, this._append`A${i},${i},0,0,${+(h * p > d * v)},${this._x1 = t + C * c},${this._y1 = r + C * u}`;
      }
  }
  arc(t, r, n, a, i, o) {
    if (t = +t, r = +r, n = +n, o = !!o, n < 0)
      throw new Error(`negative radius: ${n}`);
    let s = n * Math.cos(a), c = n * Math.sin(a), u = t + s, d = r + c, h = 1 ^ o, A = o ? a - i : i - a;
    this._x1 === null ? this._append`M${u},${d}` : (Math.abs(this._x1 - u) > R1 || Math.abs(this._y1 - d) > R1) && this._append`L${u},${d}`, n && (A < 0 && (A = A % i5 + i5), A > Rk ? this._append`A${n},${n},0,1,${h},${t - s},${r - c}A${n},${n},0,1,${h},${this._x1 = u},${this._y1 = d}` : A > R1 && this._append`A${n},${n},0,${+(A >= a5)},${h},${this._x1 = t + n * Math.cos(i)},${this._y1 = r + n * Math.sin(i)}`);
  }
  rect(t, r, n, a) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+a}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function h9(e) {
  let t = 3;
  return e.digits = function(r) {
    if (!arguments.length)
      return t;
    if (r == null)
      t = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0))
        throw new RangeError(`invalid digits: ${r}`);
      t = n;
    }
    return e;
  }, () => new $k(t);
}
function A9(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function Zb(e) {
  this._context = e;
}
Zb.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function M0(e) {
  return new Zb(e);
}
function Kb(e) {
  return e[0];
}
function zb(e) {
  return e[1];
}
function qb(e, t) {
  var r = lt(!0), n = null, a = M0, i = null, o = h9(s);
  e = typeof e == "function" ? e : e === void 0 ? Kb : lt(e), t = typeof t == "function" ? t : t === void 0 ? zb : lt(t);
  function s(c) {
    var u, d = (c = A9(c)).length, h, A = !1, p;
    for (n == null && (i = a(p = o())), u = 0; u <= d; ++u)
      !(u < d && r(h = c[u], u, c)) === A && ((A = !A) ? i.lineStart() : i.lineEnd()), A && i.point(+e(h, u, c), +t(h, u, c));
    if (p)
      return i = null, p + "" || null;
  }
  return s.x = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : lt(+c), s) : e;
  }, s.y = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : lt(+c), s) : t;
  }, s.defined = function(c) {
    return arguments.length ? (r = typeof c == "function" ? c : lt(!!c), s) : r;
  }, s.curve = function(c) {
    return arguments.length ? (a = c, n != null && (i = a(n)), s) : a;
  }, s.context = function(c) {
    return arguments.length ? (c == null ? n = i = null : i = a(n = c), s) : n;
  }, s;
}
function O3(e, t, r) {
  var n = null, a = lt(!0), i = null, o = M0, s = null, c = h9(u);
  e = typeof e == "function" ? e : e === void 0 ? Kb : lt(+e), t = typeof t == "function" ? t : lt(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? zb : lt(+r);
  function u(h) {
    var A, p, v, g = (h = A9(h)).length, m, b = !1, w, x = new Array(g), y = new Array(g);
    for (i == null && (s = o(w = c())), A = 0; A <= g; ++A) {
      if (!(A < g && a(m = h[A], A, h)) === b)
        if (b = !b)
          p = A, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), v = A - 1; v >= p; --v)
            s.point(x[v], y[v]);
          s.lineEnd(), s.areaEnd();
        }
      b && (x[A] = +e(m, A, h), y[A] = +t(m, A, h), s.point(n ? +n(m, A, h) : x[A], r ? +r(m, A, h) : y[A]));
    }
    if (w)
      return s = null, w + "" || null;
  }
  function d() {
    return qb().defined(a).curve(o).context(i);
  }
  return u.x = function(h) {
    return arguments.length ? (e = typeof h == "function" ? h : lt(+h), n = null, u) : e;
  }, u.x0 = function(h) {
    return arguments.length ? (e = typeof h == "function" ? h : lt(+h), u) : e;
  }, u.x1 = function(h) {
    return arguments.length ? (n = h == null ? null : typeof h == "function" ? h : lt(+h), u) : n;
  }, u.y = function(h) {
    return arguments.length ? (t = typeof h == "function" ? h : lt(+h), r = null, u) : t;
  }, u.y0 = function(h) {
    return arguments.length ? (t = typeof h == "function" ? h : lt(+h), u) : t;
  }, u.y1 = function(h) {
    return arguments.length ? (r = h == null ? null : typeof h == "function" ? h : lt(+h), u) : r;
  }, u.lineX0 = u.lineY0 = function() {
    return d().x(e).y(t);
  }, u.lineY1 = function() {
    return d().x(e).y(r);
  }, u.lineX1 = function() {
    return d().x(n).y(t);
  }, u.defined = function(h) {
    return arguments.length ? (a = typeof h == "function" ? h : lt(!!h), u) : a;
  }, u.curve = function(h) {
    return arguments.length ? (o = h, i != null && (s = o(i)), u) : o;
  }, u.context = function(h) {
    return arguments.length ? (h == null ? i = s = null : s = o(i = h), u) : i;
  }, u;
}
class Xb {
  constructor(t, r) {
    this._context = t, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, r) {
    switch (t = +t, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
        break;
      }
    }
    this._x0 = t, this._y0 = r;
  }
}
function Hk(e) {
  return new Xb(e, !0);
}
function Yk(e) {
  return new Xb(e, !1);
}
const p9 = {
  draw(e, t) {
    const r = Kr(t / fs);
    e.moveTo(r, 0), e.arc(0, 0, r, 0, O0);
  }
}, kk = {
  draw(e, t) {
    const r = Kr(t / 5) / 2;
    e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
  }
}, Jb = Kr(1 / 3), Vk = Jb * 2, Gk = {
  draw(e, t) {
    const r = Kr(t / Vk), n = r * Jb;
    e.moveTo(0, -r), e.lineTo(n, 0), e.lineTo(0, r), e.lineTo(-n, 0), e.closePath();
  }
}, Wk = {
  draw(e, t) {
    const r = Kr(t), n = -r / 2;
    e.rect(n, n, r, r);
  }
}, Qk = 0.8908130915292852, ey = ds(fs / 10) / ds(7 * fs / 10), Uk = ds(O0 / 10) * ey, Zk = -Qb(O0 / 10) * ey, Kk = {
  draw(e, t) {
    const r = Kr(t * Qk), n = Uk * r, a = Zk * r;
    e.moveTo(0, -r), e.lineTo(n, a);
    for (let i = 1; i < 5; ++i) {
      const o = O0 * i / 5, s = Qb(o), c = ds(o);
      e.lineTo(c * r, -s * r), e.lineTo(s * n - c * a, c * n + s * a);
    }
    e.closePath();
  }
}, _6 = Kr(3), zk = {
  draw(e, t) {
    const r = -Kr(t / (_6 * 3));
    e.moveTo(0, r * 2), e.lineTo(-_6 * r, -r), e.lineTo(_6 * r, -r), e.closePath();
  }
}, br = -0.5, yr = Kr(3) / 2, o5 = 1 / Kr(12), qk = (o5 / 2 + 1) * 3, Xk = {
  draw(e, t) {
    const r = Kr(t / qk), n = r / 2, a = r * o5, i = n, o = r * o5 + r, s = -i, c = o;
    e.moveTo(n, a), e.lineTo(i, o), e.lineTo(s, c), e.lineTo(br * n - yr * a, yr * n + br * a), e.lineTo(br * i - yr * o, yr * i + br * o), e.lineTo(br * s - yr * c, yr * s + br * c), e.lineTo(br * n + yr * a, br * a - yr * n), e.lineTo(br * i + yr * o, br * o - yr * i), e.lineTo(br * s + yr * c, br * c - yr * s), e.closePath();
  }
};
function Jk(e, t) {
  let r = null, n = h9(a);
  e = typeof e == "function" ? e : lt(e || p9), t = typeof t == "function" ? t : lt(t === void 0 ? 64 : +t);
  function a() {
    let i;
    if (r || (r = i = n()), e.apply(this, arguments).draw(r, +t.apply(this, arguments)), i)
      return r = null, i + "" || null;
  }
  return a.type = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : lt(i), a) : e;
  }, a.size = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : lt(+i), a) : t;
  }, a.context = function(i) {
    return arguments.length ? (r = i ?? null, a) : r;
  }, a;
}
function hs() {
}
function As(e, t, r) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + r) / 6
  );
}
function ty(e) {
  this._context = e;
}
ty.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        As(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        As(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function eV(e) {
  return new ty(e);
}
function ry(e) {
  this._context = e;
}
ry.prototype = {
  areaStart: hs,
  areaEnd: hs,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        As(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function tV(e) {
  return new ry(e);
}
function ny(e) {
  this._context = e;
}
ny.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      default:
        As(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function rV(e) {
  return new ny(e);
}
function ay(e) {
  this._context = e;
}
ay.prototype = {
  areaStart: hs,
  areaEnd: hs,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function nV(e) {
  return new ay(e);
}
function yh(e) {
  return e < 0 ? -1 : 1;
}
function wh(e, t, r) {
  var n = e._x1 - e._x0, a = t - e._x1, i = (e._y1 - e._y0) / (n || a < 0 && -0), o = (r - e._y1) / (a || n < 0 && -0), s = (i * a + o * n) / (n + a);
  return (yh(i) + yh(o)) * Math.min(Math.abs(i), Math.abs(o), 0.5 * Math.abs(s)) || 0;
}
function xh(e, t) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
}
function R6(e, t, r) {
  var n = e._x0, a = e._y0, i = e._x1, o = e._y1, s = (i - n) / 3;
  e._context.bezierCurveTo(n + s, a + s * t, i - s, o - s * r, i, o);
}
function ps(e) {
  this._context = e;
}
ps.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        R6(this, this._t0, xh(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var r = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, R6(this, xh(this, r = wh(this, e, t)), r);
          break;
        default:
          R6(this, this._t0, r = wh(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
    }
  }
};
function iy(e) {
  this._context = new oy(e);
}
(iy.prototype = Object.create(ps.prototype)).point = function(e, t) {
  ps.prototype.point.call(this, t, e);
};
function oy(e) {
  this._context = e;
}
oy.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, r, n, a, i) {
    this._context.bezierCurveTo(t, e, n, r, i, a);
  }
};
function aV(e) {
  return new ps(e);
}
function iV(e) {
  return new iy(e);
}
function sy(e) {
  this._context = e;
}
sy.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, r = e.length;
    if (r)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var n = Dh(e), a = Dh(t), i = 0, o = 1; o < r; ++i, ++o)
          this._context.bezierCurveTo(n[0][i], a[0][i], n[1][i], a[1][i], e[o], t[o]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function Dh(e) {
  var t, r = e.length - 1, n, a = new Array(r), i = new Array(r), o = new Array(r);
  for (a[0] = 0, i[0] = 2, o[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t)
    a[t] = 1, i[t] = 4, o[t] = 4 * e[t] + 2 * e[t + 1];
  for (a[r - 1] = 2, i[r - 1] = 7, o[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t)
    n = a[t] / i[t - 1], i[t] -= n, o[t] -= n * o[t - 1];
  for (a[r - 1] = o[r - 1] / i[r - 1], t = r - 2; t >= 0; --t)
    a[t] = (o[t] - a[t + 1]) / i[t];
  for (i[r - 1] = (e[r] + a[r - 1]) / 2, t = 0; t < r - 1; ++t)
    i[t] = 2 * e[t + 1] - a[t + 1];
  return [a, i];
}
function oV(e) {
  return new sy(e);
}
function E0(e, t) {
  this._context = e, this._t = t;
}
E0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var r = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function sV(e) {
  return new E0(e, 0.5);
}
function lV(e) {
  return new E0(e, 0);
}
function cV(e) {
  return new E0(e, 1);
}
function Za(e, t) {
  if ((o = e.length) > 1)
    for (var r = 1, n, a, i = e[t[0]], o, s = i.length; r < o; ++r)
      for (a = i, i = e[t[r]], n = 0; n < s; ++n)
        i[n][1] += i[n][0] = isNaN(a[n][1]) ? a[n][0] : a[n][1];
}
function s5(e) {
  for (var t = e.length, r = new Array(t); --t >= 0; )
    r[t] = t;
  return r;
}
function uV(e, t) {
  return e[t];
}
function dV(e) {
  const t = [];
  return t.key = e, t;
}
function fV() {
  var e = lt([]), t = s5, r = Za, n = uV;
  function a(i) {
    var o = Array.from(e.apply(this, arguments), dV), s, c = o.length, u = -1, d;
    for (const h of i)
      for (s = 0, ++u; s < c; ++s)
        (o[s][u] = [0, +n(h, o[s].key, u, i)]).data = h;
    for (s = 0, d = A9(t(o)); s < c; ++s)
      o[d[s]].index = s;
    return r(o, d), o;
  }
  return a.keys = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : lt(Array.from(i)), a) : e;
  }, a.value = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : lt(+i), a) : n;
  }, a.order = function(i) {
    return arguments.length ? (t = i == null ? s5 : typeof i == "function" ? i : lt(Array.from(i)), a) : t;
  }, a.offset = function(i) {
    return arguments.length ? (r = i ?? Za, a) : r;
  }, a;
}
function hV(e, t) {
  if ((n = e.length) > 0) {
    for (var r, n, a = 0, i = e[0].length, o; a < i; ++a) {
      for (o = r = 0; r < n; ++r)
        o += e[r][a][1] || 0;
      if (o)
        for (r = 0; r < n; ++r)
          e[r][a][1] /= o;
    }
    Za(e, t);
  }
}
function AV(e, t) {
  if ((a = e.length) > 0) {
    for (var r = 0, n = e[t[0]], a, i = n.length; r < i; ++r) {
      for (var o = 0, s = 0; o < a; ++o)
        s += e[o][r][1] || 0;
      n[r][1] += n[r][0] = -s / 2;
    }
    Za(e, t);
  }
}
function pV(e, t) {
  if (!(!((o = e.length) > 0) || !((i = (a = e[t[0]]).length) > 0))) {
    for (var r = 0, n = 1, a, i, o; n < i; ++n) {
      for (var s = 0, c = 0, u = 0; s < o; ++s) {
        for (var d = e[t[s]], h = d[n][1] || 0, A = d[n - 1][1] || 0, p = (h - A) / 2, v = 0; v < s; ++v) {
          var g = e[t[v]], m = g[n][1] || 0, b = g[n - 1][1] || 0;
          p += m - b;
        }
        c += h, u += p * h;
      }
      a[n - 1][1] += a[n - 1][0] = r, c && (r -= u / c);
    }
    a[n - 1][1] += a[n - 1][0] = r, Za(e, t);
  }
}
function ro(e) {
  "@babel/helpers - typeof";
  return ro = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ro(e);
}
var gV = ["type", "size", "sizeType"];
function l5() {
  return l5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, l5.apply(this, arguments);
}
function Oh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Mh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Oh(Object(r), !0).forEach(function(n) {
      vV(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Oh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function vV(e, t, r) {
  return t = mV(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function mV(e) {
  var t = CV(e, "string");
  return ro(t) == "symbol" ? t : String(t);
}
function CV(e, t) {
  if (ro(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ro(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function bV(e, t) {
  if (e == null)
    return {};
  var r = yV(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function yV(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var ly = {
  symbolCircle: p9,
  symbolCross: kk,
  symbolDiamond: Gk,
  symbolSquare: Wk,
  symbolStar: Kk,
  symbolTriangle: zk,
  symbolWye: Xk
}, wV = Math.PI / 180, xV = function(t) {
  var r = "symbol".concat(D0(t));
  return ly[r] || p9;
}, DV = function(t, r, n) {
  if (r === "area")
    return t;
  switch (n) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var a = 18 * wV;
      return 1.25 * t * t * (Math.tan(a) - Math.tan(a * 2) * Math.pow(Math.tan(a), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, OV = function(t, r) {
  ly["symbol".concat(D0(t))] = r;
}, S0 = function(t) {
  var r = t.type, n = r === void 0 ? "circle" : r, a = t.size, i = a === void 0 ? 64 : a, o = t.sizeType, s = o === void 0 ? "area" : o, c = bV(t, gV), u = Mh(Mh({}, c), {}, {
    type: n,
    size: i,
    sizeType: s
  }), d = function() {
    var m = xV(n), b = Jk().type(m).size(DV(i, s, n));
    return b();
  }, h = u.className, A = u.cx, p = u.cy, v = pe(u, !0);
  return A === +A && p === +p && i === +i ? /* @__PURE__ */ P.createElement("path", l5({}, v, {
    className: Pe("recharts-symbols", h),
    transform: "translate(".concat(A, ", ").concat(p, ")"),
    d: d()
  })) : null;
};
S0.registerSymbol = OV;
function Ka(e) {
  "@babel/helpers - typeof";
  return Ka = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ka(e);
}
function c5() {
  return c5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, c5.apply(this, arguments);
}
function Eh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function MV(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Eh(Object(r), !0).forEach(function(n) {
      no(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Eh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function EV(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Sh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uy(n.key), n);
  }
}
function SV(e, t, r) {
  return t && Sh(e.prototype, t), r && Sh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function PV(e, t, r) {
  return t = gs(t), jV(e, cy() ? Reflect.construct(t, r || [], gs(e).constructor) : t.apply(e, r));
}
function jV(e, t) {
  if (t && (Ka(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return IV(e);
}
function IV(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function cy() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (cy = function() {
    return !!e;
  })();
}
function gs(e) {
  return gs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, gs(e);
}
function BV(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && u5(e, t);
}
function u5(e, t) {
  return u5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, u5(e, t);
}
function no(e, t, r) {
  return t = uy(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function uy(e) {
  var t = NV(e, "string");
  return Ka(t) == "symbol" ? t : String(t);
}
function NV(e, t) {
  if (Ka(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ka(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wr = 32, g9 = /* @__PURE__ */ function(e) {
  BV(t, e);
  function t() {
    return EV(this, t), PV(this, t, arguments);
  }
  return SV(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(n) {
        var a = this.props.inactiveColor, i = wr / 2, o = wr / 6, s = wr / 3, c = n.inactive ? a : n.color;
        if (n.type === "plainline")
          return /* @__PURE__ */ P.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: c,
            strokeDasharray: n.payload.strokeDasharray,
            x1: 0,
            y1: i,
            x2: wr,
            y2: i,
            className: "recharts-legend-icon"
          });
        if (n.type === "line")
          return /* @__PURE__ */ P.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: c,
            d: "M0,".concat(i, "h").concat(s, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(2 * s, ",").concat(i, `
            H`).concat(wr, "M").concat(2 * s, ",").concat(i, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(s, ",").concat(i),
            className: "recharts-legend-icon"
          });
        if (n.type === "rect")
          return /* @__PURE__ */ P.createElement("path", {
            stroke: "none",
            fill: c,
            d: "M0,".concat(wr / 8, "h").concat(wr, "v").concat(wr * 3 / 4, "h").concat(-wr, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ P.isValidElement(n.legendIcon)) {
          var u = MV({}, n);
          return delete u.legendIcon, /* @__PURE__ */ P.cloneElement(n.legendIcon, u);
        }
        return /* @__PURE__ */ P.createElement(S0, {
          fill: c,
          cx: i,
          cy: i,
          size: wr,
          sizeType: "diameter",
          type: n.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var n = this, a = this.props, i = a.payload, o = a.iconSize, s = a.layout, c = a.formatter, u = a.inactiveColor, d = {
        x: 0,
        y: 0,
        width: wr,
        height: wr
      }, h = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, A = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return i.map(function(p, v) {
        var g = p.formatter || c, m = Pe(no(no({
          "recharts-legend-item": !0
        }, "legend-item-".concat(v), !0), "inactive", p.inactive));
        if (p.type === "none")
          return null;
        var b = xe(p.value) ? null : p.value;
        Gr(
          !xe(p.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var w = p.inactive ? u : p.color;
        return /* @__PURE__ */ P.createElement("li", c5({
          className: m,
          style: h,
          key: "legend-item-".concat(v)
        }, s1(n.props, p, v)), /* @__PURE__ */ P.createElement(e5, {
          width: o,
          height: o,
          viewBox: d,
          style: A
        }, n.renderIcon(p)), /* @__PURE__ */ P.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: w
          }
        }, g ? g(b, p, v) : b));
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.payload, i = n.layout, o = n.align;
      if (!a || !a.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: i === "horizontal" ? o : "left"
      };
      return /* @__PURE__ */ P.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]), t;
}(mr);
no(g9, "displayName", "Legend");
no(g9, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var LV = y0;
function TV() {
  this.__data__ = new LV(), this.size = 0;
}
var _V = TV;
function RV(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var FV = RV;
function $V(e) {
  return this.__data__.get(e);
}
var HV = $V;
function YV(e) {
  return this.__data__.has(e);
}
var kV = YV, VV = y0, GV = o9, WV = s9, QV = 200;
function UV(e, t) {
  var r = this.__data__;
  if (r instanceof VV) {
    var n = r.__data__;
    if (!GV || n.length < QV - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new WV(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var ZV = UV, KV = y0, zV = _V, qV = FV, XV = HV, JV = kV, eG = ZV;
function M2(e) {
  var t = this.__data__ = new KV(e);
  this.size = t.size;
}
M2.prototype.clear = zV;
M2.prototype.delete = qV;
M2.prototype.get = XV;
M2.prototype.has = JV;
M2.prototype.set = eG;
var dy = M2, tG = "__lodash_hash_undefined__";
function rG(e) {
  return this.__data__.set(e, tG), this;
}
var nG = rG;
function aG(e) {
  return this.__data__.has(e);
}
var iG = aG, oG = s9, sG = nG, lG = iG;
function vs(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new oG(); ++t < r; )
    this.add(e[t]);
}
vs.prototype.add = vs.prototype.push = sG;
vs.prototype.has = lG;
var fy = vs;
function cG(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var hy = cG;
function uG(e, t) {
  return e.has(t);
}
var Ay = uG, dG = fy, fG = hy, hG = Ay, AG = 1, pG = 2;
function gG(e, t, r, n, a, i) {
  var o = r & AG, s = e.length, c = t.length;
  if (s != c && !(o && c > s))
    return !1;
  var u = i.get(e), d = i.get(t);
  if (u && d)
    return u == t && d == e;
  var h = -1, A = !0, p = r & pG ? new dG() : void 0;
  for (i.set(e, t), i.set(t, e); ++h < s; ) {
    var v = e[h], g = t[h];
    if (n)
      var m = o ? n(g, v, h, t, e, i) : n(v, g, h, e, t, i);
    if (m !== void 0) {
      if (m)
        continue;
      A = !1;
      break;
    }
    if (p) {
      if (!fG(t, function(b, w) {
        if (!hG(p, w) && (v === b || a(v, b, r, n, i)))
          return p.push(w);
      })) {
        A = !1;
        break;
      }
    } else if (!(v === g || a(v, g, r, n, i))) {
      A = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), A;
}
var py = gG, vG = fn, mG = vG.Uint8Array, CG = mG;
function bG(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var yG = bG;
function wG(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var v9 = wG, Ph = Uo, jh = CG, xG = i9, DG = py, OG = yG, MG = v9, EG = 1, SG = 2, PG = "[object Boolean]", jG = "[object Date]", IG = "[object Error]", BG = "[object Map]", NG = "[object Number]", LG = "[object RegExp]", TG = "[object Set]", _G = "[object String]", RG = "[object Symbol]", FG = "[object ArrayBuffer]", $G = "[object DataView]", Ih = Ph ? Ph.prototype : void 0, F6 = Ih ? Ih.valueOf : void 0;
function HG(e, t, r, n, a, i, o) {
  switch (r) {
    case $G:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case FG:
      return !(e.byteLength != t.byteLength || !i(new jh(e), new jh(t)));
    case PG:
    case jG:
    case NG:
      return xG(+e, +t);
    case IG:
      return e.name == t.name && e.message == t.message;
    case LG:
    case _G:
      return e == t + "";
    case BG:
      var s = OG;
    case TG:
      var c = n & EG;
      if (s || (s = MG), e.size != t.size && !c)
        return !1;
      var u = o.get(e);
      if (u)
        return u == t;
      n |= SG, o.set(e, t);
      var d = DG(s(e), s(t), n, a, i, o);
      return o.delete(e), d;
    case RG:
      if (F6)
        return F6.call(e) == F6.call(t);
  }
  return !1;
}
var YG = HG;
function kG(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var gy = kG, VG = gy, GG = ir;
function WG(e, t, r) {
  var n = t(e);
  return GG(e) ? n : VG(n, r(e));
}
var QG = WG;
function UG(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
var ZG = UG;
function KG() {
  return [];
}
var zG = KG, qG = ZG, XG = zG, JG = Object.prototype, eW = JG.propertyIsEnumerable, Bh = Object.getOwnPropertySymbols, tW = Bh ? function(e) {
  return e == null ? [] : (e = Object(e), qG(Bh(e), function(t) {
    return eW.call(e, t);
  }));
} : XG, rW = tW;
function nW(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var aW = nW, iW = Pn, oW = jn, sW = "[object Arguments]";
function lW(e) {
  return oW(e) && iW(e) == sW;
}
var cW = lW, Nh = cW, uW = jn, vy = Object.prototype, dW = vy.hasOwnProperty, fW = vy.propertyIsEnumerable, hW = Nh(function() {
  return arguments;
}()) ? Nh : function(e) {
  return uW(e) && dW.call(e, "callee") && !fW.call(e, "callee");
}, m9 = hW, ms = { exports: {} };
function AW() {
  return !1;
}
var pW = AW;
ms.exports;
(function(e, t) {
  var r = fn, n = pW, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? r.Buffer : void 0, c = s ? s.isBuffer : void 0, u = c || n;
  e.exports = u;
})(ms, ms.exports);
var my = ms.exports, gW = 9007199254740991, vW = /^(?:0|[1-9]\d*)$/;
function mW(e, t) {
  var r = typeof e;
  return t = t ?? gW, !!t && (r == "number" || r != "symbol" && vW.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var C9 = mW, CW = 9007199254740991;
function bW(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= CW;
}
var b9 = bW, yW = Pn, wW = b9, xW = jn, DW = "[object Arguments]", OW = "[object Array]", MW = "[object Boolean]", EW = "[object Date]", SW = "[object Error]", PW = "[object Function]", jW = "[object Map]", IW = "[object Number]", BW = "[object Object]", NW = "[object RegExp]", LW = "[object Set]", TW = "[object String]", _W = "[object WeakMap]", RW = "[object ArrayBuffer]", FW = "[object DataView]", $W = "[object Float32Array]", HW = "[object Float64Array]", YW = "[object Int8Array]", kW = "[object Int16Array]", VW = "[object Int32Array]", GW = "[object Uint8Array]", WW = "[object Uint8ClampedArray]", QW = "[object Uint16Array]", UW = "[object Uint32Array]", ht = {};
ht[$W] = ht[HW] = ht[YW] = ht[kW] = ht[VW] = ht[GW] = ht[WW] = ht[QW] = ht[UW] = !0;
ht[DW] = ht[OW] = ht[RW] = ht[MW] = ht[FW] = ht[EW] = ht[SW] = ht[PW] = ht[jW] = ht[IW] = ht[BW] = ht[NW] = ht[LW] = ht[TW] = ht[_W] = !1;
function ZW(e) {
  return xW(e) && wW(e.length) && !!ht[yW(e)];
}
var KW = ZW;
function zW(e) {
  return function(t) {
    return e(t);
  };
}
var Cy = zW, Cs = { exports: {} };
Cs.exports;
(function(e, t) {
  var r = Sb, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, s = function() {
    try {
      var c = a && a.require && a.require("util").types;
      return c || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(Cs, Cs.exports);
var qW = Cs.exports, XW = KW, JW = Cy, Lh = qW, Th = Lh && Lh.isTypedArray, eQ = Th ? JW(Th) : XW, by = eQ, tQ = aW, rQ = m9, nQ = ir, aQ = my, iQ = C9, oQ = by, sQ = Object.prototype, lQ = sQ.hasOwnProperty;
function cQ(e, t) {
  var r = nQ(e), n = !r && rQ(e), a = !r && !n && aQ(e), i = !r && !n && !a && oQ(e), o = r || n || a || i, s = o ? tQ(e.length, String) : [], c = s.length;
  for (var u in e)
    (t || lQ.call(e, u)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    iQ(u, c))) && s.push(u);
  return s;
}
var uQ = cQ, dQ = Object.prototype;
function fQ(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || dQ;
  return e === r;
}
var hQ = fQ;
function AQ(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var yy = AQ, pQ = yy, gQ = pQ(Object.keys, Object), vQ = gQ, mQ = hQ, CQ = vQ, bQ = Object.prototype, yQ = bQ.hasOwnProperty;
function wQ(e) {
  if (!mQ(e))
    return CQ(e);
  var t = [];
  for (var r in Object(e))
    yQ.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var xQ = wQ, DQ = a9, OQ = b9;
function MQ(e) {
  return e != null && OQ(e.length) && !DQ(e);
}
var Ko = MQ, EQ = uQ, SQ = xQ, PQ = Ko;
function jQ(e) {
  return PQ(e) ? EQ(e) : SQ(e);
}
var P0 = jQ, IQ = QG, BQ = rW, NQ = P0;
function LQ(e) {
  return IQ(e, NQ, BQ);
}
var TQ = LQ, _h = TQ, _Q = 1, RQ = Object.prototype, FQ = RQ.hasOwnProperty;
function $Q(e, t, r, n, a, i) {
  var o = r & _Q, s = _h(e), c = s.length, u = _h(t), d = u.length;
  if (c != d && !o)
    return !1;
  for (var h = c; h--; ) {
    var A = s[h];
    if (!(o ? A in t : FQ.call(t, A)))
      return !1;
  }
  var p = i.get(e), v = i.get(t);
  if (p && v)
    return p == t && v == e;
  var g = !0;
  i.set(e, t), i.set(t, e);
  for (var m = o; ++h < c; ) {
    A = s[h];
    var b = e[A], w = t[A];
    if (n)
      var x = o ? n(w, b, A, t, e, i) : n(b, w, A, e, t, i);
    if (!(x === void 0 ? b === w || a(b, w, r, n, i) : x)) {
      g = !1;
      break;
    }
    m || (m = A == "constructor");
  }
  if (g && !m) {
    var y = e.constructor, C = t.constructor;
    y != C && "constructor" in e && "constructor" in t && !(typeof y == "function" && y instanceof y && typeof C == "function" && C instanceof C) && (g = !1);
  }
  return i.delete(e), i.delete(t), g;
}
var HQ = $Q, YQ = aa, kQ = fn, VQ = YQ(kQ, "DataView"), GQ = VQ, WQ = aa, QQ = fn, UQ = WQ(QQ, "Promise"), ZQ = UQ, KQ = aa, zQ = fn, qQ = KQ(zQ, "Set"), wy = qQ, XQ = aa, JQ = fn, eU = XQ(JQ, "WeakMap"), tU = eU, d5 = GQ, f5 = o9, h5 = ZQ, A5 = wy, p5 = tU, xy = Pn, E2 = jb, Rh = "[object Map]", rU = "[object Object]", Fh = "[object Promise]", $h = "[object Set]", Hh = "[object WeakMap]", Yh = "[object DataView]", nU = E2(d5), aU = E2(f5), iU = E2(h5), oU = E2(A5), sU = E2(p5), F1 = xy;
(d5 && F1(new d5(new ArrayBuffer(1))) != Yh || f5 && F1(new f5()) != Rh || h5 && F1(h5.resolve()) != Fh || A5 && F1(new A5()) != $h || p5 && F1(new p5()) != Hh) && (F1 = function(e) {
  var t = xy(e), r = t == rU ? e.constructor : void 0, n = r ? E2(r) : "";
  if (n)
    switch (n) {
      case nU:
        return Yh;
      case aU:
        return Rh;
      case iU:
        return Fh;
      case oU:
        return $h;
      case sU:
        return Hh;
    }
  return t;
});
var lU = F1, $6 = dy, cU = py, uU = YG, dU = HQ, kh = lU, Vh = ir, Gh = my, fU = by, hU = 1, Wh = "[object Arguments]", Qh = "[object Array]", M3 = "[object Object]", AU = Object.prototype, Uh = AU.hasOwnProperty;
function pU(e, t, r, n, a, i) {
  var o = Vh(e), s = Vh(t), c = o ? Qh : kh(e), u = s ? Qh : kh(t);
  c = c == Wh ? M3 : c, u = u == Wh ? M3 : u;
  var d = c == M3, h = u == M3, A = c == u;
  if (A && Gh(e)) {
    if (!Gh(t))
      return !1;
    o = !0, d = !1;
  }
  if (A && !d)
    return i || (i = new $6()), o || fU(e) ? cU(e, t, r, n, a, i) : uU(e, t, c, r, n, a, i);
  if (!(r & hU)) {
    var p = d && Uh.call(e, "__wrapped__"), v = h && Uh.call(t, "__wrapped__");
    if (p || v) {
      var g = p ? e.value() : e, m = v ? t.value() : t;
      return i || (i = new $6()), a(g, m, r, n, i);
    }
  }
  return A ? (i || (i = new $6()), dU(e, t, r, n, a, i)) : !1;
}
var gU = pU, vU = gU, Zh = jn;
function Dy(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !Zh(e) && !Zh(t) ? e !== e && t !== t : vU(e, t, r, n, Dy, a);
}
var y9 = Dy, mU = dy, CU = y9, bU = 1, yU = 2;
function wU(e, t, r, n) {
  var a = r.length, i = a, o = !n;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var s = r[a];
    if (o && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    s = r[a];
    var c = s[0], u = e[c], d = s[1];
    if (o && s[2]) {
      if (u === void 0 && !(c in e))
        return !1;
    } else {
      var h = new mU();
      if (n)
        var A = n(u, d, c, e, t, h);
      if (!(A === void 0 ? CU(d, u, bU | yU, n, h) : A))
        return !1;
    }
  }
  return !0;
}
var xU = wU, DU = A1;
function OU(e) {
  return e === e && !DU(e);
}
var Oy = OU, MU = Oy, EU = P0;
function SU(e) {
  for (var t = EU(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, MU(a)];
  }
  return t;
}
var PU = SU;
function jU(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var My = jU, IU = xU, BU = PU, NU = My;
function LU(e) {
  var t = BU(e);
  return t.length == 1 && t[0][2] ? NU(t[0][0], t[0][1]) : function(r) {
    return r === e || IU(r, e, t);
  };
}
var TU = LU;
function _U(e, t) {
  return e != null && t in Object(e);
}
var RU = _U, FU = Tb, $U = m9, HU = ir, YU = C9, kU = b9, VU = x0;
function GU(e, t, r) {
  t = FU(t, e);
  for (var n = -1, a = t.length, i = !1; ++n < a; ) {
    var o = VU(t[n]);
    if (!(i = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && kU(a) && YU(o, a) && (HU(e) || $U(e)));
}
var WU = GU, QU = RU, UU = WU;
function ZU(e, t) {
  return e != null && UU(e, t, QU);
}
var KU = ZU, zU = y9, qU = _b, XU = KU, JU = n9, eZ = Oy, tZ = My, rZ = x0, nZ = 1, aZ = 2;
function iZ(e, t) {
  return JU(e) && eZ(t) ? tZ(rZ(e), t) : function(r) {
    var n = qU(r, e);
    return n === void 0 && n === t ? XU(r, e) : zU(t, n, nZ | aZ);
  };
}
var oZ = iZ;
function sZ(e) {
  return e;
}
var S2 = sZ;
function lZ(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var cZ = lZ, uZ = u9;
function dZ(e) {
  return function(t) {
    return uZ(t, e);
  };
}
var fZ = dZ, hZ = cZ, AZ = fZ, pZ = n9, gZ = x0;
function vZ(e) {
  return pZ(e) ? hZ(gZ(e)) : AZ(e);
}
var mZ = vZ, CZ = TU, bZ = oZ, yZ = S2, wZ = ir, xZ = mZ;
function DZ(e) {
  return typeof e == "function" ? e : e == null ? yZ : typeof e == "object" ? wZ(e) ? bZ(e[0], e[1]) : CZ(e) : xZ(e);
}
var hn = DZ;
function OZ(e, t, r, n) {
  for (var a = e.length, i = r + (n ? 1 : -1); n ? i-- : ++i < a; )
    if (t(e[i], i, e))
      return i;
  return -1;
}
var Ey = OZ;
function MZ(e) {
  return e !== e;
}
var EZ = MZ;
function SZ(e, t, r) {
  for (var n = r - 1, a = e.length; ++n < a; )
    if (e[n] === t)
      return n;
  return -1;
}
var PZ = SZ, jZ = Ey, IZ = EZ, BZ = PZ;
function NZ(e, t, r) {
  return t === t ? BZ(e, t, r) : jZ(e, IZ, r);
}
var LZ = NZ, TZ = LZ;
function _Z(e, t) {
  var r = e == null ? 0 : e.length;
  return !!r && TZ(e, t, 0) > -1;
}
var RZ = _Z;
function FZ(e, t, r) {
  for (var n = -1, a = e == null ? 0 : e.length; ++n < a; )
    if (r(t, e[n]))
      return !0;
  return !1;
}
var $Z = FZ;
function HZ() {
}
var YZ = HZ, H6 = wy, kZ = YZ, VZ = v9, GZ = 1 / 0, WZ = H6 && 1 / VZ(new H6([, -0]))[1] == GZ ? function(e) {
  return new H6(e);
} : kZ, QZ = WZ, UZ = fy, ZZ = RZ, KZ = $Z, zZ = Ay, qZ = QZ, XZ = v9, JZ = 200;
function eK(e, t, r) {
  var n = -1, a = ZZ, i = e.length, o = !0, s = [], c = s;
  if (r)
    o = !1, a = KZ;
  else if (i >= JZ) {
    var u = t ? null : qZ(e);
    if (u)
      return XZ(u);
    o = !1, a = zZ, c = new UZ();
  } else
    c = t ? [] : s;
  e:
    for (; ++n < i; ) {
      var d = e[n], h = t ? t(d) : d;
      if (d = r || d !== 0 ? d : 0, o && h === h) {
        for (var A = c.length; A--; )
          if (c[A] === h)
            continue e;
        t && c.push(h), s.push(d);
      } else
        a(c, h, r) || (c !== s && c.push(h), s.push(d));
    }
  return s;
}
var tK = eK, rK = hn, nK = tK;
function aK(e, t) {
  return e && e.length ? nK(e, rK(t)) : [];
}
var iK = aK;
const Kh = /* @__PURE__ */ Xe(iK);
function Sy(e, t, r) {
  return t === !0 ? Kh(e, r) : xe(t) ? Kh(e, t) : e;
}
function za(e) {
  "@babel/helpers - typeof";
  return za = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, za(e);
}
var oK = ["ref"];
function zh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function E1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zh(Object(r), !0).forEach(function(n) {
      j0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function sK(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Iy(n.key), n);
  }
}
function lK(e, t, r) {
  return t && qh(e.prototype, t), r && qh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function cK(e, t, r) {
  return t = bs(t), uK(e, Py() ? Reflect.construct(t, r || [], bs(e).constructor) : t.apply(e, r));
}
function uK(e, t) {
  if (t && (za(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return jy(e);
}
function Py() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Py = function() {
    return !!e;
  })();
}
function bs(e) {
  return bs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, bs(e);
}
function jy(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function dK(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && g5(e, t);
}
function g5(e, t) {
  return g5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, g5(e, t);
}
function j0(e, t, r) {
  return t = Iy(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Iy(e) {
  var t = fK(e, "string");
  return za(t) == "symbol" ? t : String(t);
}
function fK(e, t) {
  if (za(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (za(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function hK(e, t) {
  if (e == null)
    return {};
  var r = AK(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function AK(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function pK(e) {
  return e.value;
}
function gK(e, t) {
  if (/* @__PURE__ */ P.isValidElement(e))
    return /* @__PURE__ */ P.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ P.createElement(e, t);
  t.ref;
  var r = hK(t, oK);
  return /* @__PURE__ */ P.createElement(g9, r);
}
var Xh = 1, l1 = /* @__PURE__ */ function(e) {
  dK(t, e);
  function t() {
    var r;
    sK(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = cK(this, t, [].concat(a)), j0(jy(r), "lastBoundingBox", {
      width: -1,
      height: -1
    }), r;
  }
  return lK(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var n = this.props.onBBoxUpdate, a = this.getBBox();
      a ? (Math.abs(a.width - this.lastBoundingBox.width) > Xh || Math.abs(a.height - this.lastBoundingBox.height) > Xh) && (this.lastBoundingBox.width = a.width, this.lastBoundingBox.height = a.height, n && n(a)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? E1({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(n) {
      var a = this.props, i = a.layout, o = a.align, s = a.verticalAlign, c = a.margin, u = a.chartWidth, d = a.chartHeight, h, A;
      if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
        if (o === "center" && i === "vertical") {
          var p = this.getBBoxSnapshot();
          h = {
            left: ((u || 0) - p.width) / 2
          };
        } else
          h = o === "right" ? {
            right: c && c.right || 0
          } : {
            left: c && c.left || 0
          };
      if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
        if (s === "middle") {
          var v = this.getBBoxSnapshot();
          A = {
            top: ((d || 0) - v.height) / 2
          };
        } else
          A = s === "bottom" ? {
            bottom: c && c.bottom || 0
          } : {
            top: c && c.top || 0
          };
      return E1(E1({}, h), A);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.content, o = a.width, s = a.height, c = a.wrapperStyle, u = a.payloadUniqBy, d = a.payload, h = E1(E1({
        position: "absolute",
        width: o || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(c)), c);
      return /* @__PURE__ */ P.createElement("div", {
        className: "recharts-legend-wrapper",
        style: h,
        ref: function(p) {
          n.wrapperNode = p;
        }
      }, gK(i, E1(E1({}, this.props), {}, {
        payload: Sy(d, u, pK)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(n, a) {
      var i = n.props.layout;
      return i === "vertical" && le(n.props.height) ? {
        height: n.props.height
      } : i === "horizontal" ? {
        width: n.props.width || a
      } : null;
    }
  }]), t;
}(mr);
j0(l1, "displayName", "Legend");
j0(l1, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var Jh = Uo, vK = m9, mK = ir, eA = Jh ? Jh.isConcatSpreadable : void 0;
function CK(e) {
  return mK(e) || vK(e) || !!(eA && e && e[eA]);
}
var bK = CK, yK = gy, wK = bK;
function By(e, t, r, n, a) {
  var i = -1, o = e.length;
  for (r || (r = wK), a || (a = []); ++i < o; ) {
    var s = e[i];
    t > 0 && r(s) ? t > 1 ? By(s, t - 1, r, n, a) : yK(a, s) : n || (a[a.length] = s);
  }
  return a;
}
var Ny = By;
function xK(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), o = n(t), s = o.length; s--; ) {
      var c = o[e ? s : ++a];
      if (r(i[c], c, i) === !1)
        break;
    }
    return t;
  };
}
var DK = xK, OK = DK, MK = OK(), EK = MK, SK = EK, PK = P0;
function jK(e, t) {
  return e && SK(e, t, PK);
}
var Ly = jK, IK = Ko;
function BK(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!IK(r))
      return e(r, n);
    for (var a = r.length, i = t ? a : -1, o = Object(r); (t ? i-- : ++i < a) && n(o[i], i, o) !== !1; )
      ;
    return r;
  };
}
var NK = BK, LK = Ly, TK = NK, _K = TK(LK), w9 = _K, RK = w9, FK = Ko;
function $K(e, t) {
  var r = -1, n = FK(e) ? Array(e.length) : [];
  return RK(e, function(a, i, o) {
    n[++r] = t(a, i, o);
  }), n;
}
var Ty = $K;
function HK(e, t) {
  var r = e.length;
  for (e.sort(t); r--; )
    e[r] = e[r].value;
  return e;
}
var YK = HK, tA = b2;
function kK(e, t) {
  if (e !== t) {
    var r = e !== void 0, n = e === null, a = e === e, i = tA(e), o = t !== void 0, s = t === null, c = t === t, u = tA(t);
    if (!s && !u && !i && e > t || i && o && c && !s && !u || n && o && c || !r && c || !a)
      return 1;
    if (!n && !i && !u && e < t || u && r && a && !n && !i || s && r && a || !o && a || !c)
      return -1;
  }
  return 0;
}
var VK = kK, GK = VK;
function WK(e, t, r) {
  for (var n = -1, a = e.criteria, i = t.criteria, o = a.length, s = r.length; ++n < o; ) {
    var c = GK(a[n], i[n]);
    if (c) {
      if (n >= s)
        return c;
      var u = r[n];
      return c * (u == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var QK = WK, Y6 = c9, UK = u9, ZK = hn, KK = Ty, zK = YK, qK = Cy, XK = QK, JK = S2, ez = ir;
function tz(e, t, r) {
  t.length ? t = Y6(t, function(i) {
    return ez(i) ? function(o) {
      return UK(o, i.length === 1 ? i[0] : i);
    } : i;
  }) : t = [JK];
  var n = -1;
  t = Y6(t, qK(ZK));
  var a = KK(e, function(i, o, s) {
    var c = Y6(t, function(u) {
      return u(i);
    });
    return { criteria: c, index: ++n, value: i };
  });
  return zK(a, function(i, o) {
    return XK(i, o, r);
  });
}
var rz = tz;
function nz(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var az = nz, iz = az, rA = Math.max;
function oz(e, t, r) {
  return t = rA(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, i = rA(n.length - t, 0), o = Array(i); ++a < i; )
      o[a] = n[t + a];
    a = -1;
    for (var s = Array(t + 1); ++a < t; )
      s[a] = n[a];
    return s[t] = r(o), iz(e, this, s);
  };
}
var sz = oz;
function lz(e) {
  return function() {
    return e;
  };
}
var cz = lz, uz = aa, dz = function() {
  try {
    var e = uz(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), _y = dz, fz = cz, nA = _y, hz = S2, Az = nA ? function(e, t) {
  return nA(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: fz(t),
    writable: !0
  });
} : hz, pz = Az, gz = 800, vz = 16, mz = Date.now;
function Cz(e) {
  var t = 0, r = 0;
  return function() {
    var n = mz(), a = vz - (n - r);
    if (r = n, a > 0) {
      if (++t >= gz)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var bz = Cz, yz = pz, wz = bz, xz = wz(yz), Dz = xz, Oz = S2, Mz = sz, Ez = Dz;
function Sz(e, t) {
  return Ez(Mz(e, t, Oz), e + "");
}
var Pz = Sz, jz = i9, Iz = Ko, Bz = C9, Nz = A1;
function Lz(e, t, r) {
  if (!Nz(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? Iz(r) && Bz(t, r.length) : n == "string" && t in r) ? jz(r[t], e) : !1;
}
var I0 = Lz, Tz = Ny, _z = rz, Rz = Pz, aA = I0, Fz = Rz(function(e, t) {
  if (e == null)
    return [];
  var r = t.length;
  return r > 1 && aA(e, t[0], t[1]) ? t = [] : r > 2 && aA(t[0], t[1], t[2]) && (t = [t[0]]), _z(e, Tz(t, 1), []);
}), $z = Fz;
const x9 = /* @__PURE__ */ Xe($z);
function ao(e) {
  "@babel/helpers - typeof";
  return ao = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ao(e);
}
function v5() {
  return v5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, v5.apply(this, arguments);
}
function Hz(e, t) {
  return Gz(e) || Vz(e, t) || kz(e, t) || Yz();
}
function Yz() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kz(e, t) {
  if (e) {
    if (typeof e == "string")
      return iA(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return iA(e, t);
  }
}
function iA(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Vz(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function Gz(e) {
  if (Array.isArray(e))
    return e;
}
function oA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function k6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? oA(Object(r), !0).forEach(function(n) {
      Wz(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : oA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Wz(e, t, r) {
  return t = Qz(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Qz(e) {
  var t = Uz(e, "string");
  return ao(t) == "symbol" ? t : String(t);
}
function Uz(e, t) {
  if (ao(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ao(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Zz(e) {
  return Array.isArray(e) && jt(e[0]) && jt(e[1]) ? e.join(" ~ ") : e;
}
var Kz = function(t) {
  var r = t.separator, n = r === void 0 ? " : " : r, a = t.contentStyle, i = a === void 0 ? {} : a, o = t.itemStyle, s = o === void 0 ? {} : o, c = t.labelStyle, u = c === void 0 ? {} : c, d = t.payload, h = t.formatter, A = t.itemSorter, p = t.wrapperClassName, v = t.labelClassName, g = t.label, m = t.labelFormatter, b = t.accessibilityLayer, w = b === void 0 ? !1 : b, x = function() {
    if (d && d.length) {
      var R = {
        padding: 0,
        margin: 0
      }, j = (A ? x9(d, A) : d).map(function(U, ee) {
        if (U.type === "none")
          return null;
        var X = k6({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: U.color || "#000"
        }, s), Z = U.formatter || h || Zz, te = U.value, B = U.name, I = te, _ = B;
        if (Z && I != null && _ != null) {
          var L = Z(te, B, U, ee, d);
          if (Array.isArray(L)) {
            var D = Hz(L, 2);
            I = D[0], _ = D[1];
          } else
            I = L;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ P.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(ee),
            style: X
          }, jt(_) ? /* @__PURE__ */ P.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, _) : null, jt(_) ? /* @__PURE__ */ P.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, n) : null, /* @__PURE__ */ P.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, I), /* @__PURE__ */ P.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, U.unit || ""))
        );
      });
      return /* @__PURE__ */ P.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: R
      }, j);
    }
    return null;
  }, y = k6({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, i), C = k6({
    margin: 0
  }, u), O = !ye(g), M = O ? g : "", E = Pe("recharts-default-tooltip", p), N = Pe("recharts-tooltip-label", v);
  O && m && d !== void 0 && d !== null && (M = m(g, d));
  var F = w ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ P.createElement("div", v5({
    className: E,
    style: y
  }, F), /* @__PURE__ */ P.createElement("p", {
    className: N,
    style: C
  }, /* @__PURE__ */ P.isValidElement(M) ? M : "".concat(M)), x());
};
function io(e) {
  "@babel/helpers - typeof";
  return io = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, io(e);
}
function E3(e, t, r) {
  return t = zz(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function zz(e) {
  var t = qz(e, "string");
  return io(t) == "symbol" ? t : String(t);
}
function qz(e, t) {
  if (io(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (io(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var li = "recharts-tooltip-wrapper", Xz = {
  visibility: "hidden"
};
function Jz(e) {
  var t = e.coordinate, r = e.translateX, n = e.translateY;
  return Pe(li, E3(E3(E3(E3({}, "".concat(li, "-right"), le(r) && t && le(t.x) && r >= t.x), "".concat(li, "-left"), le(r) && t && le(t.x) && r < t.x), "".concat(li, "-bottom"), le(n) && t && le(t.y) && n >= t.y), "".concat(li, "-top"), le(n) && t && le(t.y) && n < t.y));
}
function sA(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.key, a = e.offsetTopLeft, i = e.position, o = e.reverseDirection, s = e.tooltipDimension, c = e.viewBox, u = e.viewBoxDimension;
  if (i && le(i[n]))
    return i[n];
  var d = r[n] - s - a, h = r[n] + a;
  if (t[n])
    return o[n] ? d : h;
  if (o[n]) {
    var A = d, p = c[n];
    return A < p ? Math.max(h, c[n]) : Math.max(d, c[n]);
  }
  var v = h + s, g = c[n] + u;
  return v > g ? Math.max(d, c[n]) : Math.max(h, c[n]);
}
function eq(e) {
  var t = e.translateX, r = e.translateY, n = e.useTranslate3d;
  return {
    transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
  };
}
function tq(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.offsetTopLeft, a = e.position, i = e.reverseDirection, o = e.tooltipBox, s = e.useTranslate3d, c = e.viewBox, u, d, h;
  return o.height > 0 && o.width > 0 && r ? (d = sA({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "x",
    offsetTopLeft: n,
    position: a,
    reverseDirection: i,
    tooltipDimension: o.width,
    viewBox: c,
    viewBoxDimension: c.width
  }), h = sA({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "y",
    offsetTopLeft: n,
    position: a,
    reverseDirection: i,
    tooltipDimension: o.height,
    viewBox: c,
    viewBoxDimension: c.height
  }), u = eq({
    translateX: d,
    translateY: h,
    useTranslate3d: s
  })) : u = Xz, {
    cssProperties: u,
    cssClasses: Jz({
      translateX: d,
      translateY: h,
      coordinate: r
    })
  };
}
function qa(e) {
  "@babel/helpers - typeof";
  return qa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qa(e);
}
function lA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function cA(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lA(Object(r), !0).forEach(function(n) {
      b5(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : lA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function rq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function uA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Fy(n.key), n);
  }
}
function nq(e, t, r) {
  return t && uA(e.prototype, t), r && uA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function aq(e, t, r) {
  return t = ys(t), iq(e, Ry() ? Reflect.construct(t, r || [], ys(e).constructor) : t.apply(e, r));
}
function iq(e, t) {
  if (t && (qa(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return m5(e);
}
function Ry() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ry = function() {
    return !!e;
  })();
}
function ys(e) {
  return ys = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ys(e);
}
function m5(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function oq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && C5(e, t);
}
function C5(e, t) {
  return C5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, C5(e, t);
}
function b5(e, t, r) {
  return t = Fy(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Fy(e) {
  var t = sq(e, "string");
  return qa(t) == "symbol" ? t : String(t);
}
function sq(e, t) {
  if (qa(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (qa(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var dA = 1, lq = /* @__PURE__ */ function(e) {
  oq(t, e);
  function t() {
    var r;
    rq(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = aq(this, t, [].concat(a)), b5(m5(r), "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), b5(m5(r), "handleKeyDown", function(o) {
      if (o.key === "Escape") {
        var s, c, u, d;
        r.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (c = r.props.coordinate) === null || c === void 0 ? void 0 : c.x) !== null && s !== void 0 ? s : 0,
            y: (u = (d = r.props.coordinate) === null || d === void 0 ? void 0 : d.y) !== null && u !== void 0 ? u : 0
          }
        });
      }
    }), r;
  }
  return nq(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        (Math.abs(n.width - this.state.lastBoundingBox.width) > dA || Math.abs(n.height - this.state.lastBoundingBox.height) > dA) && this.setState({
          lastBoundingBox: {
            width: n.width,
            height: n.height
          }
        });
      } else
        (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
          lastBoundingBox: {
            width: -1,
            height: -1
          }
        });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var n, a;
      this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((a = this.props.coordinate) === null || a === void 0 ? void 0 : a.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.active, o = a.allowEscapeViewBox, s = a.animationDuration, c = a.animationEasing, u = a.children, d = a.coordinate, h = a.hasPayload, A = a.isAnimationActive, p = a.offset, v = a.position, g = a.reverseDirection, m = a.useTranslate3d, b = a.viewBox, w = a.wrapperStyle, x = tq({
        allowEscapeViewBox: o,
        coordinate: d,
        offsetTopLeft: p,
        position: v,
        reverseDirection: g,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: m,
        viewBox: b
      }), y = x.cssClasses, C = x.cssProperties, O = cA(cA({
        transition: A && i ? "transform ".concat(s, "ms ").concat(c) : void 0
      }, C), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && i && h ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, w);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ P.createElement("div", {
          tabIndex: -1,
          className: y,
          style: O,
          ref: function(E) {
            n.wrapperNode = E;
          }
        }, u)
      );
    }
  }]), t;
}(mr), cq = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, Ir = {
  isSsr: cq(),
  get: function(t) {
    return Ir[t];
  },
  set: function(t, r) {
    if (typeof t == "string")
      Ir[t] = r;
    else {
      var n = Object.keys(t);
      n && n.length && n.forEach(function(a) {
        Ir[a] = t[a];
      });
    }
  }
};
function Xa(e) {
  "@babel/helpers - typeof";
  return Xa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xa(e);
}
function fA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hA(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fA(Object(r), !0).forEach(function(n) {
      D9(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function uq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function AA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Hy(n.key), n);
  }
}
function dq(e, t, r) {
  return t && AA(e.prototype, t), r && AA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function fq(e, t, r) {
  return t = ws(t), hq(e, $y() ? Reflect.construct(t, r || [], ws(e).constructor) : t.apply(e, r));
}
function hq(e, t) {
  if (t && (Xa(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Aq(e);
}
function Aq(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $y() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return ($y = function() {
    return !!e;
  })();
}
function ws(e) {
  return ws = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ws(e);
}
function pq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && y5(e, t);
}
function y5(e, t) {
  return y5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, y5(e, t);
}
function D9(e, t, r) {
  return t = Hy(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Hy(e) {
  var t = gq(e, "string");
  return Xa(t) == "symbol" ? t : String(t);
}
function gq(e, t) {
  if (Xa(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Xa(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function vq(e) {
  return e.dataKey;
}
function mq(e, t) {
  return /* @__PURE__ */ P.isValidElement(e) ? /* @__PURE__ */ P.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ P.createElement(e, t) : /* @__PURE__ */ P.createElement(Kz, t);
}
var zt = /* @__PURE__ */ function(e) {
  pq(t, e);
  function t() {
    return uq(this, t), fq(this, t, arguments);
  }
  return dq(t, [{
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.active, o = a.allowEscapeViewBox, s = a.animationDuration, c = a.animationEasing, u = a.content, d = a.coordinate, h = a.filterNull, A = a.isAnimationActive, p = a.offset, v = a.payload, g = a.payloadUniqBy, m = a.position, b = a.reverseDirection, w = a.useTranslate3d, x = a.viewBox, y = a.wrapperStyle, C = v ?? [];
      h && C.length && (C = Sy(v.filter(function(M) {
        return M.value != null && (M.hide !== !0 || n.props.includeHidden);
      }), g, vq));
      var O = C.length > 0;
      return /* @__PURE__ */ P.createElement(lq, {
        allowEscapeViewBox: o,
        animationDuration: s,
        animationEasing: c,
        isAnimationActive: A,
        active: i,
        coordinate: d,
        hasPayload: O,
        offset: p,
        position: m,
        reverseDirection: b,
        useTranslate3d: w,
        viewBox: x,
        wrapperStyle: y
      }, mq(u, hA(hA({}, this.props), {}, {
        payload: C
      })));
    }
  }]), t;
}(mr);
D9(zt, "displayName", "Tooltip");
D9(zt, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !Ir.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var Cq = fn, bq = function() {
  return Cq.Date.now();
}, yq = bq, wq = /\s/;
function xq(e) {
  for (var t = e.length; t-- && wq.test(e.charAt(t)); )
    ;
  return t;
}
var Dq = xq, Oq = Dq, Mq = /^\s+/;
function Eq(e) {
  return e && e.slice(0, Oq(e) + 1).replace(Mq, "");
}
var Sq = Eq, Pq = Sq, pA = A1, jq = b2, gA = 0 / 0, Iq = /^[-+]0x[0-9a-f]+$/i, Bq = /^0b[01]+$/i, Nq = /^0o[0-7]+$/i, Lq = parseInt;
function Tq(e) {
  if (typeof e == "number")
    return e;
  if (jq(e))
    return gA;
  if (pA(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = pA(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Pq(e);
  var r = Bq.test(e);
  return r || Nq.test(e) ? Lq(e.slice(2), r ? 2 : 8) : Iq.test(e) ? gA : +e;
}
var Yy = Tq, _q = A1, V6 = yq, vA = Yy, Rq = "Expected a function", Fq = Math.max, $q = Math.min;
function Hq(e, t, r) {
  var n, a, i, o, s, c, u = 0, d = !1, h = !1, A = !0;
  if (typeof e != "function")
    throw new TypeError(Rq);
  t = vA(t) || 0, _q(r) && (d = !!r.leading, h = "maxWait" in r, i = h ? Fq(vA(r.maxWait) || 0, t) : i, A = "trailing" in r ? !!r.trailing : A);
  function p(O) {
    var M = n, E = a;
    return n = a = void 0, u = O, o = e.apply(E, M), o;
  }
  function v(O) {
    return u = O, s = setTimeout(b, t), d ? p(O) : o;
  }
  function g(O) {
    var M = O - c, E = O - u, N = t - M;
    return h ? $q(N, i - E) : N;
  }
  function m(O) {
    var M = O - c, E = O - u;
    return c === void 0 || M >= t || M < 0 || h && E >= i;
  }
  function b() {
    var O = V6();
    if (m(O))
      return w(O);
    s = setTimeout(b, g(O));
  }
  function w(O) {
    return s = void 0, A && n ? p(O) : (n = a = void 0, o);
  }
  function x() {
    s !== void 0 && clearTimeout(s), u = 0, n = c = a = s = void 0;
  }
  function y() {
    return s === void 0 ? o : w(V6());
  }
  function C() {
    var O = V6(), M = m(O);
    if (n = arguments, a = this, c = O, M) {
      if (s === void 0)
        return v(c);
      if (h)
        return clearTimeout(s), s = setTimeout(b, t), p(c);
    }
    return s === void 0 && (s = setTimeout(b, t)), o;
  }
  return C.cancel = x, C.flush = y, C;
}
var Yq = Hq, kq = Yq, Vq = A1, Gq = "Expected a function";
function Wq(e, t, r) {
  var n = !0, a = !0;
  if (typeof e != "function")
    throw new TypeError(Gq);
  return Vq(r) && (n = "leading" in r ? !!r.leading : n, a = "trailing" in r ? !!r.trailing : a), kq(e, t, {
    leading: n,
    maxWait: t,
    trailing: a
  });
}
var Qq = Wq;
const ky = /* @__PURE__ */ Xe(Qq);
function oo(e) {
  "@babel/helpers - typeof";
  return oo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oo(e);
}
function mA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function S3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? mA(Object(r), !0).forEach(function(n) {
      Uq(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : mA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Uq(e, t, r) {
  return t = Zq(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Zq(e) {
  var t = Kq(e, "string");
  return oo(t) == "symbol" ? t : String(t);
}
function Kq(e, t) {
  if (oo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (oo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function zq(e, t) {
  return eX(e) || Jq(e, t) || Xq(e, t) || qq();
}
function qq() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xq(e, t) {
  if (e) {
    if (typeof e == "string")
      return CA(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return CA(e, t);
  }
}
function CA(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Jq(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function eX(e) {
  if (Array.isArray(e))
    return e;
}
var P2 = /* @__PURE__ */ jE(function(e, t) {
  var r = e.aspect, n = e.initialDimension, a = n === void 0 ? {
    width: -1,
    height: -1
  } : n, i = e.width, o = i === void 0 ? "100%" : i, s = e.height, c = s === void 0 ? "100%" : s, u = e.minWidth, d = u === void 0 ? 0 : u, h = e.minHeight, A = e.maxHeight, p = e.children, v = e.debounce, g = v === void 0 ? 0 : v, m = e.id, b = e.className, w = e.onResize, x = e.style, y = x === void 0 ? {} : x, C = Ce(null), O = Ce();
  O.current = w, IE(t, function() {
    return Object.defineProperty(C.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), C.current;
      },
      configurable: !0
    });
  });
  var M = Ee({
    containerWidth: a.width,
    containerHeight: a.height
  }), E = zq(M, 2), N = E[0], F = E[1], k = BE(function(j, U) {
    F(function(ee) {
      var X = Math.round(j), Z = Math.round(U);
      return ee.containerWidth === X && ee.containerHeight === Z ? ee : {
        containerWidth: X,
        containerHeight: Z
      };
    });
  }, []);
  Ne(function() {
    var j = function(B) {
      var I, _ = B[0].contentRect, L = _.width, D = _.height;
      k(L, D), (I = O.current) === null || I === void 0 || I.call(O, L, D);
    };
    g > 0 && (j = ky(j, g, {
      trailing: !0,
      leading: !1
    }));
    var U = new ResizeObserver(j), ee = C.current.getBoundingClientRect(), X = ee.width, Z = ee.height;
    return k(X, Z), U.observe(C.current), function() {
      U.disconnect();
    };
  }, [k, g]);
  var R = dr(function() {
    var j = N.containerWidth, U = N.containerHeight;
    if (j < 0 || U < 0)
      return null;
    Gr(G1(o) || G1(c), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, o, c), Gr(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
    var ee = G1(o) ? j : o, X = G1(c) ? U : c;
    r && r > 0 && (ee ? X = ee / r : X && (ee = X * r), A && X > A && (X = A)), Gr(ee > 0 || X > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, ee, X, o, c, d, h, r);
    var Z = !Array.isArray(p) && K4.isElement(p) && xn(p.type).endsWith("Chart");
    return P.Children.map(p, function(te) {
      return K4.isElement(te) ? /* @__PURE__ */ Pt(te, S3({
        width: ee,
        height: X
      }, Z ? {
        style: S3({
          height: "100%",
          width: "100%",
          maxHeight: X,
          maxWidth: ee
        }, te.props.style)
      } : {})) : te;
    });
  }, [r, p, c, A, h, d, N, o]);
  return /* @__PURE__ */ P.createElement("div", {
    id: m ? "".concat(m) : void 0,
    className: Pe("recharts-responsive-container", b),
    style: S3(S3({}, y), {}, {
      width: o,
      height: c,
      minWidth: d,
      minHeight: h,
      maxHeight: A
    }),
    ref: C
  }, R);
}), Br = function(t) {
  return null;
};
Br.displayName = "Cell";
function so(e) {
  "@babel/helpers - typeof";
  return so = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, so(e);
}
function bA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function w5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bA(Object(r), !0).forEach(function(n) {
      tX(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function tX(e, t, r) {
  return t = rX(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function rX(e) {
  var t = nX(e, "string");
  return so(t) == "symbol" ? t : String(t);
}
function nX(e, t) {
  if (so(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (so(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Da = {
  widthCache: {},
  cacheCount: 0
}, aX = 2e3, iX = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, yA = "recharts_measurement_span";
function oX(e) {
  var t = w5({}, e);
  return Object.keys(t).forEach(function(r) {
    t[r] || delete t[r];
  }), t;
}
var Fi = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || Ir.isSsr)
    return {
      width: 0,
      height: 0
    };
  var n = oX(r), a = JSON.stringify({
    text: t,
    copyStyle: n
  });
  if (Da.widthCache[a])
    return Da.widthCache[a];
  try {
    var i = document.getElementById(yA);
    i || (i = document.createElement("span"), i.setAttribute("id", yA), i.setAttribute("aria-hidden", "true"), document.body.appendChild(i));
    var o = w5(w5({}, iX), n);
    Object.assign(i.style, o), i.textContent = "".concat(t);
    var s = i.getBoundingClientRect(), c = {
      width: s.width,
      height: s.height
    };
    return Da.widthCache[a] = c, ++Da.cacheCount > aX && (Da.cacheCount = 0, Da.widthCache = {}), c;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, sX = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function lo(e) {
  "@babel/helpers - typeof";
  return lo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lo(e);
}
function xs(e, t) {
  return dX(e) || uX(e, t) || cX(e, t) || lX();
}
function lX() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cX(e, t) {
  if (e) {
    if (typeof e == "string")
      return wA(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return wA(e, t);
  }
}
function wA(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function uX(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function dX(e) {
  if (Array.isArray(e))
    return e;
}
function fX(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function xA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, AX(n.key), n);
  }
}
function hX(e, t, r) {
  return t && xA(e.prototype, t), r && xA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function AX(e) {
  var t = pX(e, "string");
  return lo(t) == "symbol" ? t : String(t);
}
function pX(e, t) {
  if (lo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (lo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var DA = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, OA = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, gX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, vX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, Vy = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, mX = Object.keys(Vy), _a = "NaN";
function CX(e, t) {
  return e * Vy[t];
}
var P3 = /* @__PURE__ */ function() {
  function e(t, r) {
    fX(this, e), this.num = t, this.unit = r, this.num = t, this.unit = r, Number.isNaN(t) && (this.unit = ""), r !== "" && !gX.test(r) && (this.num = NaN, this.unit = ""), mX.includes(r) && (this.num = CX(t, r), this.unit = "px");
  }
  return hX(e, [{
    key: "add",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num + r.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num - r.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num * r.num, this.unit || r.unit);
    }
  }, {
    key: "divide",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num / r.num, this.unit || r.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(r) {
      var n, a = (n = vX.exec(r)) !== null && n !== void 0 ? n : [], i = xs(a, 3), o = i[1], s = i[2];
      return new e(parseFloat(o), s ?? "");
    }
  }]), e;
}();
function Gy(e) {
  if (e.includes(_a))
    return _a;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var r, n = (r = DA.exec(t)) !== null && r !== void 0 ? r : [], a = xs(n, 4), i = a[1], o = a[2], s = a[3], c = P3.parse(i ?? ""), u = P3.parse(s ?? ""), d = o === "*" ? c.multiply(u) : c.divide(u);
    if (d.isNaN())
      return _a;
    t = t.replace(DA, d.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var h, A = (h = OA.exec(t)) !== null && h !== void 0 ? h : [], p = xs(A, 4), v = p[1], g = p[2], m = p[3], b = P3.parse(v ?? ""), w = P3.parse(m ?? ""), x = g === "+" ? b.add(w) : b.subtract(w);
    if (x.isNaN())
      return _a;
    t = t.replace(OA, x.toString());
  }
  return t;
}
var MA = /\(([^()]*)\)/;
function bX(e) {
  for (var t = e; t.includes("("); ) {
    var r = MA.exec(t), n = xs(r, 2), a = n[1];
    t = t.replace(MA, Gy(a));
  }
  return t;
}
function yX(e) {
  var t = e.replace(/\s+/g, "");
  return t = bX(t), t = Gy(t), t;
}
function wX(e) {
  try {
    return yX(e);
  } catch {
    return _a;
  }
}
function G6(e) {
  var t = wX(e.slice(5, -1));
  return t === _a ? "" : t;
}
var xX = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], DX = ["dx", "dy", "angle", "className", "breakAll"];
function x5() {
  return x5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, x5.apply(this, arguments);
}
function EA(e, t) {
  if (e == null)
    return {};
  var r = OX(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function OX(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function SA(e, t) {
  return PX(e) || SX(e, t) || EX(e, t) || MX();
}
function MX() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function EX(e, t) {
  if (e) {
    if (typeof e == "string")
      return PA(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return PA(e, t);
  }
}
function PA(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function SX(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function PX(e) {
  if (Array.isArray(e))
    return e;
}
var Wy = /[ \f\n\r\t\v\u2028\u2029]+/, Qy = function(t) {
  var r = t.children, n = t.breakAll, a = t.style;
  try {
    var i = [];
    ye(r) || (n ? i = r.toString().split("") : i = r.toString().split(Wy));
    var o = i.map(function(c) {
      return {
        word: c,
        width: Fi(c, a).width
      };
    }), s = n ? 0 : Fi(" ", a).width;
    return {
      wordsWithComputedWidth: o,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, jX = function(t, r, n, a, i) {
  var o = t.maxLines, s = t.children, c = t.style, u = t.breakAll, d = le(o), h = s, A = function() {
    var ee = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return ee.reduce(function(X, Z) {
      var te = Z.word, B = Z.width, I = X[X.length - 1];
      if (I && (a == null || i || I.width + B + n < Number(a)))
        I.words.push(te), I.width += B + n;
      else {
        var _ = {
          words: [te],
          width: B
        };
        X.push(_);
      }
      return X;
    }, []);
  }, p = A(r), v = function(ee) {
    return ee.reduce(function(X, Z) {
      return X.width > Z.width ? X : Z;
    });
  };
  if (!d)
    return p;
  for (var g = "…", m = function(ee) {
    var X = h.slice(0, ee), Z = Qy({
      breakAll: u,
      style: c,
      children: X + g
    }).wordsWithComputedWidth, te = A(Z), B = te.length > o || v(te).width > Number(a);
    return [B, te];
  }, b = 0, w = h.length - 1, x = 0, y; b <= w && x <= h.length - 1; ) {
    var C = Math.floor((b + w) / 2), O = C - 1, M = m(O), E = SA(M, 2), N = E[0], F = E[1], k = m(C), R = SA(k, 1), j = R[0];
    if (!N && !j && (b = C + 1), N && j && (w = C - 1), !N && j) {
      y = F;
      break;
    }
    x++;
  }
  return y || p;
}, jA = function(t) {
  var r = ye(t) ? [] : t.toString().split(Wy);
  return [{
    words: r
  }];
}, IX = function(t) {
  var r = t.width, n = t.scaleToFit, a = t.children, i = t.style, o = t.breakAll, s = t.maxLines;
  if ((r || n) && !Ir.isSsr) {
    var c, u, d = Qy({
      breakAll: o,
      children: a,
      style: i
    });
    if (d) {
      var h = d.wordsWithComputedWidth, A = d.spaceWidth;
      c = h, u = A;
    } else
      return jA(a);
    return jX({
      breakAll: o,
      children: a,
      maxLines: s,
      style: i
    }, c, u, r, n);
  }
  return jA(a);
}, IA = "#808080", J1 = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, i = a === void 0 ? 0 : a, o = t.lineHeight, s = o === void 0 ? "1em" : o, c = t.capHeight, u = c === void 0 ? "0.71em" : c, d = t.scaleToFit, h = d === void 0 ? !1 : d, A = t.textAnchor, p = A === void 0 ? "start" : A, v = t.verticalAnchor, g = v === void 0 ? "end" : v, m = t.fill, b = m === void 0 ? IA : m, w = EA(t, xX), x = dr(function() {
    return IX({
      breakAll: w.breakAll,
      children: w.children,
      maxLines: w.maxLines,
      scaleToFit: h,
      style: w.style,
      width: w.width
    });
  }, [w.breakAll, w.children, w.maxLines, h, w.style, w.width]), y = w.dx, C = w.dy, O = w.angle, M = w.className, E = w.breakAll, N = EA(w, DX);
  if (!jt(n) || !jt(i))
    return null;
  var F = n + (le(y) ? y : 0), k = i + (le(C) ? C : 0), R;
  switch (g) {
    case "start":
      R = G6("calc(".concat(u, ")"));
      break;
    case "middle":
      R = G6("calc(".concat((x.length - 1) / 2, " * -").concat(s, " + (").concat(u, " / 2))"));
      break;
    default:
      R = G6("calc(".concat(x.length - 1, " * -").concat(s, ")"));
      break;
  }
  var j = [];
  if (h) {
    var U = x[0].width, ee = w.width;
    j.push("scale(".concat((le(ee) ? ee / U : 1) / U, ")"));
  }
  return O && j.push("rotate(".concat(O, ", ").concat(F, ", ").concat(k, ")")), j.length && (N.transform = j.join(" ")), /* @__PURE__ */ P.createElement("text", x5({}, pe(N, !0), {
    x: F,
    y: k,
    className: Pe("recharts-text", M),
    textAnchor: p,
    fill: b.includes("url") ? IA : b
  }), x.map(function(X, Z) {
    var te = X.words.join(E ? "" : " ");
    return /* @__PURE__ */ P.createElement("tspan", {
      x: F,
      dy: Z === 0 ? R : s,
      key: te
    }, te);
  }));
};
function n1(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function BX(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function O9(e) {
  let t, r, n;
  e.length !== 2 ? (t = n1, r = (s, c) => n1(e(s), c), n = (s, c) => e(s) - c) : (t = e === n1 || e === BX ? e : NX, r = e, n = e);
  function a(s, c, u = 0, d = s.length) {
    if (u < d) {
      if (t(c, c) !== 0)
        return d;
      do {
        const h = u + d >>> 1;
        r(s[h], c) < 0 ? u = h + 1 : d = h;
      } while (u < d);
    }
    return u;
  }
  function i(s, c, u = 0, d = s.length) {
    if (u < d) {
      if (t(c, c) !== 0)
        return d;
      do {
        const h = u + d >>> 1;
        r(s[h], c) <= 0 ? u = h + 1 : d = h;
      } while (u < d);
    }
    return u;
  }
  function o(s, c, u = 0, d = s.length) {
    const h = a(s, c, u, d - 1);
    return h > u && n(s[h - 1], c) > -n(s[h], c) ? h - 1 : h;
  }
  return { left: a, center: o, right: i };
}
function NX() {
  return 0;
}
function Uy(e) {
  return e === null ? NaN : +e;
}
function* LX(e, t) {
  if (t === void 0)
    for (let r of e)
      r != null && (r = +r) >= r && (yield r);
  else {
    let r = -1;
    for (let n of e)
      (n = t(n, ++r, e)) != null && (n = +n) >= n && (yield n);
  }
}
const TX = O9(n1), _X = TX.right;
O9(Uy).center;
const zo = _X;
class BA extends Map {
  constructor(t, r = $X) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null)
      for (const [n, a] of t)
        this.set(n, a);
  }
  get(t) {
    return super.get(NA(this, t));
  }
  has(t) {
    return super.has(NA(this, t));
  }
  set(t, r) {
    return super.set(RX(this, t), r);
  }
  delete(t) {
    return super.delete(FX(this, t));
  }
}
function NA({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : r;
}
function RX({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : (e.set(n, r), r);
}
function FX({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) && (r = e.get(n), e.delete(n)), r;
}
function $X(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function HX(e = n1) {
  if (e === n1)
    return Zy;
  if (typeof e != "function")
    throw new TypeError("compare is not a function");
  return (t, r) => {
    const n = e(t, r);
    return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
  };
}
function Zy(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const YX = Math.sqrt(50), kX = Math.sqrt(10), VX = Math.sqrt(2);
function Ds(e, t, r) {
  const n = (t - e) / Math.max(0, r), a = Math.floor(Math.log10(n)), i = n / Math.pow(10, a), o = i >= YX ? 10 : i >= kX ? 5 : i >= VX ? 2 : 1;
  let s, c, u;
  return a < 0 ? (u = Math.pow(10, -a) / o, s = Math.round(e * u), c = Math.round(t * u), s / u < e && ++s, c / u > t && --c, u = -u) : (u = Math.pow(10, a) * o, s = Math.round(e / u), c = Math.round(t / u), s * u < e && ++s, c * u > t && --c), c < s && 0.5 <= r && r < 2 ? Ds(e, t, r * 2) : [s, c, u];
}
function D5(e, t, r) {
  if (t = +t, e = +e, r = +r, !(r > 0))
    return [];
  if (e === t)
    return [e];
  const n = t < e, [a, i, o] = n ? Ds(t, e, r) : Ds(e, t, r);
  if (!(i >= a))
    return [];
  const s = i - a + 1, c = new Array(s);
  if (n)
    if (o < 0)
      for (let u = 0; u < s; ++u)
        c[u] = (i - u) / -o;
    else
      for (let u = 0; u < s; ++u)
        c[u] = (i - u) * o;
  else if (o < 0)
    for (let u = 0; u < s; ++u)
      c[u] = (a + u) / -o;
  else
    for (let u = 0; u < s; ++u)
      c[u] = (a + u) * o;
  return c;
}
function O5(e, t, r) {
  return t = +t, e = +e, r = +r, Ds(e, t, r)[2];
}
function M5(e, t, r) {
  t = +t, e = +e, r = +r;
  const n = t < e, a = n ? O5(t, e, r) : O5(e, t, r);
  return (n ? -1 : 1) * (a < 0 ? 1 / -a : a);
}
function LA(e, t) {
  let r;
  if (t === void 0)
    for (const n of e)
      n != null && (r < n || r === void 0 && n >= n) && (r = n);
  else {
    let n = -1;
    for (let a of e)
      (a = t(a, ++n, e)) != null && (r < a || r === void 0 && a >= a) && (r = a);
  }
  return r;
}
function TA(e, t) {
  let r;
  if (t === void 0)
    for (const n of e)
      n != null && (r > n || r === void 0 && n >= n) && (r = n);
  else {
    let n = -1;
    for (let a of e)
      (a = t(a, ++n, e)) != null && (r > a || r === void 0 && a >= a) && (r = a);
  }
  return r;
}
function Ky(e, t, r = 0, n = 1 / 0, a) {
  if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n))
    return e;
  for (a = a === void 0 ? Zy : HX(a); n > r; ) {
    if (n - r > 600) {
      const c = n - r + 1, u = t - r + 1, d = Math.log(c), h = 0.5 * Math.exp(2 * d / 3), A = 0.5 * Math.sqrt(d * h * (c - h) / c) * (u - c / 2 < 0 ? -1 : 1), p = Math.max(r, Math.floor(t - u * h / c + A)), v = Math.min(n, Math.floor(t + (c - u) * h / c + A));
      Ky(e, t, p, v, a);
    }
    const i = e[t];
    let o = r, s = n;
    for (ci(e, r, t), a(e[n], i) > 0 && ci(e, r, n); o < s; ) {
      for (ci(e, o, s), ++o, --s; a(e[o], i) < 0; )
        ++o;
      for (; a(e[s], i) > 0; )
        --s;
    }
    a(e[r], i) === 0 ? ci(e, r, s) : (++s, ci(e, s, n)), s <= t && (r = s + 1), t <= s && (n = s - 1);
  }
  return e;
}
function ci(e, t, r) {
  const n = e[t];
  e[t] = e[r], e[r] = n;
}
function GX(e, t, r) {
  if (e = Float64Array.from(LX(e, r)), !(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2)
      return TA(e);
    if (t >= 1)
      return LA(e);
    var n, a = (n - 1) * t, i = Math.floor(a), o = LA(Ky(e, i).subarray(0, i + 1)), s = TA(e.subarray(i + 1));
    return o + (s - o) * (a - i);
  }
}
function WX(e, t, r = Uy) {
  if (!(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2)
      return +r(e[0], 0, e);
    if (t >= 1)
      return +r(e[n - 1], n - 1, e);
    var n, a = (n - 1) * t, i = Math.floor(a), o = +r(e[i], i, e), s = +r(e[i + 1], i + 1, e);
    return o + (s - o) * (a - i);
  }
}
function QX(e, t, r) {
  e = +e, t = +t, r = (a = arguments.length) < 2 ? (t = e, e = 0, 1) : a < 3 ? 1 : +r;
  for (var n = -1, a = Math.max(0, Math.ceil((t - e) / r)) | 0, i = new Array(a); ++n < a; )
    i[n] = e + n * r;
  return i;
}
function _r(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function In(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const E5 = Symbol("implicit");
function M9() {
  var e = new BA(), t = [], r = [], n = E5;
  function a(i) {
    let o = e.get(i);
    if (o === void 0) {
      if (n !== E5)
        return n;
      e.set(i, o = t.push(i) - 1);
    }
    return r[o % r.length];
  }
  return a.domain = function(i) {
    if (!arguments.length)
      return t.slice();
    t = [], e = new BA();
    for (const o of i)
      e.has(o) || e.set(o, t.push(o) - 1);
    return a;
  }, a.range = function(i) {
    return arguments.length ? (r = Array.from(i), a) : r.slice();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.copy = function() {
    return M9(t, r).unknown(n);
  }, _r.apply(a, arguments), a;
}
function co() {
  var e = M9().unknown(void 0), t = e.domain, r = e.range, n = 0, a = 1, i, o, s = !1, c = 0, u = 0, d = 0.5;
  delete e.unknown;
  function h() {
    var A = t().length, p = a < n, v = p ? a : n, g = p ? n : a;
    i = (g - v) / Math.max(1, A - c + u * 2), s && (i = Math.floor(i)), v += (g - v - i * (A - c)) * d, o = i * (1 - c), s && (v = Math.round(v), o = Math.round(o));
    var m = QX(A).map(function(b) {
      return v + i * b;
    });
    return r(p ? m.reverse() : m);
  }
  return e.domain = function(A) {
    return arguments.length ? (t(A), h()) : t();
  }, e.range = function(A) {
    return arguments.length ? ([n, a] = A, n = +n, a = +a, h()) : [n, a];
  }, e.rangeRound = function(A) {
    return [n, a] = A, n = +n, a = +a, s = !0, h();
  }, e.bandwidth = function() {
    return o;
  }, e.step = function() {
    return i;
  }, e.round = function(A) {
    return arguments.length ? (s = !!A, h()) : s;
  }, e.padding = function(A) {
    return arguments.length ? (c = Math.min(1, u = +A), h()) : c;
  }, e.paddingInner = function(A) {
    return arguments.length ? (c = Math.min(1, A), h()) : c;
  }, e.paddingOuter = function(A) {
    return arguments.length ? (u = +A, h()) : u;
  }, e.align = function(A) {
    return arguments.length ? (d = Math.max(0, Math.min(1, A)), h()) : d;
  }, e.copy = function() {
    return co(t(), [n, a]).round(s).paddingInner(c).paddingOuter(u).align(d);
  }, _r.apply(h(), arguments);
}
function zy(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return zy(t());
  }, e;
}
function $i() {
  return zy(co.apply(null, arguments).paddingInner(1));
}
function E9(e, t, r) {
  e.prototype = t.prototype = r, r.constructor = e;
}
function qy(e, t) {
  var r = Object.create(e.prototype);
  for (var n in t)
    r[n] = t[n];
  return r;
}
function qo() {
}
var uo = 0.7, Os = 1 / uo, Ya = "\\s*([+-]?\\d+)\\s*", fo = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", cn = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", UX = /^#([0-9a-f]{3,8})$/, ZX = new RegExp(`^rgb\\(${Ya},${Ya},${Ya}\\)$`), KX = new RegExp(`^rgb\\(${cn},${cn},${cn}\\)$`), zX = new RegExp(`^rgba\\(${Ya},${Ya},${Ya},${fo}\\)$`), qX = new RegExp(`^rgba\\(${cn},${cn},${cn},${fo}\\)$`), XX = new RegExp(`^hsl\\(${fo},${cn},${cn}\\)$`), JX = new RegExp(`^hsla\\(${fo},${cn},${cn},${fo}\\)$`), _A = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
E9(qo, ho, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: RA,
  // Deprecated! Use color.formatHex.
  formatHex: RA,
  formatHex8: eJ,
  formatHsl: tJ,
  formatRgb: FA,
  toString: FA
});
function RA() {
  return this.rgb().formatHex();
}
function eJ() {
  return this.rgb().formatHex8();
}
function tJ() {
  return Xy(this).formatHsl();
}
function FA() {
  return this.rgb().formatRgb();
}
function ho(e) {
  var t, r;
  return e = (e + "").trim().toLowerCase(), (t = UX.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? $A(t) : r === 3 ? new ar(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? j3(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? j3(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = ZX.exec(e)) ? new ar(t[1], t[2], t[3], 1) : (t = KX.exec(e)) ? new ar(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = zX.exec(e)) ? j3(t[1], t[2], t[3], t[4]) : (t = qX.exec(e)) ? j3(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = XX.exec(e)) ? kA(t[1], t[2] / 100, t[3] / 100, 1) : (t = JX.exec(e)) ? kA(t[1], t[2] / 100, t[3] / 100, t[4]) : _A.hasOwnProperty(e) ? $A(_A[e]) : e === "transparent" ? new ar(NaN, NaN, NaN, 0) : null;
}
function $A(e) {
  return new ar(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function j3(e, t, r, n) {
  return n <= 0 && (e = t = r = NaN), new ar(e, t, r, n);
}
function rJ(e) {
  return e instanceof qo || (e = ho(e)), e ? (e = e.rgb(), new ar(e.r, e.g, e.b, e.opacity)) : new ar();
}
function S5(e, t, r, n) {
  return arguments.length === 1 ? rJ(e) : new ar(e, t, r, n ?? 1);
}
function ar(e, t, r, n) {
  this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
}
E9(ar, S5, qy(qo, {
  brighter(e) {
    return e = e == null ? Os : Math.pow(Os, e), new ar(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? uo : Math.pow(uo, e), new ar(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new ar(z1(this.r), z1(this.g), z1(this.b), Ms(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: HA,
  // Deprecated! Use color.formatHex.
  formatHex: HA,
  formatHex8: nJ,
  formatRgb: YA,
  toString: YA
}));
function HA() {
  return `#${W1(this.r)}${W1(this.g)}${W1(this.b)}`;
}
function nJ() {
  return `#${W1(this.r)}${W1(this.g)}${W1(this.b)}${W1((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function YA() {
  const e = Ms(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${z1(this.r)}, ${z1(this.g)}, ${z1(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function Ms(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function z1(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function W1(e) {
  return e = z1(e), (e < 16 ? "0" : "") + e.toString(16);
}
function kA(e, t, r, n) {
  return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Hr(e, t, r, n);
}
function Xy(e) {
  if (e instanceof Hr)
    return new Hr(e.h, e.s, e.l, e.opacity);
  if (e instanceof qo || (e = ho(e)), !e)
    return new Hr();
  if (e instanceof Hr)
    return e;
  e = e.rgb();
  var t = e.r / 255, r = e.g / 255, n = e.b / 255, a = Math.min(t, r, n), i = Math.max(t, r, n), o = NaN, s = i - a, c = (i + a) / 2;
  return s ? (t === i ? o = (r - n) / s + (r < n) * 6 : r === i ? o = (n - t) / s + 2 : o = (t - r) / s + 4, s /= c < 0.5 ? i + a : 2 - i - a, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new Hr(o, s, c, e.opacity);
}
function aJ(e, t, r, n) {
  return arguments.length === 1 ? Xy(e) : new Hr(e, t, r, n ?? 1);
}
function Hr(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}
E9(Hr, aJ, qy(qo, {
  brighter(e) {
    return e = e == null ? Os : Math.pow(Os, e), new Hr(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? uo : Math.pow(uo, e), new Hr(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, a = 2 * r - n;
    return new ar(
      W6(e >= 240 ? e - 240 : e + 120, a, n),
      W6(e, a, n),
      W6(e < 120 ? e + 240 : e - 120, a, n),
      this.opacity
    );
  },
  clamp() {
    return new Hr(VA(this.h), I3(this.s), I3(this.l), Ms(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = Ms(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${VA(this.h)}, ${I3(this.s) * 100}%, ${I3(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function VA(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function I3(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function W6(e, t, r) {
  return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
}
const S9 = (e) => () => e;
function iJ(e, t) {
  return function(r) {
    return e + r * t;
  };
}
function oJ(e, t, r) {
  return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
    return Math.pow(e + n * t, r);
  };
}
function sJ(e) {
  return (e = +e) == 1 ? Jy : function(t, r) {
    return r - t ? oJ(t, r, e) : S9(isNaN(t) ? r : t);
  };
}
function Jy(e, t) {
  var r = t - e;
  return r ? iJ(e, r) : S9(isNaN(e) ? t : e);
}
const GA = function e(t) {
  var r = sJ(t);
  function n(a, i) {
    var o = r((a = S5(a)).r, (i = S5(i)).r), s = r(a.g, i.g), c = r(a.b, i.b), u = Jy(a.opacity, i.opacity);
    return function(d) {
      return a.r = o(d), a.g = s(d), a.b = c(d), a.opacity = u(d), a + "";
    };
  }
  return n.gamma = e, n;
}(1);
function lJ(e, t) {
  t || (t = []);
  var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), a;
  return function(i) {
    for (a = 0; a < r; ++a)
      n[a] = e[a] * (1 - i) + t[a] * i;
    return n;
  };
}
function cJ(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function uJ(e, t) {
  var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, a = new Array(n), i = new Array(r), o;
  for (o = 0; o < n; ++o)
    a[o] = j2(e[o], t[o]);
  for (; o < r; ++o)
    i[o] = t[o];
  return function(s) {
    for (o = 0; o < n; ++o)
      i[o] = a[o](s);
    return i;
  };
}
function dJ(e, t) {
  var r = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(n) {
    return r.setTime(e * (1 - n) + t * n), r;
  };
}
function Es(e, t) {
  return e = +e, t = +t, function(r) {
    return e * (1 - r) + t * r;
  };
}
function fJ(e, t) {
  var r = {}, n = {}, a;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (a in t)
    a in e ? r[a] = j2(e[a], t[a]) : n[a] = t[a];
  return function(i) {
    for (a in r)
      n[a] = r[a](i);
    return n;
  };
}
var P5 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Q6 = new RegExp(P5.source, "g");
function hJ(e) {
  return function() {
    return e;
  };
}
function AJ(e) {
  return function(t) {
    return e(t) + "";
  };
}
function pJ(e, t) {
  var r = P5.lastIndex = Q6.lastIndex = 0, n, a, i, o = -1, s = [], c = [];
  for (e = e + "", t = t + ""; (n = P5.exec(e)) && (a = Q6.exec(t)); )
    (i = a.index) > r && (i = t.slice(r, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (a = a[0]) ? s[o] ? s[o] += a : s[++o] = a : (s[++o] = null, c.push({ i: o, x: Es(n, a) })), r = Q6.lastIndex;
  return r < t.length && (i = t.slice(r), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? c[0] ? AJ(c[0].x) : hJ(t) : (t = c.length, function(u) {
    for (var d = 0, h; d < t; ++d)
      s[(h = c[d]).i] = h.x(u);
    return s.join("");
  });
}
function j2(e, t) {
  var r = typeof t, n;
  return t == null || r === "boolean" ? S9(t) : (r === "number" ? Es : r === "string" ? (n = ho(t)) ? (t = n, GA) : pJ : t instanceof ho ? GA : t instanceof Date ? dJ : cJ(t) ? lJ : Array.isArray(t) ? uJ : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? fJ : Es)(e, t);
}
function P9(e, t) {
  return e = +e, t = +t, function(r) {
    return Math.round(e * (1 - r) + t * r);
  };
}
function gJ(e, t) {
  t === void 0 && (t = e, e = j2);
  for (var r = 0, n = t.length - 1, a = t[0], i = new Array(n < 0 ? 0 : n); r < n; )
    i[r] = e(a, a = t[++r]);
  return function(o) {
    var s = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
    return i[s](o - s);
  };
}
function vJ(e) {
  return function() {
    return e;
  };
}
function Ss(e) {
  return +e;
}
var WA = [0, 1];
function Jt(e) {
  return e;
}
function j5(e, t) {
  return (t -= e = +e) ? function(r) {
    return (r - e) / t;
  } : vJ(isNaN(t) ? NaN : 0.5);
}
function mJ(e, t) {
  var r;
  return e > t && (r = e, e = t, t = r), function(n) {
    return Math.max(e, Math.min(t, n));
  };
}
function CJ(e, t, r) {
  var n = e[0], a = e[1], i = t[0], o = t[1];
  return a < n ? (n = j5(a, n), i = r(o, i)) : (n = j5(n, a), i = r(i, o)), function(s) {
    return i(n(s));
  };
}
function bJ(e, t, r) {
  var n = Math.min(e.length, t.length) - 1, a = new Array(n), i = new Array(n), o = -1;
  for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < n; )
    a[o] = j5(e[o], e[o + 1]), i[o] = r(t[o], t[o + 1]);
  return function(s) {
    var c = zo(e, s, 1, n) - 1;
    return i[c](a[c](s));
  };
}
function Xo(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function B0() {
  var e = WA, t = WA, r = j2, n, a, i, o = Jt, s, c, u;
  function d() {
    var A = Math.min(e.length, t.length);
    return o !== Jt && (o = mJ(e[0], e[A - 1])), s = A > 2 ? bJ : CJ, c = u = null, h;
  }
  function h(A) {
    return A == null || isNaN(A = +A) ? i : (c || (c = s(e.map(n), t, r)))(n(o(A)));
  }
  return h.invert = function(A) {
    return o(a((u || (u = s(t, e.map(n), Es)))(A)));
  }, h.domain = function(A) {
    return arguments.length ? (e = Array.from(A, Ss), d()) : e.slice();
  }, h.range = function(A) {
    return arguments.length ? (t = Array.from(A), d()) : t.slice();
  }, h.rangeRound = function(A) {
    return t = Array.from(A), r = P9, d();
  }, h.clamp = function(A) {
    return arguments.length ? (o = A ? !0 : Jt, d()) : o !== Jt;
  }, h.interpolate = function(A) {
    return arguments.length ? (r = A, d()) : r;
  }, h.unknown = function(A) {
    return arguments.length ? (i = A, h) : i;
  }, function(A, p) {
    return n = A, a = p, d();
  };
}
function j9() {
  return B0()(Jt, Jt);
}
function yJ(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function Ps(e, t) {
  if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0)
    return null;
  var r, n = e.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +e.slice(r + 1)
  ];
}
function Ja(e) {
  return e = Ps(Math.abs(e)), e ? e[1] : NaN;
}
function wJ(e, t) {
  return function(r, n) {
    for (var a = r.length, i = [], o = 0, s = e[0], c = 0; a > 0 && s > 0 && (c + s + 1 > n && (s = Math.max(1, n - c)), i.push(r.substring(a -= s, a + s)), !((c += s + 1) > n)); )
      s = e[o = (o + 1) % e.length];
    return i.reverse().join(t);
  };
}
function xJ(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(r) {
      return e[+r];
    });
  };
}
var DJ = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Ao(e) {
  if (!(t = DJ.exec(e)))
    throw new Error("invalid format: " + e);
  var t;
  return new I9({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Ao.prototype = I9.prototype;
function I9(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
I9.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function OJ(e) {
  e:
    for (var t = e.length, r = 1, n = -1, a; r < t; ++r)
      switch (e[r]) {
        case ".":
          n = a = r;
          break;
        case "0":
          n === 0 && (n = r), a = r;
          break;
        default:
          if (!+e[r])
            break e;
          n > 0 && (n = 0);
          break;
      }
  return n > 0 ? e.slice(0, n) + e.slice(a + 1) : e;
}
var ew;
function MJ(e, t) {
  var r = Ps(e, t);
  if (!r)
    return e + "";
  var n = r[0], a = r[1], i = a - (ew = Math.max(-8, Math.min(8, Math.floor(a / 3))) * 3) + 1, o = n.length;
  return i === o ? n : i > o ? n + new Array(i - o + 1).join("0") : i > 0 ? n.slice(0, i) + "." + n.slice(i) : "0." + new Array(1 - i).join("0") + Ps(e, Math.max(0, t + i - 1))[0];
}
function QA(e, t) {
  var r = Ps(e, t);
  if (!r)
    return e + "";
  var n = r[0], a = r[1];
  return a < 0 ? "0." + new Array(-a).join("0") + n : n.length > a + 1 ? n.slice(0, a + 1) + "." + n.slice(a + 1) : n + new Array(a - n.length + 2).join("0");
}
const UA = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: yJ,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => QA(e * 100, t),
  r: QA,
  s: MJ,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function ZA(e) {
  return e;
}
var KA = Array.prototype.map, zA = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function EJ(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? ZA : wJ(KA.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", a = e.decimal === void 0 ? "." : e.decimal + "", i = e.numerals === void 0 ? ZA : xJ(KA.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", c = e.nan === void 0 ? "NaN" : e.nan + "";
  function u(h) {
    h = Ao(h);
    var A = h.fill, p = h.align, v = h.sign, g = h.symbol, m = h.zero, b = h.width, w = h.comma, x = h.precision, y = h.trim, C = h.type;
    C === "n" ? (w = !0, C = "g") : UA[C] || (x === void 0 && (x = 12), y = !0, C = "g"), (m || A === "0" && p === "=") && (m = !0, A = "0", p = "=");
    var O = g === "$" ? r : g === "#" && /[boxX]/.test(C) ? "0" + C.toLowerCase() : "", M = g === "$" ? n : /[%p]/.test(C) ? o : "", E = UA[C], N = /[defgprs%]/.test(C);
    x = x === void 0 ? 6 : /[gprs]/.test(C) ? Math.max(1, Math.min(21, x)) : Math.max(0, Math.min(20, x));
    function F(k) {
      var R = O, j = M, U, ee, X;
      if (C === "c")
        j = E(k) + j, k = "";
      else {
        k = +k;
        var Z = k < 0 || 1 / k < 0;
        if (k = isNaN(k) ? c : E(Math.abs(k), x), y && (k = OJ(k)), Z && +k == 0 && v !== "+" && (Z = !1), R = (Z ? v === "(" ? v : s : v === "-" || v === "(" ? "" : v) + R, j = (C === "s" ? zA[8 + ew / 3] : "") + j + (Z && v === "(" ? ")" : ""), N) {
          for (U = -1, ee = k.length; ++U < ee; )
            if (X = k.charCodeAt(U), 48 > X || X > 57) {
              j = (X === 46 ? a + k.slice(U + 1) : k.slice(U)) + j, k = k.slice(0, U);
              break;
            }
        }
      }
      w && !m && (k = t(k, 1 / 0));
      var te = R.length + k.length + j.length, B = te < b ? new Array(b - te + 1).join(A) : "";
      switch (w && m && (k = t(B + k, B.length ? b - j.length : 1 / 0), B = ""), p) {
        case "<":
          k = R + k + j + B;
          break;
        case "=":
          k = R + B + k + j;
          break;
        case "^":
          k = B.slice(0, te = B.length >> 1) + R + k + j + B.slice(te);
          break;
        default:
          k = B + R + k + j;
          break;
      }
      return i(k);
    }
    return F.toString = function() {
      return h + "";
    }, F;
  }
  function d(h, A) {
    var p = u((h = Ao(h), h.type = "f", h)), v = Math.max(-8, Math.min(8, Math.floor(Ja(A) / 3))) * 3, g = Math.pow(10, -v), m = zA[8 + v / 3];
    return function(b) {
      return p(g * b) + m;
    };
  }
  return {
    format: u,
    formatPrefix: d
  };
}
var B3, B9, tw;
SJ({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function SJ(e) {
  return B3 = EJ(e), B9 = B3.format, tw = B3.formatPrefix, B3;
}
function PJ(e) {
  return Math.max(0, -Ja(Math.abs(e)));
}
function jJ(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Ja(t) / 3))) * 3 - Ja(Math.abs(e)));
}
function IJ(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Ja(t) - Ja(e)) + 1;
}
function rw(e, t, r, n) {
  var a = M5(e, t, r), i;
  switch (n = Ao(n ?? ",f"), n.type) {
    case "s": {
      var o = Math.max(Math.abs(e), Math.abs(t));
      return n.precision == null && !isNaN(i = jJ(a, o)) && (n.precision = i), tw(n, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(i = IJ(a, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = i - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(i = PJ(a)) && (n.precision = i - (n.type === "%") * 2);
      break;
    }
  }
  return B9(n);
}
function g1(e) {
  var t = e.domain;
  return e.ticks = function(r) {
    var n = t();
    return D5(n[0], n[n.length - 1], r ?? 10);
  }, e.tickFormat = function(r, n) {
    var a = t();
    return rw(a[0], a[a.length - 1], r ?? 10, n);
  }, e.nice = function(r) {
    r == null && (r = 10);
    var n = t(), a = 0, i = n.length - 1, o = n[a], s = n[i], c, u, d = 10;
    for (s < o && (u = o, o = s, s = u, u = a, a = i, i = u); d-- > 0; ) {
      if (u = O5(o, s, r), u === c)
        return n[a] = o, n[i] = s, t(n);
      if (u > 0)
        o = Math.floor(o / u) * u, s = Math.ceil(s / u) * u;
      else if (u < 0)
        o = Math.ceil(o * u) / u, s = Math.floor(s * u) / u;
      else
        break;
      c = u;
    }
    return e;
  }, e;
}
function js() {
  var e = j9();
  return e.copy = function() {
    return Xo(e, js());
  }, _r.apply(e, arguments), g1(e);
}
function nw(e) {
  var t;
  function r(n) {
    return n == null || isNaN(n = +n) ? t : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (e = Array.from(n, Ss), r) : e.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.copy = function() {
    return nw(e).unknown(t);
  }, e = arguments.length ? Array.from(e, Ss) : [0, 1], g1(r);
}
function aw(e, t) {
  e = e.slice();
  var r = 0, n = e.length - 1, a = e[r], i = e[n], o;
  return i < a && (o = r, r = n, n = o, o = a, a = i, i = o), e[r] = t.floor(a), e[n] = t.ceil(i), e;
}
function qA(e) {
  return Math.log(e);
}
function XA(e) {
  return Math.exp(e);
}
function BJ(e) {
  return -Math.log(-e);
}
function NJ(e) {
  return -Math.exp(-e);
}
function LJ(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function TJ(e) {
  return e === 10 ? LJ : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function _J(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function JA(e) {
  return (t, r) => -e(-t, r);
}
function N9(e) {
  const t = e(qA, XA), r = t.domain;
  let n = 10, a, i;
  function o() {
    return a = _J(n), i = TJ(n), r()[0] < 0 ? (a = JA(a), i = JA(i), e(BJ, NJ)) : e(qA, XA), t;
  }
  return t.base = function(s) {
    return arguments.length ? (n = +s, o()) : n;
  }, t.domain = function(s) {
    return arguments.length ? (r(s), o()) : r();
  }, t.ticks = (s) => {
    const c = r();
    let u = c[0], d = c[c.length - 1];
    const h = d < u;
    h && ([u, d] = [d, u]);
    let A = a(u), p = a(d), v, g;
    const m = s == null ? 10 : +s;
    let b = [];
    if (!(n % 1) && p - A < m) {
      if (A = Math.floor(A), p = Math.ceil(p), u > 0) {
        for (; A <= p; ++A)
          for (v = 1; v < n; ++v)
            if (g = A < 0 ? v / i(-A) : v * i(A), !(g < u)) {
              if (g > d)
                break;
              b.push(g);
            }
      } else
        for (; A <= p; ++A)
          for (v = n - 1; v >= 1; --v)
            if (g = A > 0 ? v / i(-A) : v * i(A), !(g < u)) {
              if (g > d)
                break;
              b.push(g);
            }
      b.length * 2 < m && (b = D5(u, d, m));
    } else
      b = D5(A, p, Math.min(p - A, m)).map(i);
    return h ? b.reverse() : b;
  }, t.tickFormat = (s, c) => {
    if (s == null && (s = 10), c == null && (c = n === 10 ? "s" : ","), typeof c != "function" && (!(n % 1) && (c = Ao(c)).precision == null && (c.trim = !0), c = B9(c)), s === 1 / 0)
      return c;
    const u = Math.max(1, n * s / t.ticks().length);
    return (d) => {
      let h = d / i(Math.round(a(d)));
      return h * n < n - 0.5 && (h *= n), h <= u ? c(d) : "";
    };
  }, t.nice = () => r(aw(r(), {
    floor: (s) => i(Math.floor(a(s))),
    ceil: (s) => i(Math.ceil(a(s)))
  })), t;
}
function iw() {
  const e = N9(B0()).domain([1, 10]);
  return e.copy = () => Xo(e, iw()).base(e.base()), _r.apply(e, arguments), e;
}
function ep(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function tp(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function L9(e) {
  var t = 1, r = e(ep(t), tp(t));
  return r.constant = function(n) {
    return arguments.length ? e(ep(t = +n), tp(t)) : t;
  }, g1(r);
}
function ow() {
  var e = L9(B0());
  return e.copy = function() {
    return Xo(e, ow()).constant(e.constant());
  }, _r.apply(e, arguments);
}
function rp(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function RJ(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function FJ(e) {
  return e < 0 ? -e * e : e * e;
}
function T9(e) {
  var t = e(Jt, Jt), r = 1;
  function n() {
    return r === 1 ? e(Jt, Jt) : r === 0.5 ? e(RJ, FJ) : e(rp(r), rp(1 / r));
  }
  return t.exponent = function(a) {
    return arguments.length ? (r = +a, n()) : r;
  }, g1(t);
}
function _9() {
  var e = T9(B0());
  return e.copy = function() {
    return Xo(e, _9()).exponent(e.exponent());
  }, _r.apply(e, arguments), e;
}
function $J() {
  return _9.apply(null, arguments).exponent(0.5);
}
function np(e) {
  return Math.sign(e) * e * e;
}
function HJ(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function sw() {
  var e = j9(), t = [0, 1], r = !1, n;
  function a(i) {
    var o = HJ(e(i));
    return isNaN(o) ? n : r ? Math.round(o) : o;
  }
  return a.invert = function(i) {
    return e.invert(np(i));
  }, a.domain = function(i) {
    return arguments.length ? (e.domain(i), a) : e.domain();
  }, a.range = function(i) {
    return arguments.length ? (e.range((t = Array.from(i, Ss)).map(np)), a) : t.slice();
  }, a.rangeRound = function(i) {
    return a.range(i).round(!0);
  }, a.round = function(i) {
    return arguments.length ? (r = !!i, a) : r;
  }, a.clamp = function(i) {
    return arguments.length ? (e.clamp(i), a) : e.clamp();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.copy = function() {
    return sw(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
  }, _r.apply(a, arguments), g1(a);
}
function lw() {
  var e = [], t = [], r = [], n;
  function a() {
    var o = 0, s = Math.max(1, t.length);
    for (r = new Array(s - 1); ++o < s; )
      r[o - 1] = WX(e, o / s);
    return i;
  }
  function i(o) {
    return o == null || isNaN(o = +o) ? n : t[zo(r, o)];
  }
  return i.invertExtent = function(o) {
    var s = t.indexOf(o);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? r[s - 1] : e[0],
      s < r.length ? r[s] : e[e.length - 1]
    ];
  }, i.domain = function(o) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let s of o)
      s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(n1), a();
  }, i.range = function(o) {
    return arguments.length ? (t = Array.from(o), a()) : t.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.quantiles = function() {
    return r.slice();
  }, i.copy = function() {
    return lw().domain(e).range(t).unknown(n);
  }, _r.apply(i, arguments);
}
function cw() {
  var e = 0, t = 1, r = 1, n = [0.5], a = [0, 1], i;
  function o(c) {
    return c != null && c <= c ? a[zo(n, c, 0, r)] : i;
  }
  function s() {
    var c = -1;
    for (n = new Array(r); ++c < r; )
      n[c] = ((c + 1) * t - (c - r) * e) / (r + 1);
    return o;
  }
  return o.domain = function(c) {
    return arguments.length ? ([e, t] = c, e = +e, t = +t, s()) : [e, t];
  }, o.range = function(c) {
    return arguments.length ? (r = (a = Array.from(c)).length - 1, s()) : a.slice();
  }, o.invertExtent = function(c) {
    var u = a.indexOf(c);
    return u < 0 ? [NaN, NaN] : u < 1 ? [e, n[0]] : u >= r ? [n[r - 1], t] : [n[u - 1], n[u]];
  }, o.unknown = function(c) {
    return arguments.length && (i = c), o;
  }, o.thresholds = function() {
    return n.slice();
  }, o.copy = function() {
    return cw().domain([e, t]).range(a).unknown(i);
  }, _r.apply(g1(o), arguments);
}
function uw() {
  var e = [0.5], t = [0, 1], r, n = 1;
  function a(i) {
    return i != null && i <= i ? t[zo(e, i, 0, n)] : r;
  }
  return a.domain = function(i) {
    return arguments.length ? (e = Array.from(i), n = Math.min(e.length, t.length - 1), a) : e.slice();
  }, a.range = function(i) {
    return arguments.length ? (t = Array.from(i), n = Math.min(e.length, t.length - 1), a) : t.slice();
  }, a.invertExtent = function(i) {
    var o = t.indexOf(i);
    return [e[o - 1], e[o]];
  }, a.unknown = function(i) {
    return arguments.length ? (r = i, a) : r;
  }, a.copy = function() {
    return uw().domain(e).range(t).unknown(r);
  }, _r.apply(a, arguments);
}
const U6 = /* @__PURE__ */ new Date(), Z6 = /* @__PURE__ */ new Date();
function Bt(e, t, r, n) {
  function a(i) {
    return e(i = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+i)), i;
  }
  return a.floor = (i) => (e(i = /* @__PURE__ */ new Date(+i)), i), a.ceil = (i) => (e(i = new Date(i - 1)), t(i, 1), e(i), i), a.round = (i) => {
    const o = a(i), s = a.ceil(i);
    return i - o < s - i ? o : s;
  }, a.offset = (i, o) => (t(i = /* @__PURE__ */ new Date(+i), o == null ? 1 : Math.floor(o)), i), a.range = (i, o, s) => {
    const c = [];
    if (i = a.ceil(i), s = s == null ? 1 : Math.floor(s), !(i < o) || !(s > 0))
      return c;
    let u;
    do
      c.push(u = /* @__PURE__ */ new Date(+i)), t(i, s), e(i);
    while (u < i && i < o);
    return c;
  }, a.filter = (i) => Bt((o) => {
    if (o >= o)
      for (; e(o), !i(o); )
        o.setTime(o - 1);
  }, (o, s) => {
    if (o >= o)
      if (s < 0)
        for (; ++s <= 0; )
          for (; t(o, -1), !i(o); )
            ;
      else
        for (; --s >= 0; )
          for (; t(o, 1), !i(o); )
            ;
  }), r && (a.count = (i, o) => (U6.setTime(+i), Z6.setTime(+o), e(U6), e(Z6), Math.floor(r(U6, Z6))), a.every = (i) => (i = Math.floor(i), !isFinite(i) || !(i > 0) ? null : i > 1 ? a.filter(n ? (o) => n(o) % i === 0 : (o) => a.count(0, o) % i === 0) : a)), a;
}
const Is = Bt(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
Is.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Bt((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, r) => {
  t.setTime(+t + r * e);
}, (t, r) => (r - t) / e) : Is);
Is.range;
const Cn = 1e3, Pr = Cn * 60, bn = Pr * 60, On = bn * 24, R9 = On * 7, ap = On * 30, K6 = On * 365, Q1 = Bt((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Cn);
}, (e, t) => (t - e) / Cn, (e) => e.getUTCSeconds());
Q1.range;
const F9 = Bt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Cn);
}, (e, t) => {
  e.setTime(+e + t * Pr);
}, (e, t) => (t - e) / Pr, (e) => e.getMinutes());
F9.range;
const $9 = Bt((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * Pr);
}, (e, t) => (t - e) / Pr, (e) => e.getUTCMinutes());
$9.range;
const H9 = Bt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Cn - e.getMinutes() * Pr);
}, (e, t) => {
  e.setTime(+e + t * bn);
}, (e, t) => (t - e) / bn, (e) => e.getHours());
H9.range;
const Y9 = Bt((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * bn);
}, (e, t) => (t - e) / bn, (e) => e.getUTCHours());
Y9.range;
const Jo = Bt(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Pr) / On,
  (e) => e.getDate() - 1
);
Jo.range;
const N0 = Bt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / On, (e) => e.getUTCDate() - 1);
N0.range;
const dw = Bt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / On, (e) => Math.floor(e / On));
dw.range;
function ia(e) {
  return Bt((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setDate(t.getDate() + r * 7);
  }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * Pr) / R9);
}
const L0 = ia(0), Bs = ia(1), YJ = ia(2), kJ = ia(3), e2 = ia(4), VJ = ia(5), GJ = ia(6);
L0.range;
Bs.range;
YJ.range;
kJ.range;
e2.range;
VJ.range;
GJ.range;
function oa(e) {
  return Bt((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCDate(t.getUTCDate() + r * 7);
  }, (t, r) => (r - t) / R9);
}
const T0 = oa(0), Ns = oa(1), WJ = oa(2), QJ = oa(3), t2 = oa(4), UJ = oa(5), ZJ = oa(6);
T0.range;
Ns.range;
WJ.range;
QJ.range;
t2.range;
UJ.range;
ZJ.range;
const k9 = Bt((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
k9.range;
const V9 = Bt((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
V9.range;
const Mn = Bt((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Mn.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Bt((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, r) => {
  t.setFullYear(t.getFullYear() + r * e);
});
Mn.range;
const En = Bt((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
En.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Bt((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, r) => {
  t.setUTCFullYear(t.getUTCFullYear() + r * e);
});
En.range;
function fw(e, t, r, n, a, i) {
  const o = [
    [Q1, 1, Cn],
    [Q1, 5, 5 * Cn],
    [Q1, 15, 15 * Cn],
    [Q1, 30, 30 * Cn],
    [i, 1, Pr],
    [i, 5, 5 * Pr],
    [i, 15, 15 * Pr],
    [i, 30, 30 * Pr],
    [a, 1, bn],
    [a, 3, 3 * bn],
    [a, 6, 6 * bn],
    [a, 12, 12 * bn],
    [n, 1, On],
    [n, 2, 2 * On],
    [r, 1, R9],
    [t, 1, ap],
    [t, 3, 3 * ap],
    [e, 1, K6]
  ];
  function s(u, d, h) {
    const A = d < u;
    A && ([u, d] = [d, u]);
    const p = h && typeof h.range == "function" ? h : c(u, d, h), v = p ? p.range(u, +d + 1) : [];
    return A ? v.reverse() : v;
  }
  function c(u, d, h) {
    const A = Math.abs(d - u) / h, p = O9(([, , m]) => m).right(o, A);
    if (p === o.length)
      return e.every(M5(u / K6, d / K6, h));
    if (p === 0)
      return Is.every(Math.max(M5(u, d, h), 1));
    const [v, g] = o[A / o[p - 1][2] < o[p][2] / A ? p - 1 : p];
    return v.every(g);
  }
  return [s, c];
}
const [KJ, zJ] = fw(En, V9, T0, dw, Y9, $9), [qJ, XJ] = fw(Mn, k9, L0, Jo, H9, F9);
function z6(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function q6(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function ui(e, t, r) {
  return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function JJ(e) {
  var t = e.dateTime, r = e.date, n = e.time, a = e.periods, i = e.days, o = e.shortDays, s = e.months, c = e.shortMonths, u = di(a), d = fi(a), h = di(i), A = fi(i), p = di(o), v = fi(o), g = di(s), m = fi(s), b = di(c), w = fi(c), x = {
    a: Z,
    A: te,
    b: B,
    B: I,
    c: null,
    d: up,
    e: up,
    f: wee,
    g: Bee,
    G: Lee,
    H: Cee,
    I: bee,
    j: yee,
    L: hw,
    m: xee,
    M: Dee,
    p: _,
    q: L,
    Q: hp,
    s: Ap,
    S: Oee,
    u: Mee,
    U: Eee,
    V: See,
    w: Pee,
    W: jee,
    x: null,
    X: null,
    y: Iee,
    Y: Nee,
    Z: Tee,
    "%": fp
  }, y = {
    a: D,
    A: T,
    b: Q,
    B: z,
    c: null,
    d: dp,
    e: dp,
    f: $ee,
    g: Kee,
    G: qee,
    H: _ee,
    I: Ree,
    j: Fee,
    L: pw,
    m: Hee,
    M: Yee,
    p: W,
    q: H,
    Q: hp,
    s: Ap,
    S: kee,
    u: Vee,
    U: Gee,
    V: Wee,
    w: Qee,
    W: Uee,
    x: null,
    X: null,
    y: Zee,
    Y: zee,
    Z: Xee,
    "%": fp
  }, C = {
    a: F,
    A: k,
    b: R,
    B: j,
    c: U,
    d: lp,
    e: lp,
    f: pee,
    g: sp,
    G: op,
    H: cp,
    I: cp,
    j: dee,
    L: Aee,
    m: uee,
    M: fee,
    p: N,
    q: cee,
    Q: vee,
    s: mee,
    S: hee,
    u: aee,
    U: iee,
    V: oee,
    w: nee,
    W: see,
    x: ee,
    X,
    y: sp,
    Y: op,
    Z: lee,
    "%": gee
  };
  x.x = O(r, x), x.X = O(n, x), x.c = O(t, x), y.x = O(r, y), y.X = O(n, y), y.c = O(t, y);
  function O($, V) {
    return function(Y) {
      var S = [], J = -1, q = 0, re = $.length, ae, oe, ue;
      for (Y instanceof Date || (Y = /* @__PURE__ */ new Date(+Y)); ++J < re; )
        $.charCodeAt(J) === 37 && (S.push($.slice(q, J)), (oe = ip[ae = $.charAt(++J)]) != null ? ae = $.charAt(++J) : oe = ae === "e" ? " " : "0", (ue = V[ae]) && (ae = ue(Y, oe)), S.push(ae), q = J + 1);
      return S.push($.slice(q, J)), S.join("");
    };
  }
  function M($, V) {
    return function(Y) {
      var S = ui(1900, void 0, 1), J = E(S, $, Y += "", 0), q, re;
      if (J != Y.length)
        return null;
      if ("Q" in S)
        return new Date(S.Q);
      if ("s" in S)
        return new Date(S.s * 1e3 + ("L" in S ? S.L : 0));
      if (V && !("Z" in S) && (S.Z = 0), "p" in S && (S.H = S.H % 12 + S.p * 12), S.m === void 0 && (S.m = "q" in S ? S.q : 0), "V" in S) {
        if (S.V < 1 || S.V > 53)
          return null;
        "w" in S || (S.w = 1), "Z" in S ? (q = q6(ui(S.y, 0, 1)), re = q.getUTCDay(), q = re > 4 || re === 0 ? Ns.ceil(q) : Ns(q), q = N0.offset(q, (S.V - 1) * 7), S.y = q.getUTCFullYear(), S.m = q.getUTCMonth(), S.d = q.getUTCDate() + (S.w + 6) % 7) : (q = z6(ui(S.y, 0, 1)), re = q.getDay(), q = re > 4 || re === 0 ? Bs.ceil(q) : Bs(q), q = Jo.offset(q, (S.V - 1) * 7), S.y = q.getFullYear(), S.m = q.getMonth(), S.d = q.getDate() + (S.w + 6) % 7);
      } else
        ("W" in S || "U" in S) && ("w" in S || (S.w = "u" in S ? S.u % 7 : "W" in S ? 1 : 0), re = "Z" in S ? q6(ui(S.y, 0, 1)).getUTCDay() : z6(ui(S.y, 0, 1)).getDay(), S.m = 0, S.d = "W" in S ? (S.w + 6) % 7 + S.W * 7 - (re + 5) % 7 : S.w + S.U * 7 - (re + 6) % 7);
      return "Z" in S ? (S.H += S.Z / 100 | 0, S.M += S.Z % 100, q6(S)) : z6(S);
    };
  }
  function E($, V, Y, S) {
    for (var J = 0, q = V.length, re = Y.length, ae, oe; J < q; ) {
      if (S >= re)
        return -1;
      if (ae = V.charCodeAt(J++), ae === 37) {
        if (ae = V.charAt(J++), oe = C[ae in ip ? V.charAt(J++) : ae], !oe || (S = oe($, Y, S)) < 0)
          return -1;
      } else if (ae != Y.charCodeAt(S++))
        return -1;
    }
    return S;
  }
  function N($, V, Y) {
    var S = u.exec(V.slice(Y));
    return S ? ($.p = d.get(S[0].toLowerCase()), Y + S[0].length) : -1;
  }
  function F($, V, Y) {
    var S = p.exec(V.slice(Y));
    return S ? ($.w = v.get(S[0].toLowerCase()), Y + S[0].length) : -1;
  }
  function k($, V, Y) {
    var S = h.exec(V.slice(Y));
    return S ? ($.w = A.get(S[0].toLowerCase()), Y + S[0].length) : -1;
  }
  function R($, V, Y) {
    var S = b.exec(V.slice(Y));
    return S ? ($.m = w.get(S[0].toLowerCase()), Y + S[0].length) : -1;
  }
  function j($, V, Y) {
    var S = g.exec(V.slice(Y));
    return S ? ($.m = m.get(S[0].toLowerCase()), Y + S[0].length) : -1;
  }
  function U($, V, Y) {
    return E($, t, V, Y);
  }
  function ee($, V, Y) {
    return E($, r, V, Y);
  }
  function X($, V, Y) {
    return E($, n, V, Y);
  }
  function Z($) {
    return o[$.getDay()];
  }
  function te($) {
    return i[$.getDay()];
  }
  function B($) {
    return c[$.getMonth()];
  }
  function I($) {
    return s[$.getMonth()];
  }
  function _($) {
    return a[+($.getHours() >= 12)];
  }
  function L($) {
    return 1 + ~~($.getMonth() / 3);
  }
  function D($) {
    return o[$.getUTCDay()];
  }
  function T($) {
    return i[$.getUTCDay()];
  }
  function Q($) {
    return c[$.getUTCMonth()];
  }
  function z($) {
    return s[$.getUTCMonth()];
  }
  function W($) {
    return a[+($.getUTCHours() >= 12)];
  }
  function H($) {
    return 1 + ~~($.getUTCMonth() / 3);
  }
  return {
    format: function($) {
      var V = O($ += "", x);
      return V.toString = function() {
        return $;
      }, V;
    },
    parse: function($) {
      var V = M($ += "", !1);
      return V.toString = function() {
        return $;
      }, V;
    },
    utcFormat: function($) {
      var V = O($ += "", y);
      return V.toString = function() {
        return $;
      }, V;
    },
    utcParse: function($) {
      var V = M($ += "", !0);
      return V.toString = function() {
        return $;
      }, V;
    }
  };
}
var ip = { "-": "", _: " ", 0: "0" }, Ft = /^\s*\d+/, eee = /^%/, tee = /[\\^$*+?|[\]().{}]/g;
function Ge(e, t, r) {
  var n = e < 0 ? "-" : "", a = (n ? -e : e) + "", i = a.length;
  return n + (i < r ? new Array(r - i + 1).join(t) + a : a);
}
function ree(e) {
  return e.replace(tee, "\\$&");
}
function di(e) {
  return new RegExp("^(?:" + e.map(ree).join("|") + ")", "i");
}
function fi(e) {
  return new Map(e.map((t, r) => [t.toLowerCase(), r]));
}
function nee(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 1));
  return n ? (e.w = +n[0], r + n[0].length) : -1;
}
function aee(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 1));
  return n ? (e.u = +n[0], r + n[0].length) : -1;
}
function iee(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.U = +n[0], r + n[0].length) : -1;
}
function oee(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.V = +n[0], r + n[0].length) : -1;
}
function see(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.W = +n[0], r + n[0].length) : -1;
}
function op(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 4));
  return n ? (e.y = +n[0], r + n[0].length) : -1;
}
function sp(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function lee(e, t, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function cee(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 1));
  return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function uee(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
}
function lp(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.d = +n[0], r + n[0].length) : -1;
}
function dee(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 3));
  return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
}
function cp(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.H = +n[0], r + n[0].length) : -1;
}
function fee(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.M = +n[0], r + n[0].length) : -1;
}
function hee(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 2));
  return n ? (e.S = +n[0], r + n[0].length) : -1;
}
function Aee(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 3));
  return n ? (e.L = +n[0], r + n[0].length) : -1;
}
function pee(e, t, r) {
  var n = Ft.exec(t.slice(r, r + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function gee(e, t, r) {
  var n = eee.exec(t.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function vee(e, t, r) {
  var n = Ft.exec(t.slice(r));
  return n ? (e.Q = +n[0], r + n[0].length) : -1;
}
function mee(e, t, r) {
  var n = Ft.exec(t.slice(r));
  return n ? (e.s = +n[0], r + n[0].length) : -1;
}
function up(e, t) {
  return Ge(e.getDate(), t, 2);
}
function Cee(e, t) {
  return Ge(e.getHours(), t, 2);
}
function bee(e, t) {
  return Ge(e.getHours() % 12 || 12, t, 2);
}
function yee(e, t) {
  return Ge(1 + Jo.count(Mn(e), e), t, 3);
}
function hw(e, t) {
  return Ge(e.getMilliseconds(), t, 3);
}
function wee(e, t) {
  return hw(e, t) + "000";
}
function xee(e, t) {
  return Ge(e.getMonth() + 1, t, 2);
}
function Dee(e, t) {
  return Ge(e.getMinutes(), t, 2);
}
function Oee(e, t) {
  return Ge(e.getSeconds(), t, 2);
}
function Mee(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function Eee(e, t) {
  return Ge(L0.count(Mn(e) - 1, e), t, 2);
}
function Aw(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? e2(e) : e2.ceil(e);
}
function See(e, t) {
  return e = Aw(e), Ge(e2.count(Mn(e), e) + (Mn(e).getDay() === 4), t, 2);
}
function Pee(e) {
  return e.getDay();
}
function jee(e, t) {
  return Ge(Bs.count(Mn(e) - 1, e), t, 2);
}
function Iee(e, t) {
  return Ge(e.getFullYear() % 100, t, 2);
}
function Bee(e, t) {
  return e = Aw(e), Ge(e.getFullYear() % 100, t, 2);
}
function Nee(e, t) {
  return Ge(e.getFullYear() % 1e4, t, 4);
}
function Lee(e, t) {
  var r = e.getDay();
  return e = r >= 4 || r === 0 ? e2(e) : e2.ceil(e), Ge(e.getFullYear() % 1e4, t, 4);
}
function Tee(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + Ge(t / 60 | 0, "0", 2) + Ge(t % 60, "0", 2);
}
function dp(e, t) {
  return Ge(e.getUTCDate(), t, 2);
}
function _ee(e, t) {
  return Ge(e.getUTCHours(), t, 2);
}
function Ree(e, t) {
  return Ge(e.getUTCHours() % 12 || 12, t, 2);
}
function Fee(e, t) {
  return Ge(1 + N0.count(En(e), e), t, 3);
}
function pw(e, t) {
  return Ge(e.getUTCMilliseconds(), t, 3);
}
function $ee(e, t) {
  return pw(e, t) + "000";
}
function Hee(e, t) {
  return Ge(e.getUTCMonth() + 1, t, 2);
}
function Yee(e, t) {
  return Ge(e.getUTCMinutes(), t, 2);
}
function kee(e, t) {
  return Ge(e.getUTCSeconds(), t, 2);
}
function Vee(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function Gee(e, t) {
  return Ge(T0.count(En(e) - 1, e), t, 2);
}
function gw(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? t2(e) : t2.ceil(e);
}
function Wee(e, t) {
  return e = gw(e), Ge(t2.count(En(e), e) + (En(e).getUTCDay() === 4), t, 2);
}
function Qee(e) {
  return e.getUTCDay();
}
function Uee(e, t) {
  return Ge(Ns.count(En(e) - 1, e), t, 2);
}
function Zee(e, t) {
  return Ge(e.getUTCFullYear() % 100, t, 2);
}
function Kee(e, t) {
  return e = gw(e), Ge(e.getUTCFullYear() % 100, t, 2);
}
function zee(e, t) {
  return Ge(e.getUTCFullYear() % 1e4, t, 4);
}
function qee(e, t) {
  var r = e.getUTCDay();
  return e = r >= 4 || r === 0 ? t2(e) : t2.ceil(e), Ge(e.getUTCFullYear() % 1e4, t, 4);
}
function Xee() {
  return "+0000";
}
function fp() {
  return "%";
}
function hp(e) {
  return +e;
}
function Ap(e) {
  return Math.floor(+e / 1e3);
}
var Oa, vw, mw;
Jee({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function Jee(e) {
  return Oa = JJ(e), vw = Oa.format, Oa.parse, mw = Oa.utcFormat, Oa.utcParse, Oa;
}
function ete(e) {
  return new Date(e);
}
function tte(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function G9(e, t, r, n, a, i, o, s, c, u) {
  var d = j9(), h = d.invert, A = d.domain, p = u(".%L"), v = u(":%S"), g = u("%I:%M"), m = u("%I %p"), b = u("%a %d"), w = u("%b %d"), x = u("%B"), y = u("%Y");
  function C(O) {
    return (c(O) < O ? p : s(O) < O ? v : o(O) < O ? g : i(O) < O ? m : n(O) < O ? a(O) < O ? b : w : r(O) < O ? x : y)(O);
  }
  return d.invert = function(O) {
    return new Date(h(O));
  }, d.domain = function(O) {
    return arguments.length ? A(Array.from(O, tte)) : A().map(ete);
  }, d.ticks = function(O) {
    var M = A();
    return e(M[0], M[M.length - 1], O ?? 10);
  }, d.tickFormat = function(O, M) {
    return M == null ? C : u(M);
  }, d.nice = function(O) {
    var M = A();
    return (!O || typeof O.range != "function") && (O = t(M[0], M[M.length - 1], O ?? 10)), O ? A(aw(M, O)) : d;
  }, d.copy = function() {
    return Xo(d, G9(e, t, r, n, a, i, o, s, c, u));
  }, d;
}
function rte() {
  return _r.apply(G9(qJ, XJ, Mn, k9, L0, Jo, H9, F9, Q1, vw).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function nte() {
  return _r.apply(G9(KJ, zJ, En, V9, T0, N0, Y9, $9, Q1, mw).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function _0() {
  var e = 0, t = 1, r, n, a, i, o = Jt, s = !1, c;
  function u(h) {
    return h == null || isNaN(h = +h) ? c : o(a === 0 ? 0.5 : (h = (i(h) - r) * a, s ? Math.max(0, Math.min(1, h)) : h));
  }
  u.domain = function(h) {
    return arguments.length ? ([e, t] = h, r = i(e = +e), n = i(t = +t), a = r === n ? 0 : 1 / (n - r), u) : [e, t];
  }, u.clamp = function(h) {
    return arguments.length ? (s = !!h, u) : s;
  }, u.interpolator = function(h) {
    return arguments.length ? (o = h, u) : o;
  };
  function d(h) {
    return function(A) {
      var p, v;
      return arguments.length ? ([p, v] = A, o = h(p, v), u) : [o(0), o(1)];
    };
  }
  return u.range = d(j2), u.rangeRound = d(P9), u.unknown = function(h) {
    return arguments.length ? (c = h, u) : c;
  }, function(h) {
    return i = h, r = h(e), n = h(t), a = r === n ? 0 : 1 / (n - r), u;
  };
}
function v1(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function Cw() {
  var e = g1(_0()(Jt));
  return e.copy = function() {
    return v1(e, Cw());
  }, In.apply(e, arguments);
}
function bw() {
  var e = N9(_0()).domain([1, 10]);
  return e.copy = function() {
    return v1(e, bw()).base(e.base());
  }, In.apply(e, arguments);
}
function yw() {
  var e = L9(_0());
  return e.copy = function() {
    return v1(e, yw()).constant(e.constant());
  }, In.apply(e, arguments);
}
function W9() {
  var e = T9(_0());
  return e.copy = function() {
    return v1(e, W9()).exponent(e.exponent());
  }, In.apply(e, arguments);
}
function ate() {
  return W9.apply(null, arguments).exponent(0.5);
}
function ww() {
  var e = [], t = Jt;
  function r(n) {
    if (n != null && !isNaN(n = +n))
      return t((zo(e, n, 1) - 1) / (e.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let a of n)
      a != null && !isNaN(a = +a) && e.push(a);
    return e.sort(n1), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.range = function() {
    return e.map((n, a) => t(a / (e.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (a, i) => GX(e, i / n));
  }, r.copy = function() {
    return ww(t).domain(e);
  }, In.apply(r, arguments);
}
function R0() {
  var e = 0, t = 0.5, r = 1, n = 1, a, i, o, s, c, u = Jt, d, h = !1, A;
  function p(g) {
    return isNaN(g = +g) ? A : (g = 0.5 + ((g = +d(g)) - i) * (n * g < n * i ? s : c), u(h ? Math.max(0, Math.min(1, g)) : g));
  }
  p.domain = function(g) {
    return arguments.length ? ([e, t, r] = g, a = d(e = +e), i = d(t = +t), o = d(r = +r), s = a === i ? 0 : 0.5 / (i - a), c = i === o ? 0 : 0.5 / (o - i), n = i < a ? -1 : 1, p) : [e, t, r];
  }, p.clamp = function(g) {
    return arguments.length ? (h = !!g, p) : h;
  }, p.interpolator = function(g) {
    return arguments.length ? (u = g, p) : u;
  };
  function v(g) {
    return function(m) {
      var b, w, x;
      return arguments.length ? ([b, w, x] = m, u = gJ(g, [b, w, x]), p) : [u(0), u(0.5), u(1)];
    };
  }
  return p.range = v(j2), p.rangeRound = v(P9), p.unknown = function(g) {
    return arguments.length ? (A = g, p) : A;
  }, function(g) {
    return d = g, a = g(e), i = g(t), o = g(r), s = a === i ? 0 : 0.5 / (i - a), c = i === o ? 0 : 0.5 / (o - i), n = i < a ? -1 : 1, p;
  };
}
function xw() {
  var e = g1(R0()(Jt));
  return e.copy = function() {
    return v1(e, xw());
  }, In.apply(e, arguments);
}
function Dw() {
  var e = N9(R0()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return v1(e, Dw()).base(e.base());
  }, In.apply(e, arguments);
}
function Ow() {
  var e = L9(R0());
  return e.copy = function() {
    return v1(e, Ow()).constant(e.constant());
  }, In.apply(e, arguments);
}
function Q9() {
  var e = T9(R0());
  return e.copy = function() {
    return v1(e, Q9()).exponent(e.exponent());
  }, In.apply(e, arguments);
}
function ite() {
  return Q9.apply(null, arguments).exponent(0.5);
}
const pp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: co,
  scaleDiverging: xw,
  scaleDivergingLog: Dw,
  scaleDivergingPow: Q9,
  scaleDivergingSqrt: ite,
  scaleDivergingSymlog: Ow,
  scaleIdentity: nw,
  scaleImplicit: E5,
  scaleLinear: js,
  scaleLog: iw,
  scaleOrdinal: M9,
  scalePoint: $i,
  scalePow: _9,
  scaleQuantile: lw,
  scaleQuantize: cw,
  scaleRadial: sw,
  scaleSequential: Cw,
  scaleSequentialLog: bw,
  scaleSequentialPow: W9,
  scaleSequentialQuantile: ww,
  scaleSequentialSqrt: ate,
  scaleSequentialSymlog: yw,
  scaleSqrt: $J,
  scaleSymlog: ow,
  scaleThreshold: uw,
  scaleTime: rte,
  scaleUtc: nte,
  tickFormat: rw
}, Symbol.toStringTag, { value: "Module" }));
var ote = b2;
function ste(e, t, r) {
  for (var n = -1, a = e.length; ++n < a; ) {
    var i = e[n], o = t(i);
    if (o != null && (s === void 0 ? o === o && !ote(o) : r(o, s)))
      var s = o, c = i;
  }
  return c;
}
var F0 = ste;
function lte(e, t) {
  return e > t;
}
var Mw = lte, cte = F0, ute = Mw, dte = S2;
function fte(e) {
  return e && e.length ? cte(e, dte, ute) : void 0;
}
var hte = fte;
const zn = /* @__PURE__ */ Xe(hte);
function Ate(e, t) {
  return e < t;
}
var Ew = Ate, pte = F0, gte = Ew, vte = S2;
function mte(e) {
  return e && e.length ? pte(e, vte, gte) : void 0;
}
var Cte = mte;
const $0 = /* @__PURE__ */ Xe(Cte);
var bte = c9, yte = hn, wte = Ty, xte = ir;
function Dte(e, t) {
  var r = xte(e) ? bte : wte;
  return r(e, yte(t));
}
var Ote = Dte, Mte = Ny, Ete = Ote;
function Ste(e, t) {
  return Mte(Ete(e, t), 1);
}
var Pte = Ste;
const jte = /* @__PURE__ */ Xe(Pte);
var Ite = y9;
function Bte(e, t) {
  return Ite(e, t);
}
var Nte = Bte;
const c1 = /* @__PURE__ */ Xe(Nte);
var I2 = 1e9, Lte = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, Z9, Ct = !0, Nr = "[DecimalError] ", q1 = Nr + "Invalid argument: ", U9 = Nr + "Exponent out of range: ", B2 = Math.floor, $1 = Math.pow, Tte = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, hr, Tt = 1e7, At = 7, Sw = 9007199254740991, Ls = B2(Sw / At), he = {};
he.absoluteValue = he.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
he.comparedTo = he.cmp = function(e) {
  var t, r, n, a, i = this;
  if (e = new i.constructor(e), i.s !== e.s)
    return i.s || -e.s;
  if (i.e !== e.e)
    return i.e > e.e ^ i.s < 0 ? 1 : -1;
  for (n = i.d.length, a = e.d.length, t = 0, r = n < a ? n : a; t < r; ++t)
    if (i.d[t] !== e.d[t])
      return i.d[t] > e.d[t] ^ i.s < 0 ? 1 : -1;
  return n === a ? 0 : n > a ^ i.s < 0 ? 1 : -1;
};
he.decimalPlaces = he.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * At;
  if (t = e.d[t], t)
    for (; t % 10 == 0; t /= 10)
      r--;
  return r < 0 ? 0 : r;
};
he.dividedBy = he.div = function(e) {
  return Dn(this, new this.constructor(e));
};
he.dividedToIntegerBy = he.idiv = function(e) {
  var t = this, r = t.constructor;
  return ot(Dn(t, new r(e), 0, 1), r.precision);
};
he.equals = he.eq = function(e) {
  return !this.cmp(e);
};
he.exponent = function() {
  return Mt(this);
};
he.greaterThan = he.gt = function(e) {
  return this.cmp(e) > 0;
};
he.greaterThanOrEqualTo = he.gte = function(e) {
  return this.cmp(e) >= 0;
};
he.isInteger = he.isint = function() {
  return this.e > this.d.length - 2;
};
he.isNegative = he.isneg = function() {
  return this.s < 0;
};
he.isPositive = he.ispos = function() {
  return this.s > 0;
};
he.isZero = function() {
  return this.s === 0;
};
he.lessThan = he.lt = function(e) {
  return this.cmp(e) < 0;
};
he.lessThanOrEqualTo = he.lte = function(e) {
  return this.cmp(e) < 1;
};
he.logarithm = he.log = function(e) {
  var t, r = this, n = r.constructor, a = n.precision, i = a + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(hr))
    throw Error(Nr + "NaN");
  if (r.s < 1)
    throw Error(Nr + (r.s ? "NaN" : "-Infinity"));
  return r.eq(hr) ? new n(0) : (Ct = !1, t = Dn(po(r, i), po(e, i), i), Ct = !0, ot(t, a));
};
he.minus = he.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? Iw(t, e) : Pw(t, (e.s = -e.s, e));
};
he.modulo = he.mod = function(e) {
  var t, r = this, n = r.constructor, a = n.precision;
  if (e = new n(e), !e.s)
    throw Error(Nr + "NaN");
  return r.s ? (Ct = !1, t = Dn(r, e, 0, 1).times(e), Ct = !0, r.minus(t)) : ot(new n(r), a);
};
he.naturalExponential = he.exp = function() {
  return jw(this);
};
he.naturalLogarithm = he.ln = function() {
  return po(this);
};
he.negated = he.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
he.plus = he.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? Pw(t, e) : Iw(t, (e.s = -e.s, e));
};
he.precision = he.sd = function(e) {
  var t, r, n, a = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0)
    throw Error(q1 + e);
  if (t = Mt(a) + 1, n = a.d.length - 1, r = n * At + 1, n = a.d[n], n) {
    for (; n % 10 == 0; n /= 10)
      r--;
    for (n = a.d[0]; n >= 10; n /= 10)
      r++;
  }
  return e && t > r ? t : r;
};
he.squareRoot = he.sqrt = function() {
  var e, t, r, n, a, i, o, s = this, c = s.constructor;
  if (s.s < 1) {
    if (!s.s)
      return new c(0);
    throw Error(Nr + "NaN");
  }
  for (e = Mt(s), Ct = !1, a = Math.sqrt(+s), a == 0 || a == 1 / 0 ? (t = sn(s.d), (t.length + e) % 2 == 0 && (t += "0"), a = Math.sqrt(t), e = B2((e + 1) / 2) - (e < 0 || e % 2), a == 1 / 0 ? t = "5e" + e : (t = a.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new c(t)) : n = new c(a.toString()), r = c.precision, a = o = r + 3; ; )
    if (i = n, n = i.plus(Dn(s, i, o + 2)).times(0.5), sn(i.d).slice(0, o) === (t = sn(n.d)).slice(0, o)) {
      if (t = t.slice(o - 3, o + 1), a == o && t == "4999") {
        if (ot(i, r + 1, 0), i.times(i).eq(s)) {
          n = i;
          break;
        }
      } else if (t != "9999")
        break;
      o += 4;
    }
  return Ct = !0, ot(n, r);
};
he.times = he.mul = function(e) {
  var t, r, n, a, i, o, s, c, u, d = this, h = d.constructor, A = d.d, p = (e = new h(e)).d;
  if (!d.s || !e.s)
    return new h(0);
  for (e.s *= d.s, r = d.e + e.e, c = A.length, u = p.length, c < u && (i = A, A = p, p = i, o = c, c = u, u = o), i = [], o = c + u, n = o; n--; )
    i.push(0);
  for (n = u; --n >= 0; ) {
    for (t = 0, a = c + n; a > n; )
      s = i[a] + p[n] * A[a - n - 1] + t, i[a--] = s % Tt | 0, t = s / Tt | 0;
    i[a] = (i[a] + t) % Tt | 0;
  }
  for (; !i[--o]; )
    i.pop();
  return t ? ++r : i.shift(), e.d = i, e.e = r, Ct ? ot(e, h.precision) : e;
};
he.toDecimalPlaces = he.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (dn(e, 0, I2), t === void 0 ? t = n.rounding : dn(t, 0, 8), ot(r, e + Mt(r) + 1, t));
};
he.toExponential = function(e, t) {
  var r, n = this, a = n.constructor;
  return e === void 0 ? r = ea(n, !0) : (dn(e, 0, I2), t === void 0 ? t = a.rounding : dn(t, 0, 8), n = ot(new a(n), e + 1, t), r = ea(n, !0, e + 1)), r;
};
he.toFixed = function(e, t) {
  var r, n, a = this, i = a.constructor;
  return e === void 0 ? ea(a) : (dn(e, 0, I2), t === void 0 ? t = i.rounding : dn(t, 0, 8), n = ot(new i(a), e + Mt(a) + 1, t), r = ea(n.abs(), !1, e + Mt(n) + 1), a.isneg() && !a.isZero() ? "-" + r : r);
};
he.toInteger = he.toint = function() {
  var e = this, t = e.constructor;
  return ot(new t(e), Mt(e) + 1, t.rounding);
};
he.toNumber = function() {
  return +this;
};
he.toPower = he.pow = function(e) {
  var t, r, n, a, i, o, s = this, c = s.constructor, u = 12, d = +(e = new c(e));
  if (!e.s)
    return new c(hr);
  if (s = new c(s), !s.s) {
    if (e.s < 1)
      throw Error(Nr + "Infinity");
    return s;
  }
  if (s.eq(hr))
    return s;
  if (n = c.precision, e.eq(hr))
    return ot(s, n);
  if (t = e.e, r = e.d.length - 1, o = t >= r, i = s.s, o) {
    if ((r = d < 0 ? -d : d) <= Sw) {
      for (a = new c(hr), t = Math.ceil(n / At + 4), Ct = !1; r % 2 && (a = a.times(s), vp(a.d, t)), r = B2(r / 2), r !== 0; )
        s = s.times(s), vp(s.d, t);
      return Ct = !0, e.s < 0 ? new c(hr).div(a) : ot(a, n);
    }
  } else if (i < 0)
    throw Error(Nr + "NaN");
  return i = i < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, s.s = 1, Ct = !1, a = e.times(po(s, n + u)), Ct = !0, a = jw(a), a.s = i, a;
};
he.toPrecision = function(e, t) {
  var r, n, a = this, i = a.constructor;
  return e === void 0 ? (r = Mt(a), n = ea(a, r <= i.toExpNeg || r >= i.toExpPos)) : (dn(e, 1, I2), t === void 0 ? t = i.rounding : dn(t, 0, 8), a = ot(new i(a), e, t), r = Mt(a), n = ea(a, e <= r || r <= i.toExpNeg, e)), n;
};
he.toSignificantDigits = he.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (dn(e, 1, I2), t === void 0 ? t = n.rounding : dn(t, 0, 8)), ot(new n(r), e, t);
};
he.toString = he.valueOf = he.val = he.toJSON = he[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = Mt(e), r = e.constructor;
  return ea(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function Pw(e, t) {
  var r, n, a, i, o, s, c, u, d = e.constructor, h = d.precision;
  if (!e.s || !t.s)
    return t.s || (t = new d(e)), Ct ? ot(t, h) : t;
  if (c = e.d, u = t.d, o = e.e, a = t.e, c = c.slice(), i = o - a, i) {
    for (i < 0 ? (n = c, i = -i, s = u.length) : (n = u, a = o, s = c.length), o = Math.ceil(h / At), s = o > s ? o + 1 : s + 1, i > s && (i = s, n.length = 1), n.reverse(); i--; )
      n.push(0);
    n.reverse();
  }
  for (s = c.length, i = u.length, s - i < 0 && (i = s, n = u, u = c, c = n), r = 0; i; )
    r = (c[--i] = c[i] + u[i] + r) / Tt | 0, c[i] %= Tt;
  for (r && (c.unshift(r), ++a), s = c.length; c[--s] == 0; )
    c.pop();
  return t.d = c, t.e = a, Ct ? ot(t, h) : t;
}
function dn(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(q1 + e);
}
function sn(e) {
  var t, r, n, a = e.length - 1, i = "", o = e[0];
  if (a > 0) {
    for (i += o, t = 1; t < a; t++)
      n = e[t] + "", r = At - n.length, r && (i += Zn(r)), i += n;
    o = e[t], n = o + "", r = At - n.length, r && (i += Zn(r));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; )
    o /= 10;
  return i + o;
}
var Dn = function() {
  function e(n, a) {
    var i, o = 0, s = n.length;
    for (n = n.slice(); s--; )
      i = n[s] * a + o, n[s] = i % Tt | 0, o = i / Tt | 0;
    return o && n.unshift(o), n;
  }
  function t(n, a, i, o) {
    var s, c;
    if (i != o)
      c = i > o ? 1 : -1;
    else
      for (s = c = 0; s < i; s++)
        if (n[s] != a[s]) {
          c = n[s] > a[s] ? 1 : -1;
          break;
        }
    return c;
  }
  function r(n, a, i) {
    for (var o = 0; i--; )
      n[i] -= o, o = n[i] < a[i] ? 1 : 0, n[i] = o * Tt + n[i] - a[i];
    for (; !n[0] && n.length > 1; )
      n.shift();
  }
  return function(n, a, i, o) {
    var s, c, u, d, h, A, p, v, g, m, b, w, x, y, C, O, M, E, N = n.constructor, F = n.s == a.s ? 1 : -1, k = n.d, R = a.d;
    if (!n.s)
      return new N(n);
    if (!a.s)
      throw Error(Nr + "Division by zero");
    for (c = n.e - a.e, M = R.length, C = k.length, p = new N(F), v = p.d = [], u = 0; R[u] == (k[u] || 0); )
      ++u;
    if (R[u] > (k[u] || 0) && --c, i == null ? w = i = N.precision : o ? w = i + (Mt(n) - Mt(a)) + 1 : w = i, w < 0)
      return new N(0);
    if (w = w / At + 2 | 0, u = 0, M == 1)
      for (d = 0, R = R[0], w++; (u < C || d) && w--; u++)
        x = d * Tt + (k[u] || 0), v[u] = x / R | 0, d = x % R | 0;
    else {
      for (d = Tt / (R[0] + 1) | 0, d > 1 && (R = e(R, d), k = e(k, d), M = R.length, C = k.length), y = M, g = k.slice(0, M), m = g.length; m < M; )
        g[m++] = 0;
      E = R.slice(), E.unshift(0), O = R[0], R[1] >= Tt / 2 && ++O;
      do
        d = 0, s = t(R, g, M, m), s < 0 ? (b = g[0], M != m && (b = b * Tt + (g[1] || 0)), d = b / O | 0, d > 1 ? (d >= Tt && (d = Tt - 1), h = e(R, d), A = h.length, m = g.length, s = t(h, g, A, m), s == 1 && (d--, r(h, M < A ? E : R, A))) : (d == 0 && (s = d = 1), h = R.slice()), A = h.length, A < m && h.unshift(0), r(g, h, m), s == -1 && (m = g.length, s = t(R, g, M, m), s < 1 && (d++, r(g, M < m ? E : R, m))), m = g.length) : s === 0 && (d++, g = [0]), v[u++] = d, s && g[0] ? g[m++] = k[y] || 0 : (g = [k[y]], m = 1);
      while ((y++ < C || g[0] !== void 0) && w--);
    }
    return v[0] || v.shift(), p.e = c, ot(p, o ? i + Mt(p) + 1 : i);
  };
}();
function jw(e, t) {
  var r, n, a, i, o, s, c = 0, u = 0, d = e.constructor, h = d.precision;
  if (Mt(e) > 16)
    throw Error(U9 + Mt(e));
  if (!e.s)
    return new d(hr);
  for (t == null ? (Ct = !1, s = h) : s = t, o = new d(0.03125); e.abs().gte(0.1); )
    e = e.times(o), u += 5;
  for (n = Math.log($1(2, u)) / Math.LN10 * 2 + 5 | 0, s += n, r = a = i = new d(hr), d.precision = s; ; ) {
    if (a = ot(a.times(e), s), r = r.times(++c), o = i.plus(Dn(a, r, s)), sn(o.d).slice(0, s) === sn(i.d).slice(0, s)) {
      for (; u--; )
        i = ot(i.times(i), s);
      return d.precision = h, t == null ? (Ct = !0, ot(i, h)) : i;
    }
    i = o;
  }
}
function Mt(e) {
  for (var t = e.e * At, r = e.d[0]; r >= 10; r /= 10)
    t++;
  return t;
}
function X6(e, t, r) {
  if (t > e.LN10.sd())
    throw Ct = !0, r && (e.precision = r), Error(Nr + "LN10 precision limit exceeded");
  return ot(new e(e.LN10), t);
}
function Zn(e) {
  for (var t = ""; e--; )
    t += "0";
  return t;
}
function po(e, t) {
  var r, n, a, i, o, s, c, u, d, h = 1, A = 10, p = e, v = p.d, g = p.constructor, m = g.precision;
  if (p.s < 1)
    throw Error(Nr + (p.s ? "NaN" : "-Infinity"));
  if (p.eq(hr))
    return new g(0);
  if (t == null ? (Ct = !1, u = m) : u = t, p.eq(10))
    return t == null && (Ct = !0), X6(g, u);
  if (u += A, g.precision = u, r = sn(v), n = r.charAt(0), i = Mt(p), Math.abs(i) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      p = p.times(e), r = sn(p.d), n = r.charAt(0), h++;
    i = Mt(p), n > 1 ? (p = new g("0." + r), i++) : p = new g(n + "." + r.slice(1));
  } else
    return c = X6(g, u + 2, m).times(i + ""), p = po(new g(n + "." + r.slice(1)), u - A).plus(c), g.precision = m, t == null ? (Ct = !0, ot(p, m)) : p;
  for (s = o = p = Dn(p.minus(hr), p.plus(hr), u), d = ot(p.times(p), u), a = 3; ; ) {
    if (o = ot(o.times(d), u), c = s.plus(Dn(o, new g(a), u)), sn(c.d).slice(0, u) === sn(s.d).slice(0, u))
      return s = s.times(2), i !== 0 && (s = s.plus(X6(g, u + 2, m).times(i + ""))), s = Dn(s, new g(h), u), g.precision = m, t == null ? (Ct = !0, ot(s, m)) : s;
    s = c, a += 2;
  }
}
function gp(e, t) {
  var r, n, a;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; )
    ++n;
  for (a = t.length; t.charCodeAt(a - 1) === 48; )
    --a;
  if (t = t.slice(n, a), t) {
    if (a -= n, r = r - n - 1, e.e = B2(r / At), e.d = [], n = (r + 1) % At, r < 0 && (n += At), n < a) {
      for (n && e.d.push(+t.slice(0, n)), a -= At; n < a; )
        e.d.push(+t.slice(n, n += At));
      t = t.slice(n), n = At - t.length;
    } else
      n -= a;
    for (; n--; )
      t += "0";
    if (e.d.push(+t), Ct && (e.e > Ls || e.e < -Ls))
      throw Error(U9 + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function ot(e, t, r) {
  var n, a, i, o, s, c, u, d, h = e.d;
  for (o = 1, i = h[0]; i >= 10; i /= 10)
    o++;
  if (n = t - o, n < 0)
    n += At, a = t, u = h[d = 0];
  else {
    if (d = Math.ceil((n + 1) / At), i = h.length, d >= i)
      return e;
    for (u = i = h[d], o = 1; i >= 10; i /= 10)
      o++;
    n %= At, a = n - At + o;
  }
  if (r !== void 0 && (i = $1(10, o - a - 1), s = u / i % 10 | 0, c = t < 0 || h[d + 1] !== void 0 || u % i, c = r < 4 ? (s || c) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (r == 4 || c || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? a > 0 ? u / $1(10, o - a) : 0 : h[d - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !h[0])
    return c ? (i = Mt(e), h.length = 1, t = t - i - 1, h[0] = $1(10, (At - t % At) % At), e.e = B2(-t / At) || 0) : (h.length = 1, h[0] = e.e = e.s = 0), e;
  if (n == 0 ? (h.length = d, i = 1, d--) : (h.length = d + 1, i = $1(10, At - n), h[d] = a > 0 ? (u / $1(10, o - a) % $1(10, a) | 0) * i : 0), c)
    for (; ; )
      if (d == 0) {
        (h[0] += i) == Tt && (h[0] = 1, ++e.e);
        break;
      } else {
        if (h[d] += i, h[d] != Tt)
          break;
        h[d--] = 0, i = 1;
      }
  for (n = h.length; h[--n] === 0; )
    h.pop();
  if (Ct && (e.e > Ls || e.e < -Ls))
    throw Error(U9 + Mt(e));
  return e;
}
function Iw(e, t) {
  var r, n, a, i, o, s, c, u, d, h, A = e.constructor, p = A.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new A(e), Ct ? ot(t, p) : t;
  if (c = e.d, h = t.d, n = t.e, u = e.e, c = c.slice(), o = u - n, o) {
    for (d = o < 0, d ? (r = c, o = -o, s = h.length) : (r = h, n = u, s = c.length), a = Math.max(Math.ceil(p / At), s) + 2, o > a && (o = a, r.length = 1), r.reverse(), a = o; a--; )
      r.push(0);
    r.reverse();
  } else {
    for (a = c.length, s = h.length, d = a < s, d && (s = a), a = 0; a < s; a++)
      if (c[a] != h[a]) {
        d = c[a] < h[a];
        break;
      }
    o = 0;
  }
  for (d && (r = c, c = h, h = r, t.s = -t.s), s = c.length, a = h.length - s; a > 0; --a)
    c[s++] = 0;
  for (a = h.length; a > o; ) {
    if (c[--a] < h[a]) {
      for (i = a; i && c[--i] === 0; )
        c[i] = Tt - 1;
      --c[i], c[a] += Tt;
    }
    c[a] -= h[a];
  }
  for (; c[--s] === 0; )
    c.pop();
  for (; c[0] === 0; c.shift())
    --n;
  return c[0] ? (t.d = c, t.e = n, Ct ? ot(t, p) : t) : new A(0);
}
function ea(e, t, r) {
  var n, a = Mt(e), i = sn(e.d), o = i.length;
  return t ? (r && (n = r - o) > 0 ? i = i.charAt(0) + "." + i.slice(1) + Zn(n) : o > 1 && (i = i.charAt(0) + "." + i.slice(1)), i = i + (a < 0 ? "e" : "e+") + a) : a < 0 ? (i = "0." + Zn(-a - 1) + i, r && (n = r - o) > 0 && (i += Zn(n))) : a >= o ? (i += Zn(a + 1 - o), r && (n = r - a - 1) > 0 && (i = i + "." + Zn(n))) : ((n = a + 1) < o && (i = i.slice(0, n) + "." + i.slice(n)), r && (n = r - o) > 0 && (a + 1 === o && (i += "."), i += Zn(n))), e.s < 0 ? "-" + i : i;
}
function vp(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function Bw(e) {
  var t, r, n;
  function a(i) {
    var o = this;
    if (!(o instanceof a))
      return new a(i);
    if (o.constructor = a, i instanceof a) {
      o.s = i.s, o.e = i.e, o.d = (i = i.d) ? i.slice() : i;
      return;
    }
    if (typeof i == "number") {
      if (i * 0 !== 0)
        throw Error(q1 + i);
      if (i > 0)
        o.s = 1;
      else if (i < 0)
        i = -i, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (i === ~~i && i < 1e7) {
        o.e = 0, o.d = [i];
        return;
      }
      return gp(o, i.toString());
    } else if (typeof i != "string")
      throw Error(q1 + i);
    if (i.charCodeAt(0) === 45 ? (i = i.slice(1), o.s = -1) : o.s = 1, Tte.test(i))
      gp(o, i);
    else
      throw Error(q1 + i);
  }
  if (a.prototype = he, a.ROUND_UP = 0, a.ROUND_DOWN = 1, a.ROUND_CEIL = 2, a.ROUND_FLOOR = 3, a.ROUND_HALF_UP = 4, a.ROUND_HALF_DOWN = 5, a.ROUND_HALF_EVEN = 6, a.ROUND_HALF_CEIL = 7, a.ROUND_HALF_FLOOR = 8, a.clone = Bw, a.config = a.set = _te, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; )
      e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return a.config(e), a;
}
function _te(e) {
  if (!e || typeof e != "object")
    throw Error(Nr + "Object expected");
  var t, r, n, a = [
    "precision",
    1,
    I2,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < a.length; t += 3)
    if ((n = e[r = a[t]]) !== void 0)
      if (B2(n) === n && n >= a[t + 1] && n <= a[t + 2])
        this[r] = n;
      else
        throw Error(q1 + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10)
      this[r] = new this(n);
    else
      throw Error(q1 + r + ": " + n);
  return this;
}
var Z9 = Bw(Lte);
hr = new Z9(1);
const nt = Z9;
function Rte(e) {
  return Yte(e) || Hte(e) || $te(e) || Fte();
}
function Fte() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $te(e, t) {
  if (e) {
    if (typeof e == "string")
      return I5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return I5(e, t);
  }
}
function Hte(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function Yte(e) {
  if (Array.isArray(e))
    return I5(e);
}
function I5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var kte = function(t) {
  return t;
}, Nw = {
  "@@functional/placeholder": !0
}, Lw = function(t) {
  return t === Nw;
}, mp = function(t) {
  return function r() {
    return arguments.length === 0 || arguments.length === 1 && Lw(arguments.length <= 0 ? void 0 : arguments[0]) ? r : t.apply(void 0, arguments);
  };
}, Vte = function e(t, r) {
  return t === 1 ? r : mp(function() {
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    var o = a.filter(function(s) {
      return s !== Nw;
    }).length;
    return o >= t ? r.apply(void 0, a) : e(t - o, mp(function() {
      for (var s = arguments.length, c = new Array(s), u = 0; u < s; u++)
        c[u] = arguments[u];
      var d = a.map(function(h) {
        return Lw(h) ? c.shift() : h;
      });
      return r.apply(void 0, Rte(d).concat(c));
    }));
  });
}, H0 = function(t) {
  return Vte(t.length, t);
}, B5 = function(t, r) {
  for (var n = [], a = t; a < r; ++a)
    n[a - t] = a;
  return n;
}, Gte = H0(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(r) {
    return t[r];
  }).map(e);
}), Wte = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  if (!r.length)
    return kte;
  var a = r.reverse(), i = a[0], o = a.slice(1);
  return function() {
    return o.reduce(function(s, c) {
      return c(s);
    }, i.apply(void 0, arguments));
  };
}, N5 = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, Tw = function(t) {
  var r = null, n = null;
  return function() {
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r && i.every(function(s, c) {
      return s === r[c];
    }) || (r = i, n = t.apply(void 0, i)), n;
  };
};
function Qte(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new nt(e).abs().log(10).toNumber()) + 1, t;
}
function Ute(e, t, r) {
  for (var n = new nt(e), a = 0, i = []; n.lt(t) && a < 1e5; )
    i.push(n.toNumber()), n = n.add(r), a++;
  return i;
}
var Zte = H0(function(e, t, r) {
  var n = +e, a = +t;
  return n + r * (a - n);
}), Kte = H0(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, (r - e) / n;
}), zte = H0(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, Math.max(0, Math.min(1, (r - e) / n));
});
const Y0 = {
  rangeStep: Ute,
  getDigitCount: Qte,
  interpolateNumber: Zte,
  uninterpolateNumber: Kte,
  uninterpolateTruncation: zte
};
function L5(e) {
  return Jte(e) || Xte(e) || _w(e) || qte();
}
function qte() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xte(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function Jte(e) {
  if (Array.isArray(e))
    return T5(e);
}
function go(e, t) {
  return rre(e) || tre(e, t) || _w(e, t) || ere();
}
function ere() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _w(e, t) {
  if (e) {
    if (typeof e == "string")
      return T5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return T5(e, t);
  }
}
function T5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function tre(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], n = !0, a = !1, i = void 0;
    try {
      for (var o = e[Symbol.iterator](), s; !(n = (s = o.next()).done) && (r.push(s.value), !(t && r.length === t)); n = !0)
        ;
    } catch (c) {
      a = !0, i = c;
    } finally {
      try {
        !n && o.return != null && o.return();
      } finally {
        if (a)
          throw i;
      }
    }
    return r;
  }
}
function rre(e) {
  if (Array.isArray(e))
    return e;
}
function Rw(e) {
  var t = go(e, 2), r = t[0], n = t[1], a = r, i = n;
  return r > n && (a = n, i = r), [a, i];
}
function Fw(e, t, r) {
  if (e.lte(0))
    return new nt(0);
  var n = Y0.getDigitCount(e.toNumber()), a = new nt(10).pow(n), i = e.div(a), o = n !== 1 ? 0.05 : 0.1, s = new nt(Math.ceil(i.div(o).toNumber())).add(r).mul(o), c = s.mul(a);
  return t ? c : new nt(Math.ceil(c));
}
function nre(e, t, r) {
  var n = 1, a = new nt(e);
  if (!a.isint() && r) {
    var i = Math.abs(e);
    i < 1 ? (n = new nt(10).pow(Y0.getDigitCount(e) - 1), a = new nt(Math.floor(a.div(n).toNumber())).mul(n)) : i > 1 && (a = new nt(Math.floor(e)));
  } else
    e === 0 ? a = new nt(Math.floor((t - 1) / 2)) : r || (a = new nt(Math.floor(e)));
  var o = Math.floor((t - 1) / 2), s = Wte(Gte(function(c) {
    return a.add(new nt(c - o).mul(n)).toNumber();
  }), B5);
  return s(0, t);
}
function $w(e, t, r, n) {
  var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (r - 1)))
    return {
      step: new nt(0),
      tickMin: new nt(0),
      tickMax: new nt(0)
    };
  var i = Fw(new nt(t).sub(e).div(r - 1), n, a), o;
  e <= 0 && t >= 0 ? o = new nt(0) : (o = new nt(e).add(t).div(2), o = o.sub(new nt(o).mod(i)));
  var s = Math.ceil(o.sub(e).div(i).toNumber()), c = Math.ceil(new nt(t).sub(o).div(i).toNumber()), u = s + c + 1;
  return u > r ? $w(e, t, r, n, a + 1) : (u < r && (c = t > 0 ? c + (r - u) : c, s = t > 0 ? s : s + (r - u)), {
    step: i,
    tickMin: o.sub(new nt(s).mul(i)),
    tickMax: o.add(new nt(c).mul(i))
  });
}
function are(e) {
  var t = go(e, 2), r = t[0], n = t[1], a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Math.max(a, 2), s = Rw([r, n]), c = go(s, 2), u = c[0], d = c[1];
  if (u === -1 / 0 || d === 1 / 0) {
    var h = d === 1 / 0 ? [u].concat(L5(B5(0, a - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(L5(B5(0, a - 1).map(function() {
      return -1 / 0;
    })), [d]);
    return r > n ? N5(h) : h;
  }
  if (u === d)
    return nre(u, a, i);
  var A = $w(u, d, o, i), p = A.step, v = A.tickMin, g = A.tickMax, m = Y0.rangeStep(v, g.add(new nt(0.1).mul(p)), p);
  return r > n ? N5(m) : m;
}
function ire(e, t) {
  var r = go(e, 2), n = r[0], a = r[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Rw([n, a]), s = go(o, 2), c = s[0], u = s[1];
  if (c === -1 / 0 || u === 1 / 0)
    return [n, a];
  if (c === u)
    return [c];
  var d = Math.max(t, 2), h = Fw(new nt(u).sub(c).div(d - 1), i, 0), A = [].concat(L5(Y0.rangeStep(new nt(c), new nt(u).sub(new nt(0.99).mul(h)), h)), [u]);
  return n > a ? N5(A) : A;
}
var ore = Tw(are), sre = Tw(ire), lre = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function Ts() {
  return Ts = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ts.apply(this, arguments);
}
function cre(e, t) {
  return hre(e) || fre(e, t) || dre(e, t) || ure();
}
function ure() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dre(e, t) {
  if (e) {
    if (typeof e == "string")
      return Cp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Cp(e, t);
  }
}
function Cp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function fre(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function hre(e) {
  if (Array.isArray(e))
    return e;
}
function Are(e, t) {
  if (e == null)
    return {};
  var r = pre(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function pre(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function N2(e) {
  var t = e.offset, r = e.layout, n = e.width, a = e.dataKey, i = e.data, o = e.dataPointFormatter, s = e.xAxis, c = e.yAxis, u = Are(e, lre), d = pe(u, !1);
  e.direction === "x" && s.type !== "number" && (process.env.NODE_ENV !== "production" ? Wt(!1, 'ErrorBar requires Axis type property to be "number".') : Wt(!1));
  var h = i.map(function(A) {
    var p = o(A, a), v = p.x, g = p.y, m = p.value, b = p.errorVal;
    if (!b)
      return null;
    var w = [], x, y;
    if (Array.isArray(b)) {
      var C = cre(b, 2);
      x = C[0], y = C[1];
    } else
      x = y = b;
    if (r === "vertical") {
      var O = s.scale, M = g + t, E = M + n, N = M - n, F = O(m - x), k = O(m + y);
      w.push({
        x1: k,
        y1: E,
        x2: k,
        y2: N
      }), w.push({
        x1: F,
        y1: M,
        x2: k,
        y2: M
      }), w.push({
        x1: F,
        y1: E,
        x2: F,
        y2: N
      });
    } else if (r === "horizontal") {
      var R = c.scale, j = v + t, U = j - n, ee = j + n, X = R(m - x), Z = R(m + y);
      w.push({
        x1: U,
        y1: Z,
        x2: ee,
        y2: Z
      }), w.push({
        x1: j,
        y1: X,
        x2: j,
        y2: Z
      }), w.push({
        x1: U,
        y1: X,
        x2: ee,
        y2: X
      });
    }
    return /* @__PURE__ */ P.createElement(je, Ts({
      className: "recharts-errorBar",
      key: "bar-".concat(w.map(function(te) {
        return "".concat(te.x1, "-").concat(te.x2, "-").concat(te.y1, "-").concat(te.y2);
      }))
    }, d), w.map(function(te) {
      return /* @__PURE__ */ P.createElement("line", Ts({}, te, {
        key: "line-".concat(te.x1, "-").concat(te.x2, "-").concat(te.y1, "-").concat(te.y2)
      }));
    }));
  });
  return /* @__PURE__ */ P.createElement(je, {
    className: "recharts-errorBars"
  }, h);
}
N2.defaultProps = {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
};
N2.displayName = "ErrorBar";
function vo(e) {
  "@babel/helpers - typeof";
  return vo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vo(e);
}
function bp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function J6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bp(Object(r), !0).forEach(function(n) {
      gre(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function gre(e, t, r) {
  return t = vre(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function vre(e) {
  var t = mre(e, "string");
  return vo(t) == "symbol" ? t : String(t);
}
function mre(e, t) {
  if (vo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (vo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Hw = function(t) {
  var r = t.children, n = t.formattedGraphicalItems, a = t.legendWidth, i = t.legendContent, o = fr(r, l1);
  if (!o)
    return null;
  var s;
  return o.props && o.props.payload ? s = o.props && o.props.payload : i === "children" ? s = (n || []).reduce(function(c, u) {
    var d = u.item, h = u.props, A = h.sectors || h.data || [];
    return c.concat(A.map(function(p) {
      return {
        type: o.props.iconType || d.props.legendType,
        value: p.name,
        color: p.fill,
        payload: p
      };
    }));
  }, []) : s = (n || []).map(function(c) {
    var u = c.item, d = u.props, h = d.dataKey, A = d.name, p = d.legendType, v = d.hide;
    return {
      inactive: v,
      dataKey: h,
      type: o.props.iconType || p || "square",
      color: K9(u),
      value: A || h,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: u.props
    };
  }), J6(J6(J6({}, o.props), l1.getWithHeight(o, a)), {}, {
    payload: s,
    item: o
  });
};
function mo(e) {
  "@babel/helpers - typeof";
  return mo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mo(e);
}
function yp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Or(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yp(Object(r), !0).forEach(function(n) {
      ka(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ka(e, t, r) {
  return t = Cre(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Cre(e) {
  var t = bre(e, "string");
  return mo(t) == "symbol" ? t : String(t);
}
function bre(e, t) {
  if (mo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (mo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function wp(e) {
  return Dre(e) || xre(e) || wre(e) || yre();
}
function yre() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wre(e, t) {
  if (e) {
    if (typeof e == "string")
      return _5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return _5(e, t);
  }
}
function xre(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Dre(e) {
  if (Array.isArray(e))
    return _5(e);
}
function _5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function pt(e, t, r) {
  return ye(e) || ye(t) ? r : jt(t) ? vr(e, t, r) : xe(t) ? t(e) : r;
}
function Hi(e, t, r, n) {
  var a = jte(e, function(s) {
    return pt(s, t);
  });
  if (r === "number") {
    var i = a.filter(function(s) {
      return le(s) || parseFloat(s);
    });
    return i.length ? [$0(i), zn(i)] : [1 / 0, -1 / 0];
  }
  var o = n ? a.filter(function(s) {
    return !ye(s);
  }) : a;
  return o.map(function(s) {
    return jt(s) || s instanceof Date ? s : "";
  });
}
var Ore = function(t) {
  var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], a = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 ? arguments[3] : void 0, o = -1, s = (r = n == null ? void 0 : n.length) !== null && r !== void 0 ? r : 0;
  if (s <= 1)
    return 0;
  if (i && i.axisType === "angleAxis" && Math.abs(Math.abs(i.range[1] - i.range[0]) - 360) <= 1e-6)
    for (var c = i.range, u = 0; u < s; u++) {
      var d = u > 0 ? a[u - 1].coordinate : a[s - 1].coordinate, h = a[u].coordinate, A = u >= s - 1 ? a[0].coordinate : a[u + 1].coordinate, p = void 0;
      if (qt(h - d) !== qt(A - h)) {
        var v = [];
        if (qt(A - h) === qt(c[1] - c[0])) {
          p = A;
          var g = h + c[1] - c[0];
          v[0] = Math.min(g, (g + d) / 2), v[1] = Math.max(g, (g + d) / 2);
        } else {
          p = d;
          var m = A + c[1] - c[0];
          v[0] = Math.min(h, (m + h) / 2), v[1] = Math.max(h, (m + h) / 2);
        }
        var b = [Math.min(h, (p + h) / 2), Math.max(h, (p + h) / 2)];
        if (t > b[0] && t <= b[1] || t >= v[0] && t <= v[1]) {
          o = a[u].index;
          break;
        }
      } else {
        var w = Math.min(d, A), x = Math.max(d, A);
        if (t > (w + h) / 2 && t <= (x + h) / 2) {
          o = a[u].index;
          break;
        }
      }
    }
  else
    for (var y = 0; y < s; y++)
      if (y === 0 && t <= (n[y].coordinate + n[y + 1].coordinate) / 2 || y > 0 && y < s - 1 && t > (n[y].coordinate + n[y - 1].coordinate) / 2 && t <= (n[y].coordinate + n[y + 1].coordinate) / 2 || y === s - 1 && t > (n[y].coordinate + n[y - 1].coordinate) / 2) {
        o = n[y].index;
        break;
      }
  return o;
}, K9 = function(t) {
  var r = t, n = r.type.displayName, a = t.props, i = a.stroke, o = a.fill, s;
  switch (n) {
    case "Line":
      s = i;
      break;
    case "Area":
    case "Radar":
      s = i && i !== "none" ? i : o;
      break;
    default:
      s = o;
      break;
  }
  return s;
}, Mre = function(t) {
  var r = t.barSize, n = t.totalSize, a = t.stackGroups, i = a === void 0 ? {} : a;
  if (!i)
    return {};
  for (var o = {}, s = Object.keys(i), c = 0, u = s.length; c < u; c++)
    for (var d = i[s[c]].stackGroups, h = Object.keys(d), A = 0, p = h.length; A < p; A++) {
      var v = d[h[A]], g = v.items, m = v.cateAxisId, b = g.filter(function(C) {
        return xn(C.type).indexOf("Bar") >= 0;
      });
      if (b && b.length) {
        var w = b[0].props.barSize, x = b[0].props[m];
        o[x] || (o[x] = []);
        var y = ye(w) ? r : w;
        o[x].push({
          item: b[0],
          stackList: b.slice(1),
          barSize: ye(y) ? void 0 : Xt(y, n, 0)
        });
      }
    }
  return o;
}, Ere = function(t) {
  var r = t.barGap, n = t.barCategoryGap, a = t.bandSize, i = t.sizeList, o = i === void 0 ? [] : i, s = t.maxBarSize, c = o.length;
  if (c < 1)
    return null;
  var u = Xt(r, a, 0, !0), d, h = [];
  if (o[0].barSize === +o[0].barSize) {
    var A = !1, p = a / c, v = o.reduce(function(y, C) {
      return y + C.barSize || 0;
    }, 0);
    v += (c - 1) * u, v >= a && (v -= (c - 1) * u, u = 0), v >= a && p > 0 && (A = !0, p *= 0.9, v = c * p);
    var g = (a - v) / 2 >> 0, m = {
      offset: g - u,
      size: 0
    };
    d = o.reduce(function(y, C) {
      var O = {
        item: C.item,
        position: {
          offset: m.offset + m.size + u,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: A ? p : C.barSize
        }
      }, M = [].concat(wp(y), [O]);
      return m = M[M.length - 1].position, C.stackList && C.stackList.length && C.stackList.forEach(function(E) {
        M.push({
          item: E,
          position: m
        });
      }), M;
    }, h);
  } else {
    var b = Xt(n, a, 0, !0);
    a - 2 * b - (c - 1) * u <= 0 && (u = 0);
    var w = (a - 2 * b - (c - 1) * u) / c;
    w > 1 && (w >>= 0);
    var x = s === +s ? Math.min(w, s) : w;
    d = o.reduce(function(y, C, O) {
      var M = [].concat(wp(y), [{
        item: C.item,
        position: {
          offset: b + (w + u) * O + (w - x) / 2,
          size: x
        }
      }]);
      return C.stackList && C.stackList.length && C.stackList.forEach(function(E) {
        M.push({
          item: E,
          position: M[M.length - 1].position
        });
      }), M;
    }, h);
  }
  return d;
}, Sre = function(t, r, n, a) {
  var i = n.children, o = n.width, s = n.margin, c = o - (s.left || 0) - (s.right || 0), u = Hw({
    children: i,
    legendWidth: c
  });
  if (u) {
    var d = a || {}, h = d.width, A = d.height, p = u.align, v = u.verticalAlign, g = u.layout;
    if ((g === "vertical" || g === "horizontal" && v === "middle") && p !== "center" && le(t[p]))
      return Or(Or({}, t), {}, ka({}, p, t[p] + (h || 0)));
    if ((g === "horizontal" || g === "vertical" && p === "center") && v !== "middle" && le(t[v]))
      return Or(Or({}, t), {}, ka({}, v, t[v] + (A || 0)));
  }
  return t;
}, Pre = function(t, r, n) {
  return ye(r) ? !0 : t === "horizontal" ? r === "yAxis" : t === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
}, Yw = function(t, r, n, a, i) {
  var o = r.props.children, s = er(o, N2).filter(function(u) {
    return Pre(a, i, u.props.direction);
  });
  if (s && s.length) {
    var c = s.map(function(u) {
      return u.props.dataKey;
    });
    return t.reduce(function(u, d) {
      var h = pt(d, n);
      if (ye(h))
        return u;
      var A = Array.isArray(h) ? [$0(h), zn(h)] : [h, h], p = c.reduce(function(v, g) {
        var m = pt(d, g, 0), b = A[0] - Math.abs(Array.isArray(m) ? m[0] : m), w = A[1] + Math.abs(Array.isArray(m) ? m[1] : m);
        return [Math.min(b, v[0]), Math.max(w, v[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(p[0], u[0]), Math.max(p[1], u[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, jre = function(t, r, n, a, i) {
  var o = r.map(function(s) {
    return Yw(t, s, n, i, a);
  }).filter(function(s) {
    return !ye(s);
  });
  return o && o.length ? o.reduce(function(s, c) {
    return [Math.min(s[0], c[0]), Math.max(s[1], c[1])];
  }, [1 / 0, -1 / 0]) : null;
}, kw = function(t, r, n, a, i) {
  var o = r.map(function(c) {
    var u = c.props.dataKey;
    return n === "number" && u && Yw(t, c, u, a) || Hi(t, u, n, i);
  });
  if (n === "number")
    return o.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(c, u) {
        return [Math.min(c[0], u[0]), Math.max(c[1], u[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return o.reduce(function(c, u) {
    for (var d = 0, h = u.length; d < h; d++)
      s[u[d]] || (s[u[d]] = !0, c.push(u[d]));
    return c;
  }, []);
}, Vw = function(t, r) {
  return t === "horizontal" && r === "xAxis" || t === "vertical" && r === "yAxis" || t === "centric" && r === "angleAxis" || t === "radial" && r === "radiusAxis";
}, Gw = function(t, r, n, a) {
  if (a)
    return t.map(function(c) {
      return c.coordinate;
    });
  var i, o, s = t.map(function(c) {
    return c.coordinate === r && (i = !0), c.coordinate === n && (o = !0), c.coordinate;
  });
  return i || s.push(r), o || s.push(n), s;
}, yn = function(t, r, n) {
  if (!t)
    return null;
  var a = t.scale, i = t.duplicateDomain, o = t.type, s = t.range, c = t.realScaleType === "scaleBand" ? a.bandwidth() / 2 : 2, u = (r || n) && o === "category" && a.bandwidth ? a.bandwidth() / c : 0;
  if (u = t.axisType === "angleAxis" && (s == null ? void 0 : s.length) >= 2 ? qt(s[0] - s[1]) * 2 * u : u, r && (t.ticks || t.niceTicks)) {
    var d = (t.ticks || t.niceTicks).map(function(h) {
      var A = i ? i.indexOf(h) : h;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: a(A) + u,
        value: h,
        offset: u
      };
    });
    return d.filter(function(h) {
      return !O2(h.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(h, A) {
    return {
      coordinate: a(h) + u,
      value: h,
      index: A,
      offset: u
    };
  }) : a.ticks && !n ? a.ticks(t.tickCount).map(function(h) {
    return {
      coordinate: a(h) + u,
      value: h,
      offset: u
    };
  }) : a.domain().map(function(h, A) {
    return {
      coordinate: a(h) + u,
      value: i ? i[h] : h,
      index: A,
      offset: u
    };
  });
}, e4 = /* @__PURE__ */ new WeakMap(), N3 = function(t, r) {
  if (typeof r != "function")
    return t;
  e4.has(t) || e4.set(t, /* @__PURE__ */ new WeakMap());
  var n = e4.get(t);
  if (n.has(r))
    return n.get(r);
  var a = function() {
    t.apply(void 0, arguments), r.apply(void 0, arguments);
  };
  return n.set(r, a), a;
}, Ww = function(t, r, n) {
  var a = t.scale, i = t.type, o = t.layout, s = t.axisType;
  if (a === "auto")
    return o === "radial" && s === "radiusAxis" ? {
      scale: co(),
      realScaleType: "band"
    } : o === "radial" && s === "angleAxis" ? {
      scale: js(),
      realScaleType: "linear"
    } : i === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
      scale: $i(),
      realScaleType: "point"
    } : i === "category" ? {
      scale: co(),
      realScaleType: "band"
    } : {
      scale: js(),
      realScaleType: "linear"
    };
  if (Zo(a)) {
    var c = "scale".concat(D0(a));
    return {
      scale: (pp[c] || $i)(),
      realScaleType: pp[c] ? c : "point"
    };
  }
  return xe(a) ? {
    scale: a
  } : {
    scale: $i(),
    realScaleType: "point"
  };
}, xp = 1e-4, Qw = function(t) {
  var r = t.domain();
  if (!(!r || r.length <= 2)) {
    var n = r.length, a = t.range(), i = Math.min(a[0], a[1]) - xp, o = Math.max(a[0], a[1]) + xp, s = t(r[0]), c = t(r[n - 1]);
    (s < i || s > o || c < i || c > o) && t.domain([r[0], r[n - 1]]);
  }
}, Ire = function(t, r) {
  if (!t)
    return null;
  for (var n = 0, a = t.length; n < a; n++)
    if (t[n].item === r)
      return t[n].position;
  return null;
}, Bre = function(t, r) {
  if (!r || r.length !== 2 || !le(r[0]) || !le(r[1]))
    return t;
  var n = Math.min(r[0], r[1]), a = Math.max(r[0], r[1]), i = [t[0], t[1]];
  return (!le(t[0]) || t[0] < n) && (i[0] = n), (!le(t[1]) || t[1] > a) && (i[1] = a), i[0] > a && (i[0] = a), i[1] < n && (i[1] = n), i;
}, Nre = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, a = t[0].length; n < a; ++n)
      for (var i = 0, o = 0, s = 0; s < r; ++s) {
        var c = O2(t[s][n][1]) ? t[s][n][0] : t[s][n][1];
        c >= 0 ? (t[s][n][0] = i, t[s][n][1] = i + c, i = t[s][n][1]) : (t[s][n][0] = o, t[s][n][1] = o + c, o = t[s][n][1]);
      }
}, Lre = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, a = t[0].length; n < a; ++n)
      for (var i = 0, o = 0; o < r; ++o) {
        var s = O2(t[o][n][1]) ? t[o][n][0] : t[o][n][1];
        s >= 0 ? (t[o][n][0] = i, t[o][n][1] = i + s, i = t[o][n][1]) : (t[o][n][0] = 0, t[o][n][1] = 0);
      }
}, Tre = {
  sign: Nre,
  // @ts-expect-error definitelytyped types are incorrect
  expand: hV,
  // @ts-expect-error definitelytyped types are incorrect
  none: Za,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: AV,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: pV,
  positive: Lre
}, _re = function(t, r, n) {
  var a = r.map(function(s) {
    return s.props.dataKey;
  }), i = Tre[n], o = fV().keys(a).value(function(s, c) {
    return +pt(s, c, 0);
  }).order(s5).offset(i);
  return o(t);
}, Rre = function(t, r, n, a, i, o) {
  if (!t)
    return null;
  var s = o ? r.reverse() : r, c = {}, u = s.reduce(function(h, A) {
    var p = A.props, v = p.stackId, g = p.hide;
    if (g)
      return h;
    var m = A.props[n], b = h[m] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (jt(v)) {
      var w = b.stackGroups[v] || {
        numericAxisId: n,
        cateAxisId: a,
        items: []
      };
      w.items.push(A), b.hasStack = !0, b.stackGroups[v] = w;
    } else
      b.stackGroups[p1("_stackId_")] = {
        numericAxisId: n,
        cateAxisId: a,
        items: [A]
      };
    return Or(Or({}, h), {}, ka({}, m, b));
  }, c), d = {};
  return Object.keys(u).reduce(function(h, A) {
    var p = u[A];
    if (p.hasStack) {
      var v = {};
      p.stackGroups = Object.keys(p.stackGroups).reduce(function(g, m) {
        var b = p.stackGroups[m];
        return Or(Or({}, g), {}, ka({}, m, {
          numericAxisId: n,
          cateAxisId: a,
          items: b.items,
          stackedData: _re(t, b.items, i)
        }));
      }, v);
    }
    return Or(Or({}, h), {}, ka({}, A, p));
  }, d);
}, Uw = function(t, r) {
  var n = r.realScaleType, a = r.type, i = r.tickCount, o = r.originalDomain, s = r.allowDecimals, c = n || r.scale;
  if (c !== "auto" && c !== "linear")
    return null;
  if (i && a === "number" && o && (o[0] === "auto" || o[1] === "auto")) {
    var u = t.domain();
    if (!u.length)
      return null;
    var d = ore(u, i, s);
    return t.domain([$0(d), zn(d)]), {
      niceTicks: d
    };
  }
  if (i && a === "number") {
    var h = t.domain(), A = sre(h, i, s);
    return {
      niceTicks: A
    };
  }
  return null;
};
function r2(e) {
  var t = e.axis, r = e.ticks, n = e.bandSize, a = e.entry, i = e.index, o = e.dataKey;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !ye(a[t.dataKey])) {
      var s = cs(r, "value", a[t.dataKey]);
      if (s)
        return s.coordinate + n / 2;
    }
    return r[i] ? r[i].coordinate + n / 2 : null;
  }
  var c = pt(a, ye(o) ? t.dataKey : o);
  return ye(c) ? null : t.scale(c);
}
var Dp = function(t) {
  var r = t.axis, n = t.ticks, a = t.offset, i = t.bandSize, o = t.entry, s = t.index;
  if (r.type === "category")
    return n[s] ? n[s].coordinate + a : null;
  var c = pt(o, r.dataKey, r.domain[s]);
  return ye(c) ? null : r.scale(c) - i / 2 + a;
}, Fre = function(t) {
  var r = t.numericAxis, n = r.scale.domain();
  if (r.type === "number") {
    var a = Math.min(n[0], n[1]), i = Math.max(n[0], n[1]);
    return a <= 0 && i >= 0 ? 0 : i < 0 ? i : a;
  }
  return n[0];
}, $re = function(t, r) {
  var n = t.props.stackId;
  if (jt(n)) {
    var a = r[n];
    if (a) {
      var i = a.items.indexOf(t);
      return i >= 0 ? a.stackedData[i] : null;
    }
  }
  return null;
}, Hre = function(t) {
  return t.reduce(function(r, n) {
    return [$0(n.concat([r[0]]).filter(le)), zn(n.concat([r[1]]).filter(le))];
  }, [1 / 0, -1 / 0]);
}, Zw = function(t, r, n) {
  return Object.keys(t).reduce(function(a, i) {
    var o = t[i], s = o.stackedData, c = s.reduce(function(u, d) {
      var h = Hre(d.slice(r, n + 1));
      return [Math.min(u[0], h[0]), Math.max(u[1], h[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(c[0], a[0]), Math.max(c[1], a[1])];
  }, [1 / 0, -1 / 0]).map(function(a) {
    return a === 1 / 0 || a === -1 / 0 ? 0 : a;
  });
}, Op = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, Mp = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, R5 = function(t, r, n) {
  if (xe(t))
    return t(r, n);
  if (!Array.isArray(t))
    return r;
  var a = [];
  if (le(t[0]))
    a[0] = n ? t[0] : Math.min(t[0], r[0]);
  else if (Op.test(t[0])) {
    var i = +Op.exec(t[0])[1];
    a[0] = r[0] - i;
  } else
    xe(t[0]) ? a[0] = t[0](r[0]) : a[0] = r[0];
  if (le(t[1]))
    a[1] = n ? t[1] : Math.max(t[1], r[1]);
  else if (Mp.test(t[1])) {
    var o = +Mp.exec(t[1])[1];
    a[1] = r[1] + o;
  } else
    xe(t[1]) ? a[1] = t[1](r[1]) : a[1] = r[1];
  return a;
}, _s = function(t, r, n) {
  if (t && t.scale && t.scale.bandwidth) {
    var a = t.scale.bandwidth();
    if (!n || a > 0)
      return a;
  }
  if (t && r && r.length >= 2) {
    for (var i = x9(r, function(h) {
      return h.coordinate;
    }), o = 1 / 0, s = 1, c = i.length; s < c; s++) {
      var u = i[s], d = i[s - 1];
      o = Math.min((u.coordinate || 0) - (d.coordinate || 0), o);
    }
    return o === 1 / 0 ? 0 : o;
  }
  return n ? void 0 : 0;
}, Ep = function(t, r, n) {
  return !t || !t.length || c1(t, vr(n, "type.defaultProps.domain")) ? r : t;
}, Kw = function(t, r) {
  var n = t.props, a = n.dataKey, i = n.name, o = n.unit, s = n.formatter, c = n.tooltipType, u = n.chartType, d = n.hide;
  return Or(Or({}, pe(t, !1)), {}, {
    dataKey: a,
    unit: o,
    formatter: s,
    name: i || a,
    color: K9(t),
    value: pt(r, a),
    type: c,
    payload: r,
    chartType: u,
    hide: d
  });
};
function Co(e) {
  "@babel/helpers - typeof";
  return Co = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Co(e);
}
function Sp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sp(Object(r), !0).forEach(function(n) {
      zw(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function zw(e, t, r) {
  return t = Yre(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Yre(e) {
  var t = kre(e, "string");
  return Co(t) == "symbol" ? t : String(t);
}
function kre(e, t) {
  if (Co(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Co(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Vre(e, t) {
  return Ure(e) || Qre(e, t) || Wre(e, t) || Gre();
}
function Gre() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wre(e, t) {
  if (e) {
    if (typeof e == "string")
      return Pp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Pp(e, t);
  }
}
function Pp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Qre(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function Ure(e) {
  if (Array.isArray(e))
    return e;
}
var Rs = Math.PI / 180, Zre = function(t) {
  return t * 180 / Math.PI;
}, ct = function(t, r, n, a) {
  return {
    x: t + Math.cos(-Rs * a) * n,
    y: r + Math.sin(-Rs * a) * n
  };
}, qw = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (n.left || 0) - (n.right || 0)), Math.abs(r - (n.top || 0) - (n.bottom || 0))) / 2;
}, Kre = function(t, r, n, a, i) {
  var o = t.width, s = t.height, c = t.startAngle, u = t.endAngle, d = Xt(t.cx, o, o / 2), h = Xt(t.cy, s, s / 2), A = qw(o, s, n), p = Xt(t.innerRadius, A, 0), v = Xt(t.outerRadius, A, A * 0.8), g = Object.keys(r);
  return g.reduce(function(m, b) {
    var w = r[b], x = w.domain, y = w.reversed, C;
    if (ye(w.range))
      a === "angleAxis" ? C = [c, u] : a === "radiusAxis" && (C = [p, v]), y && (C = [C[1], C[0]]);
    else {
      C = w.range;
      var O = C, M = Vre(O, 2);
      c = M[0], u = M[1];
    }
    var E = Ww(w, i), N = E.realScaleType, F = E.scale;
    F.domain(x).range(C), Qw(F);
    var k = Uw(F, vn(vn({}, w), {}, {
      realScaleType: N
    })), R = vn(vn(vn({}, w), k), {}, {
      range: C,
      radius: v,
      realScaleType: N,
      scale: F,
      cx: d,
      cy: h,
      innerRadius: p,
      outerRadius: v,
      startAngle: c,
      endAngle: u
    });
    return vn(vn({}, m), {}, zw({}, b, R));
  }, {});
}, zre = function(t, r) {
  var n = t.x, a = t.y, i = r.x, o = r.y;
  return Math.sqrt(Math.pow(n - i, 2) + Math.pow(a - o, 2));
}, qre = function(t, r) {
  var n = t.x, a = t.y, i = r.cx, o = r.cy, s = zre({
    x: n,
    y: a
  }, {
    x: i,
    y: o
  });
  if (s <= 0)
    return {
      radius: s
    };
  var c = (n - i) / s, u = Math.acos(c);
  return a > o && (u = 2 * Math.PI - u), {
    radius: s,
    angle: Zre(u),
    angleInRadian: u
  };
}, Xre = function(t) {
  var r = t.startAngle, n = t.endAngle, a = Math.floor(r / 360), i = Math.floor(n / 360), o = Math.min(a, i);
  return {
    startAngle: r - o * 360,
    endAngle: n - o * 360
  };
}, Jre = function(t, r) {
  var n = r.startAngle, a = r.endAngle, i = Math.floor(n / 360), o = Math.floor(a / 360), s = Math.min(i, o);
  return t + s * 360;
}, jp = function(t, r) {
  var n = t.x, a = t.y, i = qre({
    x: n,
    y: a
  }, r), o = i.radius, s = i.angle, c = r.innerRadius, u = r.outerRadius;
  if (o < c || o > u)
    return !1;
  if (o === 0)
    return !0;
  var d = Xre(r), h = d.startAngle, A = d.endAngle, p = s, v;
  if (h <= A) {
    for (; p > A; )
      p -= 360;
    for (; p < h; )
      p += 360;
    v = p >= h && p <= A;
  } else {
    for (; p > h; )
      p -= 360;
    for (; p < A; )
      p += 360;
    v = p >= A && p <= h;
  }
  return v ? vn(vn({}, r), {}, {
    radius: o,
    angle: Jre(p, r)
  }) : null;
}, Xw = function(t) {
  return !/* @__PURE__ */ kr(t) && !xe(t) && typeof t != "boolean" ? t.className : "";
};
function bo(e) {
  "@babel/helpers - typeof";
  return bo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bo(e);
}
var ene = ["offset"];
function tne(e) {
  return ine(e) || ane(e) || nne(e) || rne();
}
function rne() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nne(e, t) {
  if (e) {
    if (typeof e == "string")
      return F5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return F5(e, t);
  }
}
function ane(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function ine(e) {
  if (Array.isArray(e))
    return F5(e);
}
function F5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function one(e, t) {
  if (e == null)
    return {};
  var r = sne(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function sne(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Ip(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function St(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ip(Object(r), !0).forEach(function(n) {
      lne(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ip(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function lne(e, t, r) {
  return t = cne(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function cne(e) {
  var t = une(e, "string");
  return bo(t) == "symbol" ? t : String(t);
}
function une(e, t) {
  if (bo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (bo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function yo() {
  return yo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yo.apply(this, arguments);
}
var dne = function(t) {
  var r = t.value, n = t.formatter, a = ye(t.children) ? r : t.children;
  return xe(n) ? n(a) : a;
}, fne = function(t, r) {
  var n = qt(r - t), a = Math.min(Math.abs(r - t), 360);
  return n * a;
}, hne = function(t, r, n) {
  var a = t.position, i = t.viewBox, o = t.offset, s = t.className, c = i, u = c.cx, d = c.cy, h = c.innerRadius, A = c.outerRadius, p = c.startAngle, v = c.endAngle, g = c.clockWise, m = (h + A) / 2, b = fne(p, v), w = b >= 0 ? 1 : -1, x, y;
  a === "insideStart" ? (x = p + w * o, y = g) : a === "insideEnd" ? (x = v - w * o, y = !g) : a === "end" && (x = v + w * o, y = g), y = b <= 0 ? y : !y;
  var C = ct(u, d, m, x), O = ct(u, d, m, x + (y ? 1 : -1) * 359), M = "M".concat(C.x, ",").concat(C.y, `
    A`).concat(m, ",").concat(m, ",0,1,").concat(y ? 0 : 1, `,
    `).concat(O.x, ",").concat(O.y), E = ye(t.id) ? p1("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ P.createElement("text", yo({}, n, {
    dominantBaseline: "central",
    className: Pe("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ P.createElement("defs", null, /* @__PURE__ */ P.createElement("path", {
    id: E,
    d: M
  })), /* @__PURE__ */ P.createElement("textPath", {
    xlinkHref: "#".concat(E)
  }, r));
}, Ane = function(t) {
  var r = t.viewBox, n = t.offset, a = t.position, i = r, o = i.cx, s = i.cy, c = i.innerRadius, u = i.outerRadius, d = i.startAngle, h = i.endAngle, A = (d + h) / 2;
  if (a === "outside") {
    var p = ct(o, s, u + n, A), v = p.x, g = p.y;
    return {
      x: v,
      y: g,
      textAnchor: v >= o ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (a === "center")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (a === "centerTop")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (a === "centerBottom")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var m = (c + u) / 2, b = ct(o, s, m, A), w = b.x, x = b.y;
  return {
    x: w,
    y: x,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, pne = function(t) {
  var r = t.viewBox, n = t.parentViewBox, a = t.offset, i = t.position, o = r, s = o.x, c = o.y, u = o.width, d = o.height, h = d >= 0 ? 1 : -1, A = h * a, p = h > 0 ? "end" : "start", v = h > 0 ? "start" : "end", g = u >= 0 ? 1 : -1, m = g * a, b = g > 0 ? "end" : "start", w = g > 0 ? "start" : "end";
  if (i === "top") {
    var x = {
      x: s + u / 2,
      y: c - h * a,
      textAnchor: "middle",
      verticalAnchor: p
    };
    return St(St({}, x), n ? {
      height: Math.max(c - n.y, 0),
      width: u
    } : {});
  }
  if (i === "bottom") {
    var y = {
      x: s + u / 2,
      y: c + d + A,
      textAnchor: "middle",
      verticalAnchor: v
    };
    return St(St({}, y), n ? {
      height: Math.max(n.y + n.height - (c + d), 0),
      width: u
    } : {});
  }
  if (i === "left") {
    var C = {
      x: s - m,
      y: c + d / 2,
      textAnchor: b,
      verticalAnchor: "middle"
    };
    return St(St({}, C), n ? {
      width: Math.max(C.x - n.x, 0),
      height: d
    } : {});
  }
  if (i === "right") {
    var O = {
      x: s + u + m,
      y: c + d / 2,
      textAnchor: w,
      verticalAnchor: "middle"
    };
    return St(St({}, O), n ? {
      width: Math.max(n.x + n.width - O.x, 0),
      height: d
    } : {});
  }
  var M = n ? {
    width: u,
    height: d
  } : {};
  return i === "insideLeft" ? St({
    x: s + m,
    y: c + d / 2,
    textAnchor: w,
    verticalAnchor: "middle"
  }, M) : i === "insideRight" ? St({
    x: s + u - m,
    y: c + d / 2,
    textAnchor: b,
    verticalAnchor: "middle"
  }, M) : i === "insideTop" ? St({
    x: s + u / 2,
    y: c + A,
    textAnchor: "middle",
    verticalAnchor: v
  }, M) : i === "insideBottom" ? St({
    x: s + u / 2,
    y: c + d - A,
    textAnchor: "middle",
    verticalAnchor: p
  }, M) : i === "insideTopLeft" ? St({
    x: s + m,
    y: c + A,
    textAnchor: w,
    verticalAnchor: v
  }, M) : i === "insideTopRight" ? St({
    x: s + u - m,
    y: c + A,
    textAnchor: b,
    verticalAnchor: v
  }, M) : i === "insideBottomLeft" ? St({
    x: s + m,
    y: c + d - A,
    textAnchor: w,
    verticalAnchor: p
  }, M) : i === "insideBottomRight" ? St({
    x: s + u - m,
    y: c + d - A,
    textAnchor: b,
    verticalAnchor: p
  }, M) : y2(i) && (le(i.x) || G1(i.x)) && (le(i.y) || G1(i.y)) ? St({
    x: s + Xt(i.x, u),
    y: c + Xt(i.y, d),
    textAnchor: "end",
    verticalAnchor: "end"
  }, M) : St({
    x: s + u / 2,
    y: c + d / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, M);
}, gne = function(t) {
  return "cx" in t && le(t.cx);
};
function Ot(e) {
  var t = e.offset, r = t === void 0 ? 5 : t, n = one(e, ene), a = St({
    offset: r
  }, n), i = a.viewBox, o = a.position, s = a.value, c = a.children, u = a.content, d = a.className, h = d === void 0 ? "" : d, A = a.textBreakAll;
  if (!i || ye(s) && ye(c) && !/* @__PURE__ */ kr(u) && !xe(u))
    return null;
  if (/* @__PURE__ */ kr(u))
    return /* @__PURE__ */ Pt(u, a);
  var p;
  if (xe(u)) {
    if (p = /* @__PURE__ */ Xm(u, a), /* @__PURE__ */ kr(p))
      return p;
  } else
    p = dne(a);
  var v = gne(i), g = pe(a, !0);
  if (v && (o === "insideStart" || o === "insideEnd" || o === "end"))
    return hne(a, p, g);
  var m = v ? Ane(a) : pne(a);
  return /* @__PURE__ */ P.createElement(J1, yo({
    className: Pe("recharts-label", h)
  }, g, m, {
    breakAll: A
  }), p);
}
Ot.displayName = "Label";
var Jw = function(t) {
  var r = t.cx, n = t.cy, a = t.angle, i = t.startAngle, o = t.endAngle, s = t.r, c = t.radius, u = t.innerRadius, d = t.outerRadius, h = t.x, A = t.y, p = t.top, v = t.left, g = t.width, m = t.height, b = t.clockWise, w = t.labelViewBox;
  if (w)
    return w;
  if (le(g) && le(m)) {
    if (le(h) && le(A))
      return {
        x: h,
        y: A,
        width: g,
        height: m
      };
    if (le(p) && le(v))
      return {
        x: p,
        y: v,
        width: g,
        height: m
      };
  }
  return le(h) && le(A) ? {
    x: h,
    y: A,
    width: 0,
    height: 0
  } : le(r) && le(n) ? {
    cx: r,
    cy: n,
    startAngle: i || a || 0,
    endAngle: o || a || 0,
    innerRadius: u || 0,
    outerRadius: d || c || s || 0,
    clockWise: b
  } : t.viewBox ? t.viewBox : {};
}, vne = function(t, r) {
  return t ? t === !0 ? /* @__PURE__ */ P.createElement(Ot, {
    key: "label-implicit",
    viewBox: r
  }) : jt(t) ? /* @__PURE__ */ P.createElement(Ot, {
    key: "label-implicit",
    viewBox: r,
    value: t
  }) : /* @__PURE__ */ kr(t) ? t.type === Ot ? /* @__PURE__ */ Pt(t, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ P.createElement(Ot, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : xe(t) ? /* @__PURE__ */ P.createElement(Ot, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : y2(t) ? /* @__PURE__ */ P.createElement(Ot, yo({
    viewBox: r
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, mne = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && n && !t.label)
    return null;
  var a = t.children, i = Jw(t), o = er(a, Ot).map(function(c, u) {
    return /* @__PURE__ */ Pt(c, {
      viewBox: r || i,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(u)
    });
  });
  if (!n)
    return o;
  var s = vne(t.label, r || i);
  return [s].concat(tne(o));
};
Ot.parseViewBox = Jw;
Ot.renderCallByParent = mne;
function Cne(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var bne = Cne;
const yne = /* @__PURE__ */ Xe(bne);
function wo(e) {
  "@babel/helpers - typeof";
  return wo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wo(e);
}
var wne = ["valueAccessor"], xne = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function Dne(e) {
  return Sne(e) || Ene(e) || Mne(e) || One();
}
function One() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mne(e, t) {
  if (e) {
    if (typeof e == "string")
      return $5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return $5(e, t);
  }
}
function Ene(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Sne(e) {
  if (Array.isArray(e))
    return $5(e);
}
function $5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Fs() {
  return Fs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fs.apply(this, arguments);
}
function Bp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Np(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bp(Object(r), !0).forEach(function(n) {
      Pne(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Bp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Pne(e, t, r) {
  return t = jne(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function jne(e) {
  var t = Ine(e, "string");
  return wo(t) == "symbol" ? t : String(t);
}
function Ine(e, t) {
  if (wo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (wo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Lp(e, t) {
  if (e == null)
    return {};
  var r = Bne(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Bne(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var Nne = function(t) {
  return Array.isArray(t.value) ? yne(t.value) : t.value;
};
function Wr(e) {
  var t = e.valueAccessor, r = t === void 0 ? Nne : t, n = Lp(e, wne), a = n.data, i = n.dataKey, o = n.clockWise, s = n.id, c = n.textBreakAll, u = Lp(n, xne);
  return !a || !a.length ? null : /* @__PURE__ */ P.createElement(je, {
    className: "recharts-label-list"
  }, a.map(function(d, h) {
    var A = ye(i) ? r(d, h) : pt(d && d.payload, i), p = ye(s) ? {} : {
      id: "".concat(s, "-").concat(h)
    };
    return /* @__PURE__ */ P.createElement(Ot, Fs({}, pe(d, !0), u, p, {
      parentViewBox: d.parentViewBox,
      value: A,
      textBreakAll: c,
      viewBox: Ot.parseViewBox(ye(o) ? d : Np(Np({}, d), {}, {
        clockWise: o
      })),
      key: "label-".concat(h),
      index: h
    }));
  }));
}
Wr.displayName = "LabelList";
function Lne(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ P.createElement(Wr, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ P.isValidElement(e) || xe(e) ? /* @__PURE__ */ P.createElement(Wr, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : y2(e) ? /* @__PURE__ */ P.createElement(Wr, Fs({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function Tne(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && r && !e.label)
    return null;
  var n = e.children, a = er(n, Wr).map(function(o, s) {
    return /* @__PURE__ */ Pt(o, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!r)
    return a;
  var i = Lne(e.label, t);
  return [i].concat(Dne(a));
}
Wr.renderCallByParent = Tne;
function xo(e) {
  "@babel/helpers - typeof";
  return xo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xo(e);
}
function H5() {
  return H5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, H5.apply(this, arguments);
}
function Tp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _p(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Tp(Object(r), !0).forEach(function(n) {
      _ne(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Tp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function _ne(e, t, r) {
  return t = Rne(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Rne(e) {
  var t = Fne(e, "string");
  return xo(t) == "symbol" ? t : String(t);
}
function Fne(e, t) {
  if (xo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (xo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var $ne = function(t, r) {
  var n = qt(r - t), a = Math.min(Math.abs(r - t), 359.999);
  return n * a;
}, L3 = function(t) {
  var r = t.cx, n = t.cy, a = t.radius, i = t.angle, o = t.sign, s = t.isExternal, c = t.cornerRadius, u = t.cornerIsExternal, d = c * (s ? 1 : -1) + a, h = Math.asin(c / d) / Rs, A = u ? i : i + o * h, p = ct(r, n, d, A), v = ct(r, n, a, A), g = u ? i - o * h : i, m = ct(r, n, d * Math.cos(h * Rs), g);
  return {
    center: p,
    circleTangency: v,
    lineTangency: m,
    theta: h
  };
}, ex = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, i = t.outerRadius, o = t.startAngle, s = t.endAngle, c = $ne(o, s), u = o + c, d = ct(r, n, i, o), h = ct(r, n, i, u), A = "M ".concat(d.x, ",").concat(d.y, `
    A `).concat(i, ",").concat(i, `,0,
    `).concat(+(Math.abs(c) > 180), ",").concat(+(o > u), `,
    `).concat(h.x, ",").concat(h.y, `
  `);
  if (a > 0) {
    var p = ct(r, n, a, o), v = ct(r, n, a, u);
    A += "L ".concat(v.x, ",").concat(v.y, `
            A `).concat(a, ",").concat(a, `,0,
            `).concat(+(Math.abs(c) > 180), ",").concat(+(o <= u), `,
            `).concat(p.x, ",").concat(p.y, " Z");
  } else
    A += "L ".concat(r, ",").concat(n, " Z");
  return A;
}, Hne = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, i = t.outerRadius, o = t.cornerRadius, s = t.forceCornerRadius, c = t.cornerIsExternal, u = t.startAngle, d = t.endAngle, h = qt(d - u), A = L3({
    cx: r,
    cy: n,
    radius: i,
    angle: u,
    sign: h,
    cornerRadius: o,
    cornerIsExternal: c
  }), p = A.circleTangency, v = A.lineTangency, g = A.theta, m = L3({
    cx: r,
    cy: n,
    radius: i,
    angle: d,
    sign: -h,
    cornerRadius: o,
    cornerIsExternal: c
  }), b = m.circleTangency, w = m.lineTangency, x = m.theta, y = c ? Math.abs(u - d) : Math.abs(u - d) - g - x;
  if (y < 0)
    return s ? "M ".concat(v.x, ",").concat(v.y, `
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(o * 2, `,0
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(-o * 2, `,0
      `) : ex({
      cx: r,
      cy: n,
      innerRadius: a,
      outerRadius: i,
      startAngle: u,
      endAngle: d
    });
  var C = "M ".concat(v.x, ",").concat(v.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(h < 0), ",").concat(p.x, ",").concat(p.y, `
    A`).concat(i, ",").concat(i, ",0,").concat(+(y > 180), ",").concat(+(h < 0), ",").concat(b.x, ",").concat(b.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(h < 0), ",").concat(w.x, ",").concat(w.y, `
  `);
  if (a > 0) {
    var O = L3({
      cx: r,
      cy: n,
      radius: a,
      angle: u,
      sign: h,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: c
    }), M = O.circleTangency, E = O.lineTangency, N = O.theta, F = L3({
      cx: r,
      cy: n,
      radius: a,
      angle: d,
      sign: -h,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: c
    }), k = F.circleTangency, R = F.lineTangency, j = F.theta, U = c ? Math.abs(u - d) : Math.abs(u - d) - N - j;
    if (U < 0 && o === 0)
      return "".concat(C, "L").concat(r, ",").concat(n, "Z");
    C += "L".concat(R.x, ",").concat(R.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(h < 0), ",").concat(k.x, ",").concat(k.y, `
      A`).concat(a, ",").concat(a, ",0,").concat(+(U > 180), ",").concat(+(h > 0), ",").concat(M.x, ",").concat(M.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(h < 0), ",").concat(E.x, ",").concat(E.y, "Z");
  } else
    C += "L".concat(r, ",").concat(n, "Z");
  return C;
}, Yne = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, tx = function(t) {
  var r = _p(_p({}, Yne), t), n = r.cx, a = r.cy, i = r.innerRadius, o = r.outerRadius, s = r.cornerRadius, c = r.forceCornerRadius, u = r.cornerIsExternal, d = r.startAngle, h = r.endAngle, A = r.className;
  if (o < i || d === h)
    return null;
  var p = Pe("recharts-sector", A), v = o - i, g = Xt(s, v, 0, !0), m;
  return g > 0 && Math.abs(d - h) < 360 ? m = Hne({
    cx: n,
    cy: a,
    innerRadius: i,
    outerRadius: o,
    cornerRadius: Math.min(g, v / 2),
    forceCornerRadius: c,
    cornerIsExternal: u,
    startAngle: d,
    endAngle: h
  }) : m = ex({
    cx: n,
    cy: a,
    innerRadius: i,
    outerRadius: o,
    startAngle: d,
    endAngle: h
  }), /* @__PURE__ */ P.createElement("path", H5({}, pe(r, !0), {
    className: p,
    d: m,
    role: "img"
  }));
};
function Do(e) {
  "@babel/helpers - typeof";
  return Do = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Do(e);
}
function Y5() {
  return Y5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Y5.apply(this, arguments);
}
function Rp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Fp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Rp(Object(r), !0).forEach(function(n) {
      kne(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Rp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function kne(e, t, r) {
  return t = Vne(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Vne(e) {
  var t = Gne(e, "string");
  return Do(t) == "symbol" ? t : String(t);
}
function Gne(e, t) {
  if (Do(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Do(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var $p = {
  curveBasisClosed: tV,
  curveBasisOpen: rV,
  curveBasis: eV,
  curveBumpX: Hk,
  curveBumpY: Yk,
  curveLinearClosed: nV,
  curveLinear: M0,
  curveMonotoneX: aV,
  curveMonotoneY: iV,
  curveNatural: oV,
  curveStep: sV,
  curveStepAfter: cV,
  curveStepBefore: lV
}, T3 = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, hi = function(t) {
  return t.x;
}, Ai = function(t) {
  return t.y;
}, Wne = function(t, r) {
  if (xe(t))
    return t;
  var n = "curve".concat(D0(t));
  return (n === "curveMonotone" || n === "curveBump") && r ? $p["".concat(n).concat(r === "vertical" ? "Y" : "X")] : $p[n] || M0;
}, Qne = function(t) {
  var r = t.type, n = r === void 0 ? "linear" : r, a = t.points, i = a === void 0 ? [] : a, o = t.baseLine, s = t.layout, c = t.connectNulls, u = c === void 0 ? !1 : c, d = Wne(n, s), h = u ? i.filter(function(g) {
    return T3(g);
  }) : i, A;
  if (Array.isArray(o)) {
    var p = u ? o.filter(function(g) {
      return T3(g);
    }) : o, v = h.map(function(g, m) {
      return Fp(Fp({}, g), {}, {
        base: p[m]
      });
    });
    return s === "vertical" ? A = O3().y(Ai).x1(hi).x0(function(g) {
      return g.base.x;
    }) : A = O3().x(hi).y1(Ai).y0(function(g) {
      return g.base.y;
    }), A.defined(T3).curve(d), A(v);
  }
  return s === "vertical" && le(o) ? A = O3().y(Ai).x1(hi).x0(o) : le(o) ? A = O3().x(hi).y1(Ai).y0(o) : A = qb().x(hi).y(Ai), A.defined(T3).curve(d), A(h);
}, a1 = function(t) {
  var r = t.className, n = t.points, a = t.path, i = t.pathRef;
  if ((!n || !n.length) && !a)
    return null;
  var o = n && n.length ? Qne(t) : a;
  return /* @__PURE__ */ P.createElement("path", Y5({}, pe(t, !1), us(t), {
    className: Pe("recharts-curve", r),
    d: o,
    ref: i
  }));
}, Une = Object.getOwnPropertyNames, Zne = Object.getOwnPropertySymbols, Kne = Object.prototype.hasOwnProperty;
function Hp(e, t) {
  return function(n, a, i) {
    return e(n, a, i) && t(n, a, i);
  };
}
function _3(e) {
  return function(r, n, a) {
    if (!r || !n || typeof r != "object" || typeof n != "object")
      return e(r, n, a);
    var i = a.cache, o = i.get(r), s = i.get(n);
    if (o && s)
      return o === n && s === r;
    i.set(r, n), i.set(n, r);
    var c = e(r, n, a);
    return i.delete(r), i.delete(n), c;
  };
}
function Yp(e) {
  return Une(e).concat(Zne(e));
}
var rx = Object.hasOwn || function(e, t) {
  return Kne.call(e, t);
};
function L2(e, t) {
  return e || t ? e === t : e === t || e !== e && t !== t;
}
var nx = "_owner", kp = Object.getOwnPropertyDescriptor, Vp = Object.keys;
function zne(e, t, r) {
  var n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (!r.equals(e[n], t[n], n, n, e, t, r))
      return !1;
  return !0;
}
function qne(e, t) {
  return L2(e.getTime(), t.getTime());
}
function Gp(e, t, r) {
  if (e.size !== t.size)
    return !1;
  for (var n = {}, a = e.entries(), i = 0, o, s; (o = a.next()) && !o.done; ) {
    for (var c = t.entries(), u = !1, d = 0; (s = c.next()) && !s.done; ) {
      var h = o.value, A = h[0], p = h[1], v = s.value, g = v[0], m = v[1];
      !u && !n[d] && (u = r.equals(A, g, i, d, e, t, r) && r.equals(p, m, A, g, e, t, r)) && (n[d] = !0), d++;
    }
    if (!u)
      return !1;
    i++;
  }
  return !0;
}
function Xne(e, t, r) {
  var n = Vp(e), a = n.length;
  if (Vp(t).length !== a)
    return !1;
  for (var i; a-- > 0; )
    if (i = n[a], i === nx && (e.$$typeof || t.$$typeof) && e.$$typeof !== t.$$typeof || !rx(t, i) || !r.equals(e[i], t[i], i, i, e, t, r))
      return !1;
  return !0;
}
function pi(e, t, r) {
  var n = Yp(e), a = n.length;
  if (Yp(t).length !== a)
    return !1;
  for (var i, o, s; a-- > 0; )
    if (i = n[a], i === nx && (e.$$typeof || t.$$typeof) && e.$$typeof !== t.$$typeof || !rx(t, i) || !r.equals(e[i], t[i], i, i, e, t, r) || (o = kp(e, i), s = kp(t, i), (o || s) && (!o || !s || o.configurable !== s.configurable || o.enumerable !== s.enumerable || o.writable !== s.writable)))
      return !1;
  return !0;
}
function Jne(e, t) {
  return L2(e.valueOf(), t.valueOf());
}
function e1e(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function Wp(e, t, r) {
  if (e.size !== t.size)
    return !1;
  for (var n = {}, a = e.values(), i, o; (i = a.next()) && !i.done; ) {
    for (var s = t.values(), c = !1, u = 0; (o = s.next()) && !o.done; )
      !c && !n[u] && (c = r.equals(i.value, o.value, i.value, o.value, e, t, r)) && (n[u] = !0), u++;
    if (!c)
      return !1;
  }
  return !0;
}
function t1e(e, t) {
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (; r-- > 0; )
    if (e[r] !== t[r])
      return !1;
  return !0;
}
var r1e = "[object Arguments]", n1e = "[object Boolean]", a1e = "[object Date]", i1e = "[object Map]", o1e = "[object Number]", s1e = "[object Object]", l1e = "[object RegExp]", c1e = "[object Set]", u1e = "[object String]", d1e = Array.isArray, Qp = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, Up = Object.assign, f1e = Object.prototype.toString.call.bind(Object.prototype.toString);
function h1e(e) {
  var t = e.areArraysEqual, r = e.areDatesEqual, n = e.areMapsEqual, a = e.areObjectsEqual, i = e.arePrimitiveWrappersEqual, o = e.areRegExpsEqual, s = e.areSetsEqual, c = e.areTypedArraysEqual;
  return function(d, h, A) {
    if (d === h)
      return !0;
    if (d == null || h == null || typeof d != "object" || typeof h != "object")
      return d !== d && h !== h;
    var p = d.constructor;
    if (p !== h.constructor)
      return !1;
    if (p === Object)
      return a(d, h, A);
    if (d1e(d))
      return t(d, h, A);
    if (Qp != null && Qp(d))
      return c(d, h, A);
    if (p === Date)
      return r(d, h, A);
    if (p === RegExp)
      return o(d, h, A);
    if (p === Map)
      return n(d, h, A);
    if (p === Set)
      return s(d, h, A);
    var v = f1e(d);
    return v === a1e ? r(d, h, A) : v === l1e ? o(d, h, A) : v === i1e ? n(d, h, A) : v === c1e ? s(d, h, A) : v === s1e ? typeof d.then != "function" && typeof h.then != "function" && a(d, h, A) : v === r1e ? a(d, h, A) : v === n1e || v === o1e || v === u1e ? i(d, h, A) : !1;
  };
}
function A1e(e) {
  var t = e.circular, r = e.createCustomConfig, n = e.strict, a = {
    areArraysEqual: n ? pi : zne,
    areDatesEqual: qne,
    areMapsEqual: n ? Hp(Gp, pi) : Gp,
    areObjectsEqual: n ? pi : Xne,
    arePrimitiveWrappersEqual: Jne,
    areRegExpsEqual: e1e,
    areSetsEqual: n ? Hp(Wp, pi) : Wp,
    areTypedArraysEqual: n ? pi : t1e
  };
  if (r && (a = Up({}, a, r(a))), t) {
    var i = _3(a.areArraysEqual), o = _3(a.areMapsEqual), s = _3(a.areObjectsEqual), c = _3(a.areSetsEqual);
    a = Up({}, a, {
      areArraysEqual: i,
      areMapsEqual: o,
      areObjectsEqual: s,
      areSetsEqual: c
    });
  }
  return a;
}
function p1e(e) {
  return function(t, r, n, a, i, o, s) {
    return e(t, r, s);
  };
}
function g1e(e) {
  var t = e.circular, r = e.comparator, n = e.createState, a = e.equals, i = e.strict;
  if (n)
    return function(c, u) {
      var d = n(), h = d.cache, A = h === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : h, p = d.meta;
      return r(c, u, {
        cache: A,
        equals: a,
        meta: p,
        strict: i
      });
    };
  if (t)
    return function(c, u) {
      return r(c, u, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: a,
        meta: void 0,
        strict: i
      });
    };
  var o = {
    cache: void 0,
    equals: a,
    meta: void 0,
    strict: i
  };
  return function(c, u) {
    return r(c, u, o);
  };
}
var v1e = m1();
m1({ strict: !0 });
m1({ circular: !0 });
m1({
  circular: !0,
  strict: !0
});
m1({
  createInternalComparator: function() {
    return L2;
  }
});
m1({
  strict: !0,
  createInternalComparator: function() {
    return L2;
  }
});
m1({
  circular: !0,
  createInternalComparator: function() {
    return L2;
  }
});
m1({
  circular: !0,
  createInternalComparator: function() {
    return L2;
  },
  strict: !0
});
function m1(e) {
  e === void 0 && (e = {});
  var t = e.circular, r = t === void 0 ? !1 : t, n = e.createInternalComparator, a = e.createState, i = e.strict, o = i === void 0 ? !1 : i, s = A1e(e), c = h1e(s), u = n ? n(c) : p1e(c);
  return g1e({ circular: r, comparator: c, createState: a, equals: u, strict: o });
}
function m1e(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function Zp(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function a(i) {
    r < 0 && (r = i), i - r > t ? (e(i), r = -1) : m1e(a);
  };
  requestAnimationFrame(n);
}
function k5(e) {
  "@babel/helpers - typeof";
  return k5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, k5(e);
}
function C1e(e) {
  return x1e(e) || w1e(e) || y1e(e) || b1e();
}
function b1e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function y1e(e, t) {
  if (e) {
    if (typeof e == "string")
      return Kp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Kp(e, t);
  }
}
function Kp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function w1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function x1e(e) {
  if (Array.isArray(e))
    return e;
}
function D1e() {
  var e = {}, t = function() {
    return null;
  }, r = !1, n = function a(i) {
    if (!r) {
      if (Array.isArray(i)) {
        if (!i.length)
          return;
        var o = i, s = C1e(o), c = s[0], u = s.slice(1);
        if (typeof c == "number") {
          Zp(a.bind(null, u), c);
          return;
        }
        a(c), Zp(a.bind(null, u));
        return;
      }
      k5(i) === "object" && (e = i, t(e)), typeof i == "function" && i();
    }
  };
  return {
    stop: function() {
      r = !0;
    },
    start: function(i) {
      r = !1, n(i);
    },
    subscribe: function(i) {
      return t = i, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function Oo(e) {
  "@babel/helpers - typeof";
  return Oo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Oo(e);
}
function zp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zp(Object(r), !0).forEach(function(n) {
      ax(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ax(e, t, r) {
  return t = O1e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function O1e(e) {
  var t = M1e(e, "string");
  return Oo(t) === "symbol" ? t : String(t);
}
function M1e(e, t) {
  if (Oo(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Oo(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var E1e = function(t, r) {
  return [Object.keys(t), Object.keys(r)].reduce(function(n, a) {
    return n.filter(function(i) {
      return a.includes(i);
    });
  });
}, S1e = function(t) {
  return t;
}, P1e = function(t) {
  return t.replace(/([A-Z])/g, function(r) {
    return "-".concat(r.toLowerCase());
  });
}, Yi = function(t, r) {
  return Object.keys(r).reduce(function(n, a) {
    return qp(qp({}, n), {}, ax({}, a, t(a, r[a])));
  }, {});
}, Xp = function(t, r, n) {
  return t.map(function(a) {
    return "".concat(P1e(a), " ").concat(r, "ms ").concat(n);
  }).join(",");
}, j1e = process.env.NODE_ENV !== "production", $s = function(t, r, n, a, i, o, s, c) {
  if (j1e && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var u = [n, a, i, o, s, c], d = 0;
      console.warn(r.replace(/%s/g, function() {
        return u[d++];
      }));
    }
};
function I1e(e, t) {
  return L1e(e) || N1e(e, t) || ix(e, t) || B1e();
}
function B1e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function N1e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function L1e(e) {
  if (Array.isArray(e))
    return e;
}
function T1e(e) {
  return F1e(e) || R1e(e) || ix(e) || _1e();
}
function _1e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ix(e, t) {
  if (e) {
    if (typeof e == "string")
      return V5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return V5(e, t);
  }
}
function R1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function F1e(e) {
  if (Array.isArray(e))
    return V5(e);
}
function V5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Hs = 1e-4, ox = function(t, r) {
  return [0, 3 * t, 3 * r - 6 * t, 3 * t - 3 * r + 1];
}, sx = function(t, r) {
  return t.map(function(n, a) {
    return n * Math.pow(r, a);
  }).reduce(function(n, a) {
    return n + a;
  });
}, Jp = function(t, r) {
  return function(n) {
    var a = ox(t, r);
    return sx(a, n);
  };
}, $1e = function(t, r) {
  return function(n) {
    var a = ox(t, r), i = [].concat(T1e(a.map(function(o, s) {
      return o * s;
    }).slice(1)), [0]);
    return sx(i, n);
  };
}, eg = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r[0], i = r[1], o = r[2], s = r[3];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        a = 0, i = 0, o = 1, s = 1;
        break;
      case "ease":
        a = 0.25, i = 0.1, o = 0.25, s = 1;
        break;
      case "ease-in":
        a = 0.42, i = 0, o = 1, s = 1;
        break;
      case "ease-out":
        a = 0.42, i = 0, o = 0.58, s = 1;
        break;
      case "ease-in-out":
        a = 0, i = 0, o = 0.58, s = 1;
        break;
      default: {
        var c = r[0].split("(");
        if (c[0] === "cubic-bezier" && c[1].split(")")[0].split(",").length === 4) {
          var u = c[1].split(")")[0].split(",").map(function(m) {
            return parseFloat(m);
          }), d = I1e(u, 4);
          a = d[0], i = d[1], o = d[2], s = d[3];
        } else
          $s(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
      }
    }
  $s([a, o, i, s].every(function(m) {
    return typeof m == "number" && m >= 0 && m <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
  var h = Jp(a, o), A = Jp(i, s), p = $1e(a, o), v = function(b) {
    return b > 1 ? 1 : b < 0 ? 0 : b;
  }, g = function(b) {
    for (var w = b > 1 ? 1 : b, x = w, y = 0; y < 8; ++y) {
      var C = h(x) - w, O = p(x);
      if (Math.abs(C - w) < Hs || O < Hs)
        return A(x);
      x = v(x - C / O);
    }
    return A(x);
  };
  return g.isStepper = !1, g;
}, H1e = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.stiff, n = r === void 0 ? 100 : r, a = t.damping, i = a === void 0 ? 8 : a, o = t.dt, s = o === void 0 ? 17 : o, c = function(d, h, A) {
    var p = -(d - h) * n, v = A * i, g = A + (p - v) * s / 1e3, m = A * s / 1e3 + d;
    return Math.abs(m - h) < Hs && Math.abs(g) < Hs ? [h, 0] : [m, g];
  };
  return c.isStepper = !0, c.dt = s, c;
}, Y1e = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r[0];
  if (typeof a == "string")
    switch (a) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return eg(a);
      case "spring":
        return H1e();
      default:
        if (a.split("(")[0] === "cubic-bezier")
          return eg(a);
        $s(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
    }
  return typeof a == "function" ? a : ($s(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
};
function Mo(e) {
  "@babel/helpers - typeof";
  return Mo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mo(e);
}
function tg(e) {
  return G1e(e) || V1e(e) || lx(e) || k1e();
}
function k1e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function V1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function G1e(e) {
  if (Array.isArray(e))
    return W5(e);
}
function rg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $t(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rg(Object(r), !0).forEach(function(n) {
      G5(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : rg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function G5(e, t, r) {
  return t = W1e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function W1e(e) {
  var t = Q1e(e, "string");
  return Mo(t) === "symbol" ? t : String(t);
}
function Q1e(e, t) {
  if (Mo(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Mo(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function U1e(e, t) {
  return z1e(e) || K1e(e, t) || lx(e, t) || Z1e();
}
function Z1e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lx(e, t) {
  if (e) {
    if (typeof e == "string")
      return W5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return W5(e, t);
  }
}
function W5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function K1e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function z1e(e) {
  if (Array.isArray(e))
    return e;
}
var Ys = function(t, r, n) {
  return t + (r - t) * n;
}, Q5 = function(t) {
  var r = t.from, n = t.to;
  return r !== n;
}, q1e = function e(t, r, n) {
  var a = Yi(function(i, o) {
    if (Q5(o)) {
      var s = t(o.from, o.to, o.velocity), c = U1e(s, 2), u = c[0], d = c[1];
      return $t($t({}, o), {}, {
        from: u,
        velocity: d
      });
    }
    return o;
  }, r);
  return n < 1 ? Yi(function(i, o) {
    return Q5(o) ? $t($t({}, o), {}, {
      velocity: Ys(o.velocity, a[i].velocity, n),
      from: Ys(o.from, a[i].from, n)
    }) : o;
  }, r) : e(t, a, n - 1);
};
const X1e = function(e, t, r, n, a) {
  var i = E1e(e, t), o = i.reduce(function(m, b) {
    return $t($t({}, m), {}, G5({}, b, [e[b], t[b]]));
  }, {}), s = i.reduce(function(m, b) {
    return $t($t({}, m), {}, G5({}, b, {
      from: e[b],
      velocity: 0,
      to: t[b]
    }));
  }, {}), c = -1, u, d, h = function() {
    return null;
  }, A = function() {
    return Yi(function(b, w) {
      return w.from;
    }, s);
  }, p = function() {
    return !Object.values(s).filter(Q5).length;
  }, v = function(b) {
    u || (u = b);
    var w = b - u, x = w / r.dt;
    s = q1e(r, s, x), a($t($t($t({}, e), t), A())), u = b, p() || (c = requestAnimationFrame(h));
  }, g = function(b) {
    d || (d = b);
    var w = (b - d) / n, x = Yi(function(C, O) {
      return Ys.apply(void 0, tg(O).concat([r(w)]));
    }, o);
    if (a($t($t($t({}, e), t), x)), w < 1)
      c = requestAnimationFrame(h);
    else {
      var y = Yi(function(C, O) {
        return Ys.apply(void 0, tg(O).concat([r(1)]));
      }, o);
      a($t($t($t({}, e), t), y));
    }
  };
  return h = r.isStepper ? v : g, function() {
    return requestAnimationFrame(h), function() {
      cancelAnimationFrame(c);
    };
  };
};
function n2(e) {
  "@babel/helpers - typeof";
  return n2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, n2(e);
}
var J1e = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function eae(e, t) {
  if (e == null)
    return {};
  var r = tae(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function tae(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function t4(e) {
  return iae(e) || aae(e) || nae(e) || rae();
}
function rae() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nae(e, t) {
  if (e) {
    if (typeof e == "string")
      return U5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return U5(e, t);
  }
}
function aae(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function iae(e) {
  if (Array.isArray(e))
    return U5(e);
}
function U5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function ng(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Rr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ng(Object(r), !0).forEach(function(n) {
      Ii(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ng(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ii(e, t, r) {
  return t = cx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function oae(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ag(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, cx(n.key), n);
  }
}
function sae(e, t, r) {
  return t && ag(e.prototype, t), r && ag(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function cx(e) {
  var t = lae(e, "string");
  return n2(t) === "symbol" ? t : String(t);
}
function lae(e, t) {
  if (n2(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (n2(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function cae(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Z5(e, t);
}
function Z5(e, t) {
  return Z5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Z5(e, t);
}
function uae(e) {
  var t = dae();
  return function() {
    var n = ks(e), a;
    if (t) {
      var i = ks(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return K5(this, a);
  };
}
function K5(e, t) {
  if (t && (n2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return z5(e);
}
function z5(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function dae() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ks(e) {
  return ks = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ks(e);
}
var Lr = /* @__PURE__ */ function(e) {
  cae(r, e);
  var t = uae(r);
  function r(n, a) {
    var i;
    oae(this, r), i = t.call(this, n, a);
    var o = i.props, s = o.isActive, c = o.attributeName, u = o.from, d = o.to, h = o.steps, A = o.children, p = o.duration;
    if (i.handleStyleChange = i.handleStyleChange.bind(z5(i)), i.changeStyle = i.changeStyle.bind(z5(i)), !s || p <= 0)
      return i.state = {
        style: {}
      }, typeof A == "function" && (i.state = {
        style: d
      }), K5(i);
    if (h && h.length)
      i.state = {
        style: h[0].style
      };
    else if (u) {
      if (typeof A == "function")
        return i.state = {
          style: u
        }, K5(i);
      i.state = {
        style: c ? Ii({}, c, u) : u
      };
    } else
      i.state = {
        style: {}
      };
    return i;
  }
  return sae(r, [{
    key: "componentDidMount",
    value: function() {
      var a = this.props, i = a.isActive, o = a.canBegin;
      this.mounted = !0, !(!i || !o) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var i = this.props, o = i.isActive, s = i.canBegin, c = i.attributeName, u = i.shouldReAnimate, d = i.to, h = i.from, A = this.state.style;
      if (s) {
        if (!o) {
          var p = {
            style: c ? Ii({}, c, d) : d
          };
          this.state && A && (c && A[c] !== d || !c && A !== d) && this.setState(p);
          return;
        }
        if (!(v1e(a.to, d) && a.canBegin && a.isActive)) {
          var v = !a.canBegin || !a.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var g = v || u ? h : a.to;
          if (this.state && A) {
            var m = {
              style: c ? Ii({}, c, g) : g
            };
            (c && A[c] !== g || !c && A !== g) && this.setState(m);
          }
          this.runAnimation(Rr(Rr({}, this.props), {}, {
            from: g,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var a = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), a && a();
    }
  }, {
    key: "handleStyleChange",
    value: function(a) {
      this.changeStyle(a);
    }
  }, {
    key: "changeStyle",
    value: function(a) {
      this.mounted && this.setState({
        style: a
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(a) {
      var i = this, o = a.from, s = a.to, c = a.duration, u = a.easing, d = a.begin, h = a.onAnimationEnd, A = a.onAnimationStart, p = X1e(o, s, Y1e(u), c, this.changeStyle), v = function() {
        i.stopJSAnimation = p();
      };
      this.manager.start([A, d, v, c, h]);
    }
  }, {
    key: "runStepAnimation",
    value: function(a) {
      var i = this, o = a.steps, s = a.begin, c = a.onAnimationStart, u = o[0], d = u.style, h = u.duration, A = h === void 0 ? 0 : h, p = function(g, m, b) {
        if (b === 0)
          return g;
        var w = m.duration, x = m.easing, y = x === void 0 ? "ease" : x, C = m.style, O = m.properties, M = m.onAnimationEnd, E = b > 0 ? o[b - 1] : m, N = O || Object.keys(C);
        if (typeof y == "function" || y === "spring")
          return [].concat(t4(g), [i.runJSAnimation.bind(i, {
            from: E.style,
            to: C,
            duration: w,
            easing: y
          }), w]);
        var F = Xp(N, w, y), k = Rr(Rr(Rr({}, E.style), C), {}, {
          transition: F
        });
        return [].concat(t4(g), [k, w, M]).filter(S1e);
      };
      return this.manager.start([c].concat(t4(o.reduce(p, [d, Math.max(A, s)])), [a.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(a) {
      this.manager || (this.manager = D1e());
      var i = a.begin, o = a.duration, s = a.attributeName, c = a.to, u = a.easing, d = a.onAnimationStart, h = a.onAnimationEnd, A = a.steps, p = a.children, v = this.manager;
      if (this.unSubscribe = v.subscribe(this.handleStyleChange), typeof u == "function" || typeof p == "function" || u === "spring") {
        this.runJSAnimation(a);
        return;
      }
      if (A.length > 1) {
        this.runStepAnimation(a);
        return;
      }
      var g = s ? Ii({}, s, c) : c, m = Xp(Object.keys(g), o, u);
      v.start([d, i, Rr(Rr({}, g), {}, {
        transition: m
      }), o, h]);
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.children;
      a.begin;
      var o = a.duration;
      a.attributeName, a.easing;
      var s = a.isActive;
      a.steps, a.from, a.to, a.canBegin, a.onAnimationEnd, a.shouldReAnimate, a.onAnimationReStart;
      var c = eae(a, J1e), u = K1.count(i), d = this.state.style;
      if (typeof i == "function")
        return i(d);
      if (!s || u === 0 || o <= 0)
        return i;
      var h = function(p) {
        var v = p.props, g = v.style, m = g === void 0 ? {} : g, b = v.className, w = /* @__PURE__ */ Pt(p, Rr(Rr({}, c), {}, {
          style: Rr(Rr({}, m), d),
          className: b
        }));
        return w;
      };
      return u === 1 ? h(K1.only(i)) : /* @__PURE__ */ P.createElement("div", null, K1.map(i, function(A) {
        return h(A);
      }));
    }
  }]), r;
}(mr);
Lr.displayName = "Animate";
Lr.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
Lr.propTypes = {
  from: Me.oneOfType([Me.object, Me.string]),
  to: Me.oneOfType([Me.object, Me.string]),
  attributeName: Me.string,
  // animation duration
  duration: Me.number,
  begin: Me.number,
  easing: Me.oneOfType([Me.string, Me.func]),
  steps: Me.arrayOf(Me.shape({
    duration: Me.number.isRequired,
    style: Me.object.isRequired,
    easing: Me.oneOfType([Me.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), Me.func]),
    // transition css properties(dash case), optional
    properties: Me.arrayOf("string"),
    onAnimationEnd: Me.func
  })),
  children: Me.oneOfType([Me.node, Me.func]),
  isActive: Me.bool,
  canBegin: Me.bool,
  onAnimationEnd: Me.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: Me.bool,
  onAnimationStart: Me.func,
  onAnimationReStart: Me.func
};
Me.object, Me.object, Me.object, Me.element;
Me.object, Me.object, Me.object, Me.oneOfType([Me.array, Me.element]), Me.any;
function Eo(e) {
  "@babel/helpers - typeof";
  return Eo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Eo(e);
}
function Vs() {
  return Vs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vs.apply(this, arguments);
}
function fae(e, t) {
  return gae(e) || pae(e, t) || Aae(e, t) || hae();
}
function hae() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Aae(e, t) {
  if (e) {
    if (typeof e == "string")
      return ig(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return ig(e, t);
  }
}
function ig(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function pae(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function gae(e) {
  if (Array.isArray(e))
    return e;
}
function og(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function sg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? og(Object(r), !0).forEach(function(n) {
      vae(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : og(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function vae(e, t, r) {
  return t = mae(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function mae(e) {
  var t = Cae(e, "string");
  return Eo(t) == "symbol" ? t : String(t);
}
function Cae(e, t) {
  if (Eo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Eo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var lg = function(t, r, n, a, i) {
  var o = Math.min(Math.abs(n) / 2, Math.abs(a) / 2), s = a >= 0 ? 1 : -1, c = n >= 0 ? 1 : -1, u = a >= 0 && n >= 0 || a < 0 && n < 0 ? 1 : 0, d;
  if (o > 0 && i instanceof Array) {
    for (var h = [0, 0, 0, 0], A = 0, p = 4; A < p; A++)
      h[A] = i[A] > o ? o : i[A];
    d = "M".concat(t, ",").concat(r + s * h[0]), h[0] > 0 && (d += "A ".concat(h[0], ",").concat(h[0], ",0,0,").concat(u, ",").concat(t + c * h[0], ",").concat(r)), d += "L ".concat(t + n - c * h[1], ",").concat(r), h[1] > 0 && (d += "A ".concat(h[1], ",").concat(h[1], ",0,0,").concat(u, `,
        `).concat(t + n, ",").concat(r + s * h[1])), d += "L ".concat(t + n, ",").concat(r + a - s * h[2]), h[2] > 0 && (d += "A ".concat(h[2], ",").concat(h[2], ",0,0,").concat(u, `,
        `).concat(t + n - c * h[2], ",").concat(r + a)), d += "L ".concat(t + c * h[3], ",").concat(r + a), h[3] > 0 && (d += "A ".concat(h[3], ",").concat(h[3], ",0,0,").concat(u, `,
        `).concat(t, ",").concat(r + a - s * h[3])), d += "Z";
  } else if (o > 0 && i === +i && i > 0) {
    var v = Math.min(o, i);
    d = "M ".concat(t, ",").concat(r + s * v, `
            A `).concat(v, ",").concat(v, ",0,0,").concat(u, ",").concat(t + c * v, ",").concat(r, `
            L `).concat(t + n - c * v, ",").concat(r, `
            A `).concat(v, ",").concat(v, ",0,0,").concat(u, ",").concat(t + n, ",").concat(r + s * v, `
            L `).concat(t + n, ",").concat(r + a - s * v, `
            A `).concat(v, ",").concat(v, ",0,0,").concat(u, ",").concat(t + n - c * v, ",").concat(r + a, `
            L `).concat(t + c * v, ",").concat(r + a, `
            A `).concat(v, ",").concat(v, ",0,0,").concat(u, ",").concat(t, ",").concat(r + a - s * v, " Z");
  } else
    d = "M ".concat(t, ",").concat(r, " h ").concat(n, " v ").concat(a, " h ").concat(-n, " Z");
  return d;
}, bae = function(t, r) {
  if (!t || !r)
    return !1;
  var n = t.x, a = t.y, i = r.x, o = r.y, s = r.width, c = r.height;
  if (Math.abs(s) > 0 && Math.abs(c) > 0) {
    var u = Math.min(i, i + s), d = Math.max(i, i + s), h = Math.min(o, o + c), A = Math.max(o, o + c);
    return n >= u && n <= d && a >= h && a <= A;
  }
  return !1;
}, yae = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, z9 = function(t) {
  var r = sg(sg({}, yae), t), n = Ce(), a = Ee(-1), i = fae(a, 2), o = i[0], s = i[1];
  Ne(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var y = n.current.getTotalLength();
        y && s(y);
      } catch {
      }
  }, []);
  var c = r.x, u = r.y, d = r.width, h = r.height, A = r.radius, p = r.className, v = r.animationEasing, g = r.animationDuration, m = r.animationBegin, b = r.isAnimationActive, w = r.isUpdateAnimationActive;
  if (c !== +c || u !== +u || d !== +d || h !== +h || d === 0 || h === 0)
    return null;
  var x = Pe("recharts-rectangle", p);
  return w ? /* @__PURE__ */ P.createElement(Lr, {
    canBegin: o > 0,
    from: {
      width: d,
      height: h,
      x: c,
      y: u
    },
    to: {
      width: d,
      height: h,
      x: c,
      y: u
    },
    duration: g,
    animationEasing: v,
    isActive: w
  }, function(y) {
    var C = y.width, O = y.height, M = y.x, E = y.y;
    return /* @__PURE__ */ P.createElement(Lr, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: m,
      duration: g,
      isActive: b,
      easing: v
    }, /* @__PURE__ */ P.createElement("path", Vs({}, pe(r, !0), {
      className: x,
      d: lg(M, E, C, O, A),
      ref: n
    })));
  }) : /* @__PURE__ */ P.createElement("path", Vs({}, pe(r, !0), {
    className: x,
    d: lg(c, u, d, h, A)
  }));
}, wae = ["points", "className", "baseLinePoints", "connectNulls"];
function Ra() {
  return Ra = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ra.apply(this, arguments);
}
function xae(e, t) {
  if (e == null)
    return {};
  var r = Dae(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Dae(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function cg(e) {
  return Sae(e) || Eae(e) || Mae(e) || Oae();
}
function Oae() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mae(e, t) {
  if (e) {
    if (typeof e == "string")
      return q5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return q5(e, t);
  }
}
function Eae(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Sae(e) {
  if (Array.isArray(e))
    return q5(e);
}
function q5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var ug = function(t) {
  return t && t.x === +t.x && t.y === +t.y;
}, Pae = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = [[]];
  return t.forEach(function(n) {
    ug(n) ? r[r.length - 1].push(n) : r[r.length - 1].length > 0 && r.push([]);
  }), ug(t[0]) && r[r.length - 1].push(t[0]), r[r.length - 1].length <= 0 && (r = r.slice(0, -1)), r;
}, ki = function(t, r) {
  var n = Pae(t);
  r && (n = [n.reduce(function(i, o) {
    return [].concat(cg(i), cg(o));
  }, [])]);
  var a = n.map(function(i) {
    return i.reduce(function(o, s, c) {
      return "".concat(o).concat(c === 0 ? "M" : "L").concat(s.x, ",").concat(s.y);
    }, "");
  }).join("");
  return n.length === 1 ? "".concat(a, "Z") : a;
}, jae = function(t, r, n) {
  var a = ki(t, n);
  return "".concat(a.slice(-1) === "Z" ? a.slice(0, -1) : a, "L").concat(ki(r.reverse(), n).slice(1));
}, Iae = function(t) {
  var r = t.points, n = t.className, a = t.baseLinePoints, i = t.connectNulls, o = xae(t, wae);
  if (!r || !r.length)
    return null;
  var s = Pe("recharts-polygon", n);
  if (a && a.length) {
    var c = o.stroke && o.stroke !== "none", u = jae(r, a, i);
    return /* @__PURE__ */ P.createElement("g", {
      className: s
    }, /* @__PURE__ */ P.createElement("path", Ra({}, pe(o, !0), {
      fill: u.slice(-1) === "Z" ? o.fill : "none",
      stroke: "none",
      d: u
    })), c ? /* @__PURE__ */ P.createElement("path", Ra({}, pe(o, !0), {
      fill: "none",
      d: ki(r, i)
    })) : null, c ? /* @__PURE__ */ P.createElement("path", Ra({}, pe(o, !0), {
      fill: "none",
      d: ki(a, i)
    })) : null);
  }
  var d = ki(r, i);
  return /* @__PURE__ */ P.createElement("path", Ra({}, pe(o, !0), {
    fill: d.slice(-1) === "Z" ? o.fill : "none",
    className: s,
    d
  }));
};
function X5() {
  return X5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, X5.apply(this, arguments);
}
var e3 = function(t) {
  var r = t.cx, n = t.cy, a = t.r, i = t.className, o = Pe("recharts-dot", i);
  return r === +r && n === +n && a === +a ? /* @__PURE__ */ P.createElement("circle", X5({}, pe(t, !1), us(t), {
    className: o,
    cx: r,
    cy: n,
    r: a
  })) : null;
};
function So(e) {
  "@babel/helpers - typeof";
  return So = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, So(e);
}
var Bae = ["x", "y", "top", "left", "width", "height", "className"];
function J5() {
  return J5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, J5.apply(this, arguments);
}
function dg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Nae(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dg(Object(r), !0).forEach(function(n) {
      Lae(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : dg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Lae(e, t, r) {
  return t = Tae(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Tae(e) {
  var t = _ae(e, "string");
  return So(t) == "symbol" ? t : String(t);
}
function _ae(e, t) {
  if (So(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (So(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Rae(e, t) {
  if (e == null)
    return {};
  var r = Fae(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Fae(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var $ae = function(t, r, n, a, i, o) {
  return "M".concat(t, ",").concat(i, "v").concat(a, "M").concat(o, ",").concat(r, "h").concat(n);
}, Hae = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, i = a === void 0 ? 0 : a, o = t.top, s = o === void 0 ? 0 : o, c = t.left, u = c === void 0 ? 0 : c, d = t.width, h = d === void 0 ? 0 : d, A = t.height, p = A === void 0 ? 0 : A, v = t.className, g = Rae(t, Bae), m = Nae({
    x: n,
    y: i,
    top: s,
    left: u,
    width: h,
    height: p
  }, g);
  return !le(n) || !le(i) || !le(h) || !le(p) || !le(s) || !le(u) ? null : /* @__PURE__ */ P.createElement("path", J5({}, pe(m, !0), {
    className: Pe("recharts-cross", v),
    d: $ae(n, i, h, p, s, u)
  }));
}, Yae = F0, kae = Mw, Vae = hn;
function Gae(e, t) {
  return e && e.length ? Yae(e, Vae(t), kae) : void 0;
}
var Wae = Gae;
const Qae = /* @__PURE__ */ Xe(Wae);
var Uae = F0, Zae = hn, Kae = Ew;
function zae(e, t) {
  return e && e.length ? Uae(e, Zae(t), Kae) : void 0;
}
var qae = zae;
const Xae = /* @__PURE__ */ Xe(qae);
var Jae = ["cx", "cy", "angle", "ticks", "axisLine"], e2e = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function a2(e) {
  "@babel/helpers - typeof";
  return a2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, a2(e);
}
function Vi() {
  return Vi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vi.apply(this, arguments);
}
function fg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function S1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fg(Object(r), !0).forEach(function(n) {
      k0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function hg(e, t) {
  if (e == null)
    return {};
  var r = t2e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function t2e(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function r2e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ag(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, dx(n.key), n);
  }
}
function n2e(e, t, r) {
  return t && Ag(e.prototype, t), r && Ag(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function a2e(e, t, r) {
  return t = Gs(t), i2e(e, ux() ? Reflect.construct(t, r || [], Gs(e).constructor) : t.apply(e, r));
}
function i2e(e, t) {
  if (t && (a2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return o2e(e);
}
function o2e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ux() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ux = function() {
    return !!e;
  })();
}
function Gs(e) {
  return Gs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Gs(e);
}
function s2e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && e7(e, t);
}
function e7(e, t) {
  return e7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, e7(e, t);
}
function k0(e, t, r) {
  return t = dx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dx(e) {
  var t = l2e(e, "string");
  return a2(t) == "symbol" ? t : String(t);
}
function l2e(e, t) {
  if (a2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (a2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var V0 = /* @__PURE__ */ function(e) {
  s2e(t, e);
  function t() {
    return r2e(this, t), a2e(this, t, arguments);
  }
  return n2e(t, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(n) {
        var a = n.coordinate, i = this.props, o = i.angle, s = i.cx, c = i.cy;
        return ct(s, c, a, o);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props.orientation, a;
      switch (n) {
        case "left":
          a = "end";
          break;
        case "right":
          a = "start";
          break;
        default:
          a = "middle";
          break;
      }
      return a;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.angle, s = n.ticks, c = Qae(s, function(d) {
        return d.coordinate || 0;
      }), u = Xae(s, function(d) {
        return d.coordinate || 0;
      });
      return {
        cx: a,
        cy: i,
        startAngle: o,
        endAngle: o,
        innerRadius: u.coordinate || 0,
        outerRadius: c.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.angle, s = n.ticks, c = n.axisLine, u = hg(n, Jae), d = s.reduce(function(v, g) {
        return [Math.min(v[0], g.coordinate), Math.max(v[1], g.coordinate)];
      }, [1 / 0, -1 / 0]), h = ct(a, i, d[0], o), A = ct(a, i, d[1], o), p = S1(S1(S1({}, pe(u, !1)), {}, {
        fill: "none"
      }, pe(c, !1)), {}, {
        x1: h.x,
        y1: h.y,
        x2: A.x,
        y2: A.y
      });
      return /* @__PURE__ */ P.createElement("line", Vi({
        className: "recharts-polar-radius-axis-line"
      }, p));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, a = this.props, i = a.ticks, o = a.tick, s = a.angle, c = a.tickFormatter, u = a.stroke, d = hg(a, e2e), h = this.getTickTextAnchor(), A = pe(d, !1), p = pe(o, !1), v = i.map(function(g, m) {
        var b = n.getTickValueCoord(g), w = S1(S1(S1(S1({
          textAnchor: h,
          transform: "rotate(".concat(90 - s, ", ").concat(b.x, ", ").concat(b.y, ")")
        }, A), {}, {
          stroke: "none",
          fill: u
        }, p), {}, {
          index: m
        }, b), {}, {
          payload: g
        });
        return /* @__PURE__ */ P.createElement(je, Vi({
          className: Pe("recharts-polar-radius-axis-tick", Xw(o)),
          key: "tick-".concat(g.coordinate)
        }, s1(n.props, g, m)), t.renderTickItem(o, w, c ? c(g.value, m) : g.value));
      });
      return /* @__PURE__ */ P.createElement(je, {
        className: "recharts-polar-radius-axis-ticks"
      }, v);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.ticks, i = n.axisLine, o = n.tick;
      return !a || !a.length ? null : /* @__PURE__ */ P.createElement(je, {
        className: Pe("recharts-polar-radius-axis", this.props.className)
      }, i && this.renderAxisLine(), o && this.renderTicks(), Ot.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ P.isValidElement(n) ? o = /* @__PURE__ */ P.cloneElement(n, a) : xe(n) ? o = n(a) : o = /* @__PURE__ */ P.createElement(J1, Vi({}, a, {
        className: "recharts-polar-radius-axis-tick-value"
      }), i), o;
    }
  }]), t;
}(mr);
k0(V0, "displayName", "PolarRadiusAxis");
k0(V0, "axisType", "radiusAxis");
k0(V0, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function i2(e) {
  "@babel/helpers - typeof";
  return i2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, i2(e);
}
function k1() {
  return k1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, k1.apply(this, arguments);
}
function pg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function P1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pg(Object(r), !0).forEach(function(n) {
      G0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : pg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function c2e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function gg(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, hx(n.key), n);
  }
}
function u2e(e, t, r) {
  return t && gg(e.prototype, t), r && gg(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function d2e(e, t, r) {
  return t = Ws(t), f2e(e, fx() ? Reflect.construct(t, r || [], Ws(e).constructor) : t.apply(e, r));
}
function f2e(e, t) {
  if (t && (i2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return h2e(e);
}
function h2e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (fx = function() {
    return !!e;
  })();
}
function Ws(e) {
  return Ws = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ws(e);
}
function A2e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && t7(e, t);
}
function t7(e, t) {
  return t7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, t7(e, t);
}
function G0(e, t, r) {
  return t = hx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function hx(e) {
  var t = p2e(e, "string");
  return i2(t) == "symbol" ? t : String(t);
}
function p2e(e, t) {
  if (i2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (i2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var g2e = Math.PI / 180, vg = 1e-5, W0 = /* @__PURE__ */ function(e) {
  A2e(t, e);
  function t() {
    return c2e(this, t), d2e(this, t, arguments);
  }
  return u2e(t, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(n) {
        var a = this.props, i = a.cx, o = a.cy, s = a.radius, c = a.orientation, u = a.tickSize, d = u || 8, h = ct(i, o, s, n.coordinate), A = ct(i, o, s + (c === "inner" ? -1 : 1) * d, n.coordinate);
        return {
          x1: h.x,
          y1: h.y,
          x2: A.x,
          y2: A.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(n) {
      var a = this.props.orientation, i = Math.cos(-n.coordinate * g2e), o;
      return i > vg ? o = a === "outer" ? "start" : "end" : i < -vg ? o = a === "outer" ? "end" : "start" : o = "middle", o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.radius, s = n.axisLine, c = n.axisLineType, u = P1(P1({}, pe(this.props, !1)), {}, {
        fill: "none"
      }, pe(s, !1));
      if (c === "circle")
        return /* @__PURE__ */ P.createElement(e3, k1({
          className: "recharts-polar-angle-axis-line"
        }, u, {
          cx: a,
          cy: i,
          r: o
        }));
      var d = this.props.ticks, h = d.map(function(A) {
        return ct(a, i, o, A.coordinate);
      });
      return /* @__PURE__ */ P.createElement(Iae, k1({
        className: "recharts-polar-angle-axis-line"
      }, u, {
        points: h
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, a = this.props, i = a.ticks, o = a.tick, s = a.tickLine, c = a.tickFormatter, u = a.stroke, d = pe(this.props, !1), h = pe(o, !1), A = P1(P1({}, d), {}, {
        fill: "none"
      }, pe(s, !1)), p = i.map(function(v, g) {
        var m = n.getTickLineCoord(v), b = n.getTickTextAnchor(v), w = P1(P1(P1({
          textAnchor: b
        }, d), {}, {
          stroke: "none",
          fill: u
        }, h), {}, {
          index: g,
          payload: v,
          x: m.x2,
          y: m.y2
        });
        return /* @__PURE__ */ P.createElement(je, k1({
          className: Pe("recharts-polar-angle-axis-tick", Xw(o)),
          key: "tick-".concat(v.coordinate)
        }, s1(n.props, v, g)), s && /* @__PURE__ */ P.createElement("line", k1({
          className: "recharts-polar-angle-axis-tick-line"
        }, A, m)), o && t.renderTickItem(o, w, c ? c(v.value, g) : v.value));
      });
      return /* @__PURE__ */ P.createElement(je, {
        className: "recharts-polar-angle-axis-ticks"
      }, p);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.ticks, i = n.radius, o = n.axisLine;
      return i <= 0 || !a || !a.length ? null : /* @__PURE__ */ P.createElement(je, {
        className: Pe("recharts-polar-angle-axis", this.props.className)
      }, o && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ P.isValidElement(n) ? o = /* @__PURE__ */ P.cloneElement(n, a) : xe(n) ? o = n(a) : o = /* @__PURE__ */ P.createElement(J1, k1({}, a, {
        className: "recharts-polar-angle-axis-tick-value"
      }), i), o;
    }
  }]), t;
}(mr);
G0(W0, "displayName", "PolarAngleAxis");
G0(W0, "axisType", "angleAxis");
G0(W0, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var v2e = yy, m2e = v2e(Object.getPrototypeOf, Object), C2e = m2e, b2e = Pn, y2e = C2e, w2e = jn, x2e = "[object Object]", D2e = Function.prototype, O2e = Object.prototype, Ax = D2e.toString, M2e = O2e.hasOwnProperty, E2e = Ax.call(Object);
function S2e(e) {
  if (!w2e(e) || b2e(e) != x2e)
    return !1;
  var t = y2e(e);
  if (t === null)
    return !0;
  var r = M2e.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && Ax.call(r) == E2e;
}
var P2e = S2e;
const j2e = /* @__PURE__ */ Xe(P2e);
var I2e = Pn, B2e = jn, N2e = "[object Boolean]";
function L2e(e) {
  return e === !0 || e === !1 || B2e(e) && I2e(e) == N2e;
}
var T2e = L2e;
const _2e = /* @__PURE__ */ Xe(T2e);
function Po(e) {
  "@babel/helpers - typeof";
  return Po = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Po(e);
}
function Qs() {
  return Qs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qs.apply(this, arguments);
}
function R2e(e, t) {
  return Y2e(e) || H2e(e, t) || $2e(e, t) || F2e();
}
function F2e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $2e(e, t) {
  if (e) {
    if (typeof e == "string")
      return mg(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return mg(e, t);
  }
}
function mg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function H2e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function Y2e(e) {
  if (Array.isArray(e))
    return e;
}
function Cg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function bg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Cg(Object(r), !0).forEach(function(n) {
      k2e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Cg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function k2e(e, t, r) {
  return t = V2e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function V2e(e) {
  var t = G2e(e, "string");
  return Po(t) == "symbol" ? t : String(t);
}
function G2e(e, t) {
  if (Po(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Po(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var yg = function(t, r, n, a, i) {
  var o = n - a, s;
  return s = "M ".concat(t, ",").concat(r), s += "L ".concat(t + n, ",").concat(r), s += "L ".concat(t + n - o / 2, ",").concat(r + i), s += "L ".concat(t + n - o / 2 - a, ",").concat(r + i), s += "L ".concat(t, ",").concat(r, " Z"), s;
}, W2e = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Q2e = function(t) {
  var r = bg(bg({}, W2e), t), n = Ce(), a = Ee(-1), i = R2e(a, 2), o = i[0], s = i[1];
  Ne(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var x = n.current.getTotalLength();
        x && s(x);
      } catch {
      }
  }, []);
  var c = r.x, u = r.y, d = r.upperWidth, h = r.lowerWidth, A = r.height, p = r.className, v = r.animationEasing, g = r.animationDuration, m = r.animationBegin, b = r.isUpdateAnimationActive;
  if (c !== +c || u !== +u || d !== +d || h !== +h || A !== +A || d === 0 && h === 0 || A === 0)
    return null;
  var w = Pe("recharts-trapezoid", p);
  return b ? /* @__PURE__ */ P.createElement(Lr, {
    canBegin: o > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: A,
      x: c,
      y: u
    },
    to: {
      upperWidth: d,
      lowerWidth: h,
      height: A,
      x: c,
      y: u
    },
    duration: g,
    animationEasing: v,
    isActive: b
  }, function(x) {
    var y = x.upperWidth, C = x.lowerWidth, O = x.height, M = x.x, E = x.y;
    return /* @__PURE__ */ P.createElement(Lr, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: m,
      duration: g,
      easing: v
    }, /* @__PURE__ */ P.createElement("path", Qs({}, pe(r, !0), {
      className: w,
      d: yg(M, E, y, C, O),
      ref: n
    })));
  }) : /* @__PURE__ */ P.createElement("g", null, /* @__PURE__ */ P.createElement("path", Qs({}, pe(r, !0), {
    className: w,
    d: yg(c, u, d, h, A)
  })));
}, U2e = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function jo(e) {
  "@babel/helpers - typeof";
  return jo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, jo(e);
}
function Z2e(e, t) {
  if (e == null)
    return {};
  var r = K2e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function K2e(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function wg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Us(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wg(Object(r), !0).forEach(function(n) {
      z2e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : wg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function z2e(e, t, r) {
  return t = q2e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function q2e(e) {
  var t = X2e(e, "string");
  return jo(t) == "symbol" ? t : String(t);
}
function X2e(e, t) {
  if (jo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (jo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function J2e(e, t) {
  return Us(Us({}, t), e);
}
function eie(e, t) {
  return e === "symbols";
}
function xg(e) {
  var t = e.shapeType, r = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ P.createElement(z9, r);
    case "trapezoid":
      return /* @__PURE__ */ P.createElement(Q2e, r);
    case "sector":
      return /* @__PURE__ */ P.createElement(tx, r);
    case "symbols":
      if (eie(t))
        return /* @__PURE__ */ P.createElement(S0, r);
      break;
    default:
      return null;
  }
}
function tie(e) {
  return /* @__PURE__ */ kr(e) ? e.props : e;
}
function Zs(e) {
  var t = e.option, r = e.shapeType, n = e.propTransformer, a = n === void 0 ? J2e : n, i = e.activeClassName, o = i === void 0 ? "recharts-active-shape" : i, s = e.isActive, c = Z2e(e, U2e), u;
  if (/* @__PURE__ */ kr(t))
    u = /* @__PURE__ */ Pt(t, Us(Us({}, c), tie(t)));
  else if (xe(t))
    u = t(c);
  else if (j2e(t) && !_2e(t)) {
    var d = a(t, c);
    u = /* @__PURE__ */ P.createElement(xg, {
      shapeType: r,
      elementProps: d
    });
  } else {
    var h = c;
    u = /* @__PURE__ */ P.createElement(xg, {
      shapeType: r,
      elementProps: h
    });
  }
  return s ? /* @__PURE__ */ P.createElement(je, {
    className: o
  }, u) : u;
}
function Q0(e, t) {
  return t != null && "trapezoids" in e.props;
}
function U0(e, t) {
  return t != null && "sectors" in e.props;
}
function Io(e, t) {
  return t != null && "points" in e.props;
}
function rie(e, t) {
  var r, n, a = e.x === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.x) || e.x === t.x, i = e.y === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.y) || e.y === t.y;
  return a && i;
}
function nie(e, t) {
  var r = e.endAngle === t.endAngle, n = e.startAngle === t.startAngle;
  return r && n;
}
function aie(e, t) {
  var r = e.x === t.x, n = e.y === t.y, a = e.z === t.z;
  return r && n && a;
}
function iie(e, t) {
  var r;
  return Q0(e, t) ? r = rie : U0(e, t) ? r = nie : Io(e, t) && (r = aie), r;
}
function oie(e, t) {
  var r;
  return Q0(e, t) ? r = "trapezoids" : U0(e, t) ? r = "sectors" : Io(e, t) && (r = "points"), r;
}
function sie(e, t) {
  if (Q0(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  if (U0(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  return Io(e, t) ? t.payload : {};
}
function lie(e) {
  var t = e.activeTooltipItem, r = e.graphicalItem, n = e.itemData, a = oie(r, t), i = sie(r, t), o = n.filter(function(c, u) {
    var d = c1(i, c), h = r.props[a].filter(function(v) {
      var g = iie(r, t);
      return g(v, t);
    }), A = r.props[a].indexOf(h[h.length - 1]), p = u === A;
    return d && p;
  }), s = n.indexOf(o[o.length - 1]);
  return s;
}
var es;
function o2(e) {
  "@babel/helpers - typeof";
  return o2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, o2(e);
}
function Fa() {
  return Fa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fa.apply(this, arguments);
}
function Dg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function mt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Dg(Object(r), !0).forEach(function(n) {
      Mr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Dg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function cie(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Og(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, gx(n.key), n);
  }
}
function uie(e, t, r) {
  return t && Og(e.prototype, t), r && Og(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function die(e, t, r) {
  return t = Ks(t), fie(e, px() ? Reflect.construct(t, r || [], Ks(e).constructor) : t.apply(e, r));
}
function fie(e, t) {
  if (t && (o2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ta(e);
}
function px() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (px = function() {
    return !!e;
  })();
}
function Ks(e) {
  return Ks = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ks(e);
}
function Ta(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function hie(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && r7(e, t);
}
function r7(e, t) {
  return r7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, r7(e, t);
}
function Mr(e, t, r) {
  return t = gx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function gx(e) {
  var t = Aie(e, "string");
  return o2(t) == "symbol" ? t : String(t);
}
function Aie(e, t) {
  if (o2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (o2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var zr = /* @__PURE__ */ function(e) {
  hie(t, e);
  function t(r) {
    var n;
    return cie(this, t), n = die(this, t, [r]), Mr(Ta(n), "pieRef", null), Mr(Ta(n), "sectorRefs", []), Mr(Ta(n), "id", p1("recharts-pie-")), Mr(Ta(n), "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), xe(a) && a();
    }), Mr(Ta(n), "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), xe(a) && a();
    }), n.state = {
      isAnimationFinished: !r.isAnimationActive,
      prevIsAnimationActive: r.isAnimationActive,
      prevAnimationId: r.animationId,
      sectorToFocus: 0
    }, n;
  }
  return uie(t, [{
    key: "isActiveIndex",
    value: function(n) {
      var a = this.props.activeIndex;
      return Array.isArray(a) ? a.indexOf(n) !== -1 : n === a;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var n = this.props.activeIndex;
      return Array.isArray(n) ? n.length !== 0 : n || n === 0;
    }
  }, {
    key: "renderLabels",
    value: function(n) {
      var a = this.props.isAnimationActive;
      if (a && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.label, s = i.labelLine, c = i.dataKey, u = i.valueKey, d = pe(this.props, !1), h = pe(o, !1), A = pe(s, !1), p = o && o.offsetRadius || 20, v = n.map(function(g, m) {
        var b = (g.startAngle + g.endAngle) / 2, w = ct(g.cx, g.cy, g.outerRadius + p, b), x = mt(mt(mt(mt({}, d), g), {}, {
          stroke: "none"
        }, h), {}, {
          index: m,
          textAnchor: t.getTextAnchor(w.x, g.cx)
        }, w), y = mt(mt(mt(mt({}, d), g), {}, {
          fill: "none",
          stroke: g.fill
        }, A), {}, {
          index: m,
          points: [ct(g.cx, g.cy, g.outerRadius, b), w],
          key: "line"
        }), C = c;
        return ye(c) && ye(u) ? C = "value" : ye(c) && (C = u), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ P.createElement(je, {
          key: "label-".concat(g.startAngle, "-").concat(g.endAngle, "-").concat(g.midAngle, "-").concat(m)
        }, s && t.renderLabelLineItem(s, y), t.renderLabelItem(o, x, pt(g, C)));
      });
      return /* @__PURE__ */ P.createElement(je, {
        className: "recharts-pie-labels"
      }, v);
    }
  }, {
    key: "renderSectorsStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.activeShape, s = i.blendStroke, c = i.inactiveShape;
      return n.map(function(u, d) {
        if ((u == null ? void 0 : u.startAngle) === 0 && (u == null ? void 0 : u.endAngle) === 0 && n.length !== 1)
          return null;
        var h = a.isActiveIndex(d), A = c && a.hasActiveIndex() ? c : null, p = h ? o : A, v = mt(mt({}, u), {}, {
          stroke: s ? u.fill : u.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ P.createElement(je, Fa({
          ref: function(m) {
            m && !a.sectorRefs.includes(m) && a.sectorRefs.push(m);
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, s1(a.props, u, d), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(u == null ? void 0 : u.startAngle, "-").concat(u == null ? void 0 : u.endAngle, "-").concat(u.midAngle, "-").concat(d)
        }), /* @__PURE__ */ P.createElement(Zs, Fa({
          option: p,
          isActive: h,
          shapeType: "sector"
        }, v)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.sectors, o = a.isAnimationActive, s = a.animationBegin, c = a.animationDuration, u = a.animationEasing, d = a.animationId, h = this.state, A = h.prevSectors, p = h.prevIsAnimationActive;
      return /* @__PURE__ */ P.createElement(Lr, {
        begin: s,
        duration: c,
        isActive: o,
        easing: u,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(d, "-").concat(p),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(v) {
        var g = v.t, m = [], b = i && i[0], w = b.startAngle;
        return i.forEach(function(x, y) {
          var C = A && A[y], O = y > 0 ? vr(x, "paddingAngle", 0) : 0;
          if (C) {
            var M = yt(C.endAngle - C.startAngle, x.endAngle - x.startAngle), E = mt(mt({}, x), {}, {
              startAngle: w + O,
              endAngle: w + M(g) + O
            });
            m.push(E), w = E.endAngle;
          } else {
            var N = x.endAngle, F = x.startAngle, k = yt(0, N - F), R = k(g), j = mt(mt({}, x), {}, {
              startAngle: w + O,
              endAngle: w + R + O
            });
            m.push(j), w = j.endAngle;
          }
        }), /* @__PURE__ */ P.createElement(je, null, n.renderSectorsStatically(m));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(n) {
      var a = this;
      n.onkeydown = function(i) {
        if (!i.altKey)
          switch (i.key) {
            case "ArrowLeft": {
              var o = ++a.state.sectorToFocus % a.sectorRefs.length;
              a.sectorRefs[o].focus(), a.setState({
                sectorToFocus: o
              });
              break;
            }
            case "ArrowRight": {
              var s = --a.state.sectorToFocus < 0 ? a.sectorRefs.length - 1 : a.state.sectorToFocus % a.sectorRefs.length;
              a.sectorRefs[s].focus(), a.setState({
                sectorToFocus: s
              });
              break;
            }
            case "Escape": {
              a.sectorRefs[a.state.sectorToFocus].blur(), a.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var n = this.props, a = n.sectors, i = n.isAnimationActive, o = this.state.prevSectors;
      return i && a && a.length && (!o || !c1(o, a)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(a);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.hide, o = a.sectors, s = a.className, c = a.label, u = a.cx, d = a.cy, h = a.innerRadius, A = a.outerRadius, p = a.isAnimationActive, v = this.state.isAnimationFinished;
      if (i || !o || !o.length || !le(u) || !le(d) || !le(h) || !le(A))
        return null;
      var g = Pe("recharts-pie", s);
      return /* @__PURE__ */ P.createElement(je, {
        tabIndex: this.props.rootTabIndex,
        className: g,
        ref: function(b) {
          n.pieRef = b;
        }
      }, this.renderSectors(), c && this.renderLabels(o), Ot.renderCallByParent(this.props, null, !1), (!p || v) && Wr.renderCallByParent(this.props, o, !1));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return a.prevIsAnimationActive !== n.isAnimationActive ? {
        prevIsAnimationActive: n.isAnimationActive,
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : n.isAnimationActive && n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: a.curSectors,
        isAnimationFinished: !0
      } : n.sectors !== a.curSectors ? {
        curSectors: n.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(n, a) {
      return n > a ? "start" : n < a ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(n, a) {
      if (/* @__PURE__ */ P.isValidElement(n))
        return /* @__PURE__ */ P.cloneElement(n, a);
      if (xe(n))
        return n(a);
      var i = Pe("recharts-pie-label-line", typeof n != "boolean" ? n.className : "");
      return /* @__PURE__ */ P.createElement(a1, Fa({}, a, {
        type: "linear",
        className: i
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function(n, a, i) {
      if (/* @__PURE__ */ P.isValidElement(n))
        return /* @__PURE__ */ P.cloneElement(n, a);
      var o = i;
      if (xe(n) && (o = n(a), /* @__PURE__ */ P.isValidElement(o)))
        return o;
      var s = Pe("recharts-pie-label-text", typeof n != "boolean" && !xe(n) ? n.className : "");
      return /* @__PURE__ */ P.createElement(J1, Fa({}, a, {
        alignmentBaseline: "middle",
        className: s
      }), o);
    }
  }]), t;
}(mr);
es = zr;
Mr(zr, "displayName", "Pie");
Mr(zr, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !Ir.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
Mr(zr, "parseDeltaAngle", function(e, t) {
  var r = qt(t - e), n = Math.min(Math.abs(t - e), 360);
  return r * n;
});
Mr(zr, "getRealPieData", function(e) {
  var t = e.props, r = t.data, n = t.children, a = pe(e.props, !1), i = er(n, Br);
  return r && r.length ? r.map(function(o, s) {
    return mt(mt(mt({
      payload: o
    }, a), o), i && i[s] && i[s].props);
  }) : i && i.length ? i.map(function(o) {
    return mt(mt({}, a), o.props);
  }) : [];
});
Mr(zr, "parseCoordinateOfPie", function(e, t) {
  var r = t.top, n = t.left, a = t.width, i = t.height, o = qw(a, i), s = n + Xt(e.props.cx, a, a / 2), c = r + Xt(e.props.cy, i, i / 2), u = Xt(e.props.innerRadius, o, 0), d = Xt(e.props.outerRadius, o, o * 0.8), h = e.props.maxRadius || Math.sqrt(a * a + i * i) / 2;
  return {
    cx: s,
    cy: c,
    innerRadius: u,
    outerRadius: d,
    maxRadius: h
  };
});
Mr(zr, "getComposedData", function(e) {
  var t = e.item, r = e.offset, n = es.getRealPieData(t);
  if (!n || !n.length)
    return null;
  var a = t.props, i = a.cornerRadius, o = a.startAngle, s = a.endAngle, c = a.paddingAngle, u = a.dataKey, d = a.nameKey, h = a.valueKey, A = a.tooltipType, p = Math.abs(t.props.minAngle), v = es.parseCoordinateOfPie(t, r), g = es.parseDeltaAngle(o, s), m = Math.abs(g), b = u;
  ye(u) && ye(h) ? (Gr(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), b = "value") : ye(u) && (Gr(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), b = h);
  var w = n.filter(function(E) {
    return pt(E, b, 0) !== 0;
  }).length, x = (m >= 360 ? w : w - 1) * c, y = m - w * p - x, C = n.reduce(function(E, N) {
    var F = pt(N, b, 0);
    return E + (le(F) ? F : 0);
  }, 0), O;
  if (C > 0) {
    var M;
    O = n.map(function(E, N) {
      var F = pt(E, b, 0), k = pt(E, d, N), R = (le(F) ? F : 0) / C, j;
      N ? j = M.endAngle + qt(g) * c * (F !== 0 ? 1 : 0) : j = o;
      var U = j + qt(g) * ((F !== 0 ? p : 0) + R * y), ee = (j + U) / 2, X = (v.innerRadius + v.outerRadius) / 2, Z = [{
        name: k,
        value: F,
        payload: E,
        dataKey: b,
        type: A
      }], te = ct(v.cx, v.cy, X, ee);
      return M = mt(mt(mt({
        percent: R,
        cornerRadius: i,
        name: k,
        tooltipPayload: Z,
        midAngle: ee,
        middleRadius: X,
        tooltipPosition: te
      }, E), v), {}, {
        value: pt(E, b),
        startAngle: j,
        endAngle: U,
        payload: E,
        paddingAngle: qt(g) * c
      }), M;
    });
  }
  return mt(mt({}, v), {}, {
    sectors: O,
    data: n
  });
});
var pie = Math.ceil, gie = Math.max;
function vie(e, t, r, n) {
  for (var a = -1, i = gie(pie((t - e) / (r || 1)), 0), o = Array(i); i--; )
    o[n ? i : ++a] = e, e += r;
  return o;
}
var mie = vie, Cie = Yy, Mg = 1 / 0, bie = 17976931348623157e292;
function yie(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = Cie(e), e === Mg || e === -Mg) {
    var t = e < 0 ? -1 : 1;
    return t * bie;
  }
  return e === e ? e : 0;
}
var vx = yie, wie = mie, xie = I0, r4 = vx;
function Die(e) {
  return function(t, r, n) {
    return n && typeof n != "number" && xie(t, r, n) && (r = n = void 0), t = r4(t), r === void 0 ? (r = t, t = 0) : r = r4(r), n = n === void 0 ? t < r ? 1 : -1 : r4(n), wie(t, r, n, e);
  };
}
var Oie = Die, Mie = Oie, Eie = Mie(), Sie = Eie;
const zs = /* @__PURE__ */ Xe(Sie);
function Bo(e) {
  "@babel/helpers - typeof";
  return Bo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bo(e);
}
function Eg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Sg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Eg(Object(r), !0).forEach(function(n) {
      mx(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Eg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function mx(e, t, r) {
  return t = Pie(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Pie(e) {
  var t = jie(e, "string");
  return Bo(t) == "symbol" ? t : String(t);
}
function jie(e, t) {
  if (Bo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Bo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Iie = ["Webkit", "Moz", "O", "ms"], Bie = function(t, r) {
  if (!t)
    return null;
  var n = t.replace(/(\w)/, function(i) {
    return i.toUpperCase();
  }), a = Iie.reduce(function(i, o) {
    return Sg(Sg({}, i), {}, mx({}, o + n, r));
  }, {});
  return a[t] = r, a;
};
function s2(e) {
  "@babel/helpers - typeof";
  return s2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, s2(e);
}
function qs() {
  return qs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qs.apply(this, arguments);
}
function Pg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function n4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pg(Object(r), !0).forEach(function(n) {
      ur(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Pg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Nie(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function jg(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bx(n.key), n);
  }
}
function Lie(e, t, r) {
  return t && jg(e.prototype, t), r && jg(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Tie(e, t, r) {
  return t = Xs(t), _ie(e, Cx() ? Reflect.construct(t, r || [], Xs(e).constructor) : t.apply(e, r));
}
function _ie(e, t) {
  if (t && (s2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return nn(e);
}
function Cx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Cx = function() {
    return !!e;
  })();
}
function Xs(e) {
  return Xs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Xs(e);
}
function nn(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Rie(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && n7(e, t);
}
function n7(e, t) {
  return n7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, n7(e, t);
}
function ur(e, t, r) {
  return t = bx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function bx(e) {
  var t = Fie(e, "string");
  return s2(t) == "symbol" ? t : String(t);
}
function Fie(e, t) {
  if (s2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (s2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var $ie = function(t) {
  var r = t.data, n = t.startIndex, a = t.endIndex, i = t.x, o = t.width, s = t.travellerWidth;
  if (!r || !r.length)
    return {};
  var c = r.length, u = $i().domain(zs(0, c)).range([i, i + o - s]), d = u.domain().map(function(h) {
    return u(h);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: u(n),
    endX: u(a),
    scale: u,
    scaleValues: d
  };
}, Ig = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, l2 = /* @__PURE__ */ function(e) {
  Rie(t, e);
  function t(r) {
    var n;
    return Nie(this, t), n = Tie(this, t, [r]), ur(nn(n), "handleDrag", function(a) {
      n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(a) : n.state.isSlideMoving && n.handleSlideDrag(a);
    }), ur(nn(n), "handleTouchMove", function(a) {
      a.changedTouches != null && a.changedTouches.length > 0 && n.handleDrag(a.changedTouches[0]);
    }), ur(nn(n), "handleDragEnd", function() {
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var a = n.props, i = a.endIndex, o = a.onDragEnd, s = a.startIndex;
        o == null || o({
          endIndex: i,
          startIndex: s
        });
      }), n.detachDragEndListener();
    }), ur(nn(n), "handleLeaveWrapper", function() {
      (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
    }), ur(nn(n), "handleEnterSlideOrTraveller", function() {
      n.setState({
        isTextActive: !0
      });
    }), ur(nn(n), "handleLeaveSlideOrTraveller", function() {
      n.setState({
        isTextActive: !1
      });
    }), ur(nn(n), "handleSlideDragStart", function(a) {
      var i = Ig(a) ? a.changedTouches[0] : a;
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: i.pageX
      }), n.attachDragEndListener();
    }), n.travellerDragStartHandlers = {
      startX: n.handleTravellerDragStart.bind(nn(n), "startX"),
      endX: n.handleTravellerDragStart.bind(nn(n), "endX")
    }, n.state = {}, n;
  }
  return Lie(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(n) {
      var a = n.startX, i = n.endX, o = this.state.scaleValues, s = this.props, c = s.gap, u = s.data, d = u.length - 1, h = Math.min(a, i), A = Math.max(a, i), p = t.getIndexInRange(o, h), v = t.getIndexInRange(o, A);
      return {
        startIndex: p - p % c,
        endIndex: v === d ? d : v - v % c
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(n) {
      var a = this.props, i = a.data, o = a.tickFormatter, s = a.dataKey, c = pt(i[n], s, n);
      return xe(o) ? o(c, n) : c;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(n) {
      var a = this.state, i = a.slideMoveStartX, o = a.startX, s = a.endX, c = this.props, u = c.x, d = c.width, h = c.travellerWidth, A = c.startIndex, p = c.endIndex, v = c.onChange, g = n.pageX - i;
      g > 0 ? g = Math.min(g, u + d - h - s, u + d - h - o) : g < 0 && (g = Math.max(g, u - o, u - s));
      var m = this.getIndex({
        startX: o + g,
        endX: s + g
      });
      (m.startIndex !== A || m.endIndex !== p) && v && v(m), this.setState({
        startX: o + g,
        endX: s + g,
        slideMoveStartX: n.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(n, a) {
      var i = Ig(a) ? a.changedTouches[0] : a;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: n,
        brushMoveStartX: i.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(n) {
      var a = this.state, i = a.brushMoveStartX, o = a.movingTravellerId, s = a.endX, c = a.startX, u = this.state[o], d = this.props, h = d.x, A = d.width, p = d.travellerWidth, v = d.onChange, g = d.gap, m = d.data, b = {
        startX: this.state.startX,
        endX: this.state.endX
      }, w = n.pageX - i;
      w > 0 ? w = Math.min(w, h + A - p - u) : w < 0 && (w = Math.max(w, h - u)), b[o] = u + w;
      var x = this.getIndex(b), y = x.startIndex, C = x.endIndex, O = function() {
        var E = m.length - 1;
        return o === "startX" && (s > c ? y % g === 0 : C % g === 0) || s < c && C === E || o === "endX" && (s > c ? C % g === 0 : y % g === 0) || s > c && C === E;
      };
      this.setState(ur(ur({}, o, u + w), "brushMoveStartX", n.pageX), function() {
        v && O() && v(x);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(n, a) {
      var i = this, o = this.state, s = o.scaleValues, c = o.startX, u = o.endX, d = this.state[a], h = s.indexOf(d);
      if (h !== -1) {
        var A = h + n;
        if (!(A === -1 || A >= s.length)) {
          var p = s[A];
          a === "startX" && p >= u || a === "endX" && p <= c || this.setState(ur({}, a, p), function() {
            i.props.onChange(i.getIndex({
              startX: i.state.startX,
              endX: i.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, c = n.fill, u = n.stroke;
      return /* @__PURE__ */ P.createElement("rect", {
        stroke: u,
        fill: c,
        x: a,
        y: i,
        width: o,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, c = n.data, u = n.children, d = n.padding, h = K1.only(u);
      return h ? /* @__PURE__ */ P.cloneElement(h, {
        x: a,
        y: i,
        width: o,
        height: s,
        margin: d,
        compact: !0,
        data: c
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(n, a) {
      var i, o, s = this, c = this.props, u = c.y, d = c.travellerWidth, h = c.height, A = c.traveller, p = c.ariaLabel, v = c.data, g = c.startIndex, m = c.endIndex, b = Math.max(n, this.props.x), w = n4(n4({}, pe(this.props, !1)), {}, {
        x: b,
        y: u,
        width: d,
        height: h
      }), x = p || "Min value: ".concat((i = v[g]) === null || i === void 0 ? void 0 : i.name, ", Max value: ").concat((o = v[m]) === null || o === void 0 ? void 0 : o.name);
      return /* @__PURE__ */ P.createElement(je, {
        tabIndex: 0,
        role: "slider",
        "aria-label": x,
        "aria-valuenow": n,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[a],
        onTouchStart: this.travellerDragStartHandlers[a],
        onKeyDown: function(C) {
          ["ArrowLeft", "ArrowRight"].includes(C.key) && (C.preventDefault(), C.stopPropagation(), s.handleTravellerMoveKeyboard(C.key === "ArrowRight" ? 1 : -1, a));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(A, w));
    }
  }, {
    key: "renderSlide",
    value: function(n, a) {
      var i = this.props, o = i.y, s = i.height, c = i.stroke, u = i.travellerWidth, d = Math.min(n, a) + u, h = Math.max(Math.abs(a - n) - u, 0);
      return /* @__PURE__ */ P.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: c,
        fillOpacity: 0.2,
        x: d,
        y: o,
        width: h,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var n = this.props, a = n.startIndex, i = n.endIndex, o = n.y, s = n.height, c = n.travellerWidth, u = n.stroke, d = this.state, h = d.startX, A = d.endX, p = 5, v = {
        pointerEvents: "none",
        fill: u
      };
      return /* @__PURE__ */ P.createElement(je, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ P.createElement(J1, qs({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(h, A) - p,
        y: o + s / 2
      }, v), this.getTextOfTick(a)), /* @__PURE__ */ P.createElement(J1, qs({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(h, A) + c + p,
        y: o + s / 2
      }, v), this.getTextOfTick(i)));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.data, i = n.className, o = n.children, s = n.x, c = n.y, u = n.width, d = n.height, h = n.alwaysShowText, A = this.state, p = A.startX, v = A.endX, g = A.isTextActive, m = A.isSlideMoving, b = A.isTravellerMoving, w = A.isTravellerFocused;
      if (!a || !a.length || !le(s) || !le(c) || !le(u) || !le(d) || u <= 0 || d <= 0)
        return null;
      var x = Pe("recharts-brush", i), y = P.Children.count(o) === 1, C = Bie("userSelect", "none");
      return /* @__PURE__ */ P.createElement(je, {
        className: x,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: C
      }, this.renderBackground(), y && this.renderPanorama(), this.renderSlide(p, v), this.renderTravellerLayer(p, "startX"), this.renderTravellerLayer(v, "endX"), (g || m || b || w || h) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(n) {
      var a = n.x, i = n.y, o = n.width, s = n.height, c = n.stroke, u = Math.floor(i + s / 2) - 1;
      return /* @__PURE__ */ P.createElement(P.Fragment, null, /* @__PURE__ */ P.createElement("rect", {
        x: a,
        y: i,
        width: o,
        height: s,
        fill: c,
        stroke: "none"
      }), /* @__PURE__ */ P.createElement("line", {
        x1: a + 1,
        y1: u,
        x2: a + o - 1,
        y2: u,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ P.createElement("line", {
        x1: a + 1,
        y1: u + 2,
        x2: a + o - 1,
        y2: u + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(n, a) {
      var i;
      return /* @__PURE__ */ P.isValidElement(n) ? i = /* @__PURE__ */ P.cloneElement(n, a) : xe(n) ? i = n(a) : i = t.renderDefaultTraveller(a), i;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      var i = n.data, o = n.width, s = n.x, c = n.travellerWidth, u = n.updateId, d = n.startIndex, h = n.endIndex;
      if (i !== a.prevData || u !== a.prevUpdateId)
        return n4({
          prevData: i,
          prevTravellerWidth: c,
          prevUpdateId: u,
          prevX: s,
          prevWidth: o
        }, i && i.length ? $ie({
          data: i,
          width: o,
          x: s,
          travellerWidth: c,
          startIndex: d,
          endIndex: h
        }) : {
          scale: null,
          scaleValues: null
        });
      if (a.scale && (o !== a.prevWidth || s !== a.prevX || c !== a.prevTravellerWidth)) {
        a.scale.range([s, s + o - c]);
        var A = a.scale.domain().map(function(p) {
          return a.scale(p);
        });
        return {
          prevData: i,
          prevTravellerWidth: c,
          prevUpdateId: u,
          prevX: s,
          prevWidth: o,
          startX: a.scale(n.startIndex),
          endX: a.scale(n.endIndex),
          scaleValues: A
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(n, a) {
      for (var i = n.length, o = 0, s = i - 1; s - o > 1; ) {
        var c = Math.floor((o + s) / 2);
        n[c] > a ? s = c : o = c;
      }
      return a >= n[s] ? s : o;
    }
  }]), t;
}(mr);
ur(l2, "displayName", "Brush");
ur(l2, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var Hie = w9;
function Yie(e, t) {
  var r;
  return Hie(e, function(n, a, i) {
    return r = t(n, a, i), !r;
  }), !!r;
}
var kie = Yie, Vie = hy, Gie = hn, Wie = kie, Qie = ir, Uie = I0;
function Zie(e, t, r) {
  var n = Qie(e) ? Vie : Wie;
  return r && Uie(e, t, r) && (t = void 0), n(e, Gie(t));
}
var Kie = Zie;
const zie = /* @__PURE__ */ Xe(Kie);
var un = function(t, r) {
  var n = t.alwaysShow, a = t.ifOverflow;
  return n && (a = "extendDomain"), a === r;
}, Bg = _y;
function qie(e, t, r) {
  t == "__proto__" && Bg ? Bg(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var Xie = qie, Jie = Xie, eoe = Ly, toe = hn;
function roe(e, t) {
  var r = {};
  return t = toe(t), eoe(e, function(n, a, i) {
    Jie(r, a, t(n, a, i));
  }), r;
}
var noe = roe;
const aoe = /* @__PURE__ */ Xe(noe);
function ioe(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (!t(e[r], r, e))
      return !1;
  return !0;
}
var ooe = ioe, soe = w9;
function loe(e, t) {
  var r = !0;
  return soe(e, function(n, a, i) {
    return r = !!t(n, a, i), r;
  }), r;
}
var coe = loe, uoe = ooe, doe = coe, foe = hn, hoe = ir, Aoe = I0;
function poe(e, t, r) {
  var n = hoe(e) ? uoe : doe;
  return r && Aoe(e, t, r) && (t = void 0), n(e, foe(t));
}
var goe = poe;
const yx = /* @__PURE__ */ Xe(goe);
var voe = ["x", "y"];
function c2(e) {
  "@babel/helpers - typeof";
  return c2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, c2(e);
}
function a7() {
  return a7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, a7.apply(this, arguments);
}
function Ng(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function gi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ng(Object(r), !0).forEach(function(n) {
      moe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ng(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function moe(e, t, r) {
  return t = Coe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Coe(e) {
  var t = boe(e, "string");
  return c2(t) == "symbol" ? t : String(t);
}
function boe(e, t) {
  if (c2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (c2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function yoe(e, t) {
  if (e == null)
    return {};
  var r = woe(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function woe(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function xoe(e, t) {
  var r = e.x, n = e.y, a = yoe(e, voe), i = "".concat(r), o = parseInt(i, 10), s = "".concat(n), c = parseInt(s, 10), u = "".concat(t.height || a.height), d = parseInt(u, 10), h = "".concat(t.width || a.width), A = parseInt(h, 10);
  return gi(gi(gi(gi(gi({}, t), a), o ? {
    x: o
  } : {}), c ? {
    y: c
  } : {}), {}, {
    height: d,
    width: A,
    name: t.name,
    radius: t.radius
  });
}
function Lg(e) {
  return /* @__PURE__ */ P.createElement(Zs, a7({
    shapeType: "rectangle",
    propTransformer: xoe,
    activeClassName: "recharts-active-bar"
  }, e));
}
var Doe = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(n, a) {
    if (typeof t == "number")
      return t;
    var i = typeof n == "number";
    return i ? t(n, a) : (i || (process.env.NODE_ENV !== "production" ? Wt(!1, "minPointSize callback function received a value with type of ".concat(c2(n), ". Currently only numbers are supported.")) : Wt(!1)), r);
  };
}, Ooe = ["value", "background"], wx;
function u2(e) {
  "@babel/helpers - typeof";
  return u2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, u2(e);
}
function Moe(e, t) {
  if (e == null)
    return {};
  var r = Eoe(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Eoe(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Js() {
  return Js = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Js.apply(this, arguments);
}
function Tg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Nt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Tg(Object(r), !0).forEach(function(n) {
      qn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Tg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Soe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _g(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Dx(n.key), n);
  }
}
function Poe(e, t, r) {
  return t && _g(e.prototype, t), r && _g(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function joe(e, t, r) {
  return t = e0(t), Ioe(e, xx() ? Reflect.construct(t, r || [], e0(e).constructor) : t.apply(e, r));
}
function Ioe(e, t) {
  if (t && (u2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Bi(e);
}
function xx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (xx = function() {
    return !!e;
  })();
}
function e0(e) {
  return e0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, e0(e);
}
function Bi(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Boe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && i7(e, t);
}
function i7(e, t) {
  return i7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, i7(e, t);
}
function qn(e, t, r) {
  return t = Dx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Dx(e) {
  var t = Noe(e, "string");
  return u2(t) == "symbol" ? t : String(t);
}
function Noe(e, t) {
  if (u2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (u2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Tr = /* @__PURE__ */ function(e) {
  Boe(t, e);
  function t() {
    var r;
    Soe(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = joe(this, t, [].concat(a)), qn(Bi(r), "state", {
      isAnimationFinished: !1
    }), qn(Bi(r), "id", p1("recharts-bar-")), qn(Bi(r), "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), o && o();
    }), qn(Bi(r), "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), o && o();
    }), r;
  }
  return Poe(t, [{
    key: "renderRectanglesStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.shape, s = i.dataKey, c = i.activeIndex, u = i.activeBar, d = pe(this.props, !1);
      return n && n.map(function(h, A) {
        var p = A === c, v = p ? u : o, g = Nt(Nt(Nt({}, d), h), {}, {
          isActive: p,
          option: v,
          index: A,
          dataKey: s,
          onAnimationStart: a.handleAnimationStart,
          onAnimationEnd: a.handleAnimationEnd
        });
        return /* @__PURE__ */ P.createElement(je, Js({
          className: "recharts-bar-rectangle"
        }, s1(a.props, h, A), {
          key: "rectangle-".concat(h == null ? void 0 : h.x, "-").concat(h == null ? void 0 : h.y, "-").concat(h == null ? void 0 : h.value)
        }), /* @__PURE__ */ P.createElement(Lg, g));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.data, o = a.layout, s = a.isAnimationActive, c = a.animationBegin, u = a.animationDuration, d = a.animationEasing, h = a.animationId, A = this.state.prevData;
      return /* @__PURE__ */ P.createElement(Lr, {
        begin: c,
        duration: u,
        isActive: s,
        easing: d,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(h),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(p) {
        var v = p.t, g = i.map(function(m, b) {
          var w = A && A[b];
          if (w) {
            var x = yt(w.x, m.x), y = yt(w.y, m.y), C = yt(w.width, m.width), O = yt(w.height, m.height);
            return Nt(Nt({}, m), {}, {
              x: x(v),
              y: y(v),
              width: C(v),
              height: O(v)
            });
          }
          if (o === "horizontal") {
            var M = yt(0, m.height), E = M(v);
            return Nt(Nt({}, m), {}, {
              y: m.y + m.height - E,
              height: E
            });
          }
          var N = yt(0, m.width), F = N(v);
          return Nt(Nt({}, m), {}, {
            width: F
          });
        });
        return /* @__PURE__ */ P.createElement(je, null, n.renderRectanglesStatically(g));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var n = this.props, a = n.data, i = n.isAnimationActive, o = this.state.prevData;
      return i && a && a.length && (!o || !c1(o, a)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(a);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this, a = this.props, i = a.data, o = a.dataKey, s = a.activeIndex, c = pe(this.props.background, !1);
      return i.map(function(u, d) {
        u.value;
        var h = u.background, A = Moe(u, Ooe);
        if (!h)
          return null;
        var p = Nt(Nt(Nt(Nt(Nt({}, A), {}, {
          fill: "#eee"
        }, h), c), s1(n.props, u, d)), {}, {
          onAnimationStart: n.handleAnimationStart,
          onAnimationEnd: n.handleAnimationEnd,
          dataKey: o,
          index: d,
          key: "background-bar-".concat(d),
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ P.createElement(Lg, Js({
          option: n.props.background,
          isActive: d === s
        }, p));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(n, a) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.data, s = i.xAxis, c = i.yAxis, u = i.layout, d = i.children, h = er(d, N2);
      if (!h)
        return null;
      var A = u === "vertical" ? o[0].height / 2 : o[0].width / 2, p = function(m, b) {
        var w = Array.isArray(m.value) ? m.value[1] : m.value;
        return {
          x: m.x,
          y: m.y,
          value: w,
          errorVal: pt(m, b)
        };
      }, v = {
        clipPath: n ? "url(#clipPath-".concat(a, ")") : null
      };
      return /* @__PURE__ */ P.createElement(je, v, h.map(function(g) {
        return /* @__PURE__ */ P.cloneElement(g, {
          key: "error-bar-".concat(a, "-").concat(g.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: c,
          layout: u,
          offset: A,
          dataPointFormatter: p
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.hide, i = n.data, o = n.className, s = n.xAxis, c = n.yAxis, u = n.left, d = n.top, h = n.width, A = n.height, p = n.isAnimationActive, v = n.background, g = n.id;
      if (a || !i || !i.length)
        return null;
      var m = this.state.isAnimationFinished, b = Pe("recharts-bar", o), w = s && s.allowDataOverflow, x = c && c.allowDataOverflow, y = w || x, C = ye(g) ? this.id : g;
      return /* @__PURE__ */ P.createElement(je, {
        className: b
      }, w || x ? /* @__PURE__ */ P.createElement("defs", null, /* @__PURE__ */ P.createElement("clipPath", {
        id: "clipPath-".concat(C)
      }, /* @__PURE__ */ P.createElement("rect", {
        x: w ? u : u - h / 2,
        y: x ? d : d - A / 2,
        width: w ? h : h * 2,
        height: x ? A : A * 2
      }))) : null, /* @__PURE__ */ P.createElement(je, {
        className: "recharts-bar-rectangles",
        clipPath: y ? "url(#clipPath-".concat(C, ")") : null
      }, v ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(y, C), (!p || m) && Wr.renderCallByParent(this.props, i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curData: n.data,
        prevData: a.curData
      } : n.data !== a.curData ? {
        curData: n.data
      } : null;
    }
  }]), t;
}(mr);
wx = Tr;
qn(Tr, "displayName", "Bar");
qn(Tr, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !Ir.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
qn(Tr, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.barPosition, a = e.bandSize, i = e.xAxis, o = e.yAxis, s = e.xAxisTicks, c = e.yAxisTicks, u = e.stackedData, d = e.dataStartIndex, h = e.displayedData, A = e.offset, p = Ire(n, r);
  if (!p)
    return null;
  var v = t.layout, g = r.props, m = g.dataKey, b = g.children, w = g.minPointSize, x = v === "horizontal" ? o : i, y = u ? x.scale.domain() : null, C = Fre({
    numericAxis: x
  }), O = er(b, Br), M = h.map(function(E, N) {
    var F, k, R, j, U, ee;
    u ? F = Bre(u[d + N], y) : (F = pt(E, m), Array.isArray(F) || (F = [C, F]));
    var X = Doe(w, wx.defaultProps.minPointSize)(F[1], N);
    if (v === "horizontal") {
      var Z, te = [o.scale(F[0]), o.scale(F[1])], B = te[0], I = te[1];
      k = Dp({
        axis: i,
        ticks: s,
        bandSize: a,
        offset: p.offset,
        entry: E,
        index: N
      }), R = (Z = I ?? B) !== null && Z !== void 0 ? Z : void 0, j = p.size;
      var _ = B - I;
      if (U = Number.isNaN(_) ? 0 : _, ee = {
        x: k,
        y: o.y,
        width: j,
        height: o.height
      }, Math.abs(X) > 0 && Math.abs(U) < Math.abs(X)) {
        var L = qt(U || X) * (Math.abs(X) - Math.abs(U));
        R -= L, U += L;
      }
    } else {
      var D = [i.scale(F[0]), i.scale(F[1])], T = D[0], Q = D[1];
      if (k = T, R = Dp({
        axis: o,
        ticks: c,
        bandSize: a,
        offset: p.offset,
        entry: E,
        index: N
      }), j = Q - T, U = p.size, ee = {
        x: i.x,
        y: R,
        width: i.width,
        height: U
      }, Math.abs(X) > 0 && Math.abs(j) < Math.abs(X)) {
        var z = qt(j || X) * (Math.abs(X) - Math.abs(j));
        j += z;
      }
    }
    return Nt(Nt(Nt({}, E), {}, {
      x: k,
      y: R,
      width: j,
      height: U,
      value: u ? F : F[1],
      payload: E,
      background: ee
    }, O && O[N] && O[N].props), {}, {
      tooltipPayload: [Kw(r, E)],
      tooltipPosition: {
        x: k + j / 2,
        y: R + U / 2
      }
    });
  });
  return Nt({
    data: M,
    layout: v
  }, A);
});
function No(e) {
  "@babel/helpers - typeof";
  return No = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, No(e);
}
function Loe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Rg(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ox(n.key), n);
  }
}
function Toe(e, t, r) {
  return t && Rg(e.prototype, t), r && Rg(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Fg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Fr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fg(Object(r), !0).forEach(function(n) {
      Z0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Fg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Z0(e, t, r) {
  return t = Ox(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ox(e) {
  var t = _oe(e, "string");
  return No(t) == "symbol" ? t : String(t);
}
function _oe(e, t) {
  if (No(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (No(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Mx = function(t, r, n, a, i) {
  var o = t.width, s = t.height, c = t.layout, u = t.children, d = Object.keys(r), h = {
    left: n.left,
    leftMirror: n.left,
    right: o - n.right,
    rightMirror: o - n.right,
    top: n.top,
    topMirror: n.top,
    bottom: s - n.bottom,
    bottomMirror: s - n.bottom
  }, A = !!fr(u, Tr);
  return d.reduce(function(p, v) {
    var g = r[v], m = g.orientation, b = g.domain, w = g.padding, x = w === void 0 ? {} : w, y = g.mirror, C = g.reversed, O = "".concat(m).concat(y ? "Mirror" : ""), M, E, N, F, k;
    if (g.type === "number" && (g.padding === "gap" || g.padding === "no-gap")) {
      var R = b[1] - b[0], j = 1 / 0, U = g.categoricalDomain.sort();
      if (U.forEach(function(T, Q) {
        Q > 0 && (j = Math.min((T || 0) - (U[Q - 1] || 0), j));
      }), Number.isFinite(j)) {
        var ee = j / R, X = g.layout === "vertical" ? n.height : n.width;
        if (g.padding === "gap" && (M = ee * X / 2), g.padding === "no-gap") {
          var Z = Xt(t.barCategoryGap, ee * X), te = ee * X / 2;
          M = te - Z - (te - Z) / X * Z;
        }
      }
    }
    a === "xAxis" ? E = [n.left + (x.left || 0) + (M || 0), n.left + n.width - (x.right || 0) - (M || 0)] : a === "yAxis" ? E = c === "horizontal" ? [n.top + n.height - (x.bottom || 0), n.top + (x.top || 0)] : [n.top + (x.top || 0) + (M || 0), n.top + n.height - (x.bottom || 0) - (M || 0)] : E = g.range, C && (E = [E[1], E[0]]);
    var B = Ww(g, i, A), I = B.scale, _ = B.realScaleType;
    I.domain(b).range(E), Qw(I);
    var L = Uw(I, Fr(Fr({}, g), {}, {
      realScaleType: _
    }));
    a === "xAxis" ? (k = m === "top" && !y || m === "bottom" && y, N = n.left, F = h[O] - k * g.height) : a === "yAxis" && (k = m === "left" && !y || m === "right" && y, N = h[O] - k * g.width, F = n.top);
    var D = Fr(Fr(Fr({}, g), L), {}, {
      realScaleType: _,
      x: N,
      y: F,
      scale: I,
      width: a === "xAxis" ? n.width : g.width,
      height: a === "yAxis" ? n.height : g.height
    });
    return D.bandSize = _s(D, L), !g.hide && a === "xAxis" ? h[O] += (k ? -1 : 1) * D.height : g.hide || (h[O] += (k ? -1 : 1) * D.width), Fr(Fr({}, p), {}, Z0({}, v, D));
  }, {});
}, Ex = function(t, r) {
  var n = t.x, a = t.y, i = r.x, o = r.y;
  return {
    x: Math.min(n, i),
    y: Math.min(a, o),
    width: Math.abs(i - n),
    height: Math.abs(o - a)
  };
}, Roe = function(t) {
  var r = t.x1, n = t.y1, a = t.x2, i = t.y2;
  return Ex({
    x: r,
    y: n
  }, {
    x: a,
    y: i
  });
}, Sx = /* @__PURE__ */ function() {
  function e(t) {
    Loe(this, e), this.scale = t;
  }
  return Toe(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.bandAware, i = n.position;
      if (r !== void 0) {
        if (i)
          switch (i) {
            case "start":
              return this.scale(r);
            case "middle": {
              var o = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + o;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + s;
            }
            default:
              return this.scale(r);
          }
        if (a) {
          var c = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + c;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var n = this.range(), a = n[0], i = n[n.length - 1];
      return a <= i ? r >= a && r <= i : r >= i && r <= a;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new e(r);
    }
  }]), e;
}();
Z0(Sx, "EPS", 1e-4);
var q9 = function(t) {
  var r = Object.keys(t).reduce(function(n, a) {
    return Fr(Fr({}, n), {}, Z0({}, a, Sx.create(t[a])));
  }, {});
  return Fr(Fr({}, r), {}, {
    apply: function(a) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = i.bandAware, s = i.position;
      return aoe(a, function(c, u) {
        return r[u].apply(c, {
          bandAware: o,
          position: s
        });
      });
    },
    isInRange: function(a) {
      return yx(a, function(i, o) {
        return r[o].isInRange(i);
      });
    }
  });
};
function Foe(e) {
  return (e % 180 + 180) % 180;
}
var $oe = function(t) {
  var r = t.width, n = t.height, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = Foe(a), o = i * Math.PI / 180, s = Math.atan(n / r), c = o > s && o < Math.PI - s ? n / Math.sin(o) : r / Math.cos(o);
  return Math.abs(c);
}, Hoe = hn, Yoe = Ko, koe = P0;
function Voe(e) {
  return function(t, r, n) {
    var a = Object(t);
    if (!Yoe(t)) {
      var i = Hoe(r);
      t = koe(t), r = function(s) {
        return i(a[s], s, a);
      };
    }
    var o = e(t, r, n);
    return o > -1 ? a[i ? t[o] : o] : void 0;
  };
}
var Goe = Voe, Woe = vx;
function Qoe(e) {
  var t = Woe(e), r = t % 1;
  return t === t ? r ? t - r : t : 0;
}
var Uoe = Qoe, Zoe = Ey, Koe = hn, zoe = Uoe, qoe = Math.max;
function Xoe(e, t, r) {
  var n = e == null ? 0 : e.length;
  if (!n)
    return -1;
  var a = r == null ? 0 : zoe(r);
  return a < 0 && (a = qoe(n + a, 0)), Zoe(e, Koe(t), a);
}
var Joe = Xoe, e3e = Goe, t3e = Joe, r3e = e3e(t3e), n3e = r3e;
const a3e = /* @__PURE__ */ Xe(n3e);
var i3e = IH(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function t0(e) {
  "@babel/helpers - typeof";
  return t0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, t0(e);
}
var X9 = /* @__PURE__ */ f1(void 0), J9 = /* @__PURE__ */ f1(void 0), Px = /* @__PURE__ */ f1(void 0), jx = /* @__PURE__ */ f1({}), Ix = /* @__PURE__ */ f1(void 0), Bx = /* @__PURE__ */ f1(0), Nx = /* @__PURE__ */ f1(0), $g = function(t) {
  var r = t.state, n = r.xAxisMap, a = r.yAxisMap, i = r.offset, o = t.clipPathId, s = t.children, c = t.width, u = t.height, d = i3e(i);
  return /* @__PURE__ */ P.createElement(X9.Provider, {
    value: n
  }, /* @__PURE__ */ P.createElement(J9.Provider, {
    value: a
  }, /* @__PURE__ */ P.createElement(jx.Provider, {
    value: i
  }, /* @__PURE__ */ P.createElement(Px.Provider, {
    value: d
  }, /* @__PURE__ */ P.createElement(Ix.Provider, {
    value: o
  }, /* @__PURE__ */ P.createElement(Bx.Provider, {
    value: u
  }, /* @__PURE__ */ P.createElement(Nx.Provider, {
    value: c
  }, s)))))));
}, o3e = function() {
  return wt(Ix);
};
function Lx(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var Tx = function(t) {
  var r = wt(X9);
  r == null && (process.env.NODE_ENV !== "production" ? Wt(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Wt(!1));
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? Wt(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(t0(t), "]. ").concat(Lx(r))) : Wt(!1)), n;
}, s3e = function() {
  var t = wt(X9);
  return Kn(t);
}, l3e = function() {
  var t = wt(J9), r = a3e(t, function(n) {
    return yx(n.domain, Number.isFinite);
  });
  return r || Kn(t);
}, _x = function(t) {
  var r = wt(J9);
  r == null && (process.env.NODE_ENV !== "production" ? Wt(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Wt(!1));
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? Wt(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(t0(t), "]. ").concat(Lx(r))) : Wt(!1)), n;
}, c3e = function() {
  var t = wt(Px);
  return t;
}, u3e = function() {
  return wt(jx);
}, e8 = function() {
  return wt(Nx);
}, t8 = function() {
  return wt(Bx);
};
function Lo(e) {
  "@babel/helpers - typeof";
  return Lo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Lo(e);
}
function Hg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Yg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hg(Object(r), !0).forEach(function(n) {
      d3e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Hg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function d3e(e, t, r) {
  return t = f3e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function f3e(e) {
  var t = h3e(e, "string");
  return Lo(t) == "symbol" ? t : String(t);
}
function h3e(e, t) {
  if (Lo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Lo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function A3e(e, t) {
  return m3e(e) || v3e(e, t) || g3e(e, t) || p3e();
}
function p3e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function g3e(e, t) {
  if (e) {
    if (typeof e == "string")
      return kg(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return kg(e, t);
  }
}
function kg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function v3e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function m3e(e) {
  if (Array.isArray(e))
    return e;
}
function o7() {
  return o7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, o7.apply(this, arguments);
}
var C3e = function(t, r) {
  var n;
  return /* @__PURE__ */ P.isValidElement(t) ? n = /* @__PURE__ */ P.cloneElement(t, r) : xe(t) ? n = t(r) : n = /* @__PURE__ */ P.createElement("line", o7({}, r, {
    className: "recharts-reference-line-line"
  })), n;
}, b3e = function(t, r, n, a, i, o, s, c, u) {
  var d = i.x, h = i.y, A = i.width, p = i.height;
  if (n) {
    var v = u.y, g = t.y.apply(v, {
      position: o
    });
    if (un(u, "discard") && !t.y.isInRange(g))
      return null;
    var m = [{
      x: d + A,
      y: g
    }, {
      x: d,
      y: g
    }];
    return c === "left" ? m.reverse() : m;
  }
  if (r) {
    var b = u.x, w = t.x.apply(b, {
      position: o
    });
    if (un(u, "discard") && !t.x.isInRange(w))
      return null;
    var x = [{
      x: w,
      y: h + p
    }, {
      x: w,
      y: h
    }];
    return s === "top" ? x.reverse() : x;
  }
  if (a) {
    var y = u.segment, C = y.map(function(O) {
      return t.apply(O, {
        position: o
      });
    });
    return un(u, "discard") && zie(C, function(O) {
      return !t.isInRange(O);
    }) ? null : C;
  }
  return null;
};
function r8(e) {
  var t = e.x, r = e.y, n = e.segment, a = e.xAxisId, i = e.yAxisId, o = e.shape, s = e.className, c = e.alwaysShow, u = o3e(), d = Tx(a), h = _x(i), A = c3e();
  if (!u || !A)
    return null;
  Gr(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var p = q9({
    x: d.scale,
    y: h.scale
  }), v = jt(t), g = jt(r), m = n && n.length === 2, b = b3e(p, v, g, m, A, e.position, d.orientation, h.orientation, e);
  if (!b)
    return null;
  var w = A3e(b, 2), x = w[0], y = x.x, C = x.y, O = w[1], M = O.x, E = O.y, N = un(e, "hidden") ? "url(#".concat(u, ")") : void 0, F = Yg(Yg({
    clipPath: N
  }, pe(e, !0)), {}, {
    x1: y,
    y1: C,
    x2: M,
    y2: E
  });
  return /* @__PURE__ */ P.createElement(je, {
    className: Pe("recharts-reference-line", s)
  }, C3e(o, F), Ot.renderCallByParent(e, Roe({
    x1: y,
    y1: C,
    x2: M,
    y2: E
  })));
}
r8.displayName = "ReferenceLine";
r8.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
};
function To(e) {
  "@babel/helpers - typeof";
  return To = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, To(e);
}
function s7() {
  return s7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, s7.apply(this, arguments);
}
function Vg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vg(Object(r), !0).forEach(function(n) {
      y3e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Vg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function y3e(e, t, r) {
  return t = w3e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function w3e(e) {
  var t = x3e(e, "string");
  return To(t) == "symbol" ? t : String(t);
}
function x3e(e, t) {
  if (To(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (To(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var D3e = function(t) {
  var r = t.x, n = t.y, a = t.xAxis, i = t.yAxis, o = q9({
    x: a.scale,
    y: i.scale
  }), s = o.apply({
    x: r,
    y: n
  }, {
    bandAware: !0
  });
  return un(t, "discard") && !o.isInRange(s) ? null : s;
};
function t3(e) {
  var t = e.x, r = e.y, n = e.r, a = e.alwaysShow, i = e.clipPathId, o = jt(t), s = jt(r);
  if (Gr(a === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !o || !s)
    return null;
  var c = D3e(e);
  if (!c)
    return null;
  var u = c.x, d = c.y, h = e.shape, A = e.className, p = un(e, "hidden") ? "url(#".concat(i, ")") : void 0, v = Gg(Gg({
    clipPath: p
  }, pe(e, !0)), {}, {
    cx: u,
    cy: d
  });
  return /* @__PURE__ */ P.createElement(je, {
    className: Pe("recharts-reference-dot", A)
  }, t3.renderDot(h, v), Ot.renderCallByParent(e, {
    x: u - n,
    y: d - n,
    width: 2 * n,
    height: 2 * n
  }));
}
t3.displayName = "ReferenceDot";
t3.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
};
t3.renderDot = function(e, t) {
  var r;
  return /* @__PURE__ */ P.isValidElement(e) ? r = /* @__PURE__ */ P.cloneElement(e, t) : xe(e) ? r = e(t) : r = /* @__PURE__ */ P.createElement(e3, s7({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), r;
};
function _o(e) {
  "@babel/helpers - typeof";
  return _o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _o(e);
}
function l7() {
  return l7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, l7.apply(this, arguments);
}
function Wg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Qg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wg(Object(r), !0).forEach(function(n) {
      O3e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Wg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function O3e(e, t, r) {
  return t = M3e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function M3e(e) {
  var t = E3e(e, "string");
  return _o(t) == "symbol" ? t : String(t);
}
function E3e(e, t) {
  if (_o(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (_o(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var S3e = function(t, r, n, a, i) {
  var o = i.x1, s = i.x2, c = i.y1, u = i.y2, d = i.xAxis, h = i.yAxis;
  if (!d || !h)
    return null;
  var A = q9({
    x: d.scale,
    y: h.scale
  }), p = {
    x: t ? A.x.apply(o, {
      position: "start"
    }) : A.x.rangeMin,
    y: n ? A.y.apply(c, {
      position: "start"
    }) : A.y.rangeMin
  }, v = {
    x: r ? A.x.apply(s, {
      position: "end"
    }) : A.x.rangeMax,
    y: a ? A.y.apply(u, {
      position: "end"
    }) : A.y.rangeMax
  };
  return un(i, "discard") && (!A.isInRange(p) || !A.isInRange(v)) ? null : Ex(p, v);
};
function r3(e) {
  var t = e.x1, r = e.x2, n = e.y1, a = e.y2, i = e.className, o = e.alwaysShow, s = e.clipPathId;
  Gr(o === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var c = jt(t), u = jt(r), d = jt(n), h = jt(a), A = e.shape;
  if (!c && !u && !d && !h && !A)
    return null;
  var p = S3e(c, u, d, h, e);
  if (!p && !A)
    return null;
  var v = un(e, "hidden") ? "url(#".concat(s, ")") : void 0;
  return /* @__PURE__ */ P.createElement(je, {
    className: Pe("recharts-reference-area", i)
  }, r3.renderRect(A, Qg(Qg({
    clipPath: v
  }, pe(e, !0)), p)), Ot.renderCallByParent(e, p));
}
r3.displayName = "ReferenceArea";
r3.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
};
r3.renderRect = function(e, t) {
  var r;
  return /* @__PURE__ */ P.isValidElement(e) ? r = /* @__PURE__ */ P.cloneElement(e, t) : xe(e) ? r = e(t) : r = /* @__PURE__ */ P.createElement(z9, l7({}, t, {
    className: "recharts-reference-area-rect"
  })), r;
};
function Rx(e, t, r) {
  if (t < 1)
    return [];
  if (t === 1 && r === void 0)
    return e;
  for (var n = [], a = 0; a < e.length; a += t)
    if (r === void 0 || r(e[a]) === !0)
      n.push(e[a]);
    else
      return;
  return n;
}
function P3e(e, t, r) {
  var n = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return $oe(n, r);
}
function j3e(e, t, r) {
  var n = r === "width", a = e.x, i = e.y, o = e.width, s = e.height;
  return t === 1 ? {
    start: n ? a : i,
    end: n ? a + o : i + s
  } : {
    start: n ? a + o : i + s,
    end: n ? a : i
  };
}
function r0(e, t, r, n, a) {
  if (e * t < e * n || e * t > e * a)
    return !1;
  var i = r();
  return e * (t - e * i / 2 - n) >= 0 && e * (t + e * i / 2 - a) <= 0;
}
function I3e(e, t) {
  return Rx(e, t + 1);
}
function B3e(e, t, r, n, a) {
  for (var i = (n || []).slice(), o = t.start, s = t.end, c = 0, u = 1, d = o, h = function() {
    var v = n == null ? void 0 : n[c];
    if (v === void 0)
      return {
        v: Rx(n, u)
      };
    var g = c, m, b = function() {
      return m === void 0 && (m = r(v, g)), m;
    }, w = v.coordinate, x = c === 0 || r0(e, w, b, d, s);
    x || (c = 0, d = o, u += 1), x && (d = w + e * (b() / 2 + a), c += u);
  }, A; u <= i.length; )
    if (A = h(), A)
      return A.v;
  return [];
}
function Ro(e) {
  "@babel/helpers - typeof";
  return Ro = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ro(e);
}
function Ug(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Vt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ug(Object(r), !0).forEach(function(n) {
      N3e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ug(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function N3e(e, t, r) {
  return t = L3e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function L3e(e) {
  var t = T3e(e, "string");
  return Ro(t) == "symbol" ? t : String(t);
}
function T3e(e, t) {
  if (Ro(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ro(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _3e(e, t, r, n, a) {
  for (var i = (n || []).slice(), o = i.length, s = t.start, c = t.end, u = function(A) {
    var p = i[A], v, g = function() {
      return v === void 0 && (v = r(p, A)), v;
    };
    if (A === o - 1) {
      var m = e * (p.coordinate + e * g() / 2 - c);
      i[A] = p = Vt(Vt({}, p), {}, {
        tickCoord: m > 0 ? p.coordinate - m * e : p.coordinate
      });
    } else
      i[A] = p = Vt(Vt({}, p), {}, {
        tickCoord: p.coordinate
      });
    var b = r0(e, p.tickCoord, g, s, c);
    b && (c = p.tickCoord - e * (g() / 2 + a), i[A] = Vt(Vt({}, p), {}, {
      isShow: !0
    }));
  }, d = o - 1; d >= 0; d--)
    u(d);
  return i;
}
function R3e(e, t, r, n, a, i) {
  var o = (n || []).slice(), s = o.length, c = t.start, u = t.end;
  if (i) {
    var d = n[s - 1], h = r(d, s - 1), A = e * (d.coordinate + e * h / 2 - u);
    o[s - 1] = d = Vt(Vt({}, d), {}, {
      tickCoord: A > 0 ? d.coordinate - A * e : d.coordinate
    });
    var p = r0(e, d.tickCoord, function() {
      return h;
    }, c, u);
    p && (u = d.tickCoord - e * (h / 2 + a), o[s - 1] = Vt(Vt({}, d), {}, {
      isShow: !0
    }));
  }
  for (var v = i ? s - 1 : s, g = function(w) {
    var x = o[w], y, C = function() {
      return y === void 0 && (y = r(x, w)), y;
    };
    if (w === 0) {
      var O = e * (x.coordinate - e * C() / 2 - c);
      o[w] = x = Vt(Vt({}, x), {}, {
        tickCoord: O < 0 ? x.coordinate - O * e : x.coordinate
      });
    } else
      o[w] = x = Vt(Vt({}, x), {}, {
        tickCoord: x.coordinate
      });
    var M = r0(e, x.tickCoord, C, c, u);
    M && (c = x.tickCoord + e * (C() / 2 + a), o[w] = Vt(Vt({}, x), {}, {
      isShow: !0
    }));
  }, m = 0; m < v; m++)
    g(m);
  return o;
}
function n8(e, t, r) {
  var n = e.tick, a = e.ticks, i = e.viewBox, o = e.minTickGap, s = e.orientation, c = e.interval, u = e.tickFormatter, d = e.unit, h = e.angle;
  if (!a || !a.length || !n)
    return [];
  if (le(c) || Ir.isSsr)
    return I3e(a, typeof c == "number" && le(c) ? c : 0);
  var A = [], p = s === "top" || s === "bottom" ? "width" : "height", v = d && p === "width" ? Fi(d, {
    fontSize: t,
    letterSpacing: r
  }) : {
    width: 0,
    height: 0
  }, g = function(x, y) {
    var C = xe(u) ? u(x.value, y) : x.value;
    return p === "width" ? P3e(Fi(C, {
      fontSize: t,
      letterSpacing: r
    }), v, h) : Fi(C, {
      fontSize: t,
      letterSpacing: r
    })[p];
  }, m = a.length >= 2 ? qt(a[1].coordinate - a[0].coordinate) : 1, b = j3e(i, m, p);
  return c === "equidistantPreserveStart" ? B3e(m, b, g, a, o) : (c === "preserveStart" || c === "preserveStartEnd" ? A = R3e(m, b, g, a, o, c === "preserveStartEnd") : A = _3e(m, b, g, a, o), A.filter(function(w) {
    return w.isShow;
  }));
}
var F3e = ["viewBox"], $3e = ["viewBox"], H3e = ["ticks"];
function d2(e) {
  "@babel/helpers - typeof";
  return d2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, d2(e);
}
function $a() {
  return $a = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $a.apply(this, arguments);
}
function Zg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Zt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zg(Object(r), !0).forEach(function(n) {
      a8(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Zg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function a4(e, t) {
  if (e == null)
    return {};
  var r = Y3e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Y3e(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function k3e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Kg(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $x(n.key), n);
  }
}
function V3e(e, t, r) {
  return t && Kg(e.prototype, t), r && Kg(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function G3e(e, t, r) {
  return t = n0(t), W3e(e, Fx() ? Reflect.construct(t, r || [], n0(e).constructor) : t.apply(e, r));
}
function W3e(e, t) {
  if (t && (d2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Q3e(e);
}
function Q3e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Fx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Fx = function() {
    return !!e;
  })();
}
function n0(e) {
  return n0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, n0(e);
}
function U3e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && c7(e, t);
}
function c7(e, t) {
  return c7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, c7(e, t);
}
function a8(e, t, r) {
  return t = $x(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function $x(e) {
  var t = Z3e(e, "string");
  return d2(t) == "symbol" ? t : String(t);
}
function Z3e(e, t) {
  if (d2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (d2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var T2 = /* @__PURE__ */ function(e) {
  U3e(t, e);
  function t(r) {
    var n;
    return k3e(this, t), n = G3e(this, t, [r]), n.state = {
      fontSize: "",
      letterSpacing: ""
    }, n;
  }
  return V3e(t, [{
    key: "shouldComponentUpdate",
    value: function(n, a) {
      var i = n.viewBox, o = a4(n, F3e), s = this.props, c = s.viewBox, u = a4(s, $3e);
      return !Ha(i, c) || !Ha(o, u) || !Ha(a, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.layerReference;
      if (n) {
        var a = n.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        a && this.setState({
          fontSize: window.getComputedStyle(a).fontSize,
          letterSpacing: window.getComputedStyle(a).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(n) {
      var a = this.props, i = a.x, o = a.y, s = a.width, c = a.height, u = a.orientation, d = a.tickSize, h = a.mirror, A = a.tickMargin, p, v, g, m, b, w, x = h ? -1 : 1, y = n.tickSize || d, C = le(n.tickCoord) ? n.tickCoord : n.coordinate;
      switch (u) {
        case "top":
          p = v = n.coordinate, m = o + +!h * c, g = m - x * y, w = g - x * A, b = C;
          break;
        case "left":
          g = m = n.coordinate, v = i + +!h * s, p = v - x * y, b = p - x * A, w = C;
          break;
        case "right":
          g = m = n.coordinate, v = i + +h * s, p = v + x * y, b = p + x * A, w = C;
          break;
        default:
          p = v = n.coordinate, m = o + +h * c, g = m + x * y, w = g + x * A, b = C;
          break;
      }
      return {
        line: {
          x1: p,
          y1: g,
          x2: v,
          y2: m
        },
        tick: {
          x: b,
          y: w
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props, a = n.orientation, i = n.mirror, o;
      switch (a) {
        case "left":
          o = i ? "start" : "end";
          break;
        case "right":
          o = i ? "end" : "start";
          break;
        default:
          o = "middle";
          break;
      }
      return o;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var n = this.props, a = n.orientation, i = n.mirror, o = "end";
      switch (a) {
        case "left":
        case "right":
          o = "middle";
          break;
        case "top":
          o = i ? "start" : "end";
          break;
        default:
          o = i ? "end" : "start";
          break;
      }
      return o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, c = n.orientation, u = n.mirror, d = n.axisLine, h = Zt(Zt(Zt({}, pe(this.props, !1)), pe(d, !1)), {}, {
        fill: "none"
      });
      if (c === "top" || c === "bottom") {
        var A = +(c === "top" && !u || c === "bottom" && u);
        h = Zt(Zt({}, h), {}, {
          x1: a,
          y1: i + A * s,
          x2: a + o,
          y2: i + A * s
        });
      } else {
        var p = +(c === "left" && !u || c === "right" && u);
        h = Zt(Zt({}, h), {}, {
          x1: a + p * o,
          y1: i,
          x2: a + p * o,
          y2: i + s
        });
      }
      return /* @__PURE__ */ P.createElement("line", $a({}, h, {
        className: Pe("recharts-cartesian-axis-line", vr(d, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(n, a, i) {
        var o = this, s = this.props, c = s.tickLine, u = s.stroke, d = s.tick, h = s.tickFormatter, A = s.unit, p = n8(Zt(Zt({}, this.props), {}, {
          ticks: n
        }), a, i), v = this.getTickTextAnchor(), g = this.getTickVerticalAnchor(), m = pe(this.props, !1), b = pe(d, !1), w = Zt(Zt({}, m), {}, {
          fill: "none"
        }, pe(c, !1)), x = p.map(function(y, C) {
          var O = o.getTickLineCoord(y), M = O.line, E = O.tick, N = Zt(Zt(Zt(Zt({
            textAnchor: v,
            verticalAnchor: g
          }, m), {}, {
            stroke: "none",
            fill: u
          }, b), E), {}, {
            index: C,
            payload: y,
            visibleTicksCount: p.length,
            tickFormatter: h
          });
          return /* @__PURE__ */ P.createElement(je, $a({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(y.value, "-").concat(y.coordinate, "-").concat(y.tickCoord)
          }, s1(o.props, y, C)), c && /* @__PURE__ */ P.createElement("line", $a({}, w, M, {
            className: Pe("recharts-cartesian-axis-tick-line", vr(c, "className"))
          })), d && t.renderTickItem(d, N, "".concat(xe(h) ? h(y.value, C) : y.value).concat(A || "")));
        });
        return /* @__PURE__ */ P.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, x);
      }
    )
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.axisLine, o = a.width, s = a.height, c = a.ticksGenerator, u = a.className, d = a.hide;
      if (d)
        return null;
      var h = this.props, A = h.ticks, p = a4(h, H3e), v = A;
      return xe(c) && (v = A && A.length > 0 ? c(this.props) : c(p)), o <= 0 || s <= 0 || !v || !v.length ? null : /* @__PURE__ */ P.createElement(je, {
        className: Pe("recharts-cartesian-axis", u),
        ref: function(m) {
          n.layerReference = m;
        }
      }, i && this.renderAxisLine(), this.renderTicks(v, this.state.fontSize, this.state.letterSpacing), Ot.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ P.isValidElement(n) ? o = /* @__PURE__ */ P.cloneElement(n, a) : xe(n) ? o = n(a) : o = /* @__PURE__ */ P.createElement(J1, $a({}, a, {
        className: "recharts-cartesian-axis-tick-value"
      }), i), o;
    }
  }]), t;
}(Jm);
a8(T2, "displayName", "CartesianAxis");
a8(T2, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var K3e = ["x1", "y1", "x2", "y2", "key"], z3e = ["offset"];
function ta(e) {
  "@babel/helpers - typeof";
  return ta = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ta(e);
}
function zg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zg(Object(r), !0).forEach(function(n) {
      q3e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function q3e(e, t, r) {
  return t = X3e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function X3e(e) {
  var t = J3e(e, "string");
  return ta(t) == "symbol" ? t : String(t);
}
function J3e(e, t) {
  if (ta(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ta(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function U1() {
  return U1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, U1.apply(this, arguments);
}
function qg(e, t) {
  if (e == null)
    return {};
  var r = ese(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function ese(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var tse = function(t) {
  var r = t.fill;
  if (!r || r === "none")
    return null;
  var n = t.fillOpacity, a = t.x, i = t.y, o = t.width, s = t.height;
  return /* @__PURE__ */ P.createElement("rect", {
    x: a,
    y: i,
    width: o,
    height: s,
    stroke: "none",
    fill: r,
    fillOpacity: n,
    className: "recharts-cartesian-grid-bg"
  });
};
function Hx(e, t) {
  var r;
  if (/* @__PURE__ */ P.isValidElement(e))
    r = /* @__PURE__ */ P.cloneElement(e, t);
  else if (xe(e))
    r = e(t);
  else {
    var n = t.x1, a = t.y1, i = t.x2, o = t.y2, s = t.key, c = qg(t, K3e), u = pe(c, !1);
    u.offset;
    var d = qg(u, z3e);
    r = /* @__PURE__ */ P.createElement("line", U1({}, d, {
      x1: n,
      y1: a,
      x2: i,
      y2: o,
      fill: "none",
      key: s
    }));
  }
  return r;
}
function rse(e) {
  var t = e.x, r = e.width, n = e.horizontal, a = n === void 0 ? !0 : n, i = e.horizontalPoints;
  if (!a || !i || !i.length)
    return null;
  var o = i.map(function(s, c) {
    var u = Gt(Gt({}, e), {}, {
      x1: t,
      y1: s,
      x2: t + r,
      y2: s,
      key: "line-".concat(c),
      index: c
    });
    return Hx(a, u);
  });
  return /* @__PURE__ */ P.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, o);
}
function nse(e) {
  var t = e.y, r = e.height, n = e.vertical, a = n === void 0 ? !0 : n, i = e.verticalPoints;
  if (!a || !i || !i.length)
    return null;
  var o = i.map(function(s, c) {
    var u = Gt(Gt({}, e), {}, {
      x1: s,
      y1: t,
      x2: s,
      y2: t + r,
      key: "line-".concat(c),
      index: c
    });
    return Hx(a, u);
  });
  return /* @__PURE__ */ P.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, o);
}
function ase(e) {
  var t = e.horizontalFill, r = e.fillOpacity, n = e.x, a = e.y, i = e.width, o = e.height, s = e.horizontalPoints, c = e.horizontal, u = c === void 0 ? !0 : c;
  if (!u || !t || !t.length)
    return null;
  var d = s.map(function(A) {
    return Math.round(A + a - a);
  }).sort(function(A, p) {
    return A - p;
  });
  a !== d[0] && d.unshift(0);
  var h = d.map(function(A, p) {
    var v = !d[p + 1], g = v ? a + o - A : d[p + 1] - A;
    if (g <= 0)
      return null;
    var m = p % t.length;
    return /* @__PURE__ */ P.createElement("rect", {
      key: "react-".concat(p),
      y: A,
      x: n,
      height: g,
      width: i,
      stroke: "none",
      fill: t[m],
      fillOpacity: r,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ P.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, h);
}
function ise(e) {
  var t = e.vertical, r = t === void 0 ? !0 : t, n = e.verticalFill, a = e.fillOpacity, i = e.x, o = e.y, s = e.width, c = e.height, u = e.verticalPoints;
  if (!r || !n || !n.length)
    return null;
  var d = u.map(function(A) {
    return Math.round(A + i - i);
  }).sort(function(A, p) {
    return A - p;
  });
  i !== d[0] && d.unshift(0);
  var h = d.map(function(A, p) {
    var v = !d[p + 1], g = v ? i + s - A : d[p + 1] - A;
    if (g <= 0)
      return null;
    var m = p % n.length;
    return /* @__PURE__ */ P.createElement("rect", {
      key: "react-".concat(p),
      x: A,
      y: o,
      width: g,
      height: c,
      stroke: "none",
      fill: n[m],
      fillOpacity: a,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ P.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, h);
}
var ose = function(t, r) {
  var n = t.xAxis, a = t.width, i = t.height, o = t.offset;
  return Gw(n8(Gt(Gt(Gt({}, T2.defaultProps), n), {}, {
    ticks: yn(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: i
    }
  })), o.left, o.left + o.width, r);
}, sse = function(t, r) {
  var n = t.yAxis, a = t.width, i = t.height, o = t.offset;
  return Gw(n8(Gt(Gt(Gt({}, T2.defaultProps), n), {}, {
    ticks: yn(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: i
    }
  })), o.top, o.top + o.height, r);
}, Ma = {
  horizontal: !0,
  vertical: !0,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function K0(e) {
  var t, r, n, a, i, o, s = e8(), c = t8(), u = u3e(), d = Gt(Gt({}, e), {}, {
    stroke: (t = e.stroke) !== null && t !== void 0 ? t : Ma.stroke,
    fill: (r = e.fill) !== null && r !== void 0 ? r : Ma.fill,
    horizontal: (n = e.horizontal) !== null && n !== void 0 ? n : Ma.horizontal,
    horizontalFill: (a = e.horizontalFill) !== null && a !== void 0 ? a : Ma.horizontalFill,
    vertical: (i = e.vertical) !== null && i !== void 0 ? i : Ma.vertical,
    verticalFill: (o = e.verticalFill) !== null && o !== void 0 ? o : Ma.verticalFill,
    x: le(e.x) ? e.x : u.left,
    y: le(e.y) ? e.y : u.top,
    width: le(e.width) ? e.width : u.width,
    height: le(e.height) ? e.height : u.height
  }), h = d.x, A = d.y, p = d.width, v = d.height, g = d.syncWithTicks, m = d.horizontalValues, b = d.verticalValues, w = s3e(), x = l3e();
  if (!le(p) || p <= 0 || !le(v) || v <= 0 || !le(h) || h !== +h || !le(A) || A !== +A)
    return null;
  var y = d.verticalCoordinatesGenerator || ose, C = d.horizontalCoordinatesGenerator || sse, O = d.horizontalPoints, M = d.verticalPoints;
  if ((!O || !O.length) && xe(C)) {
    var E = m && m.length, N = C({
      yAxis: x ? Gt(Gt({}, x), {}, {
        ticks: E ? m : x.ticks
      }) : void 0,
      width: s,
      height: c,
      offset: u
    }, E ? !0 : g);
    Gr(Array.isArray(N), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(ta(N), "]")), Array.isArray(N) && (O = N);
  }
  if ((!M || !M.length) && xe(y)) {
    var F = b && b.length, k = y({
      xAxis: w ? Gt(Gt({}, w), {}, {
        ticks: F ? b : w.ticks
      }) : void 0,
      width: s,
      height: c,
      offset: u
    }, F ? !0 : g);
    Gr(Array.isArray(k), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(ta(k), "]")), Array.isArray(k) && (M = k);
  }
  return /* @__PURE__ */ P.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ P.createElement(tse, {
    fill: d.fill,
    fillOpacity: d.fillOpacity,
    x: d.x,
    y: d.y,
    width: d.width,
    height: d.height
  }), /* @__PURE__ */ P.createElement(rse, U1({}, d, {
    offset: u,
    horizontalPoints: O,
    xAxis: w,
    yAxis: x
  })), /* @__PURE__ */ P.createElement(nse, U1({}, d, {
    offset: u,
    verticalPoints: M,
    xAxis: w,
    yAxis: x
  })), /* @__PURE__ */ P.createElement(ase, U1({}, d, {
    horizontalPoints: O
  })), /* @__PURE__ */ P.createElement(ise, U1({}, d, {
    verticalPoints: M
  })));
}
K0.displayName = "CartesianGrid";
var lse = ["type", "layout", "connectNulls", "ref"];
function f2(e) {
  "@babel/helpers - typeof";
  return f2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, f2(e);
}
function cse(e, t) {
  if (e == null)
    return {};
  var r = use(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function use(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Gi() {
  return Gi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gi.apply(this, arguments);
}
function Xg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function cr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xg(Object(r), !0).forEach(function(n) {
      $r(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Xg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ea(e) {
  return Ase(e) || hse(e) || fse(e) || dse();
}
function dse() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fse(e, t) {
  if (e) {
    if (typeof e == "string")
      return u7(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return u7(e, t);
  }
}
function hse(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Ase(e) {
  if (Array.isArray(e))
    return u7(e);
}
function u7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function pse(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Jg(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, kx(n.key), n);
  }
}
function gse(e, t, r) {
  return t && Jg(e.prototype, t), r && Jg(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function vse(e, t, r) {
  return t = a0(t), mse(e, Yx() ? Reflect.construct(t, r || [], a0(e).constructor) : t.apply(e, r));
}
function mse(e, t) {
  if (t && (f2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Wn(e);
}
function Yx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Yx = function() {
    return !!e;
  })();
}
function a0(e) {
  return a0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, a0(e);
}
function Wn(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Cse(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && d7(e, t);
}
function d7(e, t) {
  return d7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, d7(e, t);
}
function $r(e, t, r) {
  return t = kx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kx(e) {
  var t = bse(e, "string");
  return f2(t) == "symbol" ? t : String(t);
}
function bse(e, t) {
  if (f2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (f2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var n3 = /* @__PURE__ */ function(e) {
  Cse(t, e);
  function t() {
    var r;
    pse(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = vse(this, t, [].concat(a)), $r(Wn(r), "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), $r(Wn(r), "generateSimpleStrokeDasharray", function(o, s) {
      return "".concat(s, "px ").concat(o - s, "px");
    }), $r(Wn(r), "getStrokeDasharray", function(o, s, c) {
      var u = c.reduce(function(b, w) {
        return b + w;
      });
      if (!u)
        return r.generateSimpleStrokeDasharray(s, o);
      for (var d = Math.floor(o / u), h = o % u, A = s - o, p = [], v = 0, g = 0; v < c.length; g += c[v], ++v)
        if (g + c[v] > h) {
          p = [].concat(Ea(c.slice(0, v)), [h - g]);
          break;
        }
      var m = p.length % 2 === 0 ? [0, A] : [A];
      return [].concat(Ea(t.repeat(c, d)), Ea(p), m).map(function(b) {
        return "".concat(b, "px");
      }).join(", ");
    }), $r(Wn(r), "id", p1("recharts-line-")), $r(Wn(r), "pathRef", function(o) {
      r.mainCurve = o;
    }), $r(Wn(r), "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      }), r.props.onAnimationEnd && r.props.onAnimationEnd();
    }), $r(Wn(r), "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      }), r.props.onAnimationStart && r.props.onAnimationStart();
    }), r;
  }
  return gse(t, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        n !== this.state.totalLength && this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var n = this.mainCurve;
      try {
        return n && n.getTotalLength && n.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(n, a) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.points, s = i.xAxis, c = i.yAxis, u = i.layout, d = i.children, h = er(d, N2);
      if (!h)
        return null;
      var A = function(g, m) {
        return {
          x: g.x,
          y: g.y,
          value: g.value,
          errorVal: pt(g.payload, m)
        };
      }, p = {
        clipPath: n ? "url(#clipPath-".concat(a, ")") : null
      };
      return /* @__PURE__ */ P.createElement(je, p, h.map(function(v) {
        return /* @__PURE__ */ P.cloneElement(v, {
          key: "bar-".concat(v.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: c,
          layout: u,
          dataPointFormatter: A
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(n, a, i) {
      var o = this.props.isAnimationActive;
      if (o && !this.state.isAnimationFinished)
        return null;
      var s = this.props, c = s.dot, u = s.points, d = s.dataKey, h = pe(this.props, !1), A = pe(c, !0), p = u.map(function(g, m) {
        var b = cr(cr(cr({
          key: "dot-".concat(m),
          r: 3
        }, h), A), {}, {
          value: g.value,
          dataKey: d,
          cx: g.x,
          cy: g.y,
          index: m,
          payload: g.payload
        });
        return t.renderDotItem(c, b);
      }), v = {
        clipPath: n ? "url(#clipPath-".concat(a ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ P.createElement(je, Gi({
        className: "recharts-line-dots",
        key: "dots"
      }, v), p);
    }
  }, {
    key: "renderCurveStatically",
    value: function(n, a, i, o) {
      var s = this.props, c = s.type, u = s.layout, d = s.connectNulls;
      s.ref;
      var h = cse(s, lse), A = cr(cr(cr({}, pe(h, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: a ? "url(#clipPath-".concat(i, ")") : null,
        points: n
      }, o), {}, {
        type: c,
        layout: u,
        connectNulls: d
      });
      return /* @__PURE__ */ P.createElement(a1, Gi({}, A, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(n, a) {
      var i = this, o = this.props, s = o.points, c = o.strokeDasharray, u = o.isAnimationActive, d = o.animationBegin, h = o.animationDuration, A = o.animationEasing, p = o.animationId, v = o.animateNewValues, g = o.width, m = o.height, b = this.state, w = b.prevPoints, x = b.totalLength;
      return /* @__PURE__ */ P.createElement(Lr, {
        begin: d,
        duration: h,
        isActive: u,
        easing: A,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(y) {
        var C = y.t;
        if (w) {
          var O = w.length / s.length, M = s.map(function(R, j) {
            var U = Math.floor(j * O);
            if (w[U]) {
              var ee = w[U], X = yt(ee.x, R.x), Z = yt(ee.y, R.y);
              return cr(cr({}, R), {}, {
                x: X(C),
                y: Z(C)
              });
            }
            if (v) {
              var te = yt(g * 2, R.x), B = yt(m / 2, R.y);
              return cr(cr({}, R), {}, {
                x: te(C),
                y: B(C)
              });
            }
            return cr(cr({}, R), {}, {
              x: R.x,
              y: R.y
            });
          });
          return i.renderCurveStatically(M, n, a);
        }
        var E = yt(0, x), N = E(C), F;
        if (c) {
          var k = "".concat(c).split(/[,\s]+/gim).map(function(R) {
            return parseFloat(R);
          });
          F = i.getStrokeDasharray(N, x, k);
        } else
          F = i.generateSimpleStrokeDasharray(x, N);
        return i.renderCurveStatically(s, n, a, {
          strokeDasharray: F
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(n, a) {
      var i = this.props, o = i.points, s = i.isAnimationActive, c = this.state, u = c.prevPoints, d = c.totalLength;
      return s && o && o.length && (!u && d > 0 || !c1(u, o)) ? this.renderCurveWithAnimation(n, a) : this.renderCurveStatically(o, n, a);
    }
  }, {
    key: "render",
    value: function() {
      var n, a = this.props, i = a.hide, o = a.dot, s = a.points, c = a.className, u = a.xAxis, d = a.yAxis, h = a.top, A = a.left, p = a.width, v = a.height, g = a.isAnimationActive, m = a.id;
      if (i || !s || !s.length)
        return null;
      var b = this.state.isAnimationFinished, w = s.length === 1, x = Pe("recharts-line", c), y = u && u.allowDataOverflow, C = d && d.allowDataOverflow, O = y || C, M = ye(m) ? this.id : m, E = (n = pe(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, N = E.r, F = N === void 0 ? 3 : N, k = E.strokeWidth, R = k === void 0 ? 2 : k, j = Fb(o) ? o : {}, U = j.clipDot, ee = U === void 0 ? !0 : U, X = F * 2 + R;
      return /* @__PURE__ */ P.createElement(je, {
        className: x
      }, y || C ? /* @__PURE__ */ P.createElement("defs", null, /* @__PURE__ */ P.createElement("clipPath", {
        id: "clipPath-".concat(M)
      }, /* @__PURE__ */ P.createElement("rect", {
        x: y ? A : A - p / 2,
        y: C ? h : h - v / 2,
        width: y ? p : p * 2,
        height: C ? v : v * 2
      })), !ee && /* @__PURE__ */ P.createElement("clipPath", {
        id: "clipPath-dots-".concat(M)
      }, /* @__PURE__ */ P.createElement("rect", {
        x: A - X / 2,
        y: h - X / 2,
        width: p + X,
        height: v + X
      }))) : null, !w && this.renderCurve(O, M), this.renderErrorBar(O, M), (w || o) && this.renderDots(O, ee, M), (!g || b) && Wr.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: a.curPoints
      } : n.points !== a.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(n, a) {
      for (var i = n.length % 2 !== 0 ? [].concat(Ea(n), [0]) : n, o = [], s = 0; s < a; ++s)
        o = [].concat(Ea(o), Ea(i));
      return o;
    }
  }, {
    key: "renderDotItem",
    value: function(n, a) {
      var i;
      if (/* @__PURE__ */ P.isValidElement(n))
        i = /* @__PURE__ */ P.cloneElement(n, a);
      else if (xe(n))
        i = n(a);
      else {
        var o = Pe("recharts-line-dot", typeof n != "boolean" ? n.className : "");
        i = /* @__PURE__ */ P.createElement(e3, Gi({}, a, {
          className: o
        }));
      }
      return i;
    }
  }]), t;
}(mr);
$r(n3, "displayName", "Line");
$r(n3, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !Ir.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
$r(n3, "getComposedData", function(e) {
  var t = e.props, r = e.xAxis, n = e.yAxis, a = e.xAxisTicks, i = e.yAxisTicks, o = e.dataKey, s = e.bandSize, c = e.displayedData, u = e.offset, d = t.layout, h = c.map(function(A, p) {
    var v = pt(A, o);
    return d === "horizontal" ? {
      x: r2({
        axis: r,
        ticks: a,
        bandSize: s,
        entry: A,
        index: p
      }),
      y: ye(v) ? null : n.scale(v),
      value: v,
      payload: A
    } : {
      x: ye(v) ? null : r.scale(v),
      y: r2({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: A,
        index: p
      }),
      value: v,
      payload: A
    };
  });
  return cr({
    points: h,
    layout: d
  }, u);
});
var yse = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], Vx;
function h2(e) {
  "@babel/helpers - typeof";
  return h2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, h2(e);
}
function wse(e, t) {
  if (e == null)
    return {};
  var r = xse(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function xse(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Z1() {
  return Z1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Z1.apply(this, arguments);
}
function ev(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Qn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ev(Object(r), !0).forEach(function(n) {
      ln(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ev(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Dse(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function tv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Wx(n.key), n);
  }
}
function Ose(e, t, r) {
  return t && tv(e.prototype, t), r && tv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Mse(e, t, r) {
  return t = i0(t), Ese(e, Gx() ? Reflect.construct(t, r || [], i0(e).constructor) : t.apply(e, r));
}
function Ese(e, t) {
  if (t && (h2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ni(e);
}
function Gx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Gx = function() {
    return !!e;
  })();
}
function i0(e) {
  return i0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, i0(e);
}
function Ni(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Sse(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && f7(e, t);
}
function f7(e, t) {
  return f7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, f7(e, t);
}
function ln(e, t, r) {
  return t = Wx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Wx(e) {
  var t = Pse(e, "string");
  return h2(t) == "symbol" ? t : String(t);
}
function Pse(e, t) {
  if (h2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (h2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var sa = /* @__PURE__ */ function(e) {
  Sse(t, e);
  function t() {
    var r;
    Dse(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = Mse(this, t, [].concat(a)), ln(Ni(r), "state", {
      isAnimationFinished: !0
    }), ln(Ni(r), "id", p1("recharts-area-")), ln(Ni(r), "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), xe(o) && o();
    }), ln(Ni(r), "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), xe(o) && o();
    }), r;
  }
  return Ose(t, [{
    key: "renderDots",
    value: function(n, a, i) {
      var o = this.props.isAnimationActive, s = this.state.isAnimationFinished;
      if (o && !s)
        return null;
      var c = this.props, u = c.dot, d = c.points, h = c.dataKey, A = pe(this.props, !1), p = pe(u, !0), v = d.map(function(m, b) {
        var w = Qn(Qn(Qn({
          key: "dot-".concat(b),
          r: 3
        }, A), p), {}, {
          index: b,
          cx: m.x,
          cy: m.y,
          dataKey: h,
          value: m.value,
          payload: m.payload,
          points: d
        });
        return t.renderDotItem(u, w);
      }), g = {
        clipPath: n ? "url(#clipPath-".concat(a ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ P.createElement(je, Z1({
        className: "recharts-area-dots"
      }, g), v);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(n) {
      var a = this.props, i = a.baseLine, o = a.points, s = a.strokeWidth, c = o[0].x, u = o[o.length - 1].x, d = n * Math.abs(c - u), h = zn(o.map(function(A) {
        return A.y || 0;
      }));
      return le(i) && typeof i == "number" ? h = Math.max(i, h) : i && Array.isArray(i) && i.length && (h = Math.max(zn(i.map(function(A) {
        return A.y || 0;
      })), h)), le(h) ? /* @__PURE__ */ P.createElement("rect", {
        x: c < u ? c : c - d,
        y: 0,
        width: d,
        height: Math.floor(h + (s ? parseInt("".concat(s), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(n) {
      var a = this.props, i = a.baseLine, o = a.points, s = a.strokeWidth, c = o[0].y, u = o[o.length - 1].y, d = n * Math.abs(c - u), h = zn(o.map(function(A) {
        return A.x || 0;
      }));
      return le(i) && typeof i == "number" ? h = Math.max(i, h) : i && Array.isArray(i) && i.length && (h = Math.max(zn(i.map(function(A) {
        return A.x || 0;
      })), h)), le(h) ? /* @__PURE__ */ P.createElement("rect", {
        x: 0,
        y: c < u ? c : c - d,
        width: h + (s ? parseInt("".concat(s), 10) : 1),
        height: Math.floor(d)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(n) {
      var a = this.props.layout;
      return a === "vertical" ? this.renderVerticalRect(n) : this.renderHorizontalRect(n);
    }
  }, {
    key: "renderAreaStatically",
    value: function(n, a, i, o) {
      var s = this.props, c = s.layout, u = s.type, d = s.stroke, h = s.connectNulls, A = s.isRange;
      s.ref;
      var p = wse(s, yse);
      return /* @__PURE__ */ P.createElement(je, {
        clipPath: i ? "url(#clipPath-".concat(o, ")") : null
      }, /* @__PURE__ */ P.createElement(a1, Z1({}, pe(p, !0), {
        points: n,
        connectNulls: h,
        type: u,
        baseLine: a,
        layout: c,
        stroke: "none",
        className: "recharts-area-area"
      })), d !== "none" && /* @__PURE__ */ P.createElement(a1, Z1({}, pe(this.props, !1), {
        className: "recharts-area-curve",
        layout: c,
        type: u,
        connectNulls: h,
        fill: "none",
        points: n
      })), d !== "none" && A && /* @__PURE__ */ P.createElement(a1, Z1({}, pe(this.props, !1), {
        className: "recharts-area-curve",
        layout: c,
        type: u,
        connectNulls: h,
        fill: "none",
        points: a
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(n, a) {
      var i = this, o = this.props, s = o.points, c = o.baseLine, u = o.isAnimationActive, d = o.animationBegin, h = o.animationDuration, A = o.animationEasing, p = o.animationId, v = this.state, g = v.prevPoints, m = v.prevBaseLine;
      return /* @__PURE__ */ P.createElement(Lr, {
        begin: d,
        duration: h,
        isActive: u,
        easing: A,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(b) {
        var w = b.t;
        if (g) {
          var x = g.length / s.length, y = s.map(function(E, N) {
            var F = Math.floor(N * x);
            if (g[F]) {
              var k = g[F], R = yt(k.x, E.x), j = yt(k.y, E.y);
              return Qn(Qn({}, E), {}, {
                x: R(w),
                y: j(w)
              });
            }
            return E;
          }), C;
          if (le(c) && typeof c == "number") {
            var O = yt(m, c);
            C = O(w);
          } else if (ye(c) || O2(c)) {
            var M = yt(m, 0);
            C = M(w);
          } else
            C = c.map(function(E, N) {
              var F = Math.floor(N * x);
              if (m[F]) {
                var k = m[F], R = yt(k.x, E.x), j = yt(k.y, E.y);
                return Qn(Qn({}, E), {}, {
                  x: R(w),
                  y: j(w)
                });
              }
              return E;
            });
          return i.renderAreaStatically(y, C, n, a);
        }
        return /* @__PURE__ */ P.createElement(je, null, /* @__PURE__ */ P.createElement("defs", null, /* @__PURE__ */ P.createElement("clipPath", {
          id: "animationClipPath-".concat(a)
        }, i.renderClipRect(w))), /* @__PURE__ */ P.createElement(je, {
          clipPath: "url(#animationClipPath-".concat(a, ")")
        }, i.renderAreaStatically(s, c, n, a)));
      });
    }
  }, {
    key: "renderArea",
    value: function(n, a) {
      var i = this.props, o = i.points, s = i.baseLine, c = i.isAnimationActive, u = this.state, d = u.prevPoints, h = u.prevBaseLine, A = u.totalLength;
      return c && o && o.length && (!d && A > 0 || !c1(d, o) || !c1(h, s)) ? this.renderAreaWithAnimation(n, a) : this.renderAreaStatically(o, s, n, a);
    }
  }, {
    key: "render",
    value: function() {
      var n, a = this.props, i = a.hide, o = a.dot, s = a.points, c = a.className, u = a.top, d = a.left, h = a.xAxis, A = a.yAxis, p = a.width, v = a.height, g = a.isAnimationActive, m = a.id;
      if (i || !s || !s.length)
        return null;
      var b = this.state.isAnimationFinished, w = s.length === 1, x = Pe("recharts-area", c), y = h && h.allowDataOverflow, C = A && A.allowDataOverflow, O = y || C, M = ye(m) ? this.id : m, E = (n = pe(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, N = E.r, F = N === void 0 ? 3 : N, k = E.strokeWidth, R = k === void 0 ? 2 : k, j = Fb(o) ? o : {}, U = j.clipDot, ee = U === void 0 ? !0 : U, X = F * 2 + R;
      return /* @__PURE__ */ P.createElement(je, {
        className: x
      }, y || C ? /* @__PURE__ */ P.createElement("defs", null, /* @__PURE__ */ P.createElement("clipPath", {
        id: "clipPath-".concat(M)
      }, /* @__PURE__ */ P.createElement("rect", {
        x: y ? d : d - p / 2,
        y: C ? u : u - v / 2,
        width: y ? p : p * 2,
        height: C ? v : v * 2
      })), !ee && /* @__PURE__ */ P.createElement("clipPath", {
        id: "clipPath-dots-".concat(M)
      }, /* @__PURE__ */ P.createElement("rect", {
        x: d - X / 2,
        y: u - X / 2,
        width: p + X,
        height: v + X
      }))) : null, w ? null : this.renderArea(O, M), (o || w) && this.renderDots(O, ee, M), (!g || b) && Wr.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        curBaseLine: n.baseLine,
        prevPoints: a.curPoints,
        prevBaseLine: a.curBaseLine
      } : n.points !== a.curPoints || n.baseLine !== a.curBaseLine ? {
        curPoints: n.points,
        curBaseLine: n.baseLine
      } : null;
    }
  }]), t;
}(mr);
Vx = sa;
ln(sa, "displayName", "Area");
ln(sa, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !Ir.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
ln(sa, "getBaseValue", function(e, t, r, n) {
  var a = e.layout, i = e.baseValue, o = t.props.baseValue, s = o ?? i;
  if (le(s) && typeof s == "number")
    return s;
  var c = a === "horizontal" ? n : r, u = c.scale.domain();
  if (c.type === "number") {
    var d = Math.max(u[0], u[1]), h = Math.min(u[0], u[1]);
    return s === "dataMin" ? h : s === "dataMax" || d < 0 ? d : Math.max(Math.min(u[0], u[1]), 0);
  }
  return s === "dataMin" ? u[0] : s === "dataMax" ? u[1] : u[0];
});
ln(sa, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.xAxis, a = e.yAxis, i = e.xAxisTicks, o = e.yAxisTicks, s = e.bandSize, c = e.dataKey, u = e.stackedData, d = e.dataStartIndex, h = e.displayedData, A = e.offset, p = t.layout, v = u && u.length, g = Vx.getBaseValue(t, r, n, a), m = p === "horizontal", b = !1, w = h.map(function(y, C) {
    var O;
    v ? O = u[d + C] : (O = pt(y, c), Array.isArray(O) ? b = !0 : O = [g, O]);
    var M = O[1] == null || v && pt(y, c) == null;
    return m ? {
      x: r2({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: y,
        index: C
      }),
      y: M ? null : a.scale(O[1]),
      value: O,
      payload: y
    } : {
      x: M ? null : n.scale(O[1]),
      y: r2({
        axis: a,
        ticks: o,
        bandSize: s,
        entry: y,
        index: C
      }),
      value: O,
      payload: y
    };
  }), x;
  return v || b ? x = w.map(function(y) {
    var C = Array.isArray(y.value) ? y.value[0] : null;
    return m ? {
      x: y.x,
      y: C != null && y.y != null ? a.scale(C) : null
    } : {
      x: C != null ? n.scale(C) : null,
      y: y.y
    };
  }) : x = m ? a.scale(g) : n.scale(g), Qn({
    points: w,
    baseLine: x,
    layout: p,
    isRange: b
  }, A);
});
ln(sa, "renderDotItem", function(e, t) {
  var r;
  if (/* @__PURE__ */ P.isValidElement(e))
    r = /* @__PURE__ */ P.cloneElement(e, t);
  else if (xe(e))
    r = e(t);
  else {
    var n = Pe("recharts-area-dot", typeof e != "boolean" ? e.className : "");
    r = /* @__PURE__ */ P.createElement(e3, Z1({}, t, {
      className: n
    }));
  }
  return r;
});
var z0 = function() {
  return null;
};
z0.displayName = "ZAxis";
z0.defaultProps = {
  zAxisId: 0,
  range: [64, 64],
  scale: "auto",
  type: "number"
};
var jse = ["option", "isActive"];
function Wi() {
  return Wi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wi.apply(this, arguments);
}
function Ise(e, t) {
  if (e == null)
    return {};
  var r = Bse(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Bse(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Nse(e) {
  var t = e.option, r = e.isActive, n = Ise(e, jse);
  return typeof t == "string" ? /* @__PURE__ */ P.createElement(Zs, Wi({
    option: /* @__PURE__ */ P.createElement(S0, Wi({
      type: t
    }, n)),
    isActive: r,
    shapeType: "symbols"
  }, n)) : /* @__PURE__ */ P.createElement(Zs, Wi({
    option: t,
    isActive: r,
    shapeType: "symbols"
  }, n));
}
function A2(e) {
  "@babel/helpers - typeof";
  return A2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, A2(e);
}
function Qi() {
  return Qi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qi.apply(this, arguments);
}
function rv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Dr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rv(Object(r), !0).forEach(function(n) {
      Xn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : rv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Lse(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function nv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ux(n.key), n);
  }
}
function Tse(e, t, r) {
  return t && nv(e.prototype, t), r && nv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _se(e, t, r) {
  return t = o0(t), Rse(e, Qx() ? Reflect.construct(t, r || [], o0(e).constructor) : t.apply(e, r));
}
function Rse(e, t) {
  if (t && (A2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Li(e);
}
function Qx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Qx = function() {
    return !!e;
  })();
}
function o0(e) {
  return o0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, o0(e);
}
function Li(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Fse(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && h7(e, t);
}
function h7(e, t) {
  return h7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, h7(e, t);
}
function Xn(e, t, r) {
  return t = Ux(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ux(e) {
  var t = $se(e, "string");
  return A2(t) == "symbol" ? t : String(t);
}
function $se(e, t) {
  if (A2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (A2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var q0 = /* @__PURE__ */ function(e) {
  Fse(t, e);
  function t() {
    var r;
    Lse(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = _se(this, t, [].concat(a)), Xn(Li(r), "state", {
      isAnimationFinished: !1
    }), Xn(Li(r), "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      });
    }), Xn(Li(r), "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      });
    }), Xn(Li(r), "id", p1("recharts-scatter-")), r;
  }
  return Tse(t, [{
    key: "renderSymbolsStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.shape, s = i.activeShape, c = i.activeIndex, u = pe(this.props, !1);
      return n.map(function(d, h) {
        var A = c === h, p = A ? s : o, v = Dr(Dr({
          key: "symbol-".concat(h)
        }, u), d);
        return /* @__PURE__ */ P.createElement(je, Qi({
          className: "recharts-scatter-symbol"
        }, s1(a.props, d, h), {
          // eslint-disable-next-line react/no-array-index-key
          key: "symbol-".concat(d == null ? void 0 : d.cx, "-").concat(d == null ? void 0 : d.cy, "-").concat(d == null ? void 0 : d.size, "-").concat(h),
          role: "img"
        }), /* @__PURE__ */ P.createElement(Nse, Qi({
          option: p,
          isActive: A
        }, v)));
      });
    }
  }, {
    key: "renderSymbolsWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.points, o = a.isAnimationActive, s = a.animationBegin, c = a.animationDuration, u = a.animationEasing, d = a.animationId, h = this.state.prevPoints;
      return /* @__PURE__ */ P.createElement(Lr, {
        begin: s,
        duration: c,
        isActive: o,
        easing: u,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(d),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(A) {
        var p = A.t, v = i.map(function(g, m) {
          var b = h && h[m];
          if (b) {
            var w = yt(b.cx, g.cx), x = yt(b.cy, g.cy), y = yt(b.size, g.size);
            return Dr(Dr({}, g), {}, {
              cx: w(p),
              cy: x(p),
              size: y(p)
            });
          }
          var C = yt(0, g.size);
          return Dr(Dr({}, g), {}, {
            size: C(p)
          });
        });
        return /* @__PURE__ */ P.createElement(je, null, n.renderSymbolsStatically(v));
      });
    }
  }, {
    key: "renderSymbols",
    value: function() {
      var n = this.props, a = n.points, i = n.isAnimationActive, o = this.state.prevPoints;
      return i && a && a.length && (!o || !c1(o, a)) ? this.renderSymbolsWithAnimation() : this.renderSymbolsStatically(a);
    }
  }, {
    key: "renderErrorBar",
    value: function() {
      var n = this.props.isAnimationActive;
      if (n && !this.state.isAnimationFinished)
        return null;
      var a = this.props, i = a.points, o = a.xAxis, s = a.yAxis, c = a.children, u = er(c, N2);
      return u ? u.map(function(d, h) {
        var A = d.props, p = A.direction, v = A.dataKey;
        return /* @__PURE__ */ P.cloneElement(d, {
          key: "".concat(p, "-").concat(v, "-").concat(i[h]),
          data: i,
          xAxis: o,
          yAxis: s,
          layout: p === "x" ? "vertical" : "horizontal",
          dataPointFormatter: function(m, b) {
            return {
              x: m.cx,
              y: m.cy,
              value: p === "x" ? +m.node.x : +m.node.y,
              errorVal: pt(m, b)
            };
          }
        });
      }) : null;
    }
  }, {
    key: "renderLine",
    value: function() {
      var n = this.props, a = n.points, i = n.line, o = n.lineType, s = n.lineJointType, c = pe(this.props, !1), u = pe(i, !1), d, h;
      if (o === "joint")
        d = a.map(function(x) {
          return {
            x: x.cx,
            y: x.cy
          };
        });
      else if (o === "fitting") {
        var A = SY(a), p = A.xmin, v = A.xmax, g = A.a, m = A.b, b = function(y) {
          return g * y + m;
        };
        d = [{
          x: p,
          y: b(p)
        }, {
          x: v,
          y: b(v)
        }];
      }
      var w = Dr(Dr(Dr({}, c), {}, {
        fill: "none",
        stroke: c && c.fill
      }, u), {}, {
        points: d
      });
      return /* @__PURE__ */ P.isValidElement(i) ? h = /* @__PURE__ */ P.cloneElement(i, w) : xe(i) ? h = i(w) : h = /* @__PURE__ */ P.createElement(a1, Qi({}, w, {
        type: s
      })), /* @__PURE__ */ P.createElement(je, {
        className: "recharts-scatter-line",
        key: "recharts-scatter-line"
      }, h);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.hide, i = n.points, o = n.line, s = n.className, c = n.xAxis, u = n.yAxis, d = n.left, h = n.top, A = n.width, p = n.height, v = n.id, g = n.isAnimationActive;
      if (a || !i || !i.length)
        return null;
      var m = this.state.isAnimationFinished, b = Pe("recharts-scatter", s), w = c && c.allowDataOverflow, x = u && u.allowDataOverflow, y = w || x, C = ye(v) ? this.id : v;
      return /* @__PURE__ */ P.createElement(je, {
        className: b,
        clipPath: y ? "url(#clipPath-".concat(C, ")") : null
      }, w || x ? /* @__PURE__ */ P.createElement("defs", null, /* @__PURE__ */ P.createElement("clipPath", {
        id: "clipPath-".concat(C)
      }, /* @__PURE__ */ P.createElement("rect", {
        x: w ? d : d - A / 2,
        y: x ? h : h - p / 2,
        width: w ? A : A * 2,
        height: x ? p : p * 2
      }))) : null, o && this.renderLine(), this.renderErrorBar(), /* @__PURE__ */ P.createElement(je, {
        key: "recharts-scatter-symbols"
      }, this.renderSymbols()), (!g || m) && Wr.renderCallByParent(this.props, i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: a.curPoints
      } : n.points !== a.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }]), t;
}(mr);
Xn(q0, "displayName", "Scatter");
Xn(q0, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: "circle",
  lineType: "joint",
  lineJointType: "linear",
  data: [],
  shape: "circle",
  hide: !1,
  isAnimationActive: !Ir.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "linear"
});
Xn(q0, "getComposedData", function(e) {
  var t = e.xAxis, r = e.yAxis, n = e.zAxis, a = e.item, i = e.displayedData, o = e.xAxisTicks, s = e.yAxisTicks, c = e.offset, u = a.props.tooltipType, d = er(a.props.children, Br), h = ye(t.dataKey) ? a.props.dataKey : t.dataKey, A = ye(r.dataKey) ? a.props.dataKey : r.dataKey, p = n && n.dataKey, v = n ? n.range : z0.defaultProps.range, g = v && v[0], m = t.scale.bandwidth ? t.scale.bandwidth() : 0, b = r.scale.bandwidth ? r.scale.bandwidth() : 0, w = i.map(function(x, y) {
    var C = pt(x, h), O = pt(x, A), M = !ye(p) && pt(x, p) || "-", E = [{
      name: ye(t.dataKey) ? a.props.name : t.name || t.dataKey,
      unit: t.unit || "",
      value: C,
      payload: x,
      dataKey: h,
      type: u
    }, {
      name: ye(r.dataKey) ? a.props.name : r.name || r.dataKey,
      unit: r.unit || "",
      value: O,
      payload: x,
      dataKey: A,
      type: u
    }];
    M !== "-" && E.push({
      name: n.name || n.dataKey,
      unit: n.unit || "",
      value: M,
      payload: x,
      dataKey: p,
      type: u
    });
    var N = r2({
      axis: t,
      ticks: o,
      bandSize: m,
      entry: x,
      index: y,
      dataKey: h
    }), F = r2({
      axis: r,
      ticks: s,
      bandSize: b,
      entry: x,
      index: y,
      dataKey: A
    }), k = M !== "-" ? n.scale(M) : g, R = Math.sqrt(Math.max(k, 0) / Math.PI);
    return Dr(Dr({}, x), {}, {
      cx: N,
      cy: F,
      x: N - R,
      y: F - R,
      xAxis: t,
      yAxis: r,
      zAxis: n,
      width: 2 * R,
      height: 2 * R,
      size: k,
      node: {
        x: C,
        y: O,
        z: M
      },
      tooltipPayload: E,
      tooltipPosition: {
        x: N,
        y: F
      },
      payload: x
    }, d && d[y] && d[y].props);
  });
  return Dr({
    points: w
  }, c);
});
function A7() {
  return A7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, A7.apply(this, arguments);
}
var u1 = function(t) {
  var r = t.xAxisId, n = e8(), a = t8(), i = Tx(r);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ P.createElement(T2, A7({}, i, {
      className: Pe("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: a
      },
      ticksGenerator: function(s) {
        return yn(s, !0);
      }
    }))
  );
};
u1.displayName = "XAxis";
u1.defaultProps = {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
};
function p7() {
  return p7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, p7.apply(this, arguments);
}
var la = function(t) {
  var r = t.yAxisId, n = e8(), a = t8(), i = _x(r);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ P.createElement(T2, p7({}, i, {
      className: Pe("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: a
      },
      ticksGenerator: function(s) {
        return yn(s, !0);
      }
    }))
  );
};
la.displayName = "YAxis";
la.defaultProps = {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
};
function av(e) {
  return Vse(e) || kse(e) || Yse(e) || Hse();
}
function Hse() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Yse(e, t) {
  if (e) {
    if (typeof e == "string")
      return g7(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return g7(e, t);
  }
}
function kse(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Vse(e) {
  if (Array.isArray(e))
    return g7(e);
}
function g7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var v7 = function(t, r, n, a, i) {
  var o = er(t, r8), s = er(t, t3), c = [].concat(av(o), av(s)), u = er(t, r3), d = "".concat(a, "Id"), h = a[0], A = r;
  if (c.length && (A = c.reduce(function(g, m) {
    if (m.props[d] === n && un(m.props, "extendDomain") && le(m.props[h])) {
      var b = m.props[h];
      return [Math.min(g[0], b), Math.max(g[1], b)];
    }
    return g;
  }, A)), u.length) {
    var p = "".concat(h, "1"), v = "".concat(h, "2");
    A = u.reduce(function(g, m) {
      if (m.props[d] === n && un(m.props, "extendDomain") && le(m.props[p]) && le(m.props[v])) {
        var b = m.props[p], w = m.props[v];
        return [Math.min(g[0], b, w), Math.max(g[1], b, w)];
      }
      return g;
    }, A);
  }
  return i && i.length && (A = i.reduce(function(g, m) {
    return le(m) ? [Math.min(g[0], m), Math.max(g[1], m)] : g;
  }, A)), A;
}, Zx = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, r = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
  function a(c, u, d) {
    this.fn = c, this.context = u, this.once = d || !1;
  }
  function i(c, u, d, h, A) {
    if (typeof d != "function")
      throw new TypeError("The listener must be a function");
    var p = new a(d, h || c, A), v = r ? r + u : u;
    return c._events[v] ? c._events[v].fn ? c._events[v] = [c._events[v], p] : c._events[v].push(p) : (c._events[v] = p, c._eventsCount++), c;
  }
  function o(c, u) {
    --c._eventsCount === 0 ? c._events = new n() : delete c._events[u];
  }
  function s() {
    this._events = new n(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function() {
    var u = [], d, h;
    if (this._eventsCount === 0)
      return u;
    for (h in d = this._events)
      t.call(d, h) && u.push(r ? h.slice(1) : h);
    return Object.getOwnPropertySymbols ? u.concat(Object.getOwnPropertySymbols(d)) : u;
  }, s.prototype.listeners = function(u) {
    var d = r ? r + u : u, h = this._events[d];
    if (!h)
      return [];
    if (h.fn)
      return [h.fn];
    for (var A = 0, p = h.length, v = new Array(p); A < p; A++)
      v[A] = h[A].fn;
    return v;
  }, s.prototype.listenerCount = function(u) {
    var d = r ? r + u : u, h = this._events[d];
    return h ? h.fn ? 1 : h.length : 0;
  }, s.prototype.emit = function(u, d, h, A, p, v) {
    var g = r ? r + u : u;
    if (!this._events[g])
      return !1;
    var m = this._events[g], b = arguments.length, w, x;
    if (m.fn) {
      switch (m.once && this.removeListener(u, m.fn, void 0, !0), b) {
        case 1:
          return m.fn.call(m.context), !0;
        case 2:
          return m.fn.call(m.context, d), !0;
        case 3:
          return m.fn.call(m.context, d, h), !0;
        case 4:
          return m.fn.call(m.context, d, h, A), !0;
        case 5:
          return m.fn.call(m.context, d, h, A, p), !0;
        case 6:
          return m.fn.call(m.context, d, h, A, p, v), !0;
      }
      for (x = 1, w = new Array(b - 1); x < b; x++)
        w[x - 1] = arguments[x];
      m.fn.apply(m.context, w);
    } else {
      var y = m.length, C;
      for (x = 0; x < y; x++)
        switch (m[x].once && this.removeListener(u, m[x].fn, void 0, !0), b) {
          case 1:
            m[x].fn.call(m[x].context);
            break;
          case 2:
            m[x].fn.call(m[x].context, d);
            break;
          case 3:
            m[x].fn.call(m[x].context, d, h);
            break;
          case 4:
            m[x].fn.call(m[x].context, d, h, A);
            break;
          default:
            if (!w)
              for (C = 1, w = new Array(b - 1); C < b; C++)
                w[C - 1] = arguments[C];
            m[x].fn.apply(m[x].context, w);
        }
    }
    return !0;
  }, s.prototype.on = function(u, d, h) {
    return i(this, u, d, h, !1);
  }, s.prototype.once = function(u, d, h) {
    return i(this, u, d, h, !0);
  }, s.prototype.removeListener = function(u, d, h, A) {
    var p = r ? r + u : u;
    if (!this._events[p])
      return this;
    if (!d)
      return o(this, p), this;
    var v = this._events[p];
    if (v.fn)
      v.fn === d && (!A || v.once) && (!h || v.context === h) && o(this, p);
    else {
      for (var g = 0, m = [], b = v.length; g < b; g++)
        (v[g].fn !== d || A && !v[g].once || h && v[g].context !== h) && m.push(v[g]);
      m.length ? this._events[p] = m.length === 1 ? m[0] : m : o(this, p);
    }
    return this;
  }, s.prototype.removeAllListeners = function(u) {
    var d;
    return u ? (d = r ? r + u : u, this._events[d] && o(this, d)) : (this._events = new n(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = r, s.EventEmitter = s, e.exports = s;
})(Zx);
var Gse = Zx.exports;
const Wse = /* @__PURE__ */ Xe(Gse);
var i4 = new Wse(), o4 = "recharts.syncMouseEvents";
function Fo(e) {
  "@babel/helpers - typeof";
  return Fo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fo(e);
}
function Qse(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function iv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Kx(n.key), n);
  }
}
function Use(e, t, r) {
  return t && iv(e.prototype, t), r && iv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function s4(e, t, r) {
  return t = Kx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Kx(e) {
  var t = Zse(e, "string");
  return Fo(t) == "symbol" ? t : String(t);
}
function Zse(e, t) {
  if (Fo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Fo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Kse = /* @__PURE__ */ function() {
  function e() {
    Qse(this, e), s4(this, "activeIndex", 0), s4(this, "coordinateList", []), s4(this, "layout", "horizontal");
  }
  return Use(e, [{
    key: "setDetails",
    value: function(r) {
      var n, a = r.coordinateList, i = a === void 0 ? null : a, o = r.container, s = o === void 0 ? null : o, c = r.layout, u = c === void 0 ? null : c, d = r.offset, h = d === void 0 ? null : d, A = r.mouseHandlerCallback, p = A === void 0 ? null : A;
      this.coordinateList = (n = i ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = s ?? this.container, this.layout = u ?? this.layout, this.offset = h ?? this.offset, this.mouseHandlerCallback = p ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(r) {
      if (this.coordinateList.length !== 0)
        switch (r.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(r) {
      this.activeIndex = r;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var r, n;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var a = this.container.getBoundingClientRect(), i = a.x, o = a.y, s = a.height, c = this.coordinateList[this.activeIndex].coordinate, u = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, d = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, h = i + c + u, A = o + this.offset.top + s / 2 + d;
        this.mouseHandlerCallback({
          pageX: h,
          pageY: A
        });
      }
    }
  }]), e;
}();
function zse(e, t, r) {
  if (r === "number" && t === !0 && Array.isArray(e)) {
    var n = e == null ? void 0 : e[0], a = e == null ? void 0 : e[1];
    if (n && a && le(n) && le(a))
      return !0;
  }
  return !1;
}
function qse(e, t, r, n) {
  var a = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - a : r.left + 0.5,
    y: e === "horizontal" ? r.top + 0.5 : t.y - a,
    width: e === "horizontal" ? n : r.width - 1,
    height: e === "horizontal" ? r.height - 1 : n
  };
}
function zx(e) {
  var t = e.cx, r = e.cy, n = e.radius, a = e.startAngle, i = e.endAngle, o = ct(t, r, n, a), s = ct(t, r, n, i);
  return {
    points: [o, s],
    cx: t,
    cy: r,
    radius: n,
    startAngle: a,
    endAngle: i
  };
}
function Xse(e, t, r) {
  var n, a, i, o;
  if (e === "horizontal")
    n = t.x, i = n, a = r.top, o = r.top + r.height;
  else if (e === "vertical")
    a = t.y, o = a, n = r.left, i = r.left + r.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var s = t.cx, c = t.cy, u = t.innerRadius, d = t.outerRadius, h = t.angle, A = ct(s, c, u, h), p = ct(s, c, d, h);
      n = A.x, a = A.y, i = p.x, o = p.y;
    } else
      return zx(t);
  return [{
    x: n,
    y: a
  }, {
    x: i,
    y: o
  }];
}
function $o(e) {
  "@babel/helpers - typeof";
  return $o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $o(e);
}
function ov(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function R3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ov(Object(r), !0).forEach(function(n) {
      Jse(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ov(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Jse(e, t, r) {
  return t = e0e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function e0e(e) {
  var t = t0e(e, "string");
  return $o(t) == "symbol" ? t : String(t);
}
function t0e(e, t) {
  if ($o(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if ($o(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function r0e(e) {
  var t = e.element, r = e.tooltipEventType, n = e.isActive, a = e.activeCoordinate, i = e.activePayload, o = e.offset, s = e.activeTooltipIndex, c = e.tooltipAxisBandSize, u = e.layout, d = e.chartName;
  if (!t || !t.props.cursor || !n || !a || d !== "ScatterChart" && r !== "axis")
    return null;
  var h, A = a1;
  if (d === "ScatterChart")
    h = a, A = Hae;
  else if (d === "BarChart")
    h = qse(u, a, o, c), A = z9;
  else if (u === "radial") {
    var p = zx(a), v = p.cx, g = p.cy, m = p.radius, b = p.startAngle, w = p.endAngle;
    h = {
      cx: v,
      cy: g,
      startAngle: b,
      endAngle: w,
      innerRadius: m,
      outerRadius: m
    }, A = tx;
  } else
    h = {
      points: Xse(u, a, o)
    }, A = a1;
  var x = R3(R3(R3(R3({
    stroke: "#ccc",
    pointerEvents: "none"
  }, o), h), pe(t.props.cursor, !1)), {}, {
    payload: i,
    payloadIndex: s,
    className: Pe("recharts-tooltip-cursor", t.props.cursor.className)
  });
  return /* @__PURE__ */ kr(t.props.cursor) ? /* @__PURE__ */ Pt(t.props.cursor, x) : /* @__PURE__ */ Xm(A, x);
}
var n0e = ["item"], a0e = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function p2(e) {
  "@babel/helpers - typeof";
  return p2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, p2(e);
}
function Ui() {
  return Ui = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ui.apply(this, arguments);
}
function sv(e, t) {
  return s0e(e) || o0e(e, t) || Xx(e, t) || i0e();
}
function i0e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function o0e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function s0e(e) {
  if (Array.isArray(e))
    return e;
}
function lv(e, t) {
  if (e == null)
    return {};
  var r = l0e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function l0e(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function c0e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function cv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Jx(n.key), n);
  }
}
function u0e(e, t, r) {
  return t && cv(e.prototype, t), r && cv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function d0e(e, t, r) {
  return t = s0(t), f0e(e, qx() ? Reflect.construct(t, r || [], s0(e).constructor) : t.apply(e, r));
}
function f0e(e, t) {
  if (t && (p2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Fe(e);
}
function qx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (qx = function() {
    return !!e;
  })();
}
function s0(e) {
  return s0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, s0(e);
}
function Fe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function h0e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && m7(e, t);
}
function m7(e, t) {
  return m7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, m7(e, t);
}
function g2(e) {
  return g0e(e) || p0e(e) || Xx(e) || A0e();
}
function A0e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xx(e, t) {
  if (e) {
    if (typeof e == "string")
      return C7(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return C7(e, t);
  }
}
function p0e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function g0e(e) {
  if (Array.isArray(e))
    return C7(e);
}
function C7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function uv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ie(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? uv(Object(r), !0).forEach(function(n) {
      Oe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : uv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Oe(e, t, r) {
  return t = Jx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Jx(e) {
  var t = v0e(e, "string");
  return p2(t) == "symbol" ? t : String(t);
}
function v0e(e, t) {
  if (p2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (p2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var m0e = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, C0e = {
  width: "100%",
  height: "100%"
}, eD = {
  x: 0,
  y: 0
};
function F3(e) {
  return e;
}
var b0e = function(t, r) {
  return r === "horizontal" ? t.x : r === "vertical" ? t.y : r === "centric" ? t.angle : t.radius;
}, y0e = function(t, r, n, a) {
  var i = r.find(function(d) {
    return d && d.index === n;
  });
  if (i) {
    if (t === "horizontal")
      return {
        x: i.coordinate,
        y: a.y
      };
    if (t === "vertical")
      return {
        x: a.x,
        y: i.coordinate
      };
    if (t === "centric") {
      var o = i.coordinate, s = a.radius;
      return ie(ie(ie({}, a), ct(a.cx, a.cy, s, o)), {}, {
        angle: o,
        radius: s
      });
    }
    var c = i.coordinate, u = a.angle;
    return ie(ie(ie({}, a), ct(a.cx, a.cy, c, u)), {}, {
      angle: u,
      radius: c
    });
  }
  return eD;
}, X0 = function(t, r) {
  var n = r.graphicalItems, a = r.dataStartIndex, i = r.dataEndIndex, o = (n ?? []).reduce(function(s, c) {
    var u = c.props.data;
    return u && u.length ? [].concat(g2(s), g2(u)) : s;
  }, []);
  return o.length > 0 ? o : t && t.length && le(a) && le(i) ? t.slice(a, i + 1) : [];
};
function tD(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var b7 = function(t, r, n, a) {
  var i = t.graphicalItems, o = t.tooltipAxis, s = X0(r, t);
  return n < 0 || !i || !i.length || n >= s.length ? null : i.reduce(function(c, u) {
    var d, h = (d = u.props.data) !== null && d !== void 0 ? d : r;
    h && t.dataStartIndex + t.dataEndIndex !== 0 && (h = h.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var A;
    if (o.dataKey && !o.allowDuplicatedCategory) {
      var p = h === void 0 ? s : h;
      A = cs(p, o.dataKey, a);
    } else
      A = h && h[n] || s[n];
    return A ? [].concat(g2(c), [Kw(u, A)]) : c;
  }, []);
}, dv = function(t, r, n, a) {
  var i = a || {
    x: t.chartX,
    y: t.chartY
  }, o = b0e(i, n), s = t.orderedTooltipTicks, c = t.tooltipAxis, u = t.tooltipTicks, d = Ore(o, s, u, c);
  if (d >= 0 && u) {
    var h = u[d] && u[d].value, A = b7(t, r, d, h), p = y0e(n, s, d, i);
    return {
      activeTooltipIndex: d,
      activeLabel: h,
      activePayload: A,
      activeCoordinate: p
    };
  }
  return null;
}, w0e = function(t, r) {
  var n = r.axes, a = r.graphicalItems, i = r.axisType, o = r.axisIdKey, s = r.stackGroups, c = r.dataStartIndex, u = r.dataEndIndex, d = t.layout, h = t.children, A = t.stackOffset, p = Vw(d, i);
  return n.reduce(function(v, g) {
    var m, b = g.props, w = b.type, x = b.dataKey, y = b.allowDataOverflow, C = b.allowDuplicatedCategory, O = b.scale, M = b.ticks, E = b.includeHidden, N = g.props[o];
    if (v[N])
      return v;
    var F = X0(t.data, {
      graphicalItems: a.filter(function(L) {
        return L.props[o] === N;
      }),
      dataStartIndex: c,
      dataEndIndex: u
    }), k = F.length, R, j, U;
    zse(g.props.domain, y, w) && (R = R5(g.props.domain, null, y), p && (w === "number" || O !== "auto") && (U = Hi(F, x, "category")));
    var ee = tD(w);
    if (!R || R.length === 0) {
      var X, Z = (X = g.props.domain) !== null && X !== void 0 ? X : ee;
      if (x) {
        if (R = Hi(F, x, w), w === "category" && p) {
          var te = EY(R);
          C && te ? (j = R, R = zs(0, k)) : C || (R = Ep(Z, R, g).reduce(function(L, D) {
            return L.indexOf(D) >= 0 ? L : [].concat(g2(L), [D]);
          }, []));
        } else if (w === "category")
          C ? R = R.filter(function(L) {
            return L !== "" && !ye(L);
          }) : R = Ep(Z, R, g).reduce(function(L, D) {
            return L.indexOf(D) >= 0 || D === "" || ye(D) ? L : [].concat(g2(L), [D]);
          }, []);
        else if (w === "number") {
          var B = jre(F, a.filter(function(L) {
            return L.props[o] === N && (E || !L.props.hide);
          }), x, i, d);
          B && (R = B);
        }
        p && (w === "number" || O !== "auto") && (U = Hi(F, x, "category"));
      } else
        p ? R = zs(0, k) : s && s[N] && s[N].hasStack && w === "number" ? R = A === "expand" ? [0, 1] : Zw(s[N].stackGroups, c, u) : R = kw(F, a.filter(function(L) {
          return L.props[o] === N && (E || !L.props.hide);
        }), w, d, !0);
      if (w === "number")
        R = v7(h, R, N, i, M), Z && (R = R5(Z, R, y));
      else if (w === "category" && Z) {
        var I = Z, _ = R.every(function(L) {
          return I.indexOf(L) >= 0;
        });
        _ && (R = I);
      }
    }
    return ie(ie({}, v), {}, Oe({}, N, ie(ie({}, g.props), {}, {
      axisType: i,
      domain: R,
      categoricalDomain: U,
      duplicateDomain: j,
      originalDomain: (m = g.props.domain) !== null && m !== void 0 ? m : ee,
      isCategorical: p,
      layout: d
    })));
  }, {});
}, x0e = function(t, r) {
  var n = r.graphicalItems, a = r.Axis, i = r.axisType, o = r.axisIdKey, s = r.stackGroups, c = r.dataStartIndex, u = r.dataEndIndex, d = t.layout, h = t.children, A = X0(t.data, {
    graphicalItems: n,
    dataStartIndex: c,
    dataEndIndex: u
  }), p = A.length, v = Vw(d, i), g = -1;
  return n.reduce(function(m, b) {
    var w = b.props[o], x = tD("number");
    if (!m[w]) {
      g++;
      var y;
      return v ? y = zs(0, p) : s && s[w] && s[w].hasStack ? (y = Zw(s[w].stackGroups, c, u), y = v7(h, y, w, i)) : (y = R5(x, kw(A, n.filter(function(C) {
        return C.props[o] === w && !C.props.hide;
      }), "number", d), a.defaultProps.allowDataOverflow), y = v7(h, y, w, i)), ie(ie({}, m), {}, Oe({}, w, ie(ie({
        axisType: i
      }, a.defaultProps), {}, {
        hide: !0,
        orientation: vr(m0e, "".concat(i, ".").concat(g % 2), null),
        domain: y,
        originalDomain: x,
        isCategorical: v,
        layout: d
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return m;
  }, {});
}, D0e = function(t, r) {
  var n = r.axisType, a = n === void 0 ? "xAxis" : n, i = r.AxisComp, o = r.graphicalItems, s = r.stackGroups, c = r.dataStartIndex, u = r.dataEndIndex, d = t.children, h = "".concat(a, "Id"), A = er(d, i), p = {};
  return A && A.length ? p = w0e(t, {
    axes: A,
    graphicalItems: o,
    axisType: a,
    axisIdKey: h,
    stackGroups: s,
    dataStartIndex: c,
    dataEndIndex: u
  }) : o && o.length && (p = x0e(t, {
    Axis: i,
    graphicalItems: o,
    axisType: a,
    axisIdKey: h,
    stackGroups: s,
    dataStartIndex: c,
    dataEndIndex: u
  })), p;
}, O0e = function(t) {
  var r = Kn(t), n = yn(r, !1, !0);
  return {
    tooltipTicks: n,
    orderedTooltipTicks: x9(n, function(a) {
      return a.coordinate;
    }),
    tooltipAxis: r,
    tooltipAxisBandSize: _s(r, n)
  };
}, fv = function(t) {
  var r = t.children, n = t.defaultShowTooltip, a = fr(r, l2), i = 0, o = 0;
  return t.data && t.data.length !== 0 && (o = t.data.length - 1), a && a.props && (a.props.startIndex >= 0 && (i = a.props.startIndex), a.props.endIndex >= 0 && (o = a.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: i,
    dataEndIndex: o,
    activeTooltipIndex: -1,
    isTooltipActive: !!n
  };
}, M0e = function(t) {
  return !t || !t.length ? !1 : t.some(function(r) {
    var n = xn(r && r.type);
    return n && n.indexOf("Bar") >= 0;
  });
}, hv = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, E0e = function(t, r) {
  var n = t.props, a = t.graphicalItems, i = t.xAxisMap, o = i === void 0 ? {} : i, s = t.yAxisMap, c = s === void 0 ? {} : s, u = n.width, d = n.height, h = n.children, A = n.margin || {}, p = fr(h, l2), v = fr(h, l1), g = Object.keys(c).reduce(function(C, O) {
    var M = c[O], E = M.orientation;
    return !M.mirror && !M.hide ? ie(ie({}, C), {}, Oe({}, E, C[E] + M.width)) : C;
  }, {
    left: A.left || 0,
    right: A.right || 0
  }), m = Object.keys(o).reduce(function(C, O) {
    var M = o[O], E = M.orientation;
    return !M.mirror && !M.hide ? ie(ie({}, C), {}, Oe({}, E, vr(C, "".concat(E)) + M.height)) : C;
  }, {
    top: A.top || 0,
    bottom: A.bottom || 0
  }), b = ie(ie({}, m), g), w = b.bottom;
  p && (b.bottom += p.props.height || l2.defaultProps.height), v && r && (b = Sre(b, a, n, r));
  var x = u - b.left - b.right, y = d - b.top - b.bottom;
  return ie(ie({
    brushBottom: w
  }, b), {}, {
    // never return negative values for height and width
    width: Math.max(x, 0),
    height: Math.max(y, 0)
  });
}, S0e = function(t, r) {
  if (r === "xAxis")
    return t[r].width;
  if (r === "yAxis")
    return t[r].height;
}, i8 = function(t) {
  var r, n = t.chartName, a = t.GraphicalChild, i = t.defaultTooltipEventType, o = i === void 0 ? "axis" : i, s = t.validateTooltipEventTypes, c = s === void 0 ? ["axis"] : s, u = t.axisComponents, d = t.legendContent, h = t.formatAxisMap, A = t.defaultProps, p = function(m, b) {
    var w = b.graphicalItems, x = b.stackGroups, y = b.offset, C = b.updateId, O = b.dataStartIndex, M = b.dataEndIndex, E = m.barSize, N = m.layout, F = m.barGap, k = m.barCategoryGap, R = m.maxBarSize, j = hv(N), U = j.numericAxisName, ee = j.cateAxisName, X = M0e(w), Z = [];
    return w.forEach(function(te, B) {
      var I = X0(m.data, {
        graphicalItems: [te],
        dataStartIndex: O,
        dataEndIndex: M
      }), _ = te.props, L = _.dataKey, D = _.maxBarSize, T = te.props["".concat(U, "Id")], Q = te.props["".concat(ee, "Id")], z = {}, W = u.reduce(function(ge, Se) {
        var Te, Re, at = b["".concat(Se.axisType, "Map")], bt = te.props["".concat(Se.axisType, "Id")];
        at && at[bt] || Se.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? Wt(!1, "Specifying a(n) ".concat(Se.axisType, "Id requires a corresponding ").concat(
          Se.axisType,
          "Id on the targeted graphical component "
        ).concat((Te = te == null || (Re = te.type) === null || Re === void 0 ? void 0 : Re.displayName) !== null && Te !== void 0 ? Te : "")) : Wt(!1));
        var Qt = at[bt];
        return ie(ie({}, ge), {}, Oe(Oe({}, Se.axisType, Qt), "".concat(Se.axisType, "Ticks"), yn(Qt)));
      }, z), H = W[ee], $ = W["".concat(ee, "Ticks")], V = x && x[T] && x[T].hasStack && $re(te, x[T].stackGroups), Y = xn(te.type).indexOf("Bar") >= 0, S = _s(H, $), J = [], q = X && Mre({
        barSize: E,
        stackGroups: x,
        totalSize: S0e(W, ee)
      });
      if (Y) {
        var re, ae, oe = ye(D) ? R : D, ue = (re = (ae = _s(H, $, !0)) !== null && ae !== void 0 ? ae : oe) !== null && re !== void 0 ? re : 0;
        J = Ere({
          barGap: F,
          barCategoryGap: k,
          bandSize: ue !== S ? ue : S,
          sizeList: q[Q],
          maxBarSize: oe
        }), ue !== S && (J = J.map(function(ge) {
          return ie(ie({}, ge), {}, {
            position: ie(ie({}, ge.position), {}, {
              offset: ge.position.offset - ue / 2
            })
          });
        }));
      }
      var Ae = te && te.type && te.type.getComposedData;
      Ae && Z.push({
        props: ie(ie({}, Ae(ie(ie({}, W), {}, {
          displayedData: I,
          props: m,
          dataKey: L,
          item: te,
          bandSize: S,
          barPosition: J,
          offset: y,
          stackedData: V,
          layout: N,
          dataStartIndex: O,
          dataEndIndex: M
        }))), {}, Oe(Oe(Oe({
          key: te.key || "item-".concat(B)
        }, U, W[U]), ee, W[ee]), "animationId", C)),
        childIndex: $Y(te, m.children),
        item: te
      });
    }), Z;
  }, v = function(m, b) {
    var w = m.props, x = m.dataStartIndex, y = m.dataEndIndex, C = m.updateId;
    if (!mh({
      props: w
    }))
      return null;
    var O = w.children, M = w.layout, E = w.stackOffset, N = w.data, F = w.reverseStackOrder, k = hv(M), R = k.numericAxisName, j = k.cateAxisName, U = er(O, a), ee = Rre(N, U, "".concat(R, "Id"), "".concat(j, "Id"), E, F), X = u.reduce(function(_, L) {
      var D = "".concat(L.axisType, "Map");
      return ie(ie({}, _), {}, Oe({}, D, D0e(w, ie(ie({}, L), {}, {
        graphicalItems: U,
        stackGroups: L.axisType === R && ee,
        dataStartIndex: x,
        dataEndIndex: y
      }))));
    }, {}), Z = E0e(ie(ie({}, X), {}, {
      props: w,
      graphicalItems: U
    }), b == null ? void 0 : b.legendBBox);
    Object.keys(X).forEach(function(_) {
      X[_] = h(w, X[_], Z, _.replace("Map", ""), n);
    });
    var te = X["".concat(j, "Map")], B = O0e(te), I = p(w, ie(ie({}, X), {}, {
      dataStartIndex: x,
      dataEndIndex: y,
      updateId: C,
      graphicalItems: U,
      stackGroups: ee,
      offset: Z
    }));
    return ie(ie({
      formattedGraphicalItems: I,
      graphicalItems: U,
      offset: Z,
      stackGroups: ee
    }, B), X);
  };
  return r = /* @__PURE__ */ function(g) {
    h0e(m, g);
    function m(b) {
      var w, x, y;
      return c0e(this, m), y = d0e(this, m, [b]), Oe(Fe(y), "eventEmitterSymbol", Symbol("rechartsEventEmitter")), Oe(Fe(y), "accessibilityManager", new Kse()), Oe(Fe(y), "handleLegendBBoxUpdate", function(C) {
        if (C) {
          var O = y.state, M = O.dataStartIndex, E = O.dataEndIndex, N = O.updateId;
          y.setState(ie({
            legendBBox: C
          }, v({
            props: y.props,
            dataStartIndex: M,
            dataEndIndex: E,
            updateId: N
          }, ie(ie({}, y.state), {}, {
            legendBBox: C
          }))));
        }
      }), Oe(Fe(y), "handleReceiveSyncEvent", function(C, O, M) {
        if (y.props.syncId === C) {
          if (M === y.eventEmitterSymbol && typeof y.props.syncMethod != "function")
            return;
          y.applySyncEvent(O);
        }
      }), Oe(Fe(y), "handleBrushChange", function(C) {
        var O = C.startIndex, M = C.endIndex;
        if (O !== y.state.dataStartIndex || M !== y.state.dataEndIndex) {
          var E = y.state.updateId;
          y.setState(function() {
            return ie({
              dataStartIndex: O,
              dataEndIndex: M
            }, v({
              props: y.props,
              dataStartIndex: O,
              dataEndIndex: M,
              updateId: E
            }, y.state));
          }), y.triggerSyncEvent({
            dataStartIndex: O,
            dataEndIndex: M
          });
        }
      }), Oe(Fe(y), "handleMouseEnter", function(C) {
        var O = y.getMouseInfo(C);
        if (O) {
          var M = ie(ie({}, O), {}, {
            isTooltipActive: !0
          });
          y.setState(M), y.triggerSyncEvent(M);
          var E = y.props.onMouseEnter;
          xe(E) && E(M, C);
        }
      }), Oe(Fe(y), "triggeredAfterMouseMove", function(C) {
        var O = y.getMouseInfo(C), M = O ? ie(ie({}, O), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        y.setState(M), y.triggerSyncEvent(M);
        var E = y.props.onMouseMove;
        xe(E) && E(M, C);
      }), Oe(Fe(y), "handleItemMouseEnter", function(C) {
        y.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: C,
            activePayload: C.tooltipPayload,
            activeCoordinate: C.tooltipPosition || {
              x: C.cx,
              y: C.cy
            }
          };
        });
      }), Oe(Fe(y), "handleItemMouseLeave", function() {
        y.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), Oe(Fe(y), "handleMouseMove", function(C) {
        C.persist(), y.throttleTriggeredAfterMouseMove(C);
      }), Oe(Fe(y), "handleMouseLeave", function(C) {
        y.throttleTriggeredAfterMouseMove.cancel();
        var O = {
          isTooltipActive: !1
        };
        y.setState(O), y.triggerSyncEvent(O);
        var M = y.props.onMouseLeave;
        xe(M) && M(O, C);
      }), Oe(Fe(y), "handleOuterEvent", function(C) {
        var O = FY(C), M = vr(y.props, "".concat(O));
        if (O && xe(M)) {
          var E, N;
          /.*touch.*/i.test(O) ? N = y.getMouseInfo(C.changedTouches[0]) : N = y.getMouseInfo(C), M((E = N) !== null && E !== void 0 ? E : {}, C);
        }
      }), Oe(Fe(y), "handleClick", function(C) {
        var O = y.getMouseInfo(C);
        if (O) {
          var M = ie(ie({}, O), {}, {
            isTooltipActive: !0
          });
          y.setState(M), y.triggerSyncEvent(M);
          var E = y.props.onClick;
          xe(E) && E(M, C);
        }
      }), Oe(Fe(y), "handleMouseDown", function(C) {
        var O = y.props.onMouseDown;
        if (xe(O)) {
          var M = y.getMouseInfo(C);
          O(M, C);
        }
      }), Oe(Fe(y), "handleMouseUp", function(C) {
        var O = y.props.onMouseUp;
        if (xe(O)) {
          var M = y.getMouseInfo(C);
          O(M, C);
        }
      }), Oe(Fe(y), "handleTouchMove", function(C) {
        C.changedTouches != null && C.changedTouches.length > 0 && y.throttleTriggeredAfterMouseMove(C.changedTouches[0]);
      }), Oe(Fe(y), "handleTouchStart", function(C) {
        C.changedTouches != null && C.changedTouches.length > 0 && y.handleMouseDown(C.changedTouches[0]);
      }), Oe(Fe(y), "handleTouchEnd", function(C) {
        C.changedTouches != null && C.changedTouches.length > 0 && y.handleMouseUp(C.changedTouches[0]);
      }), Oe(Fe(y), "triggerSyncEvent", function(C) {
        y.props.syncId !== void 0 && i4.emit(o4, y.props.syncId, C, y.eventEmitterSymbol);
      }), Oe(Fe(y), "applySyncEvent", function(C) {
        var O = y.props, M = O.layout, E = O.syncMethod, N = y.state.updateId, F = C.dataStartIndex, k = C.dataEndIndex;
        if (C.dataStartIndex !== void 0 || C.dataEndIndex !== void 0)
          y.setState(ie({
            dataStartIndex: F,
            dataEndIndex: k
          }, v({
            props: y.props,
            dataStartIndex: F,
            dataEndIndex: k,
            updateId: N
          }, y.state)));
        else if (C.activeTooltipIndex !== void 0) {
          var R = C.chartX, j = C.chartY, U = C.activeTooltipIndex, ee = y.state, X = ee.offset, Z = ee.tooltipTicks;
          if (!X)
            return;
          if (typeof E == "function")
            U = E(Z, C);
          else if (E === "value") {
            U = -1;
            for (var te = 0; te < Z.length; te++)
              if (Z[te].value === C.activeLabel) {
                U = te;
                break;
              }
          }
          var B = ie(ie({}, X), {}, {
            x: X.left,
            y: X.top
          }), I = Math.min(R, B.x + B.width), _ = Math.min(j, B.y + B.height), L = Z[U] && Z[U].value, D = b7(y.state, y.props.data, U), T = Z[U] ? {
            x: M === "horizontal" ? Z[U].coordinate : I,
            y: M === "horizontal" ? _ : Z[U].coordinate
          } : eD;
          y.setState(ie(ie({}, C), {}, {
            activeLabel: L,
            activeCoordinate: T,
            activePayload: D,
            activeTooltipIndex: U
          }));
        } else
          y.setState(C);
      }), Oe(Fe(y), "renderCursor", function(C) {
        var O, M = y.state, E = M.isTooltipActive, N = M.activeCoordinate, F = M.activePayload, k = M.offset, R = M.activeTooltipIndex, j = M.tooltipAxisBandSize, U = y.getTooltipEventType(), ee = (O = C.props.active) !== null && O !== void 0 ? O : E, X = y.props.layout, Z = C.key || "_recharts-cursor";
        return /* @__PURE__ */ P.createElement(r0e, {
          key: Z,
          activeCoordinate: N,
          activePayload: F,
          activeTooltipIndex: R,
          chartName: n,
          element: C,
          isActive: ee,
          layout: X,
          offset: k,
          tooltipAxisBandSize: j,
          tooltipEventType: U
        });
      }), Oe(Fe(y), "renderPolarAxis", function(C, O, M) {
        var E = vr(C, "type.axisType"), N = vr(y.state, "".concat(E, "Map")), F = N && N[C.props["".concat(E, "Id")]];
        return /* @__PURE__ */ Pt(C, ie(ie({}, F), {}, {
          className: Pe(E, F.className),
          key: C.key || "".concat(O, "-").concat(M),
          ticks: yn(F, !0)
        }));
      }), Oe(Fe(y), "renderPolarGrid", function(C) {
        var O = C.props, M = O.radialLines, E = O.polarAngles, N = O.polarRadius, F = y.state, k = F.radiusAxisMap, R = F.angleAxisMap, j = Kn(k), U = Kn(R), ee = U.cx, X = U.cy, Z = U.innerRadius, te = U.outerRadius;
        return /* @__PURE__ */ Pt(C, {
          polarAngles: Array.isArray(E) ? E : yn(U, !0).map(function(B) {
            return B.coordinate;
          }),
          polarRadius: Array.isArray(N) ? N : yn(j, !0).map(function(B) {
            return B.coordinate;
          }),
          cx: ee,
          cy: X,
          innerRadius: Z,
          outerRadius: te,
          key: C.key || "polar-grid",
          radialLines: M
        });
      }), Oe(Fe(y), "renderLegend", function() {
        var C = y.state.formattedGraphicalItems, O = y.props, M = O.children, E = O.width, N = O.height, F = y.props.margin || {}, k = E - (F.left || 0) - (F.right || 0), R = Hw({
          children: M,
          formattedGraphicalItems: C,
          legendWidth: k,
          legendContent: d
        });
        if (!R)
          return null;
        var j = R.item, U = lv(R, n0e);
        return /* @__PURE__ */ Pt(j, ie(ie({}, U), {}, {
          chartWidth: E,
          chartHeight: N,
          margin: F,
          onBBoxUpdate: y.handleLegendBBoxUpdate
        }));
      }), Oe(Fe(y), "renderTooltip", function() {
        var C, O = y.props, M = O.children, E = O.accessibilityLayer, N = fr(M, zt);
        if (!N)
          return null;
        var F = y.state, k = F.isTooltipActive, R = F.activeCoordinate, j = F.activePayload, U = F.activeLabel, ee = F.offset, X = (C = N.props.active) !== null && C !== void 0 ? C : k;
        return /* @__PURE__ */ Pt(N, {
          viewBox: ie(ie({}, ee), {}, {
            x: ee.left,
            y: ee.top
          }),
          active: X,
          label: U,
          payload: X ? j : [],
          coordinate: R,
          accessibilityLayer: E
        });
      }), Oe(Fe(y), "renderBrush", function(C) {
        var O = y.props, M = O.margin, E = O.data, N = y.state, F = N.offset, k = N.dataStartIndex, R = N.dataEndIndex, j = N.updateId;
        return /* @__PURE__ */ Pt(C, {
          key: C.key || "_recharts-brush",
          onChange: N3(y.handleBrushChange, C.props.onChange),
          data: E,
          x: le(C.props.x) ? C.props.x : F.left,
          y: le(C.props.y) ? C.props.y : F.top + F.height + F.brushBottom - (M.bottom || 0),
          width: le(C.props.width) ? C.props.width : F.width,
          startIndex: k,
          endIndex: R,
          updateId: "brush-".concat(j)
        });
      }), Oe(Fe(y), "renderReferenceElement", function(C, O, M) {
        if (!C)
          return null;
        var E = Fe(y), N = E.clipPathId, F = y.state, k = F.xAxisMap, R = F.yAxisMap, j = F.offset, U = C.props, ee = U.xAxisId, X = U.yAxisId;
        return /* @__PURE__ */ Pt(C, {
          key: C.key || "".concat(O, "-").concat(M),
          xAxis: k[ee],
          yAxis: R[X],
          viewBox: {
            x: j.left,
            y: j.top,
            width: j.width,
            height: j.height
          },
          clipPathId: N
        });
      }), Oe(Fe(y), "renderActivePoints", function(C) {
        var O = C.item, M = C.activePoint, E = C.basePoint, N = C.childIndex, F = C.isRange, k = [], R = O.props.key, j = O.item.props, U = j.activeDot, ee = j.dataKey, X = ie(ie({
          index: N,
          dataKey: ee,
          cx: M.x,
          cy: M.y,
          r: 4,
          fill: K9(O.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: M.payload,
          value: M.value,
          key: "".concat(R, "-activePoint-").concat(N)
        }, pe(U, !1)), us(U));
        return k.push(m.renderActiveDot(U, X)), E ? k.push(m.renderActiveDot(U, ie(ie({}, X), {}, {
          cx: E.x,
          cy: E.y,
          key: "".concat(R, "-basePoint-").concat(N)
        }))) : F && k.push(null), k;
      }), Oe(Fe(y), "renderGraphicChild", function(C, O, M) {
        var E = y.filterFormatItem(C, O, M);
        if (!E)
          return null;
        var N = y.getTooltipEventType(), F = y.state, k = F.isTooltipActive, R = F.tooltipAxis, j = F.activeTooltipIndex, U = F.activeLabel, ee = y.props.children, X = fr(ee, zt), Z = E.props, te = Z.points, B = Z.isRange, I = Z.baseLine, _ = E.item.props, L = _.activeDot, D = _.hide, T = _.activeBar, Q = _.activeShape, z = !!(!D && k && X && (L || T || Q)), W = {};
        N !== "axis" && X && X.props.trigger === "click" ? W = {
          onClick: N3(y.handleItemMouseEnter, C.props.onClick)
        } : N !== "axis" && (W = {
          onMouseLeave: N3(y.handleItemMouseLeave, C.props.onMouseLeave),
          onMouseEnter: N3(y.handleItemMouseEnter, C.props.onMouseEnter)
        });
        var H = /* @__PURE__ */ Pt(C, ie(ie({}, E.props), W));
        function $(Se) {
          return typeof R.dataKey == "function" ? R.dataKey(Se.payload) : null;
        }
        if (z)
          if (j >= 0) {
            var V, Y;
            if (R.dataKey && !R.allowDuplicatedCategory) {
              var S = typeof R.dataKey == "function" ? $ : "payload.".concat(R.dataKey.toString());
              V = cs(te, S, U), Y = B && I && cs(I, S, U);
            } else
              V = te == null ? void 0 : te[j], Y = B && I && I[j];
            if (Q || T) {
              var J = C.props.activeIndex !== void 0 ? C.props.activeIndex : j;
              return [/* @__PURE__ */ Pt(C, ie(ie(ie({}, E.props), W), {}, {
                activeIndex: J
              })), null, null];
            }
            if (!ye(V))
              return [H].concat(g2(y.renderActivePoints({
                item: E,
                activePoint: V,
                basePoint: Y,
                childIndex: j,
                isRange: B
              })));
          } else {
            var q, re = (q = y.getItemByXY(y.state.activeCoordinate)) !== null && q !== void 0 ? q : {
              graphicalItem: H
            }, ae = re.graphicalItem, oe = ae.item, ue = oe === void 0 ? C : oe, Ae = ae.childIndex, ge = ie(ie(ie({}, E.props), W), {}, {
              activeIndex: Ae
            });
            return [/* @__PURE__ */ Pt(ue, ge), null, null];
          }
        return B ? [H, null, null] : [H, null];
      }), Oe(Fe(y), "renderCustomized", function(C, O, M) {
        return /* @__PURE__ */ Pt(C, ie(ie({
          key: "recharts-customized-".concat(M)
        }, y.props), y.state));
      }), Oe(Fe(y), "renderMap", {
        CartesianGrid: {
          handler: F3,
          once: !0
        },
        ReferenceArea: {
          handler: y.renderReferenceElement
        },
        ReferenceLine: {
          handler: F3
        },
        ReferenceDot: {
          handler: y.renderReferenceElement
        },
        XAxis: {
          handler: F3
        },
        YAxis: {
          handler: F3
        },
        Brush: {
          handler: y.renderBrush,
          once: !0
        },
        Bar: {
          handler: y.renderGraphicChild
        },
        Line: {
          handler: y.renderGraphicChild
        },
        Area: {
          handler: y.renderGraphicChild
        },
        Radar: {
          handler: y.renderGraphicChild
        },
        RadialBar: {
          handler: y.renderGraphicChild
        },
        Scatter: {
          handler: y.renderGraphicChild
        },
        Pie: {
          handler: y.renderGraphicChild
        },
        Funnel: {
          handler: y.renderGraphicChild
        },
        Tooltip: {
          handler: y.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: y.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: y.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: y.renderPolarAxis
        },
        Customized: {
          handler: y.renderCustomized
        }
      }), y.clipPathId = "".concat((w = b.id) !== null && w !== void 0 ? w : p1("recharts"), "-clip"), y.throttleTriggeredAfterMouseMove = ky(y.triggeredAfterMouseMove, (x = b.throttleDelay) !== null && x !== void 0 ? x : 1e3 / 60), y.state = {}, y;
    }
    return u0e(m, [{
      key: "componentDidMount",
      value: function() {
        var w, x;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (w = this.props.margin.left) !== null && w !== void 0 ? w : 0,
            top: (x = this.props.margin.top) !== null && x !== void 0 ? x : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var w = this.props, x = w.children, y = w.data, C = w.height, O = w.layout, M = fr(x, zt);
        if (M) {
          var E = M.props.defaultIndex;
          if (!(typeof E != "number" || E < 0 || E > this.state.tooltipTicks.length)) {
            var N = this.state.tooltipTicks[E] && this.state.tooltipTicks[E].value, F = b7(this.state, y, E, N), k = this.state.tooltipTicks[E].coordinate, R = (this.state.offset.top + C) / 2, j = O === "horizontal", U = j ? {
              x: k,
              y: R
            } : {
              y: k,
              x: R
            }, ee = this.state.formattedGraphicalItems.find(function(Z) {
              var te = Z.item;
              return te.type.name === "Scatter";
            });
            ee && (U = ie(ie({}, U), ee.props.points[E].tooltipPosition), F = ee.props.points[E].tooltipPayload);
            var X = {
              activeTooltipIndex: E,
              isTooltipActive: !0,
              activeLabel: N,
              activePayload: F,
              activeCoordinate: U
            };
            this.setState(X), this.renderCursor(M), this.accessibilityManager.setIndex(E);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(w, x) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== x.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== w.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== w.margin) {
          var y, C;
          this.accessibilityManager.setDetails({
            offset: {
              left: (y = this.props.margin.left) !== null && y !== void 0 ? y : 0,
              top: (C = this.props.margin.top) !== null && C !== void 0 ? C : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(w) {
        X4([fr(w.children, zt)], [fr(this.props.children, zt)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var w = fr(this.props.children, zt);
        if (w && typeof w.props.shared == "boolean") {
          var x = w.props.shared ? "axis" : "item";
          return c.indexOf(x) >= 0 ? x : o;
        }
        return o;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(w) {
        if (!this.container)
          return null;
        var x = this.container, y = x.getBoundingClientRect(), C = sX(y), O = {
          chartX: Math.round(w.pageX - C.left),
          chartY: Math.round(w.pageY - C.top)
        }, M = y.width / x.offsetWidth || 1, E = this.inRange(O.chartX, O.chartY, M);
        if (!E)
          return null;
        var N = this.state, F = N.xAxisMap, k = N.yAxisMap, R = this.getTooltipEventType();
        if (R !== "axis" && F && k) {
          var j = Kn(F).scale, U = Kn(k).scale, ee = j && j.invert ? j.invert(O.chartX) : null, X = U && U.invert ? U.invert(O.chartY) : null;
          return ie(ie({}, O), {}, {
            xValue: ee,
            yValue: X
          });
        }
        var Z = dv(this.state, this.props.data, this.props.layout, E);
        return Z ? ie(ie({}, O), Z) : null;
      }
    }, {
      key: "inRange",
      value: function(w, x) {
        var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, C = this.props.layout, O = w / y, M = x / y;
        if (C === "horizontal" || C === "vertical") {
          var E = this.state.offset, N = O >= E.left && O <= E.left + E.width && M >= E.top && M <= E.top + E.height;
          return N ? {
            x: O,
            y: M
          } : null;
        }
        var F = this.state, k = F.angleAxisMap, R = F.radiusAxisMap;
        if (k && R) {
          var j = Kn(k);
          return jp({
            x: O,
            y: M
          }, j);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var w = this.props.children, x = this.getTooltipEventType(), y = fr(w, zt), C = {};
        y && x === "axis" && (y.props.trigger === "click" ? C = {
          onClick: this.handleClick
        } : C = {
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        });
        var O = us(this.props, this.handleOuterEvent);
        return ie(ie({}, O), C);
      }
    }, {
      key: "addListener",
      value: function() {
        i4.on(o4, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        i4.removeListener(o4, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(w, x, y) {
        for (var C = this.state.formattedGraphicalItems, O = 0, M = C.length; O < M; O++) {
          var E = C[O];
          if (E.item === w || E.props.key === w.key || x === xn(E.item.type) && y === E.childIndex)
            return E;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var w = this.clipPathId, x = this.state.offset, y = x.left, C = x.top, O = x.height, M = x.width;
        return /* @__PURE__ */ P.createElement("defs", null, /* @__PURE__ */ P.createElement("clipPath", {
          id: w
        }, /* @__PURE__ */ P.createElement("rect", {
          x: y,
          y: C,
          height: O,
          width: M
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var w = this.state.xAxisMap;
        return w ? Object.entries(w).reduce(function(x, y) {
          var C = sv(y, 2), O = C[0], M = C[1];
          return ie(ie({}, x), {}, Oe({}, O, M.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var w = this.state.yAxisMap;
        return w ? Object.entries(w).reduce(function(x, y) {
          var C = sv(y, 2), O = C[0], M = C[1];
          return ie(ie({}, x), {}, Oe({}, O, M.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(w) {
        var x;
        return (x = this.state.xAxisMap) === null || x === void 0 || (x = x[w]) === null || x === void 0 ? void 0 : x.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(w) {
        var x;
        return (x = this.state.yAxisMap) === null || x === void 0 || (x = x[w]) === null || x === void 0 ? void 0 : x.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(w) {
        var x = this.state, y = x.formattedGraphicalItems, C = x.activeItem;
        if (y && y.length)
          for (var O = 0, M = y.length; O < M; O++) {
            var E = y[O], N = E.props, F = E.item, k = xn(F.type);
            if (k === "Bar") {
              var R = (N.data || []).find(function(X) {
                return bae(w, X);
              });
              if (R)
                return {
                  graphicalItem: E,
                  payload: R
                };
            } else if (k === "RadialBar") {
              var j = (N.data || []).find(function(X) {
                return jp(w, X);
              });
              if (j)
                return {
                  graphicalItem: E,
                  payload: j
                };
            } else if (Q0(E, C) || U0(E, C) || Io(E, C)) {
              var U = lie({
                graphicalItem: E,
                activeTooltipItem: C,
                itemData: F.props.data
              }), ee = F.props.activeIndex === void 0 ? U : F.props.activeIndex;
              return {
                graphicalItem: ie(ie({}, E), {}, {
                  childIndex: ee
                }),
                payload: Io(E, C) ? F.props.data[U] : E.props.data[U]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var w = this;
        if (!mh(this))
          return null;
        var x = this.props, y = x.children, C = x.className, O = x.width, M = x.height, E = x.style, N = x.compact, F = x.title, k = x.desc, R = lv(x, a0e), j = pe(R, !1);
        if (N)
          return /* @__PURE__ */ P.createElement($g, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ P.createElement(e5, Ui({}, j, {
            width: O,
            height: M,
            title: F,
            desc: k
          }), this.renderClipPath(), bh(y, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var U, ee;
          j.tabIndex = (U = this.props.tabIndex) !== null && U !== void 0 ? U : 0, j.role = (ee = this.props.role) !== null && ee !== void 0 ? ee : "application", j.onKeyDown = function(Z) {
            w.accessibilityManager.keyboardEvent(Z);
          }, j.onFocus = function() {
            w.accessibilityManager.focus();
          };
        }
        var X = this.parseEventsOfWrapper();
        return /* @__PURE__ */ P.createElement($g, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ P.createElement("div", Ui({
          className: Pe("recharts-wrapper", C),
          style: ie({
            position: "relative",
            cursor: "default",
            width: O,
            height: M
          }, E)
        }, X, {
          ref: function(te) {
            w.container = te;
          }
        }), /* @__PURE__ */ P.createElement(e5, Ui({}, j, {
          width: O,
          height: M,
          title: F,
          desc: k,
          style: C0e
        }), this.renderClipPath(), bh(y, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]), m;
  }(Jm), Oe(r, "displayName", n), Oe(r, "defaultProps", ie({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, A)), Oe(r, "getDerivedStateFromProps", function(g, m) {
    var b = g.dataKey, w = g.data, x = g.children, y = g.width, C = g.height, O = g.layout, M = g.stackOffset, E = g.margin, N = m.dataStartIndex, F = m.dataEndIndex;
    if (m.updateId === void 0) {
      var k = fv(g);
      return ie(ie(ie({}, k), {}, {
        updateId: 0
      }, v(ie(ie({
        props: g
      }, k), {}, {
        updateId: 0
      }), m)), {}, {
        prevDataKey: b,
        prevData: w,
        prevWidth: y,
        prevHeight: C,
        prevLayout: O,
        prevStackOffset: M,
        prevMargin: E,
        prevChildren: x
      });
    }
    if (b !== m.prevDataKey || w !== m.prevData || y !== m.prevWidth || C !== m.prevHeight || O !== m.prevLayout || M !== m.prevStackOffset || !Ha(E, m.prevMargin)) {
      var R = fv(g), j = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: m.chartX,
        chartY: m.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: m.isTooltipActive
      }, U = ie(ie({}, dv(m, w, O)), {}, {
        updateId: m.updateId + 1
      }), ee = ie(ie(ie({}, R), j), U);
      return ie(ie(ie({}, ee), v(ie({
        props: g
      }, ee), m)), {}, {
        prevDataKey: b,
        prevData: w,
        prevWidth: y,
        prevHeight: C,
        prevLayout: O,
        prevStackOffset: M,
        prevMargin: E,
        prevChildren: x
      });
    }
    if (!X4(x, m.prevChildren)) {
      var X, Z, te, B, I = fr(x, l2), _ = I && (X = (Z = I.props) === null || Z === void 0 ? void 0 : Z.startIndex) !== null && X !== void 0 ? X : N, L = I && (te = (B = I.props) === null || B === void 0 ? void 0 : B.endIndex) !== null && te !== void 0 ? te : F, D = _ !== N || L !== F, T = !ye(w), Q = T && !D ? m.updateId : m.updateId + 1;
      return ie(ie({
        updateId: Q
      }, v(ie(ie({
        props: g
      }, m), {}, {
        updateId: Q,
        dataStartIndex: _,
        dataEndIndex: L
      }), m)), {}, {
        prevChildren: x,
        dataStartIndex: _,
        dataEndIndex: L
      });
    }
    return null;
  }), Oe(r, "renderActiveDot", function(g, m) {
    var b;
    return /* @__PURE__ */ kr(g) ? b = /* @__PURE__ */ Pt(g, m) : xe(g) ? b = g(m) : b = /* @__PURE__ */ P.createElement(e3, m), /* @__PURE__ */ P.createElement(je, {
      className: "recharts-active-dot",
      key: m.key
    }, b);
  }), r;
}, rD = i8({
  chartName: "BarChart",
  GraphicalChild: Tr,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: u1
  }, {
    axisType: "yAxis",
    AxisComp: la
  }],
  formatAxisMap: Mx
}), o8 = i8({
  chartName: "PieChart",
  GraphicalChild: zr,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: W0
  }, {
    axisType: "radiusAxis",
    AxisComp: V0
  }],
  formatAxisMap: Kre,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
}), P0e = i8({
  chartName: "ComposedChart",
  GraphicalChild: [n3, sa, Tr, q0],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: u1
  }, {
    axisType: "yAxis",
    AxisComp: la
  }, {
    axisType: "zAxis",
    AxisComp: z0
  }],
  formatAxisMap: Mx
});
const j0e = P.forwardRef((e, t) => {
  const {
    data: r,
    onClickCellChart: n,
    onClickIconCard: a,
    chartColors: i,
    labelOne: o,
    labelTwo: s,
    percentageMessage: c,
    hiddenCenter: u,
    ...d
  } = e;
  if (r == null || o == null)
    return null;
  const h = (m) => () => {
    n !== void 0 && n({ data: m });
  }, A = i.map((m) => gt[m.colorCellChart]), p = i.map((m) => m.iconColor), v = {
    gridTemplateColumns: "4fr 6fr"
  }, g = ({
    labelTop: m,
    labelBottom: b
  }) => /* @__PURE__ */ f.jsxs("g", { children: [
    /* @__PURE__ */ f.jsx(
      "text",
      {
        x: "50%",
        y: "50%",
        textAnchor: "middle",
        dominantBaseline: "middle",
        fontSize: 30,
        fontWeight: "700",
        fill: "#292929",
        children: m
      }
    ),
    /* @__PURE__ */ f.jsx(
      "text",
      {
        x: "50%",
        y: "60%",
        textAnchor: "middle",
        dominantBaseline: "middle",
        fontSize: 14,
        fontWeight: "400",
        fill: "#292929",
        children: b
      }
    )
  ] });
  return /* @__PURE__ */ f.jsx(
    "section",
    {
      ref: t,
      className: "flex justify-center items-center",
      ...d,
      children: /* @__PURE__ */ f.jsxs(
        "div",
        {
          className: "w-full max-w-[1260px] flex flex-col gap-4 2s:grid 2s:gap-1 relative",
          style: v,
          children: [
            /* @__PURE__ */ f.jsx(P2, { width: "100%", height: 300, children: /* @__PURE__ */ f.jsxs(o8, { children: [
              /* @__PURE__ */ f.jsxs(
                zr,
                {
                  dataKey: "value",
                  data: r,
                  innerRadius: u ? "0%" : "55%",
                  outerRadius: "100%",
                  cursor: "pointer",
                  children: [
                    /* @__PURE__ */ f.jsx(
                      Ot,
                      {
                        content: /* @__PURE__ */ f.jsx(
                          g,
                          {
                            labelTop: o ?? "",
                            labelBottom: s ?? ""
                          }
                        ),
                        position: "center"
                      }
                    ),
                    r.map((m, b) => /* @__PURE__ */ f.jsx(
                      Br,
                      {
                        fill: A[b % A.length],
                        onClick: h(m)
                      },
                      `cell-${b}`
                    ))
                  ]
                }
              ),
              /* @__PURE__ */ f.jsx(zt, {})
            ] }) }),
            /* @__PURE__ */ f.jsxs("div", { className: " w-full mx-auto flex flex-col items-start justify-center", children: [
              /* @__PURE__ */ f.jsx("p", { className: "font-bold text-md", children: c }),
              r.map((m, b) => /* @__PURE__ */ f.jsx(r9, { gap: 4, spacing: 4, rounded: "md", children: /* @__PURE__ */ f.jsx(ts, { justifyContent: "between", children: /* @__PURE__ */ f.jsxs(ts, { gap: 4, children: [
                /* @__PURE__ */ f.jsx(
                  "div",
                  {
                    className: `w-3 h-3 rounded-full bg-${p[b % p.length]}`
                  }
                ),
                /* @__PURE__ */ f.jsx(Vr, { variant: "title-3", children: m.name })
              ] }) }) }, b))
            ] })
          ]
        }
      )
    }
  );
});
j0e.displayName = "PieCharts";
var nD = {}, a3 = {}, i3 = {}, Sn = {}, aD = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var i = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (i = a(i, n(s)));
      }
      return i;
    }
    function n(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return r.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var o = "";
      for (var s in i)
        t.call(i, s) && i[s] && (o = a(o, s));
      return o;
    }
    function a(i, o) {
      return o ? i ? i + " " + o : i + o : i;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(aD);
var ca = aD.exports, C1 = {}, s8 = {}, An = {}, ne = {};
ne.toDate = I0e;
function I0e(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
var ke = {};
ke.constructFrom = B0e;
function B0e(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
An.addDays = T0e;
var N0e = ne, L0e = ke;
function T0e(e, t) {
  const r = (0, N0e.toDate)(e);
  return isNaN(t) ? (0, L0e.constructFrom)(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
var _2 = {};
_2.addMonths = R0e;
var _0e = ne, Av = ke;
function R0e(e, t) {
  const r = (0, _0e.toDate)(e);
  if (isNaN(t))
    return (0, Av.constructFrom)(e, NaN);
  if (!t)
    return r;
  const n = r.getDate(), a = (0, Av.constructFrom)(e, r.getTime());
  a.setMonth(r.getMonth() + t + 1, 0);
  const i = a.getDate();
  return n >= i ? a : (r.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    n
  ), r);
}
s8.add = k0e;
var F0e = An, $0e = _2, H0e = ke, Y0e = ne;
function k0e(e, t) {
  const {
    years: r = 0,
    months: n = 0,
    weeks: a = 0,
    days: i = 0,
    hours: o = 0,
    minutes: s = 0,
    seconds: c = 0
  } = t, u = (0, Y0e.toDate)(e), d = n || r ? (0, $0e.addMonths)(u, n + r * 12) : u, h = i || a ? (0, F0e.addDays)(d, i + a * 7) : d, A = s + o * 60, v = (c + A * 60) * 1e3;
  return (0, H0e.constructFrom)(
    e,
    h.getTime() + v
  );
}
var l8 = {}, c8 = {};
c8.isSaturday = G0e;
var V0e = ne;
function G0e(e) {
  return (0, V0e.toDate)(e).getDay() === 6;
}
var u8 = {};
u8.isSunday = Q0e;
var W0e = ne;
function Q0e(e) {
  return (0, W0e.toDate)(e).getDay() === 0;
}
var o3 = {};
o3.isWeekend = Z0e;
var U0e = ne;
function Z0e(e) {
  const t = (0, U0e.toDate)(e).getDay();
  return t === 0 || t === 6;
}
l8.addBusinessDays = J0e;
var K0e = ke, z0e = c8, q0e = u8, l4 = o3, X0e = ne;
function J0e(e, t) {
  const r = (0, X0e.toDate)(e), n = (0, l4.isWeekend)(r);
  if (isNaN(t))
    return (0, K0e.constructFrom)(e, NaN);
  const a = r.getHours(), i = t < 0 ? -1 : 1, o = Math.trunc(t / 5);
  r.setDate(r.getDate() + o * 7);
  let s = Math.abs(t % 5);
  for (; s > 0; )
    r.setDate(r.getDate() + i), (0, l4.isWeekend)(r) || (s -= 1);
  return n && (0, l4.isWeekend)(r) && t !== 0 && ((0, z0e.isSaturday)(r) && r.setDate(r.getDate() + (i < 0 ? 2 : -1)), (0, q0e.isSunday)(r) && r.setDate(r.getDate() + (i < 0 ? 1 : -2))), r.setHours(a), r;
}
var J0 = {}, R2 = {};
R2.addMilliseconds = rle;
var ele = ne, tle = ke;
function rle(e, t) {
  const r = +(0, ele.toDate)(e);
  return (0, tle.constructFrom)(e, r + t);
}
var ce = {};
ce.secondsInYear = ce.secondsInWeek = ce.secondsInQuarter = ce.secondsInMonth = ce.secondsInMinute = ce.secondsInHour = ce.secondsInDay = ce.quartersInYear = ce.monthsInYear = ce.monthsInQuarter = ce.minutesInYear = ce.minutesInMonth = ce.minutesInHour = ce.minutesInDay = ce.minTime = ce.millisecondsInWeek = ce.millisecondsInSecond = ce.millisecondsInMinute = ce.millisecondsInHour = ce.millisecondsInDay = ce.maxTime = ce.daysInYear = ce.daysInWeek = void 0;
ce.daysInWeek = 7;
const nle = ce.daysInYear = 365.2425, ale = ce.maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1e3;
ce.minTime = -ale;
ce.millisecondsInWeek = 6048e5;
ce.millisecondsInDay = 864e5;
ce.millisecondsInMinute = 6e4;
ce.millisecondsInHour = 36e5;
ce.millisecondsInSecond = 1e3;
ce.minutesInYear = 525600;
ce.minutesInMonth = 43200;
ce.minutesInDay = 1440;
ce.minutesInHour = 60;
ce.monthsInQuarter = 3;
ce.monthsInYear = 12;
ce.quartersInYear = 4;
const ile = ce.secondsInHour = 3600;
ce.secondsInMinute = 60;
const iD = ce.secondsInDay = ile * 24;
ce.secondsInWeek = iD * 7;
const ole = ce.secondsInYear = iD * nle, sle = ce.secondsInMonth = ole / 12;
ce.secondsInQuarter = sle * 3;
J0.addHours = ule;
var lle = R2, cle = ce;
function ule(e, t) {
  return (0, lle.addMilliseconds)(e, t * cle.millisecondsInHour);
}
var d8 = {}, b1 = {}, pn = {}, qr = {}, Yt = {};
Yt.getDefaultOptions = dle;
Yt.setDefaultOptions = fle;
let oD = {};
function dle() {
  return oD;
}
function fle(e) {
  oD = e;
}
qr.startOfWeek = ple;
var hle = ne, Ale = Yt;
function ple(e, t) {
  var s, c, u, d;
  const r = (0, Ale.getDefaultOptions)(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? r.weekStartsOn ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, a = (0, hle.toDate)(e), i = a.getDay(), o = (i < n ? 7 : 0) + i - n;
  return a.setDate(a.getDate() - o), a.setHours(0, 0, 0, 0), a;
}
pn.startOfISOWeek = vle;
var gle = qr;
function vle(e) {
  return (0, gle.startOfWeek)(e, { weekStartsOn: 1 });
}
b1.getISOWeekYear = Cle;
var pv = ke, gv = pn, mle = ne;
function Cle(e) {
  const t = (0, mle.toDate)(e), r = t.getFullYear(), n = (0, pv.constructFrom)(e, 0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const a = (0, gv.startOfISOWeek)(
    n
  ), i = (0, pv.constructFrom)(e, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const o = (0, gv.startOfISOWeek)(
    i
  );
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
var f8 = {}, Bn = {}, s3 = {};
s3.startOfDay = yle;
var ble = ne;
function yle(e) {
  const t = (0, ble.toDate)(e);
  return t.setHours(0, 0, 0, 0), t;
}
var Nn = {};
Nn.getTimezoneOffsetInMilliseconds = xle;
var wle = ne;
function xle(e) {
  const t = (0, wle.toDate)(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
Bn.differenceInCalendarDays = Ole;
var Dle = ce, vv = s3, mv = Nn;
function Ole(e, t) {
  const r = (0, vv.startOfDay)(e), n = (0, vv.startOfDay)(t), a = +r - (0, mv.getTimezoneOffsetInMilliseconds)(r), i = +n - (0, mv.getTimezoneOffsetInMilliseconds)(n);
  return Math.round(
    (a - i) / Dle.millisecondsInDay
  );
}
var F2 = {};
F2.startOfISOWeekYear = Ple;
var Mle = b1, Ele = pn, Sle = ke;
function Ple(e) {
  const t = (0, Mle.getISOWeekYear)(e), r = (0, Sle.constructFrom)(e, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), (0, Ele.startOfISOWeek)(r);
}
f8.setISOWeekYear = Nle;
var jle = ke, Ile = Bn, Cv = F2, Ble = ne;
function Nle(e, t) {
  let r = (0, Ble.toDate)(e);
  const n = (0, Ile.differenceInCalendarDays)(
    r,
    (0, Cv.startOfISOWeekYear)(r)
  ), a = (0, jle.constructFrom)(e, 0);
  return a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0), r = (0, Cv.startOfISOWeekYear)(a), r.setDate(r.getDate() + n), r;
}
d8.addISOWeekYears = _le;
var Lle = b1, Tle = f8;
function _le(e, t) {
  return (0, Tle.setISOWeekYear)(
    e,
    (0, Lle.getISOWeekYear)(e) + t
  );
}
var el = {};
el.addMinutes = $le;
var Rle = R2, Fle = ce;
function $le(e, t) {
  return (0, Rle.addMilliseconds)(
    e,
    t * Fle.millisecondsInMinute
  );
}
var tl = {};
tl.addQuarters = Yle;
var Hle = _2;
function Yle(e, t) {
  const r = t * 3;
  return (0, Hle.addMonths)(e, r);
}
var h8 = {};
h8.addSeconds = Vle;
var kle = R2;
function Vle(e, t) {
  return (0, kle.addMilliseconds)(e, t * 1e3);
}
var l3 = {};
l3.addWeeks = Wle;
var Gle = An;
function Wle(e, t) {
  const r = t * 7;
  return (0, Gle.addDays)(e, r);
}
var A8 = {};
A8.addYears = Ule;
var Qle = _2;
function Ule(e, t) {
  return (0, Qle.addMonths)(e, t * 12);
}
var sD = {};
sD.areIntervalsOverlapping = Zle;
var $3 = ne;
function Zle(e, t, r) {
  const [n, a] = [
    +(0, $3.toDate)(e.start),
    +(0, $3.toDate)(e.end)
  ].sort((s, c) => s - c), [i, o] = [
    +(0, $3.toDate)(t.start),
    +(0, $3.toDate)(t.end)
  ].sort((s, c) => s - c);
  return r != null && r.inclusive ? n <= o && i <= a : n < o && i < a;
}
var lD = {}, p8 = {};
p8.max = zle;
var Kle = ne;
function zle(e) {
  let t;
  return e.forEach(function(r) {
    const n = (0, Kle.toDate)(r);
    (t === void 0 || t < n || isNaN(Number(n))) && (t = n);
  }), t || /* @__PURE__ */ new Date(NaN);
}
var g8 = {};
g8.min = Xle;
var qle = ne;
function Xle(e) {
  let t;
  return e.forEach((r) => {
    const n = (0, qle.toDate)(r);
    (!t || t > n || isNaN(+n)) && (t = n);
  }), t || /* @__PURE__ */ new Date(NaN);
}
lD.clamp = tce;
var Jle = p8, ece = g8;
function tce(e, t) {
  return (0, ece.min)([
    (0, Jle.max)([e, t.start]),
    t.end
  ]);
}
var cD = {};
cD.closestIndexTo = rce;
var bv = ne;
function rce(e, t) {
  const r = (0, bv.toDate)(e);
  if (isNaN(Number(r)))
    return NaN;
  const n = r.getTime();
  let a, i;
  return t.forEach(function(o, s) {
    const c = (0, bv.toDate)(o);
    if (isNaN(Number(c))) {
      a = NaN, i = NaN;
      return;
    }
    const u = Math.abs(n - c.getTime());
    (a == null || u < i) && (a = s, i = u);
  }), a;
}
var uD = {};
uD.closestTo = nce;
var yv = ke, wv = ne;
function nce(e, t) {
  const r = (0, wv.toDate)(e);
  if (isNaN(Number(r)))
    return (0, yv.constructFrom)(e, NaN);
  const n = r.getTime();
  let a, i;
  return t.forEach((o) => {
    const s = (0, wv.toDate)(o);
    if (isNaN(Number(s))) {
      a = (0, yv.constructFrom)(e, NaN), i = NaN;
      return;
    }
    const c = Math.abs(n - s.getTime());
    (a == null || c < i) && (a = s, i = c);
  }), a;
}
var ua = {};
ua.compareAsc = ace;
var xv = ne;
function ace(e, t) {
  const r = (0, xv.toDate)(e), n = (0, xv.toDate)(t), a = r.getTime() - n.getTime();
  return a < 0 ? -1 : a > 0 ? 1 : a;
}
var dD = {};
dD.compareDesc = ice;
var Dv = ne;
function ice(e, t) {
  const r = (0, Dv.toDate)(e), n = (0, Dv.toDate)(t), a = r.getTime() - n.getTime();
  return a > 0 ? -1 : a < 0 ? 1 : a;
}
var tr = {};
tr.constructNow = sce;
var oce = ke;
function sce(e) {
  return (0, oce.constructFrom)(e, Date.now());
}
var fD = {};
fD.daysToWeeks = cce;
var lce = ce;
function cce(e) {
  const t = e / lce.daysInWeek, r = Math.trunc(t);
  return r === 0 ? 0 : r;
}
var hD = {}, $2 = {};
$2.isSameDay = uce;
var Ov = s3;
function uce(e, t) {
  const r = (0, Ov.startOfDay)(e), n = (0, Ov.startOfDay)(t);
  return +r == +n;
}
var Ln = {}, v8 = {};
v8.isDate = dce;
function dce(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
Ln.isValid = Ace;
var fce = v8, hce = ne;
function Ace(e) {
  if (!(0, fce.isDate)(e) && typeof e != "number")
    return !1;
  const t = (0, hce.toDate)(e);
  return !isNaN(Number(t));
}
hD.differenceInBusinessDays = mce;
var Mv = An, pce = Bn, gce = $2, Ev = Ln, vce = o3, Sv = ne;
function mce(e, t) {
  const r = (0, Sv.toDate)(e);
  let n = (0, Sv.toDate)(t);
  if (!(0, Ev.isValid)(r) || !(0, Ev.isValid)(n))
    return NaN;
  const a = (0, pce.differenceInCalendarDays)(
    r,
    n
  ), i = a < 0 ? -1 : 1, o = Math.trunc(a / 7);
  let s = o * 5;
  for (n = (0, Mv.addDays)(n, o * 7); !(0, gce.isSameDay)(r, n); )
    s += (0, vce.isWeekend)(n) ? 0 : i, n = (0, Mv.addDays)(n, i);
  return s === 0 ? 0 : s;
}
var m8 = {};
m8.differenceInCalendarISOWeekYears = Cce;
var Pv = b1;
function Cce(e, t) {
  return (0, Pv.getISOWeekYear)(e) - (0, Pv.getISOWeekYear)(t);
}
var AD = {};
AD.differenceInCalendarISOWeeks = yce;
var bce = ce, jv = pn, Iv = Nn;
function yce(e, t) {
  const r = (0, jv.startOfISOWeek)(e), n = (0, jv.startOfISOWeek)(t), a = +r - (0, Iv.getTimezoneOffsetInMilliseconds)(r), i = +n - (0, Iv.getTimezoneOffsetInMilliseconds)(n);
  return Math.round(
    (a - i) / bce.millisecondsInWeek
  );
}
var rl = {};
rl.differenceInCalendarMonths = wce;
var Bv = ne;
function wce(e, t) {
  const r = (0, Bv.toDate)(e), n = (0, Bv.toDate)(t), a = r.getFullYear() - n.getFullYear(), i = r.getMonth() - n.getMonth();
  return a * 12 + i;
}
var C8 = {}, b8 = {};
b8.getQuarter = Dce;
var xce = ne;
function Dce(e) {
  const t = (0, xce.toDate)(e);
  return Math.trunc(t.getMonth() / 3) + 1;
}
C8.differenceInCalendarQuarters = Oce;
var Nv = b8, Lv = ne;
function Oce(e, t) {
  const r = (0, Lv.toDate)(e), n = (0, Lv.toDate)(t), a = r.getFullYear() - n.getFullYear(), i = (0, Nv.getQuarter)(r) - (0, Nv.getQuarter)(n);
  return a * 4 + i;
}
var nl = {};
nl.differenceInCalendarWeeks = Ece;
var Mce = ce, Tv = qr, _v = Nn;
function Ece(e, t, r) {
  const n = (0, Tv.startOfWeek)(e, r), a = (0, Tv.startOfWeek)(t, r), i = +n - (0, _v.getTimezoneOffsetInMilliseconds)(n), o = +a - (0, _v.getTimezoneOffsetInMilliseconds)(a);
  return Math.round(
    (i - o) / Mce.millisecondsInWeek
  );
}
var al = {};
al.differenceInCalendarYears = Sce;
var Rv = ne;
function Sce(e, t) {
  const r = (0, Rv.toDate)(e), n = (0, Rv.toDate)(t);
  return r.getFullYear() - n.getFullYear();
}
var il = {};
il.differenceInDays = jce;
var Pce = Bn, Fv = ne;
function jce(e, t) {
  const r = (0, Fv.toDate)(e), n = (0, Fv.toDate)(t), a = $v(r, n), i = Math.abs(
    (0, Pce.differenceInCalendarDays)(r, n)
  );
  r.setDate(r.getDate() - a * i);
  const o = +($v(r, n) === -a), s = a * (i - o);
  return s === 0 ? 0 : s;
}
function $v(e, t) {
  const r = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
var ol = {}, Tn = {};
Tn.getRoundingMethod = Ice;
function Ice(e) {
  return (t) => {
    const n = (e ? Math[e] : Math.trunc)(t);
    return n === 0 ? 0 : n;
  };
}
var c3 = {};
c3.differenceInMilliseconds = Bce;
var Hv = ne;
function Bce(e, t) {
  return +(0, Hv.toDate)(e) - +(0, Hv.toDate)(t);
}
ol.differenceInHours = _ce;
var Nce = Tn, Lce = ce, Tce = c3;
function _ce(e, t, r) {
  const n = (0, Tce.differenceInMilliseconds)(e, t) / Lce.millisecondsInHour;
  return (0, Nce.getRoundingMethod)(r == null ? void 0 : r.roundingMethod)(n);
}
var pD = {}, y8 = {};
y8.subISOWeekYears = Fce;
var Rce = d8;
function Fce(e, t) {
  return (0, Rce.addISOWeekYears)(e, -t);
}
pD.differenceInISOWeekYears = Yce;
var Yv = ua, $ce = m8, Hce = y8, kv = ne;
function Yce(e, t) {
  let r = (0, kv.toDate)(e);
  const n = (0, kv.toDate)(t), a = (0, Yv.compareAsc)(r, n), i = Math.abs(
    (0, $ce.differenceInCalendarISOWeekYears)(r, n)
  );
  r = (0, Hce.subISOWeekYears)(r, a * i);
  const o = +((0, Yv.compareAsc)(r, n) === -a), s = a * (i - o);
  return s === 0 ? 0 : s;
}
var sl = {};
sl.differenceInMinutes = Wce;
var kce = Tn, Vce = ce, Gce = c3;
function Wce(e, t, r) {
  const n = (0, Gce.differenceInMilliseconds)(e, t) / Vce.millisecondsInMinute;
  return (0, kce.getRoundingMethod)(r == null ? void 0 : r.roundingMethod)(n);
}
var u3 = {}, w8 = {}, ll = {};
ll.endOfDay = Uce;
var Qce = ne;
function Uce(e) {
  const t = (0, Qce.toDate)(e);
  return t.setHours(23, 59, 59, 999), t;
}
var cl = {};
cl.endOfMonth = Kce;
var Zce = ne;
function Kce(e) {
  const t = (0, Zce.toDate)(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
w8.isLastDayOfMonth = Jce;
var zce = ll, qce = cl, Xce = ne;
function Jce(e) {
  const t = (0, Xce.toDate)(e);
  return +(0, zce.endOfDay)(t) == +(0, qce.endOfMonth)(t);
}
u3.differenceInMonths = rue;
var c4 = ua, eue = rl, tue = w8, u4 = ne;
function rue(e, t) {
  const r = (0, u4.toDate)(e), n = (0, u4.toDate)(t), a = (0, c4.compareAsc)(r, n), i = Math.abs(
    (0, eue.differenceInCalendarMonths)(r, n)
  );
  let o;
  if (i < 1)
    o = 0;
  else {
    r.getMonth() === 1 && r.getDate() > 27 && r.setDate(30), r.setMonth(r.getMonth() - a * i);
    let s = (0, c4.compareAsc)(r, n) === -a;
    (0, tue.isLastDayOfMonth)((0, u4.toDate)(e)) && i === 1 && (0, c4.compareAsc)(e, n) === 1 && (s = !1), o = a * (i - Number(s));
  }
  return o === 0 ? 0 : o;
}
var gD = {};
gD.differenceInQuarters = iue;
var nue = Tn, aue = u3;
function iue(e, t, r) {
  const n = (0, aue.differenceInMonths)(e, t) / 3;
  return (0, nue.getRoundingMethod)(r == null ? void 0 : r.roundingMethod)(n);
}
var d3 = {};
d3.differenceInSeconds = lue;
var oue = Tn, sue = c3;
function lue(e, t, r) {
  const n = (0, sue.differenceInMilliseconds)(e, t) / 1e3;
  return (0, oue.getRoundingMethod)(r == null ? void 0 : r.roundingMethod)(n);
}
var vD = {};
vD.differenceInWeeks = due;
var cue = Tn, uue = il;
function due(e, t, r) {
  const n = (0, uue.differenceInDays)(e, t) / 7;
  return (0, cue.getRoundingMethod)(r == null ? void 0 : r.roundingMethod)(n);
}
var x8 = {};
x8.differenceInYears = hue;
var Vv = ua, fue = al, Gv = ne;
function hue(e, t) {
  const r = (0, Gv.toDate)(e), n = (0, Gv.toDate)(t), a = (0, Vv.compareAsc)(r, n), i = Math.abs(
    (0, fue.differenceInCalendarYears)(r, n)
  );
  r.setFullYear(1584), n.setFullYear(1584);
  const o = (0, Vv.compareAsc)(r, n) === -a, s = a * (i - +o);
  return s === 0 ? 0 : s;
}
var D8 = {};
D8.eachDayOfInterval = Aue;
var d4 = ne;
function Aue(e, t) {
  const r = (0, d4.toDate)(e.start), n = (0, d4.toDate)(e.end);
  let a = +r > +n;
  const i = a ? +r : +n, o = a ? n : r;
  o.setHours(0, 0, 0, 0);
  let s = (t == null ? void 0 : t.step) ?? 1;
  if (!s)
    return [];
  s < 0 && (s = -s, a = !a);
  const c = [];
  for (; +o <= i; )
    c.push((0, d4.toDate)(o)), o.setDate(o.getDate() + s), o.setHours(0, 0, 0, 0);
  return a ? c.reverse() : c;
}
var mD = {};
mD.eachHourOfInterval = gue;
var pue = J0, f4 = ne;
function gue(e, t) {
  const r = (0, f4.toDate)(e.start), n = (0, f4.toDate)(e.end);
  let a = +r > +n;
  const i = a ? +r : +n;
  let o = a ? n : r;
  o.setMinutes(0, 0, 0);
  let s = (t == null ? void 0 : t.step) ?? 1;
  if (!s)
    return [];
  s < 0 && (s = -s, a = !a);
  const c = [];
  for (; +o <= i; )
    c.push((0, f4.toDate)(o)), o = (0, pue.addHours)(o, s);
  return a ? c.reverse() : c;
}
var CD = {}, ul = {};
ul.startOfMinute = mue;
var vue = ne;
function mue(e) {
  const t = (0, vue.toDate)(e);
  return t.setSeconds(0, 0), t;
}
CD.eachMinuteOfInterval = yue;
var Cue = el, bue = ul, h4 = ne;
function yue(e, t) {
  const r = (0, bue.startOfMinute)(
    (0, h4.toDate)(e.start)
  ), n = (0, h4.toDate)(e.end);
  let a = +r > +n;
  const i = a ? +r : +n;
  let o = a ? n : r, s = (t == null ? void 0 : t.step) ?? 1;
  if (!s)
    return [];
  s < 0 && (s = -s, a = !a);
  const c = [];
  for (; +o <= i; )
    c.push((0, h4.toDate)(o)), o = (0, Cue.addMinutes)(o, s);
  return a ? c.reverse() : c;
}
var bD = {};
bD.eachMonthOfInterval = wue;
var A4 = ne;
function wue(e, t) {
  const r = (0, A4.toDate)(e.start), n = (0, A4.toDate)(e.end);
  let a = +r > +n;
  const i = a ? +r : +n, o = a ? n : r;
  o.setHours(0, 0, 0, 0), o.setDate(1);
  let s = (t == null ? void 0 : t.step) ?? 1;
  if (!s)
    return [];
  s < 0 && (s = -s, a = !a);
  const c = [];
  for (; +o <= i; )
    c.push((0, A4.toDate)(o)), o.setMonth(o.getMonth() + s);
  return a ? c.reverse() : c;
}
var yD = {}, dl = {};
dl.startOfQuarter = Due;
var xue = ne;
function Due(e) {
  const t = (0, xue.toDate)(e), r = t.getMonth(), n = r - r % 3;
  return t.setMonth(n, 1), t.setHours(0, 0, 0, 0), t;
}
yD.eachQuarterOfInterval = Mue;
var Oue = tl, H3 = dl, p4 = ne;
function Mue(e, t) {
  const r = (0, p4.toDate)(e.start), n = (0, p4.toDate)(e.end);
  let a = +r > +n;
  const i = a ? +(0, H3.startOfQuarter)(r) : +(0, H3.startOfQuarter)(n);
  let o = a ? (0, H3.startOfQuarter)(n) : (0, H3.startOfQuarter)(r), s = (t == null ? void 0 : t.step) ?? 1;
  if (!s)
    return [];
  s < 0 && (s = -s, a = !a);
  const c = [];
  for (; +o <= i; )
    c.push((0, p4.toDate)(o)), o = (0, Oue.addQuarters)(o, s);
  return a ? c.reverse() : c;
}
var wD = {};
wD.eachWeekOfInterval = Sue;
var Eue = l3, Y3 = qr, g4 = ne;
function Sue(e, t) {
  const r = (0, g4.toDate)(e.start), n = (0, g4.toDate)(e.end);
  let a = +r > +n;
  const i = a ? (0, Y3.startOfWeek)(n, t) : (0, Y3.startOfWeek)(r, t), o = a ? (0, Y3.startOfWeek)(r, t) : (0, Y3.startOfWeek)(n, t);
  i.setHours(15), o.setHours(15);
  const s = +o.getTime();
  let c = i, u = (t == null ? void 0 : t.step) ?? 1;
  if (!u)
    return [];
  u < 0 && (u = -u, a = !a);
  const d = [];
  for (; +c <= s; )
    c.setHours(0), d.push((0, g4.toDate)(c)), c = (0, Eue.addWeeks)(c, u), c.setHours(15);
  return a ? d.reverse() : d;
}
var fl = {};
fl.eachWeekendOfInterval = Iue;
var Pue = D8, jue = o3;
function Iue(e) {
  const t = (0, Pue.eachDayOfInterval)(e), r = [];
  let n = 0;
  for (; n < t.length; ) {
    const a = t[n++];
    (0, jue.isWeekend)(a) && r.push(a);
  }
  return r;
}
var xD = {}, f3 = {};
f3.startOfMonth = Nue;
var Bue = ne;
function Nue(e) {
  const t = (0, Bue.toDate)(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
xD.eachWeekendOfMonth = Rue;
var Lue = fl, Tue = cl, _ue = f3;
function Rue(e) {
  const t = (0, _ue.startOfMonth)(e), r = (0, Tue.endOfMonth)(e);
  return (0, Lue.eachWeekendOfInterval)({ start: t, end: r });
}
var DD = {}, O8 = {};
O8.endOfYear = $ue;
var Fue = ne;
function $ue(e) {
  const t = (0, Fue.toDate)(e), r = t.getFullYear();
  return t.setFullYear(r + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
var hl = {};
hl.startOfYear = kue;
var Hue = ne, Yue = ke;
function kue(e) {
  const t = (0, Hue.toDate)(e), r = (0, Yue.constructFrom)(e, 0);
  return r.setFullYear(t.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
DD.eachWeekendOfYear = Que;
var Vue = fl, Gue = O8, Wue = hl;
function Que(e) {
  const t = (0, Wue.startOfYear)(e), r = (0, Gue.endOfYear)(e);
  return (0, Vue.eachWeekendOfInterval)({ start: t, end: r });
}
var OD = {};
OD.eachYearOfInterval = Uue;
var v4 = ne;
function Uue(e, t) {
  const r = (0, v4.toDate)(e.start), n = (0, v4.toDate)(e.end);
  let a = +r > +n;
  const i = a ? +r : +n, o = a ? n : r;
  o.setHours(0, 0, 0, 0), o.setMonth(0, 1);
  let s = (t == null ? void 0 : t.step) ?? 1;
  if (!s)
    return [];
  s < 0 && (s = -s, a = !a);
  const c = [];
  for (; +o <= i; )
    c.push((0, v4.toDate)(o)), o.setFullYear(o.getFullYear() + s);
  return a ? c.reverse() : c;
}
var MD = {};
MD.endOfDecade = Kue;
var Zue = ne;
function Kue(e) {
  const t = (0, Zue.toDate)(e), r = t.getFullYear(), n = 9 + Math.floor(r / 10) * 10;
  return t.setFullYear(n, 11, 31), t.setHours(23, 59, 59, 999), t;
}
var ED = {};
ED.endOfHour = que;
var zue = ne;
function que(e) {
  const t = (0, zue.toDate)(e);
  return t.setMinutes(59, 59, 999), t;
}
var SD = {}, M8 = {};
M8.endOfWeek = e6e;
var Xue = ne, Jue = Yt;
function e6e(e, t) {
  var s, c, u, d;
  const r = (0, Jue.getDefaultOptions)(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? r.weekStartsOn ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, a = (0, Xue.toDate)(e), i = a.getDay(), o = (i < n ? -7 : 0) + 6 - (i - n);
  return a.setDate(a.getDate() + o), a.setHours(23, 59, 59, 999), a;
}
SD.endOfISOWeek = r6e;
var t6e = M8;
function r6e(e) {
  return (0, t6e.endOfWeek)(e, { weekStartsOn: 1 });
}
var PD = {};
PD.endOfISOWeekYear = o6e;
var n6e = b1, a6e = pn, i6e = ke;
function o6e(e) {
  const t = (0, n6e.getISOWeekYear)(e), r = (0, i6e.constructFrom)(e, 0);
  r.setFullYear(t + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const n = (0, a6e.startOfISOWeek)(r);
  return n.setMilliseconds(n.getMilliseconds() - 1), n;
}
var jD = {};
jD.endOfMinute = l6e;
var s6e = ne;
function l6e(e) {
  const t = (0, s6e.toDate)(e);
  return t.setSeconds(59, 999), t;
}
var ID = {};
ID.endOfQuarter = u6e;
var c6e = ne;
function u6e(e) {
  const t = (0, c6e.toDate)(e), r = t.getMonth(), n = r - r % 3 + 3;
  return t.setMonth(n, 0), t.setHours(23, 59, 59, 999), t;
}
var BD = {};
BD.endOfSecond = f6e;
var d6e = ne;
function f6e(e) {
  const t = (0, d6e.toDate)(e);
  return t.setMilliseconds(999), t;
}
var ND = {};
ND.endOfToday = A6e;
var h6e = ll;
function A6e() {
  return (0, h6e.endOfDay)(Date.now());
}
var LD = {};
LD.endOfTomorrow = p6e;
function p6e() {
  const e = /* @__PURE__ */ new Date(), t = e.getFullYear(), r = e.getMonth(), n = e.getDate(), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(t, r, n + 1), a.setHours(23, 59, 59, 999), a;
}
var TD = {};
TD.endOfYesterday = g6e;
function g6e() {
  const e = /* @__PURE__ */ new Date(), t = e.getFullYear(), r = e.getMonth(), n = e.getDate(), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(t, r, n - 1), a.setHours(23, 59, 59, 999), a;
}
var E8 = {}, da = {}, Al = {}, S8 = {};
S8.formatDistance = void 0;
const v6e = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, m6e = (e, t, r) => {
  let n;
  const a = v6e[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
S8.formatDistance = m6e;
var P8 = {}, _D = {};
_D.buildFormatLongFn = C6e;
function C6e(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
P8.formatLong = void 0;
var m4 = _D;
const b6e = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, y6e = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, w6e = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
P8.formatLong = {
  date: (0, m4.buildFormatLongFn)({
    formats: b6e,
    defaultWidth: "full"
  }),
  time: (0, m4.buildFormatLongFn)({
    formats: y6e,
    defaultWidth: "full"
  }),
  dateTime: (0, m4.buildFormatLongFn)({
    formats: w6e,
    defaultWidth: "full"
  })
};
var j8 = {};
j8.formatRelative = void 0;
const x6e = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, D6e = (e, t, r, n) => x6e[e];
j8.formatRelative = D6e;
var I8 = {}, RD = {};
RD.buildLocalizeFn = O6e;
function O6e(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let a;
    if (n === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, s = r != null && r.width ? String(r.width) : o;
      a = e.formattingValues[s] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, s = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[s] || e.values[o];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[i];
  };
}
I8.localize = void 0;
var vi = RD;
const M6e = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, E6e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, S6e = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, P6e = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, j6e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, I6e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, B6e = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
};
I8.localize = {
  ordinalNumber: B6e,
  era: (0, vi.buildLocalizeFn)({
    values: M6e,
    defaultWidth: "wide"
  }),
  quarter: (0, vi.buildLocalizeFn)({
    values: E6e,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: (0, vi.buildLocalizeFn)({
    values: S6e,
    defaultWidth: "wide"
  }),
  day: (0, vi.buildLocalizeFn)({
    values: P6e,
    defaultWidth: "wide"
  }),
  dayPeriod: (0, vi.buildLocalizeFn)({
    values: j6e,
    defaultWidth: "wide",
    formattingValues: I6e,
    defaultFormattingWidth: "wide"
  })
};
var B8 = {}, FD = {};
FD.buildMatchFn = N6e;
function N6e(e) {
  return (t, r = {}) => {
    const n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    const o = i[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? T6e(s, (h) => h.test(o)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      L6e(s, (h) => h.test(o))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(c) : c, u = r.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      r.valueCallback(u)
    ) : u;
    const d = t.slice(o.length);
    return { value: u, rest: d };
  };
}
function L6e(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function T6e(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
var $D = {};
$D.buildMatchPatternFn = _6e;
function _6e(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n)
      return null;
    const a = n[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    let o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    const s = t.slice(a.length);
    return { value: o, rest: s };
  };
}
B8.match = void 0;
var mi = FD, R6e = $D;
const F6e = /^(\d+)(th|st|nd|rd)?/i, $6e = /\d+/i, H6e = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Y6e = {
  any: [/^b/i, /^(a|c)/i]
}, k6e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, V6e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, G6e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, W6e = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Q6e = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, U6e = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Z6e = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, K6e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
B8.match = {
  ordinalNumber: (0, R6e.buildMatchPatternFn)({
    matchPattern: F6e,
    parsePattern: $6e,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: (0, mi.buildMatchFn)({
    matchPatterns: H6e,
    defaultMatchWidth: "wide",
    parsePatterns: Y6e,
    defaultParseWidth: "any"
  }),
  quarter: (0, mi.buildMatchFn)({
    matchPatterns: k6e,
    defaultMatchWidth: "wide",
    parsePatterns: V6e,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: (0, mi.buildMatchFn)({
    matchPatterns: G6e,
    defaultMatchWidth: "wide",
    parsePatterns: W6e,
    defaultParseWidth: "any"
  }),
  day: (0, mi.buildMatchFn)({
    matchPatterns: Q6e,
    defaultMatchWidth: "wide",
    parsePatterns: U6e,
    defaultParseWidth: "any"
  }),
  dayPeriod: (0, mi.buildMatchFn)({
    matchPatterns: Z6e,
    defaultMatchWidth: "any",
    parsePatterns: K6e,
    defaultParseWidth: "any"
  })
};
Al.enUS = void 0;
var z6e = S8, q6e = P8, X6e = j8, J6e = I8, e4e = B8;
Al.enUS = {
  code: "en-US",
  formatDistance: z6e.formatDistance,
  formatLong: q6e.formatLong,
  formatRelative: X6e.formatRelative,
  localize: J6e.localize,
  match: e4e.match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
(function(e) {
  Object.defineProperty(e, "defaultLocale", {
    enumerable: !0,
    get: function() {
      return t.enUS;
    }
  });
  var t = Al;
})(da);
var N8 = {}, L8 = {};
L8.getDayOfYear = a4e;
var t4e = Bn, r4e = hl, n4e = ne;
function a4e(e) {
  const t = (0, n4e.toDate)(e);
  return (0, t4e.differenceInCalendarDays)(
    t,
    (0, r4e.startOfYear)(t)
  ) + 1;
}
var pl = {};
pl.getISOWeek = c4e;
var i4e = ce, o4e = pn, s4e = F2, l4e = ne;
function c4e(e) {
  const t = (0, l4e.toDate)(e), r = +(0, o4e.startOfISOWeek)(t) - +(0, s4e.startOfISOWeekYear)(t);
  return Math.round(r / i4e.millisecondsInWeek) + 1;
}
var gl = {}, vl = {}, h3 = {};
h3.getWeekYear = f4e;
var Wv = ke, Qv = qr, u4e = ne, d4e = Yt;
function f4e(e, t) {
  var d, h, A, p;
  const r = (0, u4e.toDate)(e), n = r.getFullYear(), a = (0, d4e.getDefaultOptions)(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((h = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((p = (A = a.locale) == null ? void 0 : A.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, o = (0, Wv.constructFrom)(e, 0);
  o.setFullYear(n + 1, 0, i), o.setHours(0, 0, 0, 0);
  const s = (0, Qv.startOfWeek)(
    o,
    t
  ), c = (0, Wv.constructFrom)(e, 0);
  c.setFullYear(n, 0, i), c.setHours(0, 0, 0, 0);
  const u = (0, Qv.startOfWeek)(
    c,
    t
  );
  return r.getTime() >= s.getTime() ? n + 1 : r.getTime() >= u.getTime() ? n : n - 1;
}
vl.startOfWeekYear = v4e;
var h4e = ke, A4e = h3, p4e = qr, g4e = Yt;
function v4e(e, t) {
  var s, c, u, d;
  const r = (0, g4e.getDefaultOptions)(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, a = (0, A4e.getWeekYear)(e, t), i = (0, h4e.constructFrom)(e, 0);
  return i.setFullYear(a, 0, n), i.setHours(0, 0, 0, 0), (0, p4e.startOfWeek)(i, t);
}
gl.getWeek = w4e;
var m4e = ce, C4e = qr, b4e = vl, y4e = ne;
function w4e(e, t) {
  const r = (0, y4e.toDate)(e), n = +(0, C4e.startOfWeek)(r, t) - +(0, b4e.startOfWeekYear)(r, t);
  return Math.round(n / m4e.millisecondsInWeek) + 1;
}
var fa = {};
fa.addLeadingZeros = x4e;
function x4e(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
var ml = {};
ml.lightFormatters = void 0;
var $n = fa;
ml.lightFormatters = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return (0, $n.addLeadingZeros)(
      t === "yy" ? n % 100 : n,
      t.length
    );
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : (0, $n.addLeadingZeros)(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return (0, $n.addLeadingZeros)(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return (0, $n.addLeadingZeros)(
      e.getHours() % 12 || 12,
      t.length
    );
  },
  // Hour [0-23]
  H(e, t) {
    return (0, $n.addLeadingZeros)(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return (0, $n.addLeadingZeros)(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return (0, $n.addLeadingZeros)(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return (0, $n.addLeadingZeros)(a, t.length);
  }
};
N8.formatters = void 0;
var D4e = L8, O4e = pl, M4e = b1, E4e = gl, S4e = h3, xt = fa, Hn = ml;
const Sa = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
N8.formatters = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, { unit: "year" });
    }
    return Hn.lightFormatters.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const a = (0, S4e.getWeekYear)(e, n), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const o = i % 100;
      return (0, xt.addLeadingZeros)(o, 2);
    }
    return t === "Yo" ? r.ordinalNumber(i, { unit: "year" }) : (0, xt.addLeadingZeros)(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = (0, M4e.getISOWeekYear)(e);
    return (0, xt.addLeadingZeros)(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return (0, xt.addLeadingZeros)(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(n);
      case "QQ":
        return (0, xt.addLeadingZeros)(n, 2);
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(n);
      case "qq":
        return (0, xt.addLeadingZeros)(n, 2);
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Hn.lightFormatters.M(e, t);
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "L":
        return String(n + 1);
      case "LL":
        return (0, xt.addLeadingZeros)(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const a = (0, E4e.getWeek)(e, n);
    return t === "wo" ? r.ordinalNumber(a, { unit: "week" }) : (0, xt.addLeadingZeros)(a, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = (0, O4e.getISOWeek)(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : (0, xt.addLeadingZeros)(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : Hn.lightFormatters.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = (0, D4e.getDayOfYear)(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : (0, xt.addLeadingZeros)(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const a = e.getDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return (0, xt.addLeadingZeros)(i, 2);
      case "eo":
        return r.ordinalNumber(i, { unit: "day" });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const a = e.getDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return (0, xt.addLeadingZeros)(i, t.length);
      case "co":
        return r.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), a = n === 0 ? 7 : n;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return (0, xt.addLeadingZeros)(a, t.length);
      case "io":
        return r.ordinalNumber(a, { unit: "day" });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n === 12 ? a = Sa.noon : n === 0 ? a = Sa.midnight : a = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n >= 17 ? a = Sa.evening : n >= 12 ? a = Sa.afternoon : n >= 4 ? a = Sa.morning : a = Sa.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return Hn.lightFormatters.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : Hn.lightFormatters.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : (0, xt.addLeadingZeros)(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : (0, xt.addLeadingZeros)(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Hn.lightFormatters.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : Hn.lightFormatters.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Hn.lightFormatters.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      case "X":
        return Zv(n);
      case "XXXX":
      case "XX":
        return H1(n);
      case "XXXXX":
      case "XXX":
      default:
        return H1(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Zv(n);
      case "xxxx":
      case "xx":
        return H1(n);
      case "xxxxx":
      case "xxx":
      default:
        return H1(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Uv(n, ":");
      case "OOOO":
      default:
        return "GMT" + H1(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Uv(n, ":");
      case "zzzz":
      default:
        return "GMT" + H1(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(e.getTime() / 1e3);
    return (0, xt.addLeadingZeros)(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    const n = e.getTime();
    return (0, xt.addLeadingZeros)(n, t.length);
  }
};
function Uv(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.trunc(n / 60), i = n % 60;
  return i === 0 ? r + String(a) : r + String(a) + t + (0, xt.addLeadingZeros)(i, 2);
}
function Zv(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + (0, xt.addLeadingZeros)(Math.abs(e) / 60, 2) : H1(e, t);
}
function H1(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = (0, xt.addLeadingZeros)(Math.trunc(n / 60), 2), i = (0, xt.addLeadingZeros)(n % 60, 2);
  return r + a + t + i;
}
var Cl = {};
Cl.longFormatters = void 0;
const Kv = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, HD = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, P4e = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], a = r[2];
  if (!a)
    return Kv(e, t);
  let i;
  switch (n) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Kv(n, t)).replace("{{time}}", HD(a, t));
};
Cl.longFormatters = {
  p: HD,
  P: P4e
};
var A3 = {};
A3.isProtectedDayOfYearToken = N4e;
A3.isProtectedWeekYearToken = L4e;
A3.warnOrThrowProtectedError = T4e;
const j4e = /^D+$/, I4e = /^Y+$/, B4e = ["D", "DD", "YY", "YYYY"];
function N4e(e) {
  return j4e.test(e);
}
function L4e(e) {
  return I4e.test(e);
}
function T4e(e, t, r) {
  const n = _4e(e, t, r);
  if (console.warn(n), B4e.includes(e))
    throw new RangeError(n);
}
function _4e(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
(function(e) {
  e.format = e.formatDate = p, Object.defineProperty(e, "formatters", {
    enumerable: !0,
    get: function() {
      return n.formatters;
    }
  }), Object.defineProperty(e, "longFormatters", {
    enumerable: !0,
    get: function() {
      return a.longFormatters;
    }
  });
  var t = da, r = Yt, n = N8, a = Cl, i = A3, o = Ln, s = ne;
  const c = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, u = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, d = /^'([^]*?)'?$/, h = /''/g, A = /[a-zA-Z]/;
  function p(g, m, b) {
    var N, F, k, R, j, U, ee, X;
    const w = (0, r.getDefaultOptions)(), x = (b == null ? void 0 : b.locale) ?? w.locale ?? t.defaultLocale, y = (b == null ? void 0 : b.firstWeekContainsDate) ?? ((F = (N = b == null ? void 0 : b.locale) == null ? void 0 : N.options) == null ? void 0 : F.firstWeekContainsDate) ?? w.firstWeekContainsDate ?? ((R = (k = w.locale) == null ? void 0 : k.options) == null ? void 0 : R.firstWeekContainsDate) ?? 1, C = (b == null ? void 0 : b.weekStartsOn) ?? ((U = (j = b == null ? void 0 : b.locale) == null ? void 0 : j.options) == null ? void 0 : U.weekStartsOn) ?? w.weekStartsOn ?? ((X = (ee = w.locale) == null ? void 0 : ee.options) == null ? void 0 : X.weekStartsOn) ?? 0, O = (0, s.toDate)(g);
    if (!(0, o.isValid)(O))
      throw new RangeError("Invalid time value");
    let M = m.match(u).map((Z) => {
      const te = Z[0];
      if (te === "p" || te === "P") {
        const B = a.longFormatters[te];
        return B(Z, x.formatLong);
      }
      return Z;
    }).join("").match(c).map((Z) => {
      if (Z === "''")
        return { isToken: !1, value: "'" };
      const te = Z[0];
      if (te === "'")
        return { isToken: !1, value: v(Z) };
      if (n.formatters[te])
        return { isToken: !0, value: Z };
      if (te.match(A))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + te + "`"
        );
      return { isToken: !1, value: Z };
    });
    x.localize.preprocessor && (M = x.localize.preprocessor(O, M));
    const E = {
      firstWeekContainsDate: y,
      weekStartsOn: C,
      locale: x
    };
    return M.map((Z) => {
      if (!Z.isToken)
        return Z.value;
      const te = Z.value;
      (!(b != null && b.useAdditionalWeekYearTokens) && (0, i.isProtectedWeekYearToken)(te) || !(b != null && b.useAdditionalDayOfYearTokens) && (0, i.isProtectedDayOfYearToken)(te)) && (0, i.warnOrThrowProtectedError)(te, m, String(g));
      const B = n.formatters[te[0]];
      return B(O, te, x.localize, E);
    }).join("");
  }
  function v(g) {
    const m = g.match(d);
    return m ? m[1].replace(h, "'") : g;
  }
})(E8);
var T8 = {};
T8.formatDistance = k4e;
var R4e = ua, Pa = ce, F4e = u3, $4e = d3, k3 = ne, H4e = da, Y4e = Yt, zv = Nn;
function k4e(e, t, r) {
  const n = (0, Y4e.getDefaultOptions)(), a = (r == null ? void 0 : r.locale) ?? n.locale ?? H4e.defaultLocale, i = 2520, o = (0, R4e.compareAsc)(e, t);
  if (isNaN(o))
    throw new RangeError("Invalid time value");
  const s = Object.assign({}, r, {
    addSuffix: r == null ? void 0 : r.addSuffix,
    comparison: o
  });
  let c, u;
  o > 0 ? (c = (0, k3.toDate)(t), u = (0, k3.toDate)(e)) : (c = (0, k3.toDate)(e), u = (0, k3.toDate)(t));
  const d = (0, $4e.differenceInSeconds)(u, c), h = ((0, zv.getTimezoneOffsetInMilliseconds)(u) - (0, zv.getTimezoneOffsetInMilliseconds)(c)) / 1e3, A = Math.round((d - h) / 60);
  let p;
  if (A < 2)
    return r != null && r.includeSeconds ? d < 5 ? a.formatDistance("lessThanXSeconds", 5, s) : d < 10 ? a.formatDistance("lessThanXSeconds", 10, s) : d < 20 ? a.formatDistance("lessThanXSeconds", 20, s) : d < 40 ? a.formatDistance("halfAMinute", 0, s) : d < 60 ? a.formatDistance("lessThanXMinutes", 1, s) : a.formatDistance("xMinutes", 1, s) : A === 0 ? a.formatDistance("lessThanXMinutes", 1, s) : a.formatDistance("xMinutes", A, s);
  if (A < 45)
    return a.formatDistance("xMinutes", A, s);
  if (A < 90)
    return a.formatDistance("aboutXHours", 1, s);
  if (A < Pa.minutesInDay) {
    const v = Math.round(A / 60);
    return a.formatDistance("aboutXHours", v, s);
  } else {
    if (A < i)
      return a.formatDistance("xDays", 1, s);
    if (A < Pa.minutesInMonth) {
      const v = Math.round(A / Pa.minutesInDay);
      return a.formatDistance("xDays", v, s);
    } else if (A < Pa.minutesInMonth * 2)
      return p = Math.round(A / Pa.minutesInMonth), a.formatDistance("aboutXMonths", p, s);
  }
  if (p = (0, F4e.differenceInMonths)(u, c), p < 12) {
    const v = Math.round(A / Pa.minutesInMonth);
    return a.formatDistance("xMonths", v, s);
  } else {
    const v = p % 12, g = Math.trunc(p / 12);
    return v < 3 ? a.formatDistance("aboutXYears", g, s) : v < 9 ? a.formatDistance("overXYears", g, s) : a.formatDistance("almostXYears", g + 1, s);
  }
}
var _8 = {};
_8.formatDistanceStrict = U4e;
var V4e = da, G4e = Yt, W4e = Tn, qv = Nn, Q4e = ua, Yn = ce, V3 = ne;
function U4e(e, t, r) {
  const n = (0, G4e.getDefaultOptions)(), a = (r == null ? void 0 : r.locale) ?? n.locale ?? V4e.defaultLocale, i = (0, Q4e.compareAsc)(e, t);
  if (isNaN(i))
    throw new RangeError("Invalid time value");
  const o = Object.assign({}, r, {
    addSuffix: r == null ? void 0 : r.addSuffix,
    comparison: i
  });
  let s, c;
  i > 0 ? (s = (0, V3.toDate)(t), c = (0, V3.toDate)(e)) : (s = (0, V3.toDate)(e), c = (0, V3.toDate)(t));
  const u = (0, W4e.getRoundingMethod)(
    (r == null ? void 0 : r.roundingMethod) ?? "round"
  ), d = c.getTime() - s.getTime(), h = d / Yn.millisecondsInMinute, A = (0, qv.getTimezoneOffsetInMilliseconds)(c) - (0, qv.getTimezoneOffsetInMilliseconds)(s), p = (d - A) / Yn.millisecondsInMinute, v = r == null ? void 0 : r.unit;
  let g;
  if (v ? g = v : h < 1 ? g = "second" : h < 60 ? g = "minute" : h < Yn.minutesInDay ? g = "hour" : p < Yn.minutesInMonth ? g = "day" : p < Yn.minutesInYear ? g = "month" : g = "year", g === "second") {
    const m = u(d / 1e3);
    return a.formatDistance("xSeconds", m, o);
  } else if (g === "minute") {
    const m = u(h);
    return a.formatDistance("xMinutes", m, o);
  } else if (g === "hour") {
    const m = u(h / 60);
    return a.formatDistance("xHours", m, o);
  } else if (g === "day") {
    const m = u(p / Yn.minutesInDay);
    return a.formatDistance("xDays", m, o);
  } else if (g === "month") {
    const m = u(
      p / Yn.minutesInMonth
    );
    return m === 12 && v !== "month" ? a.formatDistance("xYears", 1, o) : a.formatDistance("xMonths", m, o);
  } else {
    const m = u(p / Yn.minutesInYear);
    return a.formatDistance("xYears", m, o);
  }
}
var YD = {};
YD.formatDistanceToNow = z4e;
var Z4e = tr, K4e = T8;
function z4e(e, t) {
  return (0, K4e.formatDistance)(
    e,
    (0, Z4e.constructNow)(e),
    t
  );
}
var kD = {};
kD.formatDistanceToNowStrict = J4e;
var q4e = _8, X4e = tr;
function J4e(e, t) {
  return (0, q4e.formatDistanceStrict)(
    e,
    (0, X4e.constructNow)(e),
    t
  );
}
var VD = {};
VD.formatDuration = n5e;
var e5e = da, t5e = Yt;
const r5e = [
  "years",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds"
];
function n5e(e, t) {
  const r = (0, t5e.getDefaultOptions)(), n = (t == null ? void 0 : t.locale) ?? r.locale ?? e5e.defaultLocale, a = (t == null ? void 0 : t.format) ?? r5e, i = (t == null ? void 0 : t.zero) ?? !1, o = (t == null ? void 0 : t.delimiter) ?? " ";
  return n.formatDistance ? a.reduce((c, u) => {
    const d = `x${u.replace(/(^.)/, (A) => A.toUpperCase())}`, h = e[u];
    return h !== void 0 && (i || e[u]) ? c.concat(n.formatDistance(d, h)) : c;
  }, []).join(o) : "";
}
var GD = {};
GD.formatISO = i5e;
var a5e = ne, kn = fa;
function i5e(e, t) {
  const r = (0, a5e.toDate)(e);
  if (isNaN(r.getTime()))
    throw new RangeError("Invalid time value");
  const n = (t == null ? void 0 : t.format) ?? "extended", a = (t == null ? void 0 : t.representation) ?? "complete";
  let i = "", o = "";
  const s = n === "extended" ? "-" : "", c = n === "extended" ? ":" : "";
  if (a !== "time") {
    const u = (0, kn.addLeadingZeros)(r.getDate(), 2), d = (0, kn.addLeadingZeros)(r.getMonth() + 1, 2);
    i = `${(0, kn.addLeadingZeros)(r.getFullYear(), 4)}${s}${d}${s}${u}`;
  }
  if (a !== "date") {
    const u = r.getTimezoneOffset();
    if (u !== 0) {
      const g = Math.abs(u), m = (0, kn.addLeadingZeros)(
        Math.trunc(g / 60),
        2
      ), b = (0, kn.addLeadingZeros)(g % 60, 2);
      o = `${u < 0 ? "+" : "-"}${m}:${b}`;
    } else
      o = "Z";
    const d = (0, kn.addLeadingZeros)(r.getHours(), 2), h = (0, kn.addLeadingZeros)(r.getMinutes(), 2), A = (0, kn.addLeadingZeros)(r.getSeconds(), 2), p = i === "" ? "" : "T", v = [d, h, A].join(c);
    i = `${i}${p}${v}${o}`;
  }
  return i;
}
var WD = {};
WD.formatISO9075 = l5e;
var o5e = Ln, s5e = ne, ja = fa;
function l5e(e, t) {
  const r = (0, s5e.toDate)(e);
  if (!(0, o5e.isValid)(r))
    throw new RangeError("Invalid time value");
  const n = (t == null ? void 0 : t.format) ?? "extended", a = (t == null ? void 0 : t.representation) ?? "complete";
  let i = "";
  const o = n === "extended" ? "-" : "", s = n === "extended" ? ":" : "";
  if (a !== "time") {
    const c = (0, ja.addLeadingZeros)(r.getDate(), 2), u = (0, ja.addLeadingZeros)(r.getMonth() + 1, 2);
    i = `${(0, ja.addLeadingZeros)(r.getFullYear(), 4)}${o}${u}${o}${c}`;
  }
  if (a !== "date") {
    const c = (0, ja.addLeadingZeros)(r.getHours(), 2), u = (0, ja.addLeadingZeros)(r.getMinutes(), 2), d = (0, ja.addLeadingZeros)(r.getSeconds(), 2);
    i = `${i}${i === "" ? "" : " "}${c}${s}${u}${s}${d}`;
  }
  return i;
}
var QD = {};
QD.formatISODuration = c5e;
function c5e(e) {
  const {
    years: t = 0,
    months: r = 0,
    days: n = 0,
    hours: a = 0,
    minutes: i = 0,
    seconds: o = 0
  } = e;
  return `P${t}Y${r}M${n}DT${a}H${i}M${o}S`;
}
var UD = {};
UD.formatRFC3339 = f5e;
var u5e = Ln, d5e = ne, Vn = fa;
function f5e(e, t) {
  const r = (0, d5e.toDate)(e);
  if (!(0, u5e.isValid)(r))
    throw new RangeError("Invalid time value");
  const n = (t == null ? void 0 : t.fractionDigits) ?? 0, a = (0, Vn.addLeadingZeros)(r.getDate(), 2), i = (0, Vn.addLeadingZeros)(r.getMonth() + 1, 2), o = r.getFullYear(), s = (0, Vn.addLeadingZeros)(r.getHours(), 2), c = (0, Vn.addLeadingZeros)(r.getMinutes(), 2), u = (0, Vn.addLeadingZeros)(r.getSeconds(), 2);
  let d = "";
  if (n > 0) {
    const p = r.getMilliseconds(), v = Math.trunc(
      p * Math.pow(10, n - 3)
    );
    d = "." + (0, Vn.addLeadingZeros)(v, n);
  }
  let h = "";
  const A = r.getTimezoneOffset();
  if (A !== 0) {
    const p = Math.abs(A), v = (0, Vn.addLeadingZeros)(
      Math.trunc(p / 60),
      2
    ), g = (0, Vn.addLeadingZeros)(p % 60, 2);
    h = `${A < 0 ? "+" : "-"}${v}:${g}`;
  } else
    h = "Z";
  return `${o}-${i}-${a}T${s}:${c}:${u}${d}${h}`;
}
var ZD = {};
ZD.formatRFC7231 = v5e;
var h5e = Ln, A5e = ne, G3 = fa;
const p5e = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], g5e = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
function v5e(e) {
  const t = (0, A5e.toDate)(e);
  if (!(0, h5e.isValid)(t))
    throw new RangeError("Invalid time value");
  const r = p5e[t.getUTCDay()], n = (0, G3.addLeadingZeros)(t.getUTCDate(), 2), a = g5e[t.getUTCMonth()], i = t.getUTCFullYear(), o = (0, G3.addLeadingZeros)(t.getUTCHours(), 2), s = (0, G3.addLeadingZeros)(t.getUTCMinutes(), 2), c = (0, G3.addLeadingZeros)(t.getUTCSeconds(), 2);
  return `${r}, ${n} ${a} ${i} ${o}:${s}:${c} GMT`;
}
var KD = {};
KD.formatRelative = w5e;
var m5e = Bn, C5e = E8, Xv = ne, b5e = da, y5e = Yt;
function w5e(e, t, r) {
  var h, A, p, v;
  const n = (0, Xv.toDate)(e), a = (0, Xv.toDate)(t), i = (0, y5e.getDefaultOptions)(), o = (r == null ? void 0 : r.locale) ?? i.locale ?? b5e.defaultLocale, s = (r == null ? void 0 : r.weekStartsOn) ?? ((A = (h = r == null ? void 0 : r.locale) == null ? void 0 : h.options) == null ? void 0 : A.weekStartsOn) ?? i.weekStartsOn ?? ((v = (p = i.locale) == null ? void 0 : p.options) == null ? void 0 : v.weekStartsOn) ?? 0, c = (0, m5e.differenceInCalendarDays)(n, a);
  if (isNaN(c))
    throw new RangeError("Invalid time value");
  let u;
  c < -6 ? u = "other" : c < -1 ? u = "lastWeek" : c < 0 ? u = "yesterday" : c < 1 ? u = "today" : c < 2 ? u = "tomorrow" : c < 7 ? u = "nextWeek" : u = "other";
  const d = o.formatRelative(u, n, a, {
    locale: o,
    weekStartsOn: s
  });
  return (0, C5e.format)(n, d, { locale: o, weekStartsOn: s });
}
var zD = {};
zD.fromUnixTime = D5e;
var x5e = ne;
function D5e(e) {
  return (0, x5e.toDate)(e * 1e3);
}
var R8 = {};
R8.getDate = M5e;
var O5e = ne;
function M5e(e) {
  return (0, O5e.toDate)(e).getDate();
}
var p3 = {};
p3.getDay = S5e;
var E5e = ne;
function S5e(e) {
  return (0, E5e.toDate)(e).getDay();
}
var F8 = {};
F8.getDaysInMonth = I5e;
var P5e = ne, j5e = ke;
function I5e(e) {
  const t = (0, P5e.toDate)(e), r = t.getFullYear(), n = t.getMonth(), a = (0, j5e.constructFrom)(e, 0);
  return a.setFullYear(r, n + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
var qD = {}, $8 = {};
$8.isLeapYear = N5e;
var B5e = ne;
function N5e(e) {
  const r = (0, B5e.toDate)(e).getFullYear();
  return r % 400 === 0 || r % 4 === 0 && r % 100 !== 0;
}
qD.getDaysInYear = _5e;
var L5e = $8, T5e = ne;
function _5e(e) {
  const t = (0, T5e.toDate)(e);
  return String(new Date(t)) === "Invalid Date" ? NaN : (0, L5e.isLeapYear)(t) ? 366 : 365;
}
var XD = {};
XD.getDecade = F5e;
var R5e = ne;
function F5e(e) {
  const r = (0, R5e.toDate)(e).getFullYear();
  return Math.floor(r / 10) * 10;
}
var H8 = {};
H8.getDefaultOptions = H5e;
var $5e = Yt;
function H5e() {
  return Object.assign({}, (0, $5e.getDefaultOptions)());
}
var JD = {};
JD.getHours = k5e;
var Y5e = ne;
function k5e(e) {
  return (0, Y5e.toDate)(e).getHours();
}
var Y8 = {};
Y8.getISODay = G5e;
var V5e = ne;
function G5e(e) {
  let r = (0, V5e.toDate)(e).getDay();
  return r === 0 && (r = 7), r;
}
var eO = {};
eO.getISOWeeksInYear = U5e;
var W5e = l3, Q5e = ce, Jv = F2;
function U5e(e) {
  const t = (0, Jv.startOfISOWeekYear)(e), n = +(0, Jv.startOfISOWeekYear)(
    (0, W5e.addWeeks)(t, 60)
  ) - +t;
  return Math.round(n / Q5e.millisecondsInWeek);
}
var tO = {};
tO.getMilliseconds = K5e;
var Z5e = ne;
function K5e(e) {
  return (0, Z5e.toDate)(e).getMilliseconds();
}
var rO = {};
rO.getMinutes = q5e;
var z5e = ne;
function q5e(e) {
  return (0, z5e.toDate)(e).getMinutes();
}
var nO = {};
nO.getMonth = J5e;
var X5e = ne;
function J5e(e) {
  return (0, X5e.toDate)(e).getMonth();
}
var aO = {};
aO.getOverlappingDaysInIntervals = t7e;
var em = Nn, e7e = ce, W3 = ne;
function t7e(e, t) {
  const [r, n] = [
    +(0, W3.toDate)(e.start),
    +(0, W3.toDate)(e.end)
  ].sort((h, A) => h - A), [a, i] = [
    +(0, W3.toDate)(t.start),
    +(0, W3.toDate)(t.end)
  ].sort((h, A) => h - A);
  if (!(r < i && a < n))
    return 0;
  const s = a < r ? r : a, c = s - (0, em.getTimezoneOffsetInMilliseconds)(s), u = i > n ? n : i, d = u - (0, em.getTimezoneOffsetInMilliseconds)(u);
  return Math.ceil((d - c) / e7e.millisecondsInDay);
}
var iO = {};
iO.getSeconds = n7e;
var r7e = ne;
function n7e(e) {
  return (0, r7e.toDate)(e).getSeconds();
}
var oO = {};
oO.getTime = i7e;
var a7e = ne;
function i7e(e) {
  return (0, a7e.toDate)(e).getTime();
}
var sO = {};
sO.getUnixTime = s7e;
var o7e = ne;
function s7e(e) {
  return Math.trunc(+(0, o7e.toDate)(e) / 1e3);
}
var lO = {};
lO.getWeekOfMonth = f7e;
var l7e = R8, c7e = p3, u7e = f3, d7e = Yt;
function f7e(e, t) {
  var c, u, d, h;
  const r = (0, d7e.getDefaultOptions)(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((u = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? r.weekStartsOn ?? ((h = (d = r.locale) == null ? void 0 : d.options) == null ? void 0 : h.weekStartsOn) ?? 0, a = (0, l7e.getDate)(e);
  if (isNaN(a))
    return NaN;
  const i = (0, c7e.getDay)((0, u7e.startOfMonth)(e));
  let o = n - i;
  o <= 0 && (o += 7);
  const s = a - o;
  return Math.ceil(s / 7) + 1;
}
var cO = {}, k8 = {};
k8.lastDayOfMonth = A7e;
var h7e = ne;
function A7e(e) {
  const t = (0, h7e.toDate)(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(0, 0, 0, 0), t;
}
cO.getWeeksInMonth = m7e;
var p7e = nl, g7e = k8, v7e = f3;
function m7e(e, t) {
  return (0, p7e.differenceInCalendarWeeks)(
    (0, g7e.lastDayOfMonth)(e),
    (0, v7e.startOfMonth)(e),
    t
  ) + 1;
}
var uO = {};
uO.getYear = b7e;
var C7e = ne;
function b7e(e) {
  return (0, C7e.toDate)(e).getFullYear();
}
var dO = {};
dO.hoursToMilliseconds = w7e;
var y7e = ce;
function w7e(e) {
  return Math.trunc(e * y7e.millisecondsInHour);
}
var fO = {};
fO.hoursToMinutes = D7e;
var x7e = ce;
function D7e(e) {
  return Math.trunc(e * x7e.minutesInHour);
}
var hO = {};
hO.hoursToSeconds = M7e;
var O7e = ce;
function M7e(e) {
  return Math.trunc(e * O7e.secondsInHour);
}
var AO = {};
AO.interval = E7e;
var tm = ne;
function E7e(e, t, r) {
  const n = (0, tm.toDate)(e);
  if (isNaN(+n))
    throw new TypeError("Start date is invalid");
  const a = (0, tm.toDate)(t);
  if (isNaN(+a))
    throw new TypeError("End date is invalid");
  if (r != null && r.assertPositive && +n > +a)
    throw new TypeError("End date must be after start date");
  return { start: n, end: a };
}
var pO = {};
pO.intervalToDuration = L7e;
var Ci = s8, S7e = il, P7e = ol, j7e = sl, I7e = u3, B7e = d3, N7e = x8, rm = ne;
function L7e(e) {
  const t = (0, rm.toDate)(e.start), r = (0, rm.toDate)(e.end), n = {}, a = (0, N7e.differenceInYears)(r, t);
  a && (n.years = a);
  const i = (0, Ci.add)(t, { years: n.years }), o = (0, I7e.differenceInMonths)(r, i);
  o && (n.months = o);
  const s = (0, Ci.add)(i, {
    months: n.months
  }), c = (0, S7e.differenceInDays)(r, s);
  c && (n.days = c);
  const u = (0, Ci.add)(s, {
    days: n.days
  }), d = (0, P7e.differenceInHours)(r, u);
  d && (n.hours = d);
  const h = (0, Ci.add)(u, {
    hours: n.hours
  }), A = (0, j7e.differenceInMinutes)(r, h);
  A && (n.minutes = A);
  const p = (0, Ci.add)(h, {
    minutes: n.minutes
  }), v = (0, B7e.differenceInSeconds)(r, p);
  return v && (n.seconds = v), n;
}
var gO = {};
gO.intlFormat = _7e;
var T7e = ne;
function _7e(e, t, r) {
  let n;
  return R7e(t) ? n = t : r = t, new Intl.DateTimeFormat(r == null ? void 0 : r.locale, n).format(
    (0, T7e.toDate)(e)
  );
}
function R7e(e) {
  return e !== void 0 && !("locale" in e);
}
var vO = {};
vO.intlFormatDistance = F7e;
var j1 = ce, C4 = Bn, nm = rl, b4 = C8, am = nl, y4 = al, im = ol, om = sl, w4 = d3, sm = ne;
function F7e(e, t, r) {
  let n = 0, a;
  const i = (0, sm.toDate)(e), o = (0, sm.toDate)(t);
  if (r != null && r.unit)
    a = r == null ? void 0 : r.unit, a === "second" ? n = (0, w4.differenceInSeconds)(i, o) : a === "minute" ? n = (0, om.differenceInMinutes)(i, o) : a === "hour" ? n = (0, im.differenceInHours)(i, o) : a === "day" ? n = (0, C4.differenceInCalendarDays)(i, o) : a === "week" ? n = (0, am.differenceInCalendarWeeks)(i, o) : a === "month" ? n = (0, nm.differenceInCalendarMonths)(i, o) : a === "quarter" ? n = (0, b4.differenceInCalendarQuarters)(i, o) : a === "year" && (n = (0, y4.differenceInCalendarYears)(i, o));
  else {
    const c = (0, w4.differenceInSeconds)(i, o);
    Math.abs(c) < j1.secondsInMinute ? (n = (0, w4.differenceInSeconds)(i, o), a = "second") : Math.abs(c) < j1.secondsInHour ? (n = (0, om.differenceInMinutes)(i, o), a = "minute") : Math.abs(c) < j1.secondsInDay && Math.abs((0, C4.differenceInCalendarDays)(i, o)) < 1 ? (n = (0, im.differenceInHours)(i, o), a = "hour") : Math.abs(c) < j1.secondsInWeek && (n = (0, C4.differenceInCalendarDays)(i, o)) && Math.abs(n) < 7 ? a = "day" : Math.abs(c) < j1.secondsInMonth ? (n = (0, am.differenceInCalendarWeeks)(i, o), a = "week") : Math.abs(c) < j1.secondsInQuarter ? (n = (0, nm.differenceInCalendarMonths)(i, o), a = "month") : Math.abs(c) < j1.secondsInYear && (0, b4.differenceInCalendarQuarters)(i, o) < 4 ? (n = (0, b4.differenceInCalendarQuarters)(i, o), a = "quarter") : (n = (0, y4.differenceInCalendarYears)(i, o), a = "year");
  }
  return new Intl.RelativeTimeFormat(r == null ? void 0 : r.locale, {
    localeMatcher: r == null ? void 0 : r.localeMatcher,
    numeric: (r == null ? void 0 : r.numeric) || "auto",
    style: r == null ? void 0 : r.style
  }).format(n, a);
}
var mO = {};
mO.isAfter = $7e;
var lm = ne;
function $7e(e, t) {
  const r = (0, lm.toDate)(e), n = (0, lm.toDate)(t);
  return r.getTime() > n.getTime();
}
var CO = {};
CO.isBefore = H7e;
var cm = ne;
function H7e(e, t) {
  const r = (0, cm.toDate)(e), n = (0, cm.toDate)(t);
  return +r < +n;
}
var bO = {};
bO.isEqual = Y7e;
var um = ne;
function Y7e(e, t) {
  const r = (0, um.toDate)(e), n = (0, um.toDate)(t);
  return +r == +n;
}
var yO = {};
yO.isExists = k7e;
function k7e(e, t, r) {
  const n = new Date(e, t, r);
  return n.getFullYear() === e && n.getMonth() === t && n.getDate() === r;
}
var wO = {};
wO.isFirstDayOfMonth = G7e;
var V7e = ne;
function G7e(e) {
  return (0, V7e.toDate)(e).getDate() === 1;
}
var xO = {};
xO.isFriday = Q7e;
var W7e = ne;
function Q7e(e) {
  return (0, W7e.toDate)(e).getDay() === 5;
}
var DO = {};
DO.isFuture = Z7e;
var U7e = ne;
function Z7e(e) {
  return +(0, U7e.toDate)(e) > Date.now();
}
var OO = {}, V8 = {}, G8 = {}, W8 = {}, Ve = {}, i1 = {}, Q8 = {};
Q8.transpose = z7e;
var K7e = ke;
function z7e(e, t) {
  const r = t instanceof Date ? (0, K7e.constructFrom)(t, 0) : new t(0);
  return r.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), r.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), r;
}
i1.ValueSetter = i1.Setter = i1.DateToSystemTimezoneSetter = void 0;
var q7e = Q8, X7e = ke;
const J7e = 10;
class U8 {
  constructor() {
    fe(this, "subPriority", 0);
  }
  validate(t, r) {
    return !0;
  }
}
i1.Setter = U8;
class e9e extends U8 {
  constructor(t, r, n, a, i) {
    super(), this.value = t, this.validateValue = r, this.setValue = n, this.priority = a, i && (this.subPriority = i);
  }
  validate(t, r) {
    return this.validateValue(t, this.value, r);
  }
  set(t, r, n) {
    return this.setValue(t, r, this.value, n);
  }
}
i1.ValueSetter = e9e;
class t9e extends U8 {
  constructor() {
    super(...arguments);
    fe(this, "priority", J7e);
    fe(this, "subPriority", -1);
  }
  set(r, n) {
    return n.timestampIsSet ? r : (0, X7e.constructFrom)(r, (0, q7e.transpose)(r, Date));
  }
}
i1.DateToSystemTimezoneSetter = t9e;
Ve.Parser = void 0;
var r9e = i1;
class n9e {
  run(t, r, n, a) {
    const i = this.parse(t, r, n, a);
    return i ? {
      setter: new r9e.ValueSetter(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(t, r, n) {
    return !0;
  }
}
Ve.Parser = n9e;
W8.EraParser = void 0;
var a9e = Ve;
class i9e extends a9e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 140);
    fe(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(r, { width: "abbreviated" }) || a.era(r, { width: "narrow" });
      case "GGGGG":
        return a.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return a.era(r, { width: "wide" }) || a.era(r, { width: "abbreviated" }) || a.era(r, { width: "narrow" });
    }
  }
  set(r, n, a) {
    return n.era = a, r.setFullYear(a, 0, 1), r.setHours(0, 0, 0, 0), r;
  }
}
W8.EraParser = i9e;
var Z8 = {}, Le = {}, It = {};
It.timezonePatterns = It.numericPatterns = void 0;
It.numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
};
It.timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
Le.dayPeriodEnumToHours = d9e;
Le.isLeapYearIndex = h9e;
Le.mapValue = o9e;
Le.normalizeTwoDigitYear = f9e;
Le.parseAnyDigitsSigned = l9e;
Le.parseNDigits = c9e;
Le.parseNDigitsSigned = u9e;
Le.parseNumericPattern = Er;
Le.parseTimezonePattern = s9e;
var x4 = ce, wn = It;
function o9e(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Er(e, t) {
  const r = t.match(e);
  return r ? {
    value: parseInt(r[0], 10),
    rest: t.slice(r[0].length)
  } : null;
}
function s9e(e, t) {
  const r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const n = r[1] === "+" ? 1 : -1, a = r[2] ? parseInt(r[2], 10) : 0, i = r[3] ? parseInt(r[3], 10) : 0, o = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: n * (a * x4.millisecondsInHour + i * x4.millisecondsInMinute + o * x4.millisecondsInSecond),
    rest: t.slice(r[0].length)
  };
}
function l9e(e) {
  return Er(
    wn.numericPatterns.anyDigitsSigned,
    e
  );
}
function c9e(e, t) {
  switch (e) {
    case 1:
      return Er(
        wn.numericPatterns.singleDigit,
        t
      );
    case 2:
      return Er(
        wn.numericPatterns.twoDigits,
        t
      );
    case 3:
      return Er(
        wn.numericPatterns.threeDigits,
        t
      );
    case 4:
      return Er(
        wn.numericPatterns.fourDigits,
        t
      );
    default:
      return Er(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function u9e(e, t) {
  switch (e) {
    case 1:
      return Er(
        wn.numericPatterns.singleDigitSigned,
        t
      );
    case 2:
      return Er(
        wn.numericPatterns.twoDigitsSigned,
        t
      );
    case 3:
      return Er(
        wn.numericPatterns.threeDigitsSigned,
        t
      );
    case 4:
      return Er(
        wn.numericPatterns.fourDigitsSigned,
        t
      );
    default:
      return Er(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function d9e(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function f9e(e, t) {
  const r = t > 0, n = r ? t : 1 - t;
  let a;
  if (n <= 50)
    a = e || 100;
  else {
    const i = n + 50, o = Math.trunc(i / 100) * 100, s = e >= i % 100;
    a = e + o - (s ? 100 : 0);
  }
  return r ? a : 1 - a;
}
function h9e(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
Z8.YearParser = void 0;
var A9e = Ve, Ia = Le;
class p9e extends A9e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 130);
    fe(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(r, n, a) {
    const i = (o) => ({
      year: o,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return (0, Ia.mapValue)(
          (0, Ia.parseNDigits)(4, r),
          i
        );
      case "yo":
        return (0, Ia.mapValue)(
          a.ordinalNumber(r, {
            unit: "year"
          }),
          i
        );
      default:
        return (0, Ia.mapValue)(
          (0, Ia.parseNDigits)(n.length, r),
          i
        );
    }
  }
  validate(r, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(r, n, a) {
    const i = r.getFullYear();
    if (a.isTwoDigitYear) {
      const s = (0, Ia.normalizeTwoDigitYear)(
        a.year,
        i
      );
      return r.setFullYear(s, 0, 1), r.setHours(0, 0, 0, 0), r;
    }
    const o = !("era" in n) || n.era === 1 ? a.year : 1 - a.year;
    return r.setFullYear(o, 0, 1), r.setHours(0, 0, 0, 0), r;
  }
}
Z8.YearParser = p9e;
var K8 = {};
K8.LocalWeekYearParser = void 0;
var g9e = h3, dm = qr, v9e = Ve, Ba = Le;
class m9e extends v9e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 130);
    fe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    const i = (o) => ({
      year: o,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return (0, Ba.mapValue)(
          (0, Ba.parseNDigits)(4, r),
          i
        );
      case "Yo":
        return (0, Ba.mapValue)(
          a.ordinalNumber(r, {
            unit: "year"
          }),
          i
        );
      default:
        return (0, Ba.mapValue)(
          (0, Ba.parseNDigits)(n.length, r),
          i
        );
    }
  }
  validate(r, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(r, n, a, i) {
    const o = (0, g9e.getWeekYear)(r, i);
    if (a.isTwoDigitYear) {
      const c = (0, Ba.normalizeTwoDigitYear)(
        a.year,
        o
      );
      return r.setFullYear(
        c,
        0,
        i.firstWeekContainsDate
      ), r.setHours(0, 0, 0, 0), (0, dm.startOfWeek)(r, i);
    }
    const s = !("era" in n) || n.era === 1 ? a.year : 1 - a.year;
    return r.setFullYear(s, 0, i.firstWeekContainsDate), r.setHours(0, 0, 0, 0), (0, dm.startOfWeek)(r, i);
  }
}
K8.LocalWeekYearParser = m9e;
var z8 = {};
z8.ISOWeekYearParser = void 0;
var C9e = pn, b9e = ke, y9e = Ve, fm = Le;
class w9e extends y9e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 130);
    fe(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n) {
    return n === "R" ? (0, fm.parseNDigitsSigned)(4, r) : (0, fm.parseNDigitsSigned)(n.length, r);
  }
  set(r, n, a) {
    const i = (0, b9e.constructFrom)(r, 0);
    return i.setFullYear(a, 0, 4), i.setHours(0, 0, 0, 0), (0, C9e.startOfISOWeek)(i);
  }
}
z8.ISOWeekYearParser = w9e;
var q8 = {};
q8.ExtendedYearParser = void 0;
var x9e = Ve, hm = Le;
class D9e extends x9e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 130);
    fe(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(r, n) {
    return n === "u" ? (0, hm.parseNDigitsSigned)(4, r) : (0, hm.parseNDigitsSigned)(n.length, r);
  }
  set(r, n, a) {
    return r.setFullYear(a, 0, 1), r.setHours(0, 0, 0, 0), r;
  }
}
q8.ExtendedYearParser = D9e;
var X8 = {};
X8.QuarterParser = void 0;
var O9e = Ve, M9e = Le;
class E9e extends O9e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 120);
    fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "Q":
      case "QQ":
        return (0, M9e.parseNDigits)(n.length, r);
      case "Qo":
        return a.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return a.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(r, {
          width: "wide",
          context: "formatting"
        }) || a.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 4;
  }
  set(r, n, a) {
    return r.setMonth((a - 1) * 3, 1), r.setHours(0, 0, 0, 0), r;
  }
}
X8.QuarterParser = E9e;
var J8 = {};
J8.StandAloneQuarterParser = void 0;
var S9e = Ve, P9e = Le;
class j9e extends S9e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 120);
    fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "q":
      case "qq":
        return (0, P9e.parseNDigits)(n.length, r);
      case "qo":
        return a.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return a.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(r, {
          width: "wide",
          context: "standalone"
        }) || a.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 4;
  }
  set(r, n, a) {
    return r.setMonth((a - 1) * 3, 1), r.setHours(0, 0, 0, 0), r;
  }
}
J8.StandAloneQuarterParser = j9e;
var ed = {};
ed.MonthParser = void 0;
var I9e = It, B9e = Ve, bi = Le;
class N9e extends B9e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    fe(this, "priority", 110);
  }
  parse(r, n, a) {
    const i = (o) => o - 1;
    switch (n) {
      case "M":
        return (0, bi.mapValue)(
          (0, bi.parseNumericPattern)(
            I9e.numericPatterns.month,
            r
          ),
          i
        );
      case "MM":
        return (0, bi.mapValue)(
          (0, bi.parseNDigits)(2, r),
          i
        );
      case "Mo":
        return (0, bi.mapValue)(
          a.ordinalNumber(r, {
            unit: "month"
          }),
          i
        );
      case "MMM":
        return a.month(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(r, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return a.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(r, { width: "wide", context: "formatting" }) || a.month(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(r, { width: "narrow", context: "formatting" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 11;
  }
  set(r, n, a) {
    return r.setMonth(a, 1), r.setHours(0, 0, 0, 0), r;
  }
}
ed.MonthParser = N9e;
var td = {};
td.StandAloneMonthParser = void 0;
var L9e = It, T9e = Ve, yi = Le;
class _9e extends T9e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 110);
    fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    const i = (o) => o - 1;
    switch (n) {
      case "L":
        return (0, yi.mapValue)(
          (0, yi.parseNumericPattern)(
            L9e.numericPatterns.month,
            r
          ),
          i
        );
      case "LL":
        return (0, yi.mapValue)(
          (0, yi.parseNDigits)(2, r),
          i
        );
      case "Lo":
        return (0, yi.mapValue)(
          a.ordinalNumber(r, {
            unit: "month"
          }),
          i
        );
      case "LLL":
        return a.month(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(r, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return a.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(r, { width: "wide", context: "standalone" }) || a.month(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(r, { width: "narrow", context: "standalone" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 11;
  }
  set(r, n, a) {
    return r.setMonth(a, 1), r.setHours(0, 0, 0, 0), r;
  }
}
td.StandAloneMonthParser = _9e;
var rd = {}, nd = {};
nd.setWeek = $9e;
var R9e = gl, F9e = ne;
function $9e(e, t, r) {
  const n = (0, F9e.toDate)(e), a = (0, R9e.getWeek)(n, r) - t;
  return n.setDate(n.getDate() - a * 7), n;
}
rd.LocalWeekParser = void 0;
var H9e = nd, Y9e = qr, k9e = It, V9e = Ve, Am = Le;
class G9e extends V9e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 100);
    fe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "w":
        return (0, Am.parseNumericPattern)(
          k9e.numericPatterns.week,
          r
        );
      case "wo":
        return a.ordinalNumber(r, { unit: "week" });
      default:
        return (0, Am.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 53;
  }
  set(r, n, a, i) {
    return (0, Y9e.startOfWeek)(
      (0, H9e.setWeek)(r, a, i),
      i
    );
  }
}
rd.LocalWeekParser = G9e;
var ad = {}, id = {};
id.setISOWeek = U9e;
var W9e = pl, Q9e = ne;
function U9e(e, t) {
  const r = (0, Q9e.toDate)(e), n = (0, W9e.getISOWeek)(r) - t;
  return r.setDate(r.getDate() - n * 7), r;
}
ad.ISOWeekParser = void 0;
var Z9e = id, K9e = pn, z9e = It, q9e = Ve, pm = Le;
class X9e extends q9e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 100);
    fe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "I":
        return (0, pm.parseNumericPattern)(
          z9e.numericPatterns.week,
          r
        );
      case "Io":
        return a.ordinalNumber(r, { unit: "week" });
      default:
        return (0, pm.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 53;
  }
  set(r, n, a) {
    return (0, K9e.startOfISOWeek)((0, Z9e.setISOWeek)(r, a));
  }
}
ad.ISOWeekParser = X9e;
var od = {};
od.DateParser = void 0;
var J9e = It, e8e = Ve, D4 = Le;
const t8e = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], r8e = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class n8e extends e8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 90);
    fe(this, "subPriority", 1);
    fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "d":
        return (0, D4.parseNumericPattern)(
          J9e.numericPatterns.date,
          r
        );
      case "do":
        return a.ordinalNumber(r, { unit: "date" });
      default:
        return (0, D4.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    const a = r.getFullYear(), i = (0, D4.isLeapYearIndex)(a), o = r.getMonth();
    return i ? n >= 1 && n <= r8e[o] : n >= 1 && n <= t8e[o];
  }
  set(r, n, a) {
    return r.setDate(a), r.setHours(0, 0, 0, 0), r;
  }
}
od.DateParser = n8e;
var sd = {};
sd.DayOfYearParser = void 0;
var a8e = It, i8e = Ve, O4 = Le;
class o8e extends i8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 90);
    fe(this, "subpriority", 1);
    fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "D":
      case "DD":
        return (0, O4.parseNumericPattern)(
          a8e.numericPatterns.dayOfYear,
          r
        );
      case "Do":
        return a.ordinalNumber(r, { unit: "date" });
      default:
        return (0, O4.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    const a = r.getFullYear();
    return (0, O4.isLeapYearIndex)(a) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(r, n, a) {
    return r.setMonth(0, a), r.setHours(0, 0, 0, 0), r;
  }
}
sd.DayOfYearParser = o8e;
var ld = {}, g3 = {};
g3.setDay = u8e;
var s8e = An, l8e = ne, c8e = Yt;
function u8e(e, t, r) {
  var h, A, p, v;
  const n = (0, c8e.getDefaultOptions)(), a = (r == null ? void 0 : r.weekStartsOn) ?? ((A = (h = r == null ? void 0 : r.locale) == null ? void 0 : h.options) == null ? void 0 : A.weekStartsOn) ?? n.weekStartsOn ?? ((v = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : v.weekStartsOn) ?? 0, i = (0, l8e.toDate)(e), o = i.getDay(), c = (t % 7 + 7) % 7, u = 7 - a, d = t < 0 || t > 6 ? t - (o + u) % 7 : (c + u) % 7 - (o + u) % 7;
  return (0, s8e.addDays)(i, d);
}
ld.DayParser = void 0;
var d8e = g3, f8e = Ve;
class h8e extends f8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 90);
    fe(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return a.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return a.day(r, { width: "wide", context: "formatting" }) || a.day(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 6;
  }
  set(r, n, a, i) {
    return r = (0, d8e.setDay)(r, a, i), r.setHours(0, 0, 0, 0), r;
  }
}
ld.DayParser = h8e;
var cd = {};
cd.LocalDayParser = void 0;
var A8e = g3, p8e = Ve, M4 = Le;
class g8e extends p8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 90);
    fe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a, i) {
    const o = (s) => {
      const c = Math.floor((s - 1) / 7) * 7;
      return (s + i.weekStartsOn + 6) % 7 + c;
    };
    switch (n) {
      case "e":
      case "ee":
        return (0, M4.mapValue)(
          (0, M4.parseNDigits)(n.length, r),
          o
        );
      case "eo":
        return (0, M4.mapValue)(
          a.ordinalNumber(r, {
            unit: "day"
          }),
          o
        );
      case "eee":
        return a.day(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
      case "eeeee":
        return a.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return a.day(r, { width: "wide", context: "formatting" }) || a.day(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 6;
  }
  set(r, n, a, i) {
    return r = (0, A8e.setDay)(r, a, i), r.setHours(0, 0, 0, 0), r;
  }
}
cd.LocalDayParser = g8e;
var ud = {};
ud.StandAloneLocalDayParser = void 0;
var v8e = g3, m8e = Ve, E4 = Le;
class C8e extends m8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 90);
    fe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(r, n, a, i) {
    const o = (s) => {
      const c = Math.floor((s - 1) / 7) * 7;
      return (s + i.weekStartsOn + 6) % 7 + c;
    };
    switch (n) {
      case "c":
      case "cc":
        return (0, E4.mapValue)(
          (0, E4.parseNDigits)(n.length, r),
          o
        );
      case "co":
        return (0, E4.mapValue)(
          a.ordinalNumber(r, {
            unit: "day"
          }),
          o
        );
      case "ccc":
        return a.day(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(r, { width: "short", context: "standalone" }) || a.day(r, { width: "narrow", context: "standalone" });
      case "ccccc":
        return a.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(r, { width: "short", context: "standalone" }) || a.day(r, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return a.day(r, { width: "wide", context: "standalone" }) || a.day(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(r, { width: "short", context: "standalone" }) || a.day(r, { width: "narrow", context: "standalone" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 6;
  }
  set(r, n, a, i) {
    return r = (0, v8e.setDay)(r, a, i), r.setHours(0, 0, 0, 0), r;
  }
}
ud.StandAloneLocalDayParser = C8e;
var dd = {}, fd = {};
fd.setISODay = x8e;
var b8e = An, y8e = Y8, w8e = ne;
function x8e(e, t) {
  const r = (0, w8e.toDate)(e), n = (0, y8e.getISODay)(r), a = t - n;
  return (0, b8e.addDays)(r, a);
}
dd.ISODayParser = void 0;
var D8e = fd, O8e = Ve, wi = Le;
class M8e extends O8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 90);
    fe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    const i = (o) => o === 0 ? 7 : o;
    switch (n) {
      case "i":
      case "ii":
        return (0, wi.parseNDigits)(n.length, r);
      case "io":
        return a.ordinalNumber(r, { unit: "day" });
      case "iii":
        return (0, wi.mapValue)(
          a.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(r, {
            width: "short",
            context: "formatting"
          }) || a.day(r, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiii":
        return (0, wi.mapValue)(
          a.day(r, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiiii":
        return (0, wi.mapValue)(
          a.day(r, {
            width: "short",
            context: "formatting"
          }) || a.day(r, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiii":
      default:
        return (0, wi.mapValue)(
          a.day(r, {
            width: "wide",
            context: "formatting"
          }) || a.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(r, {
            width: "short",
            context: "formatting"
          }) || a.day(r, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 7;
  }
  set(r, n, a) {
    return r = (0, D8e.setISODay)(r, a), r.setHours(0, 0, 0, 0), r;
  }
}
dd.ISODayParser = M8e;
var hd = {};
hd.AMPMParser = void 0;
var E8e = Ve, S8e = Le;
class P8e extends E8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 80);
    fe(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(r, n, a) {
    return r.setHours((0, S8e.dayPeriodEnumToHours)(a), 0, 0, 0), r;
  }
}
hd.AMPMParser = P8e;
var Ad = {};
Ad.AMPMMidnightParser = void 0;
var j8e = Ve, I8e = Le;
class B8e extends j8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 80);
    fe(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(r, n, a) {
    return r.setHours((0, I8e.dayPeriodEnumToHours)(a), 0, 0, 0), r;
  }
}
Ad.AMPMMidnightParser = B8e;
var pd = {};
pd.DayPeriodParser = void 0;
var N8e = Ve, L8e = Le;
class T8e extends N8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 80);
    fe(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(r, n, a) {
    return r.setHours((0, L8e.dayPeriodEnumToHours)(a), 0, 0, 0), r;
  }
}
pd.DayPeriodParser = T8e;
var gd = {};
gd.Hour1to12Parser = void 0;
var _8e = It, R8e = Ve, gm = Le;
class F8e extends R8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 70);
    fe(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "h":
        return (0, gm.parseNumericPattern)(
          _8e.numericPatterns.hour12h,
          r
        );
      case "ho":
        return a.ordinalNumber(r, { unit: "hour" });
      default:
        return (0, gm.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 12;
  }
  set(r, n, a) {
    const i = r.getHours() >= 12;
    return i && a < 12 ? r.setHours(a + 12, 0, 0, 0) : !i && a === 12 ? r.setHours(0, 0, 0, 0) : r.setHours(a, 0, 0, 0), r;
  }
}
gd.Hour1to12Parser = F8e;
var vd = {};
vd.Hour0to23Parser = void 0;
var $8e = It, H8e = Ve, vm = Le;
class Y8e extends H8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 70);
    fe(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "H":
        return (0, vm.parseNumericPattern)(
          $8e.numericPatterns.hour23h,
          r
        );
      case "Ho":
        return a.ordinalNumber(r, { unit: "hour" });
      default:
        return (0, vm.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 23;
  }
  set(r, n, a) {
    return r.setHours(a, 0, 0, 0), r;
  }
}
vd.Hour0to23Parser = Y8e;
var md = {};
md.Hour0To11Parser = void 0;
var k8e = It, V8e = Ve, mm = Le;
class G8e extends V8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 70);
    fe(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "K":
        return (0, mm.parseNumericPattern)(
          k8e.numericPatterns.hour11h,
          r
        );
      case "Ko":
        return a.ordinalNumber(r, { unit: "hour" });
      default:
        return (0, mm.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 11;
  }
  set(r, n, a) {
    return r.getHours() >= 12 && a < 12 ? r.setHours(a + 12, 0, 0, 0) : r.setHours(a, 0, 0, 0), r;
  }
}
md.Hour0To11Parser = G8e;
var Cd = {};
Cd.Hour1To24Parser = void 0;
var W8e = It, Q8e = Ve, Cm = Le;
class U8e extends Q8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 70);
    fe(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "k":
        return (0, Cm.parseNumericPattern)(
          W8e.numericPatterns.hour24h,
          r
        );
      case "ko":
        return a.ordinalNumber(r, { unit: "hour" });
      default:
        return (0, Cm.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 24;
  }
  set(r, n, a) {
    const i = a <= 24 ? a % 24 : a;
    return r.setHours(i, 0, 0, 0), r;
  }
}
Cd.Hour1To24Parser = U8e;
var bd = {};
bd.MinuteParser = void 0;
var Z8e = It, K8e = Ve, bm = Le;
class z8e extends K8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 60);
    fe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "m":
        return (0, bm.parseNumericPattern)(
          Z8e.numericPatterns.minute,
          r
        );
      case "mo":
        return a.ordinalNumber(r, { unit: "minute" });
      default:
        return (0, bm.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 59;
  }
  set(r, n, a) {
    return r.setMinutes(a, 0, 0), r;
  }
}
bd.MinuteParser = z8e;
var yd = {};
yd.SecondParser = void 0;
var q8e = It, X8e = Ve, ym = Le;
class J8e extends X8e.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 50);
    fe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "s":
        return (0, ym.parseNumericPattern)(
          q8e.numericPatterns.second,
          r
        );
      case "so":
        return a.ordinalNumber(r, { unit: "second" });
      default:
        return (0, ym.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 59;
  }
  set(r, n, a) {
    return r.setSeconds(a, 0), r;
  }
}
yd.SecondParser = J8e;
var wd = {};
wd.FractionOfSecondParser = void 0;
var ede = Ve, wm = Le;
class tde extends ede.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 30);
    fe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(r, n) {
    const a = (i) => Math.trunc(i * Math.pow(10, -n.length + 3));
    return (0, wm.mapValue)(
      (0, wm.parseNDigits)(n.length, r),
      a
    );
  }
  set(r, n, a) {
    return r.setMilliseconds(a), r;
  }
}
wd.FractionOfSecondParser = tde;
var xd = {};
xd.ISOTimezoneWithZParser = void 0;
var rde = ke, nde = Nn, xi = It, ade = Ve, Di = Le;
class ide extends ade.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 10);
    fe(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(r, n) {
    switch (n) {
      case "X":
        return (0, Di.parseTimezonePattern)(
          xi.timezonePatterns.basicOptionalMinutes,
          r
        );
      case "XX":
        return (0, Di.parseTimezonePattern)(
          xi.timezonePatterns.basic,
          r
        );
      case "XXXX":
        return (0, Di.parseTimezonePattern)(
          xi.timezonePatterns.basicOptionalSeconds,
          r
        );
      case "XXXXX":
        return (0, Di.parseTimezonePattern)(
          xi.timezonePatterns.extendedOptionalSeconds,
          r
        );
      case "XXX":
      default:
        return (0, Di.parseTimezonePattern)(
          xi.timezonePatterns.extended,
          r
        );
    }
  }
  set(r, n, a) {
    return n.timestampIsSet ? r : (0, rde.constructFrom)(
      r,
      r.getTime() - (0, nde.getTimezoneOffsetInMilliseconds)(r) - a
    );
  }
}
xd.ISOTimezoneWithZParser = ide;
var Dd = {};
Dd.ISOTimezoneParser = void 0;
var ode = ke, sde = Nn, Oi = It, lde = Ve, Mi = Le;
class cde extends lde.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 10);
    fe(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(r, n) {
    switch (n) {
      case "x":
        return (0, Mi.parseTimezonePattern)(
          Oi.timezonePatterns.basicOptionalMinutes,
          r
        );
      case "xx":
        return (0, Mi.parseTimezonePattern)(
          Oi.timezonePatterns.basic,
          r
        );
      case "xxxx":
        return (0, Mi.parseTimezonePattern)(
          Oi.timezonePatterns.basicOptionalSeconds,
          r
        );
      case "xxxxx":
        return (0, Mi.parseTimezonePattern)(
          Oi.timezonePatterns.extendedOptionalSeconds,
          r
        );
      case "xxx":
      default:
        return (0, Mi.parseTimezonePattern)(
          Oi.timezonePatterns.extended,
          r
        );
    }
  }
  set(r, n, a) {
    return n.timestampIsSet ? r : (0, ode.constructFrom)(
      r,
      r.getTime() - (0, sde.getTimezoneOffsetInMilliseconds)(r) - a
    );
  }
}
Dd.ISOTimezoneParser = cde;
var Od = {};
Od.TimestampSecondsParser = void 0;
var ude = ke, dde = Ve, fde = Le;
class hde extends dde.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 40);
    fe(this, "incompatibleTokens", "*");
  }
  parse(r) {
    return (0, fde.parseAnyDigitsSigned)(r);
  }
  set(r, n, a) {
    return [
      (0, ude.constructFrom)(r, a * 1e3),
      { timestampIsSet: !0 }
    ];
  }
}
Od.TimestampSecondsParser = hde;
var Md = {};
Md.TimestampMillisecondsParser = void 0;
var Ade = ke, pde = Ve, gde = Le;
class vde extends pde.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 20);
    fe(this, "incompatibleTokens", "*");
  }
  parse(r) {
    return (0, gde.parseAnyDigitsSigned)(r);
  }
  set(r, n, a) {
    return [(0, Ade.constructFrom)(r, a), { timestampIsSet: !0 }];
  }
}
Md.TimestampMillisecondsParser = vde;
G8.parsers = void 0;
var mde = W8, Cde = Z8, bde = K8, yde = z8, wde = q8, xde = X8, Dde = J8, Ode = ed, Mde = td, Ede = rd, Sde = ad, Pde = od, jde = sd, Ide = ld, Bde = cd, Nde = ud, Lde = dd, Tde = hd, _de = Ad, Rde = pd, Fde = gd, $de = vd, Hde = md, Yde = Cd, kde = bd, Vde = yd, Gde = wd, Wde = xd, Qde = Dd, Ude = Od, Zde = Md;
G8.parsers = {
  G: new mde.EraParser(),
  y: new Cde.YearParser(),
  Y: new bde.LocalWeekYearParser(),
  R: new yde.ISOWeekYearParser(),
  u: new wde.ExtendedYearParser(),
  Q: new xde.QuarterParser(),
  q: new Dde.StandAloneQuarterParser(),
  M: new Ode.MonthParser(),
  L: new Mde.StandAloneMonthParser(),
  w: new Ede.LocalWeekParser(),
  I: new Sde.ISOWeekParser(),
  d: new Pde.DateParser(),
  D: new jde.DayOfYearParser(),
  E: new Ide.DayParser(),
  e: new Bde.LocalDayParser(),
  c: new Nde.StandAloneLocalDayParser(),
  i: new Lde.ISODayParser(),
  a: new Tde.AMPMParser(),
  b: new _de.AMPMMidnightParser(),
  B: new Rde.DayPeriodParser(),
  h: new Fde.Hour1to12Parser(),
  H: new $de.Hour0to23Parser(),
  K: new Hde.Hour0To11Parser(),
  k: new Yde.Hour1To24Parser(),
  m: new kde.MinuteParser(),
  s: new Vde.SecondParser(),
  S: new Gde.FractionOfSecondParser(),
  X: new Wde.ISOTimezoneWithZParser(),
  x: new Qde.ISOTimezoneParser(),
  t: new Ude.TimestampSecondsParser(),
  T: new Zde.TimestampMillisecondsParser()
};
(function(e) {
  Object.defineProperty(e, "longFormatters", {
    enumerable: !0,
    get: function() {
      return i.longFormatters;
    }
  }), e.parse = g, Object.defineProperty(e, "parsers", {
    enumerable: !0,
    get: function() {
      return s.parsers;
    }
  });
  var t = ke, r = H8, n = da, a = ne, i = Cl, o = A3, s = G8, c = i1;
  const u = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, d = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, h = /^'([^]*?)'?$/, A = /''/g, p = /\S/, v = /[a-zA-Z]/;
  function g(b, w, x, y) {
    var X, Z, te, B, I, _, L, D;
    const C = (0, r.getDefaultOptions)(), O = (y == null ? void 0 : y.locale) ?? C.locale ?? n.defaultLocale, M = (y == null ? void 0 : y.firstWeekContainsDate) ?? ((Z = (X = y == null ? void 0 : y.locale) == null ? void 0 : X.options) == null ? void 0 : Z.firstWeekContainsDate) ?? C.firstWeekContainsDate ?? ((B = (te = C.locale) == null ? void 0 : te.options) == null ? void 0 : B.firstWeekContainsDate) ?? 1, E = (y == null ? void 0 : y.weekStartsOn) ?? ((_ = (I = y == null ? void 0 : y.locale) == null ? void 0 : I.options) == null ? void 0 : _.weekStartsOn) ?? C.weekStartsOn ?? ((D = (L = C.locale) == null ? void 0 : L.options) == null ? void 0 : D.weekStartsOn) ?? 0;
    if (w === "")
      return b === "" ? (0, a.toDate)(x) : (0, t.constructFrom)(x, NaN);
    const N = {
      firstWeekContainsDate: M,
      weekStartsOn: E,
      locale: O
    }, F = [new c.DateToSystemTimezoneSetter()], k = w.match(d).map((T) => {
      const Q = T[0];
      if (Q in i.longFormatters) {
        const z = i.longFormatters[Q];
        return z(T, O.formatLong);
      }
      return T;
    }).join("").match(u), R = [];
    for (let T of k) {
      !(y != null && y.useAdditionalWeekYearTokens) && (0, o.isProtectedWeekYearToken)(T) && (0, o.warnOrThrowProtectedError)(T, w, b), !(y != null && y.useAdditionalDayOfYearTokens) && (0, o.isProtectedDayOfYearToken)(T) && (0, o.warnOrThrowProtectedError)(T, w, b);
      const Q = T[0], z = s.parsers[Q];
      if (z) {
        const { incompatibleTokens: W } = z;
        if (Array.isArray(W)) {
          const $ = R.find(
            (V) => W.includes(V.token) || V.token === Q
          );
          if ($)
            throw new RangeError(
              `The format string mustn't contain \`${$.fullToken}\` and \`${T}\` at the same time`
            );
        } else if (z.incompatibleTokens === "*" && R.length > 0)
          throw new RangeError(
            `The format string mustn't contain \`${T}\` and any other token at the same time`
          );
        R.push({ token: Q, fullToken: T });
        const H = z.run(
          b,
          T,
          O.match,
          N
        );
        if (!H)
          return (0, t.constructFrom)(x, NaN);
        F.push(H.setter), b = H.rest;
      } else {
        if (Q.match(v))
          throw new RangeError(
            "Format string contains an unescaped latin alphabet character `" + Q + "`"
          );
        if (T === "''" ? T = "'" : Q === "'" && (T = m(T)), b.indexOf(T) === 0)
          b = b.slice(T.length);
        else
          return (0, t.constructFrom)(x, NaN);
      }
    }
    if (b.length > 0 && p.test(b))
      return (0, t.constructFrom)(x, NaN);
    const j = F.map((T) => T.priority).sort((T, Q) => Q - T).filter((T, Q, z) => z.indexOf(T) === Q).map(
      (T) => F.filter((Q) => Q.priority === T).sort((Q, z) => z.subPriority - Q.subPriority)
    ).map((T) => T[0]);
    let U = (0, a.toDate)(x);
    if (isNaN(U.getTime()))
      return (0, t.constructFrom)(x, NaN);
    const ee = {};
    for (const T of j) {
      if (!T.validate(U, N))
        return (0, t.constructFrom)(x, NaN);
      const Q = T.set(U, ee, N);
      Array.isArray(Q) ? (U = Q[0], Object.assign(ee, Q[1])) : U = Q;
    }
    return (0, t.constructFrom)(x, U);
  }
  function m(b) {
    return b.match(h)[1].replace(A, "'");
  }
})(V8);
OO.isMatch = qde;
var Kde = Ln, zde = V8;
function qde(e, t, r) {
  return (0, Kde.isValid)(
    (0, zde.parse)(e, t, /* @__PURE__ */ new Date(), r)
  );
}
var MO = {};
MO.isMonday = Jde;
var Xde = ne;
function Jde(e) {
  return (0, Xde.toDate)(e).getDay() === 1;
}
var EO = {};
EO.isPast = tfe;
var efe = ne;
function tfe(e) {
  return +(0, efe.toDate)(e) < Date.now();
}
var Ed = {}, Sd = {};
Sd.startOfHour = nfe;
var rfe = ne;
function nfe(e) {
  const t = (0, rfe.toDate)(e);
  return t.setMinutes(0, 0, 0), t;
}
Ed.isSameHour = afe;
var xm = Sd;
function afe(e, t) {
  const r = (0, xm.startOfHour)(e), n = (0, xm.startOfHour)(t);
  return +r == +n;
}
var Pd = {}, bl = {};
bl.isSameWeek = ife;
var Dm = qr;
function ife(e, t, r) {
  const n = (0, Dm.startOfWeek)(e, r), a = (0, Dm.startOfWeek)(t, r);
  return +n == +a;
}
Pd.isSameISOWeek = sfe;
var ofe = bl;
function sfe(e, t) {
  return (0, ofe.isSameWeek)(e, t, { weekStartsOn: 1 });
}
var SO = {};
SO.isSameISOWeekYear = lfe;
var Om = F2;
function lfe(e, t) {
  const r = (0, Om.startOfISOWeekYear)(e), n = (0, Om.startOfISOWeekYear)(t);
  return +r == +n;
}
var jd = {};
jd.isSameMinute = cfe;
var Mm = ul;
function cfe(e, t) {
  const r = (0, Mm.startOfMinute)(e), n = (0, Mm.startOfMinute)(t);
  return +r == +n;
}
var Id = {};
Id.isSameMonth = ufe;
var Em = ne;
function ufe(e, t) {
  const r = (0, Em.toDate)(e), n = (0, Em.toDate)(t);
  return r.getFullYear() === n.getFullYear() && r.getMonth() === n.getMonth();
}
var Bd = {};
Bd.isSameQuarter = dfe;
var Sm = dl;
function dfe(e, t) {
  const r = (0, Sm.startOfQuarter)(e), n = (0, Sm.startOfQuarter)(t);
  return +r == +n;
}
var Nd = {}, Ld = {};
Ld.startOfSecond = hfe;
var ffe = ne;
function hfe(e) {
  const t = (0, ffe.toDate)(e);
  return t.setMilliseconds(0), t;
}
Nd.isSameSecond = Afe;
var Pm = Ld;
function Afe(e, t) {
  const r = (0, Pm.startOfSecond)(e), n = (0, Pm.startOfSecond)(t);
  return +r == +n;
}
var Td = {};
Td.isSameYear = pfe;
var jm = ne;
function pfe(e, t) {
  const r = (0, jm.toDate)(e), n = (0, jm.toDate)(t);
  return r.getFullYear() === n.getFullYear();
}
var PO = {};
PO.isThisHour = mfe;
var gfe = tr, vfe = Ed;
function mfe(e) {
  return (0, vfe.isSameHour)(e, (0, gfe.constructNow)(e));
}
var jO = {};
jO.isThisISOWeek = yfe;
var Cfe = tr, bfe = Pd;
function yfe(e) {
  return (0, bfe.isSameISOWeek)(e, (0, Cfe.constructNow)(e));
}
var IO = {};
IO.isThisMinute = Dfe;
var wfe = tr, xfe = jd;
function Dfe(e) {
  return (0, xfe.isSameMinute)(e, (0, wfe.constructNow)(e));
}
var BO = {};
BO.isThisMonth = Efe;
var Ofe = tr, Mfe = Id;
function Efe(e) {
  return (0, Mfe.isSameMonth)(e, (0, Ofe.constructNow)(e));
}
var NO = {};
NO.isThisQuarter = jfe;
var Sfe = tr, Pfe = Bd;
function jfe(e) {
  return (0, Pfe.isSameQuarter)(e, (0, Sfe.constructNow)(e));
}
var LO = {};
LO.isThisSecond = Nfe;
var Ife = tr, Bfe = Nd;
function Nfe(e) {
  return (0, Bfe.isSameSecond)(e, (0, Ife.constructNow)(e));
}
var TO = {};
TO.isThisWeek = _fe;
var Lfe = tr, Tfe = bl;
function _fe(e, t) {
  return (0, Tfe.isSameWeek)(e, (0, Lfe.constructNow)(e), t);
}
var _O = {};
_O.isThisYear = $fe;
var Rfe = tr, Ffe = Td;
function $fe(e) {
  return (0, Ffe.isSameYear)(e, (0, Rfe.constructNow)(e));
}
var RO = {};
RO.isThursday = Yfe;
var Hfe = ne;
function Yfe(e) {
  return (0, Hfe.toDate)(e).getDay() === 4;
}
var FO = {};
FO.isToday = Gfe;
var kfe = tr, Vfe = $2;
function Gfe(e) {
  return (0, Vfe.isSameDay)(e, (0, kfe.constructNow)(e));
}
var $O = {};
$O.isTomorrow = Zfe;
var Wfe = An, Qfe = tr, Ufe = $2;
function Zfe(e) {
  return (0, Ufe.isSameDay)(
    e,
    (0, Wfe.addDays)((0, Qfe.constructNow)(e), 1)
  );
}
var HO = {};
HO.isTuesday = zfe;
var Kfe = ne;
function zfe(e) {
  return (0, Kfe.toDate)(e).getDay() === 2;
}
var YO = {};
YO.isWednesday = Xfe;
var qfe = ne;
function Xfe(e) {
  return (0, qfe.toDate)(e).getDay() === 3;
}
var kO = {};
kO.isWithinInterval = Jfe;
var S4 = ne;
function Jfe(e, t) {
  const r = +(0, S4.toDate)(e), [n, a] = [
    +(0, S4.toDate)(t.start),
    +(0, S4.toDate)(t.end)
  ].sort((i, o) => i - o);
  return r >= n && r <= a;
}
var VO = {}, v3 = {};
v3.subDays = the;
var ehe = An;
function the(e, t) {
  return (0, ehe.addDays)(e, -t);
}
VO.isYesterday = ihe;
var rhe = tr, nhe = $2, ahe = v3;
function ihe(e) {
  return (0, nhe.isSameDay)(
    e,
    (0, ahe.subDays)((0, rhe.constructNow)(e), 1)
  );
}
var GO = {};
GO.lastDayOfDecade = she;
var ohe = ne;
function she(e) {
  const t = (0, ohe.toDate)(e), r = t.getFullYear(), n = 9 + Math.floor(r / 10) * 10;
  return t.setFullYear(n + 1, 0, 0), t.setHours(0, 0, 0, 0), t;
}
var WO = {}, _d = {};
_d.lastDayOfWeek = uhe;
var lhe = ne, che = Yt;
function uhe(e, t) {
  var s, c, u, d;
  const r = (0, che.getDefaultOptions)(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? r.weekStartsOn ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, a = (0, lhe.toDate)(e), i = a.getDay(), o = (i < n ? -7 : 0) + 6 - (i - n);
  return a.setHours(0, 0, 0, 0), a.setDate(a.getDate() + o), a;
}
WO.lastDayOfISOWeek = fhe;
var dhe = _d;
function fhe(e) {
  return (0, dhe.lastDayOfWeek)(e, { weekStartsOn: 1 });
}
var QO = {};
QO.lastDayOfISOWeekYear = ghe;
var hhe = b1, Ahe = pn, phe = ke;
function ghe(e) {
  const t = (0, hhe.getISOWeekYear)(e), r = (0, phe.constructFrom)(e, 0);
  r.setFullYear(t + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const n = (0, Ahe.startOfISOWeek)(r);
  return n.setDate(n.getDate() - 1), n;
}
var UO = {};
UO.lastDayOfQuarter = mhe;
var vhe = ne;
function mhe(e) {
  const t = (0, vhe.toDate)(e), r = t.getMonth(), n = r - r % 3 + 3;
  return t.setMonth(n, 0), t.setHours(0, 0, 0, 0), t;
}
var ZO = {};
ZO.lastDayOfYear = bhe;
var Che = ne;
function bhe(e) {
  const t = (0, Che.toDate)(e), r = t.getFullYear();
  return t.setFullYear(r + 1, 0, 0), t.setHours(0, 0, 0, 0), t;
}
var KO = {};
(function(e) {
  e.lightFormat = c, Object.defineProperty(e, "lightFormatters", {
    enumerable: !0,
    get: function() {
      return n.lightFormatters;
    }
  });
  var t = Ln, r = ne, n = ml;
  const a = /(\w)\1*|''|'(''|[^'])+('|$)|./g, i = /^'([^]*?)'?$/, o = /''/g, s = /[a-zA-Z]/;
  function c(d, h) {
    const A = (0, r.toDate)(d);
    if (!(0, t.isValid)(A))
      throw new RangeError("Invalid time value");
    const p = h.match(a);
    return p ? p.map((g) => {
      if (g === "''")
        return "'";
      const m = g[0];
      if (m === "'")
        return u(g);
      const b = n.lightFormatters[m];
      if (b)
        return b(A, g);
      if (m.match(s))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + m + "`"
        );
      return g;
    }).join("") : "";
  }
  function u(d) {
    const h = d.match(i);
    return h ? h[1].replace(o, "'") : d;
  }
})(KO);
var zO = {};
zO.milliseconds = yhe;
var Im = ce;
function yhe({ years: e, months: t, weeks: r, days: n, hours: a, minutes: i, seconds: o }) {
  let s = 0;
  e && (s += e * Im.daysInYear), t && (s += t * (Im.daysInYear / 12)), r && (s += r * 7), n && (s += n);
  let c = s * 24 * 60 * 60;
  return a && (c += a * 60 * 60), i && (c += i * 60), o && (c += o), Math.trunc(c * 1e3);
}
var qO = {};
qO.millisecondsToHours = xhe;
var whe = ce;
function xhe(e) {
  const t = e / whe.millisecondsInHour;
  return Math.trunc(t);
}
var XO = {};
XO.millisecondsToMinutes = Ohe;
var Dhe = ce;
function Ohe(e) {
  const t = e / Dhe.millisecondsInMinute;
  return Math.trunc(t);
}
var JO = {};
JO.millisecondsToSeconds = Ehe;
var Mhe = ce;
function Ehe(e) {
  const t = e / Mhe.millisecondsInSecond;
  return Math.trunc(t);
}
var eM = {};
eM.minutesToHours = Phe;
var She = ce;
function Phe(e) {
  const t = e / She.minutesInHour;
  return Math.trunc(t);
}
var tM = {};
tM.minutesToMilliseconds = Ihe;
var jhe = ce;
function Ihe(e) {
  return Math.trunc(e * jhe.millisecondsInMinute);
}
var rM = {};
rM.minutesToSeconds = Nhe;
var Bhe = ce;
function Nhe(e) {
  return Math.trunc(e * Bhe.secondsInMinute);
}
var nM = {};
nM.monthsToQuarters = The;
var Lhe = ce;
function The(e) {
  const t = e / Lhe.monthsInQuarter;
  return Math.trunc(t);
}
var aM = {};
aM.monthsToYears = Rhe;
var _he = ce;
function Rhe(e) {
  const t = e / _he.monthsInYear;
  return Math.trunc(t);
}
var _n = {};
_n.nextDay = Hhe;
var Fhe = An, $he = p3;
function Hhe(e, t) {
  let r = t - (0, $he.getDay)(e);
  return r <= 0 && (r += 7), (0, Fhe.addDays)(e, r);
}
var iM = {};
iM.nextFriday = khe;
var Yhe = _n;
function khe(e) {
  return (0, Yhe.nextDay)(e, 5);
}
var oM = {};
oM.nextMonday = Ghe;
var Vhe = _n;
function Ghe(e) {
  return (0, Vhe.nextDay)(e, 1);
}
var sM = {};
sM.nextSaturday = Qhe;
var Whe = _n;
function Qhe(e) {
  return (0, Whe.nextDay)(e, 6);
}
var lM = {};
lM.nextSunday = Zhe;
var Uhe = _n;
function Zhe(e) {
  return (0, Uhe.nextDay)(e, 0);
}
var cM = {};
cM.nextThursday = zhe;
var Khe = _n;
function zhe(e) {
  return (0, Khe.nextDay)(e, 4);
}
var uM = {};
uM.nextTuesday = Xhe;
var qhe = _n;
function Xhe(e) {
  return (0, qhe.nextDay)(e, 2);
}
var dM = {};
dM.nextWednesday = eAe;
var Jhe = _n;
function eAe(e) {
  return (0, Jhe.nextDay)(e, 3);
}
var fM = {};
fM.parseISO = tAe;
var l0 = ce;
function tAe(e, t) {
  const r = (t == null ? void 0 : t.additionalDigits) ?? 2, n = iAe(e);
  let a;
  if (n.date) {
    const c = oAe(n.date, r);
    a = sAe(c.restDateString, c.year);
  }
  if (!a || isNaN(a.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const i = a.getTime();
  let o = 0, s;
  if (n.time && (o = lAe(n.time), isNaN(o)))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (s = cAe(n.timezone), isNaN(s))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const c = new Date(i + o), u = /* @__PURE__ */ new Date(0);
    return u.setFullYear(
      c.getUTCFullYear(),
      c.getUTCMonth(),
      c.getUTCDate()
    ), u.setHours(
      c.getUTCHours(),
      c.getUTCMinutes(),
      c.getUTCSeconds(),
      c.getUTCMilliseconds()
    ), u;
  }
  return new Date(i + o + s);
}
const Q3 = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, rAe = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, nAe = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, aAe = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function iAe(e) {
  const t = {}, r = e.split(Q3.dateTimeDelimiter);
  let n;
  if (r.length > 2)
    return t;
  if (/:/.test(r[0]) ? n = r[0] : (t.date = r[0], n = r[1], Q3.timeZoneDelimiter.test(t.date) && (t.date = e.split(Q3.timeZoneDelimiter)[0], n = e.substr(
    t.date.length,
    e.length
  ))), n) {
    const a = Q3.timezone.exec(n);
    a ? (t.time = n.replace(a[1], ""), t.timezone = a[1]) : t.time = n;
  }
  return t;
}
function oAe(e, t) {
  const r = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), n = e.match(r);
  if (!n)
    return { year: NaN, restDateString: "" };
  const a = n[1] ? parseInt(n[1]) : null, i = n[2] ? parseInt(n[2]) : null;
  return {
    year: i === null ? a : i * 100,
    restDateString: e.slice((n[1] || n[2]).length)
  };
}
function sAe(e, t) {
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  const r = e.match(rAe);
  if (!r)
    return /* @__PURE__ */ new Date(NaN);
  const n = !!r[4], a = Ei(r[1]), i = Ei(r[2]) - 1, o = Ei(r[3]), s = Ei(r[4]), c = Ei(r[5]) - 1;
  if (n)
    return AAe(t, s, c) ? uAe(t, s, c) : /* @__PURE__ */ new Date(NaN);
  {
    const u = /* @__PURE__ */ new Date(0);
    return !fAe(t, i, o) || !hAe(t, a) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(t, i, Math.max(a, o)), u);
  }
}
function Ei(e) {
  return e ? parseInt(e) : 1;
}
function lAe(e) {
  const t = e.match(nAe);
  if (!t)
    return NaN;
  const r = P4(t[1]), n = P4(t[2]), a = P4(t[3]);
  return pAe(r, n, a) ? r * l0.millisecondsInHour + n * l0.millisecondsInMinute + a * 1e3 : NaN;
}
function P4(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function cAe(e) {
  if (e === "Z")
    return 0;
  const t = e.match(aAe);
  if (!t)
    return 0;
  const r = t[1] === "+" ? -1 : 1, n = parseInt(t[2]), a = t[3] && parseInt(t[3]) || 0;
  return gAe(n, a) ? r * (n * l0.millisecondsInHour + a * l0.millisecondsInMinute) : NaN;
}
function uAe(e, t, r) {
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  const a = n.getUTCDay() || 7, i = (t - 1) * 7 + r + 1 - a;
  return n.setUTCDate(n.getUTCDate() + i), n;
}
const dAe = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function hM(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function fAe(e, t, r) {
  return t >= 0 && t <= 11 && r >= 1 && r <= (dAe[t] || (hM(e) ? 29 : 28));
}
function hAe(e, t) {
  return t >= 1 && t <= (hM(e) ? 366 : 365);
}
function AAe(e, t, r) {
  return t >= 1 && t <= 53 && r >= 0 && r <= 6;
}
function pAe(e, t, r) {
  return e === 24 ? t === 0 && r === 0 : r >= 0 && r < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function gAe(e, t) {
  return t >= 0 && t <= 59;
}
var AM = {};
AM.parseJSON = vAe;
function vAe(e) {
  const t = e.match(
    /(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/
  );
  return t ? new Date(
    Date.UTC(
      +t[1],
      +t[2] - 1,
      +t[3],
      +t[4] - (+t[9] || 0) * (t[8] == "-" ? -1 : 1),
      +t[5] - (+t[10] || 0) * (t[8] == "-" ? -1 : 1),
      +t[6],
      +((t[7] || "0") + "00").substring(0, 3)
    )
  ) : /* @__PURE__ */ new Date(NaN);
}
var Rn = {};
Rn.previousDay = bAe;
var mAe = p3, CAe = v3;
function bAe(e, t) {
  let r = (0, mAe.getDay)(e) - t;
  return r <= 0 && (r += 7), (0, CAe.subDays)(e, r);
}
var pM = {};
pM.previousFriday = wAe;
var yAe = Rn;
function wAe(e) {
  return (0, yAe.previousDay)(e, 5);
}
var gM = {};
gM.previousMonday = DAe;
var xAe = Rn;
function DAe(e) {
  return (0, xAe.previousDay)(e, 1);
}
var vM = {};
vM.previousSaturday = MAe;
var OAe = Rn;
function MAe(e) {
  return (0, OAe.previousDay)(e, 6);
}
var mM = {};
mM.previousSunday = SAe;
var EAe = Rn;
function SAe(e) {
  return (0, EAe.previousDay)(e, 0);
}
var CM = {};
CM.previousThursday = jAe;
var PAe = Rn;
function jAe(e) {
  return (0, PAe.previousDay)(e, 4);
}
var bM = {};
bM.previousTuesday = BAe;
var IAe = Rn;
function BAe(e) {
  return (0, IAe.previousDay)(e, 2);
}
var yM = {};
yM.previousWednesday = LAe;
var NAe = Rn;
function LAe(e) {
  return (0, NAe.previousDay)(e, 3);
}
var wM = {};
wM.quartersToMonths = _Ae;
var TAe = ce;
function _Ae(e) {
  return Math.trunc(e * TAe.monthsInQuarter);
}
var xM = {};
xM.quartersToYears = FAe;
var RAe = ce;
function FAe(e) {
  const t = e / RAe.quartersInYear;
  return Math.trunc(t);
}
var DM = {};
DM.roundToNearestHours = YAe;
var $Ae = Tn, Bm = ke, HAe = ne;
function YAe(e, t) {
  const r = (t == null ? void 0 : t.nearestTo) ?? 1;
  if (r < 1 || r > 12)
    return (0, Bm.constructFrom)(e, NaN);
  const n = (0, HAe.toDate)(e), a = n.getMinutes() / 60, i = n.getSeconds() / 60 / 60, o = n.getMilliseconds() / 1e3 / 60 / 60, s = n.getHours() + a + i + o, c = (t == null ? void 0 : t.roundingMethod) ?? "round", d = (0, $Ae.getRoundingMethod)(c)(s / r) * r, h = (0, Bm.constructFrom)(e, n);
  return h.setHours(d, 0, 0, 0), h;
}
var OM = {};
OM.roundToNearestMinutes = GAe;
var kAe = Tn, Nm = ke, VAe = ne;
function GAe(e, t) {
  const r = (t == null ? void 0 : t.nearestTo) ?? 1;
  if (r < 1 || r > 30)
    return (0, Nm.constructFrom)(e, NaN);
  const n = (0, VAe.toDate)(e), a = n.getSeconds() / 60, i = n.getMilliseconds() / 1e3 / 60, o = n.getMinutes() + a + i, s = (t == null ? void 0 : t.roundingMethod) ?? "round", u = (0, kAe.getRoundingMethod)(s)(o / r) * r, d = (0, Nm.constructFrom)(e, n);
  return d.setMinutes(u, 0, 0), d;
}
var MM = {};
MM.secondsToHours = QAe;
var WAe = ce;
function QAe(e) {
  const t = e / WAe.secondsInHour;
  return Math.trunc(t);
}
var EM = {};
EM.secondsToMilliseconds = ZAe;
var UAe = ce;
function ZAe(e) {
  return e * UAe.millisecondsInSecond;
}
var SM = {};
SM.secondsToMinutes = zAe;
var KAe = ce;
function zAe(e) {
  const t = e / KAe.secondsInMinute;
  return Math.trunc(t);
}
var PM = {}, yl = {};
yl.setMonth = epe;
var qAe = ke, XAe = F8, JAe = ne;
function epe(e, t) {
  const r = (0, JAe.toDate)(e), n = r.getFullYear(), a = r.getDate(), i = (0, qAe.constructFrom)(e, 0);
  i.setFullYear(n, t, 15), i.setHours(0, 0, 0, 0);
  const o = (0, XAe.getDaysInMonth)(i);
  return r.setMonth(t, Math.min(a, o)), r;
}
PM.set = ape;
var tpe = ke, rpe = yl, npe = ne;
function ape(e, t) {
  let r = (0, npe.toDate)(e);
  return isNaN(+r) ? (0, tpe.constructFrom)(e, NaN) : (t.year != null && r.setFullYear(t.year), t.month != null && (r = (0, rpe.setMonth)(r, t.month)), t.date != null && r.setDate(t.date), t.hours != null && r.setHours(t.hours), t.minutes != null && r.setMinutes(t.minutes), t.seconds != null && r.setSeconds(t.seconds), t.milliseconds != null && r.setMilliseconds(t.milliseconds), r);
}
var jM = {};
jM.setDate = ope;
var ipe = ne;
function ope(e, t) {
  const r = (0, ipe.toDate)(e);
  return r.setDate(t), r;
}
var IM = {};
IM.setDayOfYear = lpe;
var spe = ne;
function lpe(e, t) {
  const r = (0, spe.toDate)(e);
  return r.setMonth(0), r.setDate(t), r;
}
var BM = {};
BM.setDefaultOptions = cpe;
var Lm = Yt;
function cpe(e) {
  const t = {}, r = (0, Lm.getDefaultOptions)();
  for (const n in r)
    Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (e[n] === void 0 ? delete t[n] : t[n] = e[n]);
  (0, Lm.setDefaultOptions)(t);
}
var NM = {};
NM.setHours = dpe;
var upe = ne;
function dpe(e, t) {
  const r = (0, upe.toDate)(e);
  return r.setHours(t), r;
}
var LM = {};
LM.setMilliseconds = hpe;
var fpe = ne;
function hpe(e, t) {
  const r = (0, fpe.toDate)(e);
  return r.setMilliseconds(t), r;
}
var TM = {};
TM.setMinutes = ppe;
var Ape = ne;
function ppe(e, t) {
  const r = (0, Ape.toDate)(e);
  return r.setMinutes(t), r;
}
var _M = {};
_M.setQuarter = mpe;
var gpe = yl, vpe = ne;
function mpe(e, t) {
  const r = (0, vpe.toDate)(e), n = Math.trunc(r.getMonth() / 3) + 1, a = t - n;
  return (0, gpe.setMonth)(r, r.getMonth() + a * 3);
}
var RM = {};
RM.setSeconds = bpe;
var Cpe = ne;
function bpe(e, t) {
  const r = (0, Cpe.toDate)(e);
  return r.setSeconds(t), r;
}
var FM = {};
FM.setWeekYear = Ope;
var ype = ke, wpe = Bn, Tm = vl, xpe = ne, Dpe = Yt;
function Ope(e, t, r) {
  var c, u, d, h;
  const n = (0, Dpe.getDefaultOptions)(), a = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((u = (c = r == null ? void 0 : r.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((h = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1;
  let i = (0, xpe.toDate)(e);
  const o = (0, wpe.differenceInCalendarDays)(
    i,
    (0, Tm.startOfWeekYear)(i, r)
  ), s = (0, ype.constructFrom)(e, 0);
  return s.setFullYear(t, 0, a), s.setHours(0, 0, 0, 0), i = (0, Tm.startOfWeekYear)(s, r), i.setDate(i.getDate() + o), i;
}
var $M = {};
$M.setYear = Spe;
var Mpe = ke, Epe = ne;
function Spe(e, t) {
  const r = (0, Epe.toDate)(e);
  return isNaN(+r) ? (0, Mpe.constructFrom)(e, NaN) : (r.setFullYear(t), r);
}
var HM = {};
HM.startOfDecade = jpe;
var Ppe = ne;
function jpe(e) {
  const t = (0, Ppe.toDate)(e), r = t.getFullYear(), n = Math.floor(r / 10) * 10;
  return t.setFullYear(n, 0, 1), t.setHours(0, 0, 0, 0), t;
}
var YM = {};
YM.startOfToday = Bpe;
var Ipe = s3;
function Bpe() {
  return (0, Ipe.startOfDay)(Date.now());
}
var kM = {};
kM.startOfTomorrow = Npe;
function Npe() {
  const e = /* @__PURE__ */ new Date(), t = e.getFullYear(), r = e.getMonth(), n = e.getDate(), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(t, r, n + 1), a.setHours(0, 0, 0, 0), a;
}
var VM = {};
VM.startOfYesterday = Lpe;
function Lpe() {
  const e = /* @__PURE__ */ new Date(), t = e.getFullYear(), r = e.getMonth(), n = e.getDate(), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(t, r, n - 1), a.setHours(0, 0, 0, 0), a;
}
var GM = {}, Rd = {};
Rd.subMonths = _pe;
var Tpe = _2;
function _pe(e, t) {
  return (0, Tpe.addMonths)(e, -t);
}
GM.sub = Hpe;
var Rpe = v3, Fpe = Rd, $pe = ke;
function Hpe(e, t) {
  const {
    years: r = 0,
    months: n = 0,
    weeks: a = 0,
    days: i = 0,
    hours: o = 0,
    minutes: s = 0,
    seconds: c = 0
  } = t, u = (0, Fpe.subMonths)(e, n + r * 12), d = (0, Rpe.subDays)(
    u,
    i + a * 7
  ), h = s + o * 60, p = (c + h * 60) * 1e3;
  return (0, $pe.constructFrom)(
    e,
    d.getTime() - p
  );
}
var WM = {};
WM.subBusinessDays = kpe;
var Ype = l8;
function kpe(e, t) {
  return (0, Ype.addBusinessDays)(e, -t);
}
var QM = {};
QM.subHours = Gpe;
var Vpe = J0;
function Gpe(e, t) {
  return (0, Vpe.addHours)(e, -t);
}
var UM = {};
UM.subMilliseconds = Qpe;
var Wpe = R2;
function Qpe(e, t) {
  return (0, Wpe.addMilliseconds)(e, -t);
}
var ZM = {};
ZM.subMinutes = Zpe;
var Upe = el;
function Zpe(e, t) {
  return (0, Upe.addMinutes)(e, -t);
}
var KM = {};
KM.subQuarters = zpe;
var Kpe = tl;
function zpe(e, t) {
  return (0, Kpe.addQuarters)(e, -t);
}
var zM = {};
zM.subSeconds = Xpe;
var qpe = h8;
function Xpe(e, t) {
  return (0, qpe.addSeconds)(e, -t);
}
var qM = {};
qM.subWeeks = ege;
var Jpe = l3;
function ege(e, t) {
  return (0, Jpe.addWeeks)(e, -t);
}
var XM = {};
XM.subYears = rge;
var tge = A8;
function rge(e, t) {
  return (0, tge.addYears)(e, -t);
}
var JM = {};
JM.weeksToDays = age;
var nge = ce;
function age(e) {
  return Math.trunc(e * nge.daysInWeek);
}
var eE = {};
eE.yearsToDays = oge;
var ige = ce;
function oge(e) {
  return Math.trunc(e * ige.daysInYear);
}
var tE = {};
tE.yearsToMonths = lge;
var sge = ce;
function lge(e) {
  return Math.trunc(e * sge.monthsInYear);
}
var rE = {};
rE.yearsToQuarters = uge;
var cge = ce;
function uge(e) {
  return Math.trunc(e * cge.quartersInYear);
}
(function(e) {
  var t = s8;
  Object.keys(t).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === t[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return t[l];
      }
    });
  });
  var r = l8;
  Object.keys(r).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === r[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return r[l];
      }
    });
  });
  var n = An;
  Object.keys(n).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === n[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return n[l];
      }
    });
  });
  var a = J0;
  Object.keys(a).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === a[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return a[l];
      }
    });
  });
  var i = d8;
  Object.keys(i).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === i[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return i[l];
      }
    });
  });
  var o = R2;
  Object.keys(o).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === o[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return o[l];
      }
    });
  });
  var s = el;
  Object.keys(s).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === s[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return s[l];
      }
    });
  });
  var c = _2;
  Object.keys(c).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === c[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return c[l];
      }
    });
  });
  var u = tl;
  Object.keys(u).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === u[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return u[l];
      }
    });
  });
  var d = h8;
  Object.keys(d).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === d[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return d[l];
      }
    });
  });
  var h = l3;
  Object.keys(h).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === h[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return h[l];
      }
    });
  });
  var A = A8;
  Object.keys(A).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === A[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return A[l];
      }
    });
  });
  var p = sD;
  Object.keys(p).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === p[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return p[l];
      }
    });
  });
  var v = lD;
  Object.keys(v).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === v[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return v[l];
      }
    });
  });
  var g = cD;
  Object.keys(g).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === g[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return g[l];
      }
    });
  });
  var m = uD;
  Object.keys(m).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === m[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return m[l];
      }
    });
  });
  var b = ua;
  Object.keys(b).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === b[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return b[l];
      }
    });
  });
  var w = dD;
  Object.keys(w).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === w[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return w[l];
      }
    });
  });
  var x = ke;
  Object.keys(x).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === x[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return x[l];
      }
    });
  });
  var y = tr;
  Object.keys(y).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === y[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return y[l];
      }
    });
  });
  var C = fD;
  Object.keys(C).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === C[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return C[l];
      }
    });
  });
  var O = hD;
  Object.keys(O).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === O[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return O[l];
      }
    });
  });
  var M = Bn;
  Object.keys(M).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === M[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return M[l];
      }
    });
  });
  var E = m8;
  Object.keys(E).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === E[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return E[l];
      }
    });
  });
  var N = AD;
  Object.keys(N).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === N[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return N[l];
      }
    });
  });
  var F = rl;
  Object.keys(F).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === F[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return F[l];
      }
    });
  });
  var k = C8;
  Object.keys(k).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === k[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return k[l];
      }
    });
  });
  var R = nl;
  Object.keys(R).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === R[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return R[l];
      }
    });
  });
  var j = al;
  Object.keys(j).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === j[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return j[l];
      }
    });
  });
  var U = il;
  Object.keys(U).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === U[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return U[l];
      }
    });
  });
  var ee = ol;
  Object.keys(ee).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ee[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ee[l];
      }
    });
  });
  var X = pD;
  Object.keys(X).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === X[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return X[l];
      }
    });
  });
  var Z = c3;
  Object.keys(Z).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Z[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Z[l];
      }
    });
  });
  var te = sl;
  Object.keys(te).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === te[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return te[l];
      }
    });
  });
  var B = u3;
  Object.keys(B).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === B[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return B[l];
      }
    });
  });
  var I = gD;
  Object.keys(I).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === I[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return I[l];
      }
    });
  });
  var _ = d3;
  Object.keys(_).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === _[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return _[l];
      }
    });
  });
  var L = vD;
  Object.keys(L).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === L[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return L[l];
      }
    });
  });
  var D = x8;
  Object.keys(D).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === D[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return D[l];
      }
    });
  });
  var T = D8;
  Object.keys(T).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === T[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return T[l];
      }
    });
  });
  var Q = mD;
  Object.keys(Q).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Q[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Q[l];
      }
    });
  });
  var z = CD;
  Object.keys(z).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === z[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return z[l];
      }
    });
  });
  var W = bD;
  Object.keys(W).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === W[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return W[l];
      }
    });
  });
  var H = yD;
  Object.keys(H).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === H[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return H[l];
      }
    });
  });
  var $ = wD;
  Object.keys($).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === $[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return $[l];
      }
    });
  });
  var V = fl;
  Object.keys(V).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === V[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return V[l];
      }
    });
  });
  var Y = xD;
  Object.keys(Y).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Y[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Y[l];
      }
    });
  });
  var S = DD;
  Object.keys(S).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === S[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return S[l];
      }
    });
  });
  var J = OD;
  Object.keys(J).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === J[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return J[l];
      }
    });
  });
  var q = ll;
  Object.keys(q).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === q[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return q[l];
      }
    });
  });
  var re = MD;
  Object.keys(re).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === re[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return re[l];
      }
    });
  });
  var ae = ED;
  Object.keys(ae).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ae[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ae[l];
      }
    });
  });
  var oe = SD;
  Object.keys(oe).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === oe[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return oe[l];
      }
    });
  });
  var ue = PD;
  Object.keys(ue).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ue[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ue[l];
      }
    });
  });
  var Ae = jD;
  Object.keys(Ae).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ae[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ae[l];
      }
    });
  });
  var ge = cl;
  Object.keys(ge).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ge[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ge[l];
      }
    });
  });
  var Se = ID;
  Object.keys(Se).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Se[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Se[l];
      }
    });
  });
  var Te = BD;
  Object.keys(Te).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Te[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Te[l];
      }
    });
  });
  var Re = ND;
  Object.keys(Re).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Re[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Re[l];
      }
    });
  });
  var at = LD;
  Object.keys(at).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === at[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return at[l];
      }
    });
  });
  var bt = M8;
  Object.keys(bt).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === bt[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return bt[l];
      }
    });
  });
  var Qt = O8;
  Object.keys(Qt).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Qt[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Qt[l];
      }
    });
  });
  var or = TD;
  Object.keys(or).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === or[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return or[l];
      }
    });
  });
  var y1 = E8;
  Object.keys(y1).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === y1[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return y1[l];
      }
    });
  });
  var Aa = T8;
  Object.keys(Aa).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Aa[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Aa[l];
      }
    });
  });
  var pa = _8;
  Object.keys(pa).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === pa[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return pa[l];
      }
    });
  });
  var w1 = YD;
  Object.keys(w1).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === w1[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return w1[l];
      }
    });
  });
  var Y2 = kD;
  Object.keys(Y2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Y2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Y2[l];
      }
    });
  });
  var k2 = VD;
  Object.keys(k2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === k2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return k2[l];
      }
    });
  });
  var V2 = GD;
  Object.keys(V2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === V2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return V2[l];
      }
    });
  });
  var G2 = WD;
  Object.keys(G2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === G2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return G2[l];
      }
    });
  });
  var W2 = QD;
  Object.keys(W2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === W2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return W2[l];
      }
    });
  });
  var Q2 = UD;
  Object.keys(Q2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Q2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Q2[l];
      }
    });
  });
  var U2 = ZD;
  Object.keys(U2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === U2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return U2[l];
      }
    });
  });
  var x1 = KD;
  Object.keys(x1).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === x1[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return x1[l];
      }
    });
  });
  var ga = zD;
  Object.keys(ga).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ga[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ga[l];
      }
    });
  });
  var Jr = R8;
  Object.keys(Jr).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Jr[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Jr[l];
      }
    });
  });
  var D1 = p3;
  Object.keys(D1).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === D1[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return D1[l];
      }
    });
  });
  var O1 = L8;
  Object.keys(O1).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === O1[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return O1[l];
      }
    });
  });
  var va = F8;
  Object.keys(va).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === va[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return va[l];
      }
    });
  });
  var Z2 = qD;
  Object.keys(Z2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Z2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Z2[l];
      }
    });
  });
  var ma = XD;
  Object.keys(ma).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ma[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ma[l];
      }
    });
  });
  var K2 = H8;
  Object.keys(K2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === K2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return K2[l];
      }
    });
  });
  var Ca = JD;
  Object.keys(Ca).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ca[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ca[l];
      }
    });
  });
  var ba = Y8;
  Object.keys(ba).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ba[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ba[l];
      }
    });
  });
  var z2 = pl;
  Object.keys(z2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === z2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return z2[l];
      }
    });
  });
  var q2 = b1;
  Object.keys(q2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === q2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return q2[l];
      }
    });
  });
  var ya = eO;
  Object.keys(ya).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ya[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ya[l];
      }
    });
  });
  var X2 = tO;
  Object.keys(X2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === X2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return X2[l];
      }
    });
  });
  var J2 = rO;
  Object.keys(J2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === J2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return J2[l];
      }
    });
  });
  var ei = nO;
  Object.keys(ei).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ei[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ei[l];
      }
    });
  });
  var ti = aO;
  Object.keys(ti).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ti[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ti[l];
      }
    });
  });
  var G = b8;
  Object.keys(G).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === G[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return G[l];
      }
    });
  });
  var se = iO;
  Object.keys(se).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === se[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return se[l];
      }
    });
  });
  var de = oO;
  Object.keys(de).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === de[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return de[l];
      }
    });
  });
  var we = sO;
  Object.keys(we).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === we[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return we[l];
      }
    });
  });
  var _e = gl;
  Object.keys(_e).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === _e[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return _e[l];
      }
    });
  });
  var We = lO;
  Object.keys(We).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === We[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return We[l];
      }
    });
  });
  var Be = h3;
  Object.keys(Be).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Be[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Be[l];
      }
    });
  });
  var Ie = cO;
  Object.keys(Ie).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ie[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ie[l];
      }
    });
  });
  var Et = uO;
  Object.keys(Et).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Et[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Et[l];
      }
    });
  });
  var dt = dO;
  Object.keys(dt).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === dt[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return dt[l];
      }
    });
  });
  var vt = fO;
  Object.keys(vt).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === vt[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return vt[l];
      }
    });
  });
  var kt = hO;
  Object.keys(kt).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === kt[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return kt[l];
      }
    });
  });
  var en = AO;
  Object.keys(en).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === en[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return en[l];
      }
    });
  });
  var wa = pO;
  Object.keys(wa).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === wa[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return wa[l];
      }
    });
  });
  var sr = gO;
  Object.keys(sr).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === sr[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return sr[l];
      }
    });
  });
  var jl = vO;
  Object.keys(jl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === jl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return jl[l];
      }
    });
  });
  var Il = mO;
  Object.keys(Il).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Il[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Il[l];
      }
    });
  });
  var Bl = CO;
  Object.keys(Bl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Bl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Bl[l];
      }
    });
  });
  var Nl = v8;
  Object.keys(Nl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Nl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Nl[l];
      }
    });
  });
  var Ll = bO;
  Object.keys(Ll).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ll[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ll[l];
      }
    });
  });
  var Tl = yO;
  Object.keys(Tl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Tl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Tl[l];
      }
    });
  });
  var _l = wO;
  Object.keys(_l).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === _l[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return _l[l];
      }
    });
  });
  var Rl = xO;
  Object.keys(Rl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Rl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Rl[l];
      }
    });
  });
  var Fl = DO;
  Object.keys(Fl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Fl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Fl[l];
      }
    });
  });
  var $l = w8;
  Object.keys($l).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === $l[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return $l[l];
      }
    });
  });
  var Hl = $8;
  Object.keys(Hl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Hl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Hl[l];
      }
    });
  });
  var Yl = OO;
  Object.keys(Yl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Yl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Yl[l];
      }
    });
  });
  var kl = MO;
  Object.keys(kl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === kl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return kl[l];
      }
    });
  });
  var Vl = EO;
  Object.keys(Vl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Vl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Vl[l];
      }
    });
  });
  var Gl = $2;
  Object.keys(Gl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Gl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Gl[l];
      }
    });
  });
  var Wl = Ed;
  Object.keys(Wl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Wl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Wl[l];
      }
    });
  });
  var Ql = Pd;
  Object.keys(Ql).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ql[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ql[l];
      }
    });
  });
  var Ul = SO;
  Object.keys(Ul).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ul[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ul[l];
      }
    });
  });
  var Zl = jd;
  Object.keys(Zl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Zl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Zl[l];
      }
    });
  });
  var Kl = Id;
  Object.keys(Kl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Kl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Kl[l];
      }
    });
  });
  var zl = Bd;
  Object.keys(zl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === zl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return zl[l];
      }
    });
  });
  var ql = Nd;
  Object.keys(ql).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ql[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ql[l];
      }
    });
  });
  var Xl = bl;
  Object.keys(Xl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Xl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Xl[l];
      }
    });
  });
  var Jl = Td;
  Object.keys(Jl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Jl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Jl[l];
      }
    });
  });
  var ec = c8;
  Object.keys(ec).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ec[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ec[l];
      }
    });
  });
  var tc = u8;
  Object.keys(tc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === tc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return tc[l];
      }
    });
  });
  var rc = PO;
  Object.keys(rc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === rc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return rc[l];
      }
    });
  });
  var nc = jO;
  Object.keys(nc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === nc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return nc[l];
      }
    });
  });
  var ac = IO;
  Object.keys(ac).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ac[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ac[l];
      }
    });
  });
  var ic = BO;
  Object.keys(ic).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ic[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ic[l];
      }
    });
  });
  var oc = NO;
  Object.keys(oc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === oc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return oc[l];
      }
    });
  });
  var sc = LO;
  Object.keys(sc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === sc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return sc[l];
      }
    });
  });
  var lc = TO;
  Object.keys(lc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === lc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return lc[l];
      }
    });
  });
  var cc = _O;
  Object.keys(cc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === cc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return cc[l];
      }
    });
  });
  var uc = RO;
  Object.keys(uc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === uc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return uc[l];
      }
    });
  });
  var dc = FO;
  Object.keys(dc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === dc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return dc[l];
      }
    });
  });
  var fc = $O;
  Object.keys(fc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === fc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return fc[l];
      }
    });
  });
  var hc = HO;
  Object.keys(hc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === hc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return hc[l];
      }
    });
  });
  var Ac = Ln;
  Object.keys(Ac).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ac[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ac[l];
      }
    });
  });
  var pc = YO;
  Object.keys(pc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === pc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return pc[l];
      }
    });
  });
  var gc = o3;
  Object.keys(gc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === gc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return gc[l];
      }
    });
  });
  var vc = kO;
  Object.keys(vc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === vc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return vc[l];
      }
    });
  });
  var mc = VO;
  Object.keys(mc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === mc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return mc[l];
      }
    });
  });
  var Cc = GO;
  Object.keys(Cc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Cc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Cc[l];
      }
    });
  });
  var bc = WO;
  Object.keys(bc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === bc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return bc[l];
      }
    });
  });
  var yc = QO;
  Object.keys(yc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === yc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return yc[l];
      }
    });
  });
  var wc = k8;
  Object.keys(wc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === wc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return wc[l];
      }
    });
  });
  var xc = UO;
  Object.keys(xc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === xc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return xc[l];
      }
    });
  });
  var Dc = _d;
  Object.keys(Dc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Dc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Dc[l];
      }
    });
  });
  var Oc = ZO;
  Object.keys(Oc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Oc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Oc[l];
      }
    });
  });
  var Mc = KO;
  Object.keys(Mc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Mc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Mc[l];
      }
    });
  });
  var Ec = p8;
  Object.keys(Ec).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ec[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ec[l];
      }
    });
  });
  var Sc = zO;
  Object.keys(Sc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Sc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Sc[l];
      }
    });
  });
  var Pc = qO;
  Object.keys(Pc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Pc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Pc[l];
      }
    });
  });
  var jc = XO;
  Object.keys(jc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === jc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return jc[l];
      }
    });
  });
  var Ic = JO;
  Object.keys(Ic).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ic[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ic[l];
      }
    });
  });
  var Bc = g8;
  Object.keys(Bc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Bc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Bc[l];
      }
    });
  });
  var Nc = eM;
  Object.keys(Nc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Nc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Nc[l];
      }
    });
  });
  var Lc = tM;
  Object.keys(Lc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Lc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Lc[l];
      }
    });
  });
  var Tc = rM;
  Object.keys(Tc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Tc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Tc[l];
      }
    });
  });
  var _c = nM;
  Object.keys(_c).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === _c[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return _c[l];
      }
    });
  });
  var Rc = aM;
  Object.keys(Rc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Rc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Rc[l];
      }
    });
  });
  var Fc = _n;
  Object.keys(Fc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Fc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Fc[l];
      }
    });
  });
  var $c = iM;
  Object.keys($c).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === $c[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return $c[l];
      }
    });
  });
  var Hc = oM;
  Object.keys(Hc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Hc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Hc[l];
      }
    });
  });
  var Yc = sM;
  Object.keys(Yc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Yc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Yc[l];
      }
    });
  });
  var kc = lM;
  Object.keys(kc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === kc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return kc[l];
      }
    });
  });
  var Vc = cM;
  Object.keys(Vc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Vc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Vc[l];
      }
    });
  });
  var Gc = uM;
  Object.keys(Gc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Gc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Gc[l];
      }
    });
  });
  var Wc = dM;
  Object.keys(Wc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Wc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Wc[l];
      }
    });
  });
  var Qc = V8;
  Object.keys(Qc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Qc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Qc[l];
      }
    });
  });
  var Uc = fM;
  Object.keys(Uc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Uc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Uc[l];
      }
    });
  });
  var Zc = AM;
  Object.keys(Zc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Zc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Zc[l];
      }
    });
  });
  var Kc = Rn;
  Object.keys(Kc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Kc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Kc[l];
      }
    });
  });
  var zc = pM;
  Object.keys(zc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === zc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return zc[l];
      }
    });
  });
  var qc = gM;
  Object.keys(qc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === qc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return qc[l];
      }
    });
  });
  var Xc = vM;
  Object.keys(Xc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Xc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Xc[l];
      }
    });
  });
  var Jc = mM;
  Object.keys(Jc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Jc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Jc[l];
      }
    });
  });
  var eu = CM;
  Object.keys(eu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === eu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return eu[l];
      }
    });
  });
  var tu = bM;
  Object.keys(tu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === tu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return tu[l];
      }
    });
  });
  var ru = yM;
  Object.keys(ru).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ru[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ru[l];
      }
    });
  });
  var nu = wM;
  Object.keys(nu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === nu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return nu[l];
      }
    });
  });
  var au = xM;
  Object.keys(au).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === au[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return au[l];
      }
    });
  });
  var iu = DM;
  Object.keys(iu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === iu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return iu[l];
      }
    });
  });
  var ou = OM;
  Object.keys(ou).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ou[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ou[l];
      }
    });
  });
  var su = MM;
  Object.keys(su).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === su[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return su[l];
      }
    });
  });
  var lu = EM;
  Object.keys(lu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === lu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return lu[l];
      }
    });
  });
  var cu = SM;
  Object.keys(cu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === cu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return cu[l];
      }
    });
  });
  var uu = PM;
  Object.keys(uu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === uu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return uu[l];
      }
    });
  });
  var du = jM;
  Object.keys(du).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === du[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return du[l];
      }
    });
  });
  var fu = g3;
  Object.keys(fu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === fu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return fu[l];
      }
    });
  });
  var hu = IM;
  Object.keys(hu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === hu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return hu[l];
      }
    });
  });
  var Au = BM;
  Object.keys(Au).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Au[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Au[l];
      }
    });
  });
  var pu = NM;
  Object.keys(pu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === pu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return pu[l];
      }
    });
  });
  var gu = fd;
  Object.keys(gu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === gu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return gu[l];
      }
    });
  });
  var vu = id;
  Object.keys(vu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === vu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return vu[l];
      }
    });
  });
  var mu = f8;
  Object.keys(mu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === mu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return mu[l];
      }
    });
  });
  var Cu = LM;
  Object.keys(Cu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Cu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Cu[l];
      }
    });
  });
  var bu = TM;
  Object.keys(bu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === bu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return bu[l];
      }
    });
  });
  var yu = yl;
  Object.keys(yu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === yu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return yu[l];
      }
    });
  });
  var wu = _M;
  Object.keys(wu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === wu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return wu[l];
      }
    });
  });
  var xu = RM;
  Object.keys(xu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === xu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return xu[l];
      }
    });
  });
  var Du = nd;
  Object.keys(Du).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Du[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Du[l];
      }
    });
  });
  var Ou = FM;
  Object.keys(Ou).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ou[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ou[l];
      }
    });
  });
  var Mu = $M;
  Object.keys(Mu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Mu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Mu[l];
      }
    });
  });
  var Eu = s3;
  Object.keys(Eu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Eu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Eu[l];
      }
    });
  });
  var Su = HM;
  Object.keys(Su).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Su[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Su[l];
      }
    });
  });
  var Pu = Sd;
  Object.keys(Pu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Pu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Pu[l];
      }
    });
  });
  var ju = pn;
  Object.keys(ju).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ju[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ju[l];
      }
    });
  });
  var Iu = F2;
  Object.keys(Iu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Iu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Iu[l];
      }
    });
  });
  var Bu = ul;
  Object.keys(Bu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Bu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Bu[l];
      }
    });
  });
  var Nu = f3;
  Object.keys(Nu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Nu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Nu[l];
      }
    });
  });
  var Lu = dl;
  Object.keys(Lu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Lu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Lu[l];
      }
    });
  });
  var Tu = Ld;
  Object.keys(Tu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Tu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Tu[l];
      }
    });
  });
  var _u = YM;
  Object.keys(_u).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === _u[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return _u[l];
      }
    });
  });
  var Ru = kM;
  Object.keys(Ru).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ru[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ru[l];
      }
    });
  });
  var Fu = qr;
  Object.keys(Fu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Fu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Fu[l];
      }
    });
  });
  var $u = vl;
  Object.keys($u).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === $u[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return $u[l];
      }
    });
  });
  var Hu = hl;
  Object.keys(Hu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Hu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Hu[l];
      }
    });
  });
  var Yu = VM;
  Object.keys(Yu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Yu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Yu[l];
      }
    });
  });
  var ku = GM;
  Object.keys(ku).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ku[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ku[l];
      }
    });
  });
  var Vu = WM;
  Object.keys(Vu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Vu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Vu[l];
      }
    });
  });
  var Gu = v3;
  Object.keys(Gu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Gu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Gu[l];
      }
    });
  });
  var Wu = QM;
  Object.keys(Wu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Wu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Wu[l];
      }
    });
  });
  var Qu = y8;
  Object.keys(Qu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Qu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Qu[l];
      }
    });
  });
  var Uu = UM;
  Object.keys(Uu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Uu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Uu[l];
      }
    });
  });
  var Zu = ZM;
  Object.keys(Zu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Zu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Zu[l];
      }
    });
  });
  var Ku = Rd;
  Object.keys(Ku).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ku[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ku[l];
      }
    });
  });
  var zu = KM;
  Object.keys(zu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === zu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return zu[l];
      }
    });
  });
  var qu = zM;
  Object.keys(qu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === qu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return qu[l];
      }
    });
  });
  var Xu = qM;
  Object.keys(Xu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Xu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Xu[l];
      }
    });
  });
  var Ju = XM;
  Object.keys(Ju).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ju[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ju[l];
      }
    });
  });
  var e6 = ne;
  Object.keys(e6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === e6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return e6[l];
      }
    });
  });
  var t6 = Q8;
  Object.keys(t6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === t6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return t6[l];
      }
    });
  });
  var r6 = JM;
  Object.keys(r6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === r6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return r6[l];
      }
    });
  });
  var n6 = eE;
  Object.keys(n6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === n6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return n6[l];
      }
    });
  });
  var a6 = tE;
  Object.keys(a6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === a6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return a6[l];
      }
    });
  });
  var i6 = rE;
  Object.keys(i6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === i6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return i6[l];
      }
    });
  });
})(C1);
Object.defineProperty(Sn, "__esModule", {
  value: !0
});
Sn.rangeShape = Sn.default = void 0;
var I1 = dge(P), $e = nE(Zr), j4 = nE(ca), Kt = C1;
function nE(e) {
  return e && e.__esModule ? e : { default: e };
}
function aE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (aE = function(n) {
    return n ? r : t;
  })(e);
}
function dge(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = aE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function y7() {
  return y7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, y7.apply(this, arguments);
}
function Si(e, t, r) {
  return t = fge(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function fge(e) {
  var t = hge(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function hge(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class Fd extends I1.Component {
  constructor(t, r) {
    super(t, r), Si(this, "handleKeyEvent", (n) => {
      const {
        day: a,
        onMouseDown: i,
        onMouseUp: o
      } = this.props;
      [
        13,
        32
        /* enter */
      ].includes(n.keyCode) && (n.type === "keydown" ? i(a) : o(a));
    }), Si(this, "handleMouseEvent", (n) => {
      const {
        day: a,
        disabled: i,
        onPreviewChange: o,
        onMouseEnter: s,
        onMouseDown: c,
        onMouseUp: u
      } = this.props, d = {};
      if (i) {
        o();
        return;
      }
      switch (n.type) {
        case "mouseenter":
          s(a), o(a), d.hover = !0;
          break;
        case "blur":
        case "mouseleave":
          d.hover = !1;
          break;
        case "mousedown":
          d.active = !0, c(a);
          break;
        case "mouseup":
          n.stopPropagation(), d.active = !1, u(a);
          break;
        case "focus":
          o(a);
          break;
      }
      Object.keys(d).length && this.setState(d);
    }), Si(this, "getClassNames", () => {
      const {
        isPassive: n,
        isToday: a,
        isWeekend: i,
        isStartOfWeek: o,
        isEndOfWeek: s,
        isStartOfMonth: c,
        isEndOfMonth: u,
        disabled: d,
        styles: h
      } = this.props;
      return (0, j4.default)(h.day, {
        [h.dayPassive]: n,
        [h.dayDisabled]: d,
        [h.dayToday]: a,
        [h.dayWeekend]: i,
        [h.dayStartOfWeek]: o,
        [h.dayEndOfWeek]: s,
        [h.dayStartOfMonth]: c,
        [h.dayEndOfMonth]: u,
        [h.dayHovered]: this.state.hover,
        [h.dayActive]: this.state.active
      });
    }), Si(this, "renderPreviewPlaceholder", () => {
      const {
        preview: n,
        day: a,
        styles: i
      } = this.props;
      if (!n)
        return null;
      const o = n.startDate ? (0, Kt.endOfDay)(n.startDate) : null, s = n.endDate ? (0, Kt.startOfDay)(n.endDate) : null, c = (!o || (0, Kt.isAfter)(a, o)) && (!s || (0, Kt.isBefore)(a, s)), u = !c && (0, Kt.isSameDay)(a, o), d = !c && (0, Kt.isSameDay)(a, s);
      return /* @__PURE__ */ I1.default.createElement("span", {
        className: (0, j4.default)({
          [i.dayStartPreview]: u,
          [i.dayInPreview]: c,
          [i.dayEndPreview]: d
        }),
        style: {
          color: n.color
        }
      });
    }), Si(this, "renderSelectionPlaceholders", () => {
      const {
        styles: n,
        ranges: a,
        day: i
      } = this.props;
      return this.props.displayMode === "date" ? (0, Kt.isSameDay)(this.props.day, this.props.date) ? /* @__PURE__ */ I1.default.createElement("span", {
        className: n.selected,
        style: {
          color: this.props.color
        }
      }) : null : a.reduce((s, c) => {
        let u = c.startDate, d = c.endDate;
        u && d && (0, Kt.isBefore)(d, u) && ([u, d] = [d, u]), u = u ? (0, Kt.endOfDay)(u) : null, d = d ? (0, Kt.startOfDay)(d) : null;
        const h = (!u || (0, Kt.isAfter)(i, u)) && (!d || (0, Kt.isBefore)(i, d)), A = !h && (0, Kt.isSameDay)(i, u), p = !h && (0, Kt.isSameDay)(i, d);
        return h || A || p ? [...s, {
          isStartEdge: A,
          isEndEdge: p,
          isInRange: h,
          ...c
        }] : s;
      }, []).map((s, c) => /* @__PURE__ */ I1.default.createElement("span", {
        key: c,
        className: (0, j4.default)({
          [n.startEdge]: s.isStartEdge,
          [n.endEdge]: s.isEndEdge,
          [n.inRange]: s.isInRange
        }),
        style: {
          color: s.color || this.props.color
        }
      }));
    }), this.state = {
      hover: !1,
      active: !1
    };
  }
  render() {
    const {
      dayContentRenderer: t
    } = this.props;
    return /* @__PURE__ */ I1.default.createElement("button", y7({
      type: "button",
      onMouseEnter: this.handleMouseEvent,
      onMouseLeave: this.handleMouseEvent,
      onFocus: this.handleMouseEvent,
      onMouseDown: this.handleMouseEvent,
      onMouseUp: this.handleMouseEvent,
      onBlur: this.handleMouseEvent,
      onPauseCapture: this.handleMouseEvent,
      onKeyDown: this.handleKeyEvent,
      onKeyUp: this.handleKeyEvent,
      className: this.getClassNames(this.props.styles)
    }, this.props.disabled || this.props.isPassive ? {
      tabIndex: -1
    } : {}, {
      style: {
        color: this.props.color
      }
    }), this.renderSelectionPlaceholders(), this.renderPreviewPlaceholder(), /* @__PURE__ */ I1.default.createElement("span", {
      className: this.props.styles.dayNumber
    }, (t == null ? void 0 : t(this.props.day)) || /* @__PURE__ */ I1.default.createElement("span", null, (0, Kt.format)(this.props.day, this.props.dayDisplayFormat))));
  }
}
Fd.defaultProps = {};
const Age = Sn.rangeShape = $e.default.shape({
  startDate: $e.default.object,
  endDate: $e.default.object,
  color: $e.default.string,
  key: $e.default.string,
  autoFocus: $e.default.bool,
  disabled: $e.default.bool,
  showDateDisplay: $e.default.bool
});
Fd.propTypes = {
  day: $e.default.object.isRequired,
  dayDisplayFormat: $e.default.string,
  date: $e.default.object,
  ranges: $e.default.arrayOf(Age),
  preview: $e.default.shape({
    startDate: $e.default.object,
    endDate: $e.default.object,
    color: $e.default.string
  }),
  onPreviewChange: $e.default.func,
  previewColor: $e.default.string,
  disabled: $e.default.bool,
  isPassive: $e.default.bool,
  isToday: $e.default.bool,
  isWeekend: $e.default.bool,
  isStartOfWeek: $e.default.bool,
  isEndOfWeek: $e.default.bool,
  isStartOfMonth: $e.default.bool,
  isEndOfMonth: $e.default.bool,
  color: $e.default.string,
  displayMode: $e.default.oneOf(["dateRange", "date"]),
  styles: $e.default.object,
  onMouseDown: $e.default.func,
  onMouseUp: $e.default.func,
  onMouseEnter: $e.default.func,
  dayContentRenderer: $e.default.func
};
Sn.default = Fd;
var wl = {}, Fn = {};
Object.defineProperty(Fn, "__esModule", {
  value: !0
});
Fn.calcFocusDate = vge;
Fn.findNextRangeIndex = mge;
Fn.generateStyles = bge;
Fn.getMonthDisplayRange = Cge;
var pge = gge(ca), mn = C1;
function gge(e) {
  return e && e.__esModule ? e : { default: e };
}
function vge(e, t) {
  const {
    shownDate: r,
    date: n,
    months: a,
    ranges: i,
    focusedRange: o,
    displayMode: s
  } = t;
  let c;
  if (s === "dateRange") {
    const d = i[o[0]] || {};
    c = {
      start: d.startDate,
      end: d.endDate
    };
  } else
    c = {
      start: n,
      end: n
    };
  c.start = (0, mn.startOfMonth)(c.start || /* @__PURE__ */ new Date()), c.end = (0, mn.endOfMonth)(c.end || c.start);
  const u = c.start || c.end || r || /* @__PURE__ */ new Date();
  return e ? (0, mn.differenceInCalendarMonths)(c.start, c.end) > a ? e : u : r || u;
}
function mge(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
  const r = e.findIndex((n, a) => a > t && n.autoFocus !== !1 && !n.disabled);
  return r !== -1 ? r : e.findIndex((n) => n.autoFocus !== !1 && !n.disabled);
}
function Cge(e, t, r) {
  const n = (0, mn.startOfMonth)(e, t), a = (0, mn.endOfMonth)(e, t), i = (0, mn.startOfWeek)(n, t);
  let o = (0, mn.endOfWeek)(a, t);
  return r && (0, mn.differenceInCalendarDays)(o, i) <= 34 && (o = (0, mn.addDays)(o, 7)), {
    start: i,
    end: o,
    startDateOfMonth: n,
    endDateOfMonth: a
  };
}
function bge(e) {
  return e.length ? e.filter((r) => !!r).reduce((r, n) => (Object.keys(n).forEach((a) => {
    r[a] = (0, pge.default)(r[a], n[a]);
  }), r), {}) : {};
}
Object.defineProperty(wl, "__esModule", {
  value: !0
});
wl.default = void 0;
var V1 = sE(P), it = wge(Zr), iE = sE(Sn), Dt = C1, yge = Fn;
function wge(e) {
  return e && e.__esModule ? e : { default: e };
}
function oE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (oE = function(n) {
    return n ? r : t;
  })(e);
}
function sE(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = oE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function w7() {
  return w7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, w7.apply(this, arguments);
}
function xge(e, t, r) {
  const n = /* @__PURE__ */ new Date();
  return /* @__PURE__ */ V1.default.createElement("div", {
    className: e.weekDays
  }, (0, Dt.eachDayOfInterval)({
    start: (0, Dt.startOfWeek)(n, t),
    end: (0, Dt.endOfWeek)(n, t)
  }).map((a, i) => /* @__PURE__ */ V1.default.createElement("span", {
    className: e.weekDay,
    key: i
  }, (0, Dt.format)(a, r, t))));
}
class $d extends V1.PureComponent {
  render() {
    const t = /* @__PURE__ */ new Date(), {
      displayMode: r,
      focusedRange: n,
      drag: a,
      styles: i,
      disabledDates: o,
      disabledDay: s
    } = this.props, c = this.props.minDate && (0, Dt.startOfDay)(this.props.minDate), u = this.props.maxDate && (0, Dt.endOfDay)(this.props.maxDate), d = (0, yge.getMonthDisplayRange)(this.props.month, this.props.dateOptions, this.props.fixedHeight);
    let h = this.props.ranges;
    if (r === "dateRange" && a.status) {
      let {
        startDate: p,
        endDate: v
      } = a.range;
      h = h.map((g, m) => m !== n[0] ? g : {
        ...g,
        startDate: p,
        endDate: v
      });
    }
    const A = this.props.showPreview && !a.disablePreview;
    return /* @__PURE__ */ V1.default.createElement("div", {
      className: i.month,
      style: this.props.style
    }, this.props.showMonthName ? /* @__PURE__ */ V1.default.createElement("div", {
      className: i.monthName
    }, (0, Dt.format)(this.props.month, this.props.monthDisplayFormat, this.props.dateOptions)) : null, this.props.showWeekDays && xge(i, this.props.dateOptions, this.props.weekdayDisplayFormat), /* @__PURE__ */ V1.default.createElement("div", {
      className: i.days,
      onMouseLeave: this.props.onMouseLeave
    }, (0, Dt.eachDayOfInterval)({
      start: d.start,
      end: d.end
    }).map((p, v) => {
      const g = (0, Dt.isSameDay)(p, d.startDateOfMonth), m = (0, Dt.isSameDay)(p, d.endDateOfMonth), b = c && (0, Dt.isBefore)(p, c) || u && (0, Dt.isAfter)(p, u), w = o.some((y) => (0, Dt.isSameDay)(y, p)), x = s(p);
      return /* @__PURE__ */ V1.default.createElement(iE.default, w7({}, this.props, {
        ranges: h,
        day: p,
        preview: A ? this.props.preview : null,
        isWeekend: (0, Dt.isWeekend)(p, this.props.dateOptions),
        isToday: (0, Dt.isSameDay)(p, t),
        isStartOfWeek: (0, Dt.isSameDay)(p, (0, Dt.startOfWeek)(p, this.props.dateOptions)),
        isEndOfWeek: (0, Dt.isSameDay)(p, (0, Dt.endOfWeek)(p, this.props.dateOptions)),
        isStartOfMonth: g,
        isEndOfMonth: m,
        key: v,
        disabled: b || w || x,
        isPassive: !(0, Dt.isWithinInterval)(p, {
          start: d.startDateOfMonth,
          end: d.endDateOfMonth
        }),
        styles: i,
        onMouseDown: this.props.onDragSelectionStart,
        onMouseUp: this.props.onDragSelectionEnd,
        onMouseEnter: this.props.onDragSelectionMove,
        dragRange: a.range,
        drag: a.status
      }));
    })));
  }
}
$d.defaultProps = {};
$d.propTypes = {
  style: it.default.object,
  styles: it.default.object,
  month: it.default.object,
  drag: it.default.object,
  dateOptions: it.default.object,
  disabledDates: it.default.array,
  disabledDay: it.default.func,
  preview: it.default.shape({
    startDate: it.default.object,
    endDate: it.default.object
  }),
  showPreview: it.default.bool,
  displayMode: it.default.oneOf(["dateRange", "date"]),
  minDate: it.default.object,
  maxDate: it.default.object,
  ranges: it.default.arrayOf(iE.rangeShape),
  focusedRange: it.default.arrayOf(it.default.number),
  onDragSelectionStart: it.default.func,
  onDragSelectionEnd: it.default.func,
  onDragSelectionMove: it.default.func,
  onMouseLeave: it.default.func,
  monthDisplayFormat: it.default.string,
  weekdayDisplayFormat: it.default.string,
  dayDisplayFormat: it.default.string,
  showWeekDays: it.default.bool,
  showMonthName: it.default.bool,
  fixedHeight: it.default.bool
};
wl.default = $d;
var xl = {};
Object.defineProperty(xl, "__esModule", {
  value: !0
});
xl.default = void 0;
var U3 = Oge(P), tn = lE(Zr), Dge = lE(ca), Pi = C1;
function lE(e) {
  return e && e.__esModule ? e : { default: e };
}
function cE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (cE = function(n) {
    return n ? r : t;
  })(e);
}
function Oge(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = cE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function I4(e, t, r) {
  return t = Mge(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Mge(e) {
  var t = Ege(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function Ege(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class Hd extends U3.PureComponent {
  constructor(t, r) {
    super(t, r), I4(this, "onKeyDown", (n) => {
      const {
        value: a
      } = this.state;
      n.key === "Enter" && this.update(a);
    }), I4(this, "onChange", (n) => {
      this.setState({
        value: n.target.value,
        changed: !0,
        invalid: !1
      });
    }), I4(this, "onBlur", () => {
      const {
        value: n
      } = this.state;
      this.update(n);
    }), this.state = {
      invalid: !1,
      changed: !1,
      value: this.formatDate(t)
    };
  }
  componentDidUpdate(t) {
    const {
      value: r
    } = t;
    (0, Pi.isEqual)(r, this.props.value) || this.setState({
      value: this.formatDate(this.props)
    });
  }
  formatDate(t) {
    let {
      value: r,
      dateDisplayFormat: n,
      dateOptions: a
    } = t;
    return r && (0, Pi.isValid)(r) ? (0, Pi.format)(r, n, a) : "";
  }
  update(t) {
    const {
      invalid: r,
      changed: n
    } = this.state;
    if (r || !n || !t)
      return;
    const {
      onChange: a,
      dateDisplayFormat: i,
      dateOptions: o
    } = this.props, s = (0, Pi.parse)(t, i, /* @__PURE__ */ new Date(), o);
    (0, Pi.isValid)(s) ? this.setState({
      changed: !1
    }, () => a(s)) : this.setState({
      invalid: !0
    });
  }
  render() {
    const {
      className: t,
      readOnly: r,
      placeholder: n,
      ariaLabel: a,
      disabled: i,
      onFocus: o
    } = this.props, {
      value: s,
      invalid: c
    } = this.state;
    return /* @__PURE__ */ U3.default.createElement("span", {
      className: (0, Dge.default)("rdrDateInput", t)
    }, /* @__PURE__ */ U3.default.createElement("input", {
      readOnly: r,
      disabled: i,
      value: s,
      placeholder: n,
      "aria-label": a,
      onKeyDown: this.onKeyDown,
      onChange: this.onChange,
      onBlur: this.onBlur,
      onFocus: o
    }), c && /* @__PURE__ */ U3.default.createElement("span", {
      className: "rdrWarning"
    }, "⚠"));
  }
}
Hd.propTypes = {
  value: tn.default.object,
  placeholder: tn.default.string,
  disabled: tn.default.bool,
  readOnly: tn.default.bool,
  dateOptions: tn.default.object,
  dateDisplayFormat: tn.default.string,
  ariaLabel: tn.default.string,
  className: tn.default.string,
  onFocus: tn.default.func.isRequired,
  onChange: tn.default.func.isRequired
};
Hd.defaultProps = {
  readOnly: !0,
  disabled: !1,
  dateDisplayFormat: "MMM D, YYYY"
};
xl.default = Hd;
var uE = { exports: {} };
(function(e, t) {
  (function(r, n) {
    n(Zr, P);
  })(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : ji, function(r, n) {
    r = c(r), n = s(n);
    var a, i;
    function o() {
      if (typeof WeakMap != "function")
        return null;
      var T = /* @__PURE__ */ new WeakMap();
      return o = function() {
        return T;
      }, T;
    }
    function s(T) {
      if (T && T.__esModule)
        return T;
      if (T === null || u(T) !== "object" && typeof T != "function")
        return { default: T };
      var Q = o();
      if (Q && Q.has(T))
        return Q.get(T);
      var z = {}, W = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var H in T)
        if (Object.prototype.hasOwnProperty.call(T, H)) {
          var $ = W ? Object.getOwnPropertyDescriptor(T, H) : null;
          $ && ($.get || $.set) ? Object.defineProperty(z, H, $) : z[H] = T[H];
        }
      return z.default = T, Q && Q.set(T, z), z;
    }
    function c(T) {
      return T && T.__esModule ? T : { default: T };
    }
    function u(T) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? u = function(z) {
        return typeof z;
      } : u = function(z) {
        return z && typeof Symbol == "function" && z.constructor === Symbol && z !== Symbol.prototype ? "symbol" : typeof z;
      }, u(T);
    }
    function d(T, Q) {
      if (!(T instanceof Q))
        throw new TypeError("Cannot call a class as a function");
    }
    function h(T, Q) {
      for (var z = 0; z < Q.length; z++) {
        var W = Q[z];
        W.enumerable = W.enumerable || !1, W.configurable = !0, "value" in W && (W.writable = !0), Object.defineProperty(T, W.key, W);
      }
    }
    function A(T, Q, z) {
      return Q && h(T.prototype, Q), z && h(T, z), T;
    }
    function p(T, Q) {
      if (typeof Q != "function" && Q !== null)
        throw new TypeError("Super expression must either be null or a function");
      T.prototype = Object.create(Q && Q.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), Q && v(T, Q);
    }
    function v(T, Q) {
      return v = Object.setPrototypeOf || function(W, H) {
        return W.__proto__ = H, W;
      }, v(T, Q);
    }
    function g(T) {
      var Q = w();
      return function() {
        var W = x(T), H;
        if (Q) {
          var $ = x(this).constructor;
          H = Reflect.construct(W, arguments, $);
        } else
          H = W.apply(this, arguments);
        return m(this, H);
      };
    }
    function m(T, Q) {
      return Q && (u(Q) === "object" || typeof Q == "function") ? Q : b(T);
    }
    function b(T) {
      if (T === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return T;
    }
    function w() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function x(T) {
      return x = Object.setPrototypeOf ? Object.getPrototypeOf : function(z) {
        return z.__proto__ || Object.getPrototypeOf(z);
      }, x(T);
    }
    function y(T, Q) {
      var z = Object.keys(T);
      if (Object.getOwnPropertySymbols) {
        var W = Object.getOwnPropertySymbols(T);
        Q && (W = W.filter(function(H) {
          return Object.getOwnPropertyDescriptor(T, H).enumerable;
        })), z.push.apply(z, W);
      }
      return z;
    }
    function C(T) {
      for (var Q = 1; Q < arguments.length; Q++) {
        var z = arguments[Q] != null ? arguments[Q] : {};
        Q % 2 ? y(Object(z), !0).forEach(function(W) {
          O(T, W, z[W]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(T, Object.getOwnPropertyDescriptors(z)) : y(Object(z)).forEach(function(W) {
          Object.defineProperty(T, W, Object.getOwnPropertyDescriptor(z, W));
        });
      }
      return T;
    }
    function O(T, Q, z) {
      return Q in T ? Object.defineProperty(T, Q, { value: z, enumerable: !0, configurable: !0, writable: !0 }) : T[Q] = z, T;
    }
    var M = {
      x: "clientWidth",
      y: "clientHeight"
    }, E = {
      x: "clientTop",
      y: "clientLeft"
    }, N = {
      x: "innerWidth",
      y: "innerHeight"
    }, F = {
      x: "offsetWidth",
      y: "offsetHeight"
    }, k = {
      x: "offsetLeft",
      y: "offsetTop"
    }, R = {
      x: "overflowX",
      y: "overflowY"
    }, j = {
      x: "scrollWidth",
      y: "scrollHeight"
    }, U = {
      x: "scrollLeft",
      y: "scrollTop"
    }, ee = {
      x: "width",
      y: "height"
    }, X = function() {
    }, Z = function() {
      if (typeof window > "u")
        return !1;
      var T = !1;
      try {
        document.createElement("div").addEventListener("test", X, {
          get passive() {
            return T = !0, !1;
          }
        });
      } catch {
      }
      return T;
    }() ? {
      passive: !0
    } : !1, te = "ReactList failed to reach a stable state.", B = 40, I = function(Q, z) {
      for (var W in z)
        if (Q[W] !== z[W])
          return !1;
      return !0;
    }, _ = function(Q) {
      for (var z = Q.props.axis, W = Q.getEl(), H = R[z]; W = W.parentElement; )
        switch (window.getComputedStyle(W)[H]) {
          case "auto":
          case "scroll":
          case "overlay":
            return W;
        }
      return window;
    }, L = function(Q) {
      var z = Q.props.axis, W = Q.scrollParent;
      return W === window ? window[N[z]] : W[M[z]];
    }, D = function(Q, z) {
      var W = Q.length, H = Q.minSize, $ = Q.type, V = z.from, Y = z.size, S = z.itemsPerRow;
      Y = Math.max(Y, H);
      var J = Y % S;
      return J && (Y += S - J), Y > W && (Y = W), V = $ === "simple" || !V ? 0 : Math.max(Math.min(V, W - Y), 0), (J = V % S) && (V -= J, Y += J), V === z.from && Y == z.size ? z : C(C({}, z), {}, {
        from: V,
        size: Y
      });
    };
    e.exports = (i = a = /* @__PURE__ */ function(T) {
      p(z, T);
      var Q = g(z);
      A(z, null, [{
        key: "getDerivedStateFromProps",
        value: function(H, $) {
          var V = D(H, $);
          return V === $ ? null : V;
        }
      }]);
      function z(W) {
        var H;
        return d(this, z), H = Q.call(this, W), H.state = D(W, {
          itemsPerRow: 1,
          from: W.initialIndex,
          size: 0
        }), H.cache = {}, H.cachedScrollPosition = null, H.prevPrevState = {}, H.unstable = !1, H.updateCounter = 0, H;
      }
      return A(z, [{
        key: "componentDidMount",
        value: function() {
          this.updateFrameAndClearCache = this.updateFrameAndClearCache.bind(this), window.addEventListener("resize", this.updateFrameAndClearCache), this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
        }
      }, {
        key: "componentDidUpdate",
        value: function(H) {
          var $ = this;
          if (this.props.axis !== H.axis && this.clearSizeCache(), !this.unstable) {
            if (++this.updateCounter > B)
              return this.unstable = !0, console.error(te);
            this.updateCounterTimeoutId || (this.updateCounterTimeoutId = setTimeout(function() {
              $.updateCounter = 0, delete $.updateCounterTimeoutId;
            }, 0)), this.updateFrame();
          }
        }
      }, {
        key: "maybeSetState",
        value: function(H, $) {
          if (I(this.state, H))
            return $();
          this.setState(H, $);
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          window.removeEventListener("resize", this.updateFrameAndClearCache), this.scrollParent.removeEventListener("scroll", this.updateFrameAndClearCache, Z), this.scrollParent.removeEventListener("mousewheel", X, Z);
        }
      }, {
        key: "getOffset",
        value: function(H) {
          var $ = this.props.axis, V = H[E[$]] || 0, Y = k[$];
          do
            V += H[Y] || 0;
          while (H = H.offsetParent);
          return V;
        }
      }, {
        key: "getEl",
        value: function() {
          return this.el || this.items;
        }
      }, {
        key: "getScrollPosition",
        value: function() {
          if (typeof this.cachedScrollPosition == "number")
            return this.cachedScrollPosition;
          var H = this.scrollParent, $ = this.props.axis, V = U[$], Y = H === window ? (
            // Firefox always returns document.body[scrollKey] as 0 and Chrome/Safari
            // always return document.documentElement[scrollKey] as 0, so take
            // whichever has a value.
            document.body[V] || document.documentElement[V]
          ) : H[V], S = this.getScrollSize() - this.props.scrollParentViewportSizeGetter(this), J = Math.max(0, Math.min(Y, S)), q = this.getEl();
          return this.cachedScrollPosition = this.getOffset(H) + J - this.getOffset(q), this.cachedScrollPosition;
        }
      }, {
        key: "setScroll",
        value: function(H) {
          var $ = this.scrollParent, V = this.props.axis;
          if (H += this.getOffset(this.getEl()), $ === window)
            return window.scrollTo(0, H);
          H -= this.getOffset(this.scrollParent), $[U[V]] = H;
        }
      }, {
        key: "getScrollSize",
        value: function() {
          var H = this.scrollParent, $ = document, V = $.body, Y = $.documentElement, S = j[this.props.axis];
          return H === window ? Math.max(V[S], Y[S]) : H[S];
        }
      }, {
        key: "hasDeterminateSize",
        value: function() {
          var H = this.props, $ = H.itemSizeGetter, V = H.type;
          return V === "uniform" || $;
        }
      }, {
        key: "getStartAndEnd",
        value: function() {
          var H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props.threshold, $ = this.getScrollPosition(), V = Math.max(0, $ - H), Y = $ + this.props.scrollParentViewportSizeGetter(this) + H;
          return this.hasDeterminateSize() && (Y = Math.min(Y, this.getSpaceBefore(this.props.length))), {
            start: V,
            end: Y
          };
        }
      }, {
        key: "getItemSizeAndItemsPerRow",
        value: function() {
          var H = this.props, $ = H.axis, V = H.useStaticSize, Y = this.state, S = Y.itemSize, J = Y.itemsPerRow;
          if (V && S && J)
            return {
              itemSize: S,
              itemsPerRow: J
            };
          var q = this.items.children;
          if (!q.length)
            return {};
          var re = q[0], ae = re[F[$]], oe = Math.abs(ae - S);
          if ((isNaN(oe) || oe >= 1) && (S = ae), !S)
            return {};
          var ue = k[$], Ae = re[ue];
          J = 1;
          for (var ge = q[J]; ge && ge[ue] === Ae; ge = q[J])
            ++J;
          return {
            itemSize: S,
            itemsPerRow: J
          };
        }
      }, {
        key: "clearSizeCache",
        value: function() {
          this.cachedScrollPosition = null;
        }
        // Called by 'scroll' and 'resize' events, clears scroll position cache.
      }, {
        key: "updateFrameAndClearCache",
        value: function(H) {
          return this.clearSizeCache(), this.updateFrame(H);
        }
      }, {
        key: "updateFrame",
        value: function(H) {
          switch (this.updateScrollParent(), typeof H != "function" && (H = X), this.props.type) {
            case "simple":
              return this.updateSimpleFrame(H);
            case "variable":
              return this.updateVariableFrame(H);
            case "uniform":
              return this.updateUniformFrame(H);
          }
        }
      }, {
        key: "updateScrollParent",
        value: function() {
          var H = this.scrollParent;
          this.scrollParent = this.props.scrollParentGetter(this), H !== this.scrollParent && (H && (H.removeEventListener("scroll", this.updateFrameAndClearCache), H.removeEventListener("mousewheel", X)), this.clearSizeCache(), this.scrollParent.addEventListener("scroll", this.updateFrameAndClearCache, Z), this.scrollParent.addEventListener("mousewheel", X, Z));
        }
      }, {
        key: "updateSimpleFrame",
        value: function(H) {
          var $ = this.getStartAndEnd(), V = $.end, Y = this.items.children, S = 0;
          if (Y.length) {
            var J = this.props.axis, q = Y[0], re = Y[Y.length - 1];
            S = this.getOffset(re) + re[F[J]] - this.getOffset(q);
          }
          if (S > V)
            return H();
          var ae = this.props, oe = ae.pageSize, ue = ae.length, Ae = Math.min(this.state.size + oe, ue);
          this.maybeSetState({
            size: Ae
          }, H);
        }
      }, {
        key: "updateVariableFrame",
        value: function(H) {
          this.props.itemSizeGetter || this.cacheSizes();
          for (var $ = this.getStartAndEnd(), V = $.start, Y = $.end, S = this.props, J = S.length, q = S.pageSize, re = 0, ae = 0, oe = 0, ue = J - 1; ae < ue; ) {
            var Ae = this.getSizeOfItem(ae);
            if (Ae == null || re + Ae > V)
              break;
            re += Ae, ++ae;
          }
          for (var ge = J - ae; oe < ge && re < Y; ) {
            var Se = this.getSizeOfItem(ae + oe);
            if (Se == null) {
              oe = Math.min(oe + q, ge);
              break;
            }
            re += Se, ++oe;
          }
          this.maybeSetState(D(this.props, {
            from: ae,
            itemsPerRow: 1,
            size: oe
          }), H);
        }
      }, {
        key: "updateUniformFrame",
        value: function(H) {
          var $ = this.getItemSizeAndItemsPerRow(), V = $.itemSize, Y = $.itemsPerRow;
          if (!V || !Y)
            return H();
          var S = this.getStartAndEnd(), J = S.start, q = S.end, re = D(this.props, {
            from: Math.floor(J / V) * Y,
            size: (Math.ceil((q - J) / V) + 1) * Y,
            itemsPerRow: Y
          }), ae = re.from, oe = re.size;
          return this.maybeSetState({
            itemsPerRow: Y,
            from: ae,
            itemSize: V,
            size: oe
          }, H);
        }
      }, {
        key: "getSpaceBefore",
        value: function(H) {
          var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          if ($[H] != null)
            return $[H];
          var V = this.state, Y = V.itemSize, S = V.itemsPerRow;
          if (Y)
            return $[H] = Math.floor(H / S) * Y;
          for (var J = H; J > 0 && $[--J] == null; )
            ;
          for (var q = $[J] || 0, re = J; re < H; ++re) {
            $[re] = q;
            var ae = this.getSizeOfItem(re);
            if (ae == null)
              break;
            q += ae;
          }
          return $[H] = q;
        }
      }, {
        key: "cacheSizes",
        value: function() {
          for (var H = this.cache, $ = this.state.from, V = this.items.children, Y = F[this.props.axis], S = 0, J = V.length; S < J; ++S)
            H[$ + S] = V[S][Y];
        }
      }, {
        key: "getSizeOfItem",
        value: function(H) {
          var $ = this.cache, V = this.items, Y = this.props, S = Y.axis, J = Y.itemSizeGetter, q = Y.itemSizeEstimator, re = Y.type, ae = this.state, oe = ae.from, ue = ae.itemSize, Ae = ae.size;
          if (ue)
            return ue;
          if (J)
            return J(H);
          if (H in $)
            return $[H];
          if (re === "simple" && H >= oe && H < oe + Ae && V) {
            var ge = V.children[H - oe];
            if (ge)
              return ge[F[S]];
          }
          if (q)
            return q(H, $);
        }
      }, {
        key: "scrollTo",
        value: function(H) {
          H != null && this.setScroll(this.getSpaceBefore(H));
        }
      }, {
        key: "scrollAround",
        value: function(H) {
          var $ = this.getScrollPosition(), V = this.getSpaceBefore(H), Y = V - this.props.scrollParentViewportSizeGetter(this) + this.getSizeOfItem(H), S = Math.min(Y, V), J = Math.max(Y, V);
          if ($ <= S)
            return this.setScroll(S);
          if ($ > J)
            return this.setScroll(J);
        }
      }, {
        key: "getVisibleRange",
        value: function() {
          for (var H = this.state, $ = H.from, V = H.size, Y = this.getStartAndEnd(0), S = Y.start, J = Y.end, q = {}, re, ae, oe = $; oe < $ + V; ++oe) {
            var ue = this.getSpaceBefore(oe, q), Ae = ue + this.getSizeOfItem(oe);
            re == null && Ae > S && (re = oe), re != null && ue < J && (ae = oe);
          }
          return [re, ae];
        }
      }, {
        key: "renderItems",
        value: function() {
          for (var H = this, $ = this.props, V = $.itemRenderer, Y = $.itemsRenderer, S = this.state, J = S.from, q = S.size, re = [], ae = 0; ae < q; ++ae)
            re.push(V(J + ae, ae));
          return Y(re, function(oe) {
            return H.items = oe;
          });
        }
      }, {
        key: "render",
        value: function() {
          var H = this, $ = this.props, V = $.axis, Y = $.length, S = $.type, J = $.useTranslate3d, q = this.state, re = q.from, ae = q.itemsPerRow, oe = this.renderItems();
          if (S === "simple")
            return oe;
          var ue = {
            position: "relative"
          }, Ae = {}, ge = Math.ceil(Y / ae) * ae, Se = this.getSpaceBefore(ge, Ae);
          Se && (ue[ee[V]] = Se, V === "x" && (ue.overflowX = "hidden"));
          var Te = this.getSpaceBefore(re, Ae), Re = V === "x" ? Te : 0, at = V === "y" ? Te : 0, bt = J ? "translate3d(".concat(Re, "px, ").concat(at, "px, 0)") : "translate(".concat(Re, "px, ").concat(at, "px)"), Qt = {
            msTransform: bt,
            WebkitTransform: bt,
            transform: bt
          };
          return /* @__PURE__ */ n.default.createElement("div", {
            style: ue,
            ref: function(y1) {
              return H.el = y1;
            }
          }, /* @__PURE__ */ n.default.createElement("div", {
            style: Qt
          }, oe));
        }
      }]), z;
    }(n.Component), O(a, "displayName", "ReactList"), O(a, "propTypes", {
      axis: r.default.oneOf(["x", "y"]),
      initialIndex: r.default.number,
      itemRenderer: r.default.func,
      itemSizeEstimator: r.default.func,
      itemSizeGetter: r.default.func,
      itemsRenderer: r.default.func,
      length: r.default.number,
      minSize: r.default.number,
      pageSize: r.default.number,
      scrollParentGetter: r.default.func,
      scrollParentViewportSizeGetter: r.default.func,
      threshold: r.default.number,
      type: r.default.oneOf(["simple", "variable", "uniform"]),
      useStaticSize: r.default.bool,
      useTranslate3d: r.default.bool
    }), O(a, "defaultProps", {
      axis: "y",
      itemRenderer: function(Q, z) {
        return /* @__PURE__ */ n.default.createElement("div", {
          key: z
        }, Q);
      },
      itemsRenderer: function(Q, z) {
        return /* @__PURE__ */ n.default.createElement("div", {
          ref: z
        }, Q);
      },
      length: 0,
      minSize: 1,
      pageSize: 10,
      scrollParentGetter: _,
      scrollParentViewportSizeGetter: L,
      threshold: 100,
      type: "simple",
      useStaticSize: !1,
      useTranslate3d: !1
    }), i);
  });
})(uE);
var Sge = uE.exports;
function Pge(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  var r = Object.keys(e), n = Object.keys(t), a = r.length;
  if (n.length !== a)
    return !1;
  for (var i = 0; i < a; i++) {
    var o = r[i];
    if (e[o] !== t[o] || !Object.prototype.hasOwnProperty.call(t, o))
      return !1;
  }
  return !0;
}
function jge(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (var n = 0; n < r; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
const Ige = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  shallowEqualArrays: jge,
  shallowEqualObjects: Pge
}, Symbol.toStringTag, { value: "Module" })), Bge = /* @__PURE__ */ LE(Ige);
var ha = {};
Object.defineProperty(ha, "__esModule", {
  value: !0
});
ha.default = void 0;
ha.default = {
  dateRangeWrapper: "rdrDateRangeWrapper",
  calendarWrapper: "rdrCalendarWrapper",
  dateDisplay: "rdrDateDisplay",
  dateDisplayItem: "rdrDateDisplayItem",
  dateDisplayItemActive: "rdrDateDisplayItemActive",
  monthAndYearWrapper: "rdrMonthAndYearWrapper",
  monthAndYearPickers: "rdrMonthAndYearPickers",
  nextPrevButton: "rdrNextPrevButton",
  month: "rdrMonth",
  weekDays: "rdrWeekDays",
  weekDay: "rdrWeekDay",
  days: "rdrDays",
  day: "rdrDay",
  dayNumber: "rdrDayNumber",
  dayPassive: "rdrDayPassive",
  dayToday: "rdrDayToday",
  dayStartOfWeek: "rdrDayStartOfWeek",
  dayEndOfWeek: "rdrDayEndOfWeek",
  daySelected: "rdrDaySelected",
  dayDisabled: "rdrDayDisabled",
  dayStartOfMonth: "rdrDayStartOfMonth",
  dayEndOfMonth: "rdrDayEndOfMonth",
  dayWeekend: "rdrDayWeekend",
  dayStartPreview: "rdrDayStartPreview",
  dayInPreview: "rdrDayInPreview",
  dayEndPreview: "rdrDayEndPreview",
  dayHovered: "rdrDayHovered",
  dayActive: "rdrDayActive",
  inRange: "rdrInRange",
  endEdge: "rdrEndEdge",
  startEdge: "rdrStartEdge",
  prevButton: "rdrPprevButton",
  nextButton: "rdrNextButton",
  selected: "rdrSelected",
  months: "rdrMonths",
  monthPicker: "rdrMonthPicker",
  yearPicker: "rdrYearPicker",
  dateDisplayWrapper: "rdrDateDisplayWrapper",
  definedRangesWrapper: "rdrDefinedRangesWrapper",
  staticRanges: "rdrStaticRanges",
  staticRange: "rdrStaticRange",
  inputRanges: "rdrInputRanges",
  inputRange: "rdrInputRange",
  inputRangeInput: "rdrInputRangeInput",
  dateRangePickerWrapper: "rdrDateRangePickerWrapper",
  staticRangeLabel: "rdrStaticRangeLabel",
  staticRangeSelected: "rdrStaticRangeSelected",
  monthName: "rdrMonthName",
  infiniteMonths: "rdrInfiniteMonths",
  monthsVertical: "rdrMonthsVertical",
  monthsHorizontal: "rdrMonthsHorizontal"
};
var Dl = {};
Object.defineProperty(Dl, "__esModule", {
  value: !0
});
Dl.ariaLabelsShape = void 0;
var gn = Nge(Zr);
function Nge(e) {
  return e && e.__esModule ? e : { default: e };
}
Dl.ariaLabelsShape = gn.default.shape({
  dateInput: gn.default.objectOf(gn.default.shape({
    startDate: gn.default.string,
    endDate: gn.default.string
  })),
  monthPicker: gn.default.string,
  yearPicker: gn.default.string,
  prevButton: gn.default.string,
  nextButton: gn.default.string
});
Object.defineProperty(i3, "__esModule", {
  value: !0
});
i3.default = void 0;
var rt = Hge(P), me = H2(Zr), Lge = Sn, _m = H2(wl), Rm = H2(xl), Z3 = Fn, B1 = H2(ca), Tge = H2(Sge), _ge = Bge, ft = C1, Rge = Al, Fge = H2(ha), $ge = Dl;
function H2(e) {
  return e && e.__esModule ? e : { default: e };
}
function dE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (dE = function(n) {
    return n ? r : t;
  })(e);
}
function Hge(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = dE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function c0() {
  return c0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, c0.apply(this, arguments);
}
function xr(e, t, r) {
  return t = Yge(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Yge(e) {
  var t = kge(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function kge(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class v2 extends rt.PureComponent {
  constructor(t, r) {
    var n;
    super(t, r), n = this, xr(this, "focusToDate", function(a) {
      let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n.props, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
      if (!i.scroll.enabled) {
        if (o && i.preventSnapRefocus) {
          const u = (0, ft.differenceInCalendarMonths)(a, n.state.focusedDate), d = i.calendarFocus === "forwards" && u >= 0, h = i.calendarFocus === "backwards" && u <= 0;
          if ((d || h) && Math.abs(u) < i.months)
            return;
        }
        n.setState({
          focusedDate: a
        });
        return;
      }
      const s = (0, ft.differenceInCalendarMonths)(a, i.minDate, n.dateOptions), c = n.list.getVisibleRange();
      o && c.includes(s) || (n.isFirstRender = !0, n.list.scrollTo(s), n.setState({
        focusedDate: a
      }));
    }), xr(this, "updateShownDate", function() {
      let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : n.props;
      const i = a.scroll.enabled ? {
        ...a,
        months: n.list.getVisibleRange().length
      } : a, o = (0, Z3.calcFocusDate)(n.state.focusedDate, i);
      n.focusToDate(o, i);
    }), xr(this, "updatePreview", (a) => {
      if (!a) {
        this.setState({
          preview: null
        });
        return;
      }
      const i = {
        startDate: a,
        endDate: a,
        color: this.props.color
      };
      this.setState({
        preview: i
      });
    }), xr(this, "changeShownDate", function(a) {
      let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "set";
      const {
        focusedDate: o
      } = n.state, {
        onShownDateChange: s,
        minDate: c,
        maxDate: u
      } = n.props, d = {
        monthOffset: () => (0, ft.addMonths)(o, a),
        setMonth: () => (0, ft.setMonth)(o, a),
        setYear: () => (0, ft.setYear)(o, a),
        set: () => a
      }, h = (0, ft.min)([(0, ft.max)([d[i](), c]), u]);
      n.focusToDate(h, n.props, !1), s && s(h);
    }), xr(this, "handleRangeFocusChange", (a, i) => {
      this.props.onRangeFocusChange && this.props.onRangeFocusChange([a, i]);
    }), xr(this, "handleScroll", () => {
      const {
        onShownDateChange: a,
        minDate: i
      } = this.props, {
        focusedDate: o
      } = this.state, {
        isFirstRender: s
      } = this, c = this.list.getVisibleRange();
      if (c[0] === void 0)
        return;
      const u = (0, ft.addMonths)(i, c[0] || 0);
      !(0, ft.isSameMonth)(u, o) && !s && (this.setState({
        focusedDate: u
      }), a && a(u)), this.isFirstRender = !1;
    }), xr(this, "renderMonthAndYear", (a, i, o) => {
      const {
        showMonthArrow: s,
        minDate: c,
        maxDate: u,
        showMonthAndYearPickers: d,
        ariaLabels: h
      } = o, A = (u || v2.defaultProps.maxDate).getFullYear(), p = (c || v2.defaultProps.minDate).getFullYear(), v = this.styles;
      return /* @__PURE__ */ rt.default.createElement("div", {
        onMouseUp: (g) => g.stopPropagation(),
        className: v.monthAndYearWrapper
      }, s ? /* @__PURE__ */ rt.default.createElement("button", {
        type: "button",
        className: (0, B1.default)(v.nextPrevButton, v.prevButton),
        onClick: () => i(-1, "monthOffset"),
        "aria-label": h.prevButton
      }, /* @__PURE__ */ rt.default.createElement("i", null)) : null, d ? /* @__PURE__ */ rt.default.createElement("span", {
        className: v.monthAndYearPickers
      }, /* @__PURE__ */ rt.default.createElement("span", {
        className: v.monthPicker
      }, /* @__PURE__ */ rt.default.createElement("select", {
        value: a.getMonth(),
        onChange: (g) => i(g.target.value, "setMonth"),
        "aria-label": h.monthPicker
      }, this.state.monthNames.map((g, m) => /* @__PURE__ */ rt.default.createElement("option", {
        key: m,
        value: m
      }, g)))), /* @__PURE__ */ rt.default.createElement("span", {
        className: v.monthAndYearDivider
      }), /* @__PURE__ */ rt.default.createElement("span", {
        className: v.yearPicker
      }, /* @__PURE__ */ rt.default.createElement("select", {
        value: a.getFullYear(),
        onChange: (g) => i(g.target.value, "setYear"),
        "aria-label": h.yearPicker
      }, new Array(A - p + 1).fill(A).map((g, m) => {
        const b = g - m;
        return /* @__PURE__ */ rt.default.createElement("option", {
          key: b,
          value: b
        }, b);
      })))) : /* @__PURE__ */ rt.default.createElement("span", {
        className: v.monthAndYearPickers
      }, this.state.monthNames[a.getMonth()], " ", a.getFullYear()), s ? /* @__PURE__ */ rt.default.createElement("button", {
        type: "button",
        className: (0, B1.default)(v.nextPrevButton, v.nextButton),
        onClick: () => i(1, "monthOffset"),
        "aria-label": h.nextButton
      }, /* @__PURE__ */ rt.default.createElement("i", null)) : null);
    }), xr(this, "renderDateDisplay", () => {
      const {
        focusedRange: a,
        color: i,
        ranges: o,
        rangeColors: s,
        dateDisplayFormat: c,
        editableDateInputs: u,
        startDatePlaceholder: d,
        endDatePlaceholder: h,
        ariaLabels: A
      } = this.props, p = s[a[0]] || i, v = this.styles;
      return /* @__PURE__ */ rt.default.createElement("div", {
        className: v.dateDisplayWrapper
      }, o.map((g, m) => g.showDateDisplay === !1 || g.disabled && !g.showDateDisplay ? null : /* @__PURE__ */ rt.default.createElement("div", {
        className: v.dateDisplay,
        key: m,
        style: {
          color: g.color || p
        }
      }, /* @__PURE__ */ rt.default.createElement(Rm.default, {
        className: (0, B1.default)(v.dateDisplayItem, {
          [v.dateDisplayItemActive]: a[0] === m && a[1] === 0
        }),
        readOnly: !u,
        disabled: g.disabled,
        value: g.startDate,
        placeholder: d,
        dateOptions: this.dateOptions,
        dateDisplayFormat: c,
        ariaLabel: A.dateInput && A.dateInput[g.key] && A.dateInput[g.key].startDate,
        onChange: this.onDragSelectionEnd,
        onFocus: () => this.handleRangeFocusChange(m, 0)
      }), /* @__PURE__ */ rt.default.createElement(Rm.default, {
        className: (0, B1.default)(v.dateDisplayItem, {
          [v.dateDisplayItemActive]: a[0] === m && a[1] === 1
        }),
        readOnly: !u,
        disabled: g.disabled,
        value: g.endDate,
        placeholder: h,
        dateOptions: this.dateOptions,
        dateDisplayFormat: c,
        ariaLabel: A.dateInput && A.dateInput[g.key] && A.dateInput[g.key].endDate,
        onChange: this.onDragSelectionEnd,
        onFocus: () => this.handleRangeFocusChange(m, 1)
      }))));
    }), xr(this, "onDragSelectionStart", (a) => {
      const {
        onChange: i,
        dragSelectionEnabled: o
      } = this.props;
      o ? this.setState({
        drag: {
          status: !0,
          range: {
            startDate: a,
            endDate: a
          },
          disablePreview: !0
        }
      }) : i && i(a);
    }), xr(this, "onDragSelectionEnd", (a) => {
      const {
        updateRange: i,
        displayMode: o,
        onChange: s,
        dragSelectionEnabled: c
      } = this.props;
      if (!c)
        return;
      if (o === "date" || !this.state.drag.status) {
        s && s(a);
        return;
      }
      const u = {
        startDate: this.state.drag.range.startDate,
        endDate: a
      };
      o !== "dateRange" || (0, ft.isSameDay)(u.startDate, a) ? this.setState({
        drag: {
          status: !1,
          range: {}
        }
      }, () => s && s(a)) : this.setState({
        drag: {
          status: !1,
          range: {}
        }
      }, () => {
        i && i(u);
      });
    }), xr(this, "onDragSelectionMove", (a) => {
      const {
        drag: i
      } = this.state;
      !i.status || !this.props.dragSelectionEnabled || this.setState({
        drag: {
          status: i.status,
          range: {
            startDate: i.range.startDate,
            endDate: a
          },
          disablePreview: !0
        }
      });
    }), xr(this, "estimateMonthSize", (a, i) => {
      const {
        direction: o,
        minDate: s
      } = this.props, {
        scrollArea: c
      } = this.state;
      if (i && (this.listSizeCache = i, i[a]))
        return i[a];
      if (o === "horizontal")
        return c.monthWidth;
      const u = (0, ft.addMonths)(s, a), {
        start: d,
        end: h
      } = (0, Z3.getMonthDisplayRange)(u, this.dateOptions);
      return (0, ft.differenceInDays)(h, d, this.dateOptions) + 1 > 7 * 5 ? c.longMonthHeight : c.monthHeight;
    }), this.dateOptions = {
      locale: t.locale
    }, t.weekStartsOn !== void 0 && (this.dateOptions.weekStartsOn = t.weekStartsOn), this.styles = (0, Z3.generateStyles)([Fge.default, t.classNames]), this.listSizeCache = {}, this.isFirstRender = !0, this.state = {
      monthNames: this.getMonthNames(),
      focusedDate: (0, Z3.calcFocusDate)(null, t),
      drag: {
        status: !1,
        range: {
          startDate: null,
          endDate: null
        },
        disablePreview: !1
      },
      scrollArea: this.calcScrollArea(t)
    };
  }
  getMonthNames() {
    return [...Array(12).keys()].map((t) => this.props.locale.localize.month(t));
  }
  calcScrollArea(t) {
    const {
      direction: r,
      months: n,
      scroll: a
    } = t;
    if (!a.enabled)
      return {
        enabled: !1
      };
    const i = a.longMonthHeight || a.monthHeight;
    return r === "vertical" ? {
      enabled: !0,
      monthHeight: a.monthHeight || 220,
      longMonthHeight: i || 260,
      calendarWidth: "auto",
      calendarHeight: (a.calendarHeight || i || 240) * n
    } : {
      enabled: !0,
      monthWidth: a.monthWidth || 332,
      calendarWidth: (a.calendarWidth || a.monthWidth || 332) * n,
      monthHeight: i || 300,
      calendarHeight: i || 300
    };
  }
  componentDidMount() {
    this.props.scroll.enabled && setTimeout(() => this.focusToDate(this.state.focusedDate));
  }
  componentDidUpdate(t) {
    const n = {
      dateRange: "ranges",
      date: "date"
    }[this.props.displayMode];
    this.props[n] !== t[n] && this.updateShownDate(this.props), (t.locale !== this.props.locale || t.weekStartsOn !== this.props.weekStartsOn) && (this.dateOptions = {
      locale: this.props.locale
    }, this.props.weekStartsOn !== void 0 && (this.dateOptions.weekStartsOn = this.props.weekStartsOn), this.setState({
      monthNames: this.getMonthNames()
    })), (0, _ge.shallowEqualObjects)(t.scroll, this.props.scroll) || this.setState({
      scrollArea: this.calcScrollArea(this.props)
    });
  }
  renderWeekdays() {
    const t = /* @__PURE__ */ new Date();
    return /* @__PURE__ */ rt.default.createElement("div", {
      className: this.styles.weekDays
    }, (0, ft.eachDayOfInterval)({
      start: (0, ft.startOfWeek)(t, this.dateOptions),
      end: (0, ft.endOfWeek)(t, this.dateOptions)
    }).map((r, n) => /* @__PURE__ */ rt.default.createElement("span", {
      className: this.styles.weekDay,
      key: n
    }, (0, ft.format)(r, this.props.weekdayDisplayFormat, this.dateOptions))));
  }
  render() {
    const {
      showDateDisplay: t,
      onPreviewChange: r,
      scroll: n,
      direction: a,
      disabledDates: i,
      disabledDay: o,
      maxDate: s,
      minDate: c,
      rangeColors: u,
      color: d,
      navigatorRenderer: h,
      className: A,
      preview: p
    } = this.props, {
      scrollArea: v,
      focusedDate: g
    } = this.state, m = a === "vertical", b = h || this.renderMonthAndYear, w = this.props.ranges.map((x, y) => ({
      ...x,
      color: x.color || u[y] || d
    }));
    return /* @__PURE__ */ rt.default.createElement("div", {
      className: (0, B1.default)(this.styles.calendarWrapper, A),
      onMouseUp: () => this.setState({
        drag: {
          status: !1,
          range: {}
        }
      }),
      onMouseLeave: () => {
        this.setState({
          drag: {
            status: !1,
            range: {}
          }
        });
      }
    }, t && this.renderDateDisplay(), b(g, this.changeShownDate, this.props), n.enabled ? /* @__PURE__ */ rt.default.createElement("div", null, m && this.renderWeekdays(this.dateOptions), /* @__PURE__ */ rt.default.createElement("div", {
      className: (0, B1.default)(this.styles.infiniteMonths, m ? this.styles.monthsVertical : this.styles.monthsHorizontal),
      onMouseLeave: () => r && r(),
      style: {
        width: v.calendarWidth + 11,
        height: v.calendarHeight + 11
      },
      onScroll: this.handleScroll
    }, /* @__PURE__ */ rt.default.createElement(Tge.default, {
      length: (0, ft.differenceInCalendarMonths)((0, ft.endOfMonth)(s), (0, ft.addDays)((0, ft.startOfMonth)(c), -1), this.dateOptions),
      treshold: 500,
      type: "variable",
      ref: (x) => this.list = x,
      itemSizeEstimator: this.estimateMonthSize,
      axis: m ? "y" : "x",
      itemRenderer: (x, y) => {
        const C = (0, ft.addMonths)(c, x);
        return /* @__PURE__ */ rt.default.createElement(_m.default, c0({}, this.props, {
          onPreviewChange: r || this.updatePreview,
          preview: p || this.state.preview,
          ranges: w,
          key: y,
          drag: this.state.drag,
          dateOptions: this.dateOptions,
          disabledDates: i,
          disabledDay: o,
          month: C,
          onDragSelectionStart: this.onDragSelectionStart,
          onDragSelectionEnd: this.onDragSelectionEnd,
          onDragSelectionMove: this.onDragSelectionMove,
          onMouseLeave: () => r && r(),
          styles: this.styles,
          style: m ? {
            height: this.estimateMonthSize(x)
          } : {
            height: v.monthHeight,
            width: this.estimateMonthSize(x)
          },
          showMonthName: !0,
          showWeekDays: !m
        }));
      }
    }))) : /* @__PURE__ */ rt.default.createElement("div", {
      className: (0, B1.default)(this.styles.months, m ? this.styles.monthsVertical : this.styles.monthsHorizontal)
    }, new Array(this.props.months).fill(null).map((x, y) => {
      let C = (0, ft.addMonths)(this.state.focusedDate, y);
      return this.props.calendarFocus === "backwards" && (C = (0, ft.subMonths)(this.state.focusedDate, this.props.months - 1 - y)), /* @__PURE__ */ rt.default.createElement(_m.default, c0({}, this.props, {
        onPreviewChange: r || this.updatePreview,
        preview: p || this.state.preview,
        ranges: w,
        key: y,
        drag: this.state.drag,
        dateOptions: this.dateOptions,
        disabledDates: i,
        disabledDay: o,
        month: C,
        onDragSelectionStart: this.onDragSelectionStart,
        onDragSelectionEnd: this.onDragSelectionEnd,
        onDragSelectionMove: this.onDragSelectionMove,
        onMouseLeave: () => r && r(),
        styles: this.styles,
        showWeekDays: !m || y === 0,
        showMonthName: !m || y > 0
      }));
    })));
  }
}
v2.defaultProps = {
  showMonthArrow: !0,
  showMonthAndYearPickers: !0,
  disabledDates: [],
  disabledDay: () => {
  },
  classNames: {},
  locale: Rge.enUS,
  ranges: [],
  focusedRange: [0, 0],
  dateDisplayFormat: "MMM d, yyyy",
  monthDisplayFormat: "MMM yyyy",
  weekdayDisplayFormat: "E",
  dayDisplayFormat: "d",
  showDateDisplay: !0,
  showPreview: !0,
  displayMode: "date",
  months: 1,
  color: "#3d91ff",
  scroll: {
    enabled: !1
  },
  direction: "vertical",
  maxDate: (0, ft.addYears)(/* @__PURE__ */ new Date(), 20),
  minDate: (0, ft.addYears)(/* @__PURE__ */ new Date(), -100),
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  startDatePlaceholder: "Early",
  endDatePlaceholder: "Continuous",
  editableDateInputs: !1,
  dragSelectionEnabled: !0,
  fixedHeight: !1,
  calendarFocus: "forwards",
  preventSnapRefocus: !1,
  ariaLabels: {}
};
v2.propTypes = {
  showMonthArrow: me.default.bool,
  showMonthAndYearPickers: me.default.bool,
  disabledDates: me.default.array,
  disabledDay: me.default.func,
  minDate: me.default.object,
  maxDate: me.default.object,
  date: me.default.object,
  onChange: me.default.func,
  onPreviewChange: me.default.func,
  onRangeFocusChange: me.default.func,
  classNames: me.default.object,
  locale: me.default.object,
  shownDate: me.default.object,
  onShownDateChange: me.default.func,
  ranges: me.default.arrayOf(Lge.rangeShape),
  preview: me.default.shape({
    startDate: me.default.object,
    endDate: me.default.object,
    color: me.default.string
  }),
  dateDisplayFormat: me.default.string,
  monthDisplayFormat: me.default.string,
  weekdayDisplayFormat: me.default.string,
  weekStartsOn: me.default.number,
  dayDisplayFormat: me.default.string,
  focusedRange: me.default.arrayOf(me.default.number),
  initialFocusedRange: me.default.arrayOf(me.default.number),
  months: me.default.number,
  className: me.default.string,
  showDateDisplay: me.default.bool,
  showPreview: me.default.bool,
  displayMode: me.default.oneOf(["dateRange", "date"]),
  color: me.default.string,
  updateRange: me.default.func,
  scroll: me.default.shape({
    enabled: me.default.bool,
    monthHeight: me.default.number,
    longMonthHeight: me.default.number,
    monthWidth: me.default.number,
    calendarWidth: me.default.number,
    calendarHeight: me.default.number
  }),
  direction: me.default.oneOf(["vertical", "horizontal"]),
  startDatePlaceholder: me.default.string,
  endDatePlaceholder: me.default.string,
  navigatorRenderer: me.default.func,
  rangeColors: me.default.arrayOf(me.default.string),
  editableDateInputs: me.default.bool,
  dragSelectionEnabled: me.default.bool,
  fixedHeight: me.default.bool,
  calendarFocus: me.default.string,
  preventSnapRefocus: me.default.bool,
  ariaLabels: $ge.ariaLabelsShape
};
i3.default = v2;
Object.defineProperty(a3, "__esModule", {
  value: !0
});
a3.default = void 0;
var Fm = Qge(P), Na = Ol(Zr), fE = Ol(i3), Vge = Sn, B4 = Fn, rn = C1, Gge = Ol(ca), Wge = Ol(ha);
function Ol(e) {
  return e && e.__esModule ? e : { default: e };
}
function hE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (hE = function(n) {
    return n ? r : t;
  })(e);
}
function Qge(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = hE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function x7() {
  return x7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, x7.apply(this, arguments);
}
function K3(e, t, r) {
  return t = Uge(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Uge(e) {
  var t = Zge(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function Zge(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class Yd extends Fm.Component {
  constructor(t, r) {
    var n;
    super(t, r), n = this, K3(this, "calcNewSelection", function(a) {
      let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      const o = n.props.focusedRange || n.state.focusedRange, {
        ranges: s,
        onChange: c,
        maxDate: u,
        moveRangeOnFirstSelection: d,
        retainEndDateOnFirstSelection: h,
        disabledDates: A
      } = n.props, p = o[0], v = s[p];
      if (!v || !c)
        return {};
      let {
        startDate: g,
        endDate: m
      } = v;
      const b = /* @__PURE__ */ new Date();
      let w;
      if (!i)
        g = a.startDate, m = a.endDate;
      else if (o[1] === 0) {
        const C = (0, rn.differenceInCalendarDays)(m || b, g), O = () => d ? (0, rn.addDays)(a, C) : h ? !m || (0, rn.isBefore)(a, m) ? m : a : a || b;
        g = a, m = O(), u && (m = (0, rn.min)([m, u])), w = [o[0], 1];
      } else
        m = a;
      let x = o[1] === 0;
      (0, rn.isBefore)(m, g) && (x = !x, [g, m] = [m, g]);
      const y = A.filter((C) => (0, rn.isWithinInterval)(C, {
        start: g,
        end: m
      }));
      return y.length > 0 && (x ? g = (0, rn.addDays)((0, rn.max)(y), 1) : m = (0, rn.addDays)((0, rn.min)(y), -1)), w || (w = [(0, B4.findNextRangeIndex)(n.props.ranges, o[0]), 0]), {
        wasValid: !(y.length > 0),
        range: {
          startDate: g,
          endDate: m
        },
        nextFocusRange: w
      };
    }), K3(this, "setSelection", (a, i) => {
      const {
        onChange: o,
        ranges: s,
        onRangeFocusChange: c
      } = this.props, d = (this.props.focusedRange || this.state.focusedRange)[0], h = s[d];
      if (!h)
        return;
      const A = this.calcNewSelection(a, i);
      o({
        [h.key || `range${d + 1}`]: {
          ...h,
          ...A.range
        }
      }), this.setState({
        focusedRange: A.nextFocusRange,
        preview: null
      }), c && c(A.nextFocusRange);
    }), K3(this, "handleRangeFocusChange", (a) => {
      this.setState({
        focusedRange: a
      }), this.props.onRangeFocusChange && this.props.onRangeFocusChange(a);
    }), K3(this, "updatePreview", (a) => {
      var u;
      if (!a) {
        this.setState({
          preview: null
        });
        return;
      }
      const {
        rangeColors: i,
        ranges: o
      } = this.props, s = this.props.focusedRange || this.state.focusedRange, c = ((u = o[s[0]]) == null ? void 0 : u.color) || i[s[0]] || c;
      this.setState({
        preview: {
          ...a.range,
          color: c
        }
      });
    }), this.state = {
      focusedRange: t.initialFocusedRange || [(0, B4.findNextRangeIndex)(t.ranges), 0],
      preview: null
    }, this.styles = (0, B4.generateStyles)([Wge.default, t.classNames]);
  }
  render() {
    return /* @__PURE__ */ Fm.default.createElement(fE.default, x7({
      focusedRange: this.state.focusedRange,
      onRangeFocusChange: this.handleRangeFocusChange,
      preview: this.state.preview,
      onPreviewChange: (t) => {
        this.updatePreview(t ? this.calcNewSelection(t) : null);
      }
    }, this.props, {
      displayMode: "dateRange",
      className: (0, Gge.default)(this.styles.dateRangeWrapper, this.props.className),
      onChange: this.setSelection,
      updateRange: (t) => this.setSelection(t, !1),
      ref: (t) => {
        this.calendar = t;
      }
    }));
  }
}
Yd.defaultProps = {
  classNames: {},
  ranges: [],
  moveRangeOnFirstSelection: !1,
  retainEndDateOnFirstSelection: !1,
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  disabledDates: []
};
Yd.propTypes = {
  ...fE.default.propTypes,
  onChange: Na.default.func,
  onRangeFocusChange: Na.default.func,
  className: Na.default.string,
  ranges: Na.default.arrayOf(Vge.rangeShape),
  moveRangeOnFirstSelection: Na.default.bool,
  retainEndDateOnFirstSelection: Na.default.bool
};
a3.default = Yd;
var Ml = {}, m3 = {}, d1 = {};
Object.defineProperty(d1, "__esModule", {
  value: !0
});
d1.createStaticRanges = AE;
d1.defaultStaticRanges = d1.defaultInputRanges = void 0;
var st = C1;
const Lt = {
  startOfWeek: (0, st.startOfWeek)(/* @__PURE__ */ new Date()),
  endOfWeek: (0, st.endOfWeek)(/* @__PURE__ */ new Date()),
  startOfLastWeek: (0, st.startOfWeek)((0, st.addDays)(/* @__PURE__ */ new Date(), -7)),
  endOfLastWeek: (0, st.endOfWeek)((0, st.addDays)(/* @__PURE__ */ new Date(), -7)),
  startOfToday: (0, st.startOfDay)(/* @__PURE__ */ new Date()),
  endOfToday: (0, st.endOfDay)(/* @__PURE__ */ new Date()),
  startOfYesterday: (0, st.startOfDay)((0, st.addDays)(/* @__PURE__ */ new Date(), -1)),
  endOfYesterday: (0, st.endOfDay)((0, st.addDays)(/* @__PURE__ */ new Date(), -1)),
  startOfMonth: (0, st.startOfMonth)(/* @__PURE__ */ new Date()),
  endOfMonth: (0, st.endOfMonth)(/* @__PURE__ */ new Date()),
  startOfLastMonth: (0, st.startOfMonth)((0, st.addMonths)(/* @__PURE__ */ new Date(), -1)),
  endOfLastMonth: (0, st.endOfMonth)((0, st.addMonths)(/* @__PURE__ */ new Date(), -1))
}, Kge = {
  range: {},
  isSelected(e) {
    const t = this.range();
    return (0, st.isSameDay)(e.startDate, t.startDate) && (0, st.isSameDay)(e.endDate, t.endDate);
  }
};
function AE(e) {
  return e.map((t) => ({
    ...Kge,
    ...t
  }));
}
d1.defaultStaticRanges = AE([{
  label: "Today",
  range: () => ({
    startDate: Lt.startOfToday,
    endDate: Lt.endOfToday
  })
}, {
  label: "Yesterday",
  range: () => ({
    startDate: Lt.startOfYesterday,
    endDate: Lt.endOfYesterday
  })
}, {
  label: "This Week",
  range: () => ({
    startDate: Lt.startOfWeek,
    endDate: Lt.endOfWeek
  })
}, {
  label: "Last Week",
  range: () => ({
    startDate: Lt.startOfLastWeek,
    endDate: Lt.endOfLastWeek
  })
}, {
  label: "This Month",
  range: () => ({
    startDate: Lt.startOfMonth,
    endDate: Lt.endOfMonth
  })
}, {
  label: "Last Month",
  range: () => ({
    startDate: Lt.startOfLastMonth,
    endDate: Lt.endOfLastMonth
  })
}]);
d1.defaultInputRanges = [{
  label: "days up to today",
  range(e) {
    return {
      startDate: (0, st.addDays)(Lt.startOfToday, (Math.max(Number(e), 1) - 1) * -1),
      endDate: Lt.endOfToday
    };
  },
  getCurrentValue(e) {
    return (0, st.isSameDay)(e.endDate, Lt.endOfToday) ? e.startDate ? (0, st.differenceInCalendarDays)(Lt.endOfToday, e.startDate) + 1 : "∞" : "-";
  }
}, {
  label: "days starting today",
  range(e) {
    const t = /* @__PURE__ */ new Date();
    return {
      startDate: t,
      endDate: (0, st.addDays)(t, Math.max(Number(e), 1) - 1)
    };
  },
  getCurrentValue(e) {
    return (0, st.isSameDay)(e.startDate, Lt.startOfToday) ? e.endDate ? (0, st.differenceInCalendarDays)(e.endDate, Lt.startOfToday) + 1 : "∞" : "-";
  }
}];
var El = {};
Object.defineProperty(El, "__esModule", {
  value: !0
});
El.default = void 0;
var z3 = qge(P), rr = zge(Zr);
function zge(e) {
  return e && e.__esModule ? e : { default: e };
}
function pE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (pE = function(n) {
    return n ? r : t;
  })(e);
}
function qge(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = pE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function Xge(e, t, r) {
  return t = Jge(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Jge(e) {
  var t = eve(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function eve(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const $m = 0, Hm = 99999;
class kd extends z3.Component {
  constructor(t, r) {
    super(t, r), Xge(this, "onChange", (n) => {
      const {
        onChange: a
      } = this.props;
      let i = parseInt(n.target.value, 10);
      i = isNaN(i) ? 0 : Math.max(Math.min(Hm, i), $m), a(i);
    });
  }
  shouldComponentUpdate(t) {
    const {
      value: r,
      label: n,
      placeholder: a
    } = this.props;
    return r !== t.value || n !== t.label || a !== t.placeholder;
  }
  render() {
    const {
      label: t,
      placeholder: r,
      value: n,
      styles: a,
      onBlur: i,
      onFocus: o
    } = this.props;
    return /* @__PURE__ */ z3.default.createElement("div", {
      className: a.inputRange
    }, /* @__PURE__ */ z3.default.createElement("input", {
      className: a.inputRangeInput,
      placeholder: r,
      value: n,
      min: $m,
      max: Hm,
      onChange: this.onChange,
      onFocus: o,
      onBlur: i
    }), /* @__PURE__ */ z3.default.createElement("span", {
      className: a.inputRangeLabel
    }, t));
  }
}
kd.propTypes = {
  value: rr.default.oneOfType([rr.default.string, rr.default.number]),
  label: rr.default.oneOfType([rr.default.element, rr.default.node]).isRequired,
  placeholder: rr.default.string,
  styles: rr.default.shape({
    inputRange: rr.default.string,
    inputRangeInput: rr.default.string,
    inputRangeLabel: rr.default.string
  }).isRequired,
  onBlur: rr.default.func.isRequired,
  onFocus: rr.default.func.isRequired,
  onChange: rr.default.func.isRequired
};
kd.defaultProps = {
  value: "",
  placeholder: "-"
};
El.default = kd;
Object.defineProperty(m3, "__esModule", {
  value: !0
});
m3.default = void 0;
var N1 = nve(P), lr = Sl(Zr), L1 = Sl(ha), Ym = d1, tve = Sn, rve = Sl(El), km = Sl(ca);
function Sl(e) {
  return e && e.__esModule ? e : { default: e };
}
function gE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (gE = function(n) {
    return n ? r : t;
  })(e);
}
function nve(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = gE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function ave(e, t, r) {
  return t = ive(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ive(e) {
  var t = ove(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function ove(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class Vd extends N1.Component {
  constructor(t) {
    super(t), ave(this, "handleRangeChange", (r) => {
      const {
        onChange: n,
        ranges: a,
        focusedRange: i
      } = this.props, o = a[i[0]];
      !n || !o || n({
        [o.key || `range${i[0] + 1}`]: {
          ...o,
          ...r
        }
      });
    }), this.state = {
      rangeOffset: 0,
      focusedInput: -1
    };
  }
  getRangeOptionValue(t) {
    const {
      ranges: r = [],
      focusedRange: n = []
    } = this.props;
    if (typeof t.getCurrentValue != "function")
      return "";
    const a = r[n[0]] || {};
    return t.getCurrentValue(a) || "";
  }
  getSelectedRange(t, r) {
    const n = t.findIndex((i) => !i.startDate || !i.endDate || i.disabled ? !1 : r.isSelected(i));
    return {
      selectedRange: t[n],
      focusedRangeIndex: n
    };
  }
  render() {
    const {
      headerContent: t,
      footerContent: r,
      onPreviewChange: n,
      inputRanges: a,
      staticRanges: i,
      ranges: o,
      renderStaticRangeLabel: s,
      rangeColors: c,
      className: u
    } = this.props;
    return /* @__PURE__ */ N1.default.createElement("div", {
      className: (0, km.default)(L1.default.definedRangesWrapper, u)
    }, t, /* @__PURE__ */ N1.default.createElement("div", {
      className: L1.default.staticRanges
    }, i.map((d, h) => {
      const {
        selectedRange: A,
        focusedRangeIndex: p
      } = this.getSelectedRange(o, d);
      let v;
      return d.hasCustomRendering ? v = s(d) : v = d.label, /* @__PURE__ */ N1.default.createElement("button", {
        type: "button",
        className: (0, km.default)(L1.default.staticRange, {
          [L1.default.staticRangeSelected]: !!A
        }),
        style: {
          color: A ? A.color || c[p] : null
        },
        key: h,
        onClick: () => this.handleRangeChange(d.range(this.props)),
        onFocus: () => n && n(d.range(this.props)),
        onMouseOver: () => n && n(d.range(this.props)),
        onMouseLeave: () => {
          n && n();
        }
      }, /* @__PURE__ */ N1.default.createElement("span", {
        tabIndex: -1,
        className: L1.default.staticRangeLabel
      }, v));
    })), /* @__PURE__ */ N1.default.createElement("div", {
      className: L1.default.inputRanges
    }, a.map((d, h) => /* @__PURE__ */ N1.default.createElement(rve.default, {
      key: h,
      styles: L1.default,
      label: d.label,
      onFocus: () => this.setState({
        focusedInput: h,
        rangeOffset: 0
      }),
      onBlur: () => this.setState({
        rangeOffset: 0
      }),
      onChange: (A) => this.handleRangeChange(d.range(A, this.props)),
      value: this.getRangeOptionValue(d)
    }))), r);
  }
}
Vd.propTypes = {
  inputRanges: lr.default.array,
  staticRanges: lr.default.array,
  ranges: lr.default.arrayOf(tve.rangeShape),
  focusedRange: lr.default.arrayOf(lr.default.number),
  onPreviewChange: lr.default.func,
  onChange: lr.default.func,
  footerContent: lr.default.any,
  headerContent: lr.default.any,
  rangeColors: lr.default.arrayOf(lr.default.string),
  className: lr.default.string,
  renderStaticRangeLabel: lr.default.func
};
Vd.defaultProps = {
  inputRanges: Ym.defaultInputRanges,
  staticRanges: Ym.defaultStaticRanges,
  ranges: [],
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  focusedRange: [0, 0]
};
m3.default = Vd;
Object.defineProperty(Ml, "__esModule", {
  value: !0
});
Ml.default = void 0;
var q3 = uve(P), sve = C3(Zr), vE = C3(a3), mE = C3(m3), Vm = Fn, lve = C3(ca), cve = C3(ha);
function C3(e) {
  return e && e.__esModule ? e : { default: e };
}
function CE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (CE = function(n) {
    return n ? r : t;
  })(e);
}
function uve(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = CE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function u0() {
  return u0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, u0.apply(this, arguments);
}
class Gd extends q3.Component {
  constructor(t) {
    super(t), this.state = {
      focusedRange: [(0, Vm.findNextRangeIndex)(t.ranges), 0]
    }, this.styles = (0, Vm.generateStyles)([cve.default, t.classNames]);
  }
  render() {
    const {
      focusedRange: t
    } = this.state;
    return /* @__PURE__ */ q3.default.createElement("div", {
      className: (0, lve.default)(this.styles.dateRangePickerWrapper, this.props.className)
    }, /* @__PURE__ */ q3.default.createElement(mE.default, u0({
      focusedRange: t,
      onPreviewChange: (r) => this.dateRange.updatePreview(r ? this.dateRange.calcNewSelection(r, typeof r == "string") : null)
    }, this.props, {
      range: this.props.ranges[t[0]],
      className: void 0
    })), /* @__PURE__ */ q3.default.createElement(vE.default, u0({
      onRangeFocusChange: (r) => this.setState({
        focusedRange: r
      }),
      focusedRange: t
    }, this.props, {
      ref: (r) => this.dateRange = r,
      className: void 0
    })));
  }
}
Gd.defaultProps = {};
Gd.propTypes = {
  ...vE.default.propTypes,
  ...mE.default.propTypes,
  className: sve.default.string
};
Ml.default = Gd;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "Calendar", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(e, "DateRange", {
    enumerable: !0,
    get: function() {
      return t.default;
    }
  }), Object.defineProperty(e, "DateRangePicker", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(e, "DefinedRange", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(e, "createStaticRanges", {
    enumerable: !0,
    get: function() {
      return i.createStaticRanges;
    }
  }), Object.defineProperty(e, "defaultInputRanges", {
    enumerable: !0,
    get: function() {
      return i.defaultInputRanges;
    }
  }), Object.defineProperty(e, "defaultStaticRanges", {
    enumerable: !0,
    get: function() {
      return i.defaultStaticRanges;
    }
  });
  var t = o(a3), r = o(i3), n = o(Ml), a = o(m3), i = d1;
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
})(nD);
const dve = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, fve = (e, t, r) => {
  let n;
  const a = dve[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "en " + n : "hace " + n : n;
};
function Va(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const hve = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Ave = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, pve = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, gve = {
  date: Va({
    formats: hve,
    defaultWidth: "full"
  }),
  time: Va({
    formats: Ave,
    defaultWidth: "full"
  }),
  dateTime: Va({
    formats: pve,
    defaultWidth: "full"
  })
}, vve = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, mve = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, Cve = (e, t, r, n) => t.getHours() !== 1 ? mve[e] : vve[e];
function an(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let a;
    if (n === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, s = r != null && r.width ? String(r.width) : o;
      a = e.formattingValues[s] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, s = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[s] || e.values[o];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[i];
  };
}
const bve = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, yve = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, wve = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic"
  ],
  wide: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre"
  ]
}, xve = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado"
  ]
}, Dve = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, Ove = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, Mve = (e, t) => Number(e) + "º", Eve = {
  ordinalNumber: Mve,
  era: an({
    values: bve,
    defaultWidth: "wide"
  }),
  quarter: an({
    values: yve,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: an({
    values: wve,
    defaultWidth: "wide"
  }),
  day: an({
    values: xve,
    defaultWidth: "wide"
  }),
  dayPeriod: an({
    values: Dve,
    defaultWidth: "wide",
    formattingValues: Ove,
    defaultFormattingWidth: "wide"
  })
};
function bE(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n)
      return null;
    const a = n[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    let o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    const s = t.slice(a.length);
    return { value: o, rest: s };
  };
}
function on(e) {
  return (t, r = {}) => {
    const n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    const o = i[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? Pve(s, (h) => h.test(o)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Sve(s, (h) => h.test(o))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(c) : c, u = r.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      r.valueCallback(u)
    ) : u;
    const d = t.slice(o.length);
    return { value: u, rest: d };
  };
}
function Sve(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function Pve(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
const jve = /^(\d+)(º)?/i, Ive = /\d+/i, Bve = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, Nve = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes de la era com[uú]n)/i,
    /^(despu[eé]s de cristo|era com[uú]n)/i
  ]
}, Lve = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Tve = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, _ve = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, Rve = {
  narrow: [
    /^e/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^en/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ]
}, Fve = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, $ve = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, Hve = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, Yve = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, kve = {
  ordinalNumber: bE({
    matchPattern: jve,
    parsePattern: Ive,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: on({
    matchPatterns: Bve,
    defaultMatchWidth: "wide",
    parsePatterns: Nve,
    defaultParseWidth: "any"
  }),
  quarter: on({
    matchPatterns: Lve,
    defaultMatchWidth: "wide",
    parsePatterns: Tve,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: on({
    matchPatterns: _ve,
    defaultMatchWidth: "wide",
    parsePatterns: Rve,
    defaultParseWidth: "any"
  }),
  day: on({
    matchPatterns: Fve,
    defaultMatchWidth: "wide",
    parsePatterns: $ve,
    defaultParseWidth: "any"
  }),
  dayPeriod: on({
    matchPatterns: Hve,
    defaultMatchWidth: "any",
    parsePatterns: Yve,
    defaultParseWidth: "any"
  })
}, Vve = {
  code: "es",
  formatDistance: fve,
  formatLong: gve,
  formatRelative: Cve,
  localize: Eve,
  match: kve,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Gve = Vve;
const yE = P.forwardRef((e) => {
  const { onChangeValueFilterDate: t, valueFilterDate: r } = e, n = /* @__PURE__ */ new Date(), [a, i] = Ee([
    {
      startDate: void 0,
      endDate: void 0,
      key: "selection"
    }
  ]), [o, s] = Ee(!1), c = Ce(null);
  Ne(() => (document.addEventListener("keydown", u, !0), document.addEventListener("click", d, !0), () => {
    document.removeEventListener("keydown", u, !0), document.removeEventListener("click", d, !0);
  }), []);
  const u = (g) => {
    g.key === "Escape" && s(!1);
  }, d = (g) => {
    c.current != null && !c.current.contains(g.target) && s(!1);
  }, h = (g, m) => g != null && m != null ? `${g} - ${m}` : "", A = () => {
    i([
      {
        startDate: n,
        endDate: n,
        key: "selection"
      }
    ]), s(!0);
  }, p = () => {
    s(!1), t != null && t({ option: a[0] });
  }, v = () => {
    s(!1);
  };
  return /* @__PURE__ */ f.jsxs("div", { className: "block relative w-full", children: [
    /* @__PURE__ */ f.jsx(
      Un,
      {
        iconRight: "calendar",
        placeholder: "dd/mm/aaaa",
        value: r != null && r.length === 2 ? h(r[0], r[1]) : "",
        readOnly: !0,
        onClick: A
      }
    ),
    /* @__PURE__ */ f.jsx("div", { ref: c, children: o && /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs("div", { className: "absolute mb-8 left-2/4 -translate-x-1/2 2s:right-0 2s:left-auto 2s:-translate-x-0 top-10 text-[13px] z-20", children: [
      /* @__PURE__ */ f.jsx(
        nD.DateRangePicker,
        {
          onChange: (g) => {
            i([g.selection]);
          },
          editableDateInputs: !0,
          moveRangeOnFirstSelection: !1,
          ranges: a,
          months: 1,
          direction: "horizontal",
          className: "w-[334px] sm:w-auto border rounded-tr-md rounded-tl-md",
          locale: Gve
        }
      ),
      /* @__PURE__ */ f.jsxs("div", { className: "flex justify-end gap-4 p-2 border-l border-b border-r rounded-bl-md rounded-br-md bg-[#fff]", children: [
        /* @__PURE__ */ f.jsx("button", { className: "bg-neutral-300 hover:bg-neutral-200 rounded-md px-5 py-1", onClick: v, children: "Cancelar" }),
        /* @__PURE__ */ f.jsx("button", { className: "bg-secondary-500 hover:bg-secondary-600 rounded-md px-5 py-1 text-white", onClick: p, children: "Aplicar" })
      ] })
    ] }) }) })
  ] });
});
yE.displayName = "DateRangeInput";
const Wve = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Qve = (e, t, r) => {
  let n;
  const a = Wve[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
}, Uve = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Zve = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Kve = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, zve = {
  date: Va({
    formats: Uve,
    defaultWidth: "full"
  }),
  time: Va({
    formats: Zve,
    defaultWidth: "full"
  }),
  dateTime: Va({
    formats: Kve,
    defaultWidth: "full"
  })
}, qve = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Xve = (e, t, r, n) => qve[e], Jve = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, eme = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, tme = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, rme = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, nme = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, ame = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ime = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, ome = {
  ordinalNumber: ime,
  era: an({
    values: Jve,
    defaultWidth: "wide"
  }),
  quarter: an({
    values: eme,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: an({
    values: tme,
    defaultWidth: "wide"
  }),
  day: an({
    values: rme,
    defaultWidth: "wide"
  }),
  dayPeriod: an({
    values: nme,
    defaultWidth: "wide",
    formattingValues: ame,
    defaultFormattingWidth: "wide"
  })
}, sme = /^(\d+)(th|st|nd|rd)?/i, lme = /\d+/i, cme = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, ume = {
  any: [/^b/i, /^(a|c)/i]
}, dme = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, fme = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, hme = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Ame = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, pme = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, gme = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, vme = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, mme = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Cme = {
  ordinalNumber: bE({
    matchPattern: sme,
    parsePattern: lme,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: on({
    matchPatterns: cme,
    defaultMatchWidth: "wide",
    parsePatterns: ume,
    defaultParseWidth: "any"
  }),
  quarter: on({
    matchPatterns: dme,
    defaultMatchWidth: "wide",
    parsePatterns: fme,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: on({
    matchPatterns: hme,
    defaultMatchWidth: "wide",
    parsePatterns: Ame,
    defaultParseWidth: "any"
  }),
  day: on({
    matchPatterns: pme,
    defaultMatchWidth: "wide",
    parsePatterns: gme,
    defaultParseWidth: "any"
  }),
  dayPeriod: on({
    matchPatterns: vme,
    defaultMatchWidth: "any",
    parsePatterns: mme,
    defaultParseWidth: "any"
  })
}, bme = {
  code: "en-US",
  formatDistance: Qve,
  formatLong: zve,
  formatRelative: Xve,
  localize: ome,
  match: Cme,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let yme = {};
function Pl() {
  return yme;
}
const wE = 6048e5, wme = 864e5;
function Xr(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Gm(e) {
  const t = Xr(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Wm(e) {
  const t = Xr(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function xme(e, t) {
  const r = Gm(e), n = Gm(t), a = +r - Wm(r), i = +n - Wm(n);
  return Math.round((a - i) / wme);
}
function ra(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Dme(e) {
  const t = Xr(e), r = ra(e, 0);
  return r.setFullYear(t.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function Ome(e) {
  const t = Xr(e);
  return xme(t, Dme(t)) + 1;
}
function Ho(e, t) {
  var s, c, u, d;
  const r = Pl(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? r.weekStartsOn ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, a = Xr(e), i = a.getDay(), o = (i < n ? 7 : 0) + i - n;
  return a.setDate(a.getDate() - o), a.setHours(0, 0, 0, 0), a;
}
function d0(e) {
  return Ho(e, { weekStartsOn: 1 });
}
function xE(e) {
  const t = Xr(e), r = t.getFullYear(), n = ra(e, 0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const a = d0(n), i = ra(e, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const o = d0(i);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function Mme(e) {
  const t = xE(e), r = ra(e, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), d0(r);
}
function Eme(e) {
  const t = Xr(e), r = +d0(t) - +Mme(t);
  return Math.round(r / wE) + 1;
}
function DE(e, t) {
  var d, h, A, p;
  const r = Xr(e), n = r.getFullYear(), a = Pl(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((h = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((p = (A = a.locale) == null ? void 0 : A.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, o = ra(e, 0);
  o.setFullYear(n + 1, 0, i), o.setHours(0, 0, 0, 0);
  const s = Ho(o, t), c = ra(e, 0);
  c.setFullYear(n, 0, i), c.setHours(0, 0, 0, 0);
  const u = Ho(c, t);
  return r.getTime() >= s.getTime() ? n + 1 : r.getTime() >= u.getTime() ? n : n - 1;
}
function Sme(e, t) {
  var s, c, u, d;
  const r = Pl(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, a = DE(e, t), i = ra(e, 0);
  return i.setFullYear(a, 0, n), i.setHours(0, 0, 0, 0), Ho(i, t);
}
function Pme(e, t) {
  const r = Xr(e), n = +Ho(r, t) - +Sme(r, t);
  return Math.round(n / wE) + 1;
}
function Je(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const Gn = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return Je(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : Je(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Je(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Je(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Je(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Je(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Je(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return Je(a, t.length);
  }
}, La = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Qm = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, { unit: "year" });
    }
    return Gn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const a = DE(e, n), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const o = i % 100;
      return Je(o, 2);
    }
    return t === "Yo" ? r.ordinalNumber(i, { unit: "year" }) : Je(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = xE(e);
    return Je(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return Je(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(n);
      case "QQ":
        return Je(n, 2);
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(n);
      case "qq":
        return Je(n, 2);
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Gn.M(e, t);
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "L":
        return String(n + 1);
      case "LL":
        return Je(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const a = Pme(e, n);
    return t === "wo" ? r.ordinalNumber(a, { unit: "week" }) : Je(a, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = Eme(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : Je(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : Gn.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = Ome(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : Je(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const a = e.getDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return Je(i, 2);
      case "eo":
        return r.ordinalNumber(i, { unit: "day" });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const a = e.getDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return Je(i, t.length);
      case "co":
        return r.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), a = n === 0 ? 7 : n;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return Je(a, t.length);
      case "io":
        return r.ordinalNumber(a, { unit: "day" });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n === 12 ? a = La.noon : n === 0 ? a = La.midnight : a = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n >= 17 ? a = La.evening : n >= 12 ? a = La.afternoon : n >= 4 ? a = La.morning : a = La.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return Gn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : Gn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : Je(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : Je(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Gn.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : Gn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Gn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      case "X":
        return Zm(n);
      case "XXXX":
      case "XX":
        return Y1(n);
      case "XXXXX":
      case "XXX":
      default:
        return Y1(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Zm(n);
      case "xxxx":
      case "xx":
        return Y1(n);
      case "xxxxx":
      case "xxx":
      default:
        return Y1(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Um(n, ":");
      case "OOOO":
      default:
        return "GMT" + Y1(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Um(n, ":");
      case "zzzz":
      default:
        return "GMT" + Y1(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(e.getTime() / 1e3);
    return Je(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    const n = e.getTime();
    return Je(n, t.length);
  }
};
function Um(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.trunc(n / 60), i = n % 60;
  return i === 0 ? r + String(a) : r + String(a) + t + Je(i, 2);
}
function Zm(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Je(Math.abs(e) / 60, 2) : Y1(e, t);
}
function Y1(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Je(Math.trunc(n / 60), 2), i = Je(n % 60, 2);
  return r + a + t + i;
}
const Km = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, OE = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, jme = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], a = r[2];
  if (!a)
    return Km(e, t);
  let i;
  switch (n) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Km(n, t)).replace("{{time}}", OE(a, t));
}, Ime = {
  p: OE,
  P: jme
}, Bme = /^D+$/, Nme = /^Y+$/, Lme = ["D", "DD", "YY", "YYYY"];
function Tme(e) {
  return Bme.test(e);
}
function _me(e) {
  return Nme.test(e);
}
function Rme(e, t, r) {
  const n = Fme(e, t, r);
  if (console.warn(n), Lme.includes(e))
    throw new RangeError(n);
}
function Fme(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function $me(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Hme(e) {
  if (!$me(e) && typeof e != "number")
    return !1;
  const t = Xr(e);
  return !isNaN(Number(t));
}
const Yme = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, kme = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Vme = /^'([^]*?)'?$/, Gme = /''/g, Wme = /[a-zA-Z]/;
function zm(e, t, r) {
  var d, h, A, p, v, g, m, b;
  const n = Pl(), a = (r == null ? void 0 : r.locale) ?? n.locale ?? bme, i = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((h = (d = r == null ? void 0 : r.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((p = (A = n.locale) == null ? void 0 : A.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, o = (r == null ? void 0 : r.weekStartsOn) ?? ((g = (v = r == null ? void 0 : r.locale) == null ? void 0 : v.options) == null ? void 0 : g.weekStartsOn) ?? n.weekStartsOn ?? ((b = (m = n.locale) == null ? void 0 : m.options) == null ? void 0 : b.weekStartsOn) ?? 0, s = Xr(e);
  if (!Hme(s))
    throw new RangeError("Invalid time value");
  let c = t.match(kme).map((w) => {
    const x = w[0];
    if (x === "p" || x === "P") {
      const y = Ime[x];
      return y(w, a.formatLong);
    }
    return w;
  }).join("").match(Yme).map((w) => {
    if (w === "''")
      return { isToken: !1, value: "'" };
    const x = w[0];
    if (x === "'")
      return { isToken: !1, value: Qme(w) };
    if (Qm[x])
      return { isToken: !0, value: w };
    if (x.match(Wme))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + x + "`"
      );
    return { isToken: !1, value: w };
  });
  a.localize.preprocessor && (c = a.localize.preprocessor(s, c));
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: a
  };
  return c.map((w) => {
    if (!w.isToken)
      return w.value;
    const x = w.value;
    (!(r != null && r.useAdditionalWeekYearTokens) && _me(x) || !(r != null && r.useAdditionalDayOfYearTokens) && Tme(x)) && Rme(x, t, String(e));
    const y = Qm[x[0]];
    return y(s, x, a.localize, u);
  }).join("");
}
function Qme(e) {
  const t = e.match(Vme);
  return t ? t[1].replace(Gme, "'") : e;
}
const Ume = P.forwardRef((e) => {
  const {
    containerName: t,
    numberOfAlerts: r,
    onChangeValueFilterDate: n,
    valueFilterDate: a,
    graphicKeyName: i
  } = e, o = () => `component_${i ?? "defaultKeyName"}_hidden`, [s, c] = Ee(() => {
    const h = localStorage.getItem(o());
    return h !== null ? JSON.parse(h) : !1;
  }), u = () => {
    c((h) => {
      const A = !h;
      return localStorage.setItem(o(), JSON.stringify(A)), A;
    });
  }, d = (h) => {
    const A = h.option.startDate, p = h.option.endDate, v = p !== void 0 ? zm(p, "dd/MM/yyyy") : "Fecha de fin no disponible", m = [A !== void 0 ? zm(A, "dd/MM/yyyy") : "Fecha de inicio no disponible", v];
    n !== void 0 && n({ option: m });
  };
  return /* @__PURE__ */ f.jsxs("div", { className: "border rounded-md shadow-s mb-8 max-w-[1260px] mx-auto", children: [
    /* @__PURE__ */ f.jsx("div", { className: "p-4", children: /* @__PURE__ */ f.jsx("div", { className: "flex flex-col 2s:justify-between 2s:items-center gap-4 2s:flex-row", children: /* @__PURE__ */ f.jsxs(ts, { gap: 4, alignItems: "center", children: [
      /* @__PURE__ */ f.jsx("button", { className: "cursor-pointer", onClick: u, children: /* @__PURE__ */ f.jsx(
        De,
        {
          variant: s ? "eye-hide" : "eye",
          color: "neutral-300"
        }
      ) }),
      /* @__PURE__ */ f.jsx(Vr, { variant: "title-2", children: t }),
      r !== void 0 ? /* @__PURE__ */ f.jsx("div", { className: "bg-error-600 rounded-lg py-2 px-4", children: /* @__PURE__ */ f.jsxs(Vr, { variant: "title-4", color: "white", children: [
        r,
        " nuevas"
      ] }) }) : void 0
    ] }) }) }),
    /* @__PURE__ */ f.jsx("div", { className: `border-1 ${s ? "hidden" : "block"}` }),
    !(e != null && e.hiddenFilter) && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsx("div", { className: `p-4 ${s ? "hidden" : "block"}`, children: /* @__PURE__ */ f.jsxs("div", { className: "flex gap-4", children: [
        /* @__PURE__ */ f.jsx("div", { className: "flex flex-col flex-1 gap-4 2s:flex-row", children: /* @__PURE__ */ f.jsx(
          yE,
          {
            valueFilterDate: a,
            onChangeValueFilterDate: d
          }
        ) }),
        /* @__PURE__ */ f.jsx("div", { className: "hidden", children: /* @__PURE__ */ f.jsxs(
          rC,
          {
            variant: "actions",
            button: /* @__PURE__ */ f.jsx(
              Qr,
              {
                variant: "secondary",
                size: "m",
                icon: "menu-context",
                onlyIcon: !0
              }
            ),
            children: [
              /* @__PURE__ */ f.jsx(L4, { icon: "trash", children: "Eliminar" }),
              /* @__PURE__ */ f.jsx(L4, { icon: "edit", children: "Editar" })
            ]
          }
        ) })
      ] }) }),
      /* @__PURE__ */ f.jsx("div", { className: `border-1 ${s ? "hidden" : "block"}` })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: `p-4 2s:p-8 mb-4 ${s ? "hidden" : "grid"}`, children: e.children })
  ] });
});
Ume.displayName = "GraphicContainer";
const Zme = P.forwardRef((e) => {
  const { handleLabelClick: t, data: r, chartColors: n } = e;
  if (r == null)
    return null;
  const a = r.filter((d) => d.value !== 0), i = (d) => () => {
    t !== void 0 && t({ data: d });
  }, o = n.map((d) => gt[d.colorCellChart]), s = {
    gridTemplateColumns: "8fr 2fr"
  }, c = Math.PI / 180, u = ({
    cx: d,
    cy: h,
    midAngle: A,
    innerRadius: p,
    outerRadius: v,
    index: g
  }) => {
    const m = p + (v - p) * 0.5, b = d + m * Math.cos(-A * Number(c)), w = h + m * Math.sin(-A * Number(c));
    return /* @__PURE__ */ f.jsx(
      "text",
      {
        className: "text-md s:text-l font-bold",
        x: b,
        y: w,
        fill: "white",
        textAnchor: b > d ? "start" : "end",
        dominantBaseline: "central",
        children: `${a[g].value}`
      }
    );
  };
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col 2s:grid 2s:gap-8", style: s, children: [
    /* @__PURE__ */ f.jsx(P2, { width: "100%", aspect: 2, children: /* @__PURE__ */ f.jsx(o8, { children: /* @__PURE__ */ f.jsx(
      zr,
      {
        dataKey: "value",
        startAngle: 180,
        endAngle: 0,
        data: a,
        labelLine: !1,
        label: u,
        cx: "50%",
        cy: "90%",
        innerRadius: "70%",
        outerRadius: "180%",
        fill: "#8884d8",
        stroke: "none",
        cursor: "pointer",
        children: a.map((d, h) => /* @__PURE__ */ f.jsx(
          Br,
          {
            fill: o[h % o.length],
            onClick: i(d)
          },
          `cell-${h}`
        ))
      }
    ) }) }),
    /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col justify-center gap-4 rounded-md text-center", children: [
      /* @__PURE__ */ f.jsxs("div", { className: "rounded-md p-4 text-center bg-success-400", children: [
        /* @__PURE__ */ f.jsx(Vr, { variant: "title-3", color: "white", children: "A tiempo" }),
        /* @__PURE__ */ f.jsx(Ri, { variant: "heading-4", color: "white", children: r[2].value !== null ? r[2].value : "0" }),
        /* @__PURE__ */ f.jsx(r1, { variant: "description-4", color: "white", children: "Operaciones" })
      ] }),
      /* @__PURE__ */ f.jsxs("div", { className: "rounded-md p-4 text-center bg-warning-400", children: [
        /* @__PURE__ */ f.jsx(Vr, { variant: "title-3", color: "white", children: "Críticas" }),
        /* @__PURE__ */ f.jsx(Ri, { variant: "heading-4", color: "white", children: r[1].value !== null ? r[1].value : "0" }),
        /* @__PURE__ */ f.jsx(r1, { variant: "description-4", color: "white", children: "Operaciones" })
      ] }),
      /* @__PURE__ */ f.jsxs("div", { className: "rounded-md p-4 text-center bg-error-400", children: [
        /* @__PURE__ */ f.jsx(Vr, { variant: "title-3", color: "white", children: "Muy críticas" }),
        /* @__PURE__ */ f.jsx(Ri, { variant: "heading-4", color: "white", children: r[0].value !== null ? r[0].value : "0" }),
        /* @__PURE__ */ f.jsx(r1, { variant: "description-4", color: "white", children: "Operaciones" })
      ] })
    ] })
  ] }) });
});
Zme.displayName = "SemiPieChart";
const Kme = P.forwardRef((e, t) => {
  const {
    data: r,
    chartColors: n,
    domainYAxis: a,
    ticksYAxis: i,
    onActivClick: o,
    ...s
  } = e;
  if (r == null)
    return null;
  const c = r.map((b) => ({
    name: b.name,
    [b.currentDate]: b.numCurrenDate,
    [b.previousDate]: b.numPreviousDate
  })), u = Object.keys(c[0]), d = n.map((b) => gt[b.colorBar]), h = n.map((b) => gt[b.colorLine]), A = (b) => () => {
    o !== void 0 && o({ data: b });
  }, [p, v] = Ee(1), [g, m] = Ee(0);
  return Ne(() => {
    const b = () => {
      const w = document.getElementById("container-chart");
      w !== null && (w.getBoundingClientRect().width <= 650 ? (v(1), m(-45)) : (v(2), c.length >= 6 ? m(-45) : m(0)));
    };
    return b(), window.addEventListener("resize", b), () => {
      window.removeEventListener("resize", b);
    };
  }, [c]), /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx("section", { className: "w-full max-w-[1260px]", id: "container-chart", ref: t, ...s, children: /* @__PURE__ */ f.jsx(P2, { width: "100%", aspect: p, children: /* @__PURE__ */ f.jsxs(
    P0e,
    {
      width: 500,
      height: 800,
      data: c,
      margin: {
        top: 20,
        right: 20,
        bottom: g === 0 ? 20 : 40,
        left: -20
      },
      children: [
        /* @__PURE__ */ f.jsx(K0, { stroke: "#f5f5f5" }),
        /* @__PURE__ */ f.jsx(u1, { dataKey: "name", className: "text-xs 2s:text-s", interval: 0, angle: g, textAnchor: g === 0 ? "middle" : "end" }),
        /* @__PURE__ */ f.jsx(
          la,
          {
            domain: a,
            ticks: i,
            className: "text-xs 2s:text-s"
          }
        ),
        /* @__PURE__ */ f.jsx(zt, { contentStyle: { fontSize: p === 2 ? "14px" : "13px" } }),
        /* @__PURE__ */ f.jsx(
          l1,
          {
            wrapperStyle: { bottom: 0, left: 10 },
            iconType: "circle",
            formatter: (b) => /* @__PURE__ */ f.jsx("span", { style: { fontWeight: "bold", color: "black", marginTop: "40px", fontSize: p === 2 ? "14px" : "13px" }, children: b })
          }
        ),
        /* @__PURE__ */ f.jsx(Tr, { width: 65, dataKey: u[1], barSize: 65, fill: d[0], children: r.map((b, w) => /* @__PURE__ */ f.jsx(Br, { onClick: A(b) }, `cell-${w}`)) }),
        /* @__PURE__ */ f.jsx(n3, { type: "monotone", dataKey: u[2], stroke: h[0], strokeWidth: 2 })
      ]
    }
  ) }) }) });
});
Kme.displayName = "ComposedCharts";
const zme = P.forwardRef((e, t) => {
  const {
    data: r,
    chartColors: n,
    domainXAxis: a,
    ticksXAxis: i,
    onClickNegativeBar: o,
    onClickPositiveBar: s,
    ...c
  } = e;
  if (r == null)
    return null;
  const u = r.map((b) => ({
    name: b.name,
    [b.positiveBarName]: b.positiveBarNumber,
    [b.negativeBarName]: b.negativeBarNumber
  })), d = Object.keys(u[0]), h = n.map((b) => gt[b.colorBarNegative]), A = n.map((b) => gt[b.colorBarPositive]), p = (b) => () => {
    o !== void 0 && o({ data: b });
  }, v = (b) => () => {
    s !== void 0 && s({ data: b });
  }, [g, m] = Ee(1);
  return Ne(() => {
    const b = () => {
      const w = document.getElementById("container-chart-horizontal");
      w !== null && (w.getBoundingClientRect().width <= 550 ? m(1) : m(2));
    };
    return b(), window.addEventListener("resize", b), () => {
      window.removeEventListener("resize", b);
    };
  }, []), /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx("section", { id: "container-chart-horizontal", className: "w-full max-w-[1260px]", ref: t, ...c, children: /* @__PURE__ */ f.jsx(P2, { width: "100%", aspect: g, children: /* @__PURE__ */ f.jsxs(
    rD,
    {
      width: 500,
      height: 400,
      data: u,
      layout: "vertical",
      margin: {
        top: 5,
        right: 10,
        left: 0,
        bottom: 5
      },
      children: [
        /* @__PURE__ */ f.jsx(K0, { strokeDasharray: "3 3" }),
        /* @__PURE__ */ f.jsx(
          u1,
          {
            type: "number",
            domain: a,
            ticks: i,
            className: "text-xs 2s:text-s"
          }
        ),
        /* @__PURE__ */ f.jsx(la, { dataKey: "name", type: "category", className: "text-xs 2s:text-s", width: g === 2 ? 122 : void 0 }),
        /* @__PURE__ */ f.jsx(zt, { contentStyle: { fontSize: g === 2 ? "14px" : "13px" } }),
        /* @__PURE__ */ f.jsx(
          l1,
          {
            iconType: "circle",
            formatter: (b) => /* @__PURE__ */ f.jsx("span", { style: { fontWeight: "bold", color: "black", marginTop: "40px", fontSize: g === 2 ? "14px" : "13px" }, children: b })
          }
        ),
        /* @__PURE__ */ f.jsx(Tr, { dataKey: d[2], barSize: 38, fill: h[0], children: r.map((b, w) => /* @__PURE__ */ f.jsx(Br, { onClick: p(b) }, `cell-${w}`)) }),
        /* @__PURE__ */ f.jsx(Tr, { dataKey: d[1], barSize: 38, fill: A[0], children: r.map((b, w) => /* @__PURE__ */ f.jsx(Br, { onClick: v(b) }, `cell-${w}`)) })
      ]
    }
  ) }) }) });
});
zme.displayName = "HorizontalChart";
const qme = P.forwardRef((e, t) => {
  const {
    data: r,
    chartColors: n,
    domainXAxis: a,
    ticksXAxis: i,
    onClickCurrentBar: o,
    onClickPreviousBar: s,
    image: c,
    ...u
  } = e;
  if (r == null || n == null || a == null || i == null || c == null)
    return null;
  const d = r.map((O) => ({
    name: O.name,
    [O.currentDate]: O.numCurrenDate,
    [O.previousDate]: O.numPreviousDate,
    url: O.url
  })), h = Object.keys(d[0]), A = n.map((O) => gt[O.colorBarCurrent]), p = n.map((O) => gt[O.colorBarPrevious]), v = (O) => () => {
    o !== void 0 && o({ data: O });
  }, g = (O) => () => {
    s !== void 0 && s({ data: O });
  }, m = ({ data: O, ...M }) => {
    const E = M.x, N = M.y, F = O == null ? void 0 : O.map((k) => k.name);
    return E == null || N == null ? null : /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs("g", { transform: `translate(${E},${N})`, radius: "100%", children: [
      F == null ? void 0 : F.map((k, R) => /* @__PURE__ */ f.jsx("text", { x: 0, y: 10, transform: "rotate(-45)", textAnchor: "end", dominantBaseline: "middle", fontSize: 7, fontWeight: "400", fill: "#666666", children: k }, R)),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "circleView", children: /* @__PURE__ */ f.jsx("circle", { cx: -5, cy: 65, r: 14 }) }) }),
      /* @__PURE__ */ f.jsx("image", { href: M.payload.value, clipPath: "url(#circleView)", x: -55, y: 50, height: "35px", width: "100px", radius: 100, textAnchor: "middle" })
    ] }) });
  }, [b, w] = Ee(1), [x, y] = Ee(0);
  Ne(() => {
    const O = () => {
      const M = document.getElementById("container-chart-simple-bar");
      M !== null && (M.getBoundingClientRect().width <= 650 ? (w(1), y(-45)) : (w(2), d.length >= 6 ? y(-45) : y(0)));
    };
    return O(), window.addEventListener("resize", O), () => {
      window.removeEventListener("resize", O);
    };
  }, []);
  const C = ({ active: O, payload: M }) => O == null ? null : O && M != null && M.length > 0 ? /* @__PURE__ */ f.jsx("div", { className: "bg-neutral-100 p-3 border-white border-1", children: Object.keys(M[0].payload).map((E) => {
    if (E === "name") {
      const N = String(M[0].payload[E]);
      return /* @__PURE__ */ f.jsx("p", { children: `${N}` }, E);
    }
    if (E === "Mes actual") {
      const N = String(M[0].payload[E]);
      return /* @__PURE__ */ f.jsx("p", { style: { color: A[0] }, children: `${E}: ${N}` }, E);
    }
    if (E === "Mes anterior") {
      const N = String(M[0].payload[E]);
      return /* @__PURE__ */ f.jsx("p", { style: { color: p[0] }, children: `${E}: ${N}` }, E);
    }
    return null;
  }) }) : null;
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx("section", { id: "container-chart-simple-bar", className: "w-full max-w-[1260px]", ref: t, ...u, children: /* @__PURE__ */ f.jsx(P2, { width: "100%", aspect: b, children: /* @__PURE__ */ f.jsxs(
    rD,
    {
      width: 500,
      height: 300,
      data: d,
      margin: {
        top: 20,
        right: 20,
        bottom: x === 0 ? 20 : 50,
        left: -20
      },
      children: [
        /* @__PURE__ */ f.jsx(K0, { stroke: "#A3A3A3", strokeWidth: 0.5, horizontal: !0, vertical: !1 }),
        c ? /* @__PURE__ */ f.jsx(u1, { dataKey: "url", interval: 0, tick: /* @__PURE__ */ f.jsx(m, { data: r }) }) : /* @__PURE__ */ f.jsx(u1, { dataKey: "name", fontSize: 12, interval: 0, angle: -45, textAnchor: "end" }),
        /* @__PURE__ */ f.jsx(
          la,
          {
            className: "text-xs 2s:text-s",
            radius: "100%",
            domain: a,
            ticks: i
          }
        ),
        c ? /* @__PURE__ */ f.jsx(
          zt,
          {
            contentStyle: { fontSize: b === 2 ? "14px" : "13px" },
            content: /* @__PURE__ */ f.jsx(C, {})
          }
        ) : /* @__PURE__ */ f.jsx(
          zt,
          {
            contentStyle: { fontSize: b === 2 ? "14px" : "13px" }
          }
        ),
        /* @__PURE__ */ f.jsx(
          l1,
          {
            wrapperStyle: { bottom: c ? -15 : 0, left: 5 },
            iconType: "circle",
            formatter: (O) => /* @__PURE__ */ f.jsx("span", { style: { fontWeight: "bold", color: "black", marginTop: "40px", fontSize: b === 2 ? "14px" : "13px" }, children: O })
          }
        ),
        /* @__PURE__ */ f.jsx(Tr, { dataKey: h[1], fill: A[0], barSize: 37, children: r.map((O, M) => /* @__PURE__ */ f.jsx(Br, { onClick: v(O) }, `cell-${M}`)) }),
        /* @__PURE__ */ f.jsx(Tr, { dataKey: h[2], fill: p[0], barSize: 37, children: r.map((O, M) => /* @__PURE__ */ f.jsx(Br, { onClick: g(O) }, `cell-${M}`)) })
      ]
    }
  ) }) }) });
});
qme.displayName = "SimpleBarChart";
const Xme = P.forwardRef((e, t) => {
  const {
    data: r,
    onClickCellChart: n,
    onClickIconCard: a,
    chartColors: i,
    labelOne: o,
    labelTwo: s,
    percentageMessage: c,
    columns: u,
    hiddenCenter: d,
    ...h
  } = e;
  if (r == null || o == null)
    return null;
  const A = (m) => () => {
    n !== void 0 && n({ data: m });
  }, p = i.map((m) => gt[m.colorCellChart]), v = {
    gridTemplateColumns: "5fr 5fr"
  }, g = ({
    labelTop: m,
    labelBottom: b
  }) => /* @__PURE__ */ f.jsxs("g", { children: [
    /* @__PURE__ */ f.jsx(
      "text",
      {
        x: "50%",
        y: "50%",
        textAnchor: "middle",
        dominantBaseline: "middle",
        fontSize: 30,
        fontWeight: "700",
        fill: "#292929",
        children: m
      }
    ),
    /* @__PURE__ */ f.jsx(
      "text",
      {
        x: "50%",
        y: "60%",
        textAnchor: "middle",
        dominantBaseline: "middle",
        fontSize: 14,
        fontWeight: "400",
        fill: "#292929",
        children: b
      }
    )
  ] });
  return /* @__PURE__ */ f.jsx(
    "section",
    {
      ref: t,
      className: "flex justify-center items-center",
      ...h,
      children: /* @__PURE__ */ f.jsxs(
        "div",
        {
          className: "w-full max-w-[1260px] flex flex-col gap-4 2s:grid 2s:gap-8 relative",
          style: v,
          children: [
            /* @__PURE__ */ f.jsx(P2, { width: "90%", height: 300, children: /* @__PURE__ */ f.jsxs(o8, { children: [
              /* @__PURE__ */ f.jsxs(
                zr,
                {
                  dataKey: "value",
                  data: r,
                  innerRadius: d ? "0%" : "55%",
                  outerRadius: "100%",
                  cursor: "pointer",
                  children: [
                    /* @__PURE__ */ f.jsx(
                      Ot,
                      {
                        content: /* @__PURE__ */ f.jsx(
                          g,
                          {
                            labelTop: o ?? "",
                            labelBottom: s ?? ""
                          }
                        ),
                        position: "center"
                      }
                    ),
                    r.map((m, b) => /* @__PURE__ */ f.jsx(
                      Br,
                      {
                        fill: p[b % p.length],
                        onClick: A(m)
                      },
                      `cell-${b}`
                    ))
                  ]
                }
              ),
              /* @__PURE__ */ f.jsx(zt, {})
            ] }) }),
            /* @__PURE__ */ f.jsx("div", { className: "w-full mx-auto flex flex-col items-start justify-center", children: /* @__PURE__ */ f.jsx("div", { className: "overflow-x-auto", children: /* @__PURE__ */ f.jsxs("table", { className: "border-collapse border border-slate-500 rounded-lg shadow-md mb-8 w-full table-fixed", children: [
              /* @__PURE__ */ f.jsx("thead", { children: /* @__PURE__ */ f.jsx("tr", { className: "bg-neutral-300", children: u.map((m, b) => /* @__PURE__ */ f.jsx(
                "th",
                {
                  className: "px-4 py-2 text-center border border-gray-400",
                  children: m
                },
                b
              )) }) }),
              /* @__PURE__ */ f.jsx("tbody", { children: r.map((m, b) => /* @__PURE__ */ f.jsxs("tr", { className: "border-t border-gray-200", children: [
                /* @__PURE__ */ f.jsx("td", { className: "px-4 py-2", children: m.name }),
                m.value1 !== void 0 && m.value1 !== null && /* @__PURE__ */ f.jsx("td", { className: "px-4 py-2 text-center border border-gray-300", children: m.value1 }),
                m.value2 !== void 0 && m.value2 !== null && /* @__PURE__ */ f.jsx("td", { className: "px-4 py-2 text-center border border-gray-300", children: m.value2 }),
                m.value3 !== void 0 && m.value3 !== null && /* @__PURE__ */ f.jsx("td", { className: "px-4 py-2 text-center border border-gray-300", children: m.value3 }),
                /* @__PURE__ */ f.jsx("td", { className: "px-4 py-2 text-center border border-gray-300", children: m.color ? /* @__PURE__ */ f.jsx(
                  "div",
                  {
                    className: "w-4 h-4 rounded-full mx-auto",
                    style: { backgroundColor: m.color }
                  }
                ) : "" })
              ] }, b)) })
            ] }) }) })
          ]
        }
      )
    }
  );
});
Xme.displayName = "PieChartsTable";
const Jme = P.forwardRef((e, t) => {
  const {
    text: r,
    color: n,
    children: a
  } = e, i = {
    color: n !== void 0 ? gt[n] : void 0,
    fontWeight: n !== void 0 ? 600 : void 0
  }, o = {
    backgroundColor: n !== void 0 ? gt[n] : gt["neutral-300"]
  };
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: "flex flex-col 2s:flex-row 2s:justify-between gap-4 items-center", children: [
    /* @__PURE__ */ f.jsxs("div", { className: "relative text-center 2s:text-left 2s:flex-grow 2s:flex 2s:gap-4 2s:justify-between 2s:items-center", children: [
      r !== void 0 && /* @__PURE__ */ f.jsx("p", { className: "leading-[120%]", style: i, children: r }),
      /* @__PURE__ */ f.jsx("span", { className: "hidden 2s:block h-[1px] 2s:flex-grow", style: o })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "w-full 2s:w-auto", children: a })
  ] });
});
Jme.displayName = "Divider";
function cCe(e) {
  const {
    label: t,
    extFiles: r,
    multiple: n,
    disabled: a,
    maxSize: i,
    maxLengthLabelFile: o,
    limitNumberFiles: s,
    onChange: c,
    value: u
  } = e, d = D7(), h = i || 3, A = o || 16, p = [
    "ene.",
    "feb.",
    "mar.",
    "abr.",
    "may.",
    "jun.",
    "jul.",
    "ago.",
    "sep.",
    "oct.",
    "nov.",
    "dic."
  ], [v, g] = Ee([]), m = Ce(null), b = dr(() => u ? Array.isArray(u) ? [...u] : [u] : [], [u]), w = (R) => R / (1024 * 1024), x = (R) => {
    const j = R.name.split(".").at(-1);
    return j != null && j.includes("doc") ? "word" : (j != null && j.includes("xls"), "excel");
  }, y = (R) => {
    R = R.filter((j) => {
      const U = j.name.split(".").at(-1);
      return w(j.size) > h ? !1 : r.includes(`${U}`);
    }), g((j) => {
      const U = j.length + 1, ee = R.length, X = U + ee;
      if (s) {
        let Z = [];
        if (X > s) {
          let te = U;
          R.forEach((B) => {
            console.log(te, s), console.log(te > s), !(te > s) && (Z.push(B), te++);
          });
        } else
          Z = [...R];
        return c && c([...j, ...Z]), [...j, ...Z];
      }
      return c && c([...j, ...R]), [...j, ...R];
    });
  }, C = (R) => {
    g((j) => (j.splice(R, 1), c && c([...j]), [...j]));
  }, O = (R) => {
    R.preventDefault(), R.stopPropagation(), R.dataTransfer.dropEffect = "copy";
  }, M = (R) => {
    R.preventDefault(), R.stopPropagation(), !a && y(Array.from(R.dataTransfer.files));
  }, E = () => {
    var R;
    (R = m.current) == null || R.click();
  }, N = (R) => {
    a || y(Array.from(R.target.files || []));
  }, F = (R) => R.length <= A ? R : R.slice(0, A) + "...", k = (R) => {
    const j = new Date(R), U = j.getDate(), ee = j.getMonth(), X = j.getFullYear(), Z = p[ee];
    return `${U > 9 ? U : "0" + U} ${Z} ${X}`;
  };
  return Ne(() => {
    b.length && g([...b]);
  }, [b]), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        onDragOver: O,
        onDrop: M,
        onClick: E,
        style: {
          border: "2px dashed #e9edf0",
          borderRadius: "4px",
          textAlign: "center",
          margin: "20px",
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 150,
          backgroundColor: "#f5f5f5"
        },
        children: [
          /* @__PURE__ */ f.jsxs(
            "p",
            {
              style: {
                color: "#9aa1ab",
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              },
              children: [
                /* @__PURE__ */ f.jsx(De, { width: 36, variant: "uploadCLoud" }),
                t,
                /* @__PURE__ */ f.jsx("p", { children: Array.isArray(r) ? r.map((R) => R.toLocaleUpperCase()).join(",") : r.toUpperCase() })
              ]
            }
          ),
          /* @__PURE__ */ f.jsx(
            "input",
            {
              ref: m,
              type: "file",
              disabled: !!a,
              multiple: !!n,
              accept: Array.isArray(r) ? r.map((R) => "." + R).join(",") : `.${r}`,
              onChange: N,
              style: { display: "none" }
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ f.jsx("div", { className: " flex flex-row flex-wrap gap-2 mx-5", children: v.map((R, j) => /* @__PURE__ */ f.jsxs(
      "div",
      {
        className: "flex flex-row items-center",
        style: {
          borderRadius: "4px",
          backgroundColor: "#f5f5f5",
          padding: 8
        },
        children: [
          /* @__PURE__ */ f.jsx(De, { width: 36, variant: x(R) }),
          /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ f.jsx(
              "span",
              {
                style: {
                  fontWeight: "bold",
                  fontSize: 12,
                  paddingLeft: 8
                },
                children: F(R.name)
              }
            ),
            /* @__PURE__ */ f.jsxs(
              "span",
              {
                style: {
                  fontSize: 10,
                  paddingLeft: 8,
                  color: "#9aa1ab"
                },
                children: [
                  w(R.size).toFixed(2),
                  "Mb",
                  " ",
                  k(R.lastModified)
                ]
              }
            )
          ] }),
          /* @__PURE__ */ f.jsx("button", { className: "ml-6", onClick: () => C(j), children: /* @__PURE__ */ f.jsx(
            De,
            {
              width: 12,
              variant: "trash",
              style: { color: "#f5f5f5" }
            }
          ) })
        ]
      },
      `file_drop${d}-${j}`
    )) })
  ] });
}
function eCe(e) {
  const { columns: t, handleSelected: r, isAll: n, statusColumn: a = !1 } = e, i = !!r;
  return /* @__PURE__ */ f.jsxs("thead", { children: [
    /* @__PURE__ */ f.jsxs("tr", { className: "bg-neutral-200", children: [
      i && /* @__PURE__ */ f.jsx("th", { className: "p-2", children: /* @__PURE__ */ f.jsx(
        f0,
        {
          checked: n,
          onChange: () => {
            r && r("all", null);
          }
        }
      ) }),
      t.map(
        (o) => o.subColumnas ? /* @__PURE__ */ f.jsx(
          "th",
          {
            colSpan: o.subColumnas.length,
            className: "bg-neutral-300 p-4",
            children: o.columna
          },
          o.nombreColumna
        ) : /* @__PURE__ */ f.jsx("th", { className: "p-4", children: o.columna.includes("n/") ? o.columna.split("n/").map((s, c) => /* @__PURE__ */ f.jsx("span", { style: { display: "block" }, children: s }, c)) : o.columna }, o.nombreColumna)
      ),
      !a && /* @__PURE__ */ f.jsx("th", { className: "p-4", children: "ACCIONES" })
    ] }),
    !a && /* @__PURE__ */ f.jsxs("tr", { className: "bg-neutral-200", children: [
      i && /* @__PURE__ */ f.jsx("th", {}),
      t.map(
        (o) => o.subColumnas ? o.subColumnas.map((s) => /* @__PURE__ */ f.jsx("th", { className: "px-4", children: s.columna }, s.nombreColumna)) : /* @__PURE__ */ f.jsx("th", { className: "px-4" }, o.nombreColumna)
      ),
      /* @__PURE__ */ f.jsx("th", {})
    ] })
  ] });
}
function tCe(e) {
  const { columns: t, overrides: r, rows: n, isValidSelected: a } = e, i = (s) => {
    if (!s.sumarColumna)
      return "";
    const c = r == null ? void 0 : r[s.nombreColumna];
    if (c !== void 0)
      return c;
    let d = n.reduce((v, g) => {
      const m = o(g[s.nombreColumna]);
      return v + m;
    }, 0).toFixed(2);
    d = d.toString().replace(/\./g, ",");
    const [h, A] = d.split(","), p = new Intl.NumberFormat("de-DE").format(Number(h.replace(/\D/g, "")));
    return A !== void 0 ? `${p},${A}` : p;
  };
  function o(s) {
    if (s == null)
      return 0;
    if (typeof s == "number")
      return s;
    let c = s.toString().trim();
    return c.includes(".") && c.includes(",") ? c.lastIndexOf(",") > c.lastIndexOf(".") ? c = c.replace(/\./g, "").replace(",", ".") : c = c.replace(/,/g, "") : c.includes(",") ? c = c.replace(",", ".") : c.includes("."), Number(c) || 0;
  }
  return /* @__PURE__ */ f.jsxs("tr", { className: "bg-neutral-200", children: [
    a && /* @__PURE__ */ f.jsx("td", {}),
    t.map(
      (s) => s.subColumnas ? s.subColumnas.map((c) => /* @__PURE__ */ f.jsx(
        "td",
        {
          className: "border-b-2 border-indigo-500 p-2",
          children: c.sumarColumna ? i(c) : ""
        },
        c.nombreColumna
      )) : /* @__PURE__ */ f.jsx(
        "td",
        {
          className: "border-b-2 border-indigo-500 p-2",
          children: s.sumarColumna ? i(s) : ""
        },
        s.nombreColumna
      )
    ),
    /* @__PURE__ */ f.jsx("td", {})
  ] });
}
const uCe = ({
  columns: e,
  rows: t,
  handleChange: r,
  handleBlur: n,
  removeRow: a,
  searchFunctions: i,
  overrides: o,
  handleSelected: s,
  selectedRows: c,
  hiddenTrash: u,
  customLisActions: d,
  statusColumn: h
}) => {
  const A = !!s, [p, v] = Ee(t);
  Ne(() => {
    v(t);
  }, [t]);
  const [g, m] = Ee(() => {
    const M = {};
    return t && t.length > 0 && t.forEach((E, N) => {
      M[N] = {}, e.forEach((F) => {
        F.typeAutocomplete && E[F.nombreColumna] && (M[N][F.nombreColumna] = {
          id: E[F.nombreColumna],
          label: String(
            E[`${F.nombreColumna}_desc`] || E[F.nombreColumna]
          )
        });
      });
    }), M;
  }), [b, w] = Ee({}), x = async (M, E, N, F) => {
    var R;
    const k = (R = e.find(
      (j) => j.nombreColumna === N
    )) == null ? void 0 : R.typeAutocomplete;
    if (k && i[k]) {
      if (M.trim() === "") {
        w((U) => ({
          ...U,
          [E]: {
            ...U[E],
            [N]: []
          }
        })), F();
        return;
      }
      const j = await i[k](M);
      w((U) => ({
        ...U,
        [E]: {
          ...U[E],
          [N]: j
        }
      }));
    }
    F();
  }, y = (M, E, N) => {
    m((F) => ({
      ...F,
      [M]: {
        ...F[M],
        [E]: { id: N.id, label: N.label }
      }
    })), r(M, E, N.id);
  }, C = (M, E) => {
    e.forEach((N) => {
      N.typeAutocomplete && O(M, N.nombreColumna), N.subColumnas && N.subColumnas.forEach((F) => {
        F.typeAutocomplete && O(M, F.nombreColumna);
      });
    }), m((N) => {
      const F = { ...N };
      delete F[M];
      const k = {};
      return Object.keys(F).forEach((R) => {
        const j = Number(R);
        j > M ? k[j - 1] = F[j] : k[j] = F[j];
      }), k;
    }), a(M, E);
  }, O = (M, E) => {
    m((N) => ({
      ...N,
      [M]: {
        ...N[M],
        [E]: null
      }
    })), r(M, E, "");
  };
  return /* @__PURE__ */ f.jsx("div", { className: "relative w-full overflow-x-auto", children: /* @__PURE__ */ f.jsxs(
    "table",
    {
      className: "table w-full border-collapse my-6",
      style: {
        borderRadius: "10px"
      },
      children: [
        /* @__PURE__ */ f.jsx(
          eCe,
          {
            columns: e,
            handleSelected: s,
            isAll: ((c == null ? void 0 : c.length) ?? 0) >= ((t == null ? void 0 : t.length) ?? 0),
            statusColumn: h
          }
        ),
        /* @__PURE__ */ f.jsxs("tbody", { className: "text-center", children: [
          p.map((M, E) => /* @__PURE__ */ f.jsxs("tr", { children: [
            A && /* @__PURE__ */ f.jsx("td", { className: "p-2", children: /* @__PURE__ */ f.jsx(
              f0,
              {
                checked: c == null ? void 0 : c.includes(E),
                onChange: () => {
                  s && s(E, M);
                }
              }
            ) }),
            e.map(
              (N) => {
                var F, k, R;
                return N.subColumnas ? N.subColumnas.map((j) => {
                  var U, ee, X;
                  return /* @__PURE__ */ f.jsx(
                    "td",
                    {
                      className: "border-b border-indigo-500 py-2",
                      children: j.onlyString ? M[N.nombreColumna] || "" : j.typeinput ? /* @__PURE__ */ f.jsx(
                        Un,
                        {
                          type: "number",
                          variant: "white",
                          value: M[j.nombreColumna] || "",
                          onChange: (Z) => r(
                            E,
                            j.nombreColumna,
                            Z.target.value
                          ),
                          onBlur: (Z) => n(Z.target.value, E, j),
                          readOnly: j.typeDisable,
                          required: j.typeRequired,
                          style: j.typeNumberRight ? { textAlign: "right" } : j.typeNumberCenter ? { textAlign: "center" } : {}
                        }
                      ) : j.typeSelect ? /* @__PURE__ */ f.jsx(
                        "select",
                        {
                          className: "bg-white rounded-md p-4 pointer-events-auto",
                          value: M[j.nombreColumna] || j.defaultValue || "",
                          disabled: !!j.typeDisable,
                          onChange: (Z) => r(
                            E,
                            j.nombreColumna,
                            Z.target.value
                          ),
                          onBlur: (Z) => n(Z.target.value, E, j),
                          required: j.typeRequired,
                          children: j.typeSelect.map((Z) => /* @__PURE__ */ f.jsx("option", { value: Z.value, children: Z.text }, Z.value))
                        }
                      ) : j.typeAutocomplete ? /* @__PURE__ */ f.jsx(
                        "div",
                        {
                          className: "z-50 top-[calc(100%+4px)] left-0 w-full pointer-events-auto min-w-[200px]",
                          children: /* @__PURE__ */ f.jsx(
                            T4,
                            {
                              variant: "white",
                              selected: ((ee = (U = g[E]) == null ? void 0 : U[j.nombreColumna]) == null ? void 0 : ee.label) || null,
                              placeholder: "Buscar...",
                              textLoading: "Cargando...",
                              textNoResults: "No hay resultados",
                              minLengthToSearch: 2,
                              searchResults: ((X = b[E]) == null ? void 0 : X[j.nombreColumna]) || [],
                              onChangeSearch: (Z, te) => x(
                                Z,
                                E,
                                j.nombreColumna,
                                te
                              ),
                              onItemClick: (Z) => y(
                                E,
                                j.nombreColumna,
                                Z.item
                              ),
                              onResetSelected: () => O(
                                E,
                                j.nombreColumna
                              )
                            }
                          )
                        }
                      ) : j.typetext ? /* @__PURE__ */ f.jsx(
                        Un,
                        {
                          variant: "white",
                          type: "text",
                          placeholder: "Diligenciar",
                          value: M[j.nombreColumna] || "",
                          onChange: (Z) => r(
                            E,
                            j.nombreColumna,
                            Z.target.value
                          ),
                          onBlur: (Z) => n(Z.target.value, E, j),
                          readOnly: j.typeDisable,
                          required: j.typeRequired
                        }
                      ) : j.typeDate ? /* @__PURE__ */ f.jsx(
                        Un,
                        {
                          variant: "white",
                          type: "date",
                          value: M[j.nombreColumna] || "",
                          onChange: (Z) => r(
                            E,
                            j.nombreColumna,
                            Z.target.value
                          ),
                          onBlur: (Z) => n(Z.target.value, E, j),
                          readOnly: j.typeDisable,
                          required: j.typeRequired
                        }
                      ) : /* @__PURE__ */ f.jsx("td", {})
                    },
                    j.nombreColumna
                  );
                }) : /* @__PURE__ */ f.jsx(
                  "td",
                  {
                    className: "border-b border-indigo-500 py-2",
                    children: N.onlyString ? M[N.nombreColumna] || "" : N.typeinput ? /* @__PURE__ */ f.jsx(
                      Un,
                      {
                        type: "number",
                        variant: "white",
                        value: M[N.nombreColumna] || "",
                        readOnly: N.typeDisable,
                        onChange: (j) => r(
                          E,
                          N.nombreColumna,
                          j.target.value
                        ),
                        onBlur: (j) => n(j.target.value, E, N),
                        required: N.typeRequired,
                        style: N.typeNumberRight ? { textAlign: "right" } : N.typeNumberCenter ? { textAlign: "center" } : {}
                      }
                    ) : N.typeSelect ? /* @__PURE__ */ f.jsxs(
                      "select",
                      {
                        className: "bg-white rounded-md p-2 pointer-events-auto  border",
                        value: M[N.nombreColumna] || N.defaultValue || "",
                        disabled: !!N.typeDisable,
                        onChange: (j) => r(
                          E,
                          N.nombreColumna,
                          j.target.value
                        ),
                        required: N.typeRequired,
                        children: [
                          /* @__PURE__ */ f.jsx("option", { value: "", children: "Seleccione" }),
                          N.typeSelect.map((j) => /* @__PURE__ */ f.jsx("option", { value: j.value, children: j.text }, j.value))
                        ]
                      }
                    ) : N.typeAutocomplete ? /* @__PURE__ */ f.jsx(
                      "div",
                      {
                        className: "z-50 top-[calc(100%+4px)] left-0 w-full pointer-events-auto min-w-[200px]",
                        children: /* @__PURE__ */ f.jsx(
                          T4,
                          {
                            variant: "white",
                            selected: ((k = (F = g[E]) == null ? void 0 : F[N.nombreColumna]) == null ? void 0 : k.label) || null,
                            placeholder: "Buscar...",
                            textLoading: "Cargando...",
                            textNoResults: "No hay resultados",
                            minLengthToSearch: 2,
                            searchResults: ((R = b[E]) == null ? void 0 : R[N.nombreColumna]) || [],
                            onChangeSearch: (j, U) => x(
                              j,
                              E,
                              N.nombreColumna,
                              U
                            ),
                            onItemClick: (j) => y(
                              E,
                              N.nombreColumna,
                              j.item
                            ),
                            onResetSelected: () => O(E, N.nombreColumna)
                          }
                        )
                      }
                    ) : N.typetext ? /* @__PURE__ */ f.jsx(
                      Un,
                      {
                        variant: "white",
                        type: "text",
                        placeholder: "Diligenciar",
                        value: M[N.nombreColumna] || "",
                        readOnly: N.typeDisable,
                        onChange: (j) => r(
                          E,
                          N.nombreColumna,
                          j.target.value
                        ),
                        onBlur: (j) => n(j.target.value, E, N),
                        required: N.typeRequired
                      }
                    ) : N.typeDate ? /* @__PURE__ */ f.jsx(
                      Un,
                      {
                        variant: "white",
                        type: "date",
                        placeholder: "Diligenciar",
                        value: M[N.nombreColumna] || "",
                        readOnly: N.typeDisable,
                        onChange: (j) => r(
                          E,
                          N.nombreColumna,
                          j.target.value
                        ),
                        onBlur: (j) => n(j.target.value, E, N),
                        required: N.typeRequired
                      }
                    ) : /* @__PURE__ */ f.jsx("td", {})
                  },
                  N.nombreColumna
                );
              }
            ),
            !h && /* @__PURE__ */ f.jsxs("td", { children: [
              !u && /* @__PURE__ */ f.jsx(
                "button",
                {
                  onClick: (N) => {
                    N.preventDefault(), C(E, M);
                  },
                  children: /* @__PURE__ */ f.jsx(De, { variant: "trash", width: 20, color: "Acento-400" })
                }
              ),
              /* @__PURE__ */ f.jsx("div", { className: "flex gap-2 justify-center items-center", children: d && d.listButtons.map((N) => {
                const F = Object.keys(N);
                let k = !1;
                return F.includes("condition") && typeof N.condition == "function" && (k = !!N.condition(M, E)), k ? null : /* @__PURE__ */ f.jsx(
                  "button",
                  {
                    onClick: (R) => {
                      R.preventDefault(), d.handle(N.action, E, M);
                    },
                    children: /* @__PURE__ */ f.jsx(
                      De,
                      {
                        variant: N.icon || "trash",
                        width: 20,
                        color: N.color
                      }
                    )
                  },
                  N.action
                );
              }) })
            ] })
          ] }, M.id || E)),
          /* @__PURE__ */ f.jsx(
            tCe,
            {
              columns: e,
              overrides: o,
              rows: t,
              isValidSelected: A
            }
          )
        ] })
      ]
    }
  ) });
};
export {
  T4 as Autocomplete,
  Ga as Avatar,
  QR as Body,
  FE as Box,
  $E as BoxStatus,
  HE as Breadcrumb,
  Qr as Button,
  ZR as Cards,
  aC as CastorLogo,
  f0 as Checkbox,
  De as CodeIcon,
  Kme as ComposedChart,
  Sj as Dashboard,
  Pj as DashboardMain,
  r1 as Description,
  Jme as Divider,
  cCe as DropInputFile,
  rC as Dropdown,
  L4 as DropdownAction,
  Ij as ExportTable,
  Bj as ExportTableCol,
  _j as FieldError,
  ts as Flexbox,
  Tj as FlexboxRow,
  Ume as GraphicContainer,
  Kj as HeaderBoxLeft,
  zj as HeaderBoxRight,
  qj as HeaderNotificationItem,
  Xj as HeaderNotifications,
  Jj as HeaderOldButton,
  eI as HeaderSearch,
  tI as HeaderUser,
  rI as HeaderUserItem,
  nI as HeaderWrapper,
  Ri as Heading,
  zme as HorizontalChart,
  Un as Input,
  Qj as InputMask,
  Rj as Label,
  oI as MapLogo,
  fR as MenuItems,
  hR as MenuWrapper,
  AR as Modal,
  pR as ModalBody,
  gR as ModalFocus,
  CR as ModalFocusContainer,
  mR as ModalFooter,
  vR as ModalHeader,
  j0e as PieCharts,
  Xme as PieChartsTable,
  Fj as Radio,
  $j as Select,
  sCe as SelectFilter,
  oCe as SelectMult,
  Zme as SemiPieChart,
  qme as SimpleBarChart,
  bR as Spreen,
  yR as SpreenBody,
  wR as SpreenFooter,
  OR as SpreenHeader,
  xR as SpreenLeft,
  DR as SpreenRight,
  r9 as Stack,
  MR as StackRow,
  uCe as TableBasic,
  ER as TableEmpty,
  SR as TableFooter,
  jR as TableHeader,
  IR as TableLoader,
  FR as TableMain,
  $R as TablePagination,
  HR as TableShowPages,
  UR as TextOther,
  Uj as Textarea,
  Vr as Title,
  WR as Toast,
  iCe as closeDropdown,
  lCe as shootToast
};
